
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec443"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec443"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("R70Zh", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $09fa645ead4d6d9d$export$ffb0004e005737fa, (v) => $09fa645ead4d6d9d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $09fa645ead4d6d9d$export$34b9dba7ce09269b, (v) => $09fa645ead4d6d9d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $09fa645ead4d6d9d$export$25062201e9e25d76, (v) => $09fa645ead4d6d9d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $09fa645ead4d6d9d$export$ffb0004e005737fa;
var $09fa645ead4d6d9d$export$34b9dba7ce09269b;
var $09fa645ead4d6d9d$export$25062201e9e25d76;
'use strict';

var $28UcW = parcelRequire("28UcW");
var $09fa645ead4d6d9d$var$k = Symbol.for("react.element"), $09fa645ead4d6d9d$var$l = Symbol.for("react.fragment"), $09fa645ead4d6d9d$var$m = Object.prototype.hasOwnProperty, $09fa645ead4d6d9d$var$n = $28UcW.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $09fa645ead4d6d9d$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $09fa645ead4d6d9d$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$09fa645ead4d6d9d$var$m.call(a, b) && !$09fa645ead4d6d9d$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $09fa645ead4d6d9d$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $09fa645ead4d6d9d$var$n.current
    };
}
$09fa645ead4d6d9d$export$ffb0004e005737fa = $09fa645ead4d6d9d$var$l;
$09fa645ead4d6d9d$export$34b9dba7ce09269b = $09fa645ead4d6d9d$var$q;
$09fa645ead4d6d9d$export$25062201e9e25d76 = $09fa645ead4d6d9d$var$q;

});
parcelRegister("28UcW", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7cCB1"));

});
parcelRegister("7cCB1", function(module, exports) {

$parcel$export(module.exports, "Children", () => $53e797ca7aa8152e$export$dca3b0875bd9a954, (v) => $53e797ca7aa8152e$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $53e797ca7aa8152e$export$16fa2f45be04daa8, (v) => $53e797ca7aa8152e$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $53e797ca7aa8152e$export$ffb0004e005737fa, (v) => $53e797ca7aa8152e$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $53e797ca7aa8152e$export$e2c29f18771995cb, (v) => $53e797ca7aa8152e$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $53e797ca7aa8152e$export$221d75b3f55bb0bd, (v) => $53e797ca7aa8152e$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $53e797ca7aa8152e$export$5f8d39834fd61797, (v) => $53e797ca7aa8152e$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $53e797ca7aa8152e$export$74bf444e3cd11ea5, (v) => $53e797ca7aa8152e$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $53e797ca7aa8152e$export$ae55be85d98224ed, (v) => $53e797ca7aa8152e$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $53e797ca7aa8152e$export$e530037191fcd5d7, (v) => $53e797ca7aa8152e$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $53e797ca7aa8152e$export$fd42f52fd3ae1109, (v) => $53e797ca7aa8152e$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $53e797ca7aa8152e$export$c8a8987d4410bf2d, (v) => $53e797ca7aa8152e$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $53e797ca7aa8152e$export$d38cd72104c1f0e9, (v) => $53e797ca7aa8152e$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $53e797ca7aa8152e$export$7d1e3a5e95ceca43, (v) => $53e797ca7aa8152e$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $53e797ca7aa8152e$export$257a8862b851cb5b, (v) => $53e797ca7aa8152e$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $53e797ca7aa8152e$export$a8257692ac88316c, (v) => $53e797ca7aa8152e$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $53e797ca7aa8152e$export$488013bae63b21da, (v) => $53e797ca7aa8152e$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $53e797ca7aa8152e$export$7c73462e0d25e514, (v) => $53e797ca7aa8152e$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $53e797ca7aa8152e$export$7568632d0d33d16d, (v) => $53e797ca7aa8152e$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $53e797ca7aa8152e$export$88948ce120ea2619, (v) => $53e797ca7aa8152e$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $53e797ca7aa8152e$export$35808ee640e87ca7, (v) => $53e797ca7aa8152e$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $53e797ca7aa8152e$export$fae74005e78b1a27, (v) => $53e797ca7aa8152e$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $53e797ca7aa8152e$export$dc8fbce3eb94dc1e, (v) => $53e797ca7aa8152e$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $53e797ca7aa8152e$export$6a7bc4e911dc01cf, (v) => $53e797ca7aa8152e$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $53e797ca7aa8152e$export$6d9c69b0de29b591, (v) => $53e797ca7aa8152e$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $53e797ca7aa8152e$export$f680877a34711e37, (v) => $53e797ca7aa8152e$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $53e797ca7aa8152e$export$d5a552a76deda3c2, (v) => $53e797ca7aa8152e$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $53e797ca7aa8152e$export$aaabe4eda9ed9969, (v) => $53e797ca7aa8152e$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $53e797ca7aa8152e$export$e5c5a5f917a5871c, (v) => $53e797ca7aa8152e$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $53e797ca7aa8152e$export$1538c33de8887b59, (v) => $53e797ca7aa8152e$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $53e797ca7aa8152e$export$13e3392192263954, (v) => $53e797ca7aa8152e$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $53e797ca7aa8152e$export$b8f5890fc79d6aca, (v) => $53e797ca7aa8152e$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $53e797ca7aa8152e$export$60241385465d0a34, (v) => $53e797ca7aa8152e$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $53e797ca7aa8152e$export$306c0aa65ff9ec16, (v) => $53e797ca7aa8152e$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $53e797ca7aa8152e$export$7b286972b8d8ccbf, (v) => $53e797ca7aa8152e$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $53e797ca7aa8152e$export$83d89fbfd8236492, (v) => $53e797ca7aa8152e$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $53e797ca7aa8152e$export$dca3b0875bd9a954;
var $53e797ca7aa8152e$export$16fa2f45be04daa8;
var $53e797ca7aa8152e$export$ffb0004e005737fa;
var $53e797ca7aa8152e$export$e2c29f18771995cb;
var $53e797ca7aa8152e$export$221d75b3f55bb0bd;
var $53e797ca7aa8152e$export$5f8d39834fd61797;
var $53e797ca7aa8152e$export$74bf444e3cd11ea5;
var $53e797ca7aa8152e$export$ae55be85d98224ed;
var $53e797ca7aa8152e$export$e530037191fcd5d7;
var $53e797ca7aa8152e$export$fd42f52fd3ae1109;
var $53e797ca7aa8152e$export$c8a8987d4410bf2d;
var $53e797ca7aa8152e$export$d38cd72104c1f0e9;
var $53e797ca7aa8152e$export$7d1e3a5e95ceca43;
var $53e797ca7aa8152e$export$257a8862b851cb5b;
var $53e797ca7aa8152e$export$a8257692ac88316c;
var $53e797ca7aa8152e$export$488013bae63b21da;
var $53e797ca7aa8152e$export$7c73462e0d25e514;
var $53e797ca7aa8152e$export$7568632d0d33d16d;
var $53e797ca7aa8152e$export$88948ce120ea2619;
var $53e797ca7aa8152e$export$35808ee640e87ca7;
var $53e797ca7aa8152e$export$fae74005e78b1a27;
var $53e797ca7aa8152e$export$dc8fbce3eb94dc1e;
var $53e797ca7aa8152e$export$6a7bc4e911dc01cf;
var $53e797ca7aa8152e$export$6d9c69b0de29b591;
var $53e797ca7aa8152e$export$f680877a34711e37;
var $53e797ca7aa8152e$export$d5a552a76deda3c2;
var $53e797ca7aa8152e$export$aaabe4eda9ed9969;
var $53e797ca7aa8152e$export$e5c5a5f917a5871c;
var $53e797ca7aa8152e$export$1538c33de8887b59;
var $53e797ca7aa8152e$export$13e3392192263954;
var $53e797ca7aa8152e$export$b8f5890fc79d6aca;
var $53e797ca7aa8152e$export$60241385465d0a34;
var $53e797ca7aa8152e$export$306c0aa65ff9ec16;
var $53e797ca7aa8152e$export$7b286972b8d8ccbf;
var $53e797ca7aa8152e$export$83d89fbfd8236492;
'use strict';
var $53e797ca7aa8152e$var$l = Symbol.for("react.element"), $53e797ca7aa8152e$var$n = Symbol.for("react.portal"), $53e797ca7aa8152e$var$p = Symbol.for("react.fragment"), $53e797ca7aa8152e$var$q = Symbol.for("react.strict_mode"), $53e797ca7aa8152e$var$r = Symbol.for("react.profiler"), $53e797ca7aa8152e$var$t = Symbol.for("react.provider"), $53e797ca7aa8152e$var$u = Symbol.for("react.context"), $53e797ca7aa8152e$var$v = Symbol.for("react.forward_ref"), $53e797ca7aa8152e$var$w = Symbol.for("react.suspense"), $53e797ca7aa8152e$var$x = Symbol.for("react.memo"), $53e797ca7aa8152e$var$y = Symbol.for("react.lazy"), $53e797ca7aa8152e$var$z = Symbol.iterator;
function $53e797ca7aa8152e$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $53e797ca7aa8152e$var$z && a[$53e797ca7aa8152e$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $53e797ca7aa8152e$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $53e797ca7aa8152e$var$C = Object.assign, $53e797ca7aa8152e$var$D = {};
function $53e797ca7aa8152e$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $53e797ca7aa8152e$var$D;
    this.updater = e || $53e797ca7aa8152e$var$B;
}
$53e797ca7aa8152e$var$E.prototype.isReactComponent = {};
$53e797ca7aa8152e$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$53e797ca7aa8152e$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $53e797ca7aa8152e$var$F() {}
$53e797ca7aa8152e$var$F.prototype = $53e797ca7aa8152e$var$E.prototype;
function $53e797ca7aa8152e$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $53e797ca7aa8152e$var$D;
    this.updater = e || $53e797ca7aa8152e$var$B;
}
var $53e797ca7aa8152e$var$H = $53e797ca7aa8152e$var$G.prototype = new $53e797ca7aa8152e$var$F;
$53e797ca7aa8152e$var$H.constructor = $53e797ca7aa8152e$var$G;
$53e797ca7aa8152e$var$C($53e797ca7aa8152e$var$H, $53e797ca7aa8152e$var$E.prototype);
$53e797ca7aa8152e$var$H.isPureReactComponent = !0;
var $53e797ca7aa8152e$var$I = Array.isArray, $53e797ca7aa8152e$var$J = Object.prototype.hasOwnProperty, $53e797ca7aa8152e$var$K = {
    current: null
}, $53e797ca7aa8152e$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $53e797ca7aa8152e$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$53e797ca7aa8152e$var$J.call(b, d) && !$53e797ca7aa8152e$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $53e797ca7aa8152e$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $53e797ca7aa8152e$var$K.current
    };
}
function $53e797ca7aa8152e$var$N(a, b) {
    return {
        $$typeof: $53e797ca7aa8152e$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $53e797ca7aa8152e$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $53e797ca7aa8152e$var$l;
}
function $53e797ca7aa8152e$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $53e797ca7aa8152e$var$P = /\/+/g;
function $53e797ca7aa8152e$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $53e797ca7aa8152e$var$escape("" + a.key) : b.toString(36);
}
function $53e797ca7aa8152e$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $53e797ca7aa8152e$var$l:
                case $53e797ca7aa8152e$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $53e797ca7aa8152e$var$Q(h, 0) : d, $53e797ca7aa8152e$var$I(c) ? (e = "", null != a && (e = a.replace($53e797ca7aa8152e$var$P, "$&/") + "/"), $53e797ca7aa8152e$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($53e797ca7aa8152e$var$O(c) && (c = $53e797ca7aa8152e$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($53e797ca7aa8152e$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($53e797ca7aa8152e$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $53e797ca7aa8152e$var$Q(k, g);
        h += $53e797ca7aa8152e$var$R(k, b, e, f, c);
    }
    else if (f = $53e797ca7aa8152e$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $53e797ca7aa8152e$var$Q(k, g++), h += $53e797ca7aa8152e$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $53e797ca7aa8152e$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $53e797ca7aa8152e$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $53e797ca7aa8152e$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $53e797ca7aa8152e$var$U = {
    current: null
}, $53e797ca7aa8152e$var$V = {
    transition: null
}, $53e797ca7aa8152e$var$W = {
    ReactCurrentDispatcher: $53e797ca7aa8152e$var$U,
    ReactCurrentBatchConfig: $53e797ca7aa8152e$var$V,
    ReactCurrentOwner: $53e797ca7aa8152e$var$K
};
$53e797ca7aa8152e$export$dca3b0875bd9a954 = {
    map: $53e797ca7aa8152e$var$S,
    forEach: function(a, b, e) {
        $53e797ca7aa8152e$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $53e797ca7aa8152e$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $53e797ca7aa8152e$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$53e797ca7aa8152e$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$53e797ca7aa8152e$export$16fa2f45be04daa8 = $53e797ca7aa8152e$var$E;
$53e797ca7aa8152e$export$ffb0004e005737fa = $53e797ca7aa8152e$var$p;
$53e797ca7aa8152e$export$e2c29f18771995cb = $53e797ca7aa8152e$var$r;
$53e797ca7aa8152e$export$221d75b3f55bb0bd = $53e797ca7aa8152e$var$G;
$53e797ca7aa8152e$export$5f8d39834fd61797 = $53e797ca7aa8152e$var$q;
$53e797ca7aa8152e$export$74bf444e3cd11ea5 = $53e797ca7aa8152e$var$w;
$53e797ca7aa8152e$export$ae55be85d98224ed = $53e797ca7aa8152e$var$W;
$53e797ca7aa8152e$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $53e797ca7aa8152e$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $53e797ca7aa8152e$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$53e797ca7aa8152e$var$J.call(b, f) && !$53e797ca7aa8152e$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $53e797ca7aa8152e$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$53e797ca7aa8152e$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $53e797ca7aa8152e$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $53e797ca7aa8152e$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$53e797ca7aa8152e$export$c8a8987d4410bf2d = $53e797ca7aa8152e$var$M;
$53e797ca7aa8152e$export$d38cd72104c1f0e9 = function(a) {
    var b = $53e797ca7aa8152e$var$M.bind(null, a);
    b.type = a;
    return b;
};
$53e797ca7aa8152e$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$53e797ca7aa8152e$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $53e797ca7aa8152e$var$v,
        render: a
    };
};
$53e797ca7aa8152e$export$a8257692ac88316c = $53e797ca7aa8152e$var$O;
$53e797ca7aa8152e$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $53e797ca7aa8152e$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $53e797ca7aa8152e$var$T
    };
};
$53e797ca7aa8152e$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $53e797ca7aa8152e$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$53e797ca7aa8152e$export$7568632d0d33d16d = function(a) {
    var b = $53e797ca7aa8152e$var$V.transition;
    $53e797ca7aa8152e$var$V.transition = {};
    try {
        a();
    } finally{
        $53e797ca7aa8152e$var$V.transition = b;
    }
};
$53e797ca7aa8152e$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$53e797ca7aa8152e$export$35808ee640e87ca7 = function(a, b) {
    return $53e797ca7aa8152e$var$U.current.useCallback(a, b);
};
$53e797ca7aa8152e$export$fae74005e78b1a27 = function(a) {
    return $53e797ca7aa8152e$var$U.current.useContext(a);
};
$53e797ca7aa8152e$export$dc8fbce3eb94dc1e = function() {};
$53e797ca7aa8152e$export$6a7bc4e911dc01cf = function(a) {
    return $53e797ca7aa8152e$var$U.current.useDeferredValue(a);
};
$53e797ca7aa8152e$export$6d9c69b0de29b591 = function(a, b) {
    return $53e797ca7aa8152e$var$U.current.useEffect(a, b);
};
$53e797ca7aa8152e$export$f680877a34711e37 = function() {
    return $53e797ca7aa8152e$var$U.current.useId();
};
$53e797ca7aa8152e$export$d5a552a76deda3c2 = function(a, b, e) {
    return $53e797ca7aa8152e$var$U.current.useImperativeHandle(a, b, e);
};
$53e797ca7aa8152e$export$aaabe4eda9ed9969 = function(a, b) {
    return $53e797ca7aa8152e$var$U.current.useInsertionEffect(a, b);
};
$53e797ca7aa8152e$export$e5c5a5f917a5871c = function(a, b) {
    return $53e797ca7aa8152e$var$U.current.useLayoutEffect(a, b);
};
$53e797ca7aa8152e$export$1538c33de8887b59 = function(a, b) {
    return $53e797ca7aa8152e$var$U.current.useMemo(a, b);
};
$53e797ca7aa8152e$export$13e3392192263954 = function(a, b, e) {
    return $53e797ca7aa8152e$var$U.current.useReducer(a, b, e);
};
$53e797ca7aa8152e$export$b8f5890fc79d6aca = function(a) {
    return $53e797ca7aa8152e$var$U.current.useRef(a);
};
$53e797ca7aa8152e$export$60241385465d0a34 = function(a) {
    return $53e797ca7aa8152e$var$U.current.useState(a);
};
$53e797ca7aa8152e$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $53e797ca7aa8152e$var$U.current.useSyncExternalStore(a, b, e);
};
$53e797ca7aa8152e$export$7b286972b8d8ccbf = function() {
    return $53e797ca7aa8152e$var$U.current.useTransition();
};
$53e797ca7aa8152e$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("bHOev", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $885aad1b39333bac$export$ae55be85d98224ed, (v) => $885aad1b39333bac$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $885aad1b39333bac$export$d39a5bbd09211389, (v) => $885aad1b39333bac$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $885aad1b39333bac$export$882461b6382ed46c, (v) => $885aad1b39333bac$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $885aad1b39333bac$export$466bfc07425424d5, (v) => $885aad1b39333bac$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $885aad1b39333bac$export$cd75ccfd720a3cd4, (v) => $885aad1b39333bac$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $885aad1b39333bac$export$fa8d919ba61d84db, (v) => $885aad1b39333bac$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $885aad1b39333bac$export$757ceba2d55c277e, (v) => $885aad1b39333bac$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $885aad1b39333bac$export$b3890eb0ae9dca99, (v) => $885aad1b39333bac$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $885aad1b39333bac$export$502457920280e6be, (v) => $885aad1b39333bac$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $885aad1b39333bac$export$c78a37762a8d58e1, (v) => $885aad1b39333bac$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $885aad1b39333bac$export$dc54d992c10e8a18, (v) => $885aad1b39333bac$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $885aad1b39333bac$export$83d89fbfd8236492, (v) => $885aad1b39333bac$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $885aad1b39333bac$export$ae55be85d98224ed;
var $885aad1b39333bac$export$d39a5bbd09211389;
var $885aad1b39333bac$export$882461b6382ed46c;
var $885aad1b39333bac$export$466bfc07425424d5;
var $885aad1b39333bac$export$cd75ccfd720a3cd4;
var $885aad1b39333bac$export$fa8d919ba61d84db;
var $885aad1b39333bac$export$757ceba2d55c277e;
var $885aad1b39333bac$export$b3890eb0ae9dca99;
var $885aad1b39333bac$export$502457920280e6be;
var $885aad1b39333bac$export$c78a37762a8d58e1;
var $885aad1b39333bac$export$dc54d992c10e8a18;
var $885aad1b39333bac$export$83d89fbfd8236492;
'use strict';

var $28UcW = parcelRequire("28UcW");

var $8HCos = parcelRequire("8HCos");
function $885aad1b39333bac$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $885aad1b39333bac$var$da = new Set, $885aad1b39333bac$var$ea = {};
function $885aad1b39333bac$var$fa(a, b) {
    $885aad1b39333bac$var$ha(a, b);
    $885aad1b39333bac$var$ha(a + "Capture", b);
}
function $885aad1b39333bac$var$ha(a, b) {
    $885aad1b39333bac$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$885aad1b39333bac$var$da.add(b[a]);
}
var $885aad1b39333bac$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $885aad1b39333bac$var$ja = Object.prototype.hasOwnProperty, $885aad1b39333bac$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $885aad1b39333bac$var$la = {}, $885aad1b39333bac$var$ma = {};
function $885aad1b39333bac$var$oa(a) {
    if ($885aad1b39333bac$var$ja.call($885aad1b39333bac$var$ma, a)) return !0;
    if ($885aad1b39333bac$var$ja.call($885aad1b39333bac$var$la, a)) return !1;
    if ($885aad1b39333bac$var$ka.test(a)) return $885aad1b39333bac$var$ma[a] = !0;
    $885aad1b39333bac$var$la[a] = !0;
    return !1;
}
function $885aad1b39333bac$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $885aad1b39333bac$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $885aad1b39333bac$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $885aad1b39333bac$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $885aad1b39333bac$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $885aad1b39333bac$var$z[a] = new $885aad1b39333bac$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $885aad1b39333bac$var$z[b] = new $885aad1b39333bac$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $885aad1b39333bac$var$z[a] = new $885aad1b39333bac$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $885aad1b39333bac$var$z[a] = new $885aad1b39333bac$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $885aad1b39333bac$var$z[a] = new $885aad1b39333bac$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $885aad1b39333bac$var$z[a] = new $885aad1b39333bac$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $885aad1b39333bac$var$z[a] = new $885aad1b39333bac$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $885aad1b39333bac$var$z[a] = new $885aad1b39333bac$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $885aad1b39333bac$var$z[a] = new $885aad1b39333bac$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $885aad1b39333bac$var$ra = /[\-:]([a-z])/g;
function $885aad1b39333bac$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($885aad1b39333bac$var$ra, $885aad1b39333bac$var$sa);
    $885aad1b39333bac$var$z[b] = new $885aad1b39333bac$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($885aad1b39333bac$var$ra, $885aad1b39333bac$var$sa);
    $885aad1b39333bac$var$z[b] = new $885aad1b39333bac$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($885aad1b39333bac$var$ra, $885aad1b39333bac$var$sa);
    $885aad1b39333bac$var$z[b] = new $885aad1b39333bac$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $885aad1b39333bac$var$z[a] = new $885aad1b39333bac$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$885aad1b39333bac$var$z.xlinkHref = new $885aad1b39333bac$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $885aad1b39333bac$var$z[a] = new $885aad1b39333bac$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $885aad1b39333bac$var$ta(a, b, c, d) {
    var e = $885aad1b39333bac$var$z.hasOwnProperty(b) ? $885aad1b39333bac$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $885aad1b39333bac$var$qa(b, c, e, d) && (c = null), d || null === e ? $885aad1b39333bac$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $885aad1b39333bac$var$ua = $28UcW.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $885aad1b39333bac$var$va = Symbol.for("react.element"), $885aad1b39333bac$var$wa = Symbol.for("react.portal"), $885aad1b39333bac$var$ya = Symbol.for("react.fragment"), $885aad1b39333bac$var$za = Symbol.for("react.strict_mode"), $885aad1b39333bac$var$Aa = Symbol.for("react.profiler"), $885aad1b39333bac$var$Ba = Symbol.for("react.provider"), $885aad1b39333bac$var$Ca = Symbol.for("react.context"), $885aad1b39333bac$var$Da = Symbol.for("react.forward_ref"), $885aad1b39333bac$var$Ea = Symbol.for("react.suspense"), $885aad1b39333bac$var$Fa = Symbol.for("react.suspense_list"), $885aad1b39333bac$var$Ga = Symbol.for("react.memo"), $885aad1b39333bac$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $885aad1b39333bac$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $885aad1b39333bac$var$Ja = Symbol.iterator;
function $885aad1b39333bac$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $885aad1b39333bac$var$Ja && a[$885aad1b39333bac$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $885aad1b39333bac$var$A = Object.assign, $885aad1b39333bac$var$La;
function $885aad1b39333bac$var$Ma(a) {
    if (void 0 === $885aad1b39333bac$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $885aad1b39333bac$var$La = b && b[1] || "";
    }
    return "\n" + $885aad1b39333bac$var$La + a;
}
var $885aad1b39333bac$var$Na = !1;
function $885aad1b39333bac$var$Oa(a, b) {
    if (!a || $885aad1b39333bac$var$Na) return "";
    $885aad1b39333bac$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $885aad1b39333bac$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $885aad1b39333bac$var$Ma(a) : "";
}
function $885aad1b39333bac$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $885aad1b39333bac$var$Ma(a.type);
        case 16:
            return $885aad1b39333bac$var$Ma("Lazy");
        case 13:
            return $885aad1b39333bac$var$Ma("Suspense");
        case 19:
            return $885aad1b39333bac$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $885aad1b39333bac$var$Oa(a.type, !1), a;
        case 11:
            return a = $885aad1b39333bac$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $885aad1b39333bac$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $885aad1b39333bac$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $885aad1b39333bac$var$ya:
            return "Fragment";
        case $885aad1b39333bac$var$wa:
            return "Portal";
        case $885aad1b39333bac$var$Aa:
            return "Profiler";
        case $885aad1b39333bac$var$za:
            return "StrictMode";
        case $885aad1b39333bac$var$Ea:
            return "Suspense";
        case $885aad1b39333bac$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $885aad1b39333bac$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $885aad1b39333bac$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $885aad1b39333bac$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $885aad1b39333bac$var$Ga:
            return b = a.displayName || null, null !== b ? b : $885aad1b39333bac$var$Qa(a.type) || "Memo";
        case $885aad1b39333bac$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $885aad1b39333bac$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $885aad1b39333bac$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $885aad1b39333bac$var$Qa(b);
        case 8:
            return b === $885aad1b39333bac$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $885aad1b39333bac$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $885aad1b39333bac$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $885aad1b39333bac$var$Ua(a) {
    var b = $885aad1b39333bac$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $885aad1b39333bac$var$Va(a) {
    a._valueTracker || (a._valueTracker = $885aad1b39333bac$var$Ua(a));
}
function $885aad1b39333bac$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $885aad1b39333bac$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $885aad1b39333bac$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $885aad1b39333bac$var$Ya(a, b) {
    var c = b.checked;
    return $885aad1b39333bac$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $885aad1b39333bac$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $885aad1b39333bac$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $885aad1b39333bac$var$ab(a, b) {
    b = b.checked;
    null != b && $885aad1b39333bac$var$ta(a, "checked", b, !1);
}
function $885aad1b39333bac$var$bb(a, b) {
    $885aad1b39333bac$var$ab(a, b);
    var c = $885aad1b39333bac$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $885aad1b39333bac$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $885aad1b39333bac$var$cb(a, b.type, $885aad1b39333bac$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $885aad1b39333bac$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $885aad1b39333bac$var$cb(a, b, c) {
    if ("number" !== b || $885aad1b39333bac$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $885aad1b39333bac$var$eb = Array.isArray;
function $885aad1b39333bac$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $885aad1b39333bac$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $885aad1b39333bac$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($885aad1b39333bac$var$p(91));
    return $885aad1b39333bac$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $885aad1b39333bac$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($885aad1b39333bac$var$p(92));
            if ($885aad1b39333bac$var$eb(c)) {
                if (1 < c.length) throw Error($885aad1b39333bac$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $885aad1b39333bac$var$Sa(c)
    };
}
function $885aad1b39333bac$var$ib(a, b) {
    var c = $885aad1b39333bac$var$Sa(b.value), d = $885aad1b39333bac$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $885aad1b39333bac$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $885aad1b39333bac$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $885aad1b39333bac$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $885aad1b39333bac$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $885aad1b39333bac$var$mb, $885aad1b39333bac$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $885aad1b39333bac$var$mb = $885aad1b39333bac$var$mb || document.createElement("div");
        $885aad1b39333bac$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $885aad1b39333bac$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $885aad1b39333bac$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $885aad1b39333bac$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $885aad1b39333bac$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($885aad1b39333bac$var$pb).forEach(function(a) {
    $885aad1b39333bac$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $885aad1b39333bac$var$pb[b] = $885aad1b39333bac$var$pb[a];
    });
});
function $885aad1b39333bac$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $885aad1b39333bac$var$pb.hasOwnProperty(a) && $885aad1b39333bac$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $885aad1b39333bac$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $885aad1b39333bac$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $885aad1b39333bac$var$tb = $885aad1b39333bac$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $885aad1b39333bac$var$ub(a, b) {
    if (b) {
        if ($885aad1b39333bac$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($885aad1b39333bac$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($885aad1b39333bac$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($885aad1b39333bac$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($885aad1b39333bac$var$p(62));
    }
}
function $885aad1b39333bac$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $885aad1b39333bac$var$wb = null;
function $885aad1b39333bac$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $885aad1b39333bac$var$yb = null, $885aad1b39333bac$var$zb = null, $885aad1b39333bac$var$Ab = null;
function $885aad1b39333bac$var$Bb(a) {
    if (a = $885aad1b39333bac$var$Cb(a)) {
        if ("function" !== typeof $885aad1b39333bac$var$yb) throw Error($885aad1b39333bac$var$p(280));
        var b = a.stateNode;
        b && (b = $885aad1b39333bac$var$Db(b), $885aad1b39333bac$var$yb(a.stateNode, a.type, b));
    }
}
function $885aad1b39333bac$var$Eb(a) {
    $885aad1b39333bac$var$zb ? $885aad1b39333bac$var$Ab ? $885aad1b39333bac$var$Ab.push(a) : $885aad1b39333bac$var$Ab = [
        a
    ] : $885aad1b39333bac$var$zb = a;
}
function $885aad1b39333bac$var$Fb() {
    if ($885aad1b39333bac$var$zb) {
        var a = $885aad1b39333bac$var$zb, b = $885aad1b39333bac$var$Ab;
        $885aad1b39333bac$var$Ab = $885aad1b39333bac$var$zb = null;
        $885aad1b39333bac$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$885aad1b39333bac$var$Bb(b[a]);
    }
}
function $885aad1b39333bac$var$Gb(a, b) {
    return a(b);
}
function $885aad1b39333bac$var$Hb() {}
var $885aad1b39333bac$var$Ib = !1;
function $885aad1b39333bac$var$Jb(a, b, c) {
    if ($885aad1b39333bac$var$Ib) return a(b, c);
    $885aad1b39333bac$var$Ib = !0;
    try {
        return $885aad1b39333bac$var$Gb(a, b, c);
    } finally{
        if ($885aad1b39333bac$var$Ib = !1, null !== $885aad1b39333bac$var$zb || null !== $885aad1b39333bac$var$Ab) $885aad1b39333bac$var$Hb(), $885aad1b39333bac$var$Fb();
    }
}
function $885aad1b39333bac$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $885aad1b39333bac$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($885aad1b39333bac$var$p(231, b, typeof c));
    return c;
}
var $885aad1b39333bac$var$Lb = !1;
if ($885aad1b39333bac$var$ia) try {
    var $885aad1b39333bac$var$Mb = {};
    Object.defineProperty($885aad1b39333bac$var$Mb, "passive", {
        get: function() {
            $885aad1b39333bac$var$Lb = !0;
        }
    });
    window.addEventListener("test", $885aad1b39333bac$var$Mb, $885aad1b39333bac$var$Mb);
    window.removeEventListener("test", $885aad1b39333bac$var$Mb, $885aad1b39333bac$var$Mb);
} catch (a) {
    $885aad1b39333bac$var$Lb = !1;
}
function $885aad1b39333bac$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $885aad1b39333bac$var$Ob = !1, $885aad1b39333bac$var$Pb = null, $885aad1b39333bac$var$Qb = !1, $885aad1b39333bac$var$Rb = null, $885aad1b39333bac$var$Sb = {
    onError: function(a) {
        $885aad1b39333bac$var$Ob = !0;
        $885aad1b39333bac$var$Pb = a;
    }
};
function $885aad1b39333bac$var$Tb(a, b, c, d, e, f, g, h, k) {
    $885aad1b39333bac$var$Ob = !1;
    $885aad1b39333bac$var$Pb = null;
    $885aad1b39333bac$var$Nb.apply($885aad1b39333bac$var$Sb, arguments);
}
function $885aad1b39333bac$var$Ub(a, b, c, d, e, f, g, h, k) {
    $885aad1b39333bac$var$Tb.apply(this, arguments);
    if ($885aad1b39333bac$var$Ob) {
        if ($885aad1b39333bac$var$Ob) {
            var l = $885aad1b39333bac$var$Pb;
            $885aad1b39333bac$var$Ob = !1;
            $885aad1b39333bac$var$Pb = null;
        } else throw Error($885aad1b39333bac$var$p(198));
        $885aad1b39333bac$var$Qb || ($885aad1b39333bac$var$Qb = !0, $885aad1b39333bac$var$Rb = l);
    }
}
function $885aad1b39333bac$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $885aad1b39333bac$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $885aad1b39333bac$var$Xb(a) {
    if ($885aad1b39333bac$var$Vb(a) !== a) throw Error($885aad1b39333bac$var$p(188));
}
function $885aad1b39333bac$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $885aad1b39333bac$var$Vb(a);
        if (null === b) throw Error($885aad1b39333bac$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $885aad1b39333bac$var$Xb(e), a;
                if (f === d) return $885aad1b39333bac$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($885aad1b39333bac$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($885aad1b39333bac$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($885aad1b39333bac$var$p(190));
    }
    if (3 !== c.tag) throw Error($885aad1b39333bac$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $885aad1b39333bac$var$Zb(a) {
    a = $885aad1b39333bac$var$Yb(a);
    return null !== a ? $885aad1b39333bac$var$$b(a) : null;
}
function $885aad1b39333bac$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $885aad1b39333bac$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $885aad1b39333bac$var$ac = $8HCos.unstable_scheduleCallback, $885aad1b39333bac$var$bc = $8HCos.unstable_cancelCallback, $885aad1b39333bac$var$cc = $8HCos.unstable_shouldYield, $885aad1b39333bac$var$dc = $8HCos.unstable_requestPaint, $885aad1b39333bac$var$B = $8HCos.unstable_now, $885aad1b39333bac$var$ec = $8HCos.unstable_getCurrentPriorityLevel, $885aad1b39333bac$var$fc = $8HCos.unstable_ImmediatePriority, $885aad1b39333bac$var$gc = $8HCos.unstable_UserBlockingPriority, $885aad1b39333bac$var$hc = $8HCos.unstable_NormalPriority, $885aad1b39333bac$var$ic = $8HCos.unstable_LowPriority, $885aad1b39333bac$var$jc = $8HCos.unstable_IdlePriority, $885aad1b39333bac$var$kc = null, $885aad1b39333bac$var$lc = null;
function $885aad1b39333bac$var$mc(a) {
    if ($885aad1b39333bac$var$lc && "function" === typeof $885aad1b39333bac$var$lc.onCommitFiberRoot) try {
        $885aad1b39333bac$var$lc.onCommitFiberRoot($885aad1b39333bac$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $885aad1b39333bac$var$oc = Math.clz32 ? Math.clz32 : $885aad1b39333bac$var$nc, $885aad1b39333bac$var$pc = Math.log, $885aad1b39333bac$var$qc = Math.LN2;
function $885aad1b39333bac$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($885aad1b39333bac$var$pc(a) / $885aad1b39333bac$var$qc | 0) | 0;
}
var $885aad1b39333bac$var$rc = 64, $885aad1b39333bac$var$sc = 4194304;
function $885aad1b39333bac$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $885aad1b39333bac$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $885aad1b39333bac$var$tc(h) : (f &= g, 0 !== f && (d = $885aad1b39333bac$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $885aad1b39333bac$var$tc(g) : 0 !== f && (d = $885aad1b39333bac$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $885aad1b39333bac$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $885aad1b39333bac$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $885aad1b39333bac$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $885aad1b39333bac$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $885aad1b39333bac$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $885aad1b39333bac$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $885aad1b39333bac$var$yc() {
    var a = $885aad1b39333bac$var$rc;
    $885aad1b39333bac$var$rc <<= 1;
    0 === ($885aad1b39333bac$var$rc & 4194240) && ($885aad1b39333bac$var$rc = 64);
    return a;
}
function $885aad1b39333bac$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $885aad1b39333bac$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $885aad1b39333bac$var$oc(b);
    a[b] = c;
}
function $885aad1b39333bac$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $885aad1b39333bac$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $885aad1b39333bac$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $885aad1b39333bac$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $885aad1b39333bac$var$C = 0;
function $885aad1b39333bac$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $885aad1b39333bac$var$Ec, $885aad1b39333bac$var$Fc, $885aad1b39333bac$var$Gc, $885aad1b39333bac$var$Hc, $885aad1b39333bac$var$Ic, $885aad1b39333bac$var$Jc = !1, $885aad1b39333bac$var$Kc = [], $885aad1b39333bac$var$Lc = null, $885aad1b39333bac$var$Mc = null, $885aad1b39333bac$var$Nc = null, $885aad1b39333bac$var$Oc = new Map, $885aad1b39333bac$var$Pc = new Map, $885aad1b39333bac$var$Qc = [], $885aad1b39333bac$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $885aad1b39333bac$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $885aad1b39333bac$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $885aad1b39333bac$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $885aad1b39333bac$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $885aad1b39333bac$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $885aad1b39333bac$var$Pc.delete(b.pointerId);
    }
}
function $885aad1b39333bac$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $885aad1b39333bac$var$Cb(b), null !== b && $885aad1b39333bac$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $885aad1b39333bac$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $885aad1b39333bac$var$Lc = $885aad1b39333bac$var$Tc($885aad1b39333bac$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $885aad1b39333bac$var$Mc = $885aad1b39333bac$var$Tc($885aad1b39333bac$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $885aad1b39333bac$var$Nc = $885aad1b39333bac$var$Tc($885aad1b39333bac$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $885aad1b39333bac$var$Oc.set(f, $885aad1b39333bac$var$Tc($885aad1b39333bac$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $885aad1b39333bac$var$Pc.set(f, $885aad1b39333bac$var$Tc($885aad1b39333bac$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $885aad1b39333bac$var$Vc(a) {
    var b = $885aad1b39333bac$var$Wc(a.target);
    if (null !== b) {
        var c = $885aad1b39333bac$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $885aad1b39333bac$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $885aad1b39333bac$var$Ic(a.priority, function() {
                        $885aad1b39333bac$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $885aad1b39333bac$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $885aad1b39333bac$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $885aad1b39333bac$var$wb = d;
            c.target.dispatchEvent(d);
            $885aad1b39333bac$var$wb = null;
        } else return b = $885aad1b39333bac$var$Cb(c), null !== b && $885aad1b39333bac$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $885aad1b39333bac$var$Zc(a, b, c) {
    $885aad1b39333bac$var$Xc(a) && c.delete(b);
}
function $885aad1b39333bac$var$$c() {
    $885aad1b39333bac$var$Jc = !1;
    null !== $885aad1b39333bac$var$Lc && $885aad1b39333bac$var$Xc($885aad1b39333bac$var$Lc) && ($885aad1b39333bac$var$Lc = null);
    null !== $885aad1b39333bac$var$Mc && $885aad1b39333bac$var$Xc($885aad1b39333bac$var$Mc) && ($885aad1b39333bac$var$Mc = null);
    null !== $885aad1b39333bac$var$Nc && $885aad1b39333bac$var$Xc($885aad1b39333bac$var$Nc) && ($885aad1b39333bac$var$Nc = null);
    $885aad1b39333bac$var$Oc.forEach($885aad1b39333bac$var$Zc);
    $885aad1b39333bac$var$Pc.forEach($885aad1b39333bac$var$Zc);
}
function $885aad1b39333bac$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $885aad1b39333bac$var$Jc || ($885aad1b39333bac$var$Jc = !0, $8HCos.unstable_scheduleCallback($8HCos.unstable_NormalPriority, $885aad1b39333bac$var$$c)));
}
function $885aad1b39333bac$var$bd(a) {
    function b(b) {
        return $885aad1b39333bac$var$ad(b, a);
    }
    if (0 < $885aad1b39333bac$var$Kc.length) {
        $885aad1b39333bac$var$ad($885aad1b39333bac$var$Kc[0], a);
        for(var c = 1; c < $885aad1b39333bac$var$Kc.length; c++){
            var d = $885aad1b39333bac$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $885aad1b39333bac$var$Lc && $885aad1b39333bac$var$ad($885aad1b39333bac$var$Lc, a);
    null !== $885aad1b39333bac$var$Mc && $885aad1b39333bac$var$ad($885aad1b39333bac$var$Mc, a);
    null !== $885aad1b39333bac$var$Nc && $885aad1b39333bac$var$ad($885aad1b39333bac$var$Nc, a);
    $885aad1b39333bac$var$Oc.forEach(b);
    $885aad1b39333bac$var$Pc.forEach(b);
    for(c = 0; c < $885aad1b39333bac$var$Qc.length; c++)d = $885aad1b39333bac$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $885aad1b39333bac$var$Qc.length && (c = $885aad1b39333bac$var$Qc[0], null === c.blockedOn);)$885aad1b39333bac$var$Vc(c), null === c.blockedOn && $885aad1b39333bac$var$Qc.shift();
}
var $885aad1b39333bac$var$cd = $885aad1b39333bac$var$ua.ReactCurrentBatchConfig, $885aad1b39333bac$var$dd = !0;
function $885aad1b39333bac$var$ed(a, b, c, d) {
    var e = $885aad1b39333bac$var$C, f = $885aad1b39333bac$var$cd.transition;
    $885aad1b39333bac$var$cd.transition = null;
    try {
        $885aad1b39333bac$var$C = 1, $885aad1b39333bac$var$fd(a, b, c, d);
    } finally{
        $885aad1b39333bac$var$C = e, $885aad1b39333bac$var$cd.transition = f;
    }
}
function $885aad1b39333bac$var$gd(a, b, c, d) {
    var e = $885aad1b39333bac$var$C, f = $885aad1b39333bac$var$cd.transition;
    $885aad1b39333bac$var$cd.transition = null;
    try {
        $885aad1b39333bac$var$C = 4, $885aad1b39333bac$var$fd(a, b, c, d);
    } finally{
        $885aad1b39333bac$var$C = e, $885aad1b39333bac$var$cd.transition = f;
    }
}
function $885aad1b39333bac$var$fd(a, b, c, d) {
    if ($885aad1b39333bac$var$dd) {
        var e = $885aad1b39333bac$var$Yc(a, b, c, d);
        if (null === e) $885aad1b39333bac$var$hd(a, b, d, $885aad1b39333bac$var$id, c), $885aad1b39333bac$var$Sc(a, d);
        else if ($885aad1b39333bac$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($885aad1b39333bac$var$Sc(a, d), b & 4 && -1 < $885aad1b39333bac$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $885aad1b39333bac$var$Cb(e);
                null !== f && $885aad1b39333bac$var$Ec(f);
                f = $885aad1b39333bac$var$Yc(a, b, c, d);
                null === f && $885aad1b39333bac$var$hd(a, b, d, $885aad1b39333bac$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $885aad1b39333bac$var$hd(a, b, d, null, c);
    }
}
var $885aad1b39333bac$var$id = null;
function $885aad1b39333bac$var$Yc(a, b, c, d) {
    $885aad1b39333bac$var$id = null;
    a = $885aad1b39333bac$var$xb(d);
    a = $885aad1b39333bac$var$Wc(a);
    if (null !== a) {
        if (b = $885aad1b39333bac$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $885aad1b39333bac$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $885aad1b39333bac$var$id = a;
    return null;
}
function $885aad1b39333bac$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($885aad1b39333bac$var$ec()){
                case $885aad1b39333bac$var$fc:
                    return 1;
                case $885aad1b39333bac$var$gc:
                    return 4;
                case $885aad1b39333bac$var$hc:
                case $885aad1b39333bac$var$ic:
                    return 16;
                case $885aad1b39333bac$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $885aad1b39333bac$var$kd = null, $885aad1b39333bac$var$ld = null, $885aad1b39333bac$var$md = null;
function $885aad1b39333bac$var$nd() {
    if ($885aad1b39333bac$var$md) return $885aad1b39333bac$var$md;
    var a, b = $885aad1b39333bac$var$ld, c = b.length, d, e = "value" in $885aad1b39333bac$var$kd ? $885aad1b39333bac$var$kd.value : $885aad1b39333bac$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $885aad1b39333bac$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $885aad1b39333bac$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $885aad1b39333bac$var$pd() {
    return !0;
}
function $885aad1b39333bac$var$qd() {
    return !1;
}
function $885aad1b39333bac$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $885aad1b39333bac$var$pd : $885aad1b39333bac$var$qd;
        this.isPropagationStopped = $885aad1b39333bac$var$qd;
        return this;
    }
    $885aad1b39333bac$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $885aad1b39333bac$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $885aad1b39333bac$var$pd);
        },
        persist: function() {},
        isPersistent: $885aad1b39333bac$var$pd
    });
    return b;
}
var $885aad1b39333bac$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $885aad1b39333bac$var$td = $885aad1b39333bac$var$rd($885aad1b39333bac$var$sd), $885aad1b39333bac$var$ud = $885aad1b39333bac$var$A({}, $885aad1b39333bac$var$sd, {
    view: 0,
    detail: 0
}), $885aad1b39333bac$var$vd = $885aad1b39333bac$var$rd($885aad1b39333bac$var$ud), $885aad1b39333bac$var$wd, $885aad1b39333bac$var$xd, $885aad1b39333bac$var$yd, $885aad1b39333bac$var$Ad = $885aad1b39333bac$var$A({}, $885aad1b39333bac$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $885aad1b39333bac$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $885aad1b39333bac$var$yd && ($885aad1b39333bac$var$yd && "mousemove" === a.type ? ($885aad1b39333bac$var$wd = a.screenX - $885aad1b39333bac$var$yd.screenX, $885aad1b39333bac$var$xd = a.screenY - $885aad1b39333bac$var$yd.screenY) : $885aad1b39333bac$var$xd = $885aad1b39333bac$var$wd = 0, $885aad1b39333bac$var$yd = a);
        return $885aad1b39333bac$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $885aad1b39333bac$var$xd;
    }
}), $885aad1b39333bac$var$Bd = $885aad1b39333bac$var$rd($885aad1b39333bac$var$Ad), $885aad1b39333bac$var$Cd = $885aad1b39333bac$var$A({}, $885aad1b39333bac$var$Ad, {
    dataTransfer: 0
}), $885aad1b39333bac$var$Dd = $885aad1b39333bac$var$rd($885aad1b39333bac$var$Cd), $885aad1b39333bac$var$Ed = $885aad1b39333bac$var$A({}, $885aad1b39333bac$var$ud, {
    relatedTarget: 0
}), $885aad1b39333bac$var$Fd = $885aad1b39333bac$var$rd($885aad1b39333bac$var$Ed), $885aad1b39333bac$var$Gd = $885aad1b39333bac$var$A({}, $885aad1b39333bac$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $885aad1b39333bac$var$Hd = $885aad1b39333bac$var$rd($885aad1b39333bac$var$Gd), $885aad1b39333bac$var$Id = $885aad1b39333bac$var$A({}, $885aad1b39333bac$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $885aad1b39333bac$var$Jd = $885aad1b39333bac$var$rd($885aad1b39333bac$var$Id), $885aad1b39333bac$var$Kd = $885aad1b39333bac$var$A({}, $885aad1b39333bac$var$sd, {
    data: 0
}), $885aad1b39333bac$var$Ld = $885aad1b39333bac$var$rd($885aad1b39333bac$var$Kd), $885aad1b39333bac$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $885aad1b39333bac$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $885aad1b39333bac$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $885aad1b39333bac$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $885aad1b39333bac$var$Od[a]) ? !!b[a] : !1;
}
function $885aad1b39333bac$var$zd() {
    return $885aad1b39333bac$var$Pd;
}
var $885aad1b39333bac$var$Qd = $885aad1b39333bac$var$A({}, $885aad1b39333bac$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $885aad1b39333bac$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $885aad1b39333bac$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $885aad1b39333bac$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $885aad1b39333bac$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $885aad1b39333bac$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $885aad1b39333bac$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $885aad1b39333bac$var$Rd = $885aad1b39333bac$var$rd($885aad1b39333bac$var$Qd), $885aad1b39333bac$var$Sd = $885aad1b39333bac$var$A({}, $885aad1b39333bac$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $885aad1b39333bac$var$Td = $885aad1b39333bac$var$rd($885aad1b39333bac$var$Sd), $885aad1b39333bac$var$Ud = $885aad1b39333bac$var$A({}, $885aad1b39333bac$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $885aad1b39333bac$var$zd
}), $885aad1b39333bac$var$Vd = $885aad1b39333bac$var$rd($885aad1b39333bac$var$Ud), $885aad1b39333bac$var$Wd = $885aad1b39333bac$var$A({}, $885aad1b39333bac$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $885aad1b39333bac$var$Xd = $885aad1b39333bac$var$rd($885aad1b39333bac$var$Wd), $885aad1b39333bac$var$Yd = $885aad1b39333bac$var$A({}, $885aad1b39333bac$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $885aad1b39333bac$var$Zd = $885aad1b39333bac$var$rd($885aad1b39333bac$var$Yd), $885aad1b39333bac$var$$d = [
    9,
    13,
    27,
    32
], $885aad1b39333bac$var$ae = $885aad1b39333bac$var$ia && "CompositionEvent" in window, $885aad1b39333bac$var$be = null;
$885aad1b39333bac$var$ia && "documentMode" in document && ($885aad1b39333bac$var$be = document.documentMode);
var $885aad1b39333bac$var$ce = $885aad1b39333bac$var$ia && "TextEvent" in window && !$885aad1b39333bac$var$be, $885aad1b39333bac$var$de = $885aad1b39333bac$var$ia && (!$885aad1b39333bac$var$ae || $885aad1b39333bac$var$be && 8 < $885aad1b39333bac$var$be && 11 >= $885aad1b39333bac$var$be), $885aad1b39333bac$var$ee = String.fromCharCode(32), $885aad1b39333bac$var$fe = !1;
function $885aad1b39333bac$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $885aad1b39333bac$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $885aad1b39333bac$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $885aad1b39333bac$var$ie = !1;
function $885aad1b39333bac$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $885aad1b39333bac$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $885aad1b39333bac$var$fe = !0;
            return $885aad1b39333bac$var$ee;
        case "textInput":
            return a = b.data, a === $885aad1b39333bac$var$ee && $885aad1b39333bac$var$fe ? null : a;
        default:
            return null;
    }
}
function $885aad1b39333bac$var$ke(a, b) {
    if ($885aad1b39333bac$var$ie) return "compositionend" === a || !$885aad1b39333bac$var$ae && $885aad1b39333bac$var$ge(a, b) ? (a = $885aad1b39333bac$var$nd(), $885aad1b39333bac$var$md = $885aad1b39333bac$var$ld = $885aad1b39333bac$var$kd = null, $885aad1b39333bac$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $885aad1b39333bac$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $885aad1b39333bac$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $885aad1b39333bac$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$885aad1b39333bac$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $885aad1b39333bac$var$ne(a, b, c, d) {
    $885aad1b39333bac$var$Eb(d);
    b = $885aad1b39333bac$var$oe(b, "onChange");
    0 < b.length && (c = new $885aad1b39333bac$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $885aad1b39333bac$var$pe = null, $885aad1b39333bac$var$qe = null;
function $885aad1b39333bac$var$re(a) {
    $885aad1b39333bac$var$se(a, 0);
}
function $885aad1b39333bac$var$te(a) {
    var b = $885aad1b39333bac$var$ue(a);
    if ($885aad1b39333bac$var$Wa(b)) return a;
}
function $885aad1b39333bac$var$ve(a, b) {
    if ("change" === a) return b;
}
var $885aad1b39333bac$var$we = !1;
if ($885aad1b39333bac$var$ia) {
    var $885aad1b39333bac$var$xe;
    if ($885aad1b39333bac$var$ia) {
        var $885aad1b39333bac$var$ye = "oninput" in document;
        if (!$885aad1b39333bac$var$ye) {
            var $885aad1b39333bac$var$ze = document.createElement("div");
            $885aad1b39333bac$var$ze.setAttribute("oninput", "return;");
            $885aad1b39333bac$var$ye = "function" === typeof $885aad1b39333bac$var$ze.oninput;
        }
        $885aad1b39333bac$var$xe = $885aad1b39333bac$var$ye;
    } else $885aad1b39333bac$var$xe = !1;
    $885aad1b39333bac$var$we = $885aad1b39333bac$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $885aad1b39333bac$var$Ae() {
    $885aad1b39333bac$var$pe && ($885aad1b39333bac$var$pe.detachEvent("onpropertychange", $885aad1b39333bac$var$Be), $885aad1b39333bac$var$qe = $885aad1b39333bac$var$pe = null);
}
function $885aad1b39333bac$var$Be(a) {
    if ("value" === a.propertyName && $885aad1b39333bac$var$te($885aad1b39333bac$var$qe)) {
        var b = [];
        $885aad1b39333bac$var$ne(b, $885aad1b39333bac$var$qe, a, $885aad1b39333bac$var$xb(a));
        $885aad1b39333bac$var$Jb($885aad1b39333bac$var$re, b);
    }
}
function $885aad1b39333bac$var$Ce(a, b, c) {
    "focusin" === a ? ($885aad1b39333bac$var$Ae(), $885aad1b39333bac$var$pe = b, $885aad1b39333bac$var$qe = c, $885aad1b39333bac$var$pe.attachEvent("onpropertychange", $885aad1b39333bac$var$Be)) : "focusout" === a && $885aad1b39333bac$var$Ae();
}
function $885aad1b39333bac$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $885aad1b39333bac$var$te($885aad1b39333bac$var$qe);
}
function $885aad1b39333bac$var$Ee(a, b) {
    if ("click" === a) return $885aad1b39333bac$var$te(b);
}
function $885aad1b39333bac$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $885aad1b39333bac$var$te(b);
}
function $885aad1b39333bac$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $885aad1b39333bac$var$He = "function" === typeof Object.is ? Object.is : $885aad1b39333bac$var$Ge;
function $885aad1b39333bac$var$Ie(a, b) {
    if ($885aad1b39333bac$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$885aad1b39333bac$var$ja.call(b, e) || !$885aad1b39333bac$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $885aad1b39333bac$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $885aad1b39333bac$var$Ke(a, b) {
    var c = $885aad1b39333bac$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $885aad1b39333bac$var$Je(c);
    }
}
function $885aad1b39333bac$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $885aad1b39333bac$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $885aad1b39333bac$var$Me() {
    for(var a = window, b = $885aad1b39333bac$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $885aad1b39333bac$var$Xa(a.document);
    }
    return b;
}
function $885aad1b39333bac$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $885aad1b39333bac$var$Oe(a) {
    var b = $885aad1b39333bac$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $885aad1b39333bac$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $885aad1b39333bac$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $885aad1b39333bac$var$Ke(c, f);
                var g = $885aad1b39333bac$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $885aad1b39333bac$var$Pe = $885aad1b39333bac$var$ia && "documentMode" in document && 11 >= document.documentMode, $885aad1b39333bac$var$Qe = null, $885aad1b39333bac$var$Re = null, $885aad1b39333bac$var$Se = null, $885aad1b39333bac$var$Te = !1;
function $885aad1b39333bac$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $885aad1b39333bac$var$Te || null == $885aad1b39333bac$var$Qe || $885aad1b39333bac$var$Qe !== $885aad1b39333bac$var$Xa(d) || (d = $885aad1b39333bac$var$Qe, "selectionStart" in d && $885aad1b39333bac$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $885aad1b39333bac$var$Se && $885aad1b39333bac$var$Ie($885aad1b39333bac$var$Se, d) || ($885aad1b39333bac$var$Se = d, d = $885aad1b39333bac$var$oe($885aad1b39333bac$var$Re, "onSelect"), 0 < d.length && (b = new $885aad1b39333bac$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $885aad1b39333bac$var$Qe)));
}
function $885aad1b39333bac$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $885aad1b39333bac$var$We = {
    animationend: $885aad1b39333bac$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $885aad1b39333bac$var$Ve("Animation", "AnimationIteration"),
    animationstart: $885aad1b39333bac$var$Ve("Animation", "AnimationStart"),
    transitionend: $885aad1b39333bac$var$Ve("Transition", "TransitionEnd")
}, $885aad1b39333bac$var$Xe = {}, $885aad1b39333bac$var$Ye = {};
$885aad1b39333bac$var$ia && ($885aad1b39333bac$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $885aad1b39333bac$var$We.animationend.animation, delete $885aad1b39333bac$var$We.animationiteration.animation, delete $885aad1b39333bac$var$We.animationstart.animation), "TransitionEvent" in window || delete $885aad1b39333bac$var$We.transitionend.transition);
function $885aad1b39333bac$var$Ze(a) {
    if ($885aad1b39333bac$var$Xe[a]) return $885aad1b39333bac$var$Xe[a];
    if (!$885aad1b39333bac$var$We[a]) return a;
    var b = $885aad1b39333bac$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $885aad1b39333bac$var$Ye) return $885aad1b39333bac$var$Xe[a] = b[c];
    return a;
}
var $885aad1b39333bac$var$$e = $885aad1b39333bac$var$Ze("animationend"), $885aad1b39333bac$var$af = $885aad1b39333bac$var$Ze("animationiteration"), $885aad1b39333bac$var$bf = $885aad1b39333bac$var$Ze("animationstart"), $885aad1b39333bac$var$cf = $885aad1b39333bac$var$Ze("transitionend"), $885aad1b39333bac$var$df = new Map, $885aad1b39333bac$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $885aad1b39333bac$var$ff(a, b) {
    $885aad1b39333bac$var$df.set(a, b);
    $885aad1b39333bac$var$fa(b, [
        a
    ]);
}
for(var $885aad1b39333bac$var$gf = 0; $885aad1b39333bac$var$gf < $885aad1b39333bac$var$ef.length; $885aad1b39333bac$var$gf++){
    var $885aad1b39333bac$var$hf = $885aad1b39333bac$var$ef[$885aad1b39333bac$var$gf], $885aad1b39333bac$var$jf = $885aad1b39333bac$var$hf.toLowerCase(), $885aad1b39333bac$var$kf = $885aad1b39333bac$var$hf[0].toUpperCase() + $885aad1b39333bac$var$hf.slice(1);
    $885aad1b39333bac$var$ff($885aad1b39333bac$var$jf, "on" + $885aad1b39333bac$var$kf);
}
$885aad1b39333bac$var$ff($885aad1b39333bac$var$$e, "onAnimationEnd");
$885aad1b39333bac$var$ff($885aad1b39333bac$var$af, "onAnimationIteration");
$885aad1b39333bac$var$ff($885aad1b39333bac$var$bf, "onAnimationStart");
$885aad1b39333bac$var$ff("dblclick", "onDoubleClick");
$885aad1b39333bac$var$ff("focusin", "onFocus");
$885aad1b39333bac$var$ff("focusout", "onBlur");
$885aad1b39333bac$var$ff($885aad1b39333bac$var$cf, "onTransitionEnd");
$885aad1b39333bac$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$885aad1b39333bac$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$885aad1b39333bac$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$885aad1b39333bac$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$885aad1b39333bac$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$885aad1b39333bac$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$885aad1b39333bac$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$885aad1b39333bac$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$885aad1b39333bac$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$885aad1b39333bac$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $885aad1b39333bac$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $885aad1b39333bac$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($885aad1b39333bac$var$lf));
function $885aad1b39333bac$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $885aad1b39333bac$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $885aad1b39333bac$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $885aad1b39333bac$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $885aad1b39333bac$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($885aad1b39333bac$var$Qb) throw a = $885aad1b39333bac$var$Rb, $885aad1b39333bac$var$Qb = !1, $885aad1b39333bac$var$Rb = null, a;
}
function $885aad1b39333bac$var$D(a, b) {
    var c = b[$885aad1b39333bac$var$of];
    void 0 === c && (c = b[$885aad1b39333bac$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($885aad1b39333bac$var$pf(b, a, 2, !1), c.add(d));
}
function $885aad1b39333bac$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $885aad1b39333bac$var$pf(c, a, d, b);
}
var $885aad1b39333bac$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $885aad1b39333bac$var$sf(a) {
    if (!a[$885aad1b39333bac$var$rf]) {
        a[$885aad1b39333bac$var$rf] = !0;
        $885aad1b39333bac$var$da.forEach(function(b) {
            "selectionchange" !== b && ($885aad1b39333bac$var$mf.has(b) || $885aad1b39333bac$var$qf(b, !1, a), $885aad1b39333bac$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$885aad1b39333bac$var$rf] || (b[$885aad1b39333bac$var$rf] = !0, $885aad1b39333bac$var$qf("selectionchange", !1, b));
    }
}
function $885aad1b39333bac$var$pf(a, b, c, d) {
    switch($885aad1b39333bac$var$jd(b)){
        case 1:
            var e = $885aad1b39333bac$var$ed;
            break;
        case 4:
            e = $885aad1b39333bac$var$gd;
            break;
        default:
            e = $885aad1b39333bac$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$885aad1b39333bac$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $885aad1b39333bac$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $885aad1b39333bac$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $885aad1b39333bac$var$Jb(function() {
        var d = f, e = $885aad1b39333bac$var$xb(c), g = [];
        a: {
            var h = $885aad1b39333bac$var$df.get(a);
            if (void 0 !== h) {
                var k = $885aad1b39333bac$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $885aad1b39333bac$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $885aad1b39333bac$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $885aad1b39333bac$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $885aad1b39333bac$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $885aad1b39333bac$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $885aad1b39333bac$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $885aad1b39333bac$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $885aad1b39333bac$var$Vd;
                        break;
                    case $885aad1b39333bac$var$$e:
                    case $885aad1b39333bac$var$af:
                    case $885aad1b39333bac$var$bf:
                        k = $885aad1b39333bac$var$Hd;
                        break;
                    case $885aad1b39333bac$var$cf:
                        k = $885aad1b39333bac$var$Xd;
                        break;
                    case "scroll":
                        k = $885aad1b39333bac$var$vd;
                        break;
                    case "wheel":
                        k = $885aad1b39333bac$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $885aad1b39333bac$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $885aad1b39333bac$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $885aad1b39333bac$var$Kb(w, x), null != F && t.push($885aad1b39333bac$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $885aad1b39333bac$var$wb && (n = c.relatedTarget || c.fromElement) && ($885aad1b39333bac$var$Wc(n) || n[$885aad1b39333bac$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $885aad1b39333bac$var$Wc(n) : null, null !== n && (J = $885aad1b39333bac$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $885aad1b39333bac$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $885aad1b39333bac$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $885aad1b39333bac$var$ue(k);
                        u = null == n ? h : $885aad1b39333bac$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $885aad1b39333bac$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $885aad1b39333bac$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $885aad1b39333bac$var$vf(F))u++;
                            for(; 0 < w - u;)t = $885aad1b39333bac$var$vf(t), w--;
                            for(; 0 < u - w;)x = $885aad1b39333bac$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $885aad1b39333bac$var$vf(t);
                                x = $885aad1b39333bac$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $885aad1b39333bac$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $885aad1b39333bac$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $885aad1b39333bac$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $885aad1b39333bac$var$ve;
                else if ($885aad1b39333bac$var$me(h)) {
                    if ($885aad1b39333bac$var$we) na = $885aad1b39333bac$var$Fe;
                    else {
                        na = $885aad1b39333bac$var$De;
                        var xa = $885aad1b39333bac$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $885aad1b39333bac$var$Ee);
                if (na && (na = na(a, d))) {
                    $885aad1b39333bac$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $885aad1b39333bac$var$cb(h, "number", h.value);
            }
            xa = d ? $885aad1b39333bac$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($885aad1b39333bac$var$me(xa) || "true" === xa.contentEditable) $885aad1b39333bac$var$Qe = xa, $885aad1b39333bac$var$Re = d, $885aad1b39333bac$var$Se = null;
                    break;
                case "focusout":
                    $885aad1b39333bac$var$Se = $885aad1b39333bac$var$Re = $885aad1b39333bac$var$Qe = null;
                    break;
                case "mousedown":
                    $885aad1b39333bac$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $885aad1b39333bac$var$Te = !1;
                    $885aad1b39333bac$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($885aad1b39333bac$var$Pe) break;
                case "keydown":
                case "keyup":
                    $885aad1b39333bac$var$Ue(g, c, e);
            }
            var $a;
            if ($885aad1b39333bac$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $885aad1b39333bac$var$ie ? $885aad1b39333bac$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($885aad1b39333bac$var$de && "ko" !== c.locale && ($885aad1b39333bac$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $885aad1b39333bac$var$ie && ($a = $885aad1b39333bac$var$nd()) : ($885aad1b39333bac$var$kd = e, $885aad1b39333bac$var$ld = "value" in $885aad1b39333bac$var$kd ? $885aad1b39333bac$var$kd.value : $885aad1b39333bac$var$kd.textContent, $885aad1b39333bac$var$ie = !0)), xa = $885aad1b39333bac$var$oe(d, ba), 0 < xa.length && (ba = new $885aad1b39333bac$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $885aad1b39333bac$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $885aad1b39333bac$var$ce ? $885aad1b39333bac$var$je(a, c) : $885aad1b39333bac$var$ke(a, c)) d = $885aad1b39333bac$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $885aad1b39333bac$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $885aad1b39333bac$var$se(g, b);
    });
}
function $885aad1b39333bac$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $885aad1b39333bac$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $885aad1b39333bac$var$Kb(a, c), null != f && d.unshift($885aad1b39333bac$var$tf(a, f, e)), f = $885aad1b39333bac$var$Kb(a, b), null != f && d.push($885aad1b39333bac$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $885aad1b39333bac$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $885aad1b39333bac$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $885aad1b39333bac$var$Kb(c, f), null != k && g.unshift($885aad1b39333bac$var$tf(c, k, h))) : e || (k = $885aad1b39333bac$var$Kb(c, f), null != k && g.push($885aad1b39333bac$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $885aad1b39333bac$var$xf = /\r\n?/g, $885aad1b39333bac$var$yf = /\u0000|\uFFFD/g;
function $885aad1b39333bac$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($885aad1b39333bac$var$xf, "\n").replace($885aad1b39333bac$var$yf, "");
}
function $885aad1b39333bac$var$Af(a, b, c) {
    b = $885aad1b39333bac$var$zf(b);
    if ($885aad1b39333bac$var$zf(a) !== b && c) throw Error($885aad1b39333bac$var$p(425));
}
function $885aad1b39333bac$var$Bf() {}
var $885aad1b39333bac$var$Cf = null, $885aad1b39333bac$var$Df = null;
function $885aad1b39333bac$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $885aad1b39333bac$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $885aad1b39333bac$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $885aad1b39333bac$var$Hf = "function" === typeof Promise ? Promise : void 0, $885aad1b39333bac$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $885aad1b39333bac$var$Hf ? function(a) {
    return $885aad1b39333bac$var$Hf.resolve(null).then(a).catch($885aad1b39333bac$var$If);
} : $885aad1b39333bac$var$Ff;
function $885aad1b39333bac$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $885aad1b39333bac$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $885aad1b39333bac$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $885aad1b39333bac$var$bd(b);
}
function $885aad1b39333bac$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $885aad1b39333bac$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $885aad1b39333bac$var$Nf = Math.random().toString(36).slice(2), $885aad1b39333bac$var$Of = "__reactFiber$" + $885aad1b39333bac$var$Nf, $885aad1b39333bac$var$Pf = "__reactProps$" + $885aad1b39333bac$var$Nf, $885aad1b39333bac$var$uf = "__reactContainer$" + $885aad1b39333bac$var$Nf, $885aad1b39333bac$var$of = "__reactEvents$" + $885aad1b39333bac$var$Nf, $885aad1b39333bac$var$Qf = "__reactListeners$" + $885aad1b39333bac$var$Nf, $885aad1b39333bac$var$Rf = "__reactHandles$" + $885aad1b39333bac$var$Nf;
function $885aad1b39333bac$var$Wc(a) {
    var b = a[$885aad1b39333bac$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$885aad1b39333bac$var$uf] || c[$885aad1b39333bac$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $885aad1b39333bac$var$Mf(a); null !== a;){
                if (c = a[$885aad1b39333bac$var$Of]) return c;
                a = $885aad1b39333bac$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $885aad1b39333bac$var$Cb(a) {
    a = a[$885aad1b39333bac$var$Of] || a[$885aad1b39333bac$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $885aad1b39333bac$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($885aad1b39333bac$var$p(33));
}
function $885aad1b39333bac$var$Db(a) {
    return a[$885aad1b39333bac$var$Pf] || null;
}
var $885aad1b39333bac$var$Sf = [], $885aad1b39333bac$var$Tf = -1;
function $885aad1b39333bac$var$Uf(a) {
    return {
        current: a
    };
}
function $885aad1b39333bac$var$E(a) {
    0 > $885aad1b39333bac$var$Tf || (a.current = $885aad1b39333bac$var$Sf[$885aad1b39333bac$var$Tf], $885aad1b39333bac$var$Sf[$885aad1b39333bac$var$Tf] = null, $885aad1b39333bac$var$Tf--);
}
function $885aad1b39333bac$var$G(a, b) {
    $885aad1b39333bac$var$Tf++;
    $885aad1b39333bac$var$Sf[$885aad1b39333bac$var$Tf] = a.current;
    a.current = b;
}
var $885aad1b39333bac$var$Vf = {}, $885aad1b39333bac$var$H = $885aad1b39333bac$var$Uf($885aad1b39333bac$var$Vf), $885aad1b39333bac$var$Wf = $885aad1b39333bac$var$Uf(!1), $885aad1b39333bac$var$Xf = $885aad1b39333bac$var$Vf;
function $885aad1b39333bac$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $885aad1b39333bac$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $885aad1b39333bac$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $885aad1b39333bac$var$$f() {
    $885aad1b39333bac$var$E($885aad1b39333bac$var$Wf);
    $885aad1b39333bac$var$E($885aad1b39333bac$var$H);
}
function $885aad1b39333bac$var$ag(a, b, c) {
    if ($885aad1b39333bac$var$H.current !== $885aad1b39333bac$var$Vf) throw Error($885aad1b39333bac$var$p(168));
    $885aad1b39333bac$var$G($885aad1b39333bac$var$H, b);
    $885aad1b39333bac$var$G($885aad1b39333bac$var$Wf, c);
}
function $885aad1b39333bac$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($885aad1b39333bac$var$p(108, $885aad1b39333bac$var$Ra(a) || "Unknown", e));
    return $885aad1b39333bac$var$A({}, c, d);
}
function $885aad1b39333bac$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $885aad1b39333bac$var$Vf;
    $885aad1b39333bac$var$Xf = $885aad1b39333bac$var$H.current;
    $885aad1b39333bac$var$G($885aad1b39333bac$var$H, a);
    $885aad1b39333bac$var$G($885aad1b39333bac$var$Wf, $885aad1b39333bac$var$Wf.current);
    return !0;
}
function $885aad1b39333bac$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($885aad1b39333bac$var$p(169));
    c ? (a = $885aad1b39333bac$var$bg(a, b, $885aad1b39333bac$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $885aad1b39333bac$var$E($885aad1b39333bac$var$Wf), $885aad1b39333bac$var$E($885aad1b39333bac$var$H), $885aad1b39333bac$var$G($885aad1b39333bac$var$H, a)) : $885aad1b39333bac$var$E($885aad1b39333bac$var$Wf);
    $885aad1b39333bac$var$G($885aad1b39333bac$var$Wf, c);
}
var $885aad1b39333bac$var$eg = null, $885aad1b39333bac$var$fg = !1, $885aad1b39333bac$var$gg = !1;
function $885aad1b39333bac$var$hg(a) {
    null === $885aad1b39333bac$var$eg ? $885aad1b39333bac$var$eg = [
        a
    ] : $885aad1b39333bac$var$eg.push(a);
}
function $885aad1b39333bac$var$ig(a) {
    $885aad1b39333bac$var$fg = !0;
    $885aad1b39333bac$var$hg(a);
}
function $885aad1b39333bac$var$jg() {
    if (!$885aad1b39333bac$var$gg && null !== $885aad1b39333bac$var$eg) {
        $885aad1b39333bac$var$gg = !0;
        var a = 0, b = $885aad1b39333bac$var$C;
        try {
            var c = $885aad1b39333bac$var$eg;
            for($885aad1b39333bac$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $885aad1b39333bac$var$eg = null;
            $885aad1b39333bac$var$fg = !1;
        } catch (e) {
            throw null !== $885aad1b39333bac$var$eg && ($885aad1b39333bac$var$eg = $885aad1b39333bac$var$eg.slice(a + 1)), $885aad1b39333bac$var$ac($885aad1b39333bac$var$fc, $885aad1b39333bac$var$jg), e;
        } finally{
            $885aad1b39333bac$var$C = b, $885aad1b39333bac$var$gg = !1;
        }
    }
    return null;
}
var $885aad1b39333bac$var$kg = [], $885aad1b39333bac$var$lg = 0, $885aad1b39333bac$var$mg = null, $885aad1b39333bac$var$ng = 0, $885aad1b39333bac$var$og = [], $885aad1b39333bac$var$pg = 0, $885aad1b39333bac$var$qg = null, $885aad1b39333bac$var$rg = 1, $885aad1b39333bac$var$sg = "";
function $885aad1b39333bac$var$tg(a, b) {
    $885aad1b39333bac$var$kg[$885aad1b39333bac$var$lg++] = $885aad1b39333bac$var$ng;
    $885aad1b39333bac$var$kg[$885aad1b39333bac$var$lg++] = $885aad1b39333bac$var$mg;
    $885aad1b39333bac$var$mg = a;
    $885aad1b39333bac$var$ng = b;
}
function $885aad1b39333bac$var$ug(a, b, c) {
    $885aad1b39333bac$var$og[$885aad1b39333bac$var$pg++] = $885aad1b39333bac$var$rg;
    $885aad1b39333bac$var$og[$885aad1b39333bac$var$pg++] = $885aad1b39333bac$var$sg;
    $885aad1b39333bac$var$og[$885aad1b39333bac$var$pg++] = $885aad1b39333bac$var$qg;
    $885aad1b39333bac$var$qg = a;
    var d = $885aad1b39333bac$var$rg;
    a = $885aad1b39333bac$var$sg;
    var e = 32 - $885aad1b39333bac$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $885aad1b39333bac$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $885aad1b39333bac$var$rg = 1 << 32 - $885aad1b39333bac$var$oc(b) + e | c << e | d;
        $885aad1b39333bac$var$sg = f + a;
    } else $885aad1b39333bac$var$rg = 1 << f | c << e | d, $885aad1b39333bac$var$sg = a;
}
function $885aad1b39333bac$var$vg(a) {
    null !== a.return && ($885aad1b39333bac$var$tg(a, 1), $885aad1b39333bac$var$ug(a, 1, 0));
}
function $885aad1b39333bac$var$wg(a) {
    for(; a === $885aad1b39333bac$var$mg;)$885aad1b39333bac$var$mg = $885aad1b39333bac$var$kg[--$885aad1b39333bac$var$lg], $885aad1b39333bac$var$kg[$885aad1b39333bac$var$lg] = null, $885aad1b39333bac$var$ng = $885aad1b39333bac$var$kg[--$885aad1b39333bac$var$lg], $885aad1b39333bac$var$kg[$885aad1b39333bac$var$lg] = null;
    for(; a === $885aad1b39333bac$var$qg;)$885aad1b39333bac$var$qg = $885aad1b39333bac$var$og[--$885aad1b39333bac$var$pg], $885aad1b39333bac$var$og[$885aad1b39333bac$var$pg] = null, $885aad1b39333bac$var$sg = $885aad1b39333bac$var$og[--$885aad1b39333bac$var$pg], $885aad1b39333bac$var$og[$885aad1b39333bac$var$pg] = null, $885aad1b39333bac$var$rg = $885aad1b39333bac$var$og[--$885aad1b39333bac$var$pg], $885aad1b39333bac$var$og[$885aad1b39333bac$var$pg] = null;
}
var $885aad1b39333bac$var$xg = null, $885aad1b39333bac$var$yg = null, $885aad1b39333bac$var$I = !1, $885aad1b39333bac$var$zg = null;
function $885aad1b39333bac$var$Ag(a, b) {
    var c = $885aad1b39333bac$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $885aad1b39333bac$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $885aad1b39333bac$var$xg = a, $885aad1b39333bac$var$yg = $885aad1b39333bac$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $885aad1b39333bac$var$xg = a, $885aad1b39333bac$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $885aad1b39333bac$var$qg ? {
                id: $885aad1b39333bac$var$rg,
                overflow: $885aad1b39333bac$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $885aad1b39333bac$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $885aad1b39333bac$var$xg = a, $885aad1b39333bac$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $885aad1b39333bac$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $885aad1b39333bac$var$Eg(a) {
    if ($885aad1b39333bac$var$I) {
        var b = $885aad1b39333bac$var$yg;
        if (b) {
            var c = b;
            if (!$885aad1b39333bac$var$Cg(a, b)) {
                if ($885aad1b39333bac$var$Dg(a)) throw Error($885aad1b39333bac$var$p(418));
                b = $885aad1b39333bac$var$Lf(c.nextSibling);
                var d = $885aad1b39333bac$var$xg;
                b && $885aad1b39333bac$var$Cg(a, b) ? $885aad1b39333bac$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $885aad1b39333bac$var$I = !1, $885aad1b39333bac$var$xg = a);
            }
        } else {
            if ($885aad1b39333bac$var$Dg(a)) throw Error($885aad1b39333bac$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $885aad1b39333bac$var$I = !1;
            $885aad1b39333bac$var$xg = a;
        }
    }
}
function $885aad1b39333bac$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $885aad1b39333bac$var$xg = a;
}
function $885aad1b39333bac$var$Gg(a) {
    if (a !== $885aad1b39333bac$var$xg) return !1;
    if (!$885aad1b39333bac$var$I) return $885aad1b39333bac$var$Fg(a), $885aad1b39333bac$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$885aad1b39333bac$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $885aad1b39333bac$var$yg)) {
        if ($885aad1b39333bac$var$Dg(a)) throw $885aad1b39333bac$var$Hg(), Error($885aad1b39333bac$var$p(418));
        for(; b;)$885aad1b39333bac$var$Ag(a, b), b = $885aad1b39333bac$var$Lf(b.nextSibling);
    }
    $885aad1b39333bac$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($885aad1b39333bac$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $885aad1b39333bac$var$yg = $885aad1b39333bac$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $885aad1b39333bac$var$yg = null;
        }
    } else $885aad1b39333bac$var$yg = $885aad1b39333bac$var$xg ? $885aad1b39333bac$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $885aad1b39333bac$var$Hg() {
    for(var a = $885aad1b39333bac$var$yg; a;)a = $885aad1b39333bac$var$Lf(a.nextSibling);
}
function $885aad1b39333bac$var$Ig() {
    $885aad1b39333bac$var$yg = $885aad1b39333bac$var$xg = null;
    $885aad1b39333bac$var$I = !1;
}
function $885aad1b39333bac$var$Jg(a) {
    null === $885aad1b39333bac$var$zg ? $885aad1b39333bac$var$zg = [
        a
    ] : $885aad1b39333bac$var$zg.push(a);
}
var $885aad1b39333bac$var$Kg = $885aad1b39333bac$var$ua.ReactCurrentBatchConfig;
function $885aad1b39333bac$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $885aad1b39333bac$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $885aad1b39333bac$var$Mg = $885aad1b39333bac$var$Uf(null), $885aad1b39333bac$var$Ng = null, $885aad1b39333bac$var$Og = null, $885aad1b39333bac$var$Pg = null;
function $885aad1b39333bac$var$Qg() {
    $885aad1b39333bac$var$Pg = $885aad1b39333bac$var$Og = $885aad1b39333bac$var$Ng = null;
}
function $885aad1b39333bac$var$Rg(a) {
    var b = $885aad1b39333bac$var$Mg.current;
    $885aad1b39333bac$var$E($885aad1b39333bac$var$Mg);
    a._currentValue = b;
}
function $885aad1b39333bac$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $885aad1b39333bac$var$Tg(a, b) {
    $885aad1b39333bac$var$Ng = a;
    $885aad1b39333bac$var$Pg = $885aad1b39333bac$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($885aad1b39333bac$var$Ug = !0), a.firstContext = null);
}
function $885aad1b39333bac$var$Vg(a) {
    var b = a._currentValue;
    if ($885aad1b39333bac$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $885aad1b39333bac$var$Og) {
            if (null === $885aad1b39333bac$var$Ng) throw Error($885aad1b39333bac$var$p(308));
            $885aad1b39333bac$var$Og = a;
            $885aad1b39333bac$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $885aad1b39333bac$var$Og = $885aad1b39333bac$var$Og.next = a;
    }
    return b;
}
var $885aad1b39333bac$var$Wg = null;
function $885aad1b39333bac$var$Xg(a) {
    null === $885aad1b39333bac$var$Wg ? $885aad1b39333bac$var$Wg = [
        a
    ] : $885aad1b39333bac$var$Wg.push(a);
}
function $885aad1b39333bac$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $885aad1b39333bac$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $885aad1b39333bac$var$Zg(a, d);
}
function $885aad1b39333bac$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $885aad1b39333bac$var$$g = !1;
function $885aad1b39333bac$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $885aad1b39333bac$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $885aad1b39333bac$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $885aad1b39333bac$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($885aad1b39333bac$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $885aad1b39333bac$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $885aad1b39333bac$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $885aad1b39333bac$var$Zg(a, c);
}
function $885aad1b39333bac$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $885aad1b39333bac$var$Cc(a, c);
    }
}
function $885aad1b39333bac$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $885aad1b39333bac$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $885aad1b39333bac$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $885aad1b39333bac$var$A({}, q, r);
                            break a;
                        case 2:
                            $885aad1b39333bac$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $885aad1b39333bac$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $885aad1b39333bac$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($885aad1b39333bac$var$p(191, e));
            e.call(d);
        }
    }
}
var $885aad1b39333bac$var$jh = (new $28UcW.Component).refs;
function $885aad1b39333bac$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $885aad1b39333bac$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $885aad1b39333bac$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $885aad1b39333bac$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $885aad1b39333bac$var$L(), e = $885aad1b39333bac$var$lh(a), f = $885aad1b39333bac$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $885aad1b39333bac$var$dh(a, f, e);
        null !== b && ($885aad1b39333bac$var$mh(b, a, e, d), $885aad1b39333bac$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $885aad1b39333bac$var$L(), e = $885aad1b39333bac$var$lh(a), f = $885aad1b39333bac$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $885aad1b39333bac$var$dh(a, f, e);
        null !== b && ($885aad1b39333bac$var$mh(b, a, e, d), $885aad1b39333bac$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $885aad1b39333bac$var$L(), d = $885aad1b39333bac$var$lh(a), e = $885aad1b39333bac$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $885aad1b39333bac$var$dh(a, e, d);
        null !== b && ($885aad1b39333bac$var$mh(b, a, d, c), $885aad1b39333bac$var$eh(b, a, d));
    }
};
function $885aad1b39333bac$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$885aad1b39333bac$var$Ie(c, d) || !$885aad1b39333bac$var$Ie(e, f) : !0;
}
function $885aad1b39333bac$var$ph(a, b, c) {
    var d = !1, e = $885aad1b39333bac$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $885aad1b39333bac$var$Vg(f) : (e = $885aad1b39333bac$var$Zf(b) ? $885aad1b39333bac$var$Xf : $885aad1b39333bac$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $885aad1b39333bac$var$Yf(a, e) : $885aad1b39333bac$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $885aad1b39333bac$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $885aad1b39333bac$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $885aad1b39333bac$var$nh.enqueueReplaceState(b, b.state, null);
}
function $885aad1b39333bac$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $885aad1b39333bac$var$jh;
    $885aad1b39333bac$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $885aad1b39333bac$var$Vg(f) : (f = $885aad1b39333bac$var$Zf(b) ? $885aad1b39333bac$var$Xf : $885aad1b39333bac$var$H.current, e.context = $885aad1b39333bac$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($885aad1b39333bac$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $885aad1b39333bac$var$nh.enqueueReplaceState(e, e.state, null), $885aad1b39333bac$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $885aad1b39333bac$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($885aad1b39333bac$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($885aad1b39333bac$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $885aad1b39333bac$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($885aad1b39333bac$var$p(284));
        if (!c._owner) throw Error($885aad1b39333bac$var$p(290, a));
    }
    return a;
}
function $885aad1b39333bac$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($885aad1b39333bac$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $885aad1b39333bac$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $885aad1b39333bac$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $885aad1b39333bac$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $885aad1b39333bac$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $885aad1b39333bac$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $885aad1b39333bac$var$Ha && $885aad1b39333bac$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $885aad1b39333bac$var$sh(a, b, c), d.return = a, d;
        d = $885aad1b39333bac$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $885aad1b39333bac$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $885aad1b39333bac$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $885aad1b39333bac$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $885aad1b39333bac$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $885aad1b39333bac$var$va:
                    return c = $885aad1b39333bac$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $885aad1b39333bac$var$sh(a, null, b), c.return = a, c;
                case $885aad1b39333bac$var$wa:
                    return b = $885aad1b39333bac$var$zh(b, a.mode, c), b.return = a, b;
                case $885aad1b39333bac$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($885aad1b39333bac$var$eb(b) || $885aad1b39333bac$var$Ka(b)) return b = $885aad1b39333bac$var$Ah(b, a.mode, c, null), b.return = a, b;
            $885aad1b39333bac$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $885aad1b39333bac$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $885aad1b39333bac$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $885aad1b39333bac$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($885aad1b39333bac$var$eb(c) || $885aad1b39333bac$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $885aad1b39333bac$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $885aad1b39333bac$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $885aad1b39333bac$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $885aad1b39333bac$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($885aad1b39333bac$var$eb(d) || $885aad1b39333bac$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $885aad1b39333bac$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $885aad1b39333bac$var$I && $885aad1b39333bac$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $885aad1b39333bac$var$I && $885aad1b39333bac$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $885aad1b39333bac$var$I && $885aad1b39333bac$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $885aad1b39333bac$var$Ka(h);
        if ("function" !== typeof l) throw Error($885aad1b39333bac$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($885aad1b39333bac$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $885aad1b39333bac$var$I && $885aad1b39333bac$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $885aad1b39333bac$var$I && $885aad1b39333bac$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $885aad1b39333bac$var$I && $885aad1b39333bac$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $885aad1b39333bac$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $885aad1b39333bac$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $885aad1b39333bac$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $885aad1b39333bac$var$Ha && $885aad1b39333bac$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $885aad1b39333bac$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $885aad1b39333bac$var$ya ? (d = $885aad1b39333bac$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $885aad1b39333bac$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $885aad1b39333bac$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $885aad1b39333bac$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $885aad1b39333bac$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $885aad1b39333bac$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($885aad1b39333bac$var$eb(f)) return n(a, d, f, h);
            if ($885aad1b39333bac$var$Ka(f)) return t(a, d, f, h);
            $885aad1b39333bac$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $885aad1b39333bac$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $885aad1b39333bac$var$Bh = $885aad1b39333bac$var$vh(!0), $885aad1b39333bac$var$Ch = $885aad1b39333bac$var$vh(!1), $885aad1b39333bac$var$Dh = {}, $885aad1b39333bac$var$Eh = $885aad1b39333bac$var$Uf($885aad1b39333bac$var$Dh), $885aad1b39333bac$var$Fh = $885aad1b39333bac$var$Uf($885aad1b39333bac$var$Dh), $885aad1b39333bac$var$Gh = $885aad1b39333bac$var$Uf($885aad1b39333bac$var$Dh);
function $885aad1b39333bac$var$Hh(a) {
    if (a === $885aad1b39333bac$var$Dh) throw Error($885aad1b39333bac$var$p(174));
    return a;
}
function $885aad1b39333bac$var$Ih(a, b) {
    $885aad1b39333bac$var$G($885aad1b39333bac$var$Gh, b);
    $885aad1b39333bac$var$G($885aad1b39333bac$var$Fh, a);
    $885aad1b39333bac$var$G($885aad1b39333bac$var$Eh, $885aad1b39333bac$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $885aad1b39333bac$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $885aad1b39333bac$var$lb(b, a);
    }
    $885aad1b39333bac$var$E($885aad1b39333bac$var$Eh);
    $885aad1b39333bac$var$G($885aad1b39333bac$var$Eh, b);
}
function $885aad1b39333bac$var$Jh() {
    $885aad1b39333bac$var$E($885aad1b39333bac$var$Eh);
    $885aad1b39333bac$var$E($885aad1b39333bac$var$Fh);
    $885aad1b39333bac$var$E($885aad1b39333bac$var$Gh);
}
function $885aad1b39333bac$var$Kh(a) {
    $885aad1b39333bac$var$Hh($885aad1b39333bac$var$Gh.current);
    var b = $885aad1b39333bac$var$Hh($885aad1b39333bac$var$Eh.current);
    var c = $885aad1b39333bac$var$lb(b, a.type);
    b !== c && ($885aad1b39333bac$var$G($885aad1b39333bac$var$Fh, a), $885aad1b39333bac$var$G($885aad1b39333bac$var$Eh, c));
}
function $885aad1b39333bac$var$Lh(a) {
    $885aad1b39333bac$var$Fh.current === a && ($885aad1b39333bac$var$E($885aad1b39333bac$var$Eh), $885aad1b39333bac$var$E($885aad1b39333bac$var$Fh));
}
var $885aad1b39333bac$var$M = $885aad1b39333bac$var$Uf(0);
function $885aad1b39333bac$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $885aad1b39333bac$var$Nh = [];
function $885aad1b39333bac$var$Oh() {
    for(var a = 0; a < $885aad1b39333bac$var$Nh.length; a++)$885aad1b39333bac$var$Nh[a]._workInProgressVersionPrimary = null;
    $885aad1b39333bac$var$Nh.length = 0;
}
var $885aad1b39333bac$var$Ph = $885aad1b39333bac$var$ua.ReactCurrentDispatcher, $885aad1b39333bac$var$Qh = $885aad1b39333bac$var$ua.ReactCurrentBatchConfig, $885aad1b39333bac$var$Rh = 0, $885aad1b39333bac$var$N = null, $885aad1b39333bac$var$O = null, $885aad1b39333bac$var$P = null, $885aad1b39333bac$var$Sh = !1, $885aad1b39333bac$var$Th = !1, $885aad1b39333bac$var$Uh = 0, $885aad1b39333bac$var$Vh = 0;
function $885aad1b39333bac$var$Q() {
    throw Error($885aad1b39333bac$var$p(321));
}
function $885aad1b39333bac$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$885aad1b39333bac$var$He(a[c], b[c])) return !1;
    return !0;
}
function $885aad1b39333bac$var$Xh(a, b, c, d, e, f) {
    $885aad1b39333bac$var$Rh = f;
    $885aad1b39333bac$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $885aad1b39333bac$var$Ph.current = null === a || null === a.memoizedState ? $885aad1b39333bac$var$Yh : $885aad1b39333bac$var$Zh;
    a = c(d, e);
    if ($885aad1b39333bac$var$Th) {
        f = 0;
        do {
            $885aad1b39333bac$var$Th = !1;
            $885aad1b39333bac$var$Uh = 0;
            if (25 <= f) throw Error($885aad1b39333bac$var$p(301));
            f += 1;
            $885aad1b39333bac$var$P = $885aad1b39333bac$var$O = null;
            b.updateQueue = null;
            $885aad1b39333bac$var$Ph.current = $885aad1b39333bac$var$$h;
            a = c(d, e);
        }while ($885aad1b39333bac$var$Th);
    }
    $885aad1b39333bac$var$Ph.current = $885aad1b39333bac$var$ai;
    b = null !== $885aad1b39333bac$var$O && null !== $885aad1b39333bac$var$O.next;
    $885aad1b39333bac$var$Rh = 0;
    $885aad1b39333bac$var$P = $885aad1b39333bac$var$O = $885aad1b39333bac$var$N = null;
    $885aad1b39333bac$var$Sh = !1;
    if (b) throw Error($885aad1b39333bac$var$p(300));
    return a;
}
function $885aad1b39333bac$var$bi() {
    var a = 0 !== $885aad1b39333bac$var$Uh;
    $885aad1b39333bac$var$Uh = 0;
    return a;
}
function $885aad1b39333bac$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $885aad1b39333bac$var$P ? $885aad1b39333bac$var$N.memoizedState = $885aad1b39333bac$var$P = a : $885aad1b39333bac$var$P = $885aad1b39333bac$var$P.next = a;
    return $885aad1b39333bac$var$P;
}
function $885aad1b39333bac$var$di() {
    if (null === $885aad1b39333bac$var$O) {
        var a = $885aad1b39333bac$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $885aad1b39333bac$var$O.next;
    var b = null === $885aad1b39333bac$var$P ? $885aad1b39333bac$var$N.memoizedState : $885aad1b39333bac$var$P.next;
    if (null !== b) $885aad1b39333bac$var$P = b, $885aad1b39333bac$var$O = a;
    else {
        if (null === a) throw Error($885aad1b39333bac$var$p(310));
        $885aad1b39333bac$var$O = a;
        a = {
            memoizedState: $885aad1b39333bac$var$O.memoizedState,
            baseState: $885aad1b39333bac$var$O.baseState,
            baseQueue: $885aad1b39333bac$var$O.baseQueue,
            queue: $885aad1b39333bac$var$O.queue,
            next: null
        };
        null === $885aad1b39333bac$var$P ? $885aad1b39333bac$var$N.memoizedState = $885aad1b39333bac$var$P = a : $885aad1b39333bac$var$P = $885aad1b39333bac$var$P.next = a;
    }
    return $885aad1b39333bac$var$P;
}
function $885aad1b39333bac$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $885aad1b39333bac$var$fi(a) {
    var b = $885aad1b39333bac$var$di(), c = b.queue;
    if (null === c) throw Error($885aad1b39333bac$var$p(311));
    c.lastRenderedReducer = a;
    var d = $885aad1b39333bac$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($885aad1b39333bac$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $885aad1b39333bac$var$N.lanes |= m;
                $885aad1b39333bac$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $885aad1b39333bac$var$He(d, b.memoizedState) || ($885aad1b39333bac$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $885aad1b39333bac$var$N.lanes |= f, $885aad1b39333bac$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $885aad1b39333bac$var$gi(a) {
    var b = $885aad1b39333bac$var$di(), c = b.queue;
    if (null === c) throw Error($885aad1b39333bac$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $885aad1b39333bac$var$He(f, b.memoizedState) || ($885aad1b39333bac$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $885aad1b39333bac$var$hi() {}
function $885aad1b39333bac$var$ii(a, b) {
    var c = $885aad1b39333bac$var$N, d = $885aad1b39333bac$var$di(), e = b(), f = !$885aad1b39333bac$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $885aad1b39333bac$var$Ug = !0);
    d = d.queue;
    $885aad1b39333bac$var$ji($885aad1b39333bac$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $885aad1b39333bac$var$P && $885aad1b39333bac$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $885aad1b39333bac$var$li(9, $885aad1b39333bac$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $885aad1b39333bac$var$R) throw Error($885aad1b39333bac$var$p(349));
        0 !== ($885aad1b39333bac$var$Rh & 30) || $885aad1b39333bac$var$ni(c, b, e);
    }
    return e;
}
function $885aad1b39333bac$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $885aad1b39333bac$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $885aad1b39333bac$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $885aad1b39333bac$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $885aad1b39333bac$var$oi(b) && $885aad1b39333bac$var$pi(a);
}
function $885aad1b39333bac$var$ki(a, b, c) {
    return c(function() {
        $885aad1b39333bac$var$oi(b) && $885aad1b39333bac$var$pi(a);
    });
}
function $885aad1b39333bac$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$885aad1b39333bac$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $885aad1b39333bac$var$pi(a) {
    var b = $885aad1b39333bac$var$Zg(a, 1);
    null !== b && $885aad1b39333bac$var$mh(b, a, 1, -1);
}
function $885aad1b39333bac$var$qi(a) {
    var b = $885aad1b39333bac$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $885aad1b39333bac$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $885aad1b39333bac$var$ri.bind(null, $885aad1b39333bac$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $885aad1b39333bac$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $885aad1b39333bac$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $885aad1b39333bac$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $885aad1b39333bac$var$si() {
    return $885aad1b39333bac$var$di().memoizedState;
}
function $885aad1b39333bac$var$ti(a, b, c, d) {
    var e = $885aad1b39333bac$var$ci();
    $885aad1b39333bac$var$N.flags |= a;
    e.memoizedState = $885aad1b39333bac$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $885aad1b39333bac$var$ui(a, b, c, d) {
    var e = $885aad1b39333bac$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $885aad1b39333bac$var$O) {
        var g = $885aad1b39333bac$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $885aad1b39333bac$var$Wh(d, g.deps)) {
            e.memoizedState = $885aad1b39333bac$var$li(b, c, f, d);
            return;
        }
    }
    $885aad1b39333bac$var$N.flags |= a;
    e.memoizedState = $885aad1b39333bac$var$li(1 | b, c, f, d);
}
function $885aad1b39333bac$var$vi(a, b) {
    return $885aad1b39333bac$var$ti(8390656, 8, a, b);
}
function $885aad1b39333bac$var$ji(a, b) {
    return $885aad1b39333bac$var$ui(2048, 8, a, b);
}
function $885aad1b39333bac$var$wi(a, b) {
    return $885aad1b39333bac$var$ui(4, 2, a, b);
}
function $885aad1b39333bac$var$xi(a, b) {
    return $885aad1b39333bac$var$ui(4, 4, a, b);
}
function $885aad1b39333bac$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $885aad1b39333bac$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $885aad1b39333bac$var$ui(4, 4, $885aad1b39333bac$var$yi.bind(null, b, a), c);
}
function $885aad1b39333bac$var$Ai() {}
function $885aad1b39333bac$var$Bi(a, b) {
    var c = $885aad1b39333bac$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $885aad1b39333bac$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $885aad1b39333bac$var$Ci(a, b) {
    var c = $885aad1b39333bac$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $885aad1b39333bac$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $885aad1b39333bac$var$Di(a, b, c) {
    if (0 === ($885aad1b39333bac$var$Rh & 21)) return a.baseState && (a.baseState = !1, $885aad1b39333bac$var$Ug = !0), a.memoizedState = c;
    $885aad1b39333bac$var$He(c, b) || (c = $885aad1b39333bac$var$yc(), $885aad1b39333bac$var$N.lanes |= c, $885aad1b39333bac$var$hh |= c, a.baseState = !0);
    return b;
}
function $885aad1b39333bac$var$Ei(a, b) {
    var c = $885aad1b39333bac$var$C;
    $885aad1b39333bac$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $885aad1b39333bac$var$Qh.transition;
    $885aad1b39333bac$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $885aad1b39333bac$var$C = c, $885aad1b39333bac$var$Qh.transition = d;
    }
}
function $885aad1b39333bac$var$Fi() {
    return $885aad1b39333bac$var$di().memoizedState;
}
function $885aad1b39333bac$var$Gi(a, b, c) {
    var d = $885aad1b39333bac$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($885aad1b39333bac$var$Hi(a)) $885aad1b39333bac$var$Ii(b, c);
    else if (c = $885aad1b39333bac$var$Yg(a, b, c, d), null !== c) {
        var e = $885aad1b39333bac$var$L();
        $885aad1b39333bac$var$mh(c, a, d, e);
        $885aad1b39333bac$var$Ji(c, b, d);
    }
}
function $885aad1b39333bac$var$ri(a, b, c) {
    var d = $885aad1b39333bac$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($885aad1b39333bac$var$Hi(a)) $885aad1b39333bac$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($885aad1b39333bac$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $885aad1b39333bac$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $885aad1b39333bac$var$Yg(a, b, e, d);
        null !== c && (e = $885aad1b39333bac$var$L(), $885aad1b39333bac$var$mh(c, a, d, e), $885aad1b39333bac$var$Ji(c, b, d));
    }
}
function $885aad1b39333bac$var$Hi(a) {
    var b = a.alternate;
    return a === $885aad1b39333bac$var$N || null !== b && b === $885aad1b39333bac$var$N;
}
function $885aad1b39333bac$var$Ii(a, b) {
    $885aad1b39333bac$var$Th = $885aad1b39333bac$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $885aad1b39333bac$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $885aad1b39333bac$var$Cc(a, c);
    }
}
var $885aad1b39333bac$var$ai = {
    readContext: $885aad1b39333bac$var$Vg,
    useCallback: $885aad1b39333bac$var$Q,
    useContext: $885aad1b39333bac$var$Q,
    useEffect: $885aad1b39333bac$var$Q,
    useImperativeHandle: $885aad1b39333bac$var$Q,
    useInsertionEffect: $885aad1b39333bac$var$Q,
    useLayoutEffect: $885aad1b39333bac$var$Q,
    useMemo: $885aad1b39333bac$var$Q,
    useReducer: $885aad1b39333bac$var$Q,
    useRef: $885aad1b39333bac$var$Q,
    useState: $885aad1b39333bac$var$Q,
    useDebugValue: $885aad1b39333bac$var$Q,
    useDeferredValue: $885aad1b39333bac$var$Q,
    useTransition: $885aad1b39333bac$var$Q,
    useMutableSource: $885aad1b39333bac$var$Q,
    useSyncExternalStore: $885aad1b39333bac$var$Q,
    useId: $885aad1b39333bac$var$Q,
    unstable_isNewReconciler: !1
}, $885aad1b39333bac$var$Yh = {
    readContext: $885aad1b39333bac$var$Vg,
    useCallback: function(a, b) {
        $885aad1b39333bac$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $885aad1b39333bac$var$Vg,
    useEffect: $885aad1b39333bac$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $885aad1b39333bac$var$ti(4194308, 4, $885aad1b39333bac$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $885aad1b39333bac$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $885aad1b39333bac$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $885aad1b39333bac$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $885aad1b39333bac$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $885aad1b39333bac$var$Gi.bind(null, $885aad1b39333bac$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $885aad1b39333bac$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $885aad1b39333bac$var$qi,
    useDebugValue: $885aad1b39333bac$var$Ai,
    useDeferredValue: function(a) {
        return $885aad1b39333bac$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $885aad1b39333bac$var$qi(!1), b = a[0];
        a = $885aad1b39333bac$var$Ei.bind(null, a[1]);
        $885aad1b39333bac$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $885aad1b39333bac$var$N, e = $885aad1b39333bac$var$ci();
        if ($885aad1b39333bac$var$I) {
            if (void 0 === c) throw Error($885aad1b39333bac$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $885aad1b39333bac$var$R) throw Error($885aad1b39333bac$var$p(349));
            0 !== ($885aad1b39333bac$var$Rh & 30) || $885aad1b39333bac$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $885aad1b39333bac$var$vi($885aad1b39333bac$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $885aad1b39333bac$var$li(9, $885aad1b39333bac$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $885aad1b39333bac$var$ci(), b = $885aad1b39333bac$var$R.identifierPrefix;
        if ($885aad1b39333bac$var$I) {
            var c = $885aad1b39333bac$var$sg;
            var d = $885aad1b39333bac$var$rg;
            c = (d & ~(1 << 32 - $885aad1b39333bac$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $885aad1b39333bac$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $885aad1b39333bac$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $885aad1b39333bac$var$Zh = {
    readContext: $885aad1b39333bac$var$Vg,
    useCallback: $885aad1b39333bac$var$Bi,
    useContext: $885aad1b39333bac$var$Vg,
    useEffect: $885aad1b39333bac$var$ji,
    useImperativeHandle: $885aad1b39333bac$var$zi,
    useInsertionEffect: $885aad1b39333bac$var$wi,
    useLayoutEffect: $885aad1b39333bac$var$xi,
    useMemo: $885aad1b39333bac$var$Ci,
    useReducer: $885aad1b39333bac$var$fi,
    useRef: $885aad1b39333bac$var$si,
    useState: function() {
        return $885aad1b39333bac$var$fi($885aad1b39333bac$var$ei);
    },
    useDebugValue: $885aad1b39333bac$var$Ai,
    useDeferredValue: function(a) {
        var b = $885aad1b39333bac$var$di();
        return $885aad1b39333bac$var$Di(b, $885aad1b39333bac$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $885aad1b39333bac$var$fi($885aad1b39333bac$var$ei)[0], b = $885aad1b39333bac$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $885aad1b39333bac$var$hi,
    useSyncExternalStore: $885aad1b39333bac$var$ii,
    useId: $885aad1b39333bac$var$Fi,
    unstable_isNewReconciler: !1
}, $885aad1b39333bac$var$$h = {
    readContext: $885aad1b39333bac$var$Vg,
    useCallback: $885aad1b39333bac$var$Bi,
    useContext: $885aad1b39333bac$var$Vg,
    useEffect: $885aad1b39333bac$var$ji,
    useImperativeHandle: $885aad1b39333bac$var$zi,
    useInsertionEffect: $885aad1b39333bac$var$wi,
    useLayoutEffect: $885aad1b39333bac$var$xi,
    useMemo: $885aad1b39333bac$var$Ci,
    useReducer: $885aad1b39333bac$var$gi,
    useRef: $885aad1b39333bac$var$si,
    useState: function() {
        return $885aad1b39333bac$var$gi($885aad1b39333bac$var$ei);
    },
    useDebugValue: $885aad1b39333bac$var$Ai,
    useDeferredValue: function(a) {
        var b = $885aad1b39333bac$var$di();
        return null === $885aad1b39333bac$var$O ? b.memoizedState = a : $885aad1b39333bac$var$Di(b, $885aad1b39333bac$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $885aad1b39333bac$var$gi($885aad1b39333bac$var$ei)[0], b = $885aad1b39333bac$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $885aad1b39333bac$var$hi,
    useSyncExternalStore: $885aad1b39333bac$var$ii,
    useId: $885aad1b39333bac$var$Fi,
    unstable_isNewReconciler: !1
};
function $885aad1b39333bac$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $885aad1b39333bac$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $885aad1b39333bac$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $885aad1b39333bac$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $885aad1b39333bac$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $885aad1b39333bac$var$Oi(a, b, c) {
    c = $885aad1b39333bac$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $885aad1b39333bac$var$Pi || ($885aad1b39333bac$var$Pi = !0, $885aad1b39333bac$var$Qi = d);
        $885aad1b39333bac$var$Mi(a, b);
    };
    return c;
}
function $885aad1b39333bac$var$Ri(a, b, c) {
    c = $885aad1b39333bac$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $885aad1b39333bac$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $885aad1b39333bac$var$Mi(a, b);
        "function" !== typeof d && (null === $885aad1b39333bac$var$Si ? $885aad1b39333bac$var$Si = new Set([
            this
        ]) : $885aad1b39333bac$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $885aad1b39333bac$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $885aad1b39333bac$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $885aad1b39333bac$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $885aad1b39333bac$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $885aad1b39333bac$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $885aad1b39333bac$var$ch(-1, 1), b.tag = 2, $885aad1b39333bac$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $885aad1b39333bac$var$Xi = $885aad1b39333bac$var$ua.ReactCurrentOwner, $885aad1b39333bac$var$Ug = !1;
function $885aad1b39333bac$var$Yi(a, b, c, d) {
    b.child = null === a ? $885aad1b39333bac$var$Ch(b, null, c, d) : $885aad1b39333bac$var$Bh(b, a.child, c, d);
}
function $885aad1b39333bac$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $885aad1b39333bac$var$Tg(b, e);
    d = $885aad1b39333bac$var$Xh(a, b, c, d, f, e);
    c = $885aad1b39333bac$var$bi();
    if (null !== a && !$885aad1b39333bac$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $885aad1b39333bac$var$$i(a, b, e);
    $885aad1b39333bac$var$I && c && $885aad1b39333bac$var$vg(b);
    b.flags |= 1;
    $885aad1b39333bac$var$Yi(a, b, d, e);
    return b.child;
}
function $885aad1b39333bac$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$885aad1b39333bac$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $885aad1b39333bac$var$cj(a, b, f, d, e);
        a = $885aad1b39333bac$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $885aad1b39333bac$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $885aad1b39333bac$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $885aad1b39333bac$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $885aad1b39333bac$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($885aad1b39333bac$var$Ie(f, d) && a.ref === b.ref) {
            if ($885aad1b39333bac$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($885aad1b39333bac$var$Ug = !0);
            else return b.lanes = a.lanes, $885aad1b39333bac$var$$i(a, b, e);
        }
    }
    return $885aad1b39333bac$var$dj(a, b, c, d, e);
}
function $885aad1b39333bac$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $885aad1b39333bac$var$G($885aad1b39333bac$var$fj, $885aad1b39333bac$var$gj), $885aad1b39333bac$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $885aad1b39333bac$var$G($885aad1b39333bac$var$fj, $885aad1b39333bac$var$gj), $885aad1b39333bac$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $885aad1b39333bac$var$G($885aad1b39333bac$var$fj, $885aad1b39333bac$var$gj);
            $885aad1b39333bac$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $885aad1b39333bac$var$G($885aad1b39333bac$var$fj, $885aad1b39333bac$var$gj), $885aad1b39333bac$var$gj |= d;
    $885aad1b39333bac$var$Yi(a, b, e, c);
    return b.child;
}
function $885aad1b39333bac$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $885aad1b39333bac$var$dj(a, b, c, d, e) {
    var f = $885aad1b39333bac$var$Zf(c) ? $885aad1b39333bac$var$Xf : $885aad1b39333bac$var$H.current;
    f = $885aad1b39333bac$var$Yf(b, f);
    $885aad1b39333bac$var$Tg(b, e);
    c = $885aad1b39333bac$var$Xh(a, b, c, d, f, e);
    d = $885aad1b39333bac$var$bi();
    if (null !== a && !$885aad1b39333bac$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $885aad1b39333bac$var$$i(a, b, e);
    $885aad1b39333bac$var$I && d && $885aad1b39333bac$var$vg(b);
    b.flags |= 1;
    $885aad1b39333bac$var$Yi(a, b, c, e);
    return b.child;
}
function $885aad1b39333bac$var$ij(a, b, c, d, e) {
    if ($885aad1b39333bac$var$Zf(c)) {
        var f = !0;
        $885aad1b39333bac$var$cg(b);
    } else f = !1;
    $885aad1b39333bac$var$Tg(b, e);
    if (null === b.stateNode) $885aad1b39333bac$var$jj(a, b), $885aad1b39333bac$var$ph(b, c, d), $885aad1b39333bac$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $885aad1b39333bac$var$Vg(l) : (l = $885aad1b39333bac$var$Zf(c) ? $885aad1b39333bac$var$Xf : $885aad1b39333bac$var$H.current, l = $885aad1b39333bac$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $885aad1b39333bac$var$qh(b, g, d, l);
        $885aad1b39333bac$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $885aad1b39333bac$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $885aad1b39333bac$var$Wf.current || $885aad1b39333bac$var$$g ? ("function" === typeof m && ($885aad1b39333bac$var$kh(b, c, m, d), k = b.memoizedState), (h = $885aad1b39333bac$var$$g || $885aad1b39333bac$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $885aad1b39333bac$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $885aad1b39333bac$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $885aad1b39333bac$var$Vg(k) : (k = $885aad1b39333bac$var$Zf(c) ? $885aad1b39333bac$var$Xf : $885aad1b39333bac$var$H.current, k = $885aad1b39333bac$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $885aad1b39333bac$var$qh(b, g, d, k);
        $885aad1b39333bac$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $885aad1b39333bac$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $885aad1b39333bac$var$Wf.current || $885aad1b39333bac$var$$g ? ("function" === typeof y && ($885aad1b39333bac$var$kh(b, c, y, d), n = b.memoizedState), (l = $885aad1b39333bac$var$$g || $885aad1b39333bac$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $885aad1b39333bac$var$kj(a, b, c, d, f, e);
}
function $885aad1b39333bac$var$kj(a, b, c, d, e, f) {
    $885aad1b39333bac$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $885aad1b39333bac$var$dg(b, c, !1), $885aad1b39333bac$var$$i(a, b, f);
    d = b.stateNode;
    $885aad1b39333bac$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $885aad1b39333bac$var$Bh(b, a.child, null, f), b.child = $885aad1b39333bac$var$Bh(b, null, h, f)) : $885aad1b39333bac$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $885aad1b39333bac$var$dg(b, c, !0);
    return b.child;
}
function $885aad1b39333bac$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $885aad1b39333bac$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $885aad1b39333bac$var$ag(a, b.context, !1);
    $885aad1b39333bac$var$Ih(a, b.containerInfo);
}
function $885aad1b39333bac$var$mj(a, b, c, d, e) {
    $885aad1b39333bac$var$Ig();
    $885aad1b39333bac$var$Jg(e);
    b.flags |= 256;
    $885aad1b39333bac$var$Yi(a, b, c, d);
    return b.child;
}
var $885aad1b39333bac$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $885aad1b39333bac$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $885aad1b39333bac$var$pj(a, b, c) {
    var d = b.pendingProps, e = $885aad1b39333bac$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $885aad1b39333bac$var$G($885aad1b39333bac$var$M, e & 1);
    if (null === a) {
        $885aad1b39333bac$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $885aad1b39333bac$var$qj(g, d, 0, null), a = $885aad1b39333bac$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $885aad1b39333bac$var$oj(c), b.memoizedState = $885aad1b39333bac$var$nj, a) : $885aad1b39333bac$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $885aad1b39333bac$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $885aad1b39333bac$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $885aad1b39333bac$var$wh(h, f) : (f = $885aad1b39333bac$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $885aad1b39333bac$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $885aad1b39333bac$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $885aad1b39333bac$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $885aad1b39333bac$var$rj(a, b) {
    b = $885aad1b39333bac$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $885aad1b39333bac$var$tj(a, b, c, d) {
    null !== d && $885aad1b39333bac$var$Jg(d);
    $885aad1b39333bac$var$Bh(b, a.child, null, c);
    a = $885aad1b39333bac$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $885aad1b39333bac$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $885aad1b39333bac$var$Li(Error($885aad1b39333bac$var$p(422))), $885aad1b39333bac$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $885aad1b39333bac$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $885aad1b39333bac$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $885aad1b39333bac$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $885aad1b39333bac$var$oj(g);
        b.memoizedState = $885aad1b39333bac$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $885aad1b39333bac$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($885aad1b39333bac$var$p(419));
        d = $885aad1b39333bac$var$Li(f, d, void 0);
        return $885aad1b39333bac$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($885aad1b39333bac$var$Ug || h) {
        d = $885aad1b39333bac$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $885aad1b39333bac$var$Zg(a, e), $885aad1b39333bac$var$mh(d, a, e, -1));
        }
        $885aad1b39333bac$var$uj();
        d = $885aad1b39333bac$var$Li(Error($885aad1b39333bac$var$p(421)));
        return $885aad1b39333bac$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $885aad1b39333bac$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $885aad1b39333bac$var$yg = $885aad1b39333bac$var$Lf(e.nextSibling);
    $885aad1b39333bac$var$xg = b;
    $885aad1b39333bac$var$I = !0;
    $885aad1b39333bac$var$zg = null;
    null !== a && ($885aad1b39333bac$var$og[$885aad1b39333bac$var$pg++] = $885aad1b39333bac$var$rg, $885aad1b39333bac$var$og[$885aad1b39333bac$var$pg++] = $885aad1b39333bac$var$sg, $885aad1b39333bac$var$og[$885aad1b39333bac$var$pg++] = $885aad1b39333bac$var$qg, $885aad1b39333bac$var$rg = a.id, $885aad1b39333bac$var$sg = a.overflow, $885aad1b39333bac$var$qg = b);
    b = $885aad1b39333bac$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $885aad1b39333bac$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $885aad1b39333bac$var$Sg(a.return, b, c);
}
function $885aad1b39333bac$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $885aad1b39333bac$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $885aad1b39333bac$var$Yi(a, b, d.children, c);
    d = $885aad1b39333bac$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $885aad1b39333bac$var$wj(a, c, b);
            else if (19 === a.tag) $885aad1b39333bac$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $885aad1b39333bac$var$G($885aad1b39333bac$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $885aad1b39333bac$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $885aad1b39333bac$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $885aad1b39333bac$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $885aad1b39333bac$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $885aad1b39333bac$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $885aad1b39333bac$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $885aad1b39333bac$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $885aad1b39333bac$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($885aad1b39333bac$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $885aad1b39333bac$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $885aad1b39333bac$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $885aad1b39333bac$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $885aad1b39333bac$var$lj(b);
            $885aad1b39333bac$var$Ig();
            break;
        case 5:
            $885aad1b39333bac$var$Kh(b);
            break;
        case 1:
            $885aad1b39333bac$var$Zf(b.type) && $885aad1b39333bac$var$cg(b);
            break;
        case 4:
            $885aad1b39333bac$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $885aad1b39333bac$var$G($885aad1b39333bac$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $885aad1b39333bac$var$G($885aad1b39333bac$var$M, $885aad1b39333bac$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $885aad1b39333bac$var$pj(a, b, c);
                $885aad1b39333bac$var$G($885aad1b39333bac$var$M, $885aad1b39333bac$var$M.current & 1);
                a = $885aad1b39333bac$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $885aad1b39333bac$var$G($885aad1b39333bac$var$M, $885aad1b39333bac$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $885aad1b39333bac$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $885aad1b39333bac$var$G($885aad1b39333bac$var$M, $885aad1b39333bac$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $885aad1b39333bac$var$ej(a, b, c);
    }
    return $885aad1b39333bac$var$$i(a, b, c);
}
var $885aad1b39333bac$var$Aj, $885aad1b39333bac$var$Bj, $885aad1b39333bac$var$Cj, $885aad1b39333bac$var$Dj;
$885aad1b39333bac$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$885aad1b39333bac$var$Bj = function() {};
$885aad1b39333bac$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $885aad1b39333bac$var$Hh($885aad1b39333bac$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $885aad1b39333bac$var$Ya(a, e);
                d = $885aad1b39333bac$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $885aad1b39333bac$var$A({}, e, {
                    value: void 0
                });
                d = $885aad1b39333bac$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $885aad1b39333bac$var$gb(a, e);
                d = $885aad1b39333bac$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $885aad1b39333bac$var$Bf);
        }
        $885aad1b39333bac$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($885aad1b39333bac$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($885aad1b39333bac$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $885aad1b39333bac$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$885aad1b39333bac$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $885aad1b39333bac$var$Ej(a, b) {
    if (!$885aad1b39333bac$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $885aad1b39333bac$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $885aad1b39333bac$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $885aad1b39333bac$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $885aad1b39333bac$var$S(b), null;
        case 1:
            return $885aad1b39333bac$var$Zf(b.type) && $885aad1b39333bac$var$$f(), $885aad1b39333bac$var$S(b), null;
        case 3:
            d = b.stateNode;
            $885aad1b39333bac$var$Jh();
            $885aad1b39333bac$var$E($885aad1b39333bac$var$Wf);
            $885aad1b39333bac$var$E($885aad1b39333bac$var$H);
            $885aad1b39333bac$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $885aad1b39333bac$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $885aad1b39333bac$var$zg && ($885aad1b39333bac$var$Gj($885aad1b39333bac$var$zg), $885aad1b39333bac$var$zg = null));
            $885aad1b39333bac$var$Bj(a, b);
            $885aad1b39333bac$var$S(b);
            return null;
        case 5:
            $885aad1b39333bac$var$Lh(b);
            var e = $885aad1b39333bac$var$Hh($885aad1b39333bac$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $885aad1b39333bac$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($885aad1b39333bac$var$p(166));
                    $885aad1b39333bac$var$S(b);
                    return null;
                }
                a = $885aad1b39333bac$var$Hh($885aad1b39333bac$var$Eh.current);
                if ($885aad1b39333bac$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$885aad1b39333bac$var$Of] = b;
                    d[$885aad1b39333bac$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $885aad1b39333bac$var$D("cancel", d);
                            $885aad1b39333bac$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $885aad1b39333bac$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $885aad1b39333bac$var$lf.length; e++)$885aad1b39333bac$var$D($885aad1b39333bac$var$lf[e], d);
                            break;
                        case "source":
                            $885aad1b39333bac$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $885aad1b39333bac$var$D("error", d);
                            $885aad1b39333bac$var$D("load", d);
                            break;
                        case "details":
                            $885aad1b39333bac$var$D("toggle", d);
                            break;
                        case "input":
                            $885aad1b39333bac$var$Za(d, f);
                            $885aad1b39333bac$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $885aad1b39333bac$var$D("invalid", d);
                            break;
                        case "textarea":
                            $885aad1b39333bac$var$hb(d, f), $885aad1b39333bac$var$D("invalid", d);
                    }
                    $885aad1b39333bac$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $885aad1b39333bac$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $885aad1b39333bac$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $885aad1b39333bac$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $885aad1b39333bac$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $885aad1b39333bac$var$Va(d);
                            $885aad1b39333bac$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $885aad1b39333bac$var$Va(d);
                            $885aad1b39333bac$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $885aad1b39333bac$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $885aad1b39333bac$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$885aad1b39333bac$var$Of] = b;
                    a[$885aad1b39333bac$var$Pf] = d;
                    $885aad1b39333bac$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $885aad1b39333bac$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $885aad1b39333bac$var$D("cancel", a);
                                $885aad1b39333bac$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $885aad1b39333bac$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $885aad1b39333bac$var$lf.length; e++)$885aad1b39333bac$var$D($885aad1b39333bac$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $885aad1b39333bac$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $885aad1b39333bac$var$D("error", a);
                                $885aad1b39333bac$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $885aad1b39333bac$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $885aad1b39333bac$var$Za(a, d);
                                e = $885aad1b39333bac$var$Ya(a, d);
                                $885aad1b39333bac$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $885aad1b39333bac$var$A({}, d, {
                                    value: void 0
                                });
                                $885aad1b39333bac$var$D("invalid", a);
                                break;
                            case "textarea":
                                $885aad1b39333bac$var$hb(a, d);
                                e = $885aad1b39333bac$var$gb(a, d);
                                $885aad1b39333bac$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $885aad1b39333bac$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $885aad1b39333bac$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $885aad1b39333bac$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $885aad1b39333bac$var$ob(a, k) : "number" === typeof k && $885aad1b39333bac$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($885aad1b39333bac$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $885aad1b39333bac$var$D("scroll", a) : null != k && $885aad1b39333bac$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $885aad1b39333bac$var$Va(a);
                                $885aad1b39333bac$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $885aad1b39333bac$var$Va(a);
                                $885aad1b39333bac$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $885aad1b39333bac$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $885aad1b39333bac$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $885aad1b39333bac$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $885aad1b39333bac$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $885aad1b39333bac$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $885aad1b39333bac$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($885aad1b39333bac$var$p(166));
                c = $885aad1b39333bac$var$Hh($885aad1b39333bac$var$Gh.current);
                $885aad1b39333bac$var$Hh($885aad1b39333bac$var$Eh.current);
                if ($885aad1b39333bac$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$885aad1b39333bac$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $885aad1b39333bac$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $885aad1b39333bac$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $885aad1b39333bac$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$885aad1b39333bac$var$Of] = b, b.stateNode = d;
            }
            $885aad1b39333bac$var$S(b);
            return null;
        case 13:
            $885aad1b39333bac$var$E($885aad1b39333bac$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($885aad1b39333bac$var$I && null !== $885aad1b39333bac$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $885aad1b39333bac$var$Hg(), $885aad1b39333bac$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $885aad1b39333bac$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($885aad1b39333bac$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($885aad1b39333bac$var$p(317));
                        f[$885aad1b39333bac$var$Of] = b;
                    } else $885aad1b39333bac$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $885aad1b39333bac$var$S(b);
                    f = !1;
                } else null !== $885aad1b39333bac$var$zg && ($885aad1b39333bac$var$Gj($885aad1b39333bac$var$zg), $885aad1b39333bac$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($885aad1b39333bac$var$M.current & 1) ? 0 === $885aad1b39333bac$var$T && ($885aad1b39333bac$var$T = 3) : $885aad1b39333bac$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $885aad1b39333bac$var$S(b);
            return null;
        case 4:
            return $885aad1b39333bac$var$Jh(), $885aad1b39333bac$var$Bj(a, b), null === a && $885aad1b39333bac$var$sf(b.stateNode.containerInfo), $885aad1b39333bac$var$S(b), null;
        case 10:
            return $885aad1b39333bac$var$Rg(b.type._context), $885aad1b39333bac$var$S(b), null;
        case 17:
            return $885aad1b39333bac$var$Zf(b.type) && $885aad1b39333bac$var$$f(), $885aad1b39333bac$var$S(b), null;
        case 19:
            $885aad1b39333bac$var$E($885aad1b39333bac$var$M);
            f = b.memoizedState;
            if (null === f) return $885aad1b39333bac$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $885aad1b39333bac$var$Ej(f, !1);
                else {
                    if (0 !== $885aad1b39333bac$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $885aad1b39333bac$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $885aad1b39333bac$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $885aad1b39333bac$var$G($885aad1b39333bac$var$M, $885aad1b39333bac$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $885aad1b39333bac$var$B() > $885aad1b39333bac$var$Hj && (b.flags |= 128, d = !0, $885aad1b39333bac$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $885aad1b39333bac$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $885aad1b39333bac$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$885aad1b39333bac$var$I) return $885aad1b39333bac$var$S(b), null;
                    } else 2 * $885aad1b39333bac$var$B() - f.renderingStartTime > $885aad1b39333bac$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $885aad1b39333bac$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $885aad1b39333bac$var$B(), b.sibling = null, c = $885aad1b39333bac$var$M.current, $885aad1b39333bac$var$G($885aad1b39333bac$var$M, d ? c & 1 | 2 : c & 1), b;
            $885aad1b39333bac$var$S(b);
            return null;
        case 22:
        case 23:
            return $885aad1b39333bac$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($885aad1b39333bac$var$gj & 1073741824) && ($885aad1b39333bac$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $885aad1b39333bac$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($885aad1b39333bac$var$p(156, b.tag));
}
function $885aad1b39333bac$var$Jj(a, b) {
    $885aad1b39333bac$var$wg(b);
    switch(b.tag){
        case 1:
            return $885aad1b39333bac$var$Zf(b.type) && $885aad1b39333bac$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $885aad1b39333bac$var$Jh(), $885aad1b39333bac$var$E($885aad1b39333bac$var$Wf), $885aad1b39333bac$var$E($885aad1b39333bac$var$H), $885aad1b39333bac$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $885aad1b39333bac$var$Lh(b), null;
        case 13:
            $885aad1b39333bac$var$E($885aad1b39333bac$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($885aad1b39333bac$var$p(340));
                $885aad1b39333bac$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $885aad1b39333bac$var$E($885aad1b39333bac$var$M), null;
        case 4:
            return $885aad1b39333bac$var$Jh(), null;
        case 10:
            return $885aad1b39333bac$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $885aad1b39333bac$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $885aad1b39333bac$var$Kj = !1, $885aad1b39333bac$var$U = !1, $885aad1b39333bac$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $885aad1b39333bac$var$V = null;
function $885aad1b39333bac$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $885aad1b39333bac$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $885aad1b39333bac$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $885aad1b39333bac$var$W(a, b, d);
    }
}
var $885aad1b39333bac$var$Oj = !1;
function $885aad1b39333bac$var$Pj(a, b) {
    $885aad1b39333bac$var$Cf = $885aad1b39333bac$var$dd;
    a = $885aad1b39333bac$var$Me();
    if ($885aad1b39333bac$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $885aad1b39333bac$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $885aad1b39333bac$var$dd = !1;
    for($885aad1b39333bac$var$V = b; null !== $885aad1b39333bac$var$V;)if (b = $885aad1b39333bac$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $885aad1b39333bac$var$V = a;
    else for(; null !== $885aad1b39333bac$var$V;){
        b = $885aad1b39333bac$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $885aad1b39333bac$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($885aad1b39333bac$var$p(163));
            }
        } catch (F) {
            $885aad1b39333bac$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $885aad1b39333bac$var$V = a;
            break;
        }
        $885aad1b39333bac$var$V = b.return;
    }
    n = $885aad1b39333bac$var$Oj;
    $885aad1b39333bac$var$Oj = !1;
    return n;
}
function $885aad1b39333bac$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $885aad1b39333bac$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $885aad1b39333bac$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $885aad1b39333bac$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $885aad1b39333bac$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $885aad1b39333bac$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$885aad1b39333bac$var$Of], delete b[$885aad1b39333bac$var$Pf], delete b[$885aad1b39333bac$var$of], delete b[$885aad1b39333bac$var$Qf], delete b[$885aad1b39333bac$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $885aad1b39333bac$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $885aad1b39333bac$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $885aad1b39333bac$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $885aad1b39333bac$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $885aad1b39333bac$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($885aad1b39333bac$var$Wj(a, b, c), a = a.sibling; null !== a;)$885aad1b39333bac$var$Wj(a, b, c), a = a.sibling;
}
function $885aad1b39333bac$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($885aad1b39333bac$var$Xj(a, b, c), a = a.sibling; null !== a;)$885aad1b39333bac$var$Xj(a, b, c), a = a.sibling;
}
var $885aad1b39333bac$var$X = null, $885aad1b39333bac$var$Yj = !1;
function $885aad1b39333bac$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$885aad1b39333bac$var$ak(a, b, c), c = c.sibling;
}
function $885aad1b39333bac$var$ak(a, b, c) {
    if ($885aad1b39333bac$var$lc && "function" === typeof $885aad1b39333bac$var$lc.onCommitFiberUnmount) try {
        $885aad1b39333bac$var$lc.onCommitFiberUnmount($885aad1b39333bac$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $885aad1b39333bac$var$U || $885aad1b39333bac$var$Mj(c, b);
        case 6:
            var d = $885aad1b39333bac$var$X, e = $885aad1b39333bac$var$Yj;
            $885aad1b39333bac$var$X = null;
            $885aad1b39333bac$var$Zj(a, b, c);
            $885aad1b39333bac$var$X = d;
            $885aad1b39333bac$var$Yj = e;
            null !== $885aad1b39333bac$var$X && ($885aad1b39333bac$var$Yj ? (a = $885aad1b39333bac$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $885aad1b39333bac$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $885aad1b39333bac$var$X && ($885aad1b39333bac$var$Yj ? (a = $885aad1b39333bac$var$X, c = c.stateNode, 8 === a.nodeType ? $885aad1b39333bac$var$Kf(a.parentNode, c) : 1 === a.nodeType && $885aad1b39333bac$var$Kf(a, c), $885aad1b39333bac$var$bd(a)) : $885aad1b39333bac$var$Kf($885aad1b39333bac$var$X, c.stateNode));
            break;
        case 4:
            d = $885aad1b39333bac$var$X;
            e = $885aad1b39333bac$var$Yj;
            $885aad1b39333bac$var$X = c.stateNode.containerInfo;
            $885aad1b39333bac$var$Yj = !0;
            $885aad1b39333bac$var$Zj(a, b, c);
            $885aad1b39333bac$var$X = d;
            $885aad1b39333bac$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$885aad1b39333bac$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $885aad1b39333bac$var$Nj(c, b, g) : 0 !== (f & 4) && $885aad1b39333bac$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $885aad1b39333bac$var$Zj(a, b, c);
            break;
        case 1:
            if (!$885aad1b39333bac$var$U && ($885aad1b39333bac$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $885aad1b39333bac$var$W(c, b, h);
            }
            $885aad1b39333bac$var$Zj(a, b, c);
            break;
        case 21:
            $885aad1b39333bac$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($885aad1b39333bac$var$U = (d = $885aad1b39333bac$var$U) || null !== c.memoizedState, $885aad1b39333bac$var$Zj(a, b, c), $885aad1b39333bac$var$U = d) : $885aad1b39333bac$var$Zj(a, b, c);
            break;
        default:
            $885aad1b39333bac$var$Zj(a, b, c);
    }
}
function $885aad1b39333bac$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $885aad1b39333bac$var$Lj);
        b.forEach(function(b) {
            var d = $885aad1b39333bac$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $885aad1b39333bac$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $885aad1b39333bac$var$X = h.stateNode;
                        $885aad1b39333bac$var$Yj = !1;
                        break a;
                    case 3:
                        $885aad1b39333bac$var$X = h.stateNode.containerInfo;
                        $885aad1b39333bac$var$Yj = !0;
                        break a;
                    case 4:
                        $885aad1b39333bac$var$X = h.stateNode.containerInfo;
                        $885aad1b39333bac$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $885aad1b39333bac$var$X) throw Error($885aad1b39333bac$var$p(160));
            $885aad1b39333bac$var$ak(f, g, e);
            $885aad1b39333bac$var$X = null;
            $885aad1b39333bac$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $885aad1b39333bac$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$885aad1b39333bac$var$ek(b, a), b = b.sibling;
}
function $885aad1b39333bac$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $885aad1b39333bac$var$dk(b, a);
            $885aad1b39333bac$var$fk(a);
            if (d & 4) {
                try {
                    $885aad1b39333bac$var$Qj(3, a, a.return), $885aad1b39333bac$var$Rj(3, a);
                } catch (t) {
                    $885aad1b39333bac$var$W(a, a.return, t);
                }
                try {
                    $885aad1b39333bac$var$Qj(5, a, a.return);
                } catch (t) {
                    $885aad1b39333bac$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $885aad1b39333bac$var$dk(b, a);
            $885aad1b39333bac$var$fk(a);
            d & 512 && null !== c && $885aad1b39333bac$var$Mj(c, c.return);
            break;
        case 5:
            $885aad1b39333bac$var$dk(b, a);
            $885aad1b39333bac$var$fk(a);
            d & 512 && null !== c && $885aad1b39333bac$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $885aad1b39333bac$var$ob(e, "");
                } catch (t) {
                    $885aad1b39333bac$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $885aad1b39333bac$var$ab(e, f);
                    $885aad1b39333bac$var$vb(h, g);
                    var l = $885aad1b39333bac$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $885aad1b39333bac$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $885aad1b39333bac$var$nb(e, q) : "children" === m ? $885aad1b39333bac$var$ob(e, q) : $885aad1b39333bac$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $885aad1b39333bac$var$bb(e, f);
                            break;
                        case "textarea":
                            $885aad1b39333bac$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $885aad1b39333bac$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $885aad1b39333bac$var$fb(e, !!f.multiple, f.defaultValue, !0) : $885aad1b39333bac$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$885aad1b39333bac$var$Pf] = f;
                } catch (t) {
                    $885aad1b39333bac$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $885aad1b39333bac$var$dk(b, a);
            $885aad1b39333bac$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($885aad1b39333bac$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $885aad1b39333bac$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $885aad1b39333bac$var$dk(b, a);
            $885aad1b39333bac$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $885aad1b39333bac$var$bd(b.containerInfo);
            } catch (t) {
                $885aad1b39333bac$var$W(a, a.return, t);
            }
            break;
        case 4:
            $885aad1b39333bac$var$dk(b, a);
            $885aad1b39333bac$var$fk(a);
            break;
        case 13:
            $885aad1b39333bac$var$dk(b, a);
            $885aad1b39333bac$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($885aad1b39333bac$var$gk = $885aad1b39333bac$var$B()));
            d & 4 && $885aad1b39333bac$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($885aad1b39333bac$var$U = (l = $885aad1b39333bac$var$U) || m, $885aad1b39333bac$var$dk(b, a), $885aad1b39333bac$var$U = l) : $885aad1b39333bac$var$dk(b, a);
            $885aad1b39333bac$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($885aad1b39333bac$var$V = a, m = a.child; null !== m;){
                    for(q = $885aad1b39333bac$var$V = m; null !== $885aad1b39333bac$var$V;){
                        r = $885aad1b39333bac$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $885aad1b39333bac$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $885aad1b39333bac$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $885aad1b39333bac$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $885aad1b39333bac$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $885aad1b39333bac$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $885aad1b39333bac$var$V = y) : $885aad1b39333bac$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $885aad1b39333bac$var$rb("display", g));
                            } catch (t) {
                                $885aad1b39333bac$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $885aad1b39333bac$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $885aad1b39333bac$var$dk(b, a);
            $885aad1b39333bac$var$fk(a);
            d & 4 && $885aad1b39333bac$var$bk(a);
            break;
        case 21:
            break;
        default:
            $885aad1b39333bac$var$dk(b, a), $885aad1b39333bac$var$fk(a);
    }
}
function $885aad1b39333bac$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($885aad1b39333bac$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($885aad1b39333bac$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($885aad1b39333bac$var$ob(e, ""), d.flags &= -33);
                    var f = $885aad1b39333bac$var$Vj(a);
                    $885aad1b39333bac$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $885aad1b39333bac$var$Vj(a);
                    $885aad1b39333bac$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($885aad1b39333bac$var$p(161));
            }
        } catch (k) {
            $885aad1b39333bac$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $885aad1b39333bac$var$ik(a, b, c) {
    $885aad1b39333bac$var$V = a;
    $885aad1b39333bac$var$jk(a, b, c);
}
function $885aad1b39333bac$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $885aad1b39333bac$var$V;){
        var e = $885aad1b39333bac$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $885aad1b39333bac$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $885aad1b39333bac$var$U;
                h = $885aad1b39333bac$var$Kj;
                var l = $885aad1b39333bac$var$U;
                $885aad1b39333bac$var$Kj = g;
                if (($885aad1b39333bac$var$U = k) && !l) for($885aad1b39333bac$var$V = e; null !== $885aad1b39333bac$var$V;)g = $885aad1b39333bac$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $885aad1b39333bac$var$kk(e) : null !== k ? (k.return = g, $885aad1b39333bac$var$V = k) : $885aad1b39333bac$var$kk(e);
                for(; null !== f;)$885aad1b39333bac$var$V = f, $885aad1b39333bac$var$jk(f, b, c), f = f.sibling;
                $885aad1b39333bac$var$V = e;
                $885aad1b39333bac$var$Kj = h;
                $885aad1b39333bac$var$U = l;
            }
            $885aad1b39333bac$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $885aad1b39333bac$var$V = f) : $885aad1b39333bac$var$lk(a, b, c);
    }
}
function $885aad1b39333bac$var$lk(a) {
    for(; null !== $885aad1b39333bac$var$V;){
        var b = $885aad1b39333bac$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $885aad1b39333bac$var$U || $885aad1b39333bac$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$885aad1b39333bac$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $885aad1b39333bac$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $885aad1b39333bac$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $885aad1b39333bac$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $885aad1b39333bac$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($885aad1b39333bac$var$p(163));
                }
                $885aad1b39333bac$var$U || b.flags & 512 && $885aad1b39333bac$var$Sj(b);
            } catch (r) {
                $885aad1b39333bac$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $885aad1b39333bac$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $885aad1b39333bac$var$V = c;
            break;
        }
        $885aad1b39333bac$var$V = b.return;
    }
}
function $885aad1b39333bac$var$hk(a) {
    for(; null !== $885aad1b39333bac$var$V;){
        var b = $885aad1b39333bac$var$V;
        if (b === a) {
            $885aad1b39333bac$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $885aad1b39333bac$var$V = c;
            break;
        }
        $885aad1b39333bac$var$V = b.return;
    }
}
function $885aad1b39333bac$var$kk(a) {
    for(; null !== $885aad1b39333bac$var$V;){
        var b = $885aad1b39333bac$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $885aad1b39333bac$var$Rj(4, b);
                    } catch (k) {
                        $885aad1b39333bac$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $885aad1b39333bac$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $885aad1b39333bac$var$Sj(b);
                    } catch (k) {
                        $885aad1b39333bac$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $885aad1b39333bac$var$Sj(b);
                    } catch (k) {
                        $885aad1b39333bac$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $885aad1b39333bac$var$W(b, b.return, k);
        }
        if (b === a) {
            $885aad1b39333bac$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $885aad1b39333bac$var$V = h;
            break;
        }
        $885aad1b39333bac$var$V = b.return;
    }
}
var $885aad1b39333bac$var$mk = Math.ceil, $885aad1b39333bac$var$nk = $885aad1b39333bac$var$ua.ReactCurrentDispatcher, $885aad1b39333bac$var$ok = $885aad1b39333bac$var$ua.ReactCurrentOwner, $885aad1b39333bac$var$pk = $885aad1b39333bac$var$ua.ReactCurrentBatchConfig, $885aad1b39333bac$var$K = 0, $885aad1b39333bac$var$R = null, $885aad1b39333bac$var$Y = null, $885aad1b39333bac$var$Z = 0, $885aad1b39333bac$var$gj = 0, $885aad1b39333bac$var$fj = $885aad1b39333bac$var$Uf(0), $885aad1b39333bac$var$T = 0, $885aad1b39333bac$var$qk = null, $885aad1b39333bac$var$hh = 0, $885aad1b39333bac$var$rk = 0, $885aad1b39333bac$var$sk = 0, $885aad1b39333bac$var$tk = null, $885aad1b39333bac$var$uk = null, $885aad1b39333bac$var$gk = 0, $885aad1b39333bac$var$Hj = Infinity, $885aad1b39333bac$var$vk = null, $885aad1b39333bac$var$Pi = !1, $885aad1b39333bac$var$Qi = null, $885aad1b39333bac$var$Si = null, $885aad1b39333bac$var$wk = !1, $885aad1b39333bac$var$xk = null, $885aad1b39333bac$var$yk = 0, $885aad1b39333bac$var$zk = 0, $885aad1b39333bac$var$Ak = null, $885aad1b39333bac$var$Bk = -1, $885aad1b39333bac$var$Ck = 0;
function $885aad1b39333bac$var$L() {
    return 0 !== ($885aad1b39333bac$var$K & 6) ? $885aad1b39333bac$var$B() : -1 !== $885aad1b39333bac$var$Bk ? $885aad1b39333bac$var$Bk : $885aad1b39333bac$var$Bk = $885aad1b39333bac$var$B();
}
function $885aad1b39333bac$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($885aad1b39333bac$var$K & 2) && 0 !== $885aad1b39333bac$var$Z) return $885aad1b39333bac$var$Z & -$885aad1b39333bac$var$Z;
    if (null !== $885aad1b39333bac$var$Kg.transition) return 0 === $885aad1b39333bac$var$Ck && ($885aad1b39333bac$var$Ck = $885aad1b39333bac$var$yc()), $885aad1b39333bac$var$Ck;
    a = $885aad1b39333bac$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $885aad1b39333bac$var$jd(a.type);
    return a;
}
function $885aad1b39333bac$var$mh(a, b, c, d) {
    if (50 < $885aad1b39333bac$var$zk) throw $885aad1b39333bac$var$zk = 0, $885aad1b39333bac$var$Ak = null, Error($885aad1b39333bac$var$p(185));
    $885aad1b39333bac$var$Ac(a, c, d);
    if (0 === ($885aad1b39333bac$var$K & 2) || a !== $885aad1b39333bac$var$R) a === $885aad1b39333bac$var$R && (0 === ($885aad1b39333bac$var$K & 2) && ($885aad1b39333bac$var$rk |= c), 4 === $885aad1b39333bac$var$T && $885aad1b39333bac$var$Dk(a, $885aad1b39333bac$var$Z)), $885aad1b39333bac$var$Ek(a, d), 1 === c && 0 === $885aad1b39333bac$var$K && 0 === (b.mode & 1) && ($885aad1b39333bac$var$Hj = $885aad1b39333bac$var$B() + 500, $885aad1b39333bac$var$fg && $885aad1b39333bac$var$jg());
}
function $885aad1b39333bac$var$Ek(a, b) {
    var c = a.callbackNode;
    $885aad1b39333bac$var$wc(a, b);
    var d = $885aad1b39333bac$var$uc(a, a === $885aad1b39333bac$var$R ? $885aad1b39333bac$var$Z : 0);
    if (0 === d) null !== c && $885aad1b39333bac$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $885aad1b39333bac$var$bc(c);
        if (1 === b) 0 === a.tag ? $885aad1b39333bac$var$ig($885aad1b39333bac$var$Fk.bind(null, a)) : $885aad1b39333bac$var$hg($885aad1b39333bac$var$Fk.bind(null, a)), $885aad1b39333bac$var$Jf(function() {
            0 === ($885aad1b39333bac$var$K & 6) && $885aad1b39333bac$var$jg();
        }), c = null;
        else {
            switch($885aad1b39333bac$var$Dc(d)){
                case 1:
                    c = $885aad1b39333bac$var$fc;
                    break;
                case 4:
                    c = $885aad1b39333bac$var$gc;
                    break;
                case 16:
                    c = $885aad1b39333bac$var$hc;
                    break;
                case 536870912:
                    c = $885aad1b39333bac$var$jc;
                    break;
                default:
                    c = $885aad1b39333bac$var$hc;
            }
            c = $885aad1b39333bac$var$Gk(c, $885aad1b39333bac$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $885aad1b39333bac$var$Hk(a, b) {
    $885aad1b39333bac$var$Bk = -1;
    $885aad1b39333bac$var$Ck = 0;
    if (0 !== ($885aad1b39333bac$var$K & 6)) throw Error($885aad1b39333bac$var$p(327));
    var c = a.callbackNode;
    if ($885aad1b39333bac$var$Ik() && a.callbackNode !== c) return null;
    var d = $885aad1b39333bac$var$uc(a, a === $885aad1b39333bac$var$R ? $885aad1b39333bac$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $885aad1b39333bac$var$Jk(a, d);
    else {
        b = d;
        var e = $885aad1b39333bac$var$K;
        $885aad1b39333bac$var$K |= 2;
        var f = $885aad1b39333bac$var$Kk();
        if ($885aad1b39333bac$var$R !== a || $885aad1b39333bac$var$Z !== b) $885aad1b39333bac$var$vk = null, $885aad1b39333bac$var$Hj = $885aad1b39333bac$var$B() + 500, $885aad1b39333bac$var$Lk(a, b);
        for(;;)try {
            $885aad1b39333bac$var$Mk();
            break;
        } catch (h) {
            $885aad1b39333bac$var$Nk(a, h);
        }
        $885aad1b39333bac$var$Qg();
        $885aad1b39333bac$var$nk.current = f;
        $885aad1b39333bac$var$K = e;
        null !== $885aad1b39333bac$var$Y ? b = 0 : ($885aad1b39333bac$var$R = null, $885aad1b39333bac$var$Z = 0, b = $885aad1b39333bac$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $885aad1b39333bac$var$xc(a), 0 !== e && (d = e, b = $885aad1b39333bac$var$Ok(a, e)));
        if (1 === b) throw c = $885aad1b39333bac$var$qk, $885aad1b39333bac$var$Lk(a, 0), $885aad1b39333bac$var$Dk(a, d), $885aad1b39333bac$var$Ek(a, $885aad1b39333bac$var$B()), c;
        if (6 === b) $885aad1b39333bac$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$885aad1b39333bac$var$Pk(e) && (b = $885aad1b39333bac$var$Jk(a, d), 2 === b && (f = $885aad1b39333bac$var$xc(a), 0 !== f && (d = f, b = $885aad1b39333bac$var$Ok(a, f))), 1 === b)) throw c = $885aad1b39333bac$var$qk, $885aad1b39333bac$var$Lk(a, 0), $885aad1b39333bac$var$Dk(a, d), $885aad1b39333bac$var$Ek(a, $885aad1b39333bac$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($885aad1b39333bac$var$p(345));
                case 2:
                    $885aad1b39333bac$var$Qk(a, $885aad1b39333bac$var$uk, $885aad1b39333bac$var$vk);
                    break;
                case 3:
                    $885aad1b39333bac$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $885aad1b39333bac$var$gk + 500 - $885aad1b39333bac$var$B(), 10 < b)) {
                        if (0 !== $885aad1b39333bac$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $885aad1b39333bac$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $885aad1b39333bac$var$Ff($885aad1b39333bac$var$Qk.bind(null, a, $885aad1b39333bac$var$uk, $885aad1b39333bac$var$vk), b);
                        break;
                    }
                    $885aad1b39333bac$var$Qk(a, $885aad1b39333bac$var$uk, $885aad1b39333bac$var$vk);
                    break;
                case 4:
                    $885aad1b39333bac$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $885aad1b39333bac$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $885aad1b39333bac$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $885aad1b39333bac$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $885aad1b39333bac$var$Ff($885aad1b39333bac$var$Qk.bind(null, a, $885aad1b39333bac$var$uk, $885aad1b39333bac$var$vk), d);
                        break;
                    }
                    $885aad1b39333bac$var$Qk(a, $885aad1b39333bac$var$uk, $885aad1b39333bac$var$vk);
                    break;
                case 5:
                    $885aad1b39333bac$var$Qk(a, $885aad1b39333bac$var$uk, $885aad1b39333bac$var$vk);
                    break;
                default:
                    throw Error($885aad1b39333bac$var$p(329));
            }
        }
    }
    $885aad1b39333bac$var$Ek(a, $885aad1b39333bac$var$B());
    return a.callbackNode === c ? $885aad1b39333bac$var$Hk.bind(null, a) : null;
}
function $885aad1b39333bac$var$Ok(a, b) {
    var c = $885aad1b39333bac$var$tk;
    a.current.memoizedState.isDehydrated && ($885aad1b39333bac$var$Lk(a, b).flags |= 256);
    a = $885aad1b39333bac$var$Jk(a, b);
    2 !== a && (b = $885aad1b39333bac$var$uk, $885aad1b39333bac$var$uk = c, null !== b && $885aad1b39333bac$var$Gj(b));
    return a;
}
function $885aad1b39333bac$var$Gj(a) {
    null === $885aad1b39333bac$var$uk ? $885aad1b39333bac$var$uk = a : $885aad1b39333bac$var$uk.push.apply($885aad1b39333bac$var$uk, a);
}
function $885aad1b39333bac$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$885aad1b39333bac$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $885aad1b39333bac$var$Dk(a, b) {
    b &= ~$885aad1b39333bac$var$sk;
    b &= ~$885aad1b39333bac$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $885aad1b39333bac$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $885aad1b39333bac$var$Fk(a) {
    if (0 !== ($885aad1b39333bac$var$K & 6)) throw Error($885aad1b39333bac$var$p(327));
    $885aad1b39333bac$var$Ik();
    var b = $885aad1b39333bac$var$uc(a, 0);
    if (0 === (b & 1)) return $885aad1b39333bac$var$Ek(a, $885aad1b39333bac$var$B()), null;
    var c = $885aad1b39333bac$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $885aad1b39333bac$var$xc(a);
        0 !== d && (b = d, c = $885aad1b39333bac$var$Ok(a, d));
    }
    if (1 === c) throw c = $885aad1b39333bac$var$qk, $885aad1b39333bac$var$Lk(a, 0), $885aad1b39333bac$var$Dk(a, b), $885aad1b39333bac$var$Ek(a, $885aad1b39333bac$var$B()), c;
    if (6 === c) throw Error($885aad1b39333bac$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $885aad1b39333bac$var$Qk(a, $885aad1b39333bac$var$uk, $885aad1b39333bac$var$vk);
    $885aad1b39333bac$var$Ek(a, $885aad1b39333bac$var$B());
    return null;
}
function $885aad1b39333bac$var$Rk(a, b) {
    var c = $885aad1b39333bac$var$K;
    $885aad1b39333bac$var$K |= 1;
    try {
        return a(b);
    } finally{
        $885aad1b39333bac$var$K = c, 0 === $885aad1b39333bac$var$K && ($885aad1b39333bac$var$Hj = $885aad1b39333bac$var$B() + 500, $885aad1b39333bac$var$fg && $885aad1b39333bac$var$jg());
    }
}
function $885aad1b39333bac$var$Sk(a) {
    null !== $885aad1b39333bac$var$xk && 0 === $885aad1b39333bac$var$xk.tag && 0 === ($885aad1b39333bac$var$K & 6) && $885aad1b39333bac$var$Ik();
    var b = $885aad1b39333bac$var$K;
    $885aad1b39333bac$var$K |= 1;
    var c = $885aad1b39333bac$var$pk.transition, d = $885aad1b39333bac$var$C;
    try {
        if ($885aad1b39333bac$var$pk.transition = null, $885aad1b39333bac$var$C = 1, a) return a();
    } finally{
        $885aad1b39333bac$var$C = d, $885aad1b39333bac$var$pk.transition = c, $885aad1b39333bac$var$K = b, 0 === ($885aad1b39333bac$var$K & 6) && $885aad1b39333bac$var$jg();
    }
}
function $885aad1b39333bac$var$Ij() {
    $885aad1b39333bac$var$gj = $885aad1b39333bac$var$fj.current;
    $885aad1b39333bac$var$E($885aad1b39333bac$var$fj);
}
function $885aad1b39333bac$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $885aad1b39333bac$var$Gf(c));
    if (null !== $885aad1b39333bac$var$Y) for(c = $885aad1b39333bac$var$Y.return; null !== c;){
        var d = c;
        $885aad1b39333bac$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $885aad1b39333bac$var$$f();
                break;
            case 3:
                $885aad1b39333bac$var$Jh();
                $885aad1b39333bac$var$E($885aad1b39333bac$var$Wf);
                $885aad1b39333bac$var$E($885aad1b39333bac$var$H);
                $885aad1b39333bac$var$Oh();
                break;
            case 5:
                $885aad1b39333bac$var$Lh(d);
                break;
            case 4:
                $885aad1b39333bac$var$Jh();
                break;
            case 13:
                $885aad1b39333bac$var$E($885aad1b39333bac$var$M);
                break;
            case 19:
                $885aad1b39333bac$var$E($885aad1b39333bac$var$M);
                break;
            case 10:
                $885aad1b39333bac$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $885aad1b39333bac$var$Ij();
        }
        c = c.return;
    }
    $885aad1b39333bac$var$R = a;
    $885aad1b39333bac$var$Y = a = $885aad1b39333bac$var$wh(a.current, null);
    $885aad1b39333bac$var$Z = $885aad1b39333bac$var$gj = b;
    $885aad1b39333bac$var$T = 0;
    $885aad1b39333bac$var$qk = null;
    $885aad1b39333bac$var$sk = $885aad1b39333bac$var$rk = $885aad1b39333bac$var$hh = 0;
    $885aad1b39333bac$var$uk = $885aad1b39333bac$var$tk = null;
    if (null !== $885aad1b39333bac$var$Wg) {
        for(b = 0; b < $885aad1b39333bac$var$Wg.length; b++)if (c = $885aad1b39333bac$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $885aad1b39333bac$var$Wg = null;
    }
    return a;
}
function $885aad1b39333bac$var$Nk(a, b) {
    do {
        var c = $885aad1b39333bac$var$Y;
        try {
            $885aad1b39333bac$var$Qg();
            $885aad1b39333bac$var$Ph.current = $885aad1b39333bac$var$ai;
            if ($885aad1b39333bac$var$Sh) {
                for(var d = $885aad1b39333bac$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $885aad1b39333bac$var$Sh = !1;
            }
            $885aad1b39333bac$var$Rh = 0;
            $885aad1b39333bac$var$P = $885aad1b39333bac$var$O = $885aad1b39333bac$var$N = null;
            $885aad1b39333bac$var$Th = !1;
            $885aad1b39333bac$var$Uh = 0;
            $885aad1b39333bac$var$ok.current = null;
            if (null === c || null === c.return) {
                $885aad1b39333bac$var$T = 1;
                $885aad1b39333bac$var$qk = b;
                $885aad1b39333bac$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $885aad1b39333bac$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $885aad1b39333bac$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $885aad1b39333bac$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $885aad1b39333bac$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $885aad1b39333bac$var$Ti(f, l, b);
                            $885aad1b39333bac$var$uj();
                            break a;
                        }
                        k = Error($885aad1b39333bac$var$p(426));
                    }
                } else if ($885aad1b39333bac$var$I && h.mode & 1) {
                    var J = $885aad1b39333bac$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $885aad1b39333bac$var$Wi(J, g, h, f, b);
                        $885aad1b39333bac$var$Jg($885aad1b39333bac$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $885aad1b39333bac$var$Ki(k, h);
                4 !== $885aad1b39333bac$var$T && ($885aad1b39333bac$var$T = 2);
                null === $885aad1b39333bac$var$tk ? $885aad1b39333bac$var$tk = [
                    f
                ] : $885aad1b39333bac$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $885aad1b39333bac$var$Oi(f, k, b);
                            $885aad1b39333bac$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $885aad1b39333bac$var$Si || !$885aad1b39333bac$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $885aad1b39333bac$var$Ri(f, h, b);
                                $885aad1b39333bac$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $885aad1b39333bac$var$Tk(c);
        } catch (na) {
            b = na;
            $885aad1b39333bac$var$Y === c && null !== c && ($885aad1b39333bac$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $885aad1b39333bac$var$Kk() {
    var a = $885aad1b39333bac$var$nk.current;
    $885aad1b39333bac$var$nk.current = $885aad1b39333bac$var$ai;
    return null === a ? $885aad1b39333bac$var$ai : a;
}
function $885aad1b39333bac$var$uj() {
    if (0 === $885aad1b39333bac$var$T || 3 === $885aad1b39333bac$var$T || 2 === $885aad1b39333bac$var$T) $885aad1b39333bac$var$T = 4;
    null === $885aad1b39333bac$var$R || 0 === ($885aad1b39333bac$var$hh & 268435455) && 0 === ($885aad1b39333bac$var$rk & 268435455) || $885aad1b39333bac$var$Dk($885aad1b39333bac$var$R, $885aad1b39333bac$var$Z);
}
function $885aad1b39333bac$var$Jk(a, b) {
    var c = $885aad1b39333bac$var$K;
    $885aad1b39333bac$var$K |= 2;
    var d = $885aad1b39333bac$var$Kk();
    if ($885aad1b39333bac$var$R !== a || $885aad1b39333bac$var$Z !== b) $885aad1b39333bac$var$vk = null, $885aad1b39333bac$var$Lk(a, b);
    for(;;)try {
        $885aad1b39333bac$var$Uk();
        break;
    } catch (e) {
        $885aad1b39333bac$var$Nk(a, e);
    }
    $885aad1b39333bac$var$Qg();
    $885aad1b39333bac$var$K = c;
    $885aad1b39333bac$var$nk.current = d;
    if (null !== $885aad1b39333bac$var$Y) throw Error($885aad1b39333bac$var$p(261));
    $885aad1b39333bac$var$R = null;
    $885aad1b39333bac$var$Z = 0;
    return $885aad1b39333bac$var$T;
}
function $885aad1b39333bac$var$Uk() {
    for(; null !== $885aad1b39333bac$var$Y;)$885aad1b39333bac$var$Vk($885aad1b39333bac$var$Y);
}
function $885aad1b39333bac$var$Mk() {
    for(; null !== $885aad1b39333bac$var$Y && !$885aad1b39333bac$var$cc();)$885aad1b39333bac$var$Vk($885aad1b39333bac$var$Y);
}
function $885aad1b39333bac$var$Vk(a) {
    var b = $885aad1b39333bac$var$Wk(a.alternate, a, $885aad1b39333bac$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $885aad1b39333bac$var$Tk(a) : $885aad1b39333bac$var$Y = b;
    $885aad1b39333bac$var$ok.current = null;
}
function $885aad1b39333bac$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $885aad1b39333bac$var$Fj(c, b, $885aad1b39333bac$var$gj), null !== c) {
                $885aad1b39333bac$var$Y = c;
                return;
            }
        } else {
            c = $885aad1b39333bac$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $885aad1b39333bac$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $885aad1b39333bac$var$T = 6;
                $885aad1b39333bac$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $885aad1b39333bac$var$Y = b;
            return;
        }
        $885aad1b39333bac$var$Y = b = a;
    }while (null !== b);
    0 === $885aad1b39333bac$var$T && ($885aad1b39333bac$var$T = 5);
}
function $885aad1b39333bac$var$Qk(a, b, c) {
    var d = $885aad1b39333bac$var$C, e = $885aad1b39333bac$var$pk.transition;
    try {
        $885aad1b39333bac$var$pk.transition = null, $885aad1b39333bac$var$C = 1, $885aad1b39333bac$var$Xk(a, b, c, d);
    } finally{
        $885aad1b39333bac$var$pk.transition = e, $885aad1b39333bac$var$C = d;
    }
    return null;
}
function $885aad1b39333bac$var$Xk(a, b, c, d) {
    do $885aad1b39333bac$var$Ik();
    while (null !== $885aad1b39333bac$var$xk);
    if (0 !== ($885aad1b39333bac$var$K & 6)) throw Error($885aad1b39333bac$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($885aad1b39333bac$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $885aad1b39333bac$var$Bc(a, f);
    a === $885aad1b39333bac$var$R && ($885aad1b39333bac$var$Y = $885aad1b39333bac$var$R = null, $885aad1b39333bac$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $885aad1b39333bac$var$wk || ($885aad1b39333bac$var$wk = !0, $885aad1b39333bac$var$Gk($885aad1b39333bac$var$hc, function() {
        $885aad1b39333bac$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $885aad1b39333bac$var$pk.transition;
        $885aad1b39333bac$var$pk.transition = null;
        var g = $885aad1b39333bac$var$C;
        $885aad1b39333bac$var$C = 1;
        var h = $885aad1b39333bac$var$K;
        $885aad1b39333bac$var$K |= 4;
        $885aad1b39333bac$var$ok.current = null;
        $885aad1b39333bac$var$Pj(a, c);
        $885aad1b39333bac$var$ek(c, a);
        $885aad1b39333bac$var$Oe($885aad1b39333bac$var$Df);
        $885aad1b39333bac$var$dd = !!$885aad1b39333bac$var$Cf;
        $885aad1b39333bac$var$Df = $885aad1b39333bac$var$Cf = null;
        a.current = c;
        $885aad1b39333bac$var$ik(c, a, e);
        $885aad1b39333bac$var$dc();
        $885aad1b39333bac$var$K = h;
        $885aad1b39333bac$var$C = g;
        $885aad1b39333bac$var$pk.transition = f;
    } else a.current = c;
    $885aad1b39333bac$var$wk && ($885aad1b39333bac$var$wk = !1, $885aad1b39333bac$var$xk = a, $885aad1b39333bac$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($885aad1b39333bac$var$Si = null);
    $885aad1b39333bac$var$mc(c.stateNode, d);
    $885aad1b39333bac$var$Ek(a, $885aad1b39333bac$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($885aad1b39333bac$var$Pi) throw $885aad1b39333bac$var$Pi = !1, a = $885aad1b39333bac$var$Qi, $885aad1b39333bac$var$Qi = null, a;
    0 !== ($885aad1b39333bac$var$yk & 1) && 0 !== a.tag && $885aad1b39333bac$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $885aad1b39333bac$var$Ak ? $885aad1b39333bac$var$zk++ : ($885aad1b39333bac$var$zk = 0, $885aad1b39333bac$var$Ak = a) : $885aad1b39333bac$var$zk = 0;
    $885aad1b39333bac$var$jg();
    return null;
}
function $885aad1b39333bac$var$Ik() {
    if (null !== $885aad1b39333bac$var$xk) {
        var a = $885aad1b39333bac$var$Dc($885aad1b39333bac$var$yk), b = $885aad1b39333bac$var$pk.transition, c = $885aad1b39333bac$var$C;
        try {
            $885aad1b39333bac$var$pk.transition = null;
            $885aad1b39333bac$var$C = 16 > a ? 16 : a;
            if (null === $885aad1b39333bac$var$xk) var d = !1;
            else {
                a = $885aad1b39333bac$var$xk;
                $885aad1b39333bac$var$xk = null;
                $885aad1b39333bac$var$yk = 0;
                if (0 !== ($885aad1b39333bac$var$K & 6)) throw Error($885aad1b39333bac$var$p(331));
                var e = $885aad1b39333bac$var$K;
                $885aad1b39333bac$var$K |= 4;
                for($885aad1b39333bac$var$V = a.current; null !== $885aad1b39333bac$var$V;){
                    var f = $885aad1b39333bac$var$V, g = f.child;
                    if (0 !== ($885aad1b39333bac$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($885aad1b39333bac$var$V = l; null !== $885aad1b39333bac$var$V;){
                                    var m = $885aad1b39333bac$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $885aad1b39333bac$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $885aad1b39333bac$var$V = q;
                                    else for(; null !== $885aad1b39333bac$var$V;){
                                        m = $885aad1b39333bac$var$V;
                                        var r = m.sibling, y = m.return;
                                        $885aad1b39333bac$var$Tj(m);
                                        if (m === l) {
                                            $885aad1b39333bac$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $885aad1b39333bac$var$V = r;
                                            break;
                                        }
                                        $885aad1b39333bac$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $885aad1b39333bac$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $885aad1b39333bac$var$V = g;
                    else b: for(; null !== $885aad1b39333bac$var$V;){
                        f = $885aad1b39333bac$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $885aad1b39333bac$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $885aad1b39333bac$var$V = x;
                            break b;
                        }
                        $885aad1b39333bac$var$V = f.return;
                    }
                }
                var w = a.current;
                for($885aad1b39333bac$var$V = w; null !== $885aad1b39333bac$var$V;){
                    g = $885aad1b39333bac$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $885aad1b39333bac$var$V = u;
                    else b: for(g = w; null !== $885aad1b39333bac$var$V;){
                        h = $885aad1b39333bac$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $885aad1b39333bac$var$Rj(9, h);
                            }
                        } catch (na) {
                            $885aad1b39333bac$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $885aad1b39333bac$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $885aad1b39333bac$var$V = F;
                            break b;
                        }
                        $885aad1b39333bac$var$V = h.return;
                    }
                }
                $885aad1b39333bac$var$K = e;
                $885aad1b39333bac$var$jg();
                if ($885aad1b39333bac$var$lc && "function" === typeof $885aad1b39333bac$var$lc.onPostCommitFiberRoot) try {
                    $885aad1b39333bac$var$lc.onPostCommitFiberRoot($885aad1b39333bac$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $885aad1b39333bac$var$C = c, $885aad1b39333bac$var$pk.transition = b;
        }
    }
    return !1;
}
function $885aad1b39333bac$var$Yk(a, b, c) {
    b = $885aad1b39333bac$var$Ki(c, b);
    b = $885aad1b39333bac$var$Oi(a, b, 1);
    a = $885aad1b39333bac$var$dh(a, b, 1);
    b = $885aad1b39333bac$var$L();
    null !== a && ($885aad1b39333bac$var$Ac(a, 1, b), $885aad1b39333bac$var$Ek(a, b));
}
function $885aad1b39333bac$var$W(a, b, c) {
    if (3 === a.tag) $885aad1b39333bac$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $885aad1b39333bac$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $885aad1b39333bac$var$Si || !$885aad1b39333bac$var$Si.has(d))) {
                a = $885aad1b39333bac$var$Ki(c, a);
                a = $885aad1b39333bac$var$Ri(b, a, 1);
                b = $885aad1b39333bac$var$dh(b, a, 1);
                a = $885aad1b39333bac$var$L();
                null !== b && ($885aad1b39333bac$var$Ac(b, 1, a), $885aad1b39333bac$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $885aad1b39333bac$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $885aad1b39333bac$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $885aad1b39333bac$var$R === a && ($885aad1b39333bac$var$Z & c) === c && (4 === $885aad1b39333bac$var$T || 3 === $885aad1b39333bac$var$T && ($885aad1b39333bac$var$Z & 130023424) === $885aad1b39333bac$var$Z && 500 > $885aad1b39333bac$var$B() - $885aad1b39333bac$var$gk ? $885aad1b39333bac$var$Lk(a, 0) : $885aad1b39333bac$var$sk |= c);
    $885aad1b39333bac$var$Ek(a, b);
}
function $885aad1b39333bac$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $885aad1b39333bac$var$sc, $885aad1b39333bac$var$sc <<= 1, 0 === ($885aad1b39333bac$var$sc & 130023424) && ($885aad1b39333bac$var$sc = 4194304)));
    var c = $885aad1b39333bac$var$L();
    a = $885aad1b39333bac$var$Zg(a, b);
    null !== a && ($885aad1b39333bac$var$Ac(a, b, c), $885aad1b39333bac$var$Ek(a, c));
}
function $885aad1b39333bac$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $885aad1b39333bac$var$Zk(a, c);
}
function $885aad1b39333bac$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($885aad1b39333bac$var$p(314));
    }
    null !== d && d.delete(b);
    $885aad1b39333bac$var$Zk(a, c);
}
var $885aad1b39333bac$var$Wk;
$885aad1b39333bac$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $885aad1b39333bac$var$Wf.current) $885aad1b39333bac$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $885aad1b39333bac$var$Ug = !1, $885aad1b39333bac$var$zj(a, b, c);
            $885aad1b39333bac$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $885aad1b39333bac$var$Ug = !1, $885aad1b39333bac$var$I && 0 !== (b.flags & 1048576) && $885aad1b39333bac$var$ug(b, $885aad1b39333bac$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $885aad1b39333bac$var$jj(a, b);
            a = b.pendingProps;
            var e = $885aad1b39333bac$var$Yf(b, $885aad1b39333bac$var$H.current);
            $885aad1b39333bac$var$Tg(b, c);
            e = $885aad1b39333bac$var$Xh(null, b, d, a, e, c);
            var f = $885aad1b39333bac$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $885aad1b39333bac$var$Zf(d) ? (f = !0, $885aad1b39333bac$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $885aad1b39333bac$var$ah(b), e.updater = $885aad1b39333bac$var$nh, b.stateNode = e, e._reactInternals = b, $885aad1b39333bac$var$rh(b, d, a, c), b = $885aad1b39333bac$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $885aad1b39333bac$var$I && f && $885aad1b39333bac$var$vg(b), $885aad1b39333bac$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $885aad1b39333bac$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $885aad1b39333bac$var$$k(d);
                a = $885aad1b39333bac$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $885aad1b39333bac$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $885aad1b39333bac$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $885aad1b39333bac$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $885aad1b39333bac$var$aj(null, b, d, $885aad1b39333bac$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($885aad1b39333bac$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $885aad1b39333bac$var$Lg(d, e), $885aad1b39333bac$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $885aad1b39333bac$var$Lg(d, e), $885aad1b39333bac$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $885aad1b39333bac$var$lj(b);
                if (null === a) throw Error($885aad1b39333bac$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $885aad1b39333bac$var$bh(a, b);
                $885aad1b39333bac$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $885aad1b39333bac$var$Ki(Error($885aad1b39333bac$var$p(423)), b);
                        b = $885aad1b39333bac$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $885aad1b39333bac$var$Ki(Error($885aad1b39333bac$var$p(424)), b);
                        b = $885aad1b39333bac$var$mj(a, b, d, c, e);
                        break a;
                    } else for($885aad1b39333bac$var$yg = $885aad1b39333bac$var$Lf(b.stateNode.containerInfo.firstChild), $885aad1b39333bac$var$xg = b, $885aad1b39333bac$var$I = !0, $885aad1b39333bac$var$zg = null, c = $885aad1b39333bac$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $885aad1b39333bac$var$Ig();
                    if (d === e) {
                        b = $885aad1b39333bac$var$$i(a, b, c);
                        break a;
                    }
                    $885aad1b39333bac$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $885aad1b39333bac$var$Kh(b), null === a && $885aad1b39333bac$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $885aad1b39333bac$var$Ef(d, e) ? g = null : null !== f && $885aad1b39333bac$var$Ef(d, f) && (b.flags |= 32), $885aad1b39333bac$var$hj(a, b), $885aad1b39333bac$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $885aad1b39333bac$var$Eg(b), null;
        case 13:
            return $885aad1b39333bac$var$pj(a, b, c);
        case 4:
            return $885aad1b39333bac$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $885aad1b39333bac$var$Bh(b, null, d, c) : $885aad1b39333bac$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $885aad1b39333bac$var$Lg(d, e), $885aad1b39333bac$var$Zi(a, b, d, e, c);
        case 7:
            return $885aad1b39333bac$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $885aad1b39333bac$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $885aad1b39333bac$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $885aad1b39333bac$var$G($885aad1b39333bac$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($885aad1b39333bac$var$He(f.value, g)) {
                        if (f.children === e.children && !$885aad1b39333bac$var$Wf.current) {
                            b = $885aad1b39333bac$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $885aad1b39333bac$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $885aad1b39333bac$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($885aad1b39333bac$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $885aad1b39333bac$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $885aad1b39333bac$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $885aad1b39333bac$var$Tg(b, c), e = $885aad1b39333bac$var$Vg(e), d = d(e), b.flags |= 1, $885aad1b39333bac$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $885aad1b39333bac$var$Lg(d, b.pendingProps), e = $885aad1b39333bac$var$Lg(d.type, e), $885aad1b39333bac$var$aj(a, b, d, e, c);
        case 15:
            return $885aad1b39333bac$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $885aad1b39333bac$var$Lg(d, e), $885aad1b39333bac$var$jj(a, b), b.tag = 1, $885aad1b39333bac$var$Zf(d) ? (a = !0, $885aad1b39333bac$var$cg(b)) : a = !1, $885aad1b39333bac$var$Tg(b, c), $885aad1b39333bac$var$ph(b, d, e), $885aad1b39333bac$var$rh(b, d, e, c), $885aad1b39333bac$var$kj(null, b, d, !0, a, c);
        case 19:
            return $885aad1b39333bac$var$yj(a, b, c);
        case 22:
            return $885aad1b39333bac$var$ej(a, b, c);
    }
    throw Error($885aad1b39333bac$var$p(156, b.tag));
};
function $885aad1b39333bac$var$Gk(a, b) {
    return $885aad1b39333bac$var$ac(a, b);
}
function $885aad1b39333bac$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $885aad1b39333bac$var$Bg(a, b, c, d) {
    return new $885aad1b39333bac$var$al(a, b, c, d);
}
function $885aad1b39333bac$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $885aad1b39333bac$var$$k(a) {
    if ("function" === typeof a) return $885aad1b39333bac$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $885aad1b39333bac$var$Da) return 11;
        if (a === $885aad1b39333bac$var$Ga) return 14;
    }
    return 2;
}
function $885aad1b39333bac$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $885aad1b39333bac$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $885aad1b39333bac$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $885aad1b39333bac$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $885aad1b39333bac$var$ya:
            return $885aad1b39333bac$var$Ah(c.children, e, f, b);
        case $885aad1b39333bac$var$za:
            g = 8;
            e |= 8;
            break;
        case $885aad1b39333bac$var$Aa:
            return a = $885aad1b39333bac$var$Bg(12, c, b, e | 2), a.elementType = $885aad1b39333bac$var$Aa, a.lanes = f, a;
        case $885aad1b39333bac$var$Ea:
            return a = $885aad1b39333bac$var$Bg(13, c, b, e), a.elementType = $885aad1b39333bac$var$Ea, a.lanes = f, a;
        case $885aad1b39333bac$var$Fa:
            return a = $885aad1b39333bac$var$Bg(19, c, b, e), a.elementType = $885aad1b39333bac$var$Fa, a.lanes = f, a;
        case $885aad1b39333bac$var$Ia:
            return $885aad1b39333bac$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $885aad1b39333bac$var$Ba:
                    g = 10;
                    break a;
                case $885aad1b39333bac$var$Ca:
                    g = 9;
                    break a;
                case $885aad1b39333bac$var$Da:
                    g = 11;
                    break a;
                case $885aad1b39333bac$var$Ga:
                    g = 14;
                    break a;
                case $885aad1b39333bac$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($885aad1b39333bac$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $885aad1b39333bac$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $885aad1b39333bac$var$Ah(a, b, c, d) {
    a = $885aad1b39333bac$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $885aad1b39333bac$var$qj(a, b, c, d) {
    a = $885aad1b39333bac$var$Bg(22, a, d, b);
    a.elementType = $885aad1b39333bac$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $885aad1b39333bac$var$xh(a, b, c) {
    a = $885aad1b39333bac$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $885aad1b39333bac$var$zh(a, b, c) {
    b = $885aad1b39333bac$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $885aad1b39333bac$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $885aad1b39333bac$var$zc(0);
    this.expirationTimes = $885aad1b39333bac$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $885aad1b39333bac$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $885aad1b39333bac$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $885aad1b39333bac$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $885aad1b39333bac$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $885aad1b39333bac$var$ah(f);
    return a;
}
function $885aad1b39333bac$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $885aad1b39333bac$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $885aad1b39333bac$var$el(a) {
    if (!a) return $885aad1b39333bac$var$Vf;
    a = a._reactInternals;
    a: {
        if ($885aad1b39333bac$var$Vb(a) !== a || 1 !== a.tag) throw Error($885aad1b39333bac$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($885aad1b39333bac$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($885aad1b39333bac$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($885aad1b39333bac$var$Zf(c)) return $885aad1b39333bac$var$bg(a, c, b);
    }
    return b;
}
function $885aad1b39333bac$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $885aad1b39333bac$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $885aad1b39333bac$var$el(null);
    c = a.current;
    d = $885aad1b39333bac$var$L();
    e = $885aad1b39333bac$var$lh(c);
    f = $885aad1b39333bac$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $885aad1b39333bac$var$dh(c, f, e);
    a.current.lanes = e;
    $885aad1b39333bac$var$Ac(a, e, d);
    $885aad1b39333bac$var$Ek(a, d);
    return a;
}
function $885aad1b39333bac$var$gl(a, b, c, d) {
    var e = b.current, f = $885aad1b39333bac$var$L(), g = $885aad1b39333bac$var$lh(e);
    c = $885aad1b39333bac$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $885aad1b39333bac$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $885aad1b39333bac$var$dh(e, b, g);
    null !== a && ($885aad1b39333bac$var$mh(a, e, g, f), $885aad1b39333bac$var$eh(a, e, g));
    return g;
}
function $885aad1b39333bac$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $885aad1b39333bac$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $885aad1b39333bac$var$jl(a, b) {
    $885aad1b39333bac$var$il(a, b);
    (a = a.alternate) && $885aad1b39333bac$var$il(a, b);
}
function $885aad1b39333bac$var$kl() {
    return null;
}
var $885aad1b39333bac$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $885aad1b39333bac$var$ml(a) {
    this._internalRoot = a;
}
$885aad1b39333bac$var$nl.prototype.render = $885aad1b39333bac$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($885aad1b39333bac$var$p(409));
    $885aad1b39333bac$var$gl(a, b, null, null);
};
$885aad1b39333bac$var$nl.prototype.unmount = $885aad1b39333bac$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $885aad1b39333bac$var$Sk(function() {
            $885aad1b39333bac$var$gl(null, a, null, null);
        });
        b[$885aad1b39333bac$var$uf] = null;
    }
};
function $885aad1b39333bac$var$nl(a) {
    this._internalRoot = a;
}
$885aad1b39333bac$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $885aad1b39333bac$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $885aad1b39333bac$var$Qc.length && 0 !== b && b < $885aad1b39333bac$var$Qc[c].priority; c++);
        $885aad1b39333bac$var$Qc.splice(c, 0, a);
        0 === c && $885aad1b39333bac$var$Vc(a);
    }
};
function $885aad1b39333bac$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $885aad1b39333bac$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $885aad1b39333bac$var$ql() {}
function $885aad1b39333bac$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $885aad1b39333bac$var$hl(g);
                f.call(a);
            };
        }
        var g = $885aad1b39333bac$var$fl(b, d, a, 0, null, !1, !1, "", $885aad1b39333bac$var$ql);
        a._reactRootContainer = g;
        a[$885aad1b39333bac$var$uf] = g.current;
        $885aad1b39333bac$var$sf(8 === a.nodeType ? a.parentNode : a);
        $885aad1b39333bac$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $885aad1b39333bac$var$hl(k);
            h.call(a);
        };
    }
    var k = $885aad1b39333bac$var$cl(a, 0, !1, null, null, !1, !1, "", $885aad1b39333bac$var$ql);
    a._reactRootContainer = k;
    a[$885aad1b39333bac$var$uf] = k.current;
    $885aad1b39333bac$var$sf(8 === a.nodeType ? a.parentNode : a);
    $885aad1b39333bac$var$Sk(function() {
        $885aad1b39333bac$var$gl(b, k, c, d);
    });
    return k;
}
function $885aad1b39333bac$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $885aad1b39333bac$var$hl(g);
                h.call(a);
            };
        }
        $885aad1b39333bac$var$gl(b, g, a, e);
    } else g = $885aad1b39333bac$var$rl(c, b, a, e, d);
    return $885aad1b39333bac$var$hl(g);
}
$885aad1b39333bac$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $885aad1b39333bac$var$tc(b.pendingLanes);
                0 !== c && ($885aad1b39333bac$var$Cc(b, c | 1), $885aad1b39333bac$var$Ek(b, $885aad1b39333bac$var$B()), 0 === ($885aad1b39333bac$var$K & 6) && ($885aad1b39333bac$var$Hj = $885aad1b39333bac$var$B() + 500, $885aad1b39333bac$var$jg()));
            }
            break;
        case 13:
            $885aad1b39333bac$var$Sk(function() {
                var b = $885aad1b39333bac$var$Zg(a, 1);
                if (null !== b) {
                    var c = $885aad1b39333bac$var$L();
                    $885aad1b39333bac$var$mh(b, a, 1, c);
                }
            }), $885aad1b39333bac$var$jl(a, 1);
    }
};
$885aad1b39333bac$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $885aad1b39333bac$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $885aad1b39333bac$var$L();
            $885aad1b39333bac$var$mh(b, a, 134217728, c);
        }
        $885aad1b39333bac$var$jl(a, 134217728);
    }
};
$885aad1b39333bac$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $885aad1b39333bac$var$lh(a), c = $885aad1b39333bac$var$Zg(a, b);
        if (null !== c) {
            var d = $885aad1b39333bac$var$L();
            $885aad1b39333bac$var$mh(c, a, b, d);
        }
        $885aad1b39333bac$var$jl(a, b);
    }
};
$885aad1b39333bac$var$Hc = function() {
    return $885aad1b39333bac$var$C;
};
$885aad1b39333bac$var$Ic = function(a, b) {
    var c = $885aad1b39333bac$var$C;
    try {
        return $885aad1b39333bac$var$C = a, b();
    } finally{
        $885aad1b39333bac$var$C = c;
    }
};
$885aad1b39333bac$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $885aad1b39333bac$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $885aad1b39333bac$var$Db(d);
                        if (!e) throw Error($885aad1b39333bac$var$p(90));
                        $885aad1b39333bac$var$Wa(d);
                        $885aad1b39333bac$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $885aad1b39333bac$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $885aad1b39333bac$var$fb(a, !!c.multiple, b, !1);
    }
};
$885aad1b39333bac$var$Gb = $885aad1b39333bac$var$Rk;
$885aad1b39333bac$var$Hb = $885aad1b39333bac$var$Sk;
var $885aad1b39333bac$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $885aad1b39333bac$var$Cb,
        $885aad1b39333bac$var$ue,
        $885aad1b39333bac$var$Db,
        $885aad1b39333bac$var$Eb,
        $885aad1b39333bac$var$Fb,
        $885aad1b39333bac$var$Rk
    ]
}, $885aad1b39333bac$var$ul = {
    findFiberByHostInstance: $885aad1b39333bac$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $885aad1b39333bac$var$vl = {
    bundleType: $885aad1b39333bac$var$ul.bundleType,
    version: $885aad1b39333bac$var$ul.version,
    rendererPackageName: $885aad1b39333bac$var$ul.rendererPackageName,
    rendererConfig: $885aad1b39333bac$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $885aad1b39333bac$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $885aad1b39333bac$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $885aad1b39333bac$var$ul.findFiberByHostInstance || $885aad1b39333bac$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $885aad1b39333bac$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$885aad1b39333bac$var$wl.isDisabled && $885aad1b39333bac$var$wl.supportsFiber) try {
        $885aad1b39333bac$var$kc = $885aad1b39333bac$var$wl.inject($885aad1b39333bac$var$vl), $885aad1b39333bac$var$lc = $885aad1b39333bac$var$wl;
    } catch (a) {}
}
$885aad1b39333bac$export$ae55be85d98224ed = $885aad1b39333bac$var$tl;
$885aad1b39333bac$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$885aad1b39333bac$var$ol(b)) throw Error($885aad1b39333bac$var$p(200));
    return $885aad1b39333bac$var$dl(a, b, null, c);
};
$885aad1b39333bac$export$882461b6382ed46c = function(a, b) {
    if (!$885aad1b39333bac$var$ol(a)) throw Error($885aad1b39333bac$var$p(299));
    var c = !1, d = "", e = $885aad1b39333bac$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $885aad1b39333bac$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$885aad1b39333bac$var$uf] = b.current;
    $885aad1b39333bac$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $885aad1b39333bac$var$ml(b);
};
$885aad1b39333bac$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($885aad1b39333bac$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($885aad1b39333bac$var$p(268, a));
    }
    a = $885aad1b39333bac$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$885aad1b39333bac$export$cd75ccfd720a3cd4 = function(a) {
    return $885aad1b39333bac$var$Sk(a);
};
$885aad1b39333bac$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$885aad1b39333bac$var$pl(b)) throw Error($885aad1b39333bac$var$p(200));
    return $885aad1b39333bac$var$sl(null, a, b, !0, c);
};
$885aad1b39333bac$export$757ceba2d55c277e = function(a, b, c) {
    if (!$885aad1b39333bac$var$ol(a)) throw Error($885aad1b39333bac$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $885aad1b39333bac$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $885aad1b39333bac$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$885aad1b39333bac$var$uf] = b.current;
    $885aad1b39333bac$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $885aad1b39333bac$var$nl(b);
};
$885aad1b39333bac$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$885aad1b39333bac$var$pl(b)) throw Error($885aad1b39333bac$var$p(200));
    return $885aad1b39333bac$var$sl(null, a, b, !1, c);
};
$885aad1b39333bac$export$502457920280e6be = function(a) {
    if (!$885aad1b39333bac$var$pl(a)) throw Error($885aad1b39333bac$var$p(40));
    return a._reactRootContainer ? ($885aad1b39333bac$var$Sk(function() {
        $885aad1b39333bac$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$885aad1b39333bac$var$uf] = null;
        });
    }), !0) : !1;
};
$885aad1b39333bac$export$c78a37762a8d58e1 = $885aad1b39333bac$var$Rk;
$885aad1b39333bac$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$885aad1b39333bac$var$pl(c)) throw Error($885aad1b39333bac$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($885aad1b39333bac$var$p(38));
    return $885aad1b39333bac$var$sl(a, b, c, !1, d);
};
$885aad1b39333bac$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("8HCos", function(module, exports) {
'use strict';

module.exports = (parcelRequire("g44WV"));

});
parcelRegister("g44WV", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bb20dbec27c6b171$export$c4744153514ff05d, (v) => $bb20dbec27c6b171$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bb20dbec27c6b171$export$3e506c1ccc9cc1a7, (v) => $bb20dbec27c6b171$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bb20dbec27c6b171$export$e26fe2ed2fa76875, (v) => $bb20dbec27c6b171$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bb20dbec27c6b171$export$502329bbf4b505b1, (v) => $bb20dbec27c6b171$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bb20dbec27c6b171$export$6e3807111c4874c4, (v) => $bb20dbec27c6b171$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bb20dbec27c6b171$export$c27134553091fb3a, (v) => $bb20dbec27c6b171$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bb20dbec27c6b171$export$33ee1acdc04fd2a2, (v) => $bb20dbec27c6b171$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bb20dbec27c6b171$export$b00a404bbd5edef2, (v) => $bb20dbec27c6b171$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bb20dbec27c6b171$export$8352ce38b91d0c62, (v) => $bb20dbec27c6b171$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bb20dbec27c6b171$export$d66a1c1c77bd778b, (v) => $bb20dbec27c6b171$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bb20dbec27c6b171$export$d3dfb8e4810cb555, (v) => $bb20dbec27c6b171$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bb20dbec27c6b171$export$839f9183b0465a69, (v) => $bb20dbec27c6b171$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bb20dbec27c6b171$export$72fdf0e06517287b, (v) => $bb20dbec27c6b171$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bb20dbec27c6b171$export$4b844e58a3e414b4, (v) => $bb20dbec27c6b171$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bb20dbec27c6b171$export$816d2913ae6b83b1, (v) => $bb20dbec27c6b171$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bb20dbec27c6b171$export$61bcfe829111a1d0, (v) => $bb20dbec27c6b171$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bb20dbec27c6b171$export$7ee8c9beb337bc3f, (v) => $bb20dbec27c6b171$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bb20dbec27c6b171$export$b5836b71941fa3ed, (v) => $bb20dbec27c6b171$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bb20dbec27c6b171$export$cf845f2c119da08a, (v) => $bb20dbec27c6b171$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bb20dbec27c6b171$export$c4744153514ff05d;
var $bb20dbec27c6b171$export$3e506c1ccc9cc1a7;
var $bb20dbec27c6b171$export$e26fe2ed2fa76875;
var $bb20dbec27c6b171$export$502329bbf4b505b1;
var $bb20dbec27c6b171$export$6e3807111c4874c4;
var $bb20dbec27c6b171$export$c27134553091fb3a;
var $bb20dbec27c6b171$export$33ee1acdc04fd2a2;
var $bb20dbec27c6b171$export$b00a404bbd5edef2;
var $bb20dbec27c6b171$export$8352ce38b91d0c62;
var $bb20dbec27c6b171$export$d66a1c1c77bd778b;
var $bb20dbec27c6b171$export$d3dfb8e4810cb555;
var $bb20dbec27c6b171$export$839f9183b0465a69;
var $bb20dbec27c6b171$export$72fdf0e06517287b;
var $bb20dbec27c6b171$export$4b844e58a3e414b4;
var $bb20dbec27c6b171$export$816d2913ae6b83b1;
var $bb20dbec27c6b171$export$61bcfe829111a1d0;
var $bb20dbec27c6b171$export$7ee8c9beb337bc3f;
var $bb20dbec27c6b171$export$b5836b71941fa3ed;
var $bb20dbec27c6b171$export$cf845f2c119da08a;
'use strict';
function $bb20dbec27c6b171$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bb20dbec27c6b171$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bb20dbec27c6b171$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bb20dbec27c6b171$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bb20dbec27c6b171$var$g(C, c)) n < e && 0 > $bb20dbec27c6b171$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bb20dbec27c6b171$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bb20dbec27c6b171$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bb20dbec27c6b171$var$l = performance;
    $bb20dbec27c6b171$export$c4744153514ff05d = function() {
        return $bb20dbec27c6b171$var$l.now();
    };
} else {
    var $bb20dbec27c6b171$var$p = Date, $bb20dbec27c6b171$var$q = $bb20dbec27c6b171$var$p.now();
    $bb20dbec27c6b171$export$c4744153514ff05d = function() {
        return $bb20dbec27c6b171$var$p.now() - $bb20dbec27c6b171$var$q;
    };
}
var $bb20dbec27c6b171$var$r = [], $bb20dbec27c6b171$var$t = [], $bb20dbec27c6b171$var$u = 1, $bb20dbec27c6b171$var$v = null, $bb20dbec27c6b171$var$y = 3, $bb20dbec27c6b171$var$z = !1, $bb20dbec27c6b171$var$A = !1, $bb20dbec27c6b171$var$B = !1, $bb20dbec27c6b171$var$D = "function" === typeof setTimeout ? setTimeout : null, $bb20dbec27c6b171$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bb20dbec27c6b171$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bb20dbec27c6b171$var$G(a) {
    for(var b = $bb20dbec27c6b171$var$h($bb20dbec27c6b171$var$t); null !== b;){
        if (null === b.callback) $bb20dbec27c6b171$var$k($bb20dbec27c6b171$var$t);
        else if (b.startTime <= a) $bb20dbec27c6b171$var$k($bb20dbec27c6b171$var$t), b.sortIndex = b.expirationTime, $bb20dbec27c6b171$var$f($bb20dbec27c6b171$var$r, b);
        else break;
        b = $bb20dbec27c6b171$var$h($bb20dbec27c6b171$var$t);
    }
}
function $bb20dbec27c6b171$var$H(a) {
    $bb20dbec27c6b171$var$B = !1;
    $bb20dbec27c6b171$var$G(a);
    if (!$bb20dbec27c6b171$var$A) {
        if (null !== $bb20dbec27c6b171$var$h($bb20dbec27c6b171$var$r)) $bb20dbec27c6b171$var$A = !0, $bb20dbec27c6b171$var$I($bb20dbec27c6b171$var$J);
        else {
            var b = $bb20dbec27c6b171$var$h($bb20dbec27c6b171$var$t);
            null !== b && $bb20dbec27c6b171$var$K($bb20dbec27c6b171$var$H, b.startTime - a);
        }
    }
}
function $bb20dbec27c6b171$var$J(a, b) {
    $bb20dbec27c6b171$var$A = !1;
    $bb20dbec27c6b171$var$B && ($bb20dbec27c6b171$var$B = !1, $bb20dbec27c6b171$var$E($bb20dbec27c6b171$var$L), $bb20dbec27c6b171$var$L = -1);
    $bb20dbec27c6b171$var$z = !0;
    var c = $bb20dbec27c6b171$var$y;
    try {
        $bb20dbec27c6b171$var$G(b);
        for($bb20dbec27c6b171$var$v = $bb20dbec27c6b171$var$h($bb20dbec27c6b171$var$r); null !== $bb20dbec27c6b171$var$v && (!($bb20dbec27c6b171$var$v.expirationTime > b) || a && !$bb20dbec27c6b171$var$M());){
            var d = $bb20dbec27c6b171$var$v.callback;
            if ("function" === typeof d) {
                $bb20dbec27c6b171$var$v.callback = null;
                $bb20dbec27c6b171$var$y = $bb20dbec27c6b171$var$v.priorityLevel;
                var e = d($bb20dbec27c6b171$var$v.expirationTime <= b);
                b = $bb20dbec27c6b171$export$c4744153514ff05d();
                "function" === typeof e ? $bb20dbec27c6b171$var$v.callback = e : $bb20dbec27c6b171$var$v === $bb20dbec27c6b171$var$h($bb20dbec27c6b171$var$r) && $bb20dbec27c6b171$var$k($bb20dbec27c6b171$var$r);
                $bb20dbec27c6b171$var$G(b);
            } else $bb20dbec27c6b171$var$k($bb20dbec27c6b171$var$r);
            $bb20dbec27c6b171$var$v = $bb20dbec27c6b171$var$h($bb20dbec27c6b171$var$r);
        }
        if (null !== $bb20dbec27c6b171$var$v) var w = !0;
        else {
            var m = $bb20dbec27c6b171$var$h($bb20dbec27c6b171$var$t);
            null !== m && $bb20dbec27c6b171$var$K($bb20dbec27c6b171$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bb20dbec27c6b171$var$v = null, $bb20dbec27c6b171$var$y = c, $bb20dbec27c6b171$var$z = !1;
    }
}
var $bb20dbec27c6b171$var$N = !1, $bb20dbec27c6b171$var$O = null, $bb20dbec27c6b171$var$L = -1, $bb20dbec27c6b171$var$P = 5, $bb20dbec27c6b171$var$Q = -1;
function $bb20dbec27c6b171$var$M() {
    return $bb20dbec27c6b171$export$c4744153514ff05d() - $bb20dbec27c6b171$var$Q < $bb20dbec27c6b171$var$P ? !1 : !0;
}
function $bb20dbec27c6b171$var$R() {
    if (null !== $bb20dbec27c6b171$var$O) {
        var a = $bb20dbec27c6b171$export$c4744153514ff05d();
        $bb20dbec27c6b171$var$Q = a;
        var b = !0;
        try {
            b = $bb20dbec27c6b171$var$O(!0, a);
        } finally{
            b ? $bb20dbec27c6b171$var$S() : ($bb20dbec27c6b171$var$N = !1, $bb20dbec27c6b171$var$O = null);
        }
    } else $bb20dbec27c6b171$var$N = !1;
}
var $bb20dbec27c6b171$var$S;
if ("function" === typeof $bb20dbec27c6b171$var$F) $bb20dbec27c6b171$var$S = function() {
    $bb20dbec27c6b171$var$F($bb20dbec27c6b171$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bb20dbec27c6b171$var$T = new MessageChannel, $bb20dbec27c6b171$var$U = $bb20dbec27c6b171$var$T.port2;
    $bb20dbec27c6b171$var$T.port1.onmessage = $bb20dbec27c6b171$var$R;
    $bb20dbec27c6b171$var$S = function() {
        $bb20dbec27c6b171$var$U.postMessage(null);
    };
} else $bb20dbec27c6b171$var$S = function() {
    $bb20dbec27c6b171$var$D($bb20dbec27c6b171$var$R, 0);
};
function $bb20dbec27c6b171$var$I(a) {
    $bb20dbec27c6b171$var$O = a;
    $bb20dbec27c6b171$var$N || ($bb20dbec27c6b171$var$N = !0, $bb20dbec27c6b171$var$S());
}
function $bb20dbec27c6b171$var$K(a, b) {
    $bb20dbec27c6b171$var$L = $bb20dbec27c6b171$var$D(function() {
        a($bb20dbec27c6b171$export$c4744153514ff05d());
    }, b);
}
$bb20dbec27c6b171$export$3e506c1ccc9cc1a7 = 5;
$bb20dbec27c6b171$export$e26fe2ed2fa76875 = 1;
$bb20dbec27c6b171$export$502329bbf4b505b1 = 4;
$bb20dbec27c6b171$export$6e3807111c4874c4 = 3;
$bb20dbec27c6b171$export$c27134553091fb3a = null;
$bb20dbec27c6b171$export$33ee1acdc04fd2a2 = 2;
$bb20dbec27c6b171$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bb20dbec27c6b171$export$8352ce38b91d0c62 = function() {
    $bb20dbec27c6b171$var$A || $bb20dbec27c6b171$var$z || ($bb20dbec27c6b171$var$A = !0, $bb20dbec27c6b171$var$I($bb20dbec27c6b171$var$J));
};
$bb20dbec27c6b171$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bb20dbec27c6b171$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bb20dbec27c6b171$export$d3dfb8e4810cb555 = function() {
    return $bb20dbec27c6b171$var$y;
};
$bb20dbec27c6b171$export$839f9183b0465a69 = function() {
    return $bb20dbec27c6b171$var$h($bb20dbec27c6b171$var$r);
};
$bb20dbec27c6b171$export$72fdf0e06517287b = function(a) {
    switch($bb20dbec27c6b171$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bb20dbec27c6b171$var$y;
    }
    var c = $bb20dbec27c6b171$var$y;
    $bb20dbec27c6b171$var$y = b;
    try {
        return a();
    } finally{
        $bb20dbec27c6b171$var$y = c;
    }
};
$bb20dbec27c6b171$export$4b844e58a3e414b4 = function() {};
$bb20dbec27c6b171$export$816d2913ae6b83b1 = function() {};
$bb20dbec27c6b171$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bb20dbec27c6b171$var$y;
    $bb20dbec27c6b171$var$y = a;
    try {
        return b();
    } finally{
        $bb20dbec27c6b171$var$y = c;
    }
};
$bb20dbec27c6b171$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bb20dbec27c6b171$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bb20dbec27c6b171$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bb20dbec27c6b171$var$f($bb20dbec27c6b171$var$t, a), null === $bb20dbec27c6b171$var$h($bb20dbec27c6b171$var$r) && a === $bb20dbec27c6b171$var$h($bb20dbec27c6b171$var$t) && ($bb20dbec27c6b171$var$B ? ($bb20dbec27c6b171$var$E($bb20dbec27c6b171$var$L), $bb20dbec27c6b171$var$L = -1) : $bb20dbec27c6b171$var$B = !0, $bb20dbec27c6b171$var$K($bb20dbec27c6b171$var$H, c - d))) : (a.sortIndex = e, $bb20dbec27c6b171$var$f($bb20dbec27c6b171$var$r, a), $bb20dbec27c6b171$var$A || $bb20dbec27c6b171$var$z || ($bb20dbec27c6b171$var$A = !0, $bb20dbec27c6b171$var$I($bb20dbec27c6b171$var$J)));
    return a;
};
$bb20dbec27c6b171$export$b5836b71941fa3ed = $bb20dbec27c6b171$var$M;
$bb20dbec27c6b171$export$cf845f2c119da08a = function(a) {
    var b = $bb20dbec27c6b171$var$y;
    return function() {
        var c = $bb20dbec27c6b171$var$y;
        $bb20dbec27c6b171$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bb20dbec27c6b171$var$y = c;
        }
    };
};

});



parcelRegister("7b3hW", function(module, exports) {

$parcel$export(module.exports, "CookieStorage", () => CookieStorage);
$parcel$export(module.exports, "decodeCookieValue", () => decodeCookieValue);
$parcel$export(module.exports, "isDomainEqual", () => isDomainEqual);

var $bunH6 = parcelRequire("bunH6");

var $c4xZ2 = parcelRequire("c4xZ2");
/* istanbul ignore next */ var getLocks = function() {
    var _a;
    var globalScope = (0, $c4xZ2.getGlobalScope)();
    return (_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.navigator) === null || _a === void 0 ? void 0 : _a.locks;
};
var CookieStorage = /** @class */ function() {
    function CookieStorage(options, config) {
        if (config === void 0) config = {};
        this.options = (0, $bunH6.__assign)({}, options);
        this.config = config;
    }
    CookieStorage.prototype.isEnabled = function() {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var testKey, testCookieOptions, testStorage, testValue;
            var _this = this;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        testKey = 'AMP_TEST';
                        testCookieOptions = (0, $bunH6.__assign)({}, this.options);
                        testStorage = new CookieStorage(testCookieOptions);
                        testValue = String(Date.now());
                        return [
                            4 /*yield*/ ,
                            testStorage.transaction(testKey, function(storage) {
                                var _a, _b;
                                try {
                                    storage.set(testValue);
                                    var value = storage.get();
                                    var result = value === testValue;
                                    /* istanbul ignore next */ if (!result && _this.config.diagnosticsClient) (_a = _this.config.diagnosticsClient) === null || _a === void 0 || _a.recordEvent('cookies.isEnabled.failure', {
                                        reason: 'Test Value mismatch',
                                        testKey: testKey,
                                        testValue: testValue,
                                        sync: true
                                    });
                                    return result;
                                } catch (e) {
                                    /* istanbul ignore next */ if (_this.config.diagnosticsClient) {
                                        var errMessage = e instanceof Error ? e.message : String(e);
                                        (_b = _this.config.diagnosticsClient) === null || _b === void 0 || _b.recordEvent('cookies.isEnabled.failure', {
                                            reason: 'Cookie getter/setter failed',
                                            testKey: testKey,
                                            testValue: testValue,
                                            error: errMessage,
                                            sync: true
                                        });
                                    }
                                    return false;
                                } finally{
                                    // clean-up the AMP_TEST cookie behind us
                                    storage.set(null);
                                }
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    CookieStorage.prototype.get = function(key) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var value;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getRaw(key)
                        ];
                    case 1:
                        value = _a.sent();
                        return [
                            2 /*return*/ ,
                            this.decodeCookieValue(key, value)
                        ];
                }
            });
        });
    };
    CookieStorage.prototype.decodeCookieValue = function(key, value) {
        if (!value) return undefined;
        try {
            var decodedValue = decodeCookieValue(value);
            if (decodedValue === undefined) {
                console.error("Amplitude Logger [Error]: Failed to decode cookie value for key: ".concat(key, ", value: ").concat(value));
                return undefined;
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return JSON.parse(decodedValue);
        } catch (_a) {
            console.error("Amplitude Logger [Error]: Failed to parse cookie value for key: ".concat(key, ", value: ").concat(value));
            return undefined;
        }
    };
    CookieStorage.prototype.getSync = function(key) {
        var value = this.getRawSync(key);
        return this.decodeCookieValue(key, value);
    };
    CookieStorage.prototype.getRaw = function(key) {
        var _a, _b;
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var globalScope, globalScopeWithCookiesStore, cookieStore, cookies, cookies_1, cookies_1_1, cookie, ignoreError_1;
            var e_1, _c;
            return (0, $bunH6.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        globalScope = (0, $c4xZ2.getGlobalScope)();
                        globalScopeWithCookiesStore = globalScope;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        cookieStore = globalScopeWithCookiesStore === null || globalScopeWithCookiesStore === void 0 ? void 0 : globalScopeWithCookiesStore.cookieStore;
                        if (!cookieStore) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            cookieStore.getAll(key)
                        ];
                    case 2:
                        cookies = _d.sent();
                        if (cookies) {
                            /* istanbul ignore if */ if (cookies.length > 1) {
                                (_a = this.config.diagnosticsClient) === null || _a === void 0 || _a.recordEvent('cookies.duplicate', {
                                    cookies: cookies.map(function(cookie) {
                                        return cookie.domain;
                                    })
                                });
                                (_b = this.config.diagnosticsClient) === null || _b === void 0 || _b.increment('cookies.duplicate.occurrence.cookieStore');
                            }
                            try {
                                for(cookies_1 = (0, $bunH6.__values)(cookies), cookies_1_1 = cookies_1.next(); !cookies_1_1.done; cookies_1_1 = cookies_1.next()){
                                    cookie = cookies_1_1.value;
                                    if (isDomainEqual(cookie.domain, this.options.domain)) return [
                                        2 /*return*/ ,
                                        cookie.value
                                    ];
                                }
                            } catch (e_1_1) {
                                e_1 = {
                                    error: e_1_1
                                };
                            } finally{
                                try {
                                    if (cookies_1_1 && !cookies_1_1.done && (_c = cookies_1.return)) _c.call(cookies_1);
                                } finally{
                                    if (e_1) throw e_1.error;
                                }
                            }
                        }
                        _d.label = 3;
                    case 3:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        ignoreError_1 = _d.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            this.getRawSync(key)
                        ];
                }
            });
        });
    };
    CookieStorage.prototype.getRawSync = function(key) {
        var _this = this;
        var _a, _b;
        var globalScope = (0, $c4xZ2.getGlobalScope)();
        var cookies = ((_b = (_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.document) === null || _a === void 0 ? void 0 : _a.cookie.split('; ')) !== null && _b !== void 0 ? _b : []).filter(function(c) {
            return c.indexOf(key + '=') === 0;
        });
        var match = undefined;
        // if matcher function is provided, use it to de-duplicate when there's more than one cookie
        /* istanbul ignore if */ var duplicateResolverFn = this.config.duplicateResolverFn;
        if (typeof duplicateResolverFn === 'function' && cookies.length > 1) match = cookies.find(function(c) {
            var _a;
            try {
                var res = duplicateResolverFn(c.substring(key.length + 1));
                if (!res) (_a = _this.config.diagnosticsClient) === null || _a === void 0 || _a.increment('cookies.duplicate.occurrence.document.cookie');
                return res;
            } catch (ignoreError) {
                /* istanbul ignore next */ return false;
            }
        });
        // if match was not found, just get the first one that matches the key
        if (!match) match = cookies[0];
        if (!match) return undefined;
        return match.substring(key.length + 1);
    };
    CookieStorage.prototype.set = function(key, value) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                this.setSync(key, value);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    CookieStorage.prototype.setSync = function(key, value) {
        var _a;
        try {
            var expirationDays = (_a = this.options.expirationDays) !== null && _a !== void 0 ? _a : 0;
            var expires = value !== null ? expirationDays : -1;
            var expireDate = undefined;
            if (expires) {
                var date = new Date();
                date.setTime(date.getTime() + expires * 86400000);
                expireDate = date;
            }
            var str = "".concat(key, "=").concat(btoa(encodeURIComponent(JSON.stringify(value))));
            if (expireDate) str += "; expires=".concat(expireDate.toUTCString());
            str += '; path=/';
            if (this.options.domain) str += "; domain=".concat(this.options.domain);
            if (this.options.secure) str += '; Secure';
            if (this.options.sameSite) str += "; SameSite=".concat(this.options.sameSite);
            var globalScope = (0, $c4xZ2.getGlobalScope)();
            if (globalScope === null || globalScope === void 0 ? void 0 : globalScope.document) globalScope.document.cookie = str;
        } catch (error) {
            var errorMessage = error instanceof Error ? error.message : String(error);
            console.error("Amplitude Logger [Error]: Failed to set cookie for key: ".concat(key, ". Error: ").concat(errorMessage));
        }
    };
    CookieStorage.prototype.remove = function(key) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.set(key, null)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CookieStorage.prototype.reset = function() {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    CookieStorage.isDomainWritable = function(domain) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var options, storageKey, storage, res, error_1;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (CookieStorage.cachedTlds[domain]) return [
                            2 /*return*/ ,
                            true
                        ];
                        options = {
                            domain: '.' + domain
                        };
                        storageKey = 'AMP_TLDTEST';
                        storage = new CookieStorage(options);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            storage.transaction(storageKey, function(storageSync) {
                                if (CookieStorage.cachedTlds[domain]) return true;
                                try {
                                    storageSync.set(1);
                                    var result = !!storageSync.get();
                                    if (result) CookieStorage.cachedTlds[domain] = true;
                                    return result;
                                } finally{
                                    storageSync.set(null);
                                }
                            })
                        ];
                    case 2:
                        res = _a.sent();
                        return [
                            2 /*return*/ ,
                            !!res
                        ];
                    case 3:
                        error_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CookieStorage.prototype.transaction = function(key, callback) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var locks, callbackWrapper, error_2;
            var _this = this;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        locks = getLocks();
                        callbackWrapper = function() {
                            // construct a sync storage object that is scoped to
                            // Cookie with name <key>
                            var storageSync = {
                                get: function() {
                                    return _this.getSync(key);
                                },
                                set: function(value) {
                                    return _this.setSync(key, value);
                                }
                            };
                            return callback(storageSync);
                        };
                        // if 'locks' is missing, it is a legacy browser, just call the callback directly
                        // and settle for a transaction that isn't isolated across tabs
                        if (!locks) return [
                            2 /*return*/ ,
                            callbackWrapper()
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            locks.request("com.amplitude:cookie-lock:".concat(key), callbackWrapper)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 3:
                        error_2 = _a.sent();
                        return [
                            2 /*return*/ ,
                            callbackWrapper()
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CookieStorage.cachedTlds = {};
    return CookieStorage;
}();
var decodeCookiesAsDefault = function(value) {
    try {
        return decodeURIComponent(atob(value));
    } catch (_a) {
        return undefined;
    }
};
var decodeCookiesWithDoubleUrlEncoding = function(value) {
    // Modern Ruby (v7+) automatically encodes cookies with URL encoding by
    // https://api.rubyonrails.org/classes/ActionDispatch/Cookies.html
    try {
        return decodeURIComponent(atob(decodeURIComponent(value)));
    } catch (_a) {
        return undefined;
    }
};
var decodeCookieValue = function(value) {
    var _a;
    return (_a = decodeCookiesAsDefault(value)) !== null && _a !== void 0 ? _a : decodeCookiesWithDoubleUrlEncoding(value);
};
var isDomainEqual = function(domain1, domain2) {
    if (domain1 === '' && domain2 === '') return true;
    if (!domain1 || !domain2) return false;
    var normalized1 = domain1.startsWith('.') ? domain1.substring(1) : domain1;
    var normalized2 = domain2.startsWith('.') ? domain2.substring(1) : domain2;
    return normalized1.toLowerCase() === normalized2.toLowerCase();
};

});
parcelRegister("bunH6", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $85d4e03598d2c994$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $85d4e03598d2c994$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $85d4e03598d2c994$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $85d4e03598d2c994$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $85d4e03598d2c994$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $85d4e03598d2c994$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $85d4e03598d2c994$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $85d4e03598d2c994$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $85d4e03598d2c994$var$extendStatics = function(d, b) {
    $85d4e03598d2c994$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $85d4e03598d2c994$var$extendStatics(d, b);
};
function $85d4e03598d2c994$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $85d4e03598d2c994$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $85d4e03598d2c994$export$18ce0697a983be9b = function() {
    $85d4e03598d2c994$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $85d4e03598d2c994$export$18ce0697a983be9b.apply(this, arguments);
};
function $85d4e03598d2c994$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $85d4e03598d2c994$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $85d4e03598d2c994$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $85d4e03598d2c994$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $85d4e03598d2c994$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $85d4e03598d2c994$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $85d4e03598d2c994$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $85d4e03598d2c994$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $85d4e03598d2c994$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $85d4e03598d2c994$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $85d4e03598d2c994$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $85d4e03598d2c994$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $85d4e03598d2c994$export$45d3717a4c69092e(o, m, p);
}
function $85d4e03598d2c994$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $85d4e03598d2c994$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $85d4e03598d2c994$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($85d4e03598d2c994$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $85d4e03598d2c994$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $85d4e03598d2c994$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $85d4e03598d2c994$export$10c90e4f7922046c(v) {
    return this instanceof $85d4e03598d2c994$export$10c90e4f7922046c ? (this.v = v, this) : new $85d4e03598d2c994$export$10c90e4f7922046c(v);
}
function $85d4e03598d2c994$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $85d4e03598d2c994$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $85d4e03598d2c994$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $85d4e03598d2c994$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $85d4e03598d2c994$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $85d4e03598d2c994$export$19a8beecd37a4c45 === "function" ? $85d4e03598d2c994$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $85d4e03598d2c994$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $85d4e03598d2c994$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $85d4e03598d2c994$var$ownKeys = function(o) {
    $85d4e03598d2c994$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $85d4e03598d2c994$var$ownKeys(o);
};
function $85d4e03598d2c994$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $85d4e03598d2c994$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $85d4e03598d2c994$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $85d4e03598d2c994$var$__setModuleDefault(result, mod);
    return result;
}
function $85d4e03598d2c994$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $85d4e03598d2c994$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $85d4e03598d2c994$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $85d4e03598d2c994$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $85d4e03598d2c994$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $85d4e03598d2c994$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $85d4e03598d2c994$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $85d4e03598d2c994$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $85d4e03598d2c994$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $85d4e03598d2c994$export$2e2bcd8739ae039 = {
    __extends: $85d4e03598d2c994$export$a8ba968b8961cb8a,
    __assign: $85d4e03598d2c994$export$18ce0697a983be9b,
    __rest: $85d4e03598d2c994$export$3c9a16f847548506,
    __decorate: $85d4e03598d2c994$export$29e00dfd3077644b,
    __param: $85d4e03598d2c994$export$d5ad3fd78186038f,
    __esDecorate: $85d4e03598d2c994$export$3a84e1ae4e97e9b0,
    __runInitializers: $85d4e03598d2c994$export$d831c04e792af3d,
    __propKey: $85d4e03598d2c994$export$6a2a36740a146cb8,
    __setFunctionName: $85d4e03598d2c994$export$d1a06452d3489bc7,
    __metadata: $85d4e03598d2c994$export$f1db080c865becb9,
    __awaiter: $85d4e03598d2c994$export$1050f835b63b671e,
    __generator: $85d4e03598d2c994$export$67ebef60e6f28a6,
    __createBinding: $85d4e03598d2c994$export$45d3717a4c69092e,
    __exportStar: $85d4e03598d2c994$export$f33643c0debef087,
    __values: $85d4e03598d2c994$export$19a8beecd37a4c45,
    __read: $85d4e03598d2c994$export$8d051b38c9118094,
    __spread: $85d4e03598d2c994$export$afc72e2116322959,
    __spreadArrays: $85d4e03598d2c994$export$6388937ca91ccae8,
    __spreadArray: $85d4e03598d2c994$export$1216008129fb82ed,
    __await: $85d4e03598d2c994$export$10c90e4f7922046c,
    __asyncGenerator: $85d4e03598d2c994$export$e427f37a30a4de9b,
    __asyncDelegator: $85d4e03598d2c994$export$bbd80228419bb833,
    __asyncValues: $85d4e03598d2c994$export$e3b29a3d6162315f,
    __makeTemplateObject: $85d4e03598d2c994$export$4fb47efe1390b86f,
    __importStar: $85d4e03598d2c994$export$c21735bcef00d192,
    __importDefault: $85d4e03598d2c994$export$da59b14a69baef04,
    __classPrivateFieldGet: $85d4e03598d2c994$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $85d4e03598d2c994$export$d40a35129aaff81f,
    __classPrivateFieldIn: $85d4e03598d2c994$export$81fdc39f203e4e04,
    __addDisposableResource: $85d4e03598d2c994$export$88ac25d8e944e405,
    __disposeResources: $85d4e03598d2c994$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $85d4e03598d2c994$export$889dfb5d17574b0b
};

});

parcelRegister("c4xZ2", function(module, exports) {

$parcel$export(module.exports, "getGlobalScope", () => $8ca0382ef0f48453$export$aa55d5ab8e05984f);
/* eslint-disable no-restricted-globals */ /* Only file allowed to access to globalThis, window, self */ var $8ca0382ef0f48453$export$aa55d5ab8e05984f = function() {
    // This should only be used for integrations with Amplitude that are not running in a browser environment
    //   We need to specify the name of the global variable as a string to prevent it from being minified
    var ampIntegrationContextName = 'ampIntegrationContext';
    if (typeof globalThis !== 'undefined' && typeof globalThis[ampIntegrationContextName] !== 'undefined') return globalThis[ampIntegrationContextName];
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof window !== 'undefined') return window;
    if (typeof self !== 'undefined') return self;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return undefined;
};

});


parcelRegister("hLn5L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
// === Symbol Support ===
const $cee8bd0616107ef4$var$hasSymbol = (name)=>Boolean(Symbol[name]);
const $cee8bd0616107ef4$var$getSymbol = (name)=>$cee8bd0616107ef4$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
const $cee8bd0616107ef4$var$SymbolIterator = $cee8bd0616107ef4$var$getSymbol('iterator');
const $cee8bd0616107ef4$var$SymbolObservable = $cee8bd0616107ef4$var$getSymbol('observable');
const $cee8bd0616107ef4$var$SymbolSpecies = $cee8bd0616107ef4$var$getSymbol('species'); // === Abstract Operations ===
function $cee8bd0616107ef4$var$getMethod(obj, key) {
    let value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $cee8bd0616107ef4$var$getSpecies(obj) {
    let ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$cee8bd0616107ef4$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $cee8bd0616107ef4$var$Observable;
}
function $cee8bd0616107ef4$var$isObservable(x) {
    return x instanceof $cee8bd0616107ef4$var$Observable; // SPEC: Brand check
}
function $cee8bd0616107ef4$var$hostReportError(e) {
    if ($cee8bd0616107ef4$var$hostReportError.log) $cee8bd0616107ef4$var$hostReportError.log(e);
    else setTimeout(()=>{
        throw e;
    });
}
function $cee8bd0616107ef4$var$enqueue(fn) {
    Promise.resolve().then(()=>{
        try {
            fn();
        } catch (e) {
            $cee8bd0616107ef4$var$hostReportError(e);
        }
    });
}
function $cee8bd0616107ef4$var$cleanupSubscription(subscription) {
    let cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            let unsubscribe = $cee8bd0616107ef4$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $cee8bd0616107ef4$var$hostReportError(e);
    }
}
function $cee8bd0616107ef4$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $cee8bd0616107ef4$var$flushSubscription(subscription) {
    let queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(let i = 0; i < queue.length; ++i){
        $cee8bd0616107ef4$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $cee8bd0616107ef4$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    let observer = subscription._observer;
    try {
        let m = $cee8bd0616107ef4$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $cee8bd0616107ef4$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $cee8bd0616107ef4$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $cee8bd0616107ef4$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $cee8bd0616107ef4$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $cee8bd0616107ef4$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $cee8bd0616107ef4$var$enqueue(()=>$cee8bd0616107ef4$var$flushSubscription(subscription));
        return;
    }
    $cee8bd0616107ef4$var$notifySubscription(subscription, type, value);
}
class $cee8bd0616107ef4$var$Subscription {
    constructor(observer, subscriber){
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        let self = this;
        let subscriptionObserver = {
            get closed () {
                return self._state === 'closed';
            },
            next (value) {
                $cee8bd0616107ef4$var$onNotify(self, 'next', value);
            },
            error (value) {
                $cee8bd0616107ef4$var$onNotify(self, 'error', value);
            },
            complete () {
                $cee8bd0616107ef4$var$onNotify(self, 'complete');
            }
        };
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    get closed() {
        return this._state === 'closed';
    }
    unsubscribe() {
        if (this._state !== 'closed') {
            $cee8bd0616107ef4$var$closeSubscription(this);
            $cee8bd0616107ef4$var$cleanupSubscription(this);
        }
    }
}
class $cee8bd0616107ef4$var$Observable {
    constructor(subscriber){
        if (!(this instanceof $cee8bd0616107ef4$var$Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) observer = {
            next: observer,
            error: arguments[1],
            complete: arguments[2]
        };
        return new $cee8bd0616107ef4$var$Subscription(observer, this._subscriber);
    }
    forEach(fn) {
        return new Promise((resolve, reject)=>{
            if (typeof fn !== 'function') {
                reject(new TypeError(fn + ' is not a function'));
                return;
            }
            function done() {
                subscription.unsubscribe();
                resolve();
            }
            let subscription = this.subscribe({
                next (value) {
                    try {
                        fn(value, done);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    }
    map(fn) {
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        let C = $cee8bd0616107ef4$var$getSpecies(this);
        return new C((observer)=>this.subscribe({
                next (value) {
                    try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error (e) {
                    observer.error(e);
                },
                complete () {
                    observer.complete();
                }
            }));
    }
    filter(fn) {
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        let C = $cee8bd0616107ef4$var$getSpecies(this);
        return new C((observer)=>this.subscribe({
                next (value) {
                    try {
                        if (!fn(value)) return;
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error (e) {
                    observer.error(e);
                },
                complete () {
                    observer.complete();
                }
            }));
    }
    reduce(fn) {
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        let C = $cee8bd0616107ef4$var$getSpecies(this);
        let hasSeed = arguments.length > 1;
        let hasValue = false;
        let seed = arguments[1];
        let acc = seed;
        return new C((observer)=>this.subscribe({
                next (value) {
                    let first = !hasValue;
                    hasValue = true;
                    if (!first || hasSeed) try {
                        acc = fn(acc, value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    else acc = value;
                },
                error (e) {
                    observer.error(e);
                },
                complete () {
                    if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                    observer.next(acc);
                    observer.complete();
                }
            }));
    }
    async all() {
        let values = [];
        await this.forEach((value)=>values.push(value));
        return values;
    }
    concat(...sources) {
        let C = $cee8bd0616107ef4$var$getSpecies(this);
        return new C((observer)=>{
            let subscription;
            let index = 0;
            function startNext(next) {
                subscription = next.subscribe({
                    next (v) {
                        observer.next(v);
                    },
                    error (e) {
                        observer.error(e);
                    },
                    complete () {
                        if (index === sources.length) {
                            subscription = undefined;
                            observer.complete();
                        } else startNext(C.from(sources[index++]));
                    }
                });
            }
            startNext(this);
            return ()=>{
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        });
    }
    flatMap(fn) {
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        let C = $cee8bd0616107ef4$var$getSpecies(this);
        return new C((observer)=>{
            let subscriptions = [];
            let outer = this.subscribe({
                next (value) {
                    if (fn) try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    let inner = C.from(value).subscribe({
                        next (value) {
                            observer.next(value);
                        },
                        error (e) {
                            observer.error(e);
                        },
                        complete () {
                            let i = subscriptions.indexOf(inner);
                            if (i >= 0) subscriptions.splice(i, 1);
                            completeIfDone();
                        }
                    });
                    subscriptions.push(inner);
                },
                error (e) {
                    observer.error(e);
                },
                complete () {
                    completeIfDone();
                }
            });
            function completeIfDone() {
                if (outer.closed && subscriptions.length === 0) observer.complete();
            }
            return ()=>{
                subscriptions.forEach((s)=>s.unsubscribe());
                outer.unsubscribe();
            };
        });
    }
    [$cee8bd0616107ef4$var$SymbolObservable]() {
        return this;
    }
    static from(x) {
        let C = typeof this === 'function' ? this : $cee8bd0616107ef4$var$Observable;
        if (x == null) throw new TypeError(x + ' is not an object');
        let method = $cee8bd0616107ef4$var$getMethod(x, $cee8bd0616107ef4$var$SymbolObservable);
        if (method) {
            let observable = method.call(x);
            if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
            if ($cee8bd0616107ef4$var$isObservable(observable) && observable.constructor === C) return observable;
            return new C((observer)=>observable.subscribe(observer));
        }
        if ($cee8bd0616107ef4$var$hasSymbol('iterator')) {
            method = $cee8bd0616107ef4$var$getMethod(x, $cee8bd0616107ef4$var$SymbolIterator);
            if (method) return new C((observer)=>{
                $cee8bd0616107ef4$var$enqueue(()=>{
                    if (observer.closed) return;
                    for (let item of method.call(x)){
                        observer.next(item);
                        if (observer.closed) return;
                    }
                    observer.complete();
                });
            });
        }
        if (Array.isArray(x)) return new C((observer)=>{
            $cee8bd0616107ef4$var$enqueue(()=>{
                if (observer.closed) return;
                for(let i = 0; i < x.length; ++i){
                    observer.next(x[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
        throw new TypeError(x + ' is not observable');
    }
    static of(...items) {
        let C = typeof this === 'function' ? this : $cee8bd0616107ef4$var$Observable;
        return new C((observer)=>{
            $cee8bd0616107ef4$var$enqueue(()=>{
                if (observer.closed) return;
                for(let i = 0; i < items.length; ++i){
                    observer.next(items[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
    }
    static get [$cee8bd0616107ef4$var$SymbolSpecies]() {
        return this;
    }
}
module.exports.Observable = $cee8bd0616107ef4$var$Observable;
Object.defineProperty($cee8bd0616107ef4$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $cee8bd0616107ef4$var$SymbolObservable,
        hostReportError: $cee8bd0616107ef4$var$hostReportError
    },
    configurable: true
});

});

parcelRegister("eqO6c", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => r);
$parcel$export(module.exports, "isDraftable", () => t);
$parcel$export(module.exports, "immerable", () => L);
$parcel$export(module.exports, "original", () => e);
$parcel$export(module.exports, "freeze", () => d);
$parcel$export(module.exports, "nothing", () => H);
$parcel$export(module.exports, "current", () => R);
$parcel$export(module.exports, "enableES5", () => F);
$parcel$export(module.exports, "enablePatches", () => T);
$parcel$export(module.exports, "enableMapSet", () => C);
$parcel$export(module.exports, "enableAllPlugins", () => J);
$parcel$export(module.exports, "castDraft", () => K);
$parcel$export(module.exports, "castImmutable", () => $);
$parcel$export(module.exports, "Immer", () => un);
$parcel$export(module.exports, "produce", () => fn);
$parcel$export(module.exports, "produceWithPatches", () => cn);
$parcel$export(module.exports, "setAutoFreeze", () => sn);
$parcel$export(module.exports, "setUseProxies", () => vn);
$parcel$export(module.exports, "applyPatches", () => pn);
$parcel$export(module.exports, "createDraft", () => ln);
$parcel$export(module.exports, "finishDraft", () => dn);
$parcel$export(module.exports, "default", () => $a81a5b052f30f6e2$export$2e2bcd8739ae039);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $a81a5b052f30f6e2$export$2e2bcd8739ae039 = fn;

});

parcelRegister("cfmhQ", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $hjLll.default;
    }
});

var $hjLll = parcelRequire("hjLll");

});
parcelRegister("hjLll", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9b8ef66e039455c$export$2e2bcd8739ae039);

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");

var $2ZOyd = parcelRequire("2ZOyd");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
function $c9b8ef66e039455c$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2ZOyd.default), (0, $kLZMq.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $2ZOyd.default).muiName;
    return /*#__PURE__*/ $28UcW.memo(/*#__PURE__*/ $28UcW.forwardRef(Component));
}

});
parcelRegister("kLZMq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1f81eaf47f8d2d0$export$2e2bcd8739ae039);
function $f1f81eaf47f8d2d0$export$2e2bcd8739ae039() {
    $f1f81eaf47f8d2d0$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f1f81eaf47f8d2d0$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("2ZOyd", function(module, exports) {

$parcel$export(module.exports, "default", () => $22e87d9dba39d350$export$2e2bcd8739ae039);

var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $1fz9F = parcelRequire("1fz9F");

var $1mNk8 = parcelRequire("1mNk8");

var $l9mID = parcelRequire("l9mID");

var $k5hQd = parcelRequire("k5hQd");

var $6tEUB = parcelRequire("6tEUB");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $22e87d9dba39d350$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $22e87d9dba39d350$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $1mNk8.default)(color)}`,
            `fontSize${(0, $1mNk8.default)(fontSize)}`
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $6tEUB.getSvgIconUtilityClass), classes);
};
const $22e87d9dba39d350$var$SvgIconRoot = (0, $k5hQd.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $1mNk8.default)(ownerState.color)}`],
            styles[`fontSize${(0, $1mNk8.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // e.g. heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $22e87d9dba39d350$var$SvgIcon = /*#__PURE__*/ $28UcW.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $53Ou4.default)(props, $22e87d9dba39d350$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $28UcW.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $kLZMq.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $22e87d9dba39d350$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)($22e87d9dba39d350$var$SvgIconRoot, (0, $kLZMq.default)({
        as: component,
        className: (0, $dP0oo.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $4XrX4.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$22e87d9dba39d350$var$SvgIcon.muiName = 'SvgIcon';
var $22e87d9dba39d350$export$2e2bcd8739ae039 = $22e87d9dba39d350$var$SvgIcon;

});
parcelRegister("53Ou4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3af4649f34a5251a$export$2e2bcd8739ae039);
function $3af4649f34a5251a$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("dP0oo", function(module, exports) {

$parcel$export(module.exports, "clsx", () => $7de33314f10ec7d6$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $7de33314f10ec7d6$export$2e2bcd8739ae039);
function $7de33314f10ec7d6$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $7de33314f10ec7d6$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $7de33314f10ec7d6$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $7de33314f10ec7d6$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $7de33314f10ec7d6$export$2e2bcd8739ae039 = $7de33314f10ec7d6$export$4f5d2d50c9deca37;

});

parcelRegister("1fz9F", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e9276343b93f1d3$export$2e2bcd8739ae039);
function $0e9276343b93f1d3$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("1mNk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fee1b2f2b54450b$export$2e2bcd8739ae039);

var $fuRSE = parcelRequire("fuRSE");
var $0fee1b2f2b54450b$export$2e2bcd8739ae039 = (0, $fuRSE.default);

});
parcelRegister("fuRSE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b48373ea3f7770ca$export$2e2bcd8739ae039);

var $3H5bK = parcelRequire("3H5bK");
function $b48373ea3f7770ca$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $3H5bK.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("3H5bK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b096997eca6d654$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $2b096997eca6d654$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});



parcelRegister("l9mID", function(module, exports) {

$parcel$export(module.exports, "default", () => $f65c0fb77c3063e6$export$2e2bcd8739ae039);

var $9Fmgp = parcelRequire("9Fmgp");

var $dpWha = parcelRequire("dpWha");

var $RjrfP = parcelRequire("RjrfP");
'use client';
function $f65c0fb77c3063e6$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $9Fmgp.default)({
        props: props,
        name: name,
        defaultTheme: $dpWha.default,
        themeId: (0, $RjrfP.default)
    });
}

});
parcelRegister("9Fmgp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7099367ca0bc52dd$export$2e2bcd8739ae039);

var $eWMPu = parcelRequire("eWMPu");

var $5jh9n = parcelRequire("5jh9n");
'use client';
function $7099367ca0bc52dd$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $5jh9n.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $eWMPu.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("eWMPu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae1c5bfe4a174f22$export$2e2bcd8739ae039);

var $25D7Q = parcelRequire("25D7Q");
function $ae1c5bfe4a174f22$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $25D7Q.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("25D7Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $185a65e55f412987$export$2e2bcd8739ae039);

var $kLZMq = parcelRequire("kLZMq");
function $185a65e55f412987$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $kLZMq.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $kLZMq.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $kLZMq.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $185a65e55f412987$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRegister("5jh9n", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ddc07ce08f19785$export$2e2bcd8739ae039);

var $7zKsg = parcelRequire("7zKsg");

var $4jjb3 = parcelRequire("4jjb3");
'use client';
const $3ddc07ce08f19785$export$35e57303dbd8a66 = (0, $7zKsg.default)();
function $3ddc07ce08f19785$var$useTheme(defaultTheme = $3ddc07ce08f19785$export$35e57303dbd8a66) {
    return (0, $4jjb3.default)(defaultTheme);
}
var $3ddc07ce08f19785$export$2e2bcd8739ae039 = $3ddc07ce08f19785$var$useTheme;

});
parcelRegister("7zKsg", function(module, exports) {

$parcel$export(module.exports, "default", () => $583fd6461923ccdd$export$2e2bcd8739ae039);

var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $8HP8E = parcelRequire("8HP8E");

var $cY9zX = parcelRequire("cY9zX");

var $6Kzyl = parcelRequire("6Kzyl");

var $br11H = parcelRequire("br11H");

var $iJ7JK = parcelRequire("iJ7JK");

var $9DlDG = parcelRequire("9DlDG");

var $eIkMu = parcelRequire("eIkMu");
const $583fd6461923ccdd$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $583fd6461923ccdd$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $53Ou4.default)(options, $583fd6461923ccdd$var$_excluded);
    const breakpoints = (0, $cY9zX.default)(breakpointsInput);
    const spacing = (0, $br11H.default)(spacingInput);
    let muiTheme = (0, $8HP8E.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $kLZMq.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $kLZMq.default)({}, (0, $6Kzyl.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $eIkMu.default);
    muiTheme = args.reduce((acc, argument)=>(0, $8HP8E.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $kLZMq.default)({}, (0, $9DlDG.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $iJ7JK.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $583fd6461923ccdd$export$2e2bcd8739ae039 = $583fd6461923ccdd$var$createTheme;

});
parcelRegister("8HP8E", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $656a01f06e108da2$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $656a01f06e108da2$export$2e2bcd8739ae039);

var $kLZMq = parcelRequire("kLZMq");
function $656a01f06e108da2$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $656a01f06e108da2$var$deepClone(source) {
    if (!$656a01f06e108da2$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $656a01f06e108da2$var$deepClone(source[key]);
    });
    return output;
}
function $656a01f06e108da2$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $kLZMq.default)({}, target) : target;
    if ($656a01f06e108da2$export$53b83ca8eaab0383(target) && $656a01f06e108da2$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === '__proto__') return;
        if ($656a01f06e108da2$export$53b83ca8eaab0383(source[key]) && key in target && $656a01f06e108da2$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $656a01f06e108da2$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $656a01f06e108da2$export$53b83ca8eaab0383(source[key]) ? $656a01f06e108da2$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("cY9zX", function(module, exports) {

$parcel$export(module.exports, "default", () => $971284d20a72bcab$export$2e2bcd8739ae039);

var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");
const $971284d20a72bcab$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $971284d20a72bcab$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $971284d20a72bcab$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $kLZMq.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $971284d20a72bcab$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $53Ou4.default)(breakpoints, $971284d20a72bcab$var$_excluded);
    const sortedValues = $971284d20a72bcab$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $kLZMq.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("6Kzyl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ea29e089e49ee2e$export$2e2bcd8739ae039);
const $4ea29e089e49ee2e$var$shape = {
    borderRadius: 4
};
var $4ea29e089e49ee2e$export$2e2bcd8739ae039 = $4ea29e089e49ee2e$var$shape;

});

parcelRegister("br11H", function(module, exports) {

$parcel$export(module.exports, "default", () => $853303241de3b731$export$2e2bcd8739ae039);

var $fx59a = parcelRequire("fx59a");
function $853303241de3b731$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $fx59a.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("fx59a", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $b4edee2088cb5f4c$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $b4edee2088cb5f4c$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $b4edee2088cb5f4c$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $b4edee2088cb5f4c$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $b4edee2088cb5f4c$export$6f98e8eaf0be1996);


var $fFwgb = parcelRequire("fFwgb");

var $jHyv0 = parcelRequire("jHyv0");

var $3IUll = parcelRequire("3IUll");

var $7drGY = parcelRequire("7drGY");
const $b4edee2088cb5f4c$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $b4edee2088cb5f4c$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $b4edee2088cb5f4c$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $b4edee2088cb5f4c$var$getCssProperties = (0, $7drGY.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($b4edee2088cb5f4c$var$aliases[prop]) prop = $b4edee2088cb5f4c$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $b4edee2088cb5f4c$var$properties[a];
    const direction = $b4edee2088cb5f4c$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $b4edee2088cb5f4c$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $b4edee2088cb5f4c$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $b4edee2088cb5f4c$var$spacingKeys = [
    ...$b4edee2088cb5f4c$export$aab52a0dde05ad8a,
    ...$b4edee2088cb5f4c$export$f8397d44f03ab6ad
];
function $b4edee2088cb5f4c$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $jHyv0.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $b4edee2088cb5f4c$export$1def6f833384e3d1(theme) {
    return $b4edee2088cb5f4c$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $b4edee2088cb5f4c$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $b4edee2088cb5f4c$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $b4edee2088cb5f4c$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $b4edee2088cb5f4c$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $b4edee2088cb5f4c$var$getCssProperties(prop);
    const styleFromPropValue = $b4edee2088cb5f4c$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $fFwgb.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $b4edee2088cb5f4c$var$style(props, keys) {
    const transformer = $b4edee2088cb5f4c$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$b4edee2088cb5f4c$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $3IUll.default), {});
}
function $b4edee2088cb5f4c$export$7ede87f9b603dd3c(props) {
    return $b4edee2088cb5f4c$var$style(props, $b4edee2088cb5f4c$export$aab52a0dde05ad8a);
}
$b4edee2088cb5f4c$export$7ede87f9b603dd3c.propTypes = {};
$b4edee2088cb5f4c$export$7ede87f9b603dd3c.filterProps = $b4edee2088cb5f4c$export$aab52a0dde05ad8a;
function $b4edee2088cb5f4c$export$6f98e8eaf0be1996(props) {
    return $b4edee2088cb5f4c$var$style(props, $b4edee2088cb5f4c$export$f8397d44f03ab6ad);
}
$b4edee2088cb5f4c$export$6f98e8eaf0be1996.propTypes = {};
$b4edee2088cb5f4c$export$6f98e8eaf0be1996.filterProps = $b4edee2088cb5f4c$export$f8397d44f03ab6ad;
function $b4edee2088cb5f4c$var$spacing(props) {
    return $b4edee2088cb5f4c$var$style(props, $b4edee2088cb5f4c$var$spacingKeys);
}
$b4edee2088cb5f4c$var$spacing.propTypes = {};
$b4edee2088cb5f4c$var$spacing.filterProps = $b4edee2088cb5f4c$var$spacingKeys;
var $b4edee2088cb5f4c$export$2e2bcd8739ae039 = $b4edee2088cb5f4c$var$spacing;

});
parcelRegister("fFwgb", function(module, exports) {

$parcel$export(module.exports, "values", () => $b683b58a37f82b1e$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $b683b58a37f82b1e$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $b683b58a37f82b1e$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $b683b58a37f82b1e$export$8922c90b6e020726);
$parcel$export(module.exports, "mergeBreakpointsInOrder", () => $b683b58a37f82b1e$export$b89a003a1e05c0ee);
$parcel$export(module.exports, "resolveBreakpointValues", () => $b683b58a37f82b1e$export$980e6a259d807490);

var $kLZMq = parcelRequire("kLZMq");


var $8HP8E = parcelRequire("8HP8E");

var $3IUll = parcelRequire("3IUll");
const $b683b58a37f82b1e$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $b683b58a37f82b1e$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$b683b58a37f82b1e$export$68c286be0e7e55b7[key]}px)`
};
function $b683b58a37f82b1e$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $b683b58a37f82b1e$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $b683b58a37f82b1e$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $b683b58a37f82b1e$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $b683b58a37f82b1e$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $b683b58a37f82b1e$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $kLZMq.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $3IUll.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $b683b58a37f82b1e$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $b683b58a37f82b1e$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $b683b58a37f82b1e$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $b683b58a37f82b1e$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $8HP8E.default)(prev, next), {});
    return $b683b58a37f82b1e$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $b683b58a37f82b1e$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $b683b58a37f82b1e$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $b683b58a37f82b1e$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $b683b58a37f82b1e$export$2e2bcd8739ae039 = $b683b58a37f82b1e$var$breakpoints;

});
parcelRegister("3IUll", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b612fc7f479d888$export$2e2bcd8739ae039);

var $8HP8E = parcelRequire("8HP8E");
function $2b612fc7f479d888$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $8HP8E.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $2b612fc7f479d888$export$2e2bcd8739ae039 = $2b612fc7f479d888$var$merge;

});


parcelRegister("jHyv0", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $e57ccb4b09d80b99$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $e57ccb4b09d80b99$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $e57ccb4b09d80b99$export$2e2bcd8739ae039);

var $fuRSE = parcelRequire("fuRSE");


var $fFwgb = parcelRequire("fFwgb");
function $e57ccb4b09d80b99$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $e57ccb4b09d80b99$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $e57ccb4b09d80b99$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $e57ccb4b09d80b99$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $e57ccb4b09d80b99$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $e57ccb4b09d80b99$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $e57ccb4b09d80b99$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $fuRSE.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $fFwgb.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $e57ccb4b09d80b99$export$2e2bcd8739ae039 = $e57ccb4b09d80b99$var$style;

});

parcelRegister("7drGY", function(module, exports) {

$parcel$export(module.exports, "default", () => $540f3a5d040460df$export$2e2bcd8739ae039);
function $540f3a5d040460df$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("iJ7JK", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => $da226e5b8aba9604$export$7d53d8bf2911e013);
$parcel$export(module.exports, "default", () => $da226e5b8aba9604$export$2e2bcd8739ae039);

var $fuRSE = parcelRequire("fuRSE");

var $3IUll = parcelRequire("3IUll");

var $jHyv0 = parcelRequire("jHyv0");

var $fFwgb = parcelRequire("fFwgb");

var $9DlDG = parcelRequire("9DlDG");
function $da226e5b8aba9604$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $da226e5b8aba9604$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $da226e5b8aba9604$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $jHyv0.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $jHyv0.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $jHyv0.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $fuRSE.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $fFwgb.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $9DlDG.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $fFwgb.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $da226e5b8aba9604$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $3IUll.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $fFwgb.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($da226e5b8aba9604$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $3IUll.default)(css, breakpointsValues);
                        }
                    } else css = (0, $3IUll.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $fFwgb.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $da226e5b8aba9604$var$styleFunctionSx = $da226e5b8aba9604$export$7d53d8bf2911e013();
$da226e5b8aba9604$var$styleFunctionSx.filterProps = [
    'sx'
];
var $da226e5b8aba9604$export$2e2bcd8739ae039 = $da226e5b8aba9604$var$styleFunctionSx;

});
parcelRegister("9DlDG", function(module, exports) {

$parcel$export(module.exports, "default", () => $70388aa83eedb94c$export$2e2bcd8739ae039);

var $fx59a = parcelRequire("fx59a");

var $87Za1 = parcelRequire("87Za1");

var $blnt2 = parcelRequire("blnt2");

var $2aQ7t = parcelRequire("2aQ7t");

var $6ehG8 = parcelRequire("6ehG8");
const $70388aa83eedb94c$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $87Za1.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $87Za1.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $87Za1.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $87Za1.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $87Za1.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $87Za1.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $87Za1.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $2aQ7t.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $2aQ7t.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $2aQ7t.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $fx59a.padding)
    },
    pt: {
        style: (0, $fx59a.padding)
    },
    pr: {
        style: (0, $fx59a.padding)
    },
    pb: {
        style: (0, $fx59a.padding)
    },
    pl: {
        style: (0, $fx59a.padding)
    },
    px: {
        style: (0, $fx59a.padding)
    },
    py: {
        style: (0, $fx59a.padding)
    },
    padding: {
        style: (0, $fx59a.padding)
    },
    paddingTop: {
        style: (0, $fx59a.padding)
    },
    paddingRight: {
        style: (0, $fx59a.padding)
    },
    paddingBottom: {
        style: (0, $fx59a.padding)
    },
    paddingLeft: {
        style: (0, $fx59a.padding)
    },
    paddingX: {
        style: (0, $fx59a.padding)
    },
    paddingY: {
        style: (0, $fx59a.padding)
    },
    paddingInline: {
        style: (0, $fx59a.padding)
    },
    paddingInlineStart: {
        style: (0, $fx59a.padding)
    },
    paddingInlineEnd: {
        style: (0, $fx59a.padding)
    },
    paddingBlock: {
        style: (0, $fx59a.padding)
    },
    paddingBlockStart: {
        style: (0, $fx59a.padding)
    },
    paddingBlockEnd: {
        style: (0, $fx59a.padding)
    },
    m: {
        style: (0, $fx59a.margin)
    },
    mt: {
        style: (0, $fx59a.margin)
    },
    mr: {
        style: (0, $fx59a.margin)
    },
    mb: {
        style: (0, $fx59a.margin)
    },
    ml: {
        style: (0, $fx59a.margin)
    },
    mx: {
        style: (0, $fx59a.margin)
    },
    my: {
        style: (0, $fx59a.margin)
    },
    margin: {
        style: (0, $fx59a.margin)
    },
    marginTop: {
        style: (0, $fx59a.margin)
    },
    marginRight: {
        style: (0, $fx59a.margin)
    },
    marginBottom: {
        style: (0, $fx59a.margin)
    },
    marginLeft: {
        style: (0, $fx59a.margin)
    },
    marginX: {
        style: (0, $fx59a.margin)
    },
    marginY: {
        style: (0, $fx59a.margin)
    },
    marginInline: {
        style: (0, $fx59a.margin)
    },
    marginInlineStart: {
        style: (0, $fx59a.margin)
    },
    marginInlineEnd: {
        style: (0, $fx59a.margin)
    },
    marginBlock: {
        style: (0, $fx59a.margin)
    },
    marginBlockStart: {
        style: (0, $fx59a.margin)
    },
    marginBlockEnd: {
        style: (0, $fx59a.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $blnt2.gap)
    },
    rowGap: {
        style: (0, $blnt2.rowGap)
    },
    columnGap: {
        style: (0, $blnt2.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $6ehG8.sizingTransform)
    },
    maxWidth: {
        style: (0, $6ehG8.maxWidth)
    },
    minWidth: {
        transform: (0, $6ehG8.sizingTransform)
    },
    height: {
        transform: (0, $6ehG8.sizingTransform)
    },
    maxHeight: {
        transform: (0, $6ehG8.sizingTransform)
    },
    minHeight: {
        transform: (0, $6ehG8.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $70388aa83eedb94c$export$2e2bcd8739ae039 = $70388aa83eedb94c$var$defaultSxConfig;

});
parcelRegister("87Za1", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $5eae6b66ea00fff2$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $5eae6b66ea00fff2$export$7a57f79000377ca2);


var $jHyv0 = parcelRequire("jHyv0");

var $5aeMC = parcelRequire("5aeMC");

var $fx59a = parcelRequire("fx59a");

var $fFwgb = parcelRequire("fFwgb");
function $5eae6b66ea00fff2$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $5eae6b66ea00fff2$var$createBorderStyle(prop, transform) {
    return (0, $jHyv0.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $5eae6b66ea00fff2$export$1edee58a52776cd9 = $5eae6b66ea00fff2$var$createBorderStyle('border', $5eae6b66ea00fff2$export$34e2febe53ae29cc);
const $5eae6b66ea00fff2$export$f9a7b6bd24892946 = $5eae6b66ea00fff2$var$createBorderStyle('borderTop', $5eae6b66ea00fff2$export$34e2febe53ae29cc);
const $5eae6b66ea00fff2$export$5abca33e6be905d2 = $5eae6b66ea00fff2$var$createBorderStyle('borderRight', $5eae6b66ea00fff2$export$34e2febe53ae29cc);
const $5eae6b66ea00fff2$export$e2ce9f12a980a822 = $5eae6b66ea00fff2$var$createBorderStyle('borderBottom', $5eae6b66ea00fff2$export$34e2febe53ae29cc);
const $5eae6b66ea00fff2$export$47658cca1a909427 = $5eae6b66ea00fff2$var$createBorderStyle('borderLeft', $5eae6b66ea00fff2$export$34e2febe53ae29cc);
const $5eae6b66ea00fff2$export$e7fb0694ba2404fc = $5eae6b66ea00fff2$var$createBorderStyle('borderColor');
const $5eae6b66ea00fff2$export$126a92c968acdb85 = $5eae6b66ea00fff2$var$createBorderStyle('borderTopColor');
const $5eae6b66ea00fff2$export$85cc51cb8fbb8c0e = $5eae6b66ea00fff2$var$createBorderStyle('borderRightColor');
const $5eae6b66ea00fff2$export$340b0327727f6d1a = $5eae6b66ea00fff2$var$createBorderStyle('borderBottomColor');
const $5eae6b66ea00fff2$export$60beef91a985b4bf = $5eae6b66ea00fff2$var$createBorderStyle('borderLeftColor');
const $5eae6b66ea00fff2$export$f9258c55612cbed7 = $5eae6b66ea00fff2$var$createBorderStyle('outline', $5eae6b66ea00fff2$export$34e2febe53ae29cc);
const $5eae6b66ea00fff2$export$621fe586efeb64b9 = $5eae6b66ea00fff2$var$createBorderStyle('outlineColor');
const $5eae6b66ea00fff2$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $fx59a.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $fx59a.getValue)(transformer, propValue)
            });
        return (0, $fFwgb.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$5eae6b66ea00fff2$export$7a57f79000377ca2.propTypes = {};
$5eae6b66ea00fff2$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $5eae6b66ea00fff2$var$borders = (0, $5aeMC.default)($5eae6b66ea00fff2$export$1edee58a52776cd9, $5eae6b66ea00fff2$export$f9a7b6bd24892946, $5eae6b66ea00fff2$export$5abca33e6be905d2, $5eae6b66ea00fff2$export$e2ce9f12a980a822, $5eae6b66ea00fff2$export$47658cca1a909427, $5eae6b66ea00fff2$export$e7fb0694ba2404fc, $5eae6b66ea00fff2$export$126a92c968acdb85, $5eae6b66ea00fff2$export$85cc51cb8fbb8c0e, $5eae6b66ea00fff2$export$340b0327727f6d1a, $5eae6b66ea00fff2$export$60beef91a985b4bf, $5eae6b66ea00fff2$export$7a57f79000377ca2, $5eae6b66ea00fff2$export$f9258c55612cbed7, $5eae6b66ea00fff2$export$621fe586efeb64b9);
var $5eae6b66ea00fff2$export$2e2bcd8739ae039 = $5eae6b66ea00fff2$var$borders;

});
parcelRegister("5aeMC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c295a894b382541$export$2e2bcd8739ae039);

var $3IUll = parcelRequire("3IUll");
function $3c295a894b382541$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $3IUll.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $3c295a894b382541$export$2e2bcd8739ae039 = $3c295a894b382541$var$compose;

});


parcelRegister("blnt2", function(module, exports) {

$parcel$export(module.exports, "gap", () => $8423dc03a70b3075$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $8423dc03a70b3075$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $8423dc03a70b3075$export$8a833ffa5f5dbeda);

var $jHyv0 = parcelRequire("jHyv0");

var $5aeMC = parcelRequire("5aeMC");

var $fx59a = parcelRequire("fx59a");

var $fFwgb = parcelRequire("fFwgb");

const $8423dc03a70b3075$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $fx59a.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $fx59a.getValue)(transformer, propValue)
            });
        return (0, $fFwgb.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$8423dc03a70b3075$export$5df9adcb0db95e1e.propTypes = {};
$8423dc03a70b3075$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $8423dc03a70b3075$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $fx59a.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $fx59a.getValue)(transformer, propValue)
            });
        return (0, $fFwgb.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$8423dc03a70b3075$export$ec60d70ff941a580.propTypes = {};
$8423dc03a70b3075$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $8423dc03a70b3075$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $fx59a.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $fx59a.getValue)(transformer, propValue)
            });
        return (0, $fFwgb.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$8423dc03a70b3075$export$8a833ffa5f5dbeda.propTypes = {};
$8423dc03a70b3075$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $8423dc03a70b3075$export$baf44164ca3a34e8 = (0, $jHyv0.default)({
    prop: 'gridColumn'
});
const $8423dc03a70b3075$export$8f7213a1cd01e832 = (0, $jHyv0.default)({
    prop: 'gridRow'
});
const $8423dc03a70b3075$export$b0e0abbc49ba668 = (0, $jHyv0.default)({
    prop: 'gridAutoFlow'
});
const $8423dc03a70b3075$export$bcd8b929d4b4142 = (0, $jHyv0.default)({
    prop: 'gridAutoColumns'
});
const $8423dc03a70b3075$export$e5039a674e14c828 = (0, $jHyv0.default)({
    prop: 'gridAutoRows'
});
const $8423dc03a70b3075$export$42bd9088661ffb03 = (0, $jHyv0.default)({
    prop: 'gridTemplateColumns'
});
const $8423dc03a70b3075$export$920682ae05b999bc = (0, $jHyv0.default)({
    prop: 'gridTemplateRows'
});
const $8423dc03a70b3075$export$1b88fbdd482fd33a = (0, $jHyv0.default)({
    prop: 'gridTemplateAreas'
});
const $8423dc03a70b3075$export$bdb486e40d52d26f = (0, $jHyv0.default)({
    prop: 'gridArea'
});
const $8423dc03a70b3075$var$grid = (0, $5aeMC.default)($8423dc03a70b3075$export$5df9adcb0db95e1e, $8423dc03a70b3075$export$ec60d70ff941a580, $8423dc03a70b3075$export$8a833ffa5f5dbeda, $8423dc03a70b3075$export$baf44164ca3a34e8, $8423dc03a70b3075$export$8f7213a1cd01e832, $8423dc03a70b3075$export$b0e0abbc49ba668, $8423dc03a70b3075$export$bcd8b929d4b4142, $8423dc03a70b3075$export$e5039a674e14c828, $8423dc03a70b3075$export$42bd9088661ffb03, $8423dc03a70b3075$export$920682ae05b999bc, $8423dc03a70b3075$export$1b88fbdd482fd33a, $8423dc03a70b3075$export$bdb486e40d52d26f);
var $8423dc03a70b3075$export$2e2bcd8739ae039 = $8423dc03a70b3075$var$grid;

});

parcelRegister("2aQ7t", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $1954f1c9a9fca946$export$dbaffd4420ea0ac6);

var $jHyv0 = parcelRequire("jHyv0");

var $5aeMC = parcelRequire("5aeMC");
function $1954f1c9a9fca946$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $1954f1c9a9fca946$export$35e9368ef982300f = (0, $jHyv0.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $1954f1c9a9fca946$export$dbaffd4420ea0ac6
});
const $1954f1c9a9fca946$export$2506f56c10355b33 = (0, $jHyv0.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $1954f1c9a9fca946$export$dbaffd4420ea0ac6
});
const $1954f1c9a9fca946$export$8c5a050822fd698c = (0, $jHyv0.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $1954f1c9a9fca946$export$dbaffd4420ea0ac6
});
const $1954f1c9a9fca946$var$palette = (0, $5aeMC.default)($1954f1c9a9fca946$export$35e9368ef982300f, $1954f1c9a9fca946$export$2506f56c10355b33, $1954f1c9a9fca946$export$8c5a050822fd698c);
var $1954f1c9a9fca946$export$2e2bcd8739ae039 = $1954f1c9a9fca946$var$palette;

});

parcelRegister("6ehG8", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $4891c37a58be1019$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $4891c37a58be1019$export$488fda99655ff65a);

var $jHyv0 = parcelRequire("jHyv0");

var $5aeMC = parcelRequire("5aeMC");

var $fFwgb = parcelRequire("fFwgb");
function $4891c37a58be1019$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $4891c37a58be1019$export$7e3df82ee760448c = (0, $jHyv0.default)({
    prop: 'width',
    transform: $4891c37a58be1019$export$8afece71750ec241
});
const $4891c37a58be1019$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $fFwgb.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $4891c37a58be1019$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $fFwgb.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$4891c37a58be1019$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $4891c37a58be1019$export$ee148fbbe8357dd2 = (0, $jHyv0.default)({
    prop: 'minWidth',
    transform: $4891c37a58be1019$export$8afece71750ec241
});
const $4891c37a58be1019$export$ac607276a8fe9f0a = (0, $jHyv0.default)({
    prop: 'height',
    transform: $4891c37a58be1019$export$8afece71750ec241
});
const $4891c37a58be1019$export$dc0d8bd0b94f8570 = (0, $jHyv0.default)({
    prop: 'maxHeight',
    transform: $4891c37a58be1019$export$8afece71750ec241
});
const $4891c37a58be1019$export$a43cf604e12f3b17 = (0, $jHyv0.default)({
    prop: 'minHeight',
    transform: $4891c37a58be1019$export$8afece71750ec241
});
const $4891c37a58be1019$export$ffed9f14fb65e276 = (0, $jHyv0.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $4891c37a58be1019$export$8afece71750ec241
});
const $4891c37a58be1019$export$905076ed6620e671 = (0, $jHyv0.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $4891c37a58be1019$export$8afece71750ec241
});
const $4891c37a58be1019$export$6ccc93f785106a58 = (0, $jHyv0.default)({
    prop: 'boxSizing'
});
const $4891c37a58be1019$var$sizing = (0, $5aeMC.default)($4891c37a58be1019$export$7e3df82ee760448c, $4891c37a58be1019$export$488fda99655ff65a, $4891c37a58be1019$export$ee148fbbe8357dd2, $4891c37a58be1019$export$ac607276a8fe9f0a, $4891c37a58be1019$export$dc0d8bd0b94f8570, $4891c37a58be1019$export$a43cf604e12f3b17, $4891c37a58be1019$export$6ccc93f785106a58);
var $4891c37a58be1019$export$2e2bcd8739ae039 = $4891c37a58be1019$var$sizing;

});



parcelRegister("eIkMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab654b741514df8e$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $ab654b741514df8e$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("4jjb3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3237cfff79a565c5$export$2e2bcd8739ae039);

var $28UcW = parcelRequire("28UcW");
parcelRequire("3vbO9");
var $03G5m = parcelRequire("03G5m");
'use client';
function $3237cfff79a565c5$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $3237cfff79a565c5$var$useTheme(defaultTheme = null) {
    const contextTheme = $28UcW.useContext((0, $03G5m.T));
    return !contextTheme || $3237cfff79a565c5$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $3237cfff79a565c5$export$2e2bcd8739ae039 = $3237cfff79a565c5$var$useTheme;

});
parcelRegister("3vbO9", function(module, exports) {

$parcel$export(module.exports, "Global", () => $28cd6d243c482e73$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $28cd6d243c482e73$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $28cd6d243c482e73$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("03G5m")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("03G5m")).w);

var $03G5m = parcelRequire("03G5m");

var $28UcW = parcelRequire("28UcW");

var $hYp2W = parcelRequire("hYp2W");

var $a3GsN = parcelRequire("a3GsN");

var $c4JlO = parcelRequire("c4JlO");
parcelRequire("iqmCU");
parcelRequire("2ZOLb");
parcelRequire("7TUmo");

parcelRequire("i9tl0");
var $28cd6d243c482e73$var$pkg = {
    name: "@emotion/react",
    version: "11.11.3",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $28cd6d243c482e73$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $03G5m.h).call(props, 'css')) // $FlowFixMe
    return $28UcW.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $03G5m.E);
    createElementArgArray[1] = (0, $03G5m.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $28UcW.createElement.apply(null, createElementArgArray);
};
var $28cd6d243c482e73$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $28cd6d243c482e73$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $03G5m.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $c4JlO.serializeStyles)([
        styles
    ], undefined, $28UcW.useContext((0, $03G5m.T)));
    if (!(0, $03G5m.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $28UcW.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $28UcW.useRef();
    (0, $a3GsN.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $a3GsN.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $hYp2W.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $28cd6d243c482e73$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $c4JlO.serializeStyles)(args);
}
var $28cd6d243c482e73$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $28cd6d243c482e73$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $28cd6d243c482e73$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $28cd6d243c482e73$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $hYp2W.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $28cd6d243c482e73$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $a3GsN.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $hYp2W.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $28cd6d243c482e73$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $03G5m.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $c4JlO.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $hYp2W.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $28cd6d243c482e73$var$merge(cache.registered, css, $28cd6d243c482e73$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $28UcW.useContext((0, $03G5m.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $28UcW.createElement($28UcW.Fragment, null, /*#__PURE__*/ $28UcW.createElement($28cd6d243c482e73$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $28cd6d243c482e73$var$isBrowser, $28cd6d243c482e73$var$isTestEnv, $28cd6d243c482e73$var$globalContext, $28cd6d243c482e73$var$globalKey;

});
parcelRegister("03G5m", function(module, exports) {

$parcel$export(module.exports, "i", () => $00b0ed3e0c4a9554$export$23f2a1d2818174ef);
$parcel$export(module.exports, "h", () => $00b0ed3e0c4a9554$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "C", () => $00b0ed3e0c4a9554$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $00b0ed3e0c4a9554$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $00b0ed3e0c4a9554$export$971d5caa766a69d7);
$parcel$export(module.exports, "c", () => $00b0ed3e0c4a9554$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $00b0ed3e0c4a9554$export$a9c23c6ac3fc3eca);

var $28UcW = parcelRequire("28UcW");

var $iqmCU = parcelRequire("iqmCU");

var $kLZMq = parcelRequire("kLZMq");

var $7TUmo = parcelRequire("7TUmo");

var $KGL60 = parcelRequire("KGL60");

var $hYp2W = parcelRequire("hYp2W");

var $c4JlO = parcelRequire("c4JlO");

var $a3GsN = parcelRequire("a3GsN");
var $00b0ed3e0c4a9554$export$23f2a1d2818174ef = true;
var $00b0ed3e0c4a9554$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $00b0ed3e0c4a9554$var$EmotionCacheContext = /* #__PURE__ */ $28UcW.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $iqmCU.default)({
    key: 'css'
}) : null);
var $00b0ed3e0c4a9554$export$e7094788287c5e9b = $00b0ed3e0c4a9554$var$EmotionCacheContext.Provider;
var $00b0ed3e0c4a9554$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $28UcW.useContext)($00b0ed3e0c4a9554$var$EmotionCacheContext);
};
var $00b0ed3e0c4a9554$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $28UcW.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $28UcW.useContext)($00b0ed3e0c4a9554$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$00b0ed3e0c4a9554$export$23f2a1d2818174ef) $00b0ed3e0c4a9554$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $28UcW.useContext)($00b0ed3e0c4a9554$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $iqmCU.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $28UcW.createElement($00b0ed3e0c4a9554$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $00b0ed3e0c4a9554$export$971d5caa766a69d7 = /* #__PURE__ */ $28UcW.createContext({});
var $00b0ed3e0c4a9554$export$3b14a55fb2447963 = function useTheme() {
    return $28UcW.useContext($00b0ed3e0c4a9554$export$971d5caa766a69d7);
};
var $00b0ed3e0c4a9554$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $kLZMq.default)({}, outerTheme, theme);
};
var $00b0ed3e0c4a9554$var$createCacheWithTheme = /* #__PURE__ */ (0, $7TUmo.default)(function(outerTheme) {
    return (0, $7TUmo.default)(function(theme) {
        return $00b0ed3e0c4a9554$var$getTheme(outerTheme, theme);
    });
});
var $00b0ed3e0c4a9554$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $28UcW.useContext($00b0ed3e0c4a9554$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $00b0ed3e0c4a9554$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $28UcW.createElement($00b0ed3e0c4a9554$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $00b0ed3e0c4a9554$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = $28UcW.useContext($00b0ed3e0c4a9554$export$971d5caa766a69d7);
        return /*#__PURE__*/ $28UcW.createElement(Component, (0, $kLZMq.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $28UcW.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $KGL60.default)(WithTheme, Component);
}
var $00b0ed3e0c4a9554$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $00b0ed3e0c4a9554$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $00b0ed3e0c4a9554$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $00b0ed3e0c4a9554$var$getLastPart(match[1]);
    return undefined;
};
var $00b0ed3e0c4a9554$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $00b0ed3e0c4a9554$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $00b0ed3e0c4a9554$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $00b0ed3e0c4a9554$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($00b0ed3e0c4a9554$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $00b0ed3e0c4a9554$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $00b0ed3e0c4a9554$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $00b0ed3e0c4a9554$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $00b0ed3e0c4a9554$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($00b0ed3e0c4a9554$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$00b0ed3e0c4a9554$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $00b0ed3e0c4a9554$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $hYp2W.registerStyles)(cache, serialized, isStringTag);
    (0, $a3GsN.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $hYp2W.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $00b0ed3e0c4a9554$var$Emotion = /* #__PURE__ */ $00b0ed3e0c4a9554$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$00b0ed3e0c4a9554$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $hYp2W.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $c4JlO.serializeStyles)(registeredStyles, undefined, $28UcW.useContext($00b0ed3e0c4a9554$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($00b0ed3e0c4a9554$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $00b0ed3e0c4a9554$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $28UcW.createElement($28UcW.Fragment, null, /*#__PURE__*/ $28UcW.createElement($00b0ed3e0c4a9554$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $28UcW.createElement(WrappedComponent, newProps));
});
var $00b0ed3e0c4a9554$export$a9c23c6ac3fc3eca = $00b0ed3e0c4a9554$var$Emotion;

});
parcelRegister("iqmCU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d69c34dc53b4ba2a$export$2e2bcd8739ae039);

var $fP82h = parcelRequire("fP82h");

var $2BRJN = parcelRequire("2BRJN");
parcelRequire("7TUmo");
parcelRequire("dsA1p");
var $d69c34dc53b4ba2a$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $2BRJN.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $2BRJN.token)(character)) break;
        (0, $2BRJN.next)();
    }
    return (0, $2BRJN.slice)(begin, (0, $2BRJN.position));
};
var $d69c34dc53b4ba2a$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $2BRJN.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $2BRJN.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $d69c34dc53b4ba2a$var$identifierWithPointTracking((0, $2BRJN.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $2BRJN.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $2BRJN.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $2BRJN.from)(character);
    }
    while (character = (0, $2BRJN.next)());
    return parsed;
};
var $d69c34dc53b4ba2a$var$getRules = function getRules(value, points) {
    return (0, $2BRJN.dealloc)($d69c34dc53b4ba2a$var$toRules((0, $2BRJN.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $d69c34dc53b4ba2a$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $d69c34dc53b4ba2a$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$d69c34dc53b4ba2a$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $d69c34dc53b4ba2a$var$fixedElements.set(element, true);
    var points = [];
    var rules = $d69c34dc53b4ba2a$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $d69c34dc53b4ba2a$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
var $d69c34dc53b4ba2a$var$ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
var $d69c34dc53b4ba2a$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === 'comm' && element.children.indexOf($d69c34dc53b4ba2a$var$ignoreFlag) > -1;
};
var $d69c34dc53b4ba2a$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== 'rule' || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($d69c34dc53b4ba2a$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
            });
        }
    };
};
var $d69c34dc53b4ba2a$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $d69c34dc53b4ba2a$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$d69c34dc53b4ba2a$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $d69c34dc53b4ba2a$var$nullifyElement = function nullifyElement(element) {
    element.type = '';
    element.value = '';
    element["return"] = '';
    element.children = '';
    element.props = '';
};
var $d69c34dc53b4ba2a$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$d69c34dc53b4ba2a$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $d69c34dc53b4ba2a$var$nullifyElement(element);
    } else if ($d69c34dc53b4ba2a$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $d69c34dc53b4ba2a$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $d69c34dc53b4ba2a$var$prefix(value, length) {
    switch((0, $2BRJN.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $2BRJN.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $2BRJN.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $2BRJN.WEBKIT) + value + (0, $2BRJN.MOZ) + value + (0, $2BRJN.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $2BRJN.WEBKIT) + value + (0, $2BRJN.MS) + value + value;
        // order
        case 6165:
            return (0, $2BRJN.WEBKIT) + value + (0, $2BRJN.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $2BRJN.WEBKIT) + value + (0, $2BRJN.replace)(value, /(\w+).+(:[^]+)/, (0, $2BRJN.WEBKIT) + 'box-$1$2' + (0, $2BRJN.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $2BRJN.WEBKIT) + value + (0, $2BRJN.MS) + 'flex-item-' + (0, $2BRJN.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $2BRJN.WEBKIT) + value + (0, $2BRJN.MS) + 'flex-line-pack' + (0, $2BRJN.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $2BRJN.WEBKIT) + value + (0, $2BRJN.MS) + (0, $2BRJN.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $2BRJN.WEBKIT) + value + (0, $2BRJN.MS) + (0, $2BRJN.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $2BRJN.WEBKIT) + 'box-' + (0, $2BRJN.replace)(value, '-grow', '') + (0, $2BRJN.WEBKIT) + value + (0, $2BRJN.MS) + (0, $2BRJN.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $2BRJN.WEBKIT) + (0, $2BRJN.replace)(value, /([^-])(transform)/g, '$1' + (0, $2BRJN.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $2BRJN.replace)((0, $2BRJN.replace)((0, $2BRJN.replace)(value, /(zoom-|grab)/, (0, $2BRJN.WEBKIT) + '$1'), /(image-set)/, (0, $2BRJN.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $2BRJN.replace)(value, /(image-set\([^]*)/, (0, $2BRJN.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $2BRJN.replace)((0, $2BRJN.replace)(value, /(.+:)(flex-)?(.*)/, (0, $2BRJN.WEBKIT) + 'box-pack:$3' + (0, $2BRJN.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $2BRJN.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $2BRJN.replace)(value, /(.+)-inline(.+)/, (0, $2BRJN.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $2BRJN.strlen)(value) - 1 - length > 6) switch((0, $2BRJN.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $2BRJN.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $2BRJN.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $2BRJN.WEBKIT) + '$2-$3' + '$1' + (0, $2BRJN.MOZ) + ((0, $2BRJN.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $2BRJN.indexof)(value, 'stretch') ? $d69c34dc53b4ba2a$var$prefix((0, $2BRJN.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $2BRJN.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $2BRJN.charat)(value, (0, $2BRJN.strlen)(value) - 3 - (~(0, $2BRJN.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $2BRJN.replace)(value, ':', ':' + (0, $2BRJN.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $2BRJN.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $2BRJN.WEBKIT) + ((0, $2BRJN.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $2BRJN.WEBKIT) + '$2$3' + '$1' + (0, $2BRJN.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $2BRJN.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $2BRJN.WEBKIT) + value + (0, $2BRJN.MS) + (0, $2BRJN.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $2BRJN.WEBKIT) + value + (0, $2BRJN.MS) + (0, $2BRJN.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $2BRJN.WEBKIT) + value + (0, $2BRJN.MS) + (0, $2BRJN.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $2BRJN.WEBKIT) + value + (0, $2BRJN.MS) + value + value;
    }
    return value;
}
var $d69c34dc53b4ba2a$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $2BRJN.DECLARATION:
                element["return"] = $d69c34dc53b4ba2a$var$prefix(element.value, element.length);
                break;
            case 0, $2BRJN.KEYFRAMES:
                return (0, $2BRJN.serialize)([
                    (0, $2BRJN.copy)(element, {
                        value: (0, $2BRJN.replace)(element.value, '@', '@' + (0, $2BRJN.WEBKIT))
                    })
                ], callback);
            case 0, $2BRJN.RULESET:
                if (element.length) return (0, $2BRJN.combine)(element.props, function(value) {
                    switch((0, $2BRJN.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $2BRJN.serialize)([
                                (0, $2BRJN.copy)(element, {
                                    props: [
                                        (0, $2BRJN.replace)(value, /:(read-\w+)/, ':' + (0, $2BRJN.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $2BRJN.serialize)([
                                (0, $2BRJN.copy)(element, {
                                    props: [
                                        (0, $2BRJN.replace)(value, /:(plac\w+)/, ':' + (0, $2BRJN.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $2BRJN.copy)(element, {
                                    props: [
                                        (0, $2BRJN.replace)(value, /:(plac\w+)/, ':' + (0, $2BRJN.MOZ) + '$1')
                                    ]
                                }),
                                (0, $2BRJN.copy)(element, {
                                    props: [
                                        (0, $2BRJN.replace)(value, /:(plac\w+)/, (0, $2BRJN.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $d69c34dc53b4ba2a$var$defaultStylisPlugins = [
    $d69c34dc53b4ba2a$var$prefixer
];
var $d69c34dc53b4ba2a$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $d69c34dc53b4ba2a$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $d69c34dc53b4ba2a$var$compat,
        $d69c34dc53b4ba2a$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $2BRJN.stringify),
        (0, $2BRJN.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $2BRJN.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $2BRJN.serialize)((0, $2BRJN.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $fP82h.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("fP82h", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $b851da314bf87c7b$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $b851da314bf87c7b$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $b851da314bf87c7b$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $b851da314bf87c7b$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($b851da314bf87c7b$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $b851da314bf87c7b$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("2BRJN", function(module, exports) {

$parcel$export(module.exports, "MS", () => $945ed6f25e45287a$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $945ed6f25e45287a$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $945ed6f25e45287a$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $945ed6f25e45287a$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $945ed6f25e45287a$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $945ed6f25e45287a$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $945ed6f25e45287a$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $945ed6f25e45287a$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $945ed6f25e45287a$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $945ed6f25e45287a$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $945ed6f25e45287a$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $945ed6f25e45287a$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $945ed6f25e45287a$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $945ed6f25e45287a$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $945ed6f25e45287a$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $945ed6f25e45287a$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $945ed6f25e45287a$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $945ed6f25e45287a$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $945ed6f25e45287a$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $945ed6f25e45287a$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $945ed6f25e45287a$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $945ed6f25e45287a$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $945ed6f25e45287a$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $945ed6f25e45287a$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $945ed6f25e45287a$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $945ed6f25e45287a$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $945ed6f25e45287a$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $945ed6f25e45287a$export$38bcb760f1d4871c);
var $945ed6f25e45287a$export$71ad59f2e432cfe8 = "-ms-";
var $945ed6f25e45287a$export$2c0f367103c8d01c = "-moz-";
var $945ed6f25e45287a$export$39dfd62a25e0fe93 = "-webkit-";
var $945ed6f25e45287a$export$a29989082612d0d9 = "comm";
var $945ed6f25e45287a$export$aa3a2e812ca8570d = "rule";
var $945ed6f25e45287a$export$527d108ccf083c2b = "decl";
var $945ed6f25e45287a$export$d3d35020fa5b54f0 = "@page";
var $945ed6f25e45287a$export$500415a86c544f73 = "@media";
var $945ed6f25e45287a$export$a763edbf796b780a = "@import";
var $945ed6f25e45287a$export$2790aeb8b4e5c826 = "@charset";
var $945ed6f25e45287a$export$1cc683e23b84b133 = "@viewport";
var $945ed6f25e45287a$export$9447a5efea57e862 = "@supports";
var $945ed6f25e45287a$export$ef011b4e114b1fba = "@document";
var $945ed6f25e45287a$export$6aad947bda0f3f46 = "@namespace";
var $945ed6f25e45287a$export$b44a8529a35fcb60 = "@keyframes";
var $945ed6f25e45287a$export$2c16de31893252e6 = "@font-face";
var $945ed6f25e45287a$export$3d846dd52e150c6f = "@counter-style";
var $945ed6f25e45287a$export$22314bfbb57653fe = "@font-feature-values";
var $945ed6f25e45287a$export$d773506282b3cfe6 = "@layer";
var $945ed6f25e45287a$export$2335f513bbd82c6d = Math.abs;
var $945ed6f25e45287a$export$6788812c4e6611e6 = String.fromCharCode;
var $945ed6f25e45287a$export$e6e34fd1f2686227 = Object.assign;
function $945ed6f25e45287a$export$d6af199866bfb566(e, r) {
    return $945ed6f25e45287a$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $945ed6f25e45287a$export$a9db5e087081082d(e, 0)) << 2 ^ $945ed6f25e45287a$export$a9db5e087081082d(e, 1)) << 2 ^ $945ed6f25e45287a$export$a9db5e087081082d(e, 2)) << 2 ^ $945ed6f25e45287a$export$a9db5e087081082d(e, 3) : 0;
}
function $945ed6f25e45287a$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $945ed6f25e45287a$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $945ed6f25e45287a$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $945ed6f25e45287a$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $945ed6f25e45287a$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $945ed6f25e45287a$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $945ed6f25e45287a$export$36776f635604f274(e) {
    return e.length;
}
function $945ed6f25e45287a$export$f9084667e487ed46(e) {
    return e.length;
}
function $945ed6f25e45287a$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $945ed6f25e45287a$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $945ed6f25e45287a$export$53f1d5ea8de3d7c = 1;
var $945ed6f25e45287a$export$4e0c71f277ca26b3 = 1;
var $945ed6f25e45287a$export$f24224f1c91d8156 = 0;
var $945ed6f25e45287a$export$5880b8b5730aff45 = 0;
var $945ed6f25e45287a$export$c0306caf338ac095 = 0;
var $945ed6f25e45287a$export$30a86d91af8ff6e6 = "";
function $945ed6f25e45287a$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $945ed6f25e45287a$export$53f1d5ea8de3d7c,
        column: $945ed6f25e45287a$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $945ed6f25e45287a$export$784d13d8ee351f07(e, r) {
    return $945ed6f25e45287a$export$e6e34fd1f2686227($945ed6f25e45287a$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $945ed6f25e45287a$export$eba6f6f03b0a92e7() {
    return $945ed6f25e45287a$export$c0306caf338ac095;
}
function $945ed6f25e45287a$export$232faf9add678146() {
    $945ed6f25e45287a$export$c0306caf338ac095 = $945ed6f25e45287a$export$5880b8b5730aff45 > 0 ? $945ed6f25e45287a$export$a9db5e087081082d($945ed6f25e45287a$export$30a86d91af8ff6e6, --$945ed6f25e45287a$export$5880b8b5730aff45) : 0;
    if ($945ed6f25e45287a$export$4e0c71f277ca26b3--, $945ed6f25e45287a$export$c0306caf338ac095 === 10) $945ed6f25e45287a$export$4e0c71f277ca26b3 = 1, $945ed6f25e45287a$export$53f1d5ea8de3d7c--;
    return $945ed6f25e45287a$export$c0306caf338ac095;
}
function $945ed6f25e45287a$export$48cfd1e771a65c4f() {
    $945ed6f25e45287a$export$c0306caf338ac095 = $945ed6f25e45287a$export$5880b8b5730aff45 < $945ed6f25e45287a$export$f24224f1c91d8156 ? $945ed6f25e45287a$export$a9db5e087081082d($945ed6f25e45287a$export$30a86d91af8ff6e6, $945ed6f25e45287a$export$5880b8b5730aff45++) : 0;
    if ($945ed6f25e45287a$export$4e0c71f277ca26b3++, $945ed6f25e45287a$export$c0306caf338ac095 === 10) $945ed6f25e45287a$export$4e0c71f277ca26b3 = 1, $945ed6f25e45287a$export$53f1d5ea8de3d7c++;
    return $945ed6f25e45287a$export$c0306caf338ac095;
}
function $945ed6f25e45287a$export$4d3fb11e950abb9e() {
    return $945ed6f25e45287a$export$a9db5e087081082d($945ed6f25e45287a$export$30a86d91af8ff6e6, $945ed6f25e45287a$export$5880b8b5730aff45);
}
function $945ed6f25e45287a$export$e88cb2efb12ae807() {
    return $945ed6f25e45287a$export$5880b8b5730aff45;
}
function $945ed6f25e45287a$export$58adb3bec8346d0f(e, r) {
    return $945ed6f25e45287a$export$2f35ab04d2335697($945ed6f25e45287a$export$30a86d91af8ff6e6, e, r);
}
function $945ed6f25e45287a$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $945ed6f25e45287a$export$2de70f21292aac9e(e) {
    return $945ed6f25e45287a$export$53f1d5ea8de3d7c = $945ed6f25e45287a$export$4e0c71f277ca26b3 = 1, $945ed6f25e45287a$export$f24224f1c91d8156 = $945ed6f25e45287a$export$36776f635604f274($945ed6f25e45287a$export$30a86d91af8ff6e6 = e), $945ed6f25e45287a$export$5880b8b5730aff45 = 0, [];
}
function $945ed6f25e45287a$export$45918ac1574455b1(e) {
    return $945ed6f25e45287a$export$30a86d91af8ff6e6 = "", e;
}
function $945ed6f25e45287a$export$410ac95b9ec204b8(e) {
    return $945ed6f25e45287a$export$87c2784dc9fc4ab($945ed6f25e45287a$export$58adb3bec8346d0f($945ed6f25e45287a$export$5880b8b5730aff45 - 1, $945ed6f25e45287a$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $945ed6f25e45287a$export$660b2ee2d4fb4eff(e) {
    return $945ed6f25e45287a$export$45918ac1574455b1($945ed6f25e45287a$export$5f8c09e3ae6f64e1($945ed6f25e45287a$export$2de70f21292aac9e(e)));
}
function $945ed6f25e45287a$export$7af1228ff777d175(e) {
    while($945ed6f25e45287a$export$c0306caf338ac095 = $945ed6f25e45287a$export$4d3fb11e950abb9e())if ($945ed6f25e45287a$export$c0306caf338ac095 < 33) $945ed6f25e45287a$export$48cfd1e771a65c4f();
    else break;
    return $945ed6f25e45287a$export$9e1725a4cfeada27(e) > 2 || $945ed6f25e45287a$export$9e1725a4cfeada27($945ed6f25e45287a$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $945ed6f25e45287a$export$5f8c09e3ae6f64e1(e) {
    while($945ed6f25e45287a$export$48cfd1e771a65c4f())switch($945ed6f25e45287a$export$9e1725a4cfeada27($945ed6f25e45287a$export$c0306caf338ac095)){
        case 0:
            $945ed6f25e45287a$export$10d8903dec122b9d($945ed6f25e45287a$export$c2ab62c7bf24634($945ed6f25e45287a$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $945ed6f25e45287a$export$10d8903dec122b9d($945ed6f25e45287a$export$410ac95b9ec204b8($945ed6f25e45287a$export$c0306caf338ac095), e);
            break;
        default:
            $945ed6f25e45287a$export$10d8903dec122b9d($945ed6f25e45287a$export$6788812c4e6611e6($945ed6f25e45287a$export$c0306caf338ac095), e);
    }
    return e;
}
function $945ed6f25e45287a$export$955ba06d119e085e(e, r) {
    while(--r && $945ed6f25e45287a$export$48cfd1e771a65c4f())if ($945ed6f25e45287a$export$c0306caf338ac095 < 48 || $945ed6f25e45287a$export$c0306caf338ac095 > 102 || $945ed6f25e45287a$export$c0306caf338ac095 > 57 && $945ed6f25e45287a$export$c0306caf338ac095 < 65 || $945ed6f25e45287a$export$c0306caf338ac095 > 70 && $945ed6f25e45287a$export$c0306caf338ac095 < 97) break;
    return $945ed6f25e45287a$export$58adb3bec8346d0f(e, $945ed6f25e45287a$export$e88cb2efb12ae807() + (r < 6 && $945ed6f25e45287a$export$4d3fb11e950abb9e() == 32 && $945ed6f25e45287a$export$48cfd1e771a65c4f() == 32));
}
function $945ed6f25e45287a$export$c889f2fcc19dbf12(e) {
    while($945ed6f25e45287a$export$48cfd1e771a65c4f())switch($945ed6f25e45287a$export$c0306caf338ac095){
        case e:
            return $945ed6f25e45287a$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $945ed6f25e45287a$export$c889f2fcc19dbf12($945ed6f25e45287a$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $945ed6f25e45287a$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $945ed6f25e45287a$export$48cfd1e771a65c4f();
            break;
    }
    return $945ed6f25e45287a$export$5880b8b5730aff45;
}
function $945ed6f25e45287a$export$4254d4e2b3745c4c(e, r) {
    while($945ed6f25e45287a$export$48cfd1e771a65c4f())if (e + $945ed6f25e45287a$export$c0306caf338ac095 === 57) break;
    else if (e + $945ed6f25e45287a$export$c0306caf338ac095 === 84 && $945ed6f25e45287a$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $945ed6f25e45287a$export$58adb3bec8346d0f(r, $945ed6f25e45287a$export$5880b8b5730aff45 - 1) + "*" + $945ed6f25e45287a$export$6788812c4e6611e6(e === 47 ? e : $945ed6f25e45287a$export$48cfd1e771a65c4f());
}
function $945ed6f25e45287a$export$c2ab62c7bf24634(e) {
    while(!$945ed6f25e45287a$export$9e1725a4cfeada27($945ed6f25e45287a$export$4d3fb11e950abb9e()))$945ed6f25e45287a$export$48cfd1e771a65c4f();
    return $945ed6f25e45287a$export$58adb3bec8346d0f(e, $945ed6f25e45287a$export$5880b8b5730aff45);
}
function $945ed6f25e45287a$export$ef7acd7185315e22(e) {
    return $945ed6f25e45287a$export$45918ac1574455b1($945ed6f25e45287a$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $945ed6f25e45287a$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $945ed6f25e45287a$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $945ed6f25e45287a$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $945ed6f25e45287a$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($945ed6f25e45287a$export$f8e21b1e77979a08(j += $945ed6f25e45287a$export$77ad94ebf1c2b9ed($945ed6f25e45287a$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $945ed6f25e45287a$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $945ed6f25e45287a$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $945ed6f25e45287a$export$955ba06d119e085e($945ed6f25e45287a$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($945ed6f25e45287a$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $945ed6f25e45287a$export$10d8903dec122b9d($945ed6f25e45287a$export$4a34f930e789283c($945ed6f25e45287a$export$4254d4e2b3745c4c($945ed6f25e45287a$export$48cfd1e771a65c4f(), $945ed6f25e45287a$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $945ed6f25e45287a$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $945ed6f25e45287a$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $945ed6f25e45287a$export$36776f635604f274(j) - l) $945ed6f25e45287a$export$10d8903dec122b9d(p > 32 ? $945ed6f25e45287a$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $945ed6f25e45287a$export$f8483753829ec8f3($945ed6f25e45287a$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $945ed6f25e45287a$export$10d8903dec122b9d(y = $945ed6f25e45287a$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $945ed6f25e45287a$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $945ed6f25e45287a$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $945ed6f25e45287a$export$98e6a39c04603d36(e, y, y, n && $945ed6f25e45287a$export$10d8903dec122b9d($945ed6f25e45287a$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $945ed6f25e45287a$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $945ed6f25e45287a$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $945ed6f25e45287a$export$232faf9add678146() == 125) continue;
            }
            switch(j += $945ed6f25e45287a$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($945ed6f25e45287a$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($945ed6f25e45287a$export$4d3fb11e950abb9e() === 45) j += $945ed6f25e45287a$export$410ac95b9ec204b8($945ed6f25e45287a$export$48cfd1e771a65c4f());
                    v = $945ed6f25e45287a$export$4d3fb11e950abb9e(), o = l = $945ed6f25e45287a$export$36776f635604f274(g = j += $945ed6f25e45287a$export$c2ab62c7bf24634($945ed6f25e45287a$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $945ed6f25e45287a$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $945ed6f25e45287a$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $945ed6f25e45287a$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $945ed6f25e45287a$export$2f35ab04d2335697(e, v + 1, v = $945ed6f25e45287a$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $945ed6f25e45287a$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $945ed6f25e45287a$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $945ed6f25e45287a$export$35059013cd4a06db(e, r, a, s === 0 ? $945ed6f25e45287a$export$aa3a2e812ca8570d : i, f, o, l);
}
function $945ed6f25e45287a$export$4a34f930e789283c(e, r, a) {
    return $945ed6f25e45287a$export$35059013cd4a06db(e, r, a, $945ed6f25e45287a$export$a29989082612d0d9, $945ed6f25e45287a$export$6788812c4e6611e6($945ed6f25e45287a$export$eba6f6f03b0a92e7()), $945ed6f25e45287a$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $945ed6f25e45287a$export$f8483753829ec8f3(e, r, a, n) {
    return $945ed6f25e45287a$export$35059013cd4a06db(e, r, a, $945ed6f25e45287a$export$527d108ccf083c2b, $945ed6f25e45287a$export$2f35ab04d2335697(e, 0, n), $945ed6f25e45287a$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $945ed6f25e45287a$export$82e9f45cca5ba907(n, c, s) {
    switch($945ed6f25e45287a$export$d6af199866bfb566(n, c)){
        case 5103:
            return $945ed6f25e45287a$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $945ed6f25e45287a$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $945ed6f25e45287a$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $945ed6f25e45287a$export$39dfd62a25e0fe93 + n + $945ed6f25e45287a$export$2c0f367103c8d01c + n + $945ed6f25e45287a$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($945ed6f25e45287a$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $945ed6f25e45287a$export$39dfd62a25e0fe93 + n + $945ed6f25e45287a$export$71ad59f2e432cfe8 + $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $945ed6f25e45287a$export$39dfd62a25e0fe93 + n + $945ed6f25e45287a$export$71ad59f2e432cfe8 + $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $945ed6f25e45287a$export$39dfd62a25e0fe93 + n + $945ed6f25e45287a$export$71ad59f2e432cfe8 + $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $945ed6f25e45287a$export$39dfd62a25e0fe93 + n + $945ed6f25e45287a$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $945ed6f25e45287a$export$39dfd62a25e0fe93 + n + $945ed6f25e45287a$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $945ed6f25e45287a$export$39dfd62a25e0fe93 + n + $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $945ed6f25e45287a$export$39dfd62a25e0fe93 + "box-$1$2" + $945ed6f25e45287a$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $945ed6f25e45287a$export$39dfd62a25e0fe93 + n + $945ed6f25e45287a$export$71ad59f2e432cfe8 + "flex-item-" + $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$945ed6f25e45287a$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $945ed6f25e45287a$export$71ad59f2e432cfe8 + "grid-row-" + $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $945ed6f25e45287a$export$39dfd62a25e0fe93 + n + $945ed6f25e45287a$export$71ad59f2e432cfe8 + "flex-line-pack" + $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $945ed6f25e45287a$export$39dfd62a25e0fe93 + n + $945ed6f25e45287a$export$71ad59f2e432cfe8 + $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $945ed6f25e45287a$export$39dfd62a25e0fe93 + n + $945ed6f25e45287a$export$71ad59f2e432cfe8 + $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $945ed6f25e45287a$export$39dfd62a25e0fe93 + "box-" + $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, "-grow", "") + $945ed6f25e45287a$export$39dfd62a25e0fe93 + n + $945ed6f25e45287a$export$71ad59f2e432cfe8 + $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $945ed6f25e45287a$export$39dfd62a25e0fe93 + $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $945ed6f25e45287a$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $945ed6f25e45287a$export$77ad94ebf1c2b9ed($945ed6f25e45287a$export$77ad94ebf1c2b9ed($945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $945ed6f25e45287a$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $945ed6f25e45287a$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $945ed6f25e45287a$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $945ed6f25e45287a$export$77ad94ebf1c2b9ed($945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $945ed6f25e45287a$export$39dfd62a25e0fe93 + "box-pack:$3" + $945ed6f25e45287a$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $945ed6f25e45287a$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$945ed6f25e45287a$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $945ed6f25e45287a$export$71ad59f2e432cfe8 + "grid-column-align" + $945ed6f25e45287a$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $945ed6f25e45287a$export$71ad59f2e432cfe8 + $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $945ed6f25e45287a$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$945ed6f25e45287a$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $945ed6f25e45287a$export$71ad59f2e432cfe8 + $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $945ed6f25e45287a$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$945ed6f25e45287a$export$f8e21b1e77979a08(s, "span") ? $945ed6f25e45287a$export$4659b591c19bdf3d(s, /\d+/) : +$945ed6f25e45287a$export$4659b591c19bdf3d(s, /\d+/) - +$945ed6f25e45287a$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $945ed6f25e45287a$export$71ad59f2e432cfe8 + $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $945ed6f25e45287a$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $945ed6f25e45287a$export$71ad59f2e432cfe8 + $945ed6f25e45287a$export$77ad94ebf1c2b9ed($945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $945ed6f25e45287a$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($945ed6f25e45287a$export$36776f635604f274(n) - 1 - c > 6) switch($945ed6f25e45287a$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($945ed6f25e45287a$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $945ed6f25e45287a$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $945ed6f25e45287a$export$2c0f367103c8d01c + ($945ed6f25e45287a$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$945ed6f25e45287a$export$f8e21b1e77979a08(n, "stretch") ? $945ed6f25e45287a$export$82e9f45cca5ba907($945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $945ed6f25e45287a$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $945ed6f25e45287a$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($945ed6f25e45287a$export$a9db5e087081082d(n, c + 6) === 121) return $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, ":", ":" + $945ed6f25e45287a$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($945ed6f25e45287a$export$a9db5e087081082d(n, $945ed6f25e45287a$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $945ed6f25e45287a$export$39dfd62a25e0fe93 + ($945ed6f25e45287a$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $945ed6f25e45287a$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $945ed6f25e45287a$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, ":", ":" + $945ed6f25e45287a$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $945ed6f25e45287a$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $945ed6f25e45287a$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $945ed6f25e45287a$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $945ed6f25e45287a$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $945ed6f25e45287a$export$a763edbf796b780a:
        case $945ed6f25e45287a$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $945ed6f25e45287a$export$a29989082612d0d9:
            return "";
        case $945ed6f25e45287a$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $945ed6f25e45287a$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $945ed6f25e45287a$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $945ed6f25e45287a$export$36776f635604f274(a = $945ed6f25e45287a$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $945ed6f25e45287a$export$5a7767152ae0305f(e) {
    var r = $945ed6f25e45287a$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $945ed6f25e45287a$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $945ed6f25e45287a$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $945ed6f25e45287a$export$527d108ccf083c2b:
                n.return = $945ed6f25e45287a$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $945ed6f25e45287a$export$b44a8529a35fcb60:
                return $945ed6f25e45287a$export$dfdc1655ccc5b9cb([
                    $945ed6f25e45287a$export$784d13d8ee351f07(n, {
                        value: $945ed6f25e45287a$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $945ed6f25e45287a$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $945ed6f25e45287a$export$aa3a2e812ca8570d:
                if (n.length) return $945ed6f25e45287a$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($945ed6f25e45287a$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $945ed6f25e45287a$export$dfdc1655ccc5b9cb([
                                $945ed6f25e45287a$export$784d13d8ee351f07(n, {
                                    props: [
                                        $945ed6f25e45287a$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $945ed6f25e45287a$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $945ed6f25e45287a$export$dfdc1655ccc5b9cb([
                                $945ed6f25e45287a$export$784d13d8ee351f07(n, {
                                    props: [
                                        $945ed6f25e45287a$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $945ed6f25e45287a$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $945ed6f25e45287a$export$784d13d8ee351f07(n, {
                                    props: [
                                        $945ed6f25e45287a$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $945ed6f25e45287a$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $945ed6f25e45287a$export$784d13d8ee351f07(n, {
                                    props: [
                                        $945ed6f25e45287a$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $945ed6f25e45287a$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $945ed6f25e45287a$export$76a88f7de6507443(e) {
    switch(e.type){
        case $945ed6f25e45287a$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $945ed6f25e45287a$export$1be1fc439b849fdf($945ed6f25e45287a$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($945ed6f25e45287a$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $945ed6f25e45287a$export$2f35ab04d2335697(r, 1, $945ed6f25e45287a$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $945ed6f25e45287a$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $945ed6f25e45287a$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $945ed6f25e45287a$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("7TUmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c09636db5e54f5b$export$2e2bcd8739ae039);
var $5c09636db5e54f5b$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("dsA1p", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cc9d5087b917b3c$export$2e2bcd8739ae039);
function $9cc9d5087b917b3c$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("KGL60", function(module, exports) {

$parcel$export(module.exports, "default", () => $08c576f655d9f788$export$2e2bcd8739ae039);

var $i9tl0 = parcelRequire("i9tl0");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $08c576f655d9f788$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($i9tl0)))(targetComponent, sourceComponent);
};

});
parcelRegister("i9tl0", function(module, exports) {
'use strict';

var $lujjb = parcelRequire("lujjb");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $d36fd325aa9cd77e$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $d36fd325aa9cd77e$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $d36fd325aa9cd77e$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $d36fd325aa9cd77e$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $d36fd325aa9cd77e$var$TYPE_STATICS = {};
$d36fd325aa9cd77e$var$TYPE_STATICS[$lujjb.ForwardRef] = $d36fd325aa9cd77e$var$FORWARD_REF_STATICS;
$d36fd325aa9cd77e$var$TYPE_STATICS[$lujjb.Memo] = $d36fd325aa9cd77e$var$MEMO_STATICS;
function $d36fd325aa9cd77e$var$getStatics(component) {
    // React v16.11 and below
    if ($lujjb.isMemo(component)) return $d36fd325aa9cd77e$var$MEMO_STATICS;
     // React v16.12 and above
    return $d36fd325aa9cd77e$var$TYPE_STATICS[component['$$typeof']] || $d36fd325aa9cd77e$var$REACT_STATICS;
}
var $d36fd325aa9cd77e$var$defineProperty = Object.defineProperty;
var $d36fd325aa9cd77e$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $d36fd325aa9cd77e$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $d36fd325aa9cd77e$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $d36fd325aa9cd77e$var$getPrototypeOf = Object.getPrototypeOf;
var $d36fd325aa9cd77e$var$objectPrototype = Object.prototype;
function $d36fd325aa9cd77e$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($d36fd325aa9cd77e$var$objectPrototype) {
            var inheritedComponent = $d36fd325aa9cd77e$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $d36fd325aa9cd77e$var$objectPrototype) $d36fd325aa9cd77e$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $d36fd325aa9cd77e$var$getOwnPropertyNames(sourceComponent);
        if ($d36fd325aa9cd77e$var$getOwnPropertySymbols) keys = keys.concat($d36fd325aa9cd77e$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $d36fd325aa9cd77e$var$getStatics(targetComponent);
        var sourceStatics = $d36fd325aa9cd77e$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$d36fd325aa9cd77e$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $d36fd325aa9cd77e$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $d36fd325aa9cd77e$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $d36fd325aa9cd77e$var$hoistNonReactStatics;

});
parcelRegister("lujjb", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iHhrr"));

});
parcelRegister("iHhrr", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $d9c9c5b2a7915df1$export$2b8d127b894957b9, (v) => $d9c9c5b2a7915df1$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $d9c9c5b2a7915df1$export$cea3a54a6425200c, (v) => $d9c9c5b2a7915df1$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $d9c9c5b2a7915df1$export$a7c73072b1a182ae, (v) => $d9c9c5b2a7915df1$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $d9c9c5b2a7915df1$export$9f27bc3417b4524d, (v) => $d9c9c5b2a7915df1$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $d9c9c5b2a7915df1$export$db77ccec0bb4ccac, (v) => $d9c9c5b2a7915df1$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $d9c9c5b2a7915df1$export$8392c0c9d3dcbd35, (v) => $d9c9c5b2a7915df1$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $d9c9c5b2a7915df1$export$ffb0004e005737fa, (v) => $d9c9c5b2a7915df1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $d9c9c5b2a7915df1$export$b624eff549462981, (v) => $d9c9c5b2a7915df1$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $d9c9c5b2a7915df1$export$7897aa7841a5380c, (v) => $d9c9c5b2a7915df1$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $d9c9c5b2a7915df1$export$602eac185826482c, (v) => $d9c9c5b2a7915df1$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $d9c9c5b2a7915df1$export$e2c29f18771995cb, (v) => $d9c9c5b2a7915df1$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $d9c9c5b2a7915df1$export$5f8d39834fd61797, (v) => $d9c9c5b2a7915df1$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $d9c9c5b2a7915df1$export$74bf444e3cd11ea5, (v) => $d9c9c5b2a7915df1$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $d9c9c5b2a7915df1$export$92387174baf9b227, (v) => $d9c9c5b2a7915df1$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $d9c9c5b2a7915df1$export$ec112efeb987d9c6, (v) => $d9c9c5b2a7915df1$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $d9c9c5b2a7915df1$export$b706b080d889d2c9, (v) => $d9c9c5b2a7915df1$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $d9c9c5b2a7915df1$export$5be5a87408f70ddc, (v) => $d9c9c5b2a7915df1$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $d9c9c5b2a7915df1$export$45a5e7f76e0caa8d, (v) => $d9c9c5b2a7915df1$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $d9c9c5b2a7915df1$export$455c2e768291efa6, (v) => $d9c9c5b2a7915df1$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $d9c9c5b2a7915df1$export$9522e17588c12572, (v) => $d9c9c5b2a7915df1$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $d9c9c5b2a7915df1$export$2110ac352bb060b9, (v) => $d9c9c5b2a7915df1$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $d9c9c5b2a7915df1$export$56885ab8b9c456ab, (v) => $d9c9c5b2a7915df1$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $d9c9c5b2a7915df1$export$d927fcb6adf8f9de, (v) => $d9c9c5b2a7915df1$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $d9c9c5b2a7915df1$export$b82d16f27459e05a, (v) => $d9c9c5b2a7915df1$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $d9c9c5b2a7915df1$export$522c17b4f5e123e8, (v) => $d9c9c5b2a7915df1$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $d9c9c5b2a7915df1$export$1aabd8a0274ecfd6, (v) => $d9c9c5b2a7915df1$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $d9c9c5b2a7915df1$export$9b621391a187a31a, (v) => $d9c9c5b2a7915df1$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $d9c9c5b2a7915df1$export$f5bbd400c2f4426f, (v) => $d9c9c5b2a7915df1$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d9c9c5b2a7915df1$export$2b8d127b894957b9;
var $d9c9c5b2a7915df1$export$cea3a54a6425200c;
var $d9c9c5b2a7915df1$export$a7c73072b1a182ae;
var $d9c9c5b2a7915df1$export$9f27bc3417b4524d;
var $d9c9c5b2a7915df1$export$db77ccec0bb4ccac;
var $d9c9c5b2a7915df1$export$8392c0c9d3dcbd35;
var $d9c9c5b2a7915df1$export$ffb0004e005737fa;
var $d9c9c5b2a7915df1$export$b624eff549462981;
var $d9c9c5b2a7915df1$export$7897aa7841a5380c;
var $d9c9c5b2a7915df1$export$602eac185826482c;
var $d9c9c5b2a7915df1$export$e2c29f18771995cb;
var $d9c9c5b2a7915df1$export$5f8d39834fd61797;
var $d9c9c5b2a7915df1$export$74bf444e3cd11ea5;
var $d9c9c5b2a7915df1$export$92387174baf9b227;
var $d9c9c5b2a7915df1$export$ec112efeb987d9c6;
var $d9c9c5b2a7915df1$export$b706b080d889d2c9;
var $d9c9c5b2a7915df1$export$5be5a87408f70ddc;
var $d9c9c5b2a7915df1$export$45a5e7f76e0caa8d;
var $d9c9c5b2a7915df1$export$455c2e768291efa6;
var $d9c9c5b2a7915df1$export$9522e17588c12572;
var $d9c9c5b2a7915df1$export$2110ac352bb060b9;
var $d9c9c5b2a7915df1$export$56885ab8b9c456ab;
var $d9c9c5b2a7915df1$export$d927fcb6adf8f9de;
var $d9c9c5b2a7915df1$export$b82d16f27459e05a;
var $d9c9c5b2a7915df1$export$522c17b4f5e123e8;
var $d9c9c5b2a7915df1$export$1aabd8a0274ecfd6;
var $d9c9c5b2a7915df1$export$9b621391a187a31a;
var $d9c9c5b2a7915df1$export$f5bbd400c2f4426f;
'use strict';
var $d9c9c5b2a7915df1$var$b = "function" === typeof Symbol && Symbol.for, $d9c9c5b2a7915df1$var$c = $d9c9c5b2a7915df1$var$b ? Symbol.for("react.element") : 60103, $d9c9c5b2a7915df1$var$d = $d9c9c5b2a7915df1$var$b ? Symbol.for("react.portal") : 60106, $d9c9c5b2a7915df1$var$e = $d9c9c5b2a7915df1$var$b ? Symbol.for("react.fragment") : 60107, $d9c9c5b2a7915df1$var$f = $d9c9c5b2a7915df1$var$b ? Symbol.for("react.strict_mode") : 60108, $d9c9c5b2a7915df1$var$g = $d9c9c5b2a7915df1$var$b ? Symbol.for("react.profiler") : 60114, $d9c9c5b2a7915df1$var$h = $d9c9c5b2a7915df1$var$b ? Symbol.for("react.provider") : 60109, $d9c9c5b2a7915df1$var$k = $d9c9c5b2a7915df1$var$b ? Symbol.for("react.context") : 60110, $d9c9c5b2a7915df1$var$l = $d9c9c5b2a7915df1$var$b ? Symbol.for("react.async_mode") : 60111, $d9c9c5b2a7915df1$var$m = $d9c9c5b2a7915df1$var$b ? Symbol.for("react.concurrent_mode") : 60111, $d9c9c5b2a7915df1$var$n = $d9c9c5b2a7915df1$var$b ? Symbol.for("react.forward_ref") : 60112, $d9c9c5b2a7915df1$var$p = $d9c9c5b2a7915df1$var$b ? Symbol.for("react.suspense") : 60113, $d9c9c5b2a7915df1$var$q = $d9c9c5b2a7915df1$var$b ? Symbol.for("react.suspense_list") : 60120, $d9c9c5b2a7915df1$var$r = $d9c9c5b2a7915df1$var$b ? Symbol.for("react.memo") : 60115, $d9c9c5b2a7915df1$var$t = $d9c9c5b2a7915df1$var$b ? Symbol.for("react.lazy") : 60116, $d9c9c5b2a7915df1$var$v = $d9c9c5b2a7915df1$var$b ? Symbol.for("react.block") : 60121, $d9c9c5b2a7915df1$var$w = $d9c9c5b2a7915df1$var$b ? Symbol.for("react.fundamental") : 60117, $d9c9c5b2a7915df1$var$x = $d9c9c5b2a7915df1$var$b ? Symbol.for("react.responder") : 60118, $d9c9c5b2a7915df1$var$y = $d9c9c5b2a7915df1$var$b ? Symbol.for("react.scope") : 60119;
function $d9c9c5b2a7915df1$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $d9c9c5b2a7915df1$var$c:
                switch(a = a.type, a){
                    case $d9c9c5b2a7915df1$var$l:
                    case $d9c9c5b2a7915df1$var$m:
                    case $d9c9c5b2a7915df1$var$e:
                    case $d9c9c5b2a7915df1$var$g:
                    case $d9c9c5b2a7915df1$var$f:
                    case $d9c9c5b2a7915df1$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $d9c9c5b2a7915df1$var$k:
                            case $d9c9c5b2a7915df1$var$n:
                            case $d9c9c5b2a7915df1$var$t:
                            case $d9c9c5b2a7915df1$var$r:
                            case $d9c9c5b2a7915df1$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $d9c9c5b2a7915df1$var$d:
                return u;
        }
    }
}
function $d9c9c5b2a7915df1$var$A(a) {
    return $d9c9c5b2a7915df1$var$z(a) === $d9c9c5b2a7915df1$var$m;
}
$d9c9c5b2a7915df1$export$2b8d127b894957b9 = $d9c9c5b2a7915df1$var$l;
$d9c9c5b2a7915df1$export$cea3a54a6425200c = $d9c9c5b2a7915df1$var$m;
$d9c9c5b2a7915df1$export$a7c73072b1a182ae = $d9c9c5b2a7915df1$var$k;
$d9c9c5b2a7915df1$export$9f27bc3417b4524d = $d9c9c5b2a7915df1$var$h;
$d9c9c5b2a7915df1$export$db77ccec0bb4ccac = $d9c9c5b2a7915df1$var$c;
$d9c9c5b2a7915df1$export$8392c0c9d3dcbd35 = $d9c9c5b2a7915df1$var$n;
$d9c9c5b2a7915df1$export$ffb0004e005737fa = $d9c9c5b2a7915df1$var$e;
$d9c9c5b2a7915df1$export$b624eff549462981 = $d9c9c5b2a7915df1$var$t;
$d9c9c5b2a7915df1$export$7897aa7841a5380c = $d9c9c5b2a7915df1$var$r;
$d9c9c5b2a7915df1$export$602eac185826482c = $d9c9c5b2a7915df1$var$d;
$d9c9c5b2a7915df1$export$e2c29f18771995cb = $d9c9c5b2a7915df1$var$g;
$d9c9c5b2a7915df1$export$5f8d39834fd61797 = $d9c9c5b2a7915df1$var$f;
$d9c9c5b2a7915df1$export$74bf444e3cd11ea5 = $d9c9c5b2a7915df1$var$p;
$d9c9c5b2a7915df1$export$92387174baf9b227 = function(a) {
    return $d9c9c5b2a7915df1$var$A(a) || $d9c9c5b2a7915df1$var$z(a) === $d9c9c5b2a7915df1$var$l;
};
$d9c9c5b2a7915df1$export$ec112efeb987d9c6 = $d9c9c5b2a7915df1$var$A;
$d9c9c5b2a7915df1$export$b706b080d889d2c9 = function(a) {
    return $d9c9c5b2a7915df1$var$z(a) === $d9c9c5b2a7915df1$var$k;
};
$d9c9c5b2a7915df1$export$5be5a87408f70ddc = function(a) {
    return $d9c9c5b2a7915df1$var$z(a) === $d9c9c5b2a7915df1$var$h;
};
$d9c9c5b2a7915df1$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $d9c9c5b2a7915df1$var$c;
};
$d9c9c5b2a7915df1$export$455c2e768291efa6 = function(a) {
    return $d9c9c5b2a7915df1$var$z(a) === $d9c9c5b2a7915df1$var$n;
};
$d9c9c5b2a7915df1$export$9522e17588c12572 = function(a) {
    return $d9c9c5b2a7915df1$var$z(a) === $d9c9c5b2a7915df1$var$e;
};
$d9c9c5b2a7915df1$export$2110ac352bb060b9 = function(a) {
    return $d9c9c5b2a7915df1$var$z(a) === $d9c9c5b2a7915df1$var$t;
};
$d9c9c5b2a7915df1$export$56885ab8b9c456ab = function(a) {
    return $d9c9c5b2a7915df1$var$z(a) === $d9c9c5b2a7915df1$var$r;
};
$d9c9c5b2a7915df1$export$d927fcb6adf8f9de = function(a) {
    return $d9c9c5b2a7915df1$var$z(a) === $d9c9c5b2a7915df1$var$d;
};
$d9c9c5b2a7915df1$export$b82d16f27459e05a = function(a) {
    return $d9c9c5b2a7915df1$var$z(a) === $d9c9c5b2a7915df1$var$g;
};
$d9c9c5b2a7915df1$export$522c17b4f5e123e8 = function(a) {
    return $d9c9c5b2a7915df1$var$z(a) === $d9c9c5b2a7915df1$var$f;
};
$d9c9c5b2a7915df1$export$1aabd8a0274ecfd6 = function(a) {
    return $d9c9c5b2a7915df1$var$z(a) === $d9c9c5b2a7915df1$var$p;
};
$d9c9c5b2a7915df1$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $d9c9c5b2a7915df1$var$e || a === $d9c9c5b2a7915df1$var$m || a === $d9c9c5b2a7915df1$var$g || a === $d9c9c5b2a7915df1$var$f || a === $d9c9c5b2a7915df1$var$p || a === $d9c9c5b2a7915df1$var$q || "object" === typeof a && null !== a && (a.$$typeof === $d9c9c5b2a7915df1$var$t || a.$$typeof === $d9c9c5b2a7915df1$var$r || a.$$typeof === $d9c9c5b2a7915df1$var$h || a.$$typeof === $d9c9c5b2a7915df1$var$k || a.$$typeof === $d9c9c5b2a7915df1$var$n || a.$$typeof === $d9c9c5b2a7915df1$var$w || a.$$typeof === $d9c9c5b2a7915df1$var$x || a.$$typeof === $d9c9c5b2a7915df1$var$y || a.$$typeof === $d9c9c5b2a7915df1$var$v);
};
$d9c9c5b2a7915df1$export$f5bbd400c2f4426f = $d9c9c5b2a7915df1$var$z;

});




parcelRegister("hYp2W", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $d15b77fb1559cf25$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $d15b77fb1559cf25$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $d15b77fb1559cf25$export$6f077d94b33a01aa);
var $d15b77fb1559cf25$var$isBrowser = true;
function $d15b77fb1559cf25$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $d15b77fb1559cf25$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $d15b77fb1559cf25$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $d15b77fb1559cf25$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $d15b77fb1559cf25$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("c4JlO", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $8ca90981e98b175a$export$6321afa313b251b5);

var $32xUe = parcelRequire("32xUe");

var $gUUTW = parcelRequire("gUUTW");

var $dsA1p = parcelRequire("dsA1p");
var $8ca90981e98b175a$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $8ca90981e98b175a$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $8ca90981e98b175a$var$hyphenateRegex = /[A-Z]|^ms/g;
var $8ca90981e98b175a$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $8ca90981e98b175a$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $8ca90981e98b175a$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $8ca90981e98b175a$var$processStyleName = /* #__PURE__ */ (0, $dsA1p.default)(function(styleName) {
    return $8ca90981e98b175a$var$isCustomProperty(styleName) ? styleName : styleName.replace($8ca90981e98b175a$var$hyphenateRegex, '-$&').toLowerCase();
});
var $8ca90981e98b175a$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($8ca90981e98b175a$var$animationRegex, function(match, p1, p2) {
                $8ca90981e98b175a$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $8ca90981e98b175a$var$cursor
                };
                return p1;
            });
    }
    if ((0, $gUUTW.default)[key] !== 1 && !$8ca90981e98b175a$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $8ca90981e98b175a$var$contentValuePattern, $8ca90981e98b175a$var$contentValues, $8ca90981e98b175a$var$oldProcessStyleValue, $8ca90981e98b175a$var$msPattern, $8ca90981e98b175a$var$hyphenPattern, $8ca90981e98b175a$var$hyphenatedCache;
var $8ca90981e98b175a$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $8ca90981e98b175a$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $8ca90981e98b175a$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $8ca90981e98b175a$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $8ca90981e98b175a$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $8ca90981e98b175a$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $8ca90981e98b175a$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $8ca90981e98b175a$var$cursor;
                var result = interpolation(mergedProps);
                $8ca90981e98b175a$var$cursor = previousCursor;
                return $8ca90981e98b175a$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $8ca90981e98b175a$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $8ca90981e98b175a$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($8ca90981e98b175a$var$isProcessableValue(value)) string += $8ca90981e98b175a$var$processStyleName(_key) + ":" + $8ca90981e98b175a$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($8ca90981e98b175a$var$isProcessableValue(value[_i])) string += $8ca90981e98b175a$var$processStyleName(_key) + ":" + $8ca90981e98b175a$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $8ca90981e98b175a$var$handleInterpolation(mergedProps, registered, value);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $8ca90981e98b175a$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $8ca90981e98b175a$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $8ca90981e98b175a$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $8ca90981e98b175a$var$cursor;
var $8ca90981e98b175a$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $8ca90981e98b175a$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $8ca90981e98b175a$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $8ca90981e98b175a$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $8ca90981e98b175a$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $8ca90981e98b175a$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $32xUe.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $8ca90981e98b175a$var$cursor
    };
};

});
parcelRegister("32xUe", function(module, exports) {

$parcel$export(module.exports, "default", () => $236bdc009d38b1b8$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $236bdc009d38b1b8$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("gUUTW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c50e03b7fb0cf235$export$2e2bcd8739ae039);
var $c50e03b7fb0cf235$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("a3GsN", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $752b1f87a3744f93$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $752b1f87a3744f93$export$811a713a7276cb9d);

var $28UcW = parcelRequire("28UcW");
var $752b1f87a3744f93$var$syncFallback = function syncFallback(create) {
    return create();
};
var $752b1f87a3744f93$var$useInsertionEffect = $28UcW.useInsertionEffect ? $28UcW.useInsertionEffect : false;
var $752b1f87a3744f93$export$db21c7ffa21794e7 = $752b1f87a3744f93$var$useInsertionEffect || $752b1f87a3744f93$var$syncFallback;
var $752b1f87a3744f93$export$811a713a7276cb9d = $752b1f87a3744f93$var$useInsertionEffect || $28UcW.useLayoutEffect;

});


parcelRegister("2ZOLb", function(module, exports) {
function $22e8a72cf7c9425c$var$_extends() {
    module.exports = $22e8a72cf7c9425c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $22e8a72cf7c9425c$var$_extends.apply(this, arguments);
}
module.exports = $22e8a72cf7c9425c$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("dpWha", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c4ad0842437964f$export$2e2bcd8739ae039);

var $UbLFR = parcelRequire("UbLFR");
'use client';
const $9c4ad0842437964f$var$defaultTheme = (0, $UbLFR.default)();
var $9c4ad0842437964f$export$2e2bcd8739ae039 = $9c4ad0842437964f$var$defaultTheme;

});
parcelRegister("UbLFR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a8e5bf1c62b0520$export$2e2bcd8739ae039);

var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $3H5bK = parcelRequire("3H5bK");

var $8HP8E = parcelRequire("8HP8E");

var $iJ7JK = parcelRequire("iJ7JK");
var $9DlDG = parcelRequire("9DlDG");

var $7zKsg = parcelRequire("7zKsg");


var $liYsc = parcelRequire("liYsc");

var $jsown = parcelRequire("jsown");

var $bYv50 = parcelRequire("bYv50");

var $95Wi7 = parcelRequire("95Wi7");

var $bYQex = parcelRequire("bYQex");

var $amcTi = parcelRequire("amcTi");
const $0a8e5bf1c62b0520$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $0a8e5bf1c62b0520$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $53Ou4.default)(options, $0a8e5bf1c62b0520$var$_excluded);
    if (options.vars) throw new Error((0, $3H5bK.default)(18));
    const palette = (0, $jsown.default)(paletteInput);
    const systemTheme = (0, $7zKsg.default)(options);
    let muiTheme = (0, $8HP8E.default)(systemTheme, {
        mixins: (0, $liYsc.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $95Wi7.default).slice(),
        typography: (0, $bYv50.default)(palette, typographyInput),
        transitions: (0, $bYQex.default)(transitionsInput),
        zIndex: (0, $kLZMq.default)({}, (0, $amcTi.default))
    });
    muiTheme = (0, $8HP8E.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $8HP8E.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $kLZMq.default)({}, (0, $9DlDG.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $iJ7JK.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $0a8e5bf1c62b0520$var$warnedOnce = false;
function $0a8e5bf1c62b0520$export$c469355549431d9b(...args) {
    return $0a8e5bf1c62b0520$var$createTheme(...args);
}
var $0a8e5bf1c62b0520$export$2e2bcd8739ae039 = $0a8e5bf1c62b0520$var$createTheme;

});
parcelRegister("liYsc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f82a2c4f4b12aa49$export$2e2bcd8739ae039);

var $kLZMq = parcelRequire("kLZMq");
function $f82a2c4f4b12aa49$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $kLZMq.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("jsown", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2a3a73e78a242dd$export$2e2bcd8739ae039);

var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $3H5bK = parcelRequire("3H5bK");

var $8HP8E = parcelRequire("8HP8E");

var $aMDDU = parcelRequire("aMDDU");

var $kbYP9 = parcelRequire("kbYP9");

var $lgBmr = parcelRequire("lgBmr");

var $hAW7x = parcelRequire("hAW7x");

var $jO3nB = parcelRequire("jO3nB");

var $4k4Fr = parcelRequire("4k4Fr");

var $c41Z5 = parcelRequire("c41Z5");

var $b0Lco = parcelRequire("b0Lco");

var $hw3U1 = parcelRequire("hw3U1");
const $e2a3a73e78a242dd$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $e2a3a73e78a242dd$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $kbYP9.default).white,
        default: (0, $kbYP9.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $e2a3a73e78a242dd$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $kbYP9.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $kbYP9.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $e2a3a73e78a242dd$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $aMDDU.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $aMDDU.darken)(intent.main, tonalOffsetDark);
    }
}
function $e2a3a73e78a242dd$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $c41Z5.default)[200],
        light: (0, $c41Z5.default)[50],
        dark: (0, $c41Z5.default)[400]
    };
    return {
        main: (0, $c41Z5.default)[700],
        light: (0, $c41Z5.default)[400],
        dark: (0, $c41Z5.default)[800]
    };
}
function $e2a3a73e78a242dd$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $hAW7x.default)[200],
        light: (0, $hAW7x.default)[50],
        dark: (0, $hAW7x.default)[400]
    };
    return {
        main: (0, $hAW7x.default)[500],
        light: (0, $hAW7x.default)[300],
        dark: (0, $hAW7x.default)[700]
    };
}
function $e2a3a73e78a242dd$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $jO3nB.default)[500],
        light: (0, $jO3nB.default)[300],
        dark: (0, $jO3nB.default)[700]
    };
    return {
        main: (0, $jO3nB.default)[700],
        light: (0, $jO3nB.default)[400],
        dark: (0, $jO3nB.default)[800]
    };
}
function $e2a3a73e78a242dd$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $b0Lco.default)[400],
        light: (0, $b0Lco.default)[300],
        dark: (0, $b0Lco.default)[700]
    };
    return {
        main: (0, $b0Lco.default)[700],
        light: (0, $b0Lco.default)[500],
        dark: (0, $b0Lco.default)[900]
    };
}
function $e2a3a73e78a242dd$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $hw3U1.default)[400],
        light: (0, $hw3U1.default)[300],
        dark: (0, $hw3U1.default)[700]
    };
    return {
        main: (0, $hw3U1.default)[800],
        light: (0, $hw3U1.default)[500],
        dark: (0, $hw3U1.default)[900]
    };
}
function $e2a3a73e78a242dd$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $4k4Fr.default)[400],
        light: (0, $4k4Fr.default)[300],
        dark: (0, $4k4Fr.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $4k4Fr.default)[500],
        dark: (0, $4k4Fr.default)[900]
    };
}
function $e2a3a73e78a242dd$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $53Ou4.default)(palette, $e2a3a73e78a242dd$var$_excluded);
    const primary = palette.primary || $e2a3a73e78a242dd$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $e2a3a73e78a242dd$var$getDefaultSecondary(mode);
    const error = palette.error || $e2a3a73e78a242dd$var$getDefaultError(mode);
    const info = palette.info || $e2a3a73e78a242dd$var$getDefaultInfo(mode);
    const success = palette.success || $e2a3a73e78a242dd$var$getDefaultSuccess(mode);
    const warning = palette.warning || $e2a3a73e78a242dd$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $aMDDU.getContrastRatio)(background, $e2a3a73e78a242dd$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $e2a3a73e78a242dd$export$55ce6f3a06c59543.text.primary : $e2a3a73e78a242dd$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $kLZMq.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $3H5bK.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $3H5bK.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $e2a3a73e78a242dd$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $e2a3a73e78a242dd$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $e2a3a73e78a242dd$export$55ce6f3a06c59543,
        light: $e2a3a73e78a242dd$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $8HP8E.default)((0, $kLZMq.default)({
        // A collection of common colors.
        common: (0, $kLZMq.default)({}, (0, $kbYP9.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $lgBmr.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("aMDDU", function(module, exports) {
"use strict";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $7d9d2345624bd625$var$alpha;
module.exports.blend = $7d9d2345624bd625$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $7d9d2345624bd625$var$darken;
module.exports.decomposeColor = $7d9d2345624bd625$var$decomposeColor;
module.exports.emphasize = $7d9d2345624bd625$var$emphasize;
module.exports.getContrastRatio = $7d9d2345624bd625$var$getContrastRatio;
module.exports.getLuminance = $7d9d2345624bd625$var$getLuminance;
module.exports.hexToRgb = $7d9d2345624bd625$var$hexToRgb;
module.exports.hslToRgb = $7d9d2345624bd625$var$hslToRgb;
module.exports.lighten = $7d9d2345624bd625$var$lighten;
module.exports.private_safeAlpha = $7d9d2345624bd625$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $7d9d2345624bd625$var$private_safeDarken;
module.exports.private_safeEmphasize = $7d9d2345624bd625$var$private_safeEmphasize;
module.exports.private_safeLighten = $7d9d2345624bd625$var$private_safeLighten;
module.exports.recomposeColor = $7d9d2345624bd625$var$recomposeColor;
module.exports.rgbToHex = $7d9d2345624bd625$var$rgbToHex;

var $7d9d2345624bd625$var$_formatMuiErrorMessage2 = $9C5EU((parcelRequire("4Vcoo")));

var $7d9d2345624bd625$var$_clamp = $9C5EU((parcelRequire("22ZKS")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $7d9d2345624bd625$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $7d9d2345624bd625$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $7d9d2345624bd625$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $7d9d2345624bd625$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $7d9d2345624bd625$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $7d9d2345624bd625$var$decomposeColor($7d9d2345624bd625$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $7d9d2345624bd625$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $7d9d2345624bd625$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $7d9d2345624bd625$var$colorChannel = (color)=>{
    const decomposedColor = $7d9d2345624bd625$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $7d9d2345624bd625$var$colorChannel;
const $7d9d2345624bd625$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $7d9d2345624bd625$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $7d9d2345624bd625$var$private_safeColorChannel;
function $7d9d2345624bd625$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $7d9d2345624bd625$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $7d9d2345624bd625$var$decomposeColor(color);
    return `#${values.map((n, i)=>$7d9d2345624bd625$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $7d9d2345624bd625$var$hslToRgb(color) {
    color = $7d9d2345624bd625$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $7d9d2345624bd625$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $7d9d2345624bd625$var$getLuminance(color) {
    color = $7d9d2345624bd625$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $7d9d2345624bd625$var$decomposeColor($7d9d2345624bd625$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $7d9d2345624bd625$var$getContrastRatio(foreground, background) {
    const lumA = $7d9d2345624bd625$var$getLuminance(foreground);
    const lumB = $7d9d2345624bd625$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $7d9d2345624bd625$var$alpha(color, value) {
    color = $7d9d2345624bd625$var$decomposeColor(color);
    value = $7d9d2345624bd625$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $7d9d2345624bd625$var$recomposeColor(color);
}
function $7d9d2345624bd625$var$private_safeAlpha(color, value, warning) {
    try {
        return $7d9d2345624bd625$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $7d9d2345624bd625$var$darken(color, coefficient) {
    color = $7d9d2345624bd625$var$decomposeColor(color);
    coefficient = $7d9d2345624bd625$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $7d9d2345624bd625$var$recomposeColor(color);
}
function $7d9d2345624bd625$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $7d9d2345624bd625$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $7d9d2345624bd625$var$lighten(color, coefficient) {
    color = $7d9d2345624bd625$var$decomposeColor(color);
    coefficient = $7d9d2345624bd625$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $7d9d2345624bd625$var$recomposeColor(color);
}
function $7d9d2345624bd625$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $7d9d2345624bd625$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $7d9d2345624bd625$var$emphasize(color, coefficient = 0.15) {
    return $7d9d2345624bd625$var$getLuminance(color) > 0.5 ? $7d9d2345624bd625$var$darken(color, coefficient) : $7d9d2345624bd625$var$lighten(color, coefficient);
}
function $7d9d2345624bd625$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $7d9d2345624bd625$var$private_safeEmphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $7d9d2345624bd625$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $7d9d2345624bd625$var$decomposeColor(background);
    const overlayColor = $7d9d2345624bd625$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $7d9d2345624bd625$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("9C5EU", function(module, exports) {
function $6ffc0d5dc512d247$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $6ffc0d5dc512d247$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4Vcoo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("3H5bK")).default);

var $3H5bK = parcelRequire("3H5bK");

});

parcelRegister("22ZKS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("hKGGQ")).default);

var $hKGGQ = parcelRequire("hKGGQ");

});
parcelRegister("hKGGQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cec7d8eb970dd479$export$2e2bcd8739ae039);
function $cec7d8eb970dd479$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $cec7d8eb970dd479$export$2e2bcd8739ae039 = $cec7d8eb970dd479$var$clamp;

});



parcelRegister("kbYP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb34041c4af35656$export$2e2bcd8739ae039);
const $eb34041c4af35656$var$common = {
    black: '#000',
    white: '#fff'
};
var $eb34041c4af35656$export$2e2bcd8739ae039 = $eb34041c4af35656$var$common;

});

parcelRegister("lgBmr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7b812afcb7022cc$export$2e2bcd8739ae039);
const $f7b812afcb7022cc$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $f7b812afcb7022cc$export$2e2bcd8739ae039 = $f7b812afcb7022cc$var$grey;

});

parcelRegister("hAW7x", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccf2e2041189c35e$export$2e2bcd8739ae039);
const $ccf2e2041189c35e$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $ccf2e2041189c35e$export$2e2bcd8739ae039 = $ccf2e2041189c35e$var$purple;

});

parcelRegister("jO3nB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6b54ef445bd5c9d$export$2e2bcd8739ae039);
const $e6b54ef445bd5c9d$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $e6b54ef445bd5c9d$export$2e2bcd8739ae039 = $e6b54ef445bd5c9d$var$red;

});

parcelRegister("4k4Fr", function(module, exports) {

$parcel$export(module.exports, "default", () => $325ca687492d6a55$export$2e2bcd8739ae039);
const $325ca687492d6a55$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $325ca687492d6a55$export$2e2bcd8739ae039 = $325ca687492d6a55$var$orange;

});

parcelRegister("c41Z5", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c8765c71a81ef3a$export$2e2bcd8739ae039);
const $8c8765c71a81ef3a$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $8c8765c71a81ef3a$export$2e2bcd8739ae039 = $8c8765c71a81ef3a$var$blue;

});

parcelRegister("b0Lco", function(module, exports) {

$parcel$export(module.exports, "default", () => $80444e7cfeaabf69$export$2e2bcd8739ae039);
const $80444e7cfeaabf69$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $80444e7cfeaabf69$export$2e2bcd8739ae039 = $80444e7cfeaabf69$var$lightBlue;

});

parcelRegister("hw3U1", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc0873c877bfd020$export$2e2bcd8739ae039);
const $cc0873c877bfd020$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $cc0873c877bfd020$export$2e2bcd8739ae039 = $cc0873c877bfd020$var$green;

});


parcelRegister("bYv50", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b7d681e79b5e1f2$export$2e2bcd8739ae039);

var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $8HP8E = parcelRequire("8HP8E");
const $8b7d681e79b5e1f2$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $8b7d681e79b5e1f2$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $8b7d681e79b5e1f2$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $8b7d681e79b5e1f2$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $8b7d681e79b5e1f2$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $8b7d681e79b5e1f2$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $53Ou4.default)(_ref, $8b7d681e79b5e1f2$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $kLZMq.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $8b7d681e79b5e1f2$var$defaultFontFamily ? {
            letterSpacing: `${$8b7d681e79b5e1f2$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $8b7d681e79b5e1f2$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $8b7d681e79b5e1f2$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $8HP8E.default)((0, $kLZMq.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("95Wi7", function(module, exports) {

$parcel$export(module.exports, "default", () => $69f1cc202bf94d7c$export$2e2bcd8739ae039);
const $69f1cc202bf94d7c$var$shadowKeyUmbraOpacity = 0.2;
const $69f1cc202bf94d7c$var$shadowKeyPenumbraOpacity = 0.14;
const $69f1cc202bf94d7c$var$shadowAmbientShadowOpacity = 0.12;
function $69f1cc202bf94d7c$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$69f1cc202bf94d7c$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$69f1cc202bf94d7c$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$69f1cc202bf94d7c$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $69f1cc202bf94d7c$var$shadows = [
    'none',
    $69f1cc202bf94d7c$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $69f1cc202bf94d7c$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $69f1cc202bf94d7c$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $69f1cc202bf94d7c$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $69f1cc202bf94d7c$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $69f1cc202bf94d7c$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $69f1cc202bf94d7c$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $69f1cc202bf94d7c$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $69f1cc202bf94d7c$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $69f1cc202bf94d7c$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $69f1cc202bf94d7c$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $69f1cc202bf94d7c$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $69f1cc202bf94d7c$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $69f1cc202bf94d7c$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $69f1cc202bf94d7c$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $69f1cc202bf94d7c$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $69f1cc202bf94d7c$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $69f1cc202bf94d7c$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $69f1cc202bf94d7c$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $69f1cc202bf94d7c$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $69f1cc202bf94d7c$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $69f1cc202bf94d7c$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $69f1cc202bf94d7c$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $69f1cc202bf94d7c$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $69f1cc202bf94d7c$export$2e2bcd8739ae039 = $69f1cc202bf94d7c$var$shadows;

});

parcelRegister("bYQex", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b8dd0ca15b385fb$export$2e2bcd8739ae039);

var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");
const $8b8dd0ca15b385fb$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $8b8dd0ca15b385fb$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $8b8dd0ca15b385fb$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $8b8dd0ca15b385fb$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $8b8dd0ca15b385fb$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $8b8dd0ca15b385fb$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $kLZMq.default)({}, $8b8dd0ca15b385fb$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $kLZMq.default)({}, $8b8dd0ca15b385fb$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $53Ou4.default)(options, $8b8dd0ca15b385fb$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $8b8dd0ca15b385fb$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $8b8dd0ca15b385fb$var$formatMs(delay)}`).join(',');
    };
    return (0, $kLZMq.default)({
        getAutoHeightDuration: $8b8dd0ca15b385fb$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("amcTi", function(module, exports) {

$parcel$export(module.exports, "default", () => $78a5f552a5672aca$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $78a5f552a5672aca$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $78a5f552a5672aca$export$2e2bcd8739ae039 = $78a5f552a5672aca$var$zIndex;

});



parcelRegister("RjrfP", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a04077326a32da1$export$2e2bcd8739ae039);
var $0a04077326a32da1$export$2e2bcd8739ae039 = '$$material';

});


parcelRegister("k5hQd", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", () => $e9f21d2c2213a15e$export$effb20ecdbf4d6aa);
$parcel$export(module.exports, "slotShouldForwardProp", () => $e9f21d2c2213a15e$export$f10c5a10d27438e5);
$parcel$export(module.exports, "default", () => $e9f21d2c2213a15e$export$2e2bcd8739ae039);

var $el2ux = parcelRequire("el2ux");

var $dpWha = parcelRequire("dpWha");

var $RjrfP = parcelRequire("RjrfP");
'use client';
const $e9f21d2c2213a15e$export$effb20ecdbf4d6aa = (prop)=>(0, $el2ux.shouldForwardProp)(prop) && prop !== 'classes';
const $e9f21d2c2213a15e$export$f10c5a10d27438e5 = (0, $el2ux.shouldForwardProp);
const $e9f21d2c2213a15e$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($el2ux)))({
    themeId: (0, $RjrfP.default),
    defaultTheme: $dpWha.default,
    rootShouldForwardProp: $e9f21d2c2213a15e$export$effb20ecdbf4d6aa
});
var $e9f21d2c2213a15e$export$2e2bcd8739ae039 = $e9f21d2c2213a15e$var$styled;

});
parcelRegister("el2ux", function(module, exports) {
"use strict";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a704f59a3618bd87$var$createStyled;
module.exports.shouldForwardProp = $a704f59a3618bd87$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $a704f59a3618bd87$var$_extends2 = $9C5EU((parcelRequire("2ZOLb")));

var $a704f59a3618bd87$var$_objectWithoutPropertiesLoose2 = $9C5EU((parcelRequire("e1jtc")));

var $a704f59a3618bd87$var$_styledEngine = $a704f59a3618bd87$var$_interopRequireWildcard((parcelRequire("lXNQ7")));

var $8HP8E = parcelRequire("8HP8E");

var $a704f59a3618bd87$var$_capitalize = $9C5EU((parcelRequire("4Ib5o")));

var $a704f59a3618bd87$var$_getDisplayName = $9C5EU((parcelRequire("33UaD")));

var $a704f59a3618bd87$var$_createTheme = $9C5EU((parcelRequire("6bcTZ")));

var $a704f59a3618bd87$var$_styleFunctionSx = $9C5EU((parcelRequire("hGgIS")));
const $a704f59a3618bd87$var$_excluded = [
    "ownerState"
], $a704f59a3618bd87$var$_excluded2 = [
    "variants"
], $a704f59a3618bd87$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $a704f59a3618bd87$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a704f59a3618bd87$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $a704f59a3618bd87$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $a704f59a3618bd87$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $a704f59a3618bd87$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $a704f59a3618bd87$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $a704f59a3618bd87$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const $a704f59a3618bd87$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $a704f59a3618bd87$var$_createTheme.default)();
const $a704f59a3618bd87$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $a704f59a3618bd87$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $a704f59a3618bd87$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $a704f59a3618bd87$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $a704f59a3618bd87$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $a704f59a3618bd87$var$_objectWithoutPropertiesLoose2.default)(_ref, $a704f59a3618bd87$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $a704f59a3618bd87$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$a704f59a3618bd87$var$processStyleArg(resolvedStyle, (0, $a704f59a3618bd87$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $a704f59a3618bd87$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $a704f59a3618bd87$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $a704f59a3618bd87$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === 'function' ? variant.style((0, $a704f59a3618bd87$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $a704f59a3618bd87$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $a704f59a3618bd87$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $a704f59a3618bd87$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $a704f59a3618bd87$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $a704f59a3618bd87$var$_styleFunctionSx.default)((0, $a704f59a3618bd87$var$_extends2.default)({}, props, {
            theme: $a704f59a3618bd87$var$resolveTheme((0, $a704f59a3618bd87$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $a704f59a3618bd87$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $a704f59a3618bd87$var$defaultOverridesResolver($a704f59a3618bd87$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $a704f59a3618bd87$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $a704f59a3618bd87$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $a704f59a3618bd87$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($a704f59a3618bd87$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $a704f59a3618bd87$var$_styledEngine.default)(tag, (0, $a704f59a3618bd87$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $8HP8E.isPlainObject)(stylesArg)) return (props)=>$a704f59a3618bd87$var$processStyleArg(stylesArg, (0, $a704f59a3618bd87$var$_extends2.default)({}, props, {
                    theme: $a704f59a3618bd87$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $a704f59a3618bd87$var$resolveTheme((0, $a704f59a3618bd87$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $a704f59a3618bd87$var$processStyleArg(slotStyle, (0, $a704f59a3618bd87$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $a704f59a3618bd87$var$resolveTheme((0, $a704f59a3618bd87$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $a704f59a3618bd87$var$processStyleArg({
                    variants: themeVariants
                }, (0, $a704f59a3618bd87$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("e1jtc", function(module, exports) {
function $a3504306d69b8d8e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $a3504306d69b8d8e$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lXNQ7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ffd5c4c54859b22a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_processStyles", () => $ffd5c4c54859b22a$export$e00380445f2b9e0c);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("03G5m")).T);
$parcel$export(module.exports, "keyframes", () => (parcelRequire("3vbO9")).keyframes);
$parcel$export(module.exports, "css", () => (parcelRequire("3vbO9")).css);
$parcel$export(module.exports, "StyledEngineProvider", () => (parcelRequire("2bNjf")).default);
$parcel$export(module.exports, "GlobalStyles", () => (parcelRequire("H0lho")).default);
/**
 * @mui/styled-engine v5.15.11
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $5DPOq = parcelRequire("5DPOq");

var $3vbO9 = parcelRequire("3vbO9");
var $03G5m = parcelRequire("03G5m");

var $2bNjf = parcelRequire("2bNjf");

var $H0lho = parcelRequire("H0lho");
'use client';
function $ffd5c4c54859b22a$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $5DPOq.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $ffd5c4c54859b22a$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("5DPOq", function(module, exports) {

$parcel$export(module.exports, "default", () => $41b8c91ae739b662$export$2e2bcd8739ae039);

var $hBx9A = parcelRequire("hBx9A");
parcelRequire("2ZOLb");
parcelRequire("28UcW");
parcelRequire("cQESI");

parcelRequire("hYp2W");
parcelRequire("c4JlO");
parcelRequire("a3GsN");
var $41b8c91ae739b662$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
var $41b8c91ae739b662$export$2e2bcd8739ae039 = (0, $hBx9A.default).bind();
$41b8c91ae739b662$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $41b8c91ae739b662$export$2e2bcd8739ae039[tagName] = $41b8c91ae739b662$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("hBx9A", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd0f9bfca17aba84$export$2e2bcd8739ae039);

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");

var $cQESI = parcelRequire("cQESI");
parcelRequire("3vbO9");
var $03G5m = parcelRequire("03G5m");

var $hYp2W = parcelRequire("hYp2W");

var $c4JlO = parcelRequire("c4JlO");

var $a3GsN = parcelRequire("a3GsN");
var $cd0f9bfca17aba84$var$testOmitPropsOnStringTag = (0, $cQESI.default);
var $cd0f9bfca17aba84$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $cd0f9bfca17aba84$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $cd0f9bfca17aba84$var$testOmitPropsOnStringTag : $cd0f9bfca17aba84$var$testOmitPropsOnComponent;
};
var $cd0f9bfca17aba84$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $cd0f9bfca17aba84$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $cd0f9bfca17aba84$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $hYp2W.registerStyles)(cache, serialized, isStringTag);
    (0, $a3GsN.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $hYp2W.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $cd0f9bfca17aba84$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $cd0f9bfca17aba84$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $cd0f9bfca17aba84$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $03G5m.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $28UcW.useContext((0, $03G5m.T));
            }
            if (typeof props.className === 'string') className = (0, $hYp2W.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $c4JlO.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $cd0f9bfca17aba84$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $28UcW.createElement($28UcW.Fragment, null, /*#__PURE__*/ $28UcW.createElement($cd0f9bfca17aba84$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $28UcW.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $kLZMq.default)({}, options, nextOptions, {
                shouldForwardProp: $cd0f9bfca17aba84$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("cQESI", function(module, exports) {

$parcel$export(module.exports, "default", () => $95aa0d944f8c789d$export$2e2bcd8739ae039);

var $dsA1p = parcelRequire("dsA1p");
var $95aa0d944f8c789d$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $95aa0d944f8c789d$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $dsA1p.default)(function(prop) {
    return $95aa0d944f8c789d$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("2bNjf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1982dbb145d1dfb6$export$2e2bcd8739ae039);
parcelRequire("28UcW");


var $03G5m = parcelRequire("03G5m");

var $iqmCU = parcelRequire("iqmCU");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
let $1982dbb145d1dfb6$var$cache;
if (typeof document === 'object') $1982dbb145d1dfb6$var$cache = (0, $iqmCU.default)({
    key: 'css',
    prepend: true
});
function $1982dbb145d1dfb6$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $1982dbb145d1dfb6$var$cache ? /*#__PURE__*/ (0, $4XrX4.jsx)((0, $03G5m.C), {
        value: $1982dbb145d1dfb6$var$cache,
        children: children
    }) : children;
}

});
parcelRegister("4XrX4", function(module, exports) {
'use strict';

module.exports = (parcelRequire("R70Zh"));

});


parcelRegister("H0lho", function(module, exports) {

$parcel$export(module.exports, "default", () => $081448395e4fc04e$export$2e2bcd8739ae039);
parcelRequire("28UcW");


var $3vbO9 = parcelRequire("3vbO9");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
function $081448395e4fc04e$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $081448395e4fc04e$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($081448395e4fc04e$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $3vbO9.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("4Ib5o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("fuRSE")).default);

var $fuRSE = parcelRequire("fuRSE");

});

parcelRegister("33UaD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("dZq2O")).default);

var $dZq2O = parcelRequire("dZq2O");
$parcel$exportWildcard(module.exports, $dZq2O);

});
parcelRegister("dZq2O", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", () => $a2f52cc1c280e090$export$aad197c7121a6651);
$parcel$export(module.exports, "default", () => $a2f52cc1c280e090$export$2e2bcd8739ae039);

var $d79ZO = parcelRequire("d79ZO");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $a2f52cc1c280e090$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $a2f52cc1c280e090$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($a2f52cc1c280e090$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $a2f52cc1c280e090$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $a2f52cc1c280e090$export$aad197c7121a6651(Component) || fallback;
}
function $a2f52cc1c280e090$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $a2f52cc1c280e090$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $a2f52cc1c280e090$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $a2f52cc1c280e090$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $d79ZO.ForwardRef:
            return $a2f52cc1c280e090$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $d79ZO.Memo:
            return $a2f52cc1c280e090$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("d79ZO", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9mqwy"));

});
parcelRegister("9mqwy", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $6d0abe427d121f1d$export$a7c73072b1a182ae, (v) => $6d0abe427d121f1d$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6d0abe427d121f1d$export$9f27bc3417b4524d, (v) => $6d0abe427d121f1d$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6d0abe427d121f1d$export$db77ccec0bb4ccac, (v) => $6d0abe427d121f1d$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6d0abe427d121f1d$export$8392c0c9d3dcbd35, (v) => $6d0abe427d121f1d$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6d0abe427d121f1d$export$ffb0004e005737fa, (v) => $6d0abe427d121f1d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6d0abe427d121f1d$export$b624eff549462981, (v) => $6d0abe427d121f1d$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6d0abe427d121f1d$export$7897aa7841a5380c, (v) => $6d0abe427d121f1d$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6d0abe427d121f1d$export$602eac185826482c, (v) => $6d0abe427d121f1d$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6d0abe427d121f1d$export$e2c29f18771995cb, (v) => $6d0abe427d121f1d$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6d0abe427d121f1d$export$5f8d39834fd61797, (v) => $6d0abe427d121f1d$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6d0abe427d121f1d$export$74bf444e3cd11ea5, (v) => $6d0abe427d121f1d$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $6d0abe427d121f1d$export$998bcd577473dd93, (v) => $6d0abe427d121f1d$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6d0abe427d121f1d$export$92387174baf9b227, (v) => $6d0abe427d121f1d$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6d0abe427d121f1d$export$ec112efeb987d9c6, (v) => $6d0abe427d121f1d$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6d0abe427d121f1d$export$b706b080d889d2c9, (v) => $6d0abe427d121f1d$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6d0abe427d121f1d$export$5be5a87408f70ddc, (v) => $6d0abe427d121f1d$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6d0abe427d121f1d$export$45a5e7f76e0caa8d, (v) => $6d0abe427d121f1d$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6d0abe427d121f1d$export$455c2e768291efa6, (v) => $6d0abe427d121f1d$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6d0abe427d121f1d$export$9522e17588c12572, (v) => $6d0abe427d121f1d$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6d0abe427d121f1d$export$2110ac352bb060b9, (v) => $6d0abe427d121f1d$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6d0abe427d121f1d$export$56885ab8b9c456ab, (v) => $6d0abe427d121f1d$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6d0abe427d121f1d$export$d927fcb6adf8f9de, (v) => $6d0abe427d121f1d$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6d0abe427d121f1d$export$b82d16f27459e05a, (v) => $6d0abe427d121f1d$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6d0abe427d121f1d$export$522c17b4f5e123e8, (v) => $6d0abe427d121f1d$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6d0abe427d121f1d$export$1aabd8a0274ecfd6, (v) => $6d0abe427d121f1d$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $6d0abe427d121f1d$export$3d6c20d97e46b957, (v) => $6d0abe427d121f1d$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $6d0abe427d121f1d$export$9b621391a187a31a, (v) => $6d0abe427d121f1d$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6d0abe427d121f1d$export$f5bbd400c2f4426f, (v) => $6d0abe427d121f1d$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6d0abe427d121f1d$export$a7c73072b1a182ae;
var $6d0abe427d121f1d$export$9f27bc3417b4524d;
var $6d0abe427d121f1d$export$db77ccec0bb4ccac;
var $6d0abe427d121f1d$export$8392c0c9d3dcbd35;
var $6d0abe427d121f1d$export$ffb0004e005737fa;
var $6d0abe427d121f1d$export$b624eff549462981;
var $6d0abe427d121f1d$export$7897aa7841a5380c;
var $6d0abe427d121f1d$export$602eac185826482c;
var $6d0abe427d121f1d$export$e2c29f18771995cb;
var $6d0abe427d121f1d$export$5f8d39834fd61797;
var $6d0abe427d121f1d$export$74bf444e3cd11ea5;
var $6d0abe427d121f1d$export$998bcd577473dd93;
var $6d0abe427d121f1d$export$92387174baf9b227;
var $6d0abe427d121f1d$export$ec112efeb987d9c6;
var $6d0abe427d121f1d$export$b706b080d889d2c9;
var $6d0abe427d121f1d$export$5be5a87408f70ddc;
var $6d0abe427d121f1d$export$45a5e7f76e0caa8d;
var $6d0abe427d121f1d$export$455c2e768291efa6;
var $6d0abe427d121f1d$export$9522e17588c12572;
var $6d0abe427d121f1d$export$2110ac352bb060b9;
var $6d0abe427d121f1d$export$56885ab8b9c456ab;
var $6d0abe427d121f1d$export$d927fcb6adf8f9de;
var $6d0abe427d121f1d$export$b82d16f27459e05a;
var $6d0abe427d121f1d$export$522c17b4f5e123e8;
var $6d0abe427d121f1d$export$1aabd8a0274ecfd6;
var $6d0abe427d121f1d$export$3d6c20d97e46b957;
var $6d0abe427d121f1d$export$9b621391a187a31a;
var $6d0abe427d121f1d$export$f5bbd400c2f4426f;
'use strict';
var $6d0abe427d121f1d$var$b = Symbol.for("react.element"), $6d0abe427d121f1d$var$c = Symbol.for("react.portal"), $6d0abe427d121f1d$var$d = Symbol.for("react.fragment"), $6d0abe427d121f1d$var$e = Symbol.for("react.strict_mode"), $6d0abe427d121f1d$var$f = Symbol.for("react.profiler"), $6d0abe427d121f1d$var$g = Symbol.for("react.provider"), $6d0abe427d121f1d$var$h = Symbol.for("react.context"), $6d0abe427d121f1d$var$k = Symbol.for("react.server_context"), $6d0abe427d121f1d$var$l = Symbol.for("react.forward_ref"), $6d0abe427d121f1d$var$m = Symbol.for("react.suspense"), $6d0abe427d121f1d$var$n = Symbol.for("react.suspense_list"), $6d0abe427d121f1d$var$p = Symbol.for("react.memo"), $6d0abe427d121f1d$var$q = Symbol.for("react.lazy"), $6d0abe427d121f1d$var$t = Symbol.for("react.offscreen"), $6d0abe427d121f1d$var$u;
$6d0abe427d121f1d$var$u = Symbol.for("react.module.reference");
function $6d0abe427d121f1d$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $6d0abe427d121f1d$var$b:
                switch(a = a.type, a){
                    case $6d0abe427d121f1d$var$d:
                    case $6d0abe427d121f1d$var$f:
                    case $6d0abe427d121f1d$var$e:
                    case $6d0abe427d121f1d$var$m:
                    case $6d0abe427d121f1d$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6d0abe427d121f1d$var$k:
                            case $6d0abe427d121f1d$var$h:
                            case $6d0abe427d121f1d$var$l:
                            case $6d0abe427d121f1d$var$q:
                            case $6d0abe427d121f1d$var$p:
                            case $6d0abe427d121f1d$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $6d0abe427d121f1d$var$c:
                return r;
        }
    }
}
$6d0abe427d121f1d$export$a7c73072b1a182ae = $6d0abe427d121f1d$var$h;
$6d0abe427d121f1d$export$9f27bc3417b4524d = $6d0abe427d121f1d$var$g;
$6d0abe427d121f1d$export$db77ccec0bb4ccac = $6d0abe427d121f1d$var$b;
$6d0abe427d121f1d$export$8392c0c9d3dcbd35 = $6d0abe427d121f1d$var$l;
$6d0abe427d121f1d$export$ffb0004e005737fa = $6d0abe427d121f1d$var$d;
$6d0abe427d121f1d$export$b624eff549462981 = $6d0abe427d121f1d$var$q;
$6d0abe427d121f1d$export$7897aa7841a5380c = $6d0abe427d121f1d$var$p;
$6d0abe427d121f1d$export$602eac185826482c = $6d0abe427d121f1d$var$c;
$6d0abe427d121f1d$export$e2c29f18771995cb = $6d0abe427d121f1d$var$f;
$6d0abe427d121f1d$export$5f8d39834fd61797 = $6d0abe427d121f1d$var$e;
$6d0abe427d121f1d$export$74bf444e3cd11ea5 = $6d0abe427d121f1d$var$m;
$6d0abe427d121f1d$export$998bcd577473dd93 = $6d0abe427d121f1d$var$n;
$6d0abe427d121f1d$export$92387174baf9b227 = function() {
    return !1;
};
$6d0abe427d121f1d$export$ec112efeb987d9c6 = function() {
    return !1;
};
$6d0abe427d121f1d$export$b706b080d889d2c9 = function(a) {
    return $6d0abe427d121f1d$var$v(a) === $6d0abe427d121f1d$var$h;
};
$6d0abe427d121f1d$export$5be5a87408f70ddc = function(a) {
    return $6d0abe427d121f1d$var$v(a) === $6d0abe427d121f1d$var$g;
};
$6d0abe427d121f1d$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6d0abe427d121f1d$var$b;
};
$6d0abe427d121f1d$export$455c2e768291efa6 = function(a) {
    return $6d0abe427d121f1d$var$v(a) === $6d0abe427d121f1d$var$l;
};
$6d0abe427d121f1d$export$9522e17588c12572 = function(a) {
    return $6d0abe427d121f1d$var$v(a) === $6d0abe427d121f1d$var$d;
};
$6d0abe427d121f1d$export$2110ac352bb060b9 = function(a) {
    return $6d0abe427d121f1d$var$v(a) === $6d0abe427d121f1d$var$q;
};
$6d0abe427d121f1d$export$56885ab8b9c456ab = function(a) {
    return $6d0abe427d121f1d$var$v(a) === $6d0abe427d121f1d$var$p;
};
$6d0abe427d121f1d$export$d927fcb6adf8f9de = function(a) {
    return $6d0abe427d121f1d$var$v(a) === $6d0abe427d121f1d$var$c;
};
$6d0abe427d121f1d$export$b82d16f27459e05a = function(a) {
    return $6d0abe427d121f1d$var$v(a) === $6d0abe427d121f1d$var$f;
};
$6d0abe427d121f1d$export$522c17b4f5e123e8 = function(a) {
    return $6d0abe427d121f1d$var$v(a) === $6d0abe427d121f1d$var$e;
};
$6d0abe427d121f1d$export$1aabd8a0274ecfd6 = function(a) {
    return $6d0abe427d121f1d$var$v(a) === $6d0abe427d121f1d$var$m;
};
$6d0abe427d121f1d$export$3d6c20d97e46b957 = function(a) {
    return $6d0abe427d121f1d$var$v(a) === $6d0abe427d121f1d$var$n;
};
$6d0abe427d121f1d$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6d0abe427d121f1d$var$d || a === $6d0abe427d121f1d$var$f || a === $6d0abe427d121f1d$var$e || a === $6d0abe427d121f1d$var$m || a === $6d0abe427d121f1d$var$n || a === $6d0abe427d121f1d$var$t || "object" === typeof a && null !== a && (a.$$typeof === $6d0abe427d121f1d$var$q || a.$$typeof === $6d0abe427d121f1d$var$p || a.$$typeof === $6d0abe427d121f1d$var$g || a.$$typeof === $6d0abe427d121f1d$var$h || a.$$typeof === $6d0abe427d121f1d$var$l || a.$$typeof === $6d0abe427d121f1d$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$6d0abe427d121f1d$export$f5bbd400c2f4426f = $6d0abe427d121f1d$var$v;

});




parcelRegister("6bcTZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("7zKsg")).default);
$parcel$export(module.exports, "private_createBreakpoints", () => (parcelRequire("cY9zX")).default);
$parcel$export(module.exports, "unstable_applyStyles", () => (parcelRequire("eIkMu")).default);

var $7zKsg = parcelRequire("7zKsg");

var $cY9zX = parcelRequire("cY9zX");

var $eIkMu = parcelRequire("eIkMu");

});

parcelRegister("hGgIS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("iJ7JK")).default);
$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => (parcelRequire("iJ7JK")).unstable_createStyleFunctionSx);
$parcel$export(module.exports, "extendSxProp", () => (parcelRequire("5hW5y")).default);
$parcel$export(module.exports, "unstable_defaultSxConfig", () => (parcelRequire("9DlDG")).default);

var $iJ7JK = parcelRequire("iJ7JK");

var $5hW5y = parcelRequire("5hW5y");

var $9DlDG = parcelRequire("9DlDG");

});
parcelRegister("5hW5y", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d9b9978b1ab25bc$export$2e2bcd8739ae039);

var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $8HP8E = parcelRequire("8HP8E");

var $9DlDG = parcelRequire("9DlDG");
const $3d9b9978b1ab25bc$var$_excluded = [
    "sx"
];
const $3d9b9978b1ab25bc$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $9DlDG.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $3d9b9978b1ab25bc$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $53Ou4.default)(props, $3d9b9978b1ab25bc$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $3d9b9978b1ab25bc$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $8HP8E.isPlainObject)(result)) return systemProps;
        return (0, $kLZMq.default)({}, systemProps, result);
    };
    else finalSx = (0, $kLZMq.default)({}, systemProps, inSx);
    return (0, $kLZMq.default)({}, otherProps, {
        sx: finalSx
    });
}

});




parcelRegister("6tEUB", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $4b752fc3e0a12544$export$c7c50641356bdfa5);

var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $4b752fc3e0a12544$export$c7c50641356bdfa5(slot) {
    return (0, $dYzHx.default)('MuiSvgIcon', slot);
}
const $4b752fc3e0a12544$var$svgIconClasses = (0, $d0ZgE.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $4b752fc3e0a12544$export$2e2bcd8739ae039 = $4b752fc3e0a12544$var$svgIconClasses;

});
parcelRegister("d0ZgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $979accecf23a6dff$export$2e2bcd8739ae039);

var $dYzHx = parcelRequire("dYzHx");
function $979accecf23a6dff$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $dYzHx.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("dYzHx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2cc92758ca38137$export$2e2bcd8739ae039);

var $gWFI6 = parcelRequire("gWFI6");
const $a2cc92758ca38137$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $a2cc92758ca38137$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $a2cc92758ca38137$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $gWFI6.default).generate(componentName)}-${slot}`;
}
function $a2cc92758ca38137$export$34c0130b1f3e8ae3(slot) {
    return $a2cc92758ca38137$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("gWFI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5626af0ed6d8f8f$export$2e2bcd8739ae039);
const $c5626af0ed6d8f8f$var$defaultGenerator = (componentName)=>componentName;
const $c5626af0ed6d8f8f$var$createClassNameGenerator = ()=>{
    let generate = $c5626af0ed6d8f8f$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $c5626af0ed6d8f8f$var$defaultGenerator;
        }
    };
};
const $c5626af0ed6d8f8f$var$ClassNameGenerator = $c5626af0ed6d8f8f$var$createClassNameGenerator();
var $c5626af0ed6d8f8f$export$2e2bcd8739ae039 = $c5626af0ed6d8f8f$var$ClassNameGenerator;

});







parcelRegister("6t2I5", function(module, exports) {
/* UAParser.js v1.0.40
   Copyright © 2012-2024 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined) {
    "use strict";
    var LIBVERSION = "1.0.40", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS", SUFFIX_BROWSER = " Browser";
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return map.hasOwnProperty("*") ? map["*"] : str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " GX"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Maxthon"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                /(heytap|ovi|115)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Quark"
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "DuckDuckGo"
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI" + SUFFIX_BROWSER
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "360"
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1Browser"
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1" + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /(links) \(([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:honor)([-\w ]+)[;\)]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Honor"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2\d{3}a?) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(pixel c)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "TCL"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        tablet: [
                            "p10001l",
                            "w7001"
                        ],
                        "*": "mobile"
                    }
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Energizer"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Cat"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Smartfren"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nothing"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                /; (imo) ((?!tab)[\w ]+?)(?: bui|\))/i,
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(imo) (tab \w+)/i,
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(pico) (4|neo3(?: link|pro)?)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /; (quest( \d| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish|openharmony)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRegister("2cHFZ", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("a3kJd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jDXpY = parcelRequire("jDXpY");

var $hHxQD = parcelRequire("hHxQD");

var $bVJk9 = parcelRequire("bVJk9");

var $26KlG = parcelRequire("26KlG");
function $751a4366f12669d6$var$get(object, path, defaultValue) {
    if (object == null) return defaultValue;
    switch(typeof path){
        case 'string':
            {
                if ($jDXpY.isUnsafeProperty(path)) return defaultValue;
                const result = object[path];
                if (result === undefined) {
                    if ($hHxQD.isDeepKey(path)) return $751a4366f12669d6$var$get(object, $26KlG.toPath(path), defaultValue);
                    else return defaultValue;
                }
                return result;
            }
        case 'number':
        case 'symbol':
            {
                if (typeof path === 'number') path = $bVJk9.toKey(path);
                const result = object[path];
                if (result === undefined) return defaultValue;
                return result;
            }
        default:
            {
                if (Array.isArray(path)) return $751a4366f12669d6$var$getWithPath(object, path, defaultValue);
                if (Object.is(path?.valueOf(), -0)) path = '-0';
                else path = String(path);
                if ($jDXpY.isUnsafeProperty(path)) return defaultValue;
                const result = object[path];
                if (result === undefined) return defaultValue;
                return result;
            }
    }
}
function $751a4366f12669d6$var$getWithPath(object, path, defaultValue) {
    if (path.length === 0) return defaultValue;
    let current = object;
    for(let index = 0; index < path.length; index++){
        if (current == null) return defaultValue;
        if ($jDXpY.isUnsafeProperty(path[index])) return defaultValue;
        current = current[path[index]];
    }
    if (current === undefined) return defaultValue;
    return current;
}
module.exports.get = $751a4366f12669d6$var$get;

});
parcelRegister("jDXpY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $e4cfc000ab8a29d8$var$isUnsafeProperty(key) {
    return key === '__proto__';
}
module.exports.isUnsafeProperty = $e4cfc000ab8a29d8$var$isUnsafeProperty;

});

parcelRegister("hHxQD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $03535dc36f05b443$var$isDeepKey(key) {
    switch(typeof key){
        case 'number':
        case 'symbol':
            return false;
        case 'string':
            return key.includes('.') || key.includes('[') || key.includes(']');
    }
}
module.exports.isDeepKey = $03535dc36f05b443$var$isDeepKey;

});

parcelRegister("bVJk9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $8af82cf5e7b6d3d4$var$toKey(value) {
    if (typeof value === 'string' || typeof value === 'symbol') return value;
    if (Object.is(value?.valueOf?.(), -0)) return '-0';
    return String(value);
}
module.exports.toKey = $8af82cf5e7b6d3d4$var$toKey;

});

parcelRegister("26KlG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $60D9a = parcelRequire("60D9a");

var $bVJk9 = parcelRequire("bVJk9");
function $18901839c4cefbd1$var$toPath(deepKey) {
    if (Array.isArray(deepKey)) return deepKey.map($bVJk9.toKey);
    if (typeof deepKey === 'symbol') return [
        deepKey
    ];
    deepKey = $60D9a.toString(deepKey);
    const result = [];
    const length = deepKey.length;
    if (length === 0) return result;
    let index = 0;
    let key = '';
    let quoteChar = '';
    let bracket = false;
    if (deepKey.charCodeAt(0) === 46) {
        result.push('');
        index++;
    }
    while(index < length){
        const char = deepKey[index];
        if (quoteChar) {
            if (char === '\\' && index + 1 < length) {
                index++;
                key += deepKey[index];
            } else if (char === quoteChar) quoteChar = '';
            else key += char;
        } else if (bracket) {
            if (char === '"' || char === "'") quoteChar = char;
            else if (char === ']') {
                bracket = false;
                result.push(key);
                key = '';
            } else key += char;
        } else {
            if (char === '[') {
                bracket = true;
                if (key) {
                    result.push(key);
                    key = '';
                }
            } else if (char === '.') {
                if (key) {
                    result.push(key);
                    key = '';
                }
            } else key += char;
        }
        index++;
    }
    if (key) result.push(key);
    return result;
}
module.exports.toPath = $18901839c4cefbd1$var$toPath;

});
parcelRegister("60D9a", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $46011beba2a0a956$var$toString(value) {
    if (value == null) return '';
    if (typeof value === 'string') return value;
    if (Array.isArray(value)) return value.map($46011beba2a0a956$var$toString).join(',');
    const result = String(value);
    if (result === '0' && Object.is(Number(value), -0)) return '-0';
    return result;
}
module.exports.toString = $46011beba2a0a956$var$toString;

});



parcelRegister("3vuQu", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2MHYy = parcelRequire("2MHYy");

var $11V0H = parcelRequire("11V0H");

var $dIEkZ = parcelRequire("dIEkZ");
function $28dc31a5681b3e4e$var$sortBy(collection, ...criteria) {
    const length = criteria.length;
    if (length > 1 && $dIEkZ.isIterateeCall(collection, criteria[0], criteria[1])) criteria = [];
    else if (length > 2 && $dIEkZ.isIterateeCall(criteria[0], criteria[1], criteria[2])) criteria = [
        criteria[0]
    ];
    return $2MHYy.orderBy(collection, $11V0H.flatten(criteria), [
        'asc'
    ]);
}
module.exports.sortBy = $28dc31a5681b3e4e$var$sortBy;

});
parcelRegister("2MHYy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gTQV6 = parcelRequire("gTQV6");

var $5Gpta = parcelRequire("5Gpta");

var $26KlG = parcelRequire("26KlG");
function $20722d20f0b53bd8$var$orderBy(collection, criteria, orders, guard) {
    if (collection == null) return [];
    orders = guard ? undefined : orders;
    if (!Array.isArray(collection)) collection = Object.values(collection);
    if (!Array.isArray(criteria)) criteria = criteria == null ? [
        null
    ] : [
        criteria
    ];
    if (criteria.length === 0) criteria = [
        null
    ];
    if (!Array.isArray(orders)) orders = orders == null ? [] : [
        orders
    ];
    orders = orders.map((order)=>String(order));
    const getValueByNestedPath = (object, path)=>{
        let target = object;
        for(let i = 0; i < path.length && target != null; ++i)target = target[path[i]];
        return target;
    };
    const getValueByCriterion = (criterion, object)=>{
        if (object == null || criterion == null) return object;
        if (typeof criterion === 'object' && 'key' in criterion) {
            if (Object.hasOwn(object, criterion.key)) return object[criterion.key];
            return getValueByNestedPath(object, criterion.path);
        }
        if (typeof criterion === 'function') return criterion(object);
        if (Array.isArray(criterion)) return getValueByNestedPath(object, criterion);
        if (typeof object === 'object') return object[criterion];
        return object;
    };
    const preparedCriteria = criteria.map((criterion)=>{
        if (Array.isArray(criterion) && criterion.length === 1) criterion = criterion[0];
        if (criterion == null || typeof criterion === 'function' || Array.isArray(criterion) || $5Gpta.isKey(criterion)) return criterion;
        return {
            key: criterion,
            path: $26KlG.toPath(criterion)
        };
    });
    const preparedCollection = collection.map((item)=>({
            original: item,
            criteria: preparedCriteria.map((criterion)=>getValueByCriterion(criterion, item))
        }));
    return preparedCollection.slice().sort((a, b)=>{
        for(let i = 0; i < preparedCriteria.length; i++){
            const comparedResult = $gTQV6.compareValues(a.criteria[i], b.criteria[i], orders[i]);
            if (comparedResult !== 0) return comparedResult;
        }
        return 0;
    }).map((item)=>item.original);
}
module.exports.orderBy = $20722d20f0b53bd8$var$orderBy;

});
parcelRegister("gTQV6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $c4dad538f3f7a401$var$getPriority(a) {
    if (typeof a === 'symbol') return 1;
    if (a === null) return 2;
    if (a === undefined) return 3;
    if (a !== a) return 4;
    return 0;
}
const $c4dad538f3f7a401$var$compareValues = (a, b, order)=>{
    if (a !== b) {
        const aPriority = $c4dad538f3f7a401$var$getPriority(a);
        const bPriority = $c4dad538f3f7a401$var$getPriority(b);
        if (aPriority === bPriority && aPriority === 0) {
            if (a < b) return order === 'desc' ? 1 : -1;
            if (a > b) return order === 'desc' ? -1 : 1;
        }
        return order === 'desc' ? bPriority - aPriority : aPriority - bPriority;
    }
    return 0;
};
module.exports.compareValues = $c4dad538f3f7a401$var$compareValues;

});

parcelRegister("5Gpta", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1IOt4 = parcelRequire("1IOt4");
const $4234a1b601aa2cf6$var$regexIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
const $4234a1b601aa2cf6$var$regexIsPlainProp = /^\w*$/;
function $4234a1b601aa2cf6$var$isKey(value, object) {
    if (Array.isArray(value)) return false;
    if (typeof value === 'number' || typeof value === 'boolean' || value == null || $1IOt4.isSymbol(value)) return true;
    return typeof value === 'string' && ($4234a1b601aa2cf6$var$regexIsPlainProp.test(value) || !$4234a1b601aa2cf6$var$regexIsDeepProp.test(value)) || object != null && Object.hasOwn(object, value);
}
module.exports.isKey = $4234a1b601aa2cf6$var$isKey;

});
parcelRegister("1IOt4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $14110c634b71e278$var$isSymbol(value) {
    return typeof value === 'symbol' || value instanceof Symbol;
}
module.exports.isSymbol = $14110c634b71e278$var$isSymbol;

});



parcelRegister("11V0H", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $0c021b81440fcd0c$var$flatten(arr, depth = 1) {
    const result = [];
    const flooredDepth = Math.floor(depth);
    const recursive = (arr, currentDepth)=>{
        for(let i = 0; i < arr.length; i++){
            const item = arr[i];
            if (Array.isArray(item) && currentDepth < flooredDepth) recursive(item, currentDepth + 1);
            else result.push(item);
        }
    };
    recursive(arr, 0);
    return result;
}
module.exports.flatten = $0c021b81440fcd0c$var$flatten;

});

parcelRegister("dIEkZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $i6g8Z = parcelRequire("i6g8Z");

var $gW2Uh = parcelRequire("gW2Uh");

var $9lVSp = parcelRequire("9lVSp");

var $lksYT = parcelRequire("lksYT");
function $9fceaca420c3cddc$var$isIterateeCall(value, index, object) {
    if (!$9lVSp.isObject(object)) return false;
    if (typeof index === 'number' && $gW2Uh.isArrayLike(object) && $i6g8Z.isIndex(index) && index < object.length || typeof index === 'string' && index in object) return $lksYT.eq(object[index], value);
    return false;
}
module.exports.isIterateeCall = $9fceaca420c3cddc$var$isIterateeCall;

});
parcelRegister("i6g8Z", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $d2d54f6b16a84d85$var$IS_UNSIGNED_INTEGER = /^(?:0|[1-9]\d*)$/;
function $d2d54f6b16a84d85$var$isIndex(value, length = Number.MAX_SAFE_INTEGER) {
    switch(typeof value){
        case 'number':
            return Number.isInteger(value) && value >= 0 && value < length;
        case 'symbol':
            return false;
        case 'string':
            return $d2d54f6b16a84d85$var$IS_UNSIGNED_INTEGER.test(value);
    }
}
module.exports.isIndex = $d2d54f6b16a84d85$var$isIndex;

});

parcelRegister("gW2Uh", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $h9jpq = parcelRequire("h9jpq");
function $c544515176040bb4$var$isArrayLike(value) {
    return value != null && typeof value !== 'function' && $h9jpq.isLength(value.length);
}
module.exports.isArrayLike = $c544515176040bb4$var$isArrayLike;

});
parcelRegister("h9jpq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $c7c2552e02059d33$var$isLength(value) {
    return Number.isSafeInteger(value) && value >= 0;
}
module.exports.isLength = $c7c2552e02059d33$var$isLength;

});


parcelRegister("9lVSp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $6cf2f8507d472279$var$isObject(value) {
    return value !== null && (typeof value === 'object' || typeof value === 'function');
}
module.exports.isObject = $6cf2f8507d472279$var$isObject;

});

parcelRegister("lksYT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $f871f246a501a2e7$var$eq(value, other) {
    return value === other || Number.isNaN(value) && Number.isNaN(other);
}
module.exports.eq = $f871f246a501a2e7$var$eq;

});



parcelRegister("iWNkM", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("6AvcT"));

});
parcelRegister("6AvcT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $6s1v0.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $6s1v0.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $kfXzw.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $kfXzw.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $aWCiS.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $aWCiS.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $aWCiS.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $aWCiS.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $4cbe4fe70bc975b7$var$_symbol.symbolsStroke;
    }
});

var $4cbe4fe70bc975b7$var$_arc = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("6FbaB")));

var $4cbe4fe70bc975b7$var$_area = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("lrdSz")));

var $4cbe4fe70bc975b7$var$_line = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("lle2Y")));

var $4cbe4fe70bc975b7$var$_pie = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("57aYH")));

var $4cbe4fe70bc975b7$var$_areaRadial = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("l2baO")));

var $4cbe4fe70bc975b7$var$_lineRadial = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("jq8kz")));

var $4cbe4fe70bc975b7$var$_pointRadial = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("aIRPj")));

var $aWCiS = parcelRequire("aWCiS");

var $4cbe4fe70bc975b7$var$_symbol = $4cbe4fe70bc975b7$var$_interopRequireWildcard((parcelRequire("52wi8")));

var $4cbe4fe70bc975b7$var$_asterisk = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("aapJB")));

var $4cbe4fe70bc975b7$var$_circle = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("kbtSK")));

var $4cbe4fe70bc975b7$var$_cross = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("6hs13")));

var $4cbe4fe70bc975b7$var$_diamond = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("f4rvL")));

var $4cbe4fe70bc975b7$var$_diamond2 = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("9FYK2")));

var $4cbe4fe70bc975b7$var$_plus = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("jLrfX")));

var $4cbe4fe70bc975b7$var$_square = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("kUmKT")));

var $4cbe4fe70bc975b7$var$_square2 = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("7DfA8")));

var $4cbe4fe70bc975b7$var$_star = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("gMmLy")));

var $4cbe4fe70bc975b7$var$_triangle = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("2ZkFE")));

var $4cbe4fe70bc975b7$var$_triangle2 = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("etE91")));

var $4cbe4fe70bc975b7$var$_wye = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("brV8L")));

var $4cbe4fe70bc975b7$var$_x = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("OTry2")));

var $4cbe4fe70bc975b7$var$_basisClosed = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("kOxuT")));

var $4cbe4fe70bc975b7$var$_basisOpen = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("dJjfL")));

var $4cbe4fe70bc975b7$var$_basis = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("1puIN")));

var $6s1v0 = parcelRequire("6s1v0");

var $4cbe4fe70bc975b7$var$_bundle = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("lX4oA")));

var $4cbe4fe70bc975b7$var$_cardinalClosed = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("cVUbL")));

var $4cbe4fe70bc975b7$var$_cardinalOpen = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("ggpAQ")));

var $4cbe4fe70bc975b7$var$_cardinal = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("6eWgG")));

var $4cbe4fe70bc975b7$var$_catmullRomClosed = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("ayES5")));

var $4cbe4fe70bc975b7$var$_catmullRomOpen = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("6dFBx")));

var $4cbe4fe70bc975b7$var$_catmullRom = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("5QaoJ")));

var $4cbe4fe70bc975b7$var$_linearClosed = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("c940J")));

var $4cbe4fe70bc975b7$var$_linear = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("gxO0C")));

var $kfXzw = parcelRequire("kfXzw");

var $4cbe4fe70bc975b7$var$_natural = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("cSK1v")));

var $4cbe4fe70bc975b7$var$_step = $4cbe4fe70bc975b7$var$_interopRequireWildcard((parcelRequire("cnDUf")));

var $4cbe4fe70bc975b7$var$_stack = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("21K7T")));

var $4cbe4fe70bc975b7$var$_expand = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("kqrHm")));

var $4cbe4fe70bc975b7$var$_diverging = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("hafCN")));

var $4cbe4fe70bc975b7$var$_none = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("PU0MH")));

var $4cbe4fe70bc975b7$var$_silhouette = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("cdweh")));

var $4cbe4fe70bc975b7$var$_wiggle = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("cK1ui")));

var $4cbe4fe70bc975b7$var$_appearance = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("iEDzB")));

var $4cbe4fe70bc975b7$var$_ascending = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("6hzTl")));

var $4cbe4fe70bc975b7$var$_descending = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("2H8mv")));

var $4cbe4fe70bc975b7$var$_insideOut = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("9tTlP")));

var $4cbe4fe70bc975b7$var$_none2 = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("3Fs8s")));

var $4cbe4fe70bc975b7$var$_reverse = $4cbe4fe70bc975b7$var$_interopRequireDefault((parcelRequire("T5s8g")));
function $4cbe4fe70bc975b7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4cbe4fe70bc975b7$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $4cbe4fe70bc975b7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $4cbe4fe70bc975b7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $4cbe4fe70bc975b7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("6FbaB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d9f3c8801d91c8b$var$_default;

var $brG7m = parcelRequire("brG7m");

var $4d9f3c8801d91c8b$var$_constant = $4d9f3c8801d91c8b$var$_interopRequireDefault((parcelRequire("cYVR4")));

var $kzu0A = parcelRequire("kzu0A");
function $4d9f3c8801d91c8b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4d9f3c8801d91c8b$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $4d9f3c8801d91c8b$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $4d9f3c8801d91c8b$var$arcStartAngle(d) {
    return d.startAngle;
}
function $4d9f3c8801d91c8b$var$arcEndAngle(d) {
    return d.endAngle;
}
function $4d9f3c8801d91c8b$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $4d9f3c8801d91c8b$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $kzu0A.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $4d9f3c8801d91c8b$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $kzu0A.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $kzu0A.sqrt)((0, $kzu0A.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $4d9f3c8801d91c8b$var$_default() {
    var innerRadius = $4d9f3c8801d91c8b$var$arcInnerRadius, outerRadius = $4d9f3c8801d91c8b$var$arcOuterRadius, cornerRadius = (0, $4d9f3c8801d91c8b$var$_constant.default)(0), padRadius = null, startAngle = $4d9f3c8801d91c8b$var$arcStartAngle, endAngle = $4d9f3c8801d91c8b$var$arcEndAngle, padAngle = $4d9f3c8801d91c8b$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $kzu0A.halfPi, a1 = endAngle.apply(this, arguments) - $kzu0A.halfPi, da = (0, $kzu0A.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $brG7m.path)();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > $kzu0A.epsilon)) context.moveTo(0, 0);
        else if (da > $kzu0A.tau - $kzu0A.epsilon) {
            context.moveTo(r1 * (0, $kzu0A.cos)(a0), r1 * (0, $kzu0A.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $kzu0A.epsilon) {
                context.moveTo(r0 * (0, $kzu0A.cos)(a1), r0 * (0, $kzu0A.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $kzu0A.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $kzu0A.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $kzu0A.min)((0, $kzu0A.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $kzu0A.epsilon) {
                var p0 = (0, $kzu0A.asin)(rp / r0 * (0, $kzu0A.sin)(ap)), p1 = (0, $kzu0A.asin)(rp / r1 * (0, $kzu0A.sin)(ap));
                if ((da0 -= p0 * 2) > $kzu0A.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $kzu0A.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $kzu0A.cos)(a01), y01 = r1 * (0, $kzu0A.sin)(a01), x10 = r0 * (0, $kzu0A.cos)(a10), y10 = r0 * (0, $kzu0A.sin)(a10);
            // Apply rounded corners?
            if (rc > $kzu0A.epsilon) {
                var x11 = r1 * (0, $kzu0A.cos)(a11), y11 = r1 * (0, $kzu0A.sin)(a11), x00 = r0 * (0, $kzu0A.cos)(a00), y00 = r0 * (0, $kzu0A.sin)(a00), oc;
                // Restrict the corner radius according to the sector angle.
                if (da < $kzu0A.pi && (oc = $4d9f3c8801d91c8b$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $kzu0A.sin)((0, $kzu0A.acos)((ax * bx + ay * by) / ((0, $kzu0A.sqrt)(ax * ax + ay * ay) * (0, $kzu0A.sqrt)(bx * bx + by * by))) / 2), lc = (0, $kzu0A.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $kzu0A.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $kzu0A.min)(rc, (r1 - lc) / (kc + 1));
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > $kzu0A.epsilon)) context.moveTo(x01, y01);
            else if (rc1 > $kzu0A.epsilon) {
                t0 = $4d9f3c8801d91c8b$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $4d9f3c8801d91c8b$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $kzu0A.atan2)(t0.y01, t0.x01), (0, $kzu0A.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $kzu0A.atan2)(t0.y01, t0.x01), (0, $kzu0A.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $kzu0A.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $kzu0A.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $kzu0A.atan2)(t1.y11, t1.x11), (0, $kzu0A.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $kzu0A.epsilon) || !(da0 > $kzu0A.epsilon)) context.lineTo(x10, y10);
            else if (rc0 > $kzu0A.epsilon) {
                t0 = $4d9f3c8801d91c8b$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $4d9f3c8801d91c8b$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $kzu0A.atan2)(t0.y01, t0.x01), (0, $kzu0A.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $kzu0A.atan2)(t0.y01, t0.x01), (0, $kzu0A.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $kzu0A.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $kzu0A.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $kzu0A.atan2)(t1.y11, t1.x11), (0, $kzu0A.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $kzu0A.pi / 2;
        return [
            (0, $kzu0A.cos)(a) * r,
            (0, $kzu0A.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $4d9f3c8801d91c8b$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $4d9f3c8801d91c8b$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $4d9f3c8801d91c8b$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $4d9f3c8801d91c8b$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $4d9f3c8801d91c8b$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $4d9f3c8801d91c8b$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $4d9f3c8801d91c8b$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("brG7m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $8552e303c12cffa8$var$_path.default;
    }
});

var $8552e303c12cffa8$var$_path = $8552e303c12cffa8$var$_interopRequireDefault((parcelRequire("lzWrf")));
function $8552e303c12cffa8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("lzWrf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $fb5a3280164634bd$var$pi = Math.PI, $fb5a3280164634bd$var$tau = 2 * $fb5a3280164634bd$var$pi, $fb5a3280164634bd$var$epsilon = 1e-6, $fb5a3280164634bd$var$tauEpsilon = $fb5a3280164634bd$var$tau - $fb5a3280164634bd$var$epsilon;
function $fb5a3280164634bd$var$Path() {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $fb5a3280164634bd$var$path() {
    return new $fb5a3280164634bd$var$Path();
}
$fb5a3280164634bd$var$Path.prototype = $fb5a3280164634bd$var$path.prototype = {
    constructor: $fb5a3280164634bd$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $fb5a3280164634bd$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $fb5a3280164634bd$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($fb5a3280164634bd$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $fb5a3280164634bd$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $fb5a3280164634bd$var$epsilon || Math.abs(this._y1 - y0) > $fb5a3280164634bd$var$epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $fb5a3280164634bd$var$tau + $fb5a3280164634bd$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $fb5a3280164634bd$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $fb5a3280164634bd$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $fb5a3280164634bd$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $fb5a3280164634bd$var$_default = module.exports.default = $fb5a3280164634bd$var$path;

});


parcelRegister("cYVR4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9737f76c20a42154$var$_default;
function $9737f76c20a42154$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("kzu0A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $ef9e5a96ae34c285$var$acos;
module.exports.asin = $ef9e5a96ae34c285$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $ef9e5a96ae34c285$var$abs = module.exports.abs = Math.abs;
const $ef9e5a96ae34c285$var$atan2 = module.exports.atan2 = Math.atan2;
const $ef9e5a96ae34c285$var$cos = module.exports.cos = Math.cos;
const $ef9e5a96ae34c285$var$max = module.exports.max = Math.max;
const $ef9e5a96ae34c285$var$min = module.exports.min = Math.min;
const $ef9e5a96ae34c285$var$sin = module.exports.sin = Math.sin;
const $ef9e5a96ae34c285$var$sqrt = module.exports.sqrt = Math.sqrt;
const $ef9e5a96ae34c285$var$epsilon = module.exports.epsilon = 1e-12;
const $ef9e5a96ae34c285$var$pi = module.exports.pi = Math.PI;
const $ef9e5a96ae34c285$var$halfPi = module.exports.halfPi = $ef9e5a96ae34c285$var$pi / 2;
const $ef9e5a96ae34c285$var$tau = module.exports.tau = 2 * $ef9e5a96ae34c285$var$pi;
function $ef9e5a96ae34c285$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $ef9e5a96ae34c285$var$pi : Math.acos(x);
}
function $ef9e5a96ae34c285$var$asin(x) {
    return x >= 1 ? $ef9e5a96ae34c285$var$halfPi : x <= -1 ? -$ef9e5a96ae34c285$var$halfPi : Math.asin(x);
}

});


parcelRegister("lrdSz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f9b6e2b07a485c97$var$_default;

var $brG7m = parcelRequire("brG7m");

var $f9b6e2b07a485c97$var$_array = $f9b6e2b07a485c97$var$_interopRequireDefault((parcelRequire("gK2na")));

var $f9b6e2b07a485c97$var$_constant = $f9b6e2b07a485c97$var$_interopRequireDefault((parcelRequire("cYVR4")));

var $f9b6e2b07a485c97$var$_linear = $f9b6e2b07a485c97$var$_interopRequireDefault((parcelRequire("gxO0C")));

var $f9b6e2b07a485c97$var$_line = $f9b6e2b07a485c97$var$_interopRequireDefault((parcelRequire("lle2Y")));

var $ikpw0 = parcelRequire("ikpw0");
function $f9b6e2b07a485c97$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f9b6e2b07a485c97$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $f9b6e2b07a485c97$var$_constant.default)(true), context = null, curve = $f9b6e2b07a485c97$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $ikpw0.x : (0, $f9b6e2b07a485c97$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $f9b6e2b07a485c97$var$_constant.default)(0) : (0, $f9b6e2b07a485c97$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $ikpw0.y : (0, $f9b6e2b07a485c97$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $f9b6e2b07a485c97$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $brG7m.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $f9b6e2b07a485c97$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $f9b6e2b07a485c97$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $f9b6e2b07a485c97$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $f9b6e2b07a485c97$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $f9b6e2b07a485c97$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $f9b6e2b07a485c97$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $f9b6e2b07a485c97$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $f9b6e2b07a485c97$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("gK2na", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c302c8642986fdaf$var$_default;
module.exports.slice = void 0;
var $c302c8642986fdaf$var$slice = module.exports.slice = Array.prototype.slice;
function $c302c8642986fdaf$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("gxO0C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c0b685270b9c898e$var$_default;
function $c0b685270b9c898e$var$Linear(context) {
    this._context = context;
}
$c0b685270b9c898e$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $c0b685270b9c898e$var$_default(context) {
    return new $c0b685270b9c898e$var$Linear(context);
}

});

parcelRegister("lle2Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f896748da09f8d24$var$_default;

var $brG7m = parcelRequire("brG7m");

var $f896748da09f8d24$var$_array = $f896748da09f8d24$var$_interopRequireDefault((parcelRequire("gK2na")));

var $f896748da09f8d24$var$_constant = $f896748da09f8d24$var$_interopRequireDefault((parcelRequire("cYVR4")));

var $f896748da09f8d24$var$_linear = $f896748da09f8d24$var$_interopRequireDefault((parcelRequire("gxO0C")));

var $ikpw0 = parcelRequire("ikpw0");
function $f896748da09f8d24$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f896748da09f8d24$var$_default(x, y) {
    var defined = (0, $f896748da09f8d24$var$_constant.default)(true), context = null, curve = $f896748da09f8d24$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $ikpw0.x : (0, $f896748da09f8d24$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $ikpw0.y : (0, $f896748da09f8d24$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $f896748da09f8d24$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $brG7m.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $f896748da09f8d24$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $f896748da09f8d24$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $f896748da09f8d24$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("ikpw0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $d57de30de1793c8c$var$x;
module.exports.y = $d57de30de1793c8c$var$y;
function $d57de30de1793c8c$var$x(p) {
    return p[0];
}
function $d57de30de1793c8c$var$y(p) {
    return p[1];
}

});



parcelRegister("57aYH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3b961f332a681c0d$var$_default;

var $3b961f332a681c0d$var$_array = $3b961f332a681c0d$var$_interopRequireDefault((parcelRequire("gK2na")));

var $3b961f332a681c0d$var$_constant = $3b961f332a681c0d$var$_interopRequireDefault((parcelRequire("cYVR4")));

var $3b961f332a681c0d$var$_descending = $3b961f332a681c0d$var$_interopRequireDefault((parcelRequire("c3EsM")));

var $3b961f332a681c0d$var$_identity = $3b961f332a681c0d$var$_interopRequireDefault((parcelRequire("5RVp6")));

var $kzu0A = parcelRequire("kzu0A");
function $3b961f332a681c0d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3b961f332a681c0d$var$_default() {
    var value = $3b961f332a681c0d$var$_identity.default, sortValues = $3b961f332a681c0d$var$_descending.default, sort = null, startAngle = (0, $3b961f332a681c0d$var$_constant.default)(0), endAngle = (0, $3b961f332a681c0d$var$_constant.default)($kzu0A.tau), padAngle = (0, $3b961f332a681c0d$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $3b961f332a681c0d$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($kzu0A.tau, Math.max(-$kzu0A.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $3b961f332a681c0d$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $3b961f332a681c0d$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $3b961f332a681c0d$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $3b961f332a681c0d$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("c3EsM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c7526fdeb297b7d$var$_default;
function $8c7526fdeb297b7d$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("5RVp6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $445e6e2e3d665f9f$var$_default;
function $445e6e2e3d665f9f$var$_default(d) {
    return d;
}

});


parcelRegister("l2baO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f50273ac6a99f3c9$var$_default;

var $f50273ac6a99f3c9$var$_radial = $f50273ac6a99f3c9$var$_interopRequireWildcard((parcelRequire("krfMn")));

var $f50273ac6a99f3c9$var$_area = $f50273ac6a99f3c9$var$_interopRequireDefault((parcelRequire("lrdSz")));

var $jq8kz = parcelRequire("jq8kz");
function $f50273ac6a99f3c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f50273ac6a99f3c9$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f50273ac6a99f3c9$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $f50273ac6a99f3c9$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $f50273ac6a99f3c9$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $f50273ac6a99f3c9$var$_default() {
    var a = (0, $f50273ac6a99f3c9$var$_area.default)().curve($f50273ac6a99f3c9$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $jq8kz.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $jq8kz.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $jq8kz.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $jq8kz.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $f50273ac6a99f3c9$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("krfMn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $ee1291b00989bde6$var$curveRadial;

var $ee1291b00989bde6$var$_linear = $ee1291b00989bde6$var$_interopRequireDefault((parcelRequire("gxO0C")));
function $ee1291b00989bde6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ee1291b00989bde6$var$curveRadialLinear = module.exports.curveRadialLinear = $ee1291b00989bde6$var$curveRadial($ee1291b00989bde6$var$_linear.default);
function $ee1291b00989bde6$var$Radial(curve) {
    this._curve = curve;
}
$ee1291b00989bde6$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $ee1291b00989bde6$var$curveRadial(curve) {
    function radial(context) {
        return new $ee1291b00989bde6$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("jq8kz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e236e8575014af18$var$_default;
module.exports.lineRadial = $e236e8575014af18$var$lineRadial;

var $e236e8575014af18$var$_radial = $e236e8575014af18$var$_interopRequireWildcard((parcelRequire("krfMn")));

var $e236e8575014af18$var$_line = $e236e8575014af18$var$_interopRequireDefault((parcelRequire("lle2Y")));
function $e236e8575014af18$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e236e8575014af18$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e236e8575014af18$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $e236e8575014af18$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $e236e8575014af18$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $e236e8575014af18$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $e236e8575014af18$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $e236e8575014af18$var$_default() {
    return $e236e8575014af18$var$lineRadial((0, $e236e8575014af18$var$_line.default)().curve($e236e8575014af18$var$_radial.curveRadialLinear));
}

});


parcelRegister("aIRPj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7ce7c446617d5749$var$_default;
function $7ce7c446617d5749$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("aWCiS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $7f7d0871ed465c80$var$link;
module.exports.linkHorizontal = $7f7d0871ed465c80$var$linkHorizontal;
module.exports.linkRadial = $7f7d0871ed465c80$var$linkRadial;
module.exports.linkVertical = $7f7d0871ed465c80$var$linkVertical;

var $brG7m = parcelRequire("brG7m");

var $gK2na = parcelRequire("gK2na");

var $7f7d0871ed465c80$var$_constant = $7f7d0871ed465c80$var$_interopRequireDefault((parcelRequire("cYVR4")));

var $6s1v0 = parcelRequire("6s1v0");

var $ikpw0 = parcelRequire("ikpw0");
function $7f7d0871ed465c80$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7f7d0871ed465c80$var$linkSource(d) {
    return d.source;
}
function $7f7d0871ed465c80$var$linkTarget(d) {
    return d.target;
}
function $7f7d0871ed465c80$var$link(curve) {
    let source = $7f7d0871ed465c80$var$linkSource;
    let target = $7f7d0871ed465c80$var$linkTarget;
    let x = $ikpw0.x;
    let y = $ikpw0.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $gK2na.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $brG7m.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $7f7d0871ed465c80$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $7f7d0871ed465c80$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $7f7d0871ed465c80$var$linkHorizontal() {
    return $7f7d0871ed465c80$var$link($6s1v0.bumpX);
}
function $7f7d0871ed465c80$var$linkVertical() {
    return $7f7d0871ed465c80$var$link($6s1v0.bumpY);
}
function $7f7d0871ed465c80$var$linkRadial() {
    const l = $7f7d0871ed465c80$var$link($6s1v0.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("6s1v0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $4b26854aeb71b67f$var$bumpRadial;
module.exports.bumpX = $4b26854aeb71b67f$var$bumpX;
module.exports.bumpY = $4b26854aeb71b67f$var$bumpY;

var $4b26854aeb71b67f$var$_pointRadial = $4b26854aeb71b67f$var$_interopRequireDefault((parcelRequire("aIRPj")));
function $4b26854aeb71b67f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $4b26854aeb71b67f$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $4b26854aeb71b67f$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $4b26854aeb71b67f$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $4b26854aeb71b67f$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $4b26854aeb71b67f$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $4b26854aeb71b67f$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $4b26854aeb71b67f$var$bumpX(context) {
    return new $4b26854aeb71b67f$var$Bump(context, true);
}
function $4b26854aeb71b67f$var$bumpY(context) {
    return new $4b26854aeb71b67f$var$Bump(context, false);
}
function $4b26854aeb71b67f$var$bumpRadial(context) {
    return new $4b26854aeb71b67f$var$BumpRadial(context);
}

});


parcelRegister("52wi8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3ab6300dc10c9b9f$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $brG7m = parcelRequire("brG7m");

var $3ab6300dc10c9b9f$var$_constant = $3ab6300dc10c9b9f$var$_interopRequireDefault((parcelRequire("cYVR4")));

var $3ab6300dc10c9b9f$var$_asterisk = $3ab6300dc10c9b9f$var$_interopRequireDefault((parcelRequire("aapJB")));

var $3ab6300dc10c9b9f$var$_circle = $3ab6300dc10c9b9f$var$_interopRequireDefault((parcelRequire("kbtSK")));

var $3ab6300dc10c9b9f$var$_cross = $3ab6300dc10c9b9f$var$_interopRequireDefault((parcelRequire("6hs13")));

var $3ab6300dc10c9b9f$var$_diamond = $3ab6300dc10c9b9f$var$_interopRequireDefault((parcelRequire("f4rvL")));

var $3ab6300dc10c9b9f$var$_diamond2 = $3ab6300dc10c9b9f$var$_interopRequireDefault((parcelRequire("9FYK2")));

var $3ab6300dc10c9b9f$var$_plus = $3ab6300dc10c9b9f$var$_interopRequireDefault((parcelRequire("jLrfX")));

var $3ab6300dc10c9b9f$var$_square = $3ab6300dc10c9b9f$var$_interopRequireDefault((parcelRequire("kUmKT")));

var $3ab6300dc10c9b9f$var$_square2 = $3ab6300dc10c9b9f$var$_interopRequireDefault((parcelRequire("7DfA8")));

var $3ab6300dc10c9b9f$var$_star = $3ab6300dc10c9b9f$var$_interopRequireDefault((parcelRequire("gMmLy")));

var $3ab6300dc10c9b9f$var$_triangle = $3ab6300dc10c9b9f$var$_interopRequireDefault((parcelRequire("2ZkFE")));

var $3ab6300dc10c9b9f$var$_triangle2 = $3ab6300dc10c9b9f$var$_interopRequireDefault((parcelRequire("etE91")));

var $3ab6300dc10c9b9f$var$_wye = $3ab6300dc10c9b9f$var$_interopRequireDefault((parcelRequire("brV8L")));

var $3ab6300dc10c9b9f$var$_x = $3ab6300dc10c9b9f$var$_interopRequireDefault((parcelRequire("OTry2")));
function $3ab6300dc10c9b9f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $3ab6300dc10c9b9f$var$symbolsFill = module.exports.symbolsFill = [
    $3ab6300dc10c9b9f$var$_circle.default,
    $3ab6300dc10c9b9f$var$_cross.default,
    $3ab6300dc10c9b9f$var$_diamond.default,
    $3ab6300dc10c9b9f$var$_square.default,
    $3ab6300dc10c9b9f$var$_star.default,
    $3ab6300dc10c9b9f$var$_triangle.default,
    $3ab6300dc10c9b9f$var$_wye.default
];
// These symbols are designed to be stroked (with a width of 1.5px and round caps).
const $3ab6300dc10c9b9f$var$symbolsStroke = module.exports.symbolsStroke = [
    $3ab6300dc10c9b9f$var$_circle.default,
    $3ab6300dc10c9b9f$var$_plus.default,
    $3ab6300dc10c9b9f$var$_x.default,
    $3ab6300dc10c9b9f$var$_triangle2.default,
    $3ab6300dc10c9b9f$var$_asterisk.default,
    $3ab6300dc10c9b9f$var$_square2.default,
    $3ab6300dc10c9b9f$var$_diamond2.default
];
function $3ab6300dc10c9b9f$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $3ab6300dc10c9b9f$var$_constant.default)(type || $3ab6300dc10c9b9f$var$_circle.default);
    size = typeof size === "function" ? size : (0, $3ab6300dc10c9b9f$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $brG7m.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $3ab6300dc10c9b9f$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $3ab6300dc10c9b9f$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("aapJB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kzu0A = parcelRequire("kzu0A");
const $766ecce014c6d587$var$sqrt3 = (0, $kzu0A.sqrt)(3);
var $766ecce014c6d587$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $kzu0A.sqrt)(size + (0, $kzu0A.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $766ecce014c6d587$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};

});

parcelRegister("kbtSK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kzu0A = parcelRequire("kzu0A");
var $eb1c03b14d9737e4$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $kzu0A.sqrt)(size / $kzu0A.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $kzu0A.tau);
    }
};

});

parcelRegister("6hs13", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kzu0A = parcelRequire("kzu0A");
var $492a0ffc81eb5dc0$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $kzu0A.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};

});

parcelRegister("f4rvL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kzu0A = parcelRequire("kzu0A");
const $af8c91ee4fdfc6b0$var$tan30 = (0, $kzu0A.sqrt)(1 / 3);
const $af8c91ee4fdfc6b0$var$tan30_2 = $af8c91ee4fdfc6b0$var$tan30 * 2;
var $af8c91ee4fdfc6b0$var$_default = module.exports.default = {
    draw (context, size) {
        const y = (0, $kzu0A.sqrt)(size / $af8c91ee4fdfc6b0$var$tan30_2);
        const x = y * $af8c91ee4fdfc6b0$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};

});

parcelRegister("9FYK2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kzu0A = parcelRequire("kzu0A");
var $70b70f603cb4f556$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $kzu0A.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};

});

parcelRegister("jLrfX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kzu0A = parcelRequire("kzu0A");
var $e6378ca6431b3256$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $kzu0A.sqrt)(size - (0, $kzu0A.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};

});

parcelRegister("kUmKT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kzu0A = parcelRequire("kzu0A");
var $f38ab059f8796914$var$_default = module.exports.default = {
    draw (context, size) {
        const w = (0, $kzu0A.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};

});

parcelRegister("7DfA8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kzu0A = parcelRequire("kzu0A");
var $58e8432b151da0fd$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $kzu0A.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};

});

parcelRegister("gMmLy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kzu0A = parcelRequire("kzu0A");
const $c372c9ea052c764d$var$ka = 0.89081309152928522810;
const $c372c9ea052c764d$var$kr = (0, $kzu0A.sin)($kzu0A.pi / 10) / (0, $kzu0A.sin)(7 * $kzu0A.pi / 10);
const $c372c9ea052c764d$var$kx = (0, $kzu0A.sin)($kzu0A.tau / 10) * $c372c9ea052c764d$var$kr;
const $c372c9ea052c764d$var$ky = -(0, $kzu0A.cos)($kzu0A.tau / 10) * $c372c9ea052c764d$var$kr;
var $c372c9ea052c764d$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $kzu0A.sqrt)(size * $c372c9ea052c764d$var$ka);
        const x = $c372c9ea052c764d$var$kx * r;
        const y = $c372c9ea052c764d$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $kzu0A.tau * i / 5;
            const c = (0, $kzu0A.cos)(a);
            const s = (0, $kzu0A.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};

});

parcelRegister("2ZkFE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kzu0A = parcelRequire("kzu0A");
const $22d1500c2d8b8415$var$sqrt3 = (0, $kzu0A.sqrt)(3);
var $22d1500c2d8b8415$var$_default = module.exports.default = {
    draw (context, size) {
        const y = -(0, $kzu0A.sqrt)(size / ($22d1500c2d8b8415$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$22d1500c2d8b8415$var$sqrt3 * y, -y);
        context.lineTo($22d1500c2d8b8415$var$sqrt3 * y, -y);
        context.closePath();
    }
};

});

parcelRegister("etE91", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kzu0A = parcelRequire("kzu0A");
const $a8a2e9feaf95fd1d$var$sqrt3 = (0, $kzu0A.sqrt)(3);
var $a8a2e9feaf95fd1d$var$_default = module.exports.default = {
    draw (context, size) {
        const s = (0, $kzu0A.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $a8a2e9feaf95fd1d$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};

});

parcelRegister("brV8L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kzu0A = parcelRequire("kzu0A");
const $855e8a3b8b834ee9$var$c = -0.5;
const $855e8a3b8b834ee9$var$s = (0, $kzu0A.sqrt)(3) / 2;
const $855e8a3b8b834ee9$var$k = 1 / (0, $kzu0A.sqrt)(12);
const $855e8a3b8b834ee9$var$a = ($855e8a3b8b834ee9$var$k / 2 + 1) * 3;
var $855e8a3b8b834ee9$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $kzu0A.sqrt)(size / $855e8a3b8b834ee9$var$a);
        const x0 = r / 2, y0 = r * $855e8a3b8b834ee9$var$k;
        const x1 = x0, y1 = r * $855e8a3b8b834ee9$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($855e8a3b8b834ee9$var$c * x0 - $855e8a3b8b834ee9$var$s * y0, $855e8a3b8b834ee9$var$s * x0 + $855e8a3b8b834ee9$var$c * y0);
        context.lineTo($855e8a3b8b834ee9$var$c * x1 - $855e8a3b8b834ee9$var$s * y1, $855e8a3b8b834ee9$var$s * x1 + $855e8a3b8b834ee9$var$c * y1);
        context.lineTo($855e8a3b8b834ee9$var$c * x2 - $855e8a3b8b834ee9$var$s * y2, $855e8a3b8b834ee9$var$s * x2 + $855e8a3b8b834ee9$var$c * y2);
        context.lineTo($855e8a3b8b834ee9$var$c * x0 + $855e8a3b8b834ee9$var$s * y0, $855e8a3b8b834ee9$var$c * y0 - $855e8a3b8b834ee9$var$s * x0);
        context.lineTo($855e8a3b8b834ee9$var$c * x1 + $855e8a3b8b834ee9$var$s * y1, $855e8a3b8b834ee9$var$c * y1 - $855e8a3b8b834ee9$var$s * x1);
        context.lineTo($855e8a3b8b834ee9$var$c * x2 + $855e8a3b8b834ee9$var$s * y2, $855e8a3b8b834ee9$var$c * y2 - $855e8a3b8b834ee9$var$s * x2);
        context.closePath();
    }
};

});

parcelRegister("OTry2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kzu0A = parcelRequire("kzu0A");
var $098fad83ddc36e6c$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $kzu0A.sqrt)(size - (0, $kzu0A.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};

});


parcelRegister("kOxuT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f27276090b112b0a$var$_default;

var $f27276090b112b0a$var$_noop = $f27276090b112b0a$var$_interopRequireDefault((parcelRequire("lpYdN")));

var $1puIN = parcelRequire("1puIN");
function $f27276090b112b0a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f27276090b112b0a$var$BasisClosed(context) {
    this._context = context;
}
$f27276090b112b0a$var$BasisClosed.prototype = {
    areaStart: $f27276090b112b0a$var$_noop.default,
    areaEnd: $f27276090b112b0a$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $1puIN.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $f27276090b112b0a$var$_default(context) {
    return new $f27276090b112b0a$var$BasisClosed(context);
}

});
parcelRegister("lpYdN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f97aa5855306ee15$var$_default;
function $f97aa5855306ee15$var$_default() {}

});

parcelRegister("1puIN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $106ff4e274820dcc$var$Basis;
module.exports.default = $106ff4e274820dcc$var$_default;
module.exports.point = $106ff4e274820dcc$var$point;
function $106ff4e274820dcc$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $106ff4e274820dcc$var$Basis(context) {
    this._context = context;
}
$106ff4e274820dcc$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $106ff4e274820dcc$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $106ff4e274820dcc$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $106ff4e274820dcc$var$_default(context) {
    return new $106ff4e274820dcc$var$Basis(context);
}

});


parcelRegister("dJjfL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9fee699ea3a2c7b4$var$_default;

var $1puIN = parcelRequire("1puIN");
function $9fee699ea3a2c7b4$var$BasisOpen(context) {
    this._context = context;
}
$9fee699ea3a2c7b4$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $1puIN.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $9fee699ea3a2c7b4$var$_default(context) {
    return new $9fee699ea3a2c7b4$var$BasisOpen(context);
}

});

parcelRegister("lX4oA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1puIN = parcelRequire("1puIN");
function $ffb28484a1d157df$var$Bundle(context, beta) {
    this._basis = new $1puIN.Basis(context);
    this._beta = beta;
}
$ffb28484a1d157df$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $ffb28484a1d157df$var$_default = module.exports.default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $1puIN.Basis(context) : new $ffb28484a1d157df$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

});

parcelRegister("cVUbL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $96a664d6bdcac0a8$var$CardinalClosed;
module.exports.default = void 0;

var $96a664d6bdcac0a8$var$_noop = $96a664d6bdcac0a8$var$_interopRequireDefault((parcelRequire("lpYdN")));

var $6eWgG = parcelRequire("6eWgG");
function $96a664d6bdcac0a8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $96a664d6bdcac0a8$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$96a664d6bdcac0a8$var$CardinalClosed.prototype = {
    areaStart: $96a664d6bdcac0a8$var$_noop.default,
    areaEnd: $96a664d6bdcac0a8$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $6eWgG.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $96a664d6bdcac0a8$var$_default = module.exports.default = function custom(tension) {
    function cardinal(context) {
        return new $96a664d6bdcac0a8$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});
parcelRegister("6eWgG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $48b13fb5faa7cb27$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $48b13fb5faa7cb27$var$point;
function $48b13fb5faa7cb27$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $48b13fb5faa7cb27$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$48b13fb5faa7cb27$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $48b13fb5faa7cb27$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $48b13fb5faa7cb27$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $48b13fb5faa7cb27$var$_default = module.exports.default = function custom(tension) {
    function cardinal(context) {
        return new $48b13fb5faa7cb27$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});


parcelRegister("ggpAQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $bd71fe3cb1b67ad5$var$CardinalOpen;
module.exports.default = void 0;

var $6eWgG = parcelRequire("6eWgG");
function $bd71fe3cb1b67ad5$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$bd71fe3cb1b67ad5$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $6eWgG.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $bd71fe3cb1b67ad5$var$_default = module.exports.default = function custom(tension) {
    function cardinal(context) {
        return new $bd71fe3cb1b67ad5$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});

parcelRegister("ayES5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cVUbL = parcelRequire("cVUbL");

var $7afcc88ec053ce25$var$_noop = $7afcc88ec053ce25$var$_interopRequireDefault((parcelRequire("lpYdN")));

var $5QaoJ = parcelRequire("5QaoJ");
function $7afcc88ec053ce25$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7afcc88ec053ce25$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$7afcc88ec053ce25$var$CatmullRomClosed.prototype = {
    areaStart: $7afcc88ec053ce25$var$_noop.default,
    areaEnd: $7afcc88ec053ce25$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $5QaoJ.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $7afcc88ec053ce25$var$_default = module.exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $7afcc88ec053ce25$var$CatmullRomClosed(context, alpha) : new $cVUbL.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});
parcelRegister("5QaoJ", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;

var $kzu0A = parcelRequire("kzu0A");

var $6eWgG = parcelRequire("6eWgG");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $kzu0A.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $kzu0A.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new $6eWgG.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});


parcelRegister("6dFBx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ggpAQ = parcelRequire("ggpAQ");

var $5QaoJ = parcelRequire("5QaoJ");
function $48743abed9d37989$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$48743abed9d37989$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $5QaoJ.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $48743abed9d37989$var$_default = module.exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $48743abed9d37989$var$CatmullRomOpen(context, alpha) : new $ggpAQ.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});

parcelRegister("c940J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8d796fc5695546cb$var$_default;

var $8d796fc5695546cb$var$_noop = $8d796fc5695546cb$var$_interopRequireDefault((parcelRequire("lpYdN")));
function $8d796fc5695546cb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8d796fc5695546cb$var$LinearClosed(context) {
    this._context = context;
}
$8d796fc5695546cb$var$LinearClosed.prototype = {
    areaStart: $8d796fc5695546cb$var$_noop.default,
    areaEnd: $8d796fc5695546cb$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $8d796fc5695546cb$var$_default(context) {
    return new $8d796fc5695546cb$var$LinearClosed(context);
}

});

parcelRegister("kfXzw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $ebf36b1d982b87b2$var$monotoneX;
module.exports.monotoneY = $ebf36b1d982b87b2$var$monotoneY;
function $ebf36b1d982b87b2$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $ebf36b1d982b87b2$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($ebf36b1d982b87b2$var$sign(s0) + $ebf36b1d982b87b2$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $ebf36b1d982b87b2$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $ebf36b1d982b87b2$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $ebf36b1d982b87b2$var$MonotoneX(context) {
    this._context = context;
}
$ebf36b1d982b87b2$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $ebf36b1d982b87b2$var$point(this, this._t0, $ebf36b1d982b87b2$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $ebf36b1d982b87b2$var$point(this, $ebf36b1d982b87b2$var$slope2(this, t1 = $ebf36b1d982b87b2$var$slope3(this, x, y)), t1);
                break;
            default:
                $ebf36b1d982b87b2$var$point(this, this._t0, t1 = $ebf36b1d982b87b2$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $ebf36b1d982b87b2$var$MonotoneY(context) {
    this._context = new $ebf36b1d982b87b2$var$ReflectContext(context);
}
($ebf36b1d982b87b2$var$MonotoneY.prototype = Object.create($ebf36b1d982b87b2$var$MonotoneX.prototype)).point = function(x, y) {
    $ebf36b1d982b87b2$var$MonotoneX.prototype.point.call(this, y, x);
};
function $ebf36b1d982b87b2$var$ReflectContext(context) {
    this._context = context;
}
$ebf36b1d982b87b2$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $ebf36b1d982b87b2$var$monotoneX(context) {
    return new $ebf36b1d982b87b2$var$MonotoneX(context);
}
function $ebf36b1d982b87b2$var$monotoneY(context) {
    return new $ebf36b1d982b87b2$var$MonotoneY(context);
}

});

parcelRegister("cSK1v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $960e3a7377ca1f12$var$_default;
function $960e3a7377ca1f12$var$Natural(context) {
    this._context = context;
}
$960e3a7377ca1f12$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $960e3a7377ca1f12$var$controlPoints(x), py = $960e3a7377ca1f12$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $960e3a7377ca1f12$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $960e3a7377ca1f12$var$_default(context) {
    return new $960e3a7377ca1f12$var$Natural(context);
}

});

parcelRegister("cnDUf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9036968e0d05b388$var$_default;
module.exports.stepAfter = $9036968e0d05b388$var$stepAfter;
module.exports.stepBefore = $9036968e0d05b388$var$stepBefore;
function $9036968e0d05b388$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$9036968e0d05b388$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $9036968e0d05b388$var$_default(context) {
    return new $9036968e0d05b388$var$Step(context, 0.5);
}
function $9036968e0d05b388$var$stepBefore(context) {
    return new $9036968e0d05b388$var$Step(context, 0);
}
function $9036968e0d05b388$var$stepAfter(context) {
    return new $9036968e0d05b388$var$Step(context, 1);
}

});

parcelRegister("21K7T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $179f74797e2e0a6d$var$_default;

var $179f74797e2e0a6d$var$_array = $179f74797e2e0a6d$var$_interopRequireDefault((parcelRequire("gK2na")));

var $179f74797e2e0a6d$var$_constant = $179f74797e2e0a6d$var$_interopRequireDefault((parcelRequire("cYVR4")));

var $179f74797e2e0a6d$var$_none = $179f74797e2e0a6d$var$_interopRequireDefault((parcelRequire("PU0MH")));

var $179f74797e2e0a6d$var$_none2 = $179f74797e2e0a6d$var$_interopRequireDefault((parcelRequire("3Fs8s")));
function $179f74797e2e0a6d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $179f74797e2e0a6d$var$stackValue(d, key) {
    return d[key];
}
function $179f74797e2e0a6d$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $179f74797e2e0a6d$var$_default() {
    var keys = (0, $179f74797e2e0a6d$var$_constant.default)([]), order = $179f74797e2e0a6d$var$_none2.default, offset = $179f74797e2e0a6d$var$_none.default, value = $179f74797e2e0a6d$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $179f74797e2e0a6d$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $179f74797e2e0a6d$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $179f74797e2e0a6d$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $179f74797e2e0a6d$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $179f74797e2e0a6d$var$_none2.default : typeof _ === "function" ? _ : (0, $179f74797e2e0a6d$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $179f74797e2e0a6d$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("PU0MH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $09c03648325c1065$var$_default;
function $09c03648325c1065$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("3Fs8s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2abb0687696ba3e3$var$_default;
function $2abb0687696ba3e3$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("kqrHm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $edebb8a896cbe827$var$_default;

var $edebb8a896cbe827$var$_none = $edebb8a896cbe827$var$_interopRequireDefault((parcelRequire("PU0MH")));
function $edebb8a896cbe827$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $edebb8a896cbe827$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $edebb8a896cbe827$var$_none.default)(series, order);
}

});

parcelRegister("hafCN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c7ef7d9d0de2ee28$var$_default;
function $c7ef7d9d0de2ee28$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("cdweh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8e4fb2fda26edac8$var$_default;

var $8e4fb2fda26edac8$var$_none = $8e4fb2fda26edac8$var$_interopRequireDefault((parcelRequire("PU0MH")));
function $8e4fb2fda26edac8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8e4fb2fda26edac8$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $8e4fb2fda26edac8$var$_none.default)(series, order);
}

});

parcelRegister("cK1ui", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $946aef4fa92c761e$var$_default;

var $946aef4fa92c761e$var$_none = $946aef4fa92c761e$var$_interopRequireDefault((parcelRequire("PU0MH")));
function $946aef4fa92c761e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $946aef4fa92c761e$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $946aef4fa92c761e$var$_none.default)(series, order);
}

});

parcelRegister("iEDzB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d94aa8d18acd13b7$var$_default;

var $d94aa8d18acd13b7$var$_none = $d94aa8d18acd13b7$var$_interopRequireDefault((parcelRequire("3Fs8s")));
function $d94aa8d18acd13b7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d94aa8d18acd13b7$var$_default(series) {
    var peaks = series.map($d94aa8d18acd13b7$var$peak);
    return (0, $d94aa8d18acd13b7$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $d94aa8d18acd13b7$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("6hzTl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $49302bf05b7b9d93$var$_default;
module.exports.sum = $49302bf05b7b9d93$var$sum;

var $49302bf05b7b9d93$var$_none = $49302bf05b7b9d93$var$_interopRequireDefault((parcelRequire("3Fs8s")));
function $49302bf05b7b9d93$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $49302bf05b7b9d93$var$_default(series) {
    var sums = series.map($49302bf05b7b9d93$var$sum);
    return (0, $49302bf05b7b9d93$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $49302bf05b7b9d93$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("2H8mv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1f661570650d0ad5$var$_default;

var $1f661570650d0ad5$var$_ascending = $1f661570650d0ad5$var$_interopRequireDefault((parcelRequire("6hzTl")));
function $1f661570650d0ad5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1f661570650d0ad5$var$_default(series) {
    return (0, $1f661570650d0ad5$var$_ascending.default)(series).reverse();
}

});

parcelRegister("9tTlP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6e71c20c3bc8ae57$var$_default;

var $6e71c20c3bc8ae57$var$_appearance = $6e71c20c3bc8ae57$var$_interopRequireDefault((parcelRequire("iEDzB")));

var $6hzTl = parcelRequire("6hzTl");
function $6e71c20c3bc8ae57$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6e71c20c3bc8ae57$var$_default(series) {
    var n = series.length, i, j, sums = series.map($6hzTl.sum), order = (0, $6e71c20c3bc8ae57$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("T5s8g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0a595df8a124f48c$var$_default;

var $0a595df8a124f48c$var$_none = $0a595df8a124f48c$var$_interopRequireDefault((parcelRequire("3Fs8s")));
function $0a595df8a124f48c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0a595df8a124f48c$var$_default(series) {
    return (0, $0a595df8a124f48c$var$_none.default)(series).reverse();
}

});



parcelRegister("dRiSd", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $a16edd7a6c272690$export$bf730a2d8bf68b42, (v) => $a16edd7a6c272690$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a16edd7a6c272690$export$bf730a2d8bf68b42;
"use strict";

var $28UcW = parcelRequire("28UcW");

var $enMX3 = parcelRequire("enMX3");
function $a16edd7a6c272690$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $a16edd7a6c272690$var$objectIs = "function" === typeof Object.is ? Object.is : $a16edd7a6c272690$var$is, $a16edd7a6c272690$var$useSyncExternalStore = $enMX3.useSyncExternalStore, $a16edd7a6c272690$var$useRef = $28UcW.useRef, $a16edd7a6c272690$var$useEffect = $28UcW.useEffect, $a16edd7a6c272690$var$useMemo = $28UcW.useMemo, $a16edd7a6c272690$var$useDebugValue = $28UcW.useDebugValue;
$a16edd7a6c272690$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $a16edd7a6c272690$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $a16edd7a6c272690$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($a16edd7a6c272690$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $a16edd7a6c272690$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $a16edd7a6c272690$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $a16edd7a6c272690$var$useDebugValue(value);
    return value;
};

});
parcelRegister("enMX3", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hjNce"));

});
parcelRegister("hjNce", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9ba5f5a91cd99b2$export$306c0aa65ff9ec16, (v) => $c9ba5f5a91cd99b2$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9ba5f5a91cd99b2$export$306c0aa65ff9ec16;
"use strict";

var $28UcW = parcelRequire("28UcW");
function $c9ba5f5a91cd99b2$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9ba5f5a91cd99b2$var$objectIs = "function" === typeof Object.is ? Object.is : $c9ba5f5a91cd99b2$var$is, $c9ba5f5a91cd99b2$var$useState = $28UcW.useState, $c9ba5f5a91cd99b2$var$useEffect = $28UcW.useEffect, $c9ba5f5a91cd99b2$var$useLayoutEffect = $28UcW.useLayoutEffect, $c9ba5f5a91cd99b2$var$useDebugValue = $28UcW.useDebugValue;
function $c9ba5f5a91cd99b2$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9ba5f5a91cd99b2$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9ba5f5a91cd99b2$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9ba5f5a91cd99b2$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9ba5f5a91cd99b2$var$useEffect(function() {
        $c9ba5f5a91cd99b2$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9ba5f5a91cd99b2$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9ba5f5a91cd99b2$var$useDebugValue(value);
    return value;
}
function $c9ba5f5a91cd99b2$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9ba5f5a91cd99b2$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9ba5f5a91cd99b2$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9ba5f5a91cd99b2$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9ba5f5a91cd99b2$var$useSyncExternalStore$1 : $c9ba5f5a91cd99b2$var$useSyncExternalStore$2;
$c9ba5f5a91cd99b2$export$306c0aa65ff9ec16 = void 0 !== $28UcW.useSyncExternalStore ? $28UcW.useSyncExternalStore : $c9ba5f5a91cd99b2$var$shim;

});



parcelRegister("f6ZVJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hOsGj = parcelRequire("hOsGj");
function $b007749d9bd6425a$var$throttle(func, throttleMs = 0, options = {}) {
    const { leading: leading = true, trailing: trailing = true } = options;
    return $hOsGj.debounce(func, throttleMs, {
        leading: leading,
        maxWait: throttleMs,
        trailing: trailing
    });
}
module.exports.throttle = $b007749d9bd6425a$var$throttle;

});
parcelRegister("hOsGj", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dOvoP = parcelRequire("dOvoP");
function $cf7d5abce11b0a24$var$debounce(func, debounceMs = 0, options = {}) {
    if (typeof options !== 'object') options = {};
    const { leading: leading = false, trailing: trailing = true, maxWait: maxWait } = options;
    const edges = Array(2);
    if (leading) edges[0] = 'leading';
    if (trailing) edges[1] = 'trailing';
    let result = undefined;
    let pendingAt = null;
    const _debounced = $dOvoP.debounce(function(...args) {
        result = func.apply(this, args);
        pendingAt = null;
    }, debounceMs, {
        edges: edges
    });
    const debounced = function(...args) {
        if (maxWait != null) {
            if (pendingAt === null) pendingAt = Date.now();
            if (Date.now() - pendingAt >= maxWait) {
                result = func.apply(this, args);
                pendingAt = Date.now();
                _debounced.cancel();
                _debounced.schedule();
                return result;
            }
        }
        _debounced.apply(this, args);
        return result;
    };
    const flush = ()=>{
        _debounced.flush();
        return result;
    };
    debounced.cancel = _debounced.cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports.debounce = $cf7d5abce11b0a24$var$debounce;

});
parcelRegister("dOvoP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $a0e84d25b9aeb4b3$var$debounce(func, debounceMs, { signal: signal, edges: edges } = {}) {
    let pendingThis = undefined;
    let pendingArgs = null;
    const leading = edges != null && edges.includes('leading');
    const trailing = edges == null || edges.includes('trailing');
    const invoke = ()=>{
        if (pendingArgs !== null) {
            func.apply(pendingThis, pendingArgs);
            pendingThis = undefined;
            pendingArgs = null;
        }
    };
    const onTimerEnd = ()=>{
        if (trailing) invoke();
        cancel();
    };
    let timeoutId = null;
    const schedule = ()=>{
        if (timeoutId != null) clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            timeoutId = null;
            onTimerEnd();
        }, debounceMs);
    };
    const cancelTimer = ()=>{
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
    };
    const cancel = ()=>{
        cancelTimer();
        pendingThis = undefined;
        pendingArgs = null;
    };
    const flush = ()=>{
        invoke();
    };
    const debounced = function(...args) {
        if (signal?.aborted) return;
        pendingThis = this;
        pendingArgs = args;
        const isFirstCall = timeoutId == null;
        schedule();
        if (leading && isFirstCall) invoke();
    };
    debounced.schedule = schedule;
    debounced.cancel = cancel;
    debounced.flush = flush;
    signal?.addEventListener('abort', cancel, {
        once: true
    });
    return debounced;
}
module.exports.debounce = $a0e84d25b9aeb4b3$var$debounce;

});



parcelRegister("aY1aK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dIEkZ = parcelRequire("dIEkZ");

var $dDcI2 = parcelRequire("dDcI2");
function $7fc06acce9064125$var$range(start, end, step) {
    if (step && typeof step !== 'number' && $dIEkZ.isIterateeCall(start, end, step)) end = step = undefined;
    start = $dDcI2.toFinite(start);
    if (end === undefined) {
        end = start;
        start = 0;
    } else end = $dDcI2.toFinite(end);
    step = step === undefined ? start < end ? 1 : -1 : $dDcI2.toFinite(step);
    const length = Math.max(Math.ceil((end - start) / (step || 1)), 0);
    const result = new Array(length);
    for(let index = 0; index < length; index++){
        result[index] = start;
        start += step;
    }
    return result;
}
module.exports.range = $7fc06acce9064125$var$range;

});
parcelRegister("dDcI2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $agLqY = parcelRequire("agLqY");
function $9ec8c6b0afe9bb61$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $agLqY.toNumber(value);
    if (value === Infinity || value === -Infinity) {
        const sign = value < 0 ? -1 : 1;
        return sign * Number.MAX_VALUE;
    }
    return value === value ? value : 0;
}
module.exports.toFinite = $9ec8c6b0afe9bb61$var$toFinite;

});
parcelRegister("agLqY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1IOt4 = parcelRequire("1IOt4");
function $77a03167caa76d8d$var$toNumber(value) {
    if ($1IOt4.isSymbol(value)) return NaN;
    return Number(value);
}
module.exports.toNumber = $77a03167caa76d8d$var$toNumber;

});



parcelRegister("55SMh", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("d3E3F"));

});
parcelRegister("d3E3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $981aa0e5d84ed9da$var$_tickFormat.default;
    }
});

var $981aa0e5d84ed9da$var$_band = $981aa0e5d84ed9da$var$_interopRequireWildcard((parcelRequire("gsrxk")));

var $981aa0e5d84ed9da$var$_identity = $981aa0e5d84ed9da$var$_interopRequireDefault((parcelRequire("cJNoy")));

var $981aa0e5d84ed9da$var$_linear = $981aa0e5d84ed9da$var$_interopRequireDefault((parcelRequire("kQSTd")));

var $981aa0e5d84ed9da$var$_log = $981aa0e5d84ed9da$var$_interopRequireDefault((parcelRequire("HKIoj")));

var $981aa0e5d84ed9da$var$_symlog = $981aa0e5d84ed9da$var$_interopRequireDefault((parcelRequire("6teXX")));

var $981aa0e5d84ed9da$var$_ordinal = $981aa0e5d84ed9da$var$_interopRequireWildcard((parcelRequire("421pD")));

var $981aa0e5d84ed9da$var$_pow = $981aa0e5d84ed9da$var$_interopRequireWildcard((parcelRequire("7veUS")));

var $981aa0e5d84ed9da$var$_radial = $981aa0e5d84ed9da$var$_interopRequireDefault((parcelRequire("52MRI")));

var $981aa0e5d84ed9da$var$_quantile = $981aa0e5d84ed9da$var$_interopRequireDefault((parcelRequire("jP6Dh")));

var $981aa0e5d84ed9da$var$_quantize = $981aa0e5d84ed9da$var$_interopRequireDefault((parcelRequire("koS5Q")));

var $981aa0e5d84ed9da$var$_threshold = $981aa0e5d84ed9da$var$_interopRequireDefault((parcelRequire("3ws42")));

var $981aa0e5d84ed9da$var$_time = $981aa0e5d84ed9da$var$_interopRequireDefault((parcelRequire("gp5UL")));

var $981aa0e5d84ed9da$var$_utcTime = $981aa0e5d84ed9da$var$_interopRequireDefault((parcelRequire("eJySu")));

var $981aa0e5d84ed9da$var$_sequential = $981aa0e5d84ed9da$var$_interopRequireWildcard((parcelRequire("dY6Rv")));

var $981aa0e5d84ed9da$var$_sequentialQuantile = $981aa0e5d84ed9da$var$_interopRequireDefault((parcelRequire("dqIdP")));

var $981aa0e5d84ed9da$var$_diverging = $981aa0e5d84ed9da$var$_interopRequireWildcard((parcelRequire("5BnxQ")));

var $981aa0e5d84ed9da$var$_tickFormat = $981aa0e5d84ed9da$var$_interopRequireDefault((parcelRequire("6db4r")));
function $981aa0e5d84ed9da$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $981aa0e5d84ed9da$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($981aa0e5d84ed9da$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $981aa0e5d84ed9da$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $981aa0e5d84ed9da$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}

});
parcelRegister("gsrxk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bfb49f10d14a5a3e$var$band;
module.exports.point = $bfb49f10d14a5a3e$var$point;

var $dCoBu = parcelRequire("dCoBu");

var $9Ob92 = parcelRequire("9Ob92");

var $bfb49f10d14a5a3e$var$_ordinal = $bfb49f10d14a5a3e$var$_interopRequireDefault((parcelRequire("421pD")));
function $bfb49f10d14a5a3e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bfb49f10d14a5a3e$var$band() {
    var scale = (0, $bfb49f10d14a5a3e$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $dCoBu.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $bfb49f10d14a5a3e$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $9Ob92.initRange.apply(rescale(), arguments);
}
function $bfb49f10d14a5a3e$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $bfb49f10d14a5a3e$var$pointish(copy());
    };
    return scale;
}
function $bfb49f10d14a5a3e$var$point() {
    return $bfb49f10d14a5a3e$var$pointish($bfb49f10d14a5a3e$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("dCoBu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $f97YE.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $6R9G4.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $6R9G4.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $f97YE.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $f97YE.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $9ea1e8bf7f514262$var$_zip.default;
    }
});

var $9ea1e8bf7f514262$var$_bisect = $9ea1e8bf7f514262$var$_interopRequireWildcard((parcelRequire("5t5vE")));

var $9ea1e8bf7f514262$var$_ascending = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("fA7xO")));

var $9ea1e8bf7f514262$var$_bisector = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("cF6M6")));

var $9ea1e8bf7f514262$var$_count = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("lDbTd")));

var $9ea1e8bf7f514262$var$_cross = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("jgXIf")));

var $9ea1e8bf7f514262$var$_cumsum = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("1CFFg")));

var $9ea1e8bf7f514262$var$_descending = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("29Wd4")));

var $9ea1e8bf7f514262$var$_deviation = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("7FMOl")));

var $9ea1e8bf7f514262$var$_extent = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("f2VUY")));

var $f97YE = parcelRequire("f97YE");

var $9ea1e8bf7f514262$var$_group = $9ea1e8bf7f514262$var$_interopRequireWildcard((parcelRequire("bZEVG")));

var $9ea1e8bf7f514262$var$_groupSort = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("bzV9j")));

var $9ea1e8bf7f514262$var$_bin = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("athdX")));

var $9ea1e8bf7f514262$var$_freedmanDiaconis = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("b43lB")));

var $9ea1e8bf7f514262$var$_scott = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("aqsqg")));

var $9ea1e8bf7f514262$var$_sturges = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("dqW3n")));

var $9ea1e8bf7f514262$var$_max = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("irqg9")));

var $9ea1e8bf7f514262$var$_maxIndex = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("hv5s2")));

var $9ea1e8bf7f514262$var$_mean = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("btBDu")));

var $9ea1e8bf7f514262$var$_median = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("1KUI7")));

var $9ea1e8bf7f514262$var$_merge = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("7ifZU")));

var $9ea1e8bf7f514262$var$_min = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("l90Ta")));

var $9ea1e8bf7f514262$var$_minIndex = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("knRBk")));

var $9ea1e8bf7f514262$var$_mode = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("70tmQ")));

var $9ea1e8bf7f514262$var$_nice = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("b8CXR")));

var $9ea1e8bf7f514262$var$_pairs = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("4tLeL")));

var $9ea1e8bf7f514262$var$_permute = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("5zx6r")));

var $9ea1e8bf7f514262$var$_quantile = $9ea1e8bf7f514262$var$_interopRequireWildcard((parcelRequire("a2RH2")));

var $9ea1e8bf7f514262$var$_quickselect = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("g7gfg")));

var $9ea1e8bf7f514262$var$_range = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("l0ajO")));

var $9ea1e8bf7f514262$var$_rank = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("2gYxM")));

var $9ea1e8bf7f514262$var$_least = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("5dnmq")));

var $9ea1e8bf7f514262$var$_leastIndex = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("Kb2Qx")));

var $9ea1e8bf7f514262$var$_greatest = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("0nepb")));

var $9ea1e8bf7f514262$var$_greatestIndex = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("80Lma")));

var $9ea1e8bf7f514262$var$_scan = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("6VunL")));

var $9ea1e8bf7f514262$var$_shuffle = $9ea1e8bf7f514262$var$_interopRequireWildcard((parcelRequire("3x690")));

var $9ea1e8bf7f514262$var$_sum = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("gaLfr")));

var $9ea1e8bf7f514262$var$_ticks = $9ea1e8bf7f514262$var$_interopRequireWildcard((parcelRequire("b1MWk")));

var $9ea1e8bf7f514262$var$_transpose = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("kFQj9")));

var $9ea1e8bf7f514262$var$_variance = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("5XiJ4")));

var $9ea1e8bf7f514262$var$_zip = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("9KYgZ")));

var $9ea1e8bf7f514262$var$_every = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("jDex2")));

var $9ea1e8bf7f514262$var$_some = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("gr3kC")));

var $9ea1e8bf7f514262$var$_filter = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("747l5")));

var $9ea1e8bf7f514262$var$_map = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("kiW2y")));

var $9ea1e8bf7f514262$var$_reduce = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("ipf5H")));

var $9ea1e8bf7f514262$var$_reverse = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("kWjMM")));

var $9ea1e8bf7f514262$var$_sort = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("9A8R2")));

var $9ea1e8bf7f514262$var$_difference = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("jWrlE")));

var $9ea1e8bf7f514262$var$_disjoint = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("9HKVK")));

var $9ea1e8bf7f514262$var$_intersection = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("6TGoJ")));

var $9ea1e8bf7f514262$var$_subset = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("2ijsD")));

var $9ea1e8bf7f514262$var$_superset = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("iFlbT")));

var $9ea1e8bf7f514262$var$_union = $9ea1e8bf7f514262$var$_interopRequireDefault((parcelRequire("3EAPG")));

var $6R9G4 = parcelRequire("6R9G4");
function $9ea1e8bf7f514262$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9ea1e8bf7f514262$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9ea1e8bf7f514262$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $9ea1e8bf7f514262$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $9ea1e8bf7f514262$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}

});
parcelRegister("5t5vE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $3fb3ef4383f75e6a$var$_ascending = $3fb3ef4383f75e6a$var$_interopRequireDefault((parcelRequire("fA7xO")));

var $3fb3ef4383f75e6a$var$_bisector = $3fb3ef4383f75e6a$var$_interopRequireDefault((parcelRequire("cF6M6")));

var $3fb3ef4383f75e6a$var$_number = $3fb3ef4383f75e6a$var$_interopRequireDefault((parcelRequire("cOy6m")));
function $3fb3ef4383f75e6a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3fb3ef4383f75e6a$var$ascendingBisect = (0, $3fb3ef4383f75e6a$var$_bisector.default)($3fb3ef4383f75e6a$var$_ascending.default);
const $3fb3ef4383f75e6a$var$bisectRight = module.exports.bisectRight = $3fb3ef4383f75e6a$var$ascendingBisect.right;
const $3fb3ef4383f75e6a$var$bisectLeft = module.exports.bisectLeft = $3fb3ef4383f75e6a$var$ascendingBisect.left;
const $3fb3ef4383f75e6a$var$bisectCenter = module.exports.bisectCenter = (0, $3fb3ef4383f75e6a$var$_bisector.default)($3fb3ef4383f75e6a$var$_number.default).center;
var $3fb3ef4383f75e6a$var$_default = module.exports.default = $3fb3ef4383f75e6a$var$bisectRight;

});
parcelRegister("fA7xO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b58011fa7646e296$var$ascending;
function $b58011fa7646e296$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("cF6M6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $937e91b579009a13$var$bisector;

var $937e91b579009a13$var$_ascending = $937e91b579009a13$var$_interopRequireDefault((parcelRequire("fA7xO")));

var $937e91b579009a13$var$_descending = $937e91b579009a13$var$_interopRequireDefault((parcelRequire("29Wd4")));
function $937e91b579009a13$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $937e91b579009a13$var$bisector(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $937e91b579009a13$var$_ascending.default;
        compare2 = (d, x)=>(0, $937e91b579009a13$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $937e91b579009a13$var$_ascending.default || f === $937e91b579009a13$var$_descending.default ? f : $937e91b579009a13$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $937e91b579009a13$var$zero() {
    return 0;
}

});
parcelRegister("29Wd4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1929934b4f319ca5$var$descending;
function $1929934b4f319ca5$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("cOy6m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $95449b6482d83298$var$number;
module.exports.numbers = $95449b6482d83298$var$numbers;
function $95449b6482d83298$var$number(x) {
    return x === null ? NaN : +x;
}
function* $95449b6482d83298$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("lDbTd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fbf67681816882dc$var$count;
function $fbf67681816882dc$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("jgXIf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e07dd4a1367af2e2$var$cross;
function $e07dd4a1367af2e2$var$length(array) {
    return array.length | 0;
}
function $e07dd4a1367af2e2$var$empty(length) {
    return !(length > 0);
}
function $e07dd4a1367af2e2$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $e07dd4a1367af2e2$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $e07dd4a1367af2e2$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $e07dd4a1367af2e2$var$reducer(values.pop());
    values = values.map($e07dd4a1367af2e2$var$arrayify);
    const lengths = values.map($e07dd4a1367af2e2$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($e07dd4a1367af2e2$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("1CFFg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $12e9a8be99687b7c$var$cumsum;
function $12e9a8be99687b7c$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("7FMOl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5962399b39e140ad$var$deviation;

var $5962399b39e140ad$var$_variance = $5962399b39e140ad$var$_interopRequireDefault((parcelRequire("5XiJ4")));
function $5962399b39e140ad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5962399b39e140ad$var$deviation(values, valueof) {
    const v = (0, $5962399b39e140ad$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("5XiJ4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4560fd00ceece0bf$var$variance;
function $4560fd00ceece0bf$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("f2VUY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $af43f83272ec25ec$var$extent;
function $af43f83272ec25ec$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("f97YE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $b06de26834be72d2$var$fcumsum;
module.exports.fsum = $b06de26834be72d2$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $b06de26834be72d2$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $b06de26834be72d2$var$Adder;
function $b06de26834be72d2$var$fsum(values, valueof) {
    const adder = new $b06de26834be72d2$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $b06de26834be72d2$var$fcumsum(values, valueof) {
    const adder = new $b06de26834be72d2$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("bZEVG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8bb523e9d1b3a6ac$var$group;
module.exports.flatGroup = $8bb523e9d1b3a6ac$var$flatGroup;
module.exports.flatRollup = $8bb523e9d1b3a6ac$var$flatRollup;
module.exports.groups = $8bb523e9d1b3a6ac$var$groups;
module.exports.index = $8bb523e9d1b3a6ac$var$index;
module.exports.indexes = $8bb523e9d1b3a6ac$var$indexes;
module.exports.rollup = $8bb523e9d1b3a6ac$var$rollup;
module.exports.rollups = $8bb523e9d1b3a6ac$var$rollups;

var $6R9G4 = parcelRequire("6R9G4");

var $8bb523e9d1b3a6ac$var$_identity = $8bb523e9d1b3a6ac$var$_interopRequireDefault((parcelRequire("2AUzS")));
function $8bb523e9d1b3a6ac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8bb523e9d1b3a6ac$var$group(values, ...keys) {
    return $8bb523e9d1b3a6ac$var$nest(values, $8bb523e9d1b3a6ac$var$_identity.default, $8bb523e9d1b3a6ac$var$_identity.default, keys);
}
function $8bb523e9d1b3a6ac$var$groups(values, ...keys) {
    return $8bb523e9d1b3a6ac$var$nest(values, Array.from, $8bb523e9d1b3a6ac$var$_identity.default, keys);
}
function $8bb523e9d1b3a6ac$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $8bb523e9d1b3a6ac$var$flatGroup(values, ...keys) {
    return $8bb523e9d1b3a6ac$var$flatten($8bb523e9d1b3a6ac$var$groups(values, ...keys), keys);
}
function $8bb523e9d1b3a6ac$var$flatRollup(values, reduce, ...keys) {
    return $8bb523e9d1b3a6ac$var$flatten($8bb523e9d1b3a6ac$var$rollups(values, reduce, ...keys), keys);
}
function $8bb523e9d1b3a6ac$var$rollup(values, reduce, ...keys) {
    return $8bb523e9d1b3a6ac$var$nest(values, $8bb523e9d1b3a6ac$var$_identity.default, reduce, keys);
}
function $8bb523e9d1b3a6ac$var$rollups(values, reduce, ...keys) {
    return $8bb523e9d1b3a6ac$var$nest(values, Array.from, reduce, keys);
}
function $8bb523e9d1b3a6ac$var$index(values, ...keys) {
    return $8bb523e9d1b3a6ac$var$nest(values, $8bb523e9d1b3a6ac$var$_identity.default, $8bb523e9d1b3a6ac$var$unique, keys);
}
function $8bb523e9d1b3a6ac$var$indexes(values, ...keys) {
    return $8bb523e9d1b3a6ac$var$nest(values, Array.from, $8bb523e9d1b3a6ac$var$unique, keys);
}
function $8bb523e9d1b3a6ac$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $8bb523e9d1b3a6ac$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $6R9G4.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("6R9G4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $4fdf3311562b3525$var$InternMap extends Map {
    constructor(entries, key = $4fdf3311562b3525$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($4fdf3311562b3525$var$intern_get(this, key));
    }
    has(key) {
        return super.has($4fdf3311562b3525$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($4fdf3311562b3525$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($4fdf3311562b3525$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $4fdf3311562b3525$var$InternMap;
class $4fdf3311562b3525$var$InternSet extends Set {
    constructor(values, key = $4fdf3311562b3525$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($4fdf3311562b3525$var$intern_get(this, value));
    }
    add(value) {
        return super.add($4fdf3311562b3525$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($4fdf3311562b3525$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $4fdf3311562b3525$var$InternSet;
function $4fdf3311562b3525$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $4fdf3311562b3525$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $4fdf3311562b3525$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $4fdf3311562b3525$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("2AUzS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1e3ad4b8d205d6f6$var$identity;
function $1e3ad4b8d205d6f6$var$identity(x) {
    return x;
}

});


parcelRegister("bzV9j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $86df4b41a87a95cd$var$groupSort;

var $86df4b41a87a95cd$var$_ascending = $86df4b41a87a95cd$var$_interopRequireDefault((parcelRequire("fA7xO")));

var $86df4b41a87a95cd$var$_group = $86df4b41a87a95cd$var$_interopRequireWildcard((parcelRequire("bZEVG")));

var $86df4b41a87a95cd$var$_sort = $86df4b41a87a95cd$var$_interopRequireDefault((parcelRequire("9A8R2")));
function $86df4b41a87a95cd$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($86df4b41a87a95cd$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $86df4b41a87a95cd$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $86df4b41a87a95cd$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $86df4b41a87a95cd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $86df4b41a87a95cd$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $86df4b41a87a95cd$var$_sort.default)((0, $86df4b41a87a95cd$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $86df4b41a87a95cd$var$_ascending.default)(av, bv) || (0, $86df4b41a87a95cd$var$_ascending.default)(ak, bk)) : (0, $86df4b41a87a95cd$var$_sort.default)((0, $86df4b41a87a95cd$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $86df4b41a87a95cd$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("9A8R2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $6f9e582f30b67f06$var$ascendingDefined;
module.exports.compareDefined = $6f9e582f30b67f06$var$compareDefined;
module.exports.default = $6f9e582f30b67f06$var$sort;

var $6f9e582f30b67f06$var$_ascending = $6f9e582f30b67f06$var$_interopRequireDefault((parcelRequire("fA7xO")));

var $6f9e582f30b67f06$var$_permute = $6f9e582f30b67f06$var$_interopRequireDefault((parcelRequire("5zx6r")));
function $6f9e582f30b67f06$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6f9e582f30b67f06$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $6f9e582f30b67f06$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$6f9e582f30b67f06$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $6f9e582f30b67f06$var$_permute.default)(values, index);
    }
    return values.sort($6f9e582f30b67f06$var$compareDefined(f));
}
function $6f9e582f30b67f06$var$compareDefined(compare = $6f9e582f30b67f06$var$_ascending.default) {
    if (compare === $6f9e582f30b67f06$var$_ascending.default) return $6f9e582f30b67f06$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $6f9e582f30b67f06$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("5zx6r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $010c07d77aff76ef$var$permute;
function $010c07d77aff76ef$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("athdX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $79f9f92bb1791e39$var$bin;

var $gF1Aq = parcelRequire("gF1Aq");

var $79f9f92bb1791e39$var$_bisect = $79f9f92bb1791e39$var$_interopRequireDefault((parcelRequire("5t5vE")));

var $79f9f92bb1791e39$var$_constant = $79f9f92bb1791e39$var$_interopRequireDefault((parcelRequire("lMejB")));

var $79f9f92bb1791e39$var$_extent = $79f9f92bb1791e39$var$_interopRequireDefault((parcelRequire("f2VUY")));

var $79f9f92bb1791e39$var$_identity = $79f9f92bb1791e39$var$_interopRequireDefault((parcelRequire("2AUzS")));

var $79f9f92bb1791e39$var$_nice = $79f9f92bb1791e39$var$_interopRequireDefault((parcelRequire("b8CXR")));

var $79f9f92bb1791e39$var$_ticks = $79f9f92bb1791e39$var$_interopRequireWildcard((parcelRequire("b1MWk")));

var $79f9f92bb1791e39$var$_sturges = $79f9f92bb1791e39$var$_interopRequireDefault((parcelRequire("dqW3n")));
function $79f9f92bb1791e39$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($79f9f92bb1791e39$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $79f9f92bb1791e39$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $79f9f92bb1791e39$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $79f9f92bb1791e39$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $79f9f92bb1791e39$var$bin() {
    var value = $79f9f92bb1791e39$var$_identity.default, domain = $79f9f92bb1791e39$var$_extent.default, threshold = $79f9f92bb1791e39$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $79f9f92bb1791e39$var$_extent.default) [x0, x1] = (0, $79f9f92bb1791e39$var$_nice.default)(x0, x1, tn);
            tz = (0, $79f9f92bb1791e39$var$_ticks.default)(x0, x1, tn);
            // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $79f9f92bb1791e39$var$_ticks.tickIncrement)(x0, x1, tn);
            // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $79f9f92bb1791e39$var$_extent.default) {
                    const step = (0, $79f9f92bb1791e39$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $79f9f92bb1791e39$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $79f9f92bb1791e39$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $79f9f92bb1791e39$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $79f9f92bb1791e39$var$_constant.default)($gF1Aq.slice.call(_)) : (0, $79f9f92bb1791e39$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("gF1Aq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $c211b4b3be18a184$var$array = Array.prototype;
var $c211b4b3be18a184$var$slice = module.exports.slice = $c211b4b3be18a184$var$array.slice;
var $c211b4b3be18a184$var$map = module.exports.map = $c211b4b3be18a184$var$array.map;

});

parcelRegister("lMejB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fda92f59f7705217$var$constant;
function $fda92f59f7705217$var$constant(x) {
    return ()=>x;
}

});

parcelRegister("b8CXR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $81beaa99ed921358$var$nice;

var $b1MWk = parcelRequire("b1MWk");
function $81beaa99ed921358$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $b1MWk.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("b1MWk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8075c0265fb02bb6$var$ticks;
module.exports.tickIncrement = $8075c0265fb02bb6$var$tickIncrement;
module.exports.tickStep = $8075c0265fb02bb6$var$tickStep;
var $8075c0265fb02bb6$var$e10 = Math.sqrt(50), $8075c0265fb02bb6$var$e5 = Math.sqrt(10), $8075c0265fb02bb6$var$e2 = Math.sqrt(2);
function $8075c0265fb02bb6$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $8075c0265fb02bb6$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $8075c0265fb02bb6$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $8075c0265fb02bb6$var$e10 ? 10 : error >= $8075c0265fb02bb6$var$e5 ? 5 : error >= $8075c0265fb02bb6$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $8075c0265fb02bb6$var$e10 ? 10 : error >= $8075c0265fb02bb6$var$e5 ? 5 : error >= $8075c0265fb02bb6$var$e2 ? 2 : 1);
}
function $8075c0265fb02bb6$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $8075c0265fb02bb6$var$e10) step1 *= 10;
    else if (error >= $8075c0265fb02bb6$var$e5) step1 *= 5;
    else if (error >= $8075c0265fb02bb6$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("dqW3n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9c7abc4290c2fc6e$var$thresholdSturges;

var $9c7abc4290c2fc6e$var$_count = $9c7abc4290c2fc6e$var$_interopRequireDefault((parcelRequire("lDbTd")));
function $9c7abc4290c2fc6e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9c7abc4290c2fc6e$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $9c7abc4290c2fc6e$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRegister("b43lB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $80e2aa288bf91fa8$var$thresholdFreedmanDiaconis;

var $80e2aa288bf91fa8$var$_count = $80e2aa288bf91fa8$var$_interopRequireDefault((parcelRequire("lDbTd")));

var $80e2aa288bf91fa8$var$_quantile = $80e2aa288bf91fa8$var$_interopRequireDefault((parcelRequire("a2RH2")));
function $80e2aa288bf91fa8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $80e2aa288bf91fa8$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $80e2aa288bf91fa8$var$_quantile.default)(values, 0.75) - (0, $80e2aa288bf91fa8$var$_quantile.default)(values, 0.25)) * Math.pow((0, $80e2aa288bf91fa8$var$_count.default)(values), -1 / 3)));
}

});
parcelRegister("a2RH2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7503bda606d51a61$var$quantile;
module.exports.quantileSorted = $7503bda606d51a61$var$quantileSorted;

var $7503bda606d51a61$var$_max = $7503bda606d51a61$var$_interopRequireDefault((parcelRequire("irqg9")));

var $7503bda606d51a61$var$_min = $7503bda606d51a61$var$_interopRequireDefault((parcelRequire("l90Ta")));

var $7503bda606d51a61$var$_quickselect = $7503bda606d51a61$var$_interopRequireDefault((parcelRequire("g7gfg")));

var $7503bda606d51a61$var$_number = $7503bda606d51a61$var$_interopRequireWildcard((parcelRequire("cOy6m")));
function $7503bda606d51a61$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7503bda606d51a61$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $7503bda606d51a61$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $7503bda606d51a61$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $7503bda606d51a61$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7503bda606d51a61$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $7503bda606d51a61$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $7503bda606d51a61$var$_min.default)(values);
    if (p >= 1) return (0, $7503bda606d51a61$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $7503bda606d51a61$var$_max.default)((0, $7503bda606d51a61$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $7503bda606d51a61$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $7503bda606d51a61$var$quantileSorted(values, p, valueof = $7503bda606d51a61$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("irqg9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d6cf1e33f8c1d173$var$max;
function $d6cf1e33f8c1d173$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("l90Ta", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f64b20bbe57aaacb$var$min;
function $f64b20bbe57aaacb$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("g7gfg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bbb9e6bb014f971e$var$quickselect;

var $9A8R2 = parcelRequire("9A8R2");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $bbb9e6bb014f971e$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $9A8R2.ascendingDefined : (0, $9A8R2.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $bbb9e6bb014f971e$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $bbb9e6bb014f971e$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $bbb9e6bb014f971e$var$swap(array, left, right);
        while(i < j){
            $bbb9e6bb014f971e$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $bbb9e6bb014f971e$var$swap(array, left, j);
        else ++j, $bbb9e6bb014f971e$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $bbb9e6bb014f971e$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("aqsqg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7972613548df3439$var$thresholdScott;

var $7972613548df3439$var$_count = $7972613548df3439$var$_interopRequireDefault((parcelRequire("lDbTd")));

var $7972613548df3439$var$_deviation = $7972613548df3439$var$_interopRequireDefault((parcelRequire("7FMOl")));
function $7972613548df3439$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7972613548df3439$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $7972613548df3439$var$_count.default)(values)) / (3.49 * (0, $7972613548df3439$var$_deviation.default)(values)));
}

});

parcelRegister("hv5s2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cbd98f6c58f386a3$var$maxIndex;
function $cbd98f6c58f386a3$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("btBDu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $85af98d66fb7621b$var$mean;
function $85af98d66fb7621b$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("1KUI7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $147613da01b88246$var$median;

var $147613da01b88246$var$_quantile = $147613da01b88246$var$_interopRequireDefault((parcelRequire("a2RH2")));
function $147613da01b88246$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $147613da01b88246$var$median(values, valueof) {
    return (0, $147613da01b88246$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRegister("7ifZU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $54f69fa16674a264$var$merge;
function* $54f69fa16674a264$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $54f69fa16674a264$var$merge(arrays) {
    return Array.from($54f69fa16674a264$var$flatten(arrays));
}

});

parcelRegister("knRBk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ed6f88b0f7e6b6df$var$minIndex;
function $ed6f88b0f7e6b6df$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("70tmQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $519f50457c482dc7$var$mode;

var $6R9G4 = parcelRequire("6R9G4");
function $519f50457c482dc7$var$mode(values, valueof) {
    const counts = new $6R9G4.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRegister("4tLeL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $342e832700538030$var$pairs;
module.exports.pair = $342e832700538030$var$pair;
function $342e832700538030$var$pairs(values, pairof = $342e832700538030$var$pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function $342e832700538030$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("l0ajO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f4a19a21cb511f9c$var$range;
function $f4a19a21cb511f9c$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("2gYxM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1a7c0a2851cc0bce$var$rank;

var $1a7c0a2851cc0bce$var$_ascending = $1a7c0a2851cc0bce$var$_interopRequireDefault((parcelRequire("fA7xO")));

var $9A8R2 = parcelRequire("9A8R2");
function $1a7c0a2851cc0bce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1a7c0a2851cc0bce$var$rank(values, valueof = $1a7c0a2851cc0bce$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $1a7c0a2851cc0bce$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $1a7c0a2851cc0bce$var$_ascending.default ? (i, j)=>(0, $9A8R2.ascendingDefined)(V[i], V[j]) : (0, $9A8R2.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("5dnmq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3cc049929b366520$var$least;

var $3cc049929b366520$var$_ascending = $3cc049929b366520$var$_interopRequireDefault((parcelRequire("fA7xO")));
function $3cc049929b366520$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3cc049929b366520$var$least(values, compare = $3cc049929b366520$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $3cc049929b366520$var$_ascending.default)(value, minValue) < 0 : (0, $3cc049929b366520$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("Kb2Qx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $08acdd47ff416c55$var$leastIndex;

var $08acdd47ff416c55$var$_ascending = $08acdd47ff416c55$var$_interopRequireDefault((parcelRequire("fA7xO")));

var $08acdd47ff416c55$var$_minIndex = $08acdd47ff416c55$var$_interopRequireDefault((parcelRequire("knRBk")));
function $08acdd47ff416c55$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $08acdd47ff416c55$var$leastIndex(values, compare = $08acdd47ff416c55$var$_ascending.default) {
    if (compare.length === 1) return (0, $08acdd47ff416c55$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("0nepb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $001205764ff84522$var$greatest;

var $001205764ff84522$var$_ascending = $001205764ff84522$var$_interopRequireDefault((parcelRequire("fA7xO")));
function $001205764ff84522$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $001205764ff84522$var$greatest(values, compare = $001205764ff84522$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $001205764ff84522$var$_ascending.default)(value, maxValue) > 0 : (0, $001205764ff84522$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRegister("80Lma", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5d530ed0dbb24083$var$greatestIndex;

var $5d530ed0dbb24083$var$_ascending = $5d530ed0dbb24083$var$_interopRequireDefault((parcelRequire("fA7xO")));

var $5d530ed0dbb24083$var$_maxIndex = $5d530ed0dbb24083$var$_interopRequireDefault((parcelRequire("hv5s2")));
function $5d530ed0dbb24083$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5d530ed0dbb24083$var$greatestIndex(values, compare = $5d530ed0dbb24083$var$_ascending.default) {
    if (compare.length === 1) return (0, $5d530ed0dbb24083$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("6VunL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $50afa23b877eaf38$var$scan;

var $50afa23b877eaf38$var$_leastIndex = $50afa23b877eaf38$var$_interopRequireDefault((parcelRequire("Kb2Qx")));
function $50afa23b877eaf38$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $50afa23b877eaf38$var$scan(values, compare) {
    const index = (0, $50afa23b877eaf38$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("3x690", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $29293846c066fa67$var$shuffler;
var $29293846c066fa67$var$_default = module.exports.default = $29293846c066fa67$var$shuffler(Math.random);
function $29293846c066fa67$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("gaLfr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bc623af94dc3601a$var$sum;
function $bc623af94dc3601a$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("kFQj9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f0d036426c936a64$var$transpose;

var $f0d036426c936a64$var$_min = $f0d036426c936a64$var$_interopRequireDefault((parcelRequire("l90Ta")));
function $f0d036426c936a64$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f0d036426c936a64$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $f0d036426c936a64$var$_min.default)(matrix, $f0d036426c936a64$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $f0d036426c936a64$var$length(d) {
    return d.length;
}

});

parcelRegister("9KYgZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $71a729e4f89fbe05$var$zip;

var $71a729e4f89fbe05$var$_transpose = $71a729e4f89fbe05$var$_interopRequireDefault((parcelRequire("kFQj9")));
function $71a729e4f89fbe05$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $71a729e4f89fbe05$var$zip() {
    return (0, $71a729e4f89fbe05$var$_transpose.default)(arguments);
}

});

parcelRegister("jDex2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e4acee8c4de82936$var$every;
function $e4acee8c4de82936$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("gr3kC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bf71c083f93e100f$var$some;
function $bf71c083f93e100f$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("747l5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $524e9982f0cbf23b$var$filter;
function $524e9982f0cbf23b$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("kiW2y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ec8282a475ee6f2d$var$map;
function $ec8282a475ee6f2d$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("ipf5H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d666448521af6b2f$var$reduce;
function $d666448521af6b2f$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("kWjMM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f3e892747844a41d$var$reverse;
function $f3e892747844a41d$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("jWrlE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e848a5e8ea6a1963$var$difference;

var $6R9G4 = parcelRequire("6R9G4");
function $e848a5e8ea6a1963$var$difference(values, ...others) {
    values = new $6R9G4.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("9HKVK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $710c88990ef00f7a$var$disjoint;

var $6R9G4 = parcelRequire("6R9G4");
function $710c88990ef00f7a$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $6R9G4.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("6TGoJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5058c474f81e9ce4$var$intersection;

var $6R9G4 = parcelRequire("6R9G4");
function $5058c474f81e9ce4$var$intersection(values, ...others) {
    values = new $6R9G4.InternSet(values);
    others = others.map($5058c474f81e9ce4$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $5058c474f81e9ce4$var$set(values) {
    return values instanceof $6R9G4.InternSet ? values : new $6R9G4.InternSet(values);
}

});

parcelRegister("2ijsD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1abc5bba1786ec9f$var$subset;

var $1abc5bba1786ec9f$var$_superset = $1abc5bba1786ec9f$var$_interopRequireDefault((parcelRequire("iFlbT")));
function $1abc5bba1786ec9f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1abc5bba1786ec9f$var$subset(values, other) {
    return (0, $1abc5bba1786ec9f$var$_superset.default)(other, values);
}

});
parcelRegister("iFlbT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d96c7e641b276e39$var$superset;
function $d96c7e641b276e39$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $d96c7e641b276e39$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $d96c7e641b276e39$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $d96c7e641b276e39$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("3EAPG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a91adb77e114b25$var$union;

var $6R9G4 = parcelRequire("6R9G4");
function $2a91adb77e114b25$var$union(...others) {
    const set = new $6R9G4.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("9Ob92", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $72416dac796bae54$var$initInterpolator;
module.exports.initRange = $72416dac796bae54$var$initRange;
function $72416dac796bae54$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $72416dac796bae54$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("421pD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2ef871d6f419b177$var$ordinal;
module.exports.implicit = void 0;

var $dCoBu = parcelRequire("dCoBu");

var $9Ob92 = parcelRequire("9Ob92");
const $2ef871d6f419b177$var$implicit = module.exports.implicit = Symbol("implicit");
function $2ef871d6f419b177$var$ordinal() {
    var index = new $dCoBu.InternMap(), domain = [], range = [], unknown = $2ef871d6f419b177$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $2ef871d6f419b177$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $dCoBu.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $2ef871d6f419b177$var$ordinal(domain, range).unknown(unknown);
    };
    $9Ob92.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRegister("cJNoy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $946000d62bb16188$var$identity;

var $kQSTd = parcelRequire("kQSTd");

var $946000d62bb16188$var$_number = $946000d62bb16188$var$_interopRequireDefault((parcelRequire("2Qh0u")));
function $946000d62bb16188$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $946000d62bb16188$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $946000d62bb16188$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $946000d62bb16188$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $946000d62bb16188$var$_number.default) : [
        0,
        1
    ];
    return (0, $kQSTd.linearish)(scale);
}

});
parcelRegister("kQSTd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f2e33de7716a932a$var$linear;
module.exports.linearish = $f2e33de7716a932a$var$linearish;

var $dCoBu = parcelRequire("dCoBu");

var $f2e33de7716a932a$var$_continuous = $f2e33de7716a932a$var$_interopRequireWildcard((parcelRequire("g3aux")));

var $9Ob92 = parcelRequire("9Ob92");

var $f2e33de7716a932a$var$_tickFormat = $f2e33de7716a932a$var$_interopRequireDefault((parcelRequire("6db4r")));
function $f2e33de7716a932a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f2e33de7716a932a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f2e33de7716a932a$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $f2e33de7716a932a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $f2e33de7716a932a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $f2e33de7716a932a$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $dCoBu.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $f2e33de7716a932a$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $dCoBu.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $f2e33de7716a932a$var$linear() {
    var scale = (0, $f2e33de7716a932a$var$_continuous.default)();
    scale.copy = function() {
        return (0, $f2e33de7716a932a$var$_continuous.copy)(scale, $f2e33de7716a932a$var$linear());
    };
    $9Ob92.initRange.apply(scale, arguments);
    return $f2e33de7716a932a$var$linearish(scale);
}

});
parcelRegister("g3aux", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $baf5108b40c1449d$var$copy;
module.exports.default = $baf5108b40c1449d$var$continuous;
module.exports.identity = $baf5108b40c1449d$var$identity;
module.exports.transformer = $baf5108b40c1449d$var$transformer;

var $dCoBu = parcelRequire("dCoBu");

var $cbrvd = parcelRequire("cbrvd");

var $baf5108b40c1449d$var$_constant = $baf5108b40c1449d$var$_interopRequireDefault((parcelRequire("krN5P")));

var $baf5108b40c1449d$var$_number = $baf5108b40c1449d$var$_interopRequireDefault((parcelRequire("2Qh0u")));
function $baf5108b40c1449d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $baf5108b40c1449d$var$unit = [
    0,
    1
];
function $baf5108b40c1449d$var$identity(x) {
    return x;
}
function $baf5108b40c1449d$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $baf5108b40c1449d$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $baf5108b40c1449d$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $baf5108b40c1449d$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $baf5108b40c1449d$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $baf5108b40c1449d$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $baf5108b40c1449d$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $baf5108b40c1449d$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $dCoBu.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $baf5108b40c1449d$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $baf5108b40c1449d$var$transformer() {
    var domain = $baf5108b40c1449d$var$unit, range = $baf5108b40c1449d$var$unit, interpolate = $cbrvd.interpolate, transform, untransform, unknown, clamp = $baf5108b40c1449d$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $baf5108b40c1449d$var$identity) clamp = $baf5108b40c1449d$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $baf5108b40c1449d$var$polymap : $baf5108b40c1449d$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $cbrvd.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $baf5108b40c1449d$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $cbrvd.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $baf5108b40c1449d$var$identity, rescale()) : clamp !== $baf5108b40c1449d$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $baf5108b40c1449d$var$continuous() {
    return $baf5108b40c1449d$var$transformer()($baf5108b40c1449d$var$identity, $baf5108b40c1449d$var$identity);
}

});
parcelRegister("cbrvd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $9zwx8.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $9zwx8.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $8debd884f35642e4$var$_quantize.default;
    }
});

var $8debd884f35642e4$var$_value = $8debd884f35642e4$var$_interopRequireDefault((parcelRequire("i9JLI")));

var $8debd884f35642e4$var$_array = $8debd884f35642e4$var$_interopRequireDefault((parcelRequire("hM5yT")));

var $8debd884f35642e4$var$_basis = $8debd884f35642e4$var$_interopRequireDefault((parcelRequire("6Rkwu")));

var $8debd884f35642e4$var$_basisClosed = $8debd884f35642e4$var$_interopRequireDefault((parcelRequire("3Ufje")));

var $8debd884f35642e4$var$_date = $8debd884f35642e4$var$_interopRequireDefault((parcelRequire("gvs3F")));

var $8debd884f35642e4$var$_discrete = $8debd884f35642e4$var$_interopRequireDefault((parcelRequire("aApWu")));

var $8debd884f35642e4$var$_hue = $8debd884f35642e4$var$_interopRequireDefault((parcelRequire("geK21")));

var $8debd884f35642e4$var$_number = $8debd884f35642e4$var$_interopRequireDefault((parcelRequire("keTwL")));

var $8debd884f35642e4$var$_numberArray = $8debd884f35642e4$var$_interopRequireDefault((parcelRequire("6qneY")));

var $8debd884f35642e4$var$_object = $8debd884f35642e4$var$_interopRequireDefault((parcelRequire("WxKzJ")));

var $8debd884f35642e4$var$_round = $8debd884f35642e4$var$_interopRequireDefault((parcelRequire("3wq38")));

var $8debd884f35642e4$var$_string = $8debd884f35642e4$var$_interopRequireDefault((parcelRequire("9ghs8")));

var $9zwx8 = parcelRequire("9zwx8");

var $8debd884f35642e4$var$_zoom = $8debd884f35642e4$var$_interopRequireDefault((parcelRequire("8M1sm")));

var $8debd884f35642e4$var$_rgb = $8debd884f35642e4$var$_interopRequireWildcard((parcelRequire("gwB8w")));

var $8debd884f35642e4$var$_hsl = $8debd884f35642e4$var$_interopRequireWildcard((parcelRequire("dpjVX")));

var $8debd884f35642e4$var$_lab = $8debd884f35642e4$var$_interopRequireDefault((parcelRequire("bHncc")));

var $8debd884f35642e4$var$_hcl = $8debd884f35642e4$var$_interopRequireWildcard((parcelRequire("5Ihy4")));

var $8debd884f35642e4$var$_cubehelix = $8debd884f35642e4$var$_interopRequireWildcard((parcelRequire("aDk2M")));

var $8debd884f35642e4$var$_piecewise = $8debd884f35642e4$var$_interopRequireDefault((parcelRequire("bkRuy")));

var $8debd884f35642e4$var$_quantize = $8debd884f35642e4$var$_interopRequireDefault((parcelRequire("44duB")));
function $8debd884f35642e4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8debd884f35642e4$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $8debd884f35642e4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $8debd884f35642e4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $8debd884f35642e4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("i9JLI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $03693c290dbe828e$var$_default;

var $8tQsq = parcelRequire("8tQsq");

var $03693c290dbe828e$var$_rgb = $03693c290dbe828e$var$_interopRequireDefault((parcelRequire("gwB8w")));

var $hM5yT = parcelRequire("hM5yT");

var $03693c290dbe828e$var$_date = $03693c290dbe828e$var$_interopRequireDefault((parcelRequire("gvs3F")));

var $03693c290dbe828e$var$_number = $03693c290dbe828e$var$_interopRequireDefault((parcelRequire("keTwL")));

var $03693c290dbe828e$var$_object = $03693c290dbe828e$var$_interopRequireDefault((parcelRequire("WxKzJ")));

var $03693c290dbe828e$var$_string = $03693c290dbe828e$var$_interopRequireDefault((parcelRequire("9ghs8")));

var $03693c290dbe828e$var$_constant = $03693c290dbe828e$var$_interopRequireDefault((parcelRequire("92PAO")));

var $03693c290dbe828e$var$_numberArray = $03693c290dbe828e$var$_interopRequireWildcard((parcelRequire("6qneY")));
function $03693c290dbe828e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($03693c290dbe828e$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $03693c290dbe828e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $03693c290dbe828e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $03693c290dbe828e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $03693c290dbe828e$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $03693c290dbe828e$var$_constant.default)(b) : (t === "number" ? $03693c290dbe828e$var$_number.default : t === "string" ? (c = (0, $8tQsq.color)(b)) ? (b = c, $03693c290dbe828e$var$_rgb.default) : $03693c290dbe828e$var$_string.default : b instanceof $8tQsq.color ? $03693c290dbe828e$var$_rgb.default : b instanceof Date ? $03693c290dbe828e$var$_date.default : (0, $03693c290dbe828e$var$_numberArray.isNumberArray)(b) ? $03693c290dbe828e$var$_numberArray.default : Array.isArray(b) ? $hM5yT.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $03693c290dbe828e$var$_object.default : $03693c290dbe828e$var$_number.default)(a, b);
}

});
parcelRegister("8tQsq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $62c9b92161a69ce8$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $62c9b92161a69ce8$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $62c9b92161a69ce8$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $62c9b92161a69ce8$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $62c9b92161a69ce8$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $62c9b92161a69ce8$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $62c9b92161a69ce8$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $62c9b92161a69ce8$var$_color.rgb;
    }
});

var $62c9b92161a69ce8$var$_color = $62c9b92161a69ce8$var$_interopRequireWildcard((parcelRequire("4ICEu")));

var $62c9b92161a69ce8$var$_lab = $62c9b92161a69ce8$var$_interopRequireWildcard((parcelRequire("gr8PZ")));

var $62c9b92161a69ce8$var$_cubehelix = $62c9b92161a69ce8$var$_interopRequireDefault((parcelRequire("bF5cB")));
function $62c9b92161a69ce8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $62c9b92161a69ce8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($62c9b92161a69ce8$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $62c9b92161a69ce8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $62c9b92161a69ce8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}

});
parcelRegister("4ICEu", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;

var _define = _interopRequireWildcard((parcelRequire("5R1iO")));
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function Color() {}
var darker = exports.darker = 0.7;
var brighter = exports.brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("5R1iO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4432e9a48b28dff6$var$_default;
module.exports.extend = $4432e9a48b28dff6$var$extend;
function $4432e9a48b28dff6$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $4432e9a48b28dff6$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("gr8PZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $bf7605e34b080b7d$var$Hcl;
module.exports.Lab = $bf7605e34b080b7d$var$Lab;
module.exports.default = $bf7605e34b080b7d$var$lab;
module.exports.gray = $bf7605e34b080b7d$var$gray;
module.exports.hcl = $bf7605e34b080b7d$var$hcl;
module.exports.lch = $bf7605e34b080b7d$var$lch;

var $bf7605e34b080b7d$var$_define = $bf7605e34b080b7d$var$_interopRequireWildcard((parcelRequire("5R1iO")));

var $4ICEu = parcelRequire("4ICEu");

var $lhqnA = parcelRequire("lhqnA");
function $bf7605e34b080b7d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($bf7605e34b080b7d$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $bf7605e34b080b7d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $bf7605e34b080b7d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $bf7605e34b080b7d$var$K = 18, $bf7605e34b080b7d$var$Xn = 0.96422, $bf7605e34b080b7d$var$Yn = 1, $bf7605e34b080b7d$var$Zn = 0.82521, $bf7605e34b080b7d$var$t0 = 4 / 29, $bf7605e34b080b7d$var$t1 = 6 / 29, $bf7605e34b080b7d$var$t2 = 3 * $bf7605e34b080b7d$var$t1 * $bf7605e34b080b7d$var$t1, $bf7605e34b080b7d$var$t3 = $bf7605e34b080b7d$var$t1 * $bf7605e34b080b7d$var$t1 * $bf7605e34b080b7d$var$t1;
function $bf7605e34b080b7d$var$labConvert(o) {
    if (o instanceof $bf7605e34b080b7d$var$Lab) return new $bf7605e34b080b7d$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $bf7605e34b080b7d$var$Hcl) return $bf7605e34b080b7d$var$hcl2lab(o);
    if (!(o instanceof $4ICEu.Rgb)) o = (0, $4ICEu.rgbConvert)(o);
    var r = $bf7605e34b080b7d$var$rgb2lrgb(o.r), g = $bf7605e34b080b7d$var$rgb2lrgb(o.g), b = $bf7605e34b080b7d$var$rgb2lrgb(o.b), y = $bf7605e34b080b7d$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $bf7605e34b080b7d$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $bf7605e34b080b7d$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $bf7605e34b080b7d$var$Xn);
        z = $bf7605e34b080b7d$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $bf7605e34b080b7d$var$Zn);
    }
    return new $bf7605e34b080b7d$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $bf7605e34b080b7d$var$gray(l, opacity) {
    return new $bf7605e34b080b7d$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $bf7605e34b080b7d$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $bf7605e34b080b7d$var$labConvert(l) : new $bf7605e34b080b7d$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $bf7605e34b080b7d$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bf7605e34b080b7d$var$_define.default)($bf7605e34b080b7d$var$Lab, $bf7605e34b080b7d$var$lab, (0, $bf7605e34b080b7d$var$_define.extend)($4ICEu.Color, {
    brighter (k) {
        return new $bf7605e34b080b7d$var$Lab(this.l + $bf7605e34b080b7d$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $bf7605e34b080b7d$var$Lab(this.l - $bf7605e34b080b7d$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $bf7605e34b080b7d$var$Xn * $bf7605e34b080b7d$var$lab2xyz(x);
        y = $bf7605e34b080b7d$var$Yn * $bf7605e34b080b7d$var$lab2xyz(y);
        z = $bf7605e34b080b7d$var$Zn * $bf7605e34b080b7d$var$lab2xyz(z);
        return new $4ICEu.Rgb($bf7605e34b080b7d$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $bf7605e34b080b7d$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $bf7605e34b080b7d$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $bf7605e34b080b7d$var$xyz2lab(t) {
    return t > $bf7605e34b080b7d$var$t3 ? Math.pow(t, 1 / 3) : t / $bf7605e34b080b7d$var$t2 + $bf7605e34b080b7d$var$t0;
}
function $bf7605e34b080b7d$var$lab2xyz(t) {
    return t > $bf7605e34b080b7d$var$t1 ? t * t * t : $bf7605e34b080b7d$var$t2 * (t - $bf7605e34b080b7d$var$t0);
}
function $bf7605e34b080b7d$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $bf7605e34b080b7d$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $bf7605e34b080b7d$var$hclConvert(o) {
    if (o instanceof $bf7605e34b080b7d$var$Hcl) return new $bf7605e34b080b7d$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $bf7605e34b080b7d$var$Lab)) o = $bf7605e34b080b7d$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $bf7605e34b080b7d$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $lhqnA.degrees;
    return new $bf7605e34b080b7d$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $bf7605e34b080b7d$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $bf7605e34b080b7d$var$hclConvert(l) : new $bf7605e34b080b7d$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $bf7605e34b080b7d$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $bf7605e34b080b7d$var$hclConvert(h) : new $bf7605e34b080b7d$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $bf7605e34b080b7d$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $bf7605e34b080b7d$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $bf7605e34b080b7d$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $lhqnA.radians;
    return new $bf7605e34b080b7d$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $bf7605e34b080b7d$var$_define.default)($bf7605e34b080b7d$var$Hcl, $bf7605e34b080b7d$var$hcl, (0, $bf7605e34b080b7d$var$_define.extend)($4ICEu.Color, {
    brighter (k) {
        return new $bf7605e34b080b7d$var$Hcl(this.h, this.c, this.l + $bf7605e34b080b7d$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $bf7605e34b080b7d$var$Hcl(this.h, this.c, this.l - $bf7605e34b080b7d$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $bf7605e34b080b7d$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("lhqnA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $f7dfa5ea3ad2dbeb$var$radians = module.exports.radians = Math.PI / 180;
const $f7dfa5ea3ad2dbeb$var$degrees = module.exports.degrees = 180 / Math.PI;

});


parcelRegister("bF5cB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $87d78f15f04a3df2$var$Cubehelix;
module.exports.default = $87d78f15f04a3df2$var$cubehelix;

var $87d78f15f04a3df2$var$_define = $87d78f15f04a3df2$var$_interopRequireWildcard((parcelRequire("5R1iO")));

var $4ICEu = parcelRequire("4ICEu");

var $lhqnA = parcelRequire("lhqnA");
function $87d78f15f04a3df2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($87d78f15f04a3df2$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $87d78f15f04a3df2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $87d78f15f04a3df2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
var $87d78f15f04a3df2$var$A = -0.14861, $87d78f15f04a3df2$var$B = 1.78277, $87d78f15f04a3df2$var$C = -0.29227, $87d78f15f04a3df2$var$D = -0.90649, $87d78f15f04a3df2$var$E = 1.97294, $87d78f15f04a3df2$var$ED = $87d78f15f04a3df2$var$E * $87d78f15f04a3df2$var$D, $87d78f15f04a3df2$var$EB = $87d78f15f04a3df2$var$E * $87d78f15f04a3df2$var$B, $87d78f15f04a3df2$var$BC_DA = $87d78f15f04a3df2$var$B * $87d78f15f04a3df2$var$C - $87d78f15f04a3df2$var$D * $87d78f15f04a3df2$var$A;
function $87d78f15f04a3df2$var$cubehelixConvert(o) {
    if (o instanceof $87d78f15f04a3df2$var$Cubehelix) return new $87d78f15f04a3df2$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $4ICEu.Rgb)) o = (0, $4ICEu.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($87d78f15f04a3df2$var$BC_DA * b + $87d78f15f04a3df2$var$ED * r - $87d78f15f04a3df2$var$EB * g) / ($87d78f15f04a3df2$var$BC_DA + $87d78f15f04a3df2$var$ED - $87d78f15f04a3df2$var$EB), bl = b - l, k = ($87d78f15f04a3df2$var$E * (g - l) - $87d78f15f04a3df2$var$C * bl) / $87d78f15f04a3df2$var$D, s = Math.sqrt(k * k + bl * bl) / ($87d78f15f04a3df2$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $lhqnA.degrees - 120 : NaN;
    return new $87d78f15f04a3df2$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $87d78f15f04a3df2$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $87d78f15f04a3df2$var$cubehelixConvert(h) : new $87d78f15f04a3df2$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $87d78f15f04a3df2$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $87d78f15f04a3df2$var$_define.default)($87d78f15f04a3df2$var$Cubehelix, $87d78f15f04a3df2$var$cubehelix, (0, $87d78f15f04a3df2$var$_define.extend)($4ICEu.Color, {
    brighter (k) {
        k = k == null ? $4ICEu.brighter : Math.pow($4ICEu.brighter, k);
        return new $87d78f15f04a3df2$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $4ICEu.darker : Math.pow($4ICEu.darker, k);
        return new $87d78f15f04a3df2$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $lhqnA.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $4ICEu.Rgb(255 * (l + a * ($87d78f15f04a3df2$var$A * cosh + $87d78f15f04a3df2$var$B * sinh)), 255 * (l + a * ($87d78f15f04a3df2$var$C * cosh + $87d78f15f04a3df2$var$D * sinh)), 255 * (l + a * ($87d78f15f04a3df2$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("gwB8w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $8tQsq = parcelRequire("8tQsq");

var $c07c710c160a3564$var$_basis = $c07c710c160a3564$var$_interopRequireDefault((parcelRequire("6Rkwu")));

var $c07c710c160a3564$var$_basisClosed = $c07c710c160a3564$var$_interopRequireDefault((parcelRequire("3Ufje")));

var $c07c710c160a3564$var$_color = $c07c710c160a3564$var$_interopRequireWildcard((parcelRequire("5oMt1")));
function $c07c710c160a3564$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c07c710c160a3564$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $c07c710c160a3564$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $c07c710c160a3564$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $c07c710c160a3564$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c07c710c160a3564$var$_default = module.exports.default = function rgbGamma(y) {
    var color = (0, $c07c710c160a3564$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $8tQsq.rgb)(start)).r, (end = (0, $8tQsq.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $c07c710c160a3564$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $c07c710c160a3564$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $8tQsq.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $c07c710c160a3564$var$rgbBasis = module.exports.rgbBasis = $c07c710c160a3564$var$rgbSpline($c07c710c160a3564$var$_basis.default);
var $c07c710c160a3564$var$rgbBasisClosed = module.exports.rgbBasisClosed = $c07c710c160a3564$var$rgbSpline($c07c710c160a3564$var$_basisClosed.default);

});
parcelRegister("6Rkwu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $4fe79cbebf29e986$var$basis;
module.exports.default = $4fe79cbebf29e986$var$_default;
function $4fe79cbebf29e986$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $4fe79cbebf29e986$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $4fe79cbebf29e986$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("3Ufje", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2d827a2a67cdaa02$var$_default;

var $6Rkwu = parcelRequire("6Rkwu");
function $2d827a2a67cdaa02$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $6Rkwu.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("5oMt1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3ee4ca3295c09def$var$nogamma;
module.exports.gamma = $3ee4ca3295c09def$var$gamma;
module.exports.hue = $3ee4ca3295c09def$var$hue;

var $3ee4ca3295c09def$var$_constant = $3ee4ca3295c09def$var$_interopRequireDefault((parcelRequire("92PAO")));
function $3ee4ca3295c09def$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3ee4ca3295c09def$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $3ee4ca3295c09def$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $3ee4ca3295c09def$var$hue(a, b) {
    var d = b - a;
    return d ? $3ee4ca3295c09def$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $3ee4ca3295c09def$var$_constant.default)(isNaN(a) ? b : a);
}
function $3ee4ca3295c09def$var$gamma(y) {
    return (y = +y) === 1 ? $3ee4ca3295c09def$var$nogamma : function(a, b) {
        return b - a ? $3ee4ca3295c09def$var$exponential(a, b, y) : (0, $3ee4ca3295c09def$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $3ee4ca3295c09def$var$nogamma(a, b) {
    var d = b - a;
    return d ? $3ee4ca3295c09def$var$linear(a, d) : (0, $3ee4ca3295c09def$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRegister("92PAO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $695c5230b3ba7e53$var$_default = (x)=>()=>x;
module.exports.default = $695c5230b3ba7e53$var$_default;

});



parcelRegister("hM5yT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cf0b3bd6b6da9d34$var$_default;
module.exports.genericArray = $cf0b3bd6b6da9d34$var$genericArray;

var $cf0b3bd6b6da9d34$var$_value = $cf0b3bd6b6da9d34$var$_interopRequireDefault((parcelRequire("i9JLI")));

var $cf0b3bd6b6da9d34$var$_numberArray = $cf0b3bd6b6da9d34$var$_interopRequireWildcard((parcelRequire("6qneY")));
function $cf0b3bd6b6da9d34$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($cf0b3bd6b6da9d34$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $cf0b3bd6b6da9d34$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $cf0b3bd6b6da9d34$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $cf0b3bd6b6da9d34$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cf0b3bd6b6da9d34$var$_default(a, b) {
    return ((0, $cf0b3bd6b6da9d34$var$_numberArray.isNumberArray)(b) ? $cf0b3bd6b6da9d34$var$_numberArray.default : $cf0b3bd6b6da9d34$var$genericArray)(a, b);
}
function $cf0b3bd6b6da9d34$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $cf0b3bd6b6da9d34$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("6qneY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4ad732d77e594247$var$_default;
module.exports.isNumberArray = $4ad732d77e594247$var$isNumberArray;
function $4ad732d77e594247$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $4ad732d77e594247$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("gvs3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c0454e5a9ad0bfea$var$_default;
function $c0454e5a9ad0bfea$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("keTwL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ebc0300e1493fd63$var$_default;
function $ebc0300e1493fd63$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("WxKzJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0aff98fbdbdf3b93$var$_default;

var $0aff98fbdbdf3b93$var$_value = $0aff98fbdbdf3b93$var$_interopRequireDefault((parcelRequire("i9JLI")));
function $0aff98fbdbdf3b93$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0aff98fbdbdf3b93$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $0aff98fbdbdf3b93$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("9ghs8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6be32570ab7e92cc$var$_default;

var $6be32570ab7e92cc$var$_number = $6be32570ab7e92cc$var$_interopRequireDefault((parcelRequire("keTwL")));
function $6be32570ab7e92cc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6be32570ab7e92cc$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $6be32570ab7e92cc$var$reB = new RegExp($6be32570ab7e92cc$var$reA.source, "g");
function $6be32570ab7e92cc$var$zero(b) {
    return function() {
        return b;
    };
}
function $6be32570ab7e92cc$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $6be32570ab7e92cc$var$_default(a, b) {
    var bi = $6be32570ab7e92cc$var$reA.lastIndex = $6be32570ab7e92cc$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $6be32570ab7e92cc$var$reA.exec(a)) && (bm = $6be32570ab7e92cc$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $6be32570ab7e92cc$var$_number.default)(am, bm)
            });
        }
        bi = $6be32570ab7e92cc$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $6be32570ab7e92cc$var$one(q[0].x) : $6be32570ab7e92cc$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("aApWu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7b5163c9de9ce3a4$var$_default;
function $7b5163c9de9ce3a4$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("geK21", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bd21a9148ed6132a$var$_default;

var $5oMt1 = parcelRequire("5oMt1");
function $bd21a9148ed6132a$var$_default(a, b) {
    var i = (0, $5oMt1.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("3wq38", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2908912323f63b34$var$_default;
function $2908912323f63b34$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("9zwx8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $6f809e66590ce4b1$var$_number = $6f809e66590ce4b1$var$_interopRequireDefault((parcelRequire("keTwL")));

var $4A1zv = parcelRequire("4A1zv");
function $6f809e66590ce4b1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6f809e66590ce4b1$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $6f809e66590ce4b1$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $6f809e66590ce4b1$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $6f809e66590ce4b1$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $6f809e66590ce4b1$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $6f809e66590ce4b1$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $6f809e66590ce4b1$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $6f809e66590ce4b1$var$interpolateTransformCss = module.exports.interpolateTransformCss = $6f809e66590ce4b1$var$interpolateTransform($4A1zv.parseCss, "px, ", "px)", "deg)");
var $6f809e66590ce4b1$var$interpolateTransformSvg = module.exports.interpolateTransformSvg = $6f809e66590ce4b1$var$interpolateTransform($4A1zv.parseSvg, ", ", ")", ")");

});
parcelRegister("4A1zv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $355bbe5555976873$var$parseCss;
module.exports.parseSvg = $355bbe5555976873$var$parseSvg;

var $355bbe5555976873$var$_decompose = $355bbe5555976873$var$_interopRequireWildcard((parcelRequire("epCzx")));
function $355bbe5555976873$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($355bbe5555976873$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $355bbe5555976873$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $355bbe5555976873$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
var $355bbe5555976873$var$svgNode;
/* eslint-disable no-undef */ function $355bbe5555976873$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $355bbe5555976873$var$_decompose.identity : (0, $355bbe5555976873$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $355bbe5555976873$var$parseSvg(value) {
    if (value == null) return $355bbe5555976873$var$_decompose.identity;
    if (!$355bbe5555976873$var$svgNode) $355bbe5555976873$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $355bbe5555976873$var$svgNode.setAttribute("transform", value);
    if (!(value = $355bbe5555976873$var$svgNode.transform.baseVal.consolidate())) return $355bbe5555976873$var$_decompose.identity;
    value = value.matrix;
    return (0, $355bbe5555976873$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("epCzx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a7e152258aada699$var$_default;
module.exports.identity = void 0;
var $a7e152258aada699$var$degrees = 180 / Math.PI;
var $a7e152258aada699$var$identity = module.exports.identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $a7e152258aada699$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $a7e152258aada699$var$degrees,
        skewX: Math.atan(skewX) * $a7e152258aada699$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("8M1sm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $6633efa43ff265c0$var$epsilon2 = 1e-12;
function $6633efa43ff265c0$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $6633efa43ff265c0$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $6633efa43ff265c0$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $6633efa43ff265c0$var$_default = module.exports.default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $6633efa43ff265c0$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $6633efa43ff265c0$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $6633efa43ff265c0$var$tanh(rho * s + r0) - $6633efa43ff265c0$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $6633efa43ff265c0$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);

});

parcelRegister("dpjVX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $8tQsq = parcelRequire("8tQsq");

var $0284db23778e97e2$var$_color = $0284db23778e97e2$var$_interopRequireWildcard((parcelRequire("5oMt1")));
function $0284db23778e97e2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0284db23778e97e2$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $0284db23778e97e2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $0284db23778e97e2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $0284db23778e97e2$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $8tQsq.hsl)(start)).h, (end = (0, $8tQsq.hsl)(end)).h), s = (0, $0284db23778e97e2$var$_color.default)(start.s, end.s), l = (0, $0284db23778e97e2$var$_color.default)(start.l, end.l), opacity = (0, $0284db23778e97e2$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $0284db23778e97e2$var$_default = module.exports.default = $0284db23778e97e2$var$hsl($0284db23778e97e2$var$_color.hue);
var $0284db23778e97e2$var$hslLong = module.exports.hslLong = $0284db23778e97e2$var$hsl($0284db23778e97e2$var$_color.default);

});

parcelRegister("bHncc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8845b4116fd499a8$var$lab;

var $8tQsq = parcelRequire("8tQsq");

var $8845b4116fd499a8$var$_color = $8845b4116fd499a8$var$_interopRequireDefault((parcelRequire("5oMt1")));
function $8845b4116fd499a8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8845b4116fd499a8$var$lab(start, end) {
    var l = (0, $8845b4116fd499a8$var$_color.default)((start = (0, $8tQsq.lab)(start)).l, (end = (0, $8tQsq.lab)(end)).l), a = (0, $8845b4116fd499a8$var$_color.default)(start.a, end.a), b = (0, $8845b4116fd499a8$var$_color.default)(start.b, end.b), opacity = (0, $8845b4116fd499a8$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("5Ihy4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $8tQsq = parcelRequire("8tQsq");

var $428eac8eb131f861$var$_color = $428eac8eb131f861$var$_interopRequireWildcard((parcelRequire("5oMt1")));
function $428eac8eb131f861$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($428eac8eb131f861$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $428eac8eb131f861$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $428eac8eb131f861$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $428eac8eb131f861$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $8tQsq.hcl)(start)).h, (end = (0, $8tQsq.hcl)(end)).h), c = (0, $428eac8eb131f861$var$_color.default)(start.c, end.c), l = (0, $428eac8eb131f861$var$_color.default)(start.l, end.l), opacity = (0, $428eac8eb131f861$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $428eac8eb131f861$var$_default = module.exports.default = $428eac8eb131f861$var$hcl($428eac8eb131f861$var$_color.hue);
var $428eac8eb131f861$var$hclLong = module.exports.hclLong = $428eac8eb131f861$var$hcl($428eac8eb131f861$var$_color.default);

});

parcelRegister("aDk2M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $8tQsq = parcelRequire("8tQsq");

var $7bdd1833f6148952$var$_color = $7bdd1833f6148952$var$_interopRequireWildcard((parcelRequire("5oMt1")));
function $7bdd1833f6148952$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7bdd1833f6148952$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $7bdd1833f6148952$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $7bdd1833f6148952$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $7bdd1833f6148952$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $8tQsq.cubehelix)(start)).h, (end = (0, $8tQsq.cubehelix)(end)).h), s = (0, $7bdd1833f6148952$var$_color.default)(start.s, end.s), l = (0, $7bdd1833f6148952$var$_color.default)(start.l, end.l), opacity = (0, $7bdd1833f6148952$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $7bdd1833f6148952$var$_default = module.exports.default = $7bdd1833f6148952$var$cubehelix($7bdd1833f6148952$var$_color.hue);
var $7bdd1833f6148952$var$cubehelixLong = module.exports.cubehelixLong = $7bdd1833f6148952$var$cubehelix($7bdd1833f6148952$var$_color.default);

});

parcelRegister("bkRuy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $840b0e4e62d6acdb$var$piecewise;

var $840b0e4e62d6acdb$var$_value = $840b0e4e62d6acdb$var$_interopRequireDefault((parcelRequire("i9JLI")));
function $840b0e4e62d6acdb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $840b0e4e62d6acdb$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $840b0e4e62d6acdb$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("44duB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2f6200798fd31708$var$_default;
function $2f6200798fd31708$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("krN5P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ee2c691d9d6e022f$var$constants;
function $ee2c691d9d6e022f$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("2Qh0u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $211da14e849792e6$var$number;
function $211da14e849792e6$var$number(x) {
    return +x;
}

});


parcelRegister("6db4r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $485c8b64d34a3b85$var$tickFormat;

var $dCoBu = parcelRequire("dCoBu");

var $31njV = parcelRequire("31njV");
function $485c8b64d34a3b85$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $dCoBu.tickStep)(start, stop, count), precision;
    specifier = (0, $31njV.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $31njV.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $31njV.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $31njV.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $31njV.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $31njV.format)(specifier);
}

});
parcelRegister("31njV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $23338e0a962b0c4a$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $23338e0a962b0c4a$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $23338e0a962b0c4a$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $23338e0a962b0c4a$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $23338e0a962b0c4a$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $23338e0a962b0c4a$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $23338e0a962b0c4a$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $23338e0a962b0c4a$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $23338e0a962b0c4a$var$_precisionRound.default;
    }
});

var $23338e0a962b0c4a$var$_defaultLocale = $23338e0a962b0c4a$var$_interopRequireWildcard((parcelRequire("1Po44")));

var $23338e0a962b0c4a$var$_locale = $23338e0a962b0c4a$var$_interopRequireDefault((parcelRequire("hYXKg")));

var $23338e0a962b0c4a$var$_formatSpecifier = $23338e0a962b0c4a$var$_interopRequireWildcard((parcelRequire("1lGbs")));

var $23338e0a962b0c4a$var$_precisionFixed = $23338e0a962b0c4a$var$_interopRequireDefault((parcelRequire("kgJns")));

var $23338e0a962b0c4a$var$_precisionPrefix = $23338e0a962b0c4a$var$_interopRequireDefault((parcelRequire("lm4uu")));

var $23338e0a962b0c4a$var$_precisionRound = $23338e0a962b0c4a$var$_interopRequireDefault((parcelRequire("j8jhT")));
function $23338e0a962b0c4a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $23338e0a962b0c4a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($23338e0a962b0c4a$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $23338e0a962b0c4a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $23338e0a962b0c4a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}

});
parcelRegister("1Po44", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $154d38975a3f86dc$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $154d38975a3f86dc$var$_locale = $154d38975a3f86dc$var$_interopRequireDefault((parcelRequire("hYXKg")));
function $154d38975a3f86dc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $154d38975a3f86dc$var$locale;
var $154d38975a3f86dc$var$format;
var $154d38975a3f86dc$var$formatPrefix;
$154d38975a3f86dc$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $154d38975a3f86dc$var$defaultLocale(definition) {
    $154d38975a3f86dc$var$locale = (0, $154d38975a3f86dc$var$_locale.default)(definition);
    module.exports.format = $154d38975a3f86dc$var$format = $154d38975a3f86dc$var$locale.format;
    module.exports.formatPrefix = $154d38975a3f86dc$var$formatPrefix = $154d38975a3f86dc$var$locale.formatPrefix;
    return $154d38975a3f86dc$var$locale;
}

});
parcelRegister("hYXKg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0360e08e0728314b$var$_default;

var $0360e08e0728314b$var$_exponent = $0360e08e0728314b$var$_interopRequireDefault((parcelRequire("gbH2v")));

var $0360e08e0728314b$var$_formatGroup = $0360e08e0728314b$var$_interopRequireDefault((parcelRequire("kUawR")));

var $0360e08e0728314b$var$_formatNumerals = $0360e08e0728314b$var$_interopRequireDefault((parcelRequire("iz4Al")));

var $0360e08e0728314b$var$_formatSpecifier = $0360e08e0728314b$var$_interopRequireDefault((parcelRequire("1lGbs")));

var $0360e08e0728314b$var$_formatTrim = $0360e08e0728314b$var$_interopRequireDefault((parcelRequire("k0HeC")));

var $0360e08e0728314b$var$_formatTypes = $0360e08e0728314b$var$_interopRequireDefault((parcelRequire("ebiMV")));

var $fYW0R = parcelRequire("fYW0R");

var $0360e08e0728314b$var$_identity = $0360e08e0728314b$var$_interopRequireDefault((parcelRequire("6N57n")));
function $0360e08e0728314b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0360e08e0728314b$var$map = Array.prototype.map, $0360e08e0728314b$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $0360e08e0728314b$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $0360e08e0728314b$var$_identity.default : (0, $0360e08e0728314b$var$_formatGroup.default)($0360e08e0728314b$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $0360e08e0728314b$var$_identity.default : (0, $0360e08e0728314b$var$_formatNumerals.default)($0360e08e0728314b$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $0360e08e0728314b$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!$0360e08e0728314b$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $0360e08e0728314b$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $0360e08e0728314b$var$_formatTrim.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $0360e08e0728314b$var$prefixes[8 + $fYW0R.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $0360e08e0728314b$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $0360e08e0728314b$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $0360e08e0728314b$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("gbH2v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bc8f0f21a8a3522c$var$_default;

var $6WfoH = parcelRequire("6WfoH");
function $bc8f0f21a8a3522c$var$_default(x) {
    return x = (0, $6WfoH.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("6WfoH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $50d41a730eeb5f9f$var$_default;
module.exports.formatDecimalParts = $50d41a730eeb5f9f$var$formatDecimalParts;
function $50d41a730eeb5f9f$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $50d41a730eeb5f9f$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("kUawR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f38134774f803ebe$var$_default;
function $f38134774f803ebe$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("iz4Al", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d83f0d647cb7f525$var$_default;
function $d83f0d647cb7f525$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("1lGbs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $0fb8797346cf2a04$var$FormatSpecifier;
module.exports.default = $0fb8797346cf2a04$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $0fb8797346cf2a04$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $0fb8797346cf2a04$var$formatSpecifier(specifier) {
    if (!(match = $0fb8797346cf2a04$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $0fb8797346cf2a04$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$0fb8797346cf2a04$var$formatSpecifier.prototype = $0fb8797346cf2a04$var$FormatSpecifier.prototype; // instanceof
function $0fb8797346cf2a04$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$0fb8797346cf2a04$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("k0HeC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e915583e23c8946b$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $e915583e23c8946b$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("ebiMV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a530aab40ad308ac$var$_formatDecimal = $a530aab40ad308ac$var$_interopRequireDefault((parcelRequire("6WfoH")));

var $a530aab40ad308ac$var$_formatPrefixAuto = $a530aab40ad308ac$var$_interopRequireDefault((parcelRequire("fYW0R")));

var $a530aab40ad308ac$var$_formatRounded = $a530aab40ad308ac$var$_interopRequireDefault((parcelRequire("lKQL9")));
function $a530aab40ad308ac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a530aab40ad308ac$var$_default = module.exports.default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $a530aab40ad308ac$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $a530aab40ad308ac$var$_formatRounded.default)(x * 100, p),
    "r": $a530aab40ad308ac$var$_formatRounded.default,
    "s": $a530aab40ad308ac$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

});
parcelRegister("fYW0R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ba2975c0d64e348d$var$_default;
module.exports.prefixExponent = void 0;

var $6WfoH = parcelRequire("6WfoH");
var $ba2975c0d64e348d$var$prefixExponent;
function $ba2975c0d64e348d$var$_default(x, p) {
    var d = (0, $6WfoH.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $ba2975c0d64e348d$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $6WfoH.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("lKQL9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fd66d1c90419008e$var$_default;

var $6WfoH = parcelRequire("6WfoH");
function $fd66d1c90419008e$var$_default(x, p) {
    var d = (0, $6WfoH.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("6N57n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4f1b4a05e6c0032f$var$_default;
function $4f1b4a05e6c0032f$var$_default(x) {
    return x;
}

});



parcelRegister("kgJns", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ec188047ea74e769$var$_default;

var $ec188047ea74e769$var$_exponent = $ec188047ea74e769$var$_interopRequireDefault((parcelRequire("gbH2v")));
function $ec188047ea74e769$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ec188047ea74e769$var$_default(step) {
    return Math.max(0, -(0, $ec188047ea74e769$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("lm4uu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8bf22d26c1c8d0c$var$_default;

var $f8bf22d26c1c8d0c$var$_exponent = $f8bf22d26c1c8d0c$var$_interopRequireDefault((parcelRequire("gbH2v")));
function $f8bf22d26c1c8d0c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f8bf22d26c1c8d0c$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $f8bf22d26c1c8d0c$var$_exponent.default)(value) / 3))) * 3 - (0, $f8bf22d26c1c8d0c$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("j8jhT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $deddb9ca44da1915$var$_default;

var $deddb9ca44da1915$var$_exponent = $deddb9ca44da1915$var$_interopRequireDefault((parcelRequire("gbH2v")));
function $deddb9ca44da1915$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $deddb9ca44da1915$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $deddb9ca44da1915$var$_exponent.default)(max) - (0, $deddb9ca44da1915$var$_exponent.default)(step)) + 1;
}

});





parcelRegister("HKIoj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $083840e3ea4493ed$var$log;
module.exports.loggish = $083840e3ea4493ed$var$loggish;

var $dCoBu = parcelRequire("dCoBu");

var $31njV = parcelRequire("31njV");

var $083840e3ea4493ed$var$_nice = $083840e3ea4493ed$var$_interopRequireDefault((parcelRequire("bOl1M")));

var $g3aux = parcelRequire("g3aux");

var $9Ob92 = parcelRequire("9Ob92");
function $083840e3ea4493ed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $083840e3ea4493ed$var$transformLog(x) {
    return Math.log(x);
}
function $083840e3ea4493ed$var$transformExp(x) {
    return Math.exp(x);
}
function $083840e3ea4493ed$var$transformLogn(x) {
    return -Math.log(-x);
}
function $083840e3ea4493ed$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $083840e3ea4493ed$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $083840e3ea4493ed$var$powp(base) {
    return base === 10 ? $083840e3ea4493ed$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $083840e3ea4493ed$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $083840e3ea4493ed$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $083840e3ea4493ed$var$loggish(transform) {
    const scale = transform($083840e3ea4493ed$var$transformLog, $083840e3ea4493ed$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $083840e3ea4493ed$var$logp(base), pows = $083840e3ea4493ed$var$powp(base);
        if (domain()[0] < 0) {
            logs = $083840e3ea4493ed$var$reflect(logs), pows = $083840e3ea4493ed$var$reflect(pows);
            transform($083840e3ea4493ed$var$transformLogn, $083840e3ea4493ed$var$transformExpn);
        } else transform($083840e3ea4493ed$var$transformLog, $083840e3ea4493ed$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $dCoBu.ticks)(u, v, n);
        } else z = (0, $dCoBu.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $31njV.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $31njV.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $083840e3ea4493ed$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $083840e3ea4493ed$var$log() {
    const scale = $083840e3ea4493ed$var$loggish((0, $g3aux.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $g3aux.copy)(scale, $083840e3ea4493ed$var$log()).base(scale.base());
    $9Ob92.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRegister("bOl1M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8994ace2d1ca4b0b$var$nice;
function $8994ace2d1ca4b0b$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("6teXX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4b610f78638b6f6e$var$symlog;
module.exports.symlogish = $4b610f78638b6f6e$var$symlogish;

var $kQSTd = parcelRequire("kQSTd");

var $g3aux = parcelRequire("g3aux");

var $9Ob92 = parcelRequire("9Ob92");
function $4b610f78638b6f6e$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $4b610f78638b6f6e$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $4b610f78638b6f6e$var$symlogish(transform) {
    var c = 1, scale = transform($4b610f78638b6f6e$var$transformSymlog(c), $4b610f78638b6f6e$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($4b610f78638b6f6e$var$transformSymlog(c = +_), $4b610f78638b6f6e$var$transformSymexp(c)) : c;
    };
    return (0, $kQSTd.linearish)(scale);
}
function $4b610f78638b6f6e$var$symlog() {
    var scale = $4b610f78638b6f6e$var$symlogish((0, $g3aux.transformer)());
    scale.copy = function() {
        return (0, $g3aux.copy)(scale, $4b610f78638b6f6e$var$symlog()).constant(scale.constant());
    };
    return $9Ob92.initRange.apply(scale, arguments);
}

});

parcelRegister("7veUS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5766ffbad59debfe$var$pow;
module.exports.powish = $5766ffbad59debfe$var$powish;
module.exports.sqrt = $5766ffbad59debfe$var$sqrt;

var $kQSTd = parcelRequire("kQSTd");

var $g3aux = parcelRequire("g3aux");

var $9Ob92 = parcelRequire("9Ob92");
function $5766ffbad59debfe$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $5766ffbad59debfe$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $5766ffbad59debfe$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $5766ffbad59debfe$var$powish(transform) {
    var scale = transform($g3aux.identity, $g3aux.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($g3aux.identity, $g3aux.identity) : exponent === 0.5 ? transform($5766ffbad59debfe$var$transformSqrt, $5766ffbad59debfe$var$transformSquare) : transform($5766ffbad59debfe$var$transformPow(exponent), $5766ffbad59debfe$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $kQSTd.linearish)(scale);
}
function $5766ffbad59debfe$var$pow() {
    var scale = $5766ffbad59debfe$var$powish((0, $g3aux.transformer)());
    scale.copy = function() {
        return (0, $g3aux.copy)(scale, $5766ffbad59debfe$var$pow()).exponent(scale.exponent());
    };
    $9Ob92.initRange.apply(scale, arguments);
    return scale;
}
function $5766ffbad59debfe$var$sqrt() {
    return $5766ffbad59debfe$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("52MRI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3ac30b4c3d3340c0$var$radial;

var $3ac30b4c3d3340c0$var$_continuous = $3ac30b4c3d3340c0$var$_interopRequireDefault((parcelRequire("g3aux")));

var $9Ob92 = parcelRequire("9Ob92");

var $kQSTd = parcelRequire("kQSTd");

var $3ac30b4c3d3340c0$var$_number = $3ac30b4c3d3340c0$var$_interopRequireDefault((parcelRequire("2Qh0u")));
function $3ac30b4c3d3340c0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3ac30b4c3d3340c0$var$square(x) {
    return Math.sign(x) * x * x;
}
function $3ac30b4c3d3340c0$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $3ac30b4c3d3340c0$var$radial() {
    var squared = (0, $3ac30b4c3d3340c0$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $3ac30b4c3d3340c0$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($3ac30b4c3d3340c0$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $3ac30b4c3d3340c0$var$_number.default)).map($3ac30b4c3d3340c0$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $3ac30b4c3d3340c0$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $9Ob92.initRange.apply(scale, arguments);
    return (0, $kQSTd.linearish)(scale);
}

});

parcelRegister("jP6Dh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e6e7ecd5f44d5d7c$var$quantile;

var $dCoBu = parcelRequire("dCoBu");

var $9Ob92 = parcelRequire("9Ob92");
function $e6e7ecd5f44d5d7c$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $dCoBu.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $dCoBu.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($dCoBu.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $e6e7ecd5f44d5d7c$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $9Ob92.initRange.apply(scale, arguments);
}

});

parcelRegister("koS5Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eda002517c813ee6$var$quantize;

var $dCoBu = parcelRequire("dCoBu");

var $kQSTd = parcelRequire("kQSTd");

var $9Ob92 = parcelRequire("9Ob92");
function $eda002517c813ee6$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $dCoBu.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $eda002517c813ee6$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $9Ob92.initRange.apply((0, $kQSTd.linearish)(scale), arguments);
}

});

parcelRegister("3ws42", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $290a2137137c8634$var$threshold;

var $dCoBu = parcelRequire("dCoBu");

var $9Ob92 = parcelRequire("9Ob92");
function $290a2137137c8634$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $dCoBu.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $290a2137137c8634$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $9Ob92.initRange.apply(scale, arguments);
}

});

parcelRegister("gp5UL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $bf1391a74b42897f$var$calendar;
module.exports.default = $bf1391a74b42897f$var$time;

var $4eoc2 = parcelRequire("4eoc2");

var $jjF9F = parcelRequire("jjF9F");

var $bf1391a74b42897f$var$_continuous = $bf1391a74b42897f$var$_interopRequireWildcard((parcelRequire("g3aux")));

var $9Ob92 = parcelRequire("9Ob92");

var $bf1391a74b42897f$var$_nice = $bf1391a74b42897f$var$_interopRequireDefault((parcelRequire("bOl1M")));
function $bf1391a74b42897f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bf1391a74b42897f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($bf1391a74b42897f$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $bf1391a74b42897f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $bf1391a74b42897f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $bf1391a74b42897f$var$date(t) {
    return new Date(t);
}
function $bf1391a74b42897f$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $bf1391a74b42897f$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $bf1391a74b42897f$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $bf1391a74b42897f$var$number)) : domain().map($bf1391a74b42897f$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $bf1391a74b42897f$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $bf1391a74b42897f$var$_continuous.copy)(scale, $bf1391a74b42897f$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $bf1391a74b42897f$var$time() {
    return $9Ob92.initRange.apply($bf1391a74b42897f$var$calendar($4eoc2.timeTicks, $4eoc2.timeTickInterval, $4eoc2.timeYear, $4eoc2.timeMonth, $4eoc2.timeWeek, $4eoc2.timeDay, $4eoc2.timeHour, $4eoc2.timeMinute, $4eoc2.timeSecond, $jjF9F.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("4eoc2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $20cw5.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $20cw5.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $20cw5.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $20cw5.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $20cw5.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $20cw5.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $20cw5.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $20cw5.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $20cw5.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $20cw5.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $c3jUh.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $c3jUh.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $20cw5.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $20cw5.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $20cw5.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $20cw5.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $20cw5.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $20cw5.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $btn5N.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $btn5N.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $btn5N.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $btn5N.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $btn5N.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $btn5N.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $btn5N.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $btn5N.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $btn5N.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $btn5N.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $c3jUh.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $c3jUh.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $btn5N.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $btn5N.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $btn5N.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $btn5N.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $btn5N.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $btn5N.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $314b3c7b74758ee1$var$_utcYear.utcYears;
    }
});

var $314b3c7b74758ee1$var$_interval = $314b3c7b74758ee1$var$_interopRequireDefault((parcelRequire("iH7Et")));

var $314b3c7b74758ee1$var$_millisecond = $314b3c7b74758ee1$var$_interopRequireWildcard((parcelRequire("ka1Ri")));

var $314b3c7b74758ee1$var$_second = $314b3c7b74758ee1$var$_interopRequireWildcard((parcelRequire("6Tjwq")));

var $314b3c7b74758ee1$var$_minute = $314b3c7b74758ee1$var$_interopRequireWildcard((parcelRequire("26qDl")));

var $314b3c7b74758ee1$var$_hour = $314b3c7b74758ee1$var$_interopRequireWildcard((parcelRequire("izkwD")));

var $314b3c7b74758ee1$var$_day = $314b3c7b74758ee1$var$_interopRequireWildcard((parcelRequire("71umm")));

var $20cw5 = parcelRequire("20cw5");

var $314b3c7b74758ee1$var$_month = $314b3c7b74758ee1$var$_interopRequireWildcard((parcelRequire("8Urn1")));

var $314b3c7b74758ee1$var$_year = $314b3c7b74758ee1$var$_interopRequireWildcard((parcelRequire("fBKFj")));

var $314b3c7b74758ee1$var$_utcMinute = $314b3c7b74758ee1$var$_interopRequireWildcard((parcelRequire("lGEqX")));

var $314b3c7b74758ee1$var$_utcHour = $314b3c7b74758ee1$var$_interopRequireWildcard((parcelRequire("lai77")));

var $314b3c7b74758ee1$var$_utcDay = $314b3c7b74758ee1$var$_interopRequireWildcard((parcelRequire("arrFN")));

var $btn5N = parcelRequire("btn5N");

var $314b3c7b74758ee1$var$_utcMonth = $314b3c7b74758ee1$var$_interopRequireWildcard((parcelRequire("j6IFA")));

var $314b3c7b74758ee1$var$_utcYear = $314b3c7b74758ee1$var$_interopRequireWildcard((parcelRequire("cHd36")));

var $c3jUh = parcelRequire("c3jUh");
function $314b3c7b74758ee1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($314b3c7b74758ee1$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $314b3c7b74758ee1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $314b3c7b74758ee1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $314b3c7b74758ee1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("iH7Et", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d9c22da245311dbf$var$newInterval;
var $d9c22da245311dbf$var$t0 = new Date(), $d9c22da245311dbf$var$t1 = new Date();
function $d9c22da245311dbf$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $d9c22da245311dbf$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $d9c22da245311dbf$var$t0.setTime(+start), $d9c22da245311dbf$var$t1.setTime(+end);
            floori($d9c22da245311dbf$var$t0), floori($d9c22da245311dbf$var$t1);
            return Math.floor(count($d9c22da245311dbf$var$t0, $d9c22da245311dbf$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("ka1Ri", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $ead62ee16e51240a$var$_interval = $ead62ee16e51240a$var$_interopRequireDefault((parcelRequire("iH7Et")));
function $ead62ee16e51240a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ead62ee16e51240a$var$millisecond = (0, $ead62ee16e51240a$var$_interval.default)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$ead62ee16e51240a$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $ead62ee16e51240a$var$millisecond;
    return (0, $ead62ee16e51240a$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $ead62ee16e51240a$var$_default = module.exports.default = $ead62ee16e51240a$var$millisecond;
var $ead62ee16e51240a$var$milliseconds = module.exports.milliseconds = $ead62ee16e51240a$var$millisecond.range;

});

parcelRegister("6Tjwq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $504705c73d452bdf$var$_interval = $504705c73d452bdf$var$_interopRequireDefault((parcelRequire("iH7Et")));

var $4Q2uM = parcelRequire("4Q2uM");
function $504705c73d452bdf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $504705c73d452bdf$var$second = (0, $504705c73d452bdf$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $4Q2uM.durationSecond);
}, function(start, end) {
    return (end - start) / $4Q2uM.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $504705c73d452bdf$var$_default = module.exports.default = $504705c73d452bdf$var$second;
var $504705c73d452bdf$var$seconds = module.exports.seconds = $504705c73d452bdf$var$second.range;

});
parcelRegister("4Q2uM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $385df450c62ea60b$var$durationSecond = module.exports.durationSecond = 1000;
const $385df450c62ea60b$var$durationMinute = module.exports.durationMinute = $385df450c62ea60b$var$durationSecond * 60;
const $385df450c62ea60b$var$durationHour = module.exports.durationHour = $385df450c62ea60b$var$durationMinute * 60;
const $385df450c62ea60b$var$durationDay = module.exports.durationDay = $385df450c62ea60b$var$durationHour * 24;
const $385df450c62ea60b$var$durationWeek = module.exports.durationWeek = $385df450c62ea60b$var$durationDay * 7;
const $385df450c62ea60b$var$durationMonth = module.exports.durationMonth = $385df450c62ea60b$var$durationDay * 30;
const $385df450c62ea60b$var$durationYear = module.exports.durationYear = $385df450c62ea60b$var$durationDay * 365;

});


parcelRegister("26qDl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $1880cd35d91f4d1e$var$_interval = $1880cd35d91f4d1e$var$_interopRequireDefault((parcelRequire("iH7Et")));

var $4Q2uM = parcelRequire("4Q2uM");
function $1880cd35d91f4d1e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1880cd35d91f4d1e$var$minute = (0, $1880cd35d91f4d1e$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $4Q2uM.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $4Q2uM.durationMinute);
}, function(start, end) {
    return (end - start) / $4Q2uM.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $1880cd35d91f4d1e$var$_default = module.exports.default = $1880cd35d91f4d1e$var$minute;
var $1880cd35d91f4d1e$var$minutes = module.exports.minutes = $1880cd35d91f4d1e$var$minute.range;

});

parcelRegister("izkwD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $d84b6ac3bd6858ec$var$_interval = $d84b6ac3bd6858ec$var$_interopRequireDefault((parcelRequire("iH7Et")));

var $4Q2uM = parcelRequire("4Q2uM");
function $d84b6ac3bd6858ec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d84b6ac3bd6858ec$var$hour = (0, $d84b6ac3bd6858ec$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $4Q2uM.durationSecond - date.getMinutes() * $4Q2uM.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $4Q2uM.durationHour);
}, function(start, end) {
    return (end - start) / $4Q2uM.durationHour;
}, function(date) {
    return date.getHours();
});
var $d84b6ac3bd6858ec$var$_default = module.exports.default = $d84b6ac3bd6858ec$var$hour;
var $d84b6ac3bd6858ec$var$hours = module.exports.hours = $d84b6ac3bd6858ec$var$hour.range;

});

parcelRegister("71umm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $51d02d2bf5b6287b$var$_interval = $51d02d2bf5b6287b$var$_interopRequireDefault((parcelRequire("iH7Et")));

var $4Q2uM = parcelRequire("4Q2uM");
function $51d02d2bf5b6287b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $51d02d2bf5b6287b$var$day = (0, $51d02d2bf5b6287b$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $4Q2uM.durationMinute) / $4Q2uM.durationDay, (date)=>date.getDate() - 1);
var $51d02d2bf5b6287b$var$_default = module.exports.default = $51d02d2bf5b6287b$var$day;
var $51d02d2bf5b6287b$var$days = module.exports.days = $51d02d2bf5b6287b$var$day.range;

});

parcelRegister("20cw5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $17554a619f60b24d$var$_interval = $17554a619f60b24d$var$_interopRequireDefault((parcelRequire("iH7Et")));

var $4Q2uM = parcelRequire("4Q2uM");
function $17554a619f60b24d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $17554a619f60b24d$var$weekday(i) {
    return (0, $17554a619f60b24d$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $4Q2uM.durationMinute) / $4Q2uM.durationWeek;
    });
}
var $17554a619f60b24d$var$sunday = module.exports.sunday = $17554a619f60b24d$var$weekday(0);
var $17554a619f60b24d$var$monday = module.exports.monday = $17554a619f60b24d$var$weekday(1);
var $17554a619f60b24d$var$tuesday = module.exports.tuesday = $17554a619f60b24d$var$weekday(2);
var $17554a619f60b24d$var$wednesday = module.exports.wednesday = $17554a619f60b24d$var$weekday(3);
var $17554a619f60b24d$var$thursday = module.exports.thursday = $17554a619f60b24d$var$weekday(4);
var $17554a619f60b24d$var$friday = module.exports.friday = $17554a619f60b24d$var$weekday(5);
var $17554a619f60b24d$var$saturday = module.exports.saturday = $17554a619f60b24d$var$weekday(6);
var $17554a619f60b24d$var$sundays = module.exports.sundays = $17554a619f60b24d$var$sunday.range;
var $17554a619f60b24d$var$mondays = module.exports.mondays = $17554a619f60b24d$var$monday.range;
var $17554a619f60b24d$var$tuesdays = module.exports.tuesdays = $17554a619f60b24d$var$tuesday.range;
var $17554a619f60b24d$var$wednesdays = module.exports.wednesdays = $17554a619f60b24d$var$wednesday.range;
var $17554a619f60b24d$var$thursdays = module.exports.thursdays = $17554a619f60b24d$var$thursday.range;
var $17554a619f60b24d$var$fridays = module.exports.fridays = $17554a619f60b24d$var$friday.range;
var $17554a619f60b24d$var$saturdays = module.exports.saturdays = $17554a619f60b24d$var$saturday.range;

});

parcelRegister("8Urn1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $67c8c8e25fa9dd1e$var$_interval = $67c8c8e25fa9dd1e$var$_interopRequireDefault((parcelRequire("iH7Et")));
function $67c8c8e25fa9dd1e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $67c8c8e25fa9dd1e$var$month = (0, $67c8c8e25fa9dd1e$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $67c8c8e25fa9dd1e$var$_default = module.exports.default = $67c8c8e25fa9dd1e$var$month;
var $67c8c8e25fa9dd1e$var$months = module.exports.months = $67c8c8e25fa9dd1e$var$month.range;

});

parcelRegister("fBKFj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $b5ce8276e836dc2e$var$_interval = $b5ce8276e836dc2e$var$_interopRequireDefault((parcelRequire("iH7Et")));
function $b5ce8276e836dc2e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b5ce8276e836dc2e$var$year = (0, $b5ce8276e836dc2e$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$b5ce8276e836dc2e$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $b5ce8276e836dc2e$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $b5ce8276e836dc2e$var$_default = module.exports.default = $b5ce8276e836dc2e$var$year;
var $b5ce8276e836dc2e$var$years = module.exports.years = $b5ce8276e836dc2e$var$year.range;

});

parcelRegister("lGEqX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $fc9ce28d0bb8f05e$var$_interval = $fc9ce28d0bb8f05e$var$_interopRequireDefault((parcelRequire("iH7Et")));

var $4Q2uM = parcelRequire("4Q2uM");
function $fc9ce28d0bb8f05e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fc9ce28d0bb8f05e$var$utcMinute = (0, $fc9ce28d0bb8f05e$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $4Q2uM.durationMinute);
}, function(start, end) {
    return (end - start) / $4Q2uM.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $fc9ce28d0bb8f05e$var$_default = module.exports.default = $fc9ce28d0bb8f05e$var$utcMinute;
var $fc9ce28d0bb8f05e$var$utcMinutes = module.exports.utcMinutes = $fc9ce28d0bb8f05e$var$utcMinute.range;

});

parcelRegister("lai77", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $f6889527a469e378$var$_interval = $f6889527a469e378$var$_interopRequireDefault((parcelRequire("iH7Et")));

var $4Q2uM = parcelRequire("4Q2uM");
function $f6889527a469e378$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f6889527a469e378$var$utcHour = (0, $f6889527a469e378$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $4Q2uM.durationHour);
}, function(start, end) {
    return (end - start) / $4Q2uM.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $f6889527a469e378$var$_default = module.exports.default = $f6889527a469e378$var$utcHour;
var $f6889527a469e378$var$utcHours = module.exports.utcHours = $f6889527a469e378$var$utcHour.range;

});

parcelRegister("arrFN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $79a1e44fdce0a350$var$_interval = $79a1e44fdce0a350$var$_interopRequireDefault((parcelRequire("iH7Et")));

var $4Q2uM = parcelRequire("4Q2uM");
function $79a1e44fdce0a350$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $79a1e44fdce0a350$var$utcDay = (0, $79a1e44fdce0a350$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $4Q2uM.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $79a1e44fdce0a350$var$_default = module.exports.default = $79a1e44fdce0a350$var$utcDay;
var $79a1e44fdce0a350$var$utcDays = module.exports.utcDays = $79a1e44fdce0a350$var$utcDay.range;

});

parcelRegister("btn5N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $85a450cdde2d6fd5$var$_interval = $85a450cdde2d6fd5$var$_interopRequireDefault((parcelRequire("iH7Et")));

var $4Q2uM = parcelRequire("4Q2uM");
function $85a450cdde2d6fd5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $85a450cdde2d6fd5$var$utcWeekday(i) {
    return (0, $85a450cdde2d6fd5$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $4Q2uM.durationWeek;
    });
}
var $85a450cdde2d6fd5$var$utcSunday = module.exports.utcSunday = $85a450cdde2d6fd5$var$utcWeekday(0);
var $85a450cdde2d6fd5$var$utcMonday = module.exports.utcMonday = $85a450cdde2d6fd5$var$utcWeekday(1);
var $85a450cdde2d6fd5$var$utcTuesday = module.exports.utcTuesday = $85a450cdde2d6fd5$var$utcWeekday(2);
var $85a450cdde2d6fd5$var$utcWednesday = module.exports.utcWednesday = $85a450cdde2d6fd5$var$utcWeekday(3);
var $85a450cdde2d6fd5$var$utcThursday = module.exports.utcThursday = $85a450cdde2d6fd5$var$utcWeekday(4);
var $85a450cdde2d6fd5$var$utcFriday = module.exports.utcFriday = $85a450cdde2d6fd5$var$utcWeekday(5);
var $85a450cdde2d6fd5$var$utcSaturday = module.exports.utcSaturday = $85a450cdde2d6fd5$var$utcWeekday(6);
var $85a450cdde2d6fd5$var$utcSundays = module.exports.utcSundays = $85a450cdde2d6fd5$var$utcSunday.range;
var $85a450cdde2d6fd5$var$utcMondays = module.exports.utcMondays = $85a450cdde2d6fd5$var$utcMonday.range;
var $85a450cdde2d6fd5$var$utcTuesdays = module.exports.utcTuesdays = $85a450cdde2d6fd5$var$utcTuesday.range;
var $85a450cdde2d6fd5$var$utcWednesdays = module.exports.utcWednesdays = $85a450cdde2d6fd5$var$utcWednesday.range;
var $85a450cdde2d6fd5$var$utcThursdays = module.exports.utcThursdays = $85a450cdde2d6fd5$var$utcThursday.range;
var $85a450cdde2d6fd5$var$utcFridays = module.exports.utcFridays = $85a450cdde2d6fd5$var$utcFriday.range;
var $85a450cdde2d6fd5$var$utcSaturdays = module.exports.utcSaturdays = $85a450cdde2d6fd5$var$utcSaturday.range;

});

parcelRegister("j6IFA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $de913a5dbfea45c6$var$_interval = $de913a5dbfea45c6$var$_interopRequireDefault((parcelRequire("iH7Et")));
function $de913a5dbfea45c6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $de913a5dbfea45c6$var$utcMonth = (0, $de913a5dbfea45c6$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $de913a5dbfea45c6$var$_default = module.exports.default = $de913a5dbfea45c6$var$utcMonth;
var $de913a5dbfea45c6$var$utcMonths = module.exports.utcMonths = $de913a5dbfea45c6$var$utcMonth.range;

});

parcelRegister("cHd36", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $93e39f78de734355$var$_interval = $93e39f78de734355$var$_interopRequireDefault((parcelRequire("iH7Et")));
function $93e39f78de734355$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $93e39f78de734355$var$utcYear = (0, $93e39f78de734355$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$93e39f78de734355$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $93e39f78de734355$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $93e39f78de734355$var$_default = module.exports.default = $93e39f78de734355$var$utcYear;
var $93e39f78de734355$var$utcYears = module.exports.utcYears = $93e39f78de734355$var$utcYear.range;

});

parcelRegister("c3jUh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $dCoBu = parcelRequire("dCoBu");

var $4Q2uM = parcelRequire("4Q2uM");

var $8c6534ecf327cbec$var$_millisecond = $8c6534ecf327cbec$var$_interopRequireDefault((parcelRequire("ka1Ri")));

var $8c6534ecf327cbec$var$_second = $8c6534ecf327cbec$var$_interopRequireDefault((parcelRequire("6Tjwq")));

var $8c6534ecf327cbec$var$_minute = $8c6534ecf327cbec$var$_interopRequireDefault((parcelRequire("26qDl")));

var $8c6534ecf327cbec$var$_hour = $8c6534ecf327cbec$var$_interopRequireDefault((parcelRequire("izkwD")));

var $8c6534ecf327cbec$var$_day = $8c6534ecf327cbec$var$_interopRequireDefault((parcelRequire("71umm")));

var $20cw5 = parcelRequire("20cw5");

var $8c6534ecf327cbec$var$_month = $8c6534ecf327cbec$var$_interopRequireDefault((parcelRequire("8Urn1")));

var $8c6534ecf327cbec$var$_year = $8c6534ecf327cbec$var$_interopRequireDefault((parcelRequire("fBKFj")));

var $8c6534ecf327cbec$var$_utcMinute = $8c6534ecf327cbec$var$_interopRequireDefault((parcelRequire("lGEqX")));

var $8c6534ecf327cbec$var$_utcHour = $8c6534ecf327cbec$var$_interopRequireDefault((parcelRequire("lai77")));

var $8c6534ecf327cbec$var$_utcDay = $8c6534ecf327cbec$var$_interopRequireDefault((parcelRequire("arrFN")));

var $btn5N = parcelRequire("btn5N");

var $8c6534ecf327cbec$var$_utcMonth = $8c6534ecf327cbec$var$_interopRequireDefault((parcelRequire("j6IFA")));

var $8c6534ecf327cbec$var$_utcYear = $8c6534ecf327cbec$var$_interopRequireDefault((parcelRequire("cHd36")));
function $8c6534ecf327cbec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8c6534ecf327cbec$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $8c6534ecf327cbec$var$_second.default,
            1,
            $4Q2uM.durationSecond
        ],
        [
            $8c6534ecf327cbec$var$_second.default,
            5,
            5 * $4Q2uM.durationSecond
        ],
        [
            $8c6534ecf327cbec$var$_second.default,
            15,
            15 * $4Q2uM.durationSecond
        ],
        [
            $8c6534ecf327cbec$var$_second.default,
            30,
            30 * $4Q2uM.durationSecond
        ],
        [
            minute,
            1,
            $4Q2uM.durationMinute
        ],
        [
            minute,
            5,
            5 * $4Q2uM.durationMinute
        ],
        [
            minute,
            15,
            15 * $4Q2uM.durationMinute
        ],
        [
            minute,
            30,
            30 * $4Q2uM.durationMinute
        ],
        [
            hour,
            1,
            $4Q2uM.durationHour
        ],
        [
            hour,
            3,
            3 * $4Q2uM.durationHour
        ],
        [
            hour,
            6,
            6 * $4Q2uM.durationHour
        ],
        [
            hour,
            12,
            12 * $4Q2uM.durationHour
        ],
        [
            day,
            1,
            $4Q2uM.durationDay
        ],
        [
            day,
            2,
            2 * $4Q2uM.durationDay
        ],
        [
            week,
            1,
            $4Q2uM.durationWeek
        ],
        [
            month,
            1,
            $4Q2uM.durationMonth
        ],
        [
            month,
            3,
            3 * $4Q2uM.durationMonth
        ],
        [
            year,
            1,
            $4Q2uM.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $dCoBu.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $dCoBu.tickStep)(start / $4Q2uM.durationYear, stop / $4Q2uM.durationYear, count));
        if (i === 0) return $8c6534ecf327cbec$var$_millisecond.default.every(Math.max((0, $dCoBu.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$8c6534ecf327cbec$var$utcTicks, $8c6534ecf327cbec$var$utcTickInterval] = $8c6534ecf327cbec$var$ticker($8c6534ecf327cbec$var$_utcYear.default, $8c6534ecf327cbec$var$_utcMonth.default, $btn5N.utcSunday, $8c6534ecf327cbec$var$_utcDay.default, $8c6534ecf327cbec$var$_utcHour.default, $8c6534ecf327cbec$var$_utcMinute.default);
module.exports.utcTickInterval = $8c6534ecf327cbec$var$utcTickInterval;
module.exports.utcTicks = $8c6534ecf327cbec$var$utcTicks;
const [$8c6534ecf327cbec$var$timeTicks, $8c6534ecf327cbec$var$timeTickInterval] = $8c6534ecf327cbec$var$ticker($8c6534ecf327cbec$var$_year.default, $8c6534ecf327cbec$var$_month.default, $20cw5.sunday, $8c6534ecf327cbec$var$_day.default, $8c6534ecf327cbec$var$_hour.default, $8c6534ecf327cbec$var$_minute.default);
module.exports.timeTickInterval = $8c6534ecf327cbec$var$timeTickInterval;
module.exports.timeTicks = $8c6534ecf327cbec$var$timeTicks;

});


parcelRegister("jjF9F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $e0ffb72d0018bd10$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $e0ffb72d0018bd10$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $e0ffb72d0018bd10$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $e0ffb72d0018bd10$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $e0ffb72d0018bd10$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $e0ffb72d0018bd10$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $e0ffb72d0018bd10$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $e0ffb72d0018bd10$var$_defaultLocale.utcParse;
    }
});

var $e0ffb72d0018bd10$var$_defaultLocale = $e0ffb72d0018bd10$var$_interopRequireWildcard((parcelRequire("nxI7I")));

var $e0ffb72d0018bd10$var$_locale = $e0ffb72d0018bd10$var$_interopRequireDefault((parcelRequire("5fOIL")));

var $e0ffb72d0018bd10$var$_isoFormat = $e0ffb72d0018bd10$var$_interopRequireDefault((parcelRequire("eVDyw")));

var $e0ffb72d0018bd10$var$_isoParse = $e0ffb72d0018bd10$var$_interopRequireDefault((parcelRequire("6PG0U")));
function $e0ffb72d0018bd10$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e0ffb72d0018bd10$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e0ffb72d0018bd10$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $e0ffb72d0018bd10$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $e0ffb72d0018bd10$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}

});
parcelRegister("nxI7I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $046c4c556b22915b$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $046c4c556b22915b$var$_locale = $046c4c556b22915b$var$_interopRequireDefault((parcelRequire("5fOIL")));
function $046c4c556b22915b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $046c4c556b22915b$var$locale;
var $046c4c556b22915b$var$timeFormat;
var $046c4c556b22915b$var$timeParse;
var $046c4c556b22915b$var$utcFormat;
var $046c4c556b22915b$var$utcParse;
$046c4c556b22915b$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $046c4c556b22915b$var$defaultLocale(definition) {
    $046c4c556b22915b$var$locale = (0, $046c4c556b22915b$var$_locale.default)(definition);
    module.exports.timeFormat = $046c4c556b22915b$var$timeFormat = $046c4c556b22915b$var$locale.format;
    module.exports.timeParse = $046c4c556b22915b$var$timeParse = $046c4c556b22915b$var$locale.parse;
    module.exports.utcFormat = $046c4c556b22915b$var$utcFormat = $046c4c556b22915b$var$locale.utcFormat;
    module.exports.utcParse = $046c4c556b22915b$var$utcParse = $046c4c556b22915b$var$locale.utcParse;
    return $046c4c556b22915b$var$locale;
}

});
parcelRegister("5fOIL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3d35b2967f76784b$var$formatLocale;

var $4eoc2 = parcelRequire("4eoc2");
function $3d35b2967f76784b$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $3d35b2967f76784b$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $3d35b2967f76784b$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $3d35b2967f76784b$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $3d35b2967f76784b$var$formatRe(locale_periods), periodLookup = $3d35b2967f76784b$var$formatLookup(locale_periods), weekdayRe = $3d35b2967f76784b$var$formatRe(locale_weekdays), weekdayLookup = $3d35b2967f76784b$var$formatLookup(locale_weekdays), shortWeekdayRe = $3d35b2967f76784b$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $3d35b2967f76784b$var$formatLookup(locale_shortWeekdays), monthRe = $3d35b2967f76784b$var$formatRe(locale_months), monthLookup = $3d35b2967f76784b$var$formatLookup(locale_months), shortMonthRe = $3d35b2967f76784b$var$formatRe(locale_shortMonths), shortMonthLookup = $3d35b2967f76784b$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $3d35b2967f76784b$var$formatDayOfMonth,
        "e": $3d35b2967f76784b$var$formatDayOfMonth,
        "f": $3d35b2967f76784b$var$formatMicroseconds,
        "g": $3d35b2967f76784b$var$formatYearISO,
        "G": $3d35b2967f76784b$var$formatFullYearISO,
        "H": $3d35b2967f76784b$var$formatHour24,
        "I": $3d35b2967f76784b$var$formatHour12,
        "j": $3d35b2967f76784b$var$formatDayOfYear,
        "L": $3d35b2967f76784b$var$formatMilliseconds,
        "m": $3d35b2967f76784b$var$formatMonthNumber,
        "M": $3d35b2967f76784b$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $3d35b2967f76784b$var$formatUnixTimestamp,
        "s": $3d35b2967f76784b$var$formatUnixTimestampSeconds,
        "S": $3d35b2967f76784b$var$formatSeconds,
        "u": $3d35b2967f76784b$var$formatWeekdayNumberMonday,
        "U": $3d35b2967f76784b$var$formatWeekNumberSunday,
        "V": $3d35b2967f76784b$var$formatWeekNumberISO,
        "w": $3d35b2967f76784b$var$formatWeekdayNumberSunday,
        "W": $3d35b2967f76784b$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $3d35b2967f76784b$var$formatYear,
        "Y": $3d35b2967f76784b$var$formatFullYear,
        "Z": $3d35b2967f76784b$var$formatZone,
        "%": $3d35b2967f76784b$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $3d35b2967f76784b$var$formatUTCDayOfMonth,
        "e": $3d35b2967f76784b$var$formatUTCDayOfMonth,
        "f": $3d35b2967f76784b$var$formatUTCMicroseconds,
        "g": $3d35b2967f76784b$var$formatUTCYearISO,
        "G": $3d35b2967f76784b$var$formatUTCFullYearISO,
        "H": $3d35b2967f76784b$var$formatUTCHour24,
        "I": $3d35b2967f76784b$var$formatUTCHour12,
        "j": $3d35b2967f76784b$var$formatUTCDayOfYear,
        "L": $3d35b2967f76784b$var$formatUTCMilliseconds,
        "m": $3d35b2967f76784b$var$formatUTCMonthNumber,
        "M": $3d35b2967f76784b$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $3d35b2967f76784b$var$formatUnixTimestamp,
        "s": $3d35b2967f76784b$var$formatUnixTimestampSeconds,
        "S": $3d35b2967f76784b$var$formatUTCSeconds,
        "u": $3d35b2967f76784b$var$formatUTCWeekdayNumberMonday,
        "U": $3d35b2967f76784b$var$formatUTCWeekNumberSunday,
        "V": $3d35b2967f76784b$var$formatUTCWeekNumberISO,
        "w": $3d35b2967f76784b$var$formatUTCWeekdayNumberSunday,
        "W": $3d35b2967f76784b$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $3d35b2967f76784b$var$formatUTCYear,
        "Y": $3d35b2967f76784b$var$formatUTCFullYear,
        "Z": $3d35b2967f76784b$var$formatUTCZone,
        "%": $3d35b2967f76784b$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $3d35b2967f76784b$var$parseDayOfMonth,
        "e": $3d35b2967f76784b$var$parseDayOfMonth,
        "f": $3d35b2967f76784b$var$parseMicroseconds,
        "g": $3d35b2967f76784b$var$parseYear,
        "G": $3d35b2967f76784b$var$parseFullYear,
        "H": $3d35b2967f76784b$var$parseHour24,
        "I": $3d35b2967f76784b$var$parseHour24,
        "j": $3d35b2967f76784b$var$parseDayOfYear,
        "L": $3d35b2967f76784b$var$parseMilliseconds,
        "m": $3d35b2967f76784b$var$parseMonthNumber,
        "M": $3d35b2967f76784b$var$parseMinutes,
        "p": parsePeriod,
        "q": $3d35b2967f76784b$var$parseQuarter,
        "Q": $3d35b2967f76784b$var$parseUnixTimestamp,
        "s": $3d35b2967f76784b$var$parseUnixTimestampSeconds,
        "S": $3d35b2967f76784b$var$parseSeconds,
        "u": $3d35b2967f76784b$var$parseWeekdayNumberMonday,
        "U": $3d35b2967f76784b$var$parseWeekNumberSunday,
        "V": $3d35b2967f76784b$var$parseWeekNumberISO,
        "w": $3d35b2967f76784b$var$parseWeekdayNumberSunday,
        "W": $3d35b2967f76784b$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $3d35b2967f76784b$var$parseYear,
        "Y": $3d35b2967f76784b$var$parseFullYear,
        "Z": $3d35b2967f76784b$var$parseZone,
        "%": $3d35b2967f76784b$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $3d35b2967f76784b$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $3d35b2967f76784b$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $3d35b2967f76784b$var$utcDate($3d35b2967f76784b$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $4eoc2.utcMonday.ceil(week) : (0, $4eoc2.utcMonday)(week);
                    week = $4eoc2.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $3d35b2967f76784b$var$localDate($3d35b2967f76784b$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $4eoc2.timeMonday.ceil(week) : (0, $4eoc2.timeMonday)(week);
                    week = $4eoc2.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $3d35b2967f76784b$var$utcDate($3d35b2967f76784b$var$newDate(d.y, 0, 1)).getUTCDay() : $3d35b2967f76784b$var$localDate($3d35b2967f76784b$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $3d35b2967f76784b$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $3d35b2967f76784b$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $3d35b2967f76784b$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $3d35b2967f76784b$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $3d35b2967f76784b$var$numberRe = /^\s*\d+/, // note: ignores next directive
$3d35b2967f76784b$var$percentRe = /^%/, $3d35b2967f76784b$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $3d35b2967f76784b$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $3d35b2967f76784b$var$requote(s) {
    return s.replace($3d35b2967f76784b$var$requoteRe, "\\$&");
}
function $3d35b2967f76784b$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($3d35b2967f76784b$var$requote).join("|") + ")", "i");
}
function $3d35b2967f76784b$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $3d35b2967f76784b$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $3d35b2967f76784b$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $3d35b2967f76784b$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $3d35b2967f76784b$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $3d35b2967f76784b$var$parseWeekNumberSunday(d, string, i) {
    var n = $3d35b2967f76784b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $3d35b2967f76784b$var$parseWeekNumberISO(d, string, i) {
    var n = $3d35b2967f76784b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $3d35b2967f76784b$var$parseWeekNumberMonday(d, string, i) {
    var n = $3d35b2967f76784b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $3d35b2967f76784b$var$parseFullYear(d, string, i) {
    var n = $3d35b2967f76784b$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $3d35b2967f76784b$var$parseYear(d, string, i) {
    var n = $3d35b2967f76784b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $3d35b2967f76784b$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $3d35b2967f76784b$var$parseQuarter(d, string, i) {
    var n = $3d35b2967f76784b$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $3d35b2967f76784b$var$parseMonthNumber(d, string, i) {
    var n = $3d35b2967f76784b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $3d35b2967f76784b$var$parseDayOfMonth(d, string, i) {
    var n = $3d35b2967f76784b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $3d35b2967f76784b$var$parseDayOfYear(d, string, i) {
    var n = $3d35b2967f76784b$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $3d35b2967f76784b$var$parseHour24(d, string, i) {
    var n = $3d35b2967f76784b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $3d35b2967f76784b$var$parseMinutes(d, string, i) {
    var n = $3d35b2967f76784b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $3d35b2967f76784b$var$parseSeconds(d, string, i) {
    var n = $3d35b2967f76784b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $3d35b2967f76784b$var$parseMilliseconds(d, string, i) {
    var n = $3d35b2967f76784b$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $3d35b2967f76784b$var$parseMicroseconds(d, string, i) {
    var n = $3d35b2967f76784b$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $3d35b2967f76784b$var$parseLiteralPercent(d, string, i) {
    var n = $3d35b2967f76784b$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $3d35b2967f76784b$var$parseUnixTimestamp(d, string, i) {
    var n = $3d35b2967f76784b$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $3d35b2967f76784b$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $3d35b2967f76784b$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $3d35b2967f76784b$var$formatDayOfMonth(d, p) {
    return $3d35b2967f76784b$var$pad(d.getDate(), p, 2);
}
function $3d35b2967f76784b$var$formatHour24(d, p) {
    return $3d35b2967f76784b$var$pad(d.getHours(), p, 2);
}
function $3d35b2967f76784b$var$formatHour12(d, p) {
    return $3d35b2967f76784b$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $3d35b2967f76784b$var$formatDayOfYear(d, p) {
    return $3d35b2967f76784b$var$pad(1 + $4eoc2.timeDay.count((0, $4eoc2.timeYear)(d), d), p, 3);
}
function $3d35b2967f76784b$var$formatMilliseconds(d, p) {
    return $3d35b2967f76784b$var$pad(d.getMilliseconds(), p, 3);
}
function $3d35b2967f76784b$var$formatMicroseconds(d, p) {
    return $3d35b2967f76784b$var$formatMilliseconds(d, p) + "000";
}
function $3d35b2967f76784b$var$formatMonthNumber(d, p) {
    return $3d35b2967f76784b$var$pad(d.getMonth() + 1, p, 2);
}
function $3d35b2967f76784b$var$formatMinutes(d, p) {
    return $3d35b2967f76784b$var$pad(d.getMinutes(), p, 2);
}
function $3d35b2967f76784b$var$formatSeconds(d, p) {
    return $3d35b2967f76784b$var$pad(d.getSeconds(), p, 2);
}
function $3d35b2967f76784b$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $3d35b2967f76784b$var$formatWeekNumberSunday(d, p) {
    return $3d35b2967f76784b$var$pad($4eoc2.timeSunday.count((0, $4eoc2.timeYear)(d) - 1, d), p, 2);
}
function $3d35b2967f76784b$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $4eoc2.timeThursday)(d) : $4eoc2.timeThursday.ceil(d);
}
function $3d35b2967f76784b$var$formatWeekNumberISO(d, p) {
    d = $3d35b2967f76784b$var$dISO(d);
    return $3d35b2967f76784b$var$pad($4eoc2.timeThursday.count((0, $4eoc2.timeYear)(d), d) + ((0, $4eoc2.timeYear)(d).getDay() === 4), p, 2);
}
function $3d35b2967f76784b$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $3d35b2967f76784b$var$formatWeekNumberMonday(d, p) {
    return $3d35b2967f76784b$var$pad($4eoc2.timeMonday.count((0, $4eoc2.timeYear)(d) - 1, d), p, 2);
}
function $3d35b2967f76784b$var$formatYear(d, p) {
    return $3d35b2967f76784b$var$pad(d.getFullYear() % 100, p, 2);
}
function $3d35b2967f76784b$var$formatYearISO(d, p) {
    d = $3d35b2967f76784b$var$dISO(d);
    return $3d35b2967f76784b$var$pad(d.getFullYear() % 100, p, 2);
}
function $3d35b2967f76784b$var$formatFullYear(d, p) {
    return $3d35b2967f76784b$var$pad(d.getFullYear() % 10000, p, 4);
}
function $3d35b2967f76784b$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $4eoc2.timeThursday)(d) : $4eoc2.timeThursday.ceil(d);
    return $3d35b2967f76784b$var$pad(d.getFullYear() % 10000, p, 4);
}
function $3d35b2967f76784b$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $3d35b2967f76784b$var$pad(z / 60 | 0, "0", 2) + $3d35b2967f76784b$var$pad(z % 60, "0", 2);
}
function $3d35b2967f76784b$var$formatUTCDayOfMonth(d, p) {
    return $3d35b2967f76784b$var$pad(d.getUTCDate(), p, 2);
}
function $3d35b2967f76784b$var$formatUTCHour24(d, p) {
    return $3d35b2967f76784b$var$pad(d.getUTCHours(), p, 2);
}
function $3d35b2967f76784b$var$formatUTCHour12(d, p) {
    return $3d35b2967f76784b$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $3d35b2967f76784b$var$formatUTCDayOfYear(d, p) {
    return $3d35b2967f76784b$var$pad(1 + $4eoc2.utcDay.count((0, $4eoc2.utcYear)(d), d), p, 3);
}
function $3d35b2967f76784b$var$formatUTCMilliseconds(d, p) {
    return $3d35b2967f76784b$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $3d35b2967f76784b$var$formatUTCMicroseconds(d, p) {
    return $3d35b2967f76784b$var$formatUTCMilliseconds(d, p) + "000";
}
function $3d35b2967f76784b$var$formatUTCMonthNumber(d, p) {
    return $3d35b2967f76784b$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $3d35b2967f76784b$var$formatUTCMinutes(d, p) {
    return $3d35b2967f76784b$var$pad(d.getUTCMinutes(), p, 2);
}
function $3d35b2967f76784b$var$formatUTCSeconds(d, p) {
    return $3d35b2967f76784b$var$pad(d.getUTCSeconds(), p, 2);
}
function $3d35b2967f76784b$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $3d35b2967f76784b$var$formatUTCWeekNumberSunday(d, p) {
    return $3d35b2967f76784b$var$pad($4eoc2.utcSunday.count((0, $4eoc2.utcYear)(d) - 1, d), p, 2);
}
function $3d35b2967f76784b$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $4eoc2.utcThursday)(d) : $4eoc2.utcThursday.ceil(d);
}
function $3d35b2967f76784b$var$formatUTCWeekNumberISO(d, p) {
    d = $3d35b2967f76784b$var$UTCdISO(d);
    return $3d35b2967f76784b$var$pad($4eoc2.utcThursday.count((0, $4eoc2.utcYear)(d), d) + ((0, $4eoc2.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $3d35b2967f76784b$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $3d35b2967f76784b$var$formatUTCWeekNumberMonday(d, p) {
    return $3d35b2967f76784b$var$pad($4eoc2.utcMonday.count((0, $4eoc2.utcYear)(d) - 1, d), p, 2);
}
function $3d35b2967f76784b$var$formatUTCYear(d, p) {
    return $3d35b2967f76784b$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $3d35b2967f76784b$var$formatUTCYearISO(d, p) {
    d = $3d35b2967f76784b$var$UTCdISO(d);
    return $3d35b2967f76784b$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $3d35b2967f76784b$var$formatUTCFullYear(d, p) {
    return $3d35b2967f76784b$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $3d35b2967f76784b$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $4eoc2.utcThursday)(d) : $4eoc2.utcThursday.ceil(d);
    return $3d35b2967f76784b$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $3d35b2967f76784b$var$formatUTCZone() {
    return "+0000";
}
function $3d35b2967f76784b$var$formatLiteralPercent() {
    return "%";
}
function $3d35b2967f76784b$var$formatUnixTimestamp(d) {
    return +d;
}
function $3d35b2967f76784b$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("eVDyw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $nxI7I = parcelRequire("nxI7I");
var $ade51283aba1deef$var$isoSpecifier = module.exports.isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
function $ade51283aba1deef$var$formatIsoNative(date) {
    return date.toISOString();
}
var $ade51283aba1deef$var$formatIso = Date.prototype.toISOString ? $ade51283aba1deef$var$formatIsoNative : (0, $nxI7I.utcFormat)($ade51283aba1deef$var$isoSpecifier);
var $ade51283aba1deef$var$_default = module.exports.default = $ade51283aba1deef$var$formatIso;

});

parcelRegister("6PG0U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eVDyw = parcelRequire("eVDyw");

var $nxI7I = parcelRequire("nxI7I");
function $4f981889d5d1db58$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $4f981889d5d1db58$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $4f981889d5d1db58$var$parseIsoNative : (0, $nxI7I.utcParse)($eVDyw.isoSpecifier);
var $4f981889d5d1db58$var$_default = module.exports.default = $4f981889d5d1db58$var$parseIso;

});



parcelRegister("eJySu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aba052a8dbead0a7$var$utcTime;

var $4eoc2 = parcelRequire("4eoc2");

var $jjF9F = parcelRequire("jjF9F");

var $gp5UL = parcelRequire("gp5UL");

var $9Ob92 = parcelRequire("9Ob92");
function $aba052a8dbead0a7$var$utcTime() {
    return $9Ob92.initRange.apply((0, $gp5UL.calendar)($4eoc2.utcTicks, $4eoc2.utcTickInterval, $4eoc2.utcYear, $4eoc2.utcMonth, $4eoc2.utcWeek, $4eoc2.utcDay, $4eoc2.utcHour, $4eoc2.utcMinute, $4eoc2.utcSecond, $jjF9F.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("dY6Rv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $a2b6339ffadce509$var$copy;
module.exports.default = $a2b6339ffadce509$var$sequential;
module.exports.sequentialLog = $a2b6339ffadce509$var$sequentialLog;
module.exports.sequentialPow = $a2b6339ffadce509$var$sequentialPow;
module.exports.sequentialSqrt = $a2b6339ffadce509$var$sequentialSqrt;
module.exports.sequentialSymlog = $a2b6339ffadce509$var$sequentialSymlog;

var $cbrvd = parcelRequire("cbrvd");

var $g3aux = parcelRequire("g3aux");

var $9Ob92 = parcelRequire("9Ob92");

var $kQSTd = parcelRequire("kQSTd");

var $HKIoj = parcelRequire("HKIoj");

var $6teXX = parcelRequire("6teXX");

var $7veUS = parcelRequire("7veUS");
function $a2b6339ffadce509$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $g3aux.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($cbrvd.interpolate);
    scale.rangeRound = range($cbrvd.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $a2b6339ffadce509$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $a2b6339ffadce509$var$sequential() {
    var scale = (0, $kQSTd.linearish)($a2b6339ffadce509$var$transformer()($g3aux.identity));
    scale.copy = function() {
        return $a2b6339ffadce509$var$copy(scale, $a2b6339ffadce509$var$sequential());
    };
    return $9Ob92.initInterpolator.apply(scale, arguments);
}
function $a2b6339ffadce509$var$sequentialLog() {
    var scale = (0, $HKIoj.loggish)($a2b6339ffadce509$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $a2b6339ffadce509$var$copy(scale, $a2b6339ffadce509$var$sequentialLog()).base(scale.base());
    };
    return $9Ob92.initInterpolator.apply(scale, arguments);
}
function $a2b6339ffadce509$var$sequentialSymlog() {
    var scale = (0, $6teXX.symlogish)($a2b6339ffadce509$var$transformer());
    scale.copy = function() {
        return $a2b6339ffadce509$var$copy(scale, $a2b6339ffadce509$var$sequentialSymlog()).constant(scale.constant());
    };
    return $9Ob92.initInterpolator.apply(scale, arguments);
}
function $a2b6339ffadce509$var$sequentialPow() {
    var scale = (0, $7veUS.powish)($a2b6339ffadce509$var$transformer());
    scale.copy = function() {
        return $a2b6339ffadce509$var$copy(scale, $a2b6339ffadce509$var$sequentialPow()).exponent(scale.exponent());
    };
    return $9Ob92.initInterpolator.apply(scale, arguments);
}
function $a2b6339ffadce509$var$sequentialSqrt() {
    return $a2b6339ffadce509$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("dqIdP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9c7001a98955b5ce$var$sequentialQuantile;

var $dCoBu = parcelRequire("dCoBu");

var $g3aux = parcelRequire("g3aux");

var $9Ob92 = parcelRequire("9Ob92");
function $9c7001a98955b5ce$var$sequentialQuantile() {
    var domain = [], interpolator = $g3aux.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $dCoBu.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($dCoBu.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $dCoBu.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $9c7001a98955b5ce$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $9Ob92.initInterpolator.apply(scale, arguments);
}

});

parcelRegister("5BnxQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4142abfce83a84c7$var$diverging;
module.exports.divergingLog = $4142abfce83a84c7$var$divergingLog;
module.exports.divergingPow = $4142abfce83a84c7$var$divergingPow;
module.exports.divergingSqrt = $4142abfce83a84c7$var$divergingSqrt;
module.exports.divergingSymlog = $4142abfce83a84c7$var$divergingSymlog;

var $cbrvd = parcelRequire("cbrvd");

var $g3aux = parcelRequire("g3aux");

var $9Ob92 = parcelRequire("9Ob92");

var $kQSTd = parcelRequire("kQSTd");

var $HKIoj = parcelRequire("HKIoj");

var $dY6Rv = parcelRequire("dY6Rv");

var $6teXX = parcelRequire("6teXX");

var $7veUS = parcelRequire("7veUS");
function $4142abfce83a84c7$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $g3aux.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $cbrvd.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($cbrvd.interpolate);
    scale.rangeRound = range($cbrvd.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $4142abfce83a84c7$var$diverging() {
    var scale = (0, $kQSTd.linearish)($4142abfce83a84c7$var$transformer()($g3aux.identity));
    scale.copy = function() {
        return (0, $dY6Rv.copy)(scale, $4142abfce83a84c7$var$diverging());
    };
    return $9Ob92.initInterpolator.apply(scale, arguments);
}
function $4142abfce83a84c7$var$divergingLog() {
    var scale = (0, $HKIoj.loggish)($4142abfce83a84c7$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $dY6Rv.copy)(scale, $4142abfce83a84c7$var$divergingLog()).base(scale.base());
    };
    return $9Ob92.initInterpolator.apply(scale, arguments);
}
function $4142abfce83a84c7$var$divergingSymlog() {
    var scale = (0, $6teXX.symlogish)($4142abfce83a84c7$var$transformer());
    scale.copy = function() {
        return (0, $dY6Rv.copy)(scale, $4142abfce83a84c7$var$divergingSymlog()).constant(scale.constant());
    };
    return $9Ob92.initInterpolator.apply(scale, arguments);
}
function $4142abfce83a84c7$var$divergingPow() {
    var scale = (0, $7veUS.powish)($4142abfce83a84c7$var$transformer());
    scale.copy = function() {
        return (0, $dY6Rv.copy)(scale, $4142abfce83a84c7$var$divergingPow()).exponent(scale.exponent());
    };
    return $9Ob92.initInterpolator.apply(scale, arguments);
}
function $4142abfce83a84c7$var$divergingSqrt() {
    return $4142abfce83a84c7$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



parcelRegister("3KrT2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5z71N = parcelRequire("5z71N");

var $f9z2B = parcelRequire("f9z2B");

var $jChQZ = parcelRequire("jChQZ");

var $N0M37 = parcelRequire("N0M37");
function $2bab4cae4ff6cc95$var$uniqBy(array, iteratee$1 = $f9z2B.identity) {
    if (!$jChQZ.isArrayLikeObject(array)) return [];
    return $5z71N.uniqBy(Array.from(array), $N0M37.iteratee(iteratee$1));
}
module.exports.uniqBy = $2bab4cae4ff6cc95$var$uniqBy;

});
parcelRegister("5z71N", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $40d5ac3c09acfdd4$var$uniqBy(arr, mapper) {
    const map = new Map();
    for(let i = 0; i < arr.length; i++){
        const item = arr[i];
        const key = mapper(item);
        if (!map.has(key)) map.set(key, item);
    }
    return Array.from(map.values());
}
module.exports.uniqBy = $40d5ac3c09acfdd4$var$uniqBy;

});

parcelRegister("f9z2B", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $b082e0ae28f3d2cf$var$identity(x) {
    return x;
}
module.exports.identity = $b082e0ae28f3d2cf$var$identity;

});

parcelRegister("jChQZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gW2Uh = parcelRequire("gW2Uh");

var $iT9Cm = parcelRequire("iT9Cm");
function $e47f6a4d863539aa$var$isArrayLikeObject(value) {
    return $iT9Cm.isObjectLike(value) && $gW2Uh.isArrayLike(value);
}
module.exports.isArrayLikeObject = $e47f6a4d863539aa$var$isArrayLikeObject;

});
parcelRegister("iT9Cm", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $dc04d2f04bcb5c3d$var$isObjectLike(value) {
    return typeof value === 'object' && value !== null;
}
module.exports.isObjectLike = $dc04d2f04bcb5c3d$var$isObjectLike;

});


parcelRegister("N0M37", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f9z2B = parcelRequire("f9z2B");

var $6sPBN = parcelRequire("6sPBN");

var $iqLgp = parcelRequire("iqLgp");

var $1ikYz = parcelRequire("1ikYz");
function $09352d6a97c5a8bc$var$iteratee(value) {
    if (value == null) return $f9z2B.identity;
    switch(typeof value){
        case 'function':
            return value;
        case 'object':
            if (Array.isArray(value) && value.length === 2) return $1ikYz.matchesProperty(value[0], value[1]);
            return $iqLgp.matches(value);
        case 'string':
        case 'symbol':
        case 'number':
            return $6sPBN.property(value);
    }
}
module.exports.iteratee = $09352d6a97c5a8bc$var$iteratee;

});
parcelRegister("6sPBN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $a3kJd = parcelRequire("a3kJd");
function $4b4d63fa7499c54d$var$property(path) {
    return function(object) {
        return $a3kJd.get(object, path);
    };
}
module.exports.property = $4b4d63fa7499c54d$var$property;

});

parcelRegister("iqLgp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k27MX = parcelRequire("k27MX");

var $5OQ25 = parcelRequire("5OQ25");
function $d6af514523dc63c9$var$matches(source) {
    source = $5OQ25.cloneDeep(source);
    return (target)=>{
        return $k27MX.isMatch(target, source);
    };
}
module.exports.matches = $d6af514523dc63c9$var$matches;

});
parcelRegister("k27MX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4qsmU = parcelRequire("4qsmU");
function $e95a093bf1123b62$var$isMatch(target, source) {
    return $4qsmU.isMatchWith(target, source, ()=>undefined);
}
module.exports.isMatch = $e95a093bf1123b62$var$isMatch;

});
parcelRegister("4qsmU", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9lVSp = parcelRequire("9lVSp");

var $a2U6b = parcelRequire("a2U6b");

var $lksYT = parcelRequire("lksYT");
function $338f988b4da9634d$var$isMatchWith(target, source, compare) {
    if (typeof compare !== 'function') return $338f988b4da9634d$var$isMatchWith(target, source, ()=>undefined);
    return $338f988b4da9634d$var$isMatchWithInternal(target, source, function doesMatch(objValue, srcValue, key, object, source, stack) {
        const isEqual = compare(objValue, srcValue, key, object, source, stack);
        if (isEqual !== undefined) return Boolean(isEqual);
        return $338f988b4da9634d$var$isMatchWithInternal(objValue, srcValue, doesMatch, stack);
    }, new Map());
}
function $338f988b4da9634d$var$isMatchWithInternal(target, source, compare, stack) {
    if (source === target) return true;
    switch(typeof source){
        case 'object':
            return $338f988b4da9634d$var$isObjectMatch(target, source, compare, stack);
        case 'function':
            {
                const sourceKeys = Object.keys(source);
                if (sourceKeys.length > 0) return $338f988b4da9634d$var$isMatchWithInternal(target, {
                    ...source
                }, compare, stack);
                return $lksYT.eq(target, source);
            }
        default:
            if (!$9lVSp.isObject(target)) return $lksYT.eq(target, source);
            if (typeof source === 'string') return source === '';
            return true;
    }
}
function $338f988b4da9634d$var$isObjectMatch(target, source, compare, stack) {
    if (source == null) return true;
    if (Array.isArray(source)) return $338f988b4da9634d$var$isArrayMatch(target, source, compare, stack);
    if (source instanceof Map) return $338f988b4da9634d$var$isMapMatch(target, source, compare, stack);
    if (source instanceof Set) return $338f988b4da9634d$var$isSetMatch(target, source, compare, stack);
    const keys = Object.keys(source);
    if (target == null || $a2U6b.isPrimitive(target)) return keys.length === 0;
    if (keys.length === 0) return true;
    if (stack?.has(source)) return stack.get(source) === target;
    stack?.set(source, target);
    try {
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            if (!$a2U6b.isPrimitive(target) && !(key in target)) return false;
            if (source[key] === undefined && target[key] !== undefined) return false;
            if (source[key] === null && target[key] !== null) return false;
            const isEqual = compare(target[key], source[key], key, target, source, stack);
            if (!isEqual) return false;
        }
        return true;
    } finally{
        stack?.delete(source);
    }
}
function $338f988b4da9634d$var$isMapMatch(target, source, compare, stack) {
    if (source.size === 0) return true;
    if (!(target instanceof Map)) return false;
    for (const [key, sourceValue] of source.entries()){
        const targetValue = target.get(key);
        const isEqual = compare(targetValue, sourceValue, key, target, source, stack);
        if (isEqual === false) return false;
    }
    return true;
}
function $338f988b4da9634d$var$isArrayMatch(target, source, compare, stack) {
    if (source.length === 0) return true;
    if (!Array.isArray(target)) return false;
    const countedIndex = new Set();
    for(let i = 0; i < source.length; i++){
        const sourceItem = source[i];
        let found = false;
        for(let j = 0; j < target.length; j++){
            if (countedIndex.has(j)) continue;
            const targetItem = target[j];
            let matches = false;
            const isEqual = compare(targetItem, sourceItem, i, target, source, stack);
            if (isEqual) matches = true;
            if (matches) {
                countedIndex.add(j);
                found = true;
                break;
            }
        }
        if (!found) return false;
    }
    return true;
}
function $338f988b4da9634d$var$isSetMatch(target, source, compare, stack) {
    if (source.size === 0) return true;
    if (!(target instanceof Set)) return false;
    return $338f988b4da9634d$var$isArrayMatch([
        ...target
    ], [
        ...source
    ], compare, stack);
}
module.exports.isMatchWith = $338f988b4da9634d$var$isMatchWith;
module.exports.isSetMatch = $338f988b4da9634d$var$isSetMatch;

});
parcelRegister("a2U6b", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $75059b51d4b48083$var$isPrimitive(value) {
    return value == null || typeof value !== 'object' && typeof value !== 'function';
}
module.exports.isPrimitive = $75059b51d4b48083$var$isPrimitive;

});



parcelRegister("5OQ25", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lurqo = parcelRequire("lurqo");
function $43c9fbdfe1aa854a$var$cloneDeep(obj) {
    return $lurqo.cloneDeepWithImpl(obj, undefined, obj, new Map(), undefined);
}
module.exports.cloneDeep = $43c9fbdfe1aa854a$var$cloneDeep;

});
parcelRegister("lurqo", function(module, exports) {

var $4kMtH = parcelRequire("4kMtH");
var $fa51ac4e7348ad4c$require$Buffer = $4kMtH.Buffer;
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hHVRA = parcelRequire("hHVRA");

var $iPeRm = parcelRequire("iPeRm");

var $cOXRD = parcelRequire("cOXRD");

var $a2U6b = parcelRequire("a2U6b");

var $8lWya = parcelRequire("8lWya");
function $fa51ac4e7348ad4c$var$cloneDeepWith(obj, cloneValue) {
    return $fa51ac4e7348ad4c$var$cloneDeepWithImpl(obj, undefined, obj, new Map(), cloneValue);
}
function $fa51ac4e7348ad4c$var$cloneDeepWithImpl(valueToClone, keyToClone, objectToClone, stack = new Map(), cloneValue) {
    const cloned = cloneValue?.(valueToClone, keyToClone, objectToClone, stack);
    if (cloned !== undefined) return cloned;
    if ($a2U6b.isPrimitive(valueToClone)) return valueToClone;
    if (stack.has(valueToClone)) return stack.get(valueToClone);
    if (Array.isArray(valueToClone)) {
        const result = new Array(valueToClone.length);
        stack.set(valueToClone, result);
        for(let i = 0; i < valueToClone.length; i++)result[i] = $fa51ac4e7348ad4c$var$cloneDeepWithImpl(valueToClone[i], i, objectToClone, stack, cloneValue);
        if (Object.hasOwn(valueToClone, 'index')) result.index = valueToClone.index;
        if (Object.hasOwn(valueToClone, 'input')) result.input = valueToClone.input;
        return result;
    }
    if (valueToClone instanceof Date) return new Date(valueToClone.getTime());
    if (valueToClone instanceof RegExp) {
        const result = new RegExp(valueToClone.source, valueToClone.flags);
        result.lastIndex = valueToClone.lastIndex;
        return result;
    }
    if (valueToClone instanceof Map) {
        const result = new Map();
        stack.set(valueToClone, result);
        for (const [key, value] of valueToClone)result.set(key, $fa51ac4e7348ad4c$var$cloneDeepWithImpl(value, key, objectToClone, stack, cloneValue));
        return result;
    }
    if (valueToClone instanceof Set) {
        const result = new Set();
        stack.set(valueToClone, result);
        for (const value of valueToClone)result.add($fa51ac4e7348ad4c$var$cloneDeepWithImpl(value, undefined, objectToClone, stack, cloneValue));
        return result;
    }
    if (typeof $fa51ac4e7348ad4c$require$Buffer !== 'undefined' && $fa51ac4e7348ad4c$require$Buffer.isBuffer(valueToClone)) return valueToClone.subarray();
    if ($8lWya.isTypedArray(valueToClone)) {
        const result = new (Object.getPrototypeOf(valueToClone)).constructor(valueToClone.length);
        stack.set(valueToClone, result);
        for(let i = 0; i < valueToClone.length; i++)result[i] = $fa51ac4e7348ad4c$var$cloneDeepWithImpl(valueToClone[i], i, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof ArrayBuffer || typeof SharedArrayBuffer !== 'undefined' && valueToClone instanceof SharedArrayBuffer) return valueToClone.slice(0);
    if (valueToClone instanceof DataView) {
        const result = new DataView(valueToClone.buffer.slice(0), valueToClone.byteOffset, valueToClone.byteLength);
        stack.set(valueToClone, result);
        $fa51ac4e7348ad4c$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof File !== 'undefined' && valueToClone instanceof File) {
        const result = new File([
            valueToClone
        ], valueToClone.name, {
            type: valueToClone.type
        });
        stack.set(valueToClone, result);
        $fa51ac4e7348ad4c$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof Blob !== 'undefined' && valueToClone instanceof Blob) {
        const result = new Blob([
            valueToClone
        ], {
            type: valueToClone.type
        });
        stack.set(valueToClone, result);
        $fa51ac4e7348ad4c$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Error) {
        const result = new valueToClone.constructor();
        stack.set(valueToClone, result);
        result.message = valueToClone.message;
        result.name = valueToClone.name;
        result.stack = valueToClone.stack;
        result.cause = valueToClone.cause;
        $fa51ac4e7348ad4c$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Boolean) {
        const result = new Boolean(valueToClone.valueOf());
        stack.set(valueToClone, result);
        $fa51ac4e7348ad4c$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Number) {
        const result = new Number(valueToClone.valueOf());
        stack.set(valueToClone, result);
        $fa51ac4e7348ad4c$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof String) {
        const result = new String(valueToClone.valueOf());
        stack.set(valueToClone, result);
        $fa51ac4e7348ad4c$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof valueToClone === 'object' && $fa51ac4e7348ad4c$var$isCloneableObject(valueToClone)) {
        const result = Object.create(Object.getPrototypeOf(valueToClone));
        stack.set(valueToClone, result);
        $fa51ac4e7348ad4c$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    return valueToClone;
}
function $fa51ac4e7348ad4c$var$copyProperties(target, source, objectToClone = target, stack, cloneValue) {
    const keys = [
        ...Object.keys(source),
        ...$hHVRA.getSymbols(source)
    ];
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const descriptor = Object.getOwnPropertyDescriptor(target, key);
        if (descriptor == null || descriptor.writable) target[key] = $fa51ac4e7348ad4c$var$cloneDeepWithImpl(source[key], key, objectToClone, stack, cloneValue);
    }
}
function $fa51ac4e7348ad4c$var$isCloneableObject(object) {
    switch($iPeRm.getTag(object)){
        case $cOXRD.argumentsTag:
        case $cOXRD.arrayTag:
        case $cOXRD.arrayBufferTag:
        case $cOXRD.dataViewTag:
        case $cOXRD.booleanTag:
        case $cOXRD.dateTag:
        case $cOXRD.float32ArrayTag:
        case $cOXRD.float64ArrayTag:
        case $cOXRD.int8ArrayTag:
        case $cOXRD.int16ArrayTag:
        case $cOXRD.int32ArrayTag:
        case $cOXRD.mapTag:
        case $cOXRD.numberTag:
        case $cOXRD.objectTag:
        case $cOXRD.regexpTag:
        case $cOXRD.setTag:
        case $cOXRD.stringTag:
        case $cOXRD.symbolTag:
        case $cOXRD.uint8ArrayTag:
        case $cOXRD.uint8ClampedArrayTag:
        case $cOXRD.uint16ArrayTag:
        case $cOXRD.uint32ArrayTag:
            return true;
        default:
            return false;
    }
}
module.exports.cloneDeepWith = $fa51ac4e7348ad4c$var$cloneDeepWith;
module.exports.cloneDeepWithImpl = $fa51ac4e7348ad4c$var$cloneDeepWithImpl;
module.exports.copyProperties = $fa51ac4e7348ad4c$var$copyProperties;

});
parcelRegister("4kMtH", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $327ea26eaec35123$export$a143d493d941bafc, (v) => $327ea26eaec35123$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $327ea26eaec35123$export$f99ded8fe4b79145, (v) => $327ea26eaec35123$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $327ea26eaec35123$export$a143d493d941bafc;
var $327ea26eaec35123$export$e4cf37d7f6fb9e0a;
var $327ea26eaec35123$export$f99ded8fe4b79145;
var $327ea26eaec35123$export$599f31c3813fae4d;
'use strict';

var $8WSYN = parcelRequire("8WSYN");

var $k2vw5 = parcelRequire("k2vw5");
const $327ea26eaec35123$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$327ea26eaec35123$export$a143d493d941bafc = $327ea26eaec35123$var$Buffer;
$327ea26eaec35123$export$e4cf37d7f6fb9e0a = $327ea26eaec35123$var$SlowBuffer;
$327ea26eaec35123$export$f99ded8fe4b79145 = 50;
const $327ea26eaec35123$var$K_MAX_LENGTH = 0x7fffffff;
$327ea26eaec35123$export$599f31c3813fae4d = $327ea26eaec35123$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $327ea26eaec35123$var$Buffer.TYPED_ARRAY_SUPPORT = $327ea26eaec35123$var$typedArraySupport();
if (!$327ea26eaec35123$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $327ea26eaec35123$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($327ea26eaec35123$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$327ea26eaec35123$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($327ea26eaec35123$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$327ea26eaec35123$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $327ea26eaec35123$var$createBuffer(length) {
    if (length > $327ea26eaec35123$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $327ea26eaec35123$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $327ea26eaec35123$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $327ea26eaec35123$var$allocUnsafe(arg);
    }
    return $327ea26eaec35123$var$from(arg, encodingOrOffset, length);
}
$327ea26eaec35123$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $327ea26eaec35123$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $327ea26eaec35123$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $327ea26eaec35123$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($327ea26eaec35123$var$isInstance(value, ArrayBuffer) || value && $327ea26eaec35123$var$isInstance(value.buffer, ArrayBuffer)) return $327ea26eaec35123$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($327ea26eaec35123$var$isInstance(value, SharedArrayBuffer) || value && $327ea26eaec35123$var$isInstance(value.buffer, SharedArrayBuffer))) return $327ea26eaec35123$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $327ea26eaec35123$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $327ea26eaec35123$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $327ea26eaec35123$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $327ea26eaec35123$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $327ea26eaec35123$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($327ea26eaec35123$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($327ea26eaec35123$var$Buffer, Uint8Array);
function $327ea26eaec35123$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $327ea26eaec35123$var$alloc(size, fill, encoding) {
    $327ea26eaec35123$var$assertSize(size);
    if (size <= 0) return $327ea26eaec35123$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $327ea26eaec35123$var$createBuffer(size).fill(fill, encoding) : $327ea26eaec35123$var$createBuffer(size).fill(fill);
    return $327ea26eaec35123$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $327ea26eaec35123$var$Buffer.alloc = function(size, fill, encoding) {
    return $327ea26eaec35123$var$alloc(size, fill, encoding);
};
function $327ea26eaec35123$var$allocUnsafe(size) {
    $327ea26eaec35123$var$assertSize(size);
    return $327ea26eaec35123$var$createBuffer(size < 0 ? 0 : $327ea26eaec35123$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $327ea26eaec35123$var$Buffer.allocUnsafe = function(size) {
    return $327ea26eaec35123$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $327ea26eaec35123$var$Buffer.allocUnsafeSlow = function(size) {
    return $327ea26eaec35123$var$allocUnsafe(size);
};
function $327ea26eaec35123$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$327ea26eaec35123$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $327ea26eaec35123$var$byteLength(string, encoding) | 0;
    let buf = $327ea26eaec35123$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $327ea26eaec35123$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $327ea26eaec35123$var$checked(array.length) | 0;
    const buf = $327ea26eaec35123$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $327ea26eaec35123$var$fromArrayView(arrayView) {
    if ($327ea26eaec35123$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $327ea26eaec35123$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $327ea26eaec35123$var$fromArrayLike(arrayView);
}
function $327ea26eaec35123$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $327ea26eaec35123$var$Buffer.prototype);
    return buf;
}
function $327ea26eaec35123$var$fromObject(obj) {
    if ($327ea26eaec35123$var$Buffer.isBuffer(obj)) {
        const len = $327ea26eaec35123$var$checked(obj.length) | 0;
        const buf = $327ea26eaec35123$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $327ea26eaec35123$var$numberIsNaN(obj.length)) return $327ea26eaec35123$var$createBuffer(0);
        return $327ea26eaec35123$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $327ea26eaec35123$var$fromArrayLike(obj.data);
}
function $327ea26eaec35123$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $327ea26eaec35123$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $327ea26eaec35123$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $327ea26eaec35123$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $327ea26eaec35123$var$Buffer.alloc(+length);
}
$327ea26eaec35123$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $327ea26eaec35123$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$327ea26eaec35123$var$Buffer.compare = function compare(a, b) {
    if ($327ea26eaec35123$var$isInstance(a, Uint8Array)) a = $327ea26eaec35123$var$Buffer.from(a, a.offset, a.byteLength);
    if ($327ea26eaec35123$var$isInstance(b, Uint8Array)) b = $327ea26eaec35123$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$327ea26eaec35123$var$Buffer.isBuffer(a) || !$327ea26eaec35123$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$327ea26eaec35123$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$327ea26eaec35123$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $327ea26eaec35123$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $327ea26eaec35123$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($327ea26eaec35123$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$327ea26eaec35123$var$Buffer.isBuffer(buf)) buf = $327ea26eaec35123$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$327ea26eaec35123$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $327ea26eaec35123$var$byteLength(string, encoding) {
    if ($327ea26eaec35123$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $327ea26eaec35123$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $327ea26eaec35123$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $327ea26eaec35123$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $327ea26eaec35123$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$327ea26eaec35123$var$Buffer.byteLength = $327ea26eaec35123$var$byteLength;
function $327ea26eaec35123$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $327ea26eaec35123$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $327ea26eaec35123$var$utf8Slice(this, start, end);
        case 'ascii':
            return $327ea26eaec35123$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $327ea26eaec35123$var$latin1Slice(this, start, end);
        case 'base64':
            return $327ea26eaec35123$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $327ea26eaec35123$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$327ea26eaec35123$var$Buffer.prototype._isBuffer = true;
function $327ea26eaec35123$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$327ea26eaec35123$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$327ea26eaec35123$var$swap(this, i, i + 1);
    return this;
};
$327ea26eaec35123$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $327ea26eaec35123$var$swap(this, i, i + 3);
        $327ea26eaec35123$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$327ea26eaec35123$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $327ea26eaec35123$var$swap(this, i, i + 7);
        $327ea26eaec35123$var$swap(this, i + 1, i + 6);
        $327ea26eaec35123$var$swap(this, i + 2, i + 5);
        $327ea26eaec35123$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$327ea26eaec35123$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $327ea26eaec35123$var$utf8Slice(this, 0, length);
    return $327ea26eaec35123$var$slowToString.apply(this, arguments);
};
$327ea26eaec35123$var$Buffer.prototype.toLocaleString = $327ea26eaec35123$var$Buffer.prototype.toString;
$327ea26eaec35123$var$Buffer.prototype.equals = function equals(b) {
    if (!$327ea26eaec35123$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $327ea26eaec35123$var$Buffer.compare(this, b) === 0;
};
$327ea26eaec35123$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $327ea26eaec35123$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($327ea26eaec35123$var$customInspectSymbol) $327ea26eaec35123$var$Buffer.prototype[$327ea26eaec35123$var$customInspectSymbol] = $327ea26eaec35123$var$Buffer.prototype.inspect;
$327ea26eaec35123$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($327ea26eaec35123$var$isInstance(target, Uint8Array)) target = $327ea26eaec35123$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$327ea26eaec35123$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $327ea26eaec35123$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($327ea26eaec35123$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $327ea26eaec35123$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($327ea26eaec35123$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $327ea26eaec35123$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $327ea26eaec35123$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $327ea26eaec35123$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$327ea26eaec35123$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$327ea26eaec35123$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $327ea26eaec35123$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$327ea26eaec35123$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $327ea26eaec35123$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $327ea26eaec35123$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($327ea26eaec35123$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $327ea26eaec35123$var$utf8Write(buf, string, offset, length) {
    return $327ea26eaec35123$var$blitBuffer($327ea26eaec35123$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $327ea26eaec35123$var$asciiWrite(buf, string, offset, length) {
    return $327ea26eaec35123$var$blitBuffer($327ea26eaec35123$var$asciiToBytes(string), buf, offset, length);
}
function $327ea26eaec35123$var$base64Write(buf, string, offset, length) {
    return $327ea26eaec35123$var$blitBuffer($327ea26eaec35123$var$base64ToBytes(string), buf, offset, length);
}
function $327ea26eaec35123$var$ucs2Write(buf, string, offset, length) {
    return $327ea26eaec35123$var$blitBuffer($327ea26eaec35123$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$327ea26eaec35123$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $327ea26eaec35123$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $327ea26eaec35123$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $327ea26eaec35123$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $327ea26eaec35123$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $327ea26eaec35123$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$327ea26eaec35123$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $327ea26eaec35123$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $8WSYN.fromByteArray(buf);
    else return $8WSYN.fromByteArray(buf.slice(start, end));
}
function $327ea26eaec35123$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $327ea26eaec35123$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $327ea26eaec35123$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $327ea26eaec35123$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $327ea26eaec35123$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $327ea26eaec35123$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $327ea26eaec35123$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $327ea26eaec35123$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $327ea26eaec35123$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $327ea26eaec35123$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $327ea26eaec35123$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$327ea26eaec35123$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $327ea26eaec35123$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $327ea26eaec35123$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$327ea26eaec35123$var$Buffer.prototype.readUintLE = $327ea26eaec35123$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$327ea26eaec35123$var$Buffer.prototype.readUintBE = $327ea26eaec35123$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$327ea26eaec35123$var$Buffer.prototype.readUint8 = $327ea26eaec35123$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$327ea26eaec35123$var$Buffer.prototype.readUint16LE = $327ea26eaec35123$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$327ea26eaec35123$var$Buffer.prototype.readUint16BE = $327ea26eaec35123$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$327ea26eaec35123$var$Buffer.prototype.readUint32LE = $327ea26eaec35123$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$327ea26eaec35123$var$Buffer.prototype.readUint32BE = $327ea26eaec35123$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$327ea26eaec35123$var$Buffer.prototype.readBigUInt64LE = $327ea26eaec35123$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $327ea26eaec35123$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $327ea26eaec35123$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$327ea26eaec35123$var$Buffer.prototype.readBigUInt64BE = $327ea26eaec35123$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $327ea26eaec35123$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $327ea26eaec35123$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$327ea26eaec35123$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$327ea26eaec35123$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$327ea26eaec35123$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$327ea26eaec35123$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$327ea26eaec35123$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$327ea26eaec35123$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$327ea26eaec35123$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$327ea26eaec35123$var$Buffer.prototype.readBigInt64LE = $327ea26eaec35123$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $327ea26eaec35123$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $327ea26eaec35123$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$327ea26eaec35123$var$Buffer.prototype.readBigInt64BE = $327ea26eaec35123$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $327ea26eaec35123$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $327ea26eaec35123$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$327ea26eaec35123$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkOffset(offset, 4, this.length);
    return $k2vw5.read(this, offset, true, 23, 4);
};
$327ea26eaec35123$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkOffset(offset, 4, this.length);
    return $k2vw5.read(this, offset, false, 23, 4);
};
$327ea26eaec35123$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkOffset(offset, 8, this.length);
    return $k2vw5.read(this, offset, true, 52, 8);
};
$327ea26eaec35123$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkOffset(offset, 8, this.length);
    return $k2vw5.read(this, offset, false, 52, 8);
};
function $327ea26eaec35123$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$327ea26eaec35123$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$327ea26eaec35123$var$Buffer.prototype.writeUintLE = $327ea26eaec35123$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $327ea26eaec35123$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$327ea26eaec35123$var$Buffer.prototype.writeUintBE = $327ea26eaec35123$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $327ea26eaec35123$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$327ea26eaec35123$var$Buffer.prototype.writeUint8 = $327ea26eaec35123$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$327ea26eaec35123$var$Buffer.prototype.writeUint16LE = $327ea26eaec35123$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$327ea26eaec35123$var$Buffer.prototype.writeUint16BE = $327ea26eaec35123$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$327ea26eaec35123$var$Buffer.prototype.writeUint32LE = $327ea26eaec35123$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$327ea26eaec35123$var$Buffer.prototype.writeUint32BE = $327ea26eaec35123$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $327ea26eaec35123$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $327ea26eaec35123$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $327ea26eaec35123$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $327ea26eaec35123$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$327ea26eaec35123$var$Buffer.prototype.writeBigUInt64LE = $327ea26eaec35123$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $327ea26eaec35123$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$327ea26eaec35123$var$Buffer.prototype.writeBigUInt64BE = $327ea26eaec35123$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $327ea26eaec35123$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$327ea26eaec35123$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $327ea26eaec35123$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$327ea26eaec35123$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $327ea26eaec35123$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$327ea26eaec35123$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$327ea26eaec35123$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$327ea26eaec35123$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$327ea26eaec35123$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$327ea26eaec35123$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$327ea26eaec35123$var$Buffer.prototype.writeBigInt64LE = $327ea26eaec35123$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $327ea26eaec35123$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$327ea26eaec35123$var$Buffer.prototype.writeBigInt64BE = $327ea26eaec35123$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $327ea26eaec35123$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $327ea26eaec35123$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $327ea26eaec35123$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $k2vw5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$327ea26eaec35123$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $327ea26eaec35123$var$writeFloat(this, value, offset, true, noAssert);
};
$327ea26eaec35123$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $327ea26eaec35123$var$writeFloat(this, value, offset, false, noAssert);
};
function $327ea26eaec35123$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $327ea26eaec35123$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $k2vw5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$327ea26eaec35123$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $327ea26eaec35123$var$writeDouble(this, value, offset, true, noAssert);
};
$327ea26eaec35123$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $327ea26eaec35123$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$327ea26eaec35123$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$327ea26eaec35123$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$327ea26eaec35123$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$327ea26eaec35123$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $327ea26eaec35123$var$Buffer.isBuffer(val) ? val : $327ea26eaec35123$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $327ea26eaec35123$var$errors = {};
function $327ea26eaec35123$var$E(sym, getMessage, Base) {
    $327ea26eaec35123$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$327ea26eaec35123$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$327ea26eaec35123$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$327ea26eaec35123$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $327ea26eaec35123$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $327ea26eaec35123$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $327ea26eaec35123$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $327ea26eaec35123$var$checkBounds(buf, offset, byteLength) {
    $327ea26eaec35123$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $327ea26eaec35123$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $327ea26eaec35123$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $327ea26eaec35123$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $327ea26eaec35123$var$checkBounds(buf, offset, byteLength);
}
function $327ea26eaec35123$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $327ea26eaec35123$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $327ea26eaec35123$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $327ea26eaec35123$var$validateNumber(value, type);
        throw new $327ea26eaec35123$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $327ea26eaec35123$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $327ea26eaec35123$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $327ea26eaec35123$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $327ea26eaec35123$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($327ea26eaec35123$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $327ea26eaec35123$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $327ea26eaec35123$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $327ea26eaec35123$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $327ea26eaec35123$var$base64ToBytes(str) {
    return $8WSYN.toByteArray($327ea26eaec35123$var$base64clean(str));
}
function $327ea26eaec35123$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $327ea26eaec35123$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $327ea26eaec35123$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $327ea26eaec35123$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $327ea26eaec35123$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $327ea26eaec35123$var$BufferBigIntNotDefined : fn;
}
function $327ea26eaec35123$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("8WSYN", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $683e635093889a60$export$d622b2ad8d90c771, (v) => $683e635093889a60$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $683e635093889a60$export$6100ba28696e12de, (v) => $683e635093889a60$export$6100ba28696e12de = v);
var $683e635093889a60$export$a48f0734ac7c2329;
var $683e635093889a60$export$d622b2ad8d90c771;
var $683e635093889a60$export$6100ba28696e12de;
'use strict';
$683e635093889a60$export$a48f0734ac7c2329 = $683e635093889a60$var$byteLength;
$683e635093889a60$export$d622b2ad8d90c771 = $683e635093889a60$var$toByteArray;
$683e635093889a60$export$6100ba28696e12de = $683e635093889a60$var$fromByteArray;
var $683e635093889a60$var$lookup = [];
var $683e635093889a60$var$revLookup = [];
var $683e635093889a60$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $683e635093889a60$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $683e635093889a60$var$i = 0, $683e635093889a60$var$len = $683e635093889a60$var$code.length; $683e635093889a60$var$i < $683e635093889a60$var$len; ++$683e635093889a60$var$i){
    $683e635093889a60$var$lookup[$683e635093889a60$var$i] = $683e635093889a60$var$code[$683e635093889a60$var$i];
    $683e635093889a60$var$revLookup[$683e635093889a60$var$code.charCodeAt($683e635093889a60$var$i)] = $683e635093889a60$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$683e635093889a60$var$revLookup['-'.charCodeAt(0)] = 62;
$683e635093889a60$var$revLookup['_'.charCodeAt(0)] = 63;
function $683e635093889a60$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $683e635093889a60$var$byteLength(b64) {
    var lens = $683e635093889a60$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $683e635093889a60$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $683e635093889a60$var$toByteArray(b64) {
    var tmp;
    var lens = $683e635093889a60$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $683e635093889a60$var$Arr($683e635093889a60$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $683e635093889a60$var$revLookup[b64.charCodeAt(i)] << 18 | $683e635093889a60$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $683e635093889a60$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $683e635093889a60$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $683e635093889a60$var$revLookup[b64.charCodeAt(i)] << 2 | $683e635093889a60$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $683e635093889a60$var$revLookup[b64.charCodeAt(i)] << 10 | $683e635093889a60$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $683e635093889a60$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $683e635093889a60$var$tripletToBase64(num) {
    return $683e635093889a60$var$lookup[num >> 18 & 0x3F] + $683e635093889a60$var$lookup[num >> 12 & 0x3F] + $683e635093889a60$var$lookup[num >> 6 & 0x3F] + $683e635093889a60$var$lookup[num & 0x3F];
}
function $683e635093889a60$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($683e635093889a60$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $683e635093889a60$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($683e635093889a60$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($683e635093889a60$var$lookup[tmp >> 2] + $683e635093889a60$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($683e635093889a60$var$lookup[tmp >> 10] + $683e635093889a60$var$lookup[tmp >> 4 & 0x3F] + $683e635093889a60$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("k2vw5", function(module, exports) {

$parcel$export(module.exports, "read", () => $e96c711422587624$export$aafa59e2e03f2942, (v) => $e96c711422587624$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $e96c711422587624$export$68d8715fc104d294, (v) => $e96c711422587624$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $e96c711422587624$export$aafa59e2e03f2942;
var $e96c711422587624$export$68d8715fc104d294;
$e96c711422587624$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$e96c711422587624$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("hHVRA", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $ce43564594f6a709$var$getSymbols(object) {
    return Object.getOwnPropertySymbols(object).filter((symbol)=>Object.prototype.propertyIsEnumerable.call(object, symbol));
}
module.exports.getSymbols = $ce43564594f6a709$var$getSymbols;

});

parcelRegister("iPeRm", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $db488438b0113ed0$var$getTag(value) {
    if (value == null) return value === undefined ? '[object Undefined]' : '[object Null]';
    return Object.prototype.toString.call(value);
}
module.exports.getTag = $db488438b0113ed0$var$getTag;

});

parcelRegister("cOXRD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $9558974ca9877456$var$regexpTag = '[object RegExp]';
const $9558974ca9877456$var$stringTag = '[object String]';
const $9558974ca9877456$var$numberTag = '[object Number]';
const $9558974ca9877456$var$booleanTag = '[object Boolean]';
const $9558974ca9877456$var$argumentsTag = '[object Arguments]';
const $9558974ca9877456$var$symbolTag = '[object Symbol]';
const $9558974ca9877456$var$dateTag = '[object Date]';
const $9558974ca9877456$var$mapTag = '[object Map]';
const $9558974ca9877456$var$setTag = '[object Set]';
const $9558974ca9877456$var$arrayTag = '[object Array]';
const $9558974ca9877456$var$functionTag = '[object Function]';
const $9558974ca9877456$var$arrayBufferTag = '[object ArrayBuffer]';
const $9558974ca9877456$var$objectTag = '[object Object]';
const $9558974ca9877456$var$errorTag = '[object Error]';
const $9558974ca9877456$var$dataViewTag = '[object DataView]';
const $9558974ca9877456$var$uint8ArrayTag = '[object Uint8Array]';
const $9558974ca9877456$var$uint8ClampedArrayTag = '[object Uint8ClampedArray]';
const $9558974ca9877456$var$uint16ArrayTag = '[object Uint16Array]';
const $9558974ca9877456$var$uint32ArrayTag = '[object Uint32Array]';
const $9558974ca9877456$var$bigUint64ArrayTag = '[object BigUint64Array]';
const $9558974ca9877456$var$int8ArrayTag = '[object Int8Array]';
const $9558974ca9877456$var$int16ArrayTag = '[object Int16Array]';
const $9558974ca9877456$var$int32ArrayTag = '[object Int32Array]';
const $9558974ca9877456$var$bigInt64ArrayTag = '[object BigInt64Array]';
const $9558974ca9877456$var$float32ArrayTag = '[object Float32Array]';
const $9558974ca9877456$var$float64ArrayTag = '[object Float64Array]';
module.exports.argumentsTag = $9558974ca9877456$var$argumentsTag;
module.exports.arrayBufferTag = $9558974ca9877456$var$arrayBufferTag;
module.exports.arrayTag = $9558974ca9877456$var$arrayTag;
module.exports.bigInt64ArrayTag = $9558974ca9877456$var$bigInt64ArrayTag;
module.exports.bigUint64ArrayTag = $9558974ca9877456$var$bigUint64ArrayTag;
module.exports.booleanTag = $9558974ca9877456$var$booleanTag;
module.exports.dataViewTag = $9558974ca9877456$var$dataViewTag;
module.exports.dateTag = $9558974ca9877456$var$dateTag;
module.exports.errorTag = $9558974ca9877456$var$errorTag;
module.exports.float32ArrayTag = $9558974ca9877456$var$float32ArrayTag;
module.exports.float64ArrayTag = $9558974ca9877456$var$float64ArrayTag;
module.exports.functionTag = $9558974ca9877456$var$functionTag;
module.exports.int16ArrayTag = $9558974ca9877456$var$int16ArrayTag;
module.exports.int32ArrayTag = $9558974ca9877456$var$int32ArrayTag;
module.exports.int8ArrayTag = $9558974ca9877456$var$int8ArrayTag;
module.exports.mapTag = $9558974ca9877456$var$mapTag;
module.exports.numberTag = $9558974ca9877456$var$numberTag;
module.exports.objectTag = $9558974ca9877456$var$objectTag;
module.exports.regexpTag = $9558974ca9877456$var$regexpTag;
module.exports.setTag = $9558974ca9877456$var$setTag;
module.exports.stringTag = $9558974ca9877456$var$stringTag;
module.exports.symbolTag = $9558974ca9877456$var$symbolTag;
module.exports.uint16ArrayTag = $9558974ca9877456$var$uint16ArrayTag;
module.exports.uint32ArrayTag = $9558974ca9877456$var$uint32ArrayTag;
module.exports.uint8ArrayTag = $9558974ca9877456$var$uint8ArrayTag;
module.exports.uint8ClampedArrayTag = $9558974ca9877456$var$uint8ClampedArrayTag;

});

parcelRegister("8lWya", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $614db3b452928e35$var$isTypedArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}
module.exports.isTypedArray = $614db3b452928e35$var$isTypedArray;

});




parcelRegister("1ikYz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k27MX = parcelRequire("k27MX");

var $bVJk9 = parcelRequire("bVJk9");

var $i63qw = parcelRequire("i63qw");

var $a3kJd = parcelRequire("a3kJd");

var $dnbSj = parcelRequire("dnbSj");
function $0f17be40b456b95a$var$matchesProperty(property, source) {
    switch(typeof property){
        case 'object':
            if (Object.is(property?.valueOf(), -0)) property = '-0';
            break;
        case 'number':
            property = $bVJk9.toKey(property);
            break;
    }
    source = $i63qw.cloneDeep(source);
    return function(target) {
        const result = $a3kJd.get(target, property);
        if (result === undefined) return $dnbSj.has(target, property);
        if (source === undefined) return result === undefined;
        return $k27MX.isMatch(result, source);
    };
}
module.exports.matchesProperty = $0f17be40b456b95a$var$matchesProperty;

});
parcelRegister("i63qw", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dkEXx = parcelRequire("dkEXx");
function $d2cb720a41edfcf9$var$cloneDeep(obj) {
    return $dkEXx.cloneDeepWith(obj);
}
module.exports.cloneDeep = $d2cb720a41edfcf9$var$cloneDeep;

});
parcelRegister("dkEXx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lurqo = parcelRequire("lurqo");

var $cOXRD = parcelRequire("cOXRD");
function $9b4cea4492c487dd$var$cloneDeepWith(obj, customizer) {
    return $lurqo.cloneDeepWith(obj, (value, key, object, stack)=>{
        const cloned = customizer?.(value, key, object, stack);
        if (cloned !== undefined) return cloned;
        if (typeof obj !== 'object') return undefined;
        switch(Object.prototype.toString.call(obj)){
            case $cOXRD.numberTag:
            case $cOXRD.stringTag:
            case $cOXRD.booleanTag:
                {
                    const result = new obj.constructor(obj?.valueOf());
                    $lurqo.copyProperties(result, obj);
                    return result;
                }
            case $cOXRD.argumentsTag:
                {
                    const result = {};
                    $lurqo.copyProperties(result, obj);
                    result.length = obj.length;
                    result[Symbol.iterator] = obj[Symbol.iterator];
                    return result;
                }
            default:
                return undefined;
        }
    });
}
module.exports.cloneDeepWith = $9b4cea4492c487dd$var$cloneDeepWith;

});


parcelRegister("dnbSj", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hHxQD = parcelRequire("hHxQD");

var $i6g8Z = parcelRequire("i6g8Z");

var $7GLEg = parcelRequire("7GLEg");

var $26KlG = parcelRequire("26KlG");
function $9bc6a2788a98c3d0$var$has(object, path) {
    let resolvedPath;
    if (Array.isArray(path)) resolvedPath = path;
    else if (typeof path === 'string' && $hHxQD.isDeepKey(path) && object?.[path] == null) resolvedPath = $26KlG.toPath(path);
    else resolvedPath = [
        path
    ];
    if (resolvedPath.length === 0) return false;
    let current = object;
    for(let i = 0; i < resolvedPath.length; i++){
        const key = resolvedPath[i];
        if (current == null || !Object.hasOwn(current, key)) {
            const isSparseIndex = (Array.isArray(current) || $7GLEg.isArguments(current)) && $i6g8Z.isIndex(key) && key < current.length;
            if (!isSparseIndex) return false;
        }
        current = current[key];
    }
    return true;
}
module.exports.has = $9bc6a2788a98c3d0$var$has;

});
parcelRegister("7GLEg", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iPeRm = parcelRequire("iPeRm");
function $59916a9f5d59e3dd$var$isArguments(value) {
    return value !== null && typeof value === 'object' && $iPeRm.getTag(value) === '[object Arguments]';
}
module.exports.isArguments = $59916a9f5d59e3dd$var$isArguments;

});





parcelRegister("9bufC", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gOCEg = parcelRequire("gOCEg");

var $iLGN8 = parcelRequire("iLGN8");

var $gW2Uh = parcelRequire("gW2Uh");
function $6afc9b5b6f020fef$var$last(array) {
    if (!$gW2Uh.isArrayLike(array)) return undefined;
    return $gOCEg.last($iLGN8.toArray(array));
}
module.exports.last = $6afc9b5b6f020fef$var$last;

});
parcelRegister("gOCEg", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $c3df4ba49301fcdb$var$last(arr) {
    return arr[arr.length - 1];
}
module.exports.last = $c3df4ba49301fcdb$var$last;

});

parcelRegister("iLGN8", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $da9dcf4d082284c3$var$toArray(value) {
    return Array.isArray(value) ? value : Array.from(value);
}
module.exports.toArray = $da9dcf4d082284c3$var$toArray;

});


parcelRegister("8gzRo", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $604ba2736ce656ef$var$isPlainObject(object) {
    if (typeof object !== 'object') return false;
    if (object == null) return false;
    if (Object.getPrototypeOf(object) === null) return true;
    if (Object.prototype.toString.call(object) !== '[object Object]') {
        const tag = object[Symbol.toStringTag];
        if (tag == null) return false;
        const isTagReadonly = !Object.getOwnPropertyDescriptor(object, Symbol.toStringTag)?.writable;
        if (isTagReadonly) return false;
        return object.toString() === `[object ${tag}]`;
    }
    let proto = object;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(object) === proto;
}
module.exports.isPlainObject = $604ba2736ce656ef$var$isPlainObject;

});

parcelRegister("84KgJ", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $5e12967e929e6aaf$export$bf730a2d8bf68b42, (v) => $5e12967e929e6aaf$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5e12967e929e6aaf$export$bf730a2d8bf68b42;
"use strict";

var $28UcW = parcelRequire("28UcW");
function $5e12967e929e6aaf$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $5e12967e929e6aaf$var$objectIs = "function" === typeof Object.is ? Object.is : $5e12967e929e6aaf$var$is, $5e12967e929e6aaf$var$useSyncExternalStore = $28UcW.useSyncExternalStore, $5e12967e929e6aaf$var$useRef = $28UcW.useRef, $5e12967e929e6aaf$var$useEffect = $28UcW.useEffect, $5e12967e929e6aaf$var$useMemo = $28UcW.useMemo, $5e12967e929e6aaf$var$useDebugValue = $28UcW.useDebugValue;
$5e12967e929e6aaf$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $5e12967e929e6aaf$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $5e12967e929e6aaf$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($5e12967e929e6aaf$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $5e12967e929e6aaf$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $5e12967e929e6aaf$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $5e12967e929e6aaf$var$useDebugValue(value);
    return value;
};

});


var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");
var $f7655ee7f8b44636$export$882461b6382ed46c;
var $f7655ee7f8b44636$export$757ceba2d55c277e;
'use strict';
var $ac717a3ef8959bc0$exports = {};
'use strict';
function $ac717a3ef8959bc0$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($ac717a3ef8959bc0$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$ac717a3ef8959bc0$var$checkDCE();

$ac717a3ef8959bc0$exports = (parcelRequire("bHOev"));


var $f7655ee7f8b44636$var$i;
$f7655ee7f8b44636$export$882461b6382ed46c = $ac717a3ef8959bc0$exports.createRoot;
$f7655ee7f8b44636$export$757ceba2d55c277e = $ac717a3ef8959bc0$exports.hydrateRoot;




var $4XrX4 = parcelRequire("4XrX4");
/* eslint-disable @typescript-eslint/unbound-method */ 
var $bunH6 = parcelRequire("bunH6");
var $7740633108eec54d$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["None"] = 0] = "None";
    LogLevel[LogLevel["Error"] = 1] = "Error";
    LogLevel[LogLevel["Warn"] = 2] = "Warn";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Debug"] = 4] = "Debug";
})($7740633108eec54d$export$243e62d78d3b544d || ($7740633108eec54d$export$243e62d78d3b544d = {}));


var $18f2db3fc8eec36d$export$da8ad5017022fc09 = function(ignoreDepth) {
    if (ignoreDepth === void 0) ignoreDepth = 0;
    var trace = new Error().stack || '';
    return trace.split('\n').slice(2 + ignoreDepth).map(function(text) {
        return text.trim();
    });
};
var $18f2db3fc8eec36d$export$c24a266b7d0d4b26 = function(client) {
    return function() {
        var _a = (0, $bunH6.__assign)({}, client.config), logger = _a.loggerProvider, logLevel = _a.logLevel;
        return {
            logger: logger,
            logLevel: logLevel
        };
    };
};
var $18f2db3fc8eec36d$export$a7dcfccadff29f0 = function(obj, path) {
    var e_1, _a;
    path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    path = path.replace(/^\./, ''); // strip a leading dot
    try {
        for(var _b = (0, $bunH6.__values)(path.split('.')), _c = _b.next(); !_c.done; _c = _b.next()){
            var attr = _c.value;
            if (attr in obj) obj = obj[attr];
            else return;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return obj;
};
var $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9 = function(client, paths) {
    return function() {
        var e_2, _a;
        var res = {};
        try {
            for(var paths_1 = (0, $bunH6.__values)(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
                var path = paths_1_1.value;
                res[path] = $18f2db3fc8eec36d$export$a7dcfccadff29f0(client, path);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return res;
    };
};
var $18f2db3fc8eec36d$export$bd4b394e2747b144 = function(fn, fnName, getLogConfig, getStates, fnContext) {
    if (fnContext === void 0) fnContext = null;
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _a = getLogConfig(), logger = _a.logger, logLevel = _a.logLevel;
        // return early if possible to reduce overhead
        if (logLevel && logLevel < (0, $7740633108eec54d$export$243e62d78d3b544d).Debug || !logLevel || !logger) return fn.apply(fnContext, args);
        var debugContext = {
            type: 'invoke public method',
            name: fnName,
            args: args,
            stacktrace: $18f2db3fc8eec36d$export$da8ad5017022fc09(1),
            time: {
                start: new Date().toISOString()
            },
            states: {}
        };
        if (getStates && debugContext.states) debugContext.states.before = getStates();
        var result = fn.apply(fnContext, args);
        if (result && result.promise) // if result is a promise, add the callback
        result.promise.then(function() {
            if (getStates && debugContext.states) debugContext.states.after = getStates();
            if (debugContext.time) debugContext.time.end = new Date().toISOString();
            logger.debug(JSON.stringify(debugContext, null, 2));
        });
        else {
            if (getStates && debugContext.states) debugContext.states.after = getStates();
            if (debugContext.time) debugContext.time.end = new Date().toISOString();
            logger.debug(JSON.stringify(debugContext, null, 2));
        }
        return result;
    };
};



var $bunH6 = parcelRequire("bunH6");

var $bunH6 = parcelRequire("bunH6");
var $b1034e6ea0b84810$export$6df138c24303c801;
(function(IdentifyOperation) {
    // Base Operations to set values
    IdentifyOperation["SET"] = "$set";
    IdentifyOperation["SET_ONCE"] = "$setOnce";
    // Operations around modifying existing values
    IdentifyOperation["ADD"] = "$add";
    IdentifyOperation["APPEND"] = "$append";
    IdentifyOperation["PREPEND"] = "$prepend";
    IdentifyOperation["REMOVE"] = "$remove";
    // Operations around appending values *if* they aren't present
    IdentifyOperation["PREINSERT"] = "$preInsert";
    IdentifyOperation["POSTINSERT"] = "$postInsert";
    // Operations around removing properties/values
    IdentifyOperation["UNSET"] = "$unset";
    IdentifyOperation["CLEAR_ALL"] = "$clearAll";
})($b1034e6ea0b84810$export$6df138c24303c801 || ($b1034e6ea0b84810$export$6df138c24303c801 = {}));
var $b1034e6ea0b84810$export$6221d17ecafe3bf9;
(function(SpecialEventType) {
    SpecialEventType["IDENTIFY"] = "$identify";
    SpecialEventType["GROUP_IDENTIFY"] = "$groupidentify";
    SpecialEventType["REVENUE"] = "revenue_amount";
})($b1034e6ea0b84810$export$6221d17ecafe3bf9 || ($b1034e6ea0b84810$export$6221d17ecafe3bf9 = {}));



var $bunH6 = parcelRequire("bunH6");
var $c1d7ad7f2bf46bfb$export$a3f337ba59dc3dca = '-';
var $c1d7ad7f2bf46bfb$export$34512634d73abf96 = 'AMP';
var $c1d7ad7f2bf46bfb$export$7cc65d02ca2e18ec = "".concat($c1d7ad7f2bf46bfb$export$34512634d73abf96, "_unsent");
var $c1d7ad7f2bf46bfb$export$beb3c3946c248b94 = '$default_instance';
var $c1d7ad7f2bf46bfb$export$29e80e090bc2cfd4 = 'https://api2.amplitude.com/2/httpapi';
var $c1d7ad7f2bf46bfb$export$2fcb1c10f7306bcf = 'https://api.eu.amplitude.com/2/httpapi';
var $c1d7ad7f2bf46bfb$export$c567544fea55e004 = 'https://api2.amplitude.com/batch';
var $c1d7ad7f2bf46bfb$export$68967a892545fca0 = 'https://api.eu.amplitude.com/batch';
var $c1d7ad7f2bf46bfb$export$926599dcfe1d591d = 'utm_campaign';
var $c1d7ad7f2bf46bfb$export$76cba99ea272772 = 'utm_content';
var $c1d7ad7f2bf46bfb$export$5061a1cefb237161 = 'utm_id';
var $c1d7ad7f2bf46bfb$export$a6f5c6056c876f92 = 'utm_medium';
var $c1d7ad7f2bf46bfb$export$f7522a6e1839b3b9 = 'utm_source';
var $c1d7ad7f2bf46bfb$export$74173cb2cd2c2b01 = 'utm_term';
var $c1d7ad7f2bf46bfb$export$d7046fa8a8c432a0 = 'dclid';
var $c1d7ad7f2bf46bfb$export$bee91738abba7f50 = 'fbclid';
var $c1d7ad7f2bf46bfb$export$bba55cdc82bf1e23 = 'gbraid';
var $c1d7ad7f2bf46bfb$export$d72e6377dae42b4f = 'gclid';
var $c1d7ad7f2bf46bfb$export$9ed7c4aa246186b5 = 'ko_click_id';
var $c1d7ad7f2bf46bfb$export$e495e049f5a59ccc = 'li_fat_id';
var $c1d7ad7f2bf46bfb$export$f912492c0955f678 = 'msclkid';
var $c1d7ad7f2bf46bfb$export$f1d48c95a869863d = 'rdt_cid';
var $c1d7ad7f2bf46bfb$export$89d66d2933b92df = 'ttclid';
var $c1d7ad7f2bf46bfb$export$856b82f6063e22ef = 'twclid';
var $c1d7ad7f2bf46bfb$export$b5b43be4e547ddd3 = 'wbraid';
var $c1d7ad7f2bf46bfb$export$4c723243179776e1 = 'EMPTY';
var $c1d7ad7f2bf46bfb$export$ea7354d30dfda3a2 = {
    utm_campaign: undefined,
    utm_content: undefined,
    utm_id: undefined,
    utm_medium: undefined,
    utm_source: undefined,
    utm_term: undefined,
    referrer: undefined,
    referring_domain: undefined,
    dclid: undefined,
    gbraid: undefined,
    gclid: undefined,
    fbclid: undefined,
    ko_click_id: undefined,
    li_fat_id: undefined,
    msclkid: undefined,
    rdt_cid: undefined,
    ttclid: undefined,
    twclid: undefined,
    wbraid: undefined
};
var $c1d7ad7f2bf46bfb$export$8ee5ccb4ef82a40e = 'MKTG';
var $c1d7ad7f2bf46bfb$export$a52b450c7f480d9a = [
    'access-control-allow-origin',
    'access-control-allow-credentials',
    'access-control-expose-headers',
    'access-control-max-age',
    'access-control-allow-methods',
    'access-control-allow-headers',
    'accept-patch',
    'accept-ranges',
    'age',
    'allow',
    'alt-svc',
    'cache-control',
    'connection',
    'content-disposition',
    'content-encoding',
    'content-language',
    'content-length',
    'content-location',
    'content-md5',
    'content-range',
    'content-type',
    'date',
    'delta-base',
    'etag',
    'expires',
    'im',
    'last-modified',
    'link',
    'location',
    'permanent',
    'p3p',
    'pragma',
    'proxy-authenticate',
    'public-key-pins',
    'retry-after',
    'server',
    'status',
    'strict-transport-security',
    'trailer',
    'transfer-encoding',
    'tk',
    'upgrade',
    'vary',
    'via',
    'warning',
    'www-authenticate',
    'x-b3-traceid',
    'x-frame-options'
];
var $c1d7ad7f2bf46bfb$export$ac363e6ffe994c89 = [
    'authorization',
    'cookie',
    'set-cookie'
];



var $bunH6 = parcelRequire("bunH6");
var $502327478cd826cd$var$MAX_PROPERTY_KEYS = 1000;
var $502327478cd826cd$export$16a0268bc22b47b0 = function(properties) {
    if (Object.keys(properties).length > $502327478cd826cd$var$MAX_PROPERTY_KEYS) return false;
    for(var key in properties){
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        var value = properties[key];
        if (!$502327478cd826cd$export$194dd9a8a66065f3(key, value)) return false;
    }
    return true;
};
var $502327478cd826cd$export$194dd9a8a66065f3 = function(property, value) {
    var e_1, _a;
    if (typeof property !== 'string') return false;
    if (Array.isArray(value)) {
        var isValid = true;
        try {
            for(var value_1 = (0, $bunH6.__values)(value), value_1_1 = value_1.next(); !value_1_1.done; value_1_1 = value_1.next()){
                var valueElement = value_1_1.value;
                if (Array.isArray(valueElement)) return false;
                else if (typeof valueElement === 'object') isValid = isValid && $502327478cd826cd$export$16a0268bc22b47b0(valueElement);
                else if (![
                    'number',
                    'string'
                ].includes(typeof valueElement)) return false;
                if (!isValid) return false;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (value_1_1 && !value_1_1.done && (_a = value_1.return)) _a.call(value_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    } else if (value === null || value === undefined) return false;
    else if (typeof value === 'object') // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return $502327478cd826cd$export$16a0268bc22b47b0(value);
    else if (![
        'number',
        'string',
        'boolean'
    ].includes(typeof value)) return false;
    return true;
};


var $643b81d8570b18c7$export$e513146db6535bff = /** @class */ function() {
    function Identify() {
        this._propertySet = new Set();
        this._properties = {};
    }
    Identify.prototype.getUserProperties = function() {
        return (0, $bunH6.__assign)({}, this._properties);
    };
    Identify.prototype.set = function(property, value) {
        this._safeSet($643b81d8570b18c7$export$6df138c24303c801.SET, property, value);
        return this;
    };
    Identify.prototype.setOnce = function(property, value) {
        this._safeSet($643b81d8570b18c7$export$6df138c24303c801.SET_ONCE, property, value);
        return this;
    };
    Identify.prototype.append = function(property, value) {
        this._safeSet($643b81d8570b18c7$export$6df138c24303c801.APPEND, property, value);
        return this;
    };
    Identify.prototype.prepend = function(property, value) {
        this._safeSet($643b81d8570b18c7$export$6df138c24303c801.PREPEND, property, value);
        return this;
    };
    Identify.prototype.postInsert = function(property, value) {
        this._safeSet($643b81d8570b18c7$export$6df138c24303c801.POSTINSERT, property, value);
        return this;
    };
    Identify.prototype.preInsert = function(property, value) {
        this._safeSet($643b81d8570b18c7$export$6df138c24303c801.PREINSERT, property, value);
        return this;
    };
    Identify.prototype.remove = function(property, value) {
        this._safeSet($643b81d8570b18c7$export$6df138c24303c801.REMOVE, property, value);
        return this;
    };
    Identify.prototype.add = function(property, value) {
        this._safeSet($643b81d8570b18c7$export$6df138c24303c801.ADD, property, value);
        return this;
    };
    Identify.prototype.unset = function(property) {
        this._safeSet($643b81d8570b18c7$export$6df138c24303c801.UNSET, property, (0, $c1d7ad7f2bf46bfb$export$a3f337ba59dc3dca));
        return this;
    };
    Identify.prototype.clearAll = function() {
        // When clear all happens, all properties are unset. Reset the entire object.
        this._properties = {};
        this._properties[$643b81d8570b18c7$export$6df138c24303c801.CLEAR_ALL] = (0, $c1d7ad7f2bf46bfb$export$a3f337ba59dc3dca);
        return this;
    };
    // Returns whether or not this set actually worked.
    Identify.prototype._safeSet = function(operation, property, value) {
        if (this._validate(operation, property, value)) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            var userPropertyMap = this._properties[operation];
            if (userPropertyMap === undefined) {
                userPropertyMap = {};
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                this._properties[operation] = userPropertyMap;
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            userPropertyMap[property] = value;
            this._propertySet.add(property);
            return true;
        }
        return false;
    };
    Identify.prototype._validate = function(operation, property, value) {
        if (this._properties[$643b81d8570b18c7$export$6df138c24303c801.CLEAR_ALL] !== undefined) // clear all already set. Skipping operation;
        return false;
        if (this._propertySet.has(property)) // Property already used. Skipping operation
        return false;
        if (operation === $643b81d8570b18c7$export$6df138c24303c801.ADD) return typeof value === 'number';
        if (operation !== $643b81d8570b18c7$export$6df138c24303c801.UNSET && operation !== $643b81d8570b18c7$export$6df138c24303c801.REMOVE) return (0, $502327478cd826cd$export$194dd9a8a66065f3)(property, value);
        return true;
    };
    return Identify;
}();
var $643b81d8570b18c7$export$6df138c24303c801;
(function(IdentifyOperation) {
    // Base Operations to set values
    IdentifyOperation["SET"] = "$set";
    IdentifyOperation["SET_ONCE"] = "$setOnce";
    // Operations around modifying existing values
    IdentifyOperation["ADD"] = "$add";
    IdentifyOperation["APPEND"] = "$append";
    IdentifyOperation["PREPEND"] = "$prepend";
    IdentifyOperation["REMOVE"] = "$remove";
    // Operations around appending values *if* they aren't present
    IdentifyOperation["PREINSERT"] = "$preInsert";
    IdentifyOperation["POSTINSERT"] = "$postInsert";
    // Operations around removing properties/values
    IdentifyOperation["UNSET"] = "$unset";
    IdentifyOperation["CLEAR_ALL"] = "$clearAll";
})($643b81d8570b18c7$export$6df138c24303c801 || ($643b81d8570b18c7$export$6df138c24303c801 = {}));
var $643b81d8570b18c7$export$64d36bfa56d27e6a = [
    $643b81d8570b18c7$export$6df138c24303c801.CLEAR_ALL,
    $643b81d8570b18c7$export$6df138c24303c801.UNSET,
    $643b81d8570b18c7$export$6df138c24303c801.SET,
    $643b81d8570b18c7$export$6df138c24303c801.SET_ONCE,
    $643b81d8570b18c7$export$6df138c24303c801.ADD,
    $643b81d8570b18c7$export$6df138c24303c801.APPEND,
    $643b81d8570b18c7$export$6df138c24303c801.PREPEND,
    $643b81d8570b18c7$export$6df138c24303c801.PREINSERT,
    $643b81d8570b18c7$export$6df138c24303c801.POSTINSERT,
    $643b81d8570b18c7$export$6df138c24303c801.REMOVE
];


var $598aca23f12d68fa$export$5620dbefc1cb6f80 = 'Event tracked successfully';
var $598aca23f12d68fa$export$77be9b23e6f97080 = 'Unexpected error occurred';
var $598aca23f12d68fa$export$db21e8e2aba60c7d = 'Event rejected due to exceeded retry count';
var $598aca23f12d68fa$export$ce5d4f781e585e70 = 'Event skipped due to optOut config';
var $598aca23f12d68fa$export$9229755af3d7ecf1 = 'Event rejected due to missing API key';
var $598aca23f12d68fa$export$c20466bf93fe12d8 = 'Invalid API key';
var $598aca23f12d68fa$export$f9763d297affe1cc = 'Client not initialized';



var $bunH6 = parcelRequire("bunH6");
/** The status of an event. */ var $89a82e180a05067f$export$96e9906d6d93a972;
(function(Status) {
    /** The status could not be determined. */ Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */ Status["Skipped"] = "skipped";
    /** The event was sent successfully. */ Status["Success"] = "success";
    /** A user or device in the payload is currently rate limited and should try again later. */ Status["RateLimit"] = "rate_limit";
    /** The sent payload was too large to be processed. */ Status["PayloadTooLarge"] = "payload_too_large";
    /** The event could not be processed. */ Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */ Status["Failed"] = "failed";
    /** a server or client side error occuring when a request takes too long and is cancelled */ Status["Timeout"] = "Timeout";
    /** NodeJS runtime environment error.. E.g. disconnected from network */ Status["SystemError"] = "SystemError";
})($89a82e180a05067f$export$96e9906d6d93a972 || ($89a82e180a05067f$export$96e9906d6d93a972 = {}));


var $c70cdb26bcb097d4$export$db0956ffc926ab6b = function(event, code, message) {
    if (code === void 0) code = 0;
    if (message === void 0) message = (0, $89a82e180a05067f$export$96e9906d6d93a972).Unknown;
    return {
        event: event,
        code: code,
        message: message
    };
};


/**
 * Source: [jed's gist's comment]{@link https://gist.github.com/jed/982883?permalink_comment_id=3223002#gistcomment-3223002}.
 * Returns a random v4 UUID of the form xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx,
 * where each x is replaced with a random hexadecimal digit from 0 to f, and
 * y is replaced with a random hexadecimal digit from 8 to b.
 * Used to generate UUIDs for deviceIds.
 * @private
 */ 
var $bunH6 = parcelRequire("bunH6");

var $c4xZ2 = parcelRequire("c4xZ2");
var $b8d06392fac4718b$var$legacyUUID = function(a) {
    return a // if the placeholder was passed, return
     ? (a ^ // unless b is 8,
    Math.random() * // in which case
    16 >> // a random number from
    a / 4 // 8 to 11
    ).toString(16) // in hexadecimal
     : (String(1e7) + // 10000000 +
    String(-1000) + // -1000 +
    String(-4000) + // -4000 +
    String(-8000) + // -80000000 +
    String(-100000000000) // -100000000000,
    ).replace(// replacing
    /[018]/g, $b8d06392fac4718b$export$bc35efed93511c4b);
};
var $b8d06392fac4718b$var$hex = (0, $bunH6.__spreadArray)([], (0, $bunH6.__read)(Array(256).keys()), false).map(function(index) {
    return index.toString(16).padStart(2, '0');
});
var $b8d06392fac4718b$export$bc35efed93511c4b = function(a) {
    var _a;
    var globalScope = (0, $c4xZ2.getGlobalScope)();
    /* istanbul ignore next */ if (!((_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.crypto) === null || _a === void 0 ? void 0 : _a.getRandomValues)) // Fallback to legacy UUID generation if crypto is not available
    return $b8d06392fac4718b$var$legacyUUID(a);
    var r = globalScope.crypto.getRandomValues(new Uint8Array(16));
    r[6] = r[6] & 0x0f | 0x40;
    r[8] = r[8] & 0x3f | 0x80;
    return (0, $bunH6.__spreadArray)([], (0, $bunH6.__read)(r.entries()), false).map(function(_a) {
        var _b = (0, $bunH6.__read)(_a, 2), index = _b[0], int = _b[1];
        return [
            4,
            6,
            8,
            10
        ].includes(index) ? "-".concat($b8d06392fac4718b$var$hex[int]) : $b8d06392fac4718b$var$hex[int];
    }).join('');
};


var $558fa1ce0cd017e6$export$e6a97ba2cae5bb94 = /** @class */ function() {
    function Timeline(client) {
        this.client = client;
        this.queue = [];
        // Flag to guarantee one schedule apply is running
        this.applying = false;
        // Flag indicates whether timeline is ready to process event
        // Events collected before timeline is ready will stay in the queue to be processed later
        this.plugins = [];
        this._optOutListeners = [];
    }
    Timeline.prototype.register = function(plugin, config) {
        var _a, _b;
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (this.plugins.some(function(existingPlugin) {
                            return existingPlugin.name === plugin.name;
                        })) {
                            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                            this.loggerProvider.warn("Plugin with name ".concat(plugin.name, " already exists, skipping registration"));
                            return [
                                2 /*return*/ 
                            ];
                        }
                        if (plugin.name === undefined) {
                            plugin.name = (0, $b8d06392fac4718b$export$bc35efed93511c4b)();
                            this.loggerProvider.warn("Plugin name is undefined. \n      Generating a random UUID for plugin name: ".concat(plugin.name, ". \n      Set a name for the plugin to prevent it from being added multiple times."));
                        }
                        plugin.type = (_a = plugin.type) !== null && _a !== void 0 ? _a : 'enrichment';
                        return [
                            4 /*yield*/ ,
                            (_b = plugin.setup) === null || _b === void 0 ? void 0 : _b.call(plugin, config, this.client)
                        ];
                    case 1:
                        _c.sent();
                        this.plugins.push(plugin);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Timeline.prototype.deregister = function(pluginName, config) {
        var _a;
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var index, plugin;
            return (0, $bunH6.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        index = this.plugins.findIndex(function(plugin) {
                            return plugin.name === pluginName;
                        });
                        if (index === -1) {
                            config.loggerProvider.warn("Plugin with name ".concat(pluginName, " does not exist, skipping deregistration"));
                            return [
                                2 /*return*/ 
                            ];
                        }
                        plugin = this.plugins[index];
                        this.plugins.splice(index, 1);
                        return [
                            4 /*yield*/ ,
                            (_a = plugin.teardown) === null || _a === void 0 ? void 0 : _a.call(plugin)
                        ];
                    case 1:
                        _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Timeline.prototype.reset = function(client) {
        this._clearOptOutListeners();
        this.applying = false;
        var plugins = this.plugins;
        plugins.map(function(plugin) {
            var _a;
            return (_a = plugin.teardown) === null || _a === void 0 ? void 0 : _a.call(plugin);
        });
        this.plugins = [];
        this.client = client;
    };
    Timeline.prototype.push = function(event) {
        var _this = this;
        return new Promise(function(resolve) {
            _this.queue.push([
                event,
                resolve
            ]);
            _this.scheduleApply(0);
        });
    };
    Timeline.prototype.scheduleApply = function(timeout) {
        var _this = this;
        if (this.applying) return;
        this.applying = true;
        setTimeout(function() {
            _this.apply(_this.queue.shift()).then(function() {
                _this.applying = false;
                if (_this.queue.length > 0) _this.scheduleApply(0);
            });
        }, timeout);
    };
    Timeline.prototype.apply = function(item) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var _a, event, _b, resolve, before, before_1, before_1_1, plugin, e, e_1_1, enrichment, enrichment_1, enrichment_1_1, plugin, e, e_2_1, destination, executeDestinations;
            var e_1, _c, e_2, _d;
            return (0, $bunH6.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        if (!item) return [
                            2 /*return*/ 
                        ];
                        _a = (0, $bunH6.__read)(item, 1), event = _a[0];
                        _b = (0, $bunH6.__read)(item, 2), resolve = _b[1];
                        // Log initial event
                        this.loggerProvider.log('Timeline.apply: Initial event', event);
                        before = this.plugins.filter(function(plugin) {
                            return plugin.type === 'before';
                        });
                        _e.label = 1;
                    case 1:
                        _e.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        before_1 = (0, $bunH6.__values)(before), before_1_1 = before_1.next();
                        _e.label = 2;
                    case 2:
                        if (!!before_1_1.done) return [
                            3 /*break*/ ,
                            5
                        ];
                        plugin = before_1_1.value;
                        /* istanbul ignore if */ if (!plugin.execute) // do nothing
                        return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            plugin.execute((0, $bunH6.__assign)({}, event))
                        ];
                    case 3:
                        e = _e.sent();
                        if (e === null) {
                            this.loggerProvider.log("Timeline.apply: Event filtered out by before plugin '".concat(String(plugin.name), "', event: ").concat(JSON.stringify(event)));
                            resolve({
                                event: event,
                                code: 0,
                                message: ''
                            });
                            return [
                                2 /*return*/ 
                            ];
                        } else {
                            event = e;
                            this.loggerProvider.log("Timeline.apply: Event after before plugin '".concat(String(plugin.name), "', event: ").concat(JSON.stringify(event)));
                        }
                        _e.label = 4;
                    case 4:
                        before_1_1 = before_1.next();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        e_1_1 = _e.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        try {
                            if (before_1_1 && !before_1_1.done && (_c = before_1.return)) _c.call(before_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 8:
                        enrichment = this.plugins.filter(function(plugin) {
                            return plugin.type === 'enrichment' || plugin.type === undefined;
                        });
                        _e.label = 9;
                    case 9:
                        _e.trys.push([
                            9,
                            14,
                            15,
                            16
                        ]);
                        enrichment_1 = (0, $bunH6.__values)(enrichment), enrichment_1_1 = enrichment_1.next();
                        _e.label = 10;
                    case 10:
                        if (!!enrichment_1_1.done) return [
                            3 /*break*/ ,
                            13
                        ];
                        plugin = enrichment_1_1.value;
                        /* istanbul ignore if */ if (!plugin.execute) // do nothing
                        return [
                            3 /*break*/ ,
                            12
                        ];
                        return [
                            4 /*yield*/ ,
                            plugin.execute((0, $bunH6.__assign)({}, event))
                        ];
                    case 11:
                        e = _e.sent();
                        if (e === null) {
                            this.loggerProvider.log("Timeline.apply: Event filtered out by enrichment plugin '".concat(String(plugin.name), "', event: ").concat(JSON.stringify(event)));
                            resolve({
                                event: event,
                                code: 0,
                                message: ''
                            });
                            return [
                                2 /*return*/ 
                            ];
                        } else {
                            event = e;
                            this.loggerProvider.log("Timeline.apply: Event after enrichment plugin '".concat(String(plugin.name), "', event: ").concat(JSON.stringify(event)));
                        }
                        _e.label = 12;
                    case 12:
                        enrichment_1_1 = enrichment_1.next();
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 13:
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 14:
                        e_2_1 = _e.sent();
                        e_2 = {
                            error: e_2_1
                        };
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 15:
                        try {
                            if (enrichment_1_1 && !enrichment_1_1.done && (_d = enrichment_1.return)) _d.call(enrichment_1);
                        } finally{
                            if (e_2) throw e_2.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 16:
                        destination = this.plugins.filter(function(plugin) {
                            return plugin.type === 'destination';
                        });
                        // Log final event before sending to destinations
                        this.loggerProvider.log("Timeline.apply: Final event before destinations, event: ".concat(JSON.stringify(event)));
                        executeDestinations = destination.map(function(plugin) {
                            var eventClone = (0, $bunH6.__assign)({}, event);
                            return plugin.execute(eventClone).catch(function(e) {
                                return (0, $c70cdb26bcb097d4$export$db0956ffc926ab6b)(eventClone, 0, String(e));
                            });
                        });
                        Promise.all(executeDestinations).then(function(_a) {
                            var _b = (0, $bunH6.__read)(_a, 1), result = _b[0];
                            var resolveResult = result || (0, $c70cdb26bcb097d4$export$db0956ffc926ab6b)(event, 100, 'Event not tracked, no destination plugins on the instance');
                            resolve(resolveResult);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Timeline.prototype.flush = function() {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var queue, destination, executeDestinations;
            var _this = this;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        queue = this.queue;
                        this.queue = [];
                        return [
                            4 /*yield*/ ,
                            Promise.all(queue.map(function(item) {
                                return _this.apply(item);
                            }))
                        ];
                    case 1:
                        _a.sent();
                        destination = this.plugins.filter(function(plugin) {
                            return plugin.type === 'destination';
                        });
                        executeDestinations = destination.map(function(plugin) {
                            return plugin.flush && plugin.flush();
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(executeDestinations)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Timeline.prototype.addOptOutListener = function(cb) {
        this._optOutListeners.push(cb);
    };
    Timeline.prototype._clearOptOutListeners = function() {
        this._optOutListeners = [];
    };
    Timeline.prototype.onIdentityChanged = function(identity) {
        this.plugins.forEach(function(plugin) {
            var _a;
            // Intentionally to not await plugin.onIdentityChanged() for non-blocking.
            // Ignore optional channing next line for test coverage.
            // If the plugin doesn't implement it, it won't be called.
            /* istanbul ignore next */ (_a = plugin.onIdentityChanged) === null || _a === void 0 || _a.call(plugin, identity);
        });
    };
    Timeline.prototype.onSessionIdChanged = function(sessionId) {
        this.plugins.forEach(function(plugin) {
            var _a;
            // Intentionally to not await plugin.onSessionIdChanged() for non-blocking.
            // Ignore optional channing next line for test coverage.
            // If the plugin doesn't implement it, it won't be called.
            /* istanbul ignore next */ (_a = plugin.onSessionIdChanged) === null || _a === void 0 || _a.call(plugin, sessionId);
        });
    };
    Timeline.prototype.onOptOutChanged = function(optOut) {
        this.plugins.forEach(function(plugin) {
            var _a;
            // Intentionally to not await plugin.onOptOutChanged() for non-blocking.
            // Ignore optional channing next line for test coverage.
            // If the plugin doesn't implement it, it won't be called.
            /* istanbul ignore next */ (_a = plugin.onOptOutChanged) === null || _a === void 0 || _a.call(plugin, optOut);
        });
        this._callOptOutListeners(optOut);
    };
    Timeline.prototype._callOptOutListeners = function(optOut) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var _a, _b, listener, e_3, e_4_1;
            var e_4, _c;
            return (0, $bunH6.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _d.trys.push([
                            0,
                            7,
                            8,
                            9
                        ]);
                        _a = (0, $bunH6.__values)(this._optOutListeners), _b = _a.next();
                        _d.label = 1;
                    case 1:
                        if (!!_b.done) return [
                            3 /*break*/ ,
                            6
                        ];
                        listener = _b.value;
                        _d.label = 2;
                    case 2:
                        _d.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            listener(optOut)
                        ];
                    case 3:
                        _d.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        e_3 = _d.sent();
                        /* istanbul ignore next */ this.loggerProvider.error('Error calling optOut listener', e_3);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        _b = _a.next();
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 6:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 7:
                        e_4_1 = _d.sent();
                        e_4 = {
                            error: e_4_1
                        };
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        } finally{
                            if (e_4) throw e_4.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Timeline.prototype.onReset = function() {
        this.plugins.forEach(function(plugin) {
            var _a;
            // Intentionally to not await plugin.onReset() for non-blocking.
            // Ignore optional channing next line for test coverage.
            // If the plugin doesn't implement it, it won't be called.
            /* istanbul ignore next */ (_a = plugin.onReset) === null || _a === void 0 || _a.call(plugin);
        });
    };
    return Timeline;
}();



var $bunH6 = parcelRequire("bunH6");


var $eba8dfa6a039f14d$export$8b3ed29dabd23a5 = function(eventInput, eventProperties, eventOptions) {
    var baseEvent = typeof eventInput === 'string' ? {
        event_type: eventInput
    } : eventInput;
    return (0, $bunH6.__assign)((0, $bunH6.__assign)((0, $bunH6.__assign)({}, baseEvent), eventOptions), eventProperties && {
        event_properties: eventProperties
    });
};
var $eba8dfa6a039f14d$export$5de4f5c2c4d8645f = function(identify, eventOptions) {
    var identifyEvent = (0, $bunH6.__assign)((0, $bunH6.__assign)({}, eventOptions), {
        event_type: (0, $b1034e6ea0b84810$export$6221d17ecafe3bf9).IDENTIFY,
        user_properties: identify.getUserProperties()
    });
    return identifyEvent;
};
var $eba8dfa6a039f14d$export$9e05e975377d0d22 = function(groupType, groupName, identify, eventOptions) {
    var _a;
    var groupIdentify = (0, $bunH6.__assign)((0, $bunH6.__assign)({}, eventOptions), {
        event_type: (0, $b1034e6ea0b84810$export$6221d17ecafe3bf9).GROUP_IDENTIFY,
        group_properties: identify.getUserProperties(),
        groups: (_a = {}, _a[groupType] = groupName, _a)
    });
    return groupIdentify;
};
var $eba8dfa6a039f14d$export$35c5433e5b45cb60 = function(groupType, groupName, eventOptions) {
    var _a;
    var identify = new (0, $643b81d8570b18c7$export$e513146db6535bff)();
    identify.set(groupType, groupName);
    var groupEvent = (0, $bunH6.__assign)((0, $bunH6.__assign)({}, eventOptions), {
        event_type: (0, $b1034e6ea0b84810$export$6221d17ecafe3bf9).IDENTIFY,
        user_properties: identify.getUserProperties(),
        groups: (_a = {}, _a[groupType] = groupName, _a)
    });
    return groupEvent;
};
var $eba8dfa6a039f14d$export$55f867c6c37376a8 = function(revenue, eventOptions) {
    return (0, $bunH6.__assign)((0, $bunH6.__assign)({}, eventOptions), {
        event_type: (0, $b1034e6ea0b84810$export$6221d17ecafe3bf9).REVENUE,
        event_properties: revenue.getEventProperties()
    });
};



var $31df937edadccc1a$export$a2bf1b09e40c274a = function(awaitable) {
    return {
        promise: awaitable || Promise.resolve()
    };
};


var $d4da969092b6408b$export$ca16f9ebcb935ab8 = /** @class */ function() {
    function AmplitudeCore(name) {
        if (name === void 0) name = '$default';
        this.initializing = false;
        this.isReady = false;
        this.q = [];
        this.dispatchQ = [];
        this.logEvent = this.track.bind(this);
        this.timeline = new (0, $558fa1ce0cd017e6$export$e6a97ba2cae5bb94)(this);
        this.name = name;
    }
    AmplitudeCore.prototype._init = function(config) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.config = config;
                        this.timeline.reset(this);
                        this.timeline.loggerProvider = this.config.loggerProvider;
                        return [
                            4 /*yield*/ ,
                            this.runQueuedFunctions('q')
                        ];
                    case 1:
                        _a.sent();
                        this.isReady = true;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AmplitudeCore.prototype.runQueuedFunctions = function(queueName) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var queuedFunctions, queuedFunctions_1, queuedFunctions_1_1, queuedFunction, val, e_1_1;
            var e_1, _a;
            return (0, $bunH6.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        queuedFunctions = this[queueName];
                        this[queueName] = [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            8,
                            9,
                            10
                        ]);
                        queuedFunctions_1 = (0, $bunH6.__values)(queuedFunctions), queuedFunctions_1_1 = queuedFunctions_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!queuedFunctions_1_1.done) return [
                            3 /*break*/ ,
                            7
                        ];
                        queuedFunction = queuedFunctions_1_1.value;
                        val = queuedFunction();
                        if (!(val && 'promise' in val)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            val.promise
                        ];
                    case 3:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            val
                        ];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        queuedFunctions_1_1 = queuedFunctions_1.next();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 8:
                        e_1_1 = _b.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        try {
                            if (queuedFunctions_1_1 && !queuedFunctions_1_1.done && (_a = queuedFunctions_1.return)) _a.call(queuedFunctions_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 10:
                        if (!this[queueName].length) return [
                            3 /*break*/ ,
                            12
                        ];
                        return [
                            4 /*yield*/ ,
                            this.runQueuedFunctions(queueName)
                        ];
                    case 11:
                        _b.sent();
                        _b.label = 12;
                    case 12:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AmplitudeCore.prototype.track = function(eventInput, eventProperties, eventOptions) {
        var event = (0, $eba8dfa6a039f14d$export$8b3ed29dabd23a5)(eventInput, eventProperties, eventOptions);
        // Update client user properties immediately and synchronously
        this.userProperties = this.getOperationAppliedUserProperties(event.user_properties);
        return (0, $31df937edadccc1a$export$a2bf1b09e40c274a)(this.dispatch(event));
    };
    AmplitudeCore.prototype.identify = function(identify, eventOptions) {
        var event = (0, $eba8dfa6a039f14d$export$5de4f5c2c4d8645f)(identify, eventOptions);
        // Update client user properties immediately and synchronously
        this.userProperties = this.getOperationAppliedUserProperties(event.user_properties);
        return (0, $31df937edadccc1a$export$a2bf1b09e40c274a)(this.dispatch(event));
    };
    AmplitudeCore.prototype.groupIdentify = function(groupType, groupName, identify, eventOptions) {
        var event = (0, $eba8dfa6a039f14d$export$9e05e975377d0d22)(groupType, groupName, identify, eventOptions);
        return (0, $31df937edadccc1a$export$a2bf1b09e40c274a)(this.dispatch(event));
    };
    AmplitudeCore.prototype.setGroup = function(groupType, groupName, eventOptions) {
        var event = (0, $eba8dfa6a039f14d$export$35c5433e5b45cb60)(groupType, groupName, eventOptions);
        // Update client user properties immediately and synchronously
        this.userProperties = this.getOperationAppliedUserProperties(event.user_properties);
        return (0, $31df937edadccc1a$export$a2bf1b09e40c274a)(this.dispatch(event));
    };
    AmplitudeCore.prototype.revenue = function(revenue, eventOptions) {
        var event = (0, $eba8dfa6a039f14d$export$55f867c6c37376a8)(revenue, eventOptions);
        return (0, $31df937edadccc1a$export$a2bf1b09e40c274a)(this.dispatch(event));
    };
    AmplitudeCore.prototype.add = function(plugin) {
        if (!this.isReady) {
            this.q.push(this._addPlugin.bind(this, plugin));
            return (0, $31df937edadccc1a$export$a2bf1b09e40c274a)();
        }
        return this._addPlugin(plugin);
    };
    AmplitudeCore.prototype._addPlugin = function(plugin) {
        return (0, $31df937edadccc1a$export$a2bf1b09e40c274a)(this.timeline.register(plugin, this.config));
    };
    AmplitudeCore.prototype.remove = function(pluginName) {
        if (!this.isReady) {
            this.q.push(this._removePlugin.bind(this, pluginName));
            return (0, $31df937edadccc1a$export$a2bf1b09e40c274a)();
        }
        return this._removePlugin(pluginName);
    };
    AmplitudeCore.prototype._removePlugin = function(pluginName) {
        return (0, $31df937edadccc1a$export$a2bf1b09e40c274a)(this.timeline.deregister(pluginName, this.config));
    };
    AmplitudeCore.prototype.dispatchWithCallback = function(event, callback) {
        if (!this.isReady) return callback((0, $c70cdb26bcb097d4$export$db0956ffc926ab6b)(event, 0, (0, $598aca23f12d68fa$export$f9763d297affe1cc)));
        this.process(event).then(callback);
    };
    AmplitudeCore.prototype.dispatch = function(event) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $bunH6.__generator)(this, function(_a) {
                if (!this.isReady) return [
                    2 /*return*/ ,
                    new Promise(function(resolve) {
                        _this.dispatchQ.push(_this.dispatchWithCallback.bind(_this, event, resolve));
                    })
                ];
                return [
                    2 /*return*/ ,
                    this.process(event)
                ];
            });
        });
    };
    /**
     *
     * This method applies identify operations to user properties and
     * returns a single object representing the final user property state.
     *
     * This is a best-effort api that only supports $set, $clearAll, and $unset.
     * Other operations are not supported and are ignored.
     *
     * Operations are applied on top of current client state (this.userProperties).
     *
     * @param userProperties The new user properties object from identify() or setIdentity().
     * @returns A key-value object user properties without operations.
     *
     * @example
     * Input:
     * {
     *   $set: { plan: 'premium' },
     *   custom_flag: true
     * }
     *
     * Output:
     * {
     *   plan: 'premium',
     *   custom_flag: true
     * }
     */ AmplitudeCore.prototype.getOperationAppliedUserProperties = function(userProperties) {
        var _a;
        var base = (_a = this.userProperties) !== null && _a !== void 0 ? _a : {};
        var updatedProperties = (0, $bunH6.__assign)({}, base);
        if (userProperties === undefined) return updatedProperties;
        // Keep non-operation keys for later merge
        var nonOpProperties = {};
        Object.keys(userProperties).forEach(function(key) {
            if (!Object.values((0, $b1034e6ea0b84810$export$6df138c24303c801)).includes(key)) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            nonOpProperties[key] = userProperties[key];
        });
        (0, $643b81d8570b18c7$export$64d36bfa56d27e6a).forEach(function(operation) {
            // Skip when key is an operation.
            if (!Object.keys(userProperties).includes(operation)) return;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            var opProperties = userProperties[operation];
            switch(operation){
                case (0, $b1034e6ea0b84810$export$6df138c24303c801).CLEAR_ALL:
                    // Due to operation order, the following line will never execute.
                    /* istanbul ignore next */ Object.keys(updatedProperties).forEach(function(prop) {
                        delete updatedProperties[prop];
                    });
                    break;
                case (0, $b1034e6ea0b84810$export$6df138c24303c801).UNSET:
                    Object.keys(opProperties).forEach(function(prop) {
                        delete updatedProperties[prop];
                    });
                    break;
                case (0, $b1034e6ea0b84810$export$6df138c24303c801).SET:
                    Object.assign(updatedProperties, opProperties);
                    break;
            }
        });
        // Merge non-operation properties.
        // Custom properties should not be affected by operations.
        // https://github.com/amplitude/nova/blob/343f678ded83c032e83b189796b3c2be161b48f5/src/main/java/com/amplitude/userproperty/model/ModifyUserPropertiesIdent.java#L79-L83
        Object.assign(updatedProperties, nonOpProperties);
        return updatedProperties;
    };
    AmplitudeCore.prototype.process = function(event) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var result, e_2, message, result;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        // skip event processing if opt out
                        if (this.config.optOut) return [
                            2 /*return*/ ,
                            (0, $c70cdb26bcb097d4$export$db0956ffc926ab6b)(event, 0, (0, $598aca23f12d68fa$export$ce5d4f781e585e70))
                        ];
                        if (event.event_type === (0, $b1034e6ea0b84810$export$6221d17ecafe3bf9).IDENTIFY) // Do not update this.userProperties here.
                        // It is only set synchronously in identify() or setIdentity()
                        this.timeline.onIdentityChanged({
                            userProperties: this.userProperties
                        });
                        return [
                            4 /*yield*/ ,
                            this.timeline.push(event)
                        ];
                    case 1:
                        result = _a.sent();
                        result.code === 200 ? this.config.loggerProvider.log(result.message) : result.code === 100 ? this.config.loggerProvider.warn(result.message) : this.config.loggerProvider.error(result.message);
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 2:
                        e_2 = _a.sent();
                        message = String(e_2);
                        this.config.loggerProvider.error(message);
                        result = (0, $c70cdb26bcb097d4$export$db0956ffc926ab6b)(event, 0, message);
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AmplitudeCore.prototype.setOptOut = function(optOut) {
        if (!this.isReady) {
            this.q.push(this._setOptOut.bind(this, Boolean(optOut)));
            return;
        }
        this._setOptOut(optOut);
    };
    AmplitudeCore.prototype._setOptOut = function(optOut) {
        if (this.config.optOut !== optOut) {
            this.config.optOut = Boolean(optOut);
            this.timeline.onOptOutChanged(optOut);
        }
    };
    AmplitudeCore.prototype.flush = function() {
        return (0, $31df937edadccc1a$export$a2bf1b09e40c274a)(this.timeline.flush());
    };
    AmplitudeCore.prototype.plugin = function(name) {
        var plugin = this.timeline.plugins.find(function(plugin) {
            return plugin.name === name;
        });
        if (plugin === undefined) {
            this.config.loggerProvider.debug("Cannot find plugin with name ".concat(name));
            return undefined;
        }
        return plugin;
    };
    AmplitudeCore.prototype.plugins = function(pluginClass) {
        return this.timeline.plugins.filter(function(plugin) {
            return plugin instanceof pluginClass;
        });
    };
    return AmplitudeCore;
}();


var $bunH6 = parcelRequire("bunH6");



// Creates an array of elements split into groups the length of size.
// If array can't be split evenly, the final chunk will be the remaining elements.
// Works similary as https://lodash.com/docs/4.17.15#chunk
var $812580dde4aa60de$export$5f7ec48d69707ddd = function(arr, size) {
    var chunkSize = Math.max(size, 1);
    return arr.reduce(function(chunks, element, index) {
        var chunkIndex = Math.floor(index / chunkSize);
        if (!chunks[chunkIndex]) chunks[chunkIndex] = [];
        chunks[chunkIndex].push(element);
        return chunks;
    }, []);
};





var $fb8fead1aae1be82$var$PREFIX = 'Amplitude Logger ';
var $fb8fead1aae1be82$export$efa9a398d6368992 = /** @class */ function() {
    function Logger() {
        this.logLevel = (0, $7740633108eec54d$export$243e62d78d3b544d).None;
    }
    Logger.prototype.disable = function() {
        this.logLevel = (0, $7740633108eec54d$export$243e62d78d3b544d).None;
    };
    Logger.prototype.enable = function(logLevel) {
        if (logLevel === void 0) logLevel = (0, $7740633108eec54d$export$243e62d78d3b544d).Warn;
        this.logLevel = logLevel;
    };
    Logger.prototype.log = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.logLevel < (0, $7740633108eec54d$export$243e62d78d3b544d).Verbose) return;
        console.log("".concat($fb8fead1aae1be82$var$PREFIX, "[Log]: ").concat(args.join(' ')));
    };
    Logger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.logLevel < (0, $7740633108eec54d$export$243e62d78d3b544d).Warn) return;
        console.warn("".concat($fb8fead1aae1be82$var$PREFIX, "[Warn]: ").concat(args.join(' ')));
    };
    Logger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.logLevel < (0, $7740633108eec54d$export$243e62d78d3b544d).Error) return;
        console.error("".concat($fb8fead1aae1be82$var$PREFIX, "[Error]: ").concat(args.join(' ')));
    };
    Logger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.logLevel < (0, $7740633108eec54d$export$243e62d78d3b544d).Debug) return;
        // console.debug output is hidden by default in chrome
        console.log("".concat($fb8fead1aae1be82$var$PREFIX, "[Debug]: ").concat(args.join(' ')));
    };
    return Logger;
}();



var $18be17c871db5450$export$ed30944e0fe6ae5c = function() {
    return {
        flushMaxRetries: 12,
        flushQueueSize: 200,
        flushIntervalMillis: 10000,
        instanceName: (0, $c1d7ad7f2bf46bfb$export$beb3c3946c248b94),
        logLevel: (0, $7740633108eec54d$export$243e62d78d3b544d).Warn,
        loggerProvider: new (0, $fb8fead1aae1be82$export$efa9a398d6368992)(),
        offline: false,
        optOut: false,
        serverUrl: (0, $c1d7ad7f2bf46bfb$export$29e80e090bc2cfd4),
        serverZone: 'US',
        useBatch: false
    };
};
var $18be17c871db5450$export$29cd7b75162a9425 = /** @class */ function() {
    function Config(options) {
        var _a, _b, _c, _d;
        this._optOut = false;
        var defaultConfig = $18be17c871db5450$export$ed30944e0fe6ae5c();
        this.apiKey = options.apiKey;
        this.flushIntervalMillis = (_a = options.flushIntervalMillis) !== null && _a !== void 0 ? _a : defaultConfig.flushIntervalMillis;
        this.flushMaxRetries = options.flushMaxRetries || defaultConfig.flushMaxRetries;
        this.flushQueueSize = options.flushQueueSize || defaultConfig.flushQueueSize;
        this.instanceName = options.instanceName || defaultConfig.instanceName;
        this.loggerProvider = options.loggerProvider || defaultConfig.loggerProvider;
        this.logLevel = (_b = options.logLevel) !== null && _b !== void 0 ? _b : defaultConfig.logLevel;
        this.minIdLength = options.minIdLength;
        this.plan = options.plan;
        this.ingestionMetadata = options.ingestionMetadata;
        this.offline = options.offline !== undefined ? options.offline : defaultConfig.offline;
        this.optOut = (_c = options.optOut) !== null && _c !== void 0 ? _c : defaultConfig.optOut;
        this.serverUrl = options.serverUrl;
        this.serverZone = options.serverZone || defaultConfig.serverZone;
        this.storageProvider = options.storageProvider;
        this.transportProvider = options.transportProvider;
        this.useBatch = (_d = options.useBatch) !== null && _d !== void 0 ? _d : defaultConfig.useBatch;
        this.loggerProvider.enable(this.logLevel);
        var serverConfig = $18be17c871db5450$export$9100f0789d5e1cf2(options.serverUrl, options.serverZone, options.useBatch);
        this.serverZone = serverConfig.serverZone;
        this.serverUrl = serverConfig.serverUrl;
    }
    Object.defineProperty(Config.prototype, "optOut", {
        get: function() {
            return this._optOut;
        },
        set: function(optOut) {
            this._optOut = optOut;
        },
        enumerable: false,
        configurable: true
    });
    return Config;
}();
var $18be17c871db5450$export$3c14a5a58c5a65d4 = function(serverZone, useBatch) {
    if (serverZone === 'EU') return useBatch ? (0, $c1d7ad7f2bf46bfb$export$68967a892545fca0) : (0, $c1d7ad7f2bf46bfb$export$2fcb1c10f7306bcf);
    return useBatch ? (0, $c1d7ad7f2bf46bfb$export$c567544fea55e004) : (0, $c1d7ad7f2bf46bfb$export$29e80e090bc2cfd4);
};
var $18be17c871db5450$export$9100f0789d5e1cf2 = function(serverUrl, serverZone, useBatch) {
    if (serverUrl === void 0) serverUrl = '';
    if (serverZone === void 0) serverZone = $18be17c871db5450$export$ed30944e0fe6ae5c().serverZone;
    if (useBatch === void 0) useBatch = $18be17c871db5450$export$ed30944e0fe6ae5c().useBatch;
    if (serverUrl) return {
        serverUrl: serverUrl,
        serverZone: undefined
    };
    var _serverZone = [
        'US',
        'EU'
    ].includes(serverZone) ? serverZone : $18be17c871db5450$export$ed30944e0fe6ae5c().serverZone;
    return {
        serverZone: _serverZone,
        serverUrl: $18be17c871db5450$export$3c14a5a58c5a65d4(_serverZone, useBatch)
    };
};
var $18be17c871db5450$export$f7a44070a14bece0 = /** @class */ function() {
    function RequestMetadata() {
        this.sdk = {
            metrics: {
                histogram: {}
            }
        };
    }
    RequestMetadata.prototype.recordHistogram = function(key, value) {
        this.sdk.metrics.histogram[key] = value;
    };
    return RequestMetadata;
}();
var $18be17c871db5450$var$HistogramOptions = /** @class */ function() {
    function HistogramOptions() {}
    return HistogramOptions;
}();



/**
 * Checks if an HTTP status code indicates success (2xx range)
 * @param code - The HTTP status code to check
 * @returns true if the status code is in the 2xx range, false otherwise
 */ function $24a8d3e88c6b49c1$export$1624c886bf20345d(code) {
    return code >= 200 && code < 300;
}



var $92857655ea49016b$var$DEFAULT_AMPLITUDE_SERVER_URLS = new Set([
    (0, $c1d7ad7f2bf46bfb$export$29e80e090bc2cfd4),
    (0, $c1d7ad7f2bf46bfb$export$2fcb1c10f7306bcf),
    (0, $c1d7ad7f2bf46bfb$export$c567544fea55e004),
    (0, $c1d7ad7f2bf46bfb$export$68967a892545fca0)
]);
var $92857655ea49016b$var$shouldCompressUploadBodyForRequest = function(serverUrl, enableRequestBodyCompression) {
    if (enableRequestBodyCompression === void 0) enableRequestBodyCompression = false;
    if ($92857655ea49016b$var$DEFAULT_AMPLITUDE_SERVER_URLS.has(serverUrl)) return true;
    return enableRequestBodyCompression;
};
function $92857655ea49016b$var$getErrorMessage(error) {
    if (error instanceof Error) return error.message;
    return String(error);
}
function $92857655ea49016b$export$dc54abaec16aa4c8(res) {
    var responseBodyString = '';
    try {
        if ('body' in res) responseBodyString = JSON.stringify(res.body, null, 2);
    } catch (_a) {
    // to avoid crash, but don't care about the error, add comment to avoid empty block lint error
    }
    return responseBodyString;
}
var $92857655ea49016b$export$5c4bdf44e1e9cea1 = /** @class */ function() {
    function Destination(context) {
        this.name = 'amplitude';
        this.type = 'destination';
        this.retryTimeout = 1000;
        this.throttleTimeout = 30000;
        this.storageKey = '';
        // Indicator of whether events that are scheduled (but not flushed yet).
        // When flush:
        //   1. assign `scheduleId` to `flushId`
        //   2. set `scheduleId` to null
        this.scheduleId = null;
        // Timeout in milliseconds of current schedule
        this.scheduledTimeout = 0;
        // Indicator of whether current flush resolves.
        // When flush resolves, set `flushId` to null
        this.flushId = null;
        this.queue = [];
        this.diagnosticsClient = context === null || context === void 0 ? void 0 : context.diagnosticsClient;
    }
    Destination.prototype.setup = function(config) {
        var _a;
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var unsent;
            var _this = this;
            return (0, $bunH6.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.config = config;
                        this.storageKey = "".concat((0, $c1d7ad7f2bf46bfb$export$7cc65d02ca2e18ec), "_").concat(this.config.apiKey.substring(0, 10));
                        return [
                            4 /*yield*/ ,
                            (_a = this.config.storageProvider) === null || _a === void 0 ? void 0 : _a.get(this.storageKey)
                        ];
                    case 1:
                        unsent = _b.sent();
                        if (unsent && unsent.length > 0) Promise.all(unsent.map(function(event) {
                            return _this.execute(event);
                        })).catch();
                        return [
                            2 /*return*/ ,
                            Promise.resolve(undefined)
                        ];
                }
            });
        });
    };
    Destination.prototype.execute = function(event) {
        var _this = this;
        // Assign insert_id for dropping invalid event later
        if (!event.insert_id) event.insert_id = (0, $b8d06392fac4718b$export$bc35efed93511c4b)();
        return new Promise(function(resolve) {
            var context = {
                event: event,
                attempts: 0,
                callback: function(result) {
                    return resolve(result);
                },
                timeout: 0
            };
            _this.queue.push(context);
            _this.schedule(_this.config.flushIntervalMillis);
            _this.saveEvents();
        });
    };
    Destination.prototype.removeEventsExceedFlushMaxRetries = function(list) {
        var _this = this;
        return list.filter(function(context) {
            context.attempts += 1;
            if (context.attempts < _this.config.flushMaxRetries) return true;
            _this.fulfillRequest([
                context
            ], 500, (0, $598aca23f12d68fa$export$db21e8e2aba60c7d));
            return false;
        });
    };
    Destination.prototype.scheduleEvents = function(list) {
        var _this = this;
        list.forEach(function(context) {
            _this.schedule(context.timeout === 0 ? _this.config.flushIntervalMillis : context.timeout);
        });
    };
    // Schedule a flush in timeout when
    // 1. No schedule
    // 2. Timeout greater than existing timeout.
    // This makes sure that when throttled, no flush when throttle timeout expires.
    Destination.prototype.schedule = function(timeout) {
        var _this = this;
        if (this.config.offline) return;
        if (this.scheduleId === null || this.scheduleId && timeout > this.scheduledTimeout) {
            if (this.scheduleId) clearTimeout(this.scheduleId);
            this.scheduledTimeout = timeout;
            this.scheduleId = setTimeout(function() {
                _this.queue = _this.queue.map(function(context) {
                    context.timeout = 0;
                    return context;
                });
                _this.flush(true);
            }, timeout);
            return;
        }
    };
    // Mark current schedule is flushed.
    Destination.prototype.resetSchedule = function() {
        this.scheduleId = null;
        this.scheduledTimeout = 0;
    };
    // Flush all events regardless of their timeout
    Destination.prototype.flush = function(useRetry) {
        if (useRetry === void 0) useRetry = false;
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var list, later, batches;
            var _this = this;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Skip flush if offline
                        if (this.config.offline) {
                            this.resetSchedule();
                            this.config.loggerProvider.debug('Skipping flush while offline.');
                            return [
                                2 /*return*/ 
                            ];
                        }
                        if (this.flushId) {
                            this.resetSchedule();
                            this.config.loggerProvider.debug('Skipping flush because previous flush has not resolved.');
                            return [
                                2 /*return*/ 
                            ];
                        }
                        this.flushId = this.scheduleId;
                        this.resetSchedule();
                        list = [];
                        later = [];
                        this.queue.forEach(function(context) {
                            return context.timeout === 0 ? list.push(context) : later.push(context);
                        });
                        batches = (0, $812580dde4aa60de$export$5f7ec48d69707ddd)(list, this.config.flushQueueSize);
                        // Promise.all() doesn't guarantee resolve order.
                        // Sequentially resolve to make sure backend receives events in order
                        return [
                            4 /*yield*/ ,
                            batches.reduce(function(promise, batch) {
                                return (0, $bunH6.__awaiter)(_this, void 0, void 0, function() {
                                    return (0, $bunH6.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    promise
                                                ];
                                            case 1:
                                                _a.sent();
                                                return [
                                                    4 /*yield*/ ,
                                                    this.send(batch, useRetry)
                                                ];
                                            case 2:
                                                return [
                                                    2 /*return*/ ,
                                                    _a.sent()
                                                ];
                                        }
                                    });
                                });
                            }, Promise.resolve())
                        ];
                    case 1:
                        // Promise.all() doesn't guarantee resolve order.
                        // Sequentially resolve to make sure backend receives events in order
                        _a.sent();
                        // Mark current flush is done
                        this.flushId = null;
                        this.scheduleEvents(this.queue);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Destination.prototype.send = function(list, useRetry) {
        var _a;
        if (useRetry === void 0) useRetry = true;
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var payload, serverUrl, shouldCompressUploadBody, res, e_1, errorMessage;
            return (0, $bunH6.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.config.apiKey) return [
                            2 /*return*/ ,
                            this.fulfillRequest(list, 400, (0, $598aca23f12d68fa$export$9229755af3d7ecf1))
                        ];
                        payload = {
                            api_key: this.config.apiKey,
                            events: list.map(function(context) {
                                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                var _a = context.event, extra = _a.extra, eventWithoutExtra = (0, $bunH6.__rest)(_a, [
                                    "extra"
                                ]);
                                return eventWithoutExtra;
                            }),
                            options: {
                                min_id_length: this.config.minIdLength
                            },
                            client_upload_time: new Date().toISOString(),
                            request_metadata: this.config.requestMetadata
                        };
                        this.config.requestMetadata = new (0, $18be17c871db5450$export$f7a44070a14bece0)();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        serverUrl = (0, $18be17c871db5450$export$9100f0789d5e1cf2)(this.config.serverUrl, this.config.serverZone, this.config.useBatch).serverUrl;
                        shouldCompressUploadBody = $92857655ea49016b$var$shouldCompressUploadBodyForRequest(serverUrl, this.config.enableRequestBodyCompression);
                        return [
                            4 /*yield*/ ,
                            this.config.transportProvider.send(serverUrl, payload, this.config._enableRequestBodyCompressionExperimental && shouldCompressUploadBody)
                        ];
                    case 2:
                        res = _b.sent();
                        if (res === null) {
                            this.fulfillRequest(list, 0, (0, $598aca23f12d68fa$export$77be9b23e6f97080));
                            return [
                                2 /*return*/ 
                            ];
                        }
                        if (!useRetry) {
                            if ('body' in res) this.fulfillRequest(list, res.statusCode, "".concat(res.status, ": ").concat($92857655ea49016b$export$dc54abaec16aa4c8(res)));
                            else this.fulfillRequest(list, res.statusCode, res.status);
                            return [
                                2 /*return*/ 
                            ];
                        }
                        this.handleResponse(res, list);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _b.sent();
                        errorMessage = $92857655ea49016b$var$getErrorMessage(e_1);
                        this.config.loggerProvider.error(errorMessage);
                        (_a = this.diagnosticsClient) === null || _a === void 0 || _a.recordEvent('analytics.events.unsuccessful.from.catch.error', {
                            events: list.map(function(context) {
                                return context.event.event_type;
                            }),
                            message: errorMessage,
                            stack_trace: (0, $18f2db3fc8eec36d$export$da8ad5017022fc09)()
                        });
                        this.handleResponse({
                            status: (0, $89a82e180a05067f$export$96e9906d6d93a972).Failed,
                            statusCode: 0
                        }, list);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Destination.prototype.handleResponse = function(res, list) {
        var _a;
        if (!(0, $24a8d3e88c6b49c1$export$1624c886bf20345d)(res.statusCode)) (_a = this.diagnosticsClient) === null || _a === void 0 || _a.recordEvent('analytics.events.unsuccessful', {
            events: list.map(function(context) {
                return context.event.event_type;
            }),
            code: res.statusCode,
            status: res.status,
            body: $92857655ea49016b$export$dc54abaec16aa4c8(res),
            stack_trace: (0, $18f2db3fc8eec36d$export$da8ad5017022fc09)()
        });
        var status = res.status;
        switch(status){
            case (0, $89a82e180a05067f$export$96e9906d6d93a972).Success:
                this.handleSuccessResponse(res, list);
                break;
            case (0, $89a82e180a05067f$export$96e9906d6d93a972).Invalid:
                this.handleInvalidResponse(res, list);
                break;
            case (0, $89a82e180a05067f$export$96e9906d6d93a972).PayloadTooLarge:
                this.handlePayloadTooLargeResponse(res, list);
                break;
            case (0, $89a82e180a05067f$export$96e9906d6d93a972).RateLimit:
                this.handleRateLimitResponse(res, list);
                break;
            default:
                // log intermediate event status before retry
                this.config.loggerProvider.warn("{code: 0, error: \"Status '".concat(status, "' provided for ").concat(list.length, " events\"}"));
                this.handleOtherResponse(list);
                break;
        }
    };
    Destination.prototype.handleSuccessResponse = function(res, list) {
        this.fulfillRequest(list, res.statusCode, (0, $598aca23f12d68fa$export$5620dbefc1cb6f80));
    };
    Destination.prototype.handleInvalidResponse = function(res, list) {
        var _this = this;
        if (res.body.missingField || res.body.error.startsWith((0, $598aca23f12d68fa$export$c20466bf93fe12d8))) {
            this.fulfillRequest(list, res.statusCode, res.body.error);
            return;
        }
        var dropIndex = (0, $bunH6.__spreadArray)((0, $bunH6.__spreadArray)((0, $bunH6.__spreadArray)((0, $bunH6.__spreadArray)([], (0, $bunH6.__read)(Object.values(res.body.eventsWithInvalidFields)), false), (0, $bunH6.__read)(Object.values(res.body.eventsWithMissingFields)), false), (0, $bunH6.__read)(Object.values(res.body.eventsWithInvalidIdLengths)), false), (0, $bunH6.__read)(res.body.silencedEvents), false).flat();
        var dropIndexSet = new Set(dropIndex);
        var retry = list.filter(function(context, index) {
            if (dropIndexSet.has(index)) {
                _this.fulfillRequest([
                    context
                ], res.statusCode, res.body.error);
                return;
            }
            return true;
        });
        if (retry.length > 0) // log intermediate event status before retry
        this.config.loggerProvider.warn($92857655ea49016b$export$dc54abaec16aa4c8(res));
        var tryable = this.removeEventsExceedFlushMaxRetries(retry);
        this.scheduleEvents(tryable);
    };
    Destination.prototype.handlePayloadTooLargeResponse = function(res, list) {
        if (list.length === 1) {
            this.fulfillRequest(list, res.statusCode, res.body.error);
            return;
        }
        // log intermediate event status before retry
        this.config.loggerProvider.warn($92857655ea49016b$export$dc54abaec16aa4c8(res));
        this.config.flushQueueSize /= 2;
        var tryable = this.removeEventsExceedFlushMaxRetries(list);
        this.scheduleEvents(tryable);
    };
    Destination.prototype.handleRateLimitResponse = function(res, list) {
        var _this = this;
        var dropUserIds = Object.keys(res.body.exceededDailyQuotaUsers);
        var dropDeviceIds = Object.keys(res.body.exceededDailyQuotaDevices);
        var throttledIndex = res.body.throttledEvents;
        var dropUserIdsSet = new Set(dropUserIds);
        var dropDeviceIdsSet = new Set(dropDeviceIds);
        var throttledIndexSet = new Set(throttledIndex);
        var retry = list.filter(function(context, index) {
            if (context.event.user_id && dropUserIdsSet.has(context.event.user_id) || context.event.device_id && dropDeviceIdsSet.has(context.event.device_id)) {
                _this.fulfillRequest([
                    context
                ], res.statusCode, res.body.error);
                return;
            }
            if (throttledIndexSet.has(index)) context.timeout = _this.throttleTimeout;
            return true;
        });
        if (retry.length > 0) // log intermediate event status before retry
        this.config.loggerProvider.warn($92857655ea49016b$export$dc54abaec16aa4c8(res));
        var tryable = this.removeEventsExceedFlushMaxRetries(retry);
        this.scheduleEvents(tryable);
    };
    Destination.prototype.handleOtherResponse = function(list) {
        var _this = this;
        var later = list.map(function(context) {
            context.timeout = context.attempts * _this.retryTimeout;
            return context;
        });
        var tryable = this.removeEventsExceedFlushMaxRetries(later);
        this.scheduleEvents(tryable);
    };
    Destination.prototype.fulfillRequest = function(list, code, message) {
        var _a, _b, _c;
        // Record diagnostics for dropped events (non-success status codes)
        if (!(0, $24a8d3e88c6b49c1$export$1624c886bf20345d)(code)) {
            (_a = this.diagnosticsClient) === null || _a === void 0 || _a.increment('analytics.events.dropped', list.length);
            (_b = this.diagnosticsClient) === null || _b === void 0 || _b.recordEvent('analytics.events.dropped', {
                events: list.map(function(context) {
                    return context.event.event_type;
                }),
                code: code,
                message: message,
                stack_trace: (0, $18f2db3fc8eec36d$export$da8ad5017022fc09)()
            });
        } else (_c = this.diagnosticsClient) === null || _c === void 0 || _c.increment('analytics.events.sent', list.length);
        this.removeEvents(list);
        list.forEach(function(context) {
            return context.callback((0, $c70cdb26bcb097d4$export$db0956ffc926ab6b)(context.event, code, message));
        });
    };
    /**
     * This is called on
     * 1) new events are added to queue; or
     * 2) response comes back for a request
     *
     * Update the event storage based on the queue
     */ Destination.prototype.saveEvents = function() {
        if (!this.config.storageProvider) return;
        var updatedEvents = this.queue.map(function(context) {
            return context.event;
        });
        this.config.storageProvider.set(this.storageKey, updatedEvents);
    };
    /**
     * This is called on response comes back for a request
     */ Destination.prototype.removeEvents = function(eventsToRemove) {
        this.queue = this.queue.filter(function(queuedContext) {
            return !eventsToRemove.some(function(context) {
                return context.event.insert_id === queuedContext.event.insert_id;
            });
        });
        this.saveEvents();
    };
    return Destination;
}();


var $bunH6 = parcelRequire("bunH6");

var $bunH6 = parcelRequire("bunH6");

var $c4xZ2 = parcelRequire("c4xZ2");
var $2c991f301037508e$var$MAX_PERSISTENT_STORAGE_EVENTS_COUNT = 10;
// Database configuration
var $2c991f301037508e$var$DB_VERSION = 1;
var $2c991f301037508e$export$936b1dcaf847d6bc = {
    TAGS: 'tags',
    COUNTERS: 'counters',
    HISTOGRAMS: 'histograms',
    EVENTS: 'events',
    INTERNAL: 'internal'
};
var $2c991f301037508e$export$2dabc785e5e7c54f = {
    LAST_FLUSH_TIMESTAMP: 'last_flush_timestamp'
};
/**
 * Purpose-specific IndexedDB storage for diagnostics data
 * Provides optimized methods for each type of diagnostics data
 */ var $2c991f301037508e$export$1af40042dbbde141 = /** @class */ function() {
    function DiagnosticsStorage(apiKey, logger) {
        this.dbPromise = null;
        this.logger = logger;
        this.dbName = "AMP_diagnostics_".concat(apiKey.substring(0, 10));
    }
    /**
     * Check if IndexedDB is supported in the current environment
     * @returns true if IndexedDB is available, false otherwise
     */ DiagnosticsStorage.isSupported = function() {
        var _a;
        return ((_a = (0, $c4xZ2.getGlobalScope)()) === null || _a === void 0 ? void 0 : _a.indexedDB) !== undefined;
    };
    DiagnosticsStorage.prototype.getDB = function() {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                if (!this.dbPromise) this.dbPromise = this.openDB();
                return [
                    2 /*return*/ ,
                    this.dbPromise
                ];
            });
        });
    };
    DiagnosticsStorage.prototype.openDB = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var request = indexedDB.open(_this.dbName, $2c991f301037508e$var$DB_VERSION);
            request.onerror = function() {
                // Clear dbPromise when it rejects for the first time
                _this.dbPromise = null;
                reject(new Error('Failed to open IndexedDB'));
            };
            request.onsuccess = function() {
                var db = request.result;
                // Clear dbPromise when connection was on but went off later
                db.onclose = function() {
                    _this.dbPromise = null;
                    _this.logger.debug('DiagnosticsStorage: DB connection closed.');
                };
                db.onerror = function(event) {
                    _this.logger.debug('DiagnosticsStorage: A global database error occurred.', event);
                    db.close();
                };
                resolve(db);
            };
            request.onupgradeneeded = function(event) {
                var db = event.target.result;
                _this.createTables(db);
            };
        });
    };
    DiagnosticsStorage.prototype.createTables = function(db) {
        // Create tags table
        if (!db.objectStoreNames.contains($2c991f301037508e$export$936b1dcaf847d6bc.TAGS)) db.createObjectStore($2c991f301037508e$export$936b1dcaf847d6bc.TAGS, {
            keyPath: 'key'
        });
        // Create counters table
        if (!db.objectStoreNames.contains($2c991f301037508e$export$936b1dcaf847d6bc.COUNTERS)) db.createObjectStore($2c991f301037508e$export$936b1dcaf847d6bc.COUNTERS, {
            keyPath: 'key'
        });
        // Create histograms table for storing histogram stats (count, min, max, sum)
        if (!db.objectStoreNames.contains($2c991f301037508e$export$936b1dcaf847d6bc.HISTOGRAMS)) db.createObjectStore($2c991f301037508e$export$936b1dcaf847d6bc.HISTOGRAMS, {
            keyPath: 'key'
        });
        // Create events table
        if (!db.objectStoreNames.contains($2c991f301037508e$export$936b1dcaf847d6bc.EVENTS)) {
            var eventsStore = db.createObjectStore($2c991f301037508e$export$936b1dcaf847d6bc.EVENTS, {
                keyPath: 'id',
                autoIncrement: true
            });
            // Create index on time for chronological queries
            eventsStore.createIndex('time_idx', 'time', {
                unique: false
            });
        }
        // Create internal table for storing internal data like flush timestamps
        if (!db.objectStoreNames.contains($2c991f301037508e$export$936b1dcaf847d6bc.INTERNAL)) db.createObjectStore($2c991f301037508e$export$936b1dcaf847d6bc.INTERNAL, {
            keyPath: 'key'
        });
    };
    DiagnosticsStorage.prototype.setTags = function(tags) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var db, transaction_1, store_1, error_1;
            var _this = this;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        if (Object.entries(tags).length === 0) return [
                            2 /*return*/ 
                        ];
                        return [
                            4 /*yield*/ ,
                            this.getDB()
                        ];
                    case 1:
                        db = _a.sent();
                        transaction_1 = db.transaction([
                            $2c991f301037508e$export$936b1dcaf847d6bc.TAGS
                        ], 'readwrite');
                        store_1 = transaction_1.objectStore($2c991f301037508e$export$936b1dcaf847d6bc.TAGS);
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve) {
                                var entries = Object.entries(tags);
                                transaction_1.oncomplete = function() {
                                    resolve();
                                };
                                transaction_1.onabort = function(event) {
                                    _this.logger.debug('DiagnosticsStorage: Failed to set tags', event);
                                    resolve();
                                };
                                entries.forEach(function(_a) {
                                    var _b = (0, $bunH6.__read)(_a, 2), key = _b[0], value = _b[1];
                                    var putRequest = store_1.put({
                                        key: key,
                                        value: value
                                    });
                                    putRequest.onerror = function(event) {
                                        _this.logger.debug('DiagnosticsStorage: Failed to set tag', key, value, event);
                                    };
                                });
                            })
                        ];
                    case 2:
                        error_1 = _a.sent();
                        this.logger.debug('DiagnosticsStorage: Failed to set tags', error_1);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DiagnosticsStorage.prototype.incrementCounters = function(counters) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var db, transaction_2, store_2, error_2;
            var _this = this;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        if (Object.entries(counters).length === 0) return [
                            2 /*return*/ 
                        ];
                        return [
                            4 /*yield*/ ,
                            this.getDB()
                        ];
                    case 1:
                        db = _a.sent();
                        transaction_2 = db.transaction([
                            $2c991f301037508e$export$936b1dcaf847d6bc.COUNTERS
                        ], 'readwrite');
                        store_2 = transaction_2.objectStore($2c991f301037508e$export$936b1dcaf847d6bc.COUNTERS);
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve) {
                                var entries = Object.entries(counters);
                                transaction_2.oncomplete = function() {
                                    resolve();
                                };
                                transaction_2.onabort = function(event) {
                                    _this.logger.debug('DiagnosticsStorage: Failed to increment counters', event);
                                    resolve();
                                };
                                // Read existing values and update them
                                entries.forEach(function(_a) {
                                    var _b = (0, $bunH6.__read)(_a, 2), key = _b[0], incrementValue = _b[1];
                                    var getRequest = store_2.get(key);
                                    getRequest.onsuccess = function() {
                                        var existingRecord = getRequest.result;
                                        /* istanbul ignore next */ var existingValue = existingRecord ? existingRecord.value : 0;
                                        var putRequest = store_2.put({
                                            key: key,
                                            value: existingValue + incrementValue
                                        });
                                        putRequest.onerror = function(event) {
                                            _this.logger.debug('DiagnosticsStorage: Failed to update counter', key, event);
                                        };
                                    };
                                    getRequest.onerror = function(event) {
                                        _this.logger.debug('DiagnosticsStorage: Failed to read existing counter', key, event);
                                    };
                                });
                            })
                        ];
                    case 2:
                        error_2 = _a.sent();
                        this.logger.debug('DiagnosticsStorage: Failed to increment counters', error_2);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DiagnosticsStorage.prototype.setHistogramStats = function(histogramStats) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var db, transaction_3, store_3, error_3;
            var _this = this;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        if (Object.entries(histogramStats).length === 0) return [
                            2 /*return*/ 
                        ];
                        return [
                            4 /*yield*/ ,
                            this.getDB()
                        ];
                    case 1:
                        db = _a.sent();
                        transaction_3 = db.transaction([
                            $2c991f301037508e$export$936b1dcaf847d6bc.HISTOGRAMS
                        ], 'readwrite');
                        store_3 = transaction_3.objectStore($2c991f301037508e$export$936b1dcaf847d6bc.HISTOGRAMS);
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve) {
                                var entries = Object.entries(histogramStats);
                                transaction_3.oncomplete = function() {
                                    resolve();
                                };
                                transaction_3.onabort = function(event) {
                                    _this.logger.debug('DiagnosticsStorage: Failed to set histogram stats', event);
                                    resolve();
                                };
                                // Read existing values and update them
                                entries.forEach(function(_a) {
                                    var _b = (0, $bunH6.__read)(_a, 2), key = _b[0], newStats = _b[1];
                                    var getRequest = store_3.get(key);
                                    getRequest.onsuccess = function() {
                                        var existingRecord = getRequest.result;
                                        var updatedStats;
                                        /* istanbul ignore next */ if (existingRecord) // Accumulate with existing stats
                                        updatedStats = {
                                            key: key,
                                            count: existingRecord.count + newStats.count,
                                            min: Math.min(existingRecord.min, newStats.min),
                                            max: Math.max(existingRecord.max, newStats.max),
                                            sum: existingRecord.sum + newStats.sum
                                        };
                                        else // Create new stats
                                        updatedStats = {
                                            key: key,
                                            count: newStats.count,
                                            min: newStats.min,
                                            max: newStats.max,
                                            sum: newStats.sum
                                        };
                                        var putRequest = store_3.put(updatedStats);
                                        putRequest.onerror = function(event) {
                                            _this.logger.debug('DiagnosticsStorage: Failed to set histogram stats', key, event);
                                        };
                                    };
                                    getRequest.onerror = function(event) {
                                        _this.logger.debug('DiagnosticsStorage: Failed to read existing histogram stats', key, event);
                                    };
                                });
                            })
                        ];
                    case 2:
                        error_3 = _a.sent();
                        this.logger.debug('DiagnosticsStorage: Failed to set histogram stats', error_3);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DiagnosticsStorage.prototype.addEventRecords = function(events) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var db, transaction_4, store_4, error_4;
            var _this = this;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        if (events.length === 0) return [
                            2 /*return*/ 
                        ];
                        return [
                            4 /*yield*/ ,
                            this.getDB()
                        ];
                    case 1:
                        db = _a.sent();
                        transaction_4 = db.transaction([
                            $2c991f301037508e$export$936b1dcaf847d6bc.EVENTS
                        ], 'readwrite');
                        store_4 = transaction_4.objectStore($2c991f301037508e$export$936b1dcaf847d6bc.EVENTS);
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve) {
                                transaction_4.oncomplete = function() {
                                    resolve();
                                };
                                /* istanbul ignore next */ transaction_4.onabort = function(event) {
                                    _this.logger.debug('DiagnosticsStorage: Failed to add event records', event);
                                    resolve();
                                };
                                // First, check how many events are currently stored
                                var countRequest = store_4.count();
                                countRequest.onsuccess = function() {
                                    var currentCount = countRequest.result;
                                    // Calculate how many events we can add
                                    var availableSlots = Math.max(0, $2c991f301037508e$var$MAX_PERSISTENT_STORAGE_EVENTS_COUNT - currentCount);
                                    if (availableSlots < events.length) _this.logger.debug("DiagnosticsStorage: Only added ".concat(availableSlots, " of ").concat(events.length, " events due to storage limit"));
                                    // Only add events up to the available slots (take the least recent ones)
                                    events.slice(0, availableSlots).forEach(function(event) {
                                        var request = store_4.add(event);
                                        request.onerror = function(event) {
                                            _this.logger.debug('DiagnosticsStorage: Failed to add event record', event);
                                        };
                                    });
                                };
                                countRequest.onerror = function(event) {
                                    _this.logger.debug('DiagnosticsStorage: Failed to count existing events', event);
                                };
                            })
                        ];
                    case 2:
                        error_4 = _a.sent();
                        this.logger.debug('DiagnosticsStorage: Failed to add event records', error_4);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DiagnosticsStorage.prototype.setInternal = function(key, value) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var db, transaction_5, store_5, error_5;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.getDB()
                        ];
                    case 1:
                        db = _a.sent();
                        transaction_5 = db.transaction([
                            $2c991f301037508e$export$936b1dcaf847d6bc.INTERNAL
                        ], 'readwrite');
                        store_5 = transaction_5.objectStore($2c991f301037508e$export$936b1dcaf847d6bc.INTERNAL);
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                /* istanbul ignore next */ transaction_5.onabort = function() {
                                    return reject(new Error('Failed to set internal value'));
                                };
                                var request = store_5.put({
                                    key: key,
                                    value: value
                                });
                                request.onsuccess = function() {
                                    return resolve();
                                };
                                /* istanbul ignore next */ request.onerror = function() {
                                    return reject(new Error('Failed to set internal value'));
                                };
                            })
                        ];
                    case 2:
                        error_5 = _a.sent();
                        /* istanbul ignore next */ this.logger.debug('DiagnosticsStorage: Failed to set internal value', error_5);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DiagnosticsStorage.prototype.getInternal = function(key) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var db, transaction_6, store_6, error_6;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.getDB()
                        ];
                    case 1:
                        db = _a.sent();
                        transaction_6 = db.transaction([
                            $2c991f301037508e$export$936b1dcaf847d6bc.INTERNAL
                        ], 'readonly');
                        store_6 = transaction_6.objectStore($2c991f301037508e$export$936b1dcaf847d6bc.INTERNAL);
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                /* istanbul ignore next */ transaction_6.onabort = function() {
                                    return reject(new Error('Failed to get internal value'));
                                };
                                var request = store_6.get(key);
                                request.onsuccess = function() {
                                    return resolve(request.result);
                                };
                                /* istanbul ignore next */ request.onerror = function() {
                                    return reject(new Error('Failed to get internal value'));
                                };
                            })
                        ];
                    case 2:
                        error_6 = _a.sent();
                        this.logger.debug('DiagnosticsStorage: Failed to get internal value', error_6);
                        return [
                            2 /*return*/ ,
                            undefined
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DiagnosticsStorage.prototype.getLastFlushTimestamp = function() {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var record, error_7;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.getInternal($2c991f301037508e$export$2dabc785e5e7c54f.LAST_FLUSH_TIMESTAMP)
                        ];
                    case 1:
                        record = _a.sent();
                        return [
                            2 /*return*/ ,
                            record ? parseInt(record.value, 10) : undefined
                        ];
                    case 2:
                        error_7 = _a.sent();
                        /* istanbul ignore next */ this.logger.debug('DiagnosticsStorage: Failed to get last flush timestamp', error_7);
                        /* istanbul ignore next */ return [
                            2 /*return*/ ,
                            undefined
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DiagnosticsStorage.prototype.setLastFlushTimestamp = function(timestamp) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var error_8;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.setInternal($2c991f301037508e$export$2dabc785e5e7c54f.LAST_FLUSH_TIMESTAMP, timestamp.toString())
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_8 = _a.sent();
                        /* istanbul ignore next */ this.logger.debug('DiagnosticsStorage: Failed to set last flush timestamp', error_8);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /* istanbul ignore next */ DiagnosticsStorage.prototype.clearTable = function(transaction, tableName) {
        return new Promise(function(resolve, reject) {
            var store = transaction.objectStore(tableName);
            var request = store.clear();
            request.onsuccess = function() {
                return resolve();
            };
            request.onerror = function() {
                return reject(new Error("Failed to clear table ".concat(tableName)));
            };
        });
    };
    /* istanbul ignore next */ DiagnosticsStorage.prototype.getAllAndClear = function() {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var db, transaction, _a, tags, counters, histogramStats, events, error_9;
            return (0, $bunH6.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _b.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.getDB()
                        ];
                    case 1:
                        db = _b.sent();
                        transaction = db.transaction([
                            $2c991f301037508e$export$936b1dcaf847d6bc.TAGS,
                            $2c991f301037508e$export$936b1dcaf847d6bc.COUNTERS,
                            $2c991f301037508e$export$936b1dcaf847d6bc.HISTOGRAMS,
                            $2c991f301037508e$export$936b1dcaf847d6bc.EVENTS
                        ], 'readwrite');
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                this.getAllFromStore(transaction, $2c991f301037508e$export$936b1dcaf847d6bc.TAGS),
                                this.getAllFromStore(transaction, $2c991f301037508e$export$936b1dcaf847d6bc.COUNTERS),
                                this.getAllFromStore(transaction, $2c991f301037508e$export$936b1dcaf847d6bc.HISTOGRAMS),
                                this.getAllFromStore(transaction, $2c991f301037508e$export$936b1dcaf847d6bc.EVENTS)
                            ])
                        ];
                    case 2:
                        _a = (0, $bunH6.__read).apply(void 0, [
                            _b.sent(),
                            4
                        ]), tags = _a[0], counters = _a[1], histogramStats = _a[2], events = _a[3];
                        // Clear all data in the same transaction
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                this.clearTable(transaction, $2c991f301037508e$export$936b1dcaf847d6bc.COUNTERS),
                                this.clearTable(transaction, $2c991f301037508e$export$936b1dcaf847d6bc.HISTOGRAMS),
                                this.clearTable(transaction, $2c991f301037508e$export$936b1dcaf847d6bc.EVENTS)
                            ])
                        ];
                    case 3:
                        // Clear all data in the same transaction
                        _b.sent();
                        return [
                            2 /*return*/ ,
                            {
                                tags: tags,
                                counters: counters,
                                histogramStats: histogramStats,
                                events: events
                            }
                        ];
                    case 4:
                        error_9 = _b.sent();
                        this.logger.debug('DiagnosticsStorage: Failed to get all and clear data', error_9);
                        return [
                            2 /*return*/ ,
                            {
                                tags: [],
                                counters: [],
                                histogramStats: [],
                                events: []
                            }
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Helper method to get all records from a store within a transaction
     */ /* istanbul ignore next */ DiagnosticsStorage.prototype.getAllFromStore = function(transaction, tableName) {
        return new Promise(function(resolve, reject) {
            var store = transaction.objectStore(tableName);
            var request = store.getAll();
            request.onsuccess = function() {
                return resolve(request.result);
            };
            request.onerror = function() {
                return reject(new Error("Failed to get all from ".concat(tableName)));
            };
        });
    };
    return DiagnosticsStorage;
}();



var $c4xZ2 = parcelRequire("c4xZ2");
var $6a5fd5aa81de791e$export$df97552b118e0edd = function(str) {
    var hash = 0;
    if (str.length === 0) return hash;
    for(var i = 0; i < str.length; i++){
        var chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
    }
    return hash;
};
var $6a5fd5aa81de791e$export$cded347c7455b1c3 = function(timestamp, sampleRate) {
    var hashNumber = $6a5fd5aa81de791e$export$df97552b118e0edd(timestamp.toString());
    var absHash = Math.abs(hashNumber);
    var absHashMultiply = absHash * 31;
    var mod = absHashMultiply % 1000000;
    return mod / 1000000 < sampleRate;
};
var $6a5fd5aa81de791e$export$e5413c11d6cba0b6 = function(timestamp, sampleRate) {
    var hashNumber = $6a5fd5aa81de791e$export$df97552b118e0edd(timestamp.toString());
    var absHash = Math.abs(hashNumber);
    var absHashMultiply = absHash * 31;
    var mod = absHashMultiply % 100000;
    return mod / 100000 < sampleRate;
};



var $bunH6 = parcelRequire("bunH6");

var $c4xZ2 = parcelRequire("c4xZ2");
var $c89a7aa7d239cf3a$export$fb098798dfedb0ac = '__AMPLITUDE_SCRIPT_URL__';
var $c89a7aa7d239cf3a$export$d0d61ea2045dc7d9 = 'sdk.error.uncaught';
var $c89a7aa7d239cf3a$var$getNormalizedScriptUrls = function() {
    var scope = (0, $c4xZ2.getGlobalScope)();
    /* istanbul ignore next */ if (!scope) return [];
    var value = scope[$c89a7aa7d239cf3a$export$fb098798dfedb0ac];
    if (Array.isArray(value)) return value;
    /* istanbul ignore next - legacy single URL stored as string */ if (typeof value === 'string') return [
        value
    ];
    return [];
};
var $c89a7aa7d239cf3a$var$addNormalizedScriptUrl = function(url) {
    var scope = (0, $c4xZ2.getGlobalScope)();
    /* istanbul ignore next */ if (!scope) return;
    var urls = $c89a7aa7d239cf3a$var$getNormalizedScriptUrls();
    if (!urls.includes(url)) {
        urls.push(url);
        scope[$c89a7aa7d239cf3a$export$fb098798dfedb0ac] = urls;
    }
};
var $c89a7aa7d239cf3a$export$3f9735f1d11ff937 = function(metadata) {
    if (metadata.scriptUrl) {
        var normalized = $c89a7aa7d239cf3a$var$normalizeUrl(metadata.scriptUrl);
        if (normalized) $c89a7aa7d239cf3a$var$addNormalizedScriptUrl(normalized);
    }
};
var $c89a7aa7d239cf3a$export$42cf9f89720e2f60 = function(client) {
    var scope = (0, $c4xZ2.getGlobalScope)();
    if (!scope || typeof scope.addEventListener !== 'function') return;
    var handleError = function(event) {
        var error = event.error instanceof Error ? event.error : undefined;
        var stack = error === null || error === void 0 ? void 0 : error.stack;
        var match = $c89a7aa7d239cf3a$var$detectSdkOrigin({
            filename: event.filename,
            stack: stack
        });
        if (!match) return;
        capture({
            type: 'error',
            message: event.message,
            stack: stack,
            filename: event.filename,
            errorName: error === null || error === void 0 ? void 0 : error.name,
            metadata: {
                colno: event.colno,
                lineno: event.lineno,
                isTrusted: event.isTrusted,
                matchReason: match
            }
        });
    };
    var handleRejection = function(event) {
        var _a;
        var error = event.reason instanceof Error ? event.reason : undefined;
        var stack = error === null || error === void 0 ? void 0 : error.stack;
        var filename = $c89a7aa7d239cf3a$var$extractFilenameFromStack(stack);
        var match = $c89a7aa7d239cf3a$var$detectSdkOrigin({
            filename: filename,
            stack: stack
        });
        if (!match) return;
        /* istanbul ignore next */ capture({
            type: 'unhandledrejection',
            message: (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : $c89a7aa7d239cf3a$var$stringifyReason(event.reason),
            stack: stack,
            filename: filename,
            errorName: error === null || error === void 0 ? void 0 : error.name,
            metadata: {
                isTrusted: event.isTrusted,
                matchReason: match
            }
        });
    };
    var capture = function(context) {
        client.recordEvent($c89a7aa7d239cf3a$export$d0d61ea2045dc7d9, (0, $bunH6.__assign)({
            type: context.type,
            message: context.message,
            filename: context.filename,
            error_name: context.errorName,
            stack: context.stack
        }, context.metadata));
    };
    scope.addEventListener('error', handleError, true);
    scope.addEventListener('unhandledrejection', handleRejection, true);
};
var $c89a7aa7d239cf3a$var$detectSdkOrigin = function(payload) {
    var e_1, _a;
    var normalizedScriptUrls = $c89a7aa7d239cf3a$var$getNormalizedScriptUrls();
    if (normalizedScriptUrls.length === 0) return undefined;
    try {
        for(var normalizedScriptUrls_1 = (0, $bunH6.__values)(normalizedScriptUrls), normalizedScriptUrls_1_1 = normalizedScriptUrls_1.next(); !normalizedScriptUrls_1_1.done; normalizedScriptUrls_1_1 = normalizedScriptUrls_1.next()){
            var normalizedScriptUrl = normalizedScriptUrls_1_1.value;
            if (payload.filename && payload.filename.includes(normalizedScriptUrl)) return 'filename';
            if (payload.stack && payload.stack.includes(normalizedScriptUrl)) return 'stack';
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (normalizedScriptUrls_1_1 && !normalizedScriptUrls_1_1.done && (_a = normalizedScriptUrls_1.return)) _a.call(normalizedScriptUrls_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return undefined;
};
var $c89a7aa7d239cf3a$var$normalizeUrl = function(value) {
    var _a, _b;
    try {
        /* istanbul ignore next */ var url = new URL(value, (_b = (_a = (0, $c4xZ2.getGlobalScope)()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.origin);
        return url.origin + url.pathname;
    } catch (_c) {
        return undefined;
    }
};
var $c89a7aa7d239cf3a$var$extractFilenameFromStack = function(stack) {
    if (!stack) return undefined;
    var match = stack.match(/(https?:\/\/\S+?)(?=[)\s]|$)/);
    /* istanbul ignore next */ return match ? match[1] : undefined;
};
/* istanbul ignore next */ var $c89a7aa7d239cf3a$var$stringifyReason = function(reason) {
    if (typeof reason === 'string') return reason;
    try {
        return JSON.stringify(reason);
    } catch (_a) {
        return '[object Object]';
    }
};


var $a7573bf6dddd990a$export$6ae6ba0968465030 = 1000; // 1 second
var $a7573bf6dddd990a$export$6eed01b9c628f684 = 300000; // 5 minutes
var $a7573bf6dddd990a$export$d017d475f9a063d1 = 'https://diagnostics.prod.us-west-2.amplitude.com/v1/capture';
var $a7573bf6dddd990a$export$d41f264b64f4f610 = 'https://diagnostics.prod.eu-central-1.amplitude.com/v1/capture';
var $a7573bf6dddd990a$export$dd011438f3aa608d = 10000; // for tags, counters, histograms separately
var $a7573bf6dddd990a$export$9ce9c06ccfd6b19d = 10;
var $a7573bf6dddd990a$export$ab01d4540335bf2a = /** @class */ function() {
    function DiagnosticsClient(apiKey, logger, serverZone, options) {
        if (serverZone === void 0) serverZone = 'US';
        // In-memory storages
        this.inMemoryTags = {};
        this.inMemoryCounters = {};
        this.inMemoryHistograms = {};
        this.inMemoryEvents = [];
        // Timer for 1-second persistence
        this.saveTimer = null;
        // Timer for flush interval
        this.flushTimer = null;
        this.apiKey = apiKey;
        this.logger = logger;
        this.serverUrl = serverZone === 'US' ? $a7573bf6dddd990a$export$d017d475f9a063d1 : $a7573bf6dddd990a$export$d41f264b64f4f610;
        this.logger.debug('DiagnosticsClient: Initializing with options', JSON.stringify(options, null, 2));
        // Diagnostics is enabled by default with sample rate of 0 (no sampling)
        this.config = (0, $bunH6.__assign)({
            enabled: true,
            sampleRate: 0
        }, options);
        this.startTimestamp = Date.now();
        this.shouldTrack = (0, $6a5fd5aa81de791e$export$e5413c11d6cba0b6)(this.startTimestamp, this.config.sampleRate) && this.config.enabled;
        if ((0, $2c991f301037508e$export$1af40042dbbde141).isSupported()) this.storage = new (0, $2c991f301037508e$export$1af40042dbbde141)(apiKey, logger);
        else this.logger.debug('DiagnosticsClient: IndexedDB is not supported');
        this.initializeFlushInterval();
        // Track internal diagnostics metrics for sampling
        if (this.shouldTrack) {
            this.increment('sdk.diagnostics.sampled.in.and.enabled');
            (0, $c89a7aa7d239cf3a$export$42cf9f89720e2f60)(this);
        }
    }
    /**
     * Check if storage is available and tracking is enabled
     */ DiagnosticsClient.prototype.isStorageAndTrackEnabled = function() {
        return Boolean(this.storage) && Boolean(this.shouldTrack);
    };
    DiagnosticsClient.prototype.setTag = function(name, value) {
        if (!this.isStorageAndTrackEnabled()) return;
        if (Object.keys(this.inMemoryTags).length >= $a7573bf6dddd990a$export$dd011438f3aa608d) {
            this.logger.debug('DiagnosticsClient: Early return setTags as reaching memory limit');
            return;
        }
        this.inMemoryTags[name] = value;
        this.startTimersIfNeeded();
    };
    DiagnosticsClient.prototype.increment = function(name, size) {
        if (size === void 0) size = 1;
        if (!this.isStorageAndTrackEnabled()) return;
        if (Object.keys(this.inMemoryCounters).length >= $a7573bf6dddd990a$export$dd011438f3aa608d) {
            this.logger.debug('DiagnosticsClient: Early return increment as reaching memory limit');
            return;
        }
        this.inMemoryCounters[name] = (this.inMemoryCounters[name] || 0) + size;
        this.startTimersIfNeeded();
    };
    DiagnosticsClient.prototype.recordHistogram = function(name, value) {
        if (!this.isStorageAndTrackEnabled()) return;
        if (Object.keys(this.inMemoryHistograms).length >= $a7573bf6dddd990a$export$dd011438f3aa608d) {
            this.logger.debug('DiagnosticsClient: Early return recordHistogram as reaching memory limit');
            return;
        }
        var existing = this.inMemoryHistograms[name];
        if (existing) {
            // Update existing stats incrementally
            existing.count += 1;
            existing.min = Math.min(existing.min, value);
            existing.max = Math.max(existing.max, value);
            existing.sum += value;
        } else // Create new stats
        this.inMemoryHistograms[name] = {
            count: 1,
            min: value,
            max: value,
            sum: value
        };
        this.startTimersIfNeeded();
    };
    DiagnosticsClient.prototype.recordEvent = function(name, properties) {
        if (!this.isStorageAndTrackEnabled()) return;
        if (this.inMemoryEvents.length >= $a7573bf6dddd990a$export$9ce9c06ccfd6b19d) {
            this.logger.debug('DiagnosticsClient: Early return recordEvent as reaching memory limit');
            return;
        }
        this.inMemoryEvents.push({
            event_name: name,
            time: Date.now(),
            event_properties: properties
        });
        this.startTimersIfNeeded();
    };
    DiagnosticsClient.prototype.startTimersIfNeeded = function() {
        var _this = this;
        if (!this.saveTimer) this.saveTimer = setTimeout(function() {
            _this.saveAllDataToStorage().catch(function(error) {
                _this.logger.debug('DiagnosticsClient: Failed to save all data to storage', error);
            }).finally(function() {
                _this.saveTimer = null;
            });
        }, $a7573bf6dddd990a$export$6ae6ba0968465030);
        if (!this.flushTimer) this.flushTimer = setTimeout(function() {
            _this._flush().catch(function(error) {
                _this.logger.debug('DiagnosticsClient: Failed to flush', error);
            }).finally(function() {
                _this.flushTimer = null;
            });
        }, $a7573bf6dddd990a$export$6eed01b9c628f684);
    };
    DiagnosticsClient.prototype.saveAllDataToStorage = function() {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var tagsToSave, countersToSave, histogramsToSave, eventsToSave;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.storage) return [
                            2 /*return*/ 
                        ];
                        tagsToSave = (0, $bunH6.__assign)({}, this.inMemoryTags);
                        countersToSave = (0, $bunH6.__assign)({}, this.inMemoryCounters);
                        histogramsToSave = (0, $bunH6.__assign)({}, this.inMemoryHistograms);
                        eventsToSave = (0, $bunH6.__spreadArray)([], (0, $bunH6.__read)(this.inMemoryEvents), false);
                        this.inMemoryEvents = [];
                        this.inMemoryTags = {};
                        this.inMemoryCounters = {};
                        this.inMemoryHistograms = {};
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                this.storage.setTags(tagsToSave),
                                this.storage.incrementCounters(countersToSave),
                                this.storage.setHistogramStats(histogramsToSave),
                                this.storage.addEventRecords(eventsToSave)
                            ])
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DiagnosticsClient.prototype._flush = function() {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var _a, tagRecords, counterRecords, histogramStatsRecords, eventRecords, tags, counters, histogram, events, payload;
            return (0, $bunH6.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.storage) return [
                            2 /*return*/ 
                        ];
                        return [
                            4 /*yield*/ ,
                            this.saveAllDataToStorage()
                        ];
                    case 1:
                        _b.sent();
                        this.saveTimer = null;
                        this.flushTimer = null;
                        return [
                            4 /*yield*/ ,
                            this.storage.getAllAndClear()
                        ];
                    case 2:
                        _a = _b.sent(), tagRecords = _a.tags, counterRecords = _a.counters, histogramStatsRecords = _a.histogramStats, eventRecords = _a.events;
                        // Update the last flush timestamp
                        this.storage.setLastFlushTimestamp(Date.now());
                        tags = {};
                        tagRecords.forEach(function(record) {
                            tags[record.key] = record.value;
                        });
                        counters = {};
                        counterRecords.forEach(function(record) {
                            counters[record.key] = record.value;
                        });
                        histogram = {};
                        histogramStatsRecords.forEach(function(stats) {
                            histogram[stats.key] = {
                                count: stats.count,
                                min: stats.min,
                                max: stats.max,
                                avg: Math.round(stats.sum / stats.count * 100) / 100
                            };
                        });
                        events = eventRecords.map(function(record) {
                            return {
                                event_name: record.event_name,
                                time: record.time,
                                event_properties: record.event_properties
                            };
                        });
                        // Early return if all data collections are empty
                        if (Object.keys(counters).length === 0 && Object.keys(histogram).length === 0 && events.length === 0) return [
                            2 /*return*/ 
                        ];
                        payload = {
                            tags: tags,
                            histogram: histogram,
                            counters: counters,
                            events: events
                        };
                        // Send payload to diagnostics server
                        this.fetch(payload);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Send diagnostics data to the server
     */ DiagnosticsClient.prototype.fetch = function(payload) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var response, error_1;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        if (!(0, $c4xZ2.getGlobalScope)()) throw new Error('DiagnosticsClient: Fetch is not supported');
                        return [
                            4 /*yield*/ ,
                            fetch(this.serverUrl, {
                                method: 'POST',
                                headers: {
                                    'X-ApiKey': this.apiKey,
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify(payload)
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            this.logger.debug('DiagnosticsClient: Failed to send diagnostics data.');
                            return [
                                2 /*return*/ 
                            ];
                        }
                        this.logger.debug('DiagnosticsClient: Successfully sent diagnostics data');
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_1 = _a.sent();
                        this.logger.debug('DiagnosticsClient: Failed to send diagnostics data. ', error_1);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Initialize flush interval logic.
     * Check if 5 minutes has passed since last flush, if so flush immediately.
     * Otherwise set a timer to flush when the interval is reached.
     */ DiagnosticsClient.prototype.initializeFlushInterval = function() {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var now, lastFlushTimestamp, timeSinceLastFlush;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.storage) return [
                            2 /*return*/ 
                        ];
                        now = Date.now();
                        return [
                            4 /*yield*/ ,
                            this.storage.getLastFlushTimestamp()
                        ];
                    case 1:
                        lastFlushTimestamp = _a.sent() || -1;
                        // If last flush timestamp is -1, it means this is a new client
                        // Save current timestamp as the initial "last flush timestamp"
                        // and schedule the flush timer
                        if (lastFlushTimestamp === -1) {
                            this.storage.setLastFlushTimestamp(now);
                            this._setFlushTimer($a7573bf6dddd990a$export$6eed01b9c628f684);
                            return [
                                2 /*return*/ 
                            ];
                        }
                        timeSinceLastFlush = now - lastFlushTimestamp;
                        if (timeSinceLastFlush >= $a7573bf6dddd990a$export$6eed01b9c628f684) {
                            // More than 5 minutes has passed, flush immediately
                            this._flush();
                            return [
                                2 /*return*/ 
                            ];
                        } else // Set timer for remaining time
                        this._setFlushTimer($a7573bf6dddd990a$export$6eed01b9c628f684 - timeSinceLastFlush);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Helper method to set flush timer with consistent error handling
     */ DiagnosticsClient.prototype._setFlushTimer = function(delay) {
        var _this = this;
        this.flushTimer = setTimeout(function() {
            _this._flush().catch(function(error) {
                _this.logger.debug('DiagnosticsClient: Failed to flush', error);
            }).finally(function() {
                _this.flushTimer = null;
            });
        }, delay);
    };
    DiagnosticsClient.prototype._setSampleRate = function(sampleRate) {
        this.logger.debug('DiagnosticsClient: Setting sample rate to', sampleRate);
        this.config.sampleRate = sampleRate;
        this.shouldTrack = (0, $6a5fd5aa81de791e$export$e5413c11d6cba0b6)(this.startTimestamp, this.config.sampleRate) && this.config.enabled;
        this.logger.debug('DiagnosticsClient: Should track is', this.shouldTrack);
    };
    return DiagnosticsClient;
}();

var $a70d8592f51cbeef$var$ApplicationContextProviderImpl = /** @class */ function() {
    function ApplicationContextProviderImpl() {}
    ApplicationContextProviderImpl.prototype.getApplicationContext = function() {
        return {
            versionName: this.versionName,
            language: $a70d8592f51cbeef$var$getLanguage(),
            platform: 'Web',
            os: undefined,
            deviceModel: undefined
        };
    };
    return ApplicationContextProviderImpl;
}();
var $a70d8592f51cbeef$var$getLanguage = function() {
    return typeof navigator !== 'undefined' && (navigator.languages && navigator.languages[0] || navigator.language) || '';
};
var $a70d8592f51cbeef$var$EventBridgeImpl = /** @class */ function() {
    function EventBridgeImpl() {
        this.queue = [];
    }
    EventBridgeImpl.prototype.logEvent = function(event) {
        if (!this.receiver) {
            if (this.queue.length < 512) this.queue.push(event);
        } else this.receiver(event);
    };
    EventBridgeImpl.prototype.setEventReceiver = function(receiver) {
        this.receiver = receiver;
        if (this.queue.length > 0) {
            this.queue.forEach(function(event) {
                receiver(event);
            });
            this.queue = [];
        }
    };
    return EventBridgeImpl;
}();
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $a70d8592f51cbeef$var$__assign = function() {
    $a70d8592f51cbeef$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a70d8592f51cbeef$var$__assign.apply(this, arguments);
};
function $a70d8592f51cbeef$var$__values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a70d8592f51cbeef$var$__read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
typeof SuppressedError === "function" && SuppressedError;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $a70d8592f51cbeef$var$isEqual = function(obj1, obj2) {
    var e_1, _a;
    var primitive = [
        'string',
        'number',
        'boolean',
        'undefined'
    ];
    var typeA = typeof obj1;
    var typeB = typeof obj2;
    if (typeA !== typeB) return false;
    try {
        for(var primitive_1 = $a70d8592f51cbeef$var$__values(primitive), primitive_1_1 = primitive_1.next(); !primitive_1_1.done; primitive_1_1 = primitive_1.next()){
            var p = primitive_1_1.value;
            if (p === typeA) return obj1 === obj2;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (primitive_1_1 && !primitive_1_1.done && (_a = primitive_1.return)) _a.call(primitive_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    // check null
    if (obj1 == null && obj2 == null) return true;
    else if (obj1 == null || obj2 == null) return false;
    // if got here - objects
    if (obj1.length !== obj2.length) return false;
    //check if arrays
    var isArrayA = Array.isArray(obj1);
    var isArrayB = Array.isArray(obj2);
    if (isArrayA !== isArrayB) return false;
    if (isArrayA && isArrayB) //arrays
    for(var i = 0; i < obj1.length; i++){
        if (!$a70d8592f51cbeef$var$isEqual(obj1[i], obj2[i])) return false;
    }
    else {
        //objects
        var sorted1 = Object.keys(obj1).sort();
        var sorted2 = Object.keys(obj2).sort();
        if (!$a70d8592f51cbeef$var$isEqual(sorted1, sorted2)) return false;
        //compare object values
        var result_1 = true;
        Object.keys(obj1).forEach(function(key) {
            if (!$a70d8592f51cbeef$var$isEqual(obj1[key], obj2[key])) result_1 = false;
        });
        return result_1;
    }
    return true;
};
var $a70d8592f51cbeef$var$ID_OP_SET = '$set';
var $a70d8592f51cbeef$var$ID_OP_UNSET = '$unset';
var $a70d8592f51cbeef$var$ID_OP_CLEAR_ALL = '$clearAll';
// Polyfill for Object.entries
if (!Object.entries) Object.entries = function(obj) {
    var ownProps = Object.keys(obj);
    var i = ownProps.length;
    var resArray = new Array(i);
    while(i--)resArray[i] = [
        ownProps[i],
        obj[ownProps[i]]
    ];
    return resArray;
};
var $a70d8592f51cbeef$var$IdentityStoreImpl = /** @class */ function() {
    function IdentityStoreImpl() {
        this.identity = {
            userProperties: {}
        };
        this.listeners = new Set();
    }
    IdentityStoreImpl.prototype.editIdentity = function() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self1 = this;
        var actingUserProperties = $a70d8592f51cbeef$var$__assign({}, this.identity.userProperties);
        var actingIdentity = $a70d8592f51cbeef$var$__assign($a70d8592f51cbeef$var$__assign({}, this.identity), {
            userProperties: actingUserProperties
        });
        return {
            setUserId: function(userId) {
                actingIdentity.userId = userId;
                return this;
            },
            setDeviceId: function(deviceId) {
                actingIdentity.deviceId = deviceId;
                return this;
            },
            setUserProperties: function(userProperties) {
                actingIdentity.userProperties = userProperties;
                return this;
            },
            setOptOut: function(optOut) {
                actingIdentity.optOut = optOut;
                return this;
            },
            updateUserProperties: function(actions) {
                var e_1, _a, e_2, _b, e_3, _c;
                var actingProperties = actingIdentity.userProperties || {};
                try {
                    for(var _d = $a70d8592f51cbeef$var$__values(Object.entries(actions)), _e = _d.next(); !_e.done; _e = _d.next()){
                        var _f = $a70d8592f51cbeef$var$__read(_e.value, 2), action = _f[0], properties = _f[1];
                        switch(action){
                            case $a70d8592f51cbeef$var$ID_OP_SET:
                                try {
                                    for(var _g = (e_2 = void 0, $a70d8592f51cbeef$var$__values(Object.entries(properties))), _h = _g.next(); !_h.done; _h = _g.next()){
                                        var _j = $a70d8592f51cbeef$var$__read(_h.value, 2), key = _j[0], value = _j[1];
                                        actingProperties[key] = value;
                                    }
                                } catch (e_2_1) {
                                    e_2 = {
                                        error: e_2_1
                                    };
                                } finally{
                                    try {
                                        if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                                    } finally{
                                        if (e_2) throw e_2.error;
                                    }
                                }
                                break;
                            case $a70d8592f51cbeef$var$ID_OP_UNSET:
                                try {
                                    for(var _k = (e_3 = void 0, $a70d8592f51cbeef$var$__values(Object.keys(properties))), _l = _k.next(); !_l.done; _l = _k.next()){
                                        var key = _l.value;
                                        delete actingProperties[key];
                                    }
                                } catch (e_3_1) {
                                    e_3 = {
                                        error: e_3_1
                                    };
                                } finally{
                                    try {
                                        if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
                                    } finally{
                                        if (e_3) throw e_3.error;
                                    }
                                }
                                break;
                            case $a70d8592f51cbeef$var$ID_OP_CLEAR_ALL:
                                actingProperties = {};
                                break;
                        }
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                actingIdentity.userProperties = actingProperties;
                return this;
            },
            commit: function() {
                self1.setIdentity(actingIdentity);
                return this;
            }
        };
    };
    IdentityStoreImpl.prototype.getIdentity = function() {
        return $a70d8592f51cbeef$var$__assign({}, this.identity);
    };
    IdentityStoreImpl.prototype.setIdentity = function(identity) {
        var originalIdentity = $a70d8592f51cbeef$var$__assign({}, this.identity);
        this.identity = $a70d8592f51cbeef$var$__assign({}, identity);
        if (!$a70d8592f51cbeef$var$isEqual(originalIdentity, this.identity)) this.listeners.forEach(function(listener) {
            listener(identity);
        });
    };
    IdentityStoreImpl.prototype.addIdentityListener = function(listener) {
        this.listeners.add(listener);
    };
    IdentityStoreImpl.prototype.removeIdentityListener = function(listener) {
        this.listeners.delete(listener);
    };
    return IdentityStoreImpl;
}();
var $a70d8592f51cbeef$var$safeGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof $parcel$global !== 'undefined' ? $parcel$global : self;
var $a70d8592f51cbeef$export$5af12d25e001b77c = /** @class */ function() {
    function AnalyticsConnector() {
        this.identityStore = new $a70d8592f51cbeef$var$IdentityStoreImpl();
        this.eventBridge = new $a70d8592f51cbeef$var$EventBridgeImpl();
        this.applicationContextProvider = new $a70d8592f51cbeef$var$ApplicationContextProviderImpl();
    }
    AnalyticsConnector.getInstance = function(instanceName) {
        if (!$a70d8592f51cbeef$var$safeGlobal['analyticsConnectorInstances']) $a70d8592f51cbeef$var$safeGlobal['analyticsConnectorInstances'] = {};
        if (!$a70d8592f51cbeef$var$safeGlobal['analyticsConnectorInstances'][instanceName]) $a70d8592f51cbeef$var$safeGlobal['analyticsConnectorInstances'][instanceName] = new AnalyticsConnector();
        return $a70d8592f51cbeef$var$safeGlobal['analyticsConnectorInstances'][instanceName];
    };
    return AnalyticsConnector;
}();



var $7aedaea4df5fb4c3$export$4e27b19f1b537bc2 = function(instanceName) {
    if (instanceName === void 0) instanceName = (0, $c1d7ad7f2bf46bfb$export$beb3c3946c248b94);
    return (0, $a70d8592f51cbeef$export$5af12d25e001b77c).getInstance(instanceName);
};
var $7aedaea4df5fb4c3$export$ae185dd9f76bc0ec = function(userId, instanceName) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    $7aedaea4df5fb4c3$export$4e27b19f1b537bc2(instanceName).identityStore.editIdentity().setUserId(userId).commit();
};
var $7aedaea4df5fb4c3$export$2bf3e8de34602369 = function(deviceId, instanceName) {
    $7aedaea4df5fb4c3$export$4e27b19f1b537bc2(instanceName).identityStore.editIdentity().setDeviceId(deviceId).commit();
};


var $c4xZ2 = parcelRequire("c4xZ2");
var $12451edd1666d93e$export$e2de15bbd9edf9c6 = function() {
    var _a;
    var globalScope = (0, $c4xZ2.getGlobalScope)();
    /* istanbul ignore if */ if (!((_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.location) === null || _a === void 0 ? void 0 : _a.search)) return {};
    var pairs = globalScope.location.search.substring(1).split('&').filter(Boolean);
    var params = pairs.reduce(function(acc, curr) {
        var query = curr.split('=', 2);
        var key = $12451edd1666d93e$export$9c4c1f32e1ce3ceb(query[0]);
        var value = $12451edd1666d93e$export$9c4c1f32e1ce3ceb(query[1]);
        if (!value) return acc;
        acc[key] = value;
        return acc;
    }, {});
    return params;
};
var $12451edd1666d93e$export$9c4c1f32e1ce3ceb = function(value) {
    if (value === void 0) value = '';
    try {
        return decodeURIComponent(value);
    } catch (_a) {
        return '';
    }
};


var $bunH6 = parcelRequire("bunH6");

var $4d6ea4faec842874$export$1a68292eb68beee1 = /** @class */ function() {
    function IdentityEventSender() {
        this.name = 'identity';
        this.type = 'before';
        this.identityStore = (0, $7aedaea4df5fb4c3$export$4e27b19f1b537bc2)().identityStore;
    }
    IdentityEventSender.prototype.execute = function(context) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var userProperties;
            return (0, $bunH6.__generator)(this, function(_a) {
                userProperties = context.user_properties;
                if (userProperties) this.identityStore.editIdentity().updateUserProperties(userProperties).commit();
                return [
                    2 /*return*/ ,
                    context
                ];
            });
        });
    };
    IdentityEventSender.prototype.setup = function(config) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                if (config.instanceName) this.identityStore = (0, $7aedaea4df5fb4c3$export$4e27b19f1b537bc2)(config.instanceName).identityStore;
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return IdentityEventSender;
}();

var $1ee910ec69d47307$export$cd75ee83e0e7704a = function(sessionTimeout, lastEventTime) {
    if (lastEventTime === void 0) lastEventTime = Date.now();
    var currentTime = Date.now();
    var timeSinceLastEvent = currentTime - lastEventTime;
    return timeSinceLastEvent > sessionTimeout;
};

var $aba2f99b3693f7da$export$92e9c636606b8eed = null;


var $bunH6 = parcelRequire("bunH6");
var $2826c92ce36c32d2$export$a0fe9f8b2128cb93 = /** @class */ function() {
    function RemoteConfigLocalStorage(apiKey, logger) {
        this.key = "AMP_remote_config_".concat(apiKey.substring(0, 10));
        this.logger = logger;
    }
    RemoteConfigLocalStorage.prototype.fetchConfig = function() {
        var result = null;
        var failedRemoteConfigInfo = {
            remoteConfig: null,
            lastFetch: new Date()
        };
        try {
            result = localStorage.getItem(this.key);
        } catch (error) {
            this.logger.debug('Remote config localstorage failed to access: ', error);
            return Promise.resolve(failedRemoteConfigInfo);
        }
        if (result === null) {
            this.logger.debug('Remote config localstorage gets null because the key does not exist');
            return Promise.resolve(failedRemoteConfigInfo);
        }
        try {
            var remoteConfigInfo = JSON.parse(result);
            this.logger.debug("Remote config localstorage parsed successfully: ".concat(JSON.stringify(remoteConfigInfo)));
            return Promise.resolve({
                remoteConfig: remoteConfigInfo.remoteConfig,
                lastFetch: new Date(remoteConfigInfo.lastFetch)
            });
        } catch (error) {
            this.logger.debug('Remote config localstorage failed to parse: ', error);
            localStorage.removeItem(this.key);
            return Promise.resolve(failedRemoteConfigInfo);
        }
    };
    RemoteConfigLocalStorage.prototype.setConfig = function(config) {
        try {
            localStorage.setItem(this.key, JSON.stringify(config));
            this.logger.debug('Remote config localstorage set successfully.');
            return Promise.resolve(true);
        } catch (error) {
            this.logger.debug('Remote config localstorage failed to set: ', error);
        }
        return Promise.resolve(false);
    };
    return RemoteConfigLocalStorage;
}();



var $1cfaf5553b3af350$export$4f5cf0c872e34e20 = 'https://sr-client-cfg.amplitude.com/config';
var $1cfaf5553b3af350$export$65588397459b3f5c = 'https://sr-client-cfg.eu.amplitude.com/config';
var $1cfaf5553b3af350$export$3731fe3ffd3bb9df = 3;
var $1cfaf5553b3af350$var$CODE_STATUS = {
    INVALID_API_KEY: 401,
    FORBIDDEN: 403,
    RATE_LIMIT: 429
};
/**
 * The default timeout for fetch in milliseconds.
 * Linear backoff policy: timeout / retry times is the interval between fetch retry.
 */ var $1cfaf5553b3af350$var$DEFAULT_TIMEOUT = 1000;
/**
 * The minimum time between fetches in milliseconds.
 * This prevents too many requests from being sent in a short period of time.
 */ var $1cfaf5553b3af350$var$DEFAULT_MIN_TIME_BETWEEN_FETCHES = 300000; // 5 minutes
var $1cfaf5553b3af350$export$c5cb2b5ab8b7eb1a = /** @class */ function() {
    function RemoteConfigClient(apiKey, logger, serverZone, serverUrl) {
        if (serverZone === void 0) serverZone = 'US';
        // Registered callbackInfos by subscribe().
        this.callbackInfos = [];
        // Track the last successful fetch time for throttling (timestamp in milliseconds).
        this.lastSuccessfulFetch = null;
        // Store the in-flight fetch promise for deduplication.
        this.fetchPromise = null;
        // Used to skip periodic updateConfigs calls when API key is invalid.
        this.isLastFetchInvalidApiKey = false;
        this.apiKey = apiKey;
        this.serverUrl = serverUrl || (serverZone === 'US' ? $1cfaf5553b3af350$export$4f5cf0c872e34e20 : $1cfaf5553b3af350$export$65588397459b3f5c);
        this.logger = logger;
        this.storage = new (0, $2826c92ce36c32d2$export$a0fe9f8b2128cb93)(apiKey, logger);
    }
    RemoteConfigClient.prototype.subscribe = function(key, deliveryMode, callback) {
        var id = (0, $b8d06392fac4718b$export$bc35efed93511c4b)();
        var callbackInfo = {
            id: id,
            key: key,
            deliveryMode: deliveryMode,
            callback: callback
        };
        this.callbackInfos.push(callbackInfo);
        if (deliveryMode === 'all') this.subscribeAll(callbackInfo);
        else this.subscribeWaitForRemote(callbackInfo, deliveryMode.timeout);
        return id;
    };
    RemoteConfigClient.prototype.unsubscribe = function(id) {
        var index = this.callbackInfos.findIndex(function(callbackInfo) {
            return callbackInfo.id === id;
        });
        if (index === -1) {
            this.logger.debug("Remote config client unsubscribe failed because callback with id ".concat(id, " doesn't exist."));
            return false;
        }
        this.callbackInfos.splice(index, 1);
        this.logger.debug("Remote config client unsubscribe succeeded removing callback with id ".concat(id, "."));
        return true;
    };
    RemoteConfigClient.prototype.updateConfigs = function() {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var timeSinceLastFetch, result;
            var _this = this;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Check if we need to throttle based on last successful fetch time
                        if (this.lastSuccessfulFetch) {
                            timeSinceLastFetch = Date.now() - this.lastSuccessfulFetch;
                            if (timeSinceLastFetch < $1cfaf5553b3af350$var$DEFAULT_MIN_TIME_BETWEEN_FETCHES) {
                                this.logger.debug('Remote config client skipping updateConfigs: Too recent');
                                return [
                                    2 /*return*/ 
                                ];
                            }
                        }
                        return [
                            4 /*yield*/ ,
                            this.getOrCreateFetchPromise()
                        ];
                    case 1:
                        result = _a.sent();
                        this.storage.setConfig(result);
                        this.callbackInfos.forEach(function(callbackInfo) {
                            _this.sendCallback(callbackInfo, result, 'remote');
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get the in-flight fetch promise or create a new one.
     * This ensures multiple subscribe calls share the same network request.
     */ RemoteConfigClient.prototype.getOrCreateFetchPromise = function() {
        var _this = this;
        if (this.fetchPromise) return this.fetchPromise;
        if (this.isLastFetchInvalidApiKey) {
            this.logger.debug('Remote config client skipping fetch: Invalid API key');
            this.fetchPromise = Promise.resolve({
                remoteConfig: null,
                lastFetch: new Date()
            }).finally(function() {
                _this.fetchPromise = null;
            });
            return this.fetchPromise;
        }
        this.fetchPromise = this.fetch().then(function(result) {
            // Update last successful fetch time if we got a valid config
            if (result.remoteConfig !== null) _this.lastSuccessfulFetch = Date.now();
            return result;
        }).finally(function() {
            // Clear the promise after it settles (success or failure)
            _this.fetchPromise = null;
        });
        return this.fetchPromise;
    };
    /**
     * Send remote first. If it's already complete, we can skip the cached response.
     * - if remote is fetched first, no cache fetch.
     * - if cache is fetched first, still fetching remote.
     */ RemoteConfigClient.prototype.subscribeAll = function(callbackInfo) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var remotePromise, cachePromise, result;
            var _this = this;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        remotePromise = this.getOrCreateFetchPromise().then(function(result) {
                            _this.logger.debug("Remote config client subscription all mode fetched from remote: ".concat(JSON.stringify(result)));
                            _this.sendCallback(callbackInfo, result, 'remote');
                            _this.storage.setConfig(result);
                        });
                        cachePromise = this.storage.fetchConfig().then(function(result) {
                            return result;
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.race([
                                remotePromise,
                                cachePromise
                            ])
                        ];
                    case 1:
                        result = _a.sent();
                        // If cache is fetched first, wait for remote.
                        if (result !== undefined) {
                            this.logger.debug("Remote config client subscription all mode fetched from cache: ".concat(JSON.stringify(result)));
                            // Skip sending callback if cache is empty (first time user).
                            if (result.remoteConfig !== null) this.sendCallback(callbackInfo, result, 'cache');
                            else this.logger.debug('Remote config client skips sending callback because cache is empty (first time user).');
                        }
                        return [
                            4 /*yield*/ ,
                            remotePromise
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Waits for a remote response until the given timeout, then return a cached copy, if available.
     */ RemoteConfigClient.prototype.subscribeWaitForRemote = function(callbackInfo, timeout) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var timeoutPromise, result, error_1, result;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        timeoutPromise = new Promise(function(_, reject) {
                            setTimeout(function() {
                                reject('Timeout exceeded');
                            }, timeout);
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.race([
                                this.getOrCreateFetchPromise(),
                                timeoutPromise
                            ])
                        ];
                    case 2:
                        result = _a.sent();
                        this.logger.debug('Remote config client subscription wait for remote mode returns from remote.');
                        this.sendCallback(callbackInfo, result, 'remote');
                        this.storage.setConfig(result);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        error_1 = _a.sent();
                        this.logger.debug('Remote config client subscription wait for remote mode exceeded timeout. Try to fetch from cache.');
                        return [
                            4 /*yield*/ ,
                            this.storage.fetchConfig()
                        ];
                    case 4:
                        result = _a.sent();
                        if (result.remoteConfig !== null) {
                            this.logger.debug('Remote config client subscription wait for remote mode returns a cached copy.');
                            this.sendCallback(callbackInfo, result, 'cache');
                        } else {
                            this.logger.debug('Remote config client subscription wait for remote mode failed to fetch cache.');
                            this.sendCallback(callbackInfo, result, 'remote');
                        }
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Call the callback with filtered remote config based on key.
     * @param remoteConfigInfo - the whole remote config object without filtering by key.
     */ RemoteConfigClient.prototype.sendCallback = function(callbackInfo, remoteConfigInfo, source) {
        callbackInfo.lastCallback = new Date();
        var filteredConfig;
        if (callbackInfo.key) // Filter remote config by key.
        // For example, if remote config is {a: {b: {c: 1}}},
        // if key = 'a', filter result is {b: {c: 1}};
        // if key = 'a.b', filter result is {c: 1}
        filteredConfig = callbackInfo.key.split('.').reduce(function(config, key) {
            if (config === null) return config;
            return key in config ? config[key] : null;
        }, remoteConfigInfo.remoteConfig);
        else filteredConfig = remoteConfigInfo.remoteConfig;
        callbackInfo.callback(filteredConfig, source, remoteConfigInfo.lastFetch);
    };
    /**
     * Fetch remote config from remote.
     * @param retries - the number of retries. default is 3.
     * @param timeout - the timeout in milliseconds. Default is 1000.
     * This timeout serves two purposes:
     * 1. It determines how long to wait for each remote config fetch request before aborting it.
     *    If the fetch does not complete within the specified timeout, the request is cancelled using AbortController,
     *    and the attempt is considered failed (and may be retried if retries remain).
     * 2. It is also used to calculate the interval between retries. The total timeout is divided by the number of retries,
     *    so each retry waits for (timeout / retries) milliseconds before the next attempt (linear backoff).
     * Retry behavior by status code:
     * - 401: invalid API key (stop retries and disable future updateConfigs calls).
     * - 429: retry up to max retries.
     * - other 4xx: no retry.
     * - 5xx and network failures: retry up to max retries.
     * @returns the remote config info. null if failed to fetch or the response is not valid JSON.
     */ RemoteConfigClient.prototype.fetch = function(retries, timeout) {
        if (retries === void 0) retries = $1cfaf5553b3af350$export$3731fe3ffd3bb9df;
        if (timeout === void 0) timeout = $1cfaf5553b3af350$var$DEFAULT_TIMEOUT;
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var interval, failedRemoteConfigInfo, _loop_1, this_1, attempt, state_1;
            var _this = this;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        interval = timeout / retries;
                        failedRemoteConfigInfo = {
                            remoteConfig: null,
                            lastFetch: new Date()
                        };
                        _loop_1 = function(attempt) {
                            var shouldRetry, abortController, timeoutId, res, body, remoteConfig, error_2;
                            return (0, $bunH6.__generator)(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        shouldRetry = true;
                                        abortController = new AbortController();
                                        timeoutId = setTimeout(function() {
                                            return abortController.abort();
                                        }, timeout);
                                        _b.label = 1;
                                    case 1:
                                        _b.trys.push([
                                            1,
                                            7,
                                            8,
                                            9
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            fetch(this_1.getUrlParams(), {
                                                method: 'GET',
                                                headers: {
                                                    Accept: '*/*'
                                                },
                                                signal: abortController.signal
                                            })
                                        ];
                                    case 2:
                                        res = _b.sent();
                                        if (!!res.ok) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            res.text()
                                        ];
                                    case 3:
                                        body = _b.sent();
                                        this_1.logger.debug("Remote config client fetch with retry time ".concat(retries, " failed with ").concat(res.status, ": ").concat(body));
                                        if (res.status === $1cfaf5553b3af350$var$CODE_STATUS.INVALID_API_KEY || res.status === $1cfaf5553b3af350$var$CODE_STATUS.FORBIDDEN) {
                                            this_1.logger.error("Remote config client fetch failed with ".concat(res.status, ". Invalid API key; future fetches will be skipped."));
                                            this_1.isLastFetchInvalidApiKey = true;
                                            shouldRetry = false;
                                        } else if (res.status >= 400 && res.status < 500 && res.status !== $1cfaf5553b3af350$var$CODE_STATUS.RATE_LIMIT) shouldRetry = false;
                                        return [
                                            3 /*break*/ ,
                                            6
                                        ];
                                    case 4:
                                        return [
                                            4 /*yield*/ ,
                                            res.json()
                                        ];
                                    case 5:
                                        remoteConfig = _b.sent();
                                        return [
                                            2 /*return*/ ,
                                            {
                                                value: {
                                                    remoteConfig: remoteConfig,
                                                    lastFetch: new Date()
                                                }
                                            }
                                        ];
                                    case 6:
                                        return [
                                            3 /*break*/ ,
                                            9
                                        ];
                                    case 7:
                                        error_2 = _b.sent();
                                        // Handle rejects when the request fails, for example, a network error or timeout
                                        if (error_2 instanceof Error && error_2.name === 'AbortError') this_1.logger.debug("Remote config client fetch with retry time ".concat(retries, " timed out after ").concat(timeout, "ms"));
                                        else this_1.logger.debug("Remote config client fetch with retry time ".concat(retries, " is rejected because: "), error_2);
                                        return [
                                            3 /*break*/ ,
                                            9
                                        ];
                                    case 8:
                                        // Clear the timeout since request completed or failed
                                        clearTimeout(timeoutId);
                                        return [
                                            7 /*endfinally*/ 
                                        ];
                                    case 9:
                                        if (!shouldRetry) return [
                                            2 /*return*/ ,
                                            "break"
                                        ];
                                        if (!(attempt < retries - 1)) return [
                                            3 /*break*/ ,
                                            11
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            new Promise(function(resolve) {
                                                return setTimeout(resolve, _this.getJitterDelay(interval));
                                            })
                                        ];
                                    case 10:
                                        _b.sent();
                                        _b.label = 11;
                                    case 11:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        attempt = 0;
                        _a.label = 1;
                    case 1:
                        if (!(attempt < retries)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            5 /*yield**/ ,
                            _loop_1(attempt)
                        ];
                    case 2:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object") return [
                            2 /*return*/ ,
                            state_1.value
                        ];
                        if (state_1 === "break") return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 3;
                    case 3:
                        attempt++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            failedRemoteConfigInfo
                        ];
                }
            });
        });
    };
    /**
     * Return jitter in the bound of [0,baseDelay) and then floor round.
     */ RemoteConfigClient.prototype.getJitterDelay = function(baseDelay) {
        return Math.floor(Math.random() * baseDelay);
    };
    RemoteConfigClient.prototype.getUrlParams = function() {
        // URL encode the API key to handle special characters
        var encodedApiKey = encodeURIComponent(this.apiKey);
        var urlParams = new URLSearchParams();
        urlParams.append('config_group', RemoteConfigClient.CONFIG_GROUP);
        return "".concat(this.serverUrl, "/").concat(encodedApiKey, "?").concat(urlParams.toString());
    };
    RemoteConfigClient.CONFIG_GROUP = 'browser';
    return RemoteConfigClient;
}();


var $bunH6 = parcelRequire("bunH6");

var $de0ca8ba746429f4$export$5c685df9b6b94d82 = /** @class */ function() {
    function Revenue() {
        this.productId = '';
        this.quantity = 1;
        this.price = 0.0;
    }
    Revenue.prototype.setProductId = function(productId) {
        this.productId = productId;
        return this;
    };
    Revenue.prototype.setQuantity = function(quantity) {
        if (quantity > 0) this.quantity = quantity;
        return this;
    };
    Revenue.prototype.setPrice = function(price) {
        this.price = price;
        return this;
    };
    Revenue.prototype.setRevenueType = function(revenueType) {
        this.revenueType = revenueType;
        return this;
    };
    Revenue.prototype.setCurrency = function(currency) {
        this.currency = currency;
        return this;
    };
    Revenue.prototype.setRevenue = function(revenue) {
        this.revenue = revenue;
        return this;
    };
    Revenue.prototype.setReceipt = function(receipt) {
        this.receipt = receipt;
        return this;
    };
    Revenue.prototype.setReceiptSig = function(receiptSig) {
        this.receiptSig = receiptSig;
        return this;
    };
    Revenue.prototype.setEventProperties = function(properties) {
        try {
            // JSON.stringify drops undefined/function/symbol values before validation,
            // so a single undefined property no longer causes the whole object to be rejected.
            var filtered = JSON.parse(JSON.stringify(properties));
            if ((0, $502327478cd826cd$export$16a0268bc22b47b0)(filtered)) this.properties = filtered;
        } catch (_a) {
        // no-op: invalid properties are ignored
        }
        return this;
    };
    Revenue.prototype.getEventProperties = function() {
        var eventProperties = this.properties ? (0, $bunH6.__assign)({}, this.properties) : {};
        eventProperties[$de0ca8ba746429f4$export$50116cceae2de93.REVENUE_PRODUCT_ID] = this.productId;
        eventProperties[$de0ca8ba746429f4$export$50116cceae2de93.REVENUE_QUANTITY] = this.quantity;
        eventProperties[$de0ca8ba746429f4$export$50116cceae2de93.REVENUE_PRICE] = this.price;
        eventProperties[$de0ca8ba746429f4$export$50116cceae2de93.REVENUE_TYPE] = this.revenueType;
        eventProperties[$de0ca8ba746429f4$export$50116cceae2de93.REVENUE_CURRENCY] = this.currency;
        eventProperties[$de0ca8ba746429f4$export$50116cceae2de93.REVENUE] = this.revenue;
        eventProperties[$de0ca8ba746429f4$export$50116cceae2de93.RECEIPT] = this.receipt;
        eventProperties[$de0ca8ba746429f4$export$50116cceae2de93.RECEIPT_SIG] = this.receiptSig;
        return eventProperties;
    };
    return Revenue;
}();
var $de0ca8ba746429f4$export$50116cceae2de93;
(function(RevenueProperty) {
    RevenueProperty["REVENUE_PRODUCT_ID"] = "$productId";
    RevenueProperty["REVENUE_QUANTITY"] = "$quantity";
    RevenueProperty["REVENUE_PRICE"] = "$price";
    RevenueProperty["REVENUE_TYPE"] = "$revenueType";
    RevenueProperty["REVENUE_CURRENCY"] = "$currency";
    RevenueProperty["REVENUE"] = "$revenue";
    RevenueProperty["RECEIPT"] = "$receipt";
    RevenueProperty["RECEIPT_SIG"] = "$receiptSig";
})($de0ca8ba746429f4$export$50116cceae2de93 || ($de0ca8ba746429f4$export$50116cceae2de93 = {}));

/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ var $853f62061bc58afc$exports = {};
var $853f62061bc58afc$var$hasProp = Object.prototype.hasOwnProperty;
function $853f62061bc58afc$var$throwsMessage(err) {
    return '[Throws: ' + (err ? err.message : '?') + ']';
}
function $853f62061bc58afc$var$safeGetValueFromPropertyOnObject(obj, property) {
    if ($853f62061bc58afc$var$hasProp.call(obj, property)) try {
        return obj[property];
    } catch (err) {
        return $853f62061bc58afc$var$throwsMessage(err);
    }
    return obj[property];
}
function $853f62061bc58afc$var$ensureProperties(obj) {
    var seen = []; // store references to objects we have seen before
    function visit(obj) {
        if (obj === null || typeof obj !== 'object') return obj;
        if (seen.indexOf(obj) !== -1) return '[Circular]';
        seen.push(obj);
        if (typeof obj.toJSON === 'function') try {
            var fResult = visit(obj.toJSON());
            seen.pop();
            return fResult;
        } catch (err) {
            return $853f62061bc58afc$var$throwsMessage(err);
        }
        if (Array.isArray(obj)) {
            var aResult = obj.map(visit);
            seen.pop();
            return aResult;
        }
        var result = Object.keys(obj).reduce(function(result, prop) {
            // prevent faulty defined getter properties
            result[prop] = visit($853f62061bc58afc$var$safeGetValueFromPropertyOnObject(obj, prop));
            return result;
        }, {});
        seen.pop();
        return result;
    }
    return visit(obj);
}
$853f62061bc58afc$exports = function(data, replacer, space) {
    return JSON.stringify($853f62061bc58afc$var$ensureProperties(data), replacer, space);
};
$853f62061bc58afc$exports.ensureProperties = $853f62061bc58afc$var$ensureProperties;


/* istanbul ignore next */ var $d6956fea7d3d8743$export$abc3f407e87918a4 = $853f62061bc58afc$exports.default || $853f62061bc58afc$exports;



var $bunH6 = parcelRequire("bunH6");
/**
 * Returns false if autocapture === false or if autocapture[event],
 * otherwise returns true (even if "config.autocapture === undefined")
 */ var $d81f8d7bf36b1bca$var$isTrackingEnabled = function(autocapture, event) {
    if (typeof autocapture === 'boolean') return autocapture;
    if ((autocapture === null || autocapture === void 0 ? void 0 : autocapture[event]) === false) return false;
    return true;
};
var $d81f8d7bf36b1bca$export$d20b42d02fe617b9 = function(autocapture) {
    return $d81f8d7bf36b1bca$var$isTrackingEnabled(autocapture, 'attribution');
};
var $d81f8d7bf36b1bca$export$439965f940d78a9 = function(autocapture) {
    return $d81f8d7bf36b1bca$var$isTrackingEnabled(autocapture, 'fileDownloads');
};
var $d81f8d7bf36b1bca$export$affa82d896586aa0 = function(autocapture) {
    return $d81f8d7bf36b1bca$var$isTrackingEnabled(autocapture, 'formInteractions');
};
var $d81f8d7bf36b1bca$export$b6f98464b3039a53 = function(autocapture) {
    return $d81f8d7bf36b1bca$var$isTrackingEnabled(autocapture, 'pageViews');
};
var $d81f8d7bf36b1bca$export$39cec01e4b71f7d6 = function(autocapture) {
    return $d81f8d7bf36b1bca$var$isTrackingEnabled(autocapture, 'sessions');
};
var $d81f8d7bf36b1bca$export$ff6c9a4d8f74be2e = function(autocapture) {
    return $d81f8d7bf36b1bca$var$isTrackingEnabled(autocapture, 'pageUrlEnrichment');
};
var $d81f8d7bf36b1bca$export$5665ccdd71d94227 = function(autocapture) {
    if (typeof autocapture === 'boolean') return autocapture;
    if (typeof autocapture === 'object' && (autocapture.networkTracking === true || typeof autocapture.networkTracking === 'object')) return true;
    return false;
};
var $d81f8d7bf36b1bca$export$61bfa9a947732d3c = function(autocapture) {
    if (typeof autocapture === 'boolean') return autocapture;
    if (typeof autocapture === 'object' && (autocapture.elementInteractions === true || typeof autocapture.elementInteractions === 'object')) return true;
    return false;
};
var $d81f8d7bf36b1bca$export$75d23e835a5fbff1 = function(autocapture) {
    if (typeof autocapture === 'boolean') return autocapture;
    if (typeof autocapture === 'object' && autocapture.webVitals === true) return true;
    return false;
};
var $d81f8d7bf36b1bca$export$29e2986f1d1dc443 = function(autocapture) {
    if (typeof autocapture === 'boolean') return autocapture;
    if (typeof autocapture === 'object' && (autocapture.frustrationInteractions === true || typeof autocapture.frustrationInteractions === 'object')) return true;
    return false;
};
var $d81f8d7bf36b1bca$export$a6ad12940a2ffeac = function(config) {
    if ($d81f8d7bf36b1bca$export$61bfa9a947732d3c(config.autocapture) && typeof config.autocapture === 'object' && typeof config.autocapture.elementInteractions === 'object') return config.autocapture.elementInteractions;
    return undefined;
};
var $d81f8d7bf36b1bca$export$45f20628c2a4aad3 = function(config) {
    if ($d81f8d7bf36b1bca$export$29e2986f1d1dc443(config.autocapture) && typeof config.autocapture === 'object' && typeof config.autocapture.frustrationInteractions === 'object') return config.autocapture.frustrationInteractions;
    return undefined;
};
var $d81f8d7bf36b1bca$export$73c26cfb4505ddfc = function(config) {
    var _a;
    if ($d81f8d7bf36b1bca$export$5665ccdd71d94227(config.autocapture)) {
        var networkTrackingConfig = void 0;
        if (typeof config.autocapture === 'object' && typeof config.autocapture.networkTracking === 'object') networkTrackingConfig = config.autocapture.networkTracking;
        else if (config.networkTrackingOptions) networkTrackingConfig = config.networkTrackingOptions;
        return (0, $bunH6.__assign)((0, $bunH6.__assign)({}, networkTrackingConfig), {
            captureRules: (_a = networkTrackingConfig === null || networkTrackingConfig === void 0 ? void 0 : networkTrackingConfig.captureRules) === null || _a === void 0 ? void 0 : _a.map(function(rule) {
                var _a, _b, _c;
                // if URLs and hosts are both set, URLs take precedence over hosts
                if (((_a = rule.urls) === null || _a === void 0 ? void 0 : _a.length) && ((_b = rule.hosts) === null || _b === void 0 ? void 0 : _b.length)) {
                    var hostsString = JSON.stringify(rule.hosts);
                    var urlsString = JSON.stringify(rule.urls);
                    /* istanbul ignore next */ (_c = config.loggerProvider) === null || _c === void 0 || _c.warn("Found network capture rule with both urls='".concat(urlsString, "' and hosts='").concat(hostsString, "' set. ") + "Definition of urls takes precedence over hosts, so ignoring hosts.");
                    return (0, $bunH6.__assign)((0, $bunH6.__assign)({}, rule), {
                        hosts: undefined
                    });
                }
                return rule;
            })
        });
    }
    return;
};
var $d81f8d7bf36b1bca$export$12e70b7a43554816 = function(config) {
    var trackOn = function() {
        return false;
    };
    var trackHistoryChanges = undefined;
    var eventType;
    var pageCounter = config.pageCounter;
    var isDefaultPageViewTrackingEnabled = $d81f8d7bf36b1bca$export$b6f98464b3039a53(config.defaultTracking);
    if (isDefaultPageViewTrackingEnabled) {
        trackOn = undefined;
        eventType = undefined;
        if (config.defaultTracking && typeof config.defaultTracking === 'object' && config.defaultTracking.pageViews && typeof config.defaultTracking.pageViews === 'object') {
            if ('trackOn' in config.defaultTracking.pageViews) trackOn = config.defaultTracking.pageViews.trackOn;
            if ('trackHistoryChanges' in config.defaultTracking.pageViews) trackHistoryChanges = config.defaultTracking.pageViews.trackHistoryChanges;
            if ('eventType' in config.defaultTracking.pageViews && config.defaultTracking.pageViews.eventType) eventType = config.defaultTracking.pageViews.eventType;
        }
    }
    return {
        trackOn: trackOn,
        trackHistoryChanges: trackHistoryChanges,
        eventType: eventType,
        pageCounter: pageCounter
    };
};
var $d81f8d7bf36b1bca$export$4048df75bcf826ca = function(config) {
    if ($d81f8d7bf36b1bca$export$d20b42d02fe617b9(config.defaultTracking) && config.defaultTracking && typeof config.defaultTracking === 'object' && config.defaultTracking.attribution && typeof config.defaultTracking.attribution === 'object') return (0, $bunH6.__assign)({}, config.defaultTracking.attribution);
    return {};
};
var $d81f8d7bf36b1bca$export$1aa90c4af41b4740 = function(config) {
    if ($d81f8d7bf36b1bca$export$affa82d896586aa0(config.defaultTracking) && config.defaultTracking && typeof config.defaultTracking === 'object' && typeof config.defaultTracking.formInteractions === 'object') return config.defaultTracking.formInteractions;
    return undefined;
};


/**
 * Applies the proxied functions on the proxied amplitude snippet to an instance of the real object.
 * @ignore
 */ var $cec89fb4b175ee3b$export$73e72da30c1b0013 = function(instance, queue) {
    $cec89fb4b175ee3b$export$2804ceeb41243ddf(instance, queue);
};
var $cec89fb4b175ee3b$export$2804ceeb41243ddf = function(instance, queue) {
    for(var i = 0; i < queue.length; i++){
        var _a = queue[i], name_1 = _a.name, args = _a.args, resolve = _a.resolve;
        var fn = instance && instance[name_1];
        if (typeof fn === 'function') {
            var result = fn.apply(instance, args);
            if (typeof resolve === 'function') resolve(result === null || result === void 0 ? void 0 : result.promise);
        }
    }
    return instance;
};
var $cec89fb4b175ee3b$export$cca5e90941913a5a = function(instance) {
    var instanceProxy = instance;
    return instanceProxy && instanceProxy._q !== undefined;
};



var $bunH6 = parcelRequire("bunH6");
var $34381590e083b5c4$export$64783e31db14f0ba = function() {
    var _a, _b, _c, _d;
    if (typeof navigator === 'undefined') return '';
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var userLanguage = navigator.userLanguage;
    return (_d = (_c = (_b = (_a = navigator.languages) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : navigator.language) !== null && _c !== void 0 ? _c : userLanguage) !== null && _d !== void 0 ? _d : '';
};


var $01a0eb29ad2e7237$export$a4ad2735b021c132 = '2.36.9';


var $c1e7cd9d77dd64a3$export$cf504a7bb41ef3ce = 'amplitude-ts';


var $5ebaf3e7c6cf42a0$var$BROWSER_PLATFORM = 'Web';
var $5ebaf3e7c6cf42a0$var$IP_ADDRESS = '$remote';
var $5ebaf3e7c6cf42a0$export$841858b892ce1f4c = /** @class */ function() {
    function Context() {
        this.name = '@amplitude/plugin-context-browser';
        this.type = 'before';
        this.library = "".concat((0, $c1e7cd9d77dd64a3$export$cf504a7bb41ef3ce), "/").concat((0, $01a0eb29ad2e7237$export$a4ad2735b021c132));
        /* istanbul ignore else */ if (typeof navigator !== 'undefined') this.userAgent = navigator.userAgent;
    }
    Context.prototype.setup = function(config) {
        this.config = config;
        return Promise.resolve(undefined);
    };
    Context.prototype.execute = function(context) {
        var _a, _b;
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var time, lastEventId, nextEventId, event;
            return (0, $bunH6.__generator)(this, function(_c) {
                time = new Date().getTime();
                lastEventId = (_a = this.config.lastEventId) !== null && _a !== void 0 ? _a : -1;
                nextEventId = (_b = context.event_id) !== null && _b !== void 0 ? _b : lastEventId + 1;
                this.config.lastEventId = nextEventId;
                if (!context.time) this.config.lastEventTime = time;
                event = (0, $bunH6.__assign)((0, $bunH6.__assign)((0, $bunH6.__assign)((0, $bunH6.__assign)((0, $bunH6.__assign)((0, $bunH6.__assign)((0, $bunH6.__assign)((0, $bunH6.__assign)({
                    user_id: this.config.userId,
                    device_id: this.config.deviceId,
                    session_id: this.config.sessionId,
                    time: time
                }, this.config.appVersion && {
                    app_version: this.config.appVersion
                }), this.config.trackingOptions.platform && {
                    platform: $5ebaf3e7c6cf42a0$var$BROWSER_PLATFORM
                }), this.config.trackingOptions.language && {
                    language: (0, $34381590e083b5c4$export$64783e31db14f0ba)()
                }), this.config.trackingOptions.ipAddress && {
                    ip: $5ebaf3e7c6cf42a0$var$IP_ADDRESS
                }), {
                    insert_id: (0, $b8d06392fac4718b$export$bc35efed93511c4b)(),
                    partner_id: this.config.partnerId,
                    plan: this.config.plan
                }), this.config.ingestionMetadata && {
                    ingestion_metadata: {
                        source_name: this.config.ingestionMetadata.sourceName,
                        source_version: this.config.ingestionMetadata.sourceVersion
                    }
                }), context), {
                    event_id: nextEventId,
                    library: this.library,
                    user_agent: this.userAgent
                });
                return [
                    2 /*return*/ ,
                    event
                ];
            });
        });
    };
    return Context;
}();



var $bunH6 = parcelRequire("bunH6");

var $7b3hW = parcelRequire("7b3hW");
var $c849684e046f6e02$export$4820a8f23184d6a3 = function(apiKey, postKey, limit) {
    if (postKey === void 0) postKey = '';
    if (limit === void 0) limit = 10;
    return [
        (0, $c1d7ad7f2bf46bfb$export$34512634d73abf96),
        postKey,
        apiKey.substring(0, limit)
    ].filter(Boolean).join('_');
};
var $c849684e046f6e02$export$5689a36821966445 = function(apiKey) {
    return "".concat((0, $c1d7ad7f2bf46bfb$export$34512634d73abf96).toLowerCase(), "_").concat(apiKey.substring(0, 6));
};


var $bunH6 = parcelRequire("bunH6");
var $57b2afbf7a75b010$export$d7392285c701ecf5 = /** @class */ function() {
    function MemoryStorage() {
        this.memoryStorage = new Map();
    }
    MemoryStorage.prototype.isEnabled = function() {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    true
                ];
            });
        });
    };
    MemoryStorage.prototype.get = function(key) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.memoryStorage.get(key)
                ];
            });
        });
    };
    MemoryStorage.prototype.getRaw = function(key) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var value;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.get(key)
                        ];
                    case 1:
                        value = _a.sent();
                        return [
                            2 /*return*/ ,
                            value ? JSON.stringify(value) : undefined
                        ];
                }
            });
        });
    };
    MemoryStorage.prototype.set = function(key, value) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                this.memoryStorage.set(key, value);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    MemoryStorage.prototype.remove = function(key) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                this.memoryStorage.delete(key);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    MemoryStorage.prototype.reset = function() {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                this.memoryStorage.clear();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return MemoryStorage;
}();



var $bunH6 = parcelRequire("bunH6");

var $bunH6 = parcelRequire("bunH6");
var $588c8318ebeb48b5$export$2baa60fa09b100be = /** @class */ function() {
    function BrowserStorage(storage) {
        this.storage = storage;
    }
    BrowserStorage.prototype.isEnabled = function() {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var random, testStorage, testKey, value, _a;
            return (0, $bunH6.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        /* istanbul ignore if */ if (!this.storage) return [
                            2 /*return*/ ,
                            false
                        ];
                        random = String(Date.now());
                        testStorage = new BrowserStorage(this.storage);
                        testKey = 'AMP_TEST';
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            4,
                            5,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            testStorage.set(testKey, random)
                        ];
                    case 2:
                        _b.sent();
                        return [
                            4 /*yield*/ ,
                            testStorage.get(testKey)
                        ];
                    case 3:
                        value = _b.sent();
                        return [
                            2 /*return*/ ,
                            value === random
                        ];
                    case 4:
                        _a = _b.sent();
                        /* istanbul ignore next */ return [
                            2 /*return*/ ,
                            false
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            testStorage.remove(testKey)
                        ];
                    case 6:
                        _b.sent();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    BrowserStorage.prototype.get = function(key) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var value, _a;
            return (0, $bunH6.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _b.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.getRaw(key)
                        ];
                    case 1:
                        value = _b.sent();
                        if (!value) return [
                            2 /*return*/ ,
                            undefined
                        ];
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                        return [
                            2 /*return*/ ,
                            JSON.parse(value)
                        ];
                    case 2:
                        _a = _b.sent();
                        console.error("[Amplitude] Error: Could not get value from storage");
                        return [
                            2 /*return*/ ,
                            undefined
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    BrowserStorage.prototype.getRaw = function(key) {
        var _a;
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_b) {
                return [
                    2 /*return*/ ,
                    ((_a = this.storage) === null || _a === void 0 ? void 0 : _a.getItem(key)) || undefined
                ];
            });
        });
    };
    BrowserStorage.prototype.set = function(key, value) {
        var _a;
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_b) {
                try {
                    (_a = this.storage) === null || _a === void 0 || _a.setItem(key, JSON.stringify(value));
                } catch (_c) {
                //
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    BrowserStorage.prototype.remove = function(key) {
        var _a;
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_b) {
                try {
                    (_a = this.storage) === null || _a === void 0 || _a.removeItem(key);
                } catch (_c) {
                //
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    BrowserStorage.prototype.reset = function() {
        var _a;
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_b) {
                try {
                    (_a = this.storage) === null || _a === void 0 || _a.clear();
                } catch (_c) {
                //
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return BrowserStorage;
}();


var $c4xZ2 = parcelRequire("c4xZ2");
var $fc4ac5d853769364$var$MAX_ARRAY_LENGTH = 1000;
var $fc4ac5d853769364$export$19fffca37ef3e106 = /** @class */ function(_super) {
    (0, $bunH6.__extends)(LocalStorage, _super);
    function LocalStorage(config) {
        var _this = this;
        var _a, _b;
        var localStorage;
        try {
            localStorage = (_a = (0, $c4xZ2.getGlobalScope)()) === null || _a === void 0 ? void 0 : _a.localStorage;
        } catch (e) {
            (_b = config === null || config === void 0 ? void 0 : config.loggerProvider) === null || _b === void 0 || _b.debug("Failed to access localStorage. error=".concat(JSON.stringify(e)));
            localStorage = undefined;
        }
        _this = _super.call(this, localStorage) || this;
        _this.loggerProvider = config === null || config === void 0 ? void 0 : config.loggerProvider;
        return _this;
    }
    LocalStorage.prototype.set = function(key, value) {
        var _a;
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var droppedEventsCount;
            return (0, $bunH6.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(Array.isArray(value) && value.length > $fc4ac5d853769364$var$MAX_ARRAY_LENGTH)) return [
                            3 /*break*/ ,
                            2
                        ];
                        droppedEventsCount = value.length - $fc4ac5d853769364$var$MAX_ARRAY_LENGTH;
                        return [
                            4 /*yield*/ ,
                            _super.prototype.set.call(this, key, value.slice(0, $fc4ac5d853769364$var$MAX_ARRAY_LENGTH))
                        ];
                    case 1:
                        _b.sent();
                        (_a = this.loggerProvider) === null || _a === void 0 || _a.error("Failed to save ".concat(droppedEventsCount, " events because the queue length exceeded ").concat($fc4ac5d853769364$var$MAX_ARRAY_LENGTH, "."));
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            _super.prototype.set.call(this, key, value)
                        ];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return LocalStorage;
}((0, $588c8318ebeb48b5$export$2baa60fa09b100be));



var $bunH6 = parcelRequire("bunH6");

var $c4xZ2 = parcelRequire("c4xZ2");
var $769925a33a27b188$export$2c4b17e1c2e0931 = /** @class */ function(_super) {
    (0, $bunH6.__extends)(SessionStorage, _super);
    function SessionStorage() {
        var _a;
        return _super.call(this, (_a = (0, $c4xZ2.getGlobalScope)()) === null || _a === void 0 ? void 0 : _a.sessionStorage) || this;
    }
    return SessionStorage;
}((0, $588c8318ebeb48b5$export$2baa60fa09b100be));



var $bunH6 = parcelRequire("bunH6");


var $fed2d116b28b9375$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport() {}
    BaseTransport.prototype.send = function(_serverUrl, _payload, _enableRequestBodyCompression) {
        return Promise.resolve(null);
    };
    BaseTransport.prototype.buildResponse = function(responseJSON) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        if (typeof responseJSON !== 'object') return null;
        var statusCode = responseJSON.code || 0;
        var status = this.buildStatus(statusCode);
        switch(status){
            case (0, $89a82e180a05067f$export$96e9906d6d93a972).Success:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        eventsIngested: (_a = responseJSON.events_ingested) !== null && _a !== void 0 ? _a : 0,
                        payloadSizeBytes: (_b = responseJSON.payload_size_bytes) !== null && _b !== void 0 ? _b : 0,
                        serverUploadTime: (_c = responseJSON.server_upload_time) !== null && _c !== void 0 ? _c : 0
                    }
                };
            case (0, $89a82e180a05067f$export$96e9906d6d93a972).Invalid:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_d = responseJSON.error) !== null && _d !== void 0 ? _d : '',
                        missingField: (_e = responseJSON.missing_field) !== null && _e !== void 0 ? _e : '',
                        eventsWithInvalidFields: (_f = responseJSON.events_with_invalid_fields) !== null && _f !== void 0 ? _f : {},
                        eventsWithMissingFields: (_g = responseJSON.events_with_missing_fields) !== null && _g !== void 0 ? _g : {},
                        eventsWithInvalidIdLengths: (_h = responseJSON.events_with_invalid_id_lengths) !== null && _h !== void 0 ? _h : {},
                        epsThreshold: (_j = responseJSON.eps_threshold) !== null && _j !== void 0 ? _j : 0,
                        exceededDailyQuotaDevices: (_k = responseJSON.exceeded_daily_quota_devices) !== null && _k !== void 0 ? _k : {},
                        silencedDevices: (_l = responseJSON.silenced_devices) !== null && _l !== void 0 ? _l : [],
                        silencedEvents: (_m = responseJSON.silenced_events) !== null && _m !== void 0 ? _m : [],
                        throttledDevices: (_o = responseJSON.throttled_devices) !== null && _o !== void 0 ? _o : {},
                        throttledEvents: (_p = responseJSON.throttled_events) !== null && _p !== void 0 ? _p : []
                    }
                };
            case (0, $89a82e180a05067f$export$96e9906d6d93a972).PayloadTooLarge:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_q = responseJSON.error) !== null && _q !== void 0 ? _q : ''
                    }
                };
            case (0, $89a82e180a05067f$export$96e9906d6d93a972).RateLimit:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_r = responseJSON.error) !== null && _r !== void 0 ? _r : '',
                        epsThreshold: (_s = responseJSON.eps_threshold) !== null && _s !== void 0 ? _s : 0,
                        throttledDevices: (_t = responseJSON.throttled_devices) !== null && _t !== void 0 ? _t : {},
                        throttledUsers: (_u = responseJSON.throttled_users) !== null && _u !== void 0 ? _u : {},
                        exceededDailyQuotaDevices: (_v = responseJSON.exceeded_daily_quota_devices) !== null && _v !== void 0 ? _v : {},
                        exceededDailyQuotaUsers: (_w = responseJSON.exceeded_daily_quota_users) !== null && _w !== void 0 ? _w : {},
                        throttledEvents: (_x = responseJSON.throttled_events) !== null && _x !== void 0 ? _x : []
                    }
                };
            case (0, $89a82e180a05067f$export$96e9906d6d93a972).Timeout:
            default:
                return {
                    status: status,
                    statusCode: statusCode
                };
        }
    };
    BaseTransport.prototype.buildStatus = function(code) {
        if ((0, $24a8d3e88c6b49c1$export$1624c886bf20345d)(code)) return (0, $89a82e180a05067f$export$96e9906d6d93a972).Success;
        if (code === 429) return (0, $89a82e180a05067f$export$96e9906d6d93a972).RateLimit;
        if (code === 413) return (0, $89a82e180a05067f$export$96e9906d6d93a972).PayloadTooLarge;
        if (code === 408) return (0, $89a82e180a05067f$export$96e9906d6d93a972).Timeout;
        if (code >= 400 && code < 500) return (0, $89a82e180a05067f$export$96e9906d6d93a972).Invalid;
        if (code >= 500) return (0, $89a82e180a05067f$export$96e9906d6d93a972).Failed;
        return (0, $89a82e180a05067f$export$96e9906d6d93a972).Unknown;
    };
    return BaseTransport;
}();


var $bunH6 = parcelRequire("bunH6");
var $2bc5e65a15e2bc67$export$ea3cd743acaf402c = 2048;
function $2bc5e65a15e2bc67$export$542addb74dbea81b() {
    return typeof CompressionStream !== 'undefined';
}
function $2bc5e65a15e2bc67$export$54503a03a173137c(data) {
    return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
        var CompressionStreamImpl, stream, _a;
        return (0, $bunH6.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    CompressionStreamImpl = CompressionStream;
                    if (typeof CompressionStreamImpl === 'undefined') return [
                        2 /*return*/ ,
                        undefined
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    stream = new Blob([
                        data
                    ]).stream().pipeThrough(new CompressionStreamImpl('gzip'));
                    return [
                        4 /*yield*/ ,
                        new Response(stream).arrayBuffer()
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        _b.sent()
                    ];
                case 3:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        undefined
                    ];
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}


var $cbbafdbd33c1f0c3$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $bunH6.__extends)(XHRTransport, _super);
    function XHRTransport(customHeaders) {
        if (customHeaders === void 0) customHeaders = {};
        var _this = _super.call(this) || this;
        _this.state = {
            done: 4
        };
        _this.customHeaders = customHeaders;
        return _this;
    }
    XHRTransport.prototype.send = function(serverUrl, payload, shouldCompressUploadBody) {
        if (shouldCompressUploadBody === void 0) shouldCompressUploadBody = false;
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $bunH6.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        /* istanbul ignore if */ if (typeof XMLHttpRequest === 'undefined') reject(new Error('XHRTransport is not supported.'));
                        var xhr = new XMLHttpRequest();
                        xhr.open('POST', serverUrl, true);
                        xhr.onreadystatechange = function() {
                            if (xhr.readyState === _this.state.done) {
                                var responseText = xhr.responseText;
                                try {
                                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                                    resolve(_this.buildResponse(JSON.parse(responseText)));
                                } catch (_a) {
                                    resolve(_this.buildResponse({
                                        code: xhr.status
                                    }));
                                }
                            }
                        };
                        var headers = {
                            'Content-Type': 'application/json',
                            Accept: '*/*'
                        };
                        var bodyString = JSON.stringify(payload);
                        var shouldCompressBody = shouldCompressUploadBody && bodyString.length >= (0, $2bc5e65a15e2bc67$export$ea3cd743acaf402c) && (0, $2bc5e65a15e2bc67$export$542addb74dbea81b)();
                        var sendBody = function(body) {
                            var e_1, _a;
                            headers = (0, $bunH6.__assign)((0, $bunH6.__assign)({}, _this.customHeaders), headers);
                            try {
                                for(var _b = (0, $bunH6.__values)(Object.entries(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
                                    var _d = (0, $bunH6.__read)(_c.value, 2), key = _d[0], value = _d[1];
                                    xhr.setRequestHeader(key, value);
                                }
                            } catch (e_1_1) {
                                e_1 = {
                                    error: e_1_1
                                };
                            } finally{
                                try {
                                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                } finally{
                                    if (e_1) throw e_1.error;
                                }
                            }
                            xhr.send(body);
                        };
                        var doSend = function() {
                            return (0, $bunH6.__awaiter)(_this, void 0, void 0, function() {
                                var compressed;
                                return (0, $bunH6.__generator)(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            if (!shouldCompressBody) return [
                                                3 /*break*/ ,
                                                2
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                (0, $2bc5e65a15e2bc67$export$54503a03a173137c)(bodyString)
                                            ];
                                        case 1:
                                            compressed = _a.sent();
                                            if (compressed) {
                                                headers['Content-Encoding'] = 'gzip';
                                                sendBody(compressed);
                                            } else sendBody(bodyString);
                                            return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                        case 2:
                                            sendBody(bodyString);
                                            _a.label = 3;
                                        case 3:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        };
                        doSend().catch(reject);
                    })
                ];
            });
        });
    };
    return XHRTransport;
}((0, $fed2d116b28b9375$export$74b99d619e90f481));



var $bunH6 = parcelRequire("bunH6");

// Temporary browser-specific fetch transport with gzip support.
// TODO: Merge this implementation back into @amplitude/analytics-core FetchTransport
// once React Native SDK supports request body gzip.
var $423f8b44830d6047$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $bunH6.__extends)(FetchTransport, _super);
    function FetchTransport(customHeaders) {
        if (customHeaders === void 0) customHeaders = {};
        var _this = _super.call(this) || this;
        _this.customHeaders = customHeaders;
        return _this;
    }
    FetchTransport.prototype.send = function(serverUrl, payload, shouldCompressUploadBody) {
        if (shouldCompressUploadBody === void 0) shouldCompressUploadBody = false;
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var bodyString, shouldCompressBody, body, headers, compressed, options, response, responseText;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        /* istanbul ignore if */ if (typeof fetch === 'undefined') throw new Error('FetchTransport is not supported');
                        bodyString = JSON.stringify(payload);
                        shouldCompressBody = shouldCompressUploadBody && bodyString.length >= (0, $2bc5e65a15e2bc67$export$ea3cd743acaf402c) && (0, $2bc5e65a15e2bc67$export$542addb74dbea81b)();
                        body = bodyString;
                        headers = {
                            'Content-Type': 'application/json',
                            Accept: '*/*'
                        };
                        if (!shouldCompressBody) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $2bc5e65a15e2bc67$export$54503a03a173137c)(bodyString)
                        ];
                    case 1:
                        compressed = _a.sent();
                        if (compressed) {
                            headers['Content-Encoding'] = 'gzip';
                            body = compressed;
                        }
                        _a.label = 2;
                    case 2:
                        headers = (0, $bunH6.__assign)((0, $bunH6.__assign)({}, this.customHeaders), headers);
                        options = {
                            headers: headers,
                            body: body,
                            method: 'POST'
                        };
                        return [
                            4 /*yield*/ ,
                            fetch(serverUrl, options)
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            response.text()
                        ];
                    case 4:
                        responseText = _a.sent();
                        try {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                            return [
                                2 /*return*/ ,
                                this.buildResponse(JSON.parse(responseText))
                            ];
                        } catch (_b) {
                            return [
                                2 /*return*/ ,
                                this.buildResponse({
                                    code: response.status
                                })
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return FetchTransport;
}((0, $fed2d116b28b9375$export$74b99d619e90f481));



var $bunH6 = parcelRequire("bunH6");

var $c4xZ2 = parcelRequire("c4xZ2");
/**
 * SendBeacon does not support custom headers (e.g. Content-Encoding: gzip),
 * so request body compression is not applied even when enableRequestBodyCompression is true.
 */ var $6bbbf0bf0345d5b1$export$ee278d31d20f1075 = /** @class */ function(_super) {
    (0, $bunH6.__extends)(SendBeaconTransport, _super);
    function SendBeaconTransport() {
        return _super.call(this) || this;
    }
    SendBeaconTransport.prototype.send = function(serverUrl, payload, _enableRequestBodyCompression) {
        if (_enableRequestBodyCompression === void 0) _enableRequestBodyCompression = false;
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $bunH6.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var globalScope = (0, $c4xZ2.getGlobalScope)();
                        /* istanbul ignore if */ if (!(globalScope === null || globalScope === void 0 ? void 0 : globalScope.navigator.sendBeacon)) throw new Error('SendBeaconTransport is not supported');
                        try {
                            var data = JSON.stringify(payload);
                            // SendBeacon cannot set Content-Encoding, so we always send uncompressed
                            var success = globalScope.navigator.sendBeacon(serverUrl, data);
                            if (success) return resolve(_this.buildResponse({
                                code: 200,
                                events_ingested: payload.events.length,
                                payload_size_bytes: data.length,
                                server_upload_time: Date.now()
                            }));
                            return resolve(_this.buildResponse({
                                code: 500
                            }));
                        } catch (e) {
                            reject(e);
                        }
                    })
                ];
            });
        });
    };
    return SendBeaconTransport;
}((0, $fed2d116b28b9375$export$74b99d619e90f481));



var $bunH6 = parcelRequire("bunH6");

var $90a9b1de5549d278$export$641739d2a35dd5dd = function(apiKey, cookieStorage, deleteLegacyCookies) {
    if (deleteLegacyCookies === void 0) deleteLegacyCookies = true;
    return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
        var cookieName, cookies, _a, deviceId, userId, optOut, sessionId, lastEventTime, lastEventId;
        return (0, $bunH6.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    cookieName = (0, $c849684e046f6e02$export$5689a36821966445)(apiKey);
                    return [
                        4 /*yield*/ ,
                        cookieStorage.getRaw(cookieName)
                    ];
                case 1:
                    cookies = _b.sent();
                    if (!cookies) return [
                        2 /*return*/ ,
                        {
                            optOut: false
                        }
                    ];
                    if (!deleteLegacyCookies) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        cookieStorage.remove(cookieName)
                    ];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    _a = (0, $bunH6.__read)(cookies.split('.'), 6), deviceId = _a[0], userId = _a[1], optOut = _a[2], sessionId = _a[3], lastEventTime = _a[4], lastEventId = _a[5];
                    return [
                        2 /*return*/ ,
                        {
                            deviceId: deviceId,
                            userId: $90a9b1de5549d278$export$2f872c0f2117be69(userId),
                            sessionId: $90a9b1de5549d278$export$c9698ec7f05a07e1(sessionId),
                            lastEventId: $90a9b1de5549d278$export$c9698ec7f05a07e1(lastEventId),
                            lastEventTime: $90a9b1de5549d278$export$c9698ec7f05a07e1(lastEventTime),
                            optOut: Boolean(optOut)
                        }
                    ];
            }
        });
    });
};
var $90a9b1de5549d278$export$c9698ec7f05a07e1 = function(num) {
    var integer = parseInt(num, 32);
    if (isNaN(integer)) return undefined;
    return integer;
};
var $90a9b1de5549d278$export$2f872c0f2117be69 = function(value) {
    if (!atob || !escape || !value) return undefined;
    try {
        return decodeURIComponent(escape(atob(value)));
    } catch (_a) {
        return undefined;
    }
};


var $d2f545e922cce685$export$6d3ea26de30f4823 = '[Amplitude]';
var $d2f545e922cce685$export$e11a4b165d6c1798 = "".concat($d2f545e922cce685$export$6d3ea26de30f4823, " Page Viewed");
var $d2f545e922cce685$export$d1eb2ccafb450617 = "".concat($d2f545e922cce685$export$6d3ea26de30f4823, " Form Started");
var $d2f545e922cce685$export$8576ca1a5042bc32 = "".concat($d2f545e922cce685$export$6d3ea26de30f4823, " Form Submitted");
var $d2f545e922cce685$export$dd2608f2cca69490 = "".concat($d2f545e922cce685$export$6d3ea26de30f4823, " File Downloaded");
var $d2f545e922cce685$export$c7d032b40f04ffe5 = 'session_start';
var $d2f545e922cce685$export$406b0196920039c5 = 'session_end';
var $d2f545e922cce685$export$8cc480dee0a96fad = "".concat($d2f545e922cce685$export$6d3ea26de30f4823, " File Extension");
var $d2f545e922cce685$export$4b79612785fd8d50 = "".concat($d2f545e922cce685$export$6d3ea26de30f4823, " File Name");
var $d2f545e922cce685$export$13cfab8db9b47f6d = "".concat($d2f545e922cce685$export$6d3ea26de30f4823, " Link ID");
var $d2f545e922cce685$export$d089d67a4077bf08 = "".concat($d2f545e922cce685$export$6d3ea26de30f4823, " Link Text");
var $d2f545e922cce685$export$1ac552145aa3025b = "".concat($d2f545e922cce685$export$6d3ea26de30f4823, " Link URL");
var $d2f545e922cce685$export$5f1ba54ed64fd212 = "".concat($d2f545e922cce685$export$6d3ea26de30f4823, " Form ID");
var $d2f545e922cce685$export$bc6883368baba346 = "".concat($d2f545e922cce685$export$6d3ea26de30f4823, " Form Name");
var $d2f545e922cce685$export$d10a870b47f53964 = "".concat($d2f545e922cce685$export$6d3ea26de30f4823, " Form Destination");
var $d2f545e922cce685$export$a1811fbf689077b2 = 'cookie';
var $d2f545e922cce685$export$a07dea27df63211a = 'US';




var $bunH6 = parcelRequire("bunH6");

var $c4xZ2 = parcelRequire("c4xZ2");
var $28f43f1c5809d761$export$493572eb1c005ccf = {
    always: 'always',
    ifEmptyCampaign: 'ifEmptyCampaign'
};


var $e73238201900c9b1$var$domainWithoutSubdomain = function(domain) {
    var parts = domain.split('.');
    if (parts.length <= 2) return domain;
    return parts.slice(parts.length - 2, parts.length).join('.');
};
//Direct traffic mean no external referral, no UTMs, no click-ids, and no other customer identified marketing campaign url params.
var $e73238201900c9b1$var$isDirectTraffic = function(current) {
    return Object.values(current).every(function(value) {
        return !value;
    });
};
var $e73238201900c9b1$var$isEmptyCampaign = function(campaign) {
    var campaignWithoutReferrer = (0, $bunH6.__assign)((0, $bunH6.__assign)({}, campaign), {
        referring_domain: undefined,
        referrer: undefined
    });
    return Object.values(campaignWithoutReferrer).every(function(value) {
        return !value;
    });
};
var $e73238201900c9b1$export$1c9a583701535c5 = function(current, previous, options, logger, isNewSession, topLevelDomain) {
    if (isNewSession === void 0) isNewSession = true;
    var referrer = current.referrer, referring_domain = current.referring_domain, currentCampaign = (0, $bunH6.__rest)(current, [
        "referrer",
        "referring_domain"
    ]);
    var _a = previous || {}, _previous_referrer = _a.referrer, prevReferringDomain = _a.referring_domain, previousCampaign = (0, $bunH6.__rest)(_a, [
        "referrer",
        "referring_domain"
    ]);
    var excludeInternalReferrers = options.excludeInternalReferrers;
    if (excludeInternalReferrers) {
        var condition = $e73238201900c9b1$var$getExcludeInternalReferrersCondition(excludeInternalReferrers, logger);
        if (!(condition instanceof TypeError) && current.referring_domain && $e73238201900c9b1$var$isInternalReferrer(current.referring_domain, topLevelDomain)) {
            if (condition === 'always') {
                $e73238201900c9b1$var$debugLogInternalReferrerExclude(condition, current.referring_domain, logger);
                return false;
            } else if (condition === 'ifEmptyCampaign' && $e73238201900c9b1$var$isEmptyCampaign(current)) {
                $e73238201900c9b1$var$debugLogInternalReferrerExclude(condition, current.referring_domain, logger);
                return false;
            }
        }
    }
    if ($e73238201900c9b1$export$b8cc7c254fe2d3ec(options.excludeReferrers, current.referring_domain)) {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        logger.debug("This is not a new campaign because ".concat(current.referring_domain, " is in the exclude referrer list."));
        return false;
    }
    //In the same session, direct traffic should not override or unset any persisting query params
    if (!isNewSession && $e73238201900c9b1$var$isDirectTraffic(current) && previous) {
        logger.debug('This is not a new campaign because this is a direct traffic in the same session.');
        return false;
    }
    var hasNewCampaign = JSON.stringify(currentCampaign) !== JSON.stringify(previousCampaign);
    var hasNewDomain = $e73238201900c9b1$var$domainWithoutSubdomain(referring_domain || '') !== $e73238201900c9b1$var$domainWithoutSubdomain(prevReferringDomain || '');
    var result = !previous || hasNewCampaign || hasNewDomain;
    if (!result) logger.debug("This is not a new campaign because it's the same as the previous one.");
    else logger.debug("This is a new campaign. An $identify event will be sent.");
    return result;
};
var $e73238201900c9b1$export$b8cc7c254fe2d3ec = function(excludeReferrers, referringDomain) {
    if (excludeReferrers === void 0) excludeReferrers = [];
    if (referringDomain === void 0) referringDomain = '';
    return excludeReferrers.some(function(value) {
        return value instanceof RegExp ? value.test(referringDomain) : value === referringDomain;
    });
};
var $e73238201900c9b1$export$12cee2c659890ff0 = function(subDomain, domain) {
    var cookieDomainWithLeadingDot = domain.startsWith('.') ? domain : ".".concat(domain);
    var subDomainWithLeadingDot = subDomain.startsWith('.') ? subDomain : ".".concat(subDomain);
    if (subDomainWithLeadingDot.endsWith(cookieDomainWithLeadingDot)) return true;
    return false;
};
var $e73238201900c9b1$export$d146d450a8c839d2 = function(campaign, options) {
    var campaignParameters = (0, $bunH6.__assign)((0, $bunH6.__assign)({}, (0, $c1d7ad7f2bf46bfb$export$ea7354d30dfda3a2)), campaign);
    var identifyEvent = Object.entries(campaignParameters).reduce(function(identify, _a) {
        var _b;
        var _c = (0, $bunH6.__read)(_a, 2), key = _c[0], value = _c[1];
        identify.setOnce("initial_".concat(key), (_b = value !== null && value !== void 0 ? value : options.initialEmptyValue) !== null && _b !== void 0 ? _b : 'EMPTY');
        if (value) return identify.set(key, value);
        return identify.unset(key);
    }, new (0, $643b81d8570b18c7$export$e513146db6535bff)());
    return (0, $eba8dfa6a039f14d$export$5de4f5c2c4d8645f)(identifyEvent);
};
var $e73238201900c9b1$export$579a8d2534a703d9 = function(cookieDomain) {
    var domain = cookieDomain;
    if (domain) {
        if (domain.startsWith('.')) domain = domain.substring(1);
        return [
            new RegExp("".concat(domain.replace('.', '\\.'), "$"))
        ];
    }
    return [];
};
/**
 * Parses the excludeInternalReferrers configuration to determine the condition on which to
 * exclude internal referrers for campaign attribution.
 *
 * If the config is invalid type, log and return a TypeError.
 *
 * (this does explicit type checking so don't have to rely on TS compiler to catch invalid types)
 *
 * @param excludeInternalReferrers - attribution.excludeInternalReferrers configuration
 * @param logger - logger instance to log error when TypeError
 * @returns The condition if the config is valid, TypeError if the config is invalid.
 */ var $e73238201900c9b1$var$getExcludeInternalReferrersCondition = function(excludeInternalReferrers, logger) {
    if (excludeInternalReferrers === true) return (0, $28f43f1c5809d761$export$493572eb1c005ccf).always;
    if (typeof excludeInternalReferrers === 'object') {
        var condition = excludeInternalReferrers.condition;
        if (typeof condition === 'string' && Object.keys((0, $28f43f1c5809d761$export$493572eb1c005ccf)).includes(condition)) return condition;
        else if (typeof condition === 'undefined') return (0, $28f43f1c5809d761$export$493572eb1c005ccf).always;
    }
    var errorMessage = "Invalid configuration provided for attribution.excludeInternalReferrers: ".concat(JSON.stringify(excludeInternalReferrers));
    logger.error(errorMessage);
    return new TypeError(errorMessage);
};
// helper function to log debug message when internal referrer is excluded
// (added this to prevent code duplication and improve readability)
function $e73238201900c9b1$var$debugLogInternalReferrerExclude(condition, referringDomain, logger) {
    var baseMessage = "This is not a new campaign because referring_domain=".concat(referringDomain, " is on the same domain as the current page and it is configured to exclude internal referrers");
    if (condition === 'always') logger.debug(baseMessage);
    else if (condition === 'ifEmptyCampaign') logger.debug("".concat(baseMessage, " with empty campaign parameters"));
}
var $e73238201900c9b1$export$af0ab6317e9d3175 = [
    'ac.in',
    'ac.jp',
    'ac.kr',
    'ac.th',
    'ac.uk',
    'ac.za',
    'appspot.com',
    'asn.au',
    'azurewebsites.net',
    'cloudfront.net',
    'myshopify.com',
    'blogspot.com',
    'co.ca',
    'co.in',
    'co.jp',
    'co.kr',
    'co.nz',
    'co.th',
    'co.uk',
    'co.za',
    'com.ar',
    'com.au',
    'com.br',
    'com.cn',
    'com.hk',
    'com.in',
    'com.jp',
    'com.kr',
    'com.mx',
    'com.pl',
    'com.sg',
    'com.tr',
    'com.tw',
    'ed.jp',
    'edu.au',
    'edu.br',
    'edu.cn',
    'edu.hk',
    'edu.sg',
    'edu.th',
    'edu.tr',
    'edu.tw',
    'firebaseapp.com',
    'fly.dev',
    'gc.ca',
    'geek.nz',
    'github.io',
    'gitlab.io',
    'go.jp',
    'go.kr',
    'go.th',
    'gob.ar',
    'gob.mx',
    'gov.au',
    'gov.br',
    'gov.cn',
    'gov.hk',
    'gov.in',
    'gov.pl',
    'gov.sg',
    'gov.tr',
    'gov.tw',
    'gov.uk',
    'gov.za',
    'govt.nz',
    'gr.jp',
    'herokuapp.com',
    'id.au',
    'idv.hk',
    'iwi.nz',
    'lg.jp',
    'ltd.uk',
    'maori.nz',
    'me.uk',
    'mil.kr',
    'ne.jp',
    'ne.kr',
    'net.au',
    'net.br',
    'net.cn',
    'net.hk',
    'net.in',
    'net.nz',
    'net.pl',
    'net.sg',
    'net.tr',
    'net.tw',
    'net.za',
    'onrender.com',
    'or.jp',
    'or.kr',
    'or.th',
    'org.ar',
    'org.au',
    'org.br',
    'org.cn',
    'org.hk',
    'org.in',
    'org.mx',
    'org.nz',
    'org.pl',
    'org.sg',
    'org.tw',
    'org.uk',
    'org.za',
    'pages.dev',
    'pe.kr',
    'plc.uk',
    're.kr',
    'res.in',
    'sch.uk',
    'vercel.app',
    'netlify.app',
    'workers.dev'
];
var $e73238201900c9b1$export$3e8733322718eb9 = function(hostnameParam) {
    var _a, _b;
    /* istanbul ignore next */ var hostname = hostnameParam || ((_b = (_a = (0, $c4xZ2.getGlobalScope)()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.hostname);
    if (!hostname) return '';
    var parts = hostname.split('.');
    var tld = parts[parts.length - 1];
    var name = parts[parts.length - 2];
    if ($e73238201900c9b1$export$af0ab6317e9d3175.find(function(tld) {
        return hostname.endsWith(".".concat(tld));
    })) {
        tld = parts[parts.length - 2] + '.' + parts[parts.length - 1];
        name = parts[parts.length - 3];
    }
    if (!name) return tld;
    return "".concat(name, ".").concat(tld);
};
var $e73238201900c9b1$var$isInternalReferrer = function(referringDomain, topLevelDomain) {
    var globalScope = (0, $c4xZ2.getGlobalScope)();
    /* istanbul ignore if */ if (!globalScope) return false;
    // if referring domain is subdomain of config.cookieDomain, return true
    var internalDomain = (topLevelDomain || '').trim() || $e73238201900c9b1$export$3e8733322718eb9(globalScope.location.hostname);
    return $e73238201900c9b1$export$12cee2c659890ff0(referringDomain, internalDomain);
};


// Exported for testing purposes only. Do not expose to public interface.
var $e7d6c3ae2e55d0a2$export$d1ed917d271ca014 = /** @class */ function(_super) {
    (0, $bunH6.__extends)(BrowserConfig, _super);
    function BrowserConfig(apiKey, appVersion, cookieStorage, cookieOptions, defaultTracking, autocapture, deviceId, flushIntervalMillis, flushMaxRetries, flushQueueSize, identityStorage, ingestionMetadata, instanceName, lastEventId, lastEventTime, loggerProvider, logLevel, minIdLength, offline, optOut, partnerId, plan, serverUrl, serverZone, sessionId, deferredSessionId, sessionTimeout, storageProvider, trackingOptions, transport, useBatch, fetchRemoteConfig, userId, pageCounter, debugLogsEnabled, networkTrackingOptions, identify, enableDiagnostics, diagnosticsSampleRate, diagnosticsClient, remoteConfig, topLevelDomain, enableRequestBodyCompression, _enableRequestBodyCompressionExperimental) {
        if (cookieStorage === void 0) cookieStorage = new (0, $57b2afbf7a75b010$export$d7392285c701ecf5)();
        if (cookieOptions === void 0) cookieOptions = {
            domain: '',
            expiration: 365,
            sameSite: 'Lax',
            secure: false,
            upgrade: true
        };
        if (flushIntervalMillis === void 0) flushIntervalMillis = 1000;
        if (flushMaxRetries === void 0) flushMaxRetries = 5;
        if (flushQueueSize === void 0) flushQueueSize = 30;
        if (identityStorage === void 0) identityStorage = (0, $d2f545e922cce685$export$a1811fbf689077b2);
        if (loggerProvider === void 0) loggerProvider = new (0, $fb8fead1aae1be82$export$efa9a398d6368992)();
        if (logLevel === void 0) logLevel = (0, $7740633108eec54d$export$243e62d78d3b544d).Warn;
        if (offline === void 0) offline = false;
        if (optOut === void 0) optOut = false;
        if (serverUrl === void 0) serverUrl = '';
        if (serverZone === void 0) serverZone = (0, $d2f545e922cce685$export$a07dea27df63211a);
        if (sessionTimeout === void 0) sessionTimeout = 1800000;
        if (storageProvider === void 0) storageProvider = new (0, $fc4ac5d853769364$export$19fffca37ef3e106)({
            loggerProvider: loggerProvider
        });
        if (trackingOptions === void 0) trackingOptions = {
            ipAddress: true,
            language: true,
            platform: true
        };
        if (transport === void 0) transport = 'fetch';
        if (useBatch === void 0) useBatch = false;
        if (fetchRemoteConfig === void 0) fetchRemoteConfig = true;
        if (enableDiagnostics === void 0) enableDiagnostics = true;
        if (diagnosticsSampleRate === void 0) diagnosticsSampleRate = 0;
        if (enableRequestBodyCompression === void 0) enableRequestBodyCompression = false;
        if (_enableRequestBodyCompressionExperimental === void 0) _enableRequestBodyCompressionExperimental = false;
        var _this = this;
        var _a;
        _this = _super.call(this, {
            apiKey: apiKey,
            storageProvider: storageProvider,
            transportProvider: $e7d6c3ae2e55d0a2$export$d09f50d9ab7f7b69(transport)
        }) || this;
        _this.apiKey = apiKey;
        _this.appVersion = appVersion;
        _this.cookieOptions = cookieOptions;
        _this.defaultTracking = defaultTracking;
        _this.autocapture = autocapture;
        _this.flushIntervalMillis = flushIntervalMillis;
        _this.flushMaxRetries = flushMaxRetries;
        _this.flushQueueSize = flushQueueSize;
        _this.identityStorage = identityStorage;
        _this.ingestionMetadata = ingestionMetadata;
        _this.instanceName = instanceName;
        _this.loggerProvider = loggerProvider;
        _this.logLevel = logLevel;
        _this.minIdLength = minIdLength;
        _this.offline = offline;
        _this.partnerId = partnerId;
        _this.plan = plan;
        _this.serverUrl = serverUrl;
        _this.serverZone = serverZone;
        _this.sessionTimeout = sessionTimeout;
        _this.storageProvider = storageProvider;
        _this.trackingOptions = trackingOptions;
        _this.transport = transport;
        _this.useBatch = useBatch;
        _this.fetchRemoteConfig = fetchRemoteConfig;
        _this.networkTrackingOptions = networkTrackingOptions;
        _this.identify = identify;
        _this.enableDiagnostics = enableDiagnostics;
        _this.diagnosticsSampleRate = diagnosticsSampleRate;
        _this.diagnosticsClient = diagnosticsClient;
        _this.remoteConfig = remoteConfig;
        _this.topLevelDomain = topLevelDomain;
        _this.enableRequestBodyCompression = enableRequestBodyCompression;
        _this._enableRequestBodyCompressionExperimental = _enableRequestBodyCompressionExperimental;
        _this.version = (0, $01a0eb29ad2e7237$export$a4ad2735b021c132);
        _this._optOut = false;
        _this._cookieStorage = cookieStorage;
        _this.deviceId = deviceId;
        _this.lastEventId = lastEventId;
        _this.lastEventTime = lastEventTime;
        _this.optOut = optOut;
        _this.deferredSessionId = deferredSessionId;
        _this.sessionId = sessionId;
        _this.pageCounter = pageCounter;
        _this.userId = userId;
        _this.debugLogsEnabled = debugLogsEnabled;
        _this.loggerProvider.enable(debugLogsEnabled ? (0, $7740633108eec54d$export$243e62d78d3b544d).Debug : _this.logLevel);
        _this.networkTrackingOptions = networkTrackingOptions;
        _this.identify = identify;
        _this.enableDiagnostics = enableDiagnostics;
        _this.diagnosticsSampleRate = diagnosticsSampleRate;
        _this.diagnosticsClient = diagnosticsClient;
        // Note: The canonical logic for determining fetchRemoteConfig is in shouldFetchRemoteConfig().
        // This logic is duplicated here to maintain the BrowserConfig constructor contract and ensure
        // the config object has the correct fetchRemoteConfig value set on its properties.
        // The value passed to this constructor should already be computed via shouldFetchRemoteConfig().
        var _fetchRemoteConfig = (_a = remoteConfig === null || remoteConfig === void 0 ? void 0 : remoteConfig.fetchRemoteConfig) !== null && _a !== void 0 ? _a : fetchRemoteConfig;
        _this.remoteConfig = _this.remoteConfig || {};
        _this.remoteConfig.fetchRemoteConfig = _fetchRemoteConfig;
        _this.fetchRemoteConfig = _fetchRemoteConfig;
        _this.topLevelDomain = topLevelDomain || (0, $e73238201900c9b1$export$3e8733322718eb9)();
        return _this;
    }
    Object.defineProperty(BrowserConfig.prototype, "cookieStorage", {
        get: function() {
            return this._cookieStorage;
        },
        set: function(cookieStorage) {
            if (this._cookieStorage !== cookieStorage) {
                this._cookieStorage = cookieStorage;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "deviceId", {
        get: function() {
            return this._deviceId;
        },
        set: function(deviceId) {
            if (this._deviceId !== deviceId) {
                this._deviceId = deviceId;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "userId", {
        get: function() {
            return this._userId;
        },
        set: function(userId) {
            if (this._userId !== userId) {
                this._userId = userId;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "sessionId", {
        get: function() {
            return this._sessionId;
        },
        set: function(sessionId) {
            if (this._sessionId !== sessionId) {
                this._sessionId = sessionId;
                // Clear deferredSessionId when sessionId is set to prevent stale values
                // from overriding legitimate sessionIds on subsequent page loads
                if (sessionId !== undefined && this._deferredSessionId !== undefined) this._deferredSessionId = undefined;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "deferredSessionId", {
        get: function() {
            return this._deferredSessionId;
        },
        set: function(deferredSessionId) {
            if (this._deferredSessionId !== deferredSessionId && deferredSessionId !== this.sessionId) {
                this._deferredSessionId = deferredSessionId;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "optOut", {
        get: function() {
            return this._optOut;
        },
        set: function(optOut) {
            if (this._optOut !== optOut) {
                this._optOut = optOut;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "lastEventTime", {
        get: function() {
            return this._lastEventTime;
        },
        set: function(lastEventTime) {
            if (this._lastEventTime !== lastEventTime) {
                this._lastEventTime = lastEventTime;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "lastEventId", {
        get: function() {
            return this._lastEventId;
        },
        set: function(lastEventId) {
            if (this._lastEventId !== lastEventId) {
                this._lastEventId = lastEventId;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "pageCounter", {
        get: function() {
            return this._pageCounter;
        },
        set: function(pageCounter) {
            if (this._pageCounter !== pageCounter) {
                this._pageCounter = pageCounter;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "debugLogsEnabled", {
        set: function(debugLogsEnabled) {
            if (this._debugLogsEnabled !== debugLogsEnabled) {
                this._debugLogsEnabled = debugLogsEnabled;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    BrowserConfig.prototype.updateStorage = function() {
        var cache = {
            deviceId: this._deviceId,
            userId: this._userId,
            sessionId: this._sessionId,
            deferredSessionId: this._deferredSessionId,
            optOut: this._optOut,
            lastEventTime: this._lastEventTime,
            lastEventId: this._lastEventId,
            pageCounter: this._pageCounter,
            debugLogsEnabled: this._debugLogsEnabled,
            cookieDomain: undefined
        };
        if (this.cookieStorage instanceof (0, $7b3hW.CookieStorage)) cache.cookieDomain = this.cookieStorage.options.domain;
        this.cookieStorage.set((0, $c849684e046f6e02$export$4820a8f23184d6a3)(this.apiKey), cache);
    };
    return BrowserConfig;
}((0, $18be17c871db5450$export$29cd7b75162a9425));
var $e7d6c3ae2e55d0a2$export$4e33c75a470874a8 = function(apiKey, options, amplitudeInstance, diagnosticsClient, earlyConfig) {
    if (options === void 0) options = {};
    return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
        var identityStorage, defaultCookieDomain, cookieOptions, cookieConfig, cookieStorage, legacyCookies, previousCookies, queryParams, ampTimestamp, isWithinTimeLimit, deviceId, lastEventId, lastEventTime, optOut, sessionId, deferredSessionId, userId, trackingOptions, pageCounter, debugLogsEnabled, browserConfig;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
        return (0, $bunH6.__generator)(this, function(_6) {
            switch(_6.label){
                case 0:
                    identityStorage = options.identityStorage || (0, $d2f545e922cce685$export$a1811fbf689077b2);
                    defaultCookieDomain = '';
                    if (!(identityStorage === (0, $d2f545e922cce685$export$a1811fbf689077b2) && !((_a = options.cookieOptions) === null || _a === void 0 ? void 0 : _a.domain) && ((_b = options.cookieOptions) === null || _b === void 0 ? void 0 : _b.domain) !== '')) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        $e7d6c3ae2e55d0a2$export$cf2a7e4ae2c1bb19(undefined, diagnosticsClient)
                    ];
                case 1:
                    defaultCookieDomain = _6.sent();
                    _6.label = 2;
                case 2:
                    cookieOptions = (0, $bunH6.__assign)({
                        domain: (_d = (_c = options.cookieOptions) === null || _c === void 0 ? void 0 : _c.domain) !== null && _d !== void 0 ? _d : defaultCookieDomain,
                        expiration: 365,
                        sameSite: 'Lax',
                        secure: false,
                        upgrade: true
                    }, options.cookieOptions);
                    cookieConfig = {
                        // if more than one cookie with the same key exists,
                        // look for the cookie that has the domain attribute set to cookieOptions.domain
                        duplicateResolverFn: function(value) {
                            var decodedValue = (0, $7b3hW.decodeCookieValue)(value);
                            if (!decodedValue) return false;
                            var parsed = JSON.parse(decodedValue);
                            return (0, $7b3hW.isDomainEqual)(parsed.cookieDomain, cookieOptions.domain);
                        },
                        diagnosticsClient: diagnosticsClient
                    };
                    cookieStorage = $e7d6c3ae2e55d0a2$export$2fbfb3607a72373e(options.identityStorage, cookieOptions, cookieConfig);
                    return [
                        4 /*yield*/ ,
                        (0, $90a9b1de5549d278$export$641739d2a35dd5dd)(apiKey, cookieStorage, (_f = (_e = options.cookieOptions) === null || _e === void 0 ? void 0 : _e.upgrade) !== null && _f !== void 0 ? _f : true)
                    ];
                case 3:
                    legacyCookies = _6.sent();
                    return [
                        4 /*yield*/ ,
                        cookieStorage.get((0, $c849684e046f6e02$export$4820a8f23184d6a3)(apiKey))
                    ];
                case 4:
                    previousCookies = _6.sent();
                    queryParams = (0, $12451edd1666d93e$export$e2de15bbd9edf9c6)();
                    ampTimestamp = queryParams.ampTimestamp ? Number(queryParams.ampTimestamp) : undefined;
                    isWithinTimeLimit = ampTimestamp ? Date.now() < ampTimestamp : true;
                    deviceId = (_l = (_k = (_j = (_g = options.deviceId) !== null && _g !== void 0 ? _g : isWithinTimeLimit ? (_h = queryParams.ampDeviceId) !== null && _h !== void 0 ? _h : queryParams.deviceId : undefined) !== null && _j !== void 0 ? _j : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.deviceId) !== null && _k !== void 0 ? _k : legacyCookies.deviceId) !== null && _l !== void 0 ? _l : (0, $b8d06392fac4718b$export$bc35efed93511c4b)();
                    lastEventId = (_m = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.lastEventId) !== null && _m !== void 0 ? _m : legacyCookies.lastEventId;
                    lastEventTime = (_o = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.lastEventTime) !== null && _o !== void 0 ? _o : legacyCookies.lastEventTime;
                    optOut = (_q = (_p = options.optOut) !== null && _p !== void 0 ? _p : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.optOut) !== null && _q !== void 0 ? _q : legacyCookies.optOut;
                    sessionId = (_r = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.sessionId) !== null && _r !== void 0 ? _r : legacyCookies.sessionId;
                    deferredSessionId = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.deferredSessionId;
                    userId = (_t = (_s = options.userId) !== null && _s !== void 0 ? _s : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.userId) !== null && _t !== void 0 ? _t : legacyCookies.userId;
                    amplitudeInstance.previousSessionDeviceId = (_u = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.deviceId) !== null && _u !== void 0 ? _u : legacyCookies.deviceId;
                    amplitudeInstance.previousSessionUserId = (_v = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.userId) !== null && _v !== void 0 ? _v : legacyCookies.userId;
                    trackingOptions = {
                        ipAddress: (_x = (_w = options.trackingOptions) === null || _w === void 0 ? void 0 : _w.ipAddress) !== null && _x !== void 0 ? _x : true,
                        language: (_z = (_y = options.trackingOptions) === null || _y === void 0 ? void 0 : _y.language) !== null && _z !== void 0 ? _z : true,
                        platform: (_1 = (_0 = options.trackingOptions) === null || _0 === void 0 ? void 0 : _0.platform) !== null && _1 !== void 0 ? _1 : true
                    };
                    pageCounter = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.pageCounter;
                    debugLogsEnabled = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.debugLogsEnabled;
                    // Override default tracking options if autocapture is set
                    if (options.autocapture !== undefined) options.defaultTracking = options.autocapture;
                    browserConfig = new $e7d6c3ae2e55d0a2$export$d1ed917d271ca014(apiKey, options.appVersion, cookieStorage, cookieOptions, options.defaultTracking, options.autocapture, deviceId, options.flushIntervalMillis, options.flushMaxRetries, options.flushQueueSize, identityStorage, options.ingestionMetadata, options.instanceName, lastEventId, lastEventTime, // Use earlyConfig.loggerProvider to ensure consistent logger across DiagnosticsClient/RemoteConfigClient/BrowserConfig
                    (_2 = earlyConfig === null || earlyConfig === void 0 ? void 0 : earlyConfig.loggerProvider) !== null && _2 !== void 0 ? _2 : options.loggerProvider, options.logLevel, options.minIdLength, options.offline, optOut, options.partnerId, options.plan, options.serverUrl, // Use earlyConfig.serverZone to ensure consistent serverZone
                    (_3 = earlyConfig === null || earlyConfig === void 0 ? void 0 : earlyConfig.serverZone) !== null && _3 !== void 0 ? _3 : options.serverZone, sessionId, deferredSessionId, options.sessionTimeout, options.storageProvider, trackingOptions, options.transport, options.useBatch, options.fetchRemoteConfig, userId, pageCounter, debugLogsEnabled, options.networkTrackingOptions, options.identify, // Use earlyConfig values (already has remote config applied), otherwise fall back to options
                    (_4 = earlyConfig === null || earlyConfig === void 0 ? void 0 : earlyConfig.enableDiagnostics) !== null && _4 !== void 0 ? _4 : options.enableDiagnostics, (_5 = earlyConfig === null || earlyConfig === void 0 ? void 0 : earlyConfig.diagnosticsSampleRate) !== null && _5 !== void 0 ? _5 : amplitudeInstance._diagnosticsSampleRate, diagnosticsClient, options.remoteConfig, defaultCookieDomain, options.enableRequestBodyCompression, amplitudeInstance._enableRequestBodyCompressionExperimentalValue);
                    return [
                        4 /*yield*/ ,
                        browserConfig.storageProvider.isEnabled()
                    ];
                case 5:
                    if (!_6.sent()) {
                        browserConfig.loggerProvider.warn("Storage provider ".concat(browserConfig.storageProvider.constructor.name, " is not enabled. Falling back to MemoryStorage."));
                        browserConfig.storageProvider = new (0, $57b2afbf7a75b010$export$d7392285c701ecf5)();
                    }
                    return [
                        2 /*return*/ ,
                        browserConfig
                    ];
            }
        });
    });
};
var $e7d6c3ae2e55d0a2$export$2fbfb3607a72373e = function(identityStorage, cookieOptions, cookieConfig) {
    if (identityStorage === void 0) identityStorage = (0, $d2f545e922cce685$export$a1811fbf689077b2);
    if (cookieOptions === void 0) cookieOptions = {};
    switch(identityStorage){
        case 'localStorage':
            return new (0, $fc4ac5d853769364$export$19fffca37ef3e106)();
        case 'sessionStorage':
            return new (0, $769925a33a27b188$export$2c4b17e1c2e0931)();
        case 'none':
            return new (0, $57b2afbf7a75b010$export$d7392285c701ecf5)();
        case 'cookie':
        default:
            return new (0, $7b3hW.CookieStorage)((0, $bunH6.__assign)((0, $bunH6.__assign)({}, cookieOptions), {
                expirationDays: cookieOptions.expiration
            }), cookieConfig);
    }
};
var $e7d6c3ae2e55d0a2$export$c6db7417488fcb50 = function(options) {
    var _a, _b;
    if (options === void 0) options = {};
    if (((_a = options.remoteConfig) === null || _a === void 0 ? void 0 : _a.fetchRemoteConfig) === true) // set to true if remoteConfig explicitly set to true
    return true;
    else if (((_b = options.remoteConfig) === null || _b === void 0 ? void 0 : _b.fetchRemoteConfig) === false || options.fetchRemoteConfig === false) // set to false if either are set to false explicitly
    return false;
    else // default to true if both undefined
    return true;
};
var $e7d6c3ae2e55d0a2$export$d09f50d9ab7f7b69 = function(transport) {
    var type = typeof transport === 'object' ? transport.type : transport;
    var headers = typeof transport === 'object' ? transport.headers : undefined;
    if (type === 'xhr') return new (0, $cbbafdbd33c1f0c3$export$874a283af77e8e62)(headers);
    if (type === 'beacon') // SendBeacon does not support custom headers
    return new (0, $6bbbf0bf0345d5b1$export$ee278d31d20f1075)();
    // Keep a browser-local fetch transport for gzip support.
    // TODO: Merge back to core FetchTransport after React Native supports gzip.
    return new (0, $423f8b44830d6047$export$2bdee3f9b92f4e82)(headers);
};
var $e7d6c3ae2e55d0a2$export$cf2a7e4ae2c1bb19 = function(url, diagnosticsClient) {
    return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
        var host, parts, levels, skipLevel, i, i, domain, result, e_1;
        return (0, $bunH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        new (0, $7b3hW.CookieStorage)(undefined, {
                            diagnosticsClient: diagnosticsClient
                        }).isEnabled()
                    ];
                case 1:
                    if (!_a.sent() || !url && (typeof location === 'undefined' || !location.hostname)) return [
                        2 /*return*/ ,
                        ''
                    ];
                    host = url !== null && url !== void 0 ? url : location.hostname;
                    parts = host.split('.');
                    // if hostname has less than 2 parts, it's not a registrable domain
                    // and the browser won't allow setting domain-scoped cookies for it so return empty string
                    if (parts.length === 1) return [
                        2 /*return*/ ,
                        ''
                    ];
                    levels = [];
                    skipLevel = 1;
                    // if the hostname ends with a TLD we know is in the Public Suffix List
                    // then the last two parts are definitely not writable as a domain
                    if ((0, $e73238201900c9b1$export$af0ab6317e9d3175).find(function(tld) {
                        return host.endsWith(".".concat(tld));
                    })) skipLevel = 2;
                    for(i = parts.length - skipLevel - 1; i >= 0; --i)levels.push(parts.slice(i).join('.'));
                    i = 0;
                    _a.label = 2;
                case 2:
                    if (!(i < levels.length)) return [
                        3 /*break*/ ,
                        7
                    ];
                    domain = levels[i];
                    _a.label = 3;
                case 3:
                    _a.trys.push([
                        3,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4 /*yield*/ ,
                        (0, $7b3hW.CookieStorage).isDomainWritable(domain)
                    ];
                case 4:
                    result = _a.sent();
                    // if the transaction succeeded, the domain is valid
                    if (result) return [
                        2 /*return*/ ,
                        '.' + domain
                    ];
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 5:
                    e_1 = _a.sent();
                    /* istanbul ignore if */ if (diagnosticsClient) diagnosticsClient.recordEvent('cookies.tld.failure', {
                        reason: "Unexpected exception checking domain is writable: ".concat(domain),
                        error: e_1 instanceof Error ? e_1.message : String(e_1)
                    });
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 6:
                    i++;
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 7:
                    // if the transaction failed, the domain is invalid
                    // record a diagnostic event
                    if (diagnosticsClient) diagnosticsClient.recordEvent('cookies.tld.failure', {
                        reason: "Could not determine TLD for host ".concat(host)
                    });
                    // return an empty string to indicate that we couldn't determine the TLD
                    // so fallback to host-only cookies (scoped to the current host)
                    return [
                        2 /*return*/ ,
                        ''
                    ];
            }
        });
    });
};



var $bunH6 = parcelRequire("bunH6");

var $bunH6 = parcelRequire("bunH6");


var $23a80041871c3b55$export$6887fc37aa79947c = /** @class */ function() {
    function CampaignParser() {}
    CampaignParser.prototype.parse = function() {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, $bunH6.__assign)((0, $bunH6.__assign)((0, $bunH6.__assign)((0, $bunH6.__assign)({}, (0, $c1d7ad7f2bf46bfb$export$ea7354d30dfda3a2)), this.getUtmParam()), this.getReferrer()), this.getClickIds())
                ];
            });
        });
    };
    CampaignParser.prototype.getUtmParam = function() {
        var params = (0, $12451edd1666d93e$export$e2de15bbd9edf9c6)();
        var utmCampaign = params[0, $c1d7ad7f2bf46bfb$export$926599dcfe1d591d];
        var utmContent = params[0, $c1d7ad7f2bf46bfb$export$76cba99ea272772];
        var utmId = params[0, $c1d7ad7f2bf46bfb$export$5061a1cefb237161];
        var utmMedium = params[0, $c1d7ad7f2bf46bfb$export$a6f5c6056c876f92];
        var utmSource = params[0, $c1d7ad7f2bf46bfb$export$f7522a6e1839b3b9];
        var utmTerm = params[0, $c1d7ad7f2bf46bfb$export$74173cb2cd2c2b01];
        return {
            utm_campaign: utmCampaign,
            utm_content: utmContent,
            utm_id: utmId,
            utm_medium: utmMedium,
            utm_source: utmSource,
            utm_term: utmTerm
        };
    };
    CampaignParser.prototype.getReferrer = function() {
        var _a, _b;
        var data = {
            referrer: undefined,
            referring_domain: undefined
        };
        try {
            data.referrer = document.referrer || undefined;
            data.referring_domain = (_b = (_a = data.referrer) === null || _a === void 0 ? void 0 : _a.split('/')[2]) !== null && _b !== void 0 ? _b : undefined;
        } catch (_c) {
        // nothing to track
        }
        return data;
    };
    CampaignParser.prototype.getClickIds = function() {
        var _a;
        var params = (0, $12451edd1666d93e$export$e2de15bbd9edf9c6)();
        return _a = {}, _a[0, $c1d7ad7f2bf46bfb$export$d7046fa8a8c432a0] = params[0, $c1d7ad7f2bf46bfb$export$d7046fa8a8c432a0], _a[0, $c1d7ad7f2bf46bfb$export$bee91738abba7f50] = params[0, $c1d7ad7f2bf46bfb$export$bee91738abba7f50], _a[0, $c1d7ad7f2bf46bfb$export$bba55cdc82bf1e23] = params[0, $c1d7ad7f2bf46bfb$export$bba55cdc82bf1e23], _a[0, $c1d7ad7f2bf46bfb$export$d72e6377dae42b4f] = params[0, $c1d7ad7f2bf46bfb$export$d72e6377dae42b4f], _a[0, $c1d7ad7f2bf46bfb$export$9ed7c4aa246186b5] = params[0, $c1d7ad7f2bf46bfb$export$9ed7c4aa246186b5], _a[0, $c1d7ad7f2bf46bfb$export$e495e049f5a59ccc] = params[0, $c1d7ad7f2bf46bfb$export$e495e049f5a59ccc], _a[0, $c1d7ad7f2bf46bfb$export$f912492c0955f678] = params[0, $c1d7ad7f2bf46bfb$export$f912492c0955f678], _a[0, $c1d7ad7f2bf46bfb$export$f1d48c95a869863d] = params[0, $c1d7ad7f2bf46bfb$export$f1d48c95a869863d], _a[0, $c1d7ad7f2bf46bfb$export$89d66d2933b92df] = params[0, $c1d7ad7f2bf46bfb$export$89d66d2933b92df], _a[0, $c1d7ad7f2bf46bfb$export$856b82f6063e22ef] = params[0, $c1d7ad7f2bf46bfb$export$856b82f6063e22ef], _a[0, $c1d7ad7f2bf46bfb$export$b5b43be4e547ddd3] = params[0, $c1d7ad7f2bf46bfb$export$b5b43be4e547ddd3], _a;
    };
    return CampaignParser;
}();


var $c4xZ2 = parcelRequire("c4xZ2");
var $bunH6 = parcelRequire("bunH6");
var $d098392c6f9e3beb$export$1d7c7f33294ad29b = 'data-amp-mask';
var $d098392c6f9e3beb$export$bad2cbf8e277cf85 = '*****';
var $d098392c6f9e3beb$export$771e31f2b320e73e = /\b(?:\d[ -]*?){13,16}\b/;
var $d098392c6f9e3beb$export$c73f96b6b02491d = /(\d{3}-?\d{2}-?\d{4})/g;
var $d098392c6f9e3beb$export$7b7637218245c8a = /[^\s@]+@[^\s@.]+\.[^\s@]+/g;
var $d098392c6f9e3beb$export$ca40fe481df670b5 = function(text, additionalMaskTextPatterns) {
    var e_1, _a;
    if (additionalMaskTextPatterns === void 0) additionalMaskTextPatterns = [];
    if (typeof text !== 'string') return '';
    var result = text;
    // Check for credit card number (with or without spaces/dashes)
    result = result.replace($d098392c6f9e3beb$export$771e31f2b320e73e, $d098392c6f9e3beb$export$bad2cbf8e277cf85);
    // Check for social security number
    result = result.replace($d098392c6f9e3beb$export$c73f96b6b02491d, $d098392c6f9e3beb$export$bad2cbf8e277cf85);
    // Check for email
    result = result.replace($d098392c6f9e3beb$export$7b7637218245c8a, $d098392c6f9e3beb$export$bad2cbf8e277cf85);
    try {
        // Check for additional mask text patterns
        for(var additionalMaskTextPatterns_1 = (0, $bunH6.__values)(additionalMaskTextPatterns), additionalMaskTextPatterns_1_1 = additionalMaskTextPatterns_1.next(); !additionalMaskTextPatterns_1_1.done; additionalMaskTextPatterns_1_1 = additionalMaskTextPatterns_1.next()){
            var pattern = additionalMaskTextPatterns_1_1.value;
            try {
                result = result.replace(pattern, $d098392c6f9e3beb$export$bad2cbf8e277cf85);
            } catch (_b) {
            // ignore invalid pattern
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (additionalMaskTextPatterns_1_1 && !additionalMaskTextPatterns_1_1.done && (_a = additionalMaskTextPatterns_1.return)) _a.call(additionalMaskTextPatterns_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
};
var $d098392c6f9e3beb$export$23286240952da4c9 = function(parseTitleFunction) {
    if (typeof document === 'undefined' || !document.title) return '';
    var titleElement = document.querySelector('title');
    if (titleElement && titleElement.hasAttribute($d098392c6f9e3beb$export$1d7c7f33294ad29b)) return $d098392c6f9e3beb$export$bad2cbf8e277cf85;
    return parseTitleFunction ? parseTitleFunction(document.title) : document.title; // document.title is always synced to the first title element
};


var $85a93a67ee5818ee$export$d8a2b83131ad9e60 = function(input) {
    var obj = {};
    for(var key in input){
        var val = input[key];
        if (val) obj[key] = val;
    }
    return obj;
};


var $d655f70c9190fddd$export$5574584aeaaa1a29 = '[Amplitude] Page Viewed';
var $d655f70c9190fddd$export$c6d132de2f8d2b4f = 'AMP_PAGE_VIEW';
var $d655f70c9190fddd$export$a3128c6802358466 = function(options) {
    if (options === void 0) options = {};
    var amplitude;
    var globalScope = (0, $c4xZ2.getGlobalScope)();
    var loggerProvider = undefined;
    var isTracking = false;
    var localConfig;
    var sessionStorage;
    var trackOn = options.trackOn, trackHistoryChanges = options.trackHistoryChanges, _a = options.eventType, eventType = _a === void 0 ? $d655f70c9190fddd$export$5574584aeaaa1a29 : _a;
    var getDecodeURI = function(locationStr) {
        var decodedLocationStr = locationStr;
        try {
            decodedLocationStr = decodeURI(locationStr);
        } catch (e) {
            /* istanbul ignore next */ loggerProvider === null || loggerProvider === void 0 || loggerProvider.error('Malformed URI sequence: ', e);
        }
        return decodedLocationStr;
    };
    var createPageViewEvent = function(pageViewId) {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            var locationHREF, _a;
            var _b;
            return (0, $bunH6.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        locationHREF = getDecodeURI(typeof location !== 'undefined' && location.href || '');
                        _b = {
                            event_type: eventType
                        };
                        _a = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            $d655f70c9190fddd$var$getCampaignParams()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            (_b.event_properties = (0, $bunH6.__assign).apply(void 0, [
                                (0, $bunH6.__assign).apply(void 0, _a.concat([
                                    _c.sent()
                                ])),
                                {
                                    '[Amplitude] Page Domain': /* istanbul ignore next */ typeof location !== 'undefined' && location.hostname || '',
                                    '[Amplitude] Page Location': locationHREF,
                                    '[Amplitude] Page Path': /* istanbul ignore next */ typeof location !== 'undefined' && getDecodeURI(location.pathname) || '',
                                    '[Amplitude] Page Title': /* istanbul ignore next */ (0, $d098392c6f9e3beb$export$23286240952da4c9)((0, $d098392c6f9e3beb$export$ca40fe481df670b5)),
                                    '[Amplitude] Page URL': locationHREF.split('?')[0],
                                    '[Amplitude] Page View ID': pageViewId
                                }
                            ]), _b)
                        ];
                }
            });
        });
    };
    var shouldTrackOnPageLoad = function() {
        return typeof trackOn === 'undefined' || typeof trackOn === 'function' && trackOn();
    };
    /* istanbul ignore next */ var previousURL = typeof location !== 'undefined' ? location.href : null;
    var trackHistoryPageView = function() {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            var newURL, shouldTrackPageView, pageViewId, _a, _b, _c;
            return (0, $bunH6.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        newURL = location.href;
                        shouldTrackPageView = $d655f70c9190fddd$export$aa1b813607a1c442(trackHistoryChanges, newURL, previousURL || '') && shouldTrackOnPageLoad();
                        // Note: Update `previousURL` in the same clock tick as `shouldTrackHistoryPageView()`
                        // This was previously done after `amplitude?.track(await createPageViewEvent());` and
                        // causes a concurrency issue where app triggers `pushState` twice with the same URL target
                        // but `previousURL` is only updated after the second `pushState` producing two page viewed events
                        previousURL = newURL;
                        if (!shouldTrackPageView) return [
                            3 /*break*/ ,
                            4
                        ];
                        pageViewId = void 0;
                        if (sessionStorage) {
                            pageViewId = (0, $b8d06392fac4718b$export$bc35efed93511c4b)();
                            sessionStorage.set($d655f70c9190fddd$export$c6d132de2f8d2b4f, {
                                pageViewId: pageViewId
                            });
                        }
                        /* istanbul ignore next */ loggerProvider === null || loggerProvider === void 0 || loggerProvider.log('Tracking page view event');
                        if (!(amplitude === null || amplitude === void 0)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _a = void 0;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        _c = (_b = amplitude).track;
                        return [
                            4 /*yield*/ ,
                            createPageViewEvent(pageViewId)
                        ];
                    case 2:
                        _a = _c.apply(_b, [
                            _d.sent()
                        ]);
                        _d.label = 3;
                    case 3:
                        _a;
                        _d.label = 4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /* istanbul ignore next */ var handlePageChange = function() {
        trackHistoryPageView();
    };
    var plugin = {
        name: '@amplitude/plugin-page-view-tracking-browser',
        type: 'enrichment',
        setup: function(config, client) {
            return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
                var pageViewId, _a, _b;
                return (0, $bunH6.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            amplitude = client;
                            localConfig = config;
                            loggerProvider = config.loggerProvider;
                            loggerProvider.log('Installing @amplitude/plugin-page-view-tracking-browser');
                            isTracking = true;
                            if (globalScope) {
                                // init session storage
                                sessionStorage = new (0, $588c8318ebeb48b5$export$2baa60fa09b100be)(globalScope.sessionStorage);
                                globalScope.addEventListener('popstate', handlePageChange);
                                /* istanbul ignore next */ // There is no global browser listener for changes to history, so we have
                                // to modify pushState directly.
                                // https://stackoverflow.com/a/64927639
                                // eslint-disable-next-line @typescript-eslint/unbound-method
                                globalScope.history.pushState = new Proxy(globalScope.history.pushState, {
                                    apply: function(target, thisArg, _a) {
                                        var _b = (0, $bunH6.__read)(_a, 3), state = _b[0], unused = _b[1], url = _b[2];
                                        target.apply(thisArg, [
                                            state,
                                            unused,
                                            url
                                        ]);
                                        if (isTracking) handlePageChange();
                                    }
                                });
                            }
                            if (!shouldTrackOnPageLoad()) return [
                                3 /*break*/ ,
                                2
                            ];
                            loggerProvider.log('Tracking page view event');
                            pageViewId = void 0;
                            if (sessionStorage) {
                                pageViewId = (0, $b8d06392fac4718b$export$bc35efed93511c4b)();
                                sessionStorage.set($d655f70c9190fddd$export$c6d132de2f8d2b4f, {
                                    pageViewId: pageViewId
                                });
                            }
                            _b = (_a = amplitude).track;
                            return [
                                4 /*yield*/ ,
                                createPageViewEvent(pageViewId)
                            ];
                        case 1:
                            _b.apply(_a, [
                                _c.sent()
                            ]);
                            _c.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        },
        execute: function(event) {
            return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
                var pageViewId, pageViewSession, pageViewEvent;
                return (0, $bunH6.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(trackOn === 'attribution' && $d655f70c9190fddd$var$isCampaignEvent(event))) return [
                                3 /*break*/ ,
                                4
                            ];
                            /* istanbul ignore next */ // loggerProvider should be defined by the time execute is invoked
                            loggerProvider === null || loggerProvider === void 0 || loggerProvider.log('Enriching campaign event to page view event with campaign parameters');
                            pageViewId = void 0;
                            if (!sessionStorage) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                sessionStorage.get($d655f70c9190fddd$export$c6d132de2f8d2b4f)
                            ];
                        case 1:
                            pageViewSession = _a.sent();
                            pageViewId = pageViewSession === null || pageViewSession === void 0 ? void 0 : pageViewSession.pageViewId;
                            _a.label = 2;
                        case 2:
                            return [
                                4 /*yield*/ ,
                                createPageViewEvent(pageViewId)
                            ];
                        case 3:
                            pageViewEvent = _a.sent();
                            event.event_type = pageViewEvent.event_type;
                            event.event_properties = (0, $bunH6.__assign)((0, $bunH6.__assign)({}, event.event_properties), pageViewEvent.event_properties);
                            _a.label = 4;
                        case 4:
                            // Update the pageCounter for the page view event
                            if (localConfig && event.event_type === eventType) {
                                localConfig.pageCounter = !localConfig.pageCounter ? 1 : localConfig.pageCounter + 1;
                                event.event_properties = (0, $bunH6.__assign)((0, $bunH6.__assign)({}, event.event_properties), {
                                    '[Amplitude] Page Counter': localConfig.pageCounter
                                });
                            }
                            return [
                                2 /*return*/ ,
                                event
                            ];
                    }
                });
            });
        },
        teardown: function() {
            return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
                return (0, $bunH6.__generator)(this, function(_a) {
                    if (globalScope) {
                        globalScope.removeEventListener('popstate', handlePageChange);
                        isTracking = false;
                    }
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        }
    };
    return plugin;
};
var $d655f70c9190fddd$var$getCampaignParams = function() {
    return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
        var _a;
        return (0, $bunH6.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = (0, $85a93a67ee5818ee$export$d8a2b83131ad9e60);
                    return [
                        4 /*yield*/ ,
                        new (0, $23a80041871c3b55$export$6887fc37aa79947c)().parse()
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.apply(void 0, [
                            _b.sent()
                        ])
                    ];
            }
        });
    });
};
var $d655f70c9190fddd$var$isCampaignEvent = function(event) {
    if (event.event_type === '$identify' && event.user_properties) {
        var properties = event.user_properties;
        var $set = properties[(0, $b1034e6ea0b84810$export$6df138c24303c801).SET] || {};
        var $unset = properties[(0, $b1034e6ea0b84810$export$6df138c24303c801).UNSET] || {};
        var userProperties_1 = (0, $bunH6.__spreadArray)((0, $bunH6.__spreadArray)([], (0, $bunH6.__read)(Object.keys($set)), false), (0, $bunH6.__read)(Object.keys($unset)), false);
        return Object.keys((0, $c1d7ad7f2bf46bfb$export$ea7354d30dfda3a2)).every(function(value) {
            return userProperties_1.includes(value);
        });
    }
    return false;
};
var $d655f70c9190fddd$export$aa1b813607a1c442 = function(trackingOption, newURLStr, oldURLStr) {
    switch(trackingOption){
        case 'pathOnly':
            if (oldURLStr == '') return true;
            var newURL = new URL(newURLStr);
            var oldURL = new URL(oldURLStr);
            var newBaseStr = newURL.origin + newURL.pathname;
            var oldBaseStr = oldURL.origin + oldURL.pathname;
            return newBaseStr !== oldBaseStr;
        default:
            return newURLStr !== oldURLStr;
    }
};



var $bunH6 = parcelRequire("bunH6");


var $c4xZ2 = parcelRequire("c4xZ2");

var $6f4d95918d190882$export$9860fa124eec1ec4 = function() {
    var observer;
    var eventListeners = [];
    var addEventListener = function(element, type, handler) {
        element.addEventListener(type, handler);
        eventListeners.push({
            element: element,
            type: type,
            handler: handler
        });
    };
    var removeClickListeners = function() {
        eventListeners.forEach(function(_a) {
            var element = _a.element, type = _a.type, handler = _a.handler;
            /* istanbul ignore next */ element === null || element === void 0 || element.removeEventListener(type, handler);
        });
        eventListeners = [];
    };
    var formInteractionsConfig;
    var name = '@amplitude/plugin-form-interaction-tracking-browser';
    var type = 'enrichment';
    var setup = function(config, amplitude) {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            var initializeFormTracking, window_1;
            return (0, $bunH6.__generator)(this, function(_a) {
                formInteractionsConfig = (0, $d81f8d7bf36b1bca$export$1aa90c4af41b4740)(config);
                initializeFormTracking = function() {
                    /* istanbul ignore if */ if (!amplitude) {
                        // TODO: Add required minimum version of @amplitude/analytics-browser
                        config.loggerProvider.warn('Form interaction tracking requires a later version of @amplitude/analytics-browser. Form interaction events are not tracked.');
                        return;
                    }
                    /* istanbul ignore if */ if (typeof document === 'undefined') return;
                    var addedFormNodes = new WeakSet();
                    var addFormInteractionListener = function(form) {
                        if (addedFormNodes.has(form)) return;
                        addedFormNodes.add(form);
                        var hasFormChanged = false;
                        addEventListener(form, 'change', function() {
                            var _a;
                            var formDestination = $6f4d95918d190882$export$3906a216b8191dfd(form);
                            if (!hasFormChanged) amplitude.track((0, $d2f545e922cce685$export$d1eb2ccafb450617), (_a = {}, _a[0, $d2f545e922cce685$export$5f1ba54ed64fd212] = $6f4d95918d190882$export$fa9b0e03aaaa96ce(form.id), _a[0, $d2f545e922cce685$export$bc6883368baba346] = $6f4d95918d190882$export$fa9b0e03aaaa96ce(form.name), _a[0, $d2f545e922cce685$export$d10a870b47f53964] = formDestination, _a));
                            hasFormChanged = true;
                        });
                        addEventListener(form, 'submit', function(event) {
                            var _a, _b;
                            var formDestination = $6f4d95918d190882$export$3906a216b8191dfd(form);
                            if (!hasFormChanged) amplitude.track((0, $d2f545e922cce685$export$d1eb2ccafb450617), (_a = {}, _a[0, $d2f545e922cce685$export$5f1ba54ed64fd212] = $6f4d95918d190882$export$fa9b0e03aaaa96ce(form.id), _a[0, $d2f545e922cce685$export$bc6883368baba346] = $6f4d95918d190882$export$fa9b0e03aaaa96ce(form.name), _a[0, $d2f545e922cce685$export$d10a870b47f53964] = formDestination, _a));
                            hasFormChanged = true;
                            // Check if shouldTrackSubmit callback is provided and use it to determine whether to track form_submit
                            if ((formInteractionsConfig === null || formInteractionsConfig === void 0 ? void 0 : formInteractionsConfig.shouldTrackSubmit) !== undefined) {
                                if (typeof formInteractionsConfig.shouldTrackSubmit === 'function' && typeof SubmitEvent !== 'undefined' && event instanceof SubmitEvent) try {
                                    var shouldTrack = formInteractionsConfig.shouldTrackSubmit(event);
                                    if (!shouldTrack) return;
                                } catch (e) {
                                    config.loggerProvider.warn('shouldTrackSubmit callback threw an error, proceeding with tracking.');
                                }
                                else config.loggerProvider.warn('shouldTrackSubmit is ignored because it is not a function or event is not a SubmitEvent.');
                            }
                            amplitude.track((0, $d2f545e922cce685$export$8576ca1a5042bc32), (_b = {}, _b[0, $d2f545e922cce685$export$5f1ba54ed64fd212] = $6f4d95918d190882$export$fa9b0e03aaaa96ce(form.id), _b[0, $d2f545e922cce685$export$bc6883368baba346] = $6f4d95918d190882$export$fa9b0e03aaaa96ce(form.name), _b[0, $d2f545e922cce685$export$d10a870b47f53964] = formDestination, _b));
                            hasFormChanged = false;
                        });
                    };
                    // Adds listener to existing anchor tags
                    var forms = Array.from(document.getElementsByTagName('form'));
                    forms.forEach(addFormInteractionListener);
                    // Adds listener to anchor tags added after initial load
                    /* istanbul ignore else */ if (typeof MutationObserver !== 'undefined') {
                        observer = new MutationObserver(function(mutations) {
                            mutations.forEach(function(mutation) {
                                mutation.addedNodes.forEach(function(node) {
                                    if (node.nodeName === 'FORM') addFormInteractionListener(node);
                                    if ('querySelectorAll' in node && typeof node.querySelectorAll === 'function') Array.from(node.querySelectorAll('form')).map(addFormInteractionListener);
                                });
                            });
                        });
                        observer.observe(document.body, {
                            subtree: true,
                            childList: true
                        });
                    }
                };
                // If the document is already loaded, initialize immediately.
                if (document.readyState === 'complete') initializeFormTracking();
                else {
                    window_1 = (0, $c4xZ2.getGlobalScope)();
                    /* istanbul ignore else*/ if (window_1) window_1.addEventListener('load', initializeFormTracking);
                    else config.loggerProvider.debug('Form interaction tracking is not installed because global is undefined.');
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var execute = function(event) {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    event
                ];
            });
        });
    };
    var teardown = function() {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                observer === null || observer === void 0 || observer.disconnect();
                removeClickListeners();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return {
        name: name,
        type: type,
        setup: setup,
        execute: execute,
        teardown: teardown
    };
};
var $6f4d95918d190882$export$fa9b0e03aaaa96ce = function(name) {
    /* istanbul ignore if */ if (typeof name !== 'string') // We found instances where the value of `name` is an Element and not a string.
    // Elements may have circular references and would throw an error when passed to `JSON.stringify(...)`.
    // If a non-string value is seen, assume there is no value.
    return undefined;
    return name;
};
var $6f4d95918d190882$export$3906a216b8191dfd = function(form) {
    var formDestination = form.getAttribute('action');
    try {
        // eslint-disable-next-line no-restricted-globals
        formDestination = new URL(encodeURI(formDestination !== null && formDestination !== void 0 ? formDestination : ''), window.location.href).href;
    } catch (_a) {
    //
    }
    return formDestination;
};



var $bunH6 = parcelRequire("bunH6");


var $c4xZ2 = parcelRequire("c4xZ2");
var $91b9c203c48726f0$export$25832376988a00f6 = function() {
    var observer;
    var eventListeners = [];
    var addEventListener = function(element, type, handler) {
        element.addEventListener(type, handler);
        eventListeners.push({
            element: element,
            type: type,
            handler: handler
        });
    };
    var removeClickListeners = function() {
        eventListeners.forEach(function(_a) {
            var element = _a.element, type = _a.type, handler = _a.handler;
            /* istanbul ignore next */ element === null || element === void 0 || element.removeEventListener(type, handler);
        });
        eventListeners = [];
    };
    var name = '@amplitude/plugin-file-download-tracking-browser';
    var type = 'enrichment';
    var setup = function(config, amplitude) {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            var initializeFileDownloadTracking, window_1;
            return (0, $bunH6.__generator)(this, function(_a) {
                initializeFileDownloadTracking = function() {
                    /* istanbul ignore if */ if (!amplitude) {
                        // TODO: Add required minimum version of @amplitude/analytics-browser
                        config.loggerProvider.warn('File download tracking requires a later version of @amplitude/analytics-browser. File download events are not tracked.');
                        return;
                    }
                    /* istanbul ignore if */ if (typeof document === 'undefined') return;
                    var addFileDownloadListener = function(a) {
                        var url;
                        try {
                            // eslint-disable-next-line no-restricted-globals
                            url = new URL(a.href, window.location.href);
                        } catch (_a) {
                            /* istanbul ignore next */ return;
                        }
                        var result = ext.exec(url.href);
                        var fileExtension = result === null || result === void 0 ? void 0 : result[1];
                        if (fileExtension) addEventListener(a, 'click', function() {
                            var _a;
                            if (fileExtension) amplitude.track((0, $d2f545e922cce685$export$dd2608f2cca69490), (_a = {}, _a[0, $d2f545e922cce685$export$8cc480dee0a96fad] = fileExtension, _a[0, $d2f545e922cce685$export$4b79612785fd8d50] = url.pathname, _a[0, $d2f545e922cce685$export$13cfab8db9b47f6d] = a.id, _a[0, $d2f545e922cce685$export$d089d67a4077bf08] = a.text, _a[0, $d2f545e922cce685$export$1ac552145aa3025b] = a.href, _a));
                        });
                    };
                    var ext = /\.(pdf|xlsx?|docx?|txt|rtf|csv|exe|key|pp(s|t|tx)|7z|pkg|rar|gz|zip|avi|mov|mp4|mpe?g|wmv|midi?|mp3|wav|wma)(\?.+)?$/;
                    // Adds listener to existing anchor tags
                    var links = Array.from(document.getElementsByTagName('a'));
                    links.forEach(addFileDownloadListener);
                    // Adds listener to anchor tags added after initial load
                    /* istanbul ignore else */ if (typeof MutationObserver !== 'undefined') {
                        observer = new MutationObserver(function(mutations) {
                            mutations.forEach(function(mutation) {
                                mutation.addedNodes.forEach(function(node) {
                                    if (node.nodeName === 'A') addFileDownloadListener(node);
                                    if ('querySelectorAll' in node && typeof node.querySelectorAll === 'function') Array.from(node.querySelectorAll('a')).map(addFileDownloadListener);
                                });
                            });
                        });
                        observer.observe(document.body, {
                            subtree: true,
                            childList: true
                        });
                    }
                };
                // If the document is already loaded, initialize immediately.
                /* istanbul ignore else*/ if (document.readyState === 'complete') initializeFileDownloadTracking();
                else {
                    window_1 = (0, $c4xZ2.getGlobalScope)();
                    /* istanbul ignore else*/ if (window_1) window_1.addEventListener('load', initializeFileDownloadTracking);
                    else config.loggerProvider.debug('File download tracking is not installed because global is undefined.');
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var execute = function(event) {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    event
                ];
            });
        });
    };
    var teardown = function() {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                observer === null || observer === void 0 || observer.disconnect();
                removeClickListeners();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return {
        name: name,
        type: type,
        setup: setup,
        execute: execute,
        teardown: teardown
    };
};



var $0f671a966d8ee698$var$notified = false;
var $0f671a966d8ee698$export$baa23c8b1e397239 = function(config) {
    if ($0f671a966d8ee698$var$notified || config.defaultTracking !== undefined) return;
    var message = "`options.defaultTracking` is set to undefined. This implicitly configures your Amplitude instance to track Page Views, Sessions, File Downloads, and Form Interactions. You can suppress this warning by explicitly setting a value to `options.defaultTracking`. The value must either be a boolean, to enable and disable all default events, or an object, for advanced configuration. For example:\n\namplitude.init(<YOUR_API_KEY>, {\n  defaultTracking: true,\n});\n\nVisit https://www.docs.developers.amplitude.com/data/sdks/browser-2/#tracking-default-events for more details.";
    config.loggerProvider.warn(message);
    $0f671a966d8ee698$var$notified = true;
};
var $0f671a966d8ee698$export$6e4b3a224ceeea2a = function() {
    $0f671a966d8ee698$var$notified = false;
};



var $bunH6 = parcelRequire("bunH6");

var $c4xZ2 = parcelRequire("c4xZ2");
var $6c63ab46c1de032c$export$20326a3f5f1d9791 = function() {
    var name = '@amplitude/plugin-network-checker-browser';
    var type = 'before';
    var globalScope = (0, $c4xZ2.getGlobalScope)();
    var eventListeners = [];
    var addNetworkListener = function(type, handler) {
        /* istanbul ignore next */ if (globalScope === null || globalScope === void 0 ? void 0 : globalScope.addEventListener) {
            globalScope === null || globalScope === void 0 || globalScope.addEventListener(type, handler);
            eventListeners.push({
                type: type,
                handler: handler
            });
        }
    };
    var removeNetworkListeners = function() {
        eventListeners.forEach(function(_a) {
            var type = _a.type, handler = _a.handler;
            /* istanbul ignore next */ globalScope === null || globalScope === void 0 || globalScope.removeEventListener(type, handler);
        });
        eventListeners = [];
    };
    var setup = function(config, amplitude) {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                if (typeof navigator === 'undefined') {
                    config.loggerProvider.debug('Network connectivity checker plugin is disabled because navigator is not available.');
                    config.offline = false;
                    return [
                        2 /*return*/ 
                    ];
                }
                config.offline = !navigator.onLine;
                addNetworkListener('online', function() {
                    config.loggerProvider.debug('Network connectivity changed to online.');
                    config.offline = false;
                    // Flush immediately will cause ERR_NETWORK_CHANGED
                    setTimeout(function() {
                        amplitude.flush();
                    }, config.flushIntervalMillis);
                });
                addNetworkListener('offline', function() {
                    config.loggerProvider.debug('Network connectivity changed to offline.');
                    config.offline = true;
                });
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var teardown = function() {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                removeNetworkListeners();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return {
        name: name,
        type: type,
        setup: setup,
        teardown: teardown
    };
};



var $bunH6 = parcelRequire("bunH6");

function $ead06c3906638f9a$export$708d06044cf13f9b(config) {
    var e_1, _a, e_2, _b, e_3, _c;
    var _d, _e, _f, _g, _h;
    // Disabling type checking rules because remote config comes from a remote source
    // and this function needs to handle any unexpected values
    /* eslint-disable @typescript-eslint/no-unsafe-member-access,
       @typescript-eslint/no-unsafe-assignment,
       @typescript-eslint/no-unsafe-argument
   */ if (typeof config !== 'object' || config === null) return;
    // translations are not applied on array properties
    if (Array.isArray(config)) return;
    var propertyNames = Object.keys(config);
    try {
        for(var propertyNames_1 = (0, $bunH6.__values)(propertyNames), propertyNames_1_1 = propertyNames_1.next(); !propertyNames_1_1.done; propertyNames_1_1 = propertyNames_1.next()){
            var propertyName = propertyNames_1_1.value;
            try {
                var value = config[propertyName];
                // transform objects with { enabled } property to boolean | object
                if (typeof (value === null || value === void 0 ? void 0 : value.enabled) === 'boolean') {
                    if (value.enabled) {
                        // if enabled is true, set the value to the rest of the object
                        // or true if the object has no other properties
                        delete value.enabled;
                        if (Object.keys(value).length === 0) config[propertyName] = true;
                    } else // If enabled is false, set the value to false
                    config[propertyName] = false;
                }
                // recursively translate properties of the value
                $ead06c3906638f9a$export$708d06044cf13f9b(value);
            } catch (e) {
            // a failure here means that an accessor threw an error
            // so don't translate it
            // TODO(diagnostics): add a diagnostic event for this
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (propertyNames_1_1 && !propertyNames_1_1.done && (_a = propertyNames_1.return)) _a.call(propertyNames_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    // translate remote responseHeaders and requestHeaders to local responseHeaders and requestHeaders
    try {
        if ((_f = (_e = (_d = config.autocapture) === null || _d === void 0 ? void 0 : _d.networkTracking) === null || _e === void 0 ? void 0 : _e.captureRules) === null || _f === void 0 ? void 0 : _f.length) try {
            for(var _j = (0, $bunH6.__values)(config.autocapture.networkTracking.captureRules), _k = _j.next(); !_k.done; _k = _j.next()){
                var rule = _k.value;
                try {
                    for(var _l = (e_3 = void 0, (0, $bunH6.__values)([
                        'responseHeaders',
                        'requestHeaders'
                    ])), _m = _l.next(); !_m.done; _m = _l.next()){
                        var header = _m.value;
                        var _o = (_g = rule[header]) !== null && _g !== void 0 ? _g : {}, captureSafeHeaders = _o.captureSafeHeaders, allowlist = _o.allowlist;
                        if (!captureSafeHeaders && !allowlist) continue;
                        // if allowlist is not an array, remote config contract is violated, remove it
                        if (allowlist !== undefined && !Array.isArray(allowlist)) {
                            delete rule[header];
                            continue;
                        }
                        rule[header] = (0, $bunH6.__spreadArray)((0, $bunH6.__spreadArray)([], (0, $bunH6.__read)(captureSafeHeaders ? (0, $c1d7ad7f2bf46bfb$export$a52b450c7f480d9a) : []), false), (0, $bunH6.__read)(allowlist !== null && allowlist !== void 0 ? allowlist : []), false);
                    }
                } catch (e_3_1) {
                    e_3 = {
                        error: e_3_1
                    };
                } finally{
                    try {
                        if (_m && !_m.done && (_c = _l.return)) _c.call(_l);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_k && !_k.done && (_b = _j.return)) _b.call(_j);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    } catch (e) {
    /* istanbul ignore next */ // surprise exception, so don't translate it
    }
    // translate frustrationInteractions pluralization
    var frustrationInteractions = (_h = config.autocapture) === null || _h === void 0 ? void 0 : _h.frustrationInteractions;
    if (frustrationInteractions) {
        if (frustrationInteractions.rageClick) {
            frustrationInteractions.rageClicks = frustrationInteractions.rageClick;
            delete frustrationInteractions.rageClick;
        }
        if (frustrationInteractions.deadClick) {
            frustrationInteractions.deadClicks = frustrationInteractions.deadClick;
            delete frustrationInteractions.deadClick;
        }
    }
}
function $ead06c3906638f9a$var$mergeUrls(urlsExact, urlsRegex, browserConfig) {
    var e_4, _a;
    // Convert string patterns to RegExp objects, warn on invalid patterns and skip them
    var regexList = [];
    try {
        for(var _b = (0, $bunH6.__values)(urlsRegex !== null && urlsRegex !== void 0 ? urlsRegex : []), _c = _b.next(); !_c.done; _c = _b.next()){
            var pattern = _c.value;
            try {
                regexList.push(new RegExp(pattern));
            } catch (regexError) {
                browserConfig.loggerProvider.warn("Invalid regex pattern: ".concat(pattern), regexError);
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return urlsExact.concat(regexList);
}
function $ead06c3906638f9a$export$6385ab2d18f0ca55(remoteConfig, browserConfig) {
    var e_5, _a;
    var _b, _c, _d, _e, _f;
    if (!remoteConfig) return;
    // translate remote config to local compatible format
    $ead06c3906638f9a$export$708d06044cf13f9b(remoteConfig);
    try {
        browserConfig.loggerProvider.debug('Update browser config with remote configuration:', JSON.stringify(remoteConfig));
        // type cast error will be thrown if remoteConfig is not a valid RemoteConfigBrowserSDK
        // and it will be caught by the try-catch block
        var typedRemoteConfig = remoteConfig;
        // merge remoteConfig.autocapture and browserConfig.autocapture
        // if a field is in remoteConfig.autocapture, use that value
        // if a field is not in remoteConfig.autocapture, use the value from browserConfig.autocapture
        if (typedRemoteConfig && 'autocapture' in typedRemoteConfig) {
            if (typeof typedRemoteConfig.autocapture === 'boolean') browserConfig.autocapture = typedRemoteConfig.autocapture;
            if (typeof typedRemoteConfig.autocapture === 'object' && typedRemoteConfig.autocapture !== null) {
                var transformedAutocaptureRemoteConfig = (0, $bunH6.__assign)({}, typedRemoteConfig.autocapture);
                if (browserConfig.autocapture === undefined) browserConfig.autocapture = typedRemoteConfig.autocapture;
                // Handle Element Interactions config initialization
                if (typeof typedRemoteConfig.autocapture.elementInteractions === 'object' && typedRemoteConfig.autocapture.elementInteractions !== null && ((_b = typedRemoteConfig.autocapture.elementInteractions.pageUrlAllowlistRegex) === null || _b === void 0 ? void 0 : _b.length)) {
                    transformedAutocaptureRemoteConfig.elementInteractions = (0, $bunH6.__assign)({}, typedRemoteConfig.autocapture.elementInteractions);
                    var transformedRcElementInteractions = transformedAutocaptureRemoteConfig.elementInteractions;
                    // combine exact allow list and regex allow list into just 'pageUrlAllowlist'
                    var exactAllowList = (_c = transformedRcElementInteractions.pageUrlAllowlist) !== null && _c !== void 0 ? _c : [];
                    var urlsRegex = typedRemoteConfig.autocapture.elementInteractions.pageUrlAllowlistRegex;
                    transformedRcElementInteractions.pageUrlAllowlist = $ead06c3906638f9a$var$mergeUrls(exactAllowList, urlsRegex, browserConfig);
                    // clean up the regex allow list
                    delete transformedRcElementInteractions.pageUrlAllowlistRegex;
                }
                // Handle Network Tracking config initialization
                if (typeof typedRemoteConfig.autocapture.networkTracking === 'object' && typedRemoteConfig.autocapture.networkTracking !== null && ((_d = typedRemoteConfig.autocapture.networkTracking.captureRules) === null || _d === void 0 ? void 0 : _d.length)) {
                    transformedAutocaptureRemoteConfig.networkTracking = (0, $bunH6.__assign)({}, typedRemoteConfig.autocapture.networkTracking);
                    var transformedRcNetworkTracking = transformedAutocaptureRemoteConfig.networkTracking;
                    /* istanbul ignore next */ var captureRules = (_e = transformedRcNetworkTracking.captureRules) !== null && _e !== void 0 ? _e : [];
                    try {
                        for(var captureRules_1 = (0, $bunH6.__values)(captureRules), captureRules_1_1 = captureRules_1.next(); !captureRules_1_1.done; captureRules_1_1 = captureRules_1.next()){
                            var rule = captureRules_1_1.value;
                            rule.urls = $ead06c3906638f9a$var$mergeUrls((_f = rule.urls) !== null && _f !== void 0 ? _f : [], rule.urlsRegex, browserConfig);
                            delete rule.urlsRegex;
                        }
                    } catch (e_5_1) {
                        e_5 = {
                            error: e_5_1
                        };
                    } finally{
                        try {
                            if (captureRules_1_1 && !captureRules_1_1.done && (_a = captureRules_1.return)) _a.call(captureRules_1);
                        } finally{
                            if (e_5) throw e_5.error;
                        }
                    }
                }
                if (typeof browserConfig.autocapture === 'boolean') browserConfig.autocapture = (0, $bunH6.__assign)({
                    attribution: browserConfig.autocapture,
                    fileDownloads: browserConfig.autocapture,
                    formInteractions: browserConfig.autocapture,
                    pageViews: browserConfig.autocapture,
                    sessions: browserConfig.autocapture,
                    elementInteractions: browserConfig.autocapture,
                    webVitals: browserConfig.autocapture,
                    frustrationInteractions: browserConfig.autocapture
                }, transformedAutocaptureRemoteConfig);
                if (typeof browserConfig.autocapture === 'object') browserConfig.autocapture = (0, $bunH6.__assign)((0, $bunH6.__assign)({}, browserConfig.autocapture), transformedAutocaptureRemoteConfig);
            }
            // Override default tracking options if autocapture is updated by remote config
            browserConfig.defaultTracking = browserConfig.autocapture;
        }
        browserConfig.loggerProvider.debug('Browser config after remote config update:', JSON.stringify(browserConfig));
    } catch (e) {
        browserConfig.loggerProvider.error('Failed to apply remote configuration because of error: ', e);
    }
}



var $bunH6 = parcelRequire("bunH6");
/**
 * Default CSS selectors to define which elements on the page to track.
 * Extend this list to include additional elements to track. For example:
 * ```
 * autocapturePlugin({
 *    cssSelectorAllowlist: [...DEFAULT_CSS_SELECTOR_ALLOWLIST, ".my-class"],
 * })
 * ```
 */ var $86b2ff223bf803d2$export$b8b480c7efad756c = [
    'a',
    'button',
    'input',
    'select',
    'textarea',
    'label',
    'video',
    'audio',
    '[contenteditable="true" i]',
    '[data-amp-default-track]',
    '.amp-default-track'
];
var $86b2ff223bf803d2$export$98ba2b432b1218a9 = 'data-amp-track-';
var $86b2ff223bf803d2$export$1546873d565d1ebf = [
    'div',
    'span',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
];
var $86b2ff223bf803d2$export$f0e57fa749475e61 = 150;

// Shared origin constants for Amplitude cross-window communication
var $38d9e8c2db41042d$export$c50606b1594157ca = 'https://app.amplitude.com';
var $38d9e8c2db41042d$export$89cc575d7ddecf21 = 'https://app.eu.amplitude.com';
var $38d9e8c2db41042d$export$872be238b7ce36de = 'https://apps.stag2.amplitude.com';
var $38d9e8c2db41042d$export$89af84b5faccc270 = {
    US: $38d9e8c2db41042d$export$c50606b1594157ca,
    EU: $38d9e8c2db41042d$export$89cc575d7ddecf21,
    STAGING: $38d9e8c2db41042d$export$872be238b7ce36de
};
var $38d9e8c2db41042d$export$804db2504616df20 = 'https://cdn.amplitude.com/libs/background-capture-1.0.0-alpha.2.js.gz';


/**
 * Brand key set on the messenger instance to track whether background capture
 * has been enabled.
 */ var $3f3ee0ecc078bcce$var$BG_CAPTURE_BRAND = '__AMPLITUDE_BACKGROUND_CAPTURE__';
function $3f3ee0ecc078bcce$export$bd89b6a65bceda2c(messenger, options) {
    var _a;
    // Check the brand on the messenger object itself — works across bundle boundaries
    var branded = messenger;
    if (branded[$3f3ee0ecc078bcce$var$BG_CAPTURE_BRAND] === true) return;
    branded[$3f3ee0ecc078bcce$var$BG_CAPTURE_BRAND] = true;
    var scriptUrl = (_a = options === null || options === void 0 ? void 0 : options.scriptUrl) !== null && _a !== void 0 ? _a : (0, $38d9e8c2db41042d$export$804db2504616df20);
    var backgroundCaptureInstance = null;
    var onBackgroundCapture = function(type, backgroundCaptureData) {
        var _a, _b;
        if (type === 'background-capture-complete') {
            (_b = (_a = messenger.logger) === null || _a === void 0 ? void 0 : _a.debug) === null || _b === void 0 || _b.call(_a, 'Background capture complete');
            messenger.notify({
                action: 'background-capture-complete',
                data: backgroundCaptureData
            });
        }
    };
    messenger.registerActionHandler('initialize-background-capture', function() {
        var _a, _b;
        (_b = (_a = messenger.logger) === null || _a === void 0 ? void 0 : _a.debug) === null || _b === void 0 || _b.call(_a, 'Initializing background capture (external script)');
        var resolvedUrl = new URL(scriptUrl, messenger.endpoint).toString();
        messenger.loadScriptOnce(resolvedUrl).then(function() {
            var _a, _b, _c;
            (_b = (_a = messenger.logger) === null || _a === void 0 ? void 0 : _a.debug) === null || _b === void 0 || _b.call(_a, 'Background capture script loaded (external)');
            // eslint-disable-next-line
            backgroundCaptureInstance = /* istanbul ignore next -- window is always defined in browser */ (_c = window === null || window === void 0 ? void 0 : window.amplitudeBackgroundCapture) === null || _c === void 0 ? void 0 : _c.call(window, {
                messenger: messenger,
                onBackgroundCapture: onBackgroundCapture
            });
            messenger.notify({
                action: 'background-capture-loaded'
            });
        }).catch(function() {
            var _a;
            (_a = messenger.logger) === null || _a === void 0 || _a.warn('Failed to initialize background capture');
        });
    });
    messenger.registerActionHandler('close-background-capture', function() {
        var _a;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
        (_a = backgroundCaptureInstance === null || backgroundCaptureInstance === void 0 ? void 0 : backgroundCaptureInstance.close) === null || _a === void 0 || _a.call(backgroundCaptureInstance);
        backgroundCaptureInstance = null;
    });
}


var $c4xZ2 = parcelRequire("c4xZ2");
var $bunH6 = parcelRequire("bunH6");

var $c4xZ2 = parcelRequire("c4xZ2");

/* eslint-disable no-restricted-globals */ /**
 * Dynamically loads an external script by appending a <script> tag to the document head.
 * Deduplicates by checking if a script with the same src already exists.
 */ var $82916d90a19ab6a6$export$bebc04ef1f521ce0 = function(url) {
    // Dedup: if a script with this src already exists, resolve immediately
    var existing = document.querySelector("script[src=\"".concat(CSS.escape(url), "\"]"));
    if (existing) return Promise.resolve({
        status: true
    });
    return new Promise(function(resolve, reject) {
        var _a;
        try {
            var scriptElement = document.createElement('script');
            scriptElement.type = 'text/javascript';
            scriptElement.async = true;
            scriptElement.src = url;
            scriptElement.addEventListener('load', function() {
                resolve({
                    status: true
                });
            }, {
                once: true
            });
            scriptElement.addEventListener('error', function() {
                reject({
                    status: false,
                    message: "Failed to load the script ".concat(url)
                });
            });
            /* istanbul ignore next */ (_a = document.head) === null || _a === void 0 || _a.appendChild(scriptElement);
        } catch (error) {
            /* istanbul ignore next */ reject(error);
        }
    });
};
function $82916d90a19ab6a6$export$48da330df5248c4c() {
    return "".concat(Date.now(), "-").concat(Math.random().toString(36).substr(2, 9));
}


var $f9a90186b2a21d40$var$_a;
/**
 * Brand key used to identify BaseWindowMessenger instances across bundle boundaries.
 */ var $f9a90186b2a21d40$var$MESSENGER_BRAND = '__AMPLITUDE_MESSENGER_INSTANCE__';
/** Global scope key where the singleton messenger is stored. */ var $f9a90186b2a21d40$var$MESSENGER_GLOBAL_KEY = '__AMPLITUDE_MESSENGER__';
/**
 * BaseWindowMessenger provides generic cross-window communication via postMessage.
 * Singleton access via getOrCreateWindowMessenger() to prevent duplicate instances
 */ var $f9a90186b2a21d40$var$BaseWindowMessenger = /** @class */ function() {
    function BaseWindowMessenger(_b) {
        var _c = _b === void 0 ? {} : _b, _d = _c.origin, origin = _d === void 0 ? (0, $38d9e8c2db41042d$export$c50606b1594157ca) : _d;
        /** Brand property for cross-bundle instanceof checks. */ this[$f9a90186b2a21d40$var$_a] = true;
        this.isSetup = false;
        this.messageHandler = null;
        this.requestCallbacks = {};
        this.actionHandlers = new Map();
        /**
         * Messages received for actions that had no registered handler yet.
         * Drained automatically when the corresponding handler is registered via
         * registerActionHandler(), solving startup race conditions between
         * independently-initialized plugins.
         */ this.pendingMessages = new Map();
        /**
         * Tracks in-flight and completed script loads by URL.
         * Using a map, this prevents duplicate loads before the first resolves.
         */ this.scriptLoadPromises = new Map();
        this.endpoint = origin;
    }
    /**
     * Send a message to the parent window (window.opener).
     */ BaseWindowMessenger.prototype.notify = function(message) {
        var _b, _c, _d, _e;
        (_c = (_b = this.logger) === null || _b === void 0 ? void 0 : _b.debug) === null || _c === void 0 || _c.call(_b, 'Message sent: ', JSON.stringify(message));
        (_e = (_d = window.opener) === null || _d === void 0 ? void 0 : _d.postMessage) === null || _e === void 0 || _e.call(_d, message, this.endpoint);
    };
    /**
     * Send an async request to the parent window with a unique ID.
     * Returns a Promise that resolves when the parent responds.
     */ BaseWindowMessenger.prototype.sendRequest = function(action, args, options) {
        var _this = this;
        if (options === void 0) options = {
            timeout: 15000
        };
        var id = (0, $82916d90a19ab6a6$export$48da330df5248c4c)();
        var request = {
            id: id,
            action: action,
            args: args
        };
        var promise = new Promise(function(resolve, reject) {
            _this.requestCallbacks[id] = {
                resolve: resolve,
                reject: reject
            };
            _this.notify(request);
            if (options.timeout > 0) setTimeout(function() {
                reject(new Error("".concat(action, " timed out (id: ").concat(id, ")")));
                delete _this.requestCallbacks[id];
            }, options.timeout);
        });
        return promise;
    };
    /**
     * Handle a response to a previous request by resolving its Promise.
     */ BaseWindowMessenger.prototype.handleResponse = function(response) {
        var _b;
        if (!this.requestCallbacks[response.id]) {
            (_b = this.logger) === null || _b === void 0 || _b.warn("No callback found for request id: ".concat(response.id));
            return;
        }
        this.requestCallbacks[response.id].resolve(response.responseData);
        delete this.requestCallbacks[response.id];
    };
    /**
     * Register a handler for a specific action type.
     * Logs a warning if overwriting an existing handler.
     */ BaseWindowMessenger.prototype.registerActionHandler = function(action, handler) {
        var e_1, _b;
        var _c, _d;
        if (this.actionHandlers.has(action)) (_d = (_c = this.logger) === null || _c === void 0 ? void 0 : _c.warn) === null || _d === void 0 || _d.call(_c, "Overwriting existing action handler for: ".concat(action));
        this.actionHandlers.set(action, handler);
        // Replay any messages that arrived before this handler was registered
        var queued = this.pendingMessages.get(action);
        if (queued) {
            this.pendingMessages.delete(action);
            try {
                for(var queued_1 = (0, $bunH6.__values)(queued), queued_1_1 = queued_1.next(); !queued_1_1.done; queued_1_1 = queued_1.next()){
                    var data = queued_1_1.value;
                    handler(data);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (queued_1_1 && !queued_1_1.done && (_b = queued_1.return)) _b.call(queued_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
    };
    /**
     * Load a script once, deduplicating by URL.
     * Safe against concurrent calls — the second call awaits the first's in-flight Promise
     * rather than triggering a duplicate load.
     */ BaseWindowMessenger.prototype.loadScriptOnce = function(url) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var existing, loadPromise, error_1;
            return (0, $bunH6.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        existing = this.scriptLoadPromises.get(url);
                        if (existing) return [
                            2 /*return*/ ,
                            existing
                        ];
                        loadPromise = (0, $82916d90a19ab6a6$export$bebc04ef1f521ce0)(url).then(function() {
                        // Resolve to void
                        });
                        this.scriptLoadPromises.set(url, loadPromise);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            loadPromise
                        ];
                    case 2:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _b.sent();
                        // Remove failed loads so they can be retried
                        this.scriptLoadPromises.delete(url);
                        throw error_1;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Set up the message listener. Idempotent — safe to call multiple times.
     * Subclasses should call super.setup() and then register their own action handlers.
     */ BaseWindowMessenger.prototype.setup = function(_b) {
        var _this = this;
        var _c, _d;
        var _e = _b === void 0 ? {} : _b, logger = _e.logger, endpoint = _e.endpoint;
        if (logger) this.logger = logger;
        // If endpoint is customized, don't override a previously customized endpoint.
        if (endpoint && this.endpoint === (0, $38d9e8c2db41042d$export$c50606b1594157ca)) this.endpoint = endpoint;
        // Only attach the message listener once
        if (this.isSetup) return;
        this.isSetup = true;
        (_d = (_c = this.logger) === null || _c === void 0 ? void 0 : _c.debug) === null || _d === void 0 || _d.call(_c, 'Setting up messenger');
        // Attach Event Listener to listen for messages from the parent window
        this.messageHandler = function(event) {
            var _b, _c, _d, _e, _f;
            (_c = (_b = _this.logger) === null || _b === void 0 ? void 0 : _b.debug) === null || _c === void 0 || _c.call(_b, 'Message received: ', JSON.stringify(event));
            // Only accept messages from the specified origin
            if (_this.endpoint !== event.origin) return;
            var eventData = event.data;
            var action = eventData === null || eventData === void 0 ? void 0 : eventData.action;
            // Ignore messages without action
            if (!action) return;
            // If id exists, handle responses to previous requests
            if ('id' in eventData && eventData.id) {
                (_e = (_d = _this.logger) === null || _d === void 0 ? void 0 : _d.debug) === null || _e === void 0 || _e.call(_d, 'Received Response to previous request: ', JSON.stringify(event));
                _this.handleResponse(eventData);
            } else {
                if (action === 'ping') {
                    _this.notify({
                        action: 'pong'
                    });
                    return;
                }
                // Dispatch to registered action handlers, or buffer for late registration
                var handler = _this.actionHandlers.get(action);
                if (handler) handler(eventData.data);
                else {
                    var queue = (_f = _this.pendingMessages.get(action)) !== null && _f !== void 0 ? _f : [];
                    queue.push(eventData.data);
                    _this.pendingMessages.set(action, queue);
                }
            }
        };
        window.addEventListener('message', this.messageHandler);
        this.notify({
            action: 'page-loaded'
        });
    };
    /**
     * Tear down the messenger: remove the message listener, clear all state.
     */ BaseWindowMessenger.prototype.destroy = function() {
        if (this.messageHandler) {
            window.removeEventListener('message', this.messageHandler);
            this.messageHandler = null;
        }
        this.isSetup = false;
        this.actionHandlers.clear();
        this.pendingMessages.clear();
        this.requestCallbacks = {};
        this.scriptLoadPromises.clear();
        // Remove from global scope if this is the singleton
        var globalScope = (0, $c4xZ2.getGlobalScope)();
        if ((globalScope === null || globalScope === void 0 ? void 0 : globalScope[$f9a90186b2a21d40$var$MESSENGER_GLOBAL_KEY]) === this) delete globalScope[$f9a90186b2a21d40$var$MESSENGER_GLOBAL_KEY];
    };
    return BaseWindowMessenger;
}();
$f9a90186b2a21d40$var$_a = $f9a90186b2a21d40$var$MESSENGER_BRAND;
/**
 * Type guard: checks whether a value is a BaseWindowMessenger instance.
 */ function $f9a90186b2a21d40$var$isWindowMessenger(value) {
    return typeof value === 'object' && value !== null && $f9a90186b2a21d40$var$MESSENGER_BRAND in value && value[$f9a90186b2a21d40$var$MESSENGER_BRAND] === true;
}
function $f9a90186b2a21d40$export$2b183171c77d5a89(options) {
    var globalScope = (0, $c4xZ2.getGlobalScope)();
    var existing = globalScope === null || globalScope === void 0 ? void 0 : globalScope[$f9a90186b2a21d40$var$MESSENGER_GLOBAL_KEY];
    if ($f9a90186b2a21d40$var$isWindowMessenger(existing)) return existing;
    var messenger = new $f9a90186b2a21d40$var$BaseWindowMessenger(options);
    if (globalScope) globalScope[$f9a90186b2a21d40$var$MESSENGER_GLOBAL_KEY] = messenger;
    return messenger;
}


var $bunH6 = parcelRequire("bunH6");
var $465e706a1980c9f4$exports = {};

$465e706a1980c9f4$exports = (parcelRequire("hLn5L")).Observable;


/**
 * asyncMap operator for Zen Observable
 *
 * Maps each value emitted by the source Observable using an async function,
 * emitting the resolved values in the same order they arrive.
 */ function $2c30177b55b54dbd$export$707ee4c4c95d39e3(observable, fn) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($465e706a1980c9f4$exports)))(function(observer) {
        observable.subscribe({
            next: function(value) {
                fn(value).then(function(result) {
                    return observer.next(result);
                }).catch(function(error) {
                    return observer.error(error);
                });
            },
            error: function(error) {
                observer.error(error);
            },
            complete: function() {
                observer.complete();
            }
        });
    });
}
/**
 * merge operator for Zen Observable
 *
 * Merges two observables into a single observable, emitting values from both sources in the order they arrive.
 * @param sourceA Observable to merge
 * @param sourceB Observable to merge
 * @returns Unsubscribable cleanup function
 */ function $2c30177b55b54dbd$export$4950aa0f605343fb(sourceA, sourceB) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($465e706a1980c9f4$exports)))(function(observer) {
        var closed = false;
        var subscriptions = new Set();
        var cleanup = function() {
            var e_1, _a;
            closed = true;
            try {
                for(var subscriptions_1 = (0, $bunH6.__values)(subscriptions), subscriptions_1_1 = subscriptions_1.next(); !subscriptions_1_1.done; subscriptions_1_1 = subscriptions_1.next()){
                    var sub = subscriptions_1_1.value;
                    try {
                        sub.unsubscribe();
                    } catch (_b) {
                    /* do nothing */ }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (subscriptions_1_1 && !subscriptions_1_1.done && (_a = subscriptions_1.return)) _a.call(subscriptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            subscriptions.clear();
        };
        var subscribeTo = function(source) {
            var sub = source.subscribe({
                next: function(value) {
                    if (!closed) observer.next(value);
                },
                error: function(err) {
                    if (!closed) {
                        closed = true;
                        observer.error(err);
                        cleanup();
                    }
                },
                complete: function() {
                    subscriptions.delete(sub);
                    if (!closed && subscriptions.size === 0) {
                        observer.complete();
                        cleanup();
                        closed = true;
                    }
                }
            });
            subscriptions.add(sub);
        };
        subscribeTo(sourceA);
        subscribeTo(sourceB);
        return cleanup;
    });
}
// function share() {
function $2c30177b55b54dbd$export$1364843af8d5a963(source) {
    var observers = new Set();
    var subscription = null;
    function cleanup() {
        /* istanbul ignore next */ subscription === null || subscription === void 0 || subscription.unsubscribe();
        subscription = null;
        observers.clear();
    }
    return new (0, (/*@__PURE__*/$parcel$interopDefault($465e706a1980c9f4$exports)))(function(observer) {
        observers.add(observer);
        if (subscription === null) subscription = source.subscribe({
            next: function(value) {
                var e_2, _a;
                var _b;
                try {
                    for(var observers_1 = (0, $bunH6.__values)(observers), observers_1_1 = observers_1.next(); !observers_1_1.done; observers_1_1 = observers_1.next()){
                        var obs = observers_1_1.value;
                        /* istanbul ignore next */ (_b = obs.next) === null || _b === void 0 || _b.call(obs, value);
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (observers_1_1 && !observers_1_1.done && (_a = observers_1.return)) _a.call(observers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            },
            error: function(err) {
                var e_3, _a;
                var _b;
                try {
                    for(var observers_2 = (0, $bunH6.__values)(observers), observers_2_1 = observers_2.next(); !observers_2_1.done; observers_2_1 = observers_2.next()){
                        var obs = observers_2_1.value;
                        /* istanbul ignore next */ (_b = obs.error) === null || _b === void 0 || _b.call(obs, err);
                    }
                } catch (e_3_1) {
                    e_3 = {
                        error: e_3_1
                    };
                } finally{
                    try {
                        if (observers_2_1 && !observers_2_1.done && (_a = observers_2.return)) _a.call(observers_2);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                }
                cleanup();
            },
            complete: function() {
                var e_4, _a;
                var _b;
                try {
                    for(var observers_3 = (0, $bunH6.__values)(observers), observers_3_1 = observers_3.next(); !observers_3_1.done; observers_3_1 = observers_3.next()){
                        var obs = observers_3_1.value;
                        /* istanbul ignore next */ (_b = obs.complete) === null || _b === void 0 || _b.call(obs);
                    }
                } catch (e_4_1) {
                    e_4 = {
                        error: e_4_1
                    };
                } finally{
                    try {
                        if (observers_3_1 && !observers_3_1.done && (_a = observers_3.return)) _a.call(observers_3);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                }
                cleanup();
            }
        });
        // Return unsubscribe function for this observer
        return function() {
            observers.delete(observer);
            // If no observers left, unsubscribe from the source
            if (observers.size === 0 && subscription) {
                subscription.unsubscribe();
                subscription = null;
            }
        };
    });
}


var $018823fbc4c7683b$export$a4ad2735b021c132 = '1.24.0';



var $b9be34b9cefd2a81$export$3e69d3882a51f072 = '@amplitude/plugin-autocapture-browser';
var $b9be34b9cefd2a81$export$270d5ae3019308e5 = '@amplitude/plugin-frustration-browser';
var $b9be34b9cefd2a81$export$f3b4383d12baa476 = '[Amplitude] Element Clicked';
var $b9be34b9cefd2a81$export$17b824da0ec1c8ba = '[Amplitude] Dead Click';
var $b9be34b9cefd2a81$export$efb273b74f733f19 = '[Amplitude] Rage Click';
var $b9be34b9cefd2a81$export$49ccb1b3108a13dc = '[Amplitude] Error Click';
var $b9be34b9cefd2a81$export$85e9bc084297e396 = '[Amplitude] Element Changed';
var $b9be34b9cefd2a81$export$c5b24069e7a20116 = '[Amplitude] Page Scrolled';
var $b9be34b9cefd2a81$export$26ee3309f451c44 = '[Amplitude] Thrashed Cursor';
var $b9be34b9cefd2a81$export$396cd5ad29ba6170 = '[Amplitude] Element ID';
var $b9be34b9cefd2a81$export$9ae6b2f9f20abf50 = '[Amplitude] Element Class';
var $b9be34b9cefd2a81$export$ae8ed2ec3f47ca91 = '[Amplitude] Element Tag';
var $b9be34b9cefd2a81$export$6f4405900e290a66 = '[Amplitude] Element Text';
var $b9be34b9cefd2a81$export$1703b32b7bd9766d = '[Amplitude] Element Hierarchy';
var $b9be34b9cefd2a81$export$253517022e31d52 = '[Amplitude] Element Href';
var $b9be34b9cefd2a81$export$9a82fc4a0d569f9f = '[Amplitude] Element Position Left';
var $b9be34b9cefd2a81$export$41bd9356c6ad03b6 = '[Amplitude] Element Position Top';
var $b9be34b9cefd2a81$export$fe59f70315258b43 = '[Amplitude] Element Aria Label';
var $b9be34b9cefd2a81$export$24fead99416f658b = '[Amplitude] Element Attributes';
var $b9be34b9cefd2a81$export$ff07ccafdb757725 = '[Amplitude] Element Path';
var $b9be34b9cefd2a81$export$a458f4751a32ecbb = '[Amplitude] Element Parent Label';
var $b9be34b9cefd2a81$export$af0bc70234f2db5c = '[Amplitude] Page URL';
var $b9be34b9cefd2a81$export$236baf0f9c4fa772 = '[Amplitude] Page Title';
var $b9be34b9cefd2a81$export$f87aa46d335ec78e = '[Amplitude] Viewport Height';
var $b9be34b9cefd2a81$export$624bc6029c85c6ab = '[Amplitude] Viewport Width';
var $b9be34b9cefd2a81$export$17b4c7350dadf5ce = '[Amplitude] Max Page X';
var $b9be34b9cefd2a81$export$b509e6040aff7d27 = '[Amplitude] Max Page Y';
var $b9be34b9cefd2a81$export$553c8cbea8d8bb30 = '[Amplitude] Page View ID';
var $b9be34b9cefd2a81$export$1b9b88568d382c42 = 'https://cdn.amplitude.com/libs/visual-tagging-selector-1.0.0-alpha.js.gz';
var $b9be34b9cefd2a81$export$37613fce6e64ba0c = 'amp-visual-tagging-selector-highlight';
var $b9be34b9cefd2a81$export$341c05124aaddb32 = 'data-amp-mask-attributes';
var $b9be34b9cefd2a81$export$e852de43ee12445 = 25;
var $b9be34b9cefd2a81$export$de243096419150c7 = 128;
var $b9be34b9cefd2a81$export$c6d132de2f8d2b4f = 'AMP_PAGE_VIEW';
var $b9be34b9cefd2a81$export$a0f2dd29107ae52e = 18000;



var $bunH6 = parcelRequire("bunH6");

var $c4xZ2 = parcelRequire("c4xZ2");/**
 * Checks if a given URL matches any pattern in an allowlist of URLs or regex patterns.
 * @param url - The URL to check
 * @param allowlist - Array of allowed URLs (strings) or regex patterns
 * @returns true if the URL matches any pattern in the allowlist, false otherwise
 */ var $cfec2d180e2010e9$export$d00b17649a2434e7 = function(url, allowlist) {
    if (!allowlist || !allowlist.length) return true;
    return allowlist.some(function(allowedUrl) {
        if (typeof allowedUrl === 'string') return url === allowedUrl;
        return url.match(allowedUrl);
    });
};
var $cfec2d180e2010e9$export$c9f67ffc80012d9b = function(locationStr, loggerProvider) {
    var decodedLocationStr = locationStr;
    try {
        decodedLocationStr = decodeURI(locationStr);
    } catch (e) {
        /* istanbul ignore next */ loggerProvider === null || loggerProvider === void 0 || loggerProvider.error('Malformed URI sequence: ', e);
    }
    return decodedLocationStr;
};



var $54c5a19232a3034b$var$SENSITIVE_TAGS = [
    'input',
    'select',
    'textarea'
];
var $54c5a19232a3034b$export$a4394e437f962c02 = function(element, actionType) {
    var _a;
    /* istanbul ignore next */ var computedStyle = (_a = window === null || window === void 0 ? void 0 : window.getComputedStyle) === null || _a === void 0 ? void 0 : _a.call(window, element);
    /* istanbul ignore next */ return (computedStyle === null || computedStyle === void 0 ? void 0 : computedStyle.getPropertyValue('cursor')) === 'pointer' && actionType === 'click';
};
var $54c5a19232a3034b$export$8592af4e162d7307 = function(autocaptureOptions) {
    var pageUrlAllowlist = autocaptureOptions.pageUrlAllowlist, pageUrlExcludelist = autocaptureOptions.pageUrlExcludelist;
    // check if the URL is in the excludelist
    if (pageUrlExcludelist && pageUrlExcludelist.length > 0 && (0, $cfec2d180e2010e9$export$d00b17649a2434e7)(window.location.href, pageUrlExcludelist)) return false;
    // check if the URL is in the allow list
    if (!(0, $cfec2d180e2010e9$export$d00b17649a2434e7)(window.location.href, pageUrlAllowlist)) return false;
    return true;
};
var $54c5a19232a3034b$export$d41a31caec8ff08e = function(autocaptureOptions, allowlist, isAlwaysCaptureCursorPointer) {
    if (isAlwaysCaptureCursorPointer === void 0) isAlwaysCaptureCursorPointer = false;
    return function(actionType, element) {
        var _a, _b;
        var shouldTrackEventResolver = autocaptureOptions.shouldTrackEventResolver;
        /* istanbul ignore next */ var tag = (_b = (_a = element === null || element === void 0 ? void 0 : element.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a);
        // window, document, and Text nodes have no tag
        if (!tag) return false;
        if (shouldTrackEventResolver) return shouldTrackEventResolver(actionType, element);
        if (!$54c5a19232a3034b$export$8592af4e162d7307(autocaptureOptions)) return false;
        /* istanbul ignore next */ var elementType = String(element === null || element === void 0 ? void 0 : element.getAttribute('type')) || '';
        if (typeof elementType === 'string') switch(elementType.toLowerCase()){
            case 'hidden':
                return false;
            case 'password':
                return false;
        }
        var isCursorPointer = $54c5a19232a3034b$export$a4394e437f962c02(element, actionType);
        if (isAlwaysCaptureCursorPointer && isCursorPointer) return true;
        /* istanbul ignore if */ if (allowlist) {
            var hasMatchAnyAllowedSelector = allowlist.some(function(selector) {
                var _a;
                return !!((_a = element === null || element === void 0 ? void 0 : element.matches) === null || _a === void 0 ? void 0 : _a.call(element, selector));
            });
            if (!hasMatchAnyAllowedSelector) return false;
        }
        switch(tag){
            case 'input':
            case 'select':
            case 'textarea':
                return actionType === 'change' || actionType === 'click';
            default:
                /* istanbul ignore next */ /* istanbul ignore next */ if (isCursorPointer) return true;
                return actionType === 'click';
        }
    };
};
var $54c5a19232a3034b$export$ccbedd67ef6e9417 = function(node) {
    return !!node && node.nodeType === 3;
};
var $54c5a19232a3034b$export$ba13c53ef9595524 = function(element) {
    var _a, _b, _c;
    /* istanbul ignore next */ var tag = (_b = (_a = element === null || element === void 0 ? void 0 : element.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a);
    var isContentEditable = element instanceof HTMLElement ? ((_c = element.getAttribute('contenteditable')) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === 'true' : false;
    return !$54c5a19232a3034b$var$SENSITIVE_TAGS.includes(tag) && !isContentEditable;
};
var $54c5a19232a3034b$export$ed77f6c811aa55ed = function(attributeString) {
    return attributeString ? attributeString.split(',').map(function(attr) {
        return attr.trim();
    }).filter(function(attr) {
        return attr.length > 0 && attr !== 'id' && attr !== 'class';
    }) // Prevent 'id' and 'class' from being redacted as they're critical for element identification
     : [];
};
var $54c5a19232a3034b$export$94e317a984c35cd8 = function(attrs, prefix) {
    return Object.entries(attrs).reduce(function(attributes, _a) {
        var _b = (0, $bunH6.__read)(_a, 2), attributeName = _b[0], attributeValue = _b[1];
        if (attributeName.startsWith(prefix)) {
            var attributeKey = attributeName.replace(prefix, '');
            if (attributeKey) attributes[attributeKey] = attributeValue || '';
        }
        return attributes;
    }, {});
};
var $54c5a19232a3034b$export$dd1bc94b04021eeb = function(value) {
    return value === undefined || value === null || typeof value === 'object' && Object.keys(value).length === 0 || typeof value === 'string' && value.trim().length === 0;
};
var $54c5a19232a3034b$export$b2489c11de31bff2 = function(properties) {
    return Object.keys(properties).reduce(function(filteredProperties, key) {
        var value = properties[key];
        if (!$54c5a19232a3034b$export$dd1bc94b04021eeb(value)) filteredProperties[key] = value;
        return filteredProperties;
    }, {});
};
var $54c5a19232a3034b$export$e6bc05b59029fa37 = function() {
    var _a;
    try {
        var globalScope = (0, $c4xZ2.getGlobalScope)();
        /* istanbul ignore next */ var raw = (_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.sessionStorage) === null || _a === void 0 ? void 0 : _a.getItem($b9be34b9cefd2a81$export$c6d132de2f8d2b4f);
        if (!raw) return undefined;
        var parsed = JSON.parse(raw);
        if (typeof parsed.pageViewId === 'string') return parsed.pageViewId;
    } catch (_b) {
    // ignore storage access or JSON errors
    }
    return undefined;
};
var $54c5a19232a3034b$export$cf9227551c5a1597 = function(root, selectors) {
    if (root && 'querySelectorAll' in root && typeof root.querySelectorAll === 'function') {
        var elementSet = selectors.reduce(function(elements, selector) {
            if (selector) {
                var selectedElements = Array.from(root.querySelectorAll(selector));
                selectedElements.forEach(function(element) {
                    elements.add(element);
                });
            }
            return elements;
        }, new Set());
        return Array.from(elementSet);
    }
    return [];
};
var $54c5a19232a3034b$export$6eaaca7dcffbc81f = function(element, selectors) {
    if (!element) return null;
    /* istanbul ignore next */ if (selectors.some(function(selector) {
        var _a;
        return (_a = element === null || element === void 0 ? void 0 : element.matches) === null || _a === void 0 ? void 0 : _a.call(element, selector);
    })) return element;
    /* istanbul ignore next */ return $54c5a19232a3034b$export$6eaaca7dcffbc81f(element === null || element === void 0 ? void 0 : element.parentElement, selectors);
};
var $54c5a19232a3034b$export$bebc04ef1f521ce0 = function(url) {
    return new Promise(function(resolve, reject) {
        var _a;
        try {
            var scriptElement = document.createElement('script');
            scriptElement.type = 'text/javascript';
            scriptElement.async = true;
            scriptElement.src = url;
            scriptElement.addEventListener('load', function() {
                resolve({
                    status: true
                });
            }, {
                once: true
            });
            scriptElement.addEventListener('error', function() {
                reject({
                    status: false,
                    message: "Failed to load the script ".concat(url)
                });
            });
            /* istanbul ignore next */ (_a = document.head) === null || _a === void 0 || _a.appendChild(scriptElement);
        } catch (error) {
            /* istanbul ignore next */ reject(error);
        }
    });
};
function $54c5a19232a3034b$export$48da330df5248c4c() {
    return "".concat(Date.now(), "-").concat(Math.random().toString(36).substr(2, 9));
}
var $54c5a19232a3034b$export$80a5e1fd8987729f = function(event) {
    // Filter out changeEvent events with no target
    // This could happen when change events are triggered programmatically
    if (event.event.target === null || !event.closestTrackedAncestor) return false;
    return true;
};
function $54c5a19232a3034b$export$e4f91743485e39de(event) {
    return event.type === 'click' || event.type === 'change';
}
var $54c5a19232a3034b$export$92850d9476e00eee;
(function(MouseButton) {
    MouseButton[MouseButton["LEFT_OR_TOUCH_CONTACT"] = 0] = "LEFT_OR_TOUCH_CONTACT";
    MouseButton[MouseButton["MIDDLE"] = 1] = "MIDDLE";
    MouseButton[MouseButton["RIGHT"] = 2] = "RIGHT";
})($54c5a19232a3034b$export$92850d9476e00eee || ($54c5a19232a3034b$export$92850d9476e00eee = {}));


/* istanbul ignore file */ /* eslint-disable no-restricted-globals */ 

/**
 * Brand key to track whether visual tagging has been enabled on a messenger.
 */ var $9d8afee6a8f9296a$var$VISUAL_TAGGING_BRAND = '__AMPLITUDE_VISUAL_TAGGING__';
function $9d8afee6a8f9296a$export$6d290bb5fed1c68c(messenger, options) {
    // Idempotency guard — works across bundle boundaries
    var branded = messenger;
    if (branded[$9d8afee6a8f9296a$var$VISUAL_TAGGING_BRAND] === true) return;
    branded[$9d8afee6a8f9296a$var$VISUAL_TAGGING_BRAND] = true;
    var dataExtractor = options.dataExtractor, isElementSelectable = options.isElementSelectable, cssSelectorAllowlist = options.cssSelectorAllowlist, actionClickAllowlist = options.actionClickAllowlist;
    var amplitudeVisualTaggingSelectorInstance = null;
    var onSelect = function(data) {
        messenger.notify({
            action: 'element-selected',
            data: data
        });
    };
    var onTrack = function(type, properties) {
        if (type === 'selector-mode-changed') messenger.notify({
            action: 'track-selector-mode-changed',
            data: properties
        });
        else if (type === 'selector-moved') messenger.notify({
            action: 'track-selector-moved',
            data: properties
        });
    };
    messenger.registerActionHandler('initialize-visual-tagging-selector', function(actionData) {
        messenger.loadScriptOnce((0, $b9be34b9cefd2a81$export$1b9b88568d382c42)).then(function() {
            var _a;
            // eslint-disable-next-line
            amplitudeVisualTaggingSelectorInstance = (_a = window === null || window === void 0 ? void 0 : window.amplitudeVisualTaggingSelector) === null || _a === void 0 ? void 0 : _a.call(window, {
                getEventTagProps: dataExtractor.getEventTagProps,
                isElementSelectable: function(element) {
                    if (isElementSelectable) return isElementSelectable((actionData === null || actionData === void 0 ? void 0 : actionData.actionType) || 'click', element);
                    return true;
                },
                onTrack: onTrack,
                onSelect: onSelect,
                visualHighlightClass: (0, $b9be34b9cefd2a81$export$37613fce6e64ba0c),
                messenger: messenger,
                cssSelectorAllowlist: cssSelectorAllowlist,
                actionClickAllowlist: actionClickAllowlist,
                extractDataFromDataSource: dataExtractor.extractDataFromDataSource,
                dataExtractor: dataExtractor,
                diagnostics: {
                    autocapture: {
                        version: (0, $018823fbc4c7683b$export$a4ad2735b021c132)
                    }
                }
            });
            messenger.notify({
                action: 'selector-loaded'
            });
        }).catch(function() {
            var _a;
            (_a = messenger.logger) === null || _a === void 0 || _a.warn('Failed to initialize visual tagging selector');
        });
    });
    messenger.registerActionHandler('close-visual-tagging-selector', function() {
        var _a;
        // eslint-disable-next-line
        (_a = amplitudeVisualTaggingSelectorInstance === null || amplitudeVisualTaggingSelectorInstance === void 0 ? void 0 : amplitudeVisualTaggingSelectorInstance.close) === null || _a === void 0 || _a.call(amplitudeVisualTaggingSelectorInstance);
    });
}




function $81a9c83b55337a38$export$9219358a81f9347a(_a) {
    var amplitude = _a.amplitude, allObservables = _a.allObservables, shouldTrackEvent = _a.shouldTrackEvent, evaluateTriggers = _a.evaluateTriggers;
    var clickObservable = allObservables.clickObservable;
    var clickObservableFiltered = clickObservable.filter((0, $54c5a19232a3034b$export$80a5e1fd8987729f)).filter(function(click) {
        // Only track clicks on elements that should be tracked,
        return shouldTrackEvent('click', click.closestTrackedAncestor);
    }).map(function(click) {
        return evaluateTriggers(click);
    });
    var clicks = clickObservableFiltered;
    return clicks.subscribe(function(click) {
        /* istanbul ignore next */ amplitude === null || amplitude === void 0 || amplitude.track((0, $b9be34b9cefd2a81$export$f3b4383d12baa476), click.targetElementProperties);
    });
}




function $6a72d168288c1ba5$export$706320a461885e7(_a) {
    var amplitude = _a.amplitude, allObservables = _a.allObservables, getEventProperties = _a.getEventProperties, shouldTrackEvent = _a.shouldTrackEvent, evaluateTriggers = _a.evaluateTriggers;
    var changeObservable = allObservables.changeObservable;
    var filteredChangeObservable = changeObservable.filter((0, $54c5a19232a3034b$export$80a5e1fd8987729f)).filter(function(changeEvent) {
        // Only track change on elements that should be tracked,
        return shouldTrackEvent('change', changeEvent.closestTrackedAncestor);
    }).map(function(changeEvent) {
        return evaluateTriggers(changeEvent);
    });
    return filteredChangeObservable.subscribe(function(changeEvent) {
        /* istanbul ignore next */ amplitude === null || amplitude === void 0 || amplitude.track((0, $b9be34b9cefd2a81$export$85e9bc084297e396), getEventProperties('change', changeEvent.closestTrackedAncestor));
    });
}





function $ef9c44b7a3a8fad6$export$c35243ecb650b344(_a) {
    var amplitude = _a.amplitude, allObservables = _a.allObservables, options = _a.options, getEventProperties = _a.getEventProperties, shouldTrackEvent = _a.shouldTrackEvent, shouldTrackActionClick = _a.shouldTrackActionClick;
    var clickObservable = allObservables.clickObservable, mutationObservable = allObservables.mutationObservable, navigateObservable = allObservables.navigateObservable;
    var filteredClickObservable = clickObservable.filter(function(click) {
        return !shouldTrackEvent('click', click.closestTrackedAncestor);
    }).map(function(click) {
        // overwrite the closestTrackedAncestor with the closest element that is on the actionClickAllowlist
        var closestActionClickEl = (0, $54c5a19232a3034b$export$6eaaca7dcffbc81f)(click.event.target, options.actionClickAllowlist);
        click.closestTrackedAncestor = closestActionClickEl;
        // overwrite the targetElementProperties with the properties of the closestActionClickEl
        if (click.closestTrackedAncestor !== null) click.targetElementProperties = getEventProperties(click.type, click.closestTrackedAncestor);
        return click;
    }).filter((0, $54c5a19232a3034b$export$80a5e1fd8987729f)).filter(function(clickEvent) {
        // Only track change on elements that should be tracked
        return shouldTrackActionClick('click', clickEvent.closestTrackedAncestor);
    });
    var mutationOrNavigate = navigateObservable ? (0, $2c30177b55b54dbd$export$4950aa0f605343fb)(mutationObservable, navigateObservable) : mutationObservable;
    var clickMutationNavigateObservable = (0, $2c30177b55b54dbd$export$4950aa0f605343fb)(filteredClickObservable, mutationOrNavigate);
    var actionClickTimer = null;
    var lastClickEvent = null;
    var actionClickObservable = (0, $2c30177b55b54dbd$export$707ee4c4c95d39e3)(clickMutationNavigateObservable, function(event) {
        // clear any previous timer
        if (actionClickTimer) {
            clearTimeout(actionClickTimer);
            actionClickTimer = null;
        }
        if (event.type === 'click') {
            // mark the 'last click event'
            lastClickEvent = event;
            // set a timer to clear last click event if no mutation event between now and 500ms
            actionClickTimer = setTimeout(function() {
                actionClickTimer = null;
                lastClickEvent = null;
            }, 500);
            return Promise.resolve(null);
        } else // if mutation/navigation + last click event, then it's an action click
        if (lastClickEvent) {
            var event_1 = lastClickEvent;
            lastClickEvent = null;
            return Promise.resolve(event_1);
        }
        return Promise.resolve(null);
    });
    return actionClickObservable.subscribe(function(actionClick) {
        if (!actionClick) return;
        /* istanbul ignore next */ amplitude === null || amplitude === void 0 || amplitude.track((0, $b9be34b9cefd2a81$export$f3b4383d12baa476), getEventProperties('click', actionClick.closestTrackedAncestor));
    });
}



var $c4xZ2 = parcelRequire("c4xZ2");
function $31a1078e93882161$export$de1563ff5a1bae99(_a) {
    var amplitude = _a.amplitude, allObservables = _a.allObservables;
    var scrollObservable = allObservables.scrollObservable;
    var state = {
        maxX: 0,
        maxY: 0
    };
    var scrollSubscription = scrollObservable.subscribe(function() {
        var _a, _b, _c, _d;
        var globalScope = (0, $c4xZ2.getGlobalScope)();
        /* istanbul ignore next */ var currentX = Math.floor((_b = (_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.scrollX) !== null && _a !== void 0 ? _a : globalScope === null || globalScope === void 0 ? void 0 : globalScope.pageXOffset) !== null && _b !== void 0 ? _b : 0);
        /* istanbul ignore next */ var currentY = Math.floor((_d = (_c = globalScope === null || globalScope === void 0 ? void 0 : globalScope.scrollY) !== null && _c !== void 0 ? _c : globalScope === null || globalScope === void 0 ? void 0 : globalScope.pageYOffset) !== null && _d !== void 0 ? _d : 0);
        // Update page-level max positions for Page View End event (never resets during page lifetime)
        state.maxX = Math.max(state.maxX, currentX);
        state.maxY = Math.max(state.maxY, currentY);
    });
    return {
        unsubscribe: function() {
            scrollSubscription.unsubscribe();
        },
        getState: function() {
            return state;
        },
        reset: function() {
            state.maxX = 0;
            state.maxY = 0;
        }
    };
}



var $bunH6 = parcelRequire("bunH6");

var $bunH6 = parcelRequire("bunH6");

var $c4xZ2 = parcelRequire("c4xZ2");
var $86f17f20fdd08957$var$globalScope = (0, $c4xZ2.getGlobalScope)();
/* istanbul ignore next */ var $86f17f20fdd08957$var$originalConsole = $86f17f20fdd08957$var$globalScope === null || $86f17f20fdd08957$var$globalScope === void 0 ? void 0 : $86f17f20fdd08957$var$globalScope.console;
var $86f17f20fdd08957$var$handlers = {};
// keeps reference to original console methods
var $86f17f20fdd08957$var$originalFn = {};
var $86f17f20fdd08957$var$inConsoleOverride = false;
function $86f17f20fdd08957$var$overrideConsole(logLevel) {
    /* istanbul ignore if */ if (!$86f17f20fdd08957$var$originalConsole) return false;
    // should not override if original console property is not a function
    /* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */ if (typeof $86f17f20fdd08957$var$originalConsole[logLevel] !== 'function') return false;
    // if console is already overridden, return true
    if ($86f17f20fdd08957$var$originalFn[logLevel]) return true;
    // override console method
    var handler = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        try {
            if ($86f17f20fdd08957$var$handlers[logLevel] && !$86f17f20fdd08957$var$inConsoleOverride) {
                // add a re-entrancy guard to prevent infinite recursion
                $86f17f20fdd08957$var$inConsoleOverride = true;
                var callbacks = $86f17f20fdd08957$var$handlers[logLevel];
                if (callbacks) callbacks.forEach(function(callback) {
                    try {
                        callback(logLevel, args);
                    } catch (_a) {
                    // do nothing
                    }
                });
            }
        } catch (_a) {
        // do nothing
        }
        $86f17f20fdd08957$var$inConsoleOverride = false;
        return $86f17f20fdd08957$var$originalFn[logLevel].apply($86f17f20fdd08957$var$originalConsole, args);
    };
    /* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */ $86f17f20fdd08957$var$originalFn[logLevel] = $86f17f20fdd08957$var$originalConsole[logLevel];
    /* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */ $86f17f20fdd08957$var$originalConsole[logLevel] = handler;
    return true;
}
/**
 * Observe a console log method (log, warn, error, etc.)
 * @param level - The console log level to observe
 * @param callback - The callback function to call when the console log level is observed
 */ function $86f17f20fdd08957$var$addListener(level, callback) {
    var res = $86f17f20fdd08957$var$overrideConsole(level);
    /* istanbul ignore if */ if (!res) return new Error('Console override failed');
    if ($86f17f20fdd08957$var$handlers[level]) // using ! is safe because we know the key exists based on condition above
    $86f17f20fdd08957$var$handlers[level].push(callback);
    else $86f17f20fdd08957$var$handlers[level] = [
        callback
    ];
}
/**
 * Disconnect a callback function from a console log method
 * @param callback - The callback function to disconnect
 */ function $86f17f20fdd08957$var$removeListener(callback) {
    var e_1, _a;
    try {
        for(var _b = (0, $bunH6.__values)(Object.values($86f17f20fdd08957$var$handlers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var callbacks = _c.value;
            // iterate backwards to avoid index shifting
            for(var i = callbacks.length - 1; i >= 0; i--)if (callbacks[i] === callback) {
                callbacks.splice(i, 1);
                break;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
// this should only be used for testing
// restoring console can break console overrides
function $86f17f20fdd08957$var$_restoreConsole() {
    var e_2, _a;
    try {
        for(var _b = (0, $bunH6.__values)(Object.entries($86f17f20fdd08957$var$originalFn)), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = (0, $bunH6.__read)(_c.value, 2), key = _d[0], originalHandler = _d[1];
            if (originalHandler) /* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */ $86f17f20fdd08957$var$originalConsole[key] = originalHandler;
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    $86f17f20fdd08957$var$originalFn = {};
    $86f17f20fdd08957$var$handlers = {};
}
var $86f17f20fdd08957$export$a38b5952958ba26b = {
    addListener: $86f17f20fdd08957$var$addListener,
    removeListener: $86f17f20fdd08957$var$removeListener,
    _restoreConsole: $86f17f20fdd08957$var$_restoreConsole
};


var $c4xZ2 = parcelRequire("c4xZ2");
/* eslint-disable-next-line no-restricted-globals */ var $9ea49793bd7bd466$var$globalScope = (0, $c4xZ2.getGlobalScope)();
var $9ea49793bd7bd466$export$ae86221051ab432c = function() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($465e706a1980c9f4$exports)))(function(observer) {
        var mutationObserver = new MutationObserver(function(mutations) {
            observer.next(mutations);
        });
        if (document.body) mutationObserver.observe(document.body, {
            childList: true,
            attributes: true,
            characterData: true,
            subtree: true
        });
        return function() {
            return mutationObserver.disconnect();
        };
    });
};
var $9ea49793bd7bd466$export$17326e1836d300d0 = function(clickType) {
    if (clickType === void 0) clickType = 'click';
    return new (0, (/*@__PURE__*/$parcel$interopDefault($465e706a1980c9f4$exports)))(function(observer) {
        var _a;
        var handler = function(event) {
            observer.next(event);
        };
        (_a = (0, $c4xZ2.getGlobalScope)()) === null || _a === void 0 || _a.document.addEventListener(clickType, handler, {
            capture: true
        });
        return function() {
            var _a;
            (_a = (0, $c4xZ2.getGlobalScope)()) === null || _a === void 0 || _a.document.removeEventListener(clickType, handler, {
                capture: true
            });
        };
    });
};
var $9ea49793bd7bd466$export$b539d46c36ea700e = function() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($465e706a1980c9f4$exports)))(function(observer) {
        var _a;
        var handler = function(event) {
            observer.next(event);
        };
        (_a = (0, $c4xZ2.getGlobalScope)()) === null || _a === void 0 || _a.addEventListener('scroll', handler);
        return function() {
            var _a;
            (_a = (0, $c4xZ2.getGlobalScope)()) === null || _a === void 0 || _a.removeEventListener('scroll', handler);
        };
    });
};
var $9ea49793bd7bd466$var$createConsoleErrorObservable = function() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($465e706a1980c9f4$exports)))(function(observer) {
        var handler = function(_) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            /* istanbul ignore next */ var message = undefined;
            if (Array.isArray(args[0]) && typeof args[0][0] === 'string') message = args[0][0];
            observer.next({
                kind: 'console',
                message: message
            });
        };
        (0, $86f17f20fdd08957$export$a38b5952958ba26b).addListener('error', handler);
        return function() {
            (0, $86f17f20fdd08957$export$a38b5952958ba26b).removeListener(handler);
        };
    });
};
var $9ea49793bd7bd466$export$8ee1f0515582594e = function(mutationObservable, selectorAllowlist) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($465e706a1980c9f4$exports)))(function(observer) {
        var _a;
        var globalScope = (0, $c4xZ2.getGlobalScope)();
        if (!(globalScope === null || globalScope === void 0 ? void 0 : globalScope.IntersectionObserver)) return function() {
            return;
        };
        var intersectionObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                observer.next(entry);
            });
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 1.0
        });
        // Observe initial elements
        var selectorString = selectorAllowlist.join(',');
        /* istanbul ignore next */ var initialElements = (_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.document.querySelectorAll(selectorString)) !== null && _a !== void 0 ? _a : [];
        initialElements.forEach(function(element) {
            intersectionObserver.observe(element);
        });
        // Use mutation observable to observe new elements that match the allowlist
        var mutationSubscription = mutationObservable.subscribe(function(_a) {
            var event = _a.event;
            return event.forEach(function(_a) {
                var addedNodes = _a.addedNodes;
                return addedNodes.forEach(function(node) {
                    if (!(node instanceof Element)) return;
                    if (node.matches(selectorString)) intersectionObserver.observe(node);
                    node.querySelectorAll(selectorString).forEach(function(child) {
                        intersectionObserver.observe(child);
                    });
                });
            });
        });
        return function() {
            mutationSubscription.unsubscribe();
            intersectionObserver.disconnect();
        };
    });
};
var $9ea49793bd7bd466$var$createUnhandledErrorObservable = function() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($465e706a1980c9f4$exports)))(function(observer) {
        var handler = function(event) {
            if (!(event instanceof ErrorEvent)) return;
            var output = {
                kind: 'error'
            };
            if (event.error instanceof Error || event.error instanceof DOMException) output = (0, $bunH6.__assign)((0, $bunH6.__assign)({}, output), {
                message: event.error.message,
                stack: event.error.stack,
                filename: event.filename,
                lineNumber: event.lineno,
                columnNumber: event.colno
            });
            else if (typeof event.error === 'string') output.message = event.error;
            observer.next(output);
        };
        $9ea49793bd7bd466$var$globalScope.addEventListener('error', handler);
        return function() {
            $9ea49793bd7bd466$var$globalScope.removeEventListener('error', handler);
        };
    });
};
var $9ea49793bd7bd466$var$createUnhandledRejectionObservable = function() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($465e706a1980c9f4$exports)))(function(observer) {
        var handler = function(event) {
            var output = {
                kind: 'unhandledrejection'
            };
            if (event.reason instanceof Error || event.reason instanceof DOMException) {
                output.message = event.reason.message;
                output.stack = event.reason.stack;
            } else if (typeof event.reason === 'string') output.message = event.reason;
            observer.next(output);
        };
        $9ea49793bd7bd466$var$globalScope.addEventListener('unhandledrejection', handler);
        return function() {
            $9ea49793bd7bd466$var$globalScope.removeEventListener('unhandledrejection', handler);
        };
    });
};
var $9ea49793bd7bd466$export$4ca5586b47f14f0e = function() {
    var unhandledErrorObservable = (0, $2c30177b55b54dbd$export$4950aa0f605343fb)($9ea49793bd7bd466$var$createUnhandledErrorObservable(), $9ea49793bd7bd466$var$createUnhandledRejectionObservable());
    return (0, $2c30177b55b54dbd$export$4950aa0f605343fb)(unhandledErrorObservable, $9ea49793bd7bd466$var$createConsoleErrorObservable());
};
var $9ea49793bd7bd466$export$efd8ddb852fb51ed = function() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($465e706a1980c9f4$exports)))(function(observer) {
        var handler = function(event) {
            observer.next(event);
        };
        var args = {
            capture: true
        };
        $9ea49793bd7bd466$var$globalScope.document.addEventListener('mousemove', handler, args);
        return function() {
            $9ea49793bd7bd466$var$globalScope.document.removeEventListener('mousemove', handler, args);
        };
    });
};



var $bunH6 = parcelRequire("bunH6");
/**
 * Matches an event to a single filter
 * @param event - The event to match
 * @param filter - The filter to match against
 * @returns boolean indicating if the event matches the filter
 */ var $84986cac8e327a15$export$bca9d3dc7eb3075b = function(event, filter) {
    try {
        if (filter.subprop_key === '[Amplitude] Element Text') // TODO: add support for the other operators
        return filter.subprop_op === 'is' && filter.subprop_value.includes(event.targetElementProperties['[Amplitude] Element Text']);
        else if (filter.subprop_key === '[Amplitude] Element Hierarchy') // Check if the element ancestory matches the CSS selector, always check this last since it is the most expensive
        return filter.subprop_op === 'autotrack css match' && !!event.closestTrackedAncestor.closest(filter.subprop_value.toString());
    } catch (error) {
        console.error('Error matching event to filter', error);
        return false;
    }
    return false;
};


// Get DataSource
/**
 * Gets the DOM element specified by the data source configuration
 * @param dataSource - Configuration for finding the target element
 * @param contextElement - The element to start searching from
 * @returns The matching DOM element or undefined if not found
 */ var $a4b960de921798f6$export$de16705e2b70ea0f = function(dataSource, contextElement) {
    // Only process DOM_ELEMENT type data sources
    try {
        if (dataSource.sourceType === 'DOM_ELEMENT') {
            // If scope is specified, find the closest ancestor matching the scope rather than using documentElement (html) as the scope
            var scopingElement = document.documentElement;
            if (dataSource.scope && contextElement) scopingElement = contextElement.closest(dataSource.scope);
            // If we have both a scope and selector, find the matching element
            if (scopingElement && dataSource.selector) return scopingElement.querySelector(dataSource.selector);
            // Return scopingElement if no selector was specified
            return scopingElement;
        }
    } catch (error) {
        return undefined;
    }
    // Return undefined for non-DOM_ELEMENT data sources
    return undefined;
};
var $a4b960de921798f6$export$43201cdb85c83f7e = function(actions, ev, dataExtractor) {
    actions.forEach(function(action) {
        // Skip if actions is string until action set is implemented
        if (typeof action === 'string') return;
        if (action.actionType === 'ATTACH_EVENT_PROPERTY') {
            var data = dataExtractor.extractDataFromDataSource(action.dataSource, ev.closestTrackedAncestor);
            // Attach data to event
            ev.targetElementProperties[action.destinationKey] = data;
        }
    });
};


var $2ee7b39997bc4d7d$var$eventTypeToBrowserEventMap = {
    '[Amplitude] Element Clicked': 'click',
    '[Amplitude] Element Changed': 'change'
};
var $2ee7b39997bc4d7d$export$fdbc88d42bd65290 = function(labeledEvents) {
    var e_1, _a, e_2, _b;
    // Initialize all event types with empty sets
    var groupedLabeledEvents = Object.values($2ee7b39997bc4d7d$var$eventTypeToBrowserEventMap).reduce(function(acc, browserEvent) {
        acc[browserEvent] = new Set();
        return acc;
    }, {});
    // If there are no labeled events, return the initialized groupedLabeledEvents
    if (!labeledEvents) return groupedLabeledEvents;
    try {
        // Group labeled events by event type
        for(var labeledEvents_1 = (0, $bunH6.__values)(labeledEvents), labeledEvents_1_1 = labeledEvents_1.next(); !labeledEvents_1_1.done; labeledEvents_1_1 = labeledEvents_1.next()){
            var le = labeledEvents_1_1.value;
            try {
                try {
                    for(var _c = (e_2 = void 0, (0, $bunH6.__values)(le.definition)), _d = _c.next(); !_d.done; _d = _c.next()){
                        var def = _d.value;
                        var browserEvent = $2ee7b39997bc4d7d$var$eventTypeToBrowserEventMap[def.event_type];
                        if (browserEvent) groupedLabeledEvents[browserEvent].add(le.id);
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            } catch (e) {
                // Skip this labeled event if there is an error
                console.warn('Skipping Labeled Event due to malformed definition', le === null || le === void 0 ? void 0 : le.id, e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (labeledEvents_1_1 && !labeledEvents_1_1.done && (_a = labeledEvents_1.return)) _a.call(labeledEvents_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return groupedLabeledEvents;
};
var $2ee7b39997bc4d7d$export$a2303575174a625e = function(triggers) {
    var e_3, _a, e_4, _b;
    var labeledEventToTriggerMap = new Map();
    try {
        for(var triggers_1 = (0, $bunH6.__values)(triggers), triggers_1_1 = triggers_1.next(); !triggers_1_1.done; triggers_1_1 = triggers_1.next()){
            var trigger = triggers_1_1.value;
            try {
                for(var _c = (e_4 = void 0, (0, $bunH6.__values)(trigger.conditions)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var condition = _d.value;
                    if (condition.type === 'LABELED_EVENT') {
                        var eventId = condition.match.eventId;
                        // Get existing triggers for this event ID or initialize empty array
                        var existingTriggers = labeledEventToTriggerMap.get(eventId);
                        if (!existingTriggers) {
                            existingTriggers = [];
                            labeledEventToTriggerMap.set(eventId, existingTriggers);
                        }
                        // Add current trigger to the list of triggers for this event ID
                        existingTriggers.push(trigger);
                    }
                }
            } catch (e_4_1) {
                e_4 = {
                    error: e_4_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                } finally{
                    if (e_4) throw e_4.error;
                }
            }
        }
    } catch (e_3_1) {
        e_3 = {
            error: e_3_1
        };
    } finally{
        try {
            if (triggers_1_1 && !triggers_1_1.done && (_a = triggers_1.return)) _a.call(triggers_1);
        } finally{
            if (e_3) throw e_3.error;
        }
    }
    return labeledEventToTriggerMap;
};
var $2ee7b39997bc4d7d$export$12bf49d7a08e8161 = function(event, labeledEvents) {
    return labeledEvents.filter(function(le) {
        return le.definition.some(function(def) {
            return $2ee7b39997bc4d7d$var$eventTypeToBrowserEventMap[def.event_type] === event.type && def.filters.every(function(filter) {
                return (0, $84986cac8e327a15$export$bca9d3dc7eb3075b)(event, filter);
            });
        });
    });
};
var $2ee7b39997bc4d7d$export$2dd353f9f52951f9 = function(labeledEvents, leToTriggerMap) {
    var e_5, _a, e_6, _b;
    var matchingTriggers = new Set();
    try {
        for(var labeledEvents_2 = (0, $bunH6.__values)(labeledEvents), labeledEvents_2_1 = labeledEvents_2.next(); !labeledEvents_2_1.done; labeledEvents_2_1 = labeledEvents_2.next()){
            var le = labeledEvents_2_1.value;
            var triggers = leToTriggerMap.get(le.id);
            if (triggers) try {
                for(var triggers_2 = (e_6 = void 0, (0, $bunH6.__values)(triggers)), triggers_2_1 = triggers_2.next(); !triggers_2_1.done; triggers_2_1 = triggers_2.next()){
                    var trigger = triggers_2_1.value;
                    matchingTriggers.add(trigger);
                }
            } catch (e_6_1) {
                e_6 = {
                    error: e_6_1
                };
            } finally{
                try {
                    if (triggers_2_1 && !triggers_2_1.done && (_b = triggers_2.return)) _b.call(triggers_2);
                } finally{
                    if (e_6) throw e_6.error;
                }
            }
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (labeledEvents_2_1 && !labeledEvents_2_1.done && (_a = labeledEvents_2.return)) _a.call(labeledEvents_2);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return Array.from(matchingTriggers);
};
var $2ee7b39997bc4d7d$export$f401308cc4d064a = /** @class */ function() {
    function TriggerEvaluator(groupedLabeledEvents, labeledEventToTriggerMap, dataExtractor, options) {
        this.groupedLabeledEvents = groupedLabeledEvents;
        this.labeledEventToTriggerMap = labeledEventToTriggerMap;
        this.dataExtractor = dataExtractor;
        this.options = options;
    }
    TriggerEvaluator.prototype.evaluate = function(event) {
        var e_7, _a;
        // If there is no pageActions, return the event as is
        var pageActions = this.options.pageActions;
        if (!pageActions) return event;
        // Find matching labeled events
        var matchingLabeledEvents = $2ee7b39997bc4d7d$export$12bf49d7a08e8161(event, Array.from(this.groupedLabeledEvents[event.type]).map(function(id) {
            return pageActions.labeledEvents[id];
        }));
        // Find matching conditions
        var matchingTriggers = $2ee7b39997bc4d7d$export$2dd353f9f52951f9(matchingLabeledEvents, this.labeledEventToTriggerMap);
        try {
            for(var matchingTriggers_1 = (0, $bunH6.__values)(matchingTriggers), matchingTriggers_1_1 = matchingTriggers_1.next(); !matchingTriggers_1_1.done; matchingTriggers_1_1 = matchingTriggers_1.next()){
                var trigger = matchingTriggers_1_1.value;
                (0, $a4b960de921798f6$export$43201cdb85c83f7e)(trigger.actions, event, this.dataExtractor);
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (matchingTriggers_1_1 && !matchingTriggers_1_1.done && (_a = matchingTriggers_1.return)) _a.call(matchingTriggers_1);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        return event;
    };
    TriggerEvaluator.prototype.update = function(groupedLabeledEvents, labeledEventToTriggerMap, options) {
        this.groupedLabeledEvents = groupedLabeledEvents;
        this.labeledEventToTriggerMap = labeledEventToTriggerMap;
        this.options = options;
    };
    return TriggerEvaluator;
}();
var $2ee7b39997bc4d7d$export$93f6f82af2a132d = function(groupedLabeledEvents, labeledEventToTriggerMap, dataExtractor, options) {
    return new $2ee7b39997bc4d7d$export$f401308cc4d064a(groupedLabeledEvents, labeledEventToTriggerMap, dataExtractor, options);
};



var $bunH6 = parcelRequire("bunH6");




var $bunH6 = parcelRequire("bunH6");



var $11152a1086667f8a$var$BLOCKED_ATTRIBUTES = new Set([
    // Already captured elsewhere in the hierarchy object
    'id',
    'class',
    // non-useful and potentially large attribute
    'style',
    // sensitive as prefilled form data may populate this attribute
    'value',
    // DOM events
    'onclick',
    'onchange',
    'oninput',
    'onblur',
    'onsubmit',
    'onfocus',
    'onkeydown',
    'onkeyup',
    'onkeypress',
    // React specific
    'data-reactid',
    'data-react-checksum',
    'data-reactroot',
    // Amplitude specific - used for redaction but should not be included in getElementProperties
    (0, $b9be34b9cefd2a81$export$341c05124aaddb32),
    (0, $d098392c6f9e3beb$export$1d7c7f33294ad29b)
]);
var $11152a1086667f8a$var$SENSITIVE_ELEMENT_ATTRIBUTE_ALLOWLIST = [
    'type'
];
var $11152a1086667f8a$var$SVG_TAGS = [
    'svg',
    'path',
    'g'
];
var $11152a1086667f8a$var$HIGHLY_SENSITIVE_INPUT_TYPES = [
    'password',
    'hidden'
];
var $11152a1086667f8a$export$e1a64f8689a4361f = 1024;
function $11152a1086667f8a$export$d693bc18648a5069(element, userMaskedAttributeNames) {
    var e_1, _a;
    var _b, _c, _d, _e;
    if (element === null) return null;
    var tagName = String(element.tagName).toLowerCase();
    var properties = {
        tag: tagName
    };
    var siblings = Array.from((_c = (_b = element.parentElement) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : []);
    if (siblings.length) {
        properties.index = siblings.indexOf(element);
        properties.indexOfType = siblings.filter(function(el) {
            return el.tagName === element.tagName;
        }).indexOf(element);
    }
    var prevSiblingTag = (_e = (_d = element.previousElementSibling) === null || _d === void 0 ? void 0 : _d.tagName) === null || _e === void 0 ? void 0 : _e.toLowerCase();
    if (prevSiblingTag) properties.prevSib = String(prevSiblingTag);
    var id = element.getAttribute('id');
    if (id) properties.id = String(id);
    var classes = Array.from(element.classList);
    if (classes.length) properties.classes = classes;
    var attributes = {};
    var attributesArray = Array.from(element.attributes);
    var filteredAttributes = attributesArray.filter(function(attr) {
        return !$11152a1086667f8a$var$BLOCKED_ATTRIBUTES.has(attr.name);
    });
    var isSensitiveElement = !(0, $54c5a19232a3034b$export$ba13c53ef9595524)(element);
    // if input is hidden or password or for SVGs, skip attribute collection entirely
    if (!$11152a1086667f8a$var$HIGHLY_SENSITIVE_INPUT_TYPES.includes(String(element.getAttribute('type'))) && !$11152a1086667f8a$var$SVG_TAGS.includes(tagName)) try {
        for(var filteredAttributes_1 = (0, $bunH6.__values)(filteredAttributes), filteredAttributes_1_1 = filteredAttributes_1.next(); !filteredAttributes_1_1.done; filteredAttributes_1_1 = filteredAttributes_1.next()){
            var attr = filteredAttributes_1_1.value;
            // If sensitive element, only allow certain attributes
            if (isSensitiveElement && !$11152a1086667f8a$var$SENSITIVE_ELEMENT_ATTRIBUTE_ALLOWLIST.includes(attr.name)) continue;
            if (userMaskedAttributeNames.has(attr.name)) {
                attributes[attr.name] = (0, $d098392c6f9e3beb$export$bad2cbf8e277cf85);
                continue;
            }
            // Finally cast attribute value to string and limit attribute value length
            attributes[attr.name] = String(attr.value).substring(0, $b9be34b9cefd2a81$export$de243096419150c7);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (filteredAttributes_1_1 && !filteredAttributes_1_1.done && (_a = filteredAttributes_1.return)) _a.call(filteredAttributes_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    if (Object.keys(attributes).length) properties.attrs = attributes;
    return properties;
}
function $11152a1086667f8a$export$c6fd3ab3f44300d0(targetEl) {
    var ancestors = [];
    if (!targetEl) return ancestors;
    // Add self to the list of ancestors
    ancestors.push(targetEl);
    var current = targetEl.parentElement;
    while(current && current.tagName !== 'HTML'){
        ancestors.push(current);
        current = current.parentElement;
    }
    return ancestors;
}



/* istanbul ignore file */ 
var $bunH6 = parcelRequire("bunH6");
// Code is adapted from The Chromium Authors.
// Source: https://github.com/ChromeDevTools/devtools-frontend/blob/main/front_end/panels/elements/DOMPath.ts#L14
// License: BSD-style license
//
// Copyright 2014 The Chromium Authors
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
//    * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
//    * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
//    * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
var $8881c18b55c6611c$var$Step = /** @class */ function() {
    function Step(value, optimized) {
        this.value = value;
        this.optimized = optimized;
    }
    Step.prototype.toString = function() {
        return this.value;
    };
    return Step;
}();
var $8881c18b55c6611c$export$a33ca12c106e2477 = function(node, optimized) {
    // `node` is already an Element; this check is defensive.
    if (node.nodeType !== Node.ELEMENT_NODE) return '';
    var steps = [];
    var contextNode = node;
    while(contextNode){
        var step = $8881c18b55c6611c$var$cssPathStep(contextNode, Boolean(optimized), contextNode === node);
        if (!step) break;
         // bail out early
        steps.push(step);
        if (step.optimized) break;
        contextNode = contextNode.parentElement;
    }
    steps.reverse();
    return steps.join(' > ');
};
var $8881c18b55c6611c$var$cssPathStep = function(node, optimized, isTargetNode) {
    var e_1, _a;
    if (node.nodeType !== Node.ELEMENT_NODE) return null;
    var id = node.getAttribute('id');
    if (optimized) {
        if (id) return new $8881c18b55c6611c$var$Step(idSelector(id), true);
        var nodeNameLower = node.tagName.toLowerCase();
        if (nodeNameLower === 'body' || nodeNameLower === 'head' || nodeNameLower === 'html') return new $8881c18b55c6611c$var$Step(nodeNameLower, true);
    }
    var nodeName = node.tagName.toLowerCase();
    if (id) return new $8881c18b55c6611c$var$Step(nodeName + idSelector(id), true);
    var parent = node.parentNode;
    if (!parent || parent.nodeType === Node.DOCUMENT_NODE) return new $8881c18b55c6611c$var$Step(nodeName, true);
    function prefixedElementClassNames(el) {
        var classAttribute = el.getAttribute('class');
        if (!classAttribute) return [];
        return classAttribute.split(/\s+/g).filter(Boolean).map(function(name) {
            // The prefix is required to store "__proto__" in a object-based map.
            return '$' + name;
        });
    }
    function idSelector(id) {
        return '#' + CSS.escape(id);
    }
    var prefixedOwnClassNamesArray = prefixedElementClassNames(node);
    var needsClassNames = false;
    var needsNthChild = false;
    var ownIndex = -1;
    var elementIndex = -1;
    var siblings = parent.children;
    for(var i = 0; siblings && (ownIndex === -1 || !needsNthChild) && i < siblings.length; ++i){
        var sibling = siblings[i];
        if (sibling.nodeType !== Node.ELEMENT_NODE) continue;
        elementIndex += 1;
        if (sibling === node) {
            ownIndex = elementIndex;
            continue;
        }
        if (needsNthChild) continue;
        if (sibling.tagName.toLowerCase() !== nodeName) continue;
        needsClassNames = true;
        var ownClassNames = new Set(prefixedOwnClassNamesArray);
        if (!ownClassNames.size) {
            needsNthChild = true;
            continue;
        }
        var siblingClassNamesArray = prefixedElementClassNames(sibling);
        for(var j = 0; j < siblingClassNamesArray.length; ++j){
            var siblingClass = siblingClassNamesArray[j];
            if (!ownClassNames.has(siblingClass)) continue;
            ownClassNames.delete(siblingClass);
            if (!ownClassNames.size) {
                needsNthChild = true;
                break;
            }
        }
    }
    var result = nodeName;
    if (isTargetNode && nodeName.toLowerCase() === 'input' && node.getAttribute('type') && !node.getAttribute('id') && !node.getAttribute('class')) result += '[type=' + CSS.escape(node.getAttribute('type') || '') + ']';
    if (needsNthChild) result += ':nth-child(' + String(ownIndex + 1) + ')';
    else if (needsClassNames) try {
        for(var prefixedOwnClassNamesArray_1 = (0, $bunH6.__values)(prefixedOwnClassNamesArray), prefixedOwnClassNamesArray_1_1 = prefixedOwnClassNamesArray_1.next(); !prefixedOwnClassNamesArray_1_1.done; prefixedOwnClassNamesArray_1_1 = prefixedOwnClassNamesArray_1.next()){
            var prefixedName = prefixedOwnClassNamesArray_1_1.value;
            result += '.' + CSS.escape(prefixedName.slice(1));
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (prefixedOwnClassNamesArray_1_1 && !prefixedOwnClassNamesArray_1_1.done && (_a = prefixedOwnClassNamesArray_1.return)) _a.call(prefixedOwnClassNamesArray_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return new $8881c18b55c6611c$var$Step(result, false);
};


var $98cd574e8fe80c36$export$bf982f10504e5dd3 = /** @class */ function() {
    function DataExtractor(options, context) {
        var e_1, _a;
        var _this = this;
        var _b;
        /**
         * Wrapper method to replace sensitive strings using the helper function
         * @param text - The text to search for sensitive data
         * @returns The text with sensitive data replaced by masked text
         */ this.replaceSensitiveString = function(text) {
            return (0, $d098392c6f9e3beb$export$ca40fe481df670b5)(text, _this.additionalMaskTextPatterns);
        };
        // Get the DOM hierarchy of the element, starting from the target element to the root element.
        this.getHierarchy = function(element) {
            var e_2, _a;
            var _b, _c;
            var startTime = performance.now();
            var hierarchy = [];
            if (!element) return [];
            // Get list of ancestors including itself and get properties at each level in the hierarchy
            var ancestors = (0, $11152a1086667f8a$export$c6fd3ab3f44300d0)(element);
            // Build attributes to mask map
            var elementToAttributesToMaskMap = new Map();
            for(var i = ancestors.length - 1; i >= 0; i--){
                var node = ancestors[i];
                if (node) {
                    var attributesToMask = (0, $54c5a19232a3034b$export$ed77f6c811aa55ed)(node.getAttribute($b9be34b9cefd2a81$export$341c05124aaddb32));
                    var ancestorAttributesToMask = i === ancestors.length - 1 ? [] : (_b = elementToAttributesToMaskMap.get(ancestors[i + 1])) !== null && _b !== void 0 ? _b : new Set();
                    var combinedAttributesToMask = new Set((0, $bunH6.__spreadArray)((0, $bunH6.__spreadArray)([], (0, $bunH6.__read)(ancestorAttributesToMask), false), (0, $bunH6.__read)(attributesToMask), false));
                    elementToAttributesToMaskMap.set(node, combinedAttributesToMask);
                }
            }
            hierarchy = ancestors.map(function(el) {
                var _a;
                return (0, $11152a1086667f8a$export$d693bc18648a5069)(el, (_a = elementToAttributesToMaskMap.get(el)) !== null && _a !== void 0 ? _a : new Set());
            });
            var _loop_1 = function(hierarchyNode) {
                if (hierarchyNode === null || hierarchyNode === void 0 ? void 0 : hierarchyNode.attrs) Object.entries(hierarchyNode.attrs).forEach(function(_a) {
                    var _b = (0, $bunH6.__read)(_a, 2), key = _b[0], value = _b[1];
                    if (hierarchyNode.attrs) hierarchyNode.attrs[key] = _this.replaceSensitiveString(value);
                });
            };
            try {
                // Search for and mask any sensitive attribute values
                for(var hierarchy_1 = (0, $bunH6.__values)(hierarchy), hierarchy_1_1 = hierarchy_1.next(); !hierarchy_1_1.done; hierarchy_1_1 = hierarchy_1.next()){
                    var hierarchyNode = hierarchy_1_1.value;
                    _loop_1(hierarchyNode);
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (hierarchy_1_1 && !hierarchy_1_1.done && (_a = hierarchy_1.return)) _a.call(hierarchy_1);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            var endTime = performance.now();
            (_c = _this.diagnosticsClient) === null || _c === void 0 || _c.recordHistogram('autocapturePlugin.getHierarchy', endTime - startTime);
            return hierarchy;
        };
        this.getNearestLabel = function(element) {
            var parent = element.parentElement;
            if (!parent) return '';
            var labelElement;
            try {
                labelElement = parent.querySelector(':scope>span,h1,h2,h3,h4,h5,h6');
            } catch (_a) {
                /* istanbul ignore next */ labelElement = null;
            }
            if (labelElement) /* istanbul ignore next */ return _this.getText(labelElement);
            return _this.getNearestLabel(parent);
        };
        this.getElementPath = function(element) {
            var _a;
            if (!element) return '';
            var startTime = performance.now();
            var elementPath = (0, $8881c18b55c6611c$export$a33ca12c106e2477)(element);
            var endTime = performance.now();
            (_a = _this.diagnosticsClient) === null || _a === void 0 || _a.recordHistogram('autocapturePlugin.getElementPath', endTime - startTime);
            return elementPath;
        };
        // Returns the Amplitude event properties for the given element.
        this.getEventProperties = function(actionType, element, dataAttributePrefix) {
            var _a;
            var _b, _c, _d;
            /* istanbul ignore next */ var tag = (_c = (_b = element === null || element === void 0 ? void 0 : element.tagName) === null || _b === void 0 ? void 0 : _b.toLowerCase) === null || _c === void 0 ? void 0 : _c.call(_b);
            /* istanbul ignore next */ var rect = typeof element.getBoundingClientRect === 'function' ? element.getBoundingClientRect() : {
                left: null,
                top: null
            };
            var hierarchy = _this.getHierarchy(element);
            var currentElementAttributes = (_d = hierarchy[0]) === null || _d === void 0 ? void 0 : _d.attrs;
            var nearestLabel = _this.getNearestLabel(element);
            var attributes = (0, $54c5a19232a3034b$export$94e317a984c35cd8)(currentElementAttributes !== null && currentElementAttributes !== void 0 ? currentElementAttributes : {}, dataAttributePrefix);
            /* istanbul ignore next */ var properties = (_a = {}, _a[$b9be34b9cefd2a81$export$1703b32b7bd9766d] = hierarchy, _a[$b9be34b9cefd2a81$export$ae8ed2ec3f47ca91] = tag, _a[$b9be34b9cefd2a81$export$6f4405900e290a66] = _this.getText(element), _a[$b9be34b9cefd2a81$export$9a82fc4a0d569f9f] = rect.left == null ? null : Math.round(rect.left), _a[$b9be34b9cefd2a81$export$41bd9356c6ad03b6] = rect.top == null ? null : Math.round(rect.top), _a[$b9be34b9cefd2a81$export$24fead99416f658b] = attributes, _a[$b9be34b9cefd2a81$export$ff07ccafdb757725] = _this.getElementPath(element), _a[$b9be34b9cefd2a81$export$a458f4751a32ecbb] = nearestLabel, _a[$b9be34b9cefd2a81$export$af0bc70234f2db5c] = (0, $cfec2d180e2010e9$export$c9f67ffc80012d9b)(window.location.href.split('?')[0]), _a[$b9be34b9cefd2a81$export$236baf0f9c4fa772] = (0, $d098392c6f9e3beb$export$23286240952da4c9)(_this.replaceSensitiveString), _a[$b9be34b9cefd2a81$export$f87aa46d335ec78e] = window.innerHeight, _a[$b9be34b9cefd2a81$export$624bc6029c85c6ab] = window.innerWidth, _a);
            var pageViewId = (0, $54c5a19232a3034b$export$e6bc05b59029fa37)();
            /* istanbul ignore next */ if (pageViewId) /* istanbul ignore next */ properties[$b9be34b9cefd2a81$export$553c8cbea8d8bb30] = pageViewId;
            // id is never masked, so always include it
            properties[$b9be34b9cefd2a81$export$396cd5ad29ba6170] = element.getAttribute('id') || '';
            // class is never masked, so always include it
            properties[$b9be34b9cefd2a81$export$9ae6b2f9f20abf50] = element.getAttribute('class');
            properties[$b9be34b9cefd2a81$export$fe59f70315258b43] = currentElementAttributes === null || currentElementAttributes === void 0 ? void 0 : currentElementAttributes['aria-label'];
            if (tag === 'a' && actionType === 'click' && element instanceof HTMLAnchorElement) {
                var href = element.href.substring(0, $b9be34b9cefd2a81$export$de243096419150c7);
                properties[$b9be34b9cefd2a81$export$253517022e31d52] = _this.replaceSensitiveString(href); // we don't use hierarchy here because we don't want href value to be changed
            }
            return (0, $54c5a19232a3034b$export$b2489c11de31bff2)(properties);
        };
        this.addTypeAndTimestamp = function(event, type) {
            return {
                event: event,
                timestamp: Date.now(),
                type: type
            };
        };
        this.addAdditionalEventProperties = function(event, type, selectorAllowlist, dataAttributePrefix, // capture the event if the cursor is a "pointer" when this element is clicked on
        // reason: a "pointer" cursor indicates that an element should be interactable
        //         regardless of the element's tag name
        isCapturingCursorPointer) {
            if (isCapturingCursorPointer === void 0) isCapturingCursorPointer = false;
            var baseEvent = _this.addTypeAndTimestamp(event, type);
            if ((0, $54c5a19232a3034b$export$e4f91743485e39de)(baseEvent) && baseEvent.event.target !== null) {
                if (isCapturingCursorPointer) {
                    var isCursorPointer = (0, $54c5a19232a3034b$export$a4394e437f962c02)(baseEvent.event.target, baseEvent.type);
                    if (isCursorPointer) {
                        baseEvent.closestTrackedAncestor = baseEvent.event.target;
                        baseEvent.targetElementProperties = _this.getEventProperties(baseEvent.type, baseEvent.closestTrackedAncestor, dataAttributePrefix);
                        return baseEvent;
                    }
                }
                // Retrieve additional event properties from the target element
                var closestTrackedAncestor = (0, $54c5a19232a3034b$export$6eaaca7dcffbc81f)(baseEvent.event.target, selectorAllowlist);
                if (closestTrackedAncestor) {
                    baseEvent.closestTrackedAncestor = closestTrackedAncestor;
                    baseEvent.targetElementProperties = _this.getEventProperties(baseEvent.type, closestTrackedAncestor, dataAttributePrefix);
                }
                return baseEvent;
            }
            return baseEvent;
        };
        this.extractDataFromDataSource = function(dataSource, contextElement) {
            // Extract from DOM Element
            if (dataSource.sourceType === 'DOM_ELEMENT') {
                var sourceElement = (0, $a4b960de921798f6$export$de16705e2b70ea0f)(dataSource, contextElement);
                if (!sourceElement) return undefined;
                if (dataSource.elementExtractType === 'TEXT') return _this.getText(sourceElement);
                else if (dataSource.elementExtractType === 'ATTRIBUTE' && dataSource.attribute) return sourceElement.getAttribute(dataSource.attribute);
                return undefined;
            }
            // TODO: Extract from other source types
            return undefined;
        };
        // Traverse text content without cloning DOM nodes, which avoids media/network side effects
        // from recreating nested elements such as <video>, <audio>, or <img>.
        this.getTextWithMaskedDescendants = function(element) {
            var e_3, _a;
            var maskedSelector = "[".concat((0, $d098392c6f9e3beb$export$1d7c7f33294ad29b), "], [contenteditable]");
            // Fast path: if no masked descendants exist, rely on native text extraction.
            if (!element.querySelector(maskedSelector)) return element.innerText;
            var output = '';
            var childNodes = Array.from(element.childNodes);
            try {
                for(var childNodes_1 = (0, $bunH6.__values)(childNodes), childNodes_1_1 = childNodes_1.next(); !childNodes_1_1.done; childNodes_1_1 = childNodes_1.next()){
                    var childNode = childNodes_1_1.value;
                    if (childNode.nodeType === Node.TEXT_NODE) {
                        output += childNode.textContent || '';
                        continue;
                    }
                    if (!(childNode instanceof Element)) continue;
                    // Replace entire masked/contenteditable subtrees with the mask token.
                    if (childNode.hasAttribute((0, $d098392c6f9e3beb$export$1d7c7f33294ad29b)) || childNode.hasAttribute('contenteditable')) {
                        output += (0, $d098392c6f9e3beb$export$bad2cbf8e277cf85);
                        continue;
                    }
                    output += _this.getTextWithMaskedDescendants(childNode);
                }
            } catch (e_3_1) {
                e_3 = {
                    error: e_3_1
                };
            } finally{
                try {
                    if (childNodes_1_1 && !childNodes_1_1.done && (_a = childNodes_1.return)) _a.call(childNodes_1);
                } finally{
                    if (e_3) throw e_3.error;
                }
            }
            return output;
        };
        this.getText = function(element) {
            // Check if element or any parent has data-amp-mask attribute
            var hasMaskAttribute = element.closest("[".concat((0, $d098392c6f9e3beb$export$1d7c7f33294ad29b), "]")) !== null;
            if (hasMaskAttribute) return 0, $d098392c6f9e3beb$export$bad2cbf8e277cf85;
            var output = '';
            if (!element.querySelector("[".concat((0, $d098392c6f9e3beb$export$1d7c7f33294ad29b), "], [contenteditable]"))) output = element.innerText || '';
            else output = _this.getTextWithMaskedDescendants(element);
            return _this.replaceSensitiveString(output.substring(0, 255)).replace(/\s+/g, ' ').trim();
        };
        // Returns the element properties for the given element in Visual Labeling.
        this.getEventTagProps = function(element) {
            var _a;
            var _b, _c;
            if (!element) return {};
            /* istanbul ignore next */ var tag = (_c = (_b = element === null || element === void 0 ? void 0 : element.tagName) === null || _b === void 0 ? void 0 : _b.toLowerCase) === null || _c === void 0 ? void 0 : _c.call(_b);
            var properties = (_a = {}, _a[$b9be34b9cefd2a81$export$ae8ed2ec3f47ca91] = tag, _a[$b9be34b9cefd2a81$export$6f4405900e290a66] = _this.getText(element), _a[$b9be34b9cefd2a81$export$af0bc70234f2db5c] = window.location.href.split('?')[0], _a);
            return (0, $54c5a19232a3034b$export$b2489c11de31bff2)(properties);
        };
        this.diagnosticsClient = context === null || context === void 0 ? void 0 : context.diagnosticsClient;
        var rawPatterns = (_b = options.maskTextRegex) !== null && _b !== void 0 ? _b : [];
        var compiled = [];
        try {
            for(var rawPatterns_1 = (0, $bunH6.__values)(rawPatterns), rawPatterns_1_1 = rawPatterns_1.next(); !rawPatterns_1_1.done; rawPatterns_1_1 = rawPatterns_1.next()){
                var entry = rawPatterns_1_1.value;
                if (compiled.length >= $b9be34b9cefd2a81$export$e852de43ee12445) break;
                if (entry instanceof RegExp) compiled.push(entry);
                else if ('pattern' in entry && typeof entry.pattern === 'string') try {
                    compiled.push(new RegExp(entry.pattern, 'i'));
                } catch (_c) {
                // ignore invalid pattern strings
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (rawPatterns_1_1 && !rawPatterns_1_1.done && (_a = rawPatterns_1.return)) _a.call(rawPatterns_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        this.additionalMaskTextPatterns = compiled;
    }
    return DataExtractor;
}();


/* eslint-disable no-restricted-globals */ 
function $78920ce642a1cb29$export$be13975e2893c6b2(_a) {
    var allObservables = _a.allObservables, onExposure = _a.onExposure, dataExtractor = _a.dataExtractor, _b = _a.exposureDuration, exposureDuration = _b === void 0 ? (0, $86b2ff223bf803d2$export$f0e57fa749475e61) : _b;
    // Track which elements have been marked as exposed (per-element state)
    var exposureMap = new Map();
    // Track active timers for elements that are currently visible but not yet exposed
    var exposureTimerMap = new Map();
    var exposureObservable = allObservables.exposureObservable;
    var exposureSubscription = exposureObservable.subscribe(function(event) {
        var entry = event;
        var element = entry.target;
        if (entry.isIntersecting) // Element became visible - start exposure timer if not already exposed
        {
            if (!exposureMap.get(element)) {
                var timer = setTimeout(function() {
                    // Element has been visible for exposureDuration - mark as exposed
                    exposureMap.set(element, true);
                    // Record the CSS selector path in the shared exposure state
                    var elementPath = dataExtractor.getElementPath(element);
                    onExposure(elementPath);
                    // Clear the timer reference
                    exposureTimerMap.set(element, null);
                }, exposureDuration);
                exposureTimerMap.set(element, timer);
            }
        } else if (!entry.isIntersecting && entry.intersectionRatio < 1.0) {
            // Element left viewport - cancel exposure timer if one exists
            var timer = exposureTimerMap.get(element);
            if (timer) {
                clearTimeout(timer);
                exposureTimerMap.set(element, null);
            }
        }
    });
    return {
        unsubscribe: function() {
            exposureSubscription.unsubscribe();
        },
        reset: function() {
            exposureTimerMap.forEach(function(timer) {
                if (timer) clearTimeout(timer);
            });
            exposureTimerMap.clear();
            exposureMap.clear();
        }
    };
}



var $c4xZ2 = parcelRequire("c4xZ2");


function $fdb5a92b49cb227b$export$6187360a69691692(_a) {
    var _b;
    var _c, _d, _e;
    var amplitude = _a.amplitude, scrollTracker = _a.scrollTracker, currentElementExposed = _a.currentElementExposed, elementExposedForPage = _a.elementExposedForPage, exposureTracker = _a.exposureTracker, isPageEnd = _a.isPageEnd, lastScroll = _a.lastScroll;
    var pageScrollMaxState = scrollTracker.getState();
    var globalScope = (0, $c4xZ2.getGlobalScope)();
    /* istanbul ignore next */ var viewportWidth = (_c = globalScope === null || globalScope === void 0 ? void 0 : globalScope.innerWidth) !== null && _c !== void 0 ? _c : 0;
    /* istanbul ignore next */ var viewportHeight = (_d = globalScope === null || globalScope === void 0 ? void 0 : globalScope.innerHeight) !== null && _d !== void 0 ? _d : 0;
    var eventProperties = (_b = {}, _b[$b9be34b9cefd2a81$export$af0bc70234f2db5c] = /* istanbul ignore next */ (_e = globalScope === null || globalScope === void 0 ? void 0 : globalScope.location) === null || _e === void 0 ? void 0 : _e.href, _b[$b9be34b9cefd2a81$export$17b4c7350dadf5ce] = pageScrollMaxState.maxX + viewportWidth, _b[$b9be34b9cefd2a81$export$b509e6040aff7d27] = pageScrollMaxState.maxY + viewportHeight, _b[$b9be34b9cefd2a81$export$f87aa46d335ec78e] = viewportHeight, _b[$b9be34b9cefd2a81$export$624bc6029c85c6ab] = viewportWidth, _b['[Amplitude] Element Exposed'] = Array.from(currentElementExposed), _b);
    var pageViewId = (0, $54c5a19232a3034b$export$e6bc05b59029fa37)();
    if (pageViewId) eventProperties[$b9be34b9cefd2a81$export$553c8cbea8d8bb30] = pageViewId;
    // If elements exposed is empty and max scroll is same as last event, don't track
    if (currentElementExposed.size === 0 && pageScrollMaxState.maxX === lastScroll.maxX && pageScrollMaxState.maxY === lastScroll.maxY) {
        if (isPageEnd) {
            scrollTracker.reset();
            elementExposedForPage.clear();
            exposureTracker === null || exposureTracker === void 0 || exposureTracker.reset();
        }
        return;
    }
    /* istanbul ignore next */ amplitude === null || amplitude === void 0 || amplitude.track('[Amplitude] Viewport Content Updated', eventProperties);
    lastScroll.maxX = pageScrollMaxState.maxX;
    lastScroll.maxY = pageScrollMaxState.maxY;
    // Clear current batch
    currentElementExposed.clear();
    if (isPageEnd) {
        // Reset state for next page view
        scrollTracker.reset();
        elementExposedForPage.clear();
        exposureTracker === null || exposureTracker === void 0 || exposureTracker.reset();
    }
}
function $fdb5a92b49cb227b$export$aa21f854a3db777d(elementPath, elementExposedForPage, currentElementExposed, fireViewportContentUpdatedCallback) {
    if (elementExposedForPage.has(elementPath)) return;
    elementExposedForPage.add(elementPath);
    currentElementExposed.add(elementPath);
    // Check if current set size exceeds 18k chars
    var exposedArray = Array.from(currentElementExposed);
    var exposedString = JSON.stringify(exposedArray);
    if (exposedString.length >= $b9be34b9cefd2a81$export$a0f2dd29107ae52e) fireViewportContentUpdatedCallback(false);
}


var $899c6c1762774565$export$a217bf5378006153;
(function(ObservablesEnum) {
    ObservablesEnum["ClickObservable"] = "clickObservable";
    ObservablesEnum["ChangeObservable"] = "changeObservable";
    ObservablesEnum["NavigateObservable"] = "navigateObservable";
    ObservablesEnum["MutationObservable"] = "mutationObservable";
    ObservablesEnum["ScrollObservable"] = "scrollObservable";
    ObservablesEnum["ExposureObservable"] = "exposureObservable";
    ObservablesEnum["BrowserErrorObservable"] = "browserErrorObservable";
    ObservablesEnum["SelectionObservable"] = "selectionObservable";
    ObservablesEnum["MouseMoveObservable"] = "mouseMoveObservable";
})($899c6c1762774565$export$a217bf5378006153 || ($899c6c1762774565$export$a217bf5378006153 = {}));
var $899c6c1762774565$export$cd485554bb3f53da = function(options, context) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if (options === void 0) options = {};
    // Set the plugin version tag
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    context === null || context === void 0 || context.diagnosticsClient.setTag('plugin.autocapture.version', (0, $018823fbc4c7683b$export$a4ad2735b021c132));
    var _m = options.dataAttributePrefix, dataAttributePrefix = _m === void 0 ? (0, $86b2ff223bf803d2$export$98ba2b432b1218a9) : _m, _o = options.visualTaggingOptions, visualTaggingOptions = _o === void 0 ? {
        enabled: true
    } : _o;
    options.cssSelectorAllowlist = (_a = options.cssSelectorAllowlist) !== null && _a !== void 0 ? _a : (0, $86b2ff223bf803d2$export$b8b480c7efad756c);
    options.actionClickAllowlist = (_b = options.actionClickAllowlist) !== null && _b !== void 0 ? _b : (0, $86b2ff223bf803d2$export$1546873d565d1ebf);
    options.debounceTime = (_c = options.debounceTime) !== null && _c !== void 0 ? _c : 0;
    var resolvedExposureDuration = (_f = (_e = (_d = options.viewportContentUpdated) === null || _d === void 0 ? void 0 : _d.exposureDuration) !== null && _e !== void 0 ? _e : options.exposureDuration) !== null && _f !== void 0 ? _f : (0, $86b2ff223bf803d2$export$f0e57fa749475e61);
    options.viewportContentUpdated = (0, $bunH6.__assign)((0, $bunH6.__assign)({}, options.viewportContentUpdated), {
        exposureDuration: resolvedExposureDuration
    });
    options.pageUrlExcludelist = (_g = options.pageUrlExcludelist) === null || _g === void 0 ? void 0 : _g.reduce(function(acc, excludePattern) {
        if (typeof excludePattern === 'string') acc.push(excludePattern);
        if (excludePattern instanceof RegExp) acc.push(excludePattern);
        if (typeof excludePattern === 'object' && excludePattern !== null && 'pattern' in excludePattern) try {
            acc.push(new RegExp(excludePattern.pattern));
        } catch (regexError) {
            console.warn("Invalid regex pattern: ".concat(excludePattern.pattern), regexError);
            return acc;
        }
        return acc;
    }, []);
    var name = $b9be34b9cefd2a81$export$3e69d3882a51f072;
    var type = 'enrichment';
    var subscriptions = [];
    var dataExtractor = new (0, $98cd574e8fe80c36$export$bf982f10504e5dd3)(options, context);
    // Page-level state shared across trackers, emitted in a single Page View End event on beforeunload
    // elementExposedForPage holds the total set of elements seen during the entire page view lifetime
    var elementExposedForPage = new Set();
    // currentElementExposed only holds the set of elements that will be flushed during the next [Amplitude] Viewport Content Updated event
    var currentElementExposed = new Set();
    var beforeUnloadCleanup;
    var createObservables = function() {
        var _a;
        var clickObservable = (0, $2c30177b55b54dbd$export$1364843af8d5a963)((0, $9ea49793bd7bd466$export$17326e1836d300d0)().map(function(click) {
            return dataExtractor.addAdditionalEventProperties(click, 'click', options.cssSelectorAllowlist, dataAttributePrefix);
        }));
        var changeObservable = (0, $2c30177b55b54dbd$export$1364843af8d5a963)(new (0, (/*@__PURE__*/$parcel$interopDefault($465e706a1980c9f4$exports)))(function(observer) {
            var _a;
            var handler = function(changeEvent) {
                var enrichedChangeEvent = dataExtractor.addAdditionalEventProperties(changeEvent, 'change', options.cssSelectorAllowlist, dataAttributePrefix);
                observer.next(enrichedChangeEvent);
            };
            /* istanbul ignore next */ (_a = (0, $c4xZ2.getGlobalScope)()) === null || _a === void 0 || _a.document.addEventListener('change', handler, {
                capture: true
            });
            /* istanbul ignore next */ return function() {
                var _a;
                return (_a = (0, $c4xZ2.getGlobalScope)()) === null || _a === void 0 ? void 0 : _a.document.removeEventListener('change', handler);
            };
        }));
        // Create observable for URL changes
        var navigateObservable;
        /* istanbul ignore next */ if (window.navigation) navigateObservable = (0, $2c30177b55b54dbd$export$1364843af8d5a963)(new (0, (/*@__PURE__*/$parcel$interopDefault($465e706a1980c9f4$exports)))(function(observer) {
            var handler = function(navigateEvent) {
                var enrichedNavigateEvent = dataExtractor.addAdditionalEventProperties(navigateEvent, 'navigate', options.cssSelectorAllowlist, dataAttributePrefix);
                observer.next(enrichedNavigateEvent);
            };
            window.navigation.addEventListener('navigate', handler);
            return function() {
                window.navigation.removeEventListener('navigate', handler);
            };
        }));
        var mutationObservable = (0, $2c30177b55b54dbd$export$1364843af8d5a963)((0, $9ea49793bd7bd466$export$ae86221051ab432c)().map(function(mutation) {
            return dataExtractor.addAdditionalEventProperties(mutation, 'mutation', options.cssSelectorAllowlist, dataAttributePrefix);
        }));
        var scrollObservable = (0, $9ea49793bd7bd466$export$b539d46c36ea700e)();
        var exposureObservable = (0, $9ea49793bd7bd466$export$8ee1f0515582594e)(mutationObservable, options.cssSelectorAllowlist);
        return _a = {}, _a[$899c6c1762774565$export$a217bf5378006153.ChangeObservable] = changeObservable, // [ObservablesEnum.ErrorObservable]: errorObservable,
        _a[$899c6c1762774565$export$a217bf5378006153.ClickObservable] = clickObservable, _a[$899c6c1762774565$export$a217bf5378006153.MutationObservable] = mutationObservable, _a[$899c6c1762774565$export$a217bf5378006153.NavigateObservable] = navigateObservable, _a[$899c6c1762774565$export$a217bf5378006153.ScrollObservable] = scrollObservable, _a[$899c6c1762774565$export$a217bf5378006153.ExposureObservable] = exposureObservable, _a;
    };
    // Group labeled events by event type (eg. click, change)
    var groupedLabeledEvents = (0, $2ee7b39997bc4d7d$export$fdbc88d42bd65290)(Object.values((_j = (_h = options.pageActions) === null || _h === void 0 ? void 0 : _h.labeledEvents) !== null && _j !== void 0 ? _j : {}));
    var labeledEventToTriggerMap = (0, $2ee7b39997bc4d7d$export$a2303575174a625e)((_l = (_k = options.pageActions) === null || _k === void 0 ? void 0 : _k.triggers) !== null && _l !== void 0 ? _l : []);
    // Evaluate triggers for the given event by running the actions associated with the matching triggers
    var evaluateTriggers = (0, $2ee7b39997bc4d7d$export$93f6f82af2a132d)(groupedLabeledEvents, labeledEventToTriggerMap, dataExtractor, options);
    // Function to recalculate internal variables when remote config is updated
    var recomputePageActionsData = function(remotePageActions) {
        var _a, _b;
        if (remotePageActions) {
            // Merge remote config with local options
            options.pageActions = (0, $bunH6.__assign)((0, $bunH6.__assign)({}, options.pageActions), remotePageActions);
            // Recalculate internal variables
            groupedLabeledEvents = (0, $2ee7b39997bc4d7d$export$fdbc88d42bd65290)(Object.values((_a = options.pageActions.labeledEvents) !== null && _a !== void 0 ? _a : {}));
            labeledEventToTriggerMap = (0, $2ee7b39997bc4d7d$export$a2303575174a625e)((_b = options.pageActions.triggers) !== null && _b !== void 0 ? _b : []);
            // Update evaluateTriggers function
            evaluateTriggers.update(groupedLabeledEvents, labeledEventToTriggerMap, options);
        }
    };
    var setup = function(config, amplitude) {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            var pageViewEndFired, lastScroll, shouldTrackEvent, shouldTrackActionClick, allObservables, clickTrackingSubscription, changeSubscription, actionClickSubscription, scrollTracker, trackers, globalScope, handleViewportContentUpdated, handleExposure, beforeUnloadHandler, navigateObservable, popstateHandler_1, originalPushState_1, allowlist, actionClickAllowlist, messenger;
            var _a;
            return (0, $bunH6.__generator)(this, function(_b) {
                /* istanbul ignore if */ if (typeof document === 'undefined') return [
                    2 /*return*/ 
                ];
                pageViewEndFired = false;
                lastScroll = {
                    maxX: undefined,
                    maxY: undefined
                };
                // Fetch remote config for pageActions in a non-blocking manner
                if (config.fetchRemoteConfig) {
                    if (!config.remoteConfigClient) // TODO(xinyi): Diagnostics.recordEvent
                    config.loggerProvider.debug('Remote config client is not provided, skipping remote config fetch');
                    else config.remoteConfigClient.subscribe('configs.analyticsSDK.pageActions', 'all', function(remoteConfig) {
                        recomputePageActionsData(remoteConfig);
                    });
                }
                shouldTrackEvent = (0, $54c5a19232a3034b$export$d41a31caec8ff08e)(options, options.cssSelectorAllowlist);
                shouldTrackActionClick = (0, $54c5a19232a3034b$export$d41a31caec8ff08e)(options, options.actionClickAllowlist);
                allObservables = createObservables();
                clickTrackingSubscription = (0, $81a9c83b55337a38$export$9219358a81f9347a)({
                    allObservables: allObservables,
                    amplitude: amplitude,
                    shouldTrackEvent: shouldTrackEvent,
                    evaluateTriggers: evaluateTriggers.evaluate.bind(evaluateTriggers)
                });
                subscriptions.push(clickTrackingSubscription);
                changeSubscription = (0, $6a72d168288c1ba5$export$706320a461885e7)({
                    allObservables: allObservables,
                    getEventProperties: function() {
                        var args = [];
                        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                        return dataExtractor.getEventProperties.apply(dataExtractor, (0, $bunH6.__spreadArray)((0, $bunH6.__spreadArray)([], (0, $bunH6.__read)(args), false), [
                            dataAttributePrefix
                        ], false));
                    },
                    amplitude: amplitude,
                    shouldTrackEvent: shouldTrackEvent,
                    evaluateTriggers: evaluateTriggers.evaluate.bind(evaluateTriggers)
                });
                subscriptions.push(changeSubscription);
                actionClickSubscription = (0, $ef9c44b7a3a8fad6$export$c35243ecb650b344)({
                    allObservables: allObservables,
                    options: options,
                    getEventProperties: function() {
                        var args = [];
                        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                        return dataExtractor.getEventProperties.apply(dataExtractor, (0, $bunH6.__spreadArray)((0, $bunH6.__spreadArray)([], (0, $bunH6.__read)(args), false), [
                            dataAttributePrefix
                        ], false));
                    },
                    amplitude: amplitude,
                    shouldTrackEvent: shouldTrackEvent,
                    shouldTrackActionClick: shouldTrackActionClick
                });
                if (actionClickSubscription) subscriptions.push(actionClickSubscription);
                scrollTracker = (0, $31a1078e93882161$export$de1563ff5a1bae99)({
                    allObservables: allObservables,
                    amplitude: amplitude
                });
                subscriptions.push(scrollTracker);
                trackers = {};
                globalScope = (0, $c4xZ2.getGlobalScope)();
                handleViewportContentUpdated = function(isPageEnd) {
                    if (isPageEnd && pageViewEndFired) return;
                    setTimeout(function() {
                        pageViewEndFired = false;
                    }, 100);
                    pageViewEndFired = true;
                    (0, $fdb5a92b49cb227b$export$6187360a69691692)({
                        amplitude: amplitude,
                        scrollTracker: scrollTracker,
                        currentElementExposed: currentElementExposed,
                        elementExposedForPage: elementExposedForPage,
                        exposureTracker: trackers.exposure,
                        isPageEnd: isPageEnd,
                        lastScroll: lastScroll
                    });
                };
                handleExposure = function(elementPath) {
                    (0, $fdb5a92b49cb227b$export$aa21f854a3db777d)(elementPath, elementExposedForPage, currentElementExposed, handleViewportContentUpdated);
                };
                trackers.exposure = (0, $78920ce642a1cb29$export$be13975e2893c6b2)({
                    allObservables: allObservables,
                    onExposure: handleExposure,
                    dataExtractor: dataExtractor,
                    exposureDuration: resolvedExposureDuration
                });
                if (trackers.exposure) subscriptions.push(trackers.exposure);
                beforeUnloadHandler = function() {
                    handleViewportContentUpdated(true);
                };
                /* istanbul ignore next */ globalScope === null || globalScope === void 0 || globalScope.addEventListener('beforeunload', beforeUnloadHandler);
                beforeUnloadCleanup = function() {
                    /* istanbul ignore next */ globalScope === null || globalScope === void 0 || globalScope.removeEventListener('beforeunload', beforeUnloadHandler);
                };
                // Ensure cleanup on teardown as well
                subscriptions.push({
                    unsubscribe: function() {
                        return beforeUnloadCleanup();
                    }
                });
                navigateObservable = allObservables[$899c6c1762774565$export$a217bf5378006153.NavigateObservable];
                if (navigateObservable) subscriptions.push(navigateObservable.subscribe(function() {
                    handleViewportContentUpdated(true);
                }));
                else if (globalScope) {
                    popstateHandler_1 = function() {
                        handleViewportContentUpdated(true);
                    };
                    /* istanbul ignore next */ // Fallback for SPA tracking when Navigation API is not available
                    globalScope.addEventListener('popstate', popstateHandler_1);
                    originalPushState_1 = globalScope.history.pushState;
                    if (globalScope.history && originalPushState_1) // eslint-disable-next-line @typescript-eslint/unbound-method
                    globalScope.history.pushState = new Proxy(originalPushState_1, {
                        apply: function(target, thisArg, _a) {
                            var _b = (0, $bunH6.__read)(_a, 3), state = _b[0], unused = _b[1], url = _b[2];
                            target.apply(thisArg, [
                                state,
                                unused,
                                url
                            ]);
                            handleViewportContentUpdated(true);
                        }
                    });
                    subscriptions.push({
                        unsubscribe: function() {
                            /* istanbul ignore next */ globalScope.removeEventListener('popstate', popstateHandler_1);
                            /* istanbul ignore next */ if (globalScope.history && originalPushState_1) globalScope.history.pushState = originalPushState_1;
                        }
                    });
                }
                /* istanbul ignore next */ (_a = config === null || config === void 0 ? void 0 : config.loggerProvider) === null || _a === void 0 || _a.log("".concat(name, " has been successfully added."));
                // Setup visual tagging and background capture on the shared messenger singleton.
                // Using the singleton ensures a single message listener per page, even when
                // session-replay is also loaded.
                if (window.opener && visualTaggingOptions.enabled) {
                    allowlist = options.cssSelectorAllowlist;
                    actionClickAllowlist = options.actionClickAllowlist;
                    messenger = (0, $f9a90186b2a21d40$export$2b183171c77d5a89)();
                    (0, $9d8afee6a8f9296a$export$6d290bb5fed1c68c)(messenger, {
                        dataExtractor: dataExtractor,
                        isElementSelectable: (0, $54c5a19232a3034b$export$d41a31caec8ff08e)(options, (0, $bunH6.__spreadArray)((0, $bunH6.__spreadArray)([], (0, $bunH6.__read)(allowlist), false), (0, $bunH6.__read)(actionClickAllowlist), false)),
                        cssSelectorAllowlist: allowlist,
                        actionClickAllowlist: actionClickAllowlist
                    });
                    (0, $3f3ee0ecc078bcce$export$bd89b6a65bceda2c)(messenger);
                    /* istanbul ignore next */ messenger.setup((0, $bunH6.__assign)({
                        logger: config === null || config === void 0 ? void 0 : config.loggerProvider
                    }, (config === null || config === void 0 ? void 0 : config.serverZone) && {
                        endpoint: $38d9e8c2db41042d$export$89af84b5faccc270[config.serverZone]
                    }));
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var execute = function(event) {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    event
                ];
            });
        });
    };
    var teardown = function() {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            var subscriptions_1, subscriptions_1_1, subscription;
            var e_1, _a;
            return (0, $bunH6.__generator)(this, function(_b) {
                try {
                    for(subscriptions_1 = (0, $bunH6.__values)(subscriptions), subscriptions_1_1 = subscriptions_1.next(); !subscriptions_1_1.done; subscriptions_1_1 = subscriptions_1.next()){
                        subscription = subscriptions_1_1.value;
                        subscription.unsubscribe();
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (subscriptions_1_1 && !subscriptions_1_1.done && (_a = subscriptions_1.return)) _a.call(subscriptions_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return {
        name: name,
        type: type,
        setup: setup,
        execute: execute,
        teardown: teardown
    };
};


var $bunH6 = parcelRequire("bunH6");

var $bunH6 = parcelRequire("bunH6");
var $a4dde53ae76c56cb$var$CLICKABLE_ELEMENT_SELECTORS = [
    'a',
    'button',
    '[role="button"]',
    '[role="link"]',
    '[role="menuitem"]',
    '[role="menuitemcheckbox"]',
    '[role="menuitemradio"]',
    '[role="option"]',
    '[role="tab"]',
    '[role="treeitem"]',
    '[contenteditable="true" i]'
];
var $a4dde53ae76c56cb$var$DEFAULT_ERROR_AND_DEAD_CLICK_ALLOWLIST = (0, $bunH6.__spreadArray)([
    'input[type="button"]',
    'input[type="submit"]',
    'input[type="reset"]',
    'input[type="image"]',
    'input[type="file"]'
], (0, $bunH6.__read)($a4dde53ae76c56cb$var$CLICKABLE_ELEMENT_SELECTORS), false);
var $a4dde53ae76c56cb$export$85f6b4766238212a = $a4dde53ae76c56cb$var$DEFAULT_ERROR_AND_DEAD_CLICK_ALLOWLIST;
var $a4dde53ae76c56cb$export$49a333174c9f620c = $a4dde53ae76c56cb$var$DEFAULT_ERROR_AND_DEAD_CLICK_ALLOWLIST;
var $a4dde53ae76c56cb$export$4b7cdc432c590f70 = [
    '*'
];
var $a4dde53ae76c56cb$export$2cd684f4600b6e31 = 3000;
var $a4dde53ae76c56cb$export$b5b995c43472c8e0 = 1000;
var $a4dde53ae76c56cb$export$33c18d07d089b90e = 4;
var $a4dde53ae76c56cb$export$ba1d10bc0e69a30f = 50; // pixels





var $bunH6 = parcelRequire("bunH6");



var $b111d90f19d922df$var$DEAD_CLICK_TIMEOUT = 3000; // 3 seconds to wait for an activity to happen
var $b111d90f19d922df$var$CHANGE_EVENTS = [
    'mutation',
    'navigate'
];
function $b111d90f19d922df$export$1bcc16975f1978e6(_a) {
    var amplitude = _a.amplitude, allObservables = _a.allObservables, getEventProperties = _a.getEventProperties, shouldTrackDeadClick = _a.shouldTrackDeadClick;
    var clickObservable = allObservables.clickObservable, mutationObservable = allObservables.mutationObservable, navigateObservable = allObservables.navigateObservable;
    var filteredClickObservable = clickObservable.filter(function(click) {
        return (0, $54c5a19232a3034b$export$80a5e1fd8987729f)(click) && shouldTrackDeadClick('click', click.closestTrackedAncestor) && click.event.target instanceof Element && click.event.target.closest('a[target="_blank"]') === null && click.event.button === (0, $54c5a19232a3034b$export$92850d9476e00eee).LEFT_OR_TOUCH_CONTACT;
    });
    /* istanbul ignore next */ var changeObservables = navigateObservable ? (0, $2c30177b55b54dbd$export$4950aa0f605343fb)(mutationObservable, navigateObservable) : mutationObservable;
    var clicksAndChangeObservable = (0, $2c30177b55b54dbd$export$4950aa0f605343fb)(filteredClickObservable, changeObservables);
    var deadClickTimer = null;
    var deadClickObservable = (0, $2c30177b55b54dbd$export$707ee4c4c95d39e3)(clicksAndChangeObservable, function(event) {
        if (deadClickTimer && $b111d90f19d922df$var$CHANGE_EVENTS.includes(event.type)) {
            // a mutation or navigation means it's not a dead click, so clear the timer
            clearTimeout(deadClickTimer);
            deadClickTimer = null;
            return Promise.resolve(null);
        } else if (event.type === 'click') {
            // if a dead click is already on-deck, return null.
            // this throttles dead clicks events so no more than one dead click event
            // is tracked per every DEAD_CLICK_TIMEOUT ms.
            if (deadClickTimer) return Promise.resolve(null);
            return new Promise(function(resolve) {
                deadClickTimer = setTimeout(function() {
                    resolve(event);
                    deadClickTimer = null;
                }, $b111d90f19d922df$var$DEAD_CLICK_TIMEOUT);
            });
        }
        // unreachable code, but needed to satisfy the type checker
        return Promise.resolve(null);
    });
    return deadClickObservable.subscribe(function(actionClick) {
        if (!actionClick) return;
        var deadClickEvent = {
            '[Amplitude] X': actionClick.event.clientX,
            '[Amplitude] Y': actionClick.event.clientY
        };
        amplitude.track((0, $b9be34b9cefd2a81$export$17b824da0ec1c8ba), (0, $bunH6.__assign)((0, $bunH6.__assign)({}, getEventProperties('click', actionClick.closestTrackedAncestor)), deadClickEvent), {
            time: actionClick.timestamp
        });
    });
}



var $bunH6 = parcelRequire("bunH6");


var $0c5a4872a3c90d47$var$RAGE_CLICK_THRESHOLD = (0, $a4dde53ae76c56cb$export$33c18d07d089b90e);
var $0c5a4872a3c90d47$var$RAGE_CLICK_WINDOW_MS = (0, $a4dde53ae76c56cb$export$b5b995c43472c8e0);
var $0c5a4872a3c90d47$var$RAGE_CLICK_OUT_OF_BOUNDS_THRESHOLD = (0, $a4dde53ae76c56cb$export$ba1d10bc0e69a30f);
function $0c5a4872a3c90d47$var$addCoordinates(regionBox, click) {
    var _a, _b, _c, _d;
    var _e = click.event, pageX = _e.pageX, pageY = _e.pageY;
    regionBox.yMin = Math.min((_a = regionBox.yMin) !== null && _a !== void 0 ? _a : pageY, pageY);
    regionBox.yMax = Math.max((_b = regionBox.yMax) !== null && _b !== void 0 ? _b : pageY, pageY);
    regionBox.xMin = Math.min((_c = regionBox.xMin) !== null && _c !== void 0 ? _c : pageX, pageX);
    regionBox.xMax = Math.max((_d = regionBox.xMax) !== null && _d !== void 0 ? _d : pageX, pageX);
    regionBox.isOutOfBounds = regionBox.yMax - regionBox.yMin > $0c5a4872a3c90d47$var$RAGE_CLICK_OUT_OF_BOUNDS_THRESHOLD || regionBox.xMax - regionBox.xMin > $0c5a4872a3c90d47$var$RAGE_CLICK_OUT_OF_BOUNDS_THRESHOLD;
}
function $0c5a4872a3c90d47$var$getRageClickAnalyticsEvent(clickWindow) {
    /* istanbul ignore if */ if (clickWindow.length === 0) return null;
    var firstClick = clickWindow[0];
    var lastClick = clickWindow[clickWindow.length - 1];
    var rageClickEvent = (0, $bunH6.__assign)({
        '[Amplitude] Begin Time': new Date(firstClick.timestamp).toISOString(),
        '[Amplitude] End Time': new Date(lastClick.timestamp).toISOString(),
        '[Amplitude] Duration': lastClick.timestamp - firstClick.timestamp,
        '[Amplitude] Clicks': clickWindow.map(function(click) {
            return {
                X: click.event.pageX,
                Y: click.event.pageY,
                Time: click.timestamp
            };
        }),
        '[Amplitude] Click Count': clickWindow.length
    }, firstClick.targetElementProperties);
    return {
        rageClickEvent: rageClickEvent,
        time: firstClick.timestamp
    };
}
function $0c5a4872a3c90d47$var$isClickOutsideRageClickWindow(clickWindow, click) {
    var firstIndex = Math.max(0, clickWindow.length - $0c5a4872a3c90d47$var$RAGE_CLICK_THRESHOLD + 1);
    var firstClick = clickWindow[firstIndex];
    return click.timestamp - firstClick.timestamp >= $0c5a4872a3c90d47$var$RAGE_CLICK_WINDOW_MS;
}
function $0c5a4872a3c90d47$var$isNewElement(clickWindow, click) {
    return clickWindow.length > 0 && clickWindow[clickWindow.length - 1].closestTrackedAncestor !== click.closestTrackedAncestor;
}
function $0c5a4872a3c90d47$export$68b85203b16696ee(_a) {
    var _this = this;
    var amplitude = _a.amplitude, allObservables = _a.allObservables, shouldTrackRageClick = _a.shouldTrackRageClick;
    var clickObservable = allObservables.clickObservable, selectionObservable = allObservables.selectionObservable;
    // Keep track of all clicks within the sliding window
    var clickWindow = [];
    // Keep track of the region box for all clicks, to determine when a rage click is out of bounds
    var clickBoundingBox = {};
    var pendingRageClick = null;
    // helper function to reset the click window and region box
    function resetClickWindow(click) {
        clickWindow = [];
        clickBoundingBox = {};
        if (click) {
            $0c5a4872a3c90d47$var$addCoordinates(clickBoundingBox, click);
            clickWindow.push(click);
        }
    }
    var rageClickObservable = (0, $2c30177b55b54dbd$export$707ee4c4c95d39e3)(clickObservable.filter(function(click) {
        return shouldTrackRageClick('click', click.closestTrackedAncestor);
    }), function(click) {
        return (0, $bunH6.__awaiter)(_this, void 0, void 0, function() {
            var resolutionValue;
            return (0, $bunH6.__generator)(this, function(_a) {
                // add this click's coordinates to the bounding box
                $0c5a4872a3c90d47$var$addCoordinates(clickBoundingBox, click);
                resolutionValue = null;
                // if current click is:
                //  1. first click in the window
                //  2. on a new element
                //  3. outside the rage click time window
                //  4. out of bounds
                // then start a new click window
                if (clickWindow.length === 0 || $0c5a4872a3c90d47$var$isNewElement(clickWindow, click) || $0c5a4872a3c90d47$var$isClickOutsideRageClickWindow(clickWindow, click) || clickBoundingBox.isOutOfBounds) {
                    // if there was a previous Rage Click Event on deck, then send it
                    if (pendingRageClick) resolutionValue = $0c5a4872a3c90d47$var$getRageClickAnalyticsEvent(clickWindow);
                    resetClickWindow(click);
                } else clickWindow.push(click);
                // if there was a previous Rage Click Event on deck, then resolve it
                if (pendingRageClick) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                    clearTimeout(pendingRageClick.timerId);
                    pendingRageClick.resolve(resolutionValue);
                    pendingRageClick = null;
                }
                // if we have enough clicks to be a rage click, set a timout to trigger the rage
                // click event after the time threshold is reached.
                // This will be cancelled if a new click is tracked within the time threshold.
                if (clickWindow.length >= $0c5a4872a3c90d47$var$RAGE_CLICK_THRESHOLD) return [
                    2 /*return*/ ,
                    new Promise(function(resolve) {
                        pendingRageClick = {
                            resolve: resolve,
                            timerId: setTimeout(function() {
                                resolve($0c5a4872a3c90d47$var$getRageClickAnalyticsEvent(clickWindow));
                            }, $0c5a4872a3c90d47$var$RAGE_CLICK_WINDOW_MS)
                        };
                    })
                ];
                return [
                    2 /*return*/ ,
                    null
                ];
            });
        });
    });
    // reset the click window when a selection change occurs
    /* istanbul ignore next */ var selectionSubscription = selectionObservable === null || selectionObservable === void 0 ? void 0 : selectionObservable.subscribe(function() {
        resetClickWindow();
    });
    var rageClickSubscription = rageClickObservable.subscribe(function(data) {
        /* istanbul ignore if */ if (data === null) return;
        amplitude.track((0, $b9be34b9cefd2a81$export$efb273b74f733f19), data.rageClickEvent, {
            time: data.time
        });
    });
    return {
        unsubscribe: function() {
            rageClickSubscription.unsubscribe();
            /* istanbul ignore next */ selectionSubscription === null || selectionSubscription === void 0 || selectionSubscription.unsubscribe();
        }
    };
}






var $bunH6 = parcelRequire("bunH6");



var $7618aaac05935f71$var$ERROR_CLICK_TIMEOUT = 2000; // 2 seconds to wait for an error to happen
function $7618aaac05935f71$export$623660a68102b792(_a) {
    var amplitude = _a.amplitude, allObservables = _a.allObservables, shouldTrackErrorClick = _a.shouldTrackErrorClick;
    var clickObservable = allObservables.clickObservable, browserErrorObservable = allObservables.browserErrorObservable;
    var filteredClickObservable = clickObservable.filter(function(click) {
        return (0, $54c5a19232a3034b$export$80a5e1fd8987729f)(click) && shouldTrackErrorClick('click', click.closestTrackedAncestor) && click.event.target instanceof Element && click.event.target.closest('a[target="_blank"]') === null && click.event.button === (0, $54c5a19232a3034b$export$92850d9476e00eee).LEFT_OR_TOUCH_CONTACT;
    });
    var errorClickTimer = null;
    var latestClickEvent = null;
    var clearClickTimer = function() {
        if (errorClickTimer !== null) {
            clearTimeout(errorClickTimer);
            errorClickTimer = null;
        }
        latestClickEvent = null;
    };
    return (0, $2c30177b55b54dbd$export$4950aa0f605343fb)(filteredClickObservable, browserErrorObservable).subscribe(function(event) {
        var _a;
        if (event.type === 'click') {
            clearClickTimer();
            latestClickEvent = event;
            errorClickTimer = setTimeout(clearClickTimer, $7618aaac05935f71$var$ERROR_CLICK_TIMEOUT);
            return;
        }
        if (event.type === 'error' && latestClickEvent) {
            amplitude.track((0, $b9be34b9cefd2a81$export$49ccb1b3108a13dc), (0, $bunH6.__assign)((_a = {}, _a['[Amplitude] Kind'] = event.event.kind, _a['[Amplitude] Message'] = event.event.message, _a['[Amplitude] Stack'] = event.event.stack, _a['[Amplitude] Filename'] = event.event.filename, _a['[Amplitude] Line Number'] = event.event.lineNumber, _a['[Amplitude] Column Number'] = event.event.columnNumber, _a), latestClickEvent.targetElementProperties));
            clearClickTimer();
        }
    });
}





var $8f4e69d1e5184714$var$Direction;
(function(Direction) {
    Direction["INCREASING"] = "increasing";
    Direction["DECREASING"] = "decreasing";
})($8f4e69d1e5184714$var$Direction || ($8f4e69d1e5184714$var$Direction = {}));
var $8f4e69d1e5184714$var$Axis;
(function(Axis) {
    Axis["X"] = "x";
    Axis["Y"] = "y";
})($8f4e69d1e5184714$var$Axis || ($8f4e69d1e5184714$var$Axis = {}));
var $8f4e69d1e5184714$export$4c31185423cbc340 = function(_a) {
    var allWindowObservables = _a.allWindowObservables;
    var mouseMoveObservable = allWindowObservables.mouseMoveObservable;
    return new (0, (/*@__PURE__*/$parcel$interopDefault($465e706a1980c9f4$exports)))(function(observer) {
        var lastPosition = null;
        var xDirection = null;
        var yDirection = null;
        return mouseMoveObservable.subscribe(function(event) {
            var currentPosition = {
                x: event.clientX,
                y: event.clientY
            };
            if (lastPosition === null) {
                lastPosition = currentPosition;
                return;
            }
            if (currentPosition.x > lastPosition.x) {
                if (xDirection === $8f4e69d1e5184714$var$Direction.DECREASING) observer.next($8f4e69d1e5184714$var$Axis.X);
                xDirection = $8f4e69d1e5184714$var$Direction.INCREASING;
            } else if (currentPosition.x < lastPosition.x) {
                if (xDirection === $8f4e69d1e5184714$var$Direction.INCREASING) observer.next($8f4e69d1e5184714$var$Axis.X);
                xDirection = $8f4e69d1e5184714$var$Direction.DECREASING;
            }
            if (currentPosition.y > lastPosition.y) {
                if (yDirection === $8f4e69d1e5184714$var$Direction.DECREASING) observer.next($8f4e69d1e5184714$var$Axis.Y);
                yDirection = $8f4e69d1e5184714$var$Direction.INCREASING;
            } else if (currentPosition.y < lastPosition.y) {
                if (yDirection === $8f4e69d1e5184714$var$Direction.INCREASING) observer.next($8f4e69d1e5184714$var$Axis.Y);
                yDirection = $8f4e69d1e5184714$var$Direction.DECREASING;
            }
            lastPosition = currentPosition;
        });
    });
};
function $8f4e69d1e5184714$var$addDirectionChange(directionChangeSeries) {
    var now = +Date.now();
    directionChangeSeries.startTime = directionChangeSeries.startTime || now;
    // add this direction change to the series (fixed length array to avoid memory leaks)
    var changes = directionChangeSeries.changes, changesThreshold = directionChangeSeries.changesThreshold;
    changes.push(now);
    if (changes.length > changesThreshold) changes.shift();
}
// checks if there are enough direction changes within window + threshold
// for it to be considered a thrashed cursor
function $8f4e69d1e5184714$var$isThrashedCursor(directionChanges) {
    var changes = directionChanges.changes, changesThreshold = directionChanges.changesThreshold, thresholdMs = directionChanges.thresholdMs;
    if (changes.length < changesThreshold) return false;
    var delta = changes[changes.length - 1] - changes[0];
    return delta < thresholdMs;
}
function $8f4e69d1e5184714$var$resetDirectionChangeSeries(directionChangeSeries) {
    directionChangeSeries.changes = [];
    directionChangeSeries.startTime = undefined;
}
// if the time between first and last change is greater than the threshold,
// shift the window to the right until it is below the threshold
function $8f4e69d1e5184714$var$adjustWindow(directionChanges) {
    var changes = directionChanges.changes, thresholdMs = directionChanges.thresholdMs;
    // find the first change that is within the threshold
    var leftPtr = 0;
    var lastChange = changes[changes.length - 1];
    for(; leftPtr < changes.length; leftPtr++){
        var delta = lastChange - changes[leftPtr];
        if (delta < thresholdMs) break;
    }
    if (leftPtr === 0) return;
    directionChanges.startTime = changes[leftPtr];
    directionChanges.changes.splice(0, leftPtr);
}
function $8f4e69d1e5184714$var$getPendingThrashedCursor(directionChangesX, directionChangesY) {
    var startTime = undefined;
    if ($8f4e69d1e5184714$var$isThrashedCursor(directionChangesX)) startTime = directionChangesX.startTime;
    if ($8f4e69d1e5184714$var$isThrashedCursor(directionChangesY)) {
        var startTimeY = directionChangesY.startTime;
        if (startTimeY && (!startTime || startTimeY < startTime)) startTime = startTimeY;
    }
    return startTime;
}
var $8f4e69d1e5184714$var$DEFAULT_THRESHOLD = 10;
var $8f4e69d1e5184714$var$DEFAULT_WINDOW_MS = 2000;
var $8f4e69d1e5184714$export$47dd46be864489d1 = function(_a) {
    var mouseDirectionChangeObservable = _a.mouseDirectionChangeObservable, _b = _a.directionChanges, directionChanges = _b === void 0 ? $8f4e69d1e5184714$var$DEFAULT_THRESHOLD : _b, _c = _a.thresholdMs, thresholdMs = _c === void 0 ? $8f4e69d1e5184714$var$DEFAULT_WINDOW_MS : _c;
    return new (0, (/*@__PURE__*/$parcel$interopDefault($465e706a1980c9f4$exports)))(function(observer) {
        var xDirectionChanges = {
            changes: [],
            changesThreshold: directionChanges,
            thresholdMs: thresholdMs
        };
        var yDirectionChanges = {
            changes: [],
            changesThreshold: directionChanges,
            thresholdMs: thresholdMs
        };
        var pendingThrashedCursor = undefined;
        var timer = null;
        function emitPendingThrashedCursor() {
            if (pendingThrashedCursor !== undefined) {
                observer.next(pendingThrashedCursor);
                pendingThrashedCursor = undefined;
                // reset window
                if (timer !== null) clearTimeout(timer);
                $8f4e69d1e5184714$var$resetDirectionChangeSeries(xDirectionChanges);
                $8f4e69d1e5184714$var$resetDirectionChangeSeries(yDirectionChanges);
            }
        }
        return mouseDirectionChangeObservable.subscribe(function(axis) {
            if (timer !== null) clearTimeout(timer);
            $8f4e69d1e5184714$var$addDirectionChange(axis === $8f4e69d1e5184714$var$Axis.X ? xDirectionChanges : yDirectionChanges);
            var nextPendingThrashedCursor = $8f4e69d1e5184714$var$getPendingThrashedCursor(xDirectionChanges, yDirectionChanges);
            if (nextPendingThrashedCursor) {
                // if we're in a thrashed cursor window, debounce it for "thresholdMs" duration
                // this is so that we do not restart the window if more direction changes are
                // detected in this series
                pendingThrashedCursor = pendingThrashedCursor || nextPendingThrashedCursor;
                timer = setTimeout(function() {
                    emitPendingThrashedCursor();
                    timer = null;
                }, thresholdMs);
            } else emitPendingThrashedCursor();
            $8f4e69d1e5184714$var$adjustWindow(xDirectionChanges);
            $8f4e69d1e5184714$var$adjustWindow(yDirectionChanges);
            /* istanbul ignore next */ return function() {
                /* istanbul ignore if */ if (timer !== null) {
                    clearTimeout(timer);
                    timer = null;
                }
            };
        });
    });
};
var $8f4e69d1e5184714$export$efe5ac958b10e6c0 = function(_a) {
    var amplitude = _a.amplitude, options = _a.options, allObservables = _a.allObservables, _b = _a.directionChanges, directionChanges = _b === void 0 ? $8f4e69d1e5184714$var$DEFAULT_THRESHOLD : _b, _c = _a.thresholdMs, thresholdMs = _c === void 0 ? $8f4e69d1e5184714$var$DEFAULT_WINDOW_MS : _c;
    var mouseDirectionChangeObservable = $8f4e69d1e5184714$export$4c31185423cbc340({
        allWindowObservables: allObservables
    });
    var thrashedCursorObservable = $8f4e69d1e5184714$export$47dd46be864489d1({
        mouseDirectionChangeObservable: mouseDirectionChangeObservable,
        directionChanges: directionChanges,
        thresholdMs: thresholdMs
    });
    return thrashedCursorObservable.subscribe(function(time) {
        if (!(0, $54c5a19232a3034b$export$8592af4e162d7307)(options)) return;
        amplitude.track((0, $b9be34b9cefd2a81$export$26ee3309f451c44), undefined, {
            time: time
        });
    });
};


/**
 * Helper function to extract the css selector allowlist
 * from the frustration interactions options for a specific
 * autocapture feature.
 */ function $f6baf092693c7b93$var$getCssSelectorAllowlist(options, attribute, defaultAllowlist, enabled) {
    if (!enabled) return [];
    var config = options[attribute];
    if (typeof config === 'object' && config !== null && 'cssSelectorAllowlist' in config && Array.isArray(config.cssSelectorAllowlist)) return config.cssSelectorAllowlist;
    return defaultAllowlist;
}
var $f6baf092693c7b93$var$MINIMUM_THRASHED_CURSOR_DIRECTION_CHANGES = 5;
var $f6baf092693c7b93$var$MAXIMUM_THRASHED_CURSOR_THRESHOLD = 4000;
var $f6baf092693c7b93$export$d4accb1f65d780 = function(options) {
    var _a;
    if (options === void 0) options = {};
    var name = $b9be34b9cefd2a81$export$270d5ae3019308e5;
    var type = 'enrichment';
    var subscriptions = [];
    var isErrorClicksEnabled = options.errorClicks !== false;
    // if errorClicks is not defined, disable it
    // change this once it moves out of @experimental
    if (!options.errorClicks) isErrorClicksEnabled = false;
    // Check if each feature is enabled
    var deadClicksEnabled = options.deadClicks !== false && options.deadClicks !== null;
    var rageClicksEnabled = options.rageClicks !== false && options.rageClicks !== null;
    var thrashedCursorEnabled = options.thrashedCursor !== false && options.thrashedCursor !== null;
    if (!options.thrashedCursor) thrashedCursorEnabled = false;
    // Get CSS selectors for enabled features
    var rageCssSelectors = $f6baf092693c7b93$var$getCssSelectorAllowlist(options, 'rageClicks', (0, $a4dde53ae76c56cb$export$4b7cdc432c590f70), rageClicksEnabled);
    var deadCssSelectors = $f6baf092693c7b93$var$getCssSelectorAllowlist(options, 'deadClicks', (0, $a4dde53ae76c56cb$export$85f6b4766238212a), deadClicksEnabled);
    var errorCssSelectors = $f6baf092693c7b93$var$getCssSelectorAllowlist(options, 'errorClicks', (0, $a4dde53ae76c56cb$export$49a333174c9f620c), isErrorClicksEnabled);
    var dataAttributePrefix = (_a = options.dataAttributePrefix) !== null && _a !== void 0 ? _a : (0, $86b2ff223bf803d2$export$98ba2b432b1218a9);
    var dataExtractor = new (0, $98cd574e8fe80c36$export$bf982f10504e5dd3)(options);
    // combine the selector lists from enabled features to determine which clicked elements should be filtered
    var combinedCssSelectors = (0, $bunH6.__spreadArray)([], (0, $bunH6.__read)(new Set((0, $bunH6.__spreadArray)((0, $bunH6.__spreadArray)((0, $bunH6.__spreadArray)([], (0, $bunH6.__read)(rageCssSelectors), false), (0, $bunH6.__read)(deadCssSelectors), false), (0, $bunH6.__read)(errorCssSelectors), false))), false);
    // Create observables on events on the window
    var createObservables = function() {
        var _a;
        var clickObservable = (0, $2c30177b55b54dbd$export$1364843af8d5a963)((0, $9ea49793bd7bd466$export$17326e1836d300d0)('pointerdown').map(function(click) {
            return dataExtractor.addAdditionalEventProperties(click, 'click', combinedCssSelectors, dataAttributePrefix, true);
        }));
        var browserErrorObservables = (0, $2c30177b55b54dbd$export$1364843af8d5a963)((0, $9ea49793bd7bd466$export$4ca5586b47f14f0e)().map(function(error) {
            return dataExtractor.addTypeAndTimestamp(error, 'error');
        }));
        var enrichedMutationObservable = (0, $2c30177b55b54dbd$export$1364843af8d5a963)((0, $9ea49793bd7bd466$export$ae86221051ab432c)().map(function(mutation) {
            return dataExtractor.addAdditionalEventProperties(mutation, 'mutation', combinedCssSelectors, dataAttributePrefix);
        }));
        var enrichedNavigateObservable;
        if (window.navigation) {
            var navigateObservable = new (0, (/*@__PURE__*/$parcel$interopDefault($465e706a1980c9f4$exports)))(function(observer) {
                var handler = function(event) {
                    observer.next((0, $bunH6.__assign)((0, $bunH6.__assign)({}, event), {
                        type: 'navigate'
                    }));
                };
                window.navigation.addEventListener('navigate', handler);
                return function() {
                    window.navigation.removeEventListener('navigate', handler);
                };
            });
            enrichedNavigateObservable = (0, $2c30177b55b54dbd$export$1364843af8d5a963)(navigateObservable.map(function(navigate) {
                return dataExtractor.addAdditionalEventProperties(navigate, 'navigate', combinedCssSelectors, dataAttributePrefix);
            }));
        }
        var selectionObservable = (0, $2c30177b55b54dbd$export$1364843af8d5a963)(new (0, (/*@__PURE__*/$parcel$interopDefault($465e706a1980c9f4$exports)))(function(observer) {
            var handler = function() {
                var el = document.activeElement;
                // handle input and textarea
                // if the selectionStart and selectionEnd are the same, it means
                // nothing is selected (collapsed) and the cursor position is one point
                if (el && (el.tagName === 'TEXTAREA' || el.tagName === 'INPUT')) {
                    var start = void 0;
                    var end = void 0;
                    try {
                        start = el.selectionStart;
                        end = el.selectionEnd;
                        if (start === end) return; // collapsed
                    } catch (error) {
                        // input that doesn't support selectionStart/selectionEnd (like checkbox)
                        // do nothing here
                        return;
                    }
                    return observer.next();
                }
                // handle non-input elements
                // non-input elements have an attribute called "isCollapsed" which
                // if true, indicates there "is currently not any text selected"
                // (see https://developer.mozilla.org/en-US/docs/Web/API/Selection/isCollapsed)
                var selection = window.getSelection();
                if (!selection || selection.isCollapsed) return;
                return observer.next();
            };
            window.document.addEventListener('selectionchange', handler);
            return function() {
                window.document.removeEventListener('selectionchange', handler);
            };
        }));
        var mouseMoveObservable = (0, $2c30177b55b54dbd$export$1364843af8d5a963)((0, $9ea49793bd7bd466$export$efd8ddb852fb51ed)());
        return _a = {}, _a[(0, $899c6c1762774565$export$a217bf5378006153).ClickObservable] = clickObservable, _a[(0, $899c6c1762774565$export$a217bf5378006153).MutationObservable] = enrichedMutationObservable, _a[(0, $899c6c1762774565$export$a217bf5378006153).NavigateObservable] = enrichedNavigateObservable, _a[(0, $899c6c1762774565$export$a217bf5378006153).BrowserErrorObservable] = browserErrorObservables, _a[(0, $899c6c1762774565$export$a217bf5378006153).SelectionObservable] = selectionObservable, _a[(0, $899c6c1762774565$export$a217bf5378006153).MouseMoveObservable] = mouseMoveObservable, _a;
    };
    var setup = function(config, amplitude) {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            var allObservables, shouldTrackRageClick, rageClickSubscription, shouldTrackDeadClick, deadClickSubscription, shouldTrackErrorClick, errorClickSubscription, directionChanges, thresholdMs, thrashedCursorSubscription;
            var _a;
            return (0, $bunH6.__generator)(this, function(_b) {
                /* istanbul ignore if */ if (typeof document === 'undefined') return [
                    2 /*return*/ 
                ];
                allObservables = createObservables();
                // Create subscriptions only for enabled features
                if (rageClicksEnabled) {
                    shouldTrackRageClick = (0, $54c5a19232a3034b$export$d41a31caec8ff08e)(options, rageCssSelectors);
                    rageClickSubscription = (0, $0c5a4872a3c90d47$export$68b85203b16696ee)({
                        allObservables: allObservables,
                        amplitude: amplitude,
                        shouldTrackRageClick: shouldTrackRageClick
                    });
                    subscriptions.push(rageClickSubscription);
                }
                if (deadClicksEnabled) {
                    shouldTrackDeadClick = (0, $54c5a19232a3034b$export$d41a31caec8ff08e)(options, deadCssSelectors);
                    deadClickSubscription = (0, $b111d90f19d922df$export$1bcc16975f1978e6)({
                        amplitude: amplitude,
                        allObservables: allObservables,
                        getEventProperties: function(actionType, element) {
                            return dataExtractor.getEventProperties(actionType, element, dataAttributePrefix);
                        },
                        shouldTrackDeadClick: shouldTrackDeadClick
                    });
                    subscriptions.push(deadClickSubscription);
                }
                if (isErrorClicksEnabled) {
                    shouldTrackErrorClick = (0, $54c5a19232a3034b$export$d41a31caec8ff08e)(options, errorCssSelectors);
                    errorClickSubscription = (0, $7618aaac05935f71$export$623660a68102b792)({
                        amplitude: amplitude,
                        allObservables: allObservables,
                        shouldTrackErrorClick: shouldTrackErrorClick
                    });
                    subscriptions.push(errorClickSubscription);
                }
                if (thrashedCursorEnabled) {
                    directionChanges = void 0, thresholdMs = void 0;
                    if (typeof options.thrashedCursor === 'object') {
                        directionChanges = options.thrashedCursor.directionChanges;
                        thresholdMs = options.thrashedCursor.threshold;
                        if (directionChanges && directionChanges < $f6baf092693c7b93$var$MINIMUM_THRASHED_CURSOR_DIRECTION_CHANGES) {
                            config.loggerProvider.warn("'thrashedCursor.directionChanges' of ".concat(directionChanges, " is below the minimum of ").concat($f6baf092693c7b93$var$MINIMUM_THRASHED_CURSOR_DIRECTION_CHANGES, ", setting to ").concat($f6baf092693c7b93$var$MINIMUM_THRASHED_CURSOR_DIRECTION_CHANGES));
                            directionChanges = $f6baf092693c7b93$var$MINIMUM_THRASHED_CURSOR_DIRECTION_CHANGES;
                        }
                        if (thresholdMs && thresholdMs > $f6baf092693c7b93$var$MAXIMUM_THRASHED_CURSOR_THRESHOLD) {
                            config.loggerProvider.warn("'thrashedCursor.threshold' of ".concat(thresholdMs, " is above the maximum of ").concat($f6baf092693c7b93$var$MAXIMUM_THRASHED_CURSOR_THRESHOLD, ", setting to ").concat($f6baf092693c7b93$var$MAXIMUM_THRASHED_CURSOR_THRESHOLD));
                            thresholdMs = $f6baf092693c7b93$var$MAXIMUM_THRASHED_CURSOR_THRESHOLD;
                        }
                    }
                    thrashedCursorSubscription = (0, $8f4e69d1e5184714$export$efe5ac958b10e6c0)({
                        amplitude: amplitude,
                        options: options,
                        allObservables: allObservables,
                        directionChanges: directionChanges,
                        thresholdMs: thresholdMs
                    });
                    subscriptions.push(thrashedCursorSubscription);
                }
                /* istanbul ignore next */ (_a = config === null || config === void 0 ? void 0 : config.loggerProvider) === null || _a === void 0 || _a.log("".concat(name, " has been successfully added."));
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var execute = function(event) {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    event
                ];
            });
        });
    };
    var teardown = function() {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            var subscriptions_1, subscriptions_1_1, subscription;
            var e_1, _a;
            return (0, $bunH6.__generator)(this, function(_b) {
                try {
                    for(subscriptions_1 = (0, $bunH6.__values)(subscriptions), subscriptions_1_1 = subscriptions_1.next(); !subscriptions_1_1.done; subscriptions_1_1 = subscriptions_1.next()){
                        subscription = subscriptions_1_1.value;
                        subscription.unsubscribe();
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (subscriptions_1_1 && !subscriptions_1_1.done && (_a = subscriptions_1.return)) _a.call(subscriptions_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return {
        name: name,
        type: type,
        setup: setup,
        execute: execute,
        teardown: teardown
    };
};



var $bunH6 = parcelRequire("bunH6");

var $bunH6 = parcelRequire("bunH6");

var $c4xZ2 = parcelRequire("c4xZ2");


var $bunH6 = parcelRequire("bunH6");

var $c4xZ2 = parcelRequire("c4xZ2");

var $bunH6 = parcelRequire("bunH6");
function $8662818141ac4699$var$isJsonPrimitive(json) {
    return typeof json === 'string' || typeof json === 'number' || typeof json === 'boolean' || json === null || json === undefined;
}
function $8662818141ac4699$export$e8a8116d42990ec9(json, allowlist, excludelist) {
    if (!json) return;
    // tokenize the allowlist and excludelist
    var allowlistTokens = allowlist.map($8662818141ac4699$export$6e292abbb937012c);
    var excludelistTokens = excludelist.map($8662818141ac4699$export$6e292abbb937012c);
    $8662818141ac4699$export$eddee5e0e9d37ab({
        json: json,
        allowlist: allowlistTokens,
        excludelist: excludelistTokens,
        ancestors: []
    });
}
function $8662818141ac4699$export$eddee5e0e9d37ab(_a) {
    var e_1, _b;
    var json = _a.json, targetObject = _a.targetObject, allowlist = _a.allowlist, excludelist = _a.excludelist, ancestors = _a.ancestors, parentObject = _a.parentObject, targetKey = _a.targetKey;
    if (!targetObject) targetObject = json;
    var keys = Object.keys(targetObject);
    try {
        for(var keys_1 = (0, $bunH6.__values)(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
            var key = keys_1_1.value;
            var path = (0, $bunH6.__spreadArray)((0, $bunH6.__spreadArray)([], (0, $bunH6.__read)(ancestors), false), [
                key
            ], false);
            if ($8662818141ac4699$var$isJsonPrimitive(targetObject[key])) // if the value does not match allowlist or matches exclude list, delete it
            {
                if (!$8662818141ac4699$var$hasPathMatchInList(path, allowlist) || $8662818141ac4699$var$hasPathMatchInList(path, excludelist)) delete targetObject[key];
            } else $8662818141ac4699$export$eddee5e0e9d37ab({
                json: json,
                targetObject: targetObject[key],
                allowlist: allowlist,
                excludelist: excludelist,
                ancestors: path,
                parentObject: targetObject,
                targetKey: key
            });
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (keys_1_1 && !keys_1_1.done && (_b = keys_1.return)) _b.call(keys_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    // if this object is empty now, delete the whole object
    if (Object.keys(targetObject).length === 0 && parentObject && targetKey) delete parentObject[targetKey];
}
function $8662818141ac4699$export$6e292abbb937012c(path) {
    if (path.startsWith('/')) path = path.slice(1);
    return path.split('/').map(function(token) {
        return token.replace(/~0/g, '~').replace(/~1/g, '/');
    });
}
function $8662818141ac4699$export$15449ee374080dc5(path, pathMatcher, i, j) {
    if (i === void 0) i = 0;
    if (j === void 0) j = 0;
    if (j === pathMatcher.length) return i === path.length;
    if (i === path.length) {
        while(j < pathMatcher.length && pathMatcher[j] === '**')j++;
        return j === pathMatcher.length;
    }
    var currentMatcher = pathMatcher[j];
    if (currentMatcher === '**') {
        if (j + 1 === pathMatcher.length) return true;
        for(var k = i; k <= path.length; k++){
            if ($8662818141ac4699$export$15449ee374080dc5(path, pathMatcher, k, j + 1)) return true;
        }
        return false;
    } else if (currentMatcher === '*' || currentMatcher === path[i]) return $8662818141ac4699$export$15449ee374080dc5(path, pathMatcher, i + 1, j + 1);
    else return false;
}
/**
 * Check if a JSON path matches any of the path matchers in the allow or exclude list.
 *
 * @param path - The JSON path to check.
 * @param allowOrExcludeList - The allow or exclude list to check against.
 * @returns True if the path matches any of the path matchers in the allow or exclude list, false otherwise.
 */ function $8662818141ac4699$var$hasPathMatchInList(path, allowOrExcludeList) {
    return allowOrExcludeList.some(function(l) {
        return $8662818141ac4699$export$15449ee374080dc5(path, l);
    });
}



var $3814c0e3b29c3f60$var$TEXT_READ_TIMEOUT = 500;
var $3814c0e3b29c3f60$export$7fc521cfb803e2f6 = 100;
/**
 * This class encapsulates the RequestInit (https://developer.mozilla.org/en-US/docs/Web/API/RequestInit)
 * object so that the consumer can only get access to the headers, method and body size.
 *
 * This is to prevent consumers from directly accessing the Request object
 * and mutating it or running costly operations on it.
 *
 * IMPORTANT:
 *    * Do not make changes to this class without careful consideration
 *      of performance implications, memory usage and potential to mutate the customer's
 *      request.
 *   * NEVER .clone() the RequestInit object. This will 2x's the memory overhead of the request
 *   * NEVER: call .arrayBuffer(), text(), json() or any other method on the body that
 *     consumes the body's stream. This will cause the response to be consumed
 *     meaning the body will be empty when the customer tries to access it.
 *     (ie: if the body is an instanceof https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream
 *      never call any of the methods on it)
 */ var $3814c0e3b29c3f60$export$5d669795c47798f3 = /** @class */ function() {
    function RequestWrapperFetch(request) {
        this.request = request;
    }
    RequestWrapperFetch.prototype.headers = function(allow) {
        var e_1, _a;
        if (allow === void 0) allow = [];
        var headersUnsafe = this.request.headers;
        // copy the headers into a new object
        var headersSafeCopy = {};
        if (Array.isArray(headersUnsafe)) headersUnsafe.forEach(function(_a) {
            var _b = (0, $bunH6.__read)(_a, 2), headerName = _b[0], headerValue = _b[1];
            headersSafeCopy[headerName] = headerValue;
        });
        else if (headersUnsafe instanceof Headers) headersUnsafe.forEach(function(value, key) {
            headersSafeCopy[key] = value;
        });
        else if (typeof headersUnsafe === 'object' && headersUnsafe !== null) try {
            for(var _b = (0, $bunH6.__values)(Object.entries(headersUnsafe)), _c = _b.next(); !_c.done; _c = _b.next()){
                var _d = (0, $bunH6.__read)(_c.value, 2), key = _d[0], value = _d[1];
                headersSafeCopy[key] = value;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $3814c0e3b29c3f60$export$4269d6a324aa5a88(headersSafeCopy, {
            allow: allow
        });
    };
    Object.defineProperty(RequestWrapperFetch.prototype, "bodySize", {
        get: function() {
            if (typeof this._bodySize === 'number') return this._bodySize;
            var global = (0, $c4xZ2.getGlobalScope)();
            /* istanbul ignore if */ if (!(global === null || global === void 0 ? void 0 : global.TextEncoder)) return;
            var body = this.request.body;
            this._bodySize = $3814c0e3b29c3f60$var$getBodySize(body, $3814c0e3b29c3f60$export$7fc521cfb803e2f6);
            return this._bodySize;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestWrapperFetch.prototype, "method", {
        get: function() {
            return this.request.method;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestWrapperFetch.prototype, "body", {
        get: function() {
            if (typeof this.request.body === 'string') return this.request.body;
            return null;
        },
        enumerable: false,
        configurable: true
    });
    RequestWrapperFetch.prototype.json = function(allow, exclude) {
        if (allow === void 0) allow = [];
        if (exclude === void 0) exclude = [];
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var text;
            return (0, $bunH6.__generator)(this, function(_a) {
                if (allow.length === 0) return [
                    2 /*return*/ ,
                    null
                ];
                text = this.body;
                return [
                    2 /*return*/ ,
                    $3814c0e3b29c3f60$var$safeParseAndPruneBody(text, allow, exclude)
                ];
            });
        });
    };
    return RequestWrapperFetch;
}();
var $3814c0e3b29c3f60$export$61c87b7aed3d9594 = /** @class */ function() {
    function RequestWrapperXhr(bodyRaw, requestHeaders) {
        this.bodyRaw = bodyRaw;
        this.requestHeaders = requestHeaders;
    }
    RequestWrapperXhr.prototype.headers = function(allow) {
        if (allow === void 0) allow = [];
        return $3814c0e3b29c3f60$export$4269d6a324aa5a88(this.requestHeaders, {
            allow: allow
        });
    };
    Object.defineProperty(RequestWrapperXhr.prototype, "bodySize", {
        get: function() {
            return $3814c0e3b29c3f60$var$getBodySize(this.bodyRaw, $3814c0e3b29c3f60$export$7fc521cfb803e2f6);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestWrapperXhr.prototype, "body", {
        get: function() {
            if (typeof this.bodyRaw === 'string') return this.bodyRaw;
            return null;
        },
        enumerable: false,
        configurable: true
    });
    RequestWrapperXhr.prototype.json = function(allow, exclude) {
        if (allow === void 0) allow = [];
        if (exclude === void 0) exclude = [];
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var text;
            return (0, $bunH6.__generator)(this, function(_a) {
                if (allow.length === 0) return [
                    2 /*return*/ ,
                    null
                ];
                text = this.body;
                return [
                    2 /*return*/ ,
                    $3814c0e3b29c3f60$var$safeParseAndPruneBody(text, allow, exclude)
                ];
            });
        });
    };
    return RequestWrapperXhr;
}();
function $3814c0e3b29c3f60$var$getBodySize(bodyUnsafe, maxEntries) {
    var e_2, _a;
    var bodySize;
    var global = (0, $c4xZ2.getGlobalScope)();
    /* istanbul ignore next */ var TextEncoder = global === null || global === void 0 ? void 0 : global.TextEncoder;
    /* istanbul ignore next */ if (!TextEncoder) return;
    var bodySafe;
    if (typeof bodyUnsafe === 'string') {
        bodySafe = bodyUnsafe;
        bodySize = new TextEncoder().encode(bodySafe).length;
    } else if (bodyUnsafe instanceof Blob) {
        bodySafe = bodyUnsafe;
        bodySize = bodySafe.size;
    } else if (bodyUnsafe instanceof URLSearchParams) {
        bodySafe = bodyUnsafe;
        bodySize = new TextEncoder().encode(bodySafe.toString()).length;
    } else if (ArrayBuffer.isView(bodyUnsafe)) {
        bodySafe = bodyUnsafe;
        bodySize = bodySafe.byteLength;
    } else if (bodyUnsafe instanceof ArrayBuffer) {
        bodySafe = bodyUnsafe;
        bodySize = bodySafe.byteLength;
    } else if (bodyUnsafe instanceof FormData) {
        // Estimating only for text parts; not accurate for files
        var formData = bodyUnsafe;
        var total = 0;
        var count = 0;
        try {
            for(var _b = (0, $bunH6.__values)(formData.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                var _d = (0, $bunH6.__read)(_c.value, 2), key = _d[0], value = _d[1];
                total += key.length;
                if (typeof value === 'string') total += new TextEncoder().encode(value).length;
                else if (value instanceof Blob) total += value.size;
                else // encountered an unknown type
                // we can't estimate the size of this entry
                return;
                // terminate if we reach the maximum number of entries
                // to avoid performance issues in case of very large FormData
                if (++count >= maxEntries) return;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        bodySize = total;
    } else if (bodyUnsafe instanceof ReadableStream) {
        // If bodyUnsafe is an instanceof ReadableStream, we can't determine the size,
        // without consuming it, so we return undefined.
        // Never ever consume ReadableStream! DO NOT DO IT!!!
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        bodySafe = bodyUnsafe;
        return;
    }
    return bodySize;
}
/**
 * This class encapsulates the Fetch API Response object
 * (https://developer.mozilla.org/en-US/docs/Web/API/Response) so that the consumer can
 * only get access to the headers and body size.
 *
 * This is to prevent consumers from directly accessing the Response object
 * and mutating it or running costly operations on it.
 *
 * IMPORTANT:
 *   * Do not make changes to this class without careful consideration
 *     of performance implications, memory usage and potential to mutate the customer's
 *     response.
 *   * Do not .clone() the Response object unless you need to access the body.
 *     Cloning will 2x the memory overhead of the response.
 *   * NEVER consume the body's stream. This will cause the response to be consumed
 *     meaning the body will be empty when the customer tries to access it.
 *     (ie: if the body is an instanceof https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream
 *      never call any of the methods on it)
 */ var $3814c0e3b29c3f60$export$d70bdb48f217b927 = /** @class */ function() {
    function ResponseWrapperFetch(response) {
        this.response = response;
    }
    ResponseWrapperFetch.prototype.headers = function(allow) {
        var _a;
        if (allow === void 0) allow = [];
        if (this.response.headers instanceof Headers) {
            var headersSafe = this.response.headers;
            var headersOut_1 = {};
            /* istanbul ignore next */ (_a = headersSafe === null || headersSafe === void 0 ? void 0 : headersSafe.forEach) === null || _a === void 0 || _a.call(headersSafe, function(value, key) {
                headersOut_1[key] = value;
            });
            return $3814c0e3b29c3f60$export$4269d6a324aa5a88(headersOut_1, {
                allow: allow
            });
        }
        return;
    };
    Object.defineProperty(ResponseWrapperFetch.prototype, "bodySize", {
        get: function() {
            var _a, _b;
            if (this._bodySize !== undefined) return this._bodySize;
            /* istanbul ignore next */ var contentLength = (_b = (_a = this.response.headers) === null || _a === void 0 ? void 0 : _a.get) === null || _b === void 0 ? void 0 : _b.call(_a, 'content-length');
            var bodySize = contentLength ? parseInt(contentLength, 10) : undefined;
            this._bodySize = bodySize;
            return bodySize;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResponseWrapperFetch.prototype, "status", {
        get: function() {
            return this.response.status;
        },
        enumerable: false,
        configurable: true
    });
    ResponseWrapperFetch.prototype.text = function() {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var textPromise, timer, text, error_1;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // !!!IMPORTANT: we clone the response to avoid mutating the original response
                        // never call .text(), .json(), etc.. on the original response always clone it first
                        if (!this.clonedResponse) this.clonedResponse = this.response.clone();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        textPromise = this.clonedResponse.text();
                        timer = new Promise(function(resolve) {
                            return setTimeout(/* istanbul ignore next */ function() {
                                return resolve(null);
                            }, $3814c0e3b29c3f60$var$TEXT_READ_TIMEOUT);
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.race([
                                textPromise,
                                timer
                            ])
                        ];
                    case 2:
                        text = _a.sent();
                        return [
                            2 /*return*/ ,
                            text
                        ];
                    case 3:
                        error_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ResponseWrapperFetch.prototype.json = function(allow, exclude) {
        if (allow === void 0) allow = [];
        if (exclude === void 0) exclude = [];
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var text;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (allow.length === 0) return [
                            2 /*return*/ ,
                            null
                        ];
                        return [
                            4 /*yield*/ ,
                            this.text()
                        ];
                    case 1:
                        text = _a.sent();
                        return [
                            2 /*return*/ ,
                            $3814c0e3b29c3f60$var$safeParseAndPruneBody(text, allow, exclude)
                        ];
                }
            });
        });
    };
    return ResponseWrapperFetch;
}();
var $3814c0e3b29c3f60$export$99b783aaf5c1f58d = /** @class */ function() {
    function ResponseWrapperXhr(statusCode, headersString, size, getJson) {
        this.statusCode = statusCode;
        this.headersString = headersString;
        this.size = size;
        this.getJson = getJson;
    }
    Object.defineProperty(ResponseWrapperXhr.prototype, "bodySize", {
        get: function() {
            return this.size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResponseWrapperXhr.prototype, "status", {
        get: function() {
            return this.statusCode;
        },
        enumerable: false,
        configurable: true
    });
    ResponseWrapperXhr.prototype.headers = function(allow) {
        var e_3, _a;
        if (allow === void 0) allow = [];
        if (!this.headersString) return {};
        var headers = {};
        var headerLines = this.headersString.split('\r\n');
        try {
            for(var headerLines_1 = (0, $bunH6.__values)(headerLines), headerLines_1_1 = headerLines_1.next(); !headerLines_1_1.done; headerLines_1_1 = headerLines_1.next()){
                var line = headerLines_1_1.value;
                var _b = (0, $bunH6.__read)(line.split(': '), 2), key = _b[0], value = _b[1];
                if (key && value) headers[key] = value;
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (headerLines_1_1 && !headerLines_1_1.done && (_a = headerLines_1.return)) _a.call(headerLines_1);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return $3814c0e3b29c3f60$export$4269d6a324aa5a88(headers, {
            allow: allow
        });
    };
    ResponseWrapperXhr.prototype.json = function(allow, exclude) {
        if (allow === void 0) allow = [];
        if (exclude === void 0) exclude = [];
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var jsonBody;
            return (0, $bunH6.__generator)(this, function(_a) {
                if (allow.length === 0) return [
                    2 /*return*/ ,
                    null
                ];
                jsonBody = this.getJson();
                if (jsonBody) {
                    (0, $8662818141ac4699$export$e8a8116d42990ec9)(jsonBody, allow, exclude);
                    return [
                        2 /*return*/ ,
                        jsonBody
                    ];
                }
                return [
                    2 /*return*/ ,
                    null
                ];
            });
        });
    };
    return ResponseWrapperXhr;
}();
function $3814c0e3b29c3f60$var$safeParseAndPruneBody(text, allow, exclude) {
    if (!text) return null;
    try {
        var json = JSON.parse(text);
        (0, $8662818141ac4699$export$e8a8116d42990ec9)(json, allow, exclude);
        return json;
    } catch (error) {
        return null;
    }
}
var $3814c0e3b29c3f60$export$3768c1bf3d6700dd;
(function(PRUNE_STRATEGY) {
    PRUNE_STRATEGY["REDACT"] = "redact";
    PRUNE_STRATEGY["REMOVE"] = "remove";
})($3814c0e3b29c3f60$export$3768c1bf3d6700dd || ($3814c0e3b29c3f60$export$3768c1bf3d6700dd = {}));
var $3814c0e3b29c3f60$var$REDACTED_VALUE = '[REDACTED]';
var $3814c0e3b29c3f60$export$4269d6a324aa5a88 = function(headers, options) {
    var e_4, _a;
    var _b = options.allow, allow = _b === void 0 ? [] : _b, _c = options.strategy, strategy = _c === void 0 ? $3814c0e3b29c3f60$export$3768c1bf3d6700dd.REMOVE : _c;
    var exclude = (0, $bunH6.__spreadArray)([], (0, $bunH6.__read)((0, $c1d7ad7f2bf46bfb$export$ac363e6ffe994c89)), false);
    var headersPruned = {};
    var _loop_1 = function(key) {
        var lowerKey = key.toLowerCase();
        if (exclude.find(function(e) {
            return e.toLowerCase() === lowerKey;
        })) {
            if (strategy === $3814c0e3b29c3f60$export$3768c1bf3d6700dd.REDACT) headersPruned[key] = $3814c0e3b29c3f60$var$REDACTED_VALUE;
        } else if (!allow.find(function(i) {
            return i.toLowerCase() === lowerKey;
        })) {
            if (strategy === $3814c0e3b29c3f60$export$3768c1bf3d6700dd.REDACT) headersPruned[key] = $3814c0e3b29c3f60$var$REDACTED_VALUE;
        } else headersPruned[key] = headers[key];
    };
    try {
        for(var _d = (0, $bunH6.__values)(Object.keys(headers)), _e = _d.next(); !_e.done; _e = _d.next()){
            var key = _e.value;
            _loop_1(key);
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return headersPruned;
};
var $3814c0e3b29c3f60$export$97ae233cd48dc03e = /** @class */ function() {
    function NetworkRequestEvent(type, method, timestamp, startTime, url, requestWrapper, status, duration, responseWrapper, error, endTime) {
        if (status === void 0) status = 0;
        this.type = type;
        this.method = method;
        this.timestamp = timestamp;
        this.startTime = startTime;
        this.url = url;
        this.requestWrapper = requestWrapper;
        this.status = status;
        this.duration = duration;
        this.responseWrapper = responseWrapper;
        this.error = error;
        this.endTime = endTime;
    }
    NetworkRequestEvent.prototype.toSerializable = function() {
        var _a, _b, _c, _d;
        var serialized = {
            type: this.type,
            method: this.method,
            url: this.url,
            timestamp: this.timestamp,
            status: this.status,
            duration: this.duration,
            error: this.error,
            startTime: this.startTime,
            endTime: this.endTime,
            requestHeaders: (_a = this.requestWrapper) === null || _a === void 0 ? void 0 : _a.headers((0, $bunH6.__spreadArray)([], (0, $bunH6.__read)((0, $c1d7ad7f2bf46bfb$export$a52b450c7f480d9a)), false)),
            requestBodySize: (_b = this.requestWrapper) === null || _b === void 0 ? void 0 : _b.bodySize,
            responseHeaders: (_c = this.responseWrapper) === null || _c === void 0 ? void 0 : _c.headers((0, $bunH6.__spreadArray)([], (0, $bunH6.__read)((0, $c1d7ad7f2bf46bfb$export$a52b450c7f480d9a)), false)),
            responseBodySize: (_d = this.responseWrapper) === null || _d === void 0 ? void 0 : _d.bodySize
        };
        return Object.fromEntries(Object.entries(serialized).filter(function(_a) {
            var _b = (0, $bunH6.__read)(_a, 2), _ = _b[0], v = _b[1];
            return v !== undefined;
        }));
    };
    return NetworkRequestEvent;
}();


/**
 * Typeguard function checks if an input is a Request object.
 */ function $13e4b6fd65d8d9e1$var$isRequest(requestInfo) {
    return typeof requestInfo === 'object' && requestInfo !== null && 'url' in requestInfo && 'method' in requestInfo;
}
var $13e4b6fd65d8d9e1$export$bd5440468f9646a9 = /** @class */ function() {
    function NetworkEventCallback(callback, id) {
        if (id === void 0) id = (0, $b8d06392fac4718b$export$bc35efed93511c4b)();
        this.callback = callback;
        this.id = id;
    }
    return NetworkEventCallback;
}();
function $13e4b6fd65d8d9e1$var$safeInvoke(fn) {
    try {
        fn();
    } catch (err) {
    // swallow the error
    }
}
var $13e4b6fd65d8d9e1$export$9e4a2c29ef0a7cf7 = /** @class */ function() {
    function NetworkObserver(logger) {
        this.eventCallbacks = new Map();
        this.isObserving = false;
        this.logger = logger;
        var globalScope = (0, $c4xZ2.getGlobalScope)();
        if (!NetworkObserver.isSupported()) /* istanbul ignore next */ return;
        this.globalScope = globalScope;
    }
    NetworkObserver.isSupported = function() {
        var globalScope = (0, $c4xZ2.getGlobalScope)();
        return !!globalScope && !!globalScope.fetch;
    };
    NetworkObserver.prototype.subscribe = function(eventCallback, logger) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (!this.logger) this.logger = logger;
        this.eventCallbacks.set(eventCallback.id, eventCallback);
        if (!this.isObserving) {
            /* istanbul ignore next */ // eslint-disable-next-line @typescript-eslint/unbound-method
            var originalXhrOpen = (_c = (_b = (_a = this.globalScope) === null || _a === void 0 ? void 0 : _a.XMLHttpRequest) === null || _b === void 0 ? void 0 : _b.prototype) === null || _c === void 0 ? void 0 : _c.open;
            /* istanbul ignore next */ // eslint-disable-next-line @typescript-eslint/unbound-method
            var originalXhrSend = (_f = (_e = (_d = this.globalScope) === null || _d === void 0 ? void 0 : _d.XMLHttpRequest) === null || _e === void 0 ? void 0 : _e.prototype) === null || _f === void 0 ? void 0 : _f.send;
            /* istanbul ignore next */ // eslint-disable-next-line @typescript-eslint/unbound-method
            var originalXhrSetRequestHeader = (_j = (_h = (_g = this.globalScope) === null || _g === void 0 ? void 0 : _g.XMLHttpRequest) === null || _h === void 0 ? void 0 : _h.prototype) === null || _j === void 0 ? void 0 : _j.setRequestHeader;
            if (originalXhrOpen && originalXhrSend && originalXhrSetRequestHeader) this.observeXhr(originalXhrOpen, originalXhrSend, originalXhrSetRequestHeader);
            /* istanbul ignore next */ var originalFetch = (_k = this.globalScope) === null || _k === void 0 ? void 0 : _k.fetch;
            /* istanbul ignore next */ if (originalFetch) this.observeFetch(originalFetch);
            /* istanbul ignore next */ this.isObserving = true;
        }
    };
    NetworkObserver.prototype.unsubscribe = function(eventCallback) {
        this.eventCallbacks.delete(eventCallback.id);
    };
    NetworkObserver.prototype.triggerEventCallbacks = function(event) {
        var _this = this;
        this.eventCallbacks.forEach(function(callback) {
            try {
                callback.callback(event);
            } catch (err) {
                // if the callback throws an error, we should catch it
                // to avoid breaking the fetch promise chain
                $13e4b6fd65d8d9e1$var$safeInvoke(function() {
                    var _a;
                    /* istanbul ignore next */ (_a = _this.logger) === null || _a === void 0 || _a.debug('an unexpected error occurred while triggering event callbacks', err);
                });
            }
        });
    };
    NetworkObserver.prototype.handleNetworkRequestEvent = function(requestType, requestInfo, requestWrapper, responseWrapper, typedError, startTime, durationStart) {
        var _a;
        /* istanbul ignore next */ if (startTime === undefined || durationStart === undefined) // if we reach this point, it means that the performance API is not supported
        // so we can't construct a NetworkRequestEvent
        return;
        // parse the URL and Method
        var url;
        var method = 'GET';
        if ($13e4b6fd65d8d9e1$var$isRequest(requestInfo)) {
            url = requestInfo['url'];
            method = requestInfo['method'];
        } else url = (_a = requestInfo === null || requestInfo === void 0 ? void 0 : requestInfo.toString) === null || _a === void 0 ? void 0 : _a.call(requestInfo);
        // strip basic auth from the URL
        if (url) try {
            var parsedUrl = new URL(url);
            // reconstruct the URL without the basic auth
            url = "".concat(parsedUrl.protocol, "//").concat(parsedUrl.host).concat(parsedUrl.pathname).concat(parsedUrl.search).concat(parsedUrl.hash);
        // eslint-disable-next-line no-empty
        } catch (err) {}
        method = (requestWrapper === null || requestWrapper === void 0 ? void 0 : requestWrapper.method) || method;
        var status, error;
        if (responseWrapper) status = responseWrapper.status;
        if (typedError) {
            error = {
                name: typedError.name || 'UnknownError',
                message: typedError.message || 'An unknown error occurred'
            };
            status = 0;
        }
        var duration = Math.floor(performance.now() - durationStart);
        var endTime = Math.floor(startTime + duration);
        var requestEvent = new (0, $3814c0e3b29c3f60$export$97ae233cd48dc03e)(requestType, method, startTime, startTime, url, requestWrapper, status, duration, responseWrapper, error, endTime);
        this.triggerEventCallbacks(requestEvent);
    };
    NetworkObserver.prototype.getTimestamps = function() {
        var _a, _b;
        /* istanbul ignore next */ return {
            startTime: (_a = Date.now) === null || _a === void 0 ? void 0 : _a.call(Date),
            durationStart: (_b = performance === null || performance === void 0 ? void 0 : performance.now) === null || _b === void 0 ? void 0 : _b.call(performance)
        };
    };
    NetworkObserver.prototype.observeFetch = function(originalFetch) {
        var _this = this;
        /* istanbul ignore next */ if (!this.globalScope || !originalFetch) return;
        /**
         * IMPORTANT: This overrides window.fetch in browsers.
         * You probably never need to make changes to this function.
         * If you do, please be careful to preserve the original functionality of fetch
         * and make sure another developer who is an expert reviews this change throughly
         */ this.globalScope.fetch = function(requestInfo, requestInit) {
            return (0, $bunH6.__awaiter)(_this, void 0, void 0, function() {
                var timestamps, originalResponse, originalError, err_1;
                var _this = this;
                return (0, $bunH6.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            try {
                                timestamps = this.getTimestamps();
                            } catch (error) {
                                /* istanbul ignore next */ $13e4b6fd65d8d9e1$var$safeInvoke(function() {
                                    var _a;
                                    return (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.debug('an unexpected error occurred while retrieving timestamps', error);
                                });
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4 /*yield*/ ,
                                originalFetch(requestInfo, requestInit)
                            ];
                        case 2:
                            originalResponse = _a.sent();
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            err_1 = _a.sent();
                            // Capture error information
                            originalError = err_1;
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            // 3. call the handler after the fetch call is done
                            try {
                                this.handleNetworkRequestEvent('fetch', requestInfo, requestInit ? new (0, $3814c0e3b29c3f60$export$5d669795c47798f3)(requestInit) : undefined, originalResponse ? new (0, $3814c0e3b29c3f60$export$d70bdb48f217b927)(originalResponse) : undefined, originalError, /* istanbul ignore next */ timestamps === null || timestamps === void 0 ? void 0 : timestamps.startTime, /* istanbul ignore next */ timestamps === null || timestamps === void 0 ? void 0 : timestamps.durationStart);
                            } catch (err) {
                                // this catch shouldn't be reachable, but keep it here for safety
                                // because we're overriding the fetch function and better to be safe than sorry
                                /* istanbul ignore next */ $13e4b6fd65d8d9e1$var$safeInvoke(function() {
                                    var _a;
                                    return (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.debug('an unexpected error occurred while handling fetch', err);
                                });
                            }
                            // 4. return the original response or throw the original error
                            if (originalResponse) // if the response is not undefined, return it
                            return [
                                2 /*return*/ ,
                                originalResponse
                            ];
                            else throw originalError;
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
    };
    /**
     * Creates a function that parses the response of an XMLHttpRequest as JSON.
     *
     * Returns function instead of JSON object to avoid unnecessary parsing if the
     * body is not being captured.
     *
     * @param xhrSafe - The XMLHttpRequest object.
     * @param context - The NetworkObserver instance.
     * @returns A function that parses the response of an XMLHttpRequest as JSON.
     */ NetworkObserver.createXhrJsonParser = function(xhrUnsafe, context) {
        return function() {
            var _a;
            try {
                if (xhrUnsafe.responseType === 'json') {
                    // if response is a JS object, clone it so that subscribers can't mutate it
                    if ((_a = context.globalScope) === null || _a === void 0 ? void 0 : _a.structuredClone) /* eslint-disable-next-line @typescript-eslint/no-unsafe-return */ return context.globalScope.structuredClone(xhrUnsafe.response);
                } else if ([
                    'text',
                    ''
                ].includes(xhrUnsafe.responseType)) // if response is a string, parse it as JSON
                /* eslint-disable-next-line @typescript-eslint/no-unsafe-return */ return JSON.parse(xhrUnsafe.responseText);
            } catch (err) {
                /* istanbul ignore if */ if (err instanceof Error && err.name === 'InvalidStateError') // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseText#exceptions
                // if we reach here, it means we don't handle responseType correctly
                $13e4b6fd65d8d9e1$var$safeInvoke(function() {
                    var _a;
                    return (_a = context.logger) === null || _a === void 0 ? void 0 : _a.debug("unexpected error when retrieving responseText. responseType='".concat(xhrUnsafe.responseType, "'"));
                });
                // the other possible error is Json Parse error which we fail silently
                return null;
            }
            return null;
        };
    };
    NetworkObserver.prototype.observeXhr = function(originalXhrOpen, originalXhrSend, originalXhrSetRequestHeader) {
        /* istanbul ignore next */ if (!this.globalScope || !originalXhrOpen || !originalXhrSend) return;
        var xhrProto = this.globalScope.XMLHttpRequest.prototype;
        var networkObserverContext = this;
        /**
         * IMPORTANT: This overrides window.XMLHttpRequest.prototype.open
         * You probably never need to make changes to this function.
         * If you do, please be careful to preserve the original functionality of xhr.open
         * and make sure another developer who is an expert reviews this change throughly
         */ xhrProto.open = function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var xhrSafe = this;
            var _b = (0, $bunH6.__read)(args, 2), method = _b[0], url = _b[1];
            try {
                /* istanbul ignore next */ xhrSafe.$$AmplitudeAnalyticsEvent = (0, $bunH6.__assign)({
                    method: method,
                    url: (_a = url === null || url === void 0 ? void 0 : url.toString) === null || _a === void 0 ? void 0 : _a.call(url),
                    headers: {}
                }, networkObserverContext.getTimestamps());
            } catch (err) {
                /* istanbul ignore next */ $13e4b6fd65d8d9e1$var$safeInvoke(function() {
                    var _a;
                    return (_a = networkObserverContext.logger) === null || _a === void 0 ? void 0 : _a.debug('an unexpected error occurred while calling xhr open', err);
                });
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            return originalXhrOpen.apply(xhrSafe, args);
        };
        /**
         * IMPORTANT: This overrides window.XMLHttpRequest.prototype.send
         * You probably never need to make changes to this function.
         * If you do, please be careful to preserve the original functionality of xhr.send
         * and make sure another developer who is an expert reviews this change throughly
         */ // allow "any" type for args to reflect how it's used in the browser
        /* eslint-disable-next-line @typescript-eslint/no-unsafe-argument */ xhrProto.send = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhrUnsafe = this;
            var xhrSafe = xhrUnsafe;
            var getJson = NetworkObserver.createXhrJsonParser(xhrUnsafe, networkObserverContext);
            var body = args[0];
            var requestEvent = xhrSafe.$$AmplitudeAnalyticsEvent;
            // if xhrSafe.$$AmplitudeAnalyticsEvent is not set, it means that
            // the xhr.open method was called before we monkey-patched XHR and
            // the event is missed
            if (xhrSafe.$$AmplitudeAnalyticsEvent) xhrSafe.addEventListener('loadend', function() {
                try {
                    var responseHeaders = xhrSafe.getAllResponseHeaders();
                    var responseBodySize = xhrSafe.getResponseHeader('content-length');
                    var responseWrapper = new (0, $3814c0e3b29c3f60$export$99b783aaf5c1f58d)(xhrSafe.status, responseHeaders, /* istanbul ignore next */ responseBodySize ? parseInt(responseBodySize, 10) : undefined, getJson);
                    var requestHeaders = xhrSafe.$$AmplitudeAnalyticsEvent.headers;
                    var requestWrapper = new (0, $3814c0e3b29c3f60$export$61c87b7aed3d9594)(body, requestHeaders);
                    requestEvent.status = xhrSafe.status;
                    networkObserverContext.handleNetworkRequestEvent('xhr', {
                        url: requestEvent.url,
                        method: requestEvent.method
                    }, requestWrapper, responseWrapper, undefined, requestEvent.startTime, requestEvent.durationStart);
                } catch (err) {
                    /* istanbul ignore next */ $13e4b6fd65d8d9e1$var$safeInvoke(function() {
                        var _a;
                        return (_a = networkObserverContext.logger) === null || _a === void 0 ? void 0 : _a.debug('an unexpected error occurred while handling xhr send', err);
                    });
                }
            });
            /* eslint-disable-next-line @typescript-eslint/no-unsafe-argument */ return originalXhrSend.apply(xhrSafe, args);
        };
        /**
         * IMPORTANT: This overrides window.XMLHttpRequest.prototype.setRequestHeader
         * You probably never need to make changes to this function.
         * If you do, please be careful to preserve the original functionality of xhr.setRequestHeader
         * and make sure another developer who is an expert reviews this change throughly
         */ // allow "any" type for args to reflect how it's used in the browser
        /* eslint-disable-next-line @typescript-eslint/no-unsafe-argument */ xhrProto.setRequestHeader = function(headerName, headerValue) {
            var xhrSafe = this;
            try {
                var analyticsEvent = xhrSafe.$$AmplitudeAnalyticsEvent;
                if (analyticsEvent) /* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */ analyticsEvent.headers[headerName] = headerValue;
            } catch (err) {
                /* istanbul ignore next */ $13e4b6fd65d8d9e1$var$safeInvoke(function() {
                    var _a;
                    return (_a = networkObserverContext.logger) === null || _a === void 0 ? void 0 : _a.debug('an unexpected error occurred while calling xhr setRequestHeader', err);
                });
            }
            /* eslint-disable-next-line @typescript-eslint/no-unsafe-argument */ originalXhrSetRequestHeader.apply(xhrSafe, [
                headerName,
                headerValue
            ]);
        };
    };
    return NetworkObserver;
}();
var $13e4b6fd65d8d9e1$export$e2e5f51383af7d20 = new $13e4b6fd65d8d9e1$export$9e4a2c29ef0a7cf7();


var $715d5510860a5776$export$3e69d3882a51f072 = '@amplitude/plugin-network-capture-browser';
var $715d5510860a5776$export$14a64c3349344b25 = '[Amplitude] Network Request';
var $715d5510860a5776$export$2ba68017efced2a0 = true;



var $bunH6 = parcelRequire("bunH6");

var $c4xZ2 = parcelRequire("c4xZ2");

var $166adbdc7f1d4738$var$DEFAULT_STATUS_CODE_RANGE = '500-599';
function $166adbdc7f1d4738$var$wildcardMatch(str, pattern) {
    // Escape all regex special characters except for *
    var escapedPattern = pattern.replace(/[-[\]{}()+?.,\\^$|#\s]/g, '\\$&');
    // Replace * with .*
    var regexPattern = '^' + escapedPattern.replace(/\*/g, '.*') + '$';
    var regex = new RegExp(regexPattern);
    return regex.test(str);
}
function $166adbdc7f1d4738$var$isStatusCodeInRange(statusCode, range) {
    var e_1, _a;
    var ranges = range.split(',');
    try {
        for(var ranges_1 = (0, $bunH6.__values)(ranges), ranges_1_1 = ranges_1.next(); !ranges_1_1.done; ranges_1_1 = ranges_1.next()){
            var r = ranges_1_1.value;
            var _b = (0, $bunH6.__read)(r.split('-').map(Number), 2), start = _b[0], end = _b[1];
            if (statusCode === start && end === undefined) return true;
            if (statusCode >= start && statusCode <= end) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (ranges_1_1 && !ranges_1_1.done && (_a = ranges_1.return)) _a.call(ranges_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
}
function $166adbdc7f1d4738$var$isCaptureRuleMatch(rule, hostname, status, url, method) {
    // check if the host is in the allowed hosts
    if (rule.hosts && !rule.hosts.find(function(host) {
        return $166adbdc7f1d4738$var$wildcardMatch(hostname, host);
    })) return;
    // check if the URL is in the allowed URL patterns
    if (url && rule.urls && !(0, $cfec2d180e2010e9$export$d00b17649a2434e7)(url, rule.urls)) return;
    // check if the method is in the allowed methods
    if (method && rule.methods && !rule.methods.find(function(allowedMethod) {
        return method.toLowerCase() === allowedMethod.toLowerCase() || allowedMethod === '*';
    })) return;
    // check if the status code is in the allowed range
    if (status || status === 0) {
        var statusCodeRange = rule.statusCodeRange || $166adbdc7f1d4738$var$DEFAULT_STATUS_CODE_RANGE;
        if (!$166adbdc7f1d4738$var$isStatusCodeInRange(status, statusCodeRange)) return false;
    }
    return true;
}
function $166adbdc7f1d4738$var$parseUrl(url) {
    var _a;
    if (!url) return;
    try {
        /* istanbul ignore next */ var currentHref = (_a = (0, $c4xZ2.getGlobalScope)()) === null || _a === void 0 ? void 0 : _a.location.href;
        var urlObj = new URL(url, currentHref);
        var query = urlObj.searchParams.toString();
        var fragment = urlObj.hash.replace('#', '');
        var href = urlObj.href;
        var host = urlObj.host;
        urlObj.hash = '';
        urlObj.search = '';
        var hrefWithoutQueryOrHash = urlObj.href;
        return {
            query: query,
            fragment: fragment,
            href: href,
            hrefWithoutQueryOrHash: hrefWithoutQueryOrHash,
            host: host
        };
    } catch (e) {
        /* istanbul ignore next */ return;
    }
}
function $166adbdc7f1d4738$var$isAmplitudeNetworkRequestEvent(host, requestWrapper) {
    if (host.includes('amplitude.com')) try {
        var body = requestWrapper.body;
        if (typeof body !== 'string') return false;
        var bodyObj = JSON.parse(body);
        var events = bodyObj.events;
        /* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */ if (events.find(function(event) {
            return event.event_type === (0, $715d5510860a5776$export$14a64c3349344b25);
        })) return true;
    } catch (e) {
    // do nothing
    }
    return false;
}
function $166adbdc7f1d4738$export$24524265b2bf6143(rule) {
    if (typeof rule !== 'object' || rule === null) {
        // if rule is truthy or undefined, return SAFE_HEADERS
        if (rule) return (0, $bunH6.__spreadArray)([], (0, $bunH6.__read)((0, $c1d7ad7f2bf46bfb$export$a52b450c7f480d9a)), false);
        else if (rule === undefined) {
            /* istanbul ignore next */ var res = (0, $715d5510860a5776$export$2ba68017efced2a0) ? undefined : (0, $bunH6.__spreadArray)([], (0, $bunH6.__read)((0, $c1d7ad7f2bf46bfb$export$a52b450c7f480d9a)), false);
            return res;
        }
        return;
    }
    // if the rule is defined but empty, return undefined
    if (rule.length === 0) return;
    return rule;
}
function $166adbdc7f1d4738$var$isBodyCaptureRuleEmpty(rule) {
    var _a, _b;
    /* istanbul ignore next */ return !((_a = rule === null || rule === void 0 ? void 0 : rule.allowlist) === null || _a === void 0 ? void 0 : _a.length) && !((_b = rule === null || rule === void 0 ? void 0 : rule.blocklist) === null || _b === void 0 ? void 0 : _b.length);
}
function $166adbdc7f1d4738$export$b5ac5b1dd933557d(networkEvent, options) {
    var _a;
    if (options === void 0) options = {};
    var urlObj = $166adbdc7f1d4738$var$parseUrl(networkEvent.url);
    /* istanbul ignore if */ if (!urlObj) // if the URL failed to parse, do not track the event
    // this is a probably impossible case that would only happen if the URL is malformed
    /* istanbul ignore next */ return false;
    var host = urlObj.host;
    // false if is amplitude request and not configured to track amplitude requests
    if (options.ignoreAmplitudeRequests !== false && ($166adbdc7f1d4738$var$wildcardMatch(host, '*.amplitude.com') || $166adbdc7f1d4738$var$wildcardMatch(host, 'amplitude.com'))) return false;
    // false if the host is in the ignore list
    if ((_a = options.ignoreHosts) === null || _a === void 0 ? void 0 : _a.find(function(ignoreHost) {
        return $166adbdc7f1d4738$var$wildcardMatch(host, ignoreHost);
    })) return false;
    // false if the status code is not 500-599 and there are no captureRules
    if (!options.captureRules && networkEvent.status !== undefined && !$166adbdc7f1d4738$var$isStatusCodeInRange(networkEvent.status, $166adbdc7f1d4738$var$DEFAULT_STATUS_CODE_RANGE)) return false;
    if (options.captureRules) {
        // find the first capture rule, in reverse-order,
        // that is a match (true) or a miss (false)
        var isMatch_1;
        (0, $bunH6.__spreadArray)([], (0, $bunH6.__read)(options.captureRules), false).reverse().find(function(rule) {
            isMatch_1 = $166adbdc7f1d4738$var$isCaptureRuleMatch(rule, host, networkEvent.status, networkEvent.url, networkEvent.method);
            if (isMatch_1) {
                var responseHeadersRule = $166adbdc7f1d4738$export$24524265b2bf6143(rule.responseHeaders);
                if (networkEvent.responseWrapper && responseHeadersRule) {
                    var responseHeaders = networkEvent.responseWrapper.headers(responseHeadersRule);
                    if (responseHeaders) networkEvent.responseHeaders = responseHeaders;
                }
                // if requestHeaders rule is specified, enrich the event with the request headers
                var requestHeadersRule = $166adbdc7f1d4738$export$24524265b2bf6143(rule.requestHeaders);
                if (networkEvent.requestWrapper && requestHeadersRule) {
                    var requestHeaders = networkEvent.requestWrapper.headers(requestHeadersRule);
                    if (requestHeaders) networkEvent.requestHeaders = requestHeaders;
                }
                // if responseBody rule is specified, enrich the event with the response body
                if (networkEvent.responseWrapper && rule.responseBody && !$166adbdc7f1d4738$var$isBodyCaptureRuleEmpty(rule.responseBody)) networkEvent.responseBodyJson = networkEvent.responseWrapper.json(rule.responseBody.allowlist, rule.responseBody.blocklist);
                // if requestBody rule is specified, enrich the event with the request body
                if (networkEvent.requestWrapper && rule.requestBody && !$166adbdc7f1d4738$var$isBodyCaptureRuleEmpty(rule.requestBody)) networkEvent.requestBodyJson = networkEvent.requestWrapper.json(rule.requestBody.allowlist, rule.requestBody.blocklist);
            }
            return isMatch_1 !== undefined;
        });
        // if we found a miss (false) or no match (undefined),
        // then do not track the event
        if (!isMatch_1) return false;
    }
    // skip Amplitude network requests to "[Amplitude] Network Request" to avoid infinite loop
    if (networkEvent.requestWrapper && $166adbdc7f1d4738$var$isAmplitudeNetworkRequestEvent(host, networkEvent.requestWrapper)) return false;
    return true;
}
function $166adbdc7f1d4738$export$6260c04fd2ca0b07(networkAnalyticsEvent, request, amplitude, loggerProvider) {
    return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
        var _a, requestBody, responseBody;
        return (0, $bunH6.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!(request.requestBodyJson || request.responseBodyJson)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all([
                            request.requestBodyJson,
                            request.responseBodyJson
                        ])
                    ];
                case 1:
                    _a = (0, $bunH6.__read).apply(void 0, [
                        _b.sent(),
                        2
                    ]), requestBody = _a[0], responseBody = _a[1];
                    if (requestBody) try {
                        networkAnalyticsEvent['[Amplitude] Request Body'] = JSON.stringify(requestBody);
                    } catch (e) {
                        /* istanbul ignore next */ loggerProvider === null || loggerProvider === void 0 || loggerProvider.debug('Failed to stringify request body', e);
                    }
                    if (responseBody) try {
                        networkAnalyticsEvent['[Amplitude] Response Body'] = JSON.stringify(responseBody);
                    } catch (e) {
                        /* istanbul ignore next */ loggerProvider === null || loggerProvider === void 0 || loggerProvider.debug('Failed to stringify response body');
                    }
                    _b.label = 2;
                case 2:
                    /* istanbul ignore next */ amplitude === null || amplitude === void 0 || amplitude.track((0, $715d5510860a5776$export$14a64c3349344b25), networkAnalyticsEvent);
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $166adbdc7f1d4738$export$1315ad4dc0be4713(_a) {
    var allObservables = _a.allObservables, networkTrackingOptions = _a.networkTrackingOptions, amplitude = _a.amplitude, loggerProvider = _a.loggerProvider;
    var networkObservable = allObservables.networkObservable;
    var filteredNetworkObservable = networkObservable.filter(function(event) {
        // Only track network events that should be tracked
        return $166adbdc7f1d4738$export$b5ac5b1dd933557d(event.event, networkTrackingOptions);
    });
    return filteredNetworkObservable.subscribe(function(networkEvent) {
        var _a;
        var _b, _c;
        var request = networkEvent.event;
        // convert to NetworkAnalyticsEvent
        var urlObj = $166adbdc7f1d4738$var$parseUrl(request.url);
        /* istanbul ignore if */ if (!urlObj) // if the URL failed to parse, do not track the event
        // this is a very unlikely case, because URL() shouldn't throw an exception
        // when the URL is a valid URL
        /* istanbul ignore next */ return;
        var responseBodySize = (_b = request.responseWrapper) === null || _b === void 0 ? void 0 : _b.bodySize;
        /* istanbul ignore next */ var requestBodySize = (_c = request.requestWrapper) === null || _c === void 0 ? void 0 : _c.bodySize;
        var networkAnalyticsEvent = (_a = {}, _a['[Amplitude] URL'] = urlObj.hrefWithoutQueryOrHash, _a['[Amplitude] URL Query'] = urlObj.query, _a['[Amplitude] URL Fragment'] = urlObj.fragment, _a['[Amplitude] Request Method'] = request.method, _a['[Amplitude] Status Code'] = request.status, _a['[Amplitude] Start Time'] = request.startTime, _a['[Amplitude] Completion Time'] = request.endTime, _a['[Amplitude] Duration'] = request.duration, _a['[Amplitude] Request Body Size'] = requestBodySize, _a['[Amplitude] Response Body Size'] = responseBodySize, _a['[Amplitude] Request Type'] = request.type, _a['[Amplitude] Request Headers'] = request.requestHeaders, _a['[Amplitude] Response Headers'] = request.responseHeaders, _a);
        // fire-and-forget promise that tracks the event
        $166adbdc7f1d4738$export$6260c04fd2ca0b07(networkAnalyticsEvent, request, amplitude, loggerProvider);
    });
}


var $1608e7888a92f594$export$a217bf5378006153;
(function(ObservablesEnum) {
    ObservablesEnum["NetworkObservable"] = "networkObservable";
})($1608e7888a92f594$export$a217bf5378006153 || ($1608e7888a92f594$export$a217bf5378006153 = {}));
var $1608e7888a92f594$var$subscription;
var $1608e7888a92f594$export$73cfddfb0e93383e = function(options) {
    if (options === void 0) options = {};
    var name = $715d5510860a5776$export$3e69d3882a51f072;
    var type = 'enrichment';
    var logger;
    var addAdditionalEventProperties = function(event, type) {
        var baseEvent = {
            event: event,
            timestamp: Date.now(),
            type: type
        };
        return baseEvent;
    };
    // Create observables on events on the window
    var createObservables = function() {
        var _a;
        var networkObservable = new (0, (/*@__PURE__*/$parcel$interopDefault($465e706a1980c9f4$exports)))(function(observer) {
            var callback = new (0, $13e4b6fd65d8d9e1$export$bd5440468f9646a9)(function(event) {
                var eventWithProperties = addAdditionalEventProperties(event, 'network');
                observer.next(eventWithProperties);
            });
            (0, $13e4b6fd65d8d9e1$export$e2e5f51383af7d20).subscribe(callback, logger);
            return function() {
                (0, $13e4b6fd65d8d9e1$export$e2e5f51383af7d20).unsubscribe(callback);
            };
        });
        return _a = {}, _a[$1608e7888a92f594$export$a217bf5378006153.NetworkObservable] = networkObservable, _a;
    };
    var setup = function(config, amplitude) {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            var allObservables;
            return (0, $bunH6.__generator)(this, function(_a) {
                /* istanbul ignore if */ if (typeof document === 'undefined') return [
                    2 /*return*/ 
                ];
                allObservables = createObservables();
                /* istanbul ignore next */ logger = config === null || config === void 0 ? void 0 : config.loggerProvider;
                $1608e7888a92f594$var$subscription = (0, $166adbdc7f1d4738$export$1315ad4dc0be4713)({
                    allObservables: allObservables,
                    networkTrackingOptions: options,
                    amplitude: amplitude,
                    loggerProvider: logger
                });
                /* istanbul ignore next */ logger === null || logger === void 0 || logger.log("".concat(name, " has been successfully added."));
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /* istanbul ignore next */ var execute = function(event) {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    event
                ];
            });
        });
    };
    var teardown = function() {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                $1608e7888a92f594$var$subscription.unsubscribe();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return {
        name: name,
        type: type,
        setup: setup,
        execute: execute,
        teardown: teardown
    };
};



var $bunH6 = parcelRequire("bunH6");

var $c4xZ2 = parcelRequire("c4xZ2");
var $163900b84e66e5b3$export$3e69d3882a51f072 = 'web-vitals-browser';
var $163900b84e66e5b3$export$a44cad79025b176c = '[Amplitude] Web Vitals';


let $128867d9256f5db8$var$e = -1;
const $128867d9256f5db8$var$t = (t)=>{
    addEventListener("pageshow", (n)=>{
        n.persisted && ($128867d9256f5db8$var$e = n.timeStamp, t(n));
    }, !0);
}, $128867d9256f5db8$var$n = (e, t, n, i)=>{
    let s, o;
    return (r)=>{
        t.value >= 0 && (r || i) && (o = t.value - (s ?? 0), (o || void 0 === s) && (s = t.value, t.delta = o, t.rating = ((e, t)=>e > t[1] ? "poor" : e > t[0] ? "needs-improvement" : "good")(t.value, n), e(t)));
    };
}, $128867d9256f5db8$var$i = (e)=>{
    requestAnimationFrame(()=>requestAnimationFrame(()=>e()));
}, $128867d9256f5db8$var$s = ()=>{
    const e = performance.getEntriesByType("navigation")[0];
    if (e && e.responseStart > 0 && e.responseStart < performance.now()) return e;
}, $128867d9256f5db8$var$o = ()=>{
    const e = $128867d9256f5db8$var$s();
    return e?.activationStart ?? 0;
}, $128867d9256f5db8$var$r = (t, n = -1)=>{
    const i = $128867d9256f5db8$var$s();
    let r = "navigate";
    $128867d9256f5db8$var$e >= 0 ? r = "back-forward-cache" : i && (document.prerendering || $128867d9256f5db8$var$o() > 0 ? r = "prerender" : document.wasDiscarded ? r = "restore" : i.type && (r = i.type.replace(/_/g, "-")));
    return {
        name: t,
        value: n,
        rating: "good",
        delta: 0,
        entries: [],
        id: `v5-${Date.now()}-${Math.floor(8999999999999 * Math.random()) + 1e12}`,
        navigationType: r
    };
}, $128867d9256f5db8$var$c = new WeakMap;
function $128867d9256f5db8$var$a(e, t) {
    return $128867d9256f5db8$var$c.get(e) || $128867d9256f5db8$var$c.set(e, new t), $128867d9256f5db8$var$c.get(e);
}
class $128867d9256f5db8$var$d {
    t;
    i = 0;
    o = [];
    h(e) {
        if (e.hadRecentInput) return;
        const t = this.o[0], n = this.o.at(-1);
        this.i && t && n && e.startTime - n.startTime < 1e3 && e.startTime - t.startTime < 5e3 ? (this.i += e.value, this.o.push(e)) : (this.i = e.value, this.o = [
            e
        ]), this.t?.(e);
    }
}
const $128867d9256f5db8$var$h = (e, t, n = {})=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(e)) {
            const i = new PerformanceObserver((e)=>{
                Promise.resolve().then(()=>{
                    t(e.getEntries());
                });
            });
            return i.observe({
                type: e,
                buffered: !0,
                ...n
            }), i;
        }
    } catch  {}
}, $128867d9256f5db8$var$f = (e)=>{
    let t = !1;
    return ()=>{
        t || (e(), t = !0);
    };
};
let $128867d9256f5db8$var$u = -1;
const $128867d9256f5db8$var$l = new Set, $128867d9256f5db8$var$m = ()=>"hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0, $128867d9256f5db8$var$p = (e)=>{
    if ("hidden" === document.visibilityState) {
        if ("visibilitychange" === e.type) for (const e of $128867d9256f5db8$var$l)e();
        isFinite($128867d9256f5db8$var$u) || ($128867d9256f5db8$var$u = "visibilitychange" === e.type ? e.timeStamp : 0, removeEventListener("prerenderingchange", $128867d9256f5db8$var$p, !0));
    }
}, $128867d9256f5db8$var$v = ()=>{
    if ($128867d9256f5db8$var$u < 0) {
        const e = $128867d9256f5db8$var$o(), n = document.prerendering ? void 0 : globalThis.performance.getEntriesByType("visibility-state").filter((t)=>"hidden" === t.name && t.startTime > e)[0]?.startTime;
        $128867d9256f5db8$var$u = n ?? $128867d9256f5db8$var$m(), addEventListener("visibilitychange", $128867d9256f5db8$var$p, !0), addEventListener("prerenderingchange", $128867d9256f5db8$var$p, !0), $128867d9256f5db8$var$t(()=>{
            setTimeout(()=>{
                $128867d9256f5db8$var$u = $128867d9256f5db8$var$m();
            });
        });
    }
    return {
        get firstHiddenTime () {
            return $128867d9256f5db8$var$u;
        },
        onHidden (e) {
            $128867d9256f5db8$var$l.add(e);
        }
    };
}, $128867d9256f5db8$var$g = (e)=>{
    document.prerendering ? addEventListener("prerenderingchange", ()=>e(), !0) : e();
}, $128867d9256f5db8$export$e610c735b5510cec = [
    1800,
    3e3
], $128867d9256f5db8$export$fe3c86b74e15d5de = (e, s = {})=>{
    $128867d9256f5db8$var$g(()=>{
        const c = $128867d9256f5db8$var$v();
        let a, d = $128867d9256f5db8$var$r("FCP");
        const f = $128867d9256f5db8$var$h("paint", (e)=>{
            for (const t of e)"first-contentful-paint" === t.name && (f.disconnect(), t.startTime < c.firstHiddenTime && (d.value = Math.max(t.startTime - $128867d9256f5db8$var$o(), 0), d.entries.push(t), a(!0)));
        });
        f && (a = $128867d9256f5db8$var$n(e, d, $128867d9256f5db8$export$e610c735b5510cec, s.reportAllChanges), $128867d9256f5db8$var$t((t)=>{
            d = $128867d9256f5db8$var$r("FCP"), a = $128867d9256f5db8$var$n(e, d, $128867d9256f5db8$export$e610c735b5510cec, s.reportAllChanges), $128867d9256f5db8$var$i(()=>{
                d.value = performance.now() - t.timeStamp, a(!0);
            });
        }));
    });
}, $128867d9256f5db8$export$3f20d8e089ac35b2 = [
    .1,
    .25
], $128867d9256f5db8$export$a7873055838e5ad8 = (e, s = {})=>{
    const o = $128867d9256f5db8$var$v();
    $128867d9256f5db8$export$fe3c86b74e15d5de($128867d9256f5db8$var$f(()=>{
        let c, f = $128867d9256f5db8$var$r("CLS", 0);
        const u = $128867d9256f5db8$var$a(s, $128867d9256f5db8$var$d), l = (e)=>{
            for (const t of e)u.h(t);
            u.i > f.value && (f.value = u.i, f.entries = u.o, c());
        }, m = $128867d9256f5db8$var$h("layout-shift", l);
        m && (c = $128867d9256f5db8$var$n(e, f, $128867d9256f5db8$export$3f20d8e089ac35b2, s.reportAllChanges), o.onHidden(()=>{
            l(m.takeRecords()), c(!0);
        }), $128867d9256f5db8$var$t(()=>{
            u.i = 0, f = $128867d9256f5db8$var$r("CLS", 0), c = $128867d9256f5db8$var$n(e, f, $128867d9256f5db8$export$3f20d8e089ac35b2, s.reportAllChanges), $128867d9256f5db8$var$i(()=>c());
        }), setTimeout(c));
    }));
};
let $128867d9256f5db8$var$P = 0, $128867d9256f5db8$var$T = 1 / 0, $128867d9256f5db8$var$_ = 0;
const $128867d9256f5db8$var$M = (e)=>{
    for (const t of e)t.interactionId && ($128867d9256f5db8$var$T = Math.min($128867d9256f5db8$var$T, t.interactionId), $128867d9256f5db8$var$_ = Math.max($128867d9256f5db8$var$_, t.interactionId), $128867d9256f5db8$var$P = $128867d9256f5db8$var$_ ? ($128867d9256f5db8$var$_ - $128867d9256f5db8$var$T) / 7 + 1 : 0);
};
let $128867d9256f5db8$var$w;
const $128867d9256f5db8$var$C = ()=>$128867d9256f5db8$var$w ? $128867d9256f5db8$var$P : performance.interactionCount ?? 0, $128867d9256f5db8$var$I = ()=>{
    "interactionCount" in performance || $128867d9256f5db8$var$w || ($128867d9256f5db8$var$w = $128867d9256f5db8$var$h("event", $128867d9256f5db8$var$M, {
        type: "event",
        buffered: !0,
        durationThreshold: 0
    }));
};
let $128867d9256f5db8$var$F = 0;
class $128867d9256f5db8$var$k {
    u = [];
    l = new Map;
    m;
    p;
    v() {
        $128867d9256f5db8$var$F = $128867d9256f5db8$var$C(), this.u.length = 0, this.l.clear();
    }
    L() {
        const e = Math.min(this.u.length - 1, Math.floor(($128867d9256f5db8$var$C() - $128867d9256f5db8$var$F) / 50));
        return this.u[e];
    }
    h(e) {
        if (this.m?.(e), !e.interactionId && "first-input" !== e.entryType) return;
        const t = this.u.at(-1);
        let n = this.l.get(e.interactionId);
        if (n || this.u.length < 10 || e.duration > t.P) {
            if (n ? e.duration > n.P ? (n.entries = [
                e
            ], n.P = e.duration) : e.duration === n.P && e.startTime === n.entries[0].startTime && n.entries.push(e) : (n = {
                id: e.interactionId,
                entries: [
                    e
                ],
                P: e.duration
            }, this.l.set(n.id, n), this.u.push(n)), this.u.sort((e, t)=>t.P - e.P), this.u.length > 10) {
                const e = this.u.splice(10);
                for (const t of e)this.l.delete(t.id);
            }
            this.p?.(n);
        }
    }
}
const $128867d9256f5db8$var$A = (e)=>{
    const t = globalThis.requestIdleCallback || setTimeout;
    "hidden" === document.visibilityState ? e() : (e = $128867d9256f5db8$var$f(e), addEventListener("visibilitychange", e, {
        once: !0,
        capture: !0
    }), t(()=>{
        e(), removeEventListener("visibilitychange", e, {
            capture: !0
        });
    }));
}, $128867d9256f5db8$export$7f4cb060ded9173c = [
    200,
    500
], $128867d9256f5db8$export$7df4b36ecaed99e1 = (e, i = {})=>{
    if (!globalThis.PerformanceEventTiming || !("interactionId" in PerformanceEventTiming.prototype)) return;
    const s = $128867d9256f5db8$var$v();
    $128867d9256f5db8$var$g(()=>{
        $128867d9256f5db8$var$I();
        let o, c = $128867d9256f5db8$var$r("INP");
        const d = $128867d9256f5db8$var$a(i, $128867d9256f5db8$var$k), f = (e)=>{
            $128867d9256f5db8$var$A(()=>{
                for (const t of e)d.h(t);
                const t = d.L();
                t && t.P !== c.value && (c.value = t.P, c.entries = t.entries, o());
            });
        }, u = $128867d9256f5db8$var$h("event", f, {
            durationThreshold: i.durationThreshold ?? 40
        });
        o = $128867d9256f5db8$var$n(e, c, $128867d9256f5db8$export$7f4cb060ded9173c, i.reportAllChanges), u && (u.observe({
            type: "first-input",
            buffered: !0
        }), s.onHidden(()=>{
            f(u.takeRecords()), o(!0);
        }), $128867d9256f5db8$var$t(()=>{
            d.v(), c = $128867d9256f5db8$var$r("INP"), o = $128867d9256f5db8$var$n(e, c, $128867d9256f5db8$export$7f4cb060ded9173c, i.reportAllChanges);
        }));
    });
};
class $128867d9256f5db8$var$N {
    m;
    h(e) {
        this.m?.(e);
    }
}
const $128867d9256f5db8$export$948521ca5b0e1b17 = [
    2500,
    4e3
], $128867d9256f5db8$export$947b1626ab8d5632 = (e, s = {})=>{
    $128867d9256f5db8$var$g(()=>{
        const c = $128867d9256f5db8$var$v();
        let d, u = $128867d9256f5db8$var$r("LCP");
        const l = $128867d9256f5db8$var$a(s, $128867d9256f5db8$var$N), m = (e)=>{
            s.reportAllChanges || (e = e.slice(-1));
            for (const t of e)l.h(t), t.startTime < c.firstHiddenTime && (u.value = Math.max(t.startTime - $128867d9256f5db8$var$o(), 0), u.entries = [
                t
            ], d());
        }, p = $128867d9256f5db8$var$h("largest-contentful-paint", m);
        if (p) {
            d = $128867d9256f5db8$var$n(e, u, $128867d9256f5db8$export$948521ca5b0e1b17, s.reportAllChanges);
            const o = $128867d9256f5db8$var$f(()=>{
                m(p.takeRecords()), p.disconnect(), d(!0);
            }), c = (e)=>{
                e.isTrusted && ($128867d9256f5db8$var$A(o), removeEventListener(e.type, c, {
                    capture: !0
                }));
            };
            for (const e of [
                "keydown",
                "click",
                "visibilitychange"
            ])addEventListener(e, c, {
                capture: !0
            });
            $128867d9256f5db8$var$t((t)=>{
                u = $128867d9256f5db8$var$r("LCP"), d = $128867d9256f5db8$var$n(e, u, $128867d9256f5db8$export$948521ca5b0e1b17, s.reportAllChanges), $128867d9256f5db8$var$i(()=>{
                    u.value = performance.now() - t.timeStamp, d(!0);
                });
            });
        }
    });
}, $128867d9256f5db8$export$65c59ea8064668fc = [
    800,
    1800
], $128867d9256f5db8$var$O = (e)=>{
    document.prerendering ? $128867d9256f5db8$var$g(()=>$128867d9256f5db8$var$O(e)) : "complete" !== document.readyState ? addEventListener("load", ()=>$128867d9256f5db8$var$O(e), !0) : setTimeout(e);
}, $128867d9256f5db8$export$33a01e6c5f2c7e33 = (e, i = {})=>{
    let c = $128867d9256f5db8$var$r("TTFB"), a = $128867d9256f5db8$var$n(e, c, $128867d9256f5db8$export$65c59ea8064668fc, i.reportAllChanges);
    $128867d9256f5db8$var$O(()=>{
        const d = $128867d9256f5db8$var$s();
        d && (c.value = Math.max(d.responseStart - $128867d9256f5db8$var$o(), 0), c.entries = [
            d
        ], a(!0), $128867d9256f5db8$var$t(()=>{
            c = $128867d9256f5db8$var$r("TTFB", 0), a = $128867d9256f5db8$var$n(e, c, $128867d9256f5db8$export$65c59ea8064668fc, i.reportAllChanges), a(!0);
        }));
    });
};


function $5bef2f568ab3d9d1$var$getMetricStartTime(metric) {
    var _a;
    /* istanbul ignore next */ var startTime = ((_a = metric.entries[0]) === null || _a === void 0 ? void 0 : _a.startTime) || 0;
    return performance.timeOrigin + startTime;
}
function $5bef2f568ab3d9d1$var$processMetric(metric) {
    return {
        value: metric.value,
        rating: metric.rating,
        delta: metric.delta,
        navigationType: metric.navigationType,
        id: metric.id,
        timestamp: Math.floor($5bef2f568ab3d9d1$var$getMetricStartTime(metric)),
        navigationStart: Math.floor(performance.timeOrigin)
    };
}
var $5bef2f568ab3d9d1$export$aa465eaf220de4d = function() {
    var visibilityListener = null;
    var globalScope = (0, $c4xZ2.getGlobalScope)();
    var doc = globalScope === null || globalScope === void 0 ? void 0 : globalScope.document;
    var location = globalScope === null || globalScope === void 0 ? void 0 : globalScope.location;
    var setup = function(config, amplitude) {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            var locationHref, webVitalsPayload;
            return (0, $bunH6.__generator)(this, function(_a) {
                if (doc === undefined) return [
                    2 /*return*/ 
                ];
                locationHref = (0, $cfec2d180e2010e9$export$c9f67ffc80012d9b)(/* istanbul ignore next */ (location === null || location === void 0 ? void 0 : location.href) || '', config.loggerProvider);
                webVitalsPayload = {
                    '[Amplitude] Page Domain': /* istanbul ignore next */ (location === null || location === void 0 ? void 0 : location.hostname) || '',
                    '[Amplitude] Page Location': locationHref,
                    '[Amplitude] Page Path': (0, $cfec2d180e2010e9$export$c9f67ffc80012d9b)(/* istanbul ignore next */ (location === null || location === void 0 ? void 0 : location.pathname) || '', config.loggerProvider),
                    '[Amplitude] Page Title': /* istanbul ignore next */ typeof document !== 'undefined' && document.title || '',
                    '[Amplitude] Page URL': (0, $cfec2d180e2010e9$export$c9f67ffc80012d9b)(locationHref.split('?')[0], config.loggerProvider)
                };
                (0, $128867d9256f5db8$export$947b1626ab8d5632)(function(metric) {
                    webVitalsPayload['[Amplitude] LCP'] = $5bef2f568ab3d9d1$var$processMetric(metric);
                });
                (0, $128867d9256f5db8$export$fe3c86b74e15d5de)(function(metric) {
                    webVitalsPayload['[Amplitude] FCP'] = $5bef2f568ab3d9d1$var$processMetric(metric);
                });
                (0, $128867d9256f5db8$export$7df4b36ecaed99e1)(function(metric) {
                    webVitalsPayload['[Amplitude] INP'] = $5bef2f568ab3d9d1$var$processMetric(metric);
                });
                (0, $128867d9256f5db8$export$a7873055838e5ad8)(function(metric) {
                    webVitalsPayload['[Amplitude] CLS'] = $5bef2f568ab3d9d1$var$processMetric(metric);
                });
                (0, $128867d9256f5db8$export$33a01e6c5f2c7e33)(function(metric) {
                    webVitalsPayload['[Amplitude] TTFB'] = $5bef2f568ab3d9d1$var$processMetric(metric);
                });
                visibilityListener = function() {
                    if (doc.visibilityState === 'hidden' && visibilityListener) {
                        amplitude.track((0, $163900b84e66e5b3$export$a44cad79025b176c), webVitalsPayload);
                        doc.removeEventListener('visibilitychange', visibilityListener);
                        visibilityListener = null;
                    }
                };
                doc.addEventListener('visibilitychange', visibilityListener);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var execute = function(event) {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    event
                ];
            });
        });
    };
    var teardown = function() {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            return (0, $bunH6.__generator)(this, function(_a) {
                if (visibilityListener) /* istanbul ignore next */ doc === null || doc === void 0 || doc.removeEventListener('visibilitychange', visibilityListener);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return {
        name: (0, $163900b84e66e5b3$export$3e69d3882a51f072),
        type: 'enrichment',
        setup: setup,
        execute: execute,
        teardown: teardown
    };
};



var $bunH6 = parcelRequire("bunH6");

var $0b284baadc69656d$export$902ba6ec74c93f9d = function(apiKey, postKey, limit) {
    if (postKey === void 0) postKey = '';
    if (limit === void 0) limit = 10;
    return [
        (0, $c1d7ad7f2bf46bfb$export$34512634d73abf96),
        postKey,
        apiKey.substring(0, limit)
    ].filter(Boolean).join('_');
};



var $5f0c1c7b3cb800cb$export$b96750d084925672 = /** @class */ function() {
    function WebAttribution(options, config) {
        var _a;
        this.shouldTrackNewCampaign = false;
        this.options = (0, $bunH6.__assign)({
            initialEmptyValue: 'EMPTY',
            resetSessionOnNewCampaign: false,
            excludeReferrers: (0, $e73238201900c9b1$export$579a8d2534a703d9)(((_a = config.cookieOptions) === null || _a === void 0 ? void 0 : _a.domain) || config.topLevelDomain),
            optOut: config.optOut
        }, options);
        this.storage = config.cookieStorage;
        this.storageKey = (0, $0b284baadc69656d$export$902ba6ec74c93f9d)(config.apiKey, 'MKTG');
        this.webExpStorageKey = (0, $0b284baadc69656d$export$902ba6ec74c93f9d)(config.apiKey, 'MKTG_ORIGINAL');
        this.currentCampaign = (0, $c1d7ad7f2bf46bfb$export$ea7354d30dfda3a2);
        this.sessionTimeout = config.sessionTimeout;
        this.lastEventTime = config.lastEventTime;
        this.logger = config.loggerProvider;
        this.topLevelDomain = config.topLevelDomain;
        config.loggerProvider.log('Installing web attribution tracking.');
    }
    WebAttribution.prototype.init = function() {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var isEventInNewSession;
            var _a;
            return (0, $bunH6.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        // skip attribution if optOut is true
                        if (this.options.optOut) return [
                            2 /*return*/ 
                        ];
                        return [
                            4 /*yield*/ ,
                            this.fetchCampaign()
                        ];
                    case 1:
                        _a = (0, $bunH6.__read).apply(void 0, [
                            _b.sent(),
                            2
                        ]), this.currentCampaign = _a[0], this.previousCampaign = _a[1];
                        isEventInNewSession = !this.lastEventTime ? true : (0, $1ee910ec69d47307$export$cd75ee83e0e7704a)(this.sessionTimeout, this.lastEventTime);
                        if (!(0, $e73238201900c9b1$export$1c9a583701535c5)(this.currentCampaign, this.previousCampaign, this.options, this.logger, isEventInNewSession, this.topLevelDomain)) return [
                            3 /*break*/ ,
                            3
                        ];
                        this.shouldTrackNewCampaign = true;
                        return [
                            4 /*yield*/ ,
                            this.storage.set(this.storageKey, this.currentCampaign)
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    WebAttribution.prototype.fetchCampaign = function() {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var originalCampaign;
            return (0, $bunH6.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.storage.get(this.webExpStorageKey)
                        ];
                    case 1:
                        originalCampaign = _a.sent();
                        if (!originalCampaign) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.storage.remove(this.webExpStorageKey)
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                originalCampaign || new (0, $23a80041871c3b55$export$6887fc37aa79947c)().parse(),
                                this.storage.get(this.storageKey)
                            ])
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * This can be called when enable web attribution and either
     * 1. set a new session
     * 2. has new campaign and enable resetSessionOnNewCampaign
     */ WebAttribution.prototype.generateCampaignEvent = function(event_id) {
        // Mark this campaign has been tracked
        this.shouldTrackNewCampaign = false;
        var campaignEvent = (0, $e73238201900c9b1$export$d146d450a8c839d2)(this.currentCampaign, this.options);
        if (event_id) campaignEvent.event_id = event_id;
        return campaignEvent;
    };
    WebAttribution.prototype.shouldSetSessionIdOnNewCampaign = function() {
        return this.shouldTrackNewCampaign && !!this.options.resetSessionOnNewCampaign;
    };
    return WebAttribution;
}();





var $bunH6 = parcelRequire("bunH6");

var $c4xZ2 = parcelRequire("c4xZ2");
var $5e067f38bc715f4f$export$a136bf42e11d665e = 'AMP_CURRENT_PAGE';
var $5e067f38bc715f4f$export$863ba1756780b9f2 = 'AMP_PREVIOUS_PAGE';
var $5e067f38bc715f4f$export$2e34e12105c625f7 = 'AMP_URL_INFO';
var $5e067f38bc715f4f$var$PreviousPageType;
(function(PreviousPageType) {
    PreviousPageType["Direct"] = "direct";
    PreviousPageType["Internal"] = "internal";
    PreviousPageType["External"] = "external";
})($5e067f38bc715f4f$var$PreviousPageType || ($5e067f38bc715f4f$var$PreviousPageType = {}));
var $5e067f38bc715f4f$export$a4d91ac1bf074b15 = new Set([
    (0, $b1034e6ea0b84810$export$6221d17ecafe3bf9).IDENTIFY,
    (0, $b1034e6ea0b84810$export$6221d17ecafe3bf9).GROUP_IDENTIFY,
    (0, $b1034e6ea0b84810$export$6221d17ecafe3bf9).REVENUE
]);
var $5e067f38bc715f4f$export$ff6c9a4d8f74be2e = function(option) {
    if (typeof option === 'boolean') return option;
    if (typeof option === 'object' && option !== null && 'pageUrlEnrichment' in option) return Boolean(option.pageUrlEnrichment);
    return false;
};
var $5e067f38bc715f4f$export$bc4e5bafab803a96 = function(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.internalDomains, internalDomains = _c === void 0 ? [] : _c;
    var globalScope = (0, $c4xZ2.getGlobalScope)();
    var sessionStorage = undefined;
    var isStorageEnabled = false;
    var loggerProvider = undefined;
    var isProxied = false;
    var isTracking = false;
    var getHostname = function(url) {
        var hostname;
        try {
            var decodedUrl = (0, $cfec2d180e2010e9$export$c9f67ffc80012d9b)(url, loggerProvider);
            hostname = new URL(decodedUrl).hostname;
        } catch (e) {
            /* istanbul ignore next */ loggerProvider === null || loggerProvider === void 0 || loggerProvider.error('Could not parse URL: ', e);
        }
        return hostname;
    };
    var getPrevPageType = function(previousPage) {
        var currentDomain = typeof location !== 'undefined' && location.hostname || '';
        var previousPageDomain = previousPage ? getHostname(previousPage) : undefined;
        if (!previousPageDomain) return $5e067f38bc715f4f$var$PreviousPageType.Direct;
        var isCurrentInternal = internalDomains.some(function(domain) {
            return currentDomain.indexOf(domain) !== -1;
        });
        var isPrevInternal = internalDomains.some(function(domain) {
            return previousPageDomain.indexOf(domain) !== -1;
        });
        if (currentDomain === previousPageDomain || isPrevInternal && isCurrentInternal) return $5e067f38bc715f4f$var$PreviousPageType.Internal;
        return $5e067f38bc715f4f$var$PreviousPageType.External;
    };
    var saveURLInfo = function() {
        return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
            var URLInfo, currentURL, storedCurrentURL, previousURL;
            var _a;
            return (0, $bunH6.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(sessionStorage && isStorageEnabled)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            sessionStorage.get($5e067f38bc715f4f$export$2e34e12105c625f7)
                        ];
                    case 1:
                        URLInfo = _b.sent();
                        currentURL = (0, $cfec2d180e2010e9$export$c9f67ffc80012d9b)(typeof location !== 'undefined' && location.href || '');
                        storedCurrentURL = (URLInfo === null || URLInfo === void 0 ? void 0 : URLInfo[$5e067f38bc715f4f$export$a136bf42e11d665e]) || '';
                        previousURL = void 0;
                        if (currentURL === storedCurrentURL) previousURL = (URLInfo === null || URLInfo === void 0 ? void 0 : URLInfo[$5e067f38bc715f4f$export$863ba1756780b9f2]) || '';
                        else if (storedCurrentURL) previousURL = storedCurrentURL;
                        else previousURL = document.referrer || '';
                        return [
                            4 /*yield*/ ,
                            sessionStorage.set($5e067f38bc715f4f$export$2e34e12105c625f7, (_a = {}, _a[$5e067f38bc715f4f$export$a136bf42e11d665e] = currentURL, _a[$5e067f38bc715f4f$export$863ba1756780b9f2] = previousURL, _a))
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var saveUrlInfoWrapper = function() {
        saveURLInfo();
    };
    var plugin = {
        name: '@amplitude/plugin-page-url-enrichment-browser',
        type: 'enrichment',
        setup: function(config, _) {
            return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
                return (0, $bunH6.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            loggerProvider = config.loggerProvider;
                            loggerProvider.log('Installing @amplitude/plugin-page-url-enrichment-browser');
                            isTracking = true;
                            if (!globalScope) return [
                                3 /*break*/ ,
                                2
                            ];
                            sessionStorage = new (0, $588c8318ebeb48b5$export$2baa60fa09b100be)(globalScope.sessionStorage);
                            return [
                                4 /*yield*/ ,
                                sessionStorage.isEnabled()
                            ];
                        case 1:
                            isStorageEnabled = _a.sent();
                            globalScope.addEventListener('popstate', saveUrlInfoWrapper);
                            if (!isProxied) {
                                /* istanbul ignore next */ // There is no global browser listener for changes to history, so we have
                                // to modify pushState and replaceState directly.
                                // https://stackoverflow.com/a/64927639
                                // eslint-disable-next-line @typescript-eslint/unbound-method
                                globalScope.history.pushState = new Proxy(globalScope.history.pushState, {
                                    apply: function(target, thisArg, _a) {
                                        var _b = (0, $bunH6.__read)(_a, 3), state = _b[0], unused = _b[1], url = _b[2];
                                        target.apply(thisArg, [
                                            state,
                                            unused,
                                            url
                                        ]);
                                        if (isTracking) saveUrlInfoWrapper();
                                    }
                                });
                                // eslint-disable-next-line @typescript-eslint/unbound-method
                                globalScope.history.replaceState = new Proxy(globalScope.history.replaceState, {
                                    apply: function(target, thisArg, _a) {
                                        var _b = (0, $bunH6.__read)(_a, 3), state = _b[0], unused = _b[1], url = _b[2];
                                        target.apply(thisArg, [
                                            state,
                                            unused,
                                            url
                                        ]);
                                        if (isTracking) saveUrlInfoWrapper();
                                    }
                                });
                                isProxied = true;
                            }
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        },
        execute: function(event) {
            return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
                var locationHREF, URLInfo, updatedURLInfo, previousPage;
                var _a;
                return (0, $bunH6.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            locationHREF = (0, $cfec2d180e2010e9$export$c9f67ffc80012d9b)(typeof location !== 'undefined' && location.href || '');
                            if (!(sessionStorage && isStorageEnabled)) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                sessionStorage.get($5e067f38bc715f4f$export$2e34e12105c625f7)
                            ];
                        case 1:
                            URLInfo = _b.sent();
                            if (!!(URLInfo === null || URLInfo === void 0 ? void 0 : URLInfo[$5e067f38bc715f4f$export$a136bf42e11d665e])) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                sessionStorage.set($5e067f38bc715f4f$export$2e34e12105c625f7, (_a = {}, _a[$5e067f38bc715f4f$export$a136bf42e11d665e] = locationHREF, _a[$5e067f38bc715f4f$export$863ba1756780b9f2] = document.referrer || '', _a))
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            return [
                                4 /*yield*/ ,
                                sessionStorage.get($5e067f38bc715f4f$export$2e34e12105c625f7)
                            ];
                        case 4:
                            updatedURLInfo = _b.sent();
                            previousPage = '';
                            if (updatedURLInfo) previousPage = updatedURLInfo[$5e067f38bc715f4f$export$863ba1756780b9f2] || '';
                            // no need to proceed to add additional properties if the event is one of the default event types to be excluded
                            if ($5e067f38bc715f4f$export$a4d91ac1bf074b15.has(event.event_type)) return [
                                2 /*return*/ ,
                                event
                            ];
                            event.event_properties = (0, $bunH6.__assign)((0, $bunH6.__assign)({}, event.event_properties || {}), {
                                '[Amplitude] Page Domain': $5e067f38bc715f4f$var$addIfNotExist(event, '[Amplitude] Page Domain', typeof location !== 'undefined' && location.hostname || ''),
                                '[Amplitude] Page Location': $5e067f38bc715f4f$var$addIfNotExist(event, '[Amplitude] Page Location', locationHREF),
                                '[Amplitude] Page Path': $5e067f38bc715f4f$var$addIfNotExist(event, '[Amplitude] Page Path', typeof location !== 'undefined' && (0, $cfec2d180e2010e9$export$c9f67ffc80012d9b)(location.pathname) || ''),
                                '[Amplitude] Page Title': $5e067f38bc715f4f$var$addIfNotExist(event, '[Amplitude] Page Title', (0, $d098392c6f9e3beb$export$23286240952da4c9)((0, $d098392c6f9e3beb$export$ca40fe481df670b5))),
                                '[Amplitude] Page URL': $5e067f38bc715f4f$var$addIfNotExist(event, '[Amplitude] Page URL', locationHREF.split('?')[0]),
                                '[Amplitude] Previous Page Location': previousPage,
                                '[Amplitude] Previous Page Type': getPrevPageType(previousPage)
                            });
                            _b.label = 5;
                        case 5:
                            return [
                                2 /*return*/ ,
                                event
                            ];
                    }
                });
            });
        },
        teardown: function() {
            return (0, $bunH6.__awaiter)(void 0, void 0, void 0, function() {
                return (0, $bunH6.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (globalScope) {
                                globalScope.removeEventListener('popstate', saveUrlInfoWrapper);
                                isTracking = false;
                            }
                            if (!(sessionStorage && isStorageEnabled)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                sessionStorage.set($5e067f38bc715f4f$export$2e34e12105c625f7, {})
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }
    };
    return plugin;
};
function $5e067f38bc715f4f$var$addIfNotExist(event, key, value) {
    if (!event.event_properties) event.event_properties = {};
    if (event.event_properties[key] === undefined) return value;
    return event.event_properties[key];
}


var $63a3376a33793c8b$var$UNSPECIFIED_SESSION_ID = -1;
/**
 * Exported for `@amplitude/unified` or integration with blade plugins.
 * If you only use `@amplitude/analytics-browser`, use `amplitude.init()` or `amplitude.createInstance()` instead.
 */ var $63a3376a33793c8b$export$8cd30bdeabfe5a38 = /** @class */ function(_super) {
    (0, $bunH6.__extends)(AmplitudeBrowser, _super);
    function AmplitudeBrowser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Backdoor to set diagnostics sample rate
        // by calling amplitude._setDiagnosticsSampleRate(1); before amplitude.init()
        _this._diagnosticsSampleRate = 0;
        // Backdoor to test request body compression
        // by calling amplitude._enableRequestBodyCompressionExperimental(true); before amplitude.init()
        _this._enableRequestBodyCompressionExperimentalValue = false;
        return _this;
    }
    AmplitudeBrowser.prototype.init = function(apiKey, userIdOrOptions, maybeOptions) {
        if (apiKey === void 0) apiKey = '';
        var userId;
        var options;
        if (arguments.length > 2) {
            userId = userIdOrOptions;
            options = maybeOptions;
        } else if (typeof userIdOrOptions === 'string') {
            userId = userIdOrOptions;
            options = undefined;
        } else {
            userId = userIdOrOptions === null || userIdOrOptions === void 0 ? void 0 : userIdOrOptions.userId;
            options = userIdOrOptions;
        }
        return (0, $31df937edadccc1a$export$a2bf1b09e40c274a)(this._init((0, $bunH6.__assign)((0, $bunH6.__assign)({}, options), {
            userId: userId,
            apiKey: apiKey
        })));
    };
    AmplitudeBrowser.prototype._init = function(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var fetchRemoteConfig, loggerProvider, serverZone, remoteConfigClient, diagnosticsSampleRate, enableDiagnostics, diagnosticsClient, browserOptions, attributionTrackingOptions, queryParams, ampTimestamp, isWithinTimeLimit, querySessionId, deferredSessionId, connector;
            var _this = this;
            return (0, $bunH6.__generator)(this, function(_j) {
                switch(_j.label){
                    case 0:
                        // Step 1: Block concurrent initialization
                        if (this.initializing) return [
                            2 /*return*/ 
                        ];
                        this.initializing = true;
                        fetchRemoteConfig = (0, $e7d6c3ae2e55d0a2$export$c6db7417488fcb50)(options);
                        loggerProvider = (_a = options.loggerProvider) !== null && _a !== void 0 ? _a : new (0, $fb8fead1aae1be82$export$efa9a398d6368992)();
                        if (!options.loggerProvider) loggerProvider.enable((_b = options.logLevel) !== null && _b !== void 0 ? _b : (0, $7740633108eec54d$export$243e62d78d3b544d).Warn);
                        serverZone = (_c = options.serverZone) !== null && _c !== void 0 ? _c : (0, $d2f545e922cce685$export$a07dea27df63211a);
                        diagnosticsSampleRate = this._diagnosticsSampleRate;
                        enableDiagnostics = (_d = options.enableDiagnostics) !== null && _d !== void 0 ? _d : true;
                        if (!fetchRemoteConfig) return [
                            3 /*break*/ ,
                            2
                        ];
                        remoteConfigClient = new (0, $1cfaf5553b3af350$export$c5cb2b5ab8b7eb1a)(options.apiKey, loggerProvider, serverZone, /* istanbul ignore next */ (_e = options.remoteConfig) === null || _e === void 0 ? void 0 : _e.serverUrl);
                        // Fetch diagnostics config first to get sample rate
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve) {
                                // Disable coverage for this line because remote config client will always be defined in this case.
                                // istanbul ignore next
                                remoteConfigClient === null || remoteConfigClient === void 0 || remoteConfigClient.subscribe('configs.diagnostics.browserSDK', 'all', function(remoteConfig, source, lastFetch) {
                                    loggerProvider.debug('Diagnostics remote configuration received:', JSON.stringify({
                                        remoteConfig: remoteConfig,
                                        source: source,
                                        lastFetch: lastFetch
                                    }, null, 2));
                                    if (remoteConfig) {
                                        // Validate and set sampleRate (must be a valid number)
                                        var sampleRate = remoteConfig.sampleRate;
                                        if (typeof sampleRate === 'number' && !isNaN(sampleRate)) diagnosticsSampleRate = sampleRate;
                                        // Validate and set enabled (must be a boolean)
                                        var enabled = remoteConfig.enabled;
                                        if (typeof enabled === 'boolean') enableDiagnostics = enabled;
                                    }
                                    resolve();
                                });
                            })
                        ];
                    case 1:
                        // Fetch diagnostics config first to get sample rate
                        _j.sent();
                        _j.label = 2;
                    case 2:
                        diagnosticsClient = new (0, $a7573bf6dddd990a$export$ab01d4540335bf2a)(options.apiKey, loggerProvider, serverZone, {
                            enabled: enableDiagnostics,
                            sampleRate: diagnosticsSampleRate
                        });
                        diagnosticsClient.setTag('library', "".concat((0, $c1e7cd9d77dd64a3$export$cf504a7bb41ef3ce), "/").concat((0, $01a0eb29ad2e7237$export$a4ad2735b021c132)));
                        if (typeof navigator !== 'undefined') diagnosticsClient.setTag('user_agent', navigator.userAgent);
                        return [
                            4 /*yield*/ ,
                            (0, $e7d6c3ae2e55d0a2$export$4e33c75a470874a8)(options.apiKey, options, this, diagnosticsClient, {
                                loggerProvider: loggerProvider,
                                serverZone: serverZone,
                                enableDiagnostics: enableDiagnostics,
                                diagnosticsSampleRate: diagnosticsSampleRate
                            })
                        ];
                    case 3:
                        browserOptions = _j.sent();
                        if (!(fetchRemoteConfig && remoteConfigClient)) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve) {
                                // Disable coverage for this line because remote config client will always be defined in this case.
                                // istanbul ignore next
                                remoteConfigClient === null || remoteConfigClient === void 0 || remoteConfigClient.subscribe('configs.analyticsSDK.browserSDK', 'all', function(remoteConfig, source, lastFetch) {
                                    browserOptions.loggerProvider.debug('Remote configuration received:', JSON.stringify({
                                        remoteConfig: remoteConfig,
                                        source: source,
                                        lastFetch: lastFetch
                                    }, null, 2));
                                    if (remoteConfig) (0, $ead06c3906638f9a$export$6385ab2d18f0ca55)(remoteConfig, browserOptions);
                                    // Resolve the promise on first callback (initial config)
                                    resolve();
                                });
                            })
                        ];
                    case 4:
                        _j.sent();
                        _j.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _super.prototype._init.call(this, browserOptions)
                        ];
                    case 6:
                        _j.sent();
                        this.logBrowserOptions(browserOptions);
                        this.config.remoteConfigClient = remoteConfigClient;
                        if (!(0, $d81f8d7bf36b1bca$export$d20b42d02fe617b9)(this.config.defaultTracking)) return [
                            3 /*break*/ ,
                            8
                        ];
                        if (this.config.optOut) this.timeline.addOptOutListener(function(optOut) {
                            return (0, $bunH6.__awaiter)(_this, void 0, void 0, function() {
                                var attributionTrackingOptions_1;
                                return (0, $bunH6.__generator)(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            if (!!optOut) return [
                                                3 /*break*/ ,
                                                2
                                            ];
                                            attributionTrackingOptions_1 = (0, $d81f8d7bf36b1bca$export$4048df75bcf826ca)(this.config);
                                            this.webAttribution = new (0, $5f0c1c7b3cb800cb$export$b96750d084925672)(attributionTrackingOptions_1, this.config);
                                            return [
                                                4 /*yield*/ ,
                                                this.webAttribution.init()
                                            ];
                                        case 1:
                                            _a.sent();
                                            _a.label = 2;
                                        case 2:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        });
                        attributionTrackingOptions = (0, $d81f8d7bf36b1bca$export$4048df75bcf826ca)(this.config);
                        this.webAttribution = new (0, $5f0c1c7b3cb800cb$export$b96750d084925672)(attributionTrackingOptions, this.config);
                        // Fetch the current campaign, check if need to track web attribution later
                        return [
                            4 /*yield*/ ,
                            this.webAttribution.init()
                        ];
                    case 7:
                        // Fetch the current campaign, check if need to track web attribution later
                        _j.sent();
                        _j.label = 8;
                    case 8:
                        queryParams = (0, $12451edd1666d93e$export$e2de15bbd9edf9c6)();
                        ampTimestamp = queryParams.ampTimestamp ? Number(queryParams.ampTimestamp) : undefined;
                        isWithinTimeLimit = ampTimestamp ? Date.now() < ampTimestamp : true;
                        querySessionId = isWithinTimeLimit && !Number.isNaN(Number(queryParams.ampSessionId)) ? Number(queryParams.ampSessionId) : undefined;
                        deferredSessionId = this.config.deferredSessionId;
                        if (deferredSessionId === $63a3376a33793c8b$var$UNSPECIFIED_SESSION_ID && !this.config.optOut) deferredSessionId = Date.now();
                        this.setSessionId((_h = (_g = (_f = options.sessionId) !== null && _f !== void 0 ? _f : querySessionId) !== null && _g !== void 0 ? _g : deferredSessionId) !== null && _h !== void 0 ? _h : this.config.sessionId);
                        if (this.config.optOut) this.timeline.addOptOutListener(function(optOut) {
                            return (0, $bunH6.__awaiter)(_this, void 0, void 0, function() {
                                return (0, $bunH6.__generator)(this, function(_a) {
                                    if (!optOut && this.config.deferredSessionId) {
                                        if (this.config.deferredSessionId === $63a3376a33793c8b$var$UNSPECIFIED_SESSION_ID) this.setSessionId(undefined);
                                        else this.setSessionId(this.config.deferredSessionId);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        });
                        connector = (0, $7aedaea4df5fb4c3$export$4e27b19f1b537bc2)(options.instanceName);
                        connector.identityStore.setIdentity({
                            userId: this.config.userId,
                            deviceId: this.config.deviceId
                        });
                        if (!(this.config.offline !== (0, $aba2f99b3693f7da$export$92e9c636606b8eed))) return [
                            3 /*break*/ ,
                            10
                        ];
                        return [
                            4 /*yield*/ ,
                            this.add((0, $6c63ab46c1de032c$export$20326a3f5f1d9791)()).promise
                        ];
                    case 9:
                        _j.sent();
                        _j.label = 10;
                    case 10:
                        return [
                            4 /*yield*/ ,
                            this.add(new (0, $92857655ea49016b$export$5c4bdf44e1e9cea1)({
                                diagnosticsClient: diagnosticsClient
                            })).promise
                        ];
                    case 11:
                        _j.sent();
                        return [
                            4 /*yield*/ ,
                            this.add(new (0, $5ebaf3e7c6cf42a0$export$841858b892ce1f4c)()).promise
                        ];
                    case 12:
                        _j.sent();
                        return [
                            4 /*yield*/ ,
                            this.add(new (0, $4d6ea4faec842874$export$1a68292eb68beee1)()).promise
                        ];
                    case 13:
                        _j.sent();
                        // Notify if DET is enabled
                        (0, $0f671a966d8ee698$export$baa23c8b1e397239)(this.config);
                        if (!(0, $d81f8d7bf36b1bca$export$439965f940d78a9)(this.config.defaultTracking)) return [
                            3 /*break*/ ,
                            15
                        ];
                        this.config.loggerProvider.debug('Adding file download tracking plugin');
                        return [
                            4 /*yield*/ ,
                            this.add((0, $91b9c203c48726f0$export$25832376988a00f6)()).promise
                        ];
                    case 14:
                        _j.sent();
                        _j.label = 15;
                    case 15:
                        if (!(0, $d81f8d7bf36b1bca$export$affa82d896586aa0)(this.config.defaultTracking)) return [
                            3 /*break*/ ,
                            17
                        ];
                        this.config.loggerProvider.debug('Adding form interaction plugin');
                        return [
                            4 /*yield*/ ,
                            this.add((0, $6f4d95918d190882$export$9860fa124eec1ec4)()).promise
                        ];
                    case 16:
                        _j.sent();
                        _j.label = 17;
                    case 17:
                        if (!(0, $d81f8d7bf36b1bca$export$b6f98464b3039a53)(this.config.defaultTracking)) return [
                            3 /*break*/ ,
                            20
                        ];
                        if (!!this.config.optOut) return [
                            3 /*break*/ ,
                            19
                        ];
                        this.config.loggerProvider.debug('Adding page view tracking plugin');
                        return [
                            4 /*yield*/ ,
                            this.add((0, $d655f70c9190fddd$export$a3128c6802358466)((0, $d81f8d7bf36b1bca$export$12e70b7a43554816)(this.config))).promise
                        ];
                    case 18:
                        _j.sent();
                        return [
                            3 /*break*/ ,
                            20
                        ];
                    case 19:
                        this.timeline.addOptOutListener(function(optOut) {
                            return (0, $bunH6.__awaiter)(_this, void 0, void 0, function() {
                                return (0, $bunH6.__generator)(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            /* istanbul ignore if */ if (optOut) return [
                                                2 /*return*/ 
                                            ];
                                            this.config.loggerProvider.debug('Adding page view tracking plugin');
                                            return [
                                                4 /*yield*/ ,
                                                this.add((0, $d655f70c9190fddd$export$a3128c6802358466)((0, $d81f8d7bf36b1bca$export$12e70b7a43554816)(this.config))).promise
                                            ];
                                        case 1:
                                            _a.sent();
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        });
                        _j.label = 20;
                    case 20:
                        if (!(0, $d81f8d7bf36b1bca$export$61bfa9a947732d3c)(this.config.autocapture)) return [
                            3 /*break*/ ,
                            22
                        ];
                        this.config.loggerProvider.debug('Adding user interactions plugin (autocapture plugin)');
                        return [
                            4 /*yield*/ ,
                            this.add((0, $899c6c1762774565$export$cd485554bb3f53da)((0, $d81f8d7bf36b1bca$export$a6ad12940a2ffeac)(this.config), {
                                diagnosticsClient: diagnosticsClient
                            })).promise
                        ];
                    case 21:
                        _j.sent();
                        _j.label = 22;
                    case 22:
                        if (!(0, $d81f8d7bf36b1bca$export$29e2986f1d1dc443)(this.config.autocapture)) return [
                            3 /*break*/ ,
                            24
                        ];
                        this.config.loggerProvider.debug('Adding frustration interactions plugin');
                        return [
                            4 /*yield*/ ,
                            this.add((0, $f6baf092693c7b93$export$d4accb1f65d780)((0, $d81f8d7bf36b1bca$export$45f20628c2a4aad3)(this.config))).promise
                        ];
                    case 23:
                        _j.sent();
                        _j.label = 24;
                    case 24:
                        if (!(0, $d81f8d7bf36b1bca$export$5665ccdd71d94227)(this.config.autocapture)) return [
                            3 /*break*/ ,
                            26
                        ];
                        this.config.loggerProvider.debug('Adding network tracking plugin');
                        return [
                            4 /*yield*/ ,
                            this.add((0, $1608e7888a92f594$export$73cfddfb0e93383e)((0, $d81f8d7bf36b1bca$export$73c26cfb4505ddfc)(this.config))).promise
                        ];
                    case 25:
                        _j.sent();
                        _j.label = 26;
                    case 26:
                        if (!(0, $d81f8d7bf36b1bca$export$75d23e835a5fbff1)(this.config.autocapture)) return [
                            3 /*break*/ ,
                            28
                        ];
                        this.config.loggerProvider.debug('Adding web vitals plugin');
                        return [
                            4 /*yield*/ ,
                            this.add((0, $5bef2f568ab3d9d1$export$aa465eaf220de4d)()).promise
                        ];
                    case 27:
                        _j.sent();
                        _j.label = 28;
                    case 28:
                        if (!(0, $d81f8d7bf36b1bca$export$ff6c9a4d8f74be2e)(this.config.autocapture)) return [
                            3 /*break*/ ,
                            30
                        ];
                        this.config.loggerProvider.debug('Adding referrer page url plugin');
                        return [
                            4 /*yield*/ ,
                            this.add((0, $5e067f38bc715f4f$export$bc4e5bafab803a96)()).promise
                        ];
                    case 29:
                        _j.sent();
                        _j.label = 30;
                    case 30:
                        this.initializing = false;
                        // Step 6: Run queued dispatch functions
                        return [
                            4 /*yield*/ ,
                            this.runQueuedFunctions('dispatchQ')
                        ];
                    case 31:
                        // Step 6: Run queued dispatch functions
                        _j.sent();
                        // Step 7: Add the event receiver after running remaining queued functions.
                        connector.eventBridge.setEventReceiver(function(event) {
                            var _a = event.eventProperties || {}, time = _a.time, cleanEventProperties = (0, $bunH6.__rest)(_a, [
                                "time"
                            ]);
                            var eventOptions = typeof time === 'number' ? {
                                time: time
                            } : undefined;
                            _this.track(event.eventType, cleanEventProperties, eventOptions);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AmplitudeBrowser.prototype.getUserId = function() {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.userId;
    };
    AmplitudeBrowser.prototype.setUserId = function(userId) {
        if (!this.config) {
            this.q.push(this.setUserId.bind(this, userId));
            return;
        }
        this.config.loggerProvider.debug('function setUserId: ', userId);
        if (userId !== this.config.userId || userId === undefined) {
            this.config.userId = userId;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            this.timeline.onIdentityChanged({
                userId: userId
            });
            (0, $7aedaea4df5fb4c3$export$ae185dd9f76bc0ec)(userId, this.config.instanceName);
        }
    };
    AmplitudeBrowser.prototype.getDeviceId = function() {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.deviceId;
    };
    AmplitudeBrowser.prototype.setDeviceId = function(deviceId) {
        if (!this.config) {
            this.q.push(this.setDeviceId.bind(this, deviceId));
            return;
        }
        this.config.loggerProvider.debug('function setDeviceId: ', deviceId);
        if (deviceId !== this.config.deviceId) {
            this.config.deviceId = deviceId;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            this.timeline.onIdentityChanged({
                deviceId: deviceId
            });
            (0, $7aedaea4df5fb4c3$export$2bf3e8de34602369)(deviceId, this.config.instanceName);
        }
    };
    AmplitudeBrowser.prototype.reset = function() {
        this.setDeviceId((0, $b8d06392fac4718b$export$bc35efed93511c4b)());
        this.setUserId(undefined);
        this.timeline.onReset();
    };
    AmplitudeBrowser.prototype.getIdentity = function() {
        var _a, _b;
        return {
            deviceId: (_a = this.config) === null || _a === void 0 ? void 0 : _a.deviceId,
            userId: (_b = this.config) === null || _b === void 0 ? void 0 : _b.userId,
            userProperties: this.userProperties
        };
    };
    AmplitudeBrowser.prototype.setIdentity = function(identity) {
        var e_1, _a;
        var _b;
        // Handle userId change
        if ('userId' in identity) this.setUserId(identity.userId);
        // Handle deviceId change
        if ('deviceId' in identity && identity.deviceId) this.setDeviceId(identity.deviceId);
        // Handle userProperties change - auto-send identify
        if ('userProperties' in identity) {
            this.userProperties = identity.userProperties;
            // Auto-send identify event with $set operations
            var identifyObj = new (0, $643b81d8570b18c7$export$e513146db6535bff)();
            // istanbul ignore next
            var userProperties = (_b = identity.userProperties) !== null && _b !== void 0 ? _b : {};
            try {
                for(var _c = (0, $bunH6.__values)(Object.entries(userProperties)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var _e = (0, $bunH6.__read)(_d.value, 2), key = _e[0], value = _e[1];
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                    identifyObj.set(key, value);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // The identify event processing in core-client already calls onIdentityChanged,
            // so we don't need to call it explicitly here to avoid duplicate notifications.
            this.identify(identifyObj);
        }
    };
    AmplitudeBrowser.prototype.getOptOut = function() {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.optOut;
    };
    AmplitudeBrowser.prototype.getSessionId = function() {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.sessionId;
    };
    AmplitudeBrowser.prototype.setSessionId = function(sessionId) {
        var _a;
        var promises = [];
        if (!this.config) {
            this.q.push(this.setSessionId.bind(this, sessionId));
            return (0, $31df937edadccc1a$export$a2bf1b09e40c274a)(Promise.resolve());
        }
        // do not start a new session if optOut is true
        if (this.config.optOut) {
            // save the sessionId to storage to be used when optOut is false
            this.config.deferredSessionId = sessionId !== null && sessionId !== void 0 ? sessionId : $63a3376a33793c8b$var$UNSPECIFIED_SESSION_ID;
            return (0, $31df937edadccc1a$export$a2bf1b09e40c274a)(Promise.resolve());
        }
        // default sessionId to current time
        if (sessionId === undefined) sessionId = Date.now();
        // Prevents starting a new session with the same session ID
        if (sessionId === this.config.sessionId) return (0, $31df937edadccc1a$export$a2bf1b09e40c274a)(Promise.resolve());
        this.config.loggerProvider.debug('function setSessionId: ', sessionId);
        var previousSessionId = this.getSessionId();
        if (previousSessionId !== sessionId) // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        this.timeline.onSessionIdChanged(sessionId);
        var lastEventTime = this.config.lastEventTime;
        var lastEventId = (_a = this.config.lastEventId) !== null && _a !== void 0 ? _a : -1;
        this.config.sessionId = sessionId;
        this.config.lastEventTime = undefined;
        this.config.pageCounter = 0;
        if ((0, $d81f8d7bf36b1bca$export$39cec01e4b71f7d6)(this.config.defaultTracking)) {
            if (previousSessionId && lastEventTime) promises.push(this.track((0, $d2f545e922cce685$export$406b0196920039c5), undefined, {
                device_id: this.previousSessionDeviceId,
                event_id: ++lastEventId,
                session_id: previousSessionId,
                time: lastEventTime + 1,
                user_id: this.previousSessionUserId
            }).promise);
            this.config.lastEventTime = this.config.sessionId;
        }
        // Fire web attribution event when enable webAttribution tracking
        // 1. has new campaign (call setSessionId from init function)
        // 2. or shouldTrackNewCampaign (call setSessionId from async process(event) when there has new campaign and resetSessionOnNewCampaign = true )
        var isCampaignEventTracked = this.trackCampaignEventIfNeeded(++lastEventId, promises);
        // track the identify event if an Identify object is provided in the config
        if (this.config.identify) promises.push(this.track((0, $eba8dfa6a039f14d$export$5de4f5c2c4d8645f)(this.config.identify)).promise);
        if ((0, $d81f8d7bf36b1bca$export$39cec01e4b71f7d6)(this.config.defaultTracking)) promises.push(this.track((0, $d2f545e922cce685$export$c7d032b40f04ffe5), undefined, {
            event_id: isCampaignEventTracked ? ++lastEventId : lastEventId,
            session_id: this.config.sessionId,
            time: this.config.lastEventTime
        }).promise);
        this.previousSessionDeviceId = this.config.deviceId;
        this.previousSessionUserId = this.config.userId;
        return (0, $31df937edadccc1a$export$a2bf1b09e40c274a)(Promise.all(promises));
    };
    AmplitudeBrowser.prototype.extendSession = function() {
        if (!this.config) {
            this.q.push(this.extendSession.bind(this));
            return;
        }
        this.config.lastEventTime = Date.now();
    };
    AmplitudeBrowser.prototype.setTransport = function(transport) {
        if (!this.config) {
            this.q.push(this.setTransport.bind(this, transport));
            return;
        }
        this.config.transportProvider = (0, $e7d6c3ae2e55d0a2$export$d09f50d9ab7f7b69)(transport);
    };
    AmplitudeBrowser.prototype.identify = function(identify, eventOptions) {
        if ((0, $cec89fb4b175ee3b$export$cca5e90941913a5a)(identify)) {
            var queue = identify._q;
            identify._q = [];
            identify = (0, $cec89fb4b175ee3b$export$2804ceeb41243ddf)(new (0, $643b81d8570b18c7$export$e513146db6535bff)(), queue);
        }
        if (eventOptions === null || eventOptions === void 0 ? void 0 : eventOptions.user_id) this.setUserId(eventOptions.user_id);
        if (eventOptions === null || eventOptions === void 0 ? void 0 : eventOptions.device_id) this.setDeviceId(eventOptions.device_id);
        return _super.prototype.identify.call(this, identify, eventOptions);
    };
    AmplitudeBrowser.prototype.groupIdentify = function(groupType, groupName, identify, eventOptions) {
        if ((0, $cec89fb4b175ee3b$export$cca5e90941913a5a)(identify)) {
            var queue = identify._q;
            identify._q = [];
            identify = (0, $cec89fb4b175ee3b$export$2804ceeb41243ddf)(new (0, $643b81d8570b18c7$export$e513146db6535bff)(), queue);
        }
        return _super.prototype.groupIdentify.call(this, groupType, groupName, identify, eventOptions);
    };
    AmplitudeBrowser.prototype.revenue = function(revenue, eventOptions) {
        if ((0, $cec89fb4b175ee3b$export$cca5e90941913a5a)(revenue)) {
            var queue = revenue._q;
            revenue._q = [];
            revenue = (0, $cec89fb4b175ee3b$export$2804ceeb41243ddf)(new (0, $de0ca8ba746429f4$export$5c685df9b6b94d82)(), queue);
        }
        return _super.prototype.revenue.call(this, revenue, eventOptions);
    };
    AmplitudeBrowser.prototype.trackCampaignEventIfNeeded = function(lastEventId, promises) {
        if (!this.webAttribution || !this.webAttribution.shouldTrackNewCampaign) return false;
        var campaignEvent = this.webAttribution.generateCampaignEvent(lastEventId);
        if (promises) promises.push(this.track(campaignEvent).promise);
        else this.track(campaignEvent);
        this.config.loggerProvider.log('Tracking attribution.');
        return true;
    };
    AmplitudeBrowser.prototype.process = function(event) {
        return (0, $bunH6.__awaiter)(this, void 0, void 0, function() {
            var currentTime, isEventInNewSession, shouldSetSessionIdOnNewCampaign;
            return (0, $bunH6.__generator)(this, function(_a) {
                currentTime = Date.now();
                isEventInNewSession = (0, $1ee910ec69d47307$export$cd75ee83e0e7704a)(this.config.sessionTimeout, this.config.lastEventTime);
                shouldSetSessionIdOnNewCampaign = this.webAttribution && this.webAttribution.shouldSetSessionIdOnNewCampaign();
                if (event.event_type !== (0, $d2f545e922cce685$export$c7d032b40f04ffe5) && event.event_type !== (0, $d2f545e922cce685$export$406b0196920039c5) && (!event.session_id || event.session_id === this.getSessionId())) {
                    if (isEventInNewSession || shouldSetSessionIdOnNewCampaign) {
                        this.setSessionId(currentTime);
                        if (shouldSetSessionIdOnNewCampaign) this.config.loggerProvider.log('Created a new session for new campaign.');
                    } else if (!isEventInNewSession) // Web attribution should be tracked during the middle of a session
                    // if there has been a chance in the campaign information.
                    this.trackCampaignEventIfNeeded();
                }
                return [
                    2 /*return*/ ,
                    _super.prototype.process.call(this, event)
                ];
            });
        });
    };
    AmplitudeBrowser.prototype.logBrowserOptions = function(browserConfig) {
        try {
            var browserConfigCopy = (0, $bunH6.__assign)((0, $bunH6.__assign)({}, browserConfig), {
                apiKey: browserConfig.apiKey.substring(0, 10) + '********'
            });
            this.config.loggerProvider.debug('Initialized Amplitude with BrowserConfig:', (0, $d6956fea7d3d8743$export$abc3f407e87918a4)(browserConfigCopy));
        } catch (e) {
            /* istanbul ignore next */ this.config.loggerProvider.error('Error logging browser config', e);
        }
    };
    /**
     * @experimental
     * WARNING: This method is for internal testing only and is not part of the public API.
     * It may be changed or removed at any time without notice.
     *
     * Sets the diagnostics sample rate before amplitude.init()
     * @param sampleRate - The sample rate to set
     */ AmplitudeBrowser.prototype._setDiagnosticsSampleRate = function(sampleRate) {
        if (sampleRate > 1 || sampleRate < 0) return;
        // Set diagnostics sample rate before initializing the config
        if (!this.config) {
            this._diagnosticsSampleRate = sampleRate;
            return;
        }
    };
    /**
     * @experimental
     * WARNING: This method is for internal testing only and is not part of the public API.
     * It may be changed or removed at any time without notice.
     */ AmplitudeBrowser.prototype._enableRequestBodyCompressionExperimental = function(enabled) {
        // Set request body compression experimental config before initializing the config
        if (!this.config) {
            this._enableRequestBodyCompressionExperimentalValue = enabled;
            return;
        }
    };
    return AmplitudeBrowser;
}((0, $d4da969092b6408b$export$ca16f9ebcb935ab8));


var $c0dc101e77e41871$export$99152e8d49ca4e7d = function() {
    var client = new (0, $63a3376a33793c8b$export$8cd30bdeabfe5a38)();
    return {
        init: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.init.bind(client), 'init', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config'
        ])),
        add: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.add.bind(client), 'add', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config.apiKey',
            'timeline.plugins'
        ])),
        remove: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.remove.bind(client), 'remove', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config.apiKey',
            'timeline.plugins'
        ])),
        track: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.track.bind(client), 'track', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        logEvent: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.logEvent.bind(client), 'logEvent', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        identify: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.identify.bind(client), 'identify', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        groupIdentify: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.groupIdentify.bind(client), 'groupIdentify', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        setGroup: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.setGroup.bind(client), 'setGroup', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        revenue: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.revenue.bind(client), 'revenue', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        flush: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.flush.bind(client), 'flush', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        getUserId: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.getUserId.bind(client), 'getUserId', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config',
            'config.userId'
        ])),
        setUserId: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.setUserId.bind(client), 'setUserId', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config',
            'config.userId'
        ])),
        getDeviceId: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.getDeviceId.bind(client), 'getDeviceId', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config',
            'config.deviceId'
        ])),
        setDeviceId: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.setDeviceId.bind(client), 'setDeviceId', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config',
            'config.deviceId'
        ])),
        reset: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.reset.bind(client), 'reset', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config',
            'config.userId',
            'config.deviceId'
        ])),
        getSessionId: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.getSessionId.bind(client), 'getSessionId', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config'
        ])),
        setSessionId: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.setSessionId.bind(client), 'setSessionId', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config'
        ])),
        extendSession: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.extendSession.bind(client), 'extendSession', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config'
        ])),
        setOptOut: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.setOptOut.bind(client), 'setOptOut', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config'
        ])),
        setTransport: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.setTransport.bind(client), 'setTransport', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config'
        ])),
        getIdentity: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.getIdentity.bind(client), 'getIdentity', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config'
        ])),
        setIdentity: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.setIdentity.bind(client), 'setIdentity', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config',
            'config.userId',
            'config.deviceId'
        ])),
        getOptOut: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client.getOptOut.bind(client), 'getOptOut', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config'
        ])),
        _setDiagnosticsSampleRate: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client._setDiagnosticsSampleRate.bind(client), '_setDiagnosticsSampleRate', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config'
        ])),
        _enableRequestBodyCompressionExperimental: (0, $18f2db3fc8eec36d$export$bd4b394e2747b144)(client._enableRequestBodyCompressionExperimental.bind(client), '_enableRequestBodyCompressionExperimental', (0, $18f2db3fc8eec36d$export$c24a266b7d0d4b26)(client), (0, $18f2db3fc8eec36d$export$f4ba9ca2e79d2ae9)(client, [
            'config'
        ]))
    };
};
var $c0dc101e77e41871$export$2e2bcd8739ae039 = $c0dc101e77e41871$export$99152e8d49ca4e7d();






var $0d3747952a05ae22$export$e16d8520af44a096 = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).add, $0d3747952a05ae22$export$d0caa90bfa1dd141 = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).extendSession, $0d3747952a05ae22$export$4909b86c8034bf73 = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).flush, $0d3747952a05ae22$export$be262d700bd1c696 = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).getDeviceId, $0d3747952a05ae22$export$7d748212e7916c80 = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).getIdentity, $0d3747952a05ae22$export$14698eb649254485 = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).getOptOut, $0d3747952a05ae22$export$b3739caaf2580dd = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).getSessionId, $0d3747952a05ae22$export$1617268687ac763c = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).getUserId, $0d3747952a05ae22$export$30c344c0d9bb2256 = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).groupIdentify, $0d3747952a05ae22$export$65e5b62a4c490288 = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).identify, $0d3747952a05ae22$export$2cd8252107eb640b = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).init, $0d3747952a05ae22$export$5e9eec8001665ac5 = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).logEvent, $0d3747952a05ae22$export$cd7f480d6b8286c3 = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).remove, $0d3747952a05ae22$export$aad8462122ac592b = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).reset, $0d3747952a05ae22$export$7ebe0b98fc7db7a6 = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).revenue, $0d3747952a05ae22$export$674c05fa57e365a9 = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).setDeviceId, $0d3747952a05ae22$export$ba2d2608914eca73 = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).setGroup, $0d3747952a05ae22$export$b584415bd69b298f = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).setIdentity, $0d3747952a05ae22$export$74da29a5c7fe4c = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).setOptOut, $0d3747952a05ae22$export$f61b5f0b88be99b3 = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).setSessionId, $0d3747952a05ae22$export$877a0c8f77379bff = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).setTransport, $0d3747952a05ae22$export$7f5abdb7f5093137 = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).setUserId, $0d3747952a05ae22$export$6b2a7d5132615086 = (0, $c0dc101e77e41871$export$2e2bcd8739ae039).track, $0d3747952a05ae22$export$9ead6b7adacb63e3 = (0, $c0dc101e77e41871$export$2e2bcd8739ae039)._setDiagnosticsSampleRate, $0d3747952a05ae22$export$a44d0a22b1398f25 = (0, $c0dc101e77e41871$export$2e2bcd8739ae039)._enableRequestBodyCompressionExperimental;



var $28UcW = parcelRequire("28UcW");
'use strict';
function $fd5c8f41aff14f01$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $0f8cc6205e174f50$var$toString } = Object.prototype;
const { getPrototypeOf: $0f8cc6205e174f50$var$getPrototypeOf } = Object;
const $0f8cc6205e174f50$var$kindOf = ((cache)=>(thing)=>{
        const str = $0f8cc6205e174f50$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $0f8cc6205e174f50$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$0f8cc6205e174f50$var$kindOf(thing) === type;
};
const $0f8cc6205e174f50$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $0f8cc6205e174f50$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $0f8cc6205e174f50$var$isUndefined = $0f8cc6205e174f50$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $0f8cc6205e174f50$var$isBuffer(val) {
    return val !== null && !$0f8cc6205e174f50$var$isUndefined(val) && val.constructor !== null && !$0f8cc6205e174f50$var$isUndefined(val.constructor) && $0f8cc6205e174f50$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $0f8cc6205e174f50$var$isArrayBuffer = $0f8cc6205e174f50$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $0f8cc6205e174f50$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $0f8cc6205e174f50$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $0f8cc6205e174f50$var$isString = $0f8cc6205e174f50$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $0f8cc6205e174f50$var$isFunction = $0f8cc6205e174f50$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $0f8cc6205e174f50$var$isNumber = $0f8cc6205e174f50$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $0f8cc6205e174f50$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $0f8cc6205e174f50$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $0f8cc6205e174f50$var$isPlainObject = (val)=>{
    if ($0f8cc6205e174f50$var$kindOf(val) !== 'object') return false;
    const prototype = $0f8cc6205e174f50$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $0f8cc6205e174f50$var$isDate = $0f8cc6205e174f50$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $0f8cc6205e174f50$var$isFile = $0f8cc6205e174f50$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $0f8cc6205e174f50$var$isBlob = $0f8cc6205e174f50$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $0f8cc6205e174f50$var$isFileList = $0f8cc6205e174f50$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $0f8cc6205e174f50$var$isStream = (val)=>$0f8cc6205e174f50$var$isObject(val) && $0f8cc6205e174f50$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $0f8cc6205e174f50$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $0f8cc6205e174f50$var$isFunction(thing.append) && ((kind = $0f8cc6205e174f50$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $0f8cc6205e174f50$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $0f8cc6205e174f50$var$isURLSearchParams = $0f8cc6205e174f50$var$kindOfTest('URLSearchParams');
const [$0f8cc6205e174f50$var$isReadableStream, $0f8cc6205e174f50$var$isRequest, $0f8cc6205e174f50$var$isResponse, $0f8cc6205e174f50$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($0f8cc6205e174f50$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $0f8cc6205e174f50$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $0f8cc6205e174f50$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($0f8cc6205e174f50$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $0f8cc6205e174f50$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $0f8cc6205e174f50$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $0f8cc6205e174f50$var$isContextDefined = (context)=>!$0f8cc6205e174f50$var$isUndefined(context) && context !== $0f8cc6205e174f50$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $0f8cc6205e174f50$var$merge() {
    const { caseless: caseless } = $0f8cc6205e174f50$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $0f8cc6205e174f50$var$findKey(result, key) || key;
        if ($0f8cc6205e174f50$var$isPlainObject(result[targetKey]) && $0f8cc6205e174f50$var$isPlainObject(val)) result[targetKey] = $0f8cc6205e174f50$var$merge(result[targetKey], val);
        else if ($0f8cc6205e174f50$var$isPlainObject(val)) result[targetKey] = $0f8cc6205e174f50$var$merge({}, val);
        else if ($0f8cc6205e174f50$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $0f8cc6205e174f50$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $0f8cc6205e174f50$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $0f8cc6205e174f50$var$forEach(b, (val, key)=>{
        if (thisArg && $0f8cc6205e174f50$var$isFunction(val)) a[key] = (0, $fd5c8f41aff14f01$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $0f8cc6205e174f50$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $0f8cc6205e174f50$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $0f8cc6205e174f50$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $0f8cc6205e174f50$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $0f8cc6205e174f50$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $0f8cc6205e174f50$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($0f8cc6205e174f50$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$0f8cc6205e174f50$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $0f8cc6205e174f50$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $0f8cc6205e174f50$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $0f8cc6205e174f50$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $0f8cc6205e174f50$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $0f8cc6205e174f50$var$isHTMLForm = $0f8cc6205e174f50$var$kindOfTest('HTMLFormElement');
const $0f8cc6205e174f50$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $0f8cc6205e174f50$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $0f8cc6205e174f50$var$isRegExp = $0f8cc6205e174f50$var$kindOfTest('RegExp');
const $0f8cc6205e174f50$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $0f8cc6205e174f50$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $0f8cc6205e174f50$var$freezeMethods = (obj)=>{
    $0f8cc6205e174f50$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($0f8cc6205e174f50$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$0f8cc6205e174f50$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $0f8cc6205e174f50$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $0f8cc6205e174f50$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $0f8cc6205e174f50$var$noop = ()=>{};
const $0f8cc6205e174f50$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $0f8cc6205e174f50$var$ALPHA = 'abcdefghijklmnopqrstuvwxyz';
const $0f8cc6205e174f50$var$DIGIT = '0123456789';
const $0f8cc6205e174f50$var$ALPHABET = {
    DIGIT: $0f8cc6205e174f50$var$DIGIT,
    ALPHA: $0f8cc6205e174f50$var$ALPHA,
    ALPHA_DIGIT: $0f8cc6205e174f50$var$ALPHA + $0f8cc6205e174f50$var$ALPHA.toUpperCase() + $0f8cc6205e174f50$var$DIGIT
};
const $0f8cc6205e174f50$var$generateString = (size = 16, alphabet = $0f8cc6205e174f50$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = '';
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $0f8cc6205e174f50$var$isSpecCompliantForm(thing) {
    return !!(thing && $0f8cc6205e174f50$var$isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
const $0f8cc6205e174f50$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($0f8cc6205e174f50$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $0f8cc6205e174f50$var$isArray(source) ? [] : {};
                $0f8cc6205e174f50$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$0f8cc6205e174f50$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $0f8cc6205e174f50$var$isAsyncFn = $0f8cc6205e174f50$var$kindOfTest('AsyncFunction');
const $0f8cc6205e174f50$var$isThenable = (thing)=>thing && ($0f8cc6205e174f50$var$isObject(thing) || $0f8cc6205e174f50$var$isFunction(thing)) && $0f8cc6205e174f50$var$isFunction(thing.then) && $0f8cc6205e174f50$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $0f8cc6205e174f50$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $0f8cc6205e174f50$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $0f8cc6205e174f50$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $0f8cc6205e174f50$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $0f8cc6205e174f50$var$isFunction($0f8cc6205e174f50$var$_global.postMessage));
const $0f8cc6205e174f50$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($0f8cc6205e174f50$var$_global) : $0f8cc6205e174f50$var$_setImmediate;
var // *********************
$0f8cc6205e174f50$export$2e2bcd8739ae039 = {
    isArray: $0f8cc6205e174f50$var$isArray,
    isArrayBuffer: $0f8cc6205e174f50$var$isArrayBuffer,
    isBuffer: $0f8cc6205e174f50$var$isBuffer,
    isFormData: $0f8cc6205e174f50$var$isFormData,
    isArrayBufferView: $0f8cc6205e174f50$var$isArrayBufferView,
    isString: $0f8cc6205e174f50$var$isString,
    isNumber: $0f8cc6205e174f50$var$isNumber,
    isBoolean: $0f8cc6205e174f50$var$isBoolean,
    isObject: $0f8cc6205e174f50$var$isObject,
    isPlainObject: $0f8cc6205e174f50$var$isPlainObject,
    isReadableStream: $0f8cc6205e174f50$var$isReadableStream,
    isRequest: $0f8cc6205e174f50$var$isRequest,
    isResponse: $0f8cc6205e174f50$var$isResponse,
    isHeaders: $0f8cc6205e174f50$var$isHeaders,
    isUndefined: $0f8cc6205e174f50$var$isUndefined,
    isDate: $0f8cc6205e174f50$var$isDate,
    isFile: $0f8cc6205e174f50$var$isFile,
    isBlob: $0f8cc6205e174f50$var$isBlob,
    isRegExp: $0f8cc6205e174f50$var$isRegExp,
    isFunction: $0f8cc6205e174f50$var$isFunction,
    isStream: $0f8cc6205e174f50$var$isStream,
    isURLSearchParams: $0f8cc6205e174f50$var$isURLSearchParams,
    isTypedArray: $0f8cc6205e174f50$var$isTypedArray,
    isFileList: $0f8cc6205e174f50$var$isFileList,
    forEach: $0f8cc6205e174f50$var$forEach,
    merge: $0f8cc6205e174f50$var$merge,
    extend: $0f8cc6205e174f50$var$extend,
    trim: $0f8cc6205e174f50$var$trim,
    stripBOM: $0f8cc6205e174f50$var$stripBOM,
    inherits: $0f8cc6205e174f50$var$inherits,
    toFlatObject: $0f8cc6205e174f50$var$toFlatObject,
    kindOf: $0f8cc6205e174f50$var$kindOf,
    kindOfTest: $0f8cc6205e174f50$var$kindOfTest,
    endsWith: $0f8cc6205e174f50$var$endsWith,
    toArray: $0f8cc6205e174f50$var$toArray,
    forEachEntry: $0f8cc6205e174f50$var$forEachEntry,
    matchAll: $0f8cc6205e174f50$var$matchAll,
    isHTMLForm: $0f8cc6205e174f50$var$isHTMLForm,
    hasOwnProperty: $0f8cc6205e174f50$var$hasOwnProperty,
    hasOwnProp: $0f8cc6205e174f50$var$hasOwnProperty,
    reduceDescriptors: $0f8cc6205e174f50$var$reduceDescriptors,
    freezeMethods: $0f8cc6205e174f50$var$freezeMethods,
    toObjectSet: $0f8cc6205e174f50$var$toObjectSet,
    toCamelCase: $0f8cc6205e174f50$var$toCamelCase,
    noop: $0f8cc6205e174f50$var$noop,
    toFiniteNumber: $0f8cc6205e174f50$var$toFiniteNumber,
    findKey: $0f8cc6205e174f50$var$findKey,
    global: $0f8cc6205e174f50$var$_global,
    isContextDefined: $0f8cc6205e174f50$var$isContextDefined,
    ALPHABET: $0f8cc6205e174f50$var$ALPHABET,
    generateString: $0f8cc6205e174f50$var$generateString,
    isSpecCompliantForm: $0f8cc6205e174f50$var$isSpecCompliantForm,
    toJSONObject: $0f8cc6205e174f50$var$toJSONObject,
    isAsyncFn: $0f8cc6205e174f50$var$isAsyncFn,
    isThenable: $0f8cc6205e174f50$var$isThenable,
    setImmediate: $0f8cc6205e174f50$var$_setImmediate,
    asap: $0f8cc6205e174f50$var$asap
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $71b41268ebe0cfdd$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).inherits($71b41268ebe0cfdd$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $71b41268ebe0cfdd$var$prototype = $71b41268ebe0cfdd$var$AxiosError.prototype;
const $71b41268ebe0cfdd$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $71b41268ebe0cfdd$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($71b41268ebe0cfdd$var$AxiosError, $71b41268ebe0cfdd$var$descriptors);
Object.defineProperty($71b41268ebe0cfdd$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$71b41268ebe0cfdd$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($71b41268ebe0cfdd$var$prototype);
    (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $71b41268ebe0cfdd$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $71b41268ebe0cfdd$export$2e2bcd8739ae039 = $71b41268ebe0cfdd$var$AxiosError;


// eslint-disable-next-line strict
var $e0ef3453805b9d21$export$2e2bcd8739ae039 = null;



var $4kMtH = parcelRequire("4kMtH");
var $f453ba88c101a657$require$Buffer = $4kMtH.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $f453ba88c101a657$var$isVisitable(thing) {
    return (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $f453ba88c101a657$var$removeBrackets(key) {
    return (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $f453ba88c101a657$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $f453ba88c101a657$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $f453ba88c101a657$var$isFlatArray(arr) {
    return (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isArray(arr) && !arr.some($f453ba88c101a657$var$isVisitable);
}
const $f453ba88c101a657$var$predicates = (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).toFlatObject((0, $0f8cc6205e174f50$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $f453ba88c101a657$var$toFormData(obj, formData, options) {
    if (!(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $e0ef3453805b9d21$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $f453ba88c101a657$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isArray(value) && $f453ba88c101a657$var$isFlatArray(value) || ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isFileList(value) || (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $f453ba88c101a657$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $f453ba88c101a657$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($f453ba88c101a657$var$isVisitable(value)) return true;
        formData.append($f453ba88c101a657$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($f453ba88c101a657$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $f453ba88c101a657$var$isVisitable
    });
    function build(value, path) {
        if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $f453ba88c101a657$export$2e2bcd8739ae039 = $f453ba88c101a657$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $4dbecf34e7d23f5d$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $4dbecf34e7d23f5d$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $f453ba88c101a657$export$2e2bcd8739ae039)(params, this, options);
}
const $4dbecf34e7d23f5d$var$prototype = $4dbecf34e7d23f5d$var$AxiosURLSearchParams.prototype;
$4dbecf34e7d23f5d$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$4dbecf34e7d23f5d$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $4dbecf34e7d23f5d$var$encode);
    } : $4dbecf34e7d23f5d$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $4dbecf34e7d23f5d$export$2e2bcd8739ae039 = $4dbecf34e7d23f5d$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $5f5d1885e0dbebe1$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $5f5d1885e0dbebe1$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $5f5d1885e0dbebe1$var$encode;
    if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $4dbecf34e7d23f5d$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $2523756af2f9c954$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $2523756af2f9c954$export$2e2bcd8739ae039 = $2523756af2f9c954$var$InterceptorManager;





'use strict';
var $a4205bebc6bc34c2$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $43629015e9bf15fa$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $4dbecf34e7d23f5d$export$2e2bcd8739ae039);


'use strict';
var $98954c81edefa566$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $c7da7c339736db47$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $c070bd79d05aa817$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $43629015e9bf15fa$export$2e2bcd8739ae039,
        FormData: $98954c81edefa566$export$2e2bcd8739ae039,
        Blob: $c7da7c339736db47$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $4af4126a3677b7c0$exports = {};

$parcel$export($4af4126a3677b7c0$exports, "hasBrowserEnv", () => $4af4126a3677b7c0$export$c4996c4b7b93b0bf);
$parcel$export($4af4126a3677b7c0$exports, "navigator", () => $4af4126a3677b7c0$export$ec7c8efa7f5790ae);
$parcel$export($4af4126a3677b7c0$exports, "hasStandardBrowserEnv", () => $4af4126a3677b7c0$export$c0bcc9250309d66);
$parcel$export($4af4126a3677b7c0$exports, "hasStandardBrowserWebWorkerEnv", () => $4af4126a3677b7c0$export$c81692cf5af97dac);
$parcel$export($4af4126a3677b7c0$exports, "origin", () => $4af4126a3677b7c0$export$f710a83a91838a36);
const $4af4126a3677b7c0$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $4af4126a3677b7c0$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $4af4126a3677b7c0$export$c0bcc9250309d66 = $4af4126a3677b7c0$export$c4996c4b7b93b0bf && (!$4af4126a3677b7c0$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($4af4126a3677b7c0$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $4af4126a3677b7c0$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $4af4126a3677b7c0$export$f710a83a91838a36 = $4af4126a3677b7c0$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $b2df032b988cb6e7$export$2e2bcd8739ae039 = {
    ...$4af4126a3677b7c0$exports,
    ...(0, $c070bd79d05aa817$export$2e2bcd8739ae039)
};


'use strict';
function $69856384a33dcc21$export$2e2bcd8739ae039(data, options) {
    return (0, $f453ba88c101a657$export$2e2bcd8739ae039)(data, new (0, $b2df032b988cb6e7$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $b2df032b988cb6e7$export$2e2bcd8739ae039).isNode && (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $b2b065d801d9d4f0$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $b2b065d801d9d4f0$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $b2b065d801d9d4f0$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $b2b065d801d9d4f0$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isFormData(formData) && (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($b2b065d801d9d4f0$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $b2b065d801d9d4f0$export$2e2bcd8739ae039 = $b2b065d801d9d4f0$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $c3c1c202aa7a0ef7$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $c3c1c202aa7a0ef7$var$defaults = {
    transitional: (0, $a4205bebc6bc34c2$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $b2b065d801d9d4f0$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isBuffer(data) || (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isStream(data) || (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isFile(data) || (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isBlob(data) || (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $69856384a33dcc21$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $f453ba88c101a657$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $c3c1c202aa7a0ef7$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $c3c1c202aa7a0ef7$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isResponse(data) || (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039).from(e, (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $b2df032b988cb6e7$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $b2df032b988cb6e7$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $c3c1c202aa7a0ef7$var$defaults.headers[method] = {};
});
var $c3c1c202aa7a0ef7$export$2e2bcd8739ae039 = $c3c1c202aa7a0ef7$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $2ba3bcd58d4ddb99$var$ignoreDuplicateOf = (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $2ba3bcd58d4ddb99$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $2ba3bcd58d4ddb99$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $5e3cf9c8b25e414e$var$$internals = Symbol('internals');
function $5e3cf9c8b25e414e$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $5e3cf9c8b25e414e$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isArray(value) ? value.map($5e3cf9c8b25e414e$var$normalizeValue) : String(value);
}
function $5e3cf9c8b25e414e$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $5e3cf9c8b25e414e$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $5e3cf9c8b25e414e$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $5e3cf9c8b25e414e$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $5e3cf9c8b25e414e$var$buildAccessors(obj, header) {
    const accessorName = (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $5e3cf9c8b25e414e$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $5e3cf9c8b25e414e$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $5e3cf9c8b25e414e$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$5e3cf9c8b25e414e$var$isValidHeaderName(header)) setHeaders((0, $2ba3bcd58d4ddb99$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $5e3cf9c8b25e414e$var$normalizeHeader(header);
        if (header) {
            const key = (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $5e3cf9c8b25e414e$var$parseTokens(value);
                if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $5e3cf9c8b25e414e$var$normalizeHeader(header);
        if (header) {
            const key = (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $5e3cf9c8b25e414e$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $5e3cf9c8b25e414e$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $5e3cf9c8b25e414e$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $5e3cf9c8b25e414e$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $5e3cf9c8b25e414e$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $5e3cf9c8b25e414e$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $5e3cf9c8b25e414e$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$5e3cf9c8b25e414e$var$$internals] = this[$5e3cf9c8b25e414e$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $5e3cf9c8b25e414e$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $5e3cf9c8b25e414e$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$5e3cf9c8b25e414e$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).reduceDescriptors($5e3cf9c8b25e414e$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).freezeMethods($5e3cf9c8b25e414e$var$AxiosHeaders);
var $5e3cf9c8b25e414e$export$2e2bcd8739ae039 = $5e3cf9c8b25e414e$var$AxiosHeaders;


'use strict';
function $5ff99592a879917d$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $c3c1c202aa7a0ef7$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $5e3cf9c8b25e414e$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $73be4870b16c59cf$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $5da2ad8fd9d309b7$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).inherits($5da2ad8fd9d309b7$var$CanceledError, (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $5da2ad8fd9d309b7$export$2e2bcd8739ae039 = $5da2ad8fd9d309b7$var$CanceledError;







'use strict';
function $a29cfc3c3e0db785$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $316666b08505b712$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $0f5396bb75f4e451$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $0f5396bb75f4e451$export$2e2bcd8739ae039 = $0f5396bb75f4e451$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $df768da95b9bfe8f$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $df768da95b9bfe8f$export$2e2bcd8739ae039 = $df768da95b9bfe8f$var$throttle;



const $3d4e40ec2bdb4c52$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $0f5396bb75f4e451$export$2e2bcd8739ae039)(50, 250);
    return (0, $df768da95b9bfe8f$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $3d4e40ec2bdb4c52$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $3d4e40ec2bdb4c52$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $c1fea89c1a72a0e0$export$2e2bcd8739ae039 = (0, $b2df032b988cb6e7$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $b2df032b988cb6e7$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $b2df032b988cb6e7$export$2e2bcd8739ae039).origin), (0, $b2df032b988cb6e7$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $b2df032b988cb6e7$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $57b7aee8e2f76a9e$export$2e2bcd8739ae039 = (0, $b2df032b988cb6e7$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $c94273ade1894f71$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $4e25f95ae75c3efb$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $e670a746ab7db58d$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $c94273ade1894f71$export$2e2bcd8739ae039)(requestedURL)) return (0, $4e25f95ae75c3efb$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $1cc844399128f2f2$var$headersToObject = (thing)=>thing instanceof (0, $5e3cf9c8b25e414e$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $1cc844399128f2f2$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isPlainObject(target) && (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($1cc844399128f2f2$var$headersToObject(a), $1cc844399128f2f2$var$headersToObject(b), prop, true)
    };
    (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $5c7d61a04cfadb01$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $1cc844399128f2f2$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $5e3cf9c8b25e414e$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $5f5d1885e0dbebe1$export$2e2bcd8739ae039)((0, $e670a746ab7db58d$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $b2df032b988cb6e7$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $b2df032b988cb6e7$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $b2df032b988cb6e7$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $c1fea89c1a72a0e0$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $57b7aee8e2f76a9e$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $2c0b8998ad5b0085$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $2c0b8998ad5b0085$export$2e2bcd8739ae039 = $2c0b8998ad5b0085$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $5c7d61a04cfadb01$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $5e3cf9c8b25e414e$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $5e3cf9c8b25e414e$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $a29cfc3c3e0db785$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039)('Request aborted', (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039)('Network Error', (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $a4205bebc6bc34c2$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039).ETIMEDOUT : (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $3d4e40ec2bdb4c52$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $3d4e40ec2bdb4c52$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $5da2ad8fd9d309b7$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $316666b08505b712$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $b2df032b988cb6e7$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $ca39bcef7387ca97$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039) ? err : new (0, $5da2ad8fd9d309b7$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $ca39bcef7387ca97$export$2e2bcd8739ae039 = $ca39bcef7387ca97$var$composeSignals;


const $c0233a84dbead3ea$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c0233a84dbead3ea$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c0233a84dbead3ea$var$readStream(iterable))yield* $c0233a84dbead3ea$export$71b051935044bd5d(chunk, chunkSize);
};
const $c0233a84dbead3ea$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c0233a84dbead3ea$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c0233a84dbead3ea$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $6859f53882aa2bb9$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $6859f53882aa2bb9$var$isReadableStreamSupported = $6859f53882aa2bb9$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $6859f53882aa2bb9$var$encodeText = $6859f53882aa2bb9$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $6859f53882aa2bb9$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $6859f53882aa2bb9$var$supportsRequestStream = $6859f53882aa2bb9$var$isReadableStreamSupported && $6859f53882aa2bb9$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $b2df032b988cb6e7$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $6859f53882aa2bb9$var$DEFAULT_CHUNK_SIZE = 65536;
const $6859f53882aa2bb9$var$supportsResponseStream = $6859f53882aa2bb9$var$isReadableStreamSupported && $6859f53882aa2bb9$var$test(()=>(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
const $6859f53882aa2bb9$var$resolvers = {
    stream: $6859f53882aa2bb9$var$supportsResponseStream && ((res)=>res.body)
};
$6859f53882aa2bb9$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$6859f53882aa2bb9$var$resolvers[type] && ($6859f53882aa2bb9$var$resolvers[type] = (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $6859f53882aa2bb9$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $b2df032b988cb6e7$export$2e2bcd8739ae039).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
    if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isString(body)) return (await $6859f53882aa2bb9$var$encodeText(body)).byteLength;
};
const $6859f53882aa2bb9$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $6859f53882aa2bb9$var$getBodyLength(body) : length;
};
var $6859f53882aa2bb9$export$2e2bcd8739ae039 = $6859f53882aa2bb9$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $5c7d61a04cfadb01$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $ca39bcef7387ca97$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $6859f53882aa2bb9$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $6859f53882aa2bb9$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $3d4e40ec2bdb4c52$export$d9fadd12586c18d6)(requestContentLength, (0, $3d4e40ec2bdb4c52$export$c1b28109d46c3592)((0, $3d4e40ec2bdb4c52$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $c0233a84dbead3ea$export$b0119225647bd83)(_request.body, $6859f53882aa2bb9$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $6859f53882aa2bb9$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($6859f53882aa2bb9$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $3d4e40ec2bdb4c52$export$d9fadd12586c18d6)(responseContentLength, (0, $3d4e40ec2bdb4c52$export$c1b28109d46c3592)((0, $3d4e40ec2bdb4c52$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $c0233a84dbead3ea$export$b0119225647bd83)(response.body, $6859f53882aa2bb9$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $6859f53882aa2bb9$var$resolvers[(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).findKey($6859f53882aa2bb9$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $a29cfc3c3e0db785$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $5e3cf9c8b25e414e$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) throw Object.assign(new (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039)('Network Error', (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $c86a2b54bf34e228$var$knownAdapters = {
    http: (0, $e0ef3453805b9d21$export$2e2bcd8739ae039),
    xhr: (0, $2c0b8998ad5b0085$export$2e2bcd8739ae039),
    fetch: (0, $6859f53882aa2bb9$export$2e2bcd8739ae039)
};
(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).forEach($c86a2b54bf34e228$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $c86a2b54bf34e228$var$renderReason = (reason)=>`- ${reason}`;
const $c86a2b54bf34e228$var$isResolvedHandle = (adapter)=>(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $c86a2b54bf34e228$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$c86a2b54bf34e228$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $c86a2b54bf34e228$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($c86a2b54bf34e228$var$renderReason).join('\n') : ' ' + $c86a2b54bf34e228$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $c86a2b54bf34e228$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $93cabb476622d0d8$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $5da2ad8fd9d309b7$export$2e2bcd8739ae039)(null, config);
}
function $93cabb476622d0d8$export$2e2bcd8739ae039(config) {
    $93cabb476622d0d8$var$throwIfCancellationRequested(config);
    config.headers = (0, $5e3cf9c8b25e414e$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5ff99592a879917d$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $c86a2b54bf34e228$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $c3c1c202aa7a0ef7$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $93cabb476622d0d8$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $5ff99592a879917d$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $5e3cf9c8b25e414e$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $73be4870b16c59cf$export$2e2bcd8739ae039)(reason)) {
            $93cabb476622d0d8$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $5ff99592a879917d$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $5e3cf9c8b25e414e$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $2164cfb0a42b4f75$export$a4ad2735b021c132 = "1.7.9";



'use strict';
const $c6028405a3511309$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $c6028405a3511309$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $c6028405a3511309$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $c6028405a3511309$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $2164cfb0a42b4f75$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$c6028405a3511309$var$deprecatedWarnings[opt]) {
            $c6028405a3511309$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$c6028405a3511309$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $c6028405a3511309$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039)('options must be an object', (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $c6028405a3511309$export$2e2bcd8739ae039 = {
    assertOptions: $c6028405a3511309$var$assertOptions,
    validators: $c6028405a3511309$var$validators
};



'use strict';
const $3fe2b8241aee32f6$var$validators = (0, $c6028405a3511309$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $3fe2b8241aee32f6$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $2523756af2f9c954$export$2e2bcd8739ae039)(),
            response: new (0, $2523756af2f9c954$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $1cc844399128f2f2$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $c6028405a3511309$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $3fe2b8241aee32f6$var$validators.transitional($3fe2b8241aee32f6$var$validators.boolean),
            forcedJSONParsing: $3fe2b8241aee32f6$var$validators.transitional($3fe2b8241aee32f6$var$validators.boolean),
            clarifyTimeoutError: $3fe2b8241aee32f6$var$validators.transitional($3fe2b8241aee32f6$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $c6028405a3511309$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $3fe2b8241aee32f6$var$validators.function,
                serialize: $3fe2b8241aee32f6$var$validators.function
            }, true);
        }
        (0, $c6028405a3511309$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $3fe2b8241aee32f6$var$validators.spelling('baseURL'),
            withXsrfToken: $3fe2b8241aee32f6$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $5e3cf9c8b25e414e$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $93cabb476622d0d8$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $93cabb476622d0d8$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $1cc844399128f2f2$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $e670a746ab7db58d$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $5f5d1885e0dbebe1$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $3fe2b8241aee32f6$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $1cc844399128f2f2$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $0f8cc6205e174f50$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $1cc844399128f2f2$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $3fe2b8241aee32f6$var$Axios.prototype[method] = generateHTTPMethod();
    $3fe2b8241aee32f6$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $3fe2b8241aee32f6$export$2e2bcd8739ae039 = $3fe2b8241aee32f6$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $c82856fee0392712$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $5da2ad8fd9d309b7$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $c82856fee0392712$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $c82856fee0392712$export$2e2bcd8739ae039 = $c82856fee0392712$var$CancelToken;






'use strict';
function $65a80fb5b014ff27$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $aeedfd0dacdf35fb$export$2e2bcd8739ae039(payload) {
    return (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $90c2486e14f3223c$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($90c2486e14f3223c$var$HttpStatusCode).forEach(([key, value])=>{
    $90c2486e14f3223c$var$HttpStatusCode[value] = key;
});
var $90c2486e14f3223c$export$2e2bcd8739ae039 = $90c2486e14f3223c$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $ea74087fd5ac399e$var$createInstance(defaultConfig) {
    const context = new (0, $3fe2b8241aee32f6$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $fd5c8f41aff14f01$export$2e2bcd8739ae039)((0, $3fe2b8241aee32f6$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).extend(instance, (0, $3fe2b8241aee32f6$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $0f8cc6205e174f50$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $ea74087fd5ac399e$var$createInstance((0, $1cc844399128f2f2$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $ea74087fd5ac399e$var$axios = $ea74087fd5ac399e$var$createInstance((0, $c3c1c202aa7a0ef7$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$ea74087fd5ac399e$var$axios.Axios = (0, $3fe2b8241aee32f6$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$ea74087fd5ac399e$var$axios.CanceledError = (0, $5da2ad8fd9d309b7$export$2e2bcd8739ae039);
$ea74087fd5ac399e$var$axios.CancelToken = (0, $c82856fee0392712$export$2e2bcd8739ae039);
$ea74087fd5ac399e$var$axios.isCancel = (0, $73be4870b16c59cf$export$2e2bcd8739ae039);
$ea74087fd5ac399e$var$axios.VERSION = (0, $2164cfb0a42b4f75$export$a4ad2735b021c132);
$ea74087fd5ac399e$var$axios.toFormData = (0, $f453ba88c101a657$export$2e2bcd8739ae039);
// Expose AxiosError class
$ea74087fd5ac399e$var$axios.AxiosError = (0, $71b41268ebe0cfdd$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$ea74087fd5ac399e$var$axios.Cancel = $ea74087fd5ac399e$var$axios.CanceledError;
// Expose all/spread
$ea74087fd5ac399e$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$ea74087fd5ac399e$var$axios.spread = (0, $65a80fb5b014ff27$export$2e2bcd8739ae039);
// Expose isAxiosError
$ea74087fd5ac399e$var$axios.isAxiosError = (0, $aeedfd0dacdf35fb$export$2e2bcd8739ae039);
// Expose mergeConfig
$ea74087fd5ac399e$var$axios.mergeConfig = (0, $1cc844399128f2f2$export$2e2bcd8739ae039);
$ea74087fd5ac399e$var$axios.AxiosHeaders = (0, $5e3cf9c8b25e414e$export$2e2bcd8739ae039);
$ea74087fd5ac399e$var$axios.formToJSON = (thing)=>(0, $b2b065d801d9d4f0$export$2e2bcd8739ae039)((0, $0f8cc6205e174f50$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$ea74087fd5ac399e$var$axios.getAdapter = (0, $c86a2b54bf34e228$export$2e2bcd8739ae039).getAdapter;
$ea74087fd5ac399e$var$axios.HttpStatusCode = (0, $90c2486e14f3223c$export$2e2bcd8739ae039);
$ea74087fd5ac399e$var$axios.default = $ea74087fd5ac399e$var$axios;
var // this module should only have a default export
$ea74087fd5ac399e$export$2e2bcd8739ae039 = $ea74087fd5ac399e$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $01c549eebd4b6503$export$1c00760e9e5a4e95, AxiosError: $01c549eebd4b6503$export$c1fbed17c2f6a328, CanceledError: $01c549eebd4b6503$export$1ab0c6b20d94fa14, isCancel: $01c549eebd4b6503$export$3b22524397b493c6, CancelToken: $01c549eebd4b6503$export$fd08e3cb425f0d61, VERSION: $01c549eebd4b6503$export$a4ad2735b021c132, all: $01c549eebd4b6503$export$84bf76cd7afc7469, Cancel: $01c549eebd4b6503$export$848c9b7ead0df967, isAxiosError: $01c549eebd4b6503$export$fbafdbe06a5b5a9a, spread: $01c549eebd4b6503$export$3ae0fd4797ed47c8, toFormData: $01c549eebd4b6503$export$10ae0d317ea97f8b, AxiosHeaders: $01c549eebd4b6503$export$4e7d6ff0f3e6520, HttpStatusCode: $01c549eebd4b6503$export$a972f69c851492b3, formToJSON: $01c549eebd4b6503$export$86d7c59254d6a2c9, getAdapter: $01c549eebd4b6503$export$17ddc20a97d669e2, mergeConfig: $01c549eebd4b6503$export$7ec1ebcfa9d8bd6a } = (0, $ea74087fd5ac399e$export$2e2bcd8739ae039);


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $f3f8f86b339a1e6d$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $f3f8f86b339a1e6d$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $f3f8f86b339a1e6d$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $f3f8f86b339a1e6d$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $f3f8f86b339a1e6d$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f3f8f86b339a1e6d$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $f3f8f86b339a1e6d$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $f3f8f86b339a1e6d$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($f3f8f86b339a1e6d$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $f3f8f86b339a1e6d$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $f3f8f86b339a1e6d$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $f3f8f86b339a1e6d$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $f3f8f86b339a1e6d$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $f3f8f86b339a1e6d$var$stringToByteArray$1(str);
    return $f3f8f86b339a1e6d$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $f3f8f86b339a1e6d$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $f3f8f86b339a1e6d$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $f3f8f86b339a1e6d$export$c62426fdd000a97e = function(str) {
    try {
        return $f3f8f86b339a1e6d$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $f3f8f86b339a1e6d$export$6c40052bed430212(value) {
    return $f3f8f86b339a1e6d$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $f3f8f86b339a1e6d$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$f3f8f86b339a1e6d$var$isValidKey(prop)) continue;
        target[prop] = $f3f8f86b339a1e6d$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $f3f8f86b339a1e6d$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $f3f8f86b339a1e6d$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f3f8f86b339a1e6d$var$getDefaultsFromGlobal = ()=>$f3f8f86b339a1e6d$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $f3f8f86b339a1e6d$var$getDefaultsFromEnvVariable = ()=>{
    return;
};
const $f3f8f86b339a1e6d$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $f3f8f86b339a1e6d$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $f3f8f86b339a1e6d$export$212bb2fc580a90a8 = ()=>{
    try {
        return $f3f8f86b339a1e6d$var$getDefaultsFromGlobal() || $f3f8f86b339a1e6d$var$getDefaultsFromEnvVariable() || $f3f8f86b339a1e6d$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $f3f8f86b339a1e6d$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $f3f8f86b339a1e6d$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $f3f8f86b339a1e6d$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $f3f8f86b339a1e6d$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $f3f8f86b339a1e6d$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $f3f8f86b339a1e6d$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $f3f8f86b339a1e6d$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $f3f8f86b339a1e6d$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $f3f8f86b339a1e6d$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f3f8f86b339a1e6d$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $f3f8f86b339a1e6d$export$4b5284a3025a455(JSON.stringify(header)),
        $f3f8f86b339a1e6d$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $f3f8f86b339a1e6d$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $f3f8f86b339a1e6d$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($f3f8f86b339a1e6d$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $f3f8f86b339a1e6d$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $f3f8f86b339a1e6d$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $f3f8f86b339a1e6d$export$4e09c449d6c407f7() {
    return typeof self === 'object' && self.self === self;
}
function $f3f8f86b339a1e6d$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $f3f8f86b339a1e6d$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $f3f8f86b339a1e6d$export$f2f6a8999f8ebd30() {
    return $f3f8f86b339a1e6d$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $f3f8f86b339a1e6d$export$7e7b1a9668aaed8() {
    const ua = $f3f8f86b339a1e6d$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $f3f8f86b339a1e6d$export$202944b2d2824246() {
    return $f3f8f86b339a1e6d$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $f3f8f86b339a1e6d$export$5d1d834fbbf8bab7() {
    return $f3f8f86b339a1e6d$export$588c7fdda06fbb0a.NODE_CLIENT === true || $f3f8f86b339a1e6d$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $f3f8f86b339a1e6d$export$95df08bae54cb4df() {
    return !$f3f8f86b339a1e6d$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $f3f8f86b339a1e6d$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $f3f8f86b339a1e6d$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $f3f8f86b339a1e6d$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $f3f8f86b339a1e6d$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $f3f8f86b339a1e6d$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $f3f8f86b339a1e6d$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $f3f8f86b339a1e6d$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $f3f8f86b339a1e6d$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $f3f8f86b339a1e6d$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $f3f8f86b339a1e6d$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $f3f8f86b339a1e6d$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $f3f8f86b339a1e6d$var$replaceTemplate(template, data) {
    return template.replace($f3f8f86b339a1e6d$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $f3f8f86b339a1e6d$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $f3f8f86b339a1e6d$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $f3f8f86b339a1e6d$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $f3f8f86b339a1e6d$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $f3f8f86b339a1e6d$export$c5a53ce6a17cf18d($f3f8f86b339a1e6d$export$c62426fdd000a97e(parts[0]) || '');
        claims = $f3f8f86b339a1e6d$export$c5a53ce6a17cf18d($f3f8f86b339a1e6d$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $f3f8f86b339a1e6d$export$5f870fcca7ae6a88 = function(token) {
    const claims = $f3f8f86b339a1e6d$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $f3f8f86b339a1e6d$export$701c661ec91095f2 = function(token) {
    const claims = $f3f8f86b339a1e6d$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $f3f8f86b339a1e6d$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $f3f8f86b339a1e6d$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $f3f8f86b339a1e6d$export$fc970ed23da99565 = function(token) {
    const claims = $f3f8f86b339a1e6d$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f3f8f86b339a1e6d$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $f3f8f86b339a1e6d$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $f3f8f86b339a1e6d$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $f3f8f86b339a1e6d$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $f3f8f86b339a1e6d$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($f3f8f86b339a1e6d$var$isObject(aProp) && $f3f8f86b339a1e6d$var$isObject(bProp)) {
            if (!$f3f8f86b339a1e6d$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $f3f8f86b339a1e6d$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $f3f8f86b339a1e6d$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $f3f8f86b339a1e6d$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $f3f8f86b339a1e6d$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $f3f8f86b339a1e6d$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $f3f8f86b339a1e6d$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $f3f8f86b339a1e6d$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $f3f8f86b339a1e6d$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $f3f8f86b339a1e6d$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $f3f8f86b339a1e6d$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($f3f8f86b339a1e6d$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $f3f8f86b339a1e6d$var$noop;
        if (observer.error === undefined) observer.error = $f3f8f86b339a1e6d$var$noop;
        if (observer.complete === undefined) observer.complete = $f3f8f86b339a1e6d$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $f3f8f86b339a1e6d$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $f3f8f86b339a1e6d$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $f3f8f86b339a1e6d$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $f3f8f86b339a1e6d$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $f3f8f86b339a1e6d$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $f3f8f86b339a1e6d$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($f3f8f86b339a1e6d$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $f3f8f86b339a1e6d$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($f3f8f86b339a1e6d$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $f3f8f86b339a1e6d$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($f3f8f86b339a1e6d$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $f3f8f86b339a1e6d$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $f3f8f86b339a1e6d$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $f3f8f86b339a1e6d$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $f3f8f86b339a1e6d$export$abe4376e1bf796d6 = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $f3f8f86b339a1e6d$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $f3f8f86b339a1e6d$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $f3f8f86b339a1e6d$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $f3f8f86b339a1e6d$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $f3f8f86b339a1e6d$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $f3f8f86b339a1e6d$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $f3f8f86b339a1e6d$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $f3f8f86b339a1e6d$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($f3f8f86b339a1e6d$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $f3f8f86b339a1e6d$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $f3f8f86b339a1e6d$var$indicator(i);
}
function $f3f8f86b339a1e6d$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f3f8f86b339a1e6d$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $4f822ea27f1bba54$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4f822ea27f1bba54$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $4f822ea27f1bba54$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $f3f8f86b339a1e6d$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($4f822ea27f1bba54$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $4f822ea27f1bba54$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $4f822ea27f1bba54$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $4f822ea27f1bba54$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $4f822ea27f1bba54$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $4f822ea27f1bba54$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $4f822ea27f1bba54$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $4f822ea27f1bba54$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $4f822ea27f1bba54$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $4f822ea27f1bba54$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $4f822ea27f1bba54$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $4f822ea27f1bba54$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $4f822ea27f1bba54$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $a3250d6c1176d992$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $a3250d6c1176d992$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($a3250d6c1176d992$export$243e62d78d3b544d || ($a3250d6c1176d992$export$243e62d78d3b544d = {}));
const $a3250d6c1176d992$var$levelStringToEnum = {
    'debug': $a3250d6c1176d992$export$243e62d78d3b544d.DEBUG,
    'verbose': $a3250d6c1176d992$export$243e62d78d3b544d.VERBOSE,
    'info': $a3250d6c1176d992$export$243e62d78d3b544d.INFO,
    'warn': $a3250d6c1176d992$export$243e62d78d3b544d.WARN,
    'error': $a3250d6c1176d992$export$243e62d78d3b544d.ERROR,
    'silent': $a3250d6c1176d992$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $a3250d6c1176d992$var$defaultLogLevel = $a3250d6c1176d992$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $a3250d6c1176d992$var$ConsoleMethod = {
    [$a3250d6c1176d992$export$243e62d78d3b544d.DEBUG]: 'log',
    [$a3250d6c1176d992$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$a3250d6c1176d992$export$243e62d78d3b544d.INFO]: 'info',
    [$a3250d6c1176d992$export$243e62d78d3b544d.WARN]: 'warn',
    [$a3250d6c1176d992$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $a3250d6c1176d992$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $a3250d6c1176d992$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $a3250d6c1176d992$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $a3250d6c1176d992$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $a3250d6c1176d992$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $a3250d6c1176d992$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $a3250d6c1176d992$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $a3250d6c1176d992$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $a3250d6c1176d992$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $a3250d6c1176d992$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $a3250d6c1176d992$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $a3250d6c1176d992$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $a3250d6c1176d992$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $a3250d6c1176d992$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $a3250d6c1176d992$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $a3250d6c1176d992$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $a3250d6c1176d992$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $a3250d6c1176d992$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $a3250d6c1176d992$export$c622e99c0ce7b1c9(level) {
    $a3250d6c1176d992$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $a3250d6c1176d992$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $a3250d6c1176d992$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $a3250d6c1176d992$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $a3250d6c1176d992$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $587824232dad13a7$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $587824232dad13a7$var$idbProxyableTypes;
let $587824232dad13a7$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $587824232dad13a7$var$getIdbProxyableTypes() {
    return $587824232dad13a7$var$idbProxyableTypes || ($587824232dad13a7$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $587824232dad13a7$var$getCursorAdvanceMethods() {
    return $587824232dad13a7$var$cursorAdvanceMethods || ($587824232dad13a7$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $587824232dad13a7$var$cursorRequestMap = new WeakMap();
const $587824232dad13a7$var$transactionDoneMap = new WeakMap();
const $587824232dad13a7$var$transactionStoreNamesMap = new WeakMap();
const $587824232dad13a7$var$transformCache = new WeakMap();
const $587824232dad13a7$export$407448d2b89b1813 = new WeakMap();
function $587824232dad13a7$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($587824232dad13a7$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $587824232dad13a7$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $587824232dad13a7$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $587824232dad13a7$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($587824232dad13a7$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $587824232dad13a7$var$transactionDoneMap.set(tx, done);
}
let $587824232dad13a7$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $587824232dad13a7$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $587824232dad13a7$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $587824232dad13a7$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $587824232dad13a7$export$43caf9889c228507(callback) {
    $587824232dad13a7$var$idbProxyTraps = callback($587824232dad13a7$var$idbProxyTraps);
}
function $587824232dad13a7$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($587824232dad13a7$export$3b14a55fb2447963(this), storeNames, ...args);
        $587824232dad13a7$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $587824232dad13a7$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($587824232dad13a7$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($587824232dad13a7$export$3b14a55fb2447963(this), args);
        return $587824232dad13a7$export$efccba1c4a2ef57b($587824232dad13a7$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $587824232dad13a7$export$efccba1c4a2ef57b(func.apply($587824232dad13a7$export$3b14a55fb2447963(this), args));
    };
}
function $587824232dad13a7$var$transformCachableValue(value) {
    if (typeof value === 'function') return $587824232dad13a7$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $587824232dad13a7$var$cacheDonePromiseForTransaction(value);
    if ($587824232dad13a7$export$23f2a1d2818174ef(value, $587824232dad13a7$var$getIdbProxyableTypes())) return new Proxy(value, $587824232dad13a7$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $587824232dad13a7$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $587824232dad13a7$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($587824232dad13a7$var$transformCache.has(value)) return $587824232dad13a7$var$transformCache.get(value);
    const newValue = $587824232dad13a7$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $587824232dad13a7$var$transformCache.set(value, newValue);
        $587824232dad13a7$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $587824232dad13a7$export$3b14a55fb2447963 = (value)=>$587824232dad13a7$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $112b4d4b74665b6e$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $587824232dad13a7$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $587824232dad13a7$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $587824232dad13a7$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $112b4d4b74665b6e$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $587824232dad13a7$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $112b4d4b74665b6e$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $112b4d4b74665b6e$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $112b4d4b74665b6e$var$cachedMethods = new Map();
function $112b4d4b74665b6e$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($112b4d4b74665b6e$var$cachedMethods.get(prop)) return $112b4d4b74665b6e$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $112b4d4b74665b6e$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $112b4d4b74665b6e$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $112b4d4b74665b6e$var$cachedMethods.set(prop, method);
    return method;
}
(0, $587824232dad13a7$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$112b4d4b74665b6e$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$112b4d4b74665b6e$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $20bc1f3a4bda2fcc$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($20bc1f3a4bda2fcc$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $20bc1f3a4bda2fcc$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $20bc1f3a4bda2fcc$var$name$o = "@firebase/app";
const $20bc1f3a4bda2fcc$var$version$1 = "0.9.28";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20bc1f3a4bda2fcc$var$logger = new (0, $a3250d6c1176d992$export$efa9a398d6368992)('@firebase/app');
const $20bc1f3a4bda2fcc$var$name$n = "@firebase/app-compat";
const $20bc1f3a4bda2fcc$var$name$m = "@firebase/analytics-compat";
const $20bc1f3a4bda2fcc$var$name$l = "@firebase/analytics";
const $20bc1f3a4bda2fcc$var$name$k = "@firebase/app-check-compat";
const $20bc1f3a4bda2fcc$var$name$j = "@firebase/app-check";
const $20bc1f3a4bda2fcc$var$name$i = "@firebase/auth";
const $20bc1f3a4bda2fcc$var$name$h = "@firebase/auth-compat";
const $20bc1f3a4bda2fcc$var$name$g = "@firebase/database";
const $20bc1f3a4bda2fcc$var$name$f = "@firebase/database-compat";
const $20bc1f3a4bda2fcc$var$name$e = "@firebase/functions";
const $20bc1f3a4bda2fcc$var$name$d = "@firebase/functions-compat";
const $20bc1f3a4bda2fcc$var$name$c = "@firebase/installations";
const $20bc1f3a4bda2fcc$var$name$b = "@firebase/installations-compat";
const $20bc1f3a4bda2fcc$var$name$a = "@firebase/messaging";
const $20bc1f3a4bda2fcc$var$name$9 = "@firebase/messaging-compat";
const $20bc1f3a4bda2fcc$var$name$8 = "@firebase/performance";
const $20bc1f3a4bda2fcc$var$name$7 = "@firebase/performance-compat";
const $20bc1f3a4bda2fcc$var$name$6 = "@firebase/remote-config";
const $20bc1f3a4bda2fcc$var$name$5 = "@firebase/remote-config-compat";
const $20bc1f3a4bda2fcc$var$name$4 = "@firebase/storage";
const $20bc1f3a4bda2fcc$var$name$3 = "@firebase/storage-compat";
const $20bc1f3a4bda2fcc$var$name$2 = "@firebase/firestore";
const $20bc1f3a4bda2fcc$var$name$1 = "@firebase/firestore-compat";
const $20bc1f3a4bda2fcc$var$name = "firebase";
const $20bc1f3a4bda2fcc$var$version = "10.8.1";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $20bc1f3a4bda2fcc$export$9f30fa0c10967f7f = '[DEFAULT]';
const $20bc1f3a4bda2fcc$var$PLATFORM_LOG_STRING = {
    [$20bc1f3a4bda2fcc$var$name$o]: 'fire-core',
    [$20bc1f3a4bda2fcc$var$name$n]: 'fire-core-compat',
    [$20bc1f3a4bda2fcc$var$name$l]: 'fire-analytics',
    [$20bc1f3a4bda2fcc$var$name$m]: 'fire-analytics-compat',
    [$20bc1f3a4bda2fcc$var$name$j]: 'fire-app-check',
    [$20bc1f3a4bda2fcc$var$name$k]: 'fire-app-check-compat',
    [$20bc1f3a4bda2fcc$var$name$i]: 'fire-auth',
    [$20bc1f3a4bda2fcc$var$name$h]: 'fire-auth-compat',
    [$20bc1f3a4bda2fcc$var$name$g]: 'fire-rtdb',
    [$20bc1f3a4bda2fcc$var$name$f]: 'fire-rtdb-compat',
    [$20bc1f3a4bda2fcc$var$name$e]: 'fire-fn',
    [$20bc1f3a4bda2fcc$var$name$d]: 'fire-fn-compat',
    [$20bc1f3a4bda2fcc$var$name$c]: 'fire-iid',
    [$20bc1f3a4bda2fcc$var$name$b]: 'fire-iid-compat',
    [$20bc1f3a4bda2fcc$var$name$a]: 'fire-fcm',
    [$20bc1f3a4bda2fcc$var$name$9]: 'fire-fcm-compat',
    [$20bc1f3a4bda2fcc$var$name$8]: 'fire-perf',
    [$20bc1f3a4bda2fcc$var$name$7]: 'fire-perf-compat',
    [$20bc1f3a4bda2fcc$var$name$6]: 'fire-rc',
    [$20bc1f3a4bda2fcc$var$name$5]: 'fire-rc-compat',
    [$20bc1f3a4bda2fcc$var$name$4]: 'fire-gcs',
    [$20bc1f3a4bda2fcc$var$name$3]: 'fire-gcs-compat',
    [$20bc1f3a4bda2fcc$var$name$2]: 'fire-fst',
    [$20bc1f3a4bda2fcc$var$name$1]: 'fire-fst-compat',
    'fire-js': 'fire-js',
    [$20bc1f3a4bda2fcc$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $20bc1f3a4bda2fcc$export$b4e3c36c855b14b5 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $20bc1f3a4bda2fcc$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $20bc1f3a4bda2fcc$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $20bc1f3a4bda2fcc$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $20bc1f3a4bda2fcc$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $20bc1f3a4bda2fcc$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($20bc1f3a4bda2fcc$export$9566bce3835c0f28.has(componentName)) {
        $20bc1f3a4bda2fcc$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $20bc1f3a4bda2fcc$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $20bc1f3a4bda2fcc$export$b4e3c36c855b14b5.values())$20bc1f3a4bda2fcc$export$fa5244b94c62d36a(app, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $20bc1f3a4bda2fcc$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $20bc1f3a4bda2fcc$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $20bc1f3a4bda2fcc$export$9f30fa0c10967f7f) {
    $20bc1f3a4bda2fcc$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */ function $20bc1f3a4bda2fcc$export$3685d89b9c3cdfaf() {
    $20bc1f3a4bda2fcc$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20bc1f3a4bda2fcc$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.'
};
const $20bc1f3a4bda2fcc$var$ERROR_FACTORY = new (0, $f3f8f86b339a1e6d$export$3fa6e1b18a3b2d40)('app', 'Firebase', $20bc1f3a4bda2fcc$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $20bc1f3a4bda2fcc$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $4f822ea27f1bba54$export$16fa2f45be04daa8)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $20bc1f3a4bda2fcc$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $20bc1f3a4bda2fcc$export$31499a9cd224b78c = $20bc1f3a4bda2fcc$var$version;
function $20bc1f3a4bda2fcc$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $20bc1f3a4bda2fcc$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $20bc1f3a4bda2fcc$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $f3f8f86b339a1e6d$export$3dfb6827a9f89756)());
    if (!options) throw $20bc1f3a4bda2fcc$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $20bc1f3a4bda2fcc$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $f3f8f86b339a1e6d$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $f3f8f86b339a1e6d$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $20bc1f3a4bda2fcc$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $4f822ea27f1bba54$export$436a80eea5d5c0c5)(name);
    for (const component of $20bc1f3a4bda2fcc$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $20bc1f3a4bda2fcc$var$FirebaseAppImpl(options, config, container);
    $20bc1f3a4bda2fcc$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $20bc1f3a4bda2fcc$export$f9962582c9e66d99(name = $20bc1f3a4bda2fcc$export$9f30fa0c10967f7f) {
    const app = $20bc1f3a4bda2fcc$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $20bc1f3a4bda2fcc$export$9f30fa0c10967f7f && (0, $f3f8f86b339a1e6d$export$3dfb6827a9f89756)()) return $20bc1f3a4bda2fcc$export$c55cfd413944906d();
    if (!app) throw $20bc1f3a4bda2fcc$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $20bc1f3a4bda2fcc$export$68ddedf7d44b3bdf() {
    return Array.from($20bc1f3a4bda2fcc$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $20bc1f3a4bda2fcc$export$6eec44aa53d5ea34(app) {
    const name = app.name;
    if ($20bc1f3a4bda2fcc$export$b4e3c36c855b14b5.has(name)) {
        $20bc1f3a4bda2fcc$export$b4e3c36c855b14b5.delete(name);
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $20bc1f3a4bda2fcc$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $20bc1f3a4bda2fcc$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $20bc1f3a4bda2fcc$var$logger.warn(warning.join(' '));
        return;
    }
    $20bc1f3a4bda2fcc$export$c930050e7bb63965(new (0, $4f822ea27f1bba54$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $20bc1f3a4bda2fcc$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $20bc1f3a4bda2fcc$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $a3250d6c1176d992$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $20bc1f3a4bda2fcc$export$c622e99c0ce7b1c9(logLevel) {
    (0, $a3250d6c1176d992$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20bc1f3a4bda2fcc$var$DB_NAME = 'firebase-heartbeat-database';
const $20bc1f3a4bda2fcc$var$DB_VERSION = 1;
const $20bc1f3a4bda2fcc$var$STORE_NAME = 'firebase-heartbeat-store';
let $20bc1f3a4bda2fcc$var$dbPromise = null;
function $20bc1f3a4bda2fcc$var$getDbPromise() {
    if (!$20bc1f3a4bda2fcc$var$dbPromise) $20bc1f3a4bda2fcc$var$dbPromise = (0, $112b4d4b74665b6e$export$ca0ed41b1a2af7e)($20bc1f3a4bda2fcc$var$DB_NAME, $20bc1f3a4bda2fcc$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($20bc1f3a4bda2fcc$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $20bc1f3a4bda2fcc$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $20bc1f3a4bda2fcc$var$dbPromise;
}
async function $20bc1f3a4bda2fcc$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $20bc1f3a4bda2fcc$var$getDbPromise();
        const tx = db.transaction($20bc1f3a4bda2fcc$var$STORE_NAME);
        const result = await tx.objectStore($20bc1f3a4bda2fcc$var$STORE_NAME).get($20bc1f3a4bda2fcc$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $f3f8f86b339a1e6d$export$dd24e9cd51226c56)) $20bc1f3a4bda2fcc$var$logger.warn(e.message);
        else {
            const idbGetError = $20bc1f3a4bda2fcc$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $20bc1f3a4bda2fcc$var$logger.warn(idbGetError.message);
        }
    }
}
async function $20bc1f3a4bda2fcc$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $20bc1f3a4bda2fcc$var$getDbPromise();
        const tx = db.transaction($20bc1f3a4bda2fcc$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($20bc1f3a4bda2fcc$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $20bc1f3a4bda2fcc$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $f3f8f86b339a1e6d$export$dd24e9cd51226c56)) $20bc1f3a4bda2fcc$var$logger.warn(e.message);
        else {
            const idbGetError = $20bc1f3a4bda2fcc$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $20bc1f3a4bda2fcc$var$logger.warn(idbGetError.message);
        }
    }
}
function $20bc1f3a4bda2fcc$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20bc1f3a4bda2fcc$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $20bc1f3a4bda2fcc$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $20bc1f3a4bda2fcc$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $20bc1f3a4bda2fcc$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b;
        const platformLogger = this.container.getProvider('platform-logger').getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = $20bc1f3a4bda2fcc$var$getUTCDateString();
        if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
            this._heartbeatsCache = await this._heartbeatsCachePromise;
            // If we failed to construct a heartbeats cache, then return immediately.
            if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return;
        }
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
        else // There is no entry for this date. Create one.
        this._heartbeatsCache.heartbeats.push({
            date: date,
            agent: agent
        });
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= $20bc1f3a4bda2fcc$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
        // If it's still null or the array is empty, there is no data to send.
        if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return '';
        const date = $20bc1f3a4bda2fcc$var$getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $20bc1f3a4bda2fcc$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = (0, $f3f8f86b339a1e6d$export$4b5284a3025a455)(JSON.stringify({
            version: 2,
            heartbeats: heartbeatsToSend
        }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        } else {
            this._heartbeatsCache.heartbeats = [];
            // Do not wait for this, to reduce latency.
            this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
}
function $20bc1f3a4bda2fcc$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $20bc1f3a4bda2fcc$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $20bc1f3a4bda2fcc$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($20bc1f3a4bda2fcc$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($20bc1f3a4bda2fcc$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $20bc1f3a4bda2fcc$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $f3f8f86b339a1e6d$export$3865db50535c2055)()) return false;
        else return (0, $f3f8f86b339a1e6d$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $20bc1f3a4bda2fcc$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $20bc1f3a4bda2fcc$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $20bc1f3a4bda2fcc$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $20bc1f3a4bda2fcc$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $f3f8f86b339a1e6d$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $20bc1f3a4bda2fcc$var$registerCoreComponents(variant) {
    $20bc1f3a4bda2fcc$export$c930050e7bb63965(new (0, $4f822ea27f1bba54$export$16fa2f45be04daa8)('platform-logger', (container)=>new $20bc1f3a4bda2fcc$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $20bc1f3a4bda2fcc$export$c930050e7bb63965(new (0, $4f822ea27f1bba54$export$16fa2f45be04daa8)('heartbeat', (container)=>new $20bc1f3a4bda2fcc$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $20bc1f3a4bda2fcc$export$d29d5299a7137abc($20bc1f3a4bda2fcc$var$name$o, $20bc1f3a4bda2fcc$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $20bc1f3a4bda2fcc$export$d29d5299a7137abc($20bc1f3a4bda2fcc$var$name$o, $20bc1f3a4bda2fcc$var$version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    $20bc1f3a4bda2fcc$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $20bc1f3a4bda2fcc$var$registerCoreComponents('');


var $1f7af4b06747c90c$var$name = "firebase";
var $1f7af4b06747c90c$var$version = "10.8.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $20bc1f3a4bda2fcc$export$d29d5299a7137abc)($1f7af4b06747c90c$var$name, $1f7af4b06747c90c$var$version, 'app');


const $1215ada47e250a1e$var$firebaseConfig = {
    apiKey: "AIzaSyB_-VPHtRdr98Pi9v89R9wlZuvSKHVsX2U",
    authDomain: "jigsolve-3dc25.firebaseapp.com",
    projectId: "jigsolve-3dc25",
    storageBucket: "jigsolve-3dc25.appspot.com",
    messagingSenderId: "643437935397",
    appId: "1:643437935397:web:230a28d4f179b0458938cc"
};
(0, $20bc1f3a4bda2fcc$export$c55cfd413944906d)($1215ada47e250a1e$var$firebaseConfig);






var $bunH6 = parcelRequire("bunH6");

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $de660e99e3126d7c$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: 'phone',
    TOTP: 'totp'
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $de660e99e3126d7c$export$ffb5f4729a158638 = {
    /** Facebook provider ID */ FACEBOOK: 'facebook.com',
    /** GitHub provider ID */ GITHUB: 'github.com',
    /** Google provider ID */ GOOGLE: 'google.com',
    /** Password provider */ PASSWORD: 'password',
    /** Phone provider */ PHONE: 'phone',
    /** Twitter provider ID */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $de660e99e3126d7c$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: 'emailLink',
    /** Email/password sign in method */ EMAIL_PASSWORD: 'password',
    /** Facebook sign in method */ FACEBOOK: 'facebook.com',
    /** GitHub sign in method */ GITHUB: 'github.com',
    /** Google sign in method */ GOOGLE: 'google.com',
    /** Phone sign in method */ PHONE: 'phone',
    /** Twitter sign in method */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $de660e99e3126d7c$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: 'link',
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: 'reauthenticate',
    /** Operation involving signing in a user. */ SIGN_IN: 'signIn'
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $de660e99e3126d7c$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: 'EMAIL_SIGNIN',
    /** The password reset action. */ PASSWORD_RESET: 'PASSWORD_RESET',
    /** The email revocation action. */ RECOVER_EMAIL: 'RECOVER_EMAIL',
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: 'REVERT_SECOND_FACTOR_ADDITION',
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: 'VERIFY_AND_CHANGE_EMAIL',
    /** The email verification action. */ VERIFY_EMAIL: 'VERIFY_EMAIL'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $de660e99e3126d7c$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: 'This operation is restricted to administrators only.',
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: '',
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: 'Cordova framework is not ready.',
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: 'This browser is not supported.',
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: 'This credential is already associated with a different user account.',
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: 'The custom token corresponds to a different audience.',
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: 'Multi-factor users must always have a verified email.',
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: 'The email address is already in use by another account.',
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: 'The action code has expired.',
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: 'This operation has been cancelled due to another conflicting popup being opened.',
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: 'An internal AuthError has occurred.',
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: 'The mobile app identifier is not registed for the current project.',
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: 'The continue URL provided in the request is invalid.',
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: 'The custom token format is incorrect. Please check the documentation.',
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: 'The provided dynamic link domain is not configured or authorized for the current project.',
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: 'The email address is badly formatted.',
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: 'Emulator URL must start with a valid scheme (http:// or https://).',
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: 'Your API key is invalid, please check you have copied it correctly.',
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: 'The SHA-1 certificate hash provided is invalid.',
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: 'The supplied auth credential is incorrect, malformed or has expired.',
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: 'The request does not contain a valid proof of first factor successful sign-in.',
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: 'The password is invalid or the user does not have a password.',
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: 'The specified persistence type is invalid. It can only be local, session or none.',
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: 'The specified provider ID is invalid.',
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: 'The verification ID used to create the phone auth credential is invalid.',
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: 'Login blocked by user-provided method: {$originalMessage}',
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: 'An Android Package Name must be provided if the Android App is required to be installed.',
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: 'The phone auth credential was created with an empty SMS verification code.',
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: 'A continue URL must be provided in the request.',
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: 'An internal AuthError has occurred.',
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: 'An iOS Bundle ID must be provided if an App Store ID is provided.',
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: 'A non-empty password must be provided',
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: 'No second factor identifier is provided.',
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: 'The request is missing proof of first factor successful sign-in.',
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: 'To send verification codes, provide a phone number for the recipient.',
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: 'The phone auth credential was created with an empty verification ID.',
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: 'This instance of FirebaseApp has been deleted.',
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: 'The user does not have a second factor matching the identifier provided.',
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: 'Proof of ownership of a second factor is required to complete sign-in.',
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: 'A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.',
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: 'User was not linked to an account with the given provider.',
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: 'Unable to establish a connection with the popup. It may have been blocked by the browser.',
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: 'The popup has been closed by the user before finalizing the operation.',
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: 'User can only be linked to one identity for the given provider.',
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: 'The redirect operation has been cancelled by the user before finalizing.',
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: 'A redirect sign-in operation is already pending.',
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: 'The request contains malformed or mismatching credentials.',
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: 'The second factor is already enrolled on this account.',
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: 'The maximum allowed number of second factors on a user has been exceeded.',
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: 'The operation has timed out.',
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: 'Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.',
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: 'The current environment does not support the specified persistence type.',
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: 'This operation is not supported in a multi-tenant context.',
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: 'The operation requires a verified email.',
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: 'The user did not grant your application the permissions it requested.',
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: 'The user account has been disabled by an administrator.',
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: 'The supplied credentials do not correspond to the previously signed in user.',
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: '',
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: 'The password must be 6 characters long or more.',
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: 'This browser is not supported or 3rd party cookies and data may be disabled.',
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is missing when sending request to the backend.',
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is invalid when sending request to the backend.',
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: 'The reCAPTCHA action is invalid when sending request to the backend.',
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: 'reCAPTCHA Enterprise integration is not enabled for this project.',
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: 'The reCAPTCHA client type is missing when sending request to the backend.',
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is missing when sending request to the backend.',
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: 'Invalid request parameters.',
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is invalid when sending request to the backend.',
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: 'The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.',
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: 'The password does not meet the requirements.'
    };
}
function $de660e99e3126d7c$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $de660e99e3126d7c$export$2329c99376c9d0a4 = $de660e99e3126d7c$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $de660e99e3126d7c$export$7f8ddf7c7c20b3cd = $de660e99e3126d7c$var$_prodErrorMap;
const $de660e99e3126d7c$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $f3f8f86b339a1e6d$export$3fa6e1b18a3b2d40)('auth', 'Firebase', $de660e99e3126d7c$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $de660e99e3126d7c$export$9bb611d729802a56 = {
    ADMIN_ONLY_OPERATION: 'auth/admin-restricted-operation',
    ARGUMENT_ERROR: 'auth/argument-error',
    APP_NOT_AUTHORIZED: 'auth/app-not-authorized',
    APP_NOT_INSTALLED: 'auth/app-not-installed',
    CAPTCHA_CHECK_FAILED: 'auth/captcha-check-failed',
    CODE_EXPIRED: 'auth/code-expired',
    CORDOVA_NOT_READY: 'auth/cordova-not-ready',
    CORS_UNSUPPORTED: 'auth/cors-unsupported',
    CREDENTIAL_ALREADY_IN_USE: 'auth/credential-already-in-use',
    CREDENTIAL_MISMATCH: 'auth/custom-token-mismatch',
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: 'auth/requires-recent-login',
    DEPENDENT_SDK_INIT_BEFORE_AUTH: 'auth/dependent-sdk-initialized-before-auth',
    DYNAMIC_LINK_NOT_ACTIVATED: 'auth/dynamic-link-not-activated',
    EMAIL_CHANGE_NEEDS_VERIFICATION: 'auth/email-change-needs-verification',
    EMAIL_EXISTS: 'auth/email-already-in-use',
    EMULATOR_CONFIG_FAILED: 'auth/emulator-config-failed',
    EXPIRED_OOB_CODE: 'auth/expired-action-code',
    EXPIRED_POPUP_REQUEST: 'auth/cancelled-popup-request',
    INTERNAL_ERROR: 'auth/internal-error',
    INVALID_API_KEY: 'auth/invalid-api-key',
    INVALID_APP_CREDENTIAL: 'auth/invalid-app-credential',
    INVALID_APP_ID: 'auth/invalid-app-id',
    INVALID_AUTH: 'auth/invalid-user-token',
    INVALID_AUTH_EVENT: 'auth/invalid-auth-event',
    INVALID_CERT_HASH: 'auth/invalid-cert-hash',
    INVALID_CODE: 'auth/invalid-verification-code',
    INVALID_CONTINUE_URI: 'auth/invalid-continue-uri',
    INVALID_CORDOVA_CONFIGURATION: 'auth/invalid-cordova-configuration',
    INVALID_CUSTOM_TOKEN: 'auth/invalid-custom-token',
    INVALID_DYNAMIC_LINK_DOMAIN: 'auth/invalid-dynamic-link-domain',
    INVALID_EMAIL: 'auth/invalid-email',
    INVALID_EMULATOR_SCHEME: 'auth/invalid-emulator-scheme',
    INVALID_IDP_RESPONSE: 'auth/invalid-credential',
    INVALID_LOGIN_CREDENTIALS: 'auth/invalid-credential',
    INVALID_MESSAGE_PAYLOAD: 'auth/invalid-message-payload',
    INVALID_MFA_SESSION: 'auth/invalid-multi-factor-session',
    INVALID_OAUTH_CLIENT_ID: 'auth/invalid-oauth-client-id',
    INVALID_OAUTH_PROVIDER: 'auth/invalid-oauth-provider',
    INVALID_OOB_CODE: 'auth/invalid-action-code',
    INVALID_ORIGIN: 'auth/unauthorized-domain',
    INVALID_PASSWORD: 'auth/wrong-password',
    INVALID_PERSISTENCE: 'auth/invalid-persistence-type',
    INVALID_PHONE_NUMBER: 'auth/invalid-phone-number',
    INVALID_PROVIDER_ID: 'auth/invalid-provider-id',
    INVALID_RECIPIENT_EMAIL: 'auth/invalid-recipient-email',
    INVALID_SENDER: 'auth/invalid-sender',
    INVALID_SESSION_INFO: 'auth/invalid-verification-id',
    INVALID_TENANT_ID: 'auth/invalid-tenant-id',
    MFA_INFO_NOT_FOUND: 'auth/multi-factor-info-not-found',
    MFA_REQUIRED: 'auth/multi-factor-auth-required',
    MISSING_ANDROID_PACKAGE_NAME: 'auth/missing-android-pkg-name',
    MISSING_APP_CREDENTIAL: 'auth/missing-app-credential',
    MISSING_AUTH_DOMAIN: 'auth/auth-domain-config-required',
    MISSING_CODE: 'auth/missing-verification-code',
    MISSING_CONTINUE_URI: 'auth/missing-continue-uri',
    MISSING_IFRAME_START: 'auth/missing-iframe-start',
    MISSING_IOS_BUNDLE_ID: 'auth/missing-ios-bundle-id',
    MISSING_OR_INVALID_NONCE: 'auth/missing-or-invalid-nonce',
    MISSING_MFA_INFO: 'auth/missing-multi-factor-info',
    MISSING_MFA_SESSION: 'auth/missing-multi-factor-session',
    MISSING_PHONE_NUMBER: 'auth/missing-phone-number',
    MISSING_SESSION_INFO: 'auth/missing-verification-id',
    MODULE_DESTROYED: 'auth/app-deleted',
    NEED_CONFIRMATION: 'auth/account-exists-with-different-credential',
    NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
    NULL_USER: 'auth/null-user',
    NO_AUTH_EVENT: 'auth/no-auth-event',
    NO_SUCH_PROVIDER: 'auth/no-such-provider',
    OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
    OPERATION_NOT_SUPPORTED: 'auth/operation-not-supported-in-this-environment',
    POPUP_BLOCKED: 'auth/popup-blocked',
    POPUP_CLOSED_BY_USER: 'auth/popup-closed-by-user',
    PROVIDER_ALREADY_LINKED: 'auth/provider-already-linked',
    QUOTA_EXCEEDED: 'auth/quota-exceeded',
    REDIRECT_CANCELLED_BY_USER: 'auth/redirect-cancelled-by-user',
    REDIRECT_OPERATION_PENDING: 'auth/redirect-operation-pending',
    REJECTED_CREDENTIAL: 'auth/rejected-credential',
    SECOND_FACTOR_ALREADY_ENROLLED: 'auth/second-factor-already-in-use',
    SECOND_FACTOR_LIMIT_EXCEEDED: 'auth/maximum-second-factor-count-exceeded',
    TENANT_ID_MISMATCH: 'auth/tenant-id-mismatch',
    TIMEOUT: 'auth/timeout',
    TOKEN_EXPIRED: 'auth/user-token-expired',
    TOO_MANY_ATTEMPTS_TRY_LATER: 'auth/too-many-requests',
    UNAUTHORIZED_DOMAIN: 'auth/unauthorized-continue-uri',
    UNSUPPORTED_FIRST_FACTOR: 'auth/unsupported-first-factor',
    UNSUPPORTED_PERSISTENCE: 'auth/unsupported-persistence-type',
    UNSUPPORTED_TENANT_OPERATION: 'auth/unsupported-tenant-operation',
    UNVERIFIED_EMAIL: 'auth/unverified-email',
    USER_CANCELLED: 'auth/user-cancelled',
    USER_DELETED: 'auth/user-not-found',
    USER_DISABLED: 'auth/user-disabled',
    USER_MISMATCH: 'auth/user-mismatch',
    USER_SIGNED_OUT: 'auth/user-signed-out',
    WEAK_PASSWORD: 'auth/weak-password',
    WEB_STORAGE_UNSUPPORTED: 'auth/web-storage-unsupported',
    ALREADY_INITIALIZED: 'auth/already-initialized',
    RECAPTCHA_NOT_ENABLED: 'auth/recaptcha-not-enabled',
    MISSING_RECAPTCHA_TOKEN: 'auth/missing-recaptcha-token',
    INVALID_RECAPTCHA_TOKEN: 'auth/invalid-recaptcha-token',
    INVALID_RECAPTCHA_ACTION: 'auth/invalid-recaptcha-action',
    MISSING_CLIENT_TYPE: 'auth/missing-client-type',
    MISSING_RECAPTCHA_VERSION: 'auth/missing-recaptcha-version',
    INVALID_RECAPTCHA_VERSION: 'auth/invalid-recaptcha-version',
    INVALID_REQ_TYPE: 'auth/invalid-req-type'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $de660e99e3126d7c$var$logClient = new (0, $a3250d6c1176d992$export$efa9a398d6368992)('@firebase/auth');
function $de660e99e3126d7c$var$_logWarn(msg, ...args) {
    if ($de660e99e3126d7c$var$logClient.logLevel <= (0, $a3250d6c1176d992$export$243e62d78d3b544d).WARN) $de660e99e3126d7c$var$logClient.warn(`Auth (${(0, $20bc1f3a4bda2fcc$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
function $de660e99e3126d7c$var$_logError(msg, ...args) {
    if ($de660e99e3126d7c$var$logClient.logLevel <= (0, $a3250d6c1176d992$export$243e62d78d3b544d).ERROR) $de660e99e3126d7c$var$logClient.error(`Auth (${(0, $20bc1f3a4bda2fcc$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $de660e99e3126d7c$export$9fa96a7d116ea3ce(authOrCode, ...rest) {
    throw $de660e99e3126d7c$var$createErrorInternal(authOrCode, ...rest);
}
function $de660e99e3126d7c$export$9d398bebfec1c039(authOrCode, ...rest) {
    return $de660e99e3126d7c$var$createErrorInternal(authOrCode, ...rest);
}
function $de660e99e3126d7c$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, $de660e99e3126d7c$export$7f8ddf7c7c20b3cd()), {
        [code]: message
    });
    const factory = new (0, $f3f8f86b339a1e6d$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $de660e99e3126d7c$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $de660e99e3126d7c$export$9fa96a7d116ea3ce(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $de660e99e3126d7c$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $de660e99e3126d7c$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== 'string') {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $de660e99e3126d7c$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $de660e99e3126d7c$export$890c4ad488842ce7(assertion, authOrCode, ...rest) {
    if (!assertion) throw $de660e99e3126d7c$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $de660e99e3126d7c$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $de660e99e3126d7c$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $de660e99e3126d7c$export$1fbe638ecf81657e(assertion, message) {
    if (!assertion) $de660e99e3126d7c$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $de660e99e3126d7c$var$_getCurrentUrl() {
    var _a;
    return typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || '';
}
function $de660e99e3126d7c$var$_isHttpOrHttps() {
    return $de660e99e3126d7c$var$_getCurrentScheme() === 'http:' || $de660e99e3126d7c$var$_getCurrentScheme() === 'https:';
}
function $de660e99e3126d7c$var$_getCurrentScheme() {
    var _a;
    return typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $de660e99e3126d7c$var$_isOnline() {
    if (typeof navigator !== 'undefined' && navigator && 'onLine' in navigator && typeof navigator.onLine === 'boolean' && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($de660e99e3126d7c$var$_isHttpOrHttps() || (0, $f3f8f86b339a1e6d$export$caa8774a9107a58e)() || 'connection' in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $de660e99e3126d7c$var$_getUserLanguage() {
    if (typeof navigator === 'undefined') return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $de660e99e3126d7c$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $de660e99e3126d7c$export$1fbe638ecf81657e(longDelay > shortDelay, 'Short delay should be less than long delay!');
        this.isMobile = (0, $f3f8f86b339a1e6d$export$872f8323f01d7ae0)() || (0, $f3f8f86b339a1e6d$export$f7a1e23e542d38e3)();
    }
    get() {
        if (!$de660e99e3126d7c$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $de660e99e3126d7c$var$_emulatorUrl(config, path) {
    $de660e99e3126d7c$export$1fbe638ecf81657e(config.emulator, 'Emulator should always be set here');
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith('/') ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $de660e99e3126d7c$export$2ed0fc6709e59212 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== 'undefined' && 'fetch' in self) return self.fetch;
        if (typeof globalThis !== 'undefined' && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== 'undefined') return fetch;
        $de660e99e3126d7c$var$debugFail('Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== 'undefined' && 'Headers' in self) return self.Headers;
        if (typeof globalThis !== 'undefined' && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== 'undefined') return Headers;
        $de660e99e3126d7c$var$debugFail('Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== 'undefined' && 'Response' in self) return self.Response;
        if (typeof globalThis !== 'undefined' && globalThis.Response) return globalThis.Response;
        if (typeof Response !== 'undefined') return Response;
        $de660e99e3126d7c$var$debugFail('Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $de660e99e3126d7c$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $de660e99e3126d7c$var$DEFAULT_API_TIMEOUT_MS = new $de660e99e3126d7c$var$Delay(30000, 60000);
function $de660e99e3126d7c$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function $de660e99e3126d7c$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $de660e99e3126d7c$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $f3f8f86b339a1e6d$export$ac4103b836844853)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/json';
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        return $de660e99e3126d7c$export$2ed0fc6709e59212.fetch()($de660e99e3126d7c$var$_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({
            method: method,
            headers: headers,
            referrerPolicy: 'no-referrer'
        }, body));
    });
}
async function $de660e99e3126d7c$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, $de660e99e3126d7c$var$SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new $de660e99e3126d7c$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ('needConfirmation' in json) throw $de660e99e3126d7c$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !('errorMessage' in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(' : ');
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $de660e99e3126d7c$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $de660e99e3126d7c$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $de660e99e3126d7c$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, '-');
            if (serverErrorMessage) throw $de660e99e3126d7c$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $de660e99e3126d7c$export$9fa96a7d116ea3ce(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $f3f8f86b339a1e6d$export$dd24e9cd51226c56)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $de660e99e3126d7c$export$9fa96a7d116ea3ce(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            'message': String(e)
        });
    }
}
async function $de660e99e3126d7c$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $de660e99e3126d7c$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ('mfaPendingCredential' in serverResponse) $de660e99e3126d7c$export$9fa96a7d116ea3ce(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
function $de660e99e3126d7c$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) return `${auth.config.apiScheme}://${base}`;
    return $de660e99e3126d7c$var$_emulatorUrl(auth.config, base);
}
function $de660e99e3126d7c$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case 'ENFORCE':
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case 'AUDIT':
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case 'OFF':
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class $de660e99e3126d7c$var$NetworkTimeout {
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($de660e99e3126d7c$export$9d398bebfec1c039(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $de660e99e3126d7c$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
}
function $de660e99e3126d7c$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $de660e99e3126d7c$export$9d398bebfec1c039(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $de660e99e3126d7c$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $de660e99e3126d7c$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $de660e99e3126d7c$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = '';
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error('recaptchaKey undefined');
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split('/')[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $de660e99e3126d7c$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $de660e99e3126d7c$var$getRecaptchaParams(auth) {
    return (await $de660e99e3126d7c$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || '';
}
async function $de660e99e3126d7c$var$getRecaptchaConfig(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $de660e99e3126d7c$var$deleteAccount(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $de660e99e3126d7c$var$deleteLinkedAccounts(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $de660e99e3126d7c$var$getAccountInfo(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $de660e99e3126d7c$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $de660e99e3126d7c$export$306ddfe3a8403e2(user, forceRefresh = false) {
    return (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $de660e99e3126d7c$export$7a38258bbe170828(user, forceRefresh = false) {
    const userInternal = (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $de660e99e3126d7c$var$_parseToken(token);
    $de660e99e3126d7c$export$890c4ad488842ce7(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === 'object' ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_provider'];
    return {
        claims: claims,
        token: token,
        authTime: $de660e99e3126d7c$var$utcTimestampToDateString($de660e99e3126d7c$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $de660e99e3126d7c$var$utcTimestampToDateString($de660e99e3126d7c$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $de660e99e3126d7c$var$utcTimestampToDateString($de660e99e3126d7c$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_second_factor']) || null
    };
}
function $de660e99e3126d7c$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $de660e99e3126d7c$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split('.');
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $de660e99e3126d7c$var$_logError('JWT malformed, contained fewer than 3 sections');
        return null;
    }
    try {
        const decoded = (0, $f3f8f86b339a1e6d$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $de660e99e3126d7c$var$_logError('Failed to decode base64 JWT payload');
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $de660e99e3126d7c$var$_logError('Caught error parsing JWT payload as JSON', e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $de660e99e3126d7c$var$_tokenExpiresIn(token) {
    const parsedToken = $de660e99e3126d7c$var$_parseToken(token);
    $de660e99e3126d7c$export$890c4ad488842ce7(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $de660e99e3126d7c$export$890c4ad488842ce7(typeof parsedToken.exp !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $de660e99e3126d7c$export$890c4ad488842ce7(typeof parsedToken.iat !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $de660e99e3126d7c$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $f3f8f86b339a1e6d$export$dd24e9cd51226c56) && $de660e99e3126d7c$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $de660e99e3126d7c$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $de660e99e3126d7c$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $de660e99e3126d7c$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $de660e99e3126d7c$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $de660e99e3126d7c$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $de660e99e3126d7c$var$_reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $de660e99e3126d7c$var$_logoutIfInvalidated(user, $de660e99e3126d7c$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $de660e99e3126d7c$export$890c4ad488842ce7(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $de660e99e3126d7c$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $de660e99e3126d7c$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $de660e99e3126d7c$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $de660e99e3126d7c$export$d24c54395ce0c509(user) {
    const userInternal = (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(user);
    await $de660e99e3126d7c$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $de660e99e3126d7c$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $de660e99e3126d7c$var$extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId: providerId } = _a, provider = (0, $bunH6.__rest)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || '',
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $de660e99e3126d7c$var$requestStsToken(auth, refreshToken) {
    const response = await $de660e99e3126d7c$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $f3f8f86b339a1e6d$export$ac4103b836844853)({
            'grant_type': 'refresh_token',
            'refresh_token': refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = $de660e99e3126d7c$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/x-www-form-urlencoded';
        return $de660e99e3126d7c$export$2ed0fc6709e59212.fetch()(url, {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function $de660e99e3126d7c$var$revokeToken(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $de660e99e3126d7c$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $de660e99e3126d7c$export$890c4ad488842ce7(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $de660e99e3126d7c$export$890c4ad488842ce7(typeof response.idToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $de660e99e3126d7c$export$890c4ad488842ce7(typeof response.refreshToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = 'expiresIn' in response && typeof response.expiresIn !== 'undefined' ? Number(response.expiresIn) : $de660e99e3126d7c$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        $de660e99e3126d7c$export$890c4ad488842ce7(!this.accessToken || this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $de660e99e3126d7c$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $de660e99e3126d7c$var$StsTokenManager();
        if (refreshToken) {
            $de660e99e3126d7c$export$890c4ad488842ce7(typeof refreshToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $de660e99e3126d7c$export$890c4ad488842ce7(typeof accessToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $de660e99e3126d7c$export$890c4ad488842ce7(typeof expirationTime === 'number', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $de660e99e3126d7c$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $de660e99e3126d7c$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $de660e99e3126d7c$var$assertStringOrUndefined(assertion, appName) {
    $de660e99e3126d7c$export$890c4ad488842ce7(typeof assertion === 'string' || typeof assertion === 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $de660e99e3126d7c$export$23ebac1979863676 {
    constructor(_a){
        var { uid: uid, auth: auth, stsTokenManager: stsTokenManager } = _a, opt = (0, $bunH6.__rest)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $de660e99e3126d7c$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $de660e99e3126d7c$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $de660e99e3126d7c$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $de660e99e3126d7c$export$890c4ad488842ce7(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $de660e99e3126d7c$export$7a38258bbe170828(this, forceRefresh);
    }
    reload() {
        return $de660e99e3126d7c$export$d24c54395ce0c509(this);
    }
    _assign(user) {
        if (this === user) return;
        $de660e99e3126d7c$export$890c4ad488842ce7(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $de660e99e3126d7c$export$23ebac1979863676(Object.assign(Object.assign({}, this), {
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $de660e99e3126d7c$export$890c4ad488842ce7(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $de660e99e3126d7c$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        const idToken = await this.getIdToken();
        await $de660e99e3126d7c$var$_logoutIfInvalidated(this, $de660e99e3126d7c$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || '';
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $de660e99e3126d7c$export$890c4ad488842ce7(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $de660e99e3126d7c$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $de660e99e3126d7c$export$890c4ad488842ce7(typeof uid === 'string', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $de660e99e3126d7c$var$assertStringOrUndefined(displayName, auth.name);
        $de660e99e3126d7c$var$assertStringOrUndefined(email, auth.name);
        $de660e99e3126d7c$export$890c4ad488842ce7(typeof emailVerified === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $de660e99e3126d7c$export$890c4ad488842ce7(typeof isAnonymous === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $de660e99e3126d7c$var$assertStringOrUndefined(phoneNumber, auth.name);
        $de660e99e3126d7c$var$assertStringOrUndefined(photoURL, auth.name);
        $de660e99e3126d7c$var$assertStringOrUndefined(tenantId, auth.name);
        $de660e99e3126d7c$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $de660e99e3126d7c$var$assertStringOrUndefined(createdAt, auth.name);
        $de660e99e3126d7c$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $de660e99e3126d7c$export$23ebac1979863676({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $de660e99e3126d7c$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $de660e99e3126d7c$export$23ebac1979863676({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $de660e99e3126d7c$var$_reloadWithoutSaving(user);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $de660e99e3126d7c$var$instanceCache = new Map();
function $de660e99e3126d7c$export$158acd800e1ef08b(cls) {
    $de660e99e3126d7c$export$1fbe638ecf81657e(cls instanceof Function, 'Expected a class definition');
    let instance = $de660e99e3126d7c$var$instanceCache.get(cls);
    if (instance) {
        $de660e99e3126d7c$export$1fbe638ecf81657e(instance instanceof cls, 'Instance stored in cache mismatched with class');
        return instance;
    }
    instance = new cls();
    $de660e99e3126d7c$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $de660e99e3126d7c$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$de660e99e3126d7c$var$InMemoryPersistence.type = 'NONE';
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $de660e99e3126d7c$export$3a6d5c9ae78a2c08 = $de660e99e3126d7c$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $de660e99e3126d7c$export$cf2f7c5792f80b46(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $de660e99e3126d7c$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $de660e99e3126d7c$export$cf2f7c5792f80b46(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $de660e99e3126d7c$export$cf2f7c5792f80b46("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? $de660e99e3126d7c$export$23ebac1979863676._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $de660e99e3126d7c$var$PersistenceUserManager($de660e99e3126d7c$export$158acd800e1ef08b($de660e99e3126d7c$export$3a6d5c9ae78a2c08), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $de660e99e3126d7c$export$158acd800e1ef08b($de660e99e3126d7c$export$3a6d5c9ae78a2c08);
        const key = $de660e99e3126d7c$export$cf2f7c5792f80b46(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                const user = $de660e99e3126d7c$export$23ebac1979863676._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $de660e99e3126d7c$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new $de660e99e3126d7c$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $de660e99e3126d7c$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes('opera/') || ua.includes('opr/') || ua.includes('opios/')) return "Opera" /* BrowserName.OPERA */ ;
    else if ($de660e99e3126d7c$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes('msie') || ua.includes('trident/')) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes('edge/')) return "Edge" /* BrowserName.EDGE */ ;
    else if ($de660e99e3126d7c$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes('silk/')) return "Silk" /* BrowserName.SILK */ ;
    else if ($de660e99e3126d7c$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($de660e99e3126d7c$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($de660e99e3126d7c$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes('chrome/') || $de660e99e3126d7c$var$_isChromeIOS(ua)) && !ua.includes('edge/')) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($de660e99e3126d7c$export$92108d983e8ee699(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $de660e99e3126d7c$var$_isFirefox(ua = (0, $f3f8f86b339a1e6d$export$c36915b22ce77c19)()) {
    return /firefox\//i.test(ua);
}
function $de660e99e3126d7c$var$_isSafari(userAgent = (0, $f3f8f86b339a1e6d$export$c36915b22ce77c19)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes('safari/') && !ua.includes('chrome/') && !ua.includes('crios/') && !ua.includes('android');
}
function $de660e99e3126d7c$var$_isChromeIOS(ua = (0, $f3f8f86b339a1e6d$export$c36915b22ce77c19)()) {
    return /crios\//i.test(ua);
}
function $de660e99e3126d7c$var$_isIEMobile(ua = (0, $f3f8f86b339a1e6d$export$c36915b22ce77c19)()) {
    return /iemobile/i.test(ua);
}
function $de660e99e3126d7c$export$92108d983e8ee699(ua = (0, $f3f8f86b339a1e6d$export$c36915b22ce77c19)()) {
    return /android/i.test(ua);
}
function $de660e99e3126d7c$var$_isBlackBerry(ua = (0, $f3f8f86b339a1e6d$export$c36915b22ce77c19)()) {
    return /blackberry/i.test(ua);
}
function $de660e99e3126d7c$var$_isWebOS(ua = (0, $f3f8f86b339a1e6d$export$c36915b22ce77c19)()) {
    return /webos/i.test(ua);
}
function $de660e99e3126d7c$export$d66dc83d8cfc8dd(ua = (0, $f3f8f86b339a1e6d$export$c36915b22ce77c19)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $de660e99e3126d7c$export$91c6e00c14e7e6fd(ua = (0, $f3f8f86b339a1e6d$export$c36915b22ce77c19)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $de660e99e3126d7c$var$_isIOSStandalone(ua = (0, $f3f8f86b339a1e6d$export$c36915b22ce77c19)()) {
    var _a;
    return $de660e99e3126d7c$export$d66dc83d8cfc8dd(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $de660e99e3126d7c$var$_isIE10() {
    return (0, $f3f8f86b339a1e6d$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $de660e99e3126d7c$var$_isMobileBrowser(ua = (0, $f3f8f86b339a1e6d$export$c36915b22ce77c19)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $de660e99e3126d7c$export$d66dc83d8cfc8dd(ua) || $de660e99e3126d7c$export$92108d983e8ee699(ua) || $de660e99e3126d7c$var$_isWebOS(ua) || $de660e99e3126d7c$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $de660e99e3126d7c$var$_isIEMobile(ua);
}
function $de660e99e3126d7c$var$_isIframe() {
    try {
        // Check that the current window is not the top window.
        // If so, return true.
        return !!(window && window !== window.top);
    } catch (e) {
        return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $de660e99e3126d7c$export$9f4f30ee63539e24(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $de660e99e3126d7c$var$_getBrowserName((0, $f3f8f86b339a1e6d$export$c36915b22ce77c19)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$de660e99e3126d7c$var$_getBrowserName((0, $f3f8f86b339a1e6d$export$c36915b22ce77c19)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(',') : 'FirebaseCore-web'; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $20bc1f3a4bda2fcc$export$31499a9cd224b78c}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $de660e99e3126d7c$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e === null || e === void 0 ? void 0 : e.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $de660e99e3126d7c$var$_getPasswordPolicy(auth, request = {}) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $de660e99e3126d7c$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $de660e99e3126d7c$var$PasswordPolicyImpl {
    constructor(response){
        var _a, _b, _c, _d;
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : $de660e99e3126d7c$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === 'ENFORCEMENT_STATE_UNSPECIFIED') this.enforcementState = 'OFF';
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join('')) !== null && _c !== void 0 ? _c : '';
        this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        var _a, _b, _c, _d, _e, _f;
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
        status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
        status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
        status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
        status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
        status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= 'a' && passwordChar <= 'z', /* containsUppercaseCharacter= */ passwordChar >= 'A' && passwordChar <= 'Z', /* containsNumericCharacter= */ passwordChar >= '0' && passwordChar <= '9', /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $de660e99e3126d7c$export$91477dc880baac21 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $de660e99e3126d7c$var$Subscription(this);
        this.idTokenSubscription = new $de660e99e3126d7c$var$Subscription(this);
        this.beforeStateQueue = new $de660e99e3126d7c$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $de660e99e3126d7c$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $de660e99e3126d7c$export$158acd800e1ef08b(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b;
            if (this._deleted) return;
            this.persistenceManager = await $de660e99e3126d7c$var$PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $de660e99e3126d7c$export$890c4ad488842ce7(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $de660e99e3126d7c$var$_reloadWithoutSaving(user);
        } catch (e) {
            if ((e === null || e === void 0 ? void 0 : e.code) !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $de660e99e3126d7c$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(userExtern) : null;
        if (user) $de660e99e3126d7c$export$890c4ad488842ce7(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $de660e99e3126d7c$export$890c4ad488842ce7(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($de660e99e3126d7c$export$158acd800e1ef08b(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $de660e99e3126d7c$var$_getPasswordPolicy(this);
        const passwordPolicy = new $de660e99e3126d7c$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $f3f8f86b339a1e6d$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: 'apple.com',
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token: token,
                idToken: idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await $de660e99e3126d7c$var$revokeToken(this, request);
        }
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $de660e99e3126d7c$export$158acd800e1ef08b(popupRedirectResolver) || this._popupRedirectResolver;
            $de660e99e3126d7c$export$890c4ad488842ce7(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $de660e99e3126d7c$var$PersistenceUserManager.create(this, [
                $de660e99e3126d7c$export$158acd800e1ef08b(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === 'function' ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $de660e99e3126d7c$export$890c4ad488842ce7(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === 'function') {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $de660e99e3126d7c$export$890c4ad488842ce7(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $de660e99e3126d7c$export$9f4f30ee63539e24(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        var _a;
        const appCheckTokenResult = await ((_a = this.appCheckServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getToken());
        if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $de660e99e3126d7c$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token;
    }
}
/**
 * Method to be used to cast down to our private implmentation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $de660e99e3126d7c$export$a05254e7c3aeba6e(auth) {
    return (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ class $de660e99e3126d7c$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $f3f8f86b339a1e6d$export$364097d812234b3f)((observer)=>this.observer = observer);
    }
    get next() {
        $de660e99e3126d7c$export$890c4ad488842ce7(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $de660e99e3126d7c$var$externalJSProvider = {
    async loadJS () {
        throw new Error('Unable to load external scripts');
    },
    recaptchaV2Script: '',
    recaptchaEnterpriseScript: '',
    gapiScript: ''
};
function $de660e99e3126d7c$var$_setExternalJSProvider(p) {
    $de660e99e3126d7c$var$externalJSProvider = p;
}
function $de660e99e3126d7c$var$_loadJS(url) {
    return $de660e99e3126d7c$var$externalJSProvider.loadJS(url);
}
function $de660e99e3126d7c$var$_recaptchaV2ScriptUrl() {
    return $de660e99e3126d7c$var$externalJSProvider.recaptchaV2Script;
}
function $de660e99e3126d7c$var$_recaptchaEnterpriseScriptUrl() {
    return $de660e99e3126d7c$var$externalJSProvider.recaptchaEnterpriseScript;
}
function $de660e99e3126d7c$var$_gapiScriptUrl() {
    return $de660e99e3126d7c$var$externalJSProvider.gapiScript;
}
function $de660e99e3126d7c$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $de660e99e3126d7c$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = 'recaptcha-enterprise';
const $de660e99e3126d7c$var$FAKE_TOKEN = 'NO_RECAPTCHA';
class $de660e99e3126d7c$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $de660e99e3126d7c$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $de660e99e3126d7c$export$a05254e7c3aeba6e(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = 'verify', forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $de660e99e3126d7c$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error('recaptcha Enterprise site key undefined'));
                    else {
                        const config = new $de660e99e3126d7c$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($de660e99e3126d7c$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($de660e99e3126d7c$var$FAKE_TOKEN);
                });
            });
            else reject(Error('No reCAPTCHA enterprise script loaded.'));
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $de660e99e3126d7c$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === 'undefined') {
                        reject(new Error('RecaptchaVerifier is only supported in browser'));
                        return;
                    }
                    let url = $de660e99e3126d7c$var$_recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey;
                    $de660e99e3126d7c$var$_loadJS(url).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $de660e99e3126d7c$var$injectRecaptchaFields(auth, request, action, captchaResp = false) {
    const verifier = new $de660e99e3126d7c$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = Object.assign({}, request);
    if (!captchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        'captchaResp': captchaResponse
    });
    Object.assign(newRequest, {
        'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $de660e99e3126d7c$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod) {
    var _a;
    if ((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ )) {
        const requestWithRecaptcha = await $de660e99e3126d7c$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
        return actionMethod(authInstance, requestWithRecaptcha);
    } else return actionMethod(authInstance, request).catch(async (error)=>{
        if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
            console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
            const requestWithRecaptcha = await $de660e99e3126d7c$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return Promise.reject(error);
    });
}
async function $de660e99e3126d7c$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $de660e99e3126d7c$export$a05254e7c3aeba6e(auth);
    const response = await $de660e99e3126d7c$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $de660e99e3126d7c$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ )) {
        const verifier = new $de660e99e3126d7c$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $de660e99e3126d7c$export$b4171a6734a65d42(app, deps) {
    const provider = (0, $20bc1f3a4bda2fcc$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $f3f8f86b339a1e6d$export$9cb4719e2e525b7a)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $de660e99e3126d7c$export$9fa96a7d116ea3ce(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $de660e99e3126d7c$var$_initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($de660e99e3126d7c$export$158acd800e1ef08b);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $de660e99e3126d7c$export$3466f893ebf79586(auth, url, options) {
    const authInternal = $de660e99e3126d7c$export$a05254e7c3aeba6e(auth);
    $de660e99e3126d7c$export$890c4ad488842ce7(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
    $de660e99e3126d7c$export$890c4ad488842ce7(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = $de660e99e3126d7c$var$extractProtocol(url);
    const { host: host, port: port } = $de660e99e3126d7c$var$extractHostAndPort(url);
    const portStr = port === null ? '' : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(':', ''),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $de660e99e3126d7c$var$emitEmulatorWarning();
}
function $de660e99e3126d7c$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(':');
    return protocolEnd < 0 ? '' : url.substr(0, protocolEnd + 1);
}
function $de660e99e3126d7c$var$extractHostAndPort(url) {
    const protocol = $de660e99e3126d7c$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: '',
        port: null
    };
    const hostAndPort = authority[2].split('@').pop() || ''; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $de660e99e3126d7c$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(':');
        return {
            host: host,
            port: $de660e99e3126d7c$var$parsePort(port)
        };
    }
}
function $de660e99e3126d7c$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $de660e99e3126d7c$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement('p');
        const sty = el.style;
        el.innerText = 'Running in emulator mode. Do not use with production credentials.';
        sty.position = 'fixed';
        sty.width = '100%';
        sty.backgroundColor = '#ffffff';
        sty.border = '.1em solid #000000';
        sty.color = '#b50000';
        sty.bottom = '0px';
        sty.left = '0px';
        sty.margin = '0px';
        sty.zIndex = '10000';
        sty.textAlign = 'center';
        el.classList.add('firebase-emulator-warning');
        document.body.appendChild(el);
    }
    if (typeof console !== 'undefined' && typeof console.info === 'function') console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $de660e99e3126d7c$export$61196ced6d74a310 {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $de660e99e3126d7c$var$debugFail('not implemented');
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $de660e99e3126d7c$var$debugFail('not implemented');
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $de660e99e3126d7c$var$debugFail('not implemented');
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $de660e99e3126d7c$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $de660e99e3126d7c$var$resetPassword(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
async function $de660e99e3126d7c$var$updateEmailPassword(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function $de660e99e3126d7c$var$linkEmailPassword(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function $de660e99e3126d7c$var$applyActionCode$1(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $de660e99e3126d7c$var$signInWithPassword(auth, request) {
    return $de660e99e3126d7c$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
async function $de660e99e3126d7c$var$sendOobCode(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
async function $de660e99e3126d7c$var$sendEmailVerification$1(auth, request) {
    return $de660e99e3126d7c$var$sendOobCode(auth, request);
}
async function $de660e99e3126d7c$var$sendPasswordResetEmail$1(auth, request) {
    return $de660e99e3126d7c$var$sendOobCode(auth, request);
}
async function $de660e99e3126d7c$var$sendSignInLinkToEmail$1(auth, request) {
    return $de660e99e3126d7c$var$sendOobCode(auth, request);
}
async function $de660e99e3126d7c$var$verifyAndChangeEmail(auth, request) {
    return $de660e99e3126d7c$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $de660e99e3126d7c$var$signInWithEmailLink$1(auth, request) {
    return $de660e99e3126d7c$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
async function $de660e99e3126d7c$var$signInWithEmailLinkForLinking(auth, request) {
    return $de660e99e3126d7c$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $de660e99e3126d7c$export$3a1a48c8f6ef640e extends $de660e99e3126d7c$export$61196ced6d74a310 {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $de660e99e3126d7c$export$3a1a48c8f6ef640e(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $de660e99e3126d7c$export$3a1a48c8f6ef640e(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $de660e99e3126d7c$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $de660e99e3126d7c$var$signInWithPassword);
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $de660e99e3126d7c$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $de660e99e3126d7c$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $de660e99e3126d7c$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $de660e99e3126d7c$var$linkEmailPassword);
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $de660e99e3126d7c$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $de660e99e3126d7c$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $de660e99e3126d7c$var$signInWithIdp(auth, request) {
    return $de660e99e3126d7c$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $de660e99e3126d7c$var$IDP_REQUEST_URI$1 = 'http://localhost';
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $de660e99e3126d7c$export$a07804094c3ecf2d extends $de660e99e3126d7c$export$61196ced6d74a310 {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $de660e99e3126d7c$export$a07804094c3ecf2d(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $de660e99e3126d7c$export$9fa96a7d116ea3ce("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod } = obj, rest = (0, $bunH6.__rest)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new $de660e99e3126d7c$export$a07804094c3ecf2d(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $de660e99e3126d7c$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $de660e99e3126d7c$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $de660e99e3126d7c$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $de660e99e3126d7c$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody['id_token'] = this.idToken;
            if (this.accessToken) postBody['access_token'] = this.accessToken;
            if (this.secret) postBody['oauth_token_secret'] = this.secret;
            postBody['providerId'] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody['nonce'] = this.nonce;
            request.postBody = (0, $f3f8f86b339a1e6d$export$ac4103b836844853)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $de660e99e3126d7c$var$sendPhoneVerificationCode(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
async function $de660e99e3126d7c$var$signInWithPhoneNumber$1(auth, request) {
    return $de660e99e3126d7c$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
async function $de660e99e3126d7c$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $de660e99e3126d7c$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $de660e99e3126d7c$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $de660e99e3126d7c$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $de660e99e3126d7c$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: 'REAUTH'
    });
    return $de660e99e3126d7c$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, apiRequest), $de660e99e3126d7c$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $de660e99e3126d7c$export$3722cfe417b6ed86 extends $de660e99e3126d7c$export$61196ced6d74a310 {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $de660e99e3126d7c$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $de660e99e3126d7c$export$3722cfe417b6ed86({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $de660e99e3126d7c$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $de660e99e3126d7c$var$linkWithPhoneNumber$1(auth, Object.assign({
            idToken: idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $de660e99e3126d7c$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === 'string') json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $de660e99e3126d7c$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $de660e99e3126d7c$var$parseMode(mode) {
    switch(mode){
        case 'recoverEmail':
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case 'resetPassword':
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case 'signIn':
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case 'verifyEmail':
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case 'verifyAndChangeEmail':
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case 'revertSecondFactorAddition':
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $de660e99e3126d7c$var$parseDeepLink(url) {
    const link = (0, $f3f8f86b339a1e6d$export$c1271ca4c8a70741)((0, $f3f8f86b339a1e6d$export$1a8408415472d8ed)(url))['link'];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $f3f8f86b339a1e6d$export$c1271ca4c8a70741)((0, $f3f8f86b339a1e6d$export$1a8408415472d8ed)(link))['deep_link_id'] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $f3f8f86b339a1e6d$export$c1271ca4c8a70741)((0, $f3f8f86b339a1e6d$export$1a8408415472d8ed)(url))['deep_link_id'];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $f3f8f86b339a1e6d$export$c1271ca4c8a70741)((0, $f3f8f86b339a1e6d$export$1a8408415472d8ed)(iOSDeepLink))['link'] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $de660e99e3126d7c$export$f38c853ae54ed474 {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, $f3f8f86b339a1e6d$export$c1271ca4c8a70741)((0, $f3f8f86b339a1e6d$export$1a8408415472d8ed)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = $de660e99e3126d7c$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $de660e99e3126d7c$export$890c4ad488842ce7(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $de660e99e3126d7c$var$parseDeepLink(link);
        try {
            return new $de660e99e3126d7c$export$f38c853ae54ed474(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $de660e99e3126d7c$export$3b513254972cfc9c(link) {
    return $de660e99e3126d7c$export$f38c853ae54ed474.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $de660e99e3126d7c$export$e7c866399fa523f5 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $de660e99e3126d7c$export$e7c866399fa523f5.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $de660e99e3126d7c$export$3a1a48c8f6ef640e._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $de660e99e3126d7c$export$f38c853ae54ed474.parseLink(emailLink);
        $de660e99e3126d7c$export$890c4ad488842ce7(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $de660e99e3126d7c$export$3a1a48c8f6ef640e._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $de660e99e3126d7c$export$e7c866399fa523f5.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $de660e99e3126d7c$export$e7c866399fa523f5.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $de660e99e3126d7c$export$e7c866399fa523f5.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $de660e99e3126d7c$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $de660e99e3126d7c$var$BaseOAuthProvider extends $de660e99e3126d7c$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $de660e99e3126d7c$export$dc98b0b04f4c7758 extends $de660e99e3126d7c$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        $de660e99e3126d7c$export$890c4ad488842ce7('providerId' in obj && 'signInMethod' in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $de660e99e3126d7c$export$a07804094c3ecf2d._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $de660e99e3126d7c$export$890c4ad488842ce7(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $de660e99e3126d7c$export$a07804094c3ecf2d._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $de660e99e3126d7c$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $de660e99e3126d7c$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $de660e99e3126d7c$export$dc98b0b04f4c7758(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $de660e99e3126d7c$export$71cec2538cb2c617 extends $de660e99e3126d7c$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $de660e99e3126d7c$export$a07804094c3ecf2d._fromParams({
            providerId: $de660e99e3126d7c$export$71cec2538cb2c617.PROVIDER_ID,
            signInMethod: $de660e99e3126d7c$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $de660e99e3126d7c$export$71cec2538cb2c617.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $de660e99e3126d7c$export$71cec2538cb2c617.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $de660e99e3126d7c$export$71cec2538cb2c617.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $de660e99e3126d7c$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $de660e99e3126d7c$export$71cec2538cb2c617.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $de660e99e3126d7c$export$78acf4525d8a74c4 extends $de660e99e3126d7c$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope('profile');
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $de660e99e3126d7c$export$a07804094c3ecf2d._fromParams({
            providerId: $de660e99e3126d7c$export$78acf4525d8a74c4.PROVIDER_ID,
            signInMethod: $de660e99e3126d7c$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $de660e99e3126d7c$export$78acf4525d8a74c4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $de660e99e3126d7c$export$78acf4525d8a74c4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $de660e99e3126d7c$export$78acf4525d8a74c4.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $de660e99e3126d7c$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $de660e99e3126d7c$export$78acf4525d8a74c4.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Github Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Github Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $de660e99e3126d7c$export$8743009a87fcb00f extends $de660e99e3126d7c$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for Github.
     *
     * @param accessToken - Github access token.
     */ static credential(accessToken) {
        return $de660e99e3126d7c$export$a07804094c3ecf2d._fromParams({
            providerId: $de660e99e3126d7c$export$8743009a87fcb00f.PROVIDER_ID,
            signInMethod: $de660e99e3126d7c$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $de660e99e3126d7c$export$8743009a87fcb00f.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $de660e99e3126d7c$export$8743009a87fcb00f.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $de660e99e3126d7c$export$8743009a87fcb00f.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $de660e99e3126d7c$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $de660e99e3126d7c$export$8743009a87fcb00f.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $de660e99e3126d7c$var$IDP_REQUEST_URI = 'http://localhost';
/**
 * @public
 */ class $de660e99e3126d7c$export$f96d196f7728bb5 extends $de660e99e3126d7c$export$61196ced6d74a310 {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $de660e99e3126d7c$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $de660e99e3126d7c$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $de660e99e3126d7c$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $de660e99e3126d7c$export$f96d196f7728bb5(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $de660e99e3126d7c$export$f96d196f7728bb5(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $de660e99e3126d7c$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $de660e99e3126d7c$var$SAML_PROVIDER_PREFIX = 'saml.';
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $de660e99e3126d7c$export$71511d61b312f219 extends $de660e99e3126d7c$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $de660e99e3126d7c$export$890c4ad488842ce7(providerId.startsWith($de660e99e3126d7c$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $de660e99e3126d7c$export$71511d61b312f219.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $de660e99e3126d7c$export$71511d61b312f219.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $de660e99e3126d7c$export$f96d196f7728bb5.fromJSON(json);
        $de660e99e3126d7c$export$890c4ad488842ce7(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $de660e99e3126d7c$export$f96d196f7728bb5._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $de660e99e3126d7c$export$3d8c2f653ac9d0b9 extends $de660e99e3126d7c$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $de660e99e3126d7c$export$a07804094c3ecf2d._fromParams({
            providerId: $de660e99e3126d7c$export$3d8c2f653ac9d0b9.PROVIDER_ID,
            signInMethod: $de660e99e3126d7c$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $de660e99e3126d7c$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $de660e99e3126d7c$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $de660e99e3126d7c$export$3d8c2f653ac9d0b9.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $de660e99e3126d7c$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $de660e99e3126d7c$export$3d8c2f653ac9d0b9.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $de660e99e3126d7c$var$signUp(auth, request) {
    return $de660e99e3126d7c$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $de660e99e3126d7c$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $de660e99e3126d7c$export$23ebac1979863676._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $de660e99e3126d7c$var$providerIdForResponse(idTokenResponse);
        const userCred = new $de660e99e3126d7c$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $de660e99e3126d7c$var$providerIdForResponse(response);
        return new $de660e99e3126d7c$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $de660e99e3126d7c$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ('phoneNumber' in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $de660e99e3126d7c$export$34aec0b863436764(auth) {
    var _a;
    const authInternal = $de660e99e3126d7c$export$a05254e7c3aeba6e(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $de660e99e3126d7c$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $de660e99e3126d7c$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $de660e99e3126d7c$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $de660e99e3126d7c$var$MultiFactorError extends (0, $f3f8f86b339a1e6d$export$dd24e9cd51226c56) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $de660e99e3126d7c$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $de660e99e3126d7c$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $de660e99e3126d7c$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $de660e99e3126d7c$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $de660e99e3126d7c$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $de660e99e3126d7c$export$2f6ca3d3b1f80bf5(user, providerId) {
    const userInternal = (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(user);
    await $de660e99e3126d7c$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $de660e99e3126d7c$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $de660e99e3126d7c$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $de660e99e3126d7c$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $de660e99e3126d7c$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $de660e99e3126d7c$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $de660e99e3126d7c$var$_assertLinkedStatus(expected, user, provider) {
    await $de660e99e3126d7c$var$_reloadWithoutSaving(user);
    const providerIds = $de660e99e3126d7c$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $de660e99e3126d7c$export$890c4ad488842ce7(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $de660e99e3126d7c$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $de660e99e3126d7c$var$_logoutIfInvalidated(user, $de660e99e3126d7c$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $de660e99e3126d7c$export$890c4ad488842ce7(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $de660e99e3126d7c$var$_parseToken(response.idToken);
        $de660e99e3126d7c$export$890c4ad488842ce7(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $de660e99e3126d7c$export$890c4ad488842ce7(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $de660e99e3126d7c$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $de660e99e3126d7c$export$9fa96a7d116ea3ce(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $de660e99e3126d7c$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $de660e99e3126d7c$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $de660e99e3126d7c$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $de660e99e3126d7c$export$3c2fa207a37baaea(auth, credential) {
    return $de660e99e3126d7c$var$_signInWithCredential($de660e99e3126d7c$export$a05254e7c3aeba6e(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $de660e99e3126d7c$export$ce26c07117d59d6a(user, credential) {
    const userInternal = (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(user);
    await $de660e99e3126d7c$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $de660e99e3126d7c$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $de660e99e3126d7c$export$6559d589eb85fbb6(user, credential) {
    return $de660e99e3126d7c$var$_reauthenticate((0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $de660e99e3126d7c$var$signInWithCustomToken$1(auth, request) {
    return $de660e99e3126d7c$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $de660e99e3126d7c$export$efca4cbe5dd06740(auth, customToken) {
    const authInternal = $de660e99e3126d7c$export$a05254e7c3aeba6e(auth);
    const response = await $de660e99e3126d7c$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $de660e99e3126d7c$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $de660e99e3126d7c$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ('phoneInfo' in enrollment) return $de660e99e3126d7c$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ('totpInfo' in enrollment) return $de660e99e3126d7c$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $de660e99e3126d7c$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $de660e99e3126d7c$var$PhoneMultiFactorInfoImpl extends $de660e99e3126d7c$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $de660e99e3126d7c$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $de660e99e3126d7c$var$TotpMultiFactorInfoImpl extends $de660e99e3126d7c$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $de660e99e3126d7c$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $de660e99e3126d7c$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $de660e99e3126d7c$export$890c4ad488842ce7(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $de660e99e3126d7c$export$890c4ad488842ce7(typeof actionCodeSettings.dynamicLinkDomain === 'undefined' || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $de660e99e3126d7c$export$890c4ad488842ce7(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $de660e99e3126d7c$export$890c4ad488842ce7(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $de660e99e3126d7c$var$recachePasswordPolicy(auth) {
    const authInternal = $de660e99e3126d7c$export$a05254e7c3aeba6e(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * [Email Enumeration Protection](https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection) is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $de660e99e3126d7c$export$a8550f7dbe79f93a(auth, email, actionCodeSettings) {
    const authInternal = $de660e99e3126d7c$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) $de660e99e3126d7c$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await $de660e99e3126d7c$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $de660e99e3126d7c$var$sendPasswordResetEmail$1);
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $de660e99e3126d7c$export$2e2af4578d910ddf(auth, oobCode, newPassword) {
    await $de660e99e3126d7c$var$resetPassword((0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $de660e99e3126d7c$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $de660e99e3126d7c$export$a93c5207d687da10(auth, oobCode) {
    await $de660e99e3126d7c$var$applyActionCode$1((0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $de660e99e3126d7c$export$c3950d9923825c02(auth, oobCode) {
    const authModular = (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(auth);
    const response = await $de660e99e3126d7c$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $de660e99e3126d7c$export$890c4ad488842ce7(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $de660e99e3126d7c$export$890c4ad488842ce7(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $de660e99e3126d7c$export$890c4ad488842ce7(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $de660e99e3126d7c$export$890c4ad488842ce7(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $de660e99e3126d7c$var$MultiFactorInfoImpl._fromServerResponse($de660e99e3126d7c$export$a05254e7c3aeba6e(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $de660e99e3126d7c$export$a9c996f45e5784d0(auth, code) {
    const { data: data } = await $de660e99e3126d7c$export$c3950d9923825c02((0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $de660e99e3126d7c$export$7910e0436ed8d1de(auth, email, password) {
    const authInternal = $de660e99e3126d7c$export$a05254e7c3aeba6e(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = $de660e99e3126d7c$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $de660e99e3126d7c$var$signUp);
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $de660e99e3126d7c$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $de660e99e3126d7c$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match.
 * When [Email Enumeration Protection](https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection) is enabled,
 * this method fails with "auth/invalid-credential" in case of an invalid email/password.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $de660e99e3126d7c$export$555508cbc6add439(auth, email, password) {
    return $de660e99e3126d7c$export$3c2fa207a37baaea((0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(auth), $de660e99e3126d7c$export$e7c866399fa523f5.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $de660e99e3126d7c$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $de660e99e3126d7c$export$2219238a014317b0(auth, email, actionCodeSettings) {
    const authInternal = $de660e99e3126d7c$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $de660e99e3126d7c$export$890c4ad488842ce7(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $de660e99e3126d7c$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await $de660e99e3126d7c$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $de660e99e3126d7c$var$sendSignInLinkToEmail$1);
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $de660e99e3126d7c$export$4c3d22f3d993c33f(auth, emailLink) {
    const actionCodeUrl = $de660e99e3126d7c$export$f38c853ae54ed474.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $de660e99e3126d7c$export$f787f51d84a910ad(auth, email, emailLink) {
    const authModular = (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(auth);
    const credential = $de660e99e3126d7c$export$e7c866399fa523f5.credentialWithLink(email, emailLink || $de660e99e3126d7c$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $de660e99e3126d7c$export$890c4ad488842ce7(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $de660e99e3126d7c$export$3c2fa207a37baaea(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $de660e99e3126d7c$var$createAuthUri(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when [Email Enumeration Protection](https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection) is enabled, irrespective of the number of
 * authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for [Email Enumeration Protection](https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection).
 * @public
 */ async function $de660e99e3126d7c$export$c9170ad7d4cd7e57(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $de660e99e3126d7c$var$_isHttpOrHttps() ? $de660e99e3126d7c$var$_getCurrentUrl() : 'http://localhost';
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $de660e99e3126d7c$var$createAuthUri((0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $de660e99e3126d7c$export$ee7c8ad385a60b7b(user, actionCodeSettings) {
    const userInternal = (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $de660e99e3126d7c$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $de660e99e3126d7c$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $de660e99e3126d7c$export$995eb9fca571757(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $de660e99e3126d7c$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $de660e99e3126d7c$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $de660e99e3126d7c$var$updateProfile$1(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $de660e99e3126d7c$export$21579262ef46735b(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $de660e99e3126d7c$var$_logoutIfInvalidated(userInternal, $de660e99e3126d7c$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when [Email Enumeration Protection](https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection) is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function $de660e99e3126d7c$export$ab83b03e4111b1d0(user, newEmail) {
    return $de660e99e3126d7c$var$updateEmailOrPassword((0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(user), newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $de660e99e3126d7c$export$1a82df3d29112e01(user, newPassword) {
    return $de660e99e3126d7c$var$updateEmailOrPassword((0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(user), null, newPassword);
}
async function $de660e99e3126d7c$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $de660e99e3126d7c$var$_logoutIfInvalidated(user, $de660e99e3126d7c$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $de660e99e3126d7c$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = $de660e99e3126d7c$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b['sign_in_provider'];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $de660e99e3126d7c$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $de660e99e3126d7c$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $de660e99e3126d7c$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $de660e99e3126d7c$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $de660e99e3126d7c$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $de660e99e3126d7c$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $de660e99e3126d7c$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $de660e99e3126d7c$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $de660e99e3126d7c$var$FederatedAdditionalUserInfoWithUsername extends $de660e99e3126d7c$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $de660e99e3126d7c$var$FacebookAdditionalUserInfo extends $de660e99e3126d7c$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $de660e99e3126d7c$var$GithubAdditionalUserInfo extends $de660e99e3126d7c$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === 'string' ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class $de660e99e3126d7c$var$GoogleAdditionalUserInfo extends $de660e99e3126d7c$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $de660e99e3126d7c$var$TwitterAdditionalUserInfo extends $de660e99e3126d7c$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $de660e99e3126d7c$export$8a5498727ef6be21(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $de660e99e3126d7c$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $de660e99e3126d7c$export$9e5f44173e64f162(auth, persistence) {
    return (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $de660e99e3126d7c$export$625550452a3fa3ec(auth) {
    return $de660e99e3126d7c$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $de660e99e3126d7c$export$90a7f3efeed30595(auth, password) {
    const authInternal = $de660e99e3126d7c$export$a05254e7c3aeba6e(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $de660e99e3126d7c$export$efccba1c4a2ef57b(auth, nextOrObserver, error, completed) {
    return (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $de660e99e3126d7c$export$d141bba7fdc215a3(auth, callback, onAbort) {
    return (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $de660e99e3126d7c$export$4a5767248b18ef41(auth, nextOrObserver, error, completed) {
    return (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $de660e99e3126d7c$export$df995fae86a55f06(auth) {
    (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $de660e99e3126d7c$export$ef35774e6d314e91(auth, user) {
    return (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $de660e99e3126d7c$export$e7094788287c5e9b(auth) {
    return (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $de660e99e3126d7c$export$96f57966bedc81b4(auth, token) {
    const authInternal = $de660e99e3126d7c$export$a05254e7c3aeba6e(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $de660e99e3126d7c$export$a9c23c6ac3fc3eca(user) {
    return (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $de660e99e3126d7c$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $de660e99e3126d7c$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $de660e99e3126d7c$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? 'idToken' : 'pendingCredential';
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return $de660e99e3126d7c$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return $de660e99e3126d7c$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $de660e99e3126d7c$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $de660e99e3126d7c$export$a05254e7c3aeba6e(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$de660e99e3126d7c$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $de660e99e3126d7c$export$890c4ad488842ce7(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $de660e99e3126d7c$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $de660e99e3126d7c$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $de660e99e3126d7c$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $de660e99e3126d7c$export$890c4ad488842ce7(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $de660e99e3126d7c$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $de660e99e3126d7c$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $de660e99e3126d7c$export$6554612db691658e(auth, error) {
    var _a;
    const authModular = (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(auth);
    const errorInternal = error;
    $de660e99e3126d7c$export$890c4ad488842ce7(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $de660e99e3126d7c$export$890c4ad488842ce7((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $de660e99e3126d7c$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $de660e99e3126d7c$var$startEnrollPhoneMfa(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
function $de660e99e3126d7c$var$finalizeEnrollPhoneMfa(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
function $de660e99e3126d7c$var$startEnrollTotpMfa(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
function $de660e99e3126d7c$var$finalizeEnrollTotpMfa(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
function $de660e99e3126d7c$var$withdrawMfa(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
class $de660e99e3126d7c$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$de660e99e3126d7c$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $de660e99e3126d7c$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $de660e99e3126d7c$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $de660e99e3126d7c$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === 'string' ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $de660e99e3126d7c$var$_logoutIfInvalidated(this.user, $de660e99e3126d7c$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $de660e99e3126d7c$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $de660e99e3126d7c$export$493d36ec626b6698(user) {
    const userModular = (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(user);
    if (!$de660e99e3126d7c$var$multiFactorUserCache.has(userModular)) $de660e99e3126d7c$var$multiFactorUserCache.set(userModular, $de660e99e3126d7c$var$MultiFactorUserImpl._fromUser(userModular));
    return $de660e99e3126d7c$var$multiFactorUserCache.get(userModular);
}
const $de660e99e3126d7c$var$STORAGE_AVAILABLE_KEY = '__sak';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $de660e99e3126d7c$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($de660e99e3126d7c$var$STORAGE_AVAILABLE_KEY, '1');
            this.storage.removeItem($de660e99e3126d7c$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $de660e99e3126d7c$var$_iframeCannotSyncWebStorage() {
    const ua = (0, $f3f8f86b339a1e6d$export$c36915b22ce77c19)();
    return $de660e99e3126d7c$var$_isSafari(ua) || $de660e99e3126d7c$export$d66dc83d8cfc8dd(ua);
}
// The polling period in case events are not supported
const $de660e99e3126d7c$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $de660e99e3126d7c$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $de660e99e3126d7c$var$BrowserLocalPersistence extends $de660e99e3126d7c$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Safari or iOS browser and embedded in an iframe.
        this.safariLocalStorageNotSynced = $de660e99e3126d7c$var$_iframeCannotSyncWebStorage() && $de660e99e3126d7c$var$_isIframe();
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $de660e99e3126d7c$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        // Safari embedded iframe. Storage event will trigger with the delta
        // changes but no changes will be applied to the iframe localStorage.
        if (this.safariLocalStorageNotSynced) {
            // Get current iframe page value.
            const storedValue = this.storage.getItem(key);
            // Value not synchronized, synchronize manually.
            if (event.newValue !== storedValue) {
                if (event.newValue !== null) // Value changed from current value.
                this.storage.setItem(key, event.newValue);
                else // Current value deleted.
                this.storage.removeItem(key);
            } else if (this.localCache[key] === event.newValue && !poll) // Already detected and processed, do not trigger listeners again.
            return;
        }
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($de660e99e3126d7c$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $de660e99e3126d7c$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent('storage', {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $de660e99e3126d7c$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener('storage', this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener('storage', this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$de660e99e3126d7c$var$BrowserLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $de660e99e3126d7c$export$8b22cf2602fb60ce = $de660e99e3126d7c$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $de660e99e3126d7c$var$BrowserSessionPersistence extends $de660e99e3126d7c$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$de660e99e3126d7c$var$BrowserSessionPersistence.type = 'SESSION';
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $de660e99e3126d7c$export$407448d2b89b1813 = $de660e99e3126d7c$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $de660e99e3126d7c$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $de660e99e3126d7c$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $de660e99e3126d7c$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $de660e99e3126d7c$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener('message', this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener('message', this.boundEventHandler);
    }
}
$de660e99e3126d7c$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $de660e99e3126d7c$export$faec65b429be379(prefix = '', digits = 10) {
    let random = '';
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $de660e99e3126d7c$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener('message', handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== 'undefined' ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $de660e99e3126d7c$export$faec65b429be379('', 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener('message', handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $de660e99e3126d7c$var$_window() {
    return window;
}
function $de660e99e3126d7c$var$_setWindowLocation(url) {
    $de660e99e3126d7c$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $de660e99e3126d7c$var$_isWorker() {
    return typeof $de660e99e3126d7c$var$_window()['WorkerGlobalScope'] !== 'undefined' && typeof $de660e99e3126d7c$var$_window()['importScripts'] === 'function';
}
async function $de660e99e3126d7c$var$_getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function $de660e99e3126d7c$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $de660e99e3126d7c$var$_getWorkerGlobalScope() {
    return $de660e99e3126d7c$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $de660e99e3126d7c$var$DB_NAME = 'firebaseLocalStorageDb';
const $de660e99e3126d7c$var$DB_VERSION = 1;
const $de660e99e3126d7c$var$DB_OBJECTSTORE_NAME = 'firebaseLocalStorage';
const $de660e99e3126d7c$var$DB_DATA_KEYPATH = 'fbase_key';
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $de660e99e3126d7c$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener('success', ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener('error', ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $de660e99e3126d7c$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $de660e99e3126d7c$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? 'readwrite' : 'readonly').objectStore($de660e99e3126d7c$var$DB_OBJECTSTORE_NAME);
}
function $de660e99e3126d7c$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($de660e99e3126d7c$var$DB_NAME);
    return new $de660e99e3126d7c$var$DBPromise(request).toPromise();
}
function $de660e99e3126d7c$var$_openDatabase() {
    const request = indexedDB.open($de660e99e3126d7c$var$DB_NAME, $de660e99e3126d7c$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener('error', ()=>{
            reject(request.error);
        });
        request.addEventListener('upgradeneeded', ()=>{
            const db = request.result;
            try {
                db.createObjectStore($de660e99e3126d7c$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $de660e99e3126d7c$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener('success', async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($de660e99e3126d7c$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $de660e99e3126d7c$var$_deleteDatabase();
                resolve(await $de660e99e3126d7c$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $de660e99e3126d7c$var$_putObject(db, key, value) {
    const request = $de660e99e3126d7c$var$getObjectStore(db, true).put({
        [$de660e99e3126d7c$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $de660e99e3126d7c$var$DBPromise(request).toPromise();
}
async function $de660e99e3126d7c$var$getObject(db, key) {
    const request = $de660e99e3126d7c$var$getObjectStore(db, false).get(key);
    const data = await new $de660e99e3126d7c$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $de660e99e3126d7c$var$_deleteObject(db, key) {
    const request = $de660e99e3126d7c$var$getObjectStore(db, true).delete(key);
    return new $de660e99e3126d7c$var$DBPromise(request).toPromise();
}
const $de660e99e3126d7c$var$_POLLING_INTERVAL_MS = 800;
const $de660e99e3126d7c$var$_TRANSACTION_RETRY_COUNT = 3;
class $de660e99e3126d7c$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $de660e99e3126d7c$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $de660e99e3126d7c$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $de660e99e3126d7c$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $de660e99e3126d7c$var$Receiver._getInstance($de660e99e3126d7c$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $de660e99e3126d7c$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $de660e99e3126d7c$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $de660e99e3126d7c$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $de660e99e3126d7c$var$_openDatabase();
            await $de660e99e3126d7c$var$_putObject(db, $de660e99e3126d7c$var$STORAGE_AVAILABLE_KEY, '1');
            await $de660e99e3126d7c$var$_deleteObject(db, $de660e99e3126d7c$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$de660e99e3126d7c$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$de660e99e3126d7c$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$de660e99e3126d7c$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $de660e99e3126d7c$var$getObjectStore(db, false).getAll();
            return new $de660e99e3126d7c$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        if (result.length !== 0) for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $de660e99e3126d7c$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$de660e99e3126d7c$var$IndexedDBLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $de660e99e3126d7c$export$23f2a1d2818174ef = $de660e99e3126d7c$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $de660e99e3126d7c$var$startSignInPhoneMfa(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
function $de660e99e3126d7c$var$finalizeSignInPhoneMfa(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
function $de660e99e3126d7c$var$finalizeSignInTotpMfa(auth, request) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $de660e99e3126d7c$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $de660e99e3126d7c$var$_SOLVE_TIME_MS = 500;
const $de660e99e3126d7c$var$_EXPIRATION_TIME_MS = 60000;
const $de660e99e3126d7c$var$_WIDGET_ID_START = 1000000000000;
class $de660e99e3126d7c$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $de660e99e3126d7c$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $de660e99e3126d7c$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || $de660e99e3126d7c$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || $de660e99e3126d7c$var$_WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || '';
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || $de660e99e3126d7c$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return '';
    }
}
class $de660e99e3126d7c$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $de660e99e3126d7c$export$890c4ad488842ce7(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== 'invisible';
        if (this.isVisible) this.execute();
        else this.container.addEventListener('click', this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener('click', this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $de660e99e3126d7c$var$generateRandomAlphaNumericString(50);
            const { callback: callback, 'expired-callback': expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $de660e99e3126d7c$var$_EXPIRATION_TIME_MS);
        }, $de660e99e3126d7c$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error('reCAPTCHA mock was already deleted!');
    }
}
function $de660e99e3126d7c$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join('');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $de660e99e3126d7c$var$_JSLOAD_CALLBACK = $de660e99e3126d7c$var$_generateCallbackName('rcb');
const $de660e99e3126d7c$var$NETWORK_TIMEOUT_DELAY = new $de660e99e3126d7c$var$Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $de660e99e3126d7c$var$ReCaptchaLoaderImpl {
    constructor(){
        var _a;
        this.hostLanguage = '';
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $de660e99e3126d7c$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    load(auth, hl = '') {
        $de660e99e3126d7c$export$890c4ad488842ce7($de660e99e3126d7c$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $de660e99e3126d7c$var$isV2($de660e99e3126d7c$var$_window().grecaptcha)) return Promise.resolve($de660e99e3126d7c$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $de660e99e3126d7c$var$_window().setTimeout(()=>{
                reject($de660e99e3126d7c$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $de660e99e3126d7c$var$NETWORK_TIMEOUT_DELAY.get());
            $de660e99e3126d7c$var$_window()[$de660e99e3126d7c$var$_JSLOAD_CALLBACK] = ()=>{
                $de660e99e3126d7c$var$_window().clearTimeout(networkTimeout);
                delete $de660e99e3126d7c$var$_window()[$de660e99e3126d7c$var$_JSLOAD_CALLBACK];
                const recaptcha = $de660e99e3126d7c$var$_window().grecaptcha;
                if (!recaptcha || !$de660e99e3126d7c$var$isV2(recaptcha)) {
                    reject($de660e99e3126d7c$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the greptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$de660e99e3126d7c$var$_recaptchaV2ScriptUrl()}?${(0, $f3f8f86b339a1e6d$export$ac4103b836844853)({
                onload: $de660e99e3126d7c$var$_JSLOAD_CALLBACK,
                render: 'explicit',
                hl: hl
            })}`;
            $de660e99e3126d7c$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($de660e99e3126d7c$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        var _a;
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!((_a = $de660e99e3126d7c$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $de660e99e3126d7c$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $de660e99e3126d7c$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $de660e99e3126d7c$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $de660e99e3126d7c$var$RECAPTCHA_VERIFIER_TYPE = 'recaptcha';
const $de660e99e3126d7c$var$DEFAULT_PARAMS = {
    theme: 'light',
    type: 'image'
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $de660e99e3126d7c$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = Object.assign({}, $de660e99e3126d7c$var$DEFAULT_PARAMS)){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $de660e99e3126d7c$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $de660e99e3126d7c$export$a05254e7c3aeba6e(authExtern);
        this.isInvisible = this.parameters.size === 'invisible';
        $de660e99e3126d7c$export$890c4ad488842ce7(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $de660e99e3126d7c$export$890c4ad488842ce7(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $de660e99e3126d7c$var$MockReCaptchaLoaderImpl() : new $de660e99e3126d7c$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $de660e99e3126d7c$export$890c4ad488842ce7(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $de660e99e3126d7c$export$890c4ad488842ce7(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $de660e99e3126d7c$export$890c4ad488842ce7(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === 'function') existing(token);
            else if (typeof existing === 'string') {
                const globalFunc = $de660e99e3126d7c$var$_window()[existing];
                if (typeof globalFunc === 'function') globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $de660e99e3126d7c$export$890c4ad488842ce7(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement('div');
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $de660e99e3126d7c$export$890c4ad488842ce7($de660e99e3126d7c$var$_isHttpOrHttps() && !$de660e99e3126d7c$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $de660e99e3126d7c$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $de660e99e3126d7c$var$getRecaptchaParams(this.auth);
        $de660e99e3126d7c$export$890c4ad488842ce7(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $de660e99e3126d7c$export$890c4ad488842ce7(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $de660e99e3126d7c$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === 'complete') {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener('load', resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener('load', resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $de660e99e3126d7c$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $de660e99e3126d7c$export$3722cfe417b6ed86._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $de660e99e3126d7c$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    const authInternal = $de660e99e3126d7c$export$a05254e7c3aeba6e(auth);
    const verificationId = await $de660e99e3126d7c$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(appVerifier));
    return new $de660e99e3126d7c$var$ConfirmationResultImpl(verificationId, (cred)=>$de660e99e3126d7c$export$3c2fa207a37baaea(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $de660e99e3126d7c$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(user);
    await $de660e99e3126d7c$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $de660e99e3126d7c$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(appVerifier));
    return new $de660e99e3126d7c$var$ConfirmationResultImpl(verificationId, (cred)=>$de660e99e3126d7c$export$ce26c07117d59d6a(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $de660e99e3126d7c$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(user);
    const verificationId = await $de660e99e3126d7c$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(appVerifier));
    return new $de660e99e3126d7c$var$ConfirmationResultImpl(verificationId, (cred)=>$de660e99e3126d7c$export$6559d589eb85fbb6(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $de660e99e3126d7c$var$_verifyPhoneNumber(auth, options, verifier) {
    var _a;
    const recaptchaToken = await verifier.verify();
    try {
        $de660e99e3126d7c$export$890c4ad488842ce7(typeof recaptchaToken === 'string', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $de660e99e3126d7c$export$890c4ad488842ce7(verifier.type === $de660e99e3126d7c$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        let phoneInfoOptions;
        if (typeof options === 'string') phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ('session' in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ('phoneNumber' in phoneInfoOptions) {
                $de660e99e3126d7c$export$890c4ad488842ce7(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const response = await $de660e99e3126d7c$var$startEnrollPhoneMfa(auth, {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $de660e99e3126d7c$export$890c4ad488842ce7(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                $de660e99e3126d7c$export$890c4ad488842ce7(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const response = await $de660e99e3126d7c$var$startSignInPhoneMfa(auth, {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const { sessionInfo: sessionInfo } = await $de660e99e3126d7c$var$sendPhoneVerificationCode(auth, {
                phoneNumber: phoneInfoOptions.phoneNumber,
                recaptchaToken: recaptchaToken
            });
            return sessionInfo;
        }
    } finally{
        verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $de660e99e3126d7c$export$3b14a55fb2447963(user, credential) {
    await $de660e99e3126d7c$var$_link$1((0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $de660e99e3126d7c$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $de660e99e3126d7c$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $de660e99e3126d7c$export$a05254e7c3aeba6e(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $de660e99e3126d7c$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $de660e99e3126d7c$export$3722cfe417b6ed86._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $de660e99e3126d7c$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $de660e99e3126d7c$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $de660e99e3126d7c$export$3722cfe417b6ed86._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $de660e99e3126d7c$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $de660e99e3126d7c$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $de660e99e3126d7c$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $de660e99e3126d7c$export$158acd800e1ef08b(resolverOverride);
    $de660e99e3126d7c$export$890c4ad488842ce7(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $de660e99e3126d7c$var$IdpCredential extends $de660e99e3126d7c$export$61196ced6d74a310 {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $de660e99e3126d7c$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $de660e99e3126d7c$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $de660e99e3126d7c$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $de660e99e3126d7c$var$_signIn(params) {
    return $de660e99e3126d7c$var$_signInWithCredential(params.auth, new $de660e99e3126d7c$var$IdpCredential(params), params.bypassAuthState);
}
function $de660e99e3126d7c$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $de660e99e3126d7c$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $de660e99e3126d7c$var$_reauthenticate(user, new $de660e99e3126d7c$var$IdpCredential(params), params.bypassAuthState);
}
async function $de660e99e3126d7c$var$_link(params) {
    const { auth: auth, user: user } = params;
    $de660e99e3126d7c$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $de660e99e3126d7c$var$_link$1(user, new $de660e99e3126d7c$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $de660e99e3126d7c$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $de660e99e3126d7c$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $de660e99e3126d7c$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $de660e99e3126d7c$var$_reauth;
            default:
                $de660e99e3126d7c$export$9fa96a7d116ea3ce(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $de660e99e3126d7c$export$1fbe638ecf81657e(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $de660e99e3126d7c$export$1fbe638ecf81657e(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $de660e99e3126d7c$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $de660e99e3126d7c$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $de660e99e3126d7c$export$db3b6bfb95261072(auth, provider, resolver) {
    const authInternal = $de660e99e3126d7c$export$a05254e7c3aeba6e(auth);
    $de660e99e3126d7c$var$_assertInstanceOf(auth, provider, $de660e99e3126d7c$var$FederatedAuthProvider);
    const resolverInternal = $de660e99e3126d7c$var$_withDefaultResolver(authInternal, resolver);
    const action = new $de660e99e3126d7c$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $de660e99e3126d7c$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(user);
    $de660e99e3126d7c$var$_assertInstanceOf(userInternal.auth, provider, $de660e99e3126d7c$var$FederatedAuthProvider);
    const resolverInternal = $de660e99e3126d7c$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $de660e99e3126d7c$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $de660e99e3126d7c$export$4368d992c4eafac0(user, provider, resolver) {
    const userInternal = (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(user);
    $de660e99e3126d7c$var$_assertInstanceOf(userInternal.auth, provider, $de660e99e3126d7c$var$FederatedAuthProvider);
    const resolverInternal = $de660e99e3126d7c$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $de660e99e3126d7c$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $de660e99e3126d7c$var$PopupOperation extends $de660e99e3126d7c$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($de660e99e3126d7c$var$PopupOperation.currentPopupAction) $de660e99e3126d7c$var$PopupOperation.currentPopupAction.cancel();
        $de660e99e3126d7c$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $de660e99e3126d7c$export$890c4ad488842ce7(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $de660e99e3126d7c$export$1fbe638ecf81657e(this.filter.length === 1, 'Popup operations only handle one event');
        const eventId = $de660e99e3126d7c$export$faec65b429be379();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($de660e99e3126d7c$export$9d398bebfec1c039(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject($de660e99e3126d7c$export$9d398bebfec1c039(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $de660e99e3126d7c$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($de660e99e3126d7c$export$9d398bebfec1c039(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $de660e99e3126d7c$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$de660e99e3126d7c$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $de660e99e3126d7c$var$PENDING_REDIRECT_KEY = 'pendingRedirect';
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $de660e99e3126d7c$var$redirectOutcomeMap = new Map();
class $de660e99e3126d7c$var$RedirectAction extends $de660e99e3126d7c$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $de660e99e3126d7c$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $de660e99e3126d7c$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $de660e99e3126d7c$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $de660e99e3126d7c$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $de660e99e3126d7c$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $de660e99e3126d7c$var$pendingRedirectKey(auth);
    const persistence = $de660e99e3126d7c$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === 'true';
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $de660e99e3126d7c$var$_setPendingRedirectStatus(resolver, auth) {
    return $de660e99e3126d7c$var$resolverPersistence(resolver)._set($de660e99e3126d7c$var$pendingRedirectKey(auth), 'true');
}
function $de660e99e3126d7c$export$b9a6b53f9be3734() {
    $de660e99e3126d7c$var$redirectOutcomeMap.clear();
}
function $de660e99e3126d7c$export$a33b77bbdbb8366c(auth, result) {
    $de660e99e3126d7c$var$redirectOutcomeMap.set(auth._key(), result);
}
function $de660e99e3126d7c$var$resolverPersistence(resolver) {
    return $de660e99e3126d7c$export$158acd800e1ef08b(resolver._redirectPersistence);
}
function $de660e99e3126d7c$var$pendingRedirectKey(auth) {
    return $de660e99e3126d7c$export$cf2f7c5792f80b46($de660e99e3126d7c$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $de660e99e3126d7c$export$2d1720544b23b823(auth, provider, resolver) {
    return $de660e99e3126d7c$var$_signInWithRedirect(auth, provider, resolver);
}
async function $de660e99e3126d7c$var$_signInWithRedirect(auth, provider, resolver) {
    const authInternal = $de660e99e3126d7c$export$a05254e7c3aeba6e(auth);
    $de660e99e3126d7c$var$_assertInstanceOf(auth, provider, $de660e99e3126d7c$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $de660e99e3126d7c$var$_withDefaultResolver(authInternal, resolver);
    await $de660e99e3126d7c$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $de660e99e3126d7c$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $de660e99e3126d7c$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $de660e99e3126d7c$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(user);
    $de660e99e3126d7c$var$_assertInstanceOf(userInternal.auth, provider, $de660e99e3126d7c$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $de660e99e3126d7c$var$_withDefaultResolver(userInternal.auth, resolver);
    await $de660e99e3126d7c$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $de660e99e3126d7c$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $de660e99e3126d7c$export$39b482c5e57630a8(user, provider, resolver) {
    return $de660e99e3126d7c$var$_linkWithRedirect(user, provider, resolver);
}
async function $de660e99e3126d7c$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $f3f8f86b339a1e6d$export$4befe9b5fa509a1b)(user);
    $de660e99e3126d7c$var$_assertInstanceOf(userInternal.auth, provider, $de660e99e3126d7c$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $de660e99e3126d7c$var$_withDefaultResolver(userInternal.auth, resolver);
    await $de660e99e3126d7c$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $de660e99e3126d7c$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $de660e99e3126d7c$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $de660e99e3126d7c$export$35e795649ee09318(auth, resolver) {
    await $de660e99e3126d7c$export$a05254e7c3aeba6e(auth)._initializationPromise;
    return $de660e99e3126d7c$export$53a70dd1ebbae346(auth, resolver, false);
}
async function $de660e99e3126d7c$export$53a70dd1ebbae346(auth, resolverExtern, bypassAuthState = false) {
    const authInternal = $de660e99e3126d7c$export$a05254e7c3aeba6e(auth);
    const resolver = $de660e99e3126d7c$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $de660e99e3126d7c$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $de660e99e3126d7c$var$prepareUserForRedirect(user) {
    const eventId = $de660e99e3126d7c$export$faec65b429be379(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $de660e99e3126d7c$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $de660e99e3126d7c$export$24baa2b76016ce0e {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$de660e99e3126d7c$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !$de660e99e3126d7c$var$isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split('auth/')[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($de660e99e3126d7c$export$9d398bebfec1c039(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $de660e99e3126d7c$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($de660e99e3126d7c$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($de660e99e3126d7c$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $de660e99e3126d7c$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join('-');
}
function $de660e99e3126d7c$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $de660e99e3126d7c$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $de660e99e3126d7c$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $de660e99e3126d7c$export$3d12bd131bb975d1(auth, request = {}) {
    return $de660e99e3126d7c$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $de660e99e3126d7c$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $de660e99e3126d7c$var$HTTP_REGEX = /^https?/;
async function $de660e99e3126d7c$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $de660e99e3126d7c$export$3d12bd131bb975d1(auth);
    for (const domain of authorizedDomains)try {
        if ($de660e99e3126d7c$var$matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $de660e99e3126d7c$export$9fa96a7d116ea3ce(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $de660e99e3126d7c$var$matchDomain(expected) {
    const currentUrl = $de660e99e3126d7c$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith('chrome-extension://')) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === '' && hostname === '') // For some reason we're not parsing chrome URLs properly
        return protocol === 'chrome-extension:' && expected.replace('chrome-extension://', '') === currentUrl.replace('chrome-extension://', '');
        return protocol === 'chrome-extension:' && ceUrl.hostname === hostname;
    }
    if (!$de660e99e3126d7c$var$HTTP_REGEX.test(protocol)) return false;
    if ($de660e99e3126d7c$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, '\\.');
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp('^(.+\\.' + escapedDomainPattern + '|' + escapedDomainPattern + ')$', 'i');
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $de660e99e3126d7c$var$NETWORK_TIMEOUT = new $de660e99e3126d7c$var$Delay(30000, 60000);
/**
 * Reset unlaoded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $de660e99e3126d7c$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $de660e99e3126d7c$var$_window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $de660e99e3126d7c$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $de660e99e3126d7c$var$resetUnloadedGapiModules();
            gapi.load('gapi.iframes', {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $de660e99e3126d7c$var$resetUnloadedGapiModules();
                    reject($de660e99e3126d7c$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $de660e99e3126d7c$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $de660e99e3126d7c$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $de660e99e3126d7c$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $de660e99e3126d7c$var$_generateCallbackName('iframefcb');
            // GApi loader not available, dynamically load platform.js.
            $de660e99e3126d7c$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($de660e99e3126d7c$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $de660e99e3126d7c$var$_loadJS(`${$de660e99e3126d7c$var$_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $de660e99e3126d7c$var$cachedGApiLoader = null;
        throw error;
    });
}
let $de660e99e3126d7c$var$cachedGApiLoader = null;
function $de660e99e3126d7c$var$_loadGapi(auth) {
    $de660e99e3126d7c$var$cachedGApiLoader = $de660e99e3126d7c$var$cachedGApiLoader || $de660e99e3126d7c$var$loadGapi(auth);
    return $de660e99e3126d7c$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $de660e99e3126d7c$var$PING_TIMEOUT = new $de660e99e3126d7c$var$Delay(5000, 15000);
const $de660e99e3126d7c$var$IFRAME_PATH = '__/auth/iframe';
const $de660e99e3126d7c$var$EMULATED_IFRAME_PATH = 'emulator/auth/iframe';
const $de660e99e3126d7c$var$IFRAME_ATTRIBUTES = {
    style: {
        position: 'absolute',
        top: '-100px',
        width: '1px',
        height: '1px'
    },
    'aria-hidden': 'true',
    tabindex: '-1'
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $de660e99e3126d7c$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        'p'
    ],
    [
        'staging-identitytoolkit.sandbox.googleapis.com',
        's'
    ],
    [
        'test-identitytoolkit.sandbox.googleapis.com',
        't'
    ] // test
]);
function $de660e99e3126d7c$var$getIframeUrl(auth) {
    const config = auth.config;
    $de660e99e3126d7c$export$890c4ad488842ce7(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $de660e99e3126d7c$var$_emulatorUrl(config, $de660e99e3126d7c$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$de660e99e3126d7c$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $20bc1f3a4bda2fcc$export$31499a9cd224b78c)
    };
    const eid = $de660e99e3126d7c$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(',');
    return `${url}?${(0, $f3f8f86b339a1e6d$export$ac4103b836844853)(params).slice(1)}`;
}
async function $de660e99e3126d7c$var$_openIframe(auth) {
    const context = await $de660e99e3126d7c$var$_loadGapi(auth);
    const gapi1 = $de660e99e3126d7c$var$_window().gapi;
    $de660e99e3126d7c$export$890c4ad488842ce7(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $de660e99e3126d7c$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $de660e99e3126d7c$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $de660e99e3126d7c$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $de660e99e3126d7c$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $de660e99e3126d7c$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $de660e99e3126d7c$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $de660e99e3126d7c$var$BASE_POPUP_OPTIONS = {
    location: 'yes',
    resizable: 'yes',
    statusbar: 'yes',
    toolbar: 'no'
};
const $de660e99e3126d7c$var$DEFAULT_WIDTH = 500;
const $de660e99e3126d7c$var$DEFAULT_HEIGHT = 600;
const $de660e99e3126d7c$var$TARGET_BLANK = '_blank';
const $de660e99e3126d7c$var$FIREFOX_EMPTY_URL = 'http://localhost';
class $de660e99e3126d7c$export$c03999cb2f36933f {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $de660e99e3126d7c$var$_open(auth, url, name, width = $de660e99e3126d7c$var$DEFAULT_WIDTH, height = $de660e99e3126d7c$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = '';
    const options = Object.assign(Object.assign({}, $de660e99e3126d7c$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $f3f8f86b339a1e6d$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $de660e99e3126d7c$var$_isChromeIOS(ua) ? $de660e99e3126d7c$var$TARGET_BLANK : name;
    if ($de660e99e3126d7c$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $de660e99e3126d7c$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = 'yes';
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, '');
    if ($de660e99e3126d7c$var$_isIOSStandalone(ua) && target !== '_self') {
        $de660e99e3126d7c$var$openAsNewWindowIOS(url || '', target);
        return new $de660e99e3126d7c$export$c03999cb2f36933f(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || '', target, optionsString);
    $de660e99e3126d7c$export$890c4ad488842ce7(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $de660e99e3126d7c$export$c03999cb2f36933f(newWin);
}
function $de660e99e3126d7c$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement('a');
    el.href = url;
    el.target = target;
    const click = document.createEvent('MouseEvent');
    click.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $de660e99e3126d7c$var$WIDGET_PATH = '__/auth/handler';
/**
 * URL for emulated environment
 *
 * @internal
 */ const $de660e99e3126d7c$var$EMULATOR_WIDGET_PATH = 'emulator/auth/handler';
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $de660e99e3126d7c$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent('fac');
async function $de660e99e3126d7c$export$28f7fcd39efa255(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $de660e99e3126d7c$export$890c4ad488842ce7(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $de660e99e3126d7c$export$890c4ad488842ce7(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $20bc1f3a4bda2fcc$export$31499a9cd224b78c),
        eventId: eventId
    };
    if (provider instanceof $de660e99e3126d7c$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || '';
        if (!(0, $f3f8f86b339a1e6d$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $de660e99e3126d7c$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== '');
        if (scopes.length > 0) params.scopes = scopes.join(',');
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endipointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$de660e99e3126d7c$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : '';
    // Start at index 1 to skip the leading '&' in the query string
    return `${$de660e99e3126d7c$var$getHandlerBase(auth)}?${(0, $f3f8f86b339a1e6d$export$ac4103b836844853)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $de660e99e3126d7c$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$de660e99e3126d7c$var$WIDGET_PATH}`;
    return $de660e99e3126d7c$var$_emulatorUrl(config, $de660e99e3126d7c$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $de660e99e3126d7c$var$WEB_STORAGE_SUPPORT_KEY = 'webStorageSupport';
class $de660e99e3126d7c$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $de660e99e3126d7c$export$407448d2b89b1813;
        this._completeRedirectFn = $de660e99e3126d7c$export$53a70dd1ebbae346;
        this._overrideRedirectResult = $de660e99e3126d7c$export$a33b77bbdbb8366c;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        $de660e99e3126d7c$export$1fbe638ecf81657e((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, '_initialize() not called before _openPopup()');
        const url = await $de660e99e3126d7c$export$28f7fcd39efa255(auth, provider, authType, $de660e99e3126d7c$var$_getCurrentUrl(), eventId);
        return $de660e99e3126d7c$var$_open(auth, url, $de660e99e3126d7c$export$faec65b429be379());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $de660e99e3126d7c$export$28f7fcd39efa255(auth, provider, authType, $de660e99e3126d7c$var$_getCurrentUrl(), eventId);
        $de660e99e3126d7c$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $de660e99e3126d7c$export$1fbe638ecf81657e(promise, 'If manager is not set, promise should be');
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $de660e99e3126d7c$var$_openIframe(auth);
        const manager = new $de660e99e3126d7c$export$24baa2b76016ce0e(auth);
        iframe.register('authEvent', (iframeEvent)=>{
            $de660e99e3126d7c$export$890c4ad488842ce7(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($de660e99e3126d7c$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $de660e99e3126d7c$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$de660e99e3126d7c$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $de660e99e3126d7c$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $de660e99e3126d7c$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $de660e99e3126d7c$var$_isMobileBrowser() || $de660e99e3126d7c$var$_isSafari() || $de660e99e3126d7c$export$d66dc83d8cfc8dd();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $de660e99e3126d7c$export$342063e11d6c3cad = $de660e99e3126d7c$var$BrowserPopupRedirectResolver;
class $de660e99e3126d7c$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $de660e99e3126d7c$var$debugFail('unexpected MultiFactorSessionType');
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $de660e99e3126d7c$var$PhoneMultiFactorAssertionImpl extends $de660e99e3126d7c$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $de660e99e3126d7c$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $de660e99e3126d7c$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $de660e99e3126d7c$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $de660e99e3126d7c$export$953cecd6e717a553 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $de660e99e3126d7c$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $de660e99e3126d7c$export$953cecd6e717a553.FACTOR_ID = 'phone';
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $de660e99e3126d7c$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $de660e99e3126d7c$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $de660e99e3126d7c$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        var _a;
        const mfaSession = session;
        $de660e99e3126d7c$export$890c4ad488842ce7(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $de660e99e3126d7c$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $de660e99e3126d7c$export$7ccc53e8f1e7dfc5._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $de660e99e3126d7c$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $de660e99e3126d7c$var$TotpMultiFactorAssertionImpl extends $de660e99e3126d7c$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $de660e99e3126d7c$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $de660e99e3126d7c$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $de660e99e3126d7c$export$890c4ad488842ce7(typeof this.secret !== 'undefined', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $de660e99e3126d7c$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $de660e99e3126d7c$export$890c4ad488842ce7(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $de660e99e3126d7c$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $de660e99e3126d7c$export$7ccc53e8f1e7dfc5 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $de660e99e3126d7c$export$7ccc53e8f1e7dfc5(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        var _a;
        let useDefaults = false;
        if ($de660e99e3126d7c$var$_isEmptyString(accountName) || $de660e99e3126d7c$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($de660e99e3126d7c$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || 'unknownuser';
            if ($de660e99e3126d7c$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $de660e99e3126d7c$var$_isEmptyString(input) {
    return typeof input === 'undefined' || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $de660e99e3126d7c$var$name = "@firebase/auth";
var $de660e99e3126d7c$var$version = "1.6.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $de660e99e3126d7c$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $de660e99e3126d7c$export$890c4ad488842ce7(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $de660e99e3126d7c$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return 'node';
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return 'rn';
        case "Worker" /* ClientPlatform.WORKER */ :
            return 'webworker';
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return 'cordova';
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return 'web-extension';
        default:
            return undefined;
    }
}
/** @internal */ function $de660e99e3126d7c$var$registerAuth(clientPlatform) {
    (0, $20bc1f3a4bda2fcc$export$c930050e7bb63965)(new (0, $4f822ea27f1bba54$export$16fa2f45be04daa8)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider('app').getImmediate();
        const heartbeatServiceProvider = container.getProvider('heartbeat');
        const appCheckServiceProvider = container.getProvider('app-check-internal');
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $de660e99e3126d7c$export$890c4ad488842ce7(apiKey && !apiKey.includes(':'), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $de660e99e3126d7c$export$9f4f30ee63539e24(clientPlatform)
        };
        const authInstance = new $de660e99e3126d7c$export$91477dc880baac21(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $de660e99e3126d7c$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $20bc1f3a4bda2fcc$export$c930050e7bb63965)(new (0, $4f822ea27f1bba54$export$16fa2f45be04daa8)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $de660e99e3126d7c$export$a05254e7c3aeba6e(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $de660e99e3126d7c$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $20bc1f3a4bda2fcc$export$d29d5299a7137abc)($de660e99e3126d7c$var$name, $de660e99e3126d7c$var$version, $de660e99e3126d7c$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $20bc1f3a4bda2fcc$export$d29d5299a7137abc)($de660e99e3126d7c$var$name, $de660e99e3126d7c$var$version, 'esm2017');
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $de660e99e3126d7c$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $de660e99e3126d7c$var$authIdTokenMaxAge = (0, $f3f8f86b339a1e6d$export$5539a1a3afe87d6)('authIdTokenMaxAge') || $de660e99e3126d7c$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $de660e99e3126d7c$var$lastPostedIdToken = null;
const $de660e99e3126d7c$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $de660e99e3126d7c$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
        if ($de660e99e3126d7c$var$lastPostedIdToken === idToken) return;
        $de660e99e3126d7c$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? 'POST' : 'DELETE',
            headers: idToken ? {
                'Authorization': `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $de660e99e3126d7c$export$ae1af26003f05816(app = (0, $20bc1f3a4bda2fcc$export$f9962582c9e66d99)()) {
    const provider = (0, $20bc1f3a4bda2fcc$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $de660e99e3126d7c$export$b4171a6734a65d42(app, {
        popupRedirectResolver: $de660e99e3126d7c$export$342063e11d6c3cad,
        persistence: [
            $de660e99e3126d7c$export$23f2a1d2818174ef,
            $de660e99e3126d7c$export$8b22cf2602fb60ce,
            $de660e99e3126d7c$export$407448d2b89b1813
        ]
    });
    const authTokenSyncUrl = (0, $f3f8f86b339a1e6d$export$5539a1a3afe87d6)('authTokenSyncURL');
    if (authTokenSyncUrl) {
        const mintCookie = $de660e99e3126d7c$var$mintCookieFactory(authTokenSyncUrl);
        $de660e99e3126d7c$export$d141bba7fdc215a3(auth, mintCookie, ()=>mintCookie(auth.currentUser));
        $de660e99e3126d7c$export$efccba1c4a2ef57b(auth, (user)=>mintCookie(user));
    }
    const authEmulatorHost = (0, $f3f8f86b339a1e6d$export$9c11895284c8adad)('auth');
    if (authEmulatorHost) $de660e99e3126d7c$export$3466f893ebf79586(auth, `http://${authEmulatorHost}`);
    return auth;
}
function $de660e99e3126d7c$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName('head')) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
$de660e99e3126d7c$var$_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement('script');
            el.setAttribute('src', url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = $de660e99e3126d7c$export$9d398bebfec1c039("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = 'text/javascript';
            el.charset = 'UTF-8';
            $de660e99e3126d7c$var$getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: 'https://apis.google.com/js/api.js',
    recaptchaV2Script: 'https://www.google.com/recaptcha/api.js',
    recaptchaEnterpriseScript: 'https://www.google.com/recaptcha/enterprise.js?render='
});
$de660e99e3126d7c$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );











var $b749375ee49085ea$exports = {};
'use strict';
// do not edit .js files directly - edit src/index.jst
var $b749375ee49085ea$var$envHasBigInt64Array = typeof BigInt64Array !== 'undefined';
$b749375ee49085ea$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            for (i of a.entries())if (!b.has(i[0])) return false;
            for (i of a.entries())if (!equal(i[1], b.get(i[0]))) return false;
            return true;
        }
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            for (i of a.entries())if (!b.has(i[0])) return false;
            return true;
        }
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};



var $28UcW = parcelRequire("28UcW");

var $eqO6c = parcelRequire("eqO6c");
function $eb0b4d1e13e36536$export$383f6f2f61788070(store, getSubState, deps) {
    const updateRef = (0, $28UcW.useRef)({
        state: undefined,
        initialized: false
    });
    if (!updateRef.current.initialized) {
        updateRef.current.state = getSubState ? getSubState(store.getRawState()) : store.getRawState();
        updateRef.current.initialized = true;
    }
    const [, setUpdateTrigger] = (0, $28UcW.useState)(0);
    (0, $28UcW.useEffect)(()=>{
        const effectState = {
            shouldUpdate: true
        };
        function update() {
            if (effectState.shouldUpdate) {
                const nextSubState = getSubState ? getSubState(store.getRawState()) : store.getRawState();
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($b749375ee49085ea$exports)))(updateRef.current.state, nextSubState)) {
                    if (effectState.shouldUpdate) {
                        updateRef.current.state = nextSubState;
                        setUpdateTrigger((val)=>val + 1);
                    }
                }
            }
        }
        store._addUpdateListener(update);
        update();
        return ()=>{
            effectState.shouldUpdate = false;
            store._removeUpdateListener(update);
        };
    }, deps !== null && deps !== void 0 ? deps : []);
    if (deps !== undefined) {
        const prevDeps = (0, $28UcW.useRef)(deps);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($b749375ee49085ea$exports)))(deps, prevDeps)) updateRef.current.state = getSubState(store.getRawState());
    }
    return updateRef.current.state;
}
function $eb0b4d1e13e36536$export$f5b97ae82d1eeaf3(initialState, deps) {
    const storeRef = (0, $28UcW.useRef)();
    if (storeRef.current == null) storeRef.current = new $eb0b4d1e13e36536$export$390f32400eaf98c9(initialState);
    if (deps !== undefined) {
        const prevDeps = (0, $28UcW.useRef)(deps);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($b749375ee49085ea$exports)))(deps, prevDeps)) storeRef.current = new $eb0b4d1e13e36536$export$390f32400eaf98c9(initialState);
    }
    return storeRef.current;
}
const $eb0b4d1e13e36536$var$globalClientState = {
    storeOrdinal: 0,
    batching: false,
    flushStores: {}
};
(0, $eqO6c.enablePatches)();
function $eb0b4d1e13e36536$var$makeSubscriptionFunction(store, watch, listener) {
    let lastWatchState = watch(store.getRawState());
    return ()=>{
        const currentState = store.getRawState();
        const nextWatchState = watch(currentState);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($b749375ee49085ea$exports)))(nextWatchState, lastWatchState)) {
            listener(nextWatchState, currentState, lastWatchState);
            lastWatchState = nextWatchState;
        }
    };
}
function $eb0b4d1e13e36536$var$makeReactionFunctionCreator(watch, reaction) {
    return (store)=>{
        let lastWatchState = watch(store.getRawState());
        return (forceRun = false)=>{
            const currentState = store.getRawState();
            const nextWatchState = watch(currentState);
            if (forceRun || !(0, (/*@__PURE__*/$parcel$interopDefault($b749375ee49085ea$exports)))(nextWatchState, lastWatchState)) {
                if (store._optListenerCount > 0) {
                    const [nextState, patches, inversePatches] = (0, $eqO6c.produceWithPatches)(currentState, (s)=>reaction(nextWatchState, s, currentState, lastWatchState));
                    store._updateStateWithoutReaction(nextState);
                    lastWatchState = nextWatchState;
                    if (patches.length > 0) {
                        store._patchListeners.forEach((listener)=>listener(patches, inversePatches));
                        return Object.keys($eb0b4d1e13e36536$var$getChangedPathsFromPatches(patches));
                    }
                } else {
                    if (store._patchListeners.length > 0) {
                        const [nextState, patches, inversePatches] = (0, $eqO6c.produceWithPatches)(currentState, (s)=>reaction(nextWatchState, s, currentState, lastWatchState));
                        if (patches.length > 0) store._patchListeners.forEach((listener)=>listener(patches, inversePatches));
                        store._updateStateWithoutReaction(nextState);
                    } else store._updateStateWithoutReaction((0, $eqO6c.produce)(currentState, (s)=>reaction(nextWatchState, s, currentState, lastWatchState)));
                    lastWatchState = nextWatchState;
                }
            }
            return [];
        };
    };
}
const $eb0b4d1e13e36536$var$optPathDivider = "~._.~";
class $eb0b4d1e13e36536$export$390f32400eaf98c9 {
    constructor(initialState){
        this.updateListeners = [];
        this.ssr = false;
        this.reactions = [];
        this.clientSubscriptions = [];
        this.reactionCreators = [];
        this.optimizedUpdateListeners = {};
        this.optimizedUpdateListenerPaths = {};
        this.optimizedListenerPropertyMap = {};
        this._optListenerCount = 0;
        this._patchListeners = [];
        if (initialState instanceof Function) {
            const state = initialState();
            this.currentState = state;
            this.initialState = state;
            this.createInitialState = initialState;
        } else {
            this.currentState = initialState;
            this.initialState = initialState;
            this.createInitialState = ()=>initialState;
        }
        this.internalOrdId = $eb0b4d1e13e36536$var$globalClientState.storeOrdinal++;
    }
    _setInternalOptions({ ssr: ssr, reactionCreators: reactionCreators = [] }) {
        this.ssr = ssr;
        this.reactionCreators = reactionCreators;
        this.reactions = reactionCreators.map((rc)=>rc(this));
    }
    _getReactionCreators() {
        return this.reactionCreators;
    }
    _instantiateReactions() {
        this.reactions = this.reactionCreators.map((rc)=>rc(this));
    }
    _getInitialState() {
        return this.createInitialState();
    }
    _updateStateWithoutReaction(nextState) {
        this.currentState = nextState;
    }
    _updateState(nextState, updateKeyedPaths = []) {
        this.currentState = nextState;
        this.batchState = undefined;
        for (const runReaction of this.reactions)updateKeyedPaths.push(...runReaction());
        if (!this.ssr) {
            for (const runSubscription of this.clientSubscriptions)runSubscription();
            if (updateKeyedPaths.length > 0) {
                const updateOrds = new Set();
                for (const keyedPath of updateKeyedPaths){
                    if (this.optimizedListenerPropertyMap[keyedPath]) for (const ord of this.optimizedListenerPropertyMap[keyedPath])updateOrds.add(ord);
                }
                for (const ord of updateOrds.values())if (this.optimizedUpdateListeners[ord]) this.optimizedUpdateListeners[ord]();
            }
            this.updateListeners.forEach((listener)=>listener());
        }
    }
    _addUpdateListener(listener) {
        this.updateListeners.push(listener);
    }
    _removeUpdateListener(listener) {
        this.updateListeners = this.updateListeners.filter((f)=>f !== listener);
    }
    _removeUpdateListenerOpt(ordKey) {
        const listenerPathsKeyed = this.optimizedUpdateListenerPaths[ordKey];
        for (const keyedPath of listenerPathsKeyed)this.optimizedListenerPropertyMap[keyedPath] = this.optimizedListenerPropertyMap[keyedPath].filter((ord)=>ord !== ordKey);
        delete this.optimizedUpdateListenerPaths[ordKey];
        delete this.optimizedUpdateListeners[ordKey];
        this._optListenerCount--;
    }
    listenToPatches(patchListener) {
        this._patchListeners.push(patchListener);
        return ()=>{
            this._patchListeners = this._patchListeners.filter((f)=>f !== patchListener);
        };
    }
    subscribe(watch, listener) {
        if (!this.ssr) {
            const func = $eb0b4d1e13e36536$var$makeSubscriptionFunction(this, watch, listener);
            this.clientSubscriptions.push(func);
            return ()=>{
                this.clientSubscriptions = this.clientSubscriptions.filter((f)=>f !== func);
            };
        }
        return ()=>{
            console.warn(`Pullstate: Subscriptions made on the server side are not registered - so therefor this call to unsubscribe does nothing.`);
        };
    }
    createReaction(watch, reaction, { runNow: runNow = false, runNowWithSideEffects: runNowWithSideEffects = false } = {}) {
        const creator = $eb0b4d1e13e36536$var$makeReactionFunctionCreator(watch, reaction);
        this.reactionCreators.push(creator);
        const func = creator(this);
        this.reactions.push(func);
        if (runNow || runNowWithSideEffects) {
            func(true);
            if (runNowWithSideEffects && !this.ssr) this._updateState(this.currentState);
        }
        return ()=>{
            this.reactions = this.reactions.filter((f)=>f !== func);
        };
    }
    getRawState() {
        if (this.batchState !== undefined) return this.batchState;
        else return this.currentState;
    }
    useState(getSubState, deps) {
        return $eb0b4d1e13e36536$export$383f6f2f61788070(this, getSubState, deps);
    }
    useLocalCopyInitial(deps) {
        return $eb0b4d1e13e36536$export$f5b97ae82d1eeaf3(this.createInitialState, deps);
    }
    useLocalCopySnapshot(deps) {
        return $eb0b4d1e13e36536$export$f5b97ae82d1eeaf3(this.currentState, deps);
    }
    flushBatch(ignoreError = false) {
        if (this.batchState !== undefined) {
            if (this.batchState !== this.currentState) this._updateState(this.batchState);
        } else if (!ignoreError) console.error(`Pullstate: Trying to flush batch state which was never created or updated on`);
        this.batchState = undefined;
    }
    update(updater, patchesCallback) {
        if ($eb0b4d1e13e36536$var$globalClientState.batching) {
            if (this.batchState === undefined) {
                this.batchState = this.currentState;
                $eb0b4d1e13e36536$var$globalClientState.flushStores[this.internalOrdId] = this;
            }
            const func = typeof updater === "function";
            const [nextState, patches, inversePatches] = $eb0b4d1e13e36536$var$runUpdates(this.batchState, updater, func);
            if (patches.length > 0 && (this._patchListeners.length > 0 || patchesCallback)) {
                if (patchesCallback) patchesCallback(patches, inversePatches);
                this._patchListeners.forEach((listener)=>listener(patches, inversePatches));
            }
            this.batchState = nextState;
        } else {
            this.batchState = undefined;
            $eb0b4d1e13e36536$export$722fbec263ad908a(this, updater, patchesCallback);
        }
    }
    replace(newState) {
        this._updateState(newState);
    }
    replaceFromCurrent(replacer) {
        this._updateState(replacer(this.currentState));
    }
    applyPatches(patches) {
        $eb0b4d1e13e36536$var$applyPatchesToStore(this, patches);
    }
}
function $eb0b4d1e13e36536$var$applyPatchesToStore(store, patches) {
    const currentState = store.getRawState();
    const nextState = (0, $eqO6c.applyPatches)(currentState, patches);
    if (nextState !== currentState) store._updateState(nextState, Object.keys($eb0b4d1e13e36536$var$getChangedPathsFromPatches(patches)));
}
function $eb0b4d1e13e36536$var$getChangedPathsFromPatches(changePatches, prev = {}) {
    for (const patch of changePatches){
        let curKey;
        for (const p of patch.path){
            if (curKey) curKey = `${curKey}${$eb0b4d1e13e36536$var$optPathDivider}${p}`;
            else curKey = p;
            prev[curKey] = 1;
        }
    }
    return prev;
}
function $eb0b4d1e13e36536$var$runUpdates(currentState, updater, func) {
    return func ? (0, $eqO6c.produceWithPatches)(currentState, (s)=>updater(s, currentState)) : updater.reduce(([nextState, patches, inversePatches], currentValue)=>{
        const resp = (0, $eqO6c.produceWithPatches)(nextState, (s)=>currentValue(s, nextState));
        patches.push(...resp[1]);
        inversePatches.push(...resp[2]);
        return [
            resp[0],
            patches,
            inversePatches
        ];
    }, [
        currentState,
        [],
        []
    ]);
}
function $eb0b4d1e13e36536$export$722fbec263ad908a(store, updater, patchesCallback) {
    const currentState = store.getRawState();
    const func = typeof updater === "function";
    if (store._optListenerCount > 0) {
        const [nextState, patches, inversePatches] = $eb0b4d1e13e36536$var$runUpdates(currentState, updater, func);
        if (patches.length > 0) {
            if (patchesCallback) patchesCallback(patches, inversePatches);
            store._patchListeners.forEach((listener)=>listener(patches, inversePatches));
            store._updateState(nextState, Object.keys($eb0b4d1e13e36536$var$getChangedPathsFromPatches(patches)));
        }
    } else {
        let nextState;
        if (store._patchListeners.length > 0 || patchesCallback) {
            const [ns, patches, inversePatches] = $eb0b4d1e13e36536$var$runUpdates(currentState, updater, func);
            if (patches.length > 0) {
                if (patchesCallback) patchesCallback(patches, inversePatches);
                store._patchListeners.forEach((listener)=>listener(patches, inversePatches));
            }
            nextState = ns;
        } else nextState = (0, $eqO6c.produce)(currentState, (s)=>func ? updater(s, currentState) : updater.reduce((previousValue, currentUpdater)=>{
                return (0, $eqO6c.produce)(previousValue, (s)=>currentUpdater(s, previousValue));
            }, currentState));
        if (nextState !== currentState) store._updateState(nextState);
    }
}
function $eb0b4d1e13e36536$export$a8fe790b769cfd37({ store: store, on: on = (s)=>s, children: children }) {
    const state = $eb0b4d1e13e36536$export$383f6f2f61788070(store, on);
    return children(state);
}
var $eb0b4d1e13e36536$export$cf662a91baa94bd1;
(function(EAsyncEndTags) {
    EAsyncEndTags["THREW_ERROR"] = "THREW_ERROR";
    EAsyncEndTags["RETURNED_ERROR"] = "RETURNED_ERROR";
    EAsyncEndTags["UNFINISHED"] = "UNFINISHED";
    EAsyncEndTags["DORMANT"] = "DORMANT";
})($eb0b4d1e13e36536$export$cf662a91baa94bd1 || ($eb0b4d1e13e36536$export$cf662a91baa94bd1 = {}));
var $eb0b4d1e13e36536$export$9af58142bfdbdd29;
(function(EPostActionContext) {
    EPostActionContext["WATCH_HIT_CACHE"] = "WATCH_HIT_CACHE";
    EPostActionContext["BECKON_HIT_CACHE"] = "BECKON_HIT_CACHE";
    EPostActionContext["RUN_HIT_CACHE"] = "RUN_HIT_CACHE";
    EPostActionContext["READ_HIT_CACHE"] = "READ_HIT_CACHE";
    EPostActionContext["READ_RUN"] = "READ_RUN";
    EPostActionContext["SHORT_CIRCUIT"] = "SHORT_CIRCUIT";
    EPostActionContext["DIRECT_RUN"] = "DIRECT_RUN";
    EPostActionContext["BECKON_RUN"] = "BECKON_RUN";
    EPostActionContext["CACHE_UPDATE"] = "CACHE_UPDATE";
})($eb0b4d1e13e36536$export$9af58142bfdbdd29 || ($eb0b4d1e13e36536$export$9af58142bfdbdd29 = {}));
const $eb0b4d1e13e36536$var$clientAsyncCache = {
    listeners: {},
    results: {},
    actions: {},
    actionOrd: {}
};
let $eb0b4d1e13e36536$var$asyncCreationOrdinal = 0;
function $eb0b4d1e13e36536$var$keyFromObject(json) {
    if (json === null) return "(n)";
    const typeOf = typeof json;
    if (typeOf !== "object") {
        if (typeOf === "undefined") return "(u)";
        else if (typeOf === "string") return ":" + json + ";";
        else if (typeOf === "boolean" || typeOf === "number") return "(" + json + ")";
    }
    let prefix = "{";
    for (const key of Object.keys(json).sort())prefix += key + $eb0b4d1e13e36536$var$keyFromObject(json[key]);
    return prefix + "}";
}
function $eb0b4d1e13e36536$var$notifyListeners(key) {
    if ($eb0b4d1e13e36536$var$clientAsyncCache.listeners.hasOwnProperty(key)) for (const watchId of Object.keys($eb0b4d1e13e36536$var$clientAsyncCache.listeners[key]))$eb0b4d1e13e36536$var$clientAsyncCache.listeners[key][watchId]();
}
function $eb0b4d1e13e36536$var$clearActionCache(key, clearPending = true, notify = true) {
    if (clearPending && $eb0b4d1e13e36536$var$clientAsyncCache.actionOrd.hasOwnProperty(key)) $eb0b4d1e13e36536$var$clientAsyncCache.actionOrd[key] += 1;
    delete $eb0b4d1e13e36536$var$clientAsyncCache.results[key];
    if (notify) $eb0b4d1e13e36536$var$notifyListeners(key);
}
function $eb0b4d1e13e36536$var$actionOrdUpdate(cache, key) {
    if (!cache.actionOrd.hasOwnProperty(key)) cache.actionOrd[key] = 0;
    else cache.actionOrd[key] += 1;
    return cache.actionOrd[key];
}
function $eb0b4d1e13e36536$export$5437af0b946b4f81(payload = null, tags = [], message = "") {
    return {
        payload: payload,
        tags: tags,
        message: message,
        error: false,
        errorPayload: null
    };
}
function $eb0b4d1e13e36536$export$28ccfe8bc85ddc94(tags = [], message = "", errorPayload) {
    return {
        payload: null,
        tags: [
            $eb0b4d1e13e36536$export$cf662a91baa94bd1.RETURNED_ERROR,
            ...tags
        ],
        message: message,
        error: true,
        errorPayload: errorPayload
    };
}
class $eb0b4d1e13e36536$var$PullstateAsyncError extends Error {
    constructor(message, tags){
        super(message);
        this.tags = tags;
    }
}
let $eb0b4d1e13e36536$var$storeErrorProxy;
try {
    $eb0b4d1e13e36536$var$storeErrorProxy = new Proxy({}, {
        get: function(obj, prop) {
            throw new Error(`Pullstate: Trying to access store (${String(prop)}) inside async actions without the correct usage or setup.
If this error occurred on the server:
* If using run(), make use of your created instance for this request: instance.runAsyncAction()
* If using read(), useWatch(), useBeckon() etc. - make sure you have properly set up your <PullstateProvider/>

If this error occurred on the client:
* Make sure you have created your "pullstateCore" object with all your stores, using createPullstateCore(), and are making use of instantiate() before rendering.`);
        }
    });
} catch  {
    $eb0b4d1e13e36536$var$storeErrorProxy = {};
}
const $eb0b4d1e13e36536$var$startedButUnfinishedResult = [
    true,
    false,
    {
        message: "",
        tags: [
            $eb0b4d1e13e36536$export$cf662a91baa94bd1.UNFINISHED
        ],
        error: true,
        payload: null,
        errorPayload: null
    },
    false,
    -1
];
function $eb0b4d1e13e36536$export$1bf85a667346a1b4(action, options = {}) {
    return $eb0b4d1e13e36536$export$3a80f7e4c1c7e6a8(async (args, stores, customContext)=>{
        return $eb0b4d1e13e36536$export$5437af0b946b4f81(await action(args, stores, customContext));
    }, options);
}
function $eb0b4d1e13e36536$var$convertCustomCacheBreakHook(cacheBreakHook) {
    if (cacheBreakHook != null) {
        if (typeof cacheBreakHook === "boolean") return ()=>cacheBreakHook;
        else if (typeof cacheBreakHook === "number") return ({ timeCached: timeCached, result: result })=>{
            if (!result.error) return Date.now() - timeCached > cacheBreakHook;
            return true;
        };
        return cacheBreakHook;
    }
    return undefined;
}
function $eb0b4d1e13e36536$export$3a80f7e4c1c7e6a8(action, { forceContext: forceContext = false, shortCircuitHook: shortCircuitHook, cacheBreakHook: cacheBreakHook, postActionHook: postActionHook, subsetKey: subsetKey, actionId: actionId } = {}) {
    const ordinal = actionId != null ? `_${actionId}` : $eb0b4d1e13e36536$var$asyncCreationOrdinal++;
    const onServer = typeof window === "undefined";
    function _createKey(args, customKey) {
        if (customKey != null) return `${ordinal}-c-${customKey}`;
        if (subsetKey !== undefined) return `${ordinal}-${$eb0b4d1e13e36536$var$keyFromObject(subsetKey(args))}`;
        return `${ordinal}-${$eb0b4d1e13e36536$var$keyFromObject(args)}`;
    }
    const deferWaitingKey = `def_wait_${_createKey({})}`;
    let cacheBreakWatcher = {};
    let watchIdOrd = 0;
    const shouldUpdate = {};
    function runPostActionHook(result, args, stores, context) {
        if (postActionHook !== undefined) postActionHook({
            args: args,
            result: result,
            stores: stores,
            context: context
        });
    }
    function getCachedResult({ args: args, cache: cache, cacheBreakEnabled: cacheBreakEnabled, context: context, fromListener: fromListener, key: key, postActionEnabled: postActionEnabled, stores: stores, customCacheBreak: customCacheBreak }) {
        const useCacheBreakHook = customCacheBreak !== null && customCacheBreak !== void 0 ? customCacheBreak : cacheBreakHook;
        if (cache.results.hasOwnProperty(key)) {
            const cacheBreakLoop = cacheBreakWatcher.hasOwnProperty(key) && cacheBreakWatcher[key] > 2;
            if (!onServer && !fromListener && cacheBreakEnabled && useCacheBreakHook != null && cache.results[key][1] && useCacheBreakHook({
                args: args,
                result: cache.results[key][2],
                stores: stores,
                timeCached: cache.results[key][4]
            }) && !cacheBreakLoop) {
                if (cacheBreakWatcher.hasOwnProperty(key)) cacheBreakWatcher[key]++;
                else cacheBreakWatcher[key] = 1;
                const previous = cache.results[key];
                delete cache.results[key];
                return {
                    cacheBroke: true,
                    response: undefined,
                    previous: previous
                };
            } else {
                if (cacheBreakLoop) console.error(`[${key}] Pullstate detected an infinite loop caused by cacheBreakHook()
returning true too often (breaking cache as soon as your action is resolving - hence
causing beckoned actions to run the action again) in one of your AsyncActions - Pullstate prevented
further looping. Fix in your cacheBreakHook() is needed.`);
                else cacheBreakWatcher[key] = 0;
                if (postActionEnabled && cache.results[key][1] && !fromListener) runPostActionHook(cache.results[key][2], args, stores, context);
                return {
                    response: cache.results[key],
                    cacheBroke: false,
                    previous: undefined
                };
            }
        }
        return {
            cacheBroke: false,
            response: undefined,
            previous: undefined
        };
    }
    function createInternalAction(key, cache, args, stores, currentActionOrd, postActionEnabled, executionContext, customContext) {
        return ()=>action(args, stores, customContext).then((resp)=>{
                if (currentActionOrd === cache.actionOrd[key]) {
                    if (postActionEnabled) runPostActionHook(resp, args, stores, executionContext);
                    cache.results[key] = [
                        true,
                        true,
                        resp,
                        false,
                        Date.now()
                    ];
                }
                return resp;
            }).catch((e)=>{
                console.error(e);
                const result = {
                    payload: null,
                    errorPayload: null,
                    error: true,
                    tags: [
                        $eb0b4d1e13e36536$export$cf662a91baa94bd1.THREW_ERROR
                    ],
                    message: e.message
                };
                if (currentActionOrd === cache.actionOrd[key]) {
                    if (postActionEnabled) runPostActionHook(result, args, stores, executionContext);
                    cache.results[key] = [
                        true,
                        true,
                        result,
                        false,
                        Date.now()
                    ];
                }
                return result;
            }).then((resp)=>{
                if (currentActionOrd === cache.actionOrd[key]) {
                    delete cache.actions[key];
                    if (!onServer) $eb0b4d1e13e36536$var$notifyListeners(key);
                }
                return resp;
            });
    }
    function checkKeyAndReturnResponse({ key: key, cache: cache, initiate: initiate, ssr: ssr, args: args, stores: stores, fromListener: fromListener = false, postActionEnabled: postActionEnabled = true, cacheBreakEnabled: cacheBreakEnabled = true, holdingResult: holdingResult, customContext: customContext, customCacheBreak: customCacheBreak, holdPrevious: holdPrevious }) {
        const cached = getCachedResult({
            key: key,
            cache: cache,
            args: args,
            stores: stores,
            context: initiate ? $eb0b4d1e13e36536$export$9af58142bfdbdd29.BECKON_HIT_CACHE : $eb0b4d1e13e36536$export$9af58142bfdbdd29.WATCH_HIT_CACHE,
            postActionEnabled: postActionEnabled,
            cacheBreakEnabled: cacheBreakEnabled,
            fromListener: fromListener,
            customCacheBreak: customCacheBreak
        });
        if (cached.response) return cached.response;
        if (!cache.actions.hasOwnProperty(key)) {
            const currentActionOrd = $eb0b4d1e13e36536$var$actionOrdUpdate(cache, key);
            if (initiate) {
                if (shortCircuitHook !== undefined) {
                    const shortCircuitResponse = shortCircuitHook({
                        args: args,
                        stores: stores
                    });
                    if (shortCircuitResponse !== false) {
                        runPostActionHook(shortCircuitResponse, args, stores, $eb0b4d1e13e36536$export$9af58142bfdbdd29.SHORT_CIRCUIT);
                        cache.results[key] = [
                            true,
                            true,
                            shortCircuitResponse,
                            false,
                            Date.now()
                        ];
                        return cache.results[key];
                    }
                }
                if (ssr || !onServer) cache.actions[key] = createInternalAction(key, cache, args, stores, currentActionOrd, postActionEnabled, $eb0b4d1e13e36536$export$9af58142bfdbdd29.BECKON_RUN, customContext);
                if (!onServer) {
                    cache.actions[key]();
                    cache.results[key] = $eb0b4d1e13e36536$var$startedButUnfinishedResult;
                } else return $eb0b4d1e13e36536$var$startedButUnfinishedResult;
            } else {
                const resp = [
                    false,
                    false,
                    {
                        message: "",
                        tags: [
                            $eb0b4d1e13e36536$export$cf662a91baa94bd1.UNFINISHED
                        ],
                        error: true,
                        payload: null,
                        errorPayload: null
                    },
                    false,
                    -1
                ];
                if (!onServer) cache.results[key] = resp;
                if (holdPrevious) {
                    if (holdingResult) {
                        const response = [
                            ...holdingResult
                        ];
                        response[3] = true;
                        return response;
                    }
                    if (cached.previous != null) {
                        const response = [
                            ...cached.previous
                        ];
                        response[3] = true;
                        return response;
                    }
                }
                return resp;
            }
        }
        if (holdPrevious) {
            if (holdingResult) {
                const response = [
                    ...holdingResult
                ];
                response[3] = true;
                return response;
            }
            if (cached.previous != null) {
                const response = [
                    ...cached.previous
                ];
                response[3] = true;
                return response;
            }
        }
        return $eb0b4d1e13e36536$var$startedButUnfinishedResult;
    }
    const read = (args = {}, { cacheBreakEnabled: cacheBreakEnabled = true, postActionEnabled: postActionEnabled = true, key: customKey } = {})=>{
        const key = _createKey(args, customKey);
        const cache = onServer ? (0, $28UcW.useContext)($eb0b4d1e13e36536$export$2a125cbafd895cd3)._asyncCache : $eb0b4d1e13e36536$var$clientAsyncCache;
        let stores;
        let customContext;
        if (onServer || forceContext) {
            const pullstateContext = (0, $28UcW.useContext)($eb0b4d1e13e36536$export$2a125cbafd895cd3);
            stores = pullstateContext.stores;
            customContext = pullstateContext.customContext;
        } else if ($eb0b4d1e13e36536$var$clientStores.loaded) stores = $eb0b4d1e13e36536$var$clientStores.stores;
        else stores = $eb0b4d1e13e36536$var$storeErrorProxy;
        const cached = getCachedResult({
            key: key,
            cache: cache,
            args: args,
            stores: stores,
            context: $eb0b4d1e13e36536$export$9af58142bfdbdd29.READ_HIT_CACHE,
            postActionEnabled: postActionEnabled,
            cacheBreakEnabled: cacheBreakEnabled,
            fromListener: false
        });
        if (cached.response) {
            if (!cached.response[2].error) return cached.response[2].payload;
            else throw new $eb0b4d1e13e36536$var$PullstateAsyncError(cached.response[2].message, cached.response[2].tags);
        }
        if (!cache.actions.hasOwnProperty(key)) {
            if (shortCircuitHook !== undefined) {
                const shortCircuitResponse = shortCircuitHook({
                    args: args,
                    stores: stores
                });
                if (shortCircuitResponse !== false) {
                    runPostActionHook(shortCircuitResponse, args, stores, $eb0b4d1e13e36536$export$9af58142bfdbdd29.SHORT_CIRCUIT);
                    cache.results[key] = [
                        true,
                        true,
                        shortCircuitResponse,
                        false,
                        Date.now()
                    ];
                    if (!shortCircuitResponse.error) return shortCircuitResponse.payload;
                    else throw new $eb0b4d1e13e36536$var$PullstateAsyncError(shortCircuitResponse.message, shortCircuitResponse.tags);
                }
            }
            const currentActionOrd = $eb0b4d1e13e36536$var$actionOrdUpdate(cache, key);
            cache.actions[key] = createInternalAction(key, cache, args, stores, currentActionOrd, postActionEnabled, $eb0b4d1e13e36536$export$9af58142bfdbdd29.READ_RUN, customContext);
            if (onServer) throw new Error(`Pullstate Async Action: action.read() : Resolve all async state for Suspense actions before Server-side render ( make use of instance.runAsyncAction() )`);
            throw cache.actions[key]();
        }
        if (onServer) throw new Error(`Pullstate Async Action: action.read() : Resolve all async state for Suspense actions before Server-side render ( make use of instance.runAsyncAction() )`);
        const watchOrd = watchIdOrd++;
        throw new Promise((resolve)=>{
            cache.listeners[key][watchOrd] = ()=>{
                delete cache.listeners[key][watchOrd];
                resolve();
            };
        });
    };
    const useWatch = (args = {}, { initiate: initiate = false, ssr: ssr = true, postActionEnabled: postActionEnabled = false, cacheBreakEnabled: cacheBreakEnabled = false, holdPrevious: holdPrevious = false, dormant: dormant = false, key: customKey, cacheBreak: customCacheBreakIncoming } = {})=>{
        const responseRef = (0, $28UcW.useRef)();
        const prevKeyRef = (0, $28UcW.useRef)(".");
        const key = dormant ? "." : _createKey(args, customKey);
        let watchId = (0, $28UcW.useRef)(-1);
        if (watchId.current === -1) watchId.current = watchIdOrd++;
        if (!dormant) {
            if (!shouldUpdate.hasOwnProperty(key)) shouldUpdate[key] = {
                [watchId.current]: true
            };
            else shouldUpdate[key][watchId.current] = true;
        }
        const cache = onServer ? (0, $28UcW.useContext)($eb0b4d1e13e36536$export$2a125cbafd895cd3)._asyncCache : $eb0b4d1e13e36536$var$clientAsyncCache;
        let stores;
        let customContext;
        if (onServer || forceContext) {
            const pullstateContext = (0, $28UcW.useContext)($eb0b4d1e13e36536$export$2a125cbafd895cd3);
            stores = pullstateContext.stores;
            customContext = pullstateContext.customContext;
        } else if ($eb0b4d1e13e36536$var$clientStores.loaded) stores = $eb0b4d1e13e36536$var$clientStores.stores;
        else stores = $eb0b4d1e13e36536$var$storeErrorProxy;
        if (!onServer) {
            const onAsyncStateChanged = ()=>{
                if (shouldUpdate[key][watchId.current] && !(0, (/*@__PURE__*/$parcel$interopDefault($b749375ee49085ea$exports)))(responseRef.current, cache.results[key])) {
                    const nextResponse = checkKeyAndReturnResponse({
                        key: key,
                        cache: cache,
                        initiate: initiate,
                        ssr: ssr,
                        args: args,
                        stores: stores,
                        fromListener: true,
                        postActionEnabled: postActionEnabled,
                        cacheBreakEnabled: cacheBreakEnabled,
                        holdingResult: undefined,
                        customContext: customContext,
                        holdPrevious: holdPrevious
                    });
                    if (holdPrevious && !nextResponse[1] && responseRef.current != null && responseRef.current[1]) {
                        responseRef.current = [
                            ...responseRef.current
                        ];
                        responseRef.current[3] = true;
                    } else responseRef.current = nextResponse;
                    setWatchUpdate((prev)=>{
                        return prev + 1;
                    });
                }
            };
            if (!dormant) {
                if (!cache.listeners.hasOwnProperty(key)) cache.listeners[key] = {};
                cache.listeners[key][watchId.current] = onAsyncStateChanged;
                shouldUpdate[key][watchId.current] = true;
            }
            (0, $28UcW.useEffect)(()=>{
                if (!dormant) {
                    cache.listeners[key][watchId.current] = onAsyncStateChanged;
                    shouldUpdate[key][watchId.current] = true;
                }
                return ()=>{
                    if (!dormant) {
                        delete cache.listeners[key][watchId.current];
                        shouldUpdate[key][watchId.current] = false;
                    }
                };
            }, [
                key
            ]);
        }
        const [_, setWatchUpdate] = (0, $28UcW.useState)(0);
        if (dormant) {
            responseRef.current = holdPrevious && responseRef.current && responseRef.current[1] ? responseRef.current : [
                false,
                false,
                {
                    message: "",
                    tags: [
                        $eb0b4d1e13e36536$export$cf662a91baa94bd1.DORMANT
                    ],
                    error: true,
                    payload: null
                },
                false,
                -1
            ];
            prevKeyRef.current = ".";
        } else if (prevKeyRef.current !== key) {
            if (prevKeyRef.current !== null && shouldUpdate.hasOwnProperty(prevKeyRef.current)) {
                delete cache.listeners[prevKeyRef.current][watchId.current];
                shouldUpdate[prevKeyRef.current][watchId.current] = false;
            }
            prevKeyRef.current = key;
            responseRef.current = checkKeyAndReturnResponse({
                key: key,
                cache: cache,
                initiate: initiate,
                ssr: ssr,
                args: args,
                stores: stores,
                fromListener: false,
                postActionEnabled: postActionEnabled,
                cacheBreakEnabled: cacheBreakEnabled,
                holdingResult: holdPrevious && responseRef.current && responseRef.current[1] ? responseRef.current : undefined,
                customContext: customContext,
                customCacheBreak: $eb0b4d1e13e36536$var$convertCustomCacheBreakHook(customCacheBreakIncoming),
                holdPrevious: holdPrevious
            });
        }
        return responseRef.current;
    };
    const useBeckon = (args = {}, { ssr: ssr = true, postActionEnabled: postActionEnabled = true, cacheBreakEnabled: cacheBreakEnabled = true, holdPrevious: holdPrevious = false, dormant: dormant = false, key: key } = {})=>{
        const result = useWatch(args, {
            initiate: true,
            ssr: ssr,
            postActionEnabled: postActionEnabled,
            cacheBreakEnabled: cacheBreakEnabled,
            holdPrevious: holdPrevious,
            dormant: dormant,
            key: key
        });
        return [
            result[1],
            result[2],
            result[3]
        ];
    };
    const run = async (args = {}, inputs = {})=>{
        const { treatAsUpdate: treatAsUpdate = false, ignoreShortCircuit: ignoreShortCircuit = false, respectCache: respectCache = false, key: customKey, _asyncCache: _asyncCache = $eb0b4d1e13e36536$var$clientAsyncCache, _stores: _stores = $eb0b4d1e13e36536$var$clientStores.loaded ? $eb0b4d1e13e36536$var$clientStores.stores : $eb0b4d1e13e36536$var$storeErrorProxy, _customContext: _customContext, cacheBreak: customCacheBreak } = inputs;
        const key = _createKey(args, customKey);
        if (respectCache) {
            const cached = getCachedResult({
                key: key,
                cache: _asyncCache,
                args: args,
                stores: _stores,
                context: $eb0b4d1e13e36536$export$9af58142bfdbdd29.RUN_HIT_CACHE,
                postActionEnabled: true,
                cacheBreakEnabled: true,
                fromListener: false,
                customCacheBreak: $eb0b4d1e13e36536$var$convertCustomCacheBreakHook(customCacheBreak)
            });
            if (cached.response && cached.response[0]) {
                if (!cached.response[1]) {
                    const watchOrd = watchIdOrd++;
                    if (!_asyncCache.listeners.hasOwnProperty(key)) _asyncCache.listeners[key] = {};
                    return new Promise((resolve)=>{
                        _asyncCache.listeners[key][watchOrd] = ()=>{
                            const [, finished, resp] = _asyncCache.results[key];
                            if (finished) {
                                delete _asyncCache.listeners[key][watchOrd];
                                resolve(resp);
                            }
                        };
                    });
                }
                return cached.response[2];
            }
        }
        if (!ignoreShortCircuit && shortCircuitHook !== undefined) {
            const shortCircuitResponse = shortCircuitHook({
                args: args,
                stores: _stores
            });
            if (shortCircuitResponse !== false) {
                _asyncCache.results[key] = [
                    true,
                    true,
                    shortCircuitResponse,
                    false,
                    Date.now()
                ];
                runPostActionHook(shortCircuitResponse, args, _stores, $eb0b4d1e13e36536$export$9af58142bfdbdd29.SHORT_CIRCUIT);
                $eb0b4d1e13e36536$var$notifyListeners(key);
                return shortCircuitResponse;
            }
        }
        const [, prevFinished, prevResp, prevUpdate, prevCacheTime] = _asyncCache.results[key] || [
            false,
            false,
            {
                error: true,
                message: "",
                payload: null,
                tags: [
                    $eb0b4d1e13e36536$export$cf662a91baa94bd1.UNFINISHED
                ]
            },
            false,
            -1
        ];
        if (prevFinished && treatAsUpdate) _asyncCache.results[key] = [
            true,
            true,
            prevResp,
            true,
            prevCacheTime
        ];
        else _asyncCache.results[key] = [
            true,
            false,
            {
                error: true,
                message: "",
                payload: null,
                tags: [
                    $eb0b4d1e13e36536$export$cf662a91baa94bd1.UNFINISHED
                ]
            },
            false,
            -1
        ];
        let currentActionOrd = $eb0b4d1e13e36536$var$actionOrdUpdate(_asyncCache, key);
        _asyncCache.actions[key] = createInternalAction(key, _asyncCache, args, _stores, currentActionOrd, true, $eb0b4d1e13e36536$export$9af58142bfdbdd29.DIRECT_RUN, _customContext);
        $eb0b4d1e13e36536$var$notifyListeners(key);
        return _asyncCache.actions[key]();
    };
    const clearCache = (args = {}, { key: customKey, notify: notify = true } = {})=>{
        const key = _createKey(args, customKey);
        $eb0b4d1e13e36536$var$clearActionCache(key, true, notify);
    };
    const clearAllCache = ({ notify: notify = true } = {})=>{
        for (const key of Object.keys($eb0b4d1e13e36536$var$clientAsyncCache.actionOrd))if (key.startsWith(`${ordinal}-`)) $eb0b4d1e13e36536$var$clearActionCache(key, true, notify);
    };
    const clearAllUnwatchedCache = ({ notify: notify = true } = {})=>{
        for (const key of Object.keys(shouldUpdate))if (!Object.values(shouldUpdate[key]).some((su)=>su)) {
            delete shouldUpdate[key];
            $eb0b4d1e13e36536$var$clearActionCache(key, false, notify);
        }
    };
    const setCached = (args, result, options)=>{
        const { notify: notify = true, key: customKey } = options || {};
        const key = _createKey(args, customKey);
        const cache = onServer ? (0, $28UcW.useContext)($eb0b4d1e13e36536$export$2a125cbafd895cd3)._asyncCache : $eb0b4d1e13e36536$var$clientAsyncCache;
        cache.results[key] = [
            true,
            true,
            result,
            false,
            Date.now()
        ];
        if (notify) $eb0b4d1e13e36536$var$notifyListeners(key);
    };
    const setCachedPayload = (args, payload, options)=>{
        return setCached(args, $eb0b4d1e13e36536$export$5437af0b946b4f81(payload), options);
    };
    const updateCached = (args, updater, options)=>{
        const { notify: notify = true, resetTimeCached: resetTimeCached = true, runPostActionHook: postAction = false, key: customKey } = options || {};
        const key = _createKey(args, customKey);
        const cache = onServer ? (0, $28UcW.useContext)($eb0b4d1e13e36536$export$2a125cbafd895cd3)._asyncCache : $eb0b4d1e13e36536$var$clientAsyncCache;
        if (cache.results.hasOwnProperty(key) && !cache.results[key][2].error) {
            const currentCached = cache.results[key][2].payload;
            const newResult = {
                payload: (0, $eqO6c.default)(currentCached, (s)=>updater(s, currentCached)),
                error: false,
                message: cache.results[key][2].message,
                tags: cache.results[key][2].tags
            };
            if (postAction) runPostActionHook(newResult, args, $eb0b4d1e13e36536$var$clientStores.loaded ? $eb0b4d1e13e36536$var$clientStores.stores : $eb0b4d1e13e36536$var$storeErrorProxy, $eb0b4d1e13e36536$export$9af58142bfdbdd29.CACHE_UPDATE);
            cache.results[key] = [
                true,
                true,
                newResult,
                cache.results[key][3],
                resetTimeCached ? Date.now() : cache.results[key][4]
            ];
            if (notify) $eb0b4d1e13e36536$var$notifyListeners(key);
        }
    };
    const getCached = (args = {}, options)=>{
        var _a;
        const { checkCacheBreak: checkCacheBreak = false, key: customKey, cacheBreak: incomingCacheBreak } = options || {};
        const key = _createKey(args, customKey);
        let cacheBreakable = false;
        const cache = $eb0b4d1e13e36536$var$clientAsyncCache;
        if (cache.results.hasOwnProperty(key)) {
            const finalizedCacheBreakHook = (_a = $eb0b4d1e13e36536$var$convertCustomCacheBreakHook(incomingCacheBreak)) !== null && _a !== void 0 ? _a : cacheBreakHook;
            if (checkCacheBreak && finalizedCacheBreakHook !== undefined) {
                const stores = onServer ? (0, $28UcW.useContext)($eb0b4d1e13e36536$export$2a125cbafd895cd3).stores : $eb0b4d1e13e36536$var$clientStores.loaded ? $eb0b4d1e13e36536$var$clientStores.stores : $eb0b4d1e13e36536$var$storeErrorProxy;
                if (finalizedCacheBreakHook({
                    args: args,
                    result: cache.results[key][2],
                    stores: stores,
                    timeCached: cache.results[key][4]
                })) cacheBreakable = true;
            }
            const [started, finished, result, updating, timeCached] = cache.results[key];
            return {
                started: started,
                finished: finished,
                result: result,
                existed: true,
                cacheBreakable: cacheBreakable,
                updating: updating,
                timeCached: timeCached
            };
        } else return {
            started: false,
            finished: false,
            result: {
                message: "",
                tags: [
                    $eb0b4d1e13e36536$export$cf662a91baa94bd1.UNFINISHED
                ],
                error: true,
                payload: null,
                errorPayload: null
            },
            updating: false,
            existed: false,
            cacheBreakable: cacheBreakable,
            timeCached: -1
        };
    };
    let delayedRunActionTimeout;
    const delayedRun = (args = {}, { clearOldRun: clearOldRun = true, delay: delay, immediateIfCached: immediateIfCached = true, ...otherRunOptions })=>{
        if (clearOldRun) clearTimeout(delayedRunActionTimeout);
        if (immediateIfCached) {
            const { finished: finished, cacheBreakable: cacheBreakable } = getCached(args, {
                checkCacheBreak: true
            });
            if (finished && !cacheBreakable) {
                run(args, otherRunOptions);
                return ()=>{};
            }
        }
        let ref = {
            cancelled: false
        };
        delayedRunActionTimeout = setTimeout(()=>{
            if (!ref.cancelled) run(args, otherRunOptions);
        }, delay);
        return ()=>{
            ref.cancelled = true;
        };
    };
    const use = (args = {}, { initiate: initiate = true, ssr: ssr = true, postActionEnabled: postActionEnabled, cacheBreakEnabled: cacheBreakEnabled, holdPrevious: holdPrevious = false, dormant: dormant = false, key: key, onSuccess: onSuccess, cacheBreak: customCacheBreakHook } = {})=>{
        if (postActionEnabled == null) postActionEnabled = initiate;
        if (cacheBreakEnabled == null) cacheBreakEnabled = initiate;
        const raw = useWatch(args, {
            initiate: initiate,
            ssr: ssr,
            postActionEnabled: postActionEnabled,
            cacheBreakEnabled: cacheBreakEnabled,
            holdPrevious: holdPrevious,
            dormant: dormant,
            key: key,
            cacheBreak: customCacheBreakHook
        });
        const [isStarted, isFinished, result, isUpdating] = raw;
        const isSuccess = isFinished && !result.error;
        const isFailure = isFinished && result.error;
        if (onSuccess) (0, $28UcW.useEffect)(()=>{
            if (isSuccess && !dormant) onSuccess(result.payload, args);
        }, [
            isSuccess
        ]);
        const renderPayload = (func)=>{
            if (!result.error) return func(result.payload);
            return (0, (/*@__PURE__*/$parcel$interopDefault($28UcW))).Fragment;
        };
        return {
            isStarted: isStarted,
            isFinished: isFinished,
            isUpdating: isUpdating,
            isSuccess: isSuccess,
            isFailure: isFailure,
            isLoading: isStarted && (!isFinished || isUpdating),
            endTags: result.tags,
            error: result.error,
            payload: result.payload,
            errorPayload: result.errorPayload,
            renderPayload: renderPayload,
            message: result.message,
            raw: raw,
            execute: (runOptions)=>run(args, runOptions),
            clearCached: ()=>clearCache(args),
            setCached: (response, options)=>{
                setCached(args, response, options);
            },
            setCachedPayload: (payload, options)=>{
                setCachedPayload(args, payload, options);
            },
            updateCached: (updater, options)=>{
                updateCached(args, updater, options);
            }
        };
    };
    const useDefer = (inputs = {})=>{
        const [argState, setArgState] = (0, $28UcW.useState)(()=>({
                key: inputs.key ? inputs.key : deferWaitingKey,
                args: {}
            }));
        const initialResponse = use({}, {
            ...inputs,
            key: argState.key,
            initiate: false
        });
        const hasCached = (args = {}, options = {})=>{
            var _a, _b;
            const executionKey = (_a = inputs.key) !== null && _a !== void 0 ? _a : _createKey(args);
            const { checkCacheBreak: checkCacheBreak = true, successOnly: successOnly = false } = options;
            const cached = getCached(args, {
                key: executionKey,
                cacheBreak: (_b = options.cacheBreak) !== null && _b !== void 0 ? _b : inputs.cacheBreak,
                checkCacheBreak: checkCacheBreak
            });
            if (cached.existed) {
                if (!checkCacheBreak || !cached.cacheBreakable) return !successOnly || !cached.result.error;
            }
            return false;
        };
        const unwatchExecuted = ()=>{
            setArgState({
                key: deferWaitingKey,
                args: {}
            });
        };
        const execute = (args = {}, runOptions)=>{
            var _a;
            const executionKey = (_a = inputs.key) !== null && _a !== void 0 ? _a : _createKey(args);
            if (executionKey !== argState.key) setArgState({
                key: executionKey,
                args: args
            });
            return run(args, {
                ...runOptions,
                key: executionKey,
                cacheBreak: inputs.cacheBreak
            }).then((resp)=>{
                if (inputs.clearOnSuccess) clearCache({}, {
                    key: executionKey
                });
                return resp;
            });
        };
        return {
            ...initialResponse,
            clearCached: ()=>{
                clearCache({}, {
                    key: argState.key
                });
            },
            unwatchExecuted: unwatchExecuted,
            setCached: (response, options = {})=>{
                options.key = argState.key;
                setCached({}, response, options);
            },
            setCachedPayload: (payload, options = {})=>{
                options.key = argState.key;
                setCachedPayload({}, payload, options);
            },
            updateCached: (updater, options = {})=>{
                options.key = argState.key;
                updateCached({}, updater, options);
            },
            useDebouncedExecution: (args, delay, options = {})=>{
                if (!onServer) {
                    const stateRef = (0, $28UcW.useRef)({
                        update: false
                    });
                    const currentValue = (0, $28UcW.useRef)(undefined);
                    const executionOrd = (0, $28UcW.useRef)(-1);
                    const timeout = (0, $28UcW.useRef)(undefined);
                    (0, $28UcW.useEffect)(()=>{
                        stateRef.current.update = true;
                        return ()=>{
                            stateRef.current.update = false;
                        };
                    }, []);
                    const hasEqualityCheck = options.equality != null;
                    if (hasEqualityCheck) {
                        if (typeof options.equality === "function") {
                            if (currentValue.current === undefined || options.equality(currentValue.current, args)) {
                                currentValue.current = args;
                                executionOrd.current += 1;
                            }
                        } else if (currentValue.current !== options.equality) {
                            currentValue.current = options.equality;
                            executionOrd.current += 1;
                        }
                    } else if (!(0, (/*@__PURE__*/$parcel$interopDefault($b749375ee49085ea$exports)))(currentValue.current, args)) {
                        currentValue.current = args;
                        executionOrd.current += 1;
                    }
                    (0, $28UcW.useEffect)(()=>{
                        var _a, _b, _c;
                        clearTimeout(timeout.current);
                        const executeAction = ()=>{
                            var _a;
                            if (stateRef.current.update) execute(args, (_a = options.executeOptions) !== null && _a !== void 0 ? _a : {
                                respectCache: true
                            });
                        };
                        if ((_b = (_a = options.validInput) === null || _a === void 0 ? void 0 : _a.call(options, args)) !== null && _b !== void 0 ? _b : true) {
                            if (hasCached(args)) executeAction();
                            else timeout.current = setTimeout(executeAction, delay);
                        } else if (!((_c = options.watchLastValid) !== null && _c !== void 0 ? _c : false)) unwatchExecuted();
                    }, [
                        executionOrd.current
                    ]);
                }
            },
            hasCached: hasCached,
            execute: execute,
            args: argState.args,
            key: argState.key
        };
    };
    return {
        use: use,
        useDefer: useDefer,
        read: read,
        useBeckon: useBeckon,
        useWatch: useWatch,
        run: run,
        delayedRun: delayedRun,
        clearCache: clearCache,
        clearAllCache: clearAllCache,
        clearAllUnwatchedCache: clearAllUnwatchedCache,
        getCached: getCached,
        setCached: setCached,
        setCachedPayload: setCachedPayload,
        updateCached: updateCached
    };
}
const $eb0b4d1e13e36536$export$2a125cbafd895cd3 = (0, (/*@__PURE__*/$parcel$interopDefault($28UcW))).createContext(null);
const $eb0b4d1e13e36536$export$5ccae54ff2ca9c47 = ({ instance: instance, children: children })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($28UcW))).createElement($eb0b4d1e13e36536$export$2a125cbafd895cd3.Provider, {
        value: instance
    }, children);
};
let $eb0b4d1e13e36536$var$singleton = null;
const $eb0b4d1e13e36536$var$clientStores = {
    internalClientStores: true,
    loaded: false,
    stores: {}
};
class $eb0b4d1e13e36536$var$PullstateSingleton {
    constructor(allStores, options = {}){
        this.options = {};
        if ($eb0b4d1e13e36536$var$singleton !== null) console.error(`Pullstate: createPullstate() - Should not be creating the core Pullstate class more than once! In order to re-use pull state, you need to call instantiate() on your already created object.`);
        $eb0b4d1e13e36536$var$singleton = this;
        $eb0b4d1e13e36536$var$clientStores.stores = allStores;
        $eb0b4d1e13e36536$var$clientStores.loaded = true;
        this.options = options;
    }
    instantiate({ hydrateSnapshot: hydrateSnapshot, ssr: ssr = false, customContext: customContext } = {}) {
        if (!ssr) {
            const instantiated = new $eb0b4d1e13e36536$var$PullstateInstance($eb0b4d1e13e36536$var$clientStores.stores, false, customContext);
            if (hydrateSnapshot != null) instantiated.hydrateFromSnapshot(hydrateSnapshot);
            instantiated.instantiateReactions();
            return instantiated;
        }
        const newStores = {};
        for (const storeName of Object.keys($eb0b4d1e13e36536$var$clientStores.stores)){
            if (hydrateSnapshot == null) newStores[storeName] = new $eb0b4d1e13e36536$export$390f32400eaf98c9($eb0b4d1e13e36536$var$clientStores.stores[storeName]._getInitialState());
            else if (hydrateSnapshot.hasOwnProperty(storeName)) newStores[storeName] = new $eb0b4d1e13e36536$export$390f32400eaf98c9(hydrateSnapshot.allState[storeName]);
            else {
                newStores[storeName] = new $eb0b4d1e13e36536$export$390f32400eaf98c9($eb0b4d1e13e36536$var$clientStores.stores[storeName]._getInitialState());
                console.warn(`Pullstate (instantiate): store [${storeName}] didn't hydrate any state (data was non-existent on hydration object)`);
            }
            newStores[storeName]._setInternalOptions({
                ssr: ssr,
                reactionCreators: $eb0b4d1e13e36536$var$clientStores.stores[storeName]._getReactionCreators()
            });
        }
        return new $eb0b4d1e13e36536$var$PullstateInstance(newStores, true, customContext);
    }
    useStores() {
        return $eb0b4d1e13e36536$export$76335635d037fdf1();
    }
    useInstance() {
        return $eb0b4d1e13e36536$export$f4a5c5dcfe1bba82();
    }
    createAsyncActionDirect(action, options = {}) {
        return $eb0b4d1e13e36536$export$1bf85a667346a1b4(action, options);
    }
    createAsyncAction(action, options = {}) {
        var _a;
        if (((_a = this.options.asyncActions) === null || _a === void 0 ? void 0 : _a.defaultCachingSeconds) && !options.cacheBreakHook) options.cacheBreakHook = (inputs)=>inputs.timeCached < Date.now() - this.options.asyncActions.defaultCachingSeconds * 1000;
        return $eb0b4d1e13e36536$export$3a80f7e4c1c7e6a8(action, options);
    }
}
class $eb0b4d1e13e36536$var$PullstateInstance {
    constructor(allStores, ssr, customContext){
        this._ssr = false;
        this._stores = {};
        this._asyncCache = {
            listeners: {},
            results: {},
            actions: {},
            actionOrd: {}
        };
        this._stores = allStores;
        this._ssr = ssr;
        this._customContext = customContext;
    }
    getAllUnresolvedAsyncActions() {
        return Object.keys(this._asyncCache.actions).map((key)=>this._asyncCache.actions[key]());
    }
    instantiateReactions() {
        for (const storeName of Object.keys(this._stores))this._stores[storeName]._instantiateReactions();
    }
    getPullstateSnapshot() {
        const allState = {};
        for (const storeName of Object.keys(this._stores))allState[storeName] = this._stores[storeName].getRawState();
        return {
            allState: allState,
            asyncResults: this._asyncCache.results,
            asyncActionOrd: this._asyncCache.actionOrd
        };
    }
    async resolveAsyncState() {
        const promises = this.getAllUnresolvedAsyncActions();
        await Promise.all(promises);
    }
    hasAsyncStateToResolve() {
        return Object.keys(this._asyncCache.actions).length > 0;
    }
    get stores() {
        return this._stores;
    }
    get customContext() {
        return this._customContext;
    }
    async runAsyncAction(asyncAction, args = {}, runOptions = {}) {
        if (this._ssr) {
            runOptions._asyncCache = this._asyncCache;
            runOptions._stores = this._stores;
            runOptions._customContext = this._customContext;
        }
        return await asyncAction.run(args, runOptions);
    }
    hydrateFromSnapshot(snapshot) {
        for (const storeName of Object.keys(this._stores))if (snapshot.allState.hasOwnProperty(storeName)) this._stores[storeName]._updateStateWithoutReaction(snapshot.allState[storeName]);
        else console.warn(`${storeName} didn't hydrate any state (data was non-existent on hydration object)`);
        $eb0b4d1e13e36536$var$clientAsyncCache.results = snapshot.asyncResults || {};
        $eb0b4d1e13e36536$var$clientAsyncCache.actionOrd = snapshot.asyncActionOrd || {};
    }
}
function $eb0b4d1e13e36536$export$5a0e12a8c0233d26(allStores = {}, options = {}) {
    return new $eb0b4d1e13e36536$var$PullstateSingleton(allStores, options);
}
function $eb0b4d1e13e36536$export$76335635d037fdf1() {
    return (0, $28UcW.useContext)($eb0b4d1e13e36536$export$2a125cbafd895cd3).stores;
}
function $eb0b4d1e13e36536$export$f4a5c5dcfe1bba82() {
    return (0, $28UcW.useContext)($eb0b4d1e13e36536$export$2a125cbafd895cd3);
}
var $eb0b4d1e13e36536$export$7c9b3096bad056d8;
(function(EAsyncActionInjectType) {
    EAsyncActionInjectType["WATCH"] = "watch";
    EAsyncActionInjectType["BECKON"] = "beckon";
})($eb0b4d1e13e36536$export$7c9b3096bad056d8 || ($eb0b4d1e13e36536$export$7c9b3096bad056d8 = {}));
function $eb0b4d1e13e36536$export$8063ebb5fb777585(props) {
    if (props.type === $eb0b4d1e13e36536$export$7c9b3096bad056d8.BECKON) {
        const response = props.action.useBeckon(props.args, props.options);
        return props.children(response);
    }
    const response = props.action.useWatch(props.args, props.options);
    return props.children(response);
}
function $eb0b4d1e13e36536$export$ebb5de94d410126e(stores, { namespace: namespace = "" } = {}) {
    const devToolsExtension = typeof window !== "undefined" ? window === null || window === void 0 ? void 0 : window.__REDUX_DEVTOOLS_EXTENSION__ : undefined;
    if (devToolsExtension) for (const key of Object.keys(stores)){
        const store = stores[key];
        const devTools = devToolsExtension.connect({
            name: `${namespace}${key}`
        });
        devTools.init(store.getRawState());
        let ignoreNext = false;
        store.subscribe((s)=>s, (watched)=>{
            if (ignoreNext) {
                ignoreNext = false;
                return;
            }
            devTools.send("Change", watched);
        });
        devTools.subscribe((message)=>{
            if (message.type === "DISPATCH" && message.state) {
                ignoreNext = true;
                const parsed = JSON.parse(message.state);
                store.replace(parsed);
            }
        });
    }
}
const $eb0b4d1e13e36536$var$batchState = {};
function $eb0b4d1e13e36536$export$992182db723b596c({ uiBatchFunction: uiBatchFunction }) {
    $eb0b4d1e13e36536$var$batchState.uiBatchFunction = uiBatchFunction;
}
function $eb0b4d1e13e36536$export$712ea50be43a7858(runUpdates) {
    if ($eb0b4d1e13e36536$var$globalClientState.batching) throw new Error("Pullstate: Can't enact two batch() update functions at the same time-\nmake sure you are not running a batch() inside of a batch() by mistake.");
    $eb0b4d1e13e36536$var$globalClientState.batching = true;
    try {
        runUpdates();
    } finally{
        if ($eb0b4d1e13e36536$var$batchState.uiBatchFunction) $eb0b4d1e13e36536$var$batchState.uiBatchFunction(()=>{
            Object.values($eb0b4d1e13e36536$var$globalClientState.flushStores).forEach((store)=>store.flushBatch(true));
        });
        else Object.values($eb0b4d1e13e36536$var$globalClientState.flushStores).forEach((store)=>store.flushBatch(true));
        $eb0b4d1e13e36536$var$globalClientState.flushStores = {};
        $eb0b4d1e13e36536$var$globalClientState.batching = false;
    }
}


const $e2662af8a2ab1f76$export$986181c251d527c3 = new (0, $eb0b4d1e13e36536$export$390f32400eaf98c9)({
    loadingUser: true,
    loadingContent: true,
    loadingUserError: false,
    loadingContentError: false,
    signedIn: false,
    signInDialog: {
        isOpen: false,
        redirectPathAfterLogin: null
    },
    puzzleData: null,
    featureData: null,
    userData: null
});



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");
/**
 * React Router DOM v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $28UcW = parcelRequire("28UcW");

/**
 * @remix-run/router v1.15.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $6299f2354da3ee7b$var$_extends() {
    $6299f2354da3ee7b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6299f2354da3ee7b$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $6299f2354da3ee7b$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($6299f2354da3ee7b$export$e19cd5f9376f8cee || ($6299f2354da3ee7b$export$e19cd5f9376f8cee = {}));
const $6299f2354da3ee7b$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $6299f2354da3ee7b$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $6299f2354da3ee7b$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $6299f2354da3ee7b$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $6299f2354da3ee7b$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $6299f2354da3ee7b$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $6299f2354da3ee7b$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $6299f2354da3ee7b$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $6299f2354da3ee7b$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $6299f2354da3ee7b$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $6299f2354da3ee7b$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $6299f2354da3ee7b$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $6299f2354da3ee7b$export$fe53371bee54353d(to);
    }
    return $6299f2354da3ee7b$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $6299f2354da3ee7b$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $6299f2354da3ee7b$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $6299f2354da3ee7b$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $6299f2354da3ee7b$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $6299f2354da3ee7b$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $6299f2354da3ee7b$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $6299f2354da3ee7b$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $6299f2354da3ee7b$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $6299f2354da3ee7b$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $6299f2354da3ee7b$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $6299f2354da3ee7b$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $6299f2354da3ee7b$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $6299f2354da3ee7b$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $6299f2354da3ee7b$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $6299f2354da3ee7b$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $6299f2354da3ee7b$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $6299f2354da3ee7b$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $6299f2354da3ee7b$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($6299f2354da3ee7b$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $6299f2354da3ee7b$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $6299f2354da3ee7b$export$e19cd5f9376f8cee.Push;
        let location = $6299f2354da3ee7b$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $6299f2354da3ee7b$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $6299f2354da3ee7b$export$e19cd5f9376f8cee.Replace;
        let location = $6299f2354da3ee7b$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $6299f2354da3ee7b$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $6299f2354da3ee7b$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $6299f2354da3ee7b$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($6299f2354da3ee7b$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($6299f2354da3ee7b$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $6299f2354da3ee7b$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($6299f2354da3ee7b$var$ResultType || ($6299f2354da3ee7b$var$ResultType = {}));
const $6299f2354da3ee7b$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $6299f2354da3ee7b$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $6299f2354da3ee7b$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $6299f2354da3ee7b$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $6299f2354da3ee7b$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($6299f2354da3ee7b$var$isIndexRoute(route)) {
            let indexRoute = $6299f2354da3ee7b$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $6299f2354da3ee7b$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $6299f2354da3ee7b$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $6299f2354da3ee7b$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $6299f2354da3ee7b$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $6299f2354da3ee7b$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $6299f2354da3ee7b$var$flattenRoutes(routes);
    $6299f2354da3ee7b$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $6299f2354da3ee7b$var$decodePath(pathname);
        matches = $6299f2354da3ee7b$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $6299f2354da3ee7b$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $6299f2354da3ee7b$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $6299f2354da3ee7b$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $6299f2354da3ee7b$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $6299f2354da3ee7b$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $6299f2354da3ee7b$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $6299f2354da3ee7b$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $6299f2354da3ee7b$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $6299f2354da3ee7b$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $6299f2354da3ee7b$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $6299f2354da3ee7b$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $6299f2354da3ee7b$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $6299f2354da3ee7b$var$paramRe = /^:[\w-]+$/;
const $6299f2354da3ee7b$var$dynamicSegmentValue = 3;
const $6299f2354da3ee7b$var$indexRouteValue = 2;
const $6299f2354da3ee7b$var$emptySegmentValue = 1;
const $6299f2354da3ee7b$var$staticSegmentValue = 10;
const $6299f2354da3ee7b$var$splatPenalty = -2;
const $6299f2354da3ee7b$var$isSplat = (s)=>s === "*";
function $6299f2354da3ee7b$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($6299f2354da3ee7b$var$isSplat)) initialScore += $6299f2354da3ee7b$var$splatPenalty;
    if (index) initialScore += $6299f2354da3ee7b$var$indexRouteValue;
    return segments.filter((s)=>!$6299f2354da3ee7b$var$isSplat(s)).reduce((score, segment)=>score + ($6299f2354da3ee7b$var$paramRe.test(segment) ? $6299f2354da3ee7b$var$dynamicSegmentValue : segment === "" ? $6299f2354da3ee7b$var$emptySegmentValue : $6299f2354da3ee7b$var$staticSegmentValue), initialScore);
}
function $6299f2354da3ee7b$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $6299f2354da3ee7b$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $6299f2354da3ee7b$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $6299f2354da3ee7b$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $6299f2354da3ee7b$export$a5c6d149b50c1d86($6299f2354da3ee7b$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $6299f2354da3ee7b$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $6299f2354da3ee7b$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $6299f2354da3ee7b$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $6299f2354da3ee7b$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $6299f2354da3ee7b$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $6299f2354da3ee7b$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $6299f2354da3ee7b$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $6299f2354da3ee7b$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $6299f2354da3ee7b$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $6299f2354da3ee7b$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $6299f2354da3ee7b$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $6299f2354da3ee7b$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $6299f2354da3ee7b$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $6299f2354da3ee7b$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $6299f2354da3ee7b$var$normalizeSearch(search),
        hash: $6299f2354da3ee7b$var$normalizeHash(hash)
    };
}
function $6299f2354da3ee7b$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $6299f2354da3ee7b$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $6299f2354da3ee7b$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $6299f2354da3ee7b$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $6299f2354da3ee7b$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $6299f2354da3ee7b$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $6299f2354da3ee7b$export$8ccf933b0513f8d0(toArg);
    else {
        to = $6299f2354da3ee7b$var$_extends({}, toArg);
        $6299f2354da3ee7b$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $6299f2354da3ee7b$var$getInvalidPathError("?", "pathname", "search", to));
        $6299f2354da3ee7b$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $6299f2354da3ee7b$var$getInvalidPathError("#", "pathname", "hash", to));
        $6299f2354da3ee7b$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $6299f2354da3ee7b$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $6299f2354da3ee7b$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $6299f2354da3ee7b$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $6299f2354da3ee7b$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $6299f2354da3ee7b$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $6299f2354da3ee7b$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $6299f2354da3ee7b$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $6299f2354da3ee7b$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $6299f2354da3ee7b$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $6299f2354da3ee7b$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $6299f2354da3ee7b$export$42a99a7a4bc0e76a extends Error {
}
class $6299f2354da3ee7b$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $6299f2354da3ee7b$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $6299f2354da3ee7b$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $6299f2354da3ee7b$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $6299f2354da3ee7b$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $6299f2354da3ee7b$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $6299f2354da3ee7b$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $6299f2354da3ee7b$var$unwrapTrackedPromise(value) {
    if (!$6299f2354da3ee7b$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $6299f2354da3ee7b$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $6299f2354da3ee7b$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $6299f2354da3ee7b$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $6299f2354da3ee7b$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $6299f2354da3ee7b$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $6299f2354da3ee7b$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $6299f2354da3ee7b$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $6299f2354da3ee7b$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $6299f2354da3ee7b$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $6299f2354da3ee7b$var$validMutationMethods = new Set($6299f2354da3ee7b$var$validMutationMethodsArr);
const $6299f2354da3ee7b$var$validRequestMethodsArr = [
    "get",
    ...$6299f2354da3ee7b$var$validMutationMethodsArr
];
const $6299f2354da3ee7b$var$validRequestMethods = new Set($6299f2354da3ee7b$var$validRequestMethodsArr);
const $6299f2354da3ee7b$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $6299f2354da3ee7b$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $6299f2354da3ee7b$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $6299f2354da3ee7b$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $6299f2354da3ee7b$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $6299f2354da3ee7b$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $6299f2354da3ee7b$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $6299f2354da3ee7b$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $6299f2354da3ee7b$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $6299f2354da3ee7b$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $6299f2354da3ee7b$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $6299f2354da3ee7b$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $6299f2354da3ee7b$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $6299f2354da3ee7b$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $6299f2354da3ee7b$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $6299f2354da3ee7b$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $6299f2354da3ee7b$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $6299f2354da3ee7b$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $6299f2354da3ee7b$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $6299f2354da3ee7b$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $6299f2354da3ee7b$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$6299f2354da3ee7b$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($6299f2354da3ee7b$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $6299f2354da3ee7b$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $6299f2354da3ee7b$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $6299f2354da3ee7b$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $6299f2354da3ee7b$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $6299f2354da3ee7b$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $6299f2354da3ee7b$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $6299f2354da3ee7b$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $6299f2354da3ee7b$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $6299f2354da3ee7b$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($6299f2354da3ee7b$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $6299f2354da3ee7b$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $6299f2354da3ee7b$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $6299f2354da3ee7b$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $6299f2354da3ee7b$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $6299f2354da3ee7b$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $6299f2354da3ee7b$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $6299f2354da3ee7b$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $6299f2354da3ee7b$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $6299f2354da3ee7b$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $6299f2354da3ee7b$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $6299f2354da3ee7b$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $6299f2354da3ee7b$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $6299f2354da3ee7b$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $6299f2354da3ee7b$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $6299f2354da3ee7b$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $6299f2354da3ee7b$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $6299f2354da3ee7b$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$6299f2354da3ee7b$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $6299f2354da3ee7b$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $6299f2354da3ee7b$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $6299f2354da3ee7b$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $6299f2354da3ee7b$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $6299f2354da3ee7b$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $6299f2354da3ee7b$var$ResultType.error,
            error: $6299f2354da3ee7b$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $6299f2354da3ee7b$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($6299f2354da3ee7b$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($6299f2354da3ee7b$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $6299f2354da3ee7b$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $6299f2354da3ee7b$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($6299f2354da3ee7b$var$isDeferredResult(result)) throw $6299f2354da3ee7b$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $6299f2354da3ee7b$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $6299f2354da3ee7b$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $6299f2354da3ee7b$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $6299f2354da3ee7b$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $6299f2354da3ee7b$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($6299f2354da3ee7b$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $6299f2354da3ee7b$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $6299f2354da3ee7b$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $6299f2354da3ee7b$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $6299f2354da3ee7b$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $6299f2354da3ee7b$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $6299f2354da3ee7b$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $6299f2354da3ee7b$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $6299f2354da3ee7b$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $6299f2354da3ee7b$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $6299f2354da3ee7b$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $6299f2354da3ee7b$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $6299f2354da3ee7b$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $6299f2354da3ee7b$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($6299f2354da3ee7b$var$isRedirectResult(actionResult) || $6299f2354da3ee7b$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $6299f2354da3ee7b$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($6299f2354da3ee7b$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $6299f2354da3ee7b$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $6299f2354da3ee7b$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($6299f2354da3ee7b$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($6299f2354da3ee7b$var$isDeferredResult(actionResult)) throw $6299f2354da3ee7b$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $6299f2354da3ee7b$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $6299f2354da3ee7b$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $6299f2354da3ee7b$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $6299f2354da3ee7b$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $6299f2354da3ee7b$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $6299f2354da3ee7b$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $6299f2354da3ee7b$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $6299f2354da3ee7b$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $6299f2354da3ee7b$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $6299f2354da3ee7b$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $6299f2354da3ee7b$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $6299f2354da3ee7b$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $6299f2354da3ee7b$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $6299f2354da3ee7b$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($6299f2354da3ee7b$var$isDeferredResult(result)) result = await $6299f2354da3ee7b$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $6299f2354da3ee7b$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($6299f2354da3ee7b$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $6299f2354da3ee7b$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($6299f2354da3ee7b$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $6299f2354da3ee7b$export$3e9cee6b33872309(!$6299f2354da3ee7b$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $6299f2354da3ee7b$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $6299f2354da3ee7b$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $6299f2354da3ee7b$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($6299f2354da3ee7b$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $6299f2354da3ee7b$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $6299f2354da3ee7b$export$e19cd5f9376f8cee.Replace : $6299f2354da3ee7b$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $6299f2354da3ee7b$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($6299f2354da3ee7b$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $6299f2354da3ee7b$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $6299f2354da3ee7b$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $6299f2354da3ee7b$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$6299f2354da3ee7b$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $6299f2354da3ee7b$var$callLoaderOrAction("loader", $6299f2354da3ee7b$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $6299f2354da3ee7b$var$ResultType.error,
                        error: $6299f2354da3ee7b$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $6299f2354da3ee7b$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $6299f2354da3ee7b$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $6299f2354da3ee7b$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $6299f2354da3ee7b$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $6299f2354da3ee7b$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $6299f2354da3ee7b$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $6299f2354da3ee7b$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $6299f2354da3ee7b$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $6299f2354da3ee7b$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $6299f2354da3ee7b$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $6299f2354da3ee7b$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $6299f2354da3ee7b$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $6299f2354da3ee7b$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$6299f2354da3ee7b$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $6299f2354da3ee7b$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $6299f2354da3ee7b$export$4d0306f8f6a4585b = Symbol("deferred");
function $6299f2354da3ee7b$export$3336b097a6fbc59a(routes, opts) {
    $6299f2354da3ee7b$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $6299f2354da3ee7b$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $6299f2354da3ee7b$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $6299f2354da3ee7b$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $6299f2354da3ee7b$var$createLocation("", $6299f2354da3ee7b$export$fe53371bee54353d(url), null, "default");
        let matches = $6299f2354da3ee7b$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$6299f2354da3ee7b$var$isValidMethod(method) && method !== "HEAD") {
            let error = $6299f2354da3ee7b$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $6299f2354da3ee7b$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $6299f2354da3ee7b$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $6299f2354da3ee7b$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($6299f2354da3ee7b$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $6299f2354da3ee7b$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $6299f2354da3ee7b$var$createLocation("", $6299f2354da3ee7b$export$fe53371bee54353d(url), null, "default");
        let matches = $6299f2354da3ee7b$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$6299f2354da3ee7b$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $6299f2354da3ee7b$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $6299f2354da3ee7b$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $6299f2354da3ee7b$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $6299f2354da3ee7b$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $6299f2354da3ee7b$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($6299f2354da3ee7b$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$6299f2354da3ee7b$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $6299f2354da3ee7b$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($6299f2354da3ee7b$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $6299f2354da3ee7b$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $6299f2354da3ee7b$var$isResponse(result) ? result : $6299f2354da3ee7b$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($6299f2354da3ee7b$var$isQueryRouteResponse(e)) {
                if (e.type === $6299f2354da3ee7b$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($6299f2354da3ee7b$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $6299f2354da3ee7b$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $6299f2354da3ee7b$var$ResultType.error,
                error: error
            };
        } else {
            result = await $6299f2354da3ee7b$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $6299f2354da3ee7b$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($6299f2354da3ee7b$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($6299f2354da3ee7b$var$isDeferredResult(result)) {
            let error = $6299f2354da3ee7b$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $6299f2354da3ee7b$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($6299f2354da3ee7b$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($6299f2354da3ee7b$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $6299f2354da3ee7b$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $6299f2354da3ee7b$var$_extends({}, context, {
                statusCode: $6299f2354da3ee7b$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $6299f2354da3ee7b$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $6299f2354da3ee7b$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $6299f2354da3ee7b$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $6299f2354da3ee7b$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $6299f2354da3ee7b$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$6299f2354da3ee7b$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $6299f2354da3ee7b$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $6299f2354da3ee7b$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $6299f2354da3ee7b$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $6299f2354da3ee7b$export$fec11da027c70692(routes, context, error) {
    let newContext = $6299f2354da3ee7b$var$_extends({}, context, {
        statusCode: $6299f2354da3ee7b$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $6299f2354da3ee7b$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $6299f2354da3ee7b$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $6299f2354da3ee7b$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $6299f2354da3ee7b$export$cae722b0cc860f13(to ? to : ".", $6299f2354da3ee7b$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $6299f2354da3ee7b$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$6299f2354da3ee7b$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $6299f2354da3ee7b$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $6299f2354da3ee7b$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $6299f2354da3ee7b$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$6299f2354da3ee7b$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$6299f2354da3ee7b$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $6299f2354da3ee7b$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $6299f2354da3ee7b$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $6299f2354da3ee7b$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$6299f2354da3ee7b$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$6299f2354da3ee7b$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $6299f2354da3ee7b$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $6299f2354da3ee7b$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $6299f2354da3ee7b$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $6299f2354da3ee7b$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $6299f2354da3ee7b$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($6299f2354da3ee7b$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $6299f2354da3ee7b$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $6299f2354da3ee7b$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $6299f2354da3ee7b$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $6299f2354da3ee7b$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $6299f2354da3ee7b$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $6299f2354da3ee7b$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($6299f2354da3ee7b$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $6299f2354da3ee7b$var$shouldRevalidateLoader(match, $6299f2354da3ee7b$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $6299f2354da3ee7b$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $6299f2354da3ee7b$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $6299f2354da3ee7b$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $6299f2354da3ee7b$var$shouldRevalidateLoader(fetcherMatch, $6299f2354da3ee7b$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $6299f2354da3ee7b$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $6299f2354da3ee7b$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $6299f2354da3ee7b$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $6299f2354da3ee7b$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $6299f2354da3ee7b$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $6299f2354da3ee7b$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$6299f2354da3ee7b$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $6299f2354da3ee7b$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $6299f2354da3ee7b$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $6299f2354da3ee7b$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $6299f2354da3ee7b$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $6299f2354da3ee7b$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $6299f2354da3ee7b$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $6299f2354da3ee7b$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $6299f2354da3ee7b$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $6299f2354da3ee7b$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($6299f2354da3ee7b$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($6299f2354da3ee7b$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $6299f2354da3ee7b$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$6299f2354da3ee7b$var$ABSOLUTE_URL_REGEX.test(location)) location = $6299f2354da3ee7b$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $6299f2354da3ee7b$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $6299f2354da3ee7b$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $6299f2354da3ee7b$var$ResultType.error ? $6299f2354da3ee7b$var$ResultType.error : $6299f2354da3ee7b$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $6299f2354da3ee7b$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $6299f2354da3ee7b$var$ResultType.error) return {
            type: resultType,
            error: new $6299f2354da3ee7b$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $6299f2354da3ee7b$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $6299f2354da3ee7b$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($6299f2354da3ee7b$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $6299f2354da3ee7b$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $6299f2354da3ee7b$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $6299f2354da3ee7b$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($6299f2354da3ee7b$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $6299f2354da3ee7b$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $6299f2354da3ee7b$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $6299f2354da3ee7b$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $6299f2354da3ee7b$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $6299f2354da3ee7b$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $6299f2354da3ee7b$export$3e9cee6b33872309(!$6299f2354da3ee7b$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($6299f2354da3ee7b$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $6299f2354da3ee7b$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $6299f2354da3ee7b$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($6299f2354da3ee7b$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $6299f2354da3ee7b$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $6299f2354da3ee7b$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $6299f2354da3ee7b$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($6299f2354da3ee7b$var$isErrorResult(result)) {
            let boundaryMatch = $6299f2354da3ee7b$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $6299f2354da3ee7b$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($6299f2354da3ee7b$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $6299f2354da3ee7b$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($6299f2354da3ee7b$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $6299f2354da3ee7b$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $6299f2354da3ee7b$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $6299f2354da3ee7b$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $6299f2354da3ee7b$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $6299f2354da3ee7b$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $6299f2354da3ee7b$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $6299f2354da3ee7b$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $6299f2354da3ee7b$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $6299f2354da3ee7b$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($6299f2354da3ee7b$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $6299f2354da3ee7b$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $6299f2354da3ee7b$export$8ccf933b0513f8d0(path) : path;
    return $6299f2354da3ee7b$export$fe53371bee54353d($6299f2354da3ee7b$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $6299f2354da3ee7b$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $6299f2354da3ee7b$var$isDeferredResult(result) {
    return result.type === $6299f2354da3ee7b$var$ResultType.deferred;
}
function $6299f2354da3ee7b$var$isErrorResult(result) {
    return result.type === $6299f2354da3ee7b$var$ResultType.error;
}
function $6299f2354da3ee7b$var$isRedirectResult(result) {
    return (result && result.type) === $6299f2354da3ee7b$var$ResultType.redirect;
}
function $6299f2354da3ee7b$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $6299f2354da3ee7b$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $6299f2354da3ee7b$var$isRedirectResponse(result) {
    if (!$6299f2354da3ee7b$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $6299f2354da3ee7b$var$isQueryRouteResponse(obj) {
    return obj && $6299f2354da3ee7b$var$isResponse(obj.response) && (obj.type === $6299f2354da3ee7b$var$ResultType.data || obj.type === $6299f2354da3ee7b$var$ResultType.error);
}
function $6299f2354da3ee7b$var$isValidMethod(method) {
    return $6299f2354da3ee7b$var$validRequestMethods.has(method.toLowerCase());
}
function $6299f2354da3ee7b$var$isMutationMethod(method) {
    return $6299f2354da3ee7b$var$validMutationMethods.has(method.toLowerCase());
}
async function $6299f2354da3ee7b$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$6299f2354da3ee7b$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($6299f2354da3ee7b$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $6299f2354da3ee7b$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $6299f2354da3ee7b$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $6299f2354da3ee7b$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $6299f2354da3ee7b$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $6299f2354da3ee7b$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $6299f2354da3ee7b$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $6299f2354da3ee7b$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $6299f2354da3ee7b$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $6299f2354da3ee7b$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $6299f2354da3ee7b$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $6299f2354da3ee7b$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $6299f2354da3ee7b$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $6299f2354da3ee7b$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $6299f2354da3ee7b$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $6299f2354da3ee7b$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $6299f2354da3ee7b$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $6299f2354da3ee7b$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $6299f2354da3ee7b$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($6299f2354da3ee7b$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $6299f2354da3ee7b$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($6299f2354da3ee7b$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $6299f2354da3ee7b$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $28UcW = parcelRequire("28UcW");

function $6e00b7bb3feca34a$var$_extends() {
    $6e00b7bb3feca34a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6e00b7bb3feca34a$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $6e00b7bb3feca34a$export$3add0d5dce533e2e = /*#__PURE__*/ $28UcW.createContext(null);
const $6e00b7bb3feca34a$export$145dfa71566a64dc = /*#__PURE__*/ $28UcW.createContext(null);
const $6e00b7bb3feca34a$var$AwaitContext = /*#__PURE__*/ $28UcW.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $6e00b7bb3feca34a$export$26749e8557646306 = /*#__PURE__*/ $28UcW.createContext(null);
const $6e00b7bb3feca34a$export$c7914228fb69b0f5 = /*#__PURE__*/ $28UcW.createContext(null);
const $6e00b7bb3feca34a$export$9072aa6dd1f93057 = /*#__PURE__*/ $28UcW.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $6e00b7bb3feca34a$var$RouteErrorContext = /*#__PURE__*/ $28UcW.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $6e00b7bb3feca34a$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$6e00b7bb3feca34a$export$9c954a9d03d32f4a() && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $28UcW.useContext($6e00b7bb3feca34a$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $6e00b7bb3feca34a$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $6299f2354da3ee7b$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $6e00b7bb3feca34a$export$9c954a9d03d32f4a() {
    return $28UcW.useContext($6e00b7bb3feca34a$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $6e00b7bb3feca34a$export$45d76561a5302f2b() {
    !$6e00b7bb3feca34a$export$9c954a9d03d32f4a() && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
    return $28UcW.useContext($6e00b7bb3feca34a$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $6e00b7bb3feca34a$export$1b3f31771c5d07c() {
    return $28UcW.useContext($6e00b7bb3feca34a$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $6e00b7bb3feca34a$export$6c330e8992e8a295(pattern) {
    !$6e00b7bb3feca34a$export$9c954a9d03d32f4a() && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $6e00b7bb3feca34a$export$45d76561a5302f2b();
    return $28UcW.useMemo(()=>(0, $6299f2354da3ee7b$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $6e00b7bb3feca34a$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $6e00b7bb3feca34a$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $28UcW.useContext($6e00b7bb3feca34a$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $28UcW.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $6e00b7bb3feca34a$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $28UcW.useContext($6e00b7bb3feca34a$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $6e00b7bb3feca34a$var$useNavigateStable() : $6e00b7bb3feca34a$var$useNavigateUnstable();
}
function $6e00b7bb3feca34a$var$useNavigateUnstable() {
    !$6e00b7bb3feca34a$export$9c954a9d03d32f4a() && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
    let dataRouterContext = $28UcW.useContext($6e00b7bb3feca34a$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $28UcW.useContext($6e00b7bb3feca34a$export$26749e8557646306);
    let { matches: matches } = $28UcW.useContext($6e00b7bb3feca34a$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6e00b7bb3feca34a$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $6299f2354da3ee7b$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $28UcW.useRef(false);
    $6e00b7bb3feca34a$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $28UcW.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $6299f2354da3ee7b$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $6299f2354da3ee7b$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $6e00b7bb3feca34a$var$OutletContext = /*#__PURE__*/ $28UcW.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $6e00b7bb3feca34a$export$4138103a3ae699cc() {
    return $28UcW.useContext($6e00b7bb3feca34a$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $6e00b7bb3feca34a$export$a3be3530d8e40d0b(context) {
    let outlet = $28UcW.useContext($6e00b7bb3feca34a$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $28UcW.createElement($6e00b7bb3feca34a$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $6e00b7bb3feca34a$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $28UcW.useContext($6e00b7bb3feca34a$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $6e00b7bb3feca34a$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $28UcW.useContext($6e00b7bb3feca34a$export$26749e8557646306);
    let { matches: matches } = $28UcW.useContext($6e00b7bb3feca34a$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6e00b7bb3feca34a$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $6299f2354da3ee7b$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $28UcW.useMemo(()=>(0, $6299f2354da3ee7b$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $6e00b7bb3feca34a$export$5d3fca4a98652595(routes, locationArg) {
    return $6e00b7bb3feca34a$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $6e00b7bb3feca34a$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$6e00b7bb3feca34a$export$9c954a9d03d32f4a() && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $28UcW.useContext($6e00b7bb3feca34a$export$26749e8557646306);
    let { matches: parentMatches } = $28UcW.useContext($6e00b7bb3feca34a$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $6e00b7bb3feca34a$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $6299f2354da3ee7b$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $6299f2354da3ee7b$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $6e00b7bb3feca34a$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $6299f2354da3ee7b$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $6299f2354da3ee7b$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $28UcW.createElement($6e00b7bb3feca34a$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $6e00b7bb3feca34a$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $6299f2354da3ee7b$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $6e00b7bb3feca34a$var$DefaultErrorComponent() {
    let error = $6e00b7bb3feca34a$export$ed527bf60f6e05f2();
    let message = (0, $6299f2354da3ee7b$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $28UcW.createElement($28UcW.Fragment, null, /*#__PURE__*/ $28UcW.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $28UcW.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $28UcW.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $6e00b7bb3feca34a$var$defaultErrorElement = /*#__PURE__*/ $28UcW.createElement($6e00b7bb3feca34a$var$DefaultErrorComponent, null);
class $6e00b7bb3feca34a$var$RenderErrorBoundary extends $28UcW.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $28UcW.createElement($6e00b7bb3feca34a$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $28UcW.createElement($6e00b7bb3feca34a$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $6e00b7bb3feca34a$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $28UcW.useContext($6e00b7bb3feca34a$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $28UcW.createElement($6e00b7bb3feca34a$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $6e00b7bb3feca34a$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $6e00b7bb3feca34a$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $6e00b7bb3feca34a$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $28UcW.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $28UcW.createElement($6e00b7bb3feca34a$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $28UcW.createElement($6e00b7bb3feca34a$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $6e00b7bb3feca34a$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($6e00b7bb3feca34a$var$DataRouterHook || {});
var $6e00b7bb3feca34a$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($6e00b7bb3feca34a$var$DataRouterStateHook || {});
function $6e00b7bb3feca34a$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $6e00b7bb3feca34a$var$useDataRouterContext(hookName) {
    let ctx = $28UcW.useContext($6e00b7bb3feca34a$export$3add0d5dce533e2e);
    !ctx && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
    return ctx;
}
function $6e00b7bb3feca34a$var$useDataRouterState(hookName) {
    let state = $28UcW.useContext($6e00b7bb3feca34a$export$145dfa71566a64dc);
    !state && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
    return state;
}
function $6e00b7bb3feca34a$var$useRouteContext(hookName) {
    let route = $28UcW.useContext($6e00b7bb3feca34a$export$9072aa6dd1f93057);
    !route && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $6e00b7bb3feca34a$var$useCurrentRouteId(hookName) {
    let route = $6e00b7bb3feca34a$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $6e00b7bb3feca34a$export$5fc8298006ad9e58() {
    return $6e00b7bb3feca34a$var$useCurrentRouteId($6e00b7bb3feca34a$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $6e00b7bb3feca34a$export$d0fd4b7106de2769() {
    let state = $6e00b7bb3feca34a$var$useDataRouterState($6e00b7bb3feca34a$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $6e00b7bb3feca34a$export$600dc272ed516c15() {
    let dataRouterContext = $6e00b7bb3feca34a$var$useDataRouterContext($6e00b7bb3feca34a$var$DataRouterHook.UseRevalidator);
    let state = $6e00b7bb3feca34a$var$useDataRouterState($6e00b7bb3feca34a$var$DataRouterStateHook.UseRevalidator);
    return $28UcW.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $6e00b7bb3feca34a$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $6e00b7bb3feca34a$var$useDataRouterState($6e00b7bb3feca34a$var$DataRouterStateHook.UseMatches);
    return $28UcW.useMemo(()=>matches.map((m)=>(0, $6299f2354da3ee7b$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $6e00b7bb3feca34a$export$1448a5050d252c4d() {
    let state = $6e00b7bb3feca34a$var$useDataRouterState($6e00b7bb3feca34a$var$DataRouterStateHook.UseLoaderData);
    let routeId = $6e00b7bb3feca34a$var$useCurrentRouteId($6e00b7bb3feca34a$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $6e00b7bb3feca34a$export$fd5d37484eab868d(routeId) {
    let state = $6e00b7bb3feca34a$var$useDataRouterState($6e00b7bb3feca34a$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $6e00b7bb3feca34a$export$fdc00f3f26066d5e() {
    let state = $6e00b7bb3feca34a$var$useDataRouterState($6e00b7bb3feca34a$var$DataRouterStateHook.UseActionData);
    let routeId = $6e00b7bb3feca34a$var$useCurrentRouteId($6e00b7bb3feca34a$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $6e00b7bb3feca34a$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $28UcW.useContext($6e00b7bb3feca34a$var$RouteErrorContext);
    let state = $6e00b7bb3feca34a$var$useDataRouterState($6e00b7bb3feca34a$var$DataRouterStateHook.UseRouteError);
    let routeId = $6e00b7bb3feca34a$var$useCurrentRouteId($6e00b7bb3feca34a$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $6e00b7bb3feca34a$export$78a72ddb39bdd145() {
    let value = $28UcW.useContext($6e00b7bb3feca34a$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $6e00b7bb3feca34a$export$17f53340677d5831() {
    let value = $28UcW.useContext($6e00b7bb3feca34a$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $6e00b7bb3feca34a$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $6e00b7bb3feca34a$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $6e00b7bb3feca34a$var$useDataRouterContext($6e00b7bb3feca34a$var$DataRouterHook.UseBlocker);
    let state = $6e00b7bb3feca34a$var$useDataRouterState($6e00b7bb3feca34a$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $28UcW.useState("");
    let blockerFunction = $28UcW.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $6e00b7bb3feca34a$var$_extends({}, currentLocation, {
                pathname: (0, $6299f2354da3ee7b$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $6e00b7bb3feca34a$var$_extends({}, nextLocation, {
                pathname: (0, $6299f2354da3ee7b$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $28UcW.useEffect(()=>{
        let key = String(++$6e00b7bb3feca34a$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $28UcW.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $6299f2354da3ee7b$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $6e00b7bb3feca34a$var$useNavigateStable() {
    let { router: router } = $6e00b7bb3feca34a$var$useDataRouterContext($6e00b7bb3feca34a$var$DataRouterHook.UseNavigateStable);
    let id = $6e00b7bb3feca34a$var$useCurrentRouteId($6e00b7bb3feca34a$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $28UcW.useRef(false);
    $6e00b7bb3feca34a$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $28UcW.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $6e00b7bb3feca34a$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $6e00b7bb3feca34a$var$alreadyWarned = {};
function $6e00b7bb3feca34a$var$warningOnce(key, cond, message) {
    if (!cond && !$6e00b7bb3feca34a$var$alreadyWarned[key]) $6e00b7bb3feca34a$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $6e00b7bb3feca34a$var$START_TRANSITION = "startTransition";
const $6e00b7bb3feca34a$var$startTransitionImpl = $28UcW[$6e00b7bb3feca34a$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $6e00b7bb3feca34a$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $28UcW.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $28UcW.useCallback((newState)=>{
        if (v7_startTransition && $6e00b7bb3feca34a$var$startTransitionImpl) $6e00b7bb3feca34a$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $28UcW.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $28UcW.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $28UcW.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $28UcW.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $28UcW.createElement($28UcW.Fragment, null, /*#__PURE__*/ $28UcW.createElement($6e00b7bb3feca34a$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $28UcW.createElement($6e00b7bb3feca34a$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $28UcW.createElement($6e00b7bb3feca34a$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $28UcW.createElement($6e00b7bb3feca34a$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $6e00b7bb3feca34a$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $6e00b7bb3feca34a$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $6e00b7bb3feca34a$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $28UcW.useRef();
    if (historyRef.current == null) historyRef.current = (0, $6299f2354da3ee7b$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $28UcW.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $28UcW.useCallback((newState)=>{
        v7_startTransition && $6e00b7bb3feca34a$var$startTransitionImpl ? $6e00b7bb3feca34a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $28UcW.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $28UcW.createElement($6e00b7bb3feca34a$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $6e00b7bb3feca34a$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$6e00b7bb3feca34a$export$9c954a9d03d32f4a() && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $28UcW.useContext($6e00b7bb3feca34a$export$26749e8557646306);
    let { matches: matches } = $28UcW.useContext($6e00b7bb3feca34a$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6e00b7bb3feca34a$export$45d76561a5302f2b();
    let navigate = $6e00b7bb3feca34a$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $6299f2354da3ee7b$export$cae722b0cc860f13)(to, (0, $6299f2354da3ee7b$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $28UcW.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $6e00b7bb3feca34a$export$910ae8079b2c2852(props) {
    return $6e00b7bb3feca34a$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $6e00b7bb3feca34a$export$e7b0ac011bb776c6(_props) {
    (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $6e00b7bb3feca34a$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $6299f2354da3ee7b$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$6e00b7bb3feca34a$export$9c954a9d03d32f4a() && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $28UcW.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $6e00b7bb3feca34a$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $6299f2354da3ee7b$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $28UcW.useMemo(()=>{
        let trailingPathname = (0, $6299f2354da3ee7b$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $28UcW.createElement($6e00b7bb3feca34a$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $28UcW.createElement($6e00b7bb3feca34a$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $6e00b7bb3feca34a$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $6e00b7bb3feca34a$export$5d3fca4a98652595($6e00b7bb3feca34a$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $6e00b7bb3feca34a$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $28UcW.createElement($6e00b7bb3feca34a$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $28UcW.createElement($6e00b7bb3feca34a$var$ResolveAwait, null, children));
}
var $6e00b7bb3feca34a$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($6e00b7bb3feca34a$var$AwaitRenderStatus || {});
const $6e00b7bb3feca34a$var$neverSettledPromise = new Promise(()=>{});
class $6e00b7bb3feca34a$var$AwaitErrorBoundary extends $28UcW.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $6e00b7bb3feca34a$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $6e00b7bb3feca34a$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $6e00b7bb3feca34a$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $6e00b7bb3feca34a$var$AwaitRenderStatus.error : promise._data !== undefined ? $6e00b7bb3feca34a$var$AwaitRenderStatus.success : $6e00b7bb3feca34a$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $6e00b7bb3feca34a$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $6e00b7bb3feca34a$var$AwaitRenderStatus.error && promise._error instanceof (0, $6299f2354da3ee7b$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $6e00b7bb3feca34a$var$neverSettledPromise;
        if (status === $6e00b7bb3feca34a$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $6e00b7bb3feca34a$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $28UcW.createElement($6e00b7bb3feca34a$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $6e00b7bb3feca34a$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $28UcW.createElement($6e00b7bb3feca34a$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $6e00b7bb3feca34a$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $6e00b7bb3feca34a$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $28UcW.createElement($28UcW.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $6e00b7bb3feca34a$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $28UcW.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $28UcW.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $28UcW.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $6e00b7bb3feca34a$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $6e00b7bb3feca34a$export$e7b0ac011bb776c6) && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $6e00b7bb3feca34a$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $6e00b7bb3feca34a$export$daf73786167a7f72(matches) {
    return $6e00b7bb3feca34a$var$_renderMatches(matches);
}
function $6e00b7bb3feca34a$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $28UcW.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $28UcW.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $28UcW.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $6e00b7bb3feca34a$export$f30f7e456d254e83(routes, opts) {
    return (0, $6299f2354da3ee7b$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $6e00b7bb3feca34a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $6299f2354da3ee7b$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $6e00b7bb3feca34a$export$52b333d321859367
    }).initialize();
}



function $ca600093aacddd58$var$_extends() {
    $ca600093aacddd58$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ca600093aacddd58$var$_extends.apply(this, arguments);
}
function $ca600093aacddd58$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $ca600093aacddd58$var$defaultMethod = "get";
const $ca600093aacddd58$var$defaultEncType = "application/x-www-form-urlencoded";
function $ca600093aacddd58$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $ca600093aacddd58$var$isButtonElement(object) {
    return $ca600093aacddd58$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $ca600093aacddd58$var$isFormElement(object) {
    return $ca600093aacddd58$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $ca600093aacddd58$var$isInputElement(object) {
    return $ca600093aacddd58$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $ca600093aacddd58$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $ca600093aacddd58$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$ca600093aacddd58$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $ca600093aacddd58$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $ca600093aacddd58$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $ca600093aacddd58$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $ca600093aacddd58$var$_formDataSupportsSubmitter = null;
function $ca600093aacddd58$var$isFormDataSubmitterSupported() {
    if ($ca600093aacddd58$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $ca600093aacddd58$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $ca600093aacddd58$var$_formDataSupportsSubmitter = true;
    }
    return $ca600093aacddd58$var$_formDataSupportsSubmitter;
}
const $ca600093aacddd58$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $ca600093aacddd58$var$getFormEncType(encType) {
    if (encType != null && !$ca600093aacddd58$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $ca600093aacddd58$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($ca600093aacddd58$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $6299f2354da3ee7b$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $ca600093aacddd58$var$defaultMethod;
        encType = $ca600093aacddd58$var$getFormEncType(target.getAttribute("enctype")) || $ca600093aacddd58$var$defaultEncType;
        formData = new FormData(target);
    } else if ($ca600093aacddd58$var$isButtonElement(target) || $ca600093aacddd58$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $6299f2354da3ee7b$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $ca600093aacddd58$var$defaultMethod;
        encType = $ca600093aacddd58$var$getFormEncType(target.getAttribute("formenctype")) || $ca600093aacddd58$var$getFormEncType(form.getAttribute("enctype")) || $ca600093aacddd58$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$ca600093aacddd58$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($ca600093aacddd58$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $ca600093aacddd58$var$defaultMethod;
        action = null;
        encType = $ca600093aacddd58$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $ca600093aacddd58$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $ca600093aacddd58$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $ca600093aacddd58$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $ca600093aacddd58$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $ca600093aacddd58$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $ca600093aacddd58$export$1f3f55432a00e06d(routes, opts) {
    return (0, $6299f2354da3ee7b$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $ca600093aacddd58$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $6299f2354da3ee7b$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $ca600093aacddd58$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $6e00b7bb3feca34a$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $ca600093aacddd58$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $6299f2354da3ee7b$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $ca600093aacddd58$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $6299f2354da3ee7b$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $ca600093aacddd58$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $6e00b7bb3feca34a$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $ca600093aacddd58$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $ca600093aacddd58$var$_extends({}, state, {
        errors: $ca600093aacddd58$var$deserializeErrors(state.errors)
    });
    return state;
}
function $ca600093aacddd58$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $6299f2354da3ee7b$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $ca600093aacddd58$export$7ad602f0e94e62d1 = /*#__PURE__*/ $28UcW.createContext({
    isTransitioning: false
});
const $ca600093aacddd58$export$148fd98d095596d4 = /*#__PURE__*/ $28UcW.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $ca600093aacddd58$var$START_TRANSITION = "startTransition";
const $ca600093aacddd58$var$startTransitionImpl = $28UcW[$ca600093aacddd58$var$START_TRANSITION];
const $ca600093aacddd58$var$FLUSH_SYNC = "flushSync";
const $ca600093aacddd58$var$flushSyncImpl = $ac717a3ef8959bc0$exports[$ca600093aacddd58$var$FLUSH_SYNC];
const $ca600093aacddd58$var$USE_ID = "useId";
const $ca600093aacddd58$var$useIdImpl = $28UcW[$ca600093aacddd58$var$USE_ID];
function $ca600093aacddd58$var$startTransitionSafe(cb) {
    if ($ca600093aacddd58$var$startTransitionImpl) $ca600093aacddd58$var$startTransitionImpl(cb);
    else cb();
}
function $ca600093aacddd58$var$flushSyncSafe(cb) {
    if ($ca600093aacddd58$var$flushSyncImpl) $ca600093aacddd58$var$flushSyncImpl(cb);
    else cb();
}
class $ca600093aacddd58$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $ca600093aacddd58$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $28UcW.useState(router.state);
    let [pendingState, setPendingState] = $28UcW.useState();
    let [vtContext, setVtContext] = $28UcW.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $28UcW.useState();
    let [transition, setTransition] = $28UcW.useState();
    let [interruption, setInterruption] = $28UcW.useState();
    let fetcherData = $28UcW.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $28UcW.useCallback((cb)=>{
        if (v7_startTransition) $ca600093aacddd58$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $28UcW.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $ca600093aacddd58$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $ca600093aacddd58$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $ca600093aacddd58$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $ca600093aacddd58$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $ca600093aacddd58$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $28UcW.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $28UcW.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $ca600093aacddd58$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $28UcW.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $28UcW.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $28UcW.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $28UcW.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $28UcW.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $28UcW.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $28UcW.createElement($28UcW.Fragment, null, /*#__PURE__*/ $28UcW.createElement((0, $6e00b7bb3feca34a$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $28UcW.createElement((0, $6e00b7bb3feca34a$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $28UcW.createElement($ca600093aacddd58$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $28UcW.createElement($ca600093aacddd58$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $28UcW.createElement((0, $6e00b7bb3feca34a$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $28UcW.createElement($ca600093aacddd58$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $ca600093aacddd58$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $6e00b7bb3feca34a$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $ca600093aacddd58$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $28UcW.useRef();
    if (historyRef.current == null) historyRef.current = (0, $6299f2354da3ee7b$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $28UcW.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $28UcW.useCallback((newState)=>{
        v7_startTransition && $ca600093aacddd58$var$startTransitionImpl ? $ca600093aacddd58$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $28UcW.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $28UcW.createElement((0, $6e00b7bb3feca34a$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $ca600093aacddd58$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $28UcW.useRef();
    if (historyRef.current == null) historyRef.current = (0, $6299f2354da3ee7b$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $28UcW.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $28UcW.useCallback((newState)=>{
        v7_startTransition && $ca600093aacddd58$var$startTransitionImpl ? $ca600093aacddd58$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $28UcW.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $28UcW.createElement((0, $6e00b7bb3feca34a$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $ca600093aacddd58$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $28UcW.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $28UcW.useCallback((newState)=>{
        v7_startTransition && $ca600093aacddd58$var$startTransitionImpl ? $ca600093aacddd58$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $28UcW.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $28UcW.createElement((0, $6e00b7bb3feca34a$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $ca600093aacddd58$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $ca600093aacddd58$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $ca600093aacddd58$export$a6c7ac8248d6e38a = /*#__PURE__*/ $28UcW.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $ca600093aacddd58$var$_objectWithoutPropertiesLoose(_ref7, $ca600093aacddd58$var$_excluded);
    let { basename: basename } = $28UcW.useContext((0, $6e00b7bb3feca34a$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $ca600093aacddd58$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($ca600093aacddd58$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $6299f2354da3ee7b$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $6e00b7bb3feca34a$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $ca600093aacddd58$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $28UcW.createElement("a", $ca600093aacddd58$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $ca600093aacddd58$export$b0d92dbee9b5b60d = /*#__PURE__*/ $28UcW.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $ca600093aacddd58$var$_objectWithoutPropertiesLoose(_ref8, $ca600093aacddd58$var$_excluded2);
    let path = (0, $6e00b7bb3feca34a$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $6e00b7bb3feca34a$export$45d76561a5302f2b)();
    let routerState = $28UcW.useContext((0, $6e00b7bb3feca34a$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $28UcW.useContext((0, $6e00b7bb3feca34a$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $ca600093aacddd58$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $6299f2354da3ee7b$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $28UcW.createElement($ca600093aacddd58$export$a6c7ac8248d6e38a, $ca600093aacddd58$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $ca600093aacddd58$export$a7fed597f4b8afd8 = /*#__PURE__*/ $28UcW.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $ca600093aacddd58$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $ca600093aacddd58$var$_objectWithoutPropertiesLoose(_ref9, $ca600093aacddd58$var$_excluded3);
    let submit = $ca600093aacddd58$export$47c85c6e3a081d3();
    let formAction = $ca600093aacddd58$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $28UcW.createElement("form", $ca600093aacddd58$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $ca600093aacddd58$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $ca600093aacddd58$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $ca600093aacddd58$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($ca600093aacddd58$var$DataRouterHook || ($ca600093aacddd58$var$DataRouterHook = {}));
var $ca600093aacddd58$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($ca600093aacddd58$var$DataRouterStateHook || ($ca600093aacddd58$var$DataRouterStateHook = {}));
// Internal hooks
function $ca600093aacddd58$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $ca600093aacddd58$var$useDataRouterContext(hookName) {
    let ctx = $28UcW.useContext((0, $6e00b7bb3feca34a$export$3add0d5dce533e2e));
    !ctx && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
    return ctx;
}
function $ca600093aacddd58$var$useDataRouterState(hookName) {
    let state = $28UcW.useContext((0, $6e00b7bb3feca34a$export$145dfa71566a64dc));
    !state && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $ca600093aacddd58$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $6e00b7bb3feca34a$export$9770f232ac06a008)();
    let location = (0, $6e00b7bb3feca34a$export$45d76561a5302f2b)();
    let path = (0, $6e00b7bb3feca34a$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $28UcW.useCallback((event)=>{
        if ($ca600093aacddd58$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $6299f2354da3ee7b$export$fe53371bee54353d)(location) === (0, $6299f2354da3ee7b$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $ca600093aacddd58$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $28UcW.useRef($ca600093aacddd58$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $28UcW.useRef(false);
    let location = (0, $6e00b7bb3feca34a$export$45d76561a5302f2b)();
    let searchParams = $28UcW.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $ca600093aacddd58$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $6e00b7bb3feca34a$export$9770f232ac06a008)();
    let setSearchParams = $28UcW.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $ca600093aacddd58$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $ca600093aacddd58$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $ca600093aacddd58$var$fetcherId = 0;
let $ca600093aacddd58$var$getUniqueFetcherId = ()=>"__" + String(++$ca600093aacddd58$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $ca600093aacddd58$export$47c85c6e3a081d3() {
    let { router: router } = $ca600093aacddd58$var$useDataRouterContext($ca600093aacddd58$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $28UcW.useContext((0, $6e00b7bb3feca34a$export$26749e8557646306));
    let currentRouteId = (0, $6e00b7bb3feca34a$export$5fc8298006ad9e58)();
    return $28UcW.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $ca600093aacddd58$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $ca600093aacddd58$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $ca600093aacddd58$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $ca600093aacddd58$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $28UcW.useContext((0, $6e00b7bb3feca34a$export$26749e8557646306));
    let routeContext = $28UcW.useContext((0, $6e00b7bb3feca34a$export$9072aa6dd1f93057));
    !routeContext && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $ca600093aacddd58$var$_extends({}, (0, $6e00b7bb3feca34a$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $6e00b7bb3feca34a$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $6299f2354da3ee7b$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $6299f2354da3ee7b$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $ca600093aacddd58$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $ca600093aacddd58$var$useDataRouterContext($ca600093aacddd58$var$DataRouterHook.UseFetcher);
    let state = $ca600093aacddd58$var$useDataRouterState($ca600093aacddd58$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $28UcW.useContext($ca600093aacddd58$export$148fd98d095596d4);
    let route = $28UcW.useContext((0, $6e00b7bb3feca34a$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
    !route && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $ca600093aacddd58$var$useIdImpl ? $ca600093aacddd58$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $28UcW.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($ca600093aacddd58$var$getUniqueFetcherId());
    // Registration/cleanup
    $28UcW.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $28UcW.useCallback((href, opts)=>{
        !routeId && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $ca600093aacddd58$export$47c85c6e3a081d3();
    let submit = $28UcW.useCallback((target, opts)=>{
        submitImpl(target, $ca600093aacddd58$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $28UcW.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $28UcW.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $28UcW.createElement($ca600093aacddd58$export$a7fed597f4b8afd8, $ca600093aacddd58$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $6299f2354da3ee7b$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $28UcW.useMemo(()=>$ca600093aacddd58$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $ca600093aacddd58$export$fa996778a3a31087() {
    let state = $ca600093aacddd58$var$useDataRouterState($ca600093aacddd58$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $ca600093aacddd58$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $ca600093aacddd58$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $ca600093aacddd58$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $ca600093aacddd58$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $ca600093aacddd58$var$useDataRouterContext($ca600093aacddd58$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $ca600093aacddd58$var$useDataRouterState($ca600093aacddd58$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $28UcW.useContext((0, $6e00b7bb3feca34a$export$26749e8557646306));
    let location = (0, $6e00b7bb3feca34a$export$45d76561a5302f2b)();
    let matches = (0, $6e00b7bb3feca34a$export$2378eb7f5ff86053)();
    let navigation = (0, $6e00b7bb3feca34a$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $28UcW.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $ca600093aacddd58$var$usePageHide($28UcW.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $ca600093aacddd58$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $ca600093aacddd58$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($ca600093aacddd58$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $28UcW.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $ca600093aacddd58$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $ca600093aacddd58$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $28UcW.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($ca600093aacddd58$var$_extends({}, location, {
                    pathname: (0, $6299f2354da3ee7b$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($ca600093aacddd58$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $28UcW.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $ca600093aacddd58$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $28UcW.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $ca600093aacddd58$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $28UcW.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $ca600093aacddd58$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $6e00b7bb3feca34a$export$b273b3273281a049)(when);
    $28UcW.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $28UcW.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $ca600093aacddd58$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $28UcW.useContext($ca600093aacddd58$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $6299f2354da3ee7b$export$3e9cee6b33872309)(false);
    let { basename: basename } = $ca600093aacddd58$var$useDataRouterContext($ca600093aacddd58$var$DataRouterHook.useViewTransitionState);
    let path = (0, $6e00b7bb3feca34a$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $6299f2354da3ee7b$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $6299f2354da3ee7b$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $6299f2354da3ee7b$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $6299f2354da3ee7b$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");



var $28UcW = parcelRequire("28UcW");
var $a62237d662558d17$exports = {};
/*! js-cookie v3.0.5 | MIT */ (function(global, factory) {
    $a62237d662558d17$exports = factory();
})($a62237d662558d17$exports, function() {
    'use strict';
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    /* eslint-enable no-var */ return api;
});



const $85cbc800a2b35ef9$export$f3c786dfc9a16b2c = (puzzleName)=>{
    // Try to find an existing script with the ID
    let structuredDataScript = document.getElementById('puzzle-structured-data');
    // If puzzleName is null, remove the script and exit the function
    if (puzzleName === null) {
        if (structuredDataScript) structuredDataScript.remove();
        return;
    }
    // If a script does not exist, create it
    if (!structuredDataScript) {
        structuredDataScript = document.createElement('script');
        structuredDataScript.id = 'puzzle-structured-data';
        structuredDataScript.setAttribute('type', 'application/ld+json');
        document.head.appendChild(structuredDataScript);
    }
    // Update the text content of the script with the new data
    const rawData = $85cbc800a2b35ef9$var$puzzleData[puzzleName];
    rawData["@context"] = "https://schema.org";
    rawData["@type"] = "Article";
    rawData["datePublished"] = new Date().toISOString().slice(0, 19) + "Z";
    structuredDataScript.textContent = JSON.stringify(rawData, null, 2);
};
const $85cbc800a2b35ef9$var$puzzleData = {
    arithmeglyphs: {
        "headline": "Arithmeglyphs",
        "description": "A daily logic puzzle where numbers and symbols are used to reveal a hidden code.",
        "url": "https://dailybaffle.com/arithmeglyphs"
    },
    megarubigram: {
        "headline": "Megarubigram",
        "description": "An extra-hard bi-weekly word puzzle where letter grids are flipped and rotated to form words.",
        "url": "https://dailybaffle.com/megarubigram"
    },
    morphology: {
        "headline": "Morphology",
        "description": "A daily word puzzle resembling a clued word ladder.",
        "url": "https://dailybaffle.com/morphology"
    },
    pathword: {
        "headline": "Pathword",
        "description": "A daily word puzzle where a path must be drawn to unscramble four anagrams.",
        "url": "https://dailybaffle.com/pathword"
    },
    pathword5x5: {
        "headline": "Pathword 5x5",
        "description": "An extra-hard bi-weekly word puzzle involving anagrams and spatial logic.",
        "url": "https://dailybaffle.com/pathword5x5"
    },
    rubigram: {
        "headline": "Rubigram",
        "description": "A daily word puzzle where letter grids are flipped and rotated to form words.",
        "url": "https://dailybaffle.com/rubigram"
    },
    triword: {
        "headline": "Triword",
        "description": "A daily word puzzle where you must find the fragment that uniquely completes 3 words.",
        "url": "https://dailybaffle.com/triword"
    },
    ultrarubigram: {
        "headline": "Ultrarubigram",
        "description": "A monthly, desktop-only word puzzle where a 24x24 of letter grids is flipped and rotated to form words.",
        "url": "https://dailybaffle.com/ultrarubigram"
    },
    truthsorting: {
        "headline": "Truthsorting",
        "description": "A daily logic puzzle where truths and lies must be placed in the correct order.",
        "url": "https://dailybaffle.com/truthsorting"
    },
    varyClove: {
        "headline": "Vary Clove",
        "description": "A daily word puzzle where you must decipher a mysterious answer to a very basic question.",
        "url": "https://dailybaffle.com/varyclove"
    }
};


const $ba1e3b359abf28ef$export$517466abcb8fcf10 = location.hostname === 'localhost' ? undefined : location.hostname.includes('onrender') ? 'dailybaffle-1.onrender.com' : '.dailybaffle.com';
var $ba1e3b359abf28ef$export$cd903283095ece83 = /*#__PURE__*/ function(SpecialKeys) {
    SpecialKeys["Enter"] = "Enter";
    SpecialKeys["Delete"] = "Backspace";
    SpecialKeys["Tab"] = "Tab";
    SpecialKeys["ArrowUp"] = "ArrowUp";
    SpecialKeys["ArrowDown"] = "ArrowDown";
    SpecialKeys["ArrowRight"] = "ArrowRight";
    SpecialKeys["ArrowLeft"] = "ArrowLeft";
    SpecialKeys["Space"] = " ";
    return SpecialKeys;
}({});
const $ba1e3b359abf28ef$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $28UcW.useRef)(null);
    (0, $28UcW.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};
const $ba1e3b359abf28ef$export$a546a4e9e5b2cdef = (handleInput, solved, revealed)=>{
    // while the sign-in dialog is open, its email/password fields own the keyboard. otherwise
    // what you type there also lands in the puzzle, which can display your password on screen.
    const signInDialogOpen = (0, $e2662af8a2ab1f76$export$986181c251d527c3).useState((s)=>s.signInDialog.isOpen);
    (0, $28UcW.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            // bail before preventDefault so tab/space/arrows/enter still work inside the dialog
            if (signInDialogOpen) return;
            if (event.metaKey || event.ctrlKey || event.altKey) return;
            if (Object.values($ba1e3b359abf28ef$export$cd903283095ece83).includes(event.key)) event.preventDefault();
            if (solved || revealed) return;
            handleInput(event.key, event.shiftKey);
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleInput,
        solved,
        revealed,
        signInDialogOpen
    ]);
};
const $ba1e3b359abf28ef$export$70282ff0fcac9292 = (trigger, duration)=>{
    const [showAnimation, setShowAnimation] = (0, $28UcW.useState)(false);
    (0, $28UcW.useEffect)(()=>{
        if (trigger) {
            setShowAnimation(true);
            setTimeout(()=>{
                setShowAnimation(false);
            }, duration);
        }
    }, [
        trigger
    ]);
    return showAnimation;
};
const $ba1e3b359abf28ef$export$af32271b5d23b0f5 = ()=>{
    const [orientation, setOrientation] = (0, $28UcW.useState)(window.screen.orientation.type);
    (0, $28UcW.useEffect)(()=>{
        const handleOrientationChange = ()=>{
            setOrientation(window.screen.orientation.type);
        };
        window.screen.orientation.addEventListener('change', handleOrientationChange);
        return ()=>{
            window.screen.orientation.removeEventListener('change', handleOrientationChange);
        };
    }, []);
    return orientation;
};
// This doesn't detect the device, only the screen width. So if you want to display
// mobile styles on desktop when the window is shrunk to a small size, use this to trigger it.
// Returns true if width is below the mobile styling threshold.
const $ba1e3b359abf28ef$var$DEFAULT_MOBILE_THRESHOLD = 768;
const $ba1e3b359abf28ef$export$580e0f6db19fa7cc = (thresholdOverride)=>{
    const mobileThreshold = thresholdOverride ?? $ba1e3b359abf28ef$var$DEFAULT_MOBILE_THRESHOLD;
    const [isMobile, setIsMobile] = (0, $28UcW.useState)(window.innerWidth <= mobileThreshold);
    (0, $28UcW.useEffect)(()=>{
        function handleResize() {
            setIsMobile(window.innerWidth <= mobileThreshold);
        }
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return isMobile;
};
// This is a little redundant with the previous hook, but it's just for the main page that changes its layout more. The other hook is just for pages that only change on mobile, whereas this one is for a page that resizes among 3 different layouts.
// The mobile threshold is different here deliberately because the games need mobile sizing sooner than the landing page grid does.
const $ba1e3b359abf28ef$var$THRESHOLD_1 = 1150;
const $ba1e3b359abf28ef$var$THRESHOLD_2 = 775;
const $ba1e3b359abf28ef$var$getLayoutFromWidth = (width)=>{
    if (width > $ba1e3b359abf28ef$var$THRESHOLD_1) return 1;
    else if (width > $ba1e3b359abf28ef$var$THRESHOLD_2) return 2;
    else return 3;
};
const $ba1e3b359abf28ef$export$d76ab4527b141253 = ()=>{
    const [layout, setLayout] = (0, $28UcW.useState)(()=>$ba1e3b359abf28ef$var$getLayoutFromWidth(window.innerWidth));
    (0, $28UcW.useEffect)(()=>{
        const handleResize = ()=>{
            setLayout($ba1e3b359abf28ef$var$getLayoutFromWidth(window.innerWidth));
        };
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    return layout;
};
// used to disable timer during development so that state updates aren't constantly being issued
const $ba1e3b359abf28ef$var$debugMode = false;
const $ba1e3b359abf28ef$export$ce579a2cfd1aa062 = (store, useCompleted, completed)=>{
    const { isPaused: isPaused, isSoftPaused: isSoftPaused, solved: solved, revealed: revealed } = store.useState();
    (0, $28UcW.useEffect)(()=>{
        store.update((s)=>{
            if (isPaused || isSoftPaused) clearInterval(s.timerUpdatingFn);
            else {
                // no need to update timer anymore if the puzzle is solved/revealed
                if (useCompleted && completed) return;
                if (!useCompleted && (solved || revealed)) return;
                // but otherwise, when pause or soft-pause ends, set timer going again
                s.timerUpdatingFn = setInterval(()=>{
                    if ($ba1e3b359abf28ef$var$debugMode) return;
                    store.update((s)=>{
                        s.time++;
                    });
                }, 1000);
            }
        });
        // this auto-pauses the timer when the user navigates away, unmounting the puzzle
        return ()=>{
            store.update((s)=>{
                clearInterval(s.timerUpdatingFn);
            });
        };
    }, [
        isPaused,
        isSoftPaused,
        solved,
        revealed,
        completed
    ]);
    return isPaused;
};
const $ba1e3b359abf28ef$export$e73a86b2063a8f6b = (puzzleName, store)=>{
    (0, $28UcW.useEffect)(()=>{
        const instructionsPreviouslyDismissed = (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).get(`${puzzleName}InstructionsDismissed`) === 'true';
        if (!instructionsPreviouslyDismissed) store.update((s)=>{
            s.instructionsAreOpen = true;
            s.isSoftPaused = true;
        });
    }, []);
};
const $ba1e3b359abf28ef$export$20d77ccceac0f55c = (store, onSave)=>{
    (0, $28UcW.useEffect)(()=>{
        const handleVisibilityChange = ()=>{
            const isViewingPage = document.visibilityState === 'visible';
            if (!isViewingPage) onSave();
            store.update((s)=>{
                // if a dialog is open, it's already manually softpaused and we don't need to do anything
                if (s.instructionsAreOpen || s.revealConfirmationIsOpen || s.statsDialogIsOpen) return;
                s.isSoftPaused = !isViewingPage;
            });
        };
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return ()=>{
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);
};
const $ba1e3b359abf28ef$export$52dc0a972e5b91c5 = (puzzleName)=>{
    (0, $28UcW.useEffect)(()=>{
        try {
            $0d3747952a05ae22$export$6b2a7d5132615086(`${puzzleName}_opened`);
        } catch (error) {}
    }, []);
};
const $ba1e3b359abf28ef$export$5b0326dddadcb0de = (puzzleName)=>{
    (0, $28UcW.useEffect)(()=>{
        (0, $85cbc800a2b35ef9$export$f3c786dfc9a16b2c)(puzzleName);
    }, []);
};
const $ba1e3b359abf28ef$export$bc733b0c5cbb3e8a = (seconds)=>{
    // Calculate the number of days, hours, minutes, and seconds
    let days = Math.floor(seconds / 86400);
    seconds %= 86400;
    let hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    let minutes = Math.floor(seconds / 60);
    seconds = Math.floor(seconds % 60);
    // Build the formatted string
    let durationString = '';
    if (days > 0) durationString += days + 'd ';
    if (hours > 0) durationString += hours + 'h ';
    if (minutes > 0) durationString += minutes + 'm ';
    if (seconds > 0) durationString += seconds + 's';
    // Handle cases where the duration is less than 1 second
    if (durationString === '') durationString = '0s';
    return durationString.trim();
};
const $ba1e3b359abf28ef$export$e27d6512d262aec = ()=>{
    const [style, setStyle] = (0, $28UcW.useState)(window.innerHeight);
    (0, $28UcW.useEffect)(()=>{
        function handleResize() {
            setStyle(window.innerHeight);
        }
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    return style;
};
const $ba1e3b359abf28ef$export$db3b65d3d3d119f7 = (solved)=>{
    const wasSolvedOnLoad = (0, $28UcW.useRef)(solved);
    (0, $28UcW.useEffect)(()=>{
        if (!wasSolvedOnLoad.current && solved) setTimeout(()=>{
            wasSolvedOnLoad.current = true;
        }, 300);
    }, [
        solved
    ]);
    return wasSolvedOnLoad.current || false;
};
const $ba1e3b359abf28ef$export$b87c76f5e9f3d3df = (threshold)=>{
    const [shouldFloat, setShouldFloat] = (0, $28UcW.useState)(false);
    (0, $28UcW.useEffect)(()=>{
        const handleScroll = ()=>{
            const toolbar = document.querySelector('.morphologyContainer');
            const rect = toolbar.getBoundingClientRect();
            const scrolledPast = rect.top <= threshold;
            setShouldFloat(scrolledPast);
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return ()=>{
            window.removeEventListener('scroll', handleScroll);
        };
    }, [
        threshold
    ]);
    return shouldFloat;
};
const $ba1e3b359abf28ef$export$3203edd9e5edd663 = (time)=>{
    const numHours = Math.floor(time / 3600);
    const numSeconds = String(time % 60).padStart(2, '0');
    // pad the minutes with a 0 if over an hour
    if (numHours > 0) {
        const numMinutes = String(Math.floor(time % 3600 / 60)).padStart(2, '0');
        return `${numHours}:${numMinutes}:${numSeconds}`;
    } else {
        const numMinutes = String(Math.floor(time % 3600 / 60));
        return `${numMinutes}:${numSeconds}`;
    }
};



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");


var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");
const $42056ab2a8fd4216$var$PreviewIndividualGlyph = ({ glyphType: glyphType })=>/*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: `individualGlyph ${glyphType}Glyph`,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "shapeDisplay"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "inputSquare"
            })
        ]
    });
var $42056ab2a8fd4216$export$2e2bcd8739ae039 = $42056ab2a8fd4216$var$PreviewIndividualGlyph;


var $8fadddd087c48565$export$934328b60ccab05f = /*#__PURE__*/ function(GlyphType) {
    GlyphType["Triangle"] = "triangle";
    GlyphType["Square"] = "square";
    GlyphType["Diamond"] = "diamond";
    GlyphType["Dot"] = "dot";
    GlyphType["Circle"] = "circle";
    GlyphType["Noop"] = "noop";
    return GlyphType;
}({});
const $8fadddd087c48565$var$getMarkupForGlyphs = (glyphString, lineNumber)=>{
    const glyphSections = glyphString.split(/(\([^)]+\))/).map((s)=>s.trim()).filter(Boolean);
    return glyphSections.flatMap((section, i1)=>{
        const isSumBlock = section.startsWith('(');
        const glyphsForSection = section.slice(isSumBlock ? 1 : 0, isSumBlock ? -1 : undefined) // slice off the parens if needed
        .split(' ').map((glyph, i2)=>/*#__PURE__*/ (0, $4XrX4.jsx)((0, $42056ab2a8fd4216$export$2e2bcd8739ae039), {
                glyphType: glyph
            }, `${i1}-${i2}`));
        return isSumBlock ? /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
            className: "sumblock",
            children: glyphsForSection
        }, i1) : glyphsForSection;
    });
};
const $8fadddd087c48565$var$PreviewGlyphSequence = ({ glyphString: glyphString, lineNumber: lineNumber })=>{
    const glyphMarkup = $8fadddd087c48565$var$getMarkupForGlyphs(glyphString, lineNumber);
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "glyphSequence",
        children: glyphMarkup
    });
};
var $8fadddd087c48565$export$2e2bcd8739ae039 = $8fadddd087c48565$var$PreviewGlyphSequence;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");
const $dfe57487a50a7465$var$OutcomeBanner = ({ store: store })=>{
    const { solved: solved, revealed: revealed } = store.useState();
    if (solved) return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "outcomeBanner solved",
        children: "SOLVED"
    });
    if (revealed) return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "outcomeBanner revealed",
        children: "REVEALED"
    });
    return null;
};
var $dfe57487a50a7465$export$2e2bcd8739ae039 = $dfe57487a50a7465$var$OutcomeBanner;



const $860afe5c90b07ab1$export$8a6a76db0c20fb2a = {
    GENERIC_ERROR: 'generic_error',
    LOGGED_OUT: 'logged_out',
    // auth errors
    // (these match the possible values of the `code` property on the error response from firebase)
    WEAK_PASSWORD: 'auth/weak-password',
    INVALID_PASSWORD: 'auth/wrong-password',
    INVALID_EMAIL: 'auth/invalid-email',
    USER_NOT_FOUND: 'auth/user-not-found',
    EMAIL_ALREADY_IN_USE: 'auth/email-already-exists',
    REQUIRES_RECENT_LOGIN: 'auth/requires-recent-login',
    // these ones are ours, not from firebase
    USERNAME_UNAVAILABLE: 'username-unavailable',
    USERNAME_INVALID: 'username-invalid',
    INVALID_TOKEN: 'invalid-token'
};
const $860afe5c90b07ab1$export$87a8383fc3f35723 = 2000;
const $860afe5c90b07ab1$export$c83f6fa500e2ab35 = {
    puzzleId: 0,
    timerUpdatingFn: undefined,
    time: 0,
    isPaused: false,
    isSoftPaused: false,
    instructionsAreOpen: false,
    revealConfirmationIsOpen: false,
    statsDialogIsOpen: false,
    solved: false,
    revealed: false
};
var $860afe5c90b07ab1$export$3e1d53562ebc9131 = /*#__PURE__*/ function(PuzzleNames) {
    PuzzleNames["Arithmeglyphs"] = "arithmeglyphs";
    PuzzleNames["Megarubigram"] = "megarubigram";
    PuzzleNames["Morphology"] = "morphology";
    PuzzleNames["Pathword"] = "pathword";
    PuzzleNames["Pathword5x5"] = "pathword5x5";
    PuzzleNames["Rubigram"] = "rubigram";
    PuzzleNames["Triword"] = "triword";
    PuzzleNames["Truthsorting"] = "truthsorting";
    PuzzleNames["Ultrarubigram"] = "ultrarubigram";
    PuzzleNames["VaryClove"] = "varyClove";
    return PuzzleNames;
}({});
const $860afe5c90b07ab1$export$db7e8528fe84408c = {
    arithmeglyphs: 'Arithmeglyphs',
    megarubigram: 'Megarubigram',
    morphology: 'Morphology',
    pathword: 'Pathword',
    pathword5x5: 'Pathword 5x5',
    rubigram: 'Rubigram',
    triword: 'Triword',
    truthsorting: 'Truthsorting',
    ultrarubigram: 'Ultrarubigram',
    varyClove: 'Vary Clove'
};
const $860afe5c90b07ab1$export$cc7ad1873fe327df = '_desktop';
const $860afe5c90b07ab1$export$84fc02f9706d391f = '_mobile';
const $860afe5c90b07ab1$export$718e7ec1812fe0e9 = {
    ["arithmeglyphs" + $860afe5c90b07ab1$export$cc7ad1873fe327df]: 'sb_dAr',
    ["megarubigram" + $860afe5c90b07ab1$export$cc7ad1873fe327df]: 'sb_dMe',
    ["morphology" + $860afe5c90b07ab1$export$cc7ad1873fe327df]: 'sb_dMo',
    ["pathword" + $860afe5c90b07ab1$export$cc7ad1873fe327df]: 'sb_dPa',
    ["pathword5x5" + $860afe5c90b07ab1$export$cc7ad1873fe327df]: 'sb_dPa5',
    ["rubigram" + $860afe5c90b07ab1$export$cc7ad1873fe327df]: 'sb_dRu',
    ["triword" + $860afe5c90b07ab1$export$cc7ad1873fe327df]: 'sb_dTr',
    ["truthsorting" + $860afe5c90b07ab1$export$cc7ad1873fe327df]: 'sb_dTs',
    ["ultrarubigram" + $860afe5c90b07ab1$export$cc7ad1873fe327df]: 'sb_dUl',
    ["varyClove" + $860afe5c90b07ab1$export$cc7ad1873fe327df]: 'sb_dVC',
    ["arithmeglyphs" + $860afe5c90b07ab1$export$84fc02f9706d391f]: 'sb_mAr',
    ["megarubigram" + $860afe5c90b07ab1$export$84fc02f9706d391f]: 'sb_mMe',
    ["morphology" + $860afe5c90b07ab1$export$84fc02f9706d391f]: 'sb_mMo',
    ["pathword" + $860afe5c90b07ab1$export$84fc02f9706d391f]: 'sb_mPa',
    ["pathword5x5" + $860afe5c90b07ab1$export$84fc02f9706d391f]: 'sb_mPa5',
    ["rubigram" + $860afe5c90b07ab1$export$84fc02f9706d391f]: 'sb_mRu',
    ["triword" + $860afe5c90b07ab1$export$84fc02f9706d391f]: 'sb_mTr',
    ["truthsorting" + $860afe5c90b07ab1$export$84fc02f9706d391f]: 'sb_mTs',
    ["ultrarubigram" + $860afe5c90b07ab1$export$84fc02f9706d391f]: 'sb_mUl',
    ["varyClove" + $860afe5c90b07ab1$export$84fc02f9706d391f]: 'sb_mVC'
};
var $860afe5c90b07ab1$export$c3d9e0f0f1dd67c3 = /*#__PURE__*/ function(TruthsortingColors) {
    TruthsortingColors["Red"] = "red";
    TruthsortingColors["Blue"] = "blue";
    TruthsortingColors["Green"] = "green";
    TruthsortingColors["Yellow"] = "yellow";
    TruthsortingColors["Pink"] = "pink";
    TruthsortingColors["Orange"] = "orange";
    TruthsortingColors["Purple"] = "purple";
    TruthsortingColors["Cyan"] = "cyan";
    return TruthsortingColors;
}({});
var $860afe5c90b07ab1$var$TruthsortingRequirements = /*#__PURE__*/ function(TruthsortingRequirements) {
    TruthsortingRequirements["NthStatement"] = "NthStatement";
    TruthsortingRequirements["FollowedByVeracity"] = "FollowedByVeracity";
    TruthsortingRequirements["PrecededByVeracity"] = "PrecededByVeracity";
    TruthsortingRequirements["FollowedByColor"] = "FollowedByColor";
    TruthsortingRequirements["PrecededByColor"] = "PrecededByColor";
    TruthsortingRequirements["ColorVeracityAssertion"] = "ColorVeracityAssertion";
    TruthsortingRequirements["PositionalParity"] = "PositionalParity";
    TruthsortingRequirements["SurroundedBy"] = "SurroundedBy";
    TruthsortingRequirements["ColorPosition"] = "ColorPosition";
    TruthsortingRequirements["DistanceFromColor"] = "DistanceFromColor";
    TruthsortingRequirements["BothVeracityAssertion"] = "BothVeracityAssertion";
    TruthsortingRequirements["XORVeracityAssertion"] = "XORVeracityAssertion";
    TruthsortingRequirements["ColorOrder"] = "ColorOrder";
    TruthsortingRequirements["BetweenColors"] = "BetweenColors";
    TruthsortingRequirements["SelfIsCloserToColor"] = "SelfIsCloserToColor";
    TruthsortingRequirements["SelfIsFirstOrLast"] = "SelfIsFirstOrLast";
    TruthsortingRequirements["ColorIsFirstOrLast"] = "ColorIsFirstOrLast";
    TruthsortingRequirements["SelfAdjacency"] = "SelfAdjacency";
    TruthsortingRequirements["ColorAdjacency"] = "ColorAdjacency";
    TruthsortingRequirements["XNORVeracityAssertion"] = "XNORVeracityAssertion";
    TruthsortingRequirements["NegatedNthStatement"] = "NegatedNthStatement";
    TruthsortingRequirements["NegatedFollowedByColor"] = "NegatedFollowedByColor";
    TruthsortingRequirements["NegatedPrecededByColor"] = "NegatedPrecededByColor";
    TruthsortingRequirements["NegatedSurroundedBy"] = "NegatedSurroundedBy";
    TruthsortingRequirements["NegatedColorPosition"] = "NegatedColorPosition";
    TruthsortingRequirements["NegatedColorIsFirstOrLast"] = "NegatedColorIsFirstOrLast";
    TruthsortingRequirements["NegatedSelfIsFirstOrLast"] = "NegatedSelfIsFirstOrLast";
    TruthsortingRequirements["NegatedSelfAdjacency"] = "NegatedSelfAdjacency";
    return TruthsortingRequirements;
}($860afe5c90b07ab1$var$TruthsortingRequirements || {});


const $f159c0fbed3d8ee5$export$f0f19936383bf48f = new (0, $eb0b4d1e13e36536$export$390f32400eaf98c9)({
    ...(0, $860afe5c90b07ab1$export$c83f6fa500e2ab35),
    completed: false,
    focusLocation: {
        lineNumber: 1,
        index: 0
    },
    dataByLine: [],
    thirdLineNumSeq: '',
    checkDropdownIsOpen: false,
    revealDropdownIsOpen: false,
    combinedDropdownIsOpen: false,
    glyphReferenceIsOpen: false,
    confirmationDialogs: {
        revealGlyphIsOpen: false,
        revealLineIsOpen: false,
        revealPuzzleIsOpen: false,
        checkGlyphIsOpen: false,
        checkLineIsOpen: false,
        checkPuzzleIsOpen: false
    }
});



const $df94b7a5d05b54eb$var$ArithmeglyphsPreview = ({ onClick: onClick })=>{
    const puzzleData = (0, $e2662af8a2ab1f76$export$986181c251d527c3).useState((s)=>s.puzzleData?.arithmeglyphs);
    if (!puzzleData) return null;
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "previewTile puzzleTile arithmeglyphsTile",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "puzzleTitle",
                children: "Arithmeglyphs"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "arithmeglyphsPreview",
                children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                    className: "glyphSequencesContainer",
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsx)((0, $8fadddd087c48565$export$2e2bcd8739ae039), {
                            glyphString: puzzleData.line1_opSeq,
                            lineNumber: 0
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)((0, $8fadddd087c48565$export$2e2bcd8739ae039), {
                            glyphString: puzzleData.line2_opSeq,
                            lineNumber: 1
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)((0, $dfe57487a50a7465$export$2e2bcd8739ae039), {
                            store: (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f)
                        })
                    ]
                })
            })
        ]
    });
};
var $df94b7a5d05b54eb$export$2e2bcd8739ae039 = $df94b7a5d05b54eb$var$ArithmeglyphsPreview;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");


const $f731e2f2b99acd98$var$getEmptySubGrids = ()=>{
    return Array.from({
        length: 4
    }, ()=>({
            content: [],
            displayContent: [],
            solution: [],
            flippedHorizontally: false,
            flippedVertically: false,
            degreesRotated: 0,
            isInFlippingAnimation: false
        }));
};
const $f731e2f2b99acd98$var$getEmptyGrids = ()=>{
    return Array.from({
        length: 4
    }, ()=>({
            flippedHorizontally: false,
            flippedVertically: false,
            degreesRotated: 0,
            isInFlippingAnimation: false,
            subgrids: $f731e2f2b99acd98$var$getEmptySubGrids()
        }));
};
const $f731e2f2b99acd98$export$67e62d6ceebdf4ee = new (0, $eb0b4d1e13e36536$export$390f32400eaf98c9)({
    ...(0, $860afe5c90b07ab1$export$c83f6fa500e2ab35),
    activeGrid: 0,
    activeSubgrid: 0,
    degreesRotated: 0,
    grids: $f731e2f2b99acd98$var$getEmptyGrids(),
    solvedGrids: $f731e2f2b99acd98$var$getEmptyGrids()
});


var $1d8ea1f527760aa0$exports = {};
$1d8ea1f527760aa0$exports = import.meta.resolve("cxczl");



const $289b62f3bac83dc5$var$MegarubigramPreview = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "previewTile puzzleTile",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
            className: "megarubigramPreview",
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                    className: "puzzleTitle",
                    children: "Megarubigram"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                    className: "previewImageContainer",
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                            className: "rubigramIcon",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($1d8ea1f527760aa0$exports)))
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)((0, $dfe57487a50a7465$export$2e2bcd8739ae039), {
                            store: (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee)
                        })
                    ]
                })
            ]
        })
    });
};
var $289b62f3bac83dc5$export$2e2bcd8739ae039 = $289b62f3bac83dc5$var$MegarubigramPreview;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");


const $48a85ad21da8d504$var$rotationMatrix = (quarterTurns)=>{
    const cos = [
        1,
        0,
        -1,
        0
    ][quarterTurns];
    const sin = [
        0,
        1,
        0,
        -1
    ][quarterTurns];
    return [
        cos,
        -sin,
        sin,
        cos
    ];
};
/** Elements 0..3 are rotations by 0/90/180/270 degrees; 4..7 are those rotations mirrored. */ const $48a85ad21da8d504$var$MATRICES = [];
for(let k = 0; k < 4; k++)$48a85ad21da8d504$var$MATRICES.push($48a85ad21da8d504$var$rotationMatrix(k));
for(let k = 0; k < 4; k++){
    const [a, b, c, d] = $48a85ad21da8d504$var$rotationMatrix(k);
    $48a85ad21da8d504$var$MATRICES.push([
        -a,
        -b,
        c,
        d
    ]); // reflect x after rotating
}
const $48a85ad21da8d504$var$matrixIndex = ([a, b, c, d])=>{
    for(let i = 0; i < 8; i++){
        const m = $48a85ad21da8d504$var$MATRICES[i];
        if (m[0] === a && m[1] === b && m[2] === c && m[3] === d) return i;
    }
    throw new Error('not a D4 element');
};
const $48a85ad21da8d504$var$MUL = [];
const $48a85ad21da8d504$var$INV = [];
for(let i = 0; i < 8; i++){
    $48a85ad21da8d504$var$MUL.push([]);
    const [a, b, c, d] = $48a85ad21da8d504$var$MATRICES[i];
    for(let j = 0; j < 8; j++){
        const [e, f, g, h] = $48a85ad21da8d504$var$MATRICES[j];
        $48a85ad21da8d504$var$MUL[i].push($48a85ad21da8d504$var$matrixIndex([
            a * e + b * g,
            a * f + b * h,
            c * e + d * g,
            c * f + d * h
        ]));
    }
    $48a85ad21da8d504$var$INV.push($48a85ad21da8d504$var$matrixIndex([
        a,
        c,
        b,
        d
    ])); // orthogonal, so the inverse is the transpose
}
const $48a85ad21da8d504$export$76c0f2b8ecfc3d8a = 0;
const $48a85ad21da8d504$export$ef526acc0c628d7b = 4;
const $48a85ad21da8d504$export$7d1324acc3d71eb5 = 6;
const $48a85ad21da8d504$export$f672e0b6f7222cd7 = (outer, inner)=>$48a85ad21da8d504$var$MUL[outer][inner];
const $48a85ad21da8d504$export$70ae2c07e401031b = (el)=>$48a85ad21da8d504$var$INV[el];
const $48a85ad21da8d504$export$43c5e86db8db458 = (el)=>el >= 4;
const $48a85ad21da8d504$export$1c9b535badd63e7a = (el)=>$48a85ad21da8d504$var$MATRICES[el][0] === 0;
const $48a85ad21da8d504$export$5635d7ef4b8fee1c = (el, x, y)=>{
    const [a, b, c, d] = $48a85ad21da8d504$var$MATRICES[el];
    return [
        a * x + b * y,
        c * x + d * y
    ];
};
const $48a85ad21da8d504$export$6b3f69c997ae528 = (degrees)=>(degrees / 90 % 4 + 4) % 4;
const $48a85ad21da8d504$export$a630693aae3f96b7 = ({ rot: rot, flipH: flipH, flipV: flipV })=>{
    let el = $48a85ad21da8d504$export$6b3f69c997ae528(rot);
    if (flipV) el = $48a85ad21da8d504$export$f672e0b6f7222cd7($48a85ad21da8d504$export$7d1324acc3d71eb5, el);
    if (flipH) el = $48a85ad21da8d504$export$f672e0b6f7222cd7($48a85ad21da8d504$export$ef526acc0c628d7b, el);
    return el;
};
const $48a85ad21da8d504$export$2ee7a40c7f20e9b7 = (el)=>{
    const flip = $48a85ad21da8d504$export$43c5e86db8db458(el);
    const rotation = flip ? $48a85ad21da8d504$export$f672e0b6f7222cd7(el, $48a85ad21da8d504$export$ef526acc0c628d7b) : el;
    return {
        angle: rotation * 90,
        flip: flip
    };
};
const $48a85ad21da8d504$export$3571c57768c14fd1 = (previous, target)=>{
    const diff = ((target - previous) % 360 + 540) % 360 - 180;
    return previous + diff;
};
const $48a85ad21da8d504$export$e1475ecddab48344 = 24; // half-cells
/** Child index -> offset of its center from its parent's center, in units of the child's half size. */ const $48a85ad21da8d504$var$CORNER = [
    [
        -1,
        -1
    ],
    [
        1,
        -1
    ],
    [
        -1,
        1
    ],
    [
        1,
        1
    ]
]; // TL, TR, BL, BR
const $48a85ad21da8d504$export$85915561ea5d0167 = 12;
const $48a85ad21da8d504$export$426cb73c3ee7b28e = 6;
const $48a85ad21da8d504$export$61a688f241a363c6 = 3;
const $48a85ad21da8d504$export$3867a73edf336869 = (index, halfSize)=>[
        $48a85ad21da8d504$var$CORNER[index][0] * halfSize,
        $48a85ad21da8d504$var$CORNER[index][1] * halfSize
    ];
const $48a85ad21da8d504$export$b6deaad2e68d9e0f = (x, y)=>(x > 0 ? 1 : 0) + (y > 0 ? 2 : 0);
const $48a85ad21da8d504$export$1b704bc0cde19094 = (row, col)=>[
        (col - 1) * 2,
        (row - 1) * 2
    ];
const $48a85ad21da8d504$export$bf3c2d79d8478f0e = [
    'top',
    'right',
    'bottom',
    'left'
];
const $48a85ad21da8d504$export$33c60e0f35e2dfe1 = {
    top: [
        0,
        -1
    ],
    right: [
        1,
        0
    ],
    bottom: [
        0,
        1
    ],
    left: [
        -1,
        0
    ]
};
const $48a85ad21da8d504$export$8d4e26484c874870 = 24;
const $48a85ad21da8d504$var$atRest = ()=>({
        rot: 0,
        flipH: false,
        flipV: false,
        isFlipping: false,
        moving: null,
        moves: 0
    });
const $48a85ad21da8d504$export$a92b4a0921ab39e0 = ()=>({
        ...$48a85ad21da8d504$var$atRest(),
        content: []
    });
const $48a85ad21da8d504$export$b52c0673261d89c0 = ()=>Array.from({
        length: 4
    }, ()=>({
            ...$48a85ad21da8d504$var$atRest(),
            quadrants: Array.from({
                length: 4
            }, ()=>({
                    ...$48a85ad21da8d504$var$atRest(),
                    subgrids: Array.from({
                        length: 4
                    }, $48a85ad21da8d504$export$a92b4a0921ab39e0)
                }))
        }));
const $48a85ad21da8d504$export$ed50998d8ec9d534 = (grid, row, col, size)=>grid.slice(row, row + size).map((r)=>r.slice(col, col + size));
const $48a85ad21da8d504$export$c4ec174058808011 = (grids, rows)=>{
    grids.forEach((grid, g)=>{
        grid.quadrants.forEach((quadrant, q)=>{
            quadrant.subgrids.forEach((subgrid, s)=>{
                const row = (g >> 1) * 12 + (q >> 1) * 6 + (s >> 1) * 3;
                const col = (g & 1) * 12 + (q & 1) * 6 + (s & 1) * 3;
                subgrid.content = $48a85ad21da8d504$export$ed50998d8ec9d534(rows, row, col, 3);
            });
        });
    });
};
const $48a85ad21da8d504$export$245018fe6e19aee = (puzzleRot, grids)=>{
    const screen = Array.from({
        length: $48a85ad21da8d504$export$8d4e26484c874870
    }, ()=>Array($48a85ad21da8d504$export$8d4e26484c874870).fill(' '));
    const root = $48a85ad21da8d504$export$6b3f69c997ae528(puzzleRot);
    grids.forEach((grid, g)=>{
        const gridEl = $48a85ad21da8d504$export$f672e0b6f7222cd7(root, $48a85ad21da8d504$export$a630693aae3f96b7(grid));
        const [gx, gy] = $48a85ad21da8d504$export$5635d7ef4b8fee1c(root, ...$48a85ad21da8d504$export$3867a73edf336869(g, $48a85ad21da8d504$export$85915561ea5d0167));
        grid.quadrants.forEach((quadrant, q)=>{
            const quadrantEl = $48a85ad21da8d504$export$f672e0b6f7222cd7(gridEl, $48a85ad21da8d504$export$a630693aae3f96b7(quadrant));
            const [qx, qy] = $48a85ad21da8d504$export$5635d7ef4b8fee1c(gridEl, ...$48a85ad21da8d504$export$3867a73edf336869(q, $48a85ad21da8d504$export$426cb73c3ee7b28e));
            quadrant.subgrids.forEach((subgrid, s)=>{
                const subgridEl = $48a85ad21da8d504$export$f672e0b6f7222cd7(quadrantEl, $48a85ad21da8d504$export$a630693aae3f96b7(subgrid));
                const [sx, sy] = $48a85ad21da8d504$export$5635d7ef4b8fee1c(quadrantEl, ...$48a85ad21da8d504$export$3867a73edf336869(s, $48a85ad21da8d504$export$61a688f241a363c6));
                subgrid.content.forEach((cells, row)=>{
                    cells.forEach((cell, col)=>{
                        const [cx, cy] = $48a85ad21da8d504$export$5635d7ef4b8fee1c(subgridEl, ...$48a85ad21da8d504$export$1b704bc0cde19094(row, col));
                        const x = gx + qx + sx + cx;
                        const y = gy + qy + sy + cy;
                        screen[(y + $48a85ad21da8d504$export$e1475ecddab48344 - 1) / 2][(x + $48a85ad21da8d504$export$e1475ecddab48344 - 1) / 2] = cell;
                    });
                });
            });
        });
    });
    return screen;
};
const $48a85ad21da8d504$export$9666754a25e0cb16 = (a, b)=>{
    for(let row = 0; row < $48a85ad21da8d504$export$8d4e26484c874870; row++)for(let col = 0; col < $48a85ad21da8d504$export$8d4e26484c874870; col++){
        if (a[row][col] !== b[row][col]) return false;
    }
    return true;
};
const $48a85ad21da8d504$export$5068540ba132f3a1 = (state, path)=>{
    const grid = state.grids[path.grid];
    if (path.quadrant === undefined) return grid;
    const quadrant = grid.quadrants[path.quadrant];
    if (path.subgrid === undefined) return quadrant;
    return quadrant.subgrids[path.subgrid];
};
const $48a85ad21da8d504$export$222ab8a52715b4f4 = (state, path)=>{
    let el = $48a85ad21da8d504$export$6b3f69c997ae528(state.rot);
    const grid = state.grids[path.grid];
    if (path.quadrant === undefined) return el;
    el = $48a85ad21da8d504$export$f672e0b6f7222cd7(el, $48a85ad21da8d504$export$a630693aae3f96b7(grid));
    if (path.subgrid === undefined) return el;
    return $48a85ad21da8d504$export$f672e0b6f7222cd7(el, $48a85ad21da8d504$export$a630693aae3f96b7(grid.quadrants[path.quadrant]));
};
const $48a85ad21da8d504$export$2b174b2fa5e33c96 = (state, path)=>$48a85ad21da8d504$export$f672e0b6f7222cd7($48a85ad21da8d504$export$222ab8a52715b4f4(state, path), $48a85ad21da8d504$export$a630693aae3f96b7($48a85ad21da8d504$export$5068540ba132f3a1(state, path)));
const $48a85ad21da8d504$export$ea208655b482d0f9 = (state, path)=>{
    const root = $48a85ad21da8d504$export$6b3f69c997ae528(state.rot);
    let [x, y] = $48a85ad21da8d504$export$5635d7ef4b8fee1c(root, ...$48a85ad21da8d504$export$3867a73edf336869(path.grid, $48a85ad21da8d504$export$85915561ea5d0167));
    if (path.quadrant === undefined) return {
        x: x,
        y: y,
        halfSize: $48a85ad21da8d504$export$85915561ea5d0167
    };
    const gridEl = $48a85ad21da8d504$export$f672e0b6f7222cd7(root, $48a85ad21da8d504$export$a630693aae3f96b7(state.grids[path.grid]));
    const [qx, qy] = $48a85ad21da8d504$export$5635d7ef4b8fee1c(gridEl, ...$48a85ad21da8d504$export$3867a73edf336869(path.quadrant, $48a85ad21da8d504$export$426cb73c3ee7b28e));
    x += qx;
    y += qy;
    if (path.subgrid === undefined) return {
        x: x,
        y: y,
        halfSize: $48a85ad21da8d504$export$426cb73c3ee7b28e
    };
    const quadrantEl = $48a85ad21da8d504$export$f672e0b6f7222cd7(gridEl, $48a85ad21da8d504$export$a630693aae3f96b7(state.grids[path.grid].quadrants[path.quadrant]));
    const [sx, sy] = $48a85ad21da8d504$export$5635d7ef4b8fee1c(quadrantEl, ...$48a85ad21da8d504$export$3867a73edf336869(path.subgrid, $48a85ad21da8d504$export$61a688f241a363c6));
    return {
        x: x + sx,
        y: y + sy,
        halfSize: $48a85ad21da8d504$export$61a688f241a363c6
    };
};
const $48a85ad21da8d504$export$bb05e11298275b42 = (state, path, horizontal)=>{
    const piece = $48a85ad21da8d504$export$5068540ba132f3a1(state, path);
    const localIsHorizontal = $48a85ad21da8d504$export$1c9b535badd63e7a($48a85ad21da8d504$export$222ab8a52715b4f4(state, path)) ? !horizontal : horizontal;
    if (localIsHorizontal) piece.flipH = !piece.flipH;
    else piece.flipV = !piece.flipV;
    return localIsHorizontal ? 'H' : 'V';
};
const $48a85ad21da8d504$export$4e3be200d92900c1 = (state, path, clockwise)=>{
    const piece = $48a85ad21da8d504$export$5068540ba132f3a1(state, path);
    const mirrored = $48a85ad21da8d504$export$43c5e86db8db458($48a85ad21da8d504$export$222ab8a52715b4f4(state, path)) !== (piece.flipH !== piece.flipV);
    piece.rot += (clockwise ? 90 : -90) * (mirrored ? -1 : 1);
};
const $48a85ad21da8d504$var$matchSubgrid = (content, target)=>{
    for(let el = 0; el < 8; el++){
        let matches = true;
        for(let row = 0; row < 3 && matches; row++)for(let col = 0; col < 3; col++){
            const [x, y] = $48a85ad21da8d504$export$5635d7ef4b8fee1c(el, ...$48a85ad21da8d504$export$1b704bc0cde19094(row, col));
            if (target[y / 2 + 1][x / 2 + 1] !== content[row][col]) {
                matches = false;
                break;
            }
        }
        if (matches) return el;
    }
    return -1;
};
/**
 * Finds screen orientations for a piece and everything inside it that make it display
 * `target`, trying all eight for the piece itself and recursing into wherever each child lands.
 */ const $48a85ad21da8d504$var$matchPiece = (children, childHalfSize, target)=>{
    for(let el = 0; el < 8; el++){
        const solvedChildren = [];
        for(let k = 0; k < 4; k++){
            const [x, y] = $48a85ad21da8d504$export$5635d7ef4b8fee1c(el, ...$48a85ad21da8d504$export$3867a73edf336869(k, childHalfSize));
            const landing = $48a85ad21da8d504$export$b6deaad2e68d9e0f(x, y);
            const size = childHalfSize;
            const childTarget = $48a85ad21da8d504$export$ed50998d8ec9d534(target, (landing >> 1) * size, (landing & 1) * size, size);
            const child = children[k];
            const solvedChild = 'subgrids' in child ? $48a85ad21da8d504$var$matchPiece(child.subgrids, $48a85ad21da8d504$export$61a688f241a363c6, childTarget) : (()=>{
                const childEl = $48a85ad21da8d504$var$matchSubgrid(child.content, childTarget);
                return childEl === -1 ? null : {
                    el: childEl,
                    children: []
                };
            })();
            if (!solvedChild) break;
            solvedChildren.push(solvedChild);
        }
        if (solvedChildren.length === 4) return {
            el: el,
            children: solvedChildren
        };
    }
    return null;
};
const $48a85ad21da8d504$export$d593c3b3b07081f6 = (grids, solution)=>{
    for(let rootEl = 0; rootEl < 4; rootEl++){
        const solvedGrids = [];
        for(let g = 0; g < 4; g++){
            const [x, y] = $48a85ad21da8d504$export$5635d7ef4b8fee1c(rootEl, ...$48a85ad21da8d504$export$3867a73edf336869(g, $48a85ad21da8d504$export$85915561ea5d0167));
            const landing = $48a85ad21da8d504$export$b6deaad2e68d9e0f(x, y);
            const target = $48a85ad21da8d504$export$ed50998d8ec9d534(solution, (landing >> 1) * 12, (landing & 1) * 12, 12);
            const solvedGrid = $48a85ad21da8d504$var$matchPiece(grids[g].quadrants, $48a85ad21da8d504$export$426cb73c3ee7b28e, target);
            if (!solvedGrid) break;
            solvedGrids.push(solvedGrid);
        }
        if (solvedGrids.length === 4) return {
            rootEl: rootEl,
            grids: solvedGrids
        };
    }
    return null;
};
const $48a85ad21da8d504$export$a5640c3dbe03d54 = (current, target)=>{
    const options = [
        {
            toggle: null,
            flipH: current.flipH,
            flipV: current.flipV
        },
        {
            toggle: 'H',
            flipH: !current.flipH,
            flipV: current.flipV
        },
        {
            toggle: 'V',
            flipH: current.flipH,
            flipV: !current.flipV
        }
    ];
    let best = null;
    for (const option of options){
        const flipEl = $48a85ad21da8d504$export$a630693aae3f96b7({
            rot: 0,
            flipH: option.flipH,
            flipV: option.flipV
        });
        const rotation = $48a85ad21da8d504$export$f672e0b6f7222cd7($48a85ad21da8d504$export$70ae2c07e401031b(flipEl), target);
        if ($48a85ad21da8d504$export$43c5e86db8db458(rotation)) continue; // this flip combination can't reach the target
        const targetRot = rotation * 90;
        let deltaRot = ((targetRot - current.rot) % 360 + 360) % 360;
        if (deltaRot === 270) deltaRot = -90;
        const cost = (option.toggle ? 10 : 0) + Math.abs(deltaRot) / 90;
        if (!best || cost < best.cost) best = {
            toggle: option.toggle,
            deltaRot: deltaRot,
            cost: cost
        };
    }
    return best;
};
// ---------------------------------------------------------------------------
// Saving
// ---------------------------------------------------------------------------
const $48a85ad21da8d504$var$orientationOf = (p)=>({
        rot: p.rot,
        flipH: p.flipH,
        flipV: p.flipV
    });
const $48a85ad21da8d504$export$b8e17e5947e2dd8a = (grids)=>grids.map((grid)=>({
            ...$48a85ad21da8d504$var$orientationOf(grid),
            quadrants: grid.quadrants.map((quadrant)=>({
                    ...$48a85ad21da8d504$var$orientationOf(quadrant),
                    subgrids: quadrant.subgrids.map($48a85ad21da8d504$var$orientationOf)
                }))
        }));
const $48a85ad21da8d504$var$isOrientation = (o)=>!!o && typeof o === 'object' && Number.isInteger(o.rot) && o.rot % 90 === 0 && typeof o.flipH === 'boolean' && typeof o.flipV === 'boolean';
const $48a85ad21da8d504$var$setOrientation = (piece, o)=>{
    piece.rot = o.rot;
    piece.flipH = o.flipH;
    piece.flipV = o.flipV;
    piece.isFlipping = false;
    piece.moving = null;
};
const $48a85ad21da8d504$var$REST = {
    rot: 0,
    flipH: false,
    flipV: false
};
const $48a85ad21da8d504$export$39ef76c8a466c6a7 = (grids)=>{
    for (const grid of grids){
        $48a85ad21da8d504$var$setOrientation(grid, $48a85ad21da8d504$var$REST);
        for (const quadrant of grid.quadrants){
            $48a85ad21da8d504$var$setOrientation(quadrant, $48a85ad21da8d504$var$REST);
            for (const subgrid of quadrant.subgrids)$48a85ad21da8d504$var$setOrientation(subgrid, $48a85ad21da8d504$var$REST);
        }
    }
};
const $48a85ad21da8d504$export$50709009735b417 = (grids, saved)=>{
    const four = (a)=>Array.isArray(a) && a.length === 4;
    const valid = four(saved) && saved.every((grid)=>$48a85ad21da8d504$var$isOrientation(grid) && four(grid.quadrants) && grid.quadrants.every((quadrant)=>$48a85ad21da8d504$var$isOrientation(quadrant) && four(quadrant.subgrids) && quadrant.subgrids.every($48a85ad21da8d504$var$isOrientation)));
    if (!valid) return false;
    const s = saved;
    grids.forEach((grid, g)=>{
        $48a85ad21da8d504$var$setOrientation(grid, s[g]);
        grid.quadrants.forEach((quadrant, q)=>{
            $48a85ad21da8d504$var$setOrientation(quadrant, s[g].quadrants[q]);
            quadrant.subgrids.forEach((subgrid, i)=>$48a85ad21da8d504$var$setOrientation(subgrid, s[g].quadrants[q].subgrids[i]));
        });
    });
    return true;
};


const $7d75cbd0e5d3963f$export$5f5aeb422b27882 = new (0, $eb0b4d1e13e36536$export$390f32400eaf98c9)({
    ...(0, $860afe5c90b07ab1$export$c83f6fa500e2ab35),
    rot: 0,
    grids: (0, $48a85ad21da8d504$export$b52c0673261d89c0)(),
    solution: [],
    isRevealing: false,
    isCelebrating: false
});


var $b978e13b4d0699c2$exports = {};
$b978e13b4d0699c2$exports = import.meta.resolve("gE6Lu");



const $c630c49660f21e0b$var$UltrarubigramPreview = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "previewTile puzzleTile",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
            className: "ultrarubigramPreview",
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                    className: "puzzleTitle",
                    children: "Ultrarubigram"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                    className: "previewImageContainer",
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                            className: "rubigramIcon",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b978e13b4d0699c2$exports)))
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)((0, $dfe57487a50a7465$export$2e2bcd8739ae039), {
                            store: (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882)
                        })
                    ]
                })
            ]
        })
    });
};
var $c630c49660f21e0b$export$2e2bcd8739ae039 = $c630c49660f21e0b$var$UltrarubigramPreview;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");



const $01d05596dd530619$export$9e774c7f63a1a494 = new (0, $eb0b4d1e13e36536$export$390f32400eaf98c9)({
    ...(0, $860afe5c90b07ab1$export$c83f6fa500e2ab35),
    completed: false,
    author: '',
    cryptic: false,
    clues: [],
    guesses: [],
    revealedCells: [],
    mistakes: [],
    toolbar: {
        almostThereIsOpen: false,
        aboutIsOpen: false,
        clearIsOpen: false,
        checkIsOpen: false,
        revealIsOpen: false,
        combinedIsOpen: false,
        confirmationDialog: {
            clearAllIsOpen: false,
            checkLetterIsOpen: false,
            checkWordIsOpen: false,
            checkPuzzleIsOpen: false,
            autocheckIsOpen: false,
            revealLetterIsOpen: false,
            revealWordIsOpen: false,
            revealAllIsOpen: false
        }
    },
    focusedClueIndex: 0,
    cursorIndex: 0,
    autocheckOn: false
});


var $71be1746f9d9a0d8$exports = {};
$71be1746f9d9a0d8$exports = import.meta.resolve("bmyEV");



const $49a2ea573645c529$var$MorphologyPreview = ({ onClick: onClick })=>{
    const puzzleData = (0, $e2662af8a2ab1f76$export$986181c251d527c3).useState((s)=>s.puzzleData?.morphology);
    if (!puzzleData) return null;
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "previewTile puzzleTile",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
            className: "morphologyPreview",
            children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "shadedContainer",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "puzzleTitle",
                        children: puzzleData.cryptic ? 'Cryptic Morphology' : 'Morphology'
                    }),
                    puzzleData.themeless && /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "nextPuzzleNote",
                        children: "(Themeless)"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                        className: "morphologyIcon",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($71be1746f9d9a0d8$exports)))
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "authorInfo",
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "byline",
                                children: "By"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "author",
                                children: puzzleData.author || 'Anonymous'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $dfe57487a50a7465$export$2e2bcd8739ae039), {
                        store: (0, $01d05596dd530619$export$9e774c7f63a1a494)
                    })
                ]
            })
        })
    });
};
var $49a2ea573645c529$export$2e2bcd8739ae039 = $49a2ea573645c529$var$MorphologyPreview;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");



const $56703c0bbcb0049a$export$91b909e95a7f5fb0 = (puzzleSize)=>Array.from({
        length: puzzleSize
    }, ()=>Array(puzzleSize).fill(0));
const $56703c0bbcb0049a$export$557a6027eb88d4ac = new (0, $eb0b4d1e13e36536$export$390f32400eaf98c9)({
    ...(0, $860afe5c90b07ab1$export$c83f6fa500e2ab35),
    path: $56703c0bbcb0049a$export$91b909e95a7f5fb0(4),
    lines: {},
    highlights: $56703c0bbcb0049a$export$91b909e95a7f5fb0(4),
    pathLength: 0,
    pathHead: null,
    successAnimationGrid: $56703c0bbcb0049a$export$91b909e95a7f5fb0(4),
    puzzleSize: 4,
    vowelMatrix: [],
    cluetext: [],
    solutionPath: [],
    solutionLines: {},
    almostThereIsOpen: false,
    hintLetters: [],
    enabledHints: [
        0,
        2
    ],
    initialEnabledHints: 2,
    hintPositions: {},
    hintsUsed: 0
});


var $387cc6ad1e5ed9a7$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($387cc6ad1e5ed9a7$exports, "__esModule", {
    value: true
});
$387cc6ad1e5ed9a7$exports.default = void 0;

var $387cc6ad1e5ed9a7$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $387cc6ad1e5ed9a7$var$_default = $387cc6ad1e5ed9a7$exports.default = (0, $387cc6ad1e5ed9a7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');



const $ab2d7c331ac9ed33$var$PathwordPreview = ({ onClick: onClick })=>{
    const pathwordData = (0, $e2662af8a2ab1f76$export$986181c251d527c3).useState((s)=>s.puzzleData?.pathword);
    if (!pathwordData) return null;
    const matrix = pathwordData.vowelMatrix;
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "previewTile puzzleTile",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "puzzleTitle",
                children: "Pathword"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "matrixPreviewContainer",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "matrixGrid",
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "goldStar",
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($387cc6ad1e5ed9a7$exports))), {})
                            }),
                            matrix.map((row, rowIndex)=>/*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                    className: "matrixRow",
                                    children: row.map((letter, columnIndex)=>/*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: `previewGridCell ${letter ? '' : 'grey'}`
                                        }, columnIndex))
                                }, rowIndex))
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $dfe57487a50a7465$export$2e2bcd8739ae039), {
                        store: (0, $56703c0bbcb0049a$export$557a6027eb88d4ac)
                    })
                ]
            })
        ]
    });
};
var $ab2d7c331ac9ed33$export$2e2bcd8739ae039 = $ab2d7c331ac9ed33$var$PathwordPreview;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");




const $86b89eb84cf821a4$export$681392899cda0e6d = new (0, $eb0b4d1e13e36536$export$390f32400eaf98c9)({
    ...(0, $860afe5c90b07ab1$export$c83f6fa500e2ab35),
    revealed: false,
    path: (0, $56703c0bbcb0049a$export$91b909e95a7f5fb0)(5),
    lines: {},
    highlights: (0, $56703c0bbcb0049a$export$91b909e95a7f5fb0)(5),
    pathLength: 0,
    pathHead: null,
    successAnimationGrid: (0, $56703c0bbcb0049a$export$91b909e95a7f5fb0)(5),
    puzzleSize: 5,
    cluetext: [],
    vowelMatrix: [],
    solutionPath: [],
    solutionLines: {},
    almostThereIsOpen: false,
    hintLetters: [],
    enabledHints: [
        0,
        2,
        4,
        6
    ],
    initialEnabledHints: 4,
    hintPositions: {},
    hintsUsed: 0
});




const $9f7ca08643bb5ba0$var$Pathword5x5Preview = ({ onClick: onClick })=>{
    const pathword5x5Data = (0, $e2662af8a2ab1f76$export$986181c251d527c3).useState((s)=>s.puzzleData?.pathword5x5);
    if (!pathword5x5Data) return null;
    const matrix = pathword5x5Data.vowelMatrix;
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "previewTile puzzleTile",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "puzzleTitle",
                children: "Pathword 5x5"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "matrixPreviewContainer",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "matrixGrid",
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "goldStar",
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($387cc6ad1e5ed9a7$exports))), {})
                            }),
                            matrix.map((row, rowIndex)=>/*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                    className: "matrixRow",
                                    children: row.map((letter, columnIndex)=>/*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: `previewGridCell ${letter ? '' : 'grey'}`
                                        }, columnIndex))
                                }, rowIndex))
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $dfe57487a50a7465$export$2e2bcd8739ae039), {
                        store: (0, $86b89eb84cf821a4$export$681392899cda0e6d)
                    })
                ]
            })
        ]
    });
};
var $9f7ca08643bb5ba0$export$2e2bcd8739ae039 = $9f7ca08643bb5ba0$var$Pathword5x5Preview;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");
var $7fc94dda4c6e1726$exports = {};
$7fc94dda4c6e1726$exports = import.meta.resolve("duM0h");





const $e27327853171b943$export$e2e5b62534c2c783 = new (0, $eb0b4d1e13e36536$export$390f32400eaf98c9)({
    ...(0, $860afe5c90b07ab1$export$c83f6fa500e2ab35),
    activeSubgrid: 0,
    degreesRotated: 0,
    subgrids: Array(4).fill({
        content: [],
        displayContent: [],
        solvedContent: [],
        flippedHorizontally: false,
        flippedVertically: false,
        degreesRotated: 0,
        isInFlippingAnimation: false
    })
});


const $298bb54ea0e6e5d7$var$RubigramPreview = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "previewTile puzzleTile",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
            className: "rubigramPreview",
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                    className: "puzzleTitle",
                    children: "Rubigram"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                    className: "previewImageContainer",
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                            className: "rubigramIcon",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($7fc94dda4c6e1726$exports)))
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)((0, $dfe57487a50a7465$export$2e2bcd8739ae039), {
                            store: (0, $e27327853171b943$export$e2e5b62534c2c783)
                        })
                    ]
                })
            ]
        })
    });
};
var $298bb54ea0e6e5d7$export$2e2bcd8739ae039 = $298bb54ea0e6e5d7$var$RubigramPreview;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");
var $0e9ddd7f17249ecb$exports = {};
$0e9ddd7f17249ecb$exports = import.meta.resolve("aTADv");





const $1c52cfe25bc28425$export$cbdad2c51fe016e8 = new (0, $eb0b4d1e13e36536$export$390f32400eaf98c9)({
    ...(0, $860afe5c90b07ab1$export$c83f6fa500e2ab35),
    solution: '',
    fragments: [],
    fragmentsWith1PositionRevealed: [],
    fullWords: [],
    obscureSolutions: [],
    positionLifeline: '',
    guess: [],
    numInputs: 3,
    wrongGuess: false,
    usedPositionLifeline: false,
    usedLetterLifeline: false,
    used5050Lifeline: false,
    lettersFor5050: ''
});


const $cba12a45944077d0$var$TriwordPreview = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "previewTile puzzleTile",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
            className: "triwordPreview",
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                    className: "puzzleTitle",
                    children: "Triword"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                    className: "imageContainer",
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                            className: "rubigramIcon",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($0e9ddd7f17249ecb$exports)))
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)((0, $dfe57487a50a7465$export$2e2bcd8739ae039), {
                            store: (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8)
                        })
                    ]
                })
            ]
        })
    });
};
var $cba12a45944077d0$export$2e2bcd8739ae039 = $cba12a45944077d0$var$TriwordPreview;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");
var $1acf395fe1735988$exports = {};
$1acf395fe1735988$exports = import.meta.resolve("dxki4");





const $abbcacd8f9b8e7dd$export$5aa98d4d531c155f = new (0, $eb0b4d1e13e36536$export$390f32400eaf98c9)({
    ...(0, $860afe5c90b07ab1$export$c83f6fa500e2ab35),
    slots: [],
    statements: [],
    solution: [],
    solutionColors: []
});


const $e9963b52e0110b99$var$TruthsortingPreview = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "previewTile puzzleTile truthsortingPreview",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
            className: "truthsortingPreview",
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                    className: "puzzleTitle",
                    children: "Truthsorting"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                    className: "previewImageContainer",
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                            className: "truthsortingIcon",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($1acf395fe1735988$exports)))
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)((0, $dfe57487a50a7465$export$2e2bcd8739ae039), {
                            store: (0, $abbcacd8f9b8e7dd$export$5aa98d4d531c155f)
                        })
                    ]
                })
            ]
        })
    });
};
var $e9963b52e0110b99$export$2e2bcd8739ae039 = $e9963b52e0110b99$var$TruthsortingPreview;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

const $99d23830c821d20c$var$WeeklyWisdom = ()=>{
    const weeklyWisdom = (0, $e2662af8a2ab1f76$export$986181c251d527c3).useState((s)=>s.featureData?.weeklyWisdom);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "previewTile",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "featureTitle",
                children: "Weekly Wisdom"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "weeklyWisdom",
                children: weeklyWisdom
            })
        ]
    });
};
var $99d23830c821d20c$export$2e2bcd8739ae039 = $99d23830c821d20c$var$WeeklyWisdom;



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");



const $b0b4e75d7ad64c40$var$completelySynonyms = [
    "Totally",
    "Fully",
    "Entirely",
    "Absolutely",
    "Thoroughly",
    "Utterly",
    "Altogether",
    "Wholly",
    "Perfectly",
    "Downright",
    "Unquestionably",
    "Indisputably",
    "Flat-Out",
    "One Hundred Percent",
    "All The Way",
    "Every Bit",
    "Comprehensively",
    "Exhaustively",
    "Categorically",
    "Truly",
    "Genuinely",
    "Legitimately",
    "Veritably",
    "Definitely",
    "Positively",
    "Certainly",
    "Undoubtedly",
    "Seriously",
    "Straight-Up",
    "Beyond A Doubt",
    "In Every Way",
    "Without A Doubt",
    "Irrefutably",
    "Authentically",
    "Verifiably",
    "Demonstrably",
    "Palpably",
    "Obviously",
    "Clearly",
    "Evidently",
    "Manifestly",
    "Plainly",
    "Undeniably",
    "Unmistakably",
    "Visibly",
    "Apparently",
    "Supposedly",
    "Allegedly",
    "Practically",
    "Virtually",
    "Effectively",
    "Basically",
    "Essentially",
    "Fundamentally",
    "Primarily",
    "Chiefly",
    "Mostly",
    "Largely",
    "Predominantly",
    "Properly",
    "Really",
    "Very",
    "Mega",
    "Super",
    "Extra",
    "Madly",
    "Insanely",
    "Ridiculously",
    "Absurdly",
    "Wildly",
    "Bonkers",
    "Stone-Cold",
    "Spot On",
    "Bang On",
    "A Hundred Percent",
    "Probably",
    "Rumored To Be",
    "Statistically Likely To Be"
];
const $b0b4e75d7ad64c40$var$zodiacSigns = [
    'Aries',
    'Taurus',
    'Gemini',
    'Cancer',
    'Leo',
    'Virgo',
    'Libra',
    'Scorpio',
    'Sagittarius',
    'Capricorn',
    'Aquarius',
    'Pisces'
];
// outside of the function so it doesn't change on re-render, but does change on page reload
const $b0b4e75d7ad64c40$var$randomValue = Math.random();
const $b0b4e75d7ad64c40$var$Horoscopes = ()=>{
    const horoscopeMessages = (0, $e2662af8a2ab1f76$export$986181c251d527c3).useState((s)=>s.featureData?.horoscopes) || {};
    const randomSynonym = $b0b4e75d7ad64c40$var$completelySynonyms[Math.floor($b0b4e75d7ad64c40$var$randomValue * $b0b4e75d7ad64c40$var$completelySynonyms.length)];
    // Try to get the saved sign from the cookie, default to 'Aries' if not found
    const initialSign = (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).get('selectedHoroscopeSign') || 'Aries';
    const [selectedSign, setSelectedSign] = (0, $28UcW.useState)(initialSign);
    const [horoscope, setHoroscope] = (0, $28UcW.useState)(horoscopeMessages[initialSign]);
    (0, $28UcW.useEffect)(()=>{
        setHoroscope(horoscopeMessages[selectedSign]);
        (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).set('selectedHoroscopeSign', selectedSign, {
            expires: 365
        });
    }, [
        selectedSign,
        horoscopeMessages
    ]);
    const handleSignChange = (event)=>{
        setSelectedSign(event.target.value);
    };
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "previewTile",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "featureTitle",
                children: [
                    randomSynonym,
                    " Authentic Horoscopes"
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "horoscopeContainer",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "horoscopeMessage",
                        children: horoscope
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "signSelector",
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)("select", {
                            id: "sign-dropdown",
                            value: selectedSign,
                            onChange: handleSignChange,
                            children: $b0b4e75d7ad64c40$var$zodiacSigns.map((sign)=>/*#__PURE__*/ (0, $4XrX4.jsx)("option", {
                                    value: sign,
                                    children: sign
                                }, sign))
                        })
                    })
                ]
            })
        ]
    });
};
var $b0b4e75d7ad64c40$export$2e2bcd8739ae039 = $b0b4e75d7ad64c40$var$Horoscopes;


var $5efceb0aaa795c49$export$2e2bcd8739ae039 = (0, $b0b4e75d7ad64c40$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

const $12100aaba36bb6dc$var$Schedule = ()=>{
    const navigate = (0, $6e00b7bb3feca34a$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "previewTile",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "featureTitle",
                children: "Puzzle Schedule"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "scheduleItem",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "scheduleName",
                        children: "Megarubigram:"
                    }),
                    " Tues & Fri"
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "scheduleItem",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "scheduleName",
                        children: "Pathword 5x5:"
                    }),
                    " Tues & Fri"
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "scheduleItem",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "scheduleName",
                        children: "Ultrarubigram:"
                    }),
                    " 1st of the month"
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "scheduleItem",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "scheduleName",
                        children: "All others:"
                    }),
                    " Daily"
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "lastScheduleItem",
                children: "Puzzles update at midnight EST."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "scheduleFootnote",
                children: [
                    "Morphology originally ran from September 2025 through the end of July 2026, and the daily Morphologies now are re-runs from that period. A longer post discussing why it ended is available ",
                    /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                        href: "/on-ending-morphology",
                        onClick: (e)=>{
                            // keep the href for styling / open-in-new-tab, but navigate via the
                            // SPA router on normal clicks to avoid a full-page reload
                            if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
                            e.preventDefault();
                            navigate('/on-ending-morphology');
                            window.scrollTo(0, 0);
                        },
                        children: "here"
                    }),
                    "."
                ]
            })
        ]
    });
};
var $12100aaba36bb6dc$export$2e2bcd8739ae039 = $12100aaba36bb6dc$var$Schedule;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");
const $4239ffb7a316a9c3$var$Announcement = ()=>{
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "previewTile",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "featureTitle",
                children: "Has Science Gone Too Far?"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "announcement",
                children: [
                    "Megarubigram lovers rejoice: The ",
                    /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                        href: "/ultrarubigram",
                        children: "Ultrarubigram"
                    }),
                    " lives. Due to its Herculean difficulty, this puzzle will only run once a month."
                ]
            })
        ]
    });
};
var $4239ffb7a316a9c3$export$2e2bcd8739ae039 = $4239ffb7a316a9c3$var$Announcement;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");
var $e718436fdce67331$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($e718436fdce67331$exports, "__esModule", {
    value: true
});
$e718436fdce67331$exports.default = void 0;

var $e718436fdce67331$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $e718436fdce67331$var$_default = $e718436fdce67331$exports.default = (0, $e718436fdce67331$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), 'OpenInNew');


const $211fe3ac40b3cd74$var$JigsawHaikuLink = ()=>{
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "previewTile",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "featureTitle",
                children: "Jigsaw Haiku"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "announcement",
                style: {
                    textAlign: 'center'
                },
                children: [
                    "Check out our other puzzle ",
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("a", {
                        target: "_blank",
                        href: "https://jigsawhaiku.com",
                        children: [
                            "Jigsaw Haiku",
                            /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e718436fdce67331$exports))), {
                                className: "externalLinkIcon"
                            })
                        ]
                    }),
                    ", which has its own site."
                ]
            })
        ]
    });
};
var $211fe3ac40b3cd74$export$2e2bcd8739ae039 = $211fe3ac40b3cd74$var$JigsawHaikuLink;




const $22de8cbcfbfb06db$var$showAnnouncement = true;
const $22de8cbcfbfb06db$var$MainContentGrid = ()=>{
    const navigate = (0, $6e00b7bb3feca34a$export$9770f232ac06a008)();
    (0, $ba1e3b359abf28ef$export$5b0326dddadcb0de)(null);
    const goTo = (url)=>{
        return ()=>{
            navigate(url);
            window.scrollTo(0, 0);
        };
    };
    let layout = (0, $ba1e3b359abf28ef$export$d76ab4527b141253)();
    if (layout === 1) return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "mainContentGrid threeColumns",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "column",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $ab2d7c331ac9ed33$export$2e2bcd8739ae039), {
                        onClick: goTo('/pathword')
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $99d23830c821d20c$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $cba12a45944077d0$export$2e2bcd8739ae039), {
                        onClick: goTo('/triword')
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $9f7ca08643bb5ba0$export$2e2bcd8739ae039), {
                        onClick: goTo('/pathword5x5')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "columnSeparator"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "column",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $49a2ea573645c529$export$2e2bcd8739ae039), {
                        onClick: goTo('/morphology')
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "previewTile",
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "featureTitle",
                                children: "Want the Baffle in Your Pocket?"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: "announcement",
                                style: {
                                    textAlign: 'center'
                                },
                                children: [
                                    "Mobile app free for both ",
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                        href: "https://apps.apple.com/app/id6755982312",
                                        children: "iOS"
                                    }),
                                    " and ",
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                        href: "https://play.google.com/store/apps/details?id=com.dailybaffle.mobile",
                                        children: "Android"
                                    }),
                                    "!"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $df94b7a5d05b54eb$export$2e2bcd8739ae039), {
                        onClick: goTo('/arithmeglyphs')
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $12100aaba36bb6dc$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $c630c49660f21e0b$export$2e2bcd8739ae039), {
                        onClick: goTo('/ultrarubigram')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "columnSeparator"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "column",
                children: [
                    $22de8cbcfbfb06db$var$showAnnouncement && /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $4239ffb7a316a9c3$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                                className: "tileSeparator"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $e9963b52e0110b99$export$2e2bcd8739ae039), {
                        onClick: goTo('/truthsorting')
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $211fe3ac40b3cd74$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $298bb54ea0e6e5d7$export$2e2bcd8739ae039), {
                        onClick: goTo('/rubigram')
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $5efceb0aaa795c49$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $289b62f3bac83dc5$export$2e2bcd8739ae039), {
                        onClick: goTo('/megarubigram')
                    })
                ]
            })
        ]
    });
    else if (layout === 2) return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "mainContentGrid twoColumns",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "column",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $ab2d7c331ac9ed33$export$2e2bcd8739ae039), {
                        onClick: goTo('/pathword')
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $99d23830c821d20c$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $cba12a45944077d0$export$2e2bcd8739ae039), {
                        onClick: goTo('/triword')
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $298bb54ea0e6e5d7$export$2e2bcd8739ae039), {
                        onClick: goTo('/rubigram')
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $9f7ca08643bb5ba0$export$2e2bcd8739ae039), {
                        onClick: goTo('/pathword5x5')
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $c630c49660f21e0b$export$2e2bcd8739ae039), {
                        onClick: goTo('/ultrarubigram')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "columnSeparator"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "column",
                children: [
                    $22de8cbcfbfb06db$var$showAnnouncement && /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $4239ffb7a316a9c3$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                                className: "tileSeparator"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $49a2ea573645c529$export$2e2bcd8739ae039), {
                        onClick: goTo('/morphology')
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $211fe3ac40b3cd74$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "previewTile",
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "featureTitle",
                                children: "Want the Baffle in Your Pocket?"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: "announcement",
                                style: {
                                    textAlign: 'center'
                                },
                                children: [
                                    "Mobile app free for both ",
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                        href: "https://apps.apple.com/app/id6755982312",
                                        children: "iOS"
                                    }),
                                    " and ",
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                        href: "https://play.google.com/store/apps/details?id=com.dailybaffle.mobile",
                                        children: "Android"
                                    }),
                                    "!"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $e9963b52e0110b99$export$2e2bcd8739ae039), {
                        onClick: goTo('/truthsorting')
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $df94b7a5d05b54eb$export$2e2bcd8739ae039), {
                        onClick: goTo('/arithmeglyphs')
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $5efceb0aaa795c49$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $289b62f3bac83dc5$export$2e2bcd8739ae039), {
                        onClick: goTo('/megarubigram')
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                        className: "tileSeparator"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $12100aaba36bb6dc$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
    else return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "mainContentGrid oneColumn",
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
            className: "column",
            children: [
                $22de8cbcfbfb06db$var$showAnnouncement && /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsx)((0, $4239ffb7a316a9c3$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                            className: "tileSeparator"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $49a2ea573645c529$export$2e2bcd8739ae039), {
                    onClick: goTo('/morphology')
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                    className: "tileSeparator"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $e9963b52e0110b99$export$2e2bcd8739ae039), {
                    onClick: goTo('/truthsorting')
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                    className: "tileSeparator"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $211fe3ac40b3cd74$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                    className: "tileSeparator"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                    className: "previewTile",
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                            className: "featureTitle",
                            children: "Want the Baffle in Your Pocket?"
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                            className: "announcement",
                            style: {
                                textAlign: 'center'
                            },
                            children: [
                                "Mobile app free for both ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                    href: "https://apps.apple.com/app/id6755982312",
                                    children: "iOS"
                                }),
                                " and ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                    href: "https://play.google.com/store/apps/details?id=com.dailybaffle.mobile",
                                    children: "Android"
                                }),
                                "!"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                    className: "tileSeparator"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $ab2d7c331ac9ed33$export$2e2bcd8739ae039), {
                    onClick: goTo('/pathword')
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                    className: "tileSeparator"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $99d23830c821d20c$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                    className: "tileSeparator"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $cba12a45944077d0$export$2e2bcd8739ae039), {
                    onClick: goTo('/triword')
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                    className: "tileSeparator"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $298bb54ea0e6e5d7$export$2e2bcd8739ae039), {
                    onClick: goTo('/rubigram')
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                    className: "tileSeparator"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $df94b7a5d05b54eb$export$2e2bcd8739ae039), {
                    onClick: goTo('/arithmeglyphs')
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                    className: "tileSeparator"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $5efceb0aaa795c49$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                    className: "tileSeparator"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $9f7ca08643bb5ba0$export$2e2bcd8739ae039), {
                    onClick: goTo('/pathword5x5')
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                    className: "tileSeparator"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $289b62f3bac83dc5$export$2e2bcd8739ae039), {
                    onClick: goTo('/megarubigram')
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                    className: "tileSeparator"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $c630c49660f21e0b$export$2e2bcd8739ae039), {
                    onClick: goTo('/ultrarubigram')
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                    className: "tileSeparator"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $12100aaba36bb6dc$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $22de8cbcfbfb06db$export$2e2bcd8739ae039 = $22de8cbcfbfb06db$var$MainContentGrid;


var $2ca58842a47d438a$export$2e2bcd8739ae039 = (0, $22de8cbcfbfb06db$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");
var $d872a2807693457d$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($d872a2807693457d$exports, "__esModule", {
    value: true
});
$d872a2807693457d$exports.default = void 0;

var $d872a2807693457d$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $d872a2807693457d$var$_default = $d872a2807693457d$exports.default = (0, $d872a2807693457d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H7.07L2.4 12l4.66-7H22zm-11.59-2L14 13.41 17.59 17 19 15.59 15.41 12 19 8.41 17.59 7 14 10.59 10.41 7 9 8.41 12.59 12 9 15.59z"
}), 'BackspaceOutlined');
















const $6a94dce2910e1181$export$f4312d14943ef1a6 = new (0, $eb0b4d1e13e36536$export$390f32400eaf98c9)({
    ...(0, $860afe5c90b07ab1$export$c83f6fa500e2ab35),
    cursorLocation: [
        0,
        0
    ],
    guessWords: [],
    prompt: '',
    cluePhrase: '',
    numAlteredLetters: 0,
    solution: '',
    solutionAsCharArrays: []
});







const $5672f12342c56f70$export$2060161a50430d7e = (numHints)=>{
    const hintMaps = {
        0: [],
        1: [
            0
        ],
        2: [
            0,
            2
        ]
    };
    return hintMaps[numHints] ?? [
        0,
        2
    ]; // default to 2 if invalid
};
const $5672f12342c56f70$export$46f43f842bb402d = (numHints)=>{
    const hintMaps = {
        0: [],
        1: [
            0
        ],
        2: [
            0,
            2
        ],
        3: [
            0,
            2,
            4
        ],
        4: [
            0,
            2,
            4,
            6
        ]
    };
    return hintMaps[numHints] ?? [
        0,
        2,
        4,
        6
    ]; // default to 4 if invalid
};
const $5672f12342c56f70$export$eecbc5d1befeaaf0 = (path)=>{
    // Find the matrix dimensions
    const maxRow = Math.max(...path.map(([r, _])=>r));
    const maxCol = Math.max(...path.map(([_, c])=>c));
    // Initialize matrix with zeros
    const matrix = Array.from({
        length: maxRow + 1
    }, ()=>Array(maxCol + 1).fill(0));
    // Fill the matrix with the step numbers
    path.forEach(([row, col], index)=>{
        matrix[row][col] = index + 1;
    });
    return matrix;
};
const $5672f12342c56f70$export$254a14737628d90f = (solutionPath, hintLetters)=>{
    const hintPositions = {};
    hintLetters.forEach((hintIndex)=>{
        // solutionPath is 0-indexed array, so position at index hintIndex is what we want
        const [row, col] = solutionPath[hintIndex];
        hintPositions[`${row}_${col}`] = hintIndex;
    });
    return hintPositions;
};
const $5672f12342c56f70$export$8fc1e0a9d795944b = [
    [
        -1,
        -1
    ],
    [
        -1,
        0
    ],
    [
        -1,
        1
    ],
    [
        0,
        -1
    ],
    [
        0,
        1
    ],
    [
        1,
        -1
    ],
    [
        1,
        0
    ],
    [
        1,
        1
    ]
];
const $5672f12342c56f70$export$39f6b94519bfc80 = (puzzleData, numDefaultHints = 2)=>{
    (0, $56703c0bbcb0049a$export$557a6027eb88d4ac).update((s)=>{
        s.puzzleId = puzzleData.puzzleId;
        s.cluetext = puzzleData.cluetext;
        s.vowelMatrix = puzzleData.vowelMatrix;
        s.solutionPath = $5672f12342c56f70$export$eecbc5d1befeaaf0(puzzleData.solutionPath);
        s.solutionLines = $5672f12342c56f70$export$f649d9377c5250d0(s.solutionPath);
        s.hintLetters = puzzleData.hintLetters;
        s.hintPositions = $5672f12342c56f70$export$254a14737628d90f(puzzleData.solutionPath, puzzleData.hintLetters);
        s.enabledHints = $5672f12342c56f70$export$2060161a50430d7e(numDefaultHints);
        s.initialEnabledHints = numDefaultHints;
    });
};
const $5672f12342c56f70$export$7cf2f68092532300 = ()=>{
    (0, $56703c0bbcb0049a$export$557a6027eb88d4ac).update((s)=>{
        clearInterval(s.timerUpdatingFn);
        s.highlights = (0, $56703c0bbcb0049a$export$91b909e95a7f5fb0)(4);
        s.revealed = true;
        s.isPaused = false;
        (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword, {
            puzzleId: s.puzzleId,
            revealed: true,
            solved: false,
            time: s.time
        });
    });
};
const $5672f12342c56f70$export$4e3bdb6fc7af2ff8 = ()=>{
    const { time: time, timerUpdatingFn: timerUpdatingFn, puzzleId: puzzleId } = (0, $56703c0bbcb0049a$export$557a6027eb88d4ac).getRawState();
    // This puzzle has a lengthy success animation, and we delay setting solved=true
    // until after it's done, in the setTimeout below.
    // Since the pause functionality doesn't stop the timer until the puzzle is marked solved,
    // we stop it here immediately as a courtesy, before the success animation finishes.
    clearInterval(timerUpdatingFn);
    setTimeout(()=>{
        (0, $56703c0bbcb0049a$export$557a6027eb88d4ac).update((s)=>{
            s.statsDialogIsOpen = true;
            s.solved = true;
        });
    }, (0, $860afe5c90b07ab1$export$87a8383fc3f35723));
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword, {
        puzzleId: puzzleId,
        revealed: false,
        solved: true,
        time: time
    });
};
const $5672f12342c56f70$export$868183fcaa7ce9d2 = ()=>{
    const { solved: solved, revealed: revealed, time: time, puzzleId: puzzleId } = (0, $56703c0bbcb0049a$export$557a6027eb88d4ac).getRawState();
    if (solved || revealed) return;
    // just updating progress on pause or navigate away
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword, {
        puzzleId: puzzleId,
        revealed: revealed,
        solved: solved,
        time: time
    });
};
const $5672f12342c56f70$export$7b1141f0065c1d17 = (letter)=>{
    return 'aeiouy'.includes(letter);
};
const $5672f12342c56f70$var$getRelativePositionOfCells = (currentCell, otherCell)=>{
    const [rowCurr, colCurr] = currentCell;
    const [rowOther, colOther] = otherCell;
    if (rowOther < rowCurr) {
        if (colOther < colCurr) return 'topLeft';
        if (colOther > colCurr) return 'topRight';
        return 'top';
    }
    if (rowOther > rowCurr) {
        if (colOther < colCurr) return 'bottomLeft';
        if (colOther > colCurr) return 'bottomRight';
        return 'bottom';
    }
    if (colOther < colCurr) return 'left';
    if (colOther > colCurr) return 'right';
    // This case should not be reached if the otherCell is not the same as currentCell
    return '';
};
const $5672f12342c56f70$var$getClassesForCell = (currentCell, previousCell, nextCell)=>{
    let classList = '';
    if (previousCell) {
        const relativePosition = $5672f12342c56f70$var$getRelativePositionOfCells(currentCell, previousCell);
        classList += `${relativePosition}B `;
    }
    if (nextCell) {
        const relativePosition = $5672f12342c56f70$var$getRelativePositionOfCells(currentCell, nextCell);
        classList += `${relativePosition}A`;
    }
    return classList.trim();
};
const $5672f12342c56f70$export$f649d9377c5250d0 = (path)=>{
    let pathIndexLocations = {};
    let highestIndex = -Infinity;
    for(let row = 0; row < path.length; row++)for(let col = 0; col < path[row].length; col++){
        const cellValue = path[row][col];
        if (cellValue > 0) {
            highestIndex = Math.max(highestIndex, cellValue);
            pathIndexLocations[cellValue] = [
                row,
                col
            ];
        }
    }
    if (highestIndex < 2) return {};
    const lineClasses = {};
    for(let i = highestIndex; i > 0; i--){
        if (i === highestIndex) // find position relative to i - 1
        // only A (for ::after)
        lineClasses[i] = $5672f12342c56f70$var$getClassesForCell(pathIndexLocations[i], pathIndexLocations[i - 1], null);
        else if (i === 1) // find position relative to i + 1
        // only B (for ::before)
        lineClasses[i] = $5672f12342c56f70$var$getClassesForCell(pathIndexLocations[i], null, pathIndexLocations[i + 1]);
        else // find position relative to i + 1 AND i - 1
        // A and B (::after and ::before)
        lineClasses[i] = $5672f12342c56f70$var$getClassesForCell(pathIndexLocations[i], pathIndexLocations[i - 1], pathIndexLocations[i + 1]);
    }
    return lineClasses;
};
const $5672f12342c56f70$export$7f7c305e30d5967e = (pos1, pos2)=>{
    return pos1[0] === pos2[0] && pos1[1] === pos2[1];
};
const $5672f12342c56f70$export$27c72763f7f1cbe3 = (pos1, pos2)=>{
    const [row1, col1] = pos1;
    const [row2, col2] = pos2;
    const rowDistance = Math.abs(row1 - row2);
    const colDistance = Math.abs(col1 - col2);
    return rowDistance <= 1 && colDistance <= 1 && rowDistance + colDistance !== 0;
};
const $5672f12342c56f70$export$d37972fdbaa5a361 = (letter, row, col, vowelMatrix)=>{
    return $5672f12342c56f70$export$7b1141f0065c1d17(letter) !== (vowelMatrix[row][col] === 0);
};
const $5672f12342c56f70$export$63d4c81b4cbc0024 = (row, col, nextLetter, path, puzzleSize, vowelMatrix, hintPositions, hintLetters, enabledHints, cluetext, pathLength)=>{
    const highlights = (0, $56703c0bbcb0049a$export$91b909e95a7f5fb0)(puzzleSize);
    // Build a map of enabled hint positions to their required path indices: {row_col: pathIndex}
    const enabledHintMap = {};
    Object.entries(hintPositions).forEach(([posKey, hintIndex])=>{
        const hintLetterPosition = hintLetters.indexOf(hintIndex);
        const isEnabled = hintLetterPosition !== -1 && enabledHints.includes(hintLetterPosition);
        if (isEnabled) enabledHintMap[posKey] = hintIndex;
    });
    // Check if nextLetter is an enabled hint letter (at current path position)
    const nextLetterHintIndex = hintLetters.indexOf(pathLength);
    const nextLetterIsEnabledHint = nextLetterHintIndex !== -1 && enabledHints.includes(nextLetterHintIndex);
    if (nextLetterIsEnabledHint) {
        // Next letter IS an enabled hint - ONLY highlight its designated cell if adjacent
        for (const [posKey, hintIndex] of Object.entries(enabledHintMap))if (hintIndex === pathLength) {
            const [r, c] = posKey.split('_').map(Number);
            const rowDistance = Math.abs(r - row);
            const colDistance = Math.abs(c - col);
            const isAdjacent = rowDistance <= 1 && colDistance <= 1 && rowDistance + colDistance !== 0;
            if (isAdjacent && path[r][c] === 0) highlights[r][c] = 1;
            break;
        }
        return highlights; // Don't highlight any other cells
    }
    // Otherwise, use normal highlighting logic but exclude enabled hint positions
    $5672f12342c56f70$export$8fc1e0a9d795944b.forEach((direction)=>{
        const newRow = row + direction[0];
        const newCol = col + direction[1];
        // out of bounds
        if (newRow < 0 || newCol < 0 || newRow > puzzleSize - 1 || newCol > puzzleSize - 1) return;
        // already filled
        if (path[newRow][newCol] > 0) return;
        // Skip this cell if it has an enabled hint preview
        const posKey = `${newRow}_${newCol}`;
        if (enabledHintMap[posKey]) return;
        const neighborSquareIsVowel = vowelMatrix[newRow][newCol] === 0;
        const nextLetterIsVowel = 'aeiouy'.includes(nextLetter);
        // if neighbor cell matches the consonant/vowel requirement for the next letter,
        // highlight it
        if (neighborSquareIsVowel === nextLetterIsVowel) highlights[newRow][newCol] = 1;
    });
    return highlights;
};
const $5672f12342c56f70$export$99823ce229395b16 = (s)=>{
    s.path = (0, $56703c0bbcb0049a$export$91b909e95a7f5fb0)(4);
    s.lines = {};
    s.highlights = (0, $56703c0bbcb0049a$export$91b909e95a7f5fb0)(4);
    s.pathLength = 0;
    s.pathHead = null;
    s.successAnimationGrid = (0, $56703c0bbcb0049a$export$91b909e95a7f5fb0)(4);
};







const $862bdcea3eeac9b6$export$47aaa92647edceb7 = (puzzleData, numDefaultHints = 4)=>{
    (0, $86b89eb84cf821a4$export$681392899cda0e6d).update((s)=>{
        s.puzzleId = puzzleData.puzzleId;
        s.cluetext = puzzleData.cluetext;
        s.vowelMatrix = puzzleData.vowelMatrix;
        s.solutionPath = (0, $5672f12342c56f70$export$eecbc5d1befeaaf0)(puzzleData.solutionPath);
        s.solutionLines = (0, $5672f12342c56f70$export$f649d9377c5250d0)(s.solutionPath);
        s.hintLetters = puzzleData.hintLetters;
        s.hintPositions = (0, $5672f12342c56f70$export$254a14737628d90f)(puzzleData.solutionPath, puzzleData.hintLetters);
        s.enabledHints = (0, $5672f12342c56f70$export$46f43f842bb402d)(numDefaultHints);
        s.initialEnabledHints = numDefaultHints;
    });
};
const $862bdcea3eeac9b6$export$7cf2f68092532300 = ()=>{
    (0, $86b89eb84cf821a4$export$681392899cda0e6d).update((s)=>{
        clearInterval(s.timerUpdatingFn);
        s.highlights = (0, $56703c0bbcb0049a$export$91b909e95a7f5fb0)(5);
        s.revealed = true;
        s.isPaused = false;
        (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword5x5, {
            puzzleId: s.puzzleId,
            revealed: true,
            solved: false,
            time: s.time
        });
    });
};
const $862bdcea3eeac9b6$export$4e3bdb6fc7af2ff8 = ()=>{
    const { time: time, timerUpdatingFn: timerUpdatingFn, puzzleId: puzzleId } = (0, $86b89eb84cf821a4$export$681392899cda0e6d).getRawState();
    // This puzzle has a lengthy success animation, and we delay setting solved=true
    // until after it's done, in the setTimeout below.
    // Since the pause functionality doesn't stop the timer until the puzzle is marked solved,
    // we stop it here immediately as a courtesy, before the success animation finishes.
    clearInterval(timerUpdatingFn);
    setTimeout(()=>{
        (0, $86b89eb84cf821a4$export$681392899cda0e6d).update((s)=>{
            s.statsDialogIsOpen = true;
            s.solved = true;
        });
    }, (0, $860afe5c90b07ab1$export$87a8383fc3f35723));
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword5x5, {
        puzzleId: puzzleId,
        revealed: false,
        solved: true,
        time: time
    });
};
const $862bdcea3eeac9b6$export$621a0561ab81bb49 = ()=>{
    const { solved: solved, revealed: revealed, time: time, puzzleId: puzzleId } = (0, $86b89eb84cf821a4$export$681392899cda0e6d).getRawState();
    if (solved || revealed) return;
    // just updating progress on pause or navigate away
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword5x5, {
        puzzleId: puzzleId,
        revealed: revealed,
        solved: solved,
        time: time
    });
};
const $862bdcea3eeac9b6$export$3abe0514b238bb90 = (s)=>{
    s.path = (0, $56703c0bbcb0049a$export$91b909e95a7f5fb0)(5);
    s.lines = {};
    s.highlights = (0, $56703c0bbcb0049a$export$91b909e95a7f5fb0)(5);
    s.pathLength = 0;
    s.pathHead = null;
    s.successAnimationGrid = (0, $56703c0bbcb0049a$export$91b909e95a7f5fb0)(5);
};





const $741cdd5d8fe36d3f$export$435569523fbdf788 = async (puzzleName, puzzleState)=>{
    try {
        if (puzzleName === (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Morphology || puzzleName === (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Arithmeglyphs) {
            if (puzzleState.completed) {
                $0d3747952a05ae22$export$6b2a7d5132615086(`${puzzleName}_completed`);
                if (puzzleState.revealed) $0d3747952a05ae22$export$6b2a7d5132615086(`${puzzleName}_revealed`);
            }
        } else {
            if (puzzleState.solved) $0d3747952a05ae22$export$6b2a7d5132615086(`${puzzleName}_solved`);
            else if (puzzleState.revealed) $0d3747952a05ae22$export$6b2a7d5132615086(`${puzzleName}_revealed`);
        }
    } catch (error) {}
    // Track puzzle solve in backend analytics (for both logged-in and logged-out users)
    if (puzzleState.solved) try {
        await (0, $ea74087fd5ac399e$export$2e2bcd8739ae039).post('/api/analytics/track-puzzle-solve', {
            puzzleName: puzzleName,
            source: 'web'
        });
    } catch (error) {
    // Fail silently - analytics shouldn't break the app
    }
    const auth = (0, $de660e99e3126d7c$export$ae1af26003f05816)();
    const authToken = await auth.currentUser?.getIdToken(true);
    if (authToken) // we're logged in, so send update to server to save in mongo
    try {
        const { data: newStats } = await (0, $ea74087fd5ac399e$export$2e2bcd8739ae039).post('/api/users/update-progress', {
            authToken: authToken,
            puzzleName: puzzleName,
            puzzleState: puzzleState
        });
        (0, $e2662af8a2ab1f76$export$986181c251d527c3).update((s)=>{
            s.userData.stats[puzzleName] = newStats;
        });
    } catch (error) {
    // unable to save
    }
    else {
        // we're not logged in, so just save in localStorage
        const localStorage1 = window.localStorage;
        localStorage1.setItem(puzzleName, JSON.stringify(puzzleState));
    }
};
const $741cdd5d8fe36d3f$export$fc0d4ecb266a6322 = (puzzleName, puzzleIds)=>{
    const raw = localStorage.getItem(puzzleName);
    const parsed = JSON.parse(raw ?? '{}');
    // temporary while truthsortingV1 is being deprecated; full removal pending
    puzzleIds[(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Truthsorting] = puzzleIds['truthsortingV2'];
    if (parsed.puzzleId !== puzzleIds[puzzleName]) {
        localStorage.removeItem(puzzleName);
        return null;
    }
    return parsed;
};
const $741cdd5d8fe36d3f$export$d230f8554682469c = ()=>{
    const allStates = {};
    Object.values((0, $860afe5c90b07ab1$export$3e1d53562ebc9131)).forEach((puzzleName)=>{
        const raw = localStorage.getItem(puzzleName);
        const parsed = JSON.parse(raw ?? '{}');
        allStates[puzzleName] = parsed;
    });
    return allStates;
};
const $741cdd5d8fe36d3f$export$9a3c3183a7548a58 = (puzzleIds)=>{
    (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
        const saved = $741cdd5d8fe36d3f$export$fc0d4ecb266a6322((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Arithmeglyphs, puzzleIds);
        // Set default values
        s.time = 0;
        s.solved = false;
        s.revealed = false;
        s.completed = false;
        if (saved) {
            s.time = saved.time || s.time;
            s.solved = saved.solved || s.solved;
            s.revealed = saved.revealed || s.revealed;
            s.completed = saved.completed || s.completed;
            // If there was no saved state it's fine because initArithmeglyphs sets this
            // up with the correct defaults to begin with, and that would be called
            // when the data is loaded or reloaded on page load or logout.
            if (saved.partialState?.dataByLine) {
                const d = saved.partialState.dataByLine;
                s.dataByLine.forEach((line, i)=>{
                    line.guesses = d[i].guesses || line.guesses;
                    line.revealedCells = d[i].revealedCells || line.revealedCells;
                });
            }
        }
    });
    (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((s)=>{
        const saved = $741cdd5d8fe36d3f$export$fc0d4ecb266a6322((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Ultrarubigram, puzzleIds);
        // Set default values
        s.time = 0;
        s.solved = false;
        s.revealed = false;
        s.rot = 0;
        s.isRevealing = false;
        (0, $48a85ad21da8d504$export$39ef76c8a466c6a7)(s.grids);
        if (saved) {
            s.time = saved.time || s.time;
            s.solved = saved.solved || s.solved;
            s.revealed = saved.revealed || s.revealed;
            if (saved.partialState && (0, $48a85ad21da8d504$export$50709009735b417)(s.grids, saved.partialState.grids)) s.rot = saved.partialState.rot || 0;
        }
    });
    (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).update((s)=>{
        const saved = $741cdd5d8fe36d3f$export$fc0d4ecb266a6322((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Megarubigram, puzzleIds);
        // Set default values
        s.time = 0;
        s.solved = false;
        s.revealed = false;
        s.degreesRotated = 0;
        if (saved) {
            s.time = saved.time || s.time;
            s.solved = saved.solved || s.solved;
            s.revealed = saved.revealed || s.revealed;
            s.degreesRotated = saved.partialState?.degreesRotated || s.degreesRotated;
            s.grids = saved.partialState?.grids || s.grids;
        }
    });
    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
        const saved = $741cdd5d8fe36d3f$export$fc0d4ecb266a6322((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Morphology, puzzleIds);
        // Set default values
        s.time = 0;
        s.solved = false;
        s.revealed = false;
        s.completed = false;
        s.guesses = s.clues.map((clue)=>Array(clue.solution.length).fill(null));
        s.revealedCells = s.clues.map((clue)=>Array(clue.solution.length).fill(false));
        s.mistakes = s.clues.map((clue)=>Array(clue.solution.length).fill(false));
        // If a saved state exists, override defaults with saved data
        if (saved) {
            s.time = saved.time || s.time;
            s.solved = saved.solved || s.solved;
            s.revealed = saved.revealed || s.revealed;
            s.completed = saved.completed || s.completed;
            s.guesses = saved.partialState?.guesses || s.guesses;
            s.revealedCells = saved.partialState?.revealedCells || s.revealedCells;
            s.mistakes = saved.partialState?.mistakes || s.mistakes;
        }
    });
    (0, $56703c0bbcb0049a$export$557a6027eb88d4ac).update((s)=>{
        const saved = $741cdd5d8fe36d3f$export$fc0d4ecb266a6322((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword, puzzleIds);
        // Set default values
        s.time = 0;
        s.solved = false;
        s.revealed = false;
        (0, $5672f12342c56f70$export$99823ce229395b16)(s);
        if (saved) {
            s.time = saved.time || s.time;
            s.solved = saved.solved || s.solved;
            s.revealed = saved.revealed || s.revealed;
        }
    });
    (0, $86b89eb84cf821a4$export$681392899cda0e6d).update((s)=>{
        const saved = $741cdd5d8fe36d3f$export$fc0d4ecb266a6322((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword5x5, puzzleIds);
        // Set default values
        s.time = 0;
        s.solved = false;
        s.revealed = false;
        (0, $862bdcea3eeac9b6$export$3abe0514b238bb90)(s);
        if (saved) {
            s.time = saved.time || s.time;
            s.solved = saved.solved || s.solved;
            s.revealed = saved.revealed || s.revealed;
        }
    });
    (0, $e27327853171b943$export$e2e5b62534c2c783).update((s)=>{
        const saved = $741cdd5d8fe36d3f$export$fc0d4ecb266a6322((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Rubigram, puzzleIds);
        // Set default values
        s.time = 0;
        s.solved = false;
        s.revealed = false;
        if (saved) {
            s.time = saved.time || s.time;
            s.solved = saved.solved || s.solved;
            s.revealed = saved.revealed || s.revealed;
        }
    });
    (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).update((s)=>{
        const saved = $741cdd5d8fe36d3f$export$fc0d4ecb266a6322((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Triword, puzzleIds);
        // Set default values
        s.time = 0;
        s.solved = false;
        s.revealed = false;
        s.used5050Lifeline = false;
        s.usedLetterLifeline = false;
        s.usedPositionLifeline = false;
        if (saved) {
            s.time = saved.time || s.time;
            s.solved = saved.solved || s.solved;
            s.revealed = saved.revealed || s.revealed;
            s.used5050Lifeline = saved.partialState?.used5050Lifeline || s.used5050Lifeline;
            s.usedLetterLifeline = saved.partialState?.usedLetterLifeline || s.usedLetterLifeline;
            s.usedPositionLifeline = saved.partialState?.usedPositionLifeline || s.usedPositionLifeline;
        }
    });
    (0, $abbcacd8f9b8e7dd$export$5aa98d4d531c155f).update((s)=>{
        const saved = $741cdd5d8fe36d3f$export$fc0d4ecb266a6322((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Truthsorting, puzzleIds);
        // Set default values
        s.time = 0;
        s.solved = false;
        s.revealed = false;
        if (saved) {
            s.time = saved.time || s.time;
            s.solved = saved.solved || s.solved;
            s.revealed = saved.revealed || s.revealed;
        }
    });
    (0, $6a94dce2910e1181$export$f4312d14943ef1a6).update((s)=>{
        const saved = $741cdd5d8fe36d3f$export$fc0d4ecb266a6322((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).VaryClove, puzzleIds);
        // Set default values
        s.time = 0;
        s.solved = false;
        s.revealed = false;
        if (saved) {
            s.time = saved.time || s.time;
            s.solved = saved.solved || s.solved;
            s.revealed = saved.revealed || s.revealed;
        }
    });
};
const $741cdd5d8fe36d3f$var$archiveMorphologyKey = (puzzleId)=>`morphologyArchive-${puzzleId}`;
const $741cdd5d8fe36d3f$export$79f2c3ac7689272c = (state)=>{
    try {
        localStorage.setItem($741cdd5d8fe36d3f$var$archiveMorphologyKey(state.puzzleId), JSON.stringify(state));
    } catch (error) {
    // localStorage may be full or unavailable; saving progress is best-effort.
    }
};
const $741cdd5d8fe36d3f$export$fc9c2a865d055fed = (puzzleId)=>{
    const raw = localStorage.getItem($741cdd5d8fe36d3f$var$archiveMorphologyKey(puzzleId));
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch (error) {
        localStorage.removeItem($741cdd5d8fe36d3f$var$archiveMorphologyKey(puzzleId));
        return null;
    }
};
const $741cdd5d8fe36d3f$export$b1266f401cdd8344 = (puzzleId)=>{
    localStorage.removeItem($741cdd5d8fe36d3f$var$archiveMorphologyKey(puzzleId));
};





const $8a5badd6ef6136ba$export$e82b76dc89ff0f64 = ()=>{
    const { time: time, revealed: revealed, puzzleId: puzzleId } = (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).getRawState();
    setTimeout(()=>{
        (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
            s.statsDialogIsOpen = true;
        });
    }, (0, $860afe5c90b07ab1$export$87a8383fc3f35723));
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Arithmeglyphs, {
        puzzleId: puzzleId,
        revealed: revealed,
        solved: !revealed,
        time: time,
        completed: true,
        partialState: null
    });
};
const $8a5badd6ef6136ba$export$a020a0ba86fc9904 = ()=>{
    const { solved: solved, revealed: revealed, completed: completed, time: time, dataByLine: dataByLine, puzzleId: puzzleId } = (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).getRawState();
    // just updating progress on pause or navigate away
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Arithmeglyphs, {
        puzzleId: puzzleId,
        revealed: revealed,
        solved: solved,
        time: time,
        completed: completed,
        partialState: completed ? null : {
            dataByLine: dataByLine.map((line)=>({
                    guesses: line.guesses,
                    revealedCells: line.revealedCells
                })),
            timeOfLastUpdate: new Date().toISOString()
        }
    });
};
const $8a5badd6ef6136ba$export$9afb3e602442910f = (puzzleData)=>{
    (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
        s.puzzleId = puzzleData.puzzleId;
        s.dataByLine = [
            {
                guesses: Array(puzzleData.line1_numSeq.length).fill(null),
                opSeq: puzzleData.line1_opSeq,
                numSeq: puzzleData.line1_numSeq,
                revealedCells: Array(puzzleData.line1_numSeq.length).fill(false),
                mistakes: Array(puzzleData.line1_numSeq.length).fill(false)
            },
            {
                guesses: Array(puzzleData.line2_numSeq.length).fill(null),
                opSeq: puzzleData.line2_opSeq,
                numSeq: puzzleData.line2_numSeq,
                revealedCells: Array(puzzleData.line1_numSeq.length).fill(false),
                mistakes: Array(puzzleData.line1_numSeq.length).fill(false)
            }
        ];
        s.thirdLineNumSeq = puzzleData.line3_numSeq;
    });
};
var $8a5badd6ef6136ba$export$105770301816d0f9 = /*#__PURE__*/ function(ConfirmationTypes) {
    ConfirmationTypes["CheckGlyph"] = "CheckGlyph";
    ConfirmationTypes["CheckPuzzle"] = "CheckPuzzle";
    ConfirmationTypes["RevealGlyph"] = "RevealGlyph";
    ConfirmationTypes["RevealPuzzle"] = "RevealPuzzle";
    return ConfirmationTypes;
}({});
const $8a5badd6ef6136ba$var$isCompleted = (dataByLine)=>{
    const firstLine = dataByLine[0];
    let complete = true;
    firstLine.numSeq.split('').forEach((solutionDigit, i)=>{
        if (firstLine.revealedCells[i]) return;
        if (firstLine.guesses[i] !== solutionDigit) complete = false;
    });
    return complete;
};
const $8a5badd6ef6136ba$export$a9ce59cabf26964d = ()=>{
    const { focusLocation: { lineNumber: lineNumber, index: index }, dataByLine: dataByLine } = (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).getRawState();
    const guess = dataByLine[lineNumber].guesses[index];
    const solution = dataByLine[lineNumber].numSeq[index];
    if (guess === null) return;
    if (dataByLine[lineNumber].revealedCells[index]) return;
    (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
        s.revealed = true;
        if (guess === solution) {
            s.dataByLine[lineNumber].revealedCells[index] = true;
            setTimeout(()=>$8a5badd6ef6136ba$export$dd9ed606ccdb03d3((0, $ba1e3b359abf28ef$export$cd903283095ece83).Tab, false), 50);
        } else s.dataByLine[lineNumber].mistakes[index] = true;
    });
};
const $8a5badd6ef6136ba$export$ed0314765beb2ba1 = ()=>{
    const { dataByLine: dataByLine } = (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).getRawState();
    (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
        s.revealed = true;
        dataByLine.forEach((line, lineNumber)=>{
            line.guesses.forEach((guess, index)=>{
                const solution = line.numSeq[index];
                if (guess === null) return;
                if (s.dataByLine[lineNumber].revealedCells[index]) return;
                if (guess === solution) s.dataByLine[lineNumber].revealedCells[index] = true;
                else s.dataByLine[lineNumber].mistakes[index] = true;
            });
        });
    });
};
const $8a5badd6ef6136ba$export$853a3f346cd0e68f = ()=>{
    (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
        const { lineNumber: lineNumber, index: index } = s.focusLocation;
        s.dataByLine[lineNumber].revealedCells[index] = true;
        s.dataByLine[lineNumber].mistakes[index] = false;
        s.revealed = true;
        if ($8a5badd6ef6136ba$var$isCompleted(s.dataByLine)) {
            s.completed = true;
            setTimeout($8a5badd6ef6136ba$export$e82b76dc89ff0f64, 100);
        } else // move cursor to next unrevealed cell
        // it's in a setTimeout cuz we're updating store from inside a store update
        setTimeout(()=>$8a5badd6ef6136ba$export$dd9ed606ccdb03d3((0, $ba1e3b359abf28ef$export$cd903283095ece83).Tab, false), 50);
    });
};
const $8a5badd6ef6136ba$export$48a1b615b62a793 = ()=>{
    (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
        s.revealed = true;
        s.completed = true;
        s.dataByLine.forEach((line)=>{
            line.revealedCells.fill(true);
            line.mistakes.fill(false);
        });
    });
    setTimeout($8a5badd6ef6136ba$export$e82b76dc89ff0f64, 100);
};
const $8a5badd6ef6136ba$export$dd9ed606ccdb03d3 = (key, shift)=>{
    const { focusLocation: focusLocation, dataByLine: dataByLine } = (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).getRawState();
    const { lineNumber: lineNumber, index: index } = focusLocation;
    const line0Length = dataByLine[0].numSeq.length;
    const line1Length = dataByLine[1].numSeq.length;
    let isAtEndOfLine = index === dataByLine[lineNumber].numSeq.length - 1;
    const differenceInLineLengths = line1Length - line0Length;
    const upDownIndexOffset = Math.max(differenceInLineLengths - 1, 0);
    let newIndex = index;
    let newLineNumber = lineNumber;
    if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).Tab) {
        if (shift) do {
            if (newIndex > 0) newIndex--;
            else if (newLineNumber === 1) {
                newLineNumber = 0;
                newIndex = line0Length - 1;
            } else {
                newLineNumber = 1;
                newIndex = line1Length - 1;
            }
        }while (dataByLine[newLineNumber].revealedCells[newIndex]);
        else do {
            if (!isAtEndOfLine) newIndex++;
            else if (newLineNumber === 0) {
                newLineNumber = 1;
                newIndex = 0;
            } else if (newLineNumber === 1) {
                newLineNumber = 0;
                newIndex = 0;
            }
            isAtEndOfLine = newIndex === dataByLine[newLineNumber].numSeq.length - 1;
        }while (dataByLine[newLineNumber].revealedCells[newIndex]);
    }
    if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).ArrowUp) {
        if (lineNumber === 0) return;
        else {
            newLineNumber = 0;
            newIndex = Math.max(index - upDownIndexOffset, 0);
            if (newIndex > line0Length - 1) newIndex = line0Length - 1;
        }
    }
    if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).ArrowDown) {
        if (lineNumber === 1) return;
        else {
            newLineNumber = 1;
            newIndex = Math.min(index + upDownIndexOffset, line1Length - 1);
        }
    }
    if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).ArrowRight) {
        if (!isAtEndOfLine) newIndex++;
    }
    if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).ArrowLeft) {
        if (index !== 0) newIndex--;
    }
    (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
        s.focusLocation = {
            lineNumber: newLineNumber,
            index: newIndex
        };
    });
};
const $8a5badd6ef6136ba$export$412508d679148d5c = (key, shift)=>{
    const { focusLocation: { lineNumber: lineNumber, index: index }, completed: completed } = (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).getRawState();
    if (completed) return;
    if (/^[0-9]$/.test(key)) {
        if (key === '0' && $8a5badd6ef6136ba$export$9ce465357ac65a4b({
            lineNumber: lineNumber,
            index: index
        })) {
            alert('Zeroes are not allowed on the first line or in circle operators.');
            return;
        }
        (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
            // if this cell was revealed, just move cursor to next open cell
            if (s.dataByLine[lineNumber].revealedCells[index]) {
                setTimeout(()=>$8a5badd6ef6136ba$export$dd9ed606ccdb03d3((0, $ba1e3b359abf28ef$export$cd903283095ece83).Tab, false), 50);
                return;
            }
            // clear out mistake marker (from Check Glyph/Puzzle) on change
            s.dataByLine[lineNumber].mistakes[index] = false;
            s.dataByLine[lineNumber].guesses[index] = key;
            if ($8a5badd6ef6136ba$var$isCompleted(s.dataByLine)) {
                s.completed = true;
                if (!s.revealed) s.solved = true;
                $8a5badd6ef6136ba$export$e82b76dc89ff0f64();
            } else setTimeout(()=>$8a5badd6ef6136ba$export$dd9ed606ccdb03d3((0, $ba1e3b359abf28ef$export$cd903283095ece83).Tab, false), 50);
        });
    } else if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).Delete) (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
        const currentGlyphIsBlank = !s.dataByLine[lineNumber].guesses[index];
        if (currentGlyphIsBlank && index > 0) {
            s.focusLocation.index = index - 1;
            s.dataByLine[lineNumber].guesses[index - 1] = null;
        } else s.dataByLine[lineNumber].guesses[index] = null;
    });
    else if (key in (0, $ba1e3b359abf28ef$export$cd903283095ece83)) $8a5badd6ef6136ba$export$dd9ed606ccdb03d3(key, shift);
};
const $8a5badd6ef6136ba$export$9b2690a4578612b0 = (confirmationType)=>{
    const { revealed: revealed, completed: completed } = (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).getRawState();
    if (completed) return;
    switch(confirmationType){
        case "CheckGlyph":
            if (revealed) $8a5badd6ef6136ba$export$a9ce59cabf26964d();
            else (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
                s.confirmationDialogs.checkGlyphIsOpen = true;
                s.isSoftPaused = true;
            });
            break;
        case "CheckPuzzle":
            if (revealed) $8a5badd6ef6136ba$export$ed0314765beb2ba1();
            else (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
                s.confirmationDialogs.checkPuzzleIsOpen = true;
                s.isSoftPaused = true;
            });
            break;
        case "RevealGlyph":
            if (revealed) $8a5badd6ef6136ba$export$853a3f346cd0e68f();
            else (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
                s.confirmationDialogs.revealGlyphIsOpen = true;
                s.isSoftPaused = true;
            });
            break;
        case "RevealPuzzle":
            // always confirm this, even if it's already marked Revealed
            (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
                s.confirmationDialogs.revealPuzzleIsOpen = true;
                s.isSoftPaused = true;
            });
            break;
    }
};
const $8a5badd6ef6136ba$export$9ce465357ac65a4b = (focusLocation)=>{
    const { lineNumber: lineNumber, index: index } = focusLocation;
    if (lineNumber === 0) return true;
    const opString = (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).getRawState().dataByLine[lineNumber].opSeq;
    const opArray = opString.replace(/[^\w\s]/g, '').split(/\s+/).filter((word)=>word.length > 0);
    return opArray[index] === 'circle';
};



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

const $59c03ac8b4308fa0$var$IndividualGlyph = ({ glyphType: glyphType, index: index, lineNumber: lineNumber })=>{
    const { completed: completed, solved: solved, focusLocation: focusLocation, dataByLine: dataByLine } = (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).useState();
    const isFocused = !completed && lineNumber === focusLocation.lineNumber && index === focusLocation.index;
    const isRevealed = dataByLine[lineNumber].revealedCells[index];
    const isMistake = dataByLine[lineNumber].mistakes[index];
    const guess = dataByLine[lineNumber].guesses[index];
    const solution = dataByLine[lineNumber].numSeq[index];
    const onClick = ()=>{
        if (isRevealed) return;
        (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
            s.focusLocation = {
                lineNumber: lineNumber,
                index: index
            };
        });
    };
    const glyphClasses = `individualGlyph ${glyphType}Glyph ${solved ? 'solved' : ''}`;
    const inputClasses = `inputSquare ${isFocused ? 'focused' : ''} ${isMistake ? 'mistake' : ''} ${isRevealed ? 'revealed' : ''}`;
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        onClick: onClick,
        className: glyphClasses,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "shapeDisplay"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: inputClasses,
                children: completed || isRevealed ? solution : guess
            })
        ]
    });
};
var $59c03ac8b4308fa0$export$2e2bcd8739ae039 = $59c03ac8b4308fa0$var$IndividualGlyph;


var $9c50a17e4d3104e7$export$934328b60ccab05f = /*#__PURE__*/ function(GlyphType) {
    GlyphType["Triangle"] = "triangle";
    GlyphType["Square"] = "square";
    GlyphType["Diamond"] = "diamond";
    GlyphType["Dot"] = "dot";
    GlyphType["Circle"] = "circle";
    GlyphType["Noop"] = "noop";
    return GlyphType;
}({});
const $9c50a17e4d3104e7$var$getMarkupForGlyphs = (glyphString, lineNumber)=>{
    const glyphSections = glyphString.split(/(\([^)]+\))/).map((s)=>s.trim()).filter(Boolean);
    let glyphIndex = 0;
    return glyphSections.flatMap((section, i1)=>{
        const isSumBlock = section.startsWith('(');
        const glyphsForSection = section.slice(isSumBlock ? 1 : 0, isSumBlock ? -1 : undefined) // slice off the parens if needed
        .split(' ').map((glyph, i2)=>/*#__PURE__*/ (0, $4XrX4.jsx)((0, $59c03ac8b4308fa0$export$2e2bcd8739ae039), {
                glyphType: glyph,
                index: glyphIndex++,
                lineNumber: lineNumber
            }, `${i1}-${i2}`));
        return isSumBlock ? /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
            className: "sumblock",
            children: glyphsForSection
        }, i1) : glyphsForSection;
    });
};
const $9c50a17e4d3104e7$var$GlyphSequence = ({ glyphString: glyphString, lineNumber: lineNumber })=>{
    const glyphMarkup = $9c50a17e4d3104e7$var$getMarkupForGlyphs(glyphString, lineNumber);
    // Remove parens and then just count the operators/glyphs/whatever.
    // This is so we can scale long lines down slightly to fit better on mobile devices.
    const glyphCount = glyphString.replace(/[\(\)]/g, '').trim().split(/\s+/).length;
    const classes = [
        'glyphSequence'
    ];
    if (glyphCount === 8) classes.push('eightOperators');
    if (glyphCount === 9) classes.push('nineOperators');
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: classes.join(' '),
        children: glyphMarkup
    });
};
var $9c50a17e4d3104e7$export$2e2bcd8739ae039 = $9c50a17e4d3104e7$var$GlyphSequence;




var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");


const $e3bc772a91268443$var$PauseCover = ({ store: store, useCompleted: useCompleted, completed: completed })=>{
    const showPauseCover = (0, $ba1e3b359abf28ef$export$ce579a2cfd1aa062)(store, useCompleted, completed);
    const unpause = ()=>{
        store.update((s)=>{
            s.isPaused = false;
        });
    };
    if (!showPauseCover) return null;
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "pauseCover",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "pausedNotice",
                children: "(Paused)"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "pausedPrompt",
                children: "Ready to continue?"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                className: "continueButton",
                onClick: unpause,
                children: "Resume"
            })
        ]
    });
};
var $e3bc772a91268443$export$2e2bcd8739ae039 = $e3bc772a91268443$var$PauseCover;


var $b9f68b54b1083b27$export$2e2bcd8739ae039 = (0, $e3bc772a91268443$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");


var $1fz9F = parcelRequire("1fz9F");

var $aMDDU = parcelRequire("aMDDU");

var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");

var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");



var $1fz9F = parcelRequire("1fz9F");

var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");

var $28UcW = parcelRequire("28UcW");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $1eea032f836dcbb1$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $39cf289415cf806e$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $28UcW.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $1eea032f836dcbb1$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


'use client';
var $7d57efcdf4f58771$export$2e2bcd8739ae039 = (0, $39cf289415cf806e$export$2e2bcd8739ae039);



var $28UcW = parcelRequire("28UcW");

var $28UcW = parcelRequire("28UcW");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $8a0c5c067d762282$var$useEnhancedEffect = typeof window !== 'undefined' ? $28UcW.useLayoutEffect : $28UcW.useEffect;
var $8a0c5c067d762282$export$2e2bcd8739ae039 = $8a0c5c067d762282$var$useEnhancedEffect;


'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $e69ea0a302c22b7c$var$useEventCallback(fn) {
    const ref = $28UcW.useRef(fn);
    (0, $8a0c5c067d762282$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $28UcW.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $e69ea0a302c22b7c$export$2e2bcd8739ae039 = $e69ea0a302c22b7c$var$useEventCallback;


'use client';
var $5d1750c26081ebdf$export$2e2bcd8739ae039 = (0, $e69ea0a302c22b7c$export$2e2bcd8739ae039);



var $28UcW = parcelRequire("28UcW");

var $28UcW = parcelRequire("28UcW");
'use client';
const $fddb777ac7ccc4d3$var$UNINITIALIZED = {};
function $fddb777ac7ccc4d3$export$2e2bcd8739ae039(init, initArg) {
    const ref = $28UcW.useRef($fddb777ac7ccc4d3$var$UNINITIALIZED);
    if (ref.current === $fddb777ac7ccc4d3$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $28UcW = parcelRequire("28UcW");
'use client';
const $e9f5e2a178a578fb$var$EMPTY = [];
function $e9f5e2a178a578fb$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $28UcW.useEffect(fn, $e9f5e2a178a578fb$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $13f25f9c85a15779$export$786b4da70f00938b {
    constructor(){
        this.currentId = 0;
        this.clear = ()=>{
            if (this.currentId !== 0) {
                clearTimeout(this.currentId);
                this.currentId = 0;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $13f25f9c85a15779$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = 0;
            fn();
        }, delay);
    }
}
function $13f25f9c85a15779$export$2e2bcd8739ae039() {
    const timeout = (0, $fddb777ac7ccc4d3$export$2e2bcd8739ae039)($13f25f9c85a15779$export$786b4da70f00938b.create).current;
    (0, $e9f5e2a178a578fb$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


'use client';
let $fe5ba7369240aa74$var$hadKeyboardEvent = true;
let $fe5ba7369240aa74$var$hadFocusVisibleRecently = false;
const $fe5ba7369240aa74$var$hadFocusVisibleRecentlyTimeout = new (0, $13f25f9c85a15779$export$786b4da70f00938b)();
const $fe5ba7369240aa74$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $fe5ba7369240aa74$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $fe5ba7369240aa74$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $fe5ba7369240aa74$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $fe5ba7369240aa74$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $fe5ba7369240aa74$var$handlePointerDown() {
    $fe5ba7369240aa74$var$hadKeyboardEvent = false;
}
function $fe5ba7369240aa74$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($fe5ba7369240aa74$var$hadFocusVisibleRecently) $fe5ba7369240aa74$var$hadKeyboardEvent = true;
    }
}
function $fe5ba7369240aa74$var$prepare(doc) {
    doc.addEventListener('keydown', $fe5ba7369240aa74$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $fe5ba7369240aa74$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $fe5ba7369240aa74$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $fe5ba7369240aa74$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $fe5ba7369240aa74$var$handleVisibilityChange, true);
}
function $fe5ba7369240aa74$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $fe5ba7369240aa74$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $fe5ba7369240aa74$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $fe5ba7369240aa74$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $fe5ba7369240aa74$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $fe5ba7369240aa74$var$handleVisibilityChange, true);
}
function $fe5ba7369240aa74$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $fe5ba7369240aa74$var$hadKeyboardEvent || $fe5ba7369240aa74$var$focusTriggersKeyboardModality(target);
}
function $fe5ba7369240aa74$export$2e2bcd8739ae039() {
    const ref = $28UcW.useCallback((node)=>{
        if (node != null) $fe5ba7369240aa74$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $28UcW.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $fe5ba7369240aa74$var$hadFocusVisibleRecently = true;
            $fe5ba7369240aa74$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $fe5ba7369240aa74$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($fe5ba7369240aa74$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


'use client';
var $647972ce8910968b$export$2e2bcd8739ae039 = (0, $fe5ba7369240aa74$export$2e2bcd8739ae039);



var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $28UcW = parcelRequire("28UcW");


var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");
function $1421cc68d46cf3b0$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $5dfd04a4ade60e6c$export$2e2bcd8739ae039(o, p) {
    $5dfd04a4ade60e6c$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5dfd04a4ade60e6c$export$2e2bcd8739ae039(o, p);
}


function $388ee14e7a40d900$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $5dfd04a4ade60e6c$export$2e2bcd8739ae039)(subClass, superClass);
}




var $28UcW = parcelRequire("28UcW");

var $28UcW = parcelRequire("28UcW");
var $c3d498d38e18cf8a$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($28UcW))).createContext(null);



var $28UcW = parcelRequire("28UcW");
function $408c9b3c41988c03$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $28UcW.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $28UcW.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $408c9b3c41988c03$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $408c9b3c41988c03$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $408c9b3c41988c03$export$fa71e2345c31d7a2(props, onExited) {
    return $408c9b3c41988c03$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $28UcW.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $408c9b3c41988c03$var$getProp(child, 'appear', props),
            enter: $408c9b3c41988c03$var$getProp(child, 'enter', props),
            exit: $408c9b3c41988c03$var$getProp(child, 'exit', props)
        });
    });
}
function $408c9b3c41988c03$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $408c9b3c41988c03$export$bbc8a025727ea824(nextProps.children);
    var children = $408c9b3c41988c03$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $28UcW.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $28UcW.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $28UcW.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $408c9b3c41988c03$var$getProp(child, 'exit', nextProps),
            enter: $408c9b3c41988c03$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $28UcW.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $28UcW.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $28UcW.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $408c9b3c41988c03$var$getProp(child, 'exit', nextProps),
            enter: $408c9b3c41988c03$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $4e2658d873828353$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $4e2658d873828353$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $4e2658d873828353$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $388ee14e7a40d900$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $1421cc68d46cf3b0$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $408c9b3c41988c03$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $408c9b3c41988c03$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $408c9b3c41988c03$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $kLZMq.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $53Ou4.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $4e2658d873828353$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($28UcW))).createElement((0, $c3d498d38e18cf8a$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($28UcW))).createElement((0, $c3d498d38e18cf8a$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($28UcW))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($28UcW))).Component);
$4e2658d873828353$var$TransitionGroup.propTypes = {};
$4e2658d873828353$var$TransitionGroup.defaultProps = $4e2658d873828353$var$defaultProps;
var $4e2658d873828353$export$2e2bcd8739ae039 = $4e2658d873828353$var$TransitionGroup;



var $dP0oo = parcelRequire("dP0oo");

var $3vbO9 = parcelRequire("3vbO9");


var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
function $b6cb2e2585743607$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $28UcW.useState(false);
    const rippleClassName = (0, $dP0oo.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $dP0oo.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $28UcW.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
            className: childClassName
        })
    });
}
var $b6cb2e2585743607$export$2e2bcd8739ae039 = $b6cb2e2585743607$var$Ripple;



var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $544b370a4e90d3a3$export$b464606f735ab902(slot) {
    return (0, $dYzHx.default)('MuiTouchRipple', slot);
}
const $544b370a4e90d3a3$var$touchRippleClasses = (0, $d0ZgE.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $544b370a4e90d3a3$export$2e2bcd8739ae039 = $544b370a4e90d3a3$var$touchRippleClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $d0cc00b1c5e49326$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $d0cc00b1c5e49326$var$_ = (t)=>t, $d0cc00b1c5e49326$var$_t, $d0cc00b1c5e49326$var$_t2, $d0cc00b1c5e49326$var$_t3, $d0cc00b1c5e49326$var$_t4;
const $d0cc00b1c5e49326$var$DURATION = 550;
const $d0cc00b1c5e49326$export$95d0c9356b2231a3 = 80;
const $d0cc00b1c5e49326$var$enterKeyframe = (0, $3vbO9.keyframes)($d0cc00b1c5e49326$var$_t || ($d0cc00b1c5e49326$var$_t = $d0cc00b1c5e49326$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $d0cc00b1c5e49326$var$exitKeyframe = (0, $3vbO9.keyframes)($d0cc00b1c5e49326$var$_t2 || ($d0cc00b1c5e49326$var$_t2 = $d0cc00b1c5e49326$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $d0cc00b1c5e49326$var$pulsateKeyframe = (0, $3vbO9.keyframes)($d0cc00b1c5e49326$var$_t3 || ($d0cc00b1c5e49326$var$_t3 = $d0cc00b1c5e49326$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $d0cc00b1c5e49326$export$f6b7418508c72c25 = (0, $k5hQd.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $d0cc00b1c5e49326$export$676cfe7b12693c4b = (0, $k5hQd.default)((0, $b6cb2e2585743607$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($d0cc00b1c5e49326$var$_t4 || ($d0cc00b1c5e49326$var$_t4 = $d0cc00b1c5e49326$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $544b370a4e90d3a3$export$2e2bcd8739ae039).rippleVisible, $d0cc00b1c5e49326$var$enterKeyframe, $d0cc00b1c5e49326$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $544b370a4e90d3a3$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $544b370a4e90d3a3$export$2e2bcd8739ae039).child, (0, $544b370a4e90d3a3$export$2e2bcd8739ae039).childLeaving, $d0cc00b1c5e49326$var$exitKeyframe, $d0cc00b1c5e49326$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $544b370a4e90d3a3$export$2e2bcd8739ae039).childPulsate, $d0cc00b1c5e49326$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $d0cc00b1c5e49326$var$TouchRipple = /*#__PURE__*/ $28UcW.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $53Ou4.default)(props, $d0cc00b1c5e49326$var$_excluded);
    const [ripples, setRipples] = $28UcW.useState([]);
    const nextKey = $28UcW.useRef(0);
    const rippleCallback = $28UcW.useRef(null);
    $28UcW.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $28UcW.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $13f25f9c85a15779$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $28UcW.useRef(null);
    const container = $28UcW.useRef(null);
    const startCommit = $28UcW.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $4XrX4.jsx)($d0cc00b1c5e49326$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $dP0oo.default)(classes.ripple, (0, $544b370a4e90d3a3$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $dP0oo.default)(classes.rippleVisible, (0, $544b370a4e90d3a3$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $dP0oo.default)(classes.ripplePulsate, (0, $544b370a4e90d3a3$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $dP0oo.default)(classes.child, (0, $544b370a4e90d3a3$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $dP0oo.default)(classes.childLeaving, (0, $544b370a4e90d3a3$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $dP0oo.default)(classes.childPulsate, (0, $544b370a4e90d3a3$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $d0cc00b1c5e49326$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $28UcW.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($d0cc00b1c5e49326$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $28UcW.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $28UcW.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $28UcW.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $4XrX4.jsx)($d0cc00b1c5e49326$export$f6b7418508c72c25, (0, $kLZMq.default)({
        className: (0, $dP0oo.default)((0, $544b370a4e90d3a3$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $4e2658d873828353$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $d0cc00b1c5e49326$export$2e2bcd8739ae039 = $d0cc00b1c5e49326$var$TouchRipple;



var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $30a049bf442b5640$export$fccb0498dcd99783(slot) {
    return (0, $dYzHx.default)('MuiButtonBase', slot);
}
const $30a049bf442b5640$var$buttonBaseClasses = (0, $d0ZgE.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $30a049bf442b5640$export$2e2bcd8739ae039 = $30a049bf442b5640$var$buttonBaseClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $120c91fa1d9b1234$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $120c91fa1d9b1234$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $1fz9F.default)(slots, (0, $30a049bf442b5640$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $120c91fa1d9b1234$export$7ec0dcc5e3cdcd36 = (0, $k5hQd.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $30a049bf442b5640$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $120c91fa1d9b1234$var$ButtonBase = /*#__PURE__*/ $28UcW.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $53Ou4.default)(props, $120c91fa1d9b1234$var$_excluded);
    const buttonRef = $28UcW.useRef(null);
    const rippleRef = $28UcW.useRef(null);
    const handleRippleRef = (0, $7d57efcdf4f58771$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $647972ce8910968b$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $28UcW.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $28UcW.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $28UcW.useState(false);
    $28UcW.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $28UcW.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $5d1750c26081ebdf$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $5d1750c26081ebdf$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $28UcW.useRef(false);
    const handleKeyDown = (0, $5d1750c26081ebdf$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $5d1750c26081ebdf$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $7d57efcdf4f58771$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $kLZMq.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $120c91fa1d9b1234$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)($120c91fa1d9b1234$export$7ec0dcc5e3cdcd36, (0, $kLZMq.default)({
        as: ComponentProp,
        className: (0, $dP0oo.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $4XrX4.jsx)((0, $d0cc00b1c5e49326$export$2e2bcd8739ae039), (0, $kLZMq.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $120c91fa1d9b1234$export$2e2bcd8739ae039 = $120c91fa1d9b1234$var$ButtonBase;



var $1mNk8 = parcelRequire("1mNk8");

var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $da0ff0e7109d4463$export$5e8702d71474f093(slot) {
    return (0, $dYzHx.default)('MuiIconButton', slot);
}
const $da0ff0e7109d4463$var$iconButtonClasses = (0, $d0ZgE.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $da0ff0e7109d4463$export$2e2bcd8739ae039 = $da0ff0e7109d4463$var$iconButtonClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $f714e0f624d6f306$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $f714e0f624d6f306$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $1mNk8.default)(color)}`,
            edge && `edge${(0, $1mNk8.default)(edge)}`,
            `size${(0, $1mNk8.default)(size)}`
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $da0ff0e7109d4463$export$5e8702d71474f093), classes);
};
const $f714e0f624d6f306$var$IconButtonRoot = (0, $k5hQd.default)((0, $120c91fa1d9b1234$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $1mNk8.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $1mNk8.default)(ownerState.edge)}`],
            styles[`size${(0, $1mNk8.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kLZMq.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aMDDU.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $kLZMq.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $kLZMq.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $kLZMq.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aMDDU.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $da0ff0e7109d4463$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $f714e0f624d6f306$var$IconButton = /*#__PURE__*/ $28UcW.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $53Ou4.default)(props, $f714e0f624d6f306$var$_excluded);
    const ownerState = (0, $kLZMq.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $f714e0f624d6f306$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4XrX4.jsx)($f714e0f624d6f306$var$IconButtonRoot, (0, $kLZMq.default)({
        className: (0, $dP0oo.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $f714e0f624d6f306$export$2e2bcd8739ae039 = $f714e0f624d6f306$var$IconButton;


var $98556d5fcc3acbf1$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($98556d5fcc3acbf1$exports, "__esModule", {
    value: true
});
$98556d5fcc3acbf1$exports.default = void 0;

var $98556d5fcc3acbf1$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $98556d5fcc3acbf1$var$_default = $98556d5fcc3acbf1$exports.default = (0, $98556d5fcc3acbf1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M11 18h2v-2h-2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4"
}), 'HelpOutline');


var $1e3ba230a1917794$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($1e3ba230a1917794$exports, "__esModule", {
    value: true
});
$1e3ba230a1917794$exports.default = void 0;

var $1e3ba230a1917794$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $1e3ba230a1917794$var$_default = $1e3ba230a1917794$exports.default = (0, $1e3ba230a1917794$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M10 20h4V4h-4zm-6 0h4v-8H4zM16 9v11h4V9z"
}), 'Equalizer');


var $ba2d2837fc619c75$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($ba2d2837fc619c75$exports, "__esModule", {
    value: true
});
$ba2d2837fc619c75$exports.default = void 0;

var $ba2d2837fc619c75$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $ba2d2837fc619c75$var$_default = $ba2d2837fc619c75$exports.default = (0, $ba2d2837fc619c75$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"
}), 'KeyboardBackspace');


var $be547dbdaf888d8e$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($be547dbdaf888d8e$exports, "__esModule", {
    value: true
});
$be547dbdaf888d8e$exports.default = void 0;

var $be547dbdaf888d8e$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $be547dbdaf888d8e$var$_default = $be547dbdaf888d8e$exports.default = (0, $be547dbdaf888d8e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M6 19h4V5H6zm8-14v14h4V5z"
}), 'Pause');


var $815c4a10c6ca199f$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($815c4a10c6ca199f$exports, "__esModule", {
    value: true
});
$815c4a10c6ca199f$exports.default = void 0;

var $815c4a10c6ca199f$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $815c4a10c6ca199f$var$_default = $815c4a10c6ca199f$exports.default = (0, $815c4a10c6ca199f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M8 5v14l11-7z"
}), 'PlayArrow');


var $b2cd9ecc66d0956f$exports = {};
'use strict';
Object.defineProperty($b2cd9ecc66d0956f$exports, '__esModule', {
    value: true
});
function $b2cd9ecc66d0956f$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $28UcW = parcelRequire("28UcW");
var $b2cd9ecc66d0956f$var$React__default = $b2cd9ecc66d0956f$var$_interopDefault($28UcW);

var $6t2I5 = parcelRequire("6t2I5");
var $b2cd9ecc66d0956f$var$ClientUAInstance = new $6t2I5();
var $b2cd9ecc66d0956f$var$browser = $b2cd9ecc66d0956f$var$ClientUAInstance.getBrowser();
var $b2cd9ecc66d0956f$var$cpu = $b2cd9ecc66d0956f$var$ClientUAInstance.getCPU();
var $b2cd9ecc66d0956f$var$device = $b2cd9ecc66d0956f$var$ClientUAInstance.getDevice();
var $b2cd9ecc66d0956f$var$engine = $b2cd9ecc66d0956f$var$ClientUAInstance.getEngine();
var $b2cd9ecc66d0956f$var$os = $b2cd9ecc66d0956f$var$ClientUAInstance.getOS();
var $b2cd9ecc66d0956f$var$ua = $b2cd9ecc66d0956f$var$ClientUAInstance.getUA();
var $b2cd9ecc66d0956f$var$setUa = function setUa(userAgentString) {
    return $b2cd9ecc66d0956f$var$ClientUAInstance.setUA(userAgentString);
};
var $b2cd9ecc66d0956f$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error('No userAgent string was provided');
        return;
    }
    var UserAgentInstance = new $6t2I5(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $b2cd9ecc66d0956f$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $b2cd9ecc66d0956f$var$ClientUAInstance,
    browser: $b2cd9ecc66d0956f$var$browser,
    cpu: $b2cd9ecc66d0956f$var$cpu,
    device: $b2cd9ecc66d0956f$var$device,
    engine: $b2cd9ecc66d0956f$var$engine,
    os: $b2cd9ecc66d0956f$var$os,
    ua: $b2cd9ecc66d0956f$var$ua,
    setUa: $b2cd9ecc66d0956f$var$setUa,
    parseUserAgent: $b2cd9ecc66d0956f$var$parseUserAgent
});
function $b2cd9ecc66d0956f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b2cd9ecc66d0956f$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b2cd9ecc66d0956f$var$ownKeys(Object(source), true).forEach(function(key) {
            $b2cd9ecc66d0956f$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b2cd9ecc66d0956f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b2cd9ecc66d0956f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b2cd9ecc66d0956f$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $b2cd9ecc66d0956f$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b2cd9ecc66d0956f$var$_typeof(obj);
}
function $b2cd9ecc66d0956f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b2cd9ecc66d0956f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b2cd9ecc66d0956f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b2cd9ecc66d0956f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b2cd9ecc66d0956f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $b2cd9ecc66d0956f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b2cd9ecc66d0956f$var$_extends() {
    $b2cd9ecc66d0956f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b2cd9ecc66d0956f$var$_extends.apply(this, arguments);
}
function $b2cd9ecc66d0956f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $b2cd9ecc66d0956f$var$_setPrototypeOf(subClass, superClass);
}
function $b2cd9ecc66d0956f$var$_getPrototypeOf(o) {
    $b2cd9ecc66d0956f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b2cd9ecc66d0956f$var$_getPrototypeOf(o);
}
function $b2cd9ecc66d0956f$var$_setPrototypeOf(o, p) {
    $b2cd9ecc66d0956f$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b2cd9ecc66d0956f$var$_setPrototypeOf(o, p);
}
function $b2cd9ecc66d0956f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b2cd9ecc66d0956f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b2cd9ecc66d0956f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b2cd9ecc66d0956f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b2cd9ecc66d0956f$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $b2cd9ecc66d0956f$var$_assertThisInitialized(self);
}
function $b2cd9ecc66d0956f$var$_slicedToArray(arr, i) {
    return $b2cd9ecc66d0956f$var$_arrayWithHoles(arr) || $b2cd9ecc66d0956f$var$_iterableToArrayLimit(arr, i) || $b2cd9ecc66d0956f$var$_unsupportedIterableToArray(arr, i) || $b2cd9ecc66d0956f$var$_nonIterableRest();
}
function $b2cd9ecc66d0956f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b2cd9ecc66d0956f$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b2cd9ecc66d0956f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b2cd9ecc66d0956f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b2cd9ecc66d0956f$var$_arrayLikeToArray(o, minLen);
}
function $b2cd9ecc66d0956f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b2cd9ecc66d0956f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $b2cd9ecc66d0956f$var$DeviceTypes = {
    Mobile: 'mobile',
    Tablet: 'tablet',
    SmartTv: 'smarttv',
    Console: 'console',
    Wearable: 'wearable',
    Embedded: 'embedded',
    Browser: undefined
};
var $b2cd9ecc66d0956f$var$BrowserTypes = {
    Chrome: 'Chrome',
    Firefox: 'Firefox',
    Opera: 'Opera',
    Yandex: 'Yandex',
    Safari: 'Safari',
    InternetExplorer: 'Internet Explorer',
    Edge: 'Edge',
    Chromium: 'Chromium',
    Ie: 'IE',
    MobileSafari: 'Mobile Safari',
    EdgeChromium: 'Edge Chromium',
    MIUI: 'MIUI Browser',
    SamsungBrowser: 'Samsung Browser'
};
var $b2cd9ecc66d0956f$var$OsTypes = {
    IOS: 'iOS',
    Android: 'Android',
    WindowsPhone: 'Windows Phone',
    Windows: 'Windows',
    MAC_OS: 'Mac OS'
};
var $b2cd9ecc66d0956f$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $b2cd9ecc66d0956f$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $b2cd9ecc66d0956f$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $b2cd9ecc66d0956f$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $b2cd9ecc66d0956f$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $b2cd9ecc66d0956f$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $b2cd9ecc66d0956f$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $b2cd9ecc66d0956f$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $b2cd9ecc66d0956f$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $b2cd9ecc66d0956f$var$InitialDeviceTypes;
    }
};
var $b2cd9ecc66d0956f$var$setUserAgent = function setUserAgent(userAgent) {
    return $b2cd9ecc66d0956f$var$setUa(userAgent);
};
var $b2cd9ecc66d0956f$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
    return p ? p : d;
};
var $b2cd9ecc66d0956f$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== 'undefined') {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $b2cd9ecc66d0956f$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $b2cd9ecc66d0956f$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $b2cd9ecc66d0956f$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $b2cd9ecc66d0956f$var$setDefaults(browser.major),
        browserFullVersion: $b2cd9ecc66d0956f$var$setDefaults(browser.version),
        browserName: $b2cd9ecc66d0956f$var$setDefaults(browser.name),
        engineName: $b2cd9ecc66d0956f$var$setDefaults(engine.name),
        engineVersion: $b2cd9ecc66d0956f$var$setDefaults(engine.version),
        osName: $b2cd9ecc66d0956f$var$setDefaults(os.name),
        osVersion: $b2cd9ecc66d0956f$var$setDefaults(os.version),
        userAgent: $b2cd9ecc66d0956f$var$setDefaults(ua)
    };
};
var $b2cd9ecc66d0956f$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $b2cd9ecc66d0956f$var$_objectSpread2({}, type, {
        vendor: $b2cd9ecc66d0956f$var$setDefaults(device.vendor),
        model: $b2cd9ecc66d0956f$var$setDefaults(device.model),
        os: $b2cd9ecc66d0956f$var$setDefaults(os.name),
        osVersion: $b2cd9ecc66d0956f$var$setDefaults(os.version),
        ua: $b2cd9ecc66d0956f$var$setDefaults(ua)
    });
};
var $b2cd9ecc66d0956f$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $b2cd9ecc66d0956f$var$setDefaults(engine.name),
        engineVersion: $b2cd9ecc66d0956f$var$setDefaults(engine.version),
        osName: $b2cd9ecc66d0956f$var$setDefaults(os.name),
        osVersion: $b2cd9ecc66d0956f$var$setDefaults(os.version),
        userAgent: $b2cd9ecc66d0956f$var$setDefaults(ua)
    };
};
var $b2cd9ecc66d0956f$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $b2cd9ecc66d0956f$var$setDefaults(engine.name),
        engineVersion: $b2cd9ecc66d0956f$var$setDefaults(engine.version),
        osName: $b2cd9ecc66d0956f$var$setDefaults(os.name),
        osVersion: $b2cd9ecc66d0956f$var$setDefaults(os.version),
        userAgent: $b2cd9ecc66d0956f$var$setDefaults(ua)
    };
};
var $b2cd9ecc66d0956f$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $b2cd9ecc66d0956f$var$setDefaults(engine.name),
        engineVersion: $b2cd9ecc66d0956f$var$setDefaults(engine.version),
        osName: $b2cd9ecc66d0956f$var$setDefaults(os.name),
        osVersion: $b2cd9ecc66d0956f$var$setDefaults(os.version),
        userAgent: $b2cd9ecc66d0956f$var$setDefaults(ua)
    };
};
var $b2cd9ecc66d0956f$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $b2cd9ecc66d0956f$var$setDefaults(device.vendor),
        model: $b2cd9ecc66d0956f$var$setDefaults(device.model),
        engineName: $b2cd9ecc66d0956f$var$setDefaults(engine.name),
        engineVersion: $b2cd9ecc66d0956f$var$setDefaults(engine.version),
        osName: $b2cd9ecc66d0956f$var$setDefaults(os.name),
        osVersion: $b2cd9ecc66d0956f$var$setDefaults(os.version),
        userAgent: $b2cd9ecc66d0956f$var$setDefaults(ua)
    };
};
function $b2cd9ecc66d0956f$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $b2cd9ecc66d0956f$var$parseUserAgent(userAgent) : $b2cd9ecc66d0956f$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $b2cd9ecc66d0956f$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $b2cd9ecc66d0956f$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $b2cd9ecc66d0956f$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $b2cd9ecc66d0956f$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $b2cd9ecc66d0956f$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $b2cd9ecc66d0956f$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $b2cd9ecc66d0956f$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $b2cd9ecc66d0956f$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $b2cd9ecc66d0956f$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $b2cd9ecc66d0956f$var$DeviceTypes.Mobile;
};
var $b2cd9ecc66d0956f$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $b2cd9ecc66d0956f$var$DeviceTypes.Tablet;
};
var $b2cd9ecc66d0956f$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $b2cd9ecc66d0956f$var$DeviceTypes.Mobile || type === $b2cd9ecc66d0956f$var$DeviceTypes.Tablet;
};
var $b2cd9ecc66d0956f$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $b2cd9ecc66d0956f$var$DeviceTypes.SmartTv;
};
var $b2cd9ecc66d0956f$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $b2cd9ecc66d0956f$var$DeviceTypes.Browser;
};
var $b2cd9ecc66d0956f$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $b2cd9ecc66d0956f$var$DeviceTypes.Wearable;
};
var $b2cd9ecc66d0956f$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $b2cd9ecc66d0956f$var$DeviceTypes.Console;
};
var $b2cd9ecc66d0956f$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $b2cd9ecc66d0956f$var$DeviceTypes.Embedded;
};
var $b2cd9ecc66d0956f$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $b2cd9ecc66d0956f$var$setDefaults(vendor);
};
var $b2cd9ecc66d0956f$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $b2cd9ecc66d0956f$var$setDefaults(model);
};
var $b2cd9ecc66d0956f$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $b2cd9ecc66d0956f$var$setDefaults(type, 'browser');
}; // os types
var $b2cd9ecc66d0956f$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $b2cd9ecc66d0956f$var$OsTypes.Android;
};
var $b2cd9ecc66d0956f$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $b2cd9ecc66d0956f$var$OsTypes.Windows;
};
var $b2cd9ecc66d0956f$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $b2cd9ecc66d0956f$var$OsTypes.MAC_OS;
};
var $b2cd9ecc66d0956f$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $b2cd9ecc66d0956f$var$OsTypes.WindowsPhone;
};
var $b2cd9ecc66d0956f$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $b2cd9ecc66d0956f$var$OsTypes.IOS;
};
var $b2cd9ecc66d0956f$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $b2cd9ecc66d0956f$var$setDefaults(version);
};
var $b2cd9ecc66d0956f$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $b2cd9ecc66d0956f$var$setDefaults(name);
}; // browser types
var $b2cd9ecc66d0956f$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $b2cd9ecc66d0956f$var$BrowserTypes.Chrome;
};
var $b2cd9ecc66d0956f$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $b2cd9ecc66d0956f$var$BrowserTypes.Firefox;
};
var $b2cd9ecc66d0956f$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $b2cd9ecc66d0956f$var$BrowserTypes.Chromium;
};
var $b2cd9ecc66d0956f$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $b2cd9ecc66d0956f$var$BrowserTypes.Edge;
};
var $b2cd9ecc66d0956f$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $b2cd9ecc66d0956f$var$BrowserTypes.Yandex;
};
var $b2cd9ecc66d0956f$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $b2cd9ecc66d0956f$var$BrowserTypes.Safari || name === $b2cd9ecc66d0956f$var$BrowserTypes.MobileSafari;
};
var $b2cd9ecc66d0956f$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $b2cd9ecc66d0956f$var$BrowserTypes.MobileSafari;
};
var $b2cd9ecc66d0956f$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $b2cd9ecc66d0956f$var$BrowserTypes.Opera;
};
var $b2cd9ecc66d0956f$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $b2cd9ecc66d0956f$var$BrowserTypes.InternetExplorer || name === $b2cd9ecc66d0956f$var$BrowserTypes.Ie;
};
var $b2cd9ecc66d0956f$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $b2cd9ecc66d0956f$var$BrowserTypes.MIUI;
};
var $b2cd9ecc66d0956f$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $b2cd9ecc66d0956f$var$BrowserTypes.SamsungBrowser;
};
var $b2cd9ecc66d0956f$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $b2cd9ecc66d0956f$var$setDefaults(version);
};
var $b2cd9ecc66d0956f$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $b2cd9ecc66d0956f$var$setDefaults(major);
};
var $b2cd9ecc66d0956f$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $b2cd9ecc66d0956f$var$setDefaults(name);
}; // engine types
var $b2cd9ecc66d0956f$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $b2cd9ecc66d0956f$var$setDefaults(name);
};
var $b2cd9ecc66d0956f$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $b2cd9ecc66d0956f$var$setDefaults(version);
};
var $b2cd9ecc66d0956f$var$isElectronType = function isElectronType() {
    var nav = $b2cd9ecc66d0956f$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var $b2cd9ecc66d0956f$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var $b2cd9ecc66d0956f$var$getIOS13 = function getIOS13() {
    var nav = $b2cd9ecc66d0956f$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $b2cd9ecc66d0956f$var$getIPad13 = function getIPad13() {
    return $b2cd9ecc66d0956f$var$isIOS13Check('iPad');
};
var $b2cd9ecc66d0956f$var$getIphone13 = function getIphone13() {
    return $b2cd9ecc66d0956f$var$isIOS13Check('iPhone');
};
var $b2cd9ecc66d0956f$var$getIPod13 = function getIPod13() {
    return $b2cd9ecc66d0956f$var$isIOS13Check('iPod');
};
var $b2cd9ecc66d0956f$var$getUseragent = function getUseragent(userAg) {
    return $b2cd9ecc66d0956f$var$setDefaults(userAg);
};
function $b2cd9ecc66d0956f$var$buildSelectorsObject(options) {
    var _ref = options ? options : $b2cd9ecc66d0956f$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $b2cd9ecc66d0956f$var$isSmartTVType(device),
        isConsole: $b2cd9ecc66d0956f$var$isConsoleType(device),
        isWearable: $b2cd9ecc66d0956f$var$isWearableType(device),
        isEmbedded: $b2cd9ecc66d0956f$var$isEmbeddedType(device),
        isMobileSafari: $b2cd9ecc66d0956f$var$isMobileSafariType(browser) || $b2cd9ecc66d0956f$var$getIPad13(),
        isChromium: $b2cd9ecc66d0956f$var$isChromiumType(browser),
        isMobile: $b2cd9ecc66d0956f$var$isMobileAndTabletType(device) || $b2cd9ecc66d0956f$var$getIPad13(),
        isMobileOnly: $b2cd9ecc66d0956f$var$isMobileType(device),
        isTablet: $b2cd9ecc66d0956f$var$isTabletType(device) || $b2cd9ecc66d0956f$var$getIPad13(),
        isBrowser: $b2cd9ecc66d0956f$var$isBrowserType(device),
        isDesktop: $b2cd9ecc66d0956f$var$isBrowserType(device),
        isAndroid: $b2cd9ecc66d0956f$var$isAndroidType(os),
        isWinPhone: $b2cd9ecc66d0956f$var$isWinPhoneType(os),
        isIOS: $b2cd9ecc66d0956f$var$isIOSType(os) || $b2cd9ecc66d0956f$var$getIPad13(),
        isChrome: $b2cd9ecc66d0956f$var$isChromeType(browser),
        isFirefox: $b2cd9ecc66d0956f$var$isFirefoxType(browser),
        isSafari: $b2cd9ecc66d0956f$var$isSafariType(browser),
        isOpera: $b2cd9ecc66d0956f$var$isOperaType(browser),
        isIE: $b2cd9ecc66d0956f$var$isIEType(browser),
        osVersion: $b2cd9ecc66d0956f$var$getOsVersion(os),
        osName: $b2cd9ecc66d0956f$var$getOsName(os),
        fullBrowserVersion: $b2cd9ecc66d0956f$var$getBrowserFullVersion(browser),
        browserVersion: $b2cd9ecc66d0956f$var$getBrowserVersion(browser),
        browserName: $b2cd9ecc66d0956f$var$getBrowserName(browser),
        mobileVendor: $b2cd9ecc66d0956f$var$getMobileVendor(device),
        mobileModel: $b2cd9ecc66d0956f$var$getMobileModel(device),
        engineName: $b2cd9ecc66d0956f$var$getEngineName(engine),
        engineVersion: $b2cd9ecc66d0956f$var$getEngineVersion(engine),
        getUA: $b2cd9ecc66d0956f$var$getUseragent(ua),
        isEdge: $b2cd9ecc66d0956f$var$isEdgeType(browser) || $b2cd9ecc66d0956f$var$isEdgeChromiumType(ua),
        isYandex: $b2cd9ecc66d0956f$var$isYandexType(browser),
        deviceType: $b2cd9ecc66d0956f$var$getDeviceType(device),
        isIOS13: $b2cd9ecc66d0956f$var$getIOS13(),
        isIPad13: $b2cd9ecc66d0956f$var$getIPad13(),
        isIPhone13: $b2cd9ecc66d0956f$var$getIphone13(),
        isIPod13: $b2cd9ecc66d0956f$var$getIPod13(),
        isElectron: $b2cd9ecc66d0956f$var$isElectronType(),
        isEdgeChromium: $b2cd9ecc66d0956f$var$isEdgeChromiumType(ua),
        isLegacyEdge: $b2cd9ecc66d0956f$var$isEdgeType(browser) && !$b2cd9ecc66d0956f$var$isEdgeChromiumType(ua),
        isWindows: $b2cd9ecc66d0956f$var$isWindowsType(os),
        isMacOs: $b2cd9ecc66d0956f$var$isMacOsType(os),
        isMIUI: $b2cd9ecc66d0956f$var$isMIUIType(browser),
        isSamsungBrowser: $b2cd9ecc66d0956f$var$isSamsungBrowserType(browser)
    };
}
var $b2cd9ecc66d0956f$var$isSmartTV = $b2cd9ecc66d0956f$var$isSmartTVType($b2cd9ecc66d0956f$var$device);
var $b2cd9ecc66d0956f$var$isConsole = $b2cd9ecc66d0956f$var$isConsoleType($b2cd9ecc66d0956f$var$device);
var $b2cd9ecc66d0956f$var$isWearable = $b2cd9ecc66d0956f$var$isWearableType($b2cd9ecc66d0956f$var$device);
var $b2cd9ecc66d0956f$var$isEmbedded = $b2cd9ecc66d0956f$var$isEmbeddedType($b2cd9ecc66d0956f$var$device);
var $b2cd9ecc66d0956f$var$isMobileSafari = $b2cd9ecc66d0956f$var$isMobileSafariType($b2cd9ecc66d0956f$var$browser) || $b2cd9ecc66d0956f$var$getIPad13();
var $b2cd9ecc66d0956f$var$isChromium = $b2cd9ecc66d0956f$var$isChromiumType($b2cd9ecc66d0956f$var$browser);
var $b2cd9ecc66d0956f$var$isMobile = $b2cd9ecc66d0956f$var$isMobileAndTabletType($b2cd9ecc66d0956f$var$device) || $b2cd9ecc66d0956f$var$getIPad13();
var $b2cd9ecc66d0956f$var$isMobileOnly = $b2cd9ecc66d0956f$var$isMobileType($b2cd9ecc66d0956f$var$device);
var $b2cd9ecc66d0956f$var$isTablet = $b2cd9ecc66d0956f$var$isTabletType($b2cd9ecc66d0956f$var$device) || $b2cd9ecc66d0956f$var$getIPad13();
var $b2cd9ecc66d0956f$var$isBrowser = $b2cd9ecc66d0956f$var$isBrowserType($b2cd9ecc66d0956f$var$device);
var $b2cd9ecc66d0956f$var$isDesktop = $b2cd9ecc66d0956f$var$isBrowserType($b2cd9ecc66d0956f$var$device);
var $b2cd9ecc66d0956f$var$isAndroid = $b2cd9ecc66d0956f$var$isAndroidType($b2cd9ecc66d0956f$var$os);
var $b2cd9ecc66d0956f$var$isWinPhone = $b2cd9ecc66d0956f$var$isWinPhoneType($b2cd9ecc66d0956f$var$os);
var $b2cd9ecc66d0956f$var$isIOS = $b2cd9ecc66d0956f$var$isIOSType($b2cd9ecc66d0956f$var$os) || $b2cd9ecc66d0956f$var$getIPad13();
var $b2cd9ecc66d0956f$var$isChrome = $b2cd9ecc66d0956f$var$isChromeType($b2cd9ecc66d0956f$var$browser);
var $b2cd9ecc66d0956f$var$isFirefox = $b2cd9ecc66d0956f$var$isFirefoxType($b2cd9ecc66d0956f$var$browser);
var $b2cd9ecc66d0956f$var$isSafari = $b2cd9ecc66d0956f$var$isSafariType($b2cd9ecc66d0956f$var$browser);
var $b2cd9ecc66d0956f$var$isOpera = $b2cd9ecc66d0956f$var$isOperaType($b2cd9ecc66d0956f$var$browser);
var $b2cd9ecc66d0956f$var$isIE = $b2cd9ecc66d0956f$var$isIEType($b2cd9ecc66d0956f$var$browser);
var $b2cd9ecc66d0956f$var$osVersion = $b2cd9ecc66d0956f$var$getOsVersion($b2cd9ecc66d0956f$var$os);
var $b2cd9ecc66d0956f$var$osName = $b2cd9ecc66d0956f$var$getOsName($b2cd9ecc66d0956f$var$os);
var $b2cd9ecc66d0956f$var$fullBrowserVersion = $b2cd9ecc66d0956f$var$getBrowserFullVersion($b2cd9ecc66d0956f$var$browser);
var $b2cd9ecc66d0956f$var$browserVersion = $b2cd9ecc66d0956f$var$getBrowserVersion($b2cd9ecc66d0956f$var$browser);
var $b2cd9ecc66d0956f$var$browserName = $b2cd9ecc66d0956f$var$getBrowserName($b2cd9ecc66d0956f$var$browser);
var $b2cd9ecc66d0956f$var$mobileVendor = $b2cd9ecc66d0956f$var$getMobileVendor($b2cd9ecc66d0956f$var$device);
var $b2cd9ecc66d0956f$var$mobileModel = $b2cd9ecc66d0956f$var$getMobileModel($b2cd9ecc66d0956f$var$device);
var $b2cd9ecc66d0956f$var$engineName = $b2cd9ecc66d0956f$var$getEngineName($b2cd9ecc66d0956f$var$engine);
var $b2cd9ecc66d0956f$var$engineVersion = $b2cd9ecc66d0956f$var$getEngineVersion($b2cd9ecc66d0956f$var$engine);
var $b2cd9ecc66d0956f$var$getUA = $b2cd9ecc66d0956f$var$getUseragent($b2cd9ecc66d0956f$var$ua);
var $b2cd9ecc66d0956f$var$isEdge = $b2cd9ecc66d0956f$var$isEdgeType($b2cd9ecc66d0956f$var$browser) || $b2cd9ecc66d0956f$var$isEdgeChromiumType($b2cd9ecc66d0956f$var$ua);
var $b2cd9ecc66d0956f$var$isYandex = $b2cd9ecc66d0956f$var$isYandexType($b2cd9ecc66d0956f$var$browser);
var $b2cd9ecc66d0956f$var$deviceType = $b2cd9ecc66d0956f$var$getDeviceType($b2cd9ecc66d0956f$var$device);
var $b2cd9ecc66d0956f$var$isIOS13 = $b2cd9ecc66d0956f$var$getIOS13();
var $b2cd9ecc66d0956f$var$isIPad13 = $b2cd9ecc66d0956f$var$getIPad13();
var $b2cd9ecc66d0956f$var$isIPhone13 = $b2cd9ecc66d0956f$var$getIphone13();
var $b2cd9ecc66d0956f$var$isIPod13 = $b2cd9ecc66d0956f$var$getIPod13();
var $b2cd9ecc66d0956f$var$isElectron = $b2cd9ecc66d0956f$var$isElectronType();
var $b2cd9ecc66d0956f$var$isEdgeChromium = $b2cd9ecc66d0956f$var$isEdgeChromiumType($b2cd9ecc66d0956f$var$ua);
var $b2cd9ecc66d0956f$var$isLegacyEdge = $b2cd9ecc66d0956f$var$isEdgeType($b2cd9ecc66d0956f$var$browser) && !$b2cd9ecc66d0956f$var$isEdgeChromiumType($b2cd9ecc66d0956f$var$ua);
var $b2cd9ecc66d0956f$var$isWindows = $b2cd9ecc66d0956f$var$isWindowsType($b2cd9ecc66d0956f$var$os);
var $b2cd9ecc66d0956f$var$isMacOs = $b2cd9ecc66d0956f$var$isMacOsType($b2cd9ecc66d0956f$var$os);
var $b2cd9ecc66d0956f$var$isMIUI = $b2cd9ecc66d0956f$var$isMIUIType($b2cd9ecc66d0956f$var$browser);
var $b2cd9ecc66d0956f$var$isSamsungBrowser = $b2cd9ecc66d0956f$var$isSamsungBrowserType($b2cd9ecc66d0956f$var$browser);
var $b2cd9ecc66d0956f$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== 'string') {
        console.error('No valid user agent string was provided');
        return;
    }
    var _UAHelper$parseUserAg = $b2cd9ecc66d0956f$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $b2cd9ecc66d0956f$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $b2cd9ecc66d0956f$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $b2cd9ecc66d0956f$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $b2cd9ecc66d0956f$var$isAndroid ? renderWithFragment ? $b2cd9ecc66d0956f$var$React__default.createElement($28UcW.Fragment, null, children) : $b2cd9ecc66d0956f$var$React__default.createElement("div", props, children) : null;
};
var $b2cd9ecc66d0956f$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $b2cd9ecc66d0956f$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $b2cd9ecc66d0956f$var$isBrowser ? renderWithFragment ? $b2cd9ecc66d0956f$var$React__default.createElement($28UcW.Fragment, null, children) : $b2cd9ecc66d0956f$var$React__default.createElement("div", props, children) : null;
};
var $b2cd9ecc66d0956f$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $b2cd9ecc66d0956f$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $b2cd9ecc66d0956f$var$isIE ? renderWithFragment ? $b2cd9ecc66d0956f$var$React__default.createElement($28UcW.Fragment, null, children) : $b2cd9ecc66d0956f$var$React__default.createElement("div", props, children) : null;
};
var $b2cd9ecc66d0956f$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $b2cd9ecc66d0956f$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $b2cd9ecc66d0956f$var$isIOS ? renderWithFragment ? $b2cd9ecc66d0956f$var$React__default.createElement($28UcW.Fragment, null, children) : $b2cd9ecc66d0956f$var$React__default.createElement("div", props, children) : null;
};
var $b2cd9ecc66d0956f$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $b2cd9ecc66d0956f$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $b2cd9ecc66d0956f$var$isMobile ? renderWithFragment ? $b2cd9ecc66d0956f$var$React__default.createElement($28UcW.Fragment, null, children) : $b2cd9ecc66d0956f$var$React__default.createElement("div", props, children) : null;
};
var $b2cd9ecc66d0956f$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $b2cd9ecc66d0956f$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $b2cd9ecc66d0956f$var$isTablet ? renderWithFragment ? $b2cd9ecc66d0956f$var$React__default.createElement($28UcW.Fragment, null, children) : $b2cd9ecc66d0956f$var$React__default.createElement("div", props, children) : null;
};
var $b2cd9ecc66d0956f$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $b2cd9ecc66d0956f$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $b2cd9ecc66d0956f$var$isWinPhone ? renderWithFragment ? $b2cd9ecc66d0956f$var$React__default.createElement($28UcW.Fragment, null, children) : $b2cd9ecc66d0956f$var$React__default.createElement("div", props, children) : null;
};
var $b2cd9ecc66d0956f$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $b2cd9ecc66d0956f$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $b2cd9ecc66d0956f$var$isMobileOnly ? renderWithFragment ? $b2cd9ecc66d0956f$var$React__default.createElement($28UcW.Fragment, null, children) : $b2cd9ecc66d0956f$var$React__default.createElement("div", props, children) : null;
};
var $b2cd9ecc66d0956f$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $b2cd9ecc66d0956f$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $b2cd9ecc66d0956f$var$isSmartTV ? renderWithFragment ? $b2cd9ecc66d0956f$var$React__default.createElement($28UcW.Fragment, null, children) : $b2cd9ecc66d0956f$var$React__default.createElement("div", props, children) : null;
};
var $b2cd9ecc66d0956f$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $b2cd9ecc66d0956f$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $b2cd9ecc66d0956f$var$isConsole ? renderWithFragment ? $b2cd9ecc66d0956f$var$React__default.createElement($28UcW.Fragment, null, children) : $b2cd9ecc66d0956f$var$React__default.createElement("div", props, children) : null;
};
var $b2cd9ecc66d0956f$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $b2cd9ecc66d0956f$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $b2cd9ecc66d0956f$var$isWearable ? renderWithFragment ? $b2cd9ecc66d0956f$var$React__default.createElement($28UcW.Fragment, null, children) : $b2cd9ecc66d0956f$var$React__default.createElement("div", props, children) : null;
};
var $b2cd9ecc66d0956f$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $b2cd9ecc66d0956f$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $b2cd9ecc66d0956f$var$React__default.createElement($28UcW.Fragment, null, children) : $b2cd9ecc66d0956f$var$React__default.createElement("div", props, children) : null;
};
function $b2cd9ecc66d0956f$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $b2cd9ecc66d0956f$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $b2cd9ecc66d0956f$var$_classCallCheck(this, _class);
            _this = $b2cd9ecc66d0956f$var$_possibleConstructorReturn(this, $b2cd9ecc66d0956f$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($b2cd9ecc66d0956f$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($b2cd9ecc66d0956f$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($b2cd9ecc66d0956f$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $b2cd9ecc66d0956f$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $b2cd9ecc66d0956f$var$_typeof(window)) !== undefined && $b2cd9ecc66d0956f$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $b2cd9ecc66d0956f$var$React__default.createElement(WrappedComponent, $b2cd9ecc66d0956f$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($b2cd9ecc66d0956f$var$React__default.Component);
}
function $b2cd9ecc66d0956f$var$useMobileOrientation() {
    var _useState = $28UcW.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? 'portrait' : 'landscape'
        };
    }), _useState2 = $b2cd9ecc66d0956f$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $28UcW.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? 'portrait' : 'landscape'
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $28UcW.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $b2cd9ecc66d0956f$var$_typeof(window)) !== undefined && $b2cd9ecc66d0956f$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $b2cd9ecc66d0956f$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $b2cd9ecc66d0956f$var$parseUserAgent(hookUserAgent);
}
function $b2cd9ecc66d0956f$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $b2cd9ecc66d0956f$var$useDeviceData(hookUserAgent);
    var selectors = $b2cd9ecc66d0956f$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
$b2cd9ecc66d0956f$exports.AndroidView = $b2cd9ecc66d0956f$var$AndroidView;
$b2cd9ecc66d0956f$exports.BrowserTypes = $b2cd9ecc66d0956f$var$BrowserTypes;
$b2cd9ecc66d0956f$exports.BrowserView = $b2cd9ecc66d0956f$var$BrowserView;
$b2cd9ecc66d0956f$exports.ConsoleView = $b2cd9ecc66d0956f$var$ConsoleView;
$b2cd9ecc66d0956f$exports.CustomView = $b2cd9ecc66d0956f$var$CustomView;
$b2cd9ecc66d0956f$exports.IEView = $b2cd9ecc66d0956f$var$IEView;
$b2cd9ecc66d0956f$exports.IOSView = $b2cd9ecc66d0956f$var$IOSView;
$b2cd9ecc66d0956f$exports.MobileOnlyView = $b2cd9ecc66d0956f$var$MobileOnlyView;
$b2cd9ecc66d0956f$exports.MobileView = $b2cd9ecc66d0956f$var$MobileView;
$b2cd9ecc66d0956f$exports.OsTypes = $b2cd9ecc66d0956f$var$OsTypes;
$b2cd9ecc66d0956f$exports.SmartTVView = $b2cd9ecc66d0956f$var$SmartTVView;
$b2cd9ecc66d0956f$exports.TabletView = $b2cd9ecc66d0956f$var$TabletView;
$b2cd9ecc66d0956f$exports.WearableView = $b2cd9ecc66d0956f$var$WearableView;
$b2cd9ecc66d0956f$exports.WinPhoneView = $b2cd9ecc66d0956f$var$WinPhoneView;
$b2cd9ecc66d0956f$exports.browserName = $b2cd9ecc66d0956f$var$browserName;
$b2cd9ecc66d0956f$exports.browserVersion = $b2cd9ecc66d0956f$var$browserVersion;
$b2cd9ecc66d0956f$exports.deviceDetect = $b2cd9ecc66d0956f$var$deviceDetect;
$b2cd9ecc66d0956f$exports.deviceType = $b2cd9ecc66d0956f$var$deviceType;
$b2cd9ecc66d0956f$exports.engineName = $b2cd9ecc66d0956f$var$engineName;
$b2cd9ecc66d0956f$exports.engineVersion = $b2cd9ecc66d0956f$var$engineVersion;
$b2cd9ecc66d0956f$exports.fullBrowserVersion = $b2cd9ecc66d0956f$var$fullBrowserVersion;
$b2cd9ecc66d0956f$exports.getSelectorsByUserAgent = $b2cd9ecc66d0956f$var$getSelectorsByUserAgent;
$b2cd9ecc66d0956f$exports.getUA = $b2cd9ecc66d0956f$var$getUA;
$b2cd9ecc66d0956f$exports.isAndroid = $b2cd9ecc66d0956f$var$isAndroid;
$b2cd9ecc66d0956f$exports.isBrowser = $b2cd9ecc66d0956f$var$isBrowser;
$b2cd9ecc66d0956f$exports.isChrome = $b2cd9ecc66d0956f$var$isChrome;
$b2cd9ecc66d0956f$exports.isChromium = $b2cd9ecc66d0956f$var$isChromium;
$b2cd9ecc66d0956f$exports.isConsole = $b2cd9ecc66d0956f$var$isConsole;
$b2cd9ecc66d0956f$exports.isDesktop = $b2cd9ecc66d0956f$var$isDesktop;
$b2cd9ecc66d0956f$exports.isEdge = $b2cd9ecc66d0956f$var$isEdge;
$b2cd9ecc66d0956f$exports.isEdgeChromium = $b2cd9ecc66d0956f$var$isEdgeChromium;
$b2cd9ecc66d0956f$exports.isElectron = $b2cd9ecc66d0956f$var$isElectron;
$b2cd9ecc66d0956f$exports.isEmbedded = $b2cd9ecc66d0956f$var$isEmbedded;
$b2cd9ecc66d0956f$exports.isFirefox = $b2cd9ecc66d0956f$var$isFirefox;
$b2cd9ecc66d0956f$exports.isIE = $b2cd9ecc66d0956f$var$isIE;
$b2cd9ecc66d0956f$exports.isIOS = $b2cd9ecc66d0956f$var$isIOS;
$b2cd9ecc66d0956f$exports.isIOS13 = $b2cd9ecc66d0956f$var$isIOS13;
$b2cd9ecc66d0956f$exports.isIPad13 = $b2cd9ecc66d0956f$var$isIPad13;
$b2cd9ecc66d0956f$exports.isIPhone13 = $b2cd9ecc66d0956f$var$isIPhone13;
$b2cd9ecc66d0956f$exports.isIPod13 = $b2cd9ecc66d0956f$var$isIPod13;
$b2cd9ecc66d0956f$exports.isLegacyEdge = $b2cd9ecc66d0956f$var$isLegacyEdge;
$b2cd9ecc66d0956f$exports.isMIUI = $b2cd9ecc66d0956f$var$isMIUI;
$b2cd9ecc66d0956f$exports.isMacOs = $b2cd9ecc66d0956f$var$isMacOs;
$b2cd9ecc66d0956f$exports.isMobile = $b2cd9ecc66d0956f$var$isMobile;
$b2cd9ecc66d0956f$exports.isMobileOnly = $b2cd9ecc66d0956f$var$isMobileOnly;
$b2cd9ecc66d0956f$exports.isMobileSafari = $b2cd9ecc66d0956f$var$isMobileSafari;
$b2cd9ecc66d0956f$exports.isOpera = $b2cd9ecc66d0956f$var$isOpera;
$b2cd9ecc66d0956f$exports.isSafari = $b2cd9ecc66d0956f$var$isSafari;
$b2cd9ecc66d0956f$exports.isSamsungBrowser = $b2cd9ecc66d0956f$var$isSamsungBrowser;
$b2cd9ecc66d0956f$exports.isSmartTV = $b2cd9ecc66d0956f$var$isSmartTV;
$b2cd9ecc66d0956f$exports.isTablet = $b2cd9ecc66d0956f$var$isTablet;
$b2cd9ecc66d0956f$exports.isWearable = $b2cd9ecc66d0956f$var$isWearable;
$b2cd9ecc66d0956f$exports.isWinPhone = $b2cd9ecc66d0956f$var$isWinPhone;
$b2cd9ecc66d0956f$exports.isWindows = $b2cd9ecc66d0956f$var$isWindows;
$b2cd9ecc66d0956f$exports.isYandex = $b2cd9ecc66d0956f$var$isYandex;
$b2cd9ecc66d0956f$exports.mobileModel = $b2cd9ecc66d0956f$var$mobileModel;
$b2cd9ecc66d0956f$exports.mobileVendor = $b2cd9ecc66d0956f$var$mobileVendor;
$b2cd9ecc66d0956f$exports.osName = $b2cd9ecc66d0956f$var$osName;
$b2cd9ecc66d0956f$exports.osVersion = $b2cd9ecc66d0956f$var$osVersion;
$b2cd9ecc66d0956f$exports.parseUserAgent = $b2cd9ecc66d0956f$var$parseUserAgent;
$b2cd9ecc66d0956f$exports.setUserAgent = $b2cd9ecc66d0956f$var$setUserAgent;
$b2cd9ecc66d0956f$exports.useDeviceData = $b2cd9ecc66d0956f$var$useDeviceData;
$b2cd9ecc66d0956f$exports.useDeviceSelectors = $b2cd9ecc66d0956f$var$useDeviceSelectors;
$b2cd9ecc66d0956f$exports.useMobileOrientation = $b2cd9ecc66d0956f$var$useMobileOrientation;
$b2cd9ecc66d0956f$exports.withOrientationChange = $b2cd9ecc66d0956f$var$withOrientationChange;






var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");

var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $1fz9F = parcelRequire("1fz9F");

var $28UcW = parcelRequire("28UcW");
'use client';
let $930be18af46897d8$var$globalId = 0;
function $930be18af46897d8$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $28UcW.useState(idOverride);
    const id = idOverride || defaultId;
    $28UcW.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $930be18af46897d8$var$globalId += 1;
            setDefaultId(`mui-${$930be18af46897d8$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $930be18af46897d8$var$maybeReactUseId = $28UcW['useId'.toString()];
function $930be18af46897d8$export$2e2bcd8739ae039(idOverride) {
    if ($930be18af46897d8$var$maybeReactUseId !== undefined) {
        const reactId = $930be18af46897d8$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $930be18af46897d8$var$useGlobalId(idOverride);
}



var $1mNk8 = parcelRequire("1mNk8");

var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");



var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");


var $kLZMq = parcelRequire("kLZMq");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $565736d32b3dfb1b$export$e28348cc2430497(element) {
    return typeof element === 'string';
}


function $78ebb5a23c9e54f3$export$b089efb01a7bdf50(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $565736d32b3dfb1b$export$e28348cc2430497)(elementType)) return otherProps;
    return (0, $kLZMq.default)({}, otherProps, {
        ownerState: (0, $kLZMq.default)({}, otherProps.ownerState, ownerState)
    });
}



var $kLZMq = parcelRequire("kLZMq");

var $dP0oo = parcelRequire("dP0oo");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $772e7eb7442094ca$export$24d5698b57eff81c(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $3175cb5ac5b8ad7b$export$2ac0fa4d3a39be45(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $b6c6397063b8c1da$export$b01d1e419b049226(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $dP0oo.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $kLZMq.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $kLZMq.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $772e7eb7442094ca$export$24d5698b57eff81c)((0, $kLZMq.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $3175cb5ac5b8ad7b$export$2ac0fa4d3a39be45)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $3175cb5ac5b8ad7b$export$2ac0fa4d3a39be45)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $dP0oo.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $kLZMq.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $kLZMq.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $dd7d25a0ccd83122$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}


'use client';
const $308c9efc97ee800b$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function $308c9efc97ee800b$export$1e5c9e6e4e15efe3(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $53Ou4.default)(parameters, $308c9efc97ee800b$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $dd7d25a0ccd83122$export$308c24034cde71de)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $b6c6397063b8c1da$export$b01d1e419b049226)((0, $kLZMq.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $39cf289415cf806e$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $78ebb5a23c9e54f3$export$b089efb01a7bdf50)(elementType, (0, $kLZMq.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}



var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $c172664603a592be$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

function $2aa96e427bd09d3b$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $c21a6c26d624e0d3$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


function $c66694b6fb06134f$export$2e2bcd8739ae039(node) {
    const doc = (0, $2aa96e427bd09d3b$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


// Is a vertical scrollbar displayed?
function $2154e542c21584d6$var$isOverflowing(container) {
    const doc = (0, $2aa96e427bd09d3b$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $c66694b6fb06134f$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $2154e542c21584d6$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $2154e542c21584d6$var$getPaddingRight(element) {
    return parseInt((0, $c66694b6fb06134f$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $2154e542c21584d6$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $2154e542c21584d6$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$2154e542c21584d6$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $2154e542c21584d6$export$e1bd0c6150f13d96(element, show);
    });
}
function $2154e542c21584d6$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $2154e542c21584d6$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($2154e542c21584d6$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $c21a6c26d624e0d3$export$2e2bcd8739ae039)((0, $2aa96e427bd09d3b$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$2154e542c21584d6$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $2aa96e427bd09d3b$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$2154e542c21584d6$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $2aa96e427bd09d3b$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $c66694b6fb06134f$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $2154e542c21584d6$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $2154e542c21584d6$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $2154e542c21584d6$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $2154e542c21584d6$var$getHiddenSiblings(container);
        $2154e542c21584d6$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $2154e542c21584d6$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $2154e542c21584d6$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $2154e542c21584d6$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $2154e542c21584d6$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $2154e542c21584d6$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $2154e542c21584d6$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $2154e542c21584d6$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $b809dc4b0a40d7d1$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $b809dc4b0a40d7d1$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $b809dc4b0a40d7d1$var$defaultManager = new (0, $2154e542c21584d6$export$ce11c4ecd08cea67)();
function $b809dc4b0a40d7d1$export$33ffd74ebf07f060(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $b809dc4b0a40d7d1$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $28UcW.useRef({});
    const mountNodeRef = $28UcW.useRef(null);
    const modalRef = $28UcW.useRef(null);
    const handleRef = (0, $39cf289415cf806e$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $28UcW.useState(!open);
    const hasTransition = $b809dc4b0a40d7d1$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $2aa96e427bd09d3b$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $e69ea0a302c22b7c$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $b809dc4b0a40d7d1$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $28UcW.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $e69ea0a302c22b7c$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $2154e542c21584d6$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $28UcW.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $28UcW.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $28UcW.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $772e7eb7442094ca$export$24d5698b57eff81c)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $kLZMq.default)({}, propsEventHandlers, otherHandlers);
        return (0, $kLZMq.default)({
            role: 'presentation'
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $kLZMq.default)({
            'aria-hidden': true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $c172664603a592be$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $c172664603a592be$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}



var $1fz9F = parcelRequire("1fz9F");

var $28UcW = parcelRequire("28UcW");



var $4XrX4 = parcelRequire("4XrX4");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $d636f765f92576ff$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $d636f765f92576ff$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $d636f765f92576ff$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $d636f765f92576ff$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $d636f765f92576ff$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $d636f765f92576ff$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($d636f765f92576ff$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $d636f765f92576ff$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$d636f765f92576ff$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $d636f765f92576ff$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function $d636f765f92576ff$export$34eba2437817a67b(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $d636f765f92576ff$var$defaultGetTabbable, isEnabled: isEnabled = $d636f765f92576ff$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $28UcW.useRef(false);
    const sentinelStart = $28UcW.useRef(null);
    const sentinelEnd = $28UcW.useRef(null);
    const nodeToRestore = $28UcW.useRef(null);
    const reactFocusEventTarget = $28UcW.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $28UcW.useRef(false);
    const rootRef = $28UcW.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $39cf289415cf806e$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $28UcW.useRef(null);
    $28UcW.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $28UcW.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $2aa96e427bd09d3b$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $28UcW.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $2aa96e427bd09d3b$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $4XrX4.jsxs)($28UcW.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $28UcW.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}



var $28UcW = parcelRequire("28UcW");




var $4XrX4 = parcelRequire("4XrX4");
'use client';
function $0ab0701d905c1589$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const $0ab0701d905c1589$export$602eac185826482c = /*#__PURE__*/ $28UcW.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $28UcW.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $39cf289415cf806e$export$2e2bcd8739ae039)(/*#__PURE__*/ $28UcW.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $8a0c5c067d762282$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($0ab0701d905c1589$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $8a0c5c067d762282$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $1eea032f836dcbb1$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $1eea032f836dcbb1$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $28UcW.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $28UcW.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $4XrX4.jsx)($28UcW.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $4XrX4.jsx)($28UcW.Fragment, {
        children: mountNode ? /*#__PURE__*/ $ac717a3ef8959bc0$exports.createPortal(children, mountNode) : mountNode
    });
});



var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");

var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $1fz9F = parcelRequire("1fz9F");

var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");

var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $28UcW = parcelRequire("28UcW");


var $53Ou4 = parcelRequire("53Ou4");



var $28UcW = parcelRequire("28UcW");

var $e0f16f40a2b74fe6$export$2e2bcd8739ae039 = {
    disabled: false
};




var $fcaba34da346e916$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $cfd1f9e04a409bf9$export$bb38bb9a1161268 = 'unmounted';
var $cfd1f9e04a409bf9$export$84cbff306f539230 = 'exited';
var $cfd1f9e04a409bf9$export$df38205c966be359 = 'entering';
var $cfd1f9e04a409bf9$export$78e9e6e3e014d60a = 'entered';
var $cfd1f9e04a409bf9$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $cfd1f9e04a409bf9$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $388ee14e7a40d900$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $cfd1f9e04a409bf9$export$84cbff306f539230;
                _this.appearStatus = $cfd1f9e04a409bf9$export$df38205c966be359;
            } else initialStatus = $cfd1f9e04a409bf9$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $cfd1f9e04a409bf9$export$bb38bb9a1161268;
        else initialStatus = $cfd1f9e04a409bf9$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $cfd1f9e04a409bf9$export$bb38bb9a1161268) return {
            status: $cfd1f9e04a409bf9$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $cfd1f9e04a409bf9$export$df38205c966be359 && status !== $cfd1f9e04a409bf9$export$78e9e6e3e014d60a) nextStatus = $cfd1f9e04a409bf9$export$df38205c966be359;
            } else if (status === $cfd1f9e04a409bf9$export$df38205c966be359 || status === $cfd1f9e04a409bf9$export$78e9e6e3e014d60a) nextStatus = $cfd1f9e04a409bf9$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $cfd1f9e04a409bf9$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($ac717a3ef8959bc0$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $fcaba34da346e916$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $cfd1f9e04a409bf9$export$84cbff306f539230) this.setState({
            status: $cfd1f9e04a409bf9$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($ac717a3ef8959bc0$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $e0f16f40a2b74fe6$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $cfd1f9e04a409bf9$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $cfd1f9e04a409bf9$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $cfd1f9e04a409bf9$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($ac717a3ef8959bc0$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $e0f16f40a2b74fe6$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $cfd1f9e04a409bf9$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $cfd1f9e04a409bf9$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $cfd1f9e04a409bf9$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($ac717a3ef8959bc0$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $cfd1f9e04a409bf9$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $53Ou4.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($28UcW))).createElement((0, $c3d498d38e18cf8a$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($28UcW))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($28UcW))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($28UcW))).Component);
$cfd1f9e04a409bf9$var$Transition.contextType = (0, $c3d498d38e18cf8a$export$2e2bcd8739ae039);
$cfd1f9e04a409bf9$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $cfd1f9e04a409bf9$var$noop() {}
$cfd1f9e04a409bf9$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $cfd1f9e04a409bf9$var$noop,
    onEntering: $cfd1f9e04a409bf9$var$noop,
    onEntered: $cfd1f9e04a409bf9$var$noop,
    onExit: $cfd1f9e04a409bf9$var$noop,
    onExiting: $cfd1f9e04a409bf9$var$noop,
    onExited: $cfd1f9e04a409bf9$var$noop
};
$cfd1f9e04a409bf9$var$Transition.UNMOUNTED = $cfd1f9e04a409bf9$export$bb38bb9a1161268;
$cfd1f9e04a409bf9$var$Transition.EXITED = $cfd1f9e04a409bf9$export$84cbff306f539230;
$cfd1f9e04a409bf9$var$Transition.ENTERING = $cfd1f9e04a409bf9$export$df38205c966be359;
$cfd1f9e04a409bf9$var$Transition.ENTERED = $cfd1f9e04a409bf9$export$78e9e6e3e014d60a;
$cfd1f9e04a409bf9$var$Transition.EXITING = $cfd1f9e04a409bf9$export$4aacc83d4d59139f;
var $cfd1f9e04a409bf9$export$2e2bcd8739ae039 = $cfd1f9e04a409bf9$var$Transition;



parcelRequire("28UcW");

var $5jh9n = parcelRequire("5jh9n");

var $dpWha = parcelRequire("dpWha");

var $RjrfP = parcelRequire("RjrfP");
'use client';
function $93b513bca024249e$export$2e2bcd8739ae039() {
    const theme = (0, $5jh9n.default)((0, $dpWha.default));
    return theme[0, $RjrfP.default] || theme;
}


const $c2a19a68af095939$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $c2a19a68af095939$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $e78145f8e8c6d3d4$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $e78145f8e8c6d3d4$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $e78145f8e8c6d3d4$var$Fade = /*#__PURE__*/ $28UcW.forwardRef(function Fade(props, ref) {
    const theme = (0, $93b513bca024249e$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $cfd1f9e04a409bf9$export$2e2bcd8739ae039) } = props, other = (0, $53Ou4.default)(props, $e78145f8e8c6d3d4$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $28UcW.useRef(null);
    const handleRef = (0, $7d57efcdf4f58771$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $c2a19a68af095939$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $c2a19a68af095939$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $c2a19a68af095939$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $4XrX4.jsx)(TransitionComponent, (0, $kLZMq.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $28UcW.cloneElement(children, (0, $kLZMq.default)({
                style: (0, $kLZMq.default)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $e78145f8e8c6d3d4$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $e78145f8e8c6d3d4$export$2e2bcd8739ae039 = $e78145f8e8c6d3d4$var$Fade;



var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $2de9210b3070f731$export$9927a91fd93152bd(slot) {
    return (0, $dYzHx.default)('MuiBackdrop', slot);
}
const $2de9210b3070f731$var$backdropClasses = (0, $d0ZgE.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $2de9210b3070f731$export$2e2bcd8739ae039 = $2de9210b3070f731$var$backdropClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $cb219f8ff05770a2$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $cb219f8ff05770a2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $2de9210b3070f731$export$9927a91fd93152bd), classes);
};
const $cb219f8ff05770a2$var$BackdropRoot = (0, $k5hQd.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $kLZMq.default)({
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
        backgroundColor: 'transparent'
    }));
const $cb219f8ff05770a2$var$Backdrop = /*#__PURE__*/ $28UcW.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $e78145f8e8c6d3d4$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $53Ou4.default)(props, $cb219f8ff05770a2$var$_excluded);
    const ownerState = (0, $kLZMq.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $cb219f8ff05770a2$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $4XrX4.jsx)(TransitionComponent, (0, $kLZMq.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $4XrX4.jsx)($cb219f8ff05770a2$var$BackdropRoot, (0, $kLZMq.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $dP0oo.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $kLZMq.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $cb219f8ff05770a2$export$2e2bcd8739ae039 = $cb219f8ff05770a2$var$Backdrop;



var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $5a34819dbf9e86c4$export$67960e22b12a638d(slot) {
    return (0, $dYzHx.default)('MuiModal', slot);
}
const $5a34819dbf9e86c4$var$modalClasses = (0, $d0ZgE.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $5a34819dbf9e86c4$export$2e2bcd8739ae039 = $5a34819dbf9e86c4$var$modalClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $72c4c983a9f0d793$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $72c4c983a9f0d793$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $5a34819dbf9e86c4$export$67960e22b12a638d), classes);
};
const $72c4c983a9f0d793$var$ModalRoot = (0, $k5hQd.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kLZMq.default)({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: 'hidden'
    }));
const $72c4c983a9f0d793$var$ModalBackdrop = (0, $k5hQd.default)((0, $cb219f8ff05770a2$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $72c4c983a9f0d793$var$Modal = /*#__PURE__*/ $28UcW.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $l9mID.default)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $72c4c983a9f0d793$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $53Ou4.default)(props, $72c4c983a9f0d793$var$_excluded);
    const propsWithDefaults = (0, $kLZMq.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $b809dc4b0a40d7d1$export$33ffd74ebf07f060)((0, $kLZMq.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $kLZMq.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $72c4c983a9f0d793$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $72c4c983a9f0d793$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $308c9efc97ee800b$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $dP0oo.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $308c9efc97ee800b$export$1e5c9e6e4e15efe3)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $kLZMq.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $dP0oo.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $0ab0701d905c1589$export$602eac185826482c), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)(RootSlot, (0, $kLZMq.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $4XrX4.jsx)(BackdropSlot, (0, $kLZMq.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d636f765f92576ff$export$34eba2437817a67b), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $28UcW.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $72c4c983a9f0d793$export$2e2bcd8739ae039 = $72c4c983a9f0d793$var$Modal;




var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");



var $1fz9F = parcelRequire("1fz9F");

var $aMDDU = parcelRequire("aMDDU");

var $k5hQd = parcelRequire("k5hQd");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $ac36e38d8c0b5f78$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $ac36e38d8c0b5f78$export$2e2bcd8739ae039 = $ac36e38d8c0b5f78$var$getOverlayAlpha;



var $l9mID = parcelRequire("l9mID");


var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $1babcd97b2b11eef$export$29cdb466b9b6f20b(slot) {
    return (0, $dYzHx.default)('MuiPaper', slot);
}
const $1babcd97b2b11eef$var$paperClasses = (0, $d0ZgE.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $1babcd97b2b11eef$export$2e2bcd8739ae039 = $1babcd97b2b11eef$var$paperClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $ac02ff9d8c78ed7f$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $ac02ff9d8c78ed7f$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $1babcd97b2b11eef$export$29cdb466b9b6f20b), classes);
};
const $ac02ff9d8c78ed7f$var$PaperRoot = (0, $k5hQd.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $kLZMq.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, $kLZMq.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $aMDDU.alpha)('#fff', (0, $ac36e38d8c0b5f78$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $aMDDU.alpha)('#fff', (0, $ac36e38d8c0b5f78$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $ac02ff9d8c78ed7f$var$Paper = /*#__PURE__*/ $28UcW.forwardRef(function Paper(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $53Ou4.default)(props, $ac02ff9d8c78ed7f$var$_excluded);
    const ownerState = (0, $kLZMq.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $ac02ff9d8c78ed7f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4XrX4.jsx)($ac02ff9d8c78ed7f$var$PaperRoot, (0, $kLZMq.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $dP0oo.default)(classes.root, className),
        ref: ref
    }, other));
});
var $ac02ff9d8c78ed7f$export$2e2bcd8739ae039 = $ac02ff9d8c78ed7f$var$Paper;



var $l9mID = parcelRequire("l9mID");

var $k5hQd = parcelRequire("k5hQd");

var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $b366dcde1e094d06$export$2177af0aa15c34c2(slot) {
    return (0, $dYzHx.default)('MuiDialog', slot);
}
const $b366dcde1e094d06$var$dialogClasses = (0, $d0ZgE.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $b366dcde1e094d06$export$2e2bcd8739ae039 = $b366dcde1e094d06$var$dialogClasses;



var $28UcW = parcelRequire("28UcW");
const $18aa0493e8a28dcb$var$DialogContext = /*#__PURE__*/ $28UcW.createContext({});
var $18aa0493e8a28dcb$export$2e2bcd8739ae039 = $18aa0493e8a28dcb$var$DialogContext;





var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $74c5b717dc6d45d0$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $74c5b717dc6d45d0$var$DialogBackdrop = (0, $k5hQd.default)((0, $cb219f8ff05770a2$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $74c5b717dc6d45d0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $1mNk8.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $1mNk8.default)(scroll)}`,
            `paperWidth${(0, $1mNk8.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $b366dcde1e094d06$export$2177af0aa15c34c2), classes);
};
const $74c5b717dc6d45d0$var$DialogRoot = (0, $k5hQd.default)((0, $72c4c983a9f0d793$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $74c5b717dc6d45d0$var$DialogContainer = (0, $k5hQd.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $1mNk8.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kLZMq.default)({
        height: '100%',
        '@media print': {
            height: 'auto'
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.scroll === 'body' && {
        overflowY: 'auto',
        overflowX: 'hidden',
        textAlign: 'center',
        '&::after': {
            content: '""',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '100%',
            width: '0'
        }
    }));
const $74c5b717dc6d45d0$var$DialogPaper = (0, $k5hQd.default)((0, $ac02ff9d8c78ed7f$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $1mNk8.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $1mNk8.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kLZMq.default)({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        // Fix IE11 issue, to remove at some point.
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        }
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100% - 64px)'
    }, ownerState.scroll === 'body' && {
        display: 'inline-block',
        verticalAlign: 'middle',
        textAlign: 'left' // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: 'calc(100% - 64px)'
    }, ownerState.maxWidth === 'xs' && {
        maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $b366dcde1e094d06$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $b366dcde1e094d06$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.fullWidth && {
        width: 'calc(100% - 64px)'
    }, ownerState.fullScreen && {
        margin: 0,
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: 'none',
        borderRadius: 0,
        [`&.${(0, $b366dcde1e094d06$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: '100%'
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $74c5b717dc6d45d0$var$Dialog = /*#__PURE__*/ $28UcW.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $93b513bca024249e$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $ac02ff9d8c78ed7f$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', TransitionComponent: TransitionComponent = (0, $e78145f8e8c6d3d4$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $53Ou4.default)(props, $74c5b717dc6d45d0$var$_excluded);
    const ownerState = (0, $kLZMq.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $74c5b717dc6d45d0$var$useUtilityClasses(ownerState);
    const backdropClick = $28UcW.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $930be18af46897d8$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $28UcW.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $4XrX4.jsx)($74c5b717dc6d45d0$var$DialogRoot, (0, $kLZMq.default)({
        className: (0, $dP0oo.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $74c5b717dc6d45d0$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $kLZMq.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $4XrX4.jsx)(TransitionComponent, (0, $kLZMq.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $4XrX4.jsx)($74c5b717dc6d45d0$var$DialogContainer, {
                className: (0, $dP0oo.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $4XrX4.jsx)($74c5b717dc6d45d0$var$DialogPaper, (0, $kLZMq.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $dP0oo.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $18aa0493e8a28dcb$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $74c5b717dc6d45d0$export$2e2bcd8739ae039 = $74c5b717dc6d45d0$var$Dialog;


var $e321c78d6bed6c1c$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($e321c78d6bed6c1c$exports, "__esModule", {
    value: true
});
$e321c78d6bed6c1c$exports.default = void 0;

var $e321c78d6bed6c1c$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $e321c78d6bed6c1c$var$_default = $e321c78d6bed6c1c$exports.default = (0, $e321c78d6bed6c1c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92"
}), 'Share');







const $f41d6f824c6cdd3f$var$getScheduleText = (puzzleName)=>{
    switch(puzzleName){
        case (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Megarubigram:
            return "Megarubigram updates on Tuesdays and Fridays.";
        case (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword5x5:
            return "Pathword 5x5 updates on Tuesdays and Fridays.";
        case (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Morphology:
            return "New Morphology puzzles every weekday.";
        case (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Ultrarubigram:
            return "Ultrarubigram updates on the first of each month.";
        default:
            return "New puzzle daily.";
    }
};
const $f41d6f824c6cdd3f$var$StatsDialog = ({ puzzleName: puzzleName, store: store })=>{
    const { statsDialogIsOpen: statsDialogIsOpen, solved: solved, time: time, revealed: revealed, completed: completed, puzzleId: puzzleId } = store.useState();
    const [showClipboardAlert, setShowClipboardAlert] = (0, $28UcW.useState)(false);
    const userData = (0, $e2662af8a2ab1f76$export$986181c251d527c3).useState((s)=>s.userData);
    const puzzleStats = userData?.stats[puzzleName];
    const todaysTimeFormatted = (0, $ba1e3b359abf28ef$export$bc733b0c5cbb3e8a)(time);
    const numPlayed = puzzleStats?.numPlayed || 0;
    const numSolved = puzzleStats?.numSolved || 0;
    const percentWins = Math.round(numSolved / numPlayed * 100) || 0;
    const currentStreak = puzzleStats?.currentStreak;
    const bestTime = puzzleStats?.bestTime || 0;
    const averageTime = puzzleStats?.averageTime || 0;
    const numUnder10 = puzzleStats?.under10 ?? null;
    const numUnder30 = puzzleStats?.under30 ?? null;
    const numUnder60 = puzzleStats?.under60 ?? null;
    const numUnder120 = puzzleStats?.under120 ?? null;
    const numUnder300 = puzzleStats?.under300 ?? null;
    const numUnder600 = puzzleStats?.under600 ?? null;
    const numUnder1200 = puzzleStats?.under1200 ?? null;
    const numUnder2400 = puzzleStats?.under2400 ?? null;
    const numUnder3600 = puzzleStats?.under3600 ?? null;
    const onClose = ()=>{
        store.update((s)=>{
            s.statsDialogIsOpen = false;
            s.isSoftPaused = false;
        });
    };
    const onShare = ()=>{
        const shareCode = (0, $b2cd9ecc66d0956f$exports.isMobile) ? (0, $860afe5c90b07ab1$export$718e7ec1812fe0e9)[puzzleName + (0, $860afe5c90b07ab1$export$84fc02f9706d391f)] : (0, $860afe5c90b07ab1$export$718e7ec1812fe0e9)[puzzleName + (0, $860afe5c90b07ab1$export$cc7ad1873fe327df)];
        const puzzleUrl = `https://dailybaffle.com/${puzzleName}?utm_source=${shareCode}`;
        let resultText = `I solved ${(0, $860afe5c90b07ab1$export$db7e8528fe84408c)[puzzleName]} #${puzzleId} in ${todaysTimeFormatted}!`;
        if (navigator.share && (0, $b2cd9ecc66d0956f$exports.isMobile)) navigator.share({
            text: resultText,
            url: puzzleUrl
        });
        else {
            resultText = `${resultText}\n${puzzleUrl}`;
            navigator.clipboard.writeText(resultText);
            setShowClipboardAlert(true);
            setTimeout(()=>{
                setShowClipboardAlert(false);
            }, 1000);
        }
    };
    const createAccount = ()=>{
        (0, $e2662af8a2ab1f76$export$986181c251d527c3).update((s)=>{
            s.signInDialog.isOpen = true;
        });
        setTimeout(()=>{
            onClose();
        }, 100);
    };
    const shouldShowShare = [
        (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Morphology,
        (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Arithmeglyphs
    ].includes(puzzleName) ? completed : solved || revealed;
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $4XrX4.Fragment), {
        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $74c5b717dc6d45d0$export$2e2bcd8739ae039), {
            onClose: onClose,
            open: statsDialogIsOpen,
            children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "statsDialogContent",
                children: [
                    showClipboardAlert && /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "clipboardAlert",
                        children: "Copied results to clipboard"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("h1", {
                        children: [
                            (0, $860afe5c90b07ab1$export$db7e8528fe84408c)[puzzleName],
                            " Stats"
                        ]
                    }),
                    solved ? /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                                className: "topStatsMessage",
                                children: `You solved today's puzzle in ${todaysTimeFormatted}. Nice work!`
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                                className: "bottomStatsMessage",
                                children: $f41d6f824c6cdd3f$var$getScheduleText(puzzleName)
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                                className: "topStatsMessage",
                                children: revealed ? `Today's puzzle was revealed.` : `You haven't solved today's puzzle yet.`
                            }),
                            revealed && /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                                className: "bottomStatsMessage",
                                children: $f41d6f824c6cdd3f$var$getScheduleText(puzzleName)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "statsDisplayContainer",
                        children: [
                            !userData && /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "signedOutStatsCover",
                                children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                    className: "signedOutMessage",
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                            onClick: createAccount,
                                            children: "Create a free account"
                                        }),
                                        " to keep track of your daily stats!"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: "topStatsRow",
                                children: [
                                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "value",
                                                children: numPlayed
                                            }),
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "label",
                                                children: "Played"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "value",
                                                children: numSolved
                                            }),
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "label",
                                                children: "Solved"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                                className: "value",
                                                children: [
                                                    percentWins,
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "label",
                                                children: "Solve Rate"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: "middleStatsRow",
                                children: [
                                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "value",
                                                children: currentStreak
                                            }),
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "label",
                                                children: "Solve Streak"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "value",
                                                children: (0, $ba1e3b359abf28ef$export$bc733b0c5cbb3e8a)(averageTime)
                                            }),
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "label",
                                                children: "Average Time"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "value",
                                                children: (0, $ba1e3b359abf28ef$export$bc733b0c5cbb3e8a)(bestTime)
                                            }),
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "label",
                                                children: "Best Time"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("h2", {
                                children: "Solve Times"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: "bottomStatsRow",
                                children: [
                                    numUnder10 !== null && /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "value",
                                                children: numUnder10
                                            }),
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "label",
                                                children: "<10s"
                                            })
                                        ]
                                    }),
                                    numUnder30 !== null && /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "value",
                                                children: numUnder30
                                            }),
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "label",
                                                children: "<30s"
                                            })
                                        ]
                                    }),
                                    numUnder60 !== null && /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "value",
                                                children: numUnder60
                                            }),
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "label",
                                                children: "<60s"
                                            })
                                        ]
                                    }),
                                    numUnder120 !== null && /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "value",
                                                children: numUnder120
                                            }),
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "label",
                                                children: "<2m"
                                            })
                                        ]
                                    }),
                                    numUnder300 !== null && /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "value",
                                                children: numUnder300
                                            }),
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "label",
                                                children: "<5m"
                                            })
                                        ]
                                    }),
                                    numUnder600 !== null && /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "value",
                                                children: numUnder600
                                            }),
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "label",
                                                children: "<10m"
                                            })
                                        ]
                                    }),
                                    numUnder1200 !== null && /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "value",
                                                children: numUnder1200
                                            }),
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "label",
                                                children: "<20m"
                                            })
                                        ]
                                    }),
                                    numUnder2400 !== null && /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "value",
                                                children: numUnder2400
                                            }),
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "label",
                                                children: "<40m"
                                            })
                                        ]
                                    }),
                                    numUnder3600 !== null && /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "value",
                                                children: numUnder3600
                                            }),
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                className: "label",
                                                children: "<1h"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "statsButtonsContainer",
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                                onClick: onClose,
                                children: "View Puzzle"
                            }),
                            shouldShowShare && /*#__PURE__*/ (0, $4XrX4.jsxs)("button", {
                                className: "shareButton",
                                onClick: onShare,
                                children: [
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                        children: "Share"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e321c78d6bed6c1c$exports))), {})
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $f41d6f824c6cdd3f$export$2e2bcd8739ae039 = $f41d6f824c6cdd3f$var$StatsDialog;


var $1d9a1bb1e0e16baf$export$2e2bcd8739ae039 = (0, $f41d6f824c6cdd3f$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

var $b4a213a738a62de4$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($b4a213a738a62de4$exports, "__esModule", {
    value: true
});
$b4a213a738a62de4$exports.default = void 0;

var $b4a213a738a62de4$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $b4a213a738a62de4$var$_default = $b4a213a738a62de4$exports.default = (0, $b4a213a738a62de4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



const $2bbc7cde64cbe8e7$var$CustomRevealConfirmationDialog = ({ isOpen: isOpen, onConfirm: onConfirm, onClose: onClose, prompt: prompt, store: store })=>{
    const onCloseWrapper = ()=>{
        store.update((s)=>{
            s.isSoftPaused = false;
        });
        onClose();
    };
    const onConfirmWrapper = ()=>{
        store.update((s)=>{
            s.isSoftPaused = false;
        });
        onConfirm();
        onClose();
    };
    const displayPrompt = prompt || 'Are you utterly certain? This puzzle will count as revealed and be excluded from any solve streak.';
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $74c5b717dc6d45d0$export$2e2bcd8739ae039), {
        open: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
            className: "revealConfirmationDialogContent",
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                    className: "closeButton",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b4a213a738a62de4$exports))), {})
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                    className: "prompt",
                    children: displayPrompt
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                    className: "decisionButton",
                    onClick: onCloseWrapper,
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                    className: "decisionButton revealButton",
                    onClick: onConfirmWrapper,
                    children: "Confirm"
                })
            ]
        })
    });
};
var $2bbc7cde64cbe8e7$export$2e2bcd8739ae039 = $2bbc7cde64cbe8e7$var$CustomRevealConfirmationDialog;


const $9e21341151e80584$var$RevealConfirmationDialogCluster = ()=>{
    const { confirmationDialogs: confirmationDialogs } = (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).useState();
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2bbc7cde64cbe8e7$export$2e2bcd8739ae039), {
                store: (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f),
                onConfirm: (0, $8a5badd6ef6136ba$export$a9ce59cabf26964d),
                onClose: ()=>{
                    (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
                        s.confirmationDialogs.checkGlyphIsOpen = false;
                    });
                },
                isOpen: confirmationDialogs.checkGlyphIsOpen
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2bbc7cde64cbe8e7$export$2e2bcd8739ae039), {
                store: (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f),
                onConfirm: (0, $8a5badd6ef6136ba$export$ed0314765beb2ba1),
                onClose: ()=>{
                    (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
                        s.confirmationDialogs.checkPuzzleIsOpen = false;
                    });
                },
                isOpen: confirmationDialogs.checkPuzzleIsOpen
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2bbc7cde64cbe8e7$export$2e2bcd8739ae039), {
                store: (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f),
                onConfirm: (0, $8a5badd6ef6136ba$export$853a3f346cd0e68f),
                onClose: ()=>{
                    (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
                        s.confirmationDialogs.revealGlyphIsOpen = false;
                    });
                },
                isOpen: confirmationDialogs.revealGlyphIsOpen
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2bbc7cde64cbe8e7$export$2e2bcd8739ae039), {
                store: (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f),
                onConfirm: (0, $8a5badd6ef6136ba$export$48a1b615b62a793),
                onClose: ()=>{
                    (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
                        s.confirmationDialogs.revealPuzzleIsOpen = false;
                    });
                },
                isOpen: confirmationDialogs.revealPuzzleIsOpen,
                prompt: "Are you sure you want to reveal the full puzzle? This puzzle will count as revealed and be excluded from any solve streak."
            })
        ]
    });
};
var $9e21341151e80584$export$2e2bcd8739ae039 = $9e21341151e80584$var$RevealConfirmationDialogCluster;






var $hjLll = parcelRequire("hjLll");

var $4XrX4 = parcelRequire("4XrX4");
"use client";
var $bd71d3bf9adc9947$export$2e2bcd8739ae039 = (0, $hjLll.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m7.46 7.12-2.78 1.15c-.51-1.36-1.58-2.44-2.95-2.94l1.15-2.78c2.1.8 3.77 2.47 4.58 4.57M12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3M9.13 4.54l1.17 2.78c-1.38.5-2.47 1.59-2.98 2.97L4.54 9.13c.81-2.11 2.48-3.78 4.59-4.59M4.54 14.87l2.78-1.15c.51 1.38 1.59 2.46 2.97 2.96l-1.17 2.78c-2.1-.81-3.77-2.48-4.58-4.59m10.34 4.59-1.15-2.78c1.37-.51 2.45-1.59 2.95-2.97l2.78 1.17c-.81 2.1-2.48 3.77-4.58 4.58"
}), 'Support');


const $d3542e50feca41f9$var$AssistToolbar = ()=>{
    const { completed: completed, combinedDropdownIsOpen: combinedDropdownIsOpen, checkDropdownIsOpen: checkDropdownIsOpen, revealDropdownIsOpen: revealDropdownIsOpen } = (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).useState();
    const ref = (0, $28UcW.useRef)(null);
    const useMobileDimensions = (0, $ba1e3b359abf28ef$export$580e0f6db19fa7cc)() || (0, $b2cd9ecc66d0956f$exports.isMobile);
    // If a click is outside the toolbar, it closes all menus.
    // A click within the menu is handled by togglesMenus, which closes all but the clicked one.
    (0, $28UcW.useEffect)(()=>{
        const onClickOutside = (e)=>{
            if (ref.current && !ref.current.contains(e.target)) {
                (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
                    s.revealDropdownIsOpen = false;
                    s.checkDropdownIsOpen = false;
                    s.combinedDropdownIsOpen = false;
                });
                document.removeEventListener('click', onClickOutside);
            }
        };
        if (checkDropdownIsOpen || revealDropdownIsOpen || combinedDropdownIsOpen) document.addEventListener('click', onClickOutside);
        return ()=>{
            document.removeEventListener('click', onClickOutside);
        };
    }, [
        checkDropdownIsOpen,
        revealDropdownIsOpen,
        combinedDropdownIsOpen
    ]);
    const toggleMenus = (index)=>{
        switch(index){
            case 1:
                (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
                    s.checkDropdownIsOpen = !s.checkDropdownIsOpen;
                    s.revealDropdownIsOpen = false;
                    s.combinedDropdownIsOpen = false;
                });
                break;
            case 2:
                (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
                    s.checkDropdownIsOpen = false;
                    s.revealDropdownIsOpen = !s.revealDropdownIsOpen;
                    s.combinedDropdownIsOpen = false;
                });
                break;
            case 3:
                (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
                    s.checkDropdownIsOpen = false;
                    s.revealDropdownIsOpen = false;
                    s.combinedDropdownIsOpen = !s.combinedDropdownIsOpen;
                });
                break;
        }
    };
    if (useMobileDimensions) return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        ref: ref,
        className: "assistToolbar mobileToolbar arithmeglyphsToolbar",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $9e21341151e80584$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "dropdownButton",
                onClick: ()=>{
                    (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
                        s.combinedDropdownIsOpen = !s.combinedDropdownIsOpen;
                    });
                },
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "buttonLabel",
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                            disableRipple: true,
                            disableTouchRipple: true,
                            children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $bd71d3bf9adc9947$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                        className: `dropdownMenu revealMenu ${combinedDropdownIsOpen ? 'open' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                onClick: ()=>(0, $8a5badd6ef6136ba$export$9b2690a4578612b0)((0, $8a5badd6ef6136ba$export$105770301816d0f9).CheckGlyph),
                                children: "Check Glyph"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                onClick: ()=>(0, $8a5badd6ef6136ba$export$9b2690a4578612b0)((0, $8a5badd6ef6136ba$export$105770301816d0f9).CheckPuzzle),
                                children: "Check Puzzle"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                onClick: ()=>(0, $8a5badd6ef6136ba$export$9b2690a4578612b0)((0, $8a5badd6ef6136ba$export$105770301816d0f9).RevealGlyph),
                                children: "Reveal Glyph"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                onClick: ()=>(0, $8a5badd6ef6136ba$export$9b2690a4578612b0)((0, $8a5badd6ef6136ba$export$105770301816d0f9).RevealPuzzle),
                                children: "Reveal Puzzle"
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        ref: ref,
        className: "assistToolbar arithmeglyphsToolbar",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $9e21341151e80584$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "dropdownButton",
                onClick: ()=>toggleMenus(1),
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "buttonLabel",
                        children: "Check"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                        className: `dropdownMenu checkMenu ${checkDropdownIsOpen ? 'open' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                onClick: ()=>{
                                    (0, $8a5badd6ef6136ba$export$9b2690a4578612b0)((0, $8a5badd6ef6136ba$export$105770301816d0f9).CheckGlyph);
                                },
                                children: "Glyph"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                onClick: ()=>{
                                    (0, $8a5badd6ef6136ba$export$9b2690a4578612b0)((0, $8a5badd6ef6136ba$export$105770301816d0f9).CheckPuzzle);
                                },
                                children: "Puzzle"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "dropdownButton",
                onClick: ()=>toggleMenus(2),
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "buttonLabel",
                        children: "Reveal"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                        className: `dropdownMenu revealMenu ${revealDropdownIsOpen ? 'open' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                onClick: ()=>{
                                    (0, $8a5badd6ef6136ba$export$9b2690a4578612b0)((0, $8a5badd6ef6136ba$export$105770301816d0f9).RevealGlyph);
                                },
                                children: "Glyph"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                onClick: ()=>{
                                    (0, $8a5badd6ef6136ba$export$9b2690a4578612b0)((0, $8a5badd6ef6136ba$export$105770301816d0f9).RevealPuzzle);
                                },
                                children: "Puzzle"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $d3542e50feca41f9$export$2e2bcd8739ae039 = $d3542e50feca41f9$var$AssistToolbar;



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");



const $74661742cb91806b$var$InstructionsDialog = ({ isOpen: isOpen, onClose: onClose, className: className, children: children })=>{
    const contentClass = 'instructionsDialogContent' + (className ? ` ${className}` : '');
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $74c5b717dc6d45d0$export$2e2bcd8739ae039), {
        open: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
            className: contentClass,
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                    className: "closeButton",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b4a213a738a62de4$exports))), {})
                }),
                children
            ]
        })
    });
};
var $74661742cb91806b$export$2e2bcd8739ae039 = $74661742cb91806b$var$InstructionsDialog;


var $a923e83bee9905be$export$2e2bcd8739ae039 = (0, $74661742cb91806b$export$2e2bcd8739ae039);


var $f3e73e32852a9a16$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($f3e73e32852a9a16$exports, "__esModule", {
    value: true
});
$f3e73e32852a9a16$exports.default = void 0;

var $f3e73e32852a9a16$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $f3e73e32852a9a16$var$_default = $f3e73e32852a9a16$exports.default = (0, $f3e73e32852a9a16$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z"
}), 'ArrowForwardIos');


var $29c2a91f42039c33$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($29c2a91f42039c33$exports, "__esModule", {
    value: true
});
$29c2a91f42039c33$exports.default = void 0;

var $29c2a91f42039c33$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $29c2a91f42039c33$var$_default = $29c2a91f42039c33$exports.default = (0, $29c2a91f42039c33$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M11.67 3.87 9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"
}), 'ArrowBackIos');



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");
var $904b700d578607f5$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($904b700d578607f5$exports, "__esModule", {
    value: true
});
$904b700d578607f5$exports.default = void 0;

var $904b700d578607f5$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $904b700d578607f5$var$_default = $904b700d578607f5$exports.default = (0, $904b700d578607f5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "m19 15-1.41-1.41L13 18.17V2h-2v16.17l-4.59-4.59L5 15l7 7z"
}), 'South');


var $3581768918032efa$exports = {};
$3581768918032efa$exports = import.meta.resolve("cDIT6");


var $d081d358b5a5ec6f$exports = {};
$d081d358b5a5ec6f$exports = import.meta.resolve("3fivt");


var $ac2f34a72ad27b87$exports = {};
$ac2f34a72ad27b87$exports = import.meta.resolve("fbUEF");


var $94fedd3111359b4a$exports = {};
$94fedd3111359b4a$exports = import.meta.resolve("fl26n");


var $811f00d1bfaaeb55$exports = {};
$811f00d1bfaaeb55$exports = import.meta.resolve("eCcoq");


var $13ad7e98a4e24693$exports = {};
$13ad7e98a4e24693$exports = import.meta.resolve("hpdiu");


var $ce535b826eb32b9c$exports = {};
$ce535b826eb32b9c$exports = import.meta.resolve("La71R");


var $90c08f1f63af961f$exports = {};
$90c08f1f63af961f$exports = import.meta.resolve("iBsLp");


var $04eabaf03912825f$exports = {};
$04eabaf03912825f$exports = import.meta.resolve("etvcD");


const $3716177ac8d3c4fa$export$e4d29f0c4f6a05ae = ()=>{
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "page",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "In Arithmeglyphs, you must work backwards from the third line to fill in the numbers that have been blanked out on the first two lines."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                className: "instructionsSeq5",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($811f00d1bfaaeb55$exports)))
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                className: "instructionsSeq6",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($13ad7e98a4e24693$exports)))
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                className: "instructionsSeq4 page3seq4",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($94fedd3111359b4a$exports)))
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                children: [
                    "The shapes placed randomly around some of the blanks are ",
                    /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                        className: "italicText",
                        children: "operator glyphs"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "Line 1's glyphs and hidden numbers together produced the hidden numbers on line 2. Line 2's glyphs and hidden numbers produced the final sequence of 4129 on line 3."
            })
        ]
    });
};
const $3716177ac8d3c4fa$export$ea983f8f94c1a3bd = ()=>{
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "page",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "To learn how to work backwards, let's see how glyphs produce new number sequences going forwards."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                children: [
                    "A puzzle starts with a random sequence like ",
                    /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                        className: "boldText",
                        children: "421"
                    }),
                    ", and some glyphs are placed on it at random. Then we go left to right."
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "If a digit has no glyph, that digit carries over to the next sequence unchanged."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "operatorReferenceContainer",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                        className: "squareExample",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($90c08f1f63af961f$exports)))
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                        className: "referenceText",
                        children: "Square this digit"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "operatorReferenceContainer",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                        className: "triangleExample",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($04eabaf03912825f$exports)))
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                        className: "referenceText",
                        children: "Multiply this digit by 3"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                className: "instructionsSeq1",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($3581768918032efa$exports)))
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($904b700d578607f5$exports))), {
                className: "downwardArrow"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                className: "instructionsSeq2",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($d081d358b5a5ec6f$exports)))
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "Only individual digits matter, so that's not a 16 anymore - it's just a 1 and a 6 now."
            })
        ]
    });
};
const $3716177ac8d3c4fa$export$88e3273e895d21c = ()=>{
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "page",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "Next, a new random pattern of glyphs is applied to this second number sequence."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                children: [
                    "A blue rectangle around multiple digits means that those operator results are added together before placing the resulting digits on the next line. ",
                    /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                        className: "boldText",
                        children: "6 + (2 \xd7 3) = 12"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "operatorReferenceContainer",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                        className: "diamondExample",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ce535b826eb32b9c$exports)))
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                        className: "referenceText",
                        children: "Multiply this digit by 4"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                className: "instructionsSeq1",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($3581768918032efa$exports)))
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($904b700d578607f5$exports))), {
                className: "downwardArrow"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                className: "instructionsSeq3",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($ac2f34a72ad27b87$exports)))
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($904b700d578607f5$exports))), {
                className: "downwardArrow"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                className: "instructionsSeq4",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($94fedd3111359b4a$exports)))
            })
        ]
    });
};
const $3716177ac8d3c4fa$export$d78a8dae90141fc2 = ()=>{
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "page",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                children: [
                    "Finally, the digits of the first two sequences are erased, leaving only the glyph pattern and the third number sequence. ",
                    /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                    " This is what you're given."
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                className: "instructionsSeq5",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($811f00d1bfaaeb55$exports)))
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                className: "instructionsSeq6",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($13ad7e98a4e24693$exports)))
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                className: "instructionsSeq4 page3seq4",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($94fedd3111359b4a$exports)))
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "To solve the puzzle, you must work backwards from the third line to reconstruct the original starting sequence."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "There are no 0s on the first line, no negative numbers at all, and only one solution. Good luck!"
            })
        ]
    });
};





const $d41918f78b32ec10$export$24603e4b2e690832 = ({ numDots: numDots, page: page, onDotClick: onDotClick })=>{
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "dotContainer",
        children: [
            0,
            1,
            2,
            3
        ].map((index)=>/*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: `dot ${page === index ? 'active' : ''}`,
                onClick: ()=>onDotClick(index)
            }, index))
    });
};
const $d41918f78b32ec10$var$Instructions = ()=>{
    const instructionsAreOpen = (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).useState((s)=>s.instructionsAreOpen);
    const [page, setPage] = (0, $28UcW.useState)(0);
    const closeInstructions = ()=>{
        (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
            s.instructionsAreOpen = false;
            s.isSoftPaused = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).set(`${(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Arithmeglyphs}InstructionsDismissed`, 'true', {
            domain: (0, $ba1e3b359abf28ef$export$517466abcb8fcf10),
            expires: 365
        });
        setTimeout(()=>setPage(0), 100);
    };
    const nextPage = ()=>{
        if (page < 3) setPage(page + 1);
    };
    const prevPage = ()=>{
        if (page > 0) setPage(page - 1);
    };
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $a923e83bee9905be$export$2e2bcd8739ae039), {
        isOpen: instructionsAreOpen,
        onClose: closeInstructions,
        className: "arithmeglyphsInstructions",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("h1", {
                className: "instructionsTitle",
                children: "How to Play Arithmeglyphs"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "pages",
                style: {
                    transform: `translateX(-${page * 25}%)`
                },
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $3716177ac8d3c4fa$export$e4d29f0c4f6a05ae), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $3716177ac8d3c4fa$export$ea983f8f94c1a3bd), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $3716177ac8d3c4fa$export$88e3273e895d21c), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $3716177ac8d3c4fa$export$d78a8dae90141fc2), {})
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "navigation",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                        onClick: prevPage,
                        disabled: page === 0,
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($29c2a91f42039c33$exports))), {})
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)($d41918f78b32ec10$export$24603e4b2e690832, {
                        numDots: 4,
                        page: page,
                        onDotClick: (i)=>{
                            setPage(i);
                        }
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                        onClick: nextPage,
                        disabled: page === 3,
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f3e73e32852a9a16$exports))), {})
                    })
                ]
            })
        ]
    });
};
var $d41918f78b32ec10$export$2e2bcd8739ae039 = $d41918f78b32ec10$var$Instructions;





var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");









const $2ad1591c8d5a726e$var$MobileInstructions = ()=>{
    const isOpen = (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).useState((s)=>s.instructionsAreOpen);
    const [page, setPage] = (0, $28UcW.useState)(0);
    const nextPage = ()=>{
        if (page < 3) setPage(page + 1);
    };
    const prevPage = ()=>{
        if (page > 0) setPage(page - 1);
    };
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: `arithmeglyphsMobileInstructions ${isOpen ? 'popupOpen' : ''}`,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "popupHeader",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                        className: "closeButton",
                        onClick: ()=>{
                            (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
                                s.instructionsAreOpen = false;
                                s.isSoftPaused = false;
                            });
                            (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).set(`${(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Arithmeglyphs}InstructionsDismissed`, 'true', {
                                domain: (0, $ba1e3b359abf28ef$export$517466abcb8fcf10),
                                expires: 365
                            });
                            setTimeout(()=>setPage(0), 100);
                        },
                        children: "\xd7"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("h2", {
                        className: "popupTitle",
                        children: "How to Play Arithmeglyphs"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "popupBody",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "pages",
                        style: {
                            transform: `translateX(-${page * 25}%)`
                        },
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $3716177ac8d3c4fa$export$e4d29f0c4f6a05ae), {}),
                            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $3716177ac8d3c4fa$export$ea983f8f94c1a3bd), {}),
                            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $3716177ac8d3c4fa$export$88e3273e895d21c), {}),
                            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $3716177ac8d3c4fa$export$d78a8dae90141fc2), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "navigation",
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                                onClick: prevPage,
                                disabled: page === 0,
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($29c2a91f42039c33$exports))), {})
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d41918f78b32ec10$export$24603e4b2e690832), {
                                numDots: 4,
                                page: page,
                                onDotClick: (i)=>{
                                    setPage(i);
                                }
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                                onClick: nextPage,
                                disabled: page === 3,
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f3e73e32852a9a16$exports))), {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $2ad1591c8d5a726e$export$2e2bcd8739ae039 = $2ad1591c8d5a726e$var$MobileInstructions;


var $57a0da092fd353aa$export$2e2bcd8739ae039 = (0, $2ad1591c8d5a726e$export$2e2bcd8739ae039);



const $190fdde7f506ae97$var$ArithmeglyphsTopBar = ()=>{
    const { completed: completed, time: time, isPaused: isPaused } = (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).useState();
    const useMobileStyles = (0, $b2cd9ecc66d0956f$exports.isMobile) || (0, $ba1e3b359abf28ef$export$580e0f6db19fa7cc)();
    const navigate = (0, $6e00b7bb3feca34a$export$9770f232ac06a008)();
    const pauseButtonClass = completed ? 'hidden' : '';
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: `puzzleTopBar arithmeglyphsTopBar ${useMobileStyles ? 'mobile' : ''}`,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "topBarLeftSection",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        disableRipple: true,
                        title: "Back",
                        onClick: ()=>{
                            navigate('/');
                            window.scrollTo(0, 0);
                            (0, $8a5badd6ef6136ba$export$a020a0ba86fc9904)();
                        },
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ba2d2837fc619c75$exports))), {})
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "navigationLabel",
                        children: (0, $860afe5c90b07ab1$export$db7e8528fe84408c)[(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Arithmeglyphs]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "topBarMiddleSection",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "timer",
                        children: (0, $ba1e3b359abf28ef$export$3203edd9e5edd663)(time)
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        className: pauseButtonClass,
                        title: "Pause",
                        onClick: ()=>{
                            (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
                                if (!s.isPaused) (0, $8a5badd6ef6136ba$export$a020a0ba86fc9904)();
                                s.isPaused = !s.isPaused;
                            });
                            window.scrollTo(0, 0);
                        },
                        children: isPaused ? /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($815c4a10c6ca199f$exports))), {}) : /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($be547dbdaf888d8e$exports))), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "topBarRightSection",
                children: [
                    (0, $b2cd9ecc66d0956f$exports.isMobile) ? /*#__PURE__*/ (0, $4XrX4.jsx)((0, $57a0da092fd353aa$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d41918f78b32ec10$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $1d9a1bb1e0e16baf$export$2e2bcd8739ae039), {
                        puzzleName: (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Arithmeglyphs,
                        store: (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f)
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d3542e50feca41f9$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        disableRipple: true,
                        title: "How to Play",
                        onClick: ()=>{
                            (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
                                s.instructionsAreOpen = true;
                                s.isSoftPaused = true;
                            });
                        },
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($98556d5fcc3acbf1$exports))), {})
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        disableRipple: true,
                        title: "Stats",
                        onClick: ()=>{
                            (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
                                s.statsDialogIsOpen = true;
                                s.isSoftPaused = true;
                            });
                        },
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1e3ba230a1917794$exports))), {})
                    })
                ]
            })
        ]
    });
};
var $190fdde7f506ae97$export$2e2bcd8739ae039 = $190fdde7f506ae97$var$ArithmeglyphsTopBar;




var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");




const $114275e50165c05e$var$GlyphReference = ()=>{
    const isOpen = (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).useState((s)=>s.glyphReferenceIsOpen);
    const useMobileDimensions = (0, $ba1e3b359abf28ef$export$580e0f6db19fa7cc)() || (0, $b2cd9ecc66d0956f$exports.isMobile);
    const containerClasses = (useMobileDimensions ? 'mobileGlyphReference' : 'desktopGlyphReference') + (isOpen ? ' open' : '');
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: containerClasses,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                className: "closeButton",
                onClick: ()=>{
                    (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
                        s.glyphReferenceIsOpen = false;
                    });
                },
                children: "\xd7"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "referenceContentContainer",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "referenceHeader",
                        children: "Glyph Reference"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "scrollContainer",
                        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                            className: "referenceList",
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "itemLabel",
                                            children: "No glyph"
                                        }),
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "itemDescription",
                                            children: "A digit with no glyph will be unchanged."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "itemLabel",
                                            children: "Triangle"
                                        }),
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "itemDescription",
                                            children: "A digit inside a triangle will be multipled by 3."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "itemLabel",
                                            children: "Diamond"
                                        }),
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "itemDescription",
                                            children: "A digit inside a diamond will be multiplied by 4."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "itemLabel",
                                            children: "Square"
                                        }),
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "itemDescription",
                                            children: "A digit inside a square will be squared."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "itemLabel",
                                            children: "Circle"
                                        }),
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "itemDescription",
                                            children: "A digit inside a circle will be rounded down to the next lowest even number. Examples: Circle(4) is 2; Circle(3) is also 2; Circle(2) is 0. A circle will never contain a zero."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "itemLabel",
                                            children: "Dot"
                                        }),
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "itemDescription",
                                            children: "A digit with a single dot over it will have 1 added to its value."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "itemLabel",
                                            children: "Blue rectangle"
                                        }),
                                        /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                            className: "itemDescription",
                                            children: [
                                                /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                                                    children: "When multiple glyphs are enclosed by a blue rectangle, the results of those glyphs will be added together before inserting the resulting digits on the next line."
                                                }),
                                                /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                                                    children: "Note that resulting values of 10 and up are always broken into separate digits on the next line (i.e. 10 would become 1 and 0), but only after all operations take place."
                                                }),
                                                /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                                                    children: "So a blue rectangle around two triangle(4)s plays out as:"
                                                }),
                                                /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                                                    children: "(3 \xd7 4) + (3 \xd7 4) = 24"
                                                }),
                                                /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                                                    children: "Thus, a 2 and a 4 would result on the next line."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $114275e50165c05e$export$2e2bcd8739ae039 = $114275e50165c05e$var$GlyphReference;



var $28UcW = parcelRequire("28UcW");

const $80f684051860af43$export$2500c8a6bc3f2f43 = (puzzleName)=>{
    const trackedRef = (0, $28UcW.useRef)(false);
    (0, $28UcW.useEffect)(()=>{
        // Only track once per mount
        if (trackedRef.current) return;
        trackedRef.current = true;
        // Track puzzle open (fire and forget)
        (0, $ea74087fd5ac399e$export$2e2bcd8739ae039).post('/api/analytics/track-puzzle-open', {
            puzzleName: puzzleName
        }).catch((err)=>{
            // Fail silently - analytics shouldn't break the app
            console.debug('Analytics tracking failed:', err);
        });
    }, [
        puzzleName
    ]);
};



const $815c3d6722b31cd1$var$Arithmeglyphs = ()=>{
    const { solved: solved, completed: completed, dataByLine: dataByLine, thirdLineNumSeq: thirdLineNumSeq, focusLocation: focusLocation } = (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).useState();
    // It's intended to take `revealed` & `solved`, but arithmeglyphs only uses `completed`,
    // so I'm just passing that for both those params so I don't have to make a separate hook.
    (0, $ba1e3b359abf28ef$export$a546a4e9e5b2cdef)((0, $8a5badd6ef6136ba$export$412508d679148d5c), completed, completed);
    (0, $ba1e3b359abf28ef$export$af32271b5d23b0f5)();
    (0, $ba1e3b359abf28ef$export$e73a86b2063a8f6b)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Arithmeglyphs, (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f));
    (0, $ba1e3b359abf28ef$export$20d77ccceac0f55c)((0, $f159c0fbed3d8ee5$export$f0f19936383bf48f), (0, $8a5badd6ef6136ba$export$a020a0ba86fc9904));
    (0, $ba1e3b359abf28ef$export$5b0326dddadcb0de)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Arithmeglyphs);
    (0, $ba1e3b359abf28ef$export$52dc0a972e5b91c5)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Arithmeglyphs);
    (0, $80f684051860af43$export$2500c8a6bc3f2f43)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Arithmeglyphs);
    const isLandscape = window.innerWidth > window.innerHeight && window.innerHeight < 500;
    const useMobileDimensions = (0, $ba1e3b359abf28ef$export$580e0f6db19fa7cc)() || (0, $b2cd9ecc66d0956f$exports.isMobile);
    const disableZeroButton = !completed && (0, $8a5badd6ef6136ba$export$9ce465357ac65a4b)(focusLocation);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $190fdde7f506ae97$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: `puzzleContainer arithmeglyphsContainer ${useMobileDimensions ? 'mobile' : ''} ${isLandscape ? 'landscape' : ''}`,
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $114275e50165c05e$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: `glyphSequencesContainer ${solved ? 'solved' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $9c50a17e4d3104e7$export$2e2bcd8739ae039), {
                                glyphString: dataByLine[0].opSeq,
                                lineNumber: 0
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $9c50a17e4d3104e7$export$2e2bcd8739ae039), {
                                glyphString: dataByLine[1].opSeq,
                                lineNumber: 1
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "thirdLine",
                                children: thirdLineNumSeq.split('').map((digit, i)=>/*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                        className: "thirdLineDigit",
                                        children: digit
                                    }, i))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                        className: "referenceToggle",
                        onClick: ()=>{
                            (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
                                s.glyphReferenceIsOpen = !s.glyphReferenceIsOpen;
                            });
                        },
                        children: "[ View Glyph Reference ]"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "inputPanel",
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: "numbersGrid",
                                children: [
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                        className: "button",
                                        onClick: ()=>(0, $8a5badd6ef6136ba$export$412508d679148d5c)('1', false),
                                        children: "1"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                        className: "button",
                                        onClick: ()=>(0, $8a5badd6ef6136ba$export$412508d679148d5c)('2', false),
                                        children: "2"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                        className: "button",
                                        onClick: ()=>(0, $8a5badd6ef6136ba$export$412508d679148d5c)('3', false),
                                        children: "3"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                        className: "button",
                                        onClick: ()=>(0, $8a5badd6ef6136ba$export$412508d679148d5c)('4', false),
                                        children: "4"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                        className: "button",
                                        onClick: ()=>(0, $8a5badd6ef6136ba$export$412508d679148d5c)('5', false),
                                        children: "5"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                        className: "button",
                                        onClick: ()=>(0, $8a5badd6ef6136ba$export$412508d679148d5c)('6', false),
                                        children: "6"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                        className: "button",
                                        onClick: ()=>(0, $8a5badd6ef6136ba$export$412508d679148d5c)('7', false),
                                        children: "7"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                        className: "button",
                                        onClick: ()=>(0, $8a5badd6ef6136ba$export$412508d679148d5c)('8', false),
                                        children: "8"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                        className: "button",
                                        onClick: ()=>(0, $8a5badd6ef6136ba$export$412508d679148d5c)('9', false),
                                        children: "9"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                        className: `button ${disableZeroButton ? 'disabled' : ''}`,
                                        onClick: ()=>{
                                            if (disableZeroButton) return;
                                            (0, $8a5badd6ef6136ba$export$412508d679148d5c)('0', false);
                                        },
                                        children: "0"
                                    }),
                                    isLandscape && /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                        className: "backspace",
                                        onClick: ()=>(0, $8a5badd6ef6136ba$export$412508d679148d5c)((0, $ba1e3b359abf28ef$export$cd903283095ece83).Delete, false),
                                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d872a2807693457d$exports))), {})
                                    })
                                ]
                            }),
                            !isLandscape && /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "backspace",
                                onClick: ()=>(0, $8a5badd6ef6136ba$export$412508d679148d5c)((0, $ba1e3b359abf28ef$export$cd903283095ece83).Delete, false),
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d872a2807693457d$exports))), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $b9f68b54b1083b27$export$2e2bcd8739ae039), {
                        store: (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f)
                    })
                ]
            })
        ]
    });
};
var $815c3d6722b31cd1$export$2e2bcd8739ae039 = $815c3d6722b31cd1$var$Arithmeglyphs;


var $54ed509a2813e983$export$2e2bcd8739ae039 = (0, $815c3d6722b31cd1$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");


var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

var $2cHFZ = parcelRequire("2cHFZ");



const $71d26f524812ace6$export$4e3bdb6fc7af2ff8 = ()=>{
    const { time: time, puzzleId: puzzleId } = (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).getRawState();
    setTimeout(()=>{
        (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).update((s)=>{
            s.statsDialogIsOpen = true;
        });
    }, (0, $860afe5c90b07ab1$export$87a8383fc3f35723));
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Megarubigram, {
        puzzleId: puzzleId,
        revealed: false,
        solved: true,
        time: time,
        // If they saved progress on this puzzle, it is kinda large compared to other puzzle states.
        // So once they solve it, we overwrite that with empty object to not waste space in mongo.
        partialState: null
    });
};
const $71d26f524812ace6$export$7cf2f68092532300 = ()=>{
    (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).update((s)=>{
        clearInterval(s.timerUpdatingFn);
        s.revealed = true;
        s.isPaused = false;
        (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Megarubigram, {
            puzzleId: s.puzzleId,
            revealed: true,
            solved: false,
            time: s.time,
            partialState: null
        });
    });
};
const $71d26f524812ace6$export$9c46c33257c0e40e = ()=>{
    const { solved: solved, revealed: revealed, time: time, degreesRotated: degreesRotated, grids: grids, puzzleId: puzzleId } = (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).getRawState();
    if (solved || revealed) return;
    // just updating progress on pause or navigate away
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Megarubigram, {
        puzzleId: puzzleId,
        revealed: revealed,
        solved: solved,
        time: time,
        partialState: {
            degreesRotated: degreesRotated,
            grids: grids
        }
    });
};
const $71d26f524812ace6$export$456ce1e409e7e64 = (puzzleData)=>{
    (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).update((s)=>{
        s.puzzleId = puzzleData.puzzleId;
        const scrambledGrid = puzzleData.scrambledGrid;
        const solvedGrid = puzzleData.grid;
        // The server gives the grid data as string[], with each row as a string.
        // This breaks it up into string[][] which is what the frontend code expects.
        const brokenUpScrambledGrid = [];
        const brokenUpSolvedGrid = [];
        for(let n = 0; n < scrambledGrid.length; n++){
            brokenUpScrambledGrid.push(scrambledGrid[n].split(''));
            brokenUpSolvedGrid.push(solvedGrid[n].split(''));
        }
        // we have to take the grids given from the server and break them up into 6x6 matrices first
        const topLeft_solved = $71d26f524812ace6$var$extractQuadrant(brokenUpSolvedGrid, 0, 0);
        const topRight_solved = $71d26f524812ace6$var$extractQuadrant(brokenUpSolvedGrid, 0, 6);
        const bottomLeft_solved = $71d26f524812ace6$var$extractQuadrant(brokenUpSolvedGrid, 6, 0);
        const bottomRight_solved = $71d26f524812ace6$var$extractQuadrant(brokenUpSolvedGrid, 6, 6);
        const topLeft = $71d26f524812ace6$var$extractQuadrant(brokenUpScrambledGrid, 0, 0);
        const topRight = $71d26f524812ace6$var$extractQuadrant(brokenUpScrambledGrid, 0, 6);
        const bottomLeft = $71d26f524812ace6$var$extractQuadrant(brokenUpScrambledGrid, 6, 0);
        const bottomRight = $71d26f524812ace6$var$extractQuadrant(brokenUpScrambledGrid, 6, 6);
        // Arranged in clockwise order for the sake of the math that
        // determines which grid is in which corner when a quadrant is flipped.
        // (getGridIdAccountingForPuzzleRotation)
        // This makes it so gridId=2 means bottom right and 3 is bottom left.
        const quadrants = [
            topLeft,
            topRight,
            bottomRight,
            bottomLeft
        ];
        const solvedQuadrants = [
            topLeft_solved,
            topRight_solved,
            bottomRight_solved,
            bottomLeft_solved
        ];
        // then we take those 6x6 quadrants and break them up into 3x3 subgrids
        // and assign those to the megarubigram store's data
        s.grids.forEach((grid, gridIndex)=>{
            const quadrant = quadrants[gridIndex];
            const solvedQuadrant = solvedQuadrants[gridIndex];
            grid.subgrids.forEach((subgrid, subgridIndex)=>{
                const row = [
                    0,
                    1
                ].includes(subgridIndex) ? 0 : 3;
                let col = [
                    0,
                    3
                ].includes(subgridIndex) ? 0 : 3;
                subgrid.content = $71d26f524812ace6$var$extractSubquadrant(quadrant, row, col);
                subgrid.displayContent = (0, $2cHFZ.cloneDeep)(subgrid.content);
                subgrid.solution = $71d26f524812ace6$var$extractSubquadrant(solvedQuadrant, row, col);
            });
        });
    });
};
// Function to extract a 6x6 grid quadrant from a 12x12
const $71d26f524812ace6$var$extractQuadrant = (matrix, rowStart, colStart)=>{
    return matrix.slice(rowStart, rowStart + 6).map((row)=>row.slice(colStart, colStart + 6));
};
// Function to extract a 3x3 grid quadrant from a 6x6
const $71d26f524812ace6$var$extractSubquadrant = (matrix, rowStart, colStart)=>{
    return matrix.slice(rowStart, rowStart + 3).map((row)=>row.slice(colStart, colStart + 3));
};
const $71d26f524812ace6$var$checkIsSolved = (grids)=>{
    let solved = true;
    for(let n = 0; n < grids.length; n++){
        for(let i = 0; i < grids[n].subgrids.length; i++){
            const subgrid = grids[n].subgrids[i];
            for(let row = 0; row < subgrid.content.length; row++){
                for(let col = 0; col < subgrid.content[row].length; col++)if (subgrid.content[row][col] !== subgrid.solution[row][col]) {
                    solved = false;
                    break;
                }
                if (!solved) break;
            }
            if (!solved) break;
        }
        if (!solved) break;
    }
    if (solved) $71d26f524812ace6$export$4e3bdb6fc7af2ff8();
    return solved;
};
const $71d26f524812ace6$export$b48741606a812e86 = (subgridId, isHFlipped, isVflipped, degreesPuzzleRotated)=>{
    const numPositionShifts = degreesPuzzleRotated / 90 % 4;
    switch(numPositionShifts){
        case 0:
            if (isHFlipped) subgridId = [
                1,
                0,
                3,
                2
            ][subgridId];
            if (isVflipped) subgridId = [
                3,
                2,
                1,
                0
            ][subgridId];
            return subgridId;
        case 1:
        case -3:
            if (isHFlipped) subgridId = [
                3,
                2,
                1,
                0
            ][subgridId];
            if (isVflipped) subgridId = [
                1,
                0,
                3,
                2
            ][subgridId];
            return subgridId;
        case 2:
        case -2:
            if (isHFlipped) subgridId = [
                1,
                0,
                3,
                2
            ][subgridId];
            if (isVflipped) subgridId = [
                3,
                2,
                1,
                0
            ][subgridId];
            return subgridId;
        case 3:
        case -1:
        default:
            if (isHFlipped) subgridId = [
                3,
                2,
                1,
                0
            ][subgridId];
            if (isVflipped) subgridId = [
                1,
                0,
                3,
                2
            ][subgridId];
            return subgridId;
    }
};
const $71d26f524812ace6$var$getGridIdAccountingForRotation = (gridId)=>{
    const timesPuzzleRotated = (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).getRawState().degreesRotated / 90;
    const sequenceLength = 4;
    // if you do out the examples you'll find this is correct, for both +/- rotations.
    return ((gridId + timesPuzzleRotated) % sequenceLength + sequenceLength) % sequenceLength;
};
const $71d26f524812ace6$export$aefd6fe06446b9a0 = (clockwise)=>{
    (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).update((s)=>{
        s.degreesRotated = clockwise ? s.degreesRotated + 90 : s.degreesRotated - 90;
        if (clockwise) $71d26f524812ace6$var$rotatePuzzleDataClockwise(s.grids);
        else $71d26f524812ace6$var$rotatePuzzleDataCounterClockwise(s.grids);
        s.solved = $71d26f524812ace6$var$checkIsSolved(s.grids);
    });
};
const $71d26f524812ace6$export$1b0bddff6a99251 = (gridIdForCss, subgridIdForCss, positionalSubgridIdForData, isAccountingForRotation)=>{
    const positionalGridIdForData = $71d26f524812ace6$var$getGridIdAccountingForRotation(gridIdForCss);
    const puzzleRotation = (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).getRawState().degreesRotated;
    const gridRotation = (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).getRawState().grids[gridIdForCss].degreesRotated;
    const gridIsRotated90Degrees = (puzzleRotation + gridRotation) % 180 !== 0;
    if (gridIsRotated90Degrees && !isAccountingForRotation) {
        $71d26f524812ace6$export$f4c48aae4f78d06f(gridIdForCss, subgridIdForCss, positionalSubgridIdForData, true);
        return;
    }
    (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).update((s)=>{
        s.activeGrid = gridIdForCss;
        s.activeSubgrid = subgridIdForCss;
        const subgridForCss = s.grids[gridIdForCss].subgrids[subgridIdForCss];
        const subgridForData = s.grids[positionalGridIdForData].subgrids[positionalSubgridIdForData];
        subgridForCss.flippedHorizontally = !subgridForCss.flippedHorizontally;
        subgridForCss.isInFlippingAnimation = true;
        // disable this as soon as animation ends
        setTimeout(()=>{
            (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).update((_s)=>{
                _s.grids[gridIdForCss].subgrids[subgridIdForCss].isInFlippingAnimation = false;
            });
        }, 300);
        if (isAccountingForRotation) subgridForData.content = $71d26f524812ace6$var$flipSubgridDataVertically(subgridForData.content);
        else subgridForData.content = $71d26f524812ace6$var$flipSubgridDataHorizontally(subgridForData.content);
        s.solved = $71d26f524812ace6$var$checkIsSolved(s.grids);
        $71d26f524812ace6$var$printQuadrantGrid(s.grids[positionalGridIdForData]);
    });
};
const $71d26f524812ace6$export$f4c48aae4f78d06f = (gridIdForCss, subgridIdForCss, positionalSubgridIdForData, isAccountingForRotation)=>{
    const positionalGridIdForData = $71d26f524812ace6$var$getGridIdAccountingForRotation(gridIdForCss);
    const puzzleRotation = (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).getRawState().degreesRotated;
    const gridRotation = (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).getRawState().grids[gridIdForCss].degreesRotated;
    const gridIsRotated90Degrees = (puzzleRotation + gridRotation) % 180 !== 0;
    if (gridIsRotated90Degrees && !isAccountingForRotation) {
        $71d26f524812ace6$export$1b0bddff6a99251(gridIdForCss, subgridIdForCss, positionalSubgridIdForData, true);
        return;
    }
    (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).update((s)=>{
        s.activeGrid = gridIdForCss;
        s.activeSubgrid = subgridIdForCss;
        const subgridForCss = s.grids[gridIdForCss].subgrids[subgridIdForCss];
        const subgridForData = s.grids[positionalGridIdForData].subgrids[positionalSubgridIdForData];
        subgridForCss.flippedVertically = !subgridForCss.flippedVertically;
        subgridForCss.isInFlippingAnimation = true;
        // disable this as soon as animation ends
        setTimeout(()=>{
            (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).update((_s)=>{
                _s.grids[gridIdForCss].subgrids[subgridIdForCss].isInFlippingAnimation = false;
            });
        }, 300);
        if (isAccountingForRotation) subgridForData.content = $71d26f524812ace6$var$flipSubgridDataHorizontally(subgridForData.content);
        else subgridForData.content = $71d26f524812ace6$var$flipSubgridDataVertically(subgridForData.content);
        s.solved = $71d26f524812ace6$var$checkIsSolved(s.grids);
        $71d26f524812ace6$var$printQuadrantGrid(s.grids[positionalGridIdForData]);
    });
};
const $71d26f524812ace6$export$a5b072a07155f62c = (gridIdForCss, subgridIdForCss, positionalSubgridIdForData, clockwise)=>{
    const gridIdForData = $71d26f524812ace6$var$getGridIdAccountingForRotation(gridIdForCss);
    (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).update((s)=>{
        s.activeGrid = gridIdForCss;
        s.activeSubgrid = subgridIdForCss;
        const subgridForCss = s.grids[gridIdForCss].subgrids[subgridIdForCss];
        const subgridForData = s.grids[gridIdForData].subgrids[positionalSubgridIdForData];
        if (subgridForCss.flippedHorizontally !== subgridForCss.flippedVertically) subgridForCss.degreesRotated = subgridForCss.degreesRotated + (clockwise ? -90 : 90);
        else subgridForCss.degreesRotated = subgridForCss.degreesRotated + (clockwise ? 90 : -90);
        // If the grid is flipped, the data subgrid should be rotated the opposite direction of how
        // the css subgrid gets rotated.
        const gridIsFlippedInCss = s.grids[gridIdForCss].flippedHorizontally !== s.grids[gridIdForCss].flippedVertically;
        if (gridIsFlippedInCss) clockwise = !clockwise;
        if (clockwise) subgridForData.content = $71d26f524812ace6$var$rotateSubgridDataClockwise(subgridForData.content);
        else subgridForData.content = $71d26f524812ace6$var$rotateSubgridDataCounterClockwise(subgridForData.content);
        s.solved = $71d26f524812ace6$var$checkIsSolved(s.grids);
        $71d26f524812ace6$var$printQuadrantGrid(s.grids[gridIdForData]);
    });
};
const $71d26f524812ace6$export$da16647af3805a9b = (gridIdForCss)=>{
    const puzzleRotation = (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).getRawState().degreesRotated;
    const puzzleIsRotated90Degrees = puzzleRotation % 180 !== 0;
    (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).update((s)=>{
        const positionalGridIdToUpdate = $71d26f524812ace6$var$getGridIdAccountingForRotation(gridIdForCss);
        s.activeGrid = gridIdForCss;
        const gridForCss = s.grids[gridIdForCss];
        const gridForData = s.grids[positionalGridIdToUpdate];
        gridForCss.flippedVertically = !gridForCss.flippedVertically;
        gridForCss.isInFlippingAnimation = true;
        // disable this as soon as animation ends
        setTimeout(()=>{
            (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).update((_s)=>{
                _s.grids[gridIdForCss].isInFlippingAnimation = false;
            });
        }, 300);
        if (puzzleIsRotated90Degrees) $71d26f524812ace6$var$flipGridDataHorizontally(gridForData);
        else $71d26f524812ace6$var$flipGridDataVertically(gridForData);
        s.solved = $71d26f524812ace6$var$checkIsSolved(s.grids);
        $71d26f524812ace6$var$printQuadrantGrid(gridForData);
    });
};
const $71d26f524812ace6$export$884011c1a382011 = (gridIdForCss)=>{
    const puzzleRotation = (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).getRawState().degreesRotated;
    const puzzleIsRotated90Degrees = puzzleRotation % 180 !== 0;
    (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).update((s)=>{
        const positionalGridIdToUpdate = $71d26f524812ace6$var$getGridIdAccountingForRotation(gridIdForCss);
        s.activeGrid = gridIdForCss;
        const gridForCss = s.grids[gridIdForCss];
        const gridForData = s.grids[positionalGridIdToUpdate];
        gridForCss.flippedHorizontally = !gridForCss.flippedHorizontally;
        gridForCss.isInFlippingAnimation = true;
        // disable this as soon as animation ends - might want to do it for ALL not just one,
        // in case they spin the thing during those 0.7s somehow especially with two hands on a touchscreen
        setTimeout(()=>{
            (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).update((_s)=>{
                _s.grids[gridIdForCss].isInFlippingAnimation = false;
            });
        }, 300);
        if (puzzleIsRotated90Degrees) $71d26f524812ace6$var$flipGridDataVertically(gridForData);
        else $71d26f524812ace6$var$flipGridDataHorizontally(gridForData);
        s.solved = $71d26f524812ace6$var$checkIsSolved(s.grids);
        $71d26f524812ace6$var$printQuadrantGrid(gridForData);
    });
};
const $71d26f524812ace6$export$8e6a6fd7074b7e63 = (gridIdForCss, clockwise)=>{
    (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).update((s)=>{
        const positionalGridIdToUpdate = $71d26f524812ace6$var$getGridIdAccountingForRotation(gridIdForCss);
        s.activeGrid = gridIdForCss;
        const gridForCss = s.grids[gridIdForCss];
        const gridForData = s.grids[positionalGridIdToUpdate];
        if (gridForCss.flippedHorizontally !== gridForCss.flippedVertically) gridForCss.degreesRotated = gridForCss.degreesRotated + (clockwise ? -90 : 90);
        else gridForCss.degreesRotated = gridForCss.degreesRotated + (clockwise ? 90 : -90);
        if (clockwise) $71d26f524812ace6$var$rotateGridDataClockwise(gridForData);
        else $71d26f524812ace6$var$rotateGridDataCounterClockwise(gridForData);
        s.solved = $71d26f524812ace6$var$checkIsSolved(s.grids);
        $71d26f524812ace6$var$printQuadrantGrid(gridForData);
    });
};
// These fns below do the actual updates to the grid and subgrid data and are used
// by the visual fns above.
// The visual fns make sure the right thing is updating VISUALLY to the user,
// whereas these functions below just make the more low-level simple changes to specified
// parts of the underlying data matrices. remember, the html content never actually changes.
// Example: user wants to horizontally flip the lower right subgrid, but due to transformations
// that actually means vertically flipping the upper left subgrid. so the visual fn figures out
// which subgrid it REALLY is, then one of these fns below would just flip the upper left subgrid.
const $71d26f524812ace6$var$flipSubgridDataHorizontally = (subgrid)=>{
    const flippedSubgrid = [];
    for (let row of subgrid)flippedSubgrid.push(row.slice().reverse());
    return flippedSubgrid;
};
const $71d26f524812ace6$var$flipSubgridDataVertically = (subgrid)=>{
    const flippedSubgrid = [];
    for(let i = subgrid.length - 1; i >= 0; i--)flippedSubgrid.push(subgrid[i].slice());
    return flippedSubgrid;
};
const $71d26f524812ace6$var$rotateSubgridDataClockwise = (subgrid)=>{
    const rotatedSubgrid = [];
    for(let i = 0; i < subgrid.length; i++){
        rotatedSubgrid.push([]);
        for(let j = 0; j < subgrid.length; j++)rotatedSubgrid[i].push(subgrid[subgrid.length - j - 1][i]);
    }
    return rotatedSubgrid;
};
const $71d26f524812ace6$var$rotateSubgridDataCounterClockwise = (subgrid)=>{
    const rotatedSubgrid = [];
    for(let i = 0; i < subgrid.length; i++){
        rotatedSubgrid.push([]);
        for(let j = 0; j < subgrid.length; j++)rotatedSubgrid[i].push(subgrid[j][subgrid.length - i - 1]);
    }
    return rotatedSubgrid;
};
const $71d26f524812ace6$var$flipGridDataHorizontally = (grid)=>{
    grid.subgrids.forEach((subgrid)=>{
        subgrid.content = $71d26f524812ace6$var$flipSubgridDataHorizontally(subgrid.content);
    });
    const subgridsCopy = (0, $2cHFZ.cloneDeep)(grid.subgrids);
    grid.subgrids[0].content = subgridsCopy[1].content;
    grid.subgrids[1].content = subgridsCopy[0].content;
    grid.subgrids[2].content = subgridsCopy[3].content;
    grid.subgrids[3].content = subgridsCopy[2].content;
};
const $71d26f524812ace6$var$flipGridDataVertically = (grid)=>{
    grid.subgrids.forEach((subgrid)=>{
        subgrid.content = $71d26f524812ace6$var$flipSubgridDataVertically(subgrid.content);
    });
    const subgridsCopy = (0, $2cHFZ.cloneDeep)(grid.subgrids);
    grid.subgrids[0].content = subgridsCopy[3].content;
    grid.subgrids[1].content = subgridsCopy[2].content;
    grid.subgrids[2].content = subgridsCopy[1].content;
    grid.subgrids[3].content = subgridsCopy[0].content;
};
const $71d26f524812ace6$var$rotateGridDataClockwise = (grid)=>{
    // First rotate the content of the subgrids
    const rotatedTopLeft = $71d26f524812ace6$var$rotateSubgridDataClockwise(grid.subgrids[0].content);
    const rotatedTopRight = $71d26f524812ace6$var$rotateSubgridDataClockwise(grid.subgrids[1].content);
    const rotatedBottomRight = $71d26f524812ace6$var$rotateSubgridDataClockwise(grid.subgrids[2].content);
    const rotatedBottomLeft = $71d26f524812ace6$var$rotateSubgridDataClockwise(grid.subgrids[3].content);
    // Then rotate the position of the subgrids
    // Bottom left becomes top left. Top left becomes top right.
    // Top right becomes bottom right. Bottom right becomes bottom left.
    grid.subgrids[0].content = rotatedBottomLeft;
    grid.subgrids[1].content = rotatedTopLeft;
    grid.subgrids[2].content = rotatedTopRight;
    grid.subgrids[3].content = rotatedBottomRight;
};
const $71d26f524812ace6$var$rotateGridDataCounterClockwise = (grid)=>{
    // First rotate the content of the subgrids
    const rotatedTopLeft = $71d26f524812ace6$var$rotateSubgridDataCounterClockwise(grid.subgrids[0].content);
    const rotatedTopRight = $71d26f524812ace6$var$rotateSubgridDataCounterClockwise(grid.subgrids[1].content);
    const rotatedBottomRight = $71d26f524812ace6$var$rotateSubgridDataCounterClockwise(grid.subgrids[2].content);
    const rotatedBottomLeft = $71d26f524812ace6$var$rotateSubgridDataCounterClockwise(grid.subgrids[3].content);
    // Then rotate the position of the subgrids
    grid.subgrids[0].content = rotatedTopRight;
    grid.subgrids[1].content = rotatedBottomRight;
    grid.subgrids[2].content = rotatedBottomLeft;
    grid.subgrids[3].content = rotatedTopLeft;
};
const $71d26f524812ace6$var$rotatePuzzleDataClockwise = (grids)=>{
    $71d26f524812ace6$var$printParentGrid(grids);
    grids.forEach((grid)=>{
        $71d26f524812ace6$var$rotateGridDataClockwise(grid);
    });
    const gridsCopy = (0, $2cHFZ.cloneDeep)(grids);
    grids[0].subgrids.forEach((subgrid, index)=>{
        subgrid.content = gridsCopy[3].subgrids[index].content;
    });
    grids[1].subgrids.forEach((subgrid, index)=>{
        subgrid.content = gridsCopy[0].subgrids[index].content;
    });
    grids[2].subgrids.forEach((subgrid, index)=>{
        subgrid.content = gridsCopy[1].subgrids[index].content;
    });
    grids[3].subgrids.forEach((subgrid, index)=>{
        subgrid.content = gridsCopy[2].subgrids[index].content;
    });
    $71d26f524812ace6$var$printParentGrid(grids);
};
const $71d26f524812ace6$var$rotatePuzzleDataCounterClockwise = (grids)=>{
    $71d26f524812ace6$var$printParentGrid(grids);
    grids.forEach((grid)=>{
        $71d26f524812ace6$var$rotateGridDataCounterClockwise(grid);
    });
    const gridsCopy = (0, $2cHFZ.cloneDeep)(grids);
    grids[0].subgrids.forEach((subgrid, index)=>{
        subgrid.content = gridsCopy[1].subgrids[index].content;
    });
    grids[1].subgrids.forEach((subgrid, index)=>{
        subgrid.content = gridsCopy[2].subgrids[index].content;
    });
    grids[2].subgrids.forEach((subgrid, index)=>{
        subgrid.content = gridsCopy[3].subgrids[index].content;
    });
    grids[3].subgrids.forEach((subgrid, index)=>{
        subgrid.content = gridsCopy[0].subgrids[index].content;
    });
    $71d26f524812ace6$var$printParentGrid(grids);
};
///////////
function $71d26f524812ace6$var$printParentGrid(grids) {
    var grid, gridIndex, subgridData, subgridIndex, row;
    // only enable this for debugging purposes.
    return;
    // Function to merge a subgrid into the parent grid at a specific position
    function mergeSubgrid(subgrid, rowOffset, colOffset) {
        for(let r = 0; r < subgrid.length; r++)for(let c = 0; c < subgrid[r].length; c++)parentGrid[rowOffset + r][colOffset + c] = subgrid[r][c];
    }
}
function $71d26f524812ace6$var$printQuadrantGrid(grid) {
    var subgrid, subgridIndex, row;
    // only enable this for debugging purposes.
    return;
    // Function to merge a subgrid into the parent grid at a specific position
    function mergeSubgrid(subgrid, rowOffset, colOffset) {
        for(let r = 0; r < subgrid.length; r++)for(let c = 0; c < subgrid[r].length; c++)parentGrid[rowOffset + r][colOffset + c] = subgrid[r][c];
    }
}



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");



var $27f101808c5d1eaa$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($27f101808c5d1eaa$exports, "__esModule", {
    value: true
});
$27f101808c5d1eaa$exports.default = void 0;

var $27f101808c5d1eaa$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $27f101808c5d1eaa$var$_default = $27f101808c5d1eaa$exports.default = (0, $27f101808c5d1eaa$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8"
}), 'Replay');


const $1b7ccc4f3999c68a$var$ControlSubgrid = ({ gridId: gridId, subgridId: subgridId })=>{
    const grid = (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).useState((s)=>s.grids[gridId]);
    const subgrid = grid.subgrids[subgridId];
    const activeSubgridId = (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).useState((s)=>s.activeSubgrid);
    const isActive = subgridId === activeSubgridId;
    const subgridHFlipped = subgrid.flippedHorizontally;
    const subgridVFlipped = subgrid.flippedVertically;
    const gridHFlipped = grid.flippedHorizontally;
    const gridVFlipped = grid.flippedVertically;
    // if it's flipped one way but not the other, then reverse rotation
    const reverseSubgridRotation = gridHFlipped !== gridVFlipped;
    const degreesSubgridRotated = subgrid.degreesRotated;
    const degreesGridRotated = grid.degreesRotated;
    const degreesPuzzleRotated = (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).useState((s)=>s.degreesRotated);
    const isSubgridAt90DegAngle = (degreesSubgridRotated + degreesGridRotated + degreesPuzzleRotated) / 90 % 2 !== 0;
    const flipperStyles = {
        transform: `rotateY(${subgridHFlipped ? 180 : 0}deg)` + ` rotateX(${subgridVFlipped ? 180 : 0}deg)` + ` rotateZ(${degreesSubgridRotated}deg)`
    };
    let degreesToRotateLetters = -1 * (degreesSubgridRotated + degreesGridRotated + degreesPuzzleRotated);
    let flipsToAdd = 0;
    const isGridAt90DegAngle = Math.abs(degreesGridRotated + degreesPuzzleRotated) % 180 !== 0;
    if (isGridAt90DegAngle) {
        if (subgridVFlipped) flipsToAdd += 1;
        if (subgridHFlipped) flipsToAdd += 1;
        if (gridVFlipped) flipsToAdd += 1;
        if (gridHFlipped) flipsToAdd += 1;
    }
    // don't be deceived, degreesGridRotated is not the same as what makes up isGridAt90DegAngle
    if (gridVFlipped !== gridHFlipped && degreesGridRotated % 180 !== 0) flipsToAdd += 1;
    degreesToRotateLetters += 180 * (flipsToAdd % 2);
    // This makes sure letters never rotate more than 180deg in any direction for a transform
    const prevDegree = (0, $28UcW.useRef)(degreesToRotateLetters);
    const equivalentDiff = (degreesToRotateLetters - prevDegree.current) % 360;
    if (equivalentDiff === 270) degreesToRotateLetters = prevDegree.current - 90;
    else if (equivalentDiff === -270) degreesToRotateLetters = prevDegree.current + 90;
    else if (equivalentDiff === 0) degreesToRotateLetters = prevDegree.current;
    else degreesToRotateLetters = prevDegree.current + equivalentDiff;
    prevDegree.current = degreesToRotateLetters;
    ///////// end that code ///////
    const letterStyles = {
        transform: `rotate(${degreesToRotateLetters}deg)` + ` rotate3d(1, 0, 0, ${subgridVFlipped !== gridVFlipped ? 180 : 0}deg)` + ` rotate3d(0, 1, 0, ${subgridHFlipped !== gridHFlipped ? 180 : 0}deg)`
    };
    ////////////////
    // This little piece of code is _essential_. It figures out what position
    // this subgrid is in relative to its parent grid. 0=top-left, 1=top-right,
    // 2=bottom-right, 3=bottom left. clockwise order.
    // We need this so the utils can update the right part of the char matrices
    // that are used to check if the puzzle is solved or not.
    // This variable doesn't include degreesSubgridRotated because that doesn't change where
    // the subgrid is, which is the point of this calculation.
    const timesSubgridPositionRotated = (degreesPuzzleRotated + degreesGridRotated) / 90;
    // This is how far the subgrid has moved around the grid.
    // From upper left to lower right would be 2 or -2, for example.
    const numSubgridPositionShifts = timesSubgridPositionRotated % 4;
    // this line accounts for rotations--
    const rotatedSubgridId = ((subgridId + numSubgridPositionShifts) % 4 + 4) % 4;
    // --and this line accounts for flips, giving a completely right positional id.
    const positionalSubgridId = (0, $71d26f524812ace6$export$b48741606a812e86)(rotatedSubgridId, gridHFlipped, gridVFlipped, degreesPuzzleRotated);
    ////////////////
    const onCellClick = (rowIndex, cellIndex)=>{
        if (isSubgridAt90DegAngle) {
            if (rowIndex === 1 && [
                0,
                2
            ].includes(cellIndex)) (0, $71d26f524812ace6$export$f4c48aae4f78d06f)(gridId, subgridId, positionalSubgridId);
            else if ([
                0,
                2
            ].includes(rowIndex) && cellIndex === 1) (0, $71d26f524812ace6$export$1b0bddff6a99251)(gridId, subgridId, positionalSubgridId);
        } else {
            if (rowIndex === 1 && [
                0,
                2
            ].includes(cellIndex)) (0, $71d26f524812ace6$export$1b0bddff6a99251)(gridId, subgridId, positionalSubgridId);
            else if ([
                0,
                2
            ].includes(rowIndex) && cellIndex === 1) (0, $71d26f524812ace6$export$f4c48aae4f78d06f)(gridId, subgridId, positionalSubgridId);
        }
    };
    const isClickableCell = (rowIndex, cellIndex)=>{
        return rowIndex === 1 && [
            0,
            2
        ].includes(cellIndex) || [
            0,
            2
        ].includes(rowIndex) && cellIndex === 1;
    };
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: `controlSubgrid subgrid${subgridId} ${isActive ? 'activeSubgrid' : ''}`,
        children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
            className: "controlSubgridFlipper",
            style: flipperStyles,
            children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: `controlSubgridContents ${subgrid.isInFlippingAnimation ? 'isFlipping' : ''}`,
                children: subgrid.displayContent.map((row, rowIndex)=>/*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "gridRow",
                        children: row.map((cell, cellIndex)=>/*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: `gridCellContainer ${isClickableCell(rowIndex, cellIndex) ? 'clickableCell' : ''}`,
                                onClick: ()=>onCellClick(rowIndex, cellIndex),
                                children: rowIndex === 1 && cellIndex === 1 ? /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                    className: "gridCell",
                                    style: letterStyles,
                                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                                        disableRipple: true,
                                        className: "rotateSubgridClockwiseButton center",
                                        title: "Rotate Clockwise",
                                        onClick: ()=>(0, $71d26f524812ace6$export$a5b072a07155f62c)(gridId, subgridId, positionalSubgridId, !reverseSubgridRotation),
                                        onContextMenu: (e)=>{
                                            e.preventDefault();
                                            (0, $71d26f524812ace6$export$a5b072a07155f62c)(gridId, subgridId, positionalSubgridId, reverseSubgridRotation);
                                        },
                                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($27f101808c5d1eaa$exports))), {})
                                    })
                                }) : /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                    className: `gridCell ${cell === '.' ? 'blankCell' : ''}`,
                                    style: cell === '.' ? {} : letterStyles,
                                    children: cell === '.' ? '' : cell
                                })
                            }, cellIndex))
                    }, rowIndex))
            })
        })
    });
};
var $1b7ccc4f3999c68a$export$2e2bcd8739ae039 = $1b7ccc4f3999c68a$var$ControlSubgrid;




const $1a4478c5df0411e5$var$ControlGrid = ({ gridId: gridId })=>{
    const grid = (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).useState((s)=>s.grids[gridId]);
    const activeGridId = (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).useState((s)=>s.activeGrid);
    const isActive = gridId === activeGridId;
    const degreesPuzzleRotated = (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).useState((s)=>s.degreesRotated);
    const degreesGridRotated = grid.degreesRotated;
    const flippedHorizontally = grid.flippedHorizontally;
    const flippedVertically = grid.flippedVertically;
    const flipperStyles = {
        transform: `rotateY(${flippedHorizontally ? 180 : 0}deg)` + ` rotateX(${flippedVertically ? 180 : 0}deg)` + ` rotateZ(${degreesGridRotated}deg)`
    };
    let degreesToRotateCenterButton = -1 * (degreesGridRotated + degreesPuzzleRotated + 50);
    if (Math.abs(degreesPuzzleRotated % 180) === 90 && flippedHorizontally !== flippedVertically) degreesToRotateCenterButton += 180;
    const centerButtonStyles = {
        transform: `rotate(${degreesToRotateCenterButton}deg) scaleX(-1)` + ` rotateY(${flippedHorizontally ? 180 : 0}deg)` + ` rotateX(${flippedVertically ? 180 : 0}deg)`
    };
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: `controlGrid grid${gridId} ${isActive ? 'activeGrid' : ''}`,
        onContextMenu: (e)=>{
            e.preventDefault();
        },
        children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
            className: "controlGridFlipper",
            style: flipperStyles,
            children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: `controlGridContents ${grid.isInFlippingAnimation ? 'isFlipping' : ''}`,
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $1b7ccc4f3999c68a$export$2e2bcd8739ae039), {
                        gridId: gridId,
                        subgridId: 0
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $1b7ccc4f3999c68a$export$2e2bcd8739ae039), {
                        gridId: gridId,
                        subgridId: 1
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $1b7ccc4f3999c68a$export$2e2bcd8739ae039), {
                        gridId: gridId,
                        subgridId: 3
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $1b7ccc4f3999c68a$export$2e2bcd8739ae039), {
                        gridId: gridId,
                        subgridId: 2
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        disableRipple: true,
                        className: "rotateGridClockwiseButton",
                        title: "Rotate Clockwise/Counterclockwise",
                        onClick: ()=>(0, $71d26f524812ace6$export$8e6a6fd7074b7e63)(gridId, true),
                        onContextMenu: (e)=>{
                            e.preventDefault();
                            (0, $71d26f524812ace6$export$8e6a6fd7074b7e63)(gridId, false);
                        },
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($27f101808c5d1eaa$exports))), {
                            style: centerButtonStyles
                        })
                    })
                ]
            })
        })
    });
};
var $1a4478c5df0411e5$export$2e2bcd8739ae039 = $1a4478c5df0411e5$var$ControlGrid;





var $51ed7e09b9f5ed7e$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($51ed7e09b9f5ed7e$exports, "__esModule", {
    value: true
});
$51ed7e09b9f5ed7e$exports.default = void 0;

var $51ed7e09b9f5ed7e$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $51ed7e09b9f5ed7e$var$_default = $51ed7e09b9f5ed7e$exports.default = (0, $51ed7e09b9f5ed7e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99zM9 3 5 6.99h3V14h2V6.99h3z"
}), 'SwapVert');


var $632b5fe9ab18dec8$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($632b5fe9ab18dec8$exports, "__esModule", {
    value: true
});
$632b5fe9ab18dec8$exports.default = void 0;

var $632b5fe9ab18dec8$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $632b5fe9ab18dec8$var$_default = $632b5fe9ab18dec8$exports.default = (0, $632b5fe9ab18dec8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M6.99 11 3 15l3.99 4v-3H14v-2H6.99zM21 9l-3.99-4v3H10v2h7.01v3z"
}), 'SwapHoriz');



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

const $b00ba7589a1059b4$var$SolvedControlSubgrid = ({ gridId: gridId, subgridId: subgridId })=>{
    const grid = (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).useState((s)=>s.grids[gridId]);
    const subgrid = grid.subgrids[subgridId];
    const blankLetterStyles = {
        backgroundColor: '#777676'
    };
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: `controlSubgrid subgrid${subgridId}`,
        children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
            className: "controlSubgridFlipper",
            children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "controlSubgridContents",
                children: subgrid.solution.map((row, rowIndex)=>/*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "gridRow",
                        children: row.map((cell, cellIndex)=>/*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "gridCellContainer",
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                    className: "gridCell",
                                    style: cell === '.' ? blankLetterStyles : {},
                                    children: cell === '.' ? '' : cell
                                })
                            }, cellIndex))
                    }, rowIndex))
            })
        })
    });
};
var $b00ba7589a1059b4$export$2e2bcd8739ae039 = $b00ba7589a1059b4$var$SolvedControlSubgrid;


const $5a2e5f2156870dc0$var$SolvedControlGrid = ({ gridId: gridId })=>{
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: `controlGrid grid${gridId}`,
        children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
            className: "controlGridFlipper",
            children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "controlGridContents",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $b00ba7589a1059b4$export$2e2bcd8739ae039), {
                        gridId: gridId,
                        subgridId: 0
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $b00ba7589a1059b4$export$2e2bcd8739ae039), {
                        gridId: gridId,
                        subgridId: 1
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $b00ba7589a1059b4$export$2e2bcd8739ae039), {
                        gridId: gridId,
                        subgridId: 3
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $b00ba7589a1059b4$export$2e2bcd8739ae039), {
                        gridId: gridId,
                        subgridId: 2
                    })
                ]
            })
        })
    });
};
var $5a2e5f2156870dc0$export$2e2bcd8739ae039 = $5a2e5f2156870dc0$var$SolvedControlGrid;


const $9a73452511409ae0$var$SolvedOuterControlGrid = ()=>{
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "outerGridContainer",
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
            className: "puzzleRotationContainer",
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $5a2e5f2156870dc0$export$2e2bcd8739ae039), {
                    gridId: 0
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $5a2e5f2156870dc0$export$2e2bcd8739ae039), {
                    gridId: 1
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $5a2e5f2156870dc0$export$2e2bcd8739ae039), {
                    gridId: 3
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $5a2e5f2156870dc0$export$2e2bcd8739ae039), {
                    gridId: 2
                })
            ]
        })
    });
};
var $9a73452511409ae0$export$2e2bcd8739ae039 = $9a73452511409ae0$var$SolvedOuterControlGrid;



const $a27b1282775a2496$var$OuterControlGrid = ()=>{
    const { degreesRotated: degreesRotated, revealed: revealed, solved: solved } = (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).useState();
    const wasSolvedOnLoad = (0, $ba1e3b359abf28ef$export$db3b65d3d3d119f7)(solved);
    const puzzleIsRotated90Deg = degreesRotated % 180 !== 0;
    const gridStyles = {
        transform: `rotate(${degreesRotated}deg)` + (solved ? puzzleIsRotated90Deg ? ` rotateX(360deg)` : ` rotateY(360deg)` : '')
    };
    // why +50? i have no idea. somehow somewhere it's being rotated -50º
    // when compared to the other rotate button icons. idk and idc rn.
    const centerButtonStyles = {
        transform: `rotate(${-1 * (degreesRotated + 50)}deg) scaleX(-1)`
    };
    if (revealed || wasSolvedOnLoad) return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $9a73452511409ae0$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "outerGridContainer",
        onContextMenu: (e)=>{
            e.preventDefault();
        },
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
            className: "puzzleRotationContainer",
            style: gridStyles,
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $1a4478c5df0411e5$export$2e2bcd8739ae039), {
                    gridId: 0
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $1a4478c5df0411e5$export$2e2bcd8739ae039), {
                    gridId: 1
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $1a4478c5df0411e5$export$2e2bcd8739ae039), {
                    gridId: 3
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $1a4478c5df0411e5$export$2e2bcd8739ae039), {
                    gridId: 2
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                    disableRipple: true,
                    className: "rotateGridClockwiseButton",
                    title: "Rotate Clockwise/Counterclockwise",
                    onClick: ()=>(0, $71d26f524812ace6$export$aefd6fe06446b9a0)(true),
                    onContextMenu: (e)=>{
                        e.preventDefault();
                        (0, $71d26f524812ace6$export$aefd6fe06446b9a0)(false);
                    },
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($27f101808c5d1eaa$exports))), {
                        style: centerButtonStyles
                    })
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                    disableRipple: true,
                    className: "flipVerticallyButton upperLeft",
                    title: "Flip",
                    onClick: ()=>(0, $71d26f524812ace6$export$da16647af3805a9b)(0),
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($51ed7e09b9f5ed7e$exports))), {})
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                    disableRipple: true,
                    className: "flipHorizontallyButton upperLeft",
                    title: "Flip",
                    onClick: ()=>(0, $71d26f524812ace6$export$884011c1a382011)(0),
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($632b5fe9ab18dec8$exports))), {})
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                    disableRipple: true,
                    className: "flipVerticallyButton upperRight",
                    title: "Flip",
                    onClick: ()=>(0, $71d26f524812ace6$export$da16647af3805a9b)(1),
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($51ed7e09b9f5ed7e$exports))), {})
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                    disableRipple: true,
                    className: "flipHorizontallyButton upperRight",
                    title: "Flip",
                    onClick: ()=>(0, $71d26f524812ace6$export$884011c1a382011)(1),
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($632b5fe9ab18dec8$exports))), {})
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                    disableRipple: true,
                    className: "flipVerticallyButton lowerLeft",
                    title: "Flip",
                    onClick: ()=>(0, $71d26f524812ace6$export$da16647af3805a9b)(3),
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($51ed7e09b9f5ed7e$exports))), {})
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                    disableRipple: true,
                    className: "flipHorizontallyButton lowerLeft",
                    title: "Flip",
                    onClick: ()=>(0, $71d26f524812ace6$export$884011c1a382011)(3),
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($632b5fe9ab18dec8$exports))), {})
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                    disableRipple: true,
                    className: "flipVerticallyButton lowerRight",
                    title: "Flip",
                    onClick: ()=>(0, $71d26f524812ace6$export$da16647af3805a9b)(2),
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($51ed7e09b9f5ed7e$exports))), {})
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                    disableRipple: true,
                    className: "flipHorizontallyButton lowerRight",
                    title: "Flip",
                    onClick: ()=>(0, $71d26f524812ace6$export$884011c1a382011)(2),
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($632b5fe9ab18dec8$exports))), {})
                })
            ]
        })
    });
};
var $a27b1282775a2496$export$2e2bcd8739ae039 = $a27b1282775a2496$var$OuterControlGrid;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

var $5a0d259702ee5b28$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($5a0d259702ee5b28$exports, "__esModule", {
    value: true
});
$5a0d259702ee5b28$exports.default = void 0;

var $5a0d259702ee5b28$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $5a0d259702ee5b28$var$_default = $5a0d259702ee5b28$exports.default = (0, $5a0d259702ee5b28$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), 'Visibility');













var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");



const $3d67e01a4e46eb41$var$RevealConfirmationDialog = ({ store: store, onReveal: onReveal })=>{
    const isOpen = store.useState((s)=>s.revealConfirmationIsOpen);
    const onClose = ()=>{
        store.update((s)=>{
            s.revealConfirmationIsOpen = false;
            s.isSoftPaused = false;
        });
    };
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $74c5b717dc6d45d0$export$2e2bcd8739ae039), {
        open: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
            className: "revealConfirmationDialogContent",
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                    className: "closeButton",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b4a213a738a62de4$exports))), {})
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                    className: "prompt",
                    children: "Are you utterly certain you wish to reveal the solution?"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                    className: "decisionButton",
                    onClick: onClose,
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                    className: "decisionButton revealButton",
                    onClick: ()=>{
                        onReveal();
                        onClose();
                    },
                    children: "Reveal"
                })
            ]
        })
    });
};
var $3d67e01a4e46eb41$export$2e2bcd8739ae039 = $3d67e01a4e46eb41$var$RevealConfirmationDialog;



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");

var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $28UcW = parcelRequire("28UcW");
parcelRequire("d79ZO");


var $dP0oo = parcelRequire("dP0oo");

var $1fz9F = parcelRequire("1fz9F");



var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $28UcW = parcelRequire("28UcW");
parcelRequire("d79ZO");


var $365128ae56094f12$export$2e2bcd8739ae039 = (0, $2aa96e427bd09d3b$export$2e2bcd8739ae039);



var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $1fz9F = parcelRequire("1fz9F");

var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");

var $28UcW = parcelRequire("28UcW");
'use client';
/**
 * @ignore - internal component.
 */ const $1e5fcc96bed351de$var$ListContext = /*#__PURE__*/ $28UcW.createContext({});
var $1e5fcc96bed351de$export$2e2bcd8739ae039 = $1e5fcc96bed351de$var$ListContext;



var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $9a0aa37547e94670$export$c6bd6795ed6e3203(slot) {
    return (0, $dYzHx.default)('MuiList', slot);
}
const $9a0aa37547e94670$var$listClasses = (0, $d0ZgE.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $9a0aa37547e94670$export$2e2bcd8739ae039 = $9a0aa37547e94670$var$listClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $904a66adae8e3a57$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $904a66adae8e3a57$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $9a0aa37547e94670$export$c6bd6795ed6e3203), classes);
};
const $904a66adae8e3a57$var$ListRoot = (0, $k5hQd.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $kLZMq.default)({
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $904a66adae8e3a57$var$List = /*#__PURE__*/ $28UcW.forwardRef(function List(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $53Ou4.default)(props, $904a66adae8e3a57$var$_excluded);
    const context = $28UcW.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $kLZMq.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $904a66adae8e3a57$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $1e5fcc96bed351de$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)($904a66adae8e3a57$var$ListRoot, (0, $kLZMq.default)({
            as: component,
            className: (0, $dP0oo.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $904a66adae8e3a57$export$2e2bcd8739ae039 = $904a66adae8e3a57$var$List;



var $ee347e6fe1032fab$export$2e2bcd8739ae039 = (0, $c21a6c26d624e0d3$export$2e2bcd8739ae039);




'use client';
var $1c9ca6404a5190fd$export$2e2bcd8739ae039 = (0, $8a0c5c067d762282$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $54adaf57eaadbc6c$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $54adaf57eaadbc6c$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $54adaf57eaadbc6c$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $54adaf57eaadbc6c$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $54adaf57eaadbc6c$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$54adaf57eaadbc6c$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $54adaf57eaadbc6c$var$MenuList = /*#__PURE__*/ $28UcW.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu' } = props, other = (0, $53Ou4.default)(props, $54adaf57eaadbc6c$var$_excluded);
    const listRef = $28UcW.useRef(null);
    const textCriteriaRef = $28UcW.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $1c9ca6404a5190fd$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $28UcW.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $ee347e6fe1032fab$export$2e2bcd8739ae039)((0, $365128ae56094f12$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $365128ae56094f12$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $54adaf57eaadbc6c$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $54adaf57eaadbc6c$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $54adaf57eaadbc6c$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $54adaf57eaadbc6c$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $54adaf57eaadbc6c$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $54adaf57eaadbc6c$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $54adaf57eaadbc6c$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $54adaf57eaadbc6c$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $54adaf57eaadbc6c$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $54adaf57eaadbc6c$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $54adaf57eaadbc6c$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $7d57efcdf4f58771$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $28UcW.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $28UcW.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $28UcW.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $28UcW.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $904a66adae8e3a57$export$2e2bcd8739ae039), (0, $kLZMq.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $54adaf57eaadbc6c$export$2e2bcd8739ae039 = $54adaf57eaadbc6c$var$MenuList;



var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");


var $1fz9F = parcelRequire("1fz9F");






var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $3404783e704c4a0b$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $a8a837f5dfa86fc7$export$2e2bcd8739ae039 = (0, $3404783e704c4a0b$export$2e2bcd8739ae039);




var $d3163a8765e3e7f6$export$2e2bcd8739ae039 = (0, $c66694b6fb06134f$export$2e2bcd8739ae039);




var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $28UcW = parcelRequire("28UcW");








var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $fd8c790be1396626$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $fd8c790be1396626$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $fd8c790be1396626$var$styles = {
    entering: {
        opacity: 1,
        transform: $fd8c790be1396626$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $fd8c790be1396626$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $fd8c790be1396626$var$Grow = /*#__PURE__*/ $28UcW.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $cfd1f9e04a409bf9$export$2e2bcd8739ae039) } = props, other = (0, $53Ou4.default)(props, $fd8c790be1396626$var$_excluded);
    const timer = (0, $13f25f9c85a15779$export$2e2bcd8739ae039)();
    const autoTimeout = $28UcW.useRef();
    const theme = (0, $93b513bca024249e$export$2e2bcd8739ae039)();
    const nodeRef = $28UcW.useRef(null);
    const handleRef = (0, $7d57efcdf4f58771$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $c2a19a68af095939$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $c2a19a68af095939$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $fd8c790be1396626$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $c2a19a68af095939$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $fd8c790be1396626$var$isWebKit154 ? duration : duration * 0.666,
                delay: $fd8c790be1396626$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $fd8c790be1396626$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $4XrX4.jsx)(TransitionComponent, (0, $kLZMq.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $28UcW.cloneElement(children, (0, $kLZMq.default)({
                style: (0, $kLZMq.default)({
                    opacity: 0,
                    transform: $fd8c790be1396626$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $fd8c790be1396626$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$fd8c790be1396626$var$Grow.muiSupportAuto = true;
var $fd8c790be1396626$export$2e2bcd8739ae039 = $fd8c790be1396626$var$Grow;





var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $a4d98c02e1311c8e$export$88f455dd56c95edb(slot) {
    return (0, $dYzHx.default)('MuiPopover', slot);
}
const $a4d98c02e1311c8e$var$popoverClasses = (0, $d0ZgE.default)('MuiPopover', [
    'root',
    'paper'
]);
var $a4d98c02e1311c8e$export$2e2bcd8739ae039 = $a4d98c02e1311c8e$var$popoverClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $c59a86853ae558d6$var$_excluded = [
    "onEntering"
], $c59a86853ae558d6$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $c59a86853ae558d6$var$_excluded3 = [
    "slotProps"
];
function $c59a86853ae558d6$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $c59a86853ae558d6$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $c59a86853ae558d6$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $c59a86853ae558d6$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $c59a86853ae558d6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $a4d98c02e1311c8e$export$88f455dd56c95edb), classes);
};
const $c59a86853ae558d6$export$bcce13685275fc99 = (0, $k5hQd.default)((0, $72c4c983a9f0d793$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $c59a86853ae558d6$export$821346c38a2d9390 = (0, $k5hQd.default)((0, $ac02ff9d8c78ed7f$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $c59a86853ae558d6$var$Popover = /*#__PURE__*/ $28UcW.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent = (0, $fd8c790be1396626$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = 'auto', TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $53Ou4.default)(props.TransitionProps, $c59a86853ae558d6$var$_excluded), other = (0, $53Ou4.default)(props, $c59a86853ae558d6$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $28UcW.useRef();
    const handlePaperRef = (0, $7d57efcdf4f58771$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $kLZMq.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $c59a86853ae558d6$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $28UcW.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $c59a86853ae558d6$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $365128ae56094f12$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $c59a86853ae558d6$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $c59a86853ae558d6$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $28UcW.useCallback((elemRect)=>{
        return {
            vertical: $c59a86853ae558d6$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $c59a86853ae558d6$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $28UcW.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $c59a86853ae558d6$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $d3163a8765e3e7f6$export$2e2bcd8739ae039)($c59a86853ae558d6$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $c59a86853ae558d6$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $28UcW.useState(open);
    const setPositioningStyles = $28UcW.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $28UcW.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $28UcW.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $28UcW.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $28UcW.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $a8a837f5dfa86fc7$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $d3163a8765e3e7f6$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $365128ae56094f12$export$2e2bcd8739ae039)($c59a86853ae558d6$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $c59a86853ae558d6$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $c59a86853ae558d6$export$821346c38a2d9390;
    const paperProps = (0, $308c9efc97ee800b$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: (0, $kLZMq.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $kLZMq.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $dP0oo.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $308c9efc97ee800b$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $dP0oo.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $53Ou4.default)(_useSlotProps, $c59a86853ae558d6$var$_excluded3);
    return /*#__PURE__*/ (0, $4XrX4.jsx)(RootSlot, (0, $kLZMq.default)({}, rootProps, !(0, $565736d32b3dfb1b$export$e28348cc2430497)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $4XrX4.jsx)(TransitionComponent, (0, $kLZMq.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $4XrX4.jsx)(PaperSlot, (0, $kLZMq.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $c59a86853ae558d6$export$2e2bcd8739ae039 = $c59a86853ae558d6$var$Popover;



var $k5hQd = parcelRequire("k5hQd");


var $l9mID = parcelRequire("l9mID");

var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $9078e3cdca2ab546$export$2cf86a63a84fe23d(slot) {
    return (0, $dYzHx.default)('MuiMenu', slot);
}
const $9078e3cdca2ab546$var$menuClasses = (0, $d0ZgE.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $9078e3cdca2ab546$export$2e2bcd8739ae039 = $9078e3cdca2ab546$var$menuClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $253324ab0d2d0f8a$var$_excluded = [
    "onEntering"
], $253324ab0d2d0f8a$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $253324ab0d2d0f8a$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $253324ab0d2d0f8a$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $253324ab0d2d0f8a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $9078e3cdca2ab546$export$2cf86a63a84fe23d), classes);
};
const $253324ab0d2d0f8a$var$MenuRoot = (0, $k5hQd.default)((0, $c59a86853ae558d6$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $k5hQd.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $253324ab0d2d0f8a$export$4f7c51a5920c9f33 = (0, $k5hQd.default)((0, $c59a86853ae558d6$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $253324ab0d2d0f8a$var$MenuMenuList = (0, $k5hQd.default)((0, $54adaf57eaadbc6c$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $253324ab0d2d0f8a$var$Menu = /*#__PURE__*/ $28UcW.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $53Ou4.default)(props.TransitionProps, $253324ab0d2d0f8a$var$_excluded), other = (0, $53Ou4.default)(props, $253324ab0d2d0f8a$var$_excluded2);
    const theme = (0, $93b513bca024249e$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === 'rtl';
    const ownerState = (0, $kLZMq.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $253324ab0d2d0f8a$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $28UcW.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $28UcW.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $28UcW.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $253324ab0d2d0f8a$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $308c9efc97ee800b$export$1e5c9e6e4e15efe3)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $308c9efc97ee800b$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $4XrX4.jsx)($253324ab0d2d0f8a$var$MenuRoot, (0, $kLZMq.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $253324ab0d2d0f8a$var$RTL_ORIGIN : $253324ab0d2d0f8a$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $kLZMq.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $4XrX4.jsx)($253324ab0d2d0f8a$var$MenuMenuList, (0, $kLZMq.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $dP0oo.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $253324ab0d2d0f8a$export$2e2bcd8739ae039 = $253324ab0d2d0f8a$var$Menu;



var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $1fz9F = parcelRequire("1fz9F");

var $aMDDU = parcelRequire("aMDDU");

var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");





var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $bdc8384d03faeed4$export$46f01d01378ec5a2(slot) {
    return (0, $dYzHx.default)('MuiDivider', slot);
}
const $bdc8384d03faeed4$var$dividerClasses = (0, $d0ZgE.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $bdc8384d03faeed4$export$2e2bcd8739ae039 = $bdc8384d03faeed4$var$dividerClasses;



var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $beb273f923d87250$export$81478e24460c57f2(slot) {
    return (0, $dYzHx.default)('MuiListItemIcon', slot);
}
const $beb273f923d87250$var$listItemIconClasses = (0, $d0ZgE.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $beb273f923d87250$export$2e2bcd8739ae039 = $beb273f923d87250$var$listItemIconClasses;



var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $9d7152e0587ec96a$export$1061006a0db3aeb5(slot) {
    return (0, $dYzHx.default)('MuiListItemText', slot);
}
const $9d7152e0587ec96a$var$listItemTextClasses = (0, $d0ZgE.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $9d7152e0587ec96a$export$2e2bcd8739ae039 = $9d7152e0587ec96a$var$listItemTextClasses;



var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $afcb0248a907e0ab$export$515f8c67b5305377(slot) {
    return (0, $dYzHx.default)('MuiMenuItem', slot);
}
const $afcb0248a907e0ab$var$menuItemClasses = (0, $d0ZgE.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $afcb0248a907e0ab$export$2e2bcd8739ae039 = $afcb0248a907e0ab$var$menuItemClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $fbf0bf3f5e6ed773$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $fbf0bf3f5e6ed773$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $fbf0bf3f5e6ed773$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $1fz9F.default)(slots, (0, $afcb0248a907e0ab$export$515f8c67b5305377), classes);
    return (0, $kLZMq.default)({}, classes, composedClasses);
};
const $fbf0bf3f5e6ed773$var$MenuItemRoot = (0, $k5hQd.default)((0, $120c91fa1d9b1234$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $k5hQd.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $fbf0bf3f5e6ed773$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $kLZMq.default)({}, theme.typography.body1, {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, {
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $afcb0248a907e0ab$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aMDDU.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $afcb0248a907e0ab$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $aMDDU.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $afcb0248a907e0ab$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $aMDDU.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aMDDU.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $afcb0248a907e0ab$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $afcb0248a907e0ab$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $bdc8384d03faeed4$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $bdc8384d03faeed4$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $9d7152e0587ec96a$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $9d7152e0587ec96a$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $beb273f923d87250$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up('sm')]: {
            minHeight: 'auto'
        }
    }, ownerState.dense && (0, $kLZMq.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $beb273f923d87250$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: '1.25rem'
        }
    })));
const $fbf0bf3f5e6ed773$var$MenuItem = /*#__PURE__*/ $28UcW.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className } = props, other = (0, $53Ou4.default)(props, $fbf0bf3f5e6ed773$var$_excluded);
    const context = $28UcW.useContext((0, $1e5fcc96bed351de$export$2e2bcd8739ae039));
    const childContext = $28UcW.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $28UcW.useRef(null);
    (0, $1c9ca6404a5190fd$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $kLZMq.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $fbf0bf3f5e6ed773$var$useUtilityClasses(props);
    const handleRef = (0, $7d57efcdf4f58771$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $1e5fcc96bed351de$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $4XrX4.jsx)($fbf0bf3f5e6ed773$var$MenuItemRoot, (0, $kLZMq.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $dP0oo.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $dP0oo.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $fbf0bf3f5e6ed773$export$2e2bcd8739ae039 = $fbf0bf3f5e6ed773$var$MenuItem;



var $8ea01901ca9bf04a$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($8ea01901ca9bf04a$exports, "__esModule", {
    value: true
});
$8ea01901ca9bf04a$exports.default = void 0;

var $8ea01901ca9bf04a$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $8ea01901ca9bf04a$var$_default = $8ea01901ca9bf04a$exports.default = (0, $8ea01901ca9bf04a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m7.46 7.12-2.78 1.15c-.51-1.36-1.58-2.44-2.95-2.94l1.15-2.78c2.1.8 3.77 2.47 4.58 4.57M12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3M9.13 4.54l1.17 2.78c-1.38.5-2.47 1.59-2.98 2.97L4.54 9.13c.81-2.11 2.48-3.78 4.59-4.59M4.54 14.87l2.78-1.15c.51 1.38 1.59 2.46 2.97 2.96l-1.17 2.78c-2.1-.81-3.77-2.48-4.58-4.59m10.34 4.59-1.15-2.78c1.37-.51 2.45-1.59 2.95-2.97l2.78 1.17c-.81 2.1-2.48 3.77-4.58 4.58"
}), 'Support');







const $89509cfb9f60b696$export$7cf2f68092532300 = ()=>{
    (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).update((s)=>{
        clearInterval(s.timerUpdatingFn);
        s.revealed = true;
        s.isPaused = false;
        (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Triword, {
            puzzleId: s.puzzleId,
            revealed: true,
            solved: false,
            time: s.time
        });
    });
};
const $89509cfb9f60b696$export$4e3bdb6fc7af2ff8 = ()=>{
    const { time: time, puzzleId: puzzleId } = (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).getRawState();
    // the other puzzles don't call this inside onSolve, only triword does. i don't love that.
    (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).update((s)=>{
        s.solved = true;
    });
    setTimeout(()=>{
        (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).update((s)=>{
            s.statsDialogIsOpen = true;
        });
    }, (0, $860afe5c90b07ab1$export$87a8383fc3f35723));
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Triword, {
        puzzleId: puzzleId,
        revealed: false,
        solved: true,
        time: time
    });
};
const $89509cfb9f60b696$export$e409bdf423f1f13c = ()=>{
    const { solved: solved, revealed: revealed, time: time, used5050Lifeline: used5050Lifeline, usedLetterLifeline: usedLetterLifeline, usedPositionLifeline: usedPositionLifeline, puzzleId: puzzleId } = (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).getRawState();
    // this fn is just for updating progress on pause or navigate away.
    if (solved || revealed) return;
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Triword, {
        puzzleId: puzzleId,
        revealed: revealed,
        solved: solved,
        time: time,
        partialState: {
            used5050Lifeline: used5050Lifeline,
            usedLetterLifeline: usedLetterLifeline,
            usedPositionLifeline: usedPositionLifeline
        }
    });
};
const $89509cfb9f60b696$export$412508d679148d5c = (key)=>{
    const { guess: guess, solution: solution, solved: solved, revealed: revealed, numInputs: numInputs, usedLetterLifeline: usedLetterLifeline, obscureSolutions: obscureSolutions } = (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).getRawState();
    if (solved || revealed) return;
    if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).Delete) {
        (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).update((s)=>{
            s.guess = guess.slice(0, -1);
        });
        return;
    }
    if (/^[a-zA-Z]$/.test(key)) {
        key = key.toLowerCase();
        const noRoomForInput = guess.length === numInputs || usedLetterLifeline && guess.length === numInputs - 1;
        if (noRoomForInput) return;
        const lastLetter = solution[solution.length - 1];
        const newGuess = usedLetterLifeline ? guess.join('') + key + lastLetter : guess.join('') + key;
        (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).update((s)=>{
            s.guess = [
                ...s.guess,
                key
            ];
        });
        if (newGuess === solution) $89509cfb9f60b696$export$4e3bdb6fc7af2ff8();
        else if (obscureSolutions.includes(newGuess) && newGuess.length === solution.length) // Some of the obscure solutions are 3-letter solutions for 4-letter puzzles,
        // so we do a length check since we don't want to trigger this alert for those
        alert("Nice work! This solution is valid, but at least one of the words is extremely rare. A less obscure solution exists.");
        else if (newGuess.length === solution.length) {
            (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).update((s)=>{
                s.wrongGuess = true;
            });
            setTimeout(()=>{
                (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).update((s)=>{
                    s.wrongGuess = false;
                });
            }, 300);
        }
    }
};
const $89509cfb9f60b696$export$1df4bb14ce74baa0 = ()=>{
    // if they currently have the last letter filled with a guess,
    // clear that slot before replacing it with the revealed letter
    const { guess: guess, solution: solution } = (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).getRawState();
    if (guess.length === solution.length) (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).update((s)=>{
        s.guess = s.guess.slice(0, s.guess.length - 1);
    });
};
const $89509cfb9f60b696$export$a4e69d7037101c3f = (puzzleData)=>{
    // puzzleData.clues has the full words, and we then slice the solution out of them
    // before displaying the remaining fragments to the user
    const fragments = puzzleData.clues.map((fullWord, index)=>{
        return fullWord.replace(puzzleData.solution, '');
    });
    const fragmentsWith1PositionRevealed = puzzleData.clues.map((fullWord, index)=>{
        if (fullWord === puzzleData.positionLifeline) return fullWord.replace(puzzleData.solution, '_'.repeat(puzzleData.solution.length));
        return fullWord.replace(puzzleData.solution, '');
    });
    const obscureSolutions = puzzleData.obscureSolutions || [];
    (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).update((s)=>{
        s.puzzleId = puzzleData.puzzleId;
        s.solution = puzzleData.solution;
        s.fullWords = puzzleData.clues;
        s.fragments = fragments;
        s.fragmentsWith1PositionRevealed = fragmentsWith1PositionRevealed;
        s.obscureSolutions = obscureSolutions;
        s.numInputs = puzzleData.solution.length;
        s.lettersFor5050 = puzzleData.lettersFor5050;
    });
};


// most of this is copied from MUI docs for BasicMenu and then slightly modified
const $46818b22ce15fbb5$var$LifelineButton = ()=>{
    const solved = (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).useState((s)=>s.solved);
    const [anchorEl, setAnchorEl] = $28UcW.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const { usedPositionLifeline: usedPositionLifeline, usedLetterLifeline: usedLetterLifeline, used5050Lifeline: used5050Lifeline } = (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).useState((s)=>{
        return {
            usedPositionLifeline: s.usedPositionLifeline,
            usedLetterLifeline: s.usedLetterLifeline,
            used5050Lifeline: s.used5050Lifeline
        };
    });
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("span", {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                id: "lifelines",
                title: "Lifelines",
                disabled: solved,
                onClick: handleClick,
                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8ea01901ca9bf04a$exports))), {})
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $253324ab0d2d0f8a$export$2e2bcd8739ae039), {
                id: "basic-menu",
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $fbf0bf3f5e6ed773$export$2e2bcd8739ae039), {
                        disabled: usedPositionLifeline,
                        onClick: ()=>{
                            (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).update((s)=>{
                                s.usedPositionLifeline = true;
                            });
                            handleClose();
                            // timeout so store can update with lifeline usage
                            setTimeout((0, $89509cfb9f60b696$export$e409bdf423f1f13c), 100);
                        },
                        children: "Reveal 1 clue position"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $fbf0bf3f5e6ed773$export$2e2bcd8739ae039), {
                        disabled: usedLetterLifeline,
                        onClick: ()=>{
                            (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).update((s)=>{
                                s.usedLetterLifeline = true;
                            });
                            handleClose();
                            (0, $89509cfb9f60b696$export$1df4bb14ce74baa0)();
                            setTimeout((0, $89509cfb9f60b696$export$e409bdf423f1f13c), 100);
                        },
                        children: "Reveal last letter"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $fbf0bf3f5e6ed773$export$2e2bcd8739ae039), {
                        disabled: used5050Lifeline,
                        onClick: ()=>{
                            (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).update((s)=>{
                                s.used5050Lifeline = true;
                            });
                            handleClose();
                            setTimeout((0, $89509cfb9f60b696$export$e409bdf423f1f13c), 100);
                        },
                        children: "50/50"
                    })
                ]
            })
        ]
    });
};
var $46818b22ce15fbb5$export$2e2bcd8739ae039 = $46818b22ce15fbb5$var$LifelineButton;



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");




const $922c917bd3871513$var$LifelineButton = ({ store: store, onSave: onSave })=>{
    const { solved: solved, hintLetters: hintLetters, enabledHints: enabledHints, hintsUsed: hintsUsed, initialEnabledHints: initialEnabledHints } = store.useState();
    const [anchorEl, setAnchorEl] = $28UcW.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    // Calculate available lifeline hints (total hints minus initial hints)
    const totalLifelineHints = hintLetters.length - initialEnabledHints;
    const remainingHints = hintLetters.length - enabledHints.length;
    const allHintsUsed = remainingHints === 0;
    const useHint = ()=>{
        store.update((s)=>{
            // Find the next hint index to enable (smallest one not in enabledHints)
            const nextHintIndex = Array.from({
                length: hintLetters.length
            }, (_, i)=>i).find((i)=>!s.enabledHints.includes(i));
            if (nextHintIndex !== undefined) {
                s.enabledHints = [
                    ...s.enabledHints,
                    nextHintIndex
                ].sort((a, b)=>a - b);
                s.hintsUsed++;
            }
        });
        handleClose();
        setTimeout(onSave, 100);
    };
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("span", {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                id: "lifelines",
                title: "Lifelines",
                disabled: solved,
                onClick: handleClick,
                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8ea01901ca9bf04a$exports))), {})
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $253324ab0d2d0f8a$export$2e2bcd8739ae039), {
                id: "basic-menu",
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                children: /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $fbf0bf3f5e6ed773$export$2e2bcd8739ae039), {
                    disabled: allHintsUsed,
                    onClick: useHint,
                    children: [
                        "Get hint (",
                        hintsUsed,
                        "/",
                        totalLifelineHints,
                        ")"
                    ]
                })
            })
        ]
    });
};
var $922c917bd3871513$export$2e2bcd8739ae039 = $922c917bd3871513$var$LifelineButton;



const $d1bf944c5018dbe5$var$PuzzleTopBar = ({ puzzleName: puzzleName, store: store, onSave: onSave, onReveal: onReveal, InstructionsComponent: InstructionsComponent })=>{
    const { solved: solved, revealed: revealed, time: time, isPaused: isPaused } = store.useState();
    const useMobileStyles = (0, $b2cd9ecc66d0956f$exports.isMobile) || (0, $ba1e3b359abf28ef$export$580e0f6db19fa7cc)();
    const navigate = (0, $6e00b7bb3feca34a$export$9770f232ac06a008)();
    const pauseButtonClass = solved || revealed ? 'hidden' : '';
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: `puzzleTopBar ${useMobileStyles ? 'mobile' : ''}`,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "topBarLeftSection",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        disableRipple: true,
                        title: "Back",
                        onClick: ()=>{
                            navigate('/');
                            window.scrollTo(0, 0);
                            onSave();
                        },
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ba2d2837fc619c75$exports))), {})
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "navigationLabel",
                        children: (0, $860afe5c90b07ab1$export$db7e8528fe84408c)[puzzleName]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "topBarMiddleSection",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "timer",
                        children: (0, $ba1e3b359abf28ef$export$3203edd9e5edd663)(time)
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        className: pauseButtonClass,
                        title: "Pause",
                        onClick: ()=>{
                            store.update((s)=>{
                                if (!s.isPaused) onSave();
                                s.isPaused = !s.isPaused;
                            });
                            window.scrollTo(0, 0);
                        },
                        children: isPaused ? /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($815c4a10c6ca199f$exports))), {}) : /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($be547dbdaf888d8e$exports))), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "topBarRightSection",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)(InstructionsComponent, {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $3d67e01a4e46eb41$export$2e2bcd8739ae039), {
                        store: store,
                        onReveal: onReveal
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $1d9a1bb1e0e16baf$export$2e2bcd8739ae039), {
                        puzzleName: puzzleName,
                        store: store
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        disableRipple: true,
                        title: "How to Play",
                        onClick: ()=>{
                            store.update((s)=>{
                                s.instructionsAreOpen = true;
                                s.isSoftPaused = true;
                            });
                        },
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($98556d5fcc3acbf1$exports))), {})
                    }),
                    puzzleName === (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Triword && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $46818b22ce15fbb5$export$2e2bcd8739ae039), {}),
                    (puzzleName === (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword || puzzleName === (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword5x5) && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $922c917bd3871513$export$2e2bcd8739ae039), {
                        store: store,
                        onSave: onSave
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        disableRipple: true,
                        disabled: revealed || solved,
                        title: "Reveal",
                        onClick: ()=>{
                            store.update((s)=>{
                                s.revealConfirmationIsOpen = true;
                                s.isSoftPaused = true;
                            });
                        },
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5a0d259702ee5b28$exports))), {})
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        disableRipple: true,
                        title: "Stats",
                        onClick: ()=>{
                            store.update((s)=>{
                                s.statsDialogIsOpen = true;
                                s.isSoftPaused = true;
                            });
                        },
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1e3ba230a1917794$exports))), {})
                    })
                ]
            })
        ]
    });
};
var $d1bf944c5018dbe5$export$2e2bcd8739ae039 = $d1bf944c5018dbe5$var$PuzzleTopBar;


var $d549bcf7ed920b37$export$2e2bcd8739ae039 = (0, $d1bf944c5018dbe5$export$2e2bcd8739ae039);




var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");






const $e10eaf9479823e75$var$closeInstructions = ()=>{
    (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).update((s)=>{
        s.instructionsAreOpen = false;
        s.isSoftPaused = false;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).set(`${(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Megarubigram}InstructionsDismissed`, 'true', {
        domain: (0, $ba1e3b359abf28ef$export$517466abcb8fcf10),
        expires: 365
    });
};
const $e10eaf9479823e75$var$Instructions = ()=>{
    const isOpen = (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).useState((s)=>s.instructionsAreOpen);
    const isTouch = (0, $b2cd9ecc66d0956f$exports.isMobile) || (0, $b2cd9ecc66d0956f$exports.isTablet);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $a923e83bee9905be$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: $e10eaf9479823e75$var$closeInstructions,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("h1", {
                className: "instructionsTitle",
                children: "How to Play the Megarubigram"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "instructionsBody",
                children: /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                            children: [
                                "Rotate and flip until every row and column ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                    className: "italicText",
                                    children: "longer than two letters"
                                }),
                                " spells a word from left-to-right and top-to-bottom."
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                            children: [
                                "Flip the 3x3 subgrids by ",
                                isTouch ? 'tapping' : 'clicking',
                                " their non-corner cells."
                            ]
                        }),
                        !isTouch && /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                            children: "Right-click the rotate buttons to rotate counterclockwise."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                            children: "No obscure words and mostly no proper names."
                        }),
                        (0, $b2cd9ecc66d0956f$exports.isMobile) && /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                            children: "This puzzle is harder to solve on mobile due to the density of the UI, but you can try if you wish."
                        })
                    ]
                })
            })
        ]
    });
};
var $e10eaf9479823e75$export$2e2bcd8739ae039 = $e10eaf9479823e75$var$Instructions;








const $1a89168b3e488813$var$Megarubigram = ()=>{
    const { solved: solved, revealed: revealed } = (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).useState();
    const useMobileStyles = (0, $b2cd9ecc66d0956f$exports.isMobile) || (0, $ba1e3b359abf28ef$export$580e0f6db19fa7cc)();
    (0, $ba1e3b359abf28ef$export$e73a86b2063a8f6b)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Rubigram, (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee));
    (0, $ba1e3b359abf28ef$export$20d77ccceac0f55c)((0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee), (0, $71d26f524812ace6$export$9c46c33257c0e40e));
    (0, $ba1e3b359abf28ef$export$5b0326dddadcb0de)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Megarubigram);
    (0, $ba1e3b359abf28ef$export$52dc0a972e5b91c5)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Megarubigram);
    (0, $80f684051860af43$export$2500c8a6bc3f2f43)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Megarubigram);
    const puzzleContainerClasses = `puzzleContainer megarubigramContainer` + ` ${solved ? 'solved' : ''}` + ` ${useMobileStyles ? 'mobile' : ''}`;
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d549bcf7ed920b37$export$2e2bcd8739ae039), {
                puzzleName: (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Megarubigram,
                store: (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee),
                onReveal: (0, $71d26f524812ace6$export$7cf2f68092532300),
                onSave: (0, $71d26f524812ace6$export$9c46c33257c0e40e),
                InstructionsComponent: (0, $e10eaf9479823e75$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: puzzleContainerClasses,
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $a27b1282775a2496$export$2e2bcd8739ae039), {}),
                    revealed && /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "outcomeBanner",
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                children: "Solution revealed. Try again next time!"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                children: "New Megarubigrams on Tuesdays and Fridays."
                            })
                        ]
                    }),
                    solved && /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "outcomeBanner",
                        children: "Solved! New Megarubigrams on Tuesdays and Fridays."
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $b9f68b54b1083b27$export$2e2bcd8739ae039), {
                        store: (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee)
                    })
                ]
            })
        ]
    });
};
var $1a89168b3e488813$export$2e2bcd8739ae039 = $1a89168b3e488813$var$Megarubigram;


var $11fb873f9cbbf0ee$export$2e2bcd8739ae039 = (0, $1a89168b3e488813$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");




var $28UcW = parcelRequire("28UcW");




var $28UcW = parcelRequire("28UcW");






const $503d195e8098532c$export$7613e4d4725461b7 = new (0, $eb0b4d1e13e36536$export$390f32400eaf98c9)({
    ...(0, $860afe5c90b07ab1$export$c83f6fa500e2ab35),
    completed: false,
    author: '',
    cryptic: false,
    dateLabel: '',
    clues: [],
    guesses: [],
    revealedCells: [],
    mistakes: [],
    toolbar: {
        almostThereIsOpen: false,
        aboutIsOpen: false,
        clearIsOpen: false,
        checkIsOpen: false,
        revealIsOpen: false,
        combinedIsOpen: false,
        confirmationDialog: {
            clearAllIsOpen: false,
            checkLetterIsOpen: false,
            checkWordIsOpen: false,
            checkPuzzleIsOpen: false,
            autocheckIsOpen: false,
            revealLetterIsOpen: false,
            revealWordIsOpen: false,
            revealAllIsOpen: false
        }
    },
    focusedClueIndex: 0,
    cursorIndex: 0,
    autocheckOn: false
});


const $2eaf3926a83a2b13$export$b789e1fe3c5b2ad4 = async (puzzleId)=>{
    const authToken = await (0, $de660e99e3126d7c$export$ae1af26003f05816)().currentUser?.getIdToken(true);
    if (!authToken) return; // not logged in -> do nothing, on purpose
    try {
        await (0, $ea74087fd5ac399e$export$2e2bcd8739ae039).post('/api/users/complete-archive', {
            authToken: authToken,
            puzzleId: puzzleId
        });
    } catch (error) {
    // best-effort; recording an archive completion is non-critical
    }
};
const $2eaf3926a83a2b13$var$onComplete = ()=>{
    const { puzzleId: puzzleId } = (0, $503d195e8098532c$export$7613e4d4725461b7).getRawState();
    // Note: unlike the daily puzzle, we deliberately do NOT open the stats dialog.
    // The board just shows its completed/solved state.
    // Record the completion for signed-in users (no-op otherwise)...
    $2eaf3926a83a2b13$export$b789e1fe3c5b2ad4(puzzleId);
    // ...and drop the locally-saved in-progress state for this puzzle, since it's done.
    (0, $741cdd5d8fe36d3f$export$b1266f401cdd8344)(puzzleId);
};
const $2eaf3926a83a2b13$export$5c96c7fea13888f = ()=>{
    const { puzzleId: puzzleId, time: time, solved: solved, revealed: revealed, completed: completed, guesses: guesses, revealedCells: revealedCells, mistakes: mistakes } = (0, $503d195e8098532c$export$7613e4d4725461b7).getRawState();
    // Once completed, the state is cleared by onComplete; nothing to persist.
    if (completed) return;
    (0, $741cdd5d8fe36d3f$export$79f2c3ac7689272c)({
        puzzleId: puzzleId,
        time: time,
        solved: solved,
        revealed: revealed,
        completed: completed,
        guesses: guesses,
        revealedCells: revealedCells,
        mistakes: mistakes
    });
};
const $2eaf3926a83a2b13$export$d3eb60cfe0446065 = (isoDate)=>{
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(isoDate);
    if (!match) return '';
    const [, year, month, day] = match;
    const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
    return date.toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC'
    });
};
const $2eaf3926a83a2b13$export$a0020d212ef6ba7a = (puzzleData)=>{
    // The archive store is a singleton reused across archive dates, so we reset all
    // transient state here (not just the board) to avoid leaking state from a
    // previously-viewed archive puzzle. Then we overlay any locally-saved progress
    // for THIS puzzle id.
    const saved = (0, $741cdd5d8fe36d3f$export$fc9c2a865d055fed)(puzzleData.puzzleId);
    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
        s.puzzleId = puzzleData.puzzleId;
        s.dateLabel = $2eaf3926a83a2b13$export$d3eb60cfe0446065(puzzleData.date);
        s.author = puzzleData.author;
        s.cryptic = !!puzzleData.cryptic;
        // it should be all caps anyway, but just in case of mistake we make sure here.
        s.clues = puzzleData.clues.map((clue)=>({
                ...clue,
                solution: clue.solution.toUpperCase()
            }));
        // Fresh-board defaults.
        s.guesses = s.clues.map((clue)=>Array(clue.solution.length).fill(null));
        s.revealedCells = s.clues.map((clue)=>Array(clue.solution.length).fill(false));
        s.mistakes = s.clues.map((clue)=>Array(clue.solution.length).fill(false));
        s.time = 0;
        s.solved = false;
        s.revealed = false;
        s.completed = false;
        s.isPaused = false;
        s.isSoftPaused = false;
        s.focusedClueIndex = 0;
        s.cursorIndex = 0;
        s.autocheckOn = false;
        // Overlay saved progress, if any. We guard each array against shape drift
        // (e.g. if the puzzle data ever changed) by only using saved arrays whose
        // outer length matches the current clue count.
        if (saved) {
            const lengthsMatch = (arr)=>Array.isArray(arr) && arr.length === s.clues.length;
            if (lengthsMatch(saved.guesses)) s.guesses = saved.guesses;
            if (lengthsMatch(saved.revealedCells)) s.revealedCells = saved.revealedCells;
            if (lengthsMatch(saved.mistakes)) s.mistakes = saved.mistakes;
            s.time = saved.time || 0;
            s.solved = saved.solved || false;
            s.revealed = saved.revealed || false;
            s.completed = saved.completed || false;
        }
    });
};
let $2eaf3926a83a2b13$var$hasAlreadyShownAlmostThereDialog = false;
const $2eaf3926a83a2b13$var$shouldShowAlmostThereDialog = (guesses, revealedCells, clues)=>{
    if ($2eaf3926a83a2b13$var$hasAlreadyShownAlmostThereDialog) return false;
    for(let i = 0; i < clues.length; i++){
        const guess = guesses[i];
        for(let j = 0; j < guess.length; j++){
            if (revealedCells[i][j]) continue;
            if (guess[j] === null) return false;
        }
    }
    $2eaf3926a83a2b13$var$hasAlreadyShownAlmostThereDialog = true;
    return true;
};
const $2eaf3926a83a2b13$var$isCompleted = (guesses, revealedCells, clues)=>{
    for(let i = 0; i < clues.length; i++){
        const solution = clues[i].solution;
        const guess = guesses[i];
        for(let j = 0; j < solution.length; j++){
            if (revealedCells[i][j]) continue;
            if (guess[j] !== solution[j]) return false;
        }
    }
    return true;
};
const $2eaf3926a83a2b13$export$28120faafeefa4c5 = (s)=>{
    const guessForClue = s.guesses[s.focusedClueIndex];
    const nullIndex = guessForClue.findIndex((letterGuess, i)=>letterGuess === null && s.revealedCells[s.focusedClueIndex][i] === false);
    s.cursorIndex = Math.max(nullIndex, 0);
};
// s = state, because this is meant to be used on a state draft inside a store update
const $2eaf3926a83a2b13$var$moveCursorToNextOpenSlot = (s)=>{
    const guessForClue = s.guesses[s.focusedClueIndex];
    // Find the first null index AFTER s.cursorIndex that isn't revealed
    let nullIndex = guessForClue.slice(s.cursorIndex + 1).findIndex((guessForLetter, i)=>guessForLetter === null && s.revealedCells[s.focusedClueIndex][s.cursorIndex + 1 + i] === false) + s.cursorIndex + 1;
    // if we didn't find one, then look for the first null index that isn't revealed, from the start
    if (nullIndex === -1) nullIndex = guessForClue.findIndex((guessForLetter, i)=>guessForLetter === null && s.revealedCells[s.focusedClueIndex][i] === false);
    if (nullIndex !== -1) s.cursorIndex = nullIndex;
    else // If no null is found at all, move index forward by one unless we're at the end
    s.cursorIndex = s.cursorIndex === guessForClue.length - 1 ? s.cursorIndex : s.cursorIndex + 1;
};
const $2eaf3926a83a2b13$export$412508d679148d5c = (key, shiftKey)=>{
    const { completed: completed, guesses: guesses, revealedCells: revealedCells, cursorIndex: cursorIndex, focusedClueIndex: focusedClueIndex } = (0, $503d195e8098532c$export$7613e4d4725461b7).getRawState();
    if (completed) return;
    if (/^[a-zA-Z]$/.test(key)) {
        // solutions are always normalized to all caps
        key = key.toUpperCase();
        if (revealedCells[focusedClueIndex][cursorIndex]) (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
            s.cursorIndex = Math.min(s.guesses[focusedClueIndex].length - 1, s.cursorIndex + 1);
        });
        else (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
            s.guesses[focusedClueIndex][cursorIndex] = key;
            s.mistakes[focusedClueIndex][cursorIndex] = false;
            s.cursorIndex = Math.min(s.guesses[focusedClueIndex].length - 1, s.cursorIndex + 1);
            if (s.revealedCells[s.focusedClueIndex][s.cursorIndex]) $2eaf3926a83a2b13$var$moveCursorToNextOpenSlot(s);
            if ($2eaf3926a83a2b13$var$isCompleted(s.guesses, s.revealedCells, s.clues)) {
                s.completed = true;
                if (!s.revealed) s.solved = true;
                $2eaf3926a83a2b13$var$onComplete();
            } else if ($2eaf3926a83a2b13$var$shouldShowAlmostThereDialog(s.guesses, s.revealedCells, s.clues)) s.toolbar.almostThereIsOpen = true;
        });
    } else if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).Space) {
        if (shiftKey) {
            $2eaf3926a83a2b13$export$4f2368f44db85843();
            return;
        }
        // if revealed or blank, go to next slot unless that's revealed too. stop at end ofc.
        // (this is basically a forward backspace, i.e. Del on windows.)
        if (revealedCells[focusedClueIndex][cursorIndex] || !guesses[focusedClueIndex][cursorIndex]) (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
            s.cursorIndex = Math.min(s.cursorIndex + 1, s.guesses[s.focusedClueIndex].length - 1);
        });
        else (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
            if (s.guesses[focusedClueIndex][cursorIndex]) {
                s.guesses[focusedClueIndex][cursorIndex] = null;
                s.mistakes[focusedClueIndex][cursorIndex] = false;
            }
        });
    } else if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).Delete) {
        // if revealed or blank, clear previous slot unless that's revealed too. stop at index 0 ofc.
        if (revealedCells[focusedClueIndex][cursorIndex] || !guesses[focusedClueIndex][cursorIndex]) (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
            s.cursorIndex = Math.max(s.cursorIndex - 1, 0);
            if (!revealedCells[focusedClueIndex][s.cursorIndex]) {
                s.guesses[focusedClueIndex][s.cursorIndex] = null;
                s.mistakes[focusedClueIndex][s.cursorIndex] = false;
            }
        });
        else (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
            if (s.guesses[focusedClueIndex][cursorIndex]) {
                s.guesses[focusedClueIndex][cursorIndex] = null;
                s.mistakes[focusedClueIndex][cursorIndex] = false;
            }
        });
    } else if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).ArrowUp) (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
        s.focusedClueIndex = Math.max(s.focusedClueIndex - 1, 0);
        s.cursorIndex = Math.min(Math.max(s.cursorIndex, 0), s.guesses[s.focusedClueIndex].length - 1);
    });
    else if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).ArrowDown) (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
        s.focusedClueIndex = Math.min(s.focusedClueIndex + 1, s.clues.length - 1);
        s.cursorIndex = Math.min(Math.max(s.cursorIndex, 0), s.guesses[s.focusedClueIndex].length - 1);
    });
    else if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).ArrowLeft) (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
        s.cursorIndex = Math.max(s.cursorIndex - 1, 0);
    });
    else if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).ArrowRight) (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
        const lengthOfFocusedClue = s.clues[s.focusedClueIndex].solution.length;
        s.cursorIndex = Math.min(s.cursorIndex + 1, lengthOfFocusedClue - 1);
    });
    else if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).Tab) {
        if (shiftKey) (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
            s.focusedClueIndex = focusedClueIndex - 1 < 0 ? guesses.length - 1 : focusedClueIndex - 1;
            $2eaf3926a83a2b13$export$28120faafeefa4c5(s);
        });
        else (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
            s.focusedClueIndex = focusedClueIndex + 1 > guesses.length - 1 ? 0 : focusedClueIndex + 1;
            $2eaf3926a83a2b13$export$28120faafeefa4c5(s);
        });
    }
};
const $2eaf3926a83a2b13$export$4f2368f44db85843 = ()=>{
    const { focusedClueIndex: focusedClueIndex } = (0, $503d195e8098532c$export$7613e4d4725461b7).getRawState();
    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
        for(let n = 0; n < s.guesses[focusedClueIndex].length; n++){
            s.guesses[focusedClueIndex][n] = null;
            s.mistakes[focusedClueIndex][n] = false;
        }
        s.cursorIndex = 0;
    });
};
const $2eaf3926a83a2b13$export$af2f1643f52e0e9c = ()=>{
    if ((0, $503d195e8098532c$export$7613e4d4725461b7).getRawState().solved) return;
    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
        for(let n = 0; n < s.guesses.length; n++){
            for(let i = 0; i < s.guesses[n].length; i++){
                s.guesses[n][i] = null;
                s.mistakes[n][i] = false;
            }
            s.cursorIndex = 0;
            s.focusedClueIndex = 0;
        }
    });
};
const $2eaf3926a83a2b13$export$6f61f2e76c082c66 = ()=>{
    const { focusedClueIndex: focusedClueIndex, cursorIndex: cursorIndex } = (0, $503d195e8098532c$export$7613e4d4725461b7).getRawState();
    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
        s.revealed = true;
        s.revealedCells[focusedClueIndex][cursorIndex] = true;
        s.mistakes[focusedClueIndex][cursorIndex] = false;
        if ($2eaf3926a83a2b13$var$isCompleted(s.guesses, s.revealedCells, s.clues)) {
            s.completed = true;
            setTimeout($2eaf3926a83a2b13$var$onComplete, 100);
        } else // let store update then save
        setTimeout($2eaf3926a83a2b13$export$5c96c7fea13888f, 100);
    });
};
const $2eaf3926a83a2b13$export$920879cc398c7fed = ()=>{
    const { focusedClueIndex: focusedClueIndex } = (0, $503d195e8098532c$export$7613e4d4725461b7).getRawState();
    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
        s.revealed = true;
        for(let n = 0; n < s.revealedCells[focusedClueIndex].length; n++){
            s.revealedCells[focusedClueIndex][n] = true;
            s.mistakes[focusedClueIndex][n] = false;
        }
        if ($2eaf3926a83a2b13$var$isCompleted(s.guesses, s.revealedCells, s.clues)) {
            s.completed = true;
            setTimeout($2eaf3926a83a2b13$var$onComplete, 100);
        } else // let store update then save
        setTimeout($2eaf3926a83a2b13$export$5c96c7fea13888f, 100);
    });
};
const $2eaf3926a83a2b13$export$48a1b615b62a793 = ()=>{
    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
        s.revealed = true;
        s.completed = true;
        for(let n = 0; n < s.revealedCells.length; n++)for(let i = 0; i < s.revealedCells[n].length; i++)s.revealedCells[n][i] = true;
    });
    // let store update then save
    setTimeout($2eaf3926a83a2b13$var$onComplete, 100);
};
const $2eaf3926a83a2b13$export$ebf0e4b32d392a5 = ()=>{
    const { autocheckOn: autocheckOn, guesses: guesses, cursorIndex: cursorIndex, focusedClueIndex: focusedClueIndex, clues: clues } = (0, $503d195e8098532c$export$7613e4d4725461b7).getRawState();
    if (autocheckOn) return;
    if (guesses[focusedClueIndex][cursorIndex] === clues[focusedClueIndex].solution[cursorIndex]) (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
        s.revealed = true;
        s.revealedCells[focusedClueIndex][cursorIndex] = true;
    });
    else if (guesses[focusedClueIndex][cursorIndex] !== null) (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
        s.revealed = true;
        s.mistakes[focusedClueIndex][cursorIndex] = true;
    });
    // let store update then save
    setTimeout($2eaf3926a83a2b13$export$5c96c7fea13888f, 100);
};
const $2eaf3926a83a2b13$export$766daef7c097c7f7 = ()=>{
    const { autocheckOn: autocheckOn, guesses: guesses, focusedClueIndex: focusedClueIndex, clues: clues } = (0, $503d195e8098532c$export$7613e4d4725461b7).getRawState();
    if (autocheckOn) return;
    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
        s.revealed = true;
        for(let n = 0; n < guesses[focusedClueIndex].length; n++)// ignore already revealed cells
        if (!s.revealedCells[focusedClueIndex][n]) {
            // check if is right or not and mark it.
            if (guesses[focusedClueIndex][n] === clues[focusedClueIndex].solution[n]) s.revealedCells[focusedClueIndex][n] = true;
            else if (guesses[focusedClueIndex][n] !== null) s.mistakes[focusedClueIndex][n] = true;
        }
    });
    // let store update then save
    setTimeout($2eaf3926a83a2b13$export$5c96c7fea13888f, 100);
};
const $2eaf3926a83a2b13$export$ed0314765beb2ba1 = ()=>{
    const { guesses: guesses, clues: clues } = (0, $503d195e8098532c$export$7613e4d4725461b7).getRawState();
    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
        s.revealed = true;
        for(let i = 0; i < guesses.length; i++){
            for(let n = 0; n < guesses[i].length; n++)// ignore already revealed cells
            if (!s.revealedCells[i][n]) {
                // check if is right or not and mark it.
                if (guesses[i][n] === clues[i].solution[n]) s.revealedCells[i][n] = true;
                else if (guesses[i][n] !== null) s.mistakes[i][n] = true;
            }
        }
    });
    // let store update then save
    setTimeout($2eaf3926a83a2b13$export$5c96c7fea13888f, 100);
};
const $2eaf3926a83a2b13$export$d861b77f58a34e9b = ()=>{
    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
        s.revealed = true;
        s.autocheckOn = !s.autocheckOn;
    });
};
var $2eaf3926a83a2b13$export$105770301816d0f9 = /*#__PURE__*/ function(ConfirmationTypes) {
    ConfirmationTypes["CheckLetter"] = "CheckLetter";
    ConfirmationTypes["CheckWord"] = "CheckWord";
    ConfirmationTypes["CheckPuzzle"] = "CheckPuzzle";
    ConfirmationTypes["Autocheck"] = "Autocheck";
    ConfirmationTypes["RevealLetter"] = "RevealLetter";
    ConfirmationTypes["RevealWord"] = "RevealWord";
    ConfirmationTypes["RevealPuzzle"] = "RevealPuzzle";
    return ConfirmationTypes;
}({});
const $2eaf3926a83a2b13$export$9b2690a4578612b0 = (confirmationType)=>{
    const { revealed: revealed, completed: completed } = (0, $503d195e8098532c$export$7613e4d4725461b7).getRawState();
    if (completed) return;
    switch(confirmationType){
        case "CheckLetter":
            if (revealed) $2eaf3926a83a2b13$export$ebf0e4b32d392a5();
            else (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                s.toolbar.confirmationDialog.checkLetterIsOpen = true;
                s.isSoftPaused = true;
            });
            break;
        case "CheckWord":
            if (revealed) $2eaf3926a83a2b13$export$766daef7c097c7f7();
            else (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                s.toolbar.confirmationDialog.checkWordIsOpen = true;
                s.isSoftPaused = true;
            });
            break;
        case "CheckPuzzle":
            if (revealed) $2eaf3926a83a2b13$export$ed0314765beb2ba1();
            else (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                s.toolbar.confirmationDialog.checkPuzzleIsOpen = true;
                s.isSoftPaused = true;
            });
            break;
        case "Autocheck":
            if (revealed) $2eaf3926a83a2b13$export$d861b77f58a34e9b();
            else (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                s.toolbar.confirmationDialog.autocheckIsOpen = true;
                s.isSoftPaused = true;
            });
            break;
        case "RevealLetter":
            if (revealed) $2eaf3926a83a2b13$export$6f61f2e76c082c66();
            else (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                s.toolbar.confirmationDialog.revealLetterIsOpen = true;
                s.isSoftPaused = true;
            });
            break;
        case "RevealWord":
            if (revealed) $2eaf3926a83a2b13$export$920879cc398c7fed();
            else (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                s.toolbar.confirmationDialog.revealWordIsOpen = true;
                s.isSoftPaused = true;
            });
            break;
        case "RevealPuzzle":
            // always confirm this, even if it's already marked Revealed
            (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                s.toolbar.confirmationDialog.revealAllIsOpen = true;
                s.isSoftPaused = true;
            });
            break;
    }
};
const $2eaf3926a83a2b13$export$2ee2e0ff7ab8887b = (focusedClueIndex)=>{
    const clues = (0, $503d195e8098532c$export$7613e4d4725461b7).getRawState().clues;
    const clueRows = document.querySelectorAll('.clueRow');
    const cluesContainer = document.querySelector('.cluesContainer');
    const focused = clueRows[focusedClueIndex];
    const focusedRect = focused.getBoundingClientRect();
    const cluesContainerRect = cluesContainer.getBoundingClientRect();
    const focusedIsBelowView = focusedRect.top > cluesContainerRect.bottom - 60;
    const focusedIsAboveView = focusedRect.bottom < cluesContainerRect.top + 40;
    if (focusedIsBelowView) {
        if (focusedClueIndex === clues.length - 1) cluesContainer.scrollTop = cluesContainer.scrollHeight;
        else {
            const newScroll = cluesContainer.scrollTop + focusedRect.height;
            if (focusedRect.top > cluesContainerRect.bottom) cluesContainer.scrollTop = focused.offsetTop + focused.offsetHeight - cluesContainer.clientHeight + 40;
            else cluesContainer.scrollTop = newScroll;
        }
        return;
    }
    if (focusedIsAboveView) {
        if (focusedClueIndex === 0) cluesContainer.scrollTop = 0;
        else {
            const newScroll = cluesContainer.scrollTop - focusedRect.height;
            if (focusedRect.bottom < cluesContainerRect.top) cluesContainer.scrollTop = focused.offsetTop;
            else cluesContainer.scrollTop = newScroll;
        }
        return;
    }
};
const $2eaf3926a83a2b13$export$34fa0bd59b56d9c7 = (clueText)=>{
    const parts = [];
    let currentIndex = 0;
    let keyCounter = 0;
    // Find all italic sections marked with ^text^
    const italicRegex = /\^([^^]+)\^/g;
    let match;
    while((match = italicRegex.exec(clueText)) !== null){
        // Add text before the italic section
        if (match.index > currentIndex) parts.push(clueText.substring(currentIndex, match.index));
        // Add the italic section
        parts.push((0, (/*@__PURE__*/$parcel$interopDefault($28UcW))).createElement('span', {
            key: keyCounter++,
            className: 'italicText'
        }, match[1]));
        currentIndex = match.index + match[0].length;
    }
    // Add remaining text after last italic section
    if (currentIndex < clueText.length) parts.push(clueText.substring(currentIndex));
    // If no italic markers were found, just return the original text
    return parts.length === 0 ? clueText : parts;
};



const $796711f10012c239$var$onComplete = ()=>{
    const { time: time, revealed: revealed, puzzleId: puzzleId } = (0, $01d05596dd530619$export$9e774c7f63a1a494).getRawState();
    setTimeout(()=>{
        (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
            s.statsDialogIsOpen = true;
        });
    }, (0, $860afe5c90b07ab1$export$87a8383fc3f35723));
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Morphology, {
        puzzleId: puzzleId,
        revealed: revealed,
        solved: !revealed,
        time: time,
        completed: true,
        partialState: null
    });
    // Also record today's solve in the user's archive list (signed-in only; no-op
    // otherwise). Lets the archive view reflect that today's puzzle was completed.
    (0, $2eaf3926a83a2b13$export$b789e1fe3c5b2ad4)(puzzleId);
};
const $796711f10012c239$export$5c96c7fea13888f = ()=>{
    const { solved: solved, revealed: revealed, completed: completed, time: time, guesses: guesses, revealedCells: revealedCells, puzzleId: puzzleId } = (0, $01d05596dd530619$export$9e774c7f63a1a494).getRawState();
    // just updating progress on pause or navigate away
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Morphology, {
        puzzleId: puzzleId,
        revealed: revealed,
        solved: solved,
        time: time,
        completed: completed,
        partialState: completed ? null : {
            guesses: guesses,
            revealedCells: revealedCells,
            timeOfLastUpdate: new Date().toISOString()
        }
    });
};
const $796711f10012c239$export$2b897112635d6470 = (puzzleData)=>{
    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
        s.puzzleId = puzzleData.puzzleId;
        s.cryptic = !!puzzleData.cryptic;
        // it should be all caps anyway, but just in case of mistake we make sure here.
        s.clues = puzzleData.clues.map((clue)=>({
                ...clue,
                solution: clue.solution.toUpperCase()
            }));
        s.guesses = s.clues.map((clue)=>Array(clue.solution.length).fill(null));
        s.revealedCells = s.clues.map((clue)=>Array(clue.solution.length).fill(false));
        s.mistakes = s.clues.map((clue)=>Array(clue.solution.length).fill(false));
        s.author = puzzleData.author;
    });
};
let $796711f10012c239$var$hasAlreadyShownAlmostThereDialog = false;
const $796711f10012c239$var$shouldShowAlmostThereDialog = (guesses, revealedCells, clues)=>{
    if ($796711f10012c239$var$hasAlreadyShownAlmostThereDialog) return false;
    for(let i = 0; i < clues.length; i++){
        const guess = guesses[i];
        for(let j = 0; j < guess.length; j++){
            if (revealedCells[i][j]) continue;
            if (guess[j] === null) return false;
        }
    }
    $796711f10012c239$var$hasAlreadyShownAlmostThereDialog = true;
    return true;
};
const $796711f10012c239$var$isCompleted = (guesses, revealedCells, clues)=>{
    for(let i = 0; i < clues.length; i++){
        const solution = clues[i].solution;
        const guess = guesses[i];
        for(let j = 0; j < solution.length; j++){
            if (revealedCells[i][j]) continue;
            if (guess[j] !== solution[j]) return false;
        }
    }
    return true;
};
const $796711f10012c239$export$28120faafeefa4c5 = (s)=>{
    const guessForClue = s.guesses[s.focusedClueIndex];
    const nullIndex = guessForClue.findIndex((letterGuess, i)=>letterGuess === null && s.revealedCells[s.focusedClueIndex][i] === false);
    s.cursorIndex = Math.max(nullIndex, 0);
};
// s = state, because this is meant to be used on a state draft inside a store update
const $796711f10012c239$var$moveCursorToNextOpenSlot = (s)=>{
    const guessForClue = s.guesses[s.focusedClueIndex];
    // Find the first null index AFTER s.cursorIndex that isn't revealed
    let nullIndex = guessForClue.slice(s.cursorIndex + 1).findIndex((guessForLetter, i)=>guessForLetter === null && s.revealedCells[s.focusedClueIndex][s.cursorIndex + 1 + i] === false) + s.cursorIndex + 1;
    // if we didn't find one, then look for the first null index that isn't revealed, from the start
    if (nullIndex === -1) nullIndex = guessForClue.findIndex((guessForLetter, i)=>guessForLetter === null && s.revealedCells[s.focusedClueIndex][i] === false);
    if (nullIndex !== -1) s.cursorIndex = nullIndex;
    else // If no null is found at all, move index forward by one unless we're at the end
    s.cursorIndex = s.cursorIndex === guessForClue.length - 1 ? s.cursorIndex : s.cursorIndex + 1;
};
const $796711f10012c239$export$412508d679148d5c = (key, shiftKey)=>{
    const { completed: completed, guesses: guesses, revealedCells: revealedCells, cursorIndex: cursorIndex, focusedClueIndex: focusedClueIndex } = (0, $01d05596dd530619$export$9e774c7f63a1a494).getRawState();
    if (completed) return;
    if (/^[a-zA-Z]$/.test(key)) {
        // solutions are always normalized to all caps
        key = key.toUpperCase();
        if (revealedCells[focusedClueIndex][cursorIndex]) (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
            s.cursorIndex = Math.min(s.guesses[focusedClueIndex].length - 1, s.cursorIndex + 1);
        });
        else (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
            s.guesses[focusedClueIndex][cursorIndex] = key;
            s.mistakes[focusedClueIndex][cursorIndex] = false;
            s.cursorIndex = Math.min(s.guesses[focusedClueIndex].length - 1, s.cursorIndex + 1);
            if (s.revealedCells[s.focusedClueIndex][s.cursorIndex]) $796711f10012c239$var$moveCursorToNextOpenSlot(s);
            if ($796711f10012c239$var$isCompleted(s.guesses, s.revealedCells, s.clues)) {
                s.completed = true;
                if (!s.revealed) s.solved = true;
                $796711f10012c239$var$onComplete();
            } else if ($796711f10012c239$var$shouldShowAlmostThereDialog(s.guesses, s.revealedCells, s.clues)) s.toolbar.almostThereIsOpen = true;
        });
    } else if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).Space) {
        if (shiftKey) {
            $796711f10012c239$export$4f2368f44db85843();
            return;
        }
        // if revealed or blank, go to next slot unless that's revealed too. stop at end ofc.
        // (this is basically a forward backspace, i.e. Del on windows.)
        if (revealedCells[focusedClueIndex][cursorIndex] || !guesses[focusedClueIndex][cursorIndex]) (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
            s.cursorIndex = Math.min(s.cursorIndex + 1, s.guesses[s.focusedClueIndex].length - 1);
        });
        else (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
            if (s.guesses[focusedClueIndex][cursorIndex]) {
                s.guesses[focusedClueIndex][cursorIndex] = null;
                s.mistakes[focusedClueIndex][cursorIndex] = false;
            }
        });
    } else if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).Delete) {
        // if revealed or blank, clear previous slot unless that's revealed too. stop at index 0 ofc.
        if (revealedCells[focusedClueIndex][cursorIndex] || !guesses[focusedClueIndex][cursorIndex]) (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
            s.cursorIndex = Math.max(s.cursorIndex - 1, 0);
            if (!revealedCells[focusedClueIndex][s.cursorIndex]) {
                s.guesses[focusedClueIndex][s.cursorIndex] = null;
                s.mistakes[focusedClueIndex][s.cursorIndex] = false;
            }
        });
        else (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
            if (s.guesses[focusedClueIndex][cursorIndex]) {
                s.guesses[focusedClueIndex][cursorIndex] = null;
                s.mistakes[focusedClueIndex][cursorIndex] = false;
            }
        });
    } else if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).ArrowUp) (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
        s.focusedClueIndex = Math.max(s.focusedClueIndex - 1, 0);
        s.cursorIndex = Math.min(Math.max(s.cursorIndex, 0), s.guesses[s.focusedClueIndex].length - 1);
    });
    else if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).ArrowDown) (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
        s.focusedClueIndex = Math.min(s.focusedClueIndex + 1, s.clues.length - 1);
        s.cursorIndex = Math.min(Math.max(s.cursorIndex, 0), s.guesses[s.focusedClueIndex].length - 1);
    });
    else if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).ArrowLeft) (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
        s.cursorIndex = Math.max(s.cursorIndex - 1, 0);
    });
    else if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).ArrowRight) (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
        const lengthOfFocusedClue = s.clues[s.focusedClueIndex].solution.length;
        s.cursorIndex = Math.min(s.cursorIndex + 1, lengthOfFocusedClue - 1);
    });
    else if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).Tab) {
        if (shiftKey) (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
            s.focusedClueIndex = focusedClueIndex - 1 < 0 ? guesses.length - 1 : focusedClueIndex - 1;
            $796711f10012c239$export$28120faafeefa4c5(s);
        });
        else (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
            s.focusedClueIndex = focusedClueIndex + 1 > guesses.length - 1 ? 0 : focusedClueIndex + 1;
            $796711f10012c239$export$28120faafeefa4c5(s);
        });
    }
};
const $796711f10012c239$export$4f2368f44db85843 = ()=>{
    const { focusedClueIndex: focusedClueIndex } = (0, $01d05596dd530619$export$9e774c7f63a1a494).getRawState();
    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
        for(let n = 0; n < s.guesses[focusedClueIndex].length; n++){
            s.guesses[focusedClueIndex][n] = null;
            s.mistakes[focusedClueIndex][n] = false;
        }
        s.cursorIndex = 0;
    });
};
const $796711f10012c239$export$af2f1643f52e0e9c = ()=>{
    if ((0, $01d05596dd530619$export$9e774c7f63a1a494).getRawState().solved) return;
    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
        for(let n = 0; n < s.guesses.length; n++){
            for(let i = 0; i < s.guesses[n].length; i++){
                s.guesses[n][i] = null;
                s.mistakes[n][i] = false;
            }
            s.cursorIndex = 0;
            s.focusedClueIndex = 0;
        }
    });
};
const $796711f10012c239$export$6f61f2e76c082c66 = ()=>{
    const { focusedClueIndex: focusedClueIndex, cursorIndex: cursorIndex } = (0, $01d05596dd530619$export$9e774c7f63a1a494).getRawState();
    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
        s.revealed = true;
        s.revealedCells[focusedClueIndex][cursorIndex] = true;
        s.mistakes[focusedClueIndex][cursorIndex] = false;
        if ($796711f10012c239$var$isCompleted(s.guesses, s.revealedCells, s.clues)) {
            s.completed = true;
            setTimeout($796711f10012c239$var$onComplete, 100);
        } else // let store update then save
        setTimeout($796711f10012c239$export$5c96c7fea13888f, 100);
    });
};
const $796711f10012c239$export$920879cc398c7fed = ()=>{
    const { focusedClueIndex: focusedClueIndex } = (0, $01d05596dd530619$export$9e774c7f63a1a494).getRawState();
    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
        s.revealed = true;
        for(let n = 0; n < s.revealedCells[focusedClueIndex].length; n++){
            s.revealedCells[focusedClueIndex][n] = true;
            s.mistakes[focusedClueIndex][n] = false;
        }
        if ($796711f10012c239$var$isCompleted(s.guesses, s.revealedCells, s.clues)) {
            s.completed = true;
            setTimeout($796711f10012c239$var$onComplete, 100);
        } else // let store update then save
        setTimeout($796711f10012c239$export$5c96c7fea13888f, 100);
    });
};
const $796711f10012c239$export$48a1b615b62a793 = ()=>{
    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
        s.revealed = true;
        s.completed = true;
        for(let n = 0; n < s.revealedCells.length; n++)for(let i = 0; i < s.revealedCells[n].length; i++)s.revealedCells[n][i] = true;
    });
    // let store update then save
    setTimeout($796711f10012c239$var$onComplete, 100);
};
const $796711f10012c239$export$ebf0e4b32d392a5 = ()=>{
    const { autocheckOn: autocheckOn, guesses: guesses, cursorIndex: cursorIndex, focusedClueIndex: focusedClueIndex, clues: clues } = (0, $01d05596dd530619$export$9e774c7f63a1a494).getRawState();
    if (autocheckOn) return;
    if (guesses[focusedClueIndex][cursorIndex] === clues[focusedClueIndex].solution[cursorIndex]) (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
        s.revealed = true;
        s.revealedCells[focusedClueIndex][cursorIndex] = true;
    });
    else if (guesses[focusedClueIndex][cursorIndex] !== null) (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
        s.revealed = true;
        s.mistakes[focusedClueIndex][cursorIndex] = true;
    });
    // let store update then save
    setTimeout($796711f10012c239$export$5c96c7fea13888f, 100);
};
const $796711f10012c239$export$766daef7c097c7f7 = ()=>{
    const { autocheckOn: autocheckOn, guesses: guesses, focusedClueIndex: focusedClueIndex, clues: clues } = (0, $01d05596dd530619$export$9e774c7f63a1a494).getRawState();
    if (autocheckOn) return;
    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
        s.revealed = true;
        for(let n = 0; n < guesses[focusedClueIndex].length; n++)// ignore already revealed cells
        if (!s.revealedCells[focusedClueIndex][n]) {
            // check if is right or not and mark it.
            if (guesses[focusedClueIndex][n] === clues[focusedClueIndex].solution[n]) s.revealedCells[focusedClueIndex][n] = true;
            else if (guesses[focusedClueIndex][n] !== null) s.mistakes[focusedClueIndex][n] = true;
        }
    });
    // let store update then save
    setTimeout($796711f10012c239$export$5c96c7fea13888f, 100);
};
const $796711f10012c239$export$ed0314765beb2ba1 = ()=>{
    const { guesses: guesses, clues: clues } = (0, $01d05596dd530619$export$9e774c7f63a1a494).getRawState();
    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
        s.revealed = true;
        for(let i = 0; i < guesses.length; i++){
            for(let n = 0; n < guesses[i].length; n++)// ignore already revealed cells
            if (!s.revealedCells[i][n]) {
                // check if is right or not and mark it.
                if (guesses[i][n] === clues[i].solution[n]) s.revealedCells[i][n] = true;
                else if (guesses[i][n] !== null) s.mistakes[i][n] = true;
            }
        }
    });
    // let store update then save
    setTimeout($796711f10012c239$export$5c96c7fea13888f, 100);
};
const $796711f10012c239$export$d861b77f58a34e9b = ()=>{
    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
        s.revealed = true;
        s.autocheckOn = !s.autocheckOn;
    });
};
var $796711f10012c239$export$105770301816d0f9 = /*#__PURE__*/ function(ConfirmationTypes) {
    ConfirmationTypes["CheckLetter"] = "CheckLetter";
    ConfirmationTypes["CheckWord"] = "CheckWord";
    ConfirmationTypes["CheckPuzzle"] = "CheckPuzzle";
    ConfirmationTypes["Autocheck"] = "Autocheck";
    ConfirmationTypes["RevealLetter"] = "RevealLetter";
    ConfirmationTypes["RevealWord"] = "RevealWord";
    ConfirmationTypes["RevealPuzzle"] = "RevealPuzzle";
    return ConfirmationTypes;
}({});
const $796711f10012c239$export$9b2690a4578612b0 = (confirmationType)=>{
    const { revealed: revealed, completed: completed } = (0, $01d05596dd530619$export$9e774c7f63a1a494).getRawState();
    if (completed) return;
    switch(confirmationType){
        case "CheckLetter":
            if (revealed) $796711f10012c239$export$ebf0e4b32d392a5();
            else (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                s.toolbar.confirmationDialog.checkLetterIsOpen = true;
                s.isSoftPaused = true;
            });
            break;
        case "CheckWord":
            if (revealed) $796711f10012c239$export$766daef7c097c7f7();
            else (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                s.toolbar.confirmationDialog.checkWordIsOpen = true;
                s.isSoftPaused = true;
            });
            break;
        case "CheckPuzzle":
            if (revealed) $796711f10012c239$export$ed0314765beb2ba1();
            else (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                s.toolbar.confirmationDialog.checkPuzzleIsOpen = true;
                s.isSoftPaused = true;
            });
            break;
        case "Autocheck":
            if (revealed) $796711f10012c239$export$d861b77f58a34e9b();
            else (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                s.toolbar.confirmationDialog.autocheckIsOpen = true;
                s.isSoftPaused = true;
            });
            break;
        case "RevealLetter":
            if (revealed) $796711f10012c239$export$6f61f2e76c082c66();
            else (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                s.toolbar.confirmationDialog.revealLetterIsOpen = true;
                s.isSoftPaused = true;
            });
            break;
        case "RevealWord":
            if (revealed) $796711f10012c239$export$920879cc398c7fed();
            else (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                s.toolbar.confirmationDialog.revealWordIsOpen = true;
                s.isSoftPaused = true;
            });
            break;
        case "RevealPuzzle":
            // always confirm this, even if it's already marked Revealed
            (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                s.toolbar.confirmationDialog.revealAllIsOpen = true;
                s.isSoftPaused = true;
            });
            break;
    }
};
const $796711f10012c239$export$2ee2e0ff7ab8887b = (focusedClueIndex)=>{
    const clues = (0, $01d05596dd530619$export$9e774c7f63a1a494).getRawState().clues;
    const clueRows = document.querySelectorAll('.clueRow');
    const cluesContainer = document.querySelector('.cluesContainer');
    const focused = clueRows[focusedClueIndex];
    const focusedRect = focused.getBoundingClientRect();
    const cluesContainerRect = cluesContainer.getBoundingClientRect();
    const focusedIsBelowView = focusedRect.top > cluesContainerRect.bottom - 60;
    const focusedIsAboveView = focusedRect.bottom < cluesContainerRect.top + 40;
    if (focusedIsBelowView) {
        if (focusedClueIndex === clues.length - 1) cluesContainer.scrollTop = cluesContainer.scrollHeight;
        else {
            const newScroll = cluesContainer.scrollTop + focusedRect.height;
            if (focusedRect.top > cluesContainerRect.bottom) cluesContainer.scrollTop = focused.offsetTop + focused.offsetHeight - cluesContainer.clientHeight + 40;
            else cluesContainer.scrollTop = newScroll;
        }
        return;
    }
    if (focusedIsAboveView) {
        if (focusedClueIndex === 0) cluesContainer.scrollTop = 0;
        else {
            const newScroll = cluesContainer.scrollTop - focusedRect.height;
            if (focusedRect.bottom < cluesContainerRect.top) cluesContainer.scrollTop = focused.offsetTop;
            else cluesContainer.scrollTop = newScroll;
        }
        return;
    }
};
const $796711f10012c239$export$41c7003f986b7c06 = ()=>{
    // Format the date as "Weekday, Month Day, Year"
    const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
    // Convert to EST timezone
    const estDate = new Date(new Date().toLocaleString('en-US', {
        timeZone: 'America/New_York'
    }));
    return estDate.toLocaleDateString('en-US', options);
};
const $796711f10012c239$export$34fa0bd59b56d9c7 = (clueText)=>{
    const parts = [];
    let currentIndex = 0;
    let keyCounter = 0;
    // Find all italic sections marked with ^text^
    const italicRegex = /\^([^^]+)\^/g;
    let match;
    while((match = italicRegex.exec(clueText)) !== null){
        // Add text before the italic section
        if (match.index > currentIndex) parts.push(clueText.substring(currentIndex, match.index));
        // Add the italic section
        parts.push((0, (/*@__PURE__*/$parcel$interopDefault($28UcW))).createElement('span', {
            key: keyCounter++,
            className: 'italicText'
        }, match[1]));
        currentIndex = match.index + match[0].length;
    }
    // Add remaining text after last italic section
    if (currentIndex < clueText.length) parts.push(clueText.substring(currentIndex));
    // If no italic markers were found, just return the original text
    return parts.length === 0 ? clueText : parts;
};




var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");


var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");



const $cd4fe362d74545f0$var$RevealConfirmationDialogCluster = ()=>{
    const confirmationDialogSettings = (0, $01d05596dd530619$export$9e774c7f63a1a494).useState((s)=>s.toolbar.confirmationDialog);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2bbc7cde64cbe8e7$export$2e2bcd8739ae039), {
                store: (0, $01d05596dd530619$export$9e774c7f63a1a494),
                onConfirm: (0, $796711f10012c239$export$af2f1643f52e0e9c),
                onClose: ()=>{
                    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                        s.toolbar.confirmationDialog.clearAllIsOpen = false;
                    });
                },
                isOpen: confirmationDialogSettings.clearAllIsOpen,
                prompt: "Are you sure you want to clear the entire puzzle?"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2bbc7cde64cbe8e7$export$2e2bcd8739ae039), {
                store: (0, $01d05596dd530619$export$9e774c7f63a1a494),
                onConfirm: (0, $796711f10012c239$export$ebf0e4b32d392a5),
                onClose: ()=>{
                    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                        s.toolbar.confirmationDialog.checkLetterIsOpen = false;
                    });
                },
                isOpen: confirmationDialogSettings.checkLetterIsOpen
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2bbc7cde64cbe8e7$export$2e2bcd8739ae039), {
                store: (0, $01d05596dd530619$export$9e774c7f63a1a494),
                onConfirm: (0, $796711f10012c239$export$766daef7c097c7f7),
                onClose: ()=>{
                    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                        s.toolbar.confirmationDialog.checkWordIsOpen = false;
                    });
                },
                isOpen: confirmationDialogSettings.checkWordIsOpen
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2bbc7cde64cbe8e7$export$2e2bcd8739ae039), {
                store: (0, $01d05596dd530619$export$9e774c7f63a1a494),
                onConfirm: (0, $796711f10012c239$export$ed0314765beb2ba1),
                onClose: ()=>{
                    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                        s.toolbar.confirmationDialog.checkPuzzleIsOpen = false;
                    });
                },
                isOpen: confirmationDialogSettings.checkPuzzleIsOpen
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2bbc7cde64cbe8e7$export$2e2bcd8739ae039), {
                store: (0, $01d05596dd530619$export$9e774c7f63a1a494),
                onConfirm: (0, $796711f10012c239$export$d861b77f58a34e9b),
                onClose: ()=>{
                    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                        s.toolbar.confirmationDialog.autocheckIsOpen = false;
                    });
                },
                isOpen: confirmationDialogSettings.autocheckIsOpen
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2bbc7cde64cbe8e7$export$2e2bcd8739ae039), {
                store: (0, $01d05596dd530619$export$9e774c7f63a1a494),
                onConfirm: (0, $796711f10012c239$export$6f61f2e76c082c66),
                onClose: ()=>{
                    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                        s.toolbar.confirmationDialog.revealLetterIsOpen = false;
                    });
                },
                isOpen: confirmationDialogSettings.revealLetterIsOpen
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2bbc7cde64cbe8e7$export$2e2bcd8739ae039), {
                store: (0, $01d05596dd530619$export$9e774c7f63a1a494),
                onConfirm: (0, $796711f10012c239$export$920879cc398c7fed),
                onClose: ()=>{
                    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                        s.toolbar.confirmationDialog.revealWordIsOpen = false;
                    });
                },
                isOpen: confirmationDialogSettings.revealWordIsOpen
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2bbc7cde64cbe8e7$export$2e2bcd8739ae039), {
                store: (0, $01d05596dd530619$export$9e774c7f63a1a494),
                onConfirm: (0, $796711f10012c239$export$48a1b615b62a793),
                onClose: ()=>{
                    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                        s.toolbar.confirmationDialog.revealAllIsOpen = false;
                    });
                },
                isOpen: confirmationDialogSettings.revealAllIsOpen,
                prompt: "Are you sure you want to reveal the full puzzle? This puzzle will count as revealed and be excluded from any solve streak."
            })
        ]
    });
};
var $cd4fe362d74545f0$export$2e2bcd8739ae039 = $cd4fe362d74545f0$var$RevealConfirmationDialogCluster;


const $6f5220930e57a52a$var$DesktopToolbar = ()=>{
    const { autocheckOn: autocheckOn, completed: completed, toolbar: { clearIsOpen: clearIsOpen, revealIsOpen: revealIsOpen, checkIsOpen: checkIsOpen } } = (0, $01d05596dd530619$export$9e774c7f63a1a494).useState();
    const ref = (0, $28UcW.useRef)(null);
    // If a click is outside the toolbar, it closes all menus.
    // A click within the menu is handled by togglesMenus, which closes all but the clicked one.
    (0, $28UcW.useEffect)(()=>{
        const onClickOutside = (e)=>{
            if (ref.current && !ref.current.contains(e.target)) {
                (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                    s.toolbar.clearIsOpen = false;
                    s.toolbar.revealIsOpen = false;
                    s.toolbar.checkIsOpen = false;
                });
                document.removeEventListener('click', onClickOutside);
            }
        };
        if (clearIsOpen || revealIsOpen || checkIsOpen) document.addEventListener('click', onClickOutside);
        return ()=>{
            document.removeEventListener('click', onClickOutside);
        };
    }, [
        clearIsOpen,
        revealIsOpen,
        checkIsOpen
    ]);
    const toggleMenus = (index)=>{
        switch(index){
            case 1:
                (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                    s.toolbar.clearIsOpen = !clearIsOpen;
                    s.toolbar.revealIsOpen = false;
                    s.toolbar.checkIsOpen = false;
                });
                break;
            case 2:
                (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                    s.toolbar.clearIsOpen = false;
                    s.toolbar.revealIsOpen = !revealIsOpen;
                    s.toolbar.checkIsOpen = false;
                });
                break;
            case 3:
                (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                    s.toolbar.clearIsOpen = false;
                    s.toolbar.revealIsOpen = false;
                    s.toolbar.checkIsOpen = !checkIsOpen;
                });
                break;
        }
    };
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        ref: ref,
        className: "morphologyToolbar",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $cd4fe362d74545f0$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "dropdownButton",
                onClick: ()=>toggleMenus(1),
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "buttonLabel",
                        children: "Clear"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                        className: `dropdownMenu clearMenu ${clearIsOpen ? 'open' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                onClick: (0, $796711f10012c239$export$4f2368f44db85843),
                                children: "Word"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                onClick: ()=>{
                                    if (completed) return;
                                    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                                        s.toolbar.confirmationDialog.clearAllIsOpen = true;
                                    });
                                },
                                children: "Puzzle"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "dropdownButton",
                onClick: ()=>toggleMenus(2),
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "buttonLabel",
                        children: "Reveal"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                        className: `dropdownMenu revealMenu ${revealIsOpen ? 'open' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                onClick: ()=>{
                                    (0, $796711f10012c239$export$9b2690a4578612b0)((0, $796711f10012c239$export$105770301816d0f9).RevealLetter);
                                },
                                children: "Square"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                onClick: ()=>{
                                    (0, $796711f10012c239$export$9b2690a4578612b0)((0, $796711f10012c239$export$105770301816d0f9).RevealWord);
                                },
                                children: "Word"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                onClick: ()=>{
                                    (0, $796711f10012c239$export$9b2690a4578612b0)((0, $796711f10012c239$export$105770301816d0f9).RevealPuzzle);
                                },
                                children: "Puzzle"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "dropdownButton",
                onClick: ()=>toggleMenus(3),
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: autocheckOn ? 'autocheck buttonLabel' : 'buttonLabel',
                        children: autocheckOn ? 'Autocheck' : 'Check'
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                        className: `dropdownMenu checkMenu ${checkIsOpen ? 'open' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                onClick: ()=>{
                                    (0, $796711f10012c239$export$9b2690a4578612b0)((0, $796711f10012c239$export$105770301816d0f9).Autocheck);
                                },
                                children: "Autocheck"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                className: autocheckOn ? 'disabled' : '',
                                onClick: ()=>{
                                    (0, $796711f10012c239$export$9b2690a4578612b0)((0, $796711f10012c239$export$105770301816d0f9).CheckLetter);
                                },
                                children: "Square"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                className: autocheckOn ? 'disabled' : '',
                                onClick: ()=>{
                                    (0, $796711f10012c239$export$9b2690a4578612b0)((0, $796711f10012c239$export$105770301816d0f9).CheckWord);
                                },
                                children: "Word"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                className: autocheckOn ? 'disabled' : '',
                                onClick: ()=>{
                                    (0, $796711f10012c239$export$9b2690a4578612b0)((0, $796711f10012c239$export$105770301816d0f9).CheckPuzzle);
                                },
                                children: "Puzzle"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $6f5220930e57a52a$export$2e2bcd8739ae039 = $6f5220930e57a52a$var$DesktopToolbar;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

const $d49ef9e08b564bf6$var$InputSquare = ({ clueIndex: clueIndex, letterIndex: letterIndex })=>{
    const { completed: completed, clues: clues, guesses: guesses, revealedCells: revealedCells, mistakes: mistakes, focusedClueIndex: focusedClueIndex, cursorIndex: cursorIndex } = (0, $01d05596dd530619$export$9e774c7f63a1a494).useState();
    const letter = guesses[clueIndex][letterIndex];
    const isFocused = clueIndex === focusedClueIndex && letterIndex === cursorIndex;
    // `completed` here catches the case of page reload subsequent to RevealAll, since we don't save
    // the fully revealedCells to the database at that point, just mark it revealed+completed.
    const isRevealed = completed || revealedCells[clueIndex][letterIndex];
    const isWrong = mistakes[clueIndex][letterIndex];
    const classes = `letterInput` + `${isFocused ? ' focused' : ''}` + `${isRevealed ? ' revealed' : ''}` + `${isWrong ? ' mistake' : ''}` + `${completed ? ' solved' : ''}`;
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: classes,
        onClick: (e)=>{
            (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                s.focusedClueIndex = clueIndex;
                s.cursorIndex = letterIndex;
            });
            // to stop the row onClick in Morphology.tsx from firing
            e.__isSelectingIndividualCell = true;
        },
        children: isRevealed ? clues[clueIndex].solution[letterIndex] : letter
    });
};
var $d49ef9e08b564bf6$export$2e2bcd8739ae039 = $d49ef9e08b564bf6$var$InputSquare;


const $190ce18e10e265cb$var$SolutionInput = ({ guess: guess, clueIndex: clueIndex })=>{
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "solutionInput",
        children: guess.map((letter, letterIndex)=>/*#__PURE__*/ (0, $4XrX4.jsx)((0, $d49ef9e08b564bf6$export$2e2bcd8739ae039), {
                clueIndex: clueIndex,
                letterIndex: letterIndex
            }, letterIndex))
    });
};
var $190ce18e10e265cb$export$2e2bcd8739ae039 = $190ce18e10e265cb$var$SolutionInput;




var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");















var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");





const $192491710ae4f590$var$closeInstructions = ()=>{
    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
        s.instructionsAreOpen = false;
        s.isSoftPaused = false;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).set(`${(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Morphology}InstructionsDismissed`, 'true', {
        domain: (0, $ba1e3b359abf28ef$export$517466abcb8fcf10),
        expires: 365
    });
};
const $192491710ae4f590$var$Instructions = ()=>{
    const isOpen = (0, $01d05596dd530619$export$9e774c7f63a1a494).useState((s)=>s.instructionsAreOpen);
    const cryptic = (0, $01d05596dd530619$export$9e774c7f63a1a494).useState((s)=>s.cryptic);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $a923e83bee9905be$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: $192491710ae4f590$var$closeInstructions,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("h1", {
                className: "instructionsTitle",
                children: "How to Play Morphology"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "instructionsBody",
                children: /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                            children: "Fill in the word ladder with single-word solutions matching the clues."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                            children: [
                                "Each solution differs from the previous clue's solution by just a few letters. The difference is called the ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                    className: "italicText",
                                    children: "morph"
                                }),
                                " and is given in the format ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                    className: "morphText",
                                    children: "(+X, -Y, ~Z)"
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                            className: "sublist",
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                            className: "morphText",
                                            children: "+X"
                                        }),
                                        " means X characters were added.",
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                                        " CHAT is ",
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                            className: "morphText",
                                            children: "+1"
                                        }),
                                        " from CAT."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                            className: "morphText",
                                            children: "-Y"
                                        }),
                                        " means Y characters were removed.",
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                                        " RAIN is ",
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                            className: "morphText",
                                            children: "-2"
                                        }),
                                        " from RACING."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                            className: "morphText",
                                            children: "~Z"
                                        }),
                                        " means Z characters were changed.",
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                                        " GUITAR is ",
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                            className: "morphText",
                                            children: "~2"
                                        }),
                                        " from SUITOR."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                            children: "Morphology usually avoids obscure words, as well as proper names that aren't commonplace or inferrable by the morph."
                        }),
                        cryptic && /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                            className: "crypticCallout",
                            children: /*#__PURE__*/ (0, $4XrX4.jsxs)("b", {
                                children: [
                                    "Today's puzzle is a cryptic, which follows cryptic crossword clueing conventions. Learn more via ",
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                        target: "_blank",
                                        href: "https://www.youtube.com/watch?v=HrKiYFJxgic",
                                        children: "this video"
                                    }),
                                    ", ",
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                        target: "_blank",
                                        href: "https://www.newyorker.com/puzzles-and-games-dept/cryptic-crossword/reintroducing-the-new-yorkers-cryptic-crossword",
                                        children: "this article"
                                    }),
                                    ", or ",
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                        target: "_blank",
                                        href: "https://s.wsj.net/blogs/html/wsjcrypticguide.pdf",
                                        children: "this concise PDF"
                                    }),
                                    "."
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $192491710ae4f590$export$2e2bcd8739ae039 = $192491710ae4f590$var$Instructions;



const $81b5e3023dbf0b84$var$MorphologyTopBar = ()=>{
    const { completed: completed, time: time, isPaused: isPaused } = (0, $01d05596dd530619$export$9e774c7f63a1a494).useState();
    const useFloatingToolbar = (0, $ba1e3b359abf28ef$export$b87c76f5e9f3d3df)(105);
    const useMobileStyles = (0, $b2cd9ecc66d0956f$exports.isMobile) || (0, $ba1e3b359abf28ef$export$580e0f6db19fa7cc)();
    const navigate = (0, $6e00b7bb3feca34a$export$9770f232ac06a008)();
    const pauseButtonClass = completed ? 'hidden' : '';
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: `puzzleTopBar ${useMobileStyles ? 'mobile' : ''}`,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "topBarLeftSection",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        disableRipple: true,
                        title: "Back",
                        onClick: ()=>{
                            navigate('/');
                            window.scrollTo(0, 0);
                            (0, $796711f10012c239$export$5c96c7fea13888f)();
                        },
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ba2d2837fc619c75$exports))), {})
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "navigationLabel",
                        children: (0, $860afe5c90b07ab1$export$db7e8528fe84408c)[(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Morphology]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "topBarMiddleSection",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "timer",
                        children: (0, $ba1e3b359abf28ef$export$3203edd9e5edd663)(time)
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        className: pauseButtonClass,
                        title: "Pause",
                        onClick: ()=>{
                            (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                                if (!s.isPaused) (0, $796711f10012c239$export$5c96c7fea13888f)();
                                s.isPaused = !s.isPaused;
                            });
                            window.scrollTo(0, 0);
                        },
                        children: isPaused ? /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($815c4a10c6ca199f$exports))), {}) : /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($be547dbdaf888d8e$exports))), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "topBarRightSection",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $192491710ae4f590$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $1d9a1bb1e0e16baf$export$2e2bcd8739ae039), {
                        puzzleName: (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Morphology,
                        store: (0, $01d05596dd530619$export$9e774c7f63a1a494)
                    }),
                    useFloatingToolbar && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $6f5220930e57a52a$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        disableRipple: true,
                        title: "How to Play",
                        onClick: ()=>{
                            (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                                s.instructionsAreOpen = true;
                                s.isSoftPaused = true;
                            });
                        },
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($98556d5fcc3acbf1$exports))), {})
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        disableRipple: true,
                        title: "Stats",
                        onClick: ()=>{
                            (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                                s.statsDialogIsOpen = true;
                                s.isSoftPaused = true;
                            });
                        },
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1e3ba230a1917794$exports))), {})
                    })
                ]
            })
        ]
    });
};
var $81b5e3023dbf0b84$export$2e2bcd8739ae039 = $81b5e3023dbf0b84$var$MorphologyTopBar;





var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");




const $ad0136b5d85536a6$var$AlmostThereDialog = ()=>{
    const isOpen = (0, $01d05596dd530619$export$9e774c7f63a1a494).useState((s)=>s.toolbar.almostThereIsOpen);
    const onClose = ()=>{
        (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
            s.toolbar.almostThereIsOpen = false;
        });
    };
    // This dialog cannot be closed by clicking the backdrop,
    // because allowing that causes it to close instantly on mobile
    // because the final touch keyboard input is still "active" and insta-closes it.
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $74c5b717dc6d45d0$export$2e2bcd8739ae039), {
        open: isOpen,
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
            className: "revealConfirmationDialogContent",
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                    className: "closeButton",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b4a213a738a62de4$exports))), {})
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                    className: "aboutBody",
                    children: "Almost there! You've filled in the puzzle, but at least one square is wrong. The puzzle will tell you when everything is correct."
                })
            ]
        })
    });
};
var $ad0136b5d85536a6$export$2e2bcd8739ae039 = $ad0136b5d85536a6$var$AlmostThereDialog;


const $51b82258230669f9$var$DesktopMorphology = ()=>{
    const { clues: clues, author: author, guesses: guesses, solved: solved, focusedClueIndex: focusedClueIndex, completed: completed, cryptic: cryptic } = (0, $01d05596dd530619$export$9e774c7f63a1a494).useState();
    // Parse clues once when clues change (only happens on initial load)
    const parsedClues = (0, $28UcW.useMemo)(()=>{
        return clues.map((clue)=>(0, $796711f10012c239$export$34fa0bd59b56d9c7)(clue.clue));
    }, [
        clues
    ]);
    // handle scrolling things into view when using tab navigation
    (0, $28UcW.useEffect)(()=>{
        const clueRows = document.querySelectorAll('.clueRow');
        const viewportHeight = window.innerHeight;
        const focused = clueRows[focusedClueIndex];
        const focusedRect = focused.getBoundingClientRect();
        const focusedIsBelowView = focusedRect.top > viewportHeight - 30;
        const focusedIsAboveView = focusedRect.bottom < 115;
        if (focusedIsBelowView) {
            focused.scrollIntoView({
                behavior: 'instant',
                block: "nearest"
            });
            return;
        }
        if (focusedIsAboveView) {
            window.scrollTo({
                top: focusedRect.top + window.scrollY - 105,
                behavior: 'instant'
            });
            return;
        }
    }, [
        focusedClueIndex
    ]);
    const useFloatingToolbar = (0, $ba1e3b359abf28ef$export$b87c76f5e9f3d3df)(105);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $81b5e3023dbf0b84$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $ad0136b5d85536a6$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "puzzleHeader",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "headerFirstLine",
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "puzzleTitle",
                                children: cryptic ? 'Cryptic Morphology' : 'Morphology'
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "puzzleDate",
                                children: (0, $796711f10012c239$export$41c7003f986b7c06)()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "puzzleAuthor",
                        children: [
                            "By ",
                            author
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "morphologyContainer",
                children: [
                    !useFloatingToolbar && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $6f5220930e57a52a$export$2e2bcd8739ae039), {}),
                    clues.map((clue, i)=>/*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                            className: `clueRow ${!solved && focusedClueIndex === i ? 'selected' : ''}`,
                            onClick: (e)=>{
                                // this onClick is for when they click the row but not a specific cell in it
                                (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                                    if (e.__isSelectingIndividualCell) return;
                                    s.focusedClueIndex = i;
                                    (0, $796711f10012c239$export$28120faafeefa4c5)(s);
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                    className: "clueContainer",
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "clueIndex",
                                            children: i + 1
                                        }),
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "clueText",
                                            children: parsedClues[i]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                    className: "morph",
                                    children: clue.morph || ''
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                    className: "solutionInputContainer",
                                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $190ce18e10e265cb$export$2e2bcd8739ae039), {
                                        clueIndex: i,
                                        guess: guesses[i]
                                    })
                                })
                            ]
                        }, i))
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $b9f68b54b1083b27$export$2e2bcd8739ae039), {
                store: (0, $01d05596dd530619$export$9e774c7f63a1a494),
                useCompleted: true,
                completed: completed
            })
        ]
    });
};
var $51b82258230669f9$export$2e2bcd8739ae039 = $51b82258230669f9$var$DesktopMorphology;



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");




var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");







var $hjLll = parcelRequire("hjLll");

var $4XrX4 = parcelRequire("4XrX4");
"use client";
var $1807e3b0b2b8f39f$export$2e2bcd8739ae039 = (0, $hjLll.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M11 18h2v-2h-2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4"
}), 'HelpOutline');


var $hjLll = parcelRequire("hjLll");

var $4XrX4 = parcelRequire("4XrX4");
"use client";
var $70d00445c3fb6966$export$2e2bcd8739ae039 = (0, $hjLll.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'InfoOutlined');


var $hjLll = parcelRequire("hjLll");

var $4XrX4 = parcelRequire("4XrX4");
"use client";
var $7959af7cc02c0510$export$2e2bcd8739ae039 = (0, $hjLll.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"
}), 'KeyboardBackspace');


var $hjLll = parcelRequire("hjLll");

var $4XrX4 = parcelRequire("4XrX4");
"use client";
var $067abf68e76eb17f$export$2e2bcd8739ae039 = (0, $hjLll.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M6 19h4V5H6zm8-14v14h4V5z"
}), 'Pause');


var $hjLll = parcelRequire("hjLll");

var $4XrX4 = parcelRequire("4XrX4");
"use client";
var $a78c933a9fed8f1c$export$2e2bcd8739ae039 = (0, $hjLll.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M8 5v14l11-7z"
}), 'PlayArrow');





const $24990b7d3afb472c$var$MobileToolbar = ()=>{
    const { isPaused: isPaused, autocheckOn: autocheckOn, time: time, completed: completed, toolbar: { combinedIsOpen: combinedIsOpen } } = (0, $01d05596dd530619$export$9e774c7f63a1a494).useState();
    const ref = (0, $28UcW.useRef)(null);
    const navigate = (0, $6e00b7bb3feca34a$export$9770f232ac06a008)();
    const pauseButtonClass = completed ? 'hidden' : '';
    // If a click is outside the toolbar, it closes all menus.
    // A click within the menu is handled by togglesMenus, which closes all but the clicked one.
    (0, $28UcW.useEffect)(()=>{
        const onClickOutside = (e)=>{
            if (ref.current && !ref.current.contains(e.target)) {
                (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                    s.toolbar.clearIsOpen = false;
                    s.toolbar.revealIsOpen = false;
                    s.toolbar.checkIsOpen = false;
                    s.toolbar.combinedIsOpen = false;
                });
                document.removeEventListener('click', onClickOutside);
            }
        };
        if (combinedIsOpen) document.addEventListener('click', onClickOutside);
        return ()=>{
            document.removeEventListener('click', onClickOutside);
        };
    }, [
        combinedIsOpen
    ]);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        ref: ref,
        className: "morphologyToolbar mobile",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $cd4fe362d74545f0$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $1d9a1bb1e0e16baf$export$2e2bcd8739ae039), {
                puzzleName: (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Morphology,
                store: (0, $01d05596dd530619$export$9e774c7f63a1a494)
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "backButtonContainer",
                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                    disableRipple: true,
                    title: "Back",
                    onClick: ()=>{
                        navigate('/');
                        window.scrollTo(0, 0);
                        (0, $796711f10012c239$export$5c96c7fea13888f)();
                    },
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $7959af7cc02c0510$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "timerContainer",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "timer",
                        children: (0, $ba1e3b359abf28ef$export$3203edd9e5edd663)(time)
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        className: pauseButtonClass,
                        title: "Pause",
                        onClick: ()=>{
                            (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                                if (!s.isPaused) (0, $796711f10012c239$export$5c96c7fea13888f)();
                                s.isPaused = !s.isPaused;
                            });
                        },
                        children: isPaused ? /*#__PURE__*/ (0, $4XrX4.jsx)((0, $a78c933a9fed8f1c$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $4XrX4.jsx)((0, $067abf68e76eb17f$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "infoAndHelpContainer",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        disableRipple: true,
                        title: "Stats",
                        onClick: ()=>{
                            (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                                s.statsDialogIsOpen = true;
                                s.isSoftPaused = true;
                            });
                        },
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1e3ba230a1917794$exports))), {})
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "dropdownButton",
                        onClick: ()=>{
                            (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                                s.instructionsAreOpen = !s.instructionsAreOpen;
                                s.isSoftPaused = s.instructionsAreOpen;
                                s.toolbar.combinedIsOpen = false;
                            });
                        },
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                            className: "buttonLabel",
                            children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                                disableRipple: true,
                                disableTouchRipple: true,
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $1807e3b0b2b8f39f$export$2e2bcd8739ae039), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "dropdownButton",
                        onClick: ()=>{
                            (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                                s.toolbar.aboutIsOpen = true;
                                s.toolbar.combinedIsOpen = false;
                            });
                        },
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                            className: "buttonLabel",
                            children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                                disableRipple: true,
                                disableTouchRipple: true,
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $70d00445c3fb6966$export$2e2bcd8739ae039), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "dropdownButton",
                        onClick: ()=>{
                            (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                                s.toolbar.combinedIsOpen = !s.toolbar.combinedIsOpen;
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "buttonLabel",
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                                    disableRipple: true,
                                    disableTouchRipple: true,
                                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $bd71d3bf9adc9947$export$2e2bcd8739ae039), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                                className: `dropdownMenu revealMenu ${combinedIsOpen ? 'open' : ''}`,
                                children: [
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                        onClick: (0, $796711f10012c239$export$4f2368f44db85843),
                                        children: "Clear Word"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                        onClick: ()=>{
                                            if (completed) return;
                                            (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                                                s.toolbar.confirmationDialog.clearAllIsOpen = true;
                                            });
                                        },
                                        children: "Clear Puzzle"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                        className: autocheckOn ? 'autocheckEnabled' : undefined,
                                        onClick: ()=>(0, $796711f10012c239$export$9b2690a4578612b0)((0, $796711f10012c239$export$105770301816d0f9).Autocheck),
                                        children: "Autocheck"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                        className: autocheckOn ? 'disabled' : undefined,
                                        onClick: ()=>(0, $796711f10012c239$export$9b2690a4578612b0)((0, $796711f10012c239$export$105770301816d0f9).CheckLetter),
                                        children: "Check Square"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                        className: autocheckOn ? 'disabled' : undefined,
                                        onClick: ()=>(0, $796711f10012c239$export$9b2690a4578612b0)((0, $796711f10012c239$export$105770301816d0f9).CheckWord),
                                        children: "Check Word"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                        className: autocheckOn ? 'disabled' : undefined,
                                        onClick: ()=>(0, $796711f10012c239$export$9b2690a4578612b0)((0, $796711f10012c239$export$105770301816d0f9).CheckPuzzle),
                                        children: "Check Puzzle"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                        onClick: ()=>(0, $796711f10012c239$export$9b2690a4578612b0)((0, $796711f10012c239$export$105770301816d0f9).RevealLetter),
                                        children: "Reveal Square"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                        onClick: ()=>(0, $796711f10012c239$export$9b2690a4578612b0)((0, $796711f10012c239$export$105770301816d0f9).RevealWord),
                                        children: "Reveal Word"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                        onClick: ()=>(0, $796711f10012c239$export$9b2690a4578612b0)((0, $796711f10012c239$export$105770301816d0f9).RevealPuzzle),
                                        children: "Reveal Puzzle"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $24990b7d3afb472c$export$2e2bcd8739ae039 = $24990b7d3afb472c$var$MobileToolbar;




var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");


var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");



const $092f78907c532331$var$Key = ({ value: value, handleInput: handleInput })=>{
    const hapticFeedbackEnabled = (0, $e2662af8a2ab1f76$export$986181c251d527c3).useState((s)=>s.userData?.settings.hapticFeedbackEnabled) ?? true;
    const [isTouchActive, setIsTouchActive] = (0, $28UcW.useState)(false);
    const handleClick = (event)=>{
        if (!isTouchActive) {
            try {
                navigator.vibrate(20);
            } catch (error) {
            // do nothing, just don't vibrate
            }
            handleInput(value);
            event.currentTarget.blur();
        }
        setIsTouchActive(false); // Reset the flag after a potential click
    };
    const handleTouchStart = ()=>{
        setIsTouchActive(true);
        try {
            if (hapticFeedbackEnabled) navigator.vibrate(20);
        } catch (error) {
        // do nothing, just don't vibrate
        }
        handleInput(value);
    };
    const handleTouchEnd = ()=>{
    // We don't need to do anything specific on touch end in this case
    // because handleInput is already called on touch start.
    // Setting isTouchActive to false in handleClick handles the click case.
    };
    const isWideKey = value === (0, $ba1e3b359abf28ef$export$cd903283095ece83).Enter || value === (0, $ba1e3b359abf28ef$export$cd903283095ece83).Delete;
    const getSymbol = (value)=>{
        if (value === (0, $ba1e3b359abf28ef$export$cd903283095ece83).Delete) return /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d872a2807693457d$exports))), {});
        else return value;
    };
    return /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
        className: `${isWideKey ? 'wideKey' : ''} keyboardKey`,
        onClick: handleClick,
        onTouchStart: handleTouchStart,
        onTouchEnd: handleTouchEnd,
        children: getSymbol(value)
    });
};
var $092f78907c532331$export$2e2bcd8739ae039 = $092f78907c532331$var$Key;



const $ab5ef079158eba71$var$Keyboard = ({ handleInput: handleInput })=>{
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "keyboardContainer",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "keyRow",
                children: [
                    'Q',
                    'W',
                    'E',
                    'R',
                    'T',
                    'Y',
                    'U',
                    'I',
                    'O',
                    'P'
                ].map((key)=>/*#__PURE__*/ (0, $4XrX4.jsx)((0, $092f78907c532331$export$2e2bcd8739ae039), {
                        handleInput: handleInput,
                        value: key
                    }, key))
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "keyRow",
                children: [
                    'A',
                    'S',
                    'D',
                    'F',
                    'G',
                    'H',
                    'J',
                    'K',
                    'L'
                ].map((key)=>/*#__PURE__*/ (0, $4XrX4.jsx)((0, $092f78907c532331$export$2e2bcd8739ae039), {
                        handleInput: handleInput,
                        value: key
                    }, key))
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "keyRow",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $092f78907c532331$export$2e2bcd8739ae039), {
                        handleInput: handleInput,
                        value: (0, $ba1e3b359abf28ef$export$cd903283095ece83).Enter
                    }),
                    [
                        'Z',
                        'X',
                        'C',
                        'V',
                        'B',
                        'N',
                        'M'
                    ].map((key)=>/*#__PURE__*/ (0, $4XrX4.jsx)((0, $092f78907c532331$export$2e2bcd8739ae039), {
                            handleInput: handleInput,
                            value: key
                        }, key)),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $092f78907c532331$export$2e2bcd8739ae039), {
                        handleInput: handleInput,
                        value: (0, $ba1e3b359abf28ef$export$cd903283095ece83).Delete
                    })
                ]
            })
        ]
    });
};
var $ab5ef079158eba71$export$2e2bcd8739ae039 = $ab5ef079158eba71$var$Keyboard;


var $d6c154c725c93576$export$2e2bcd8739ae039 = (0, $ab5ef079158eba71$export$2e2bcd8739ae039);



var $67349de2d338c8da$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($67349de2d338c8da$exports, "__esModule", {
    value: true
});
$67349de2d338c8da$exports.default = void 0;

var $67349de2d338c8da$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $67349de2d338c8da$var$_default = $67349de2d338c8da$exports.default = (0, $67349de2d338c8da$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"
}), 'KeyboardArrowUp');


var $9d3a2b240304cbb0$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($9d3a2b240304cbb0$exports, "__esModule", {
    value: true
});
$9d3a2b240304cbb0$exports.default = void 0;

var $9d3a2b240304cbb0$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $9d3a2b240304cbb0$var$_default = $9d3a2b240304cbb0$exports.default = (0, $9d3a2b240304cbb0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
}), 'KeyboardArrowDown');




var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");


var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

const $f13252b13d1e29c0$var$MobilePopup = ({ isOpen: isOpen, title: title, onClose: onClose, children: children })=>{
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: `mobilePopup ${isOpen ? 'popupOpen' : ''}`,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "popupHeader",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                        className: "closeButton",
                        onClick: onClose,
                        children: "\xd7"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("h2", {
                        className: "popupTitle",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "popupBody",
                children: children
            })
        ]
    });
};
var $f13252b13d1e29c0$export$2e2bcd8739ae039 = $f13252b13d1e29c0$var$MobilePopup;





const $d3291d0ee1503b1e$var$MobileMorphologyInstructions = ()=>{
    const isOpen = (0, $01d05596dd530619$export$9e774c7f63a1a494).useState((s)=>s.instructionsAreOpen);
    const cryptic = (0, $01d05596dd530619$export$9e774c7f63a1a494).useState((s)=>s.cryptic);
    const onClose = ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).set(`${(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Morphology}InstructionsDismissed`, 'true', {
            domain: (0, $ba1e3b359abf28ef$export$517466abcb8fcf10),
            expires: 365
        });
        (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
            s.instructionsAreOpen = false;
            s.isSoftPaused = false;
        });
    };
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f13252b13d1e29c0$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: onClose,
        title: "How to Play Morphology",
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                    children: "Fill in the word ladder with single-word solutions matching the clues."
                }),
                /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                    children: [
                        "Each solution differs from the previous clue's solution by just a few letters. The difference is called the ",
                        /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                            className: "italicText",
                            children: "morph"
                        }),
                        " and is given in the format ",
                        /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                            className: "morphText",
                            children: "(+X, -Y, ~Z)"
                        }),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                    className: "sublist",
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                    className: "morphText",
                                    children: "+X"
                                }),
                                " means X characters were added.",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                                " CHAT is ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                    className: "morphText",
                                    children: "+1"
                                }),
                                " from CAT."
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                    className: "morphText",
                                    children: "-Y"
                                }),
                                " means Y characters were removed.",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                                " RAIN is ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                    className: "morphText",
                                    children: "-2"
                                }),
                                " from RACING."
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                    className: "morphText",
                                    children: "~Z"
                                }),
                                " means Z characters were changed.",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                                " GUITAR is ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                    className: "morphText",
                                    children: "~2"
                                }),
                                " from SUITOR."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                    children: "Morphology usually avoids obscure words, as well as proper names that aren't commonplace or inferrable by the morph."
                }),
                cryptic && /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                    className: "crypticCallout",
                    children: /*#__PURE__*/ (0, $4XrX4.jsxs)("b", {
                        children: [
                            "Today's puzzle is a cryptic, which follows cryptic crossword clueing conventions. Learn more via ",
                            /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                target: "_blank",
                                href: "https://www.youtube.com/watch?v=HrKiYFJxgic",
                                children: "this video"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                target: "_blank",
                                href: "https://www.newyorker.com/puzzles-and-games-dept/cryptic-crossword/reintroducing-the-new-yorkers-cryptic-crossword",
                                children: "this article"
                            }),
                            ", or ",
                            /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                target: "_blank",
                                href: "https://s.wsj.net/blogs/html/wsjcrypticguide.pdf",
                                children: "this concise PDF"
                            }),
                            "."
                        ]
                    })
                })
            ]
        })
    });
};
var $d3291d0ee1503b1e$export$2e2bcd8739ae039 = $d3291d0ee1503b1e$var$MobileMorphologyInstructions;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");





const $ae322019fa869f66$var$MobileMorphologyAbout = ()=>{
    const isOpen = (0, $01d05596dd530619$export$9e774c7f63a1a494).useState((s)=>s.toolbar.aboutIsOpen);
    const author = (0, $01d05596dd530619$export$9e774c7f63a1a494).useState((s)=>s.author);
    const onClose = ()=>{
        (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
            s.toolbar.aboutIsOpen = false;
        });
    };
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $74c5b717dc6d45d0$export$2e2bcd8739ae039), {
        open: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
            className: "revealConfirmationDialogContent",
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                    className: "closeButton",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b4a213a738a62de4$exports))), {})
                }),
                /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                    className: "aboutBody",
                    children: [
                        (0, $796711f10012c239$export$41c7003f986b7c06)(),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                        "Today's puzzle by ",
                        author,
                        "."
                    ]
                })
            ]
        })
    });
};
var $ae322019fa869f66$export$2e2bcd8739ae039 = $ae322019fa869f66$var$MobileMorphologyAbout;




let $1ff633b146248580$var$lastScrollTime = 0;
let $1ff633b146248580$var$lastScrollSwitchId = 0;
const $1ff633b146248580$var$keyboardHeight = 192;
const $1ff633b146248580$var$upDownButtonsHeight = 30;
const $1ff633b146248580$var$menuBarHeight = 40;
const $1ff633b146248580$var$MobileMorphology = ()=>{
    const { clues: clues, author: author, guesses: guesses, completed: completed, focusedClueIndex: focusedClueIndex } = (0, $01d05596dd530619$export$9e774c7f63a1a494).useState();
    // Parse clues once when clues change (only happens on initial load)
    const parsedClues = (0, $28UcW.useMemo)(()=>{
        return clues.map((clue)=>(0, $796711f10012c239$export$34fa0bd59b56d9c7)(clue.clue));
    }, [
        clues
    ]);
    const [initialScroll, setInitialScroll] = (0, $28UcW.useState)(0);
    const totalHeight = (0, $ba1e3b359abf28ef$export$e27d6512d262aec)();
    const remainingHeight = completed ? totalHeight - $1ff633b146248580$var$menuBarHeight : totalHeight - ($1ff633b146248580$var$keyboardHeight + $1ff633b146248580$var$menuBarHeight + $1ff633b146248580$var$upDownButtonsHeight);
    const scrollableContainerHeight = remainingHeight / 2;
    const inputsRef = (0, $28UcW.useRef)(null);
    const cluesRef = (0, $28UcW.useRef)(null);
    // handle scrolling things into view when using up/down button navigation
    (0, $28UcW.useEffect)(()=>{
        // the setTimeout avoids an annoying issue where you tap a row at the top or bottom edge
        // of the scroll container and it immediately jumps and forces you to select one past
        // what you were aiming for
        setTimeout(()=>{
            (0, $796711f10012c239$export$2ee2e0ff7ab8887b)(focusedClueIndex);
        }, 10);
    }, [
        focusedClueIndex
    ]);
    // switcher is just a super arbitrary parameter used to tell which
    // container is being scrolled so we can match the scroll on the other one
    const syncScrolls = (e, switcher)=>{
        if (!inputsRef.current || !cluesRef.current) return;
        // When you scroll one container manually, the triggered scroll on the other still invokes
        // the onScroll event and consequently triggers some kind of feedback loop.
        // This logic basically says "ignore any scroll events that are targeting a new
        // container within less than a 50ms interval" because those can be assumed to be
        // the undesirable false triggers.
        if (switcher === $1ff633b146248580$var$lastScrollSwitchId) $1ff633b146248580$var$lastScrollTime = e.timeStamp;
        else if (e.timeStamp - $1ff633b146248580$var$lastScrollTime > 50) {
            $1ff633b146248580$var$lastScrollTime = e.timeStamp;
            $1ff633b146248580$var$lastScrollSwitchId = switcher;
        } else return;
        const inputs = inputsRef.current;
        const clues = cluesRef.current;
        const inputsScrollHeight = inputs.scrollHeight - inputs.clientHeight;
        const cluesScrollHeight = clues.scrollHeight - clues.clientHeight;
        if (switcher === 1) {
            const scrollPercent = inputs.scrollTop / inputsScrollHeight * 100;
            clues.scrollTop = scrollPercent / 100 * cluesScrollHeight;
        } else {
            const scrollPercent = clues.scrollTop / cluesScrollHeight * 100;
            inputs.scrollTop = scrollPercent / 100 * inputsScrollHeight;
        }
    };
    const onNext = ()=>{
        (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
            const isOnLastClue = s.focusedClueIndex === clues.length - 1;
            s.focusedClueIndex = isOnLastClue ? 0 : s.focusedClueIndex + 1;
            (0, $796711f10012c239$export$28120faafeefa4c5)(s);
        });
    };
    const onPrevious = ()=>{
        (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
            const isOnFirstClue = s.focusedClueIndex === 0;
            s.focusedClueIndex = isOnFirstClue ? clues.length - 1 : s.focusedClueIndex - 1;
            (0, $796711f10012c239$export$28120faafeefa4c5)(s);
        });
    };
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $24990b7d3afb472c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $ad0136b5d85536a6$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "morphologyContainer mobile",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "inputsContainer",
                        ref: inputsRef,
                        onScroll: (e)=>syncScrolls(e, 1),
                        style: {
                            height: scrollableContainerHeight
                        },
                        children: clues.map((clue, i)=>/*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: `inputRow ${focusedClueIndex === i ? 'selected' : ''}`,
                                onClick: (e)=>{
                                    if (e.__isSelectingIndividualCell) return;
                                    // (We need both onClick and onScroll because MobileMorphology is also
                                    // used for small window sizes on desktop.)
                                    // this onClick is for when they click the row but not a specific cell in it
                                    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                                        s.focusedClueIndex = i;
                                        (0, $796711f10012c239$export$28120faafeefa4c5)(s);
                                    });
                                },
                                onTouchStart: ()=>{
                                    const scrollTop = document.querySelector('.inputsContainer').scrollTop;
                                    setInitialScroll(scrollTop);
                                },
                                onTouchEnd: (e)=>{
                                    if (e.__isSelectingIndividualCell) return;
                                    const scrollTop = document.querySelector('.inputsContainer').scrollTop;
                                    if (scrollTop !== initialScroll) return;
                                    // this onClick is for when they click the row but not a specific cell in it
                                    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                                        s.focusedClueIndex = i;
                                        (0, $796711f10012c239$export$28120faafeefa4c5)(s);
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                        className: "clueIndex",
                                        children: i + 1
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                        className: "solutionInputContainer",
                                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $190ce18e10e265cb$export$2e2bcd8739ae039), {
                                            clueIndex: i,
                                            guess: guesses[i]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                        className: "morph",
                                        children: clue.morph || ''
                                    })
                                ]
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "cluesContainer",
                        ref: cluesRef,
                        onScroll: (e)=>syncScrolls(e, 2),
                        style: {
                            height: scrollableContainerHeight
                        },
                        children: clues.map((clue, i)=>/*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: `clueRow ${focusedClueIndex === i ? 'selected' : ''}`,
                                onClick: ()=>{
                                    // (We need both onClick and onScroll because MobileMorphology is also
                                    // used for small window sizes on desktop.)
                                    // this onClick is for when they click the row but not a specific cell in it
                                    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                                        s.focusedClueIndex = i;
                                        (0, $796711f10012c239$export$28120faafeefa4c5)(s);
                                    });
                                },
                                onTouchStart: ()=>{
                                    const scrollTop = document.querySelector('.inputsContainer').scrollTop;
                                    setInitialScroll(scrollTop);
                                },
                                onTouchEnd: ()=>{
                                    const scrollTop = document.querySelector('.inputsContainer').scrollTop;
                                    if (scrollTop !== initialScroll) return;
                                    // this onClick is for when they click the row but not a specific cell in it
                                    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
                                        s.focusedClueIndex = i;
                                        (0, $796711f10012c239$export$28120faafeefa4c5)(s);
                                    });
                                },
                                children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                    className: "clueContainer",
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "clueIndex",
                                            children: i + 1
                                        }),
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "clueText",
                                            children: parsedClues[i]
                                        })
                                    ]
                                })
                            }, i))
                    }),
                    !completed && /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "navigationContainer",
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                                onClick: onPrevious,
                                disableRipple: true,
                                disableFocusRipple: true,
                                disableTouchRipple: true,
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($67349de2d338c8da$exports))), {})
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                                onClick: onNext,
                                disableRipple: true,
                                disableFocusRipple: true,
                                disableTouchRipple: true,
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9d3a2b240304cbb0$exports))), {})
                            })
                        ]
                    }),
                    !completed && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d6c154c725c93576$export$2e2bcd8739ae039), {
                        handleInput: (0, $796711f10012c239$export$412508d679148d5c)
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $b9f68b54b1083b27$export$2e2bcd8739ae039), {
                        store: (0, $01d05596dd530619$export$9e774c7f63a1a494),
                        useCompleted: true,
                        completed: completed
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d3291d0ee1503b1e$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $ae322019fa869f66$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $1ff633b146248580$export$2e2bcd8739ae039 = $1ff633b146248580$var$MobileMorphology;





const $136a2f89319ea25d$var$Morphology = ()=>{
    const { autocheckOn: autocheckOn, guesses: guesses, completed: completed } = (0, $01d05596dd530619$export$9e774c7f63a1a494).useState();
    // It's intended to take `revealed` & `solved`, but morphology only uses `completed`,
    // so I'm just passing that for both those params so I don't have to make a separate hook.
    (0, $ba1e3b359abf28ef$export$a546a4e9e5b2cdef)((0, $796711f10012c239$export$412508d679148d5c), completed, completed);
    (0, $ba1e3b359abf28ef$export$20d77ccceac0f55c)((0, $01d05596dd530619$export$9e774c7f63a1a494), (0, $796711f10012c239$export$5c96c7fea13888f));
    (0, $ba1e3b359abf28ef$export$e73a86b2063a8f6b)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Morphology, (0, $01d05596dd530619$export$9e774c7f63a1a494));
    (0, $ba1e3b359abf28ef$export$5b0326dddadcb0de)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Morphology);
    (0, $ba1e3b359abf28ef$export$52dc0a972e5b91c5)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Morphology);
    (0, $80f684051860af43$export$2500c8a6bc3f2f43)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Morphology);
    (0, $28UcW.useEffect)(()=>{
        if (autocheckOn) (0, $796711f10012c239$export$ed0314765beb2ba1)();
    }, [
        guesses,
        autocheckOn
    ]);
    const useMobileStyles = (0, $b2cd9ecc66d0956f$exports.isMobile) || (0, $ba1e3b359abf28ef$export$580e0f6db19fa7cc)();
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: `puzzleContainer ${useMobileStyles ? 'mobile' : ''}`,
        children: [
            useMobileStyles && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $1ff633b146248580$export$2e2bcd8739ae039), {}),
            !useMobileStyles && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $51b82258230669f9$export$2e2bcd8739ae039), {})
        ]
    });
};
var $136a2f89319ea25d$export$2e2bcd8739ae039 = $136a2f89319ea25d$var$Morphology;



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");




var $28UcW = parcelRequire("28UcW");
var $b8c8be97d3ce6849$var$cssUnit = {
    cm: true,
    mm: true,
    in: true,
    px: true,
    pt: true,
    pc: true,
    em: true,
    ex: true,
    ch: true,
    rem: true,
    vw: true,
    vh: true,
    vmin: true,
    vmax: true,
    "%": true
};
function $b8c8be97d3ce6849$export$78b59f8245744464(size) {
    if (typeof size === "number") return {
        value: size,
        unit: "px"
    };
    var value;
    var valueString = (size.match(/^[0-9.]*/) || "").toString();
    if (valueString.includes(".")) value = parseFloat(valueString);
    else value = parseInt(valueString, 10);
    var unit = (size.match(/[^0-9]*$/) || "").toString();
    if ($b8c8be97d3ce6849$var$cssUnit[unit]) return {
        value: value,
        unit: unit
    };
    console.warn("React Spinners: ".concat(size, " is not a valid css value. Defaulting to ").concat(value, "px."));
    return {
        value: value,
        unit: "px"
    };
}
function $b8c8be97d3ce6849$export$55101aa37e5c1f8f(value) {
    var lengthWithunit = $b8c8be97d3ce6849$export$78b59f8245744464(value);
    return "".concat(lengthWithunit.value).concat(lengthWithunit.unit);
}


var $916d60d55b4a6180$export$86bdb2b9e42f41bc = function(loaderName, frames, suffix) {
    var animationName = "react-spinners-".concat(loaderName, "-").concat(suffix);
    if (typeof window == "undefined" || !window.document) return animationName;
    var styleEl = document.createElement("style");
    document.head.appendChild(styleEl);
    var styleSheet = styleEl.sheet;
    var keyFrames = "\n    @keyframes ".concat(animationName, " {\n      ").concat(frames, "\n    }\n  ");
    if (styleSheet) styleSheet.insertRule(keyFrames, 0);
    return animationName;
};


var $6c43798b9151482b$var$BasicColors;
(function(BasicColors) {
    BasicColors["maroon"] = "#800000";
    BasicColors["red"] = "#FF0000";
    BasicColors["orange"] = "#FFA500";
    BasicColors["yellow"] = "#FFFF00";
    BasicColors["olive"] = "#808000";
    BasicColors["green"] = "#008000";
    BasicColors["purple"] = "#800080";
    BasicColors["fuchsia"] = "#FF00FF";
    BasicColors["lime"] = "#00FF00";
    BasicColors["teal"] = "#008080";
    BasicColors["aqua"] = "#00FFFF";
    BasicColors["blue"] = "#0000FF";
    BasicColors["navy"] = "#000080";
    BasicColors["black"] = "#000000";
    BasicColors["gray"] = "#808080";
    BasicColors["silver"] = "#C0C0C0";
    BasicColors["white"] = "#FFFFFF";
})($6c43798b9151482b$var$BasicColors || ($6c43798b9151482b$var$BasicColors = {}));
var $6c43798b9151482b$export$b24a234cb8fe39d5 = function(color, opacity) {
    if (Object.keys($6c43798b9151482b$var$BasicColors).includes(color)) color = $6c43798b9151482b$var$BasicColors[color];
    if (color[0] === "#") color = color.slice(1);
    if (color.length === 3) {
        var res_1 = "";
        color.split("").forEach(function(c) {
            res_1 += c;
            res_1 += c;
        });
        color = res_1;
    }
    var rgbValues = (color.match(/.{2}/g) || []).map(function(hex) {
        return parseInt(hex, 16);
    }).join(", ");
    return "rgba(".concat(rgbValues, ", ").concat(opacity, ")");
};


var $309dd07201abfd19$var$__assign = undefined && undefined.__assign || function() {
    $309dd07201abfd19$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $309dd07201abfd19$var$__assign.apply(this, arguments);
};
var $309dd07201abfd19$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $309dd07201abfd19$var$long = (0, $916d60d55b4a6180$export$86bdb2b9e42f41bc)("BarLoader", "0% {left: -35%;right: 100%} 60% {left: 100%;right: -90%} 100% {left: 100%;right: -90%}", "long");
var $309dd07201abfd19$var$short = (0, $916d60d55b4a6180$export$86bdb2b9e42f41bc)("BarLoader", "0% {left: -200%;right: 100%} 60% {left: 107%;right: -8%} 100% {left: 107%;right: -8%}", "short");
function $309dd07201abfd19$var$BarLoader(_a) {
    var _b = _a.loading, loading = _b === void 0 ? true : _b, _c = _a.color, color = _c === void 0 ? "#000000" : _c, _d = _a.speedMultiplier, speedMultiplier = _d === void 0 ? 1 : _d, _e = _a.cssOverride, cssOverride = _e === void 0 ? {} : _e, _f = _a.height, height = _f === void 0 ? 4 : _f, _g = _a.width, width = _g === void 0 ? 100 : _g, additionalprops = $309dd07201abfd19$var$__rest(_a, [
        "loading",
        "color",
        "speedMultiplier",
        "cssOverride",
        "height",
        "width"
    ]);
    var wrapper = $309dd07201abfd19$var$__assign({
        display: "inherit",
        position: "relative",
        width: (0, $b8c8be97d3ce6849$export$55101aa37e5c1f8f)(width),
        height: (0, $b8c8be97d3ce6849$export$55101aa37e5c1f8f)(height),
        overflow: "hidden",
        backgroundColor: (0, $6c43798b9151482b$export$b24a234cb8fe39d5)(color, 0.2),
        backgroundClip: "padding-box"
    }, cssOverride);
    var style = function(i) {
        return {
            position: "absolute",
            height: (0, $b8c8be97d3ce6849$export$55101aa37e5c1f8f)(height),
            overflow: "hidden",
            backgroundColor: color,
            backgroundClip: "padding-box",
            display: "block",
            borderRadius: 2,
            willChange: "left, right",
            animationFillMode: "forwards",
            animation: "".concat(i === 1 ? $309dd07201abfd19$var$long : $309dd07201abfd19$var$short, " ").concat(2.1 / speedMultiplier, "s ").concat(i === 2 ? "".concat(1.15 / speedMultiplier, "s") : "", " ").concat(i === 1 ? "cubic-bezier(0.65, 0.815, 0.735, 0.395)" : "cubic-bezier(0.165, 0.84, 0.44, 1)", " infinite")
        };
    };
    if (!loading) return null;
    return $28UcW.createElement("span", $309dd07201abfd19$var$__assign({
        style: wrapper
    }, additionalprops), $28UcW.createElement("span", {
        style: style(1)
    }), $28UcW.createElement("span", {
        style: style(2)
    }));
}
var $309dd07201abfd19$export$2e2bcd8739ae039 = $309dd07201abfd19$var$BarLoader;







var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");


var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");



const $508758c4c0fa6bdd$var$RevealConfirmationDialogCluster = ()=>{
    const confirmationDialogSettings = (0, $503d195e8098532c$export$7613e4d4725461b7).useState((s)=>s.toolbar.confirmationDialog);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2bbc7cde64cbe8e7$export$2e2bcd8739ae039), {
                store: (0, $503d195e8098532c$export$7613e4d4725461b7),
                onConfirm: (0, $2eaf3926a83a2b13$export$af2f1643f52e0e9c),
                onClose: ()=>{
                    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                        s.toolbar.confirmationDialog.clearAllIsOpen = false;
                    });
                },
                isOpen: confirmationDialogSettings.clearAllIsOpen,
                prompt: "Are you sure you want to clear the entire puzzle?"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2bbc7cde64cbe8e7$export$2e2bcd8739ae039), {
                store: (0, $503d195e8098532c$export$7613e4d4725461b7),
                onConfirm: (0, $2eaf3926a83a2b13$export$ebf0e4b32d392a5),
                onClose: ()=>{
                    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                        s.toolbar.confirmationDialog.checkLetterIsOpen = false;
                    });
                },
                isOpen: confirmationDialogSettings.checkLetterIsOpen
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2bbc7cde64cbe8e7$export$2e2bcd8739ae039), {
                store: (0, $503d195e8098532c$export$7613e4d4725461b7),
                onConfirm: (0, $2eaf3926a83a2b13$export$766daef7c097c7f7),
                onClose: ()=>{
                    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                        s.toolbar.confirmationDialog.checkWordIsOpen = false;
                    });
                },
                isOpen: confirmationDialogSettings.checkWordIsOpen
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2bbc7cde64cbe8e7$export$2e2bcd8739ae039), {
                store: (0, $503d195e8098532c$export$7613e4d4725461b7),
                onConfirm: (0, $2eaf3926a83a2b13$export$ed0314765beb2ba1),
                onClose: ()=>{
                    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                        s.toolbar.confirmationDialog.checkPuzzleIsOpen = false;
                    });
                },
                isOpen: confirmationDialogSettings.checkPuzzleIsOpen
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2bbc7cde64cbe8e7$export$2e2bcd8739ae039), {
                store: (0, $503d195e8098532c$export$7613e4d4725461b7),
                onConfirm: (0, $2eaf3926a83a2b13$export$d861b77f58a34e9b),
                onClose: ()=>{
                    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                        s.toolbar.confirmationDialog.autocheckIsOpen = false;
                    });
                },
                isOpen: confirmationDialogSettings.autocheckIsOpen
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2bbc7cde64cbe8e7$export$2e2bcd8739ae039), {
                store: (0, $503d195e8098532c$export$7613e4d4725461b7),
                onConfirm: (0, $2eaf3926a83a2b13$export$6f61f2e76c082c66),
                onClose: ()=>{
                    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                        s.toolbar.confirmationDialog.revealLetterIsOpen = false;
                    });
                },
                isOpen: confirmationDialogSettings.revealLetterIsOpen
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2bbc7cde64cbe8e7$export$2e2bcd8739ae039), {
                store: (0, $503d195e8098532c$export$7613e4d4725461b7),
                onConfirm: (0, $2eaf3926a83a2b13$export$920879cc398c7fed),
                onClose: ()=>{
                    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                        s.toolbar.confirmationDialog.revealWordIsOpen = false;
                    });
                },
                isOpen: confirmationDialogSettings.revealWordIsOpen
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2bbc7cde64cbe8e7$export$2e2bcd8739ae039), {
                store: (0, $503d195e8098532c$export$7613e4d4725461b7),
                onConfirm: (0, $2eaf3926a83a2b13$export$48a1b615b62a793),
                onClose: ()=>{
                    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                        s.toolbar.confirmationDialog.revealAllIsOpen = false;
                    });
                },
                isOpen: confirmationDialogSettings.revealAllIsOpen,
                prompt: "Are you sure you want to reveal the full puzzle? This puzzle will count as revealed and be excluded from any solve streak."
            })
        ]
    });
};
var $508758c4c0fa6bdd$export$2e2bcd8739ae039 = $508758c4c0fa6bdd$var$RevealConfirmationDialogCluster;


const $efb662539f0209d6$var$DesktopToolbar = ()=>{
    const { autocheckOn: autocheckOn, completed: completed, toolbar: { clearIsOpen: clearIsOpen, revealIsOpen: revealIsOpen, checkIsOpen: checkIsOpen } } = (0, $503d195e8098532c$export$7613e4d4725461b7).useState();
    const ref = (0, $28UcW.useRef)(null);
    // If a click is outside the toolbar, it closes all menus.
    // A click within the menu is handled by togglesMenus, which closes all but the clicked one.
    (0, $28UcW.useEffect)(()=>{
        const onClickOutside = (e)=>{
            if (ref.current && !ref.current.contains(e.target)) {
                (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                    s.toolbar.clearIsOpen = false;
                    s.toolbar.revealIsOpen = false;
                    s.toolbar.checkIsOpen = false;
                });
                document.removeEventListener('click', onClickOutside);
            }
        };
        if (clearIsOpen || revealIsOpen || checkIsOpen) document.addEventListener('click', onClickOutside);
        return ()=>{
            document.removeEventListener('click', onClickOutside);
        };
    }, [
        clearIsOpen,
        revealIsOpen,
        checkIsOpen
    ]);
    const toggleMenus = (index)=>{
        switch(index){
            case 1:
                (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                    s.toolbar.clearIsOpen = !clearIsOpen;
                    s.toolbar.revealIsOpen = false;
                    s.toolbar.checkIsOpen = false;
                });
                break;
            case 2:
                (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                    s.toolbar.clearIsOpen = false;
                    s.toolbar.revealIsOpen = !revealIsOpen;
                    s.toolbar.checkIsOpen = false;
                });
                break;
            case 3:
                (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                    s.toolbar.clearIsOpen = false;
                    s.toolbar.revealIsOpen = false;
                    s.toolbar.checkIsOpen = !checkIsOpen;
                });
                break;
        }
    };
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        ref: ref,
        className: "morphologyToolbar",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $508758c4c0fa6bdd$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "dropdownButton",
                onClick: ()=>toggleMenus(1),
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "buttonLabel",
                        children: "Clear"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                        className: `dropdownMenu clearMenu ${clearIsOpen ? 'open' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                onClick: (0, $2eaf3926a83a2b13$export$4f2368f44db85843),
                                children: "Word"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                onClick: ()=>{
                                    if (completed) return;
                                    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                                        s.toolbar.confirmationDialog.clearAllIsOpen = true;
                                    });
                                },
                                children: "Puzzle"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "dropdownButton",
                onClick: ()=>toggleMenus(2),
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "buttonLabel",
                        children: "Reveal"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                        className: `dropdownMenu revealMenu ${revealIsOpen ? 'open' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                onClick: ()=>{
                                    (0, $2eaf3926a83a2b13$export$9b2690a4578612b0)((0, $2eaf3926a83a2b13$export$105770301816d0f9).RevealLetter);
                                },
                                children: "Square"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                onClick: ()=>{
                                    (0, $2eaf3926a83a2b13$export$9b2690a4578612b0)((0, $2eaf3926a83a2b13$export$105770301816d0f9).RevealWord);
                                },
                                children: "Word"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                onClick: ()=>{
                                    (0, $2eaf3926a83a2b13$export$9b2690a4578612b0)((0, $2eaf3926a83a2b13$export$105770301816d0f9).RevealPuzzle);
                                },
                                children: "Puzzle"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "dropdownButton",
                onClick: ()=>toggleMenus(3),
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: autocheckOn ? 'autocheck buttonLabel' : 'buttonLabel',
                        children: autocheckOn ? 'Autocheck' : 'Check'
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                        className: `dropdownMenu checkMenu ${checkIsOpen ? 'open' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                onClick: ()=>{
                                    (0, $2eaf3926a83a2b13$export$9b2690a4578612b0)((0, $2eaf3926a83a2b13$export$105770301816d0f9).Autocheck);
                                },
                                children: "Autocheck"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                className: autocheckOn ? 'disabled' : '',
                                onClick: ()=>{
                                    (0, $2eaf3926a83a2b13$export$9b2690a4578612b0)((0, $2eaf3926a83a2b13$export$105770301816d0f9).CheckLetter);
                                },
                                children: "Square"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                className: autocheckOn ? 'disabled' : '',
                                onClick: ()=>{
                                    (0, $2eaf3926a83a2b13$export$9b2690a4578612b0)((0, $2eaf3926a83a2b13$export$105770301816d0f9).CheckWord);
                                },
                                children: "Word"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                className: autocheckOn ? 'disabled' : '',
                                onClick: ()=>{
                                    (0, $2eaf3926a83a2b13$export$9b2690a4578612b0)((0, $2eaf3926a83a2b13$export$105770301816d0f9).CheckPuzzle);
                                },
                                children: "Puzzle"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $efb662539f0209d6$export$2e2bcd8739ae039 = $efb662539f0209d6$var$DesktopToolbar;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

const $5e9fdfcf25665105$var$InputSquare = ({ clueIndex: clueIndex, letterIndex: letterIndex })=>{
    const { completed: completed, clues: clues, guesses: guesses, revealedCells: revealedCells, mistakes: mistakes, focusedClueIndex: focusedClueIndex, cursorIndex: cursorIndex } = (0, $503d195e8098532c$export$7613e4d4725461b7).useState();
    const letter = guesses[clueIndex][letterIndex];
    const isFocused = clueIndex === focusedClueIndex && letterIndex === cursorIndex;
    // `completed` here catches the case of page reload subsequent to RevealAll, since we don't save
    // the fully revealedCells to the database at that point, just mark it revealed+completed.
    const isRevealed = completed || revealedCells[clueIndex][letterIndex];
    const isWrong = mistakes[clueIndex][letterIndex];
    const classes = `letterInput` + `${isFocused ? ' focused' : ''}` + `${isRevealed ? ' revealed' : ''}` + `${isWrong ? ' mistake' : ''}` + `${completed ? ' solved' : ''}`;
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: classes,
        onClick: (e)=>{
            (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                s.focusedClueIndex = clueIndex;
                s.cursorIndex = letterIndex;
            });
            // to stop the row onClick in Morphology.tsx from firing
            e.__isSelectingIndividualCell = true;
        },
        children: isRevealed ? clues[clueIndex].solution[letterIndex] : letter
    });
};
var $5e9fdfcf25665105$export$2e2bcd8739ae039 = $5e9fdfcf25665105$var$InputSquare;


const $44269a96dd5fae24$var$SolutionInput = ({ guess: guess, clueIndex: clueIndex })=>{
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "solutionInput",
        children: guess.map((letter, letterIndex)=>/*#__PURE__*/ (0, $4XrX4.jsx)((0, $5e9fdfcf25665105$export$2e2bcd8739ae039), {
                clueIndex: clueIndex,
                letterIndex: letterIndex
            }, letterIndex))
    });
};
var $44269a96dd5fae24$export$2e2bcd8739ae039 = $44269a96dd5fae24$var$SolutionInput;




var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");













var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");





const $4d10dd06f77090f5$var$closeInstructions = ()=>{
    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
        s.instructionsAreOpen = false;
        s.isSoftPaused = false;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).set(`${(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Morphology}InstructionsDismissed`, 'true', {
        domain: (0, $ba1e3b359abf28ef$export$517466abcb8fcf10),
        expires: 365
    });
};
const $4d10dd06f77090f5$var$Instructions = ()=>{
    const isOpen = (0, $503d195e8098532c$export$7613e4d4725461b7).useState((s)=>s.instructionsAreOpen);
    const cryptic = (0, $503d195e8098532c$export$7613e4d4725461b7).useState((s)=>s.cryptic);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $a923e83bee9905be$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: $4d10dd06f77090f5$var$closeInstructions,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("h1", {
                className: "instructionsTitle",
                children: "How to Play Morphology"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "instructionsBody",
                children: /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                            children: "Fill in the word ladder with single-word solutions matching the clues."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                            children: [
                                "Each solution differs from the previous clue's solution by just a few letters. The difference is called the ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                    className: "italicText",
                                    children: "morph"
                                }),
                                " and is given in the format ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                    className: "morphText",
                                    children: "(+X, -Y, ~Z)"
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                            className: "sublist",
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                            className: "morphText",
                                            children: "+X"
                                        }),
                                        " means X characters were added.",
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                                        " CHAT is ",
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                            className: "morphText",
                                            children: "+1"
                                        }),
                                        " from CAT."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                            className: "morphText",
                                            children: "-Y"
                                        }),
                                        " means Y characters were removed.",
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                                        " RAIN is ",
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                            className: "morphText",
                                            children: "-2"
                                        }),
                                        " from RACING."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                            className: "morphText",
                                            children: "~Z"
                                        }),
                                        " means Z characters were changed.",
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                                        " GUITAR is ",
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                            className: "morphText",
                                            children: "~2"
                                        }),
                                        " from SUITOR."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                            children: "Morphology usually avoids obscure words, as well as proper names that aren't commonplace or inferrable by the morph."
                        }),
                        cryptic && /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                            className: "crypticCallout",
                            children: /*#__PURE__*/ (0, $4XrX4.jsxs)("b", {
                                children: [
                                    "This puzzle is a cryptic, which follows cryptic crossword clueing conventions. Learn more via ",
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                        target: "_blank",
                                        href: "https://www.youtube.com/watch?v=HrKiYFJxgic",
                                        children: "this video"
                                    }),
                                    ", ",
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                        target: "_blank",
                                        href: "https://www.newyorker.com/puzzles-and-games-dept/cryptic-crossword/reintroducing-the-new-yorkers-cryptic-crossword",
                                        children: "this article"
                                    }),
                                    ", or ",
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                        target: "_blank",
                                        href: "https://s.wsj.net/blogs/html/wsjcrypticguide.pdf",
                                        children: "this concise PDF"
                                    }),
                                    "."
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $4d10dd06f77090f5$export$2e2bcd8739ae039 = $4d10dd06f77090f5$var$Instructions;



const $b83ee9b416f8fe3a$var$MorphologyTopBar = ()=>{
    const { completed: completed, time: time, isPaused: isPaused } = (0, $503d195e8098532c$export$7613e4d4725461b7).useState();
    const useFloatingToolbar = (0, $ba1e3b359abf28ef$export$b87c76f5e9f3d3df)(105);
    const useMobileStyles = (0, $b2cd9ecc66d0956f$exports.isMobile) || (0, $ba1e3b359abf28ef$export$580e0f6db19fa7cc)();
    const navigate = (0, $6e00b7bb3feca34a$export$9770f232ac06a008)();
    const pauseButtonClass = completed ? 'hidden' : '';
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: `puzzleTopBar ${useMobileStyles ? 'mobile' : ''}`,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "topBarLeftSection",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        disableRipple: true,
                        title: "Back",
                        onClick: ()=>{
                            navigate('/');
                            window.scrollTo(0, 0);
                            (0, $2eaf3926a83a2b13$export$5c96c7fea13888f)();
                        },
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ba2d2837fc619c75$exports))), {})
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "navigationLabel",
                        children: (0, $860afe5c90b07ab1$export$db7e8528fe84408c)[(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Morphology]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "topBarMiddleSection",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "timer",
                        children: (0, $ba1e3b359abf28ef$export$3203edd9e5edd663)(time)
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        className: pauseButtonClass,
                        title: "Pause",
                        onClick: ()=>{
                            (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                                if (!s.isPaused) (0, $2eaf3926a83a2b13$export$5c96c7fea13888f)();
                                s.isPaused = !s.isPaused;
                            });
                            window.scrollTo(0, 0);
                        },
                        children: isPaused ? /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($815c4a10c6ca199f$exports))), {}) : /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($be547dbdaf888d8e$exports))), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "topBarRightSection",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $4d10dd06f77090f5$export$2e2bcd8739ae039), {}),
                    useFloatingToolbar && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $efb662539f0209d6$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        disableRipple: true,
                        title: "How to Play",
                        onClick: ()=>{
                            (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                                s.instructionsAreOpen = true;
                                s.isSoftPaused = true;
                            });
                        },
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($98556d5fcc3acbf1$exports))), {})
                    })
                ]
            })
        ]
    });
};
var $b83ee9b416f8fe3a$export$2e2bcd8739ae039 = $b83ee9b416f8fe3a$var$MorphologyTopBar;





var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");




const $8187a7daf91c6db9$var$AlmostThereDialog = ()=>{
    const isOpen = (0, $503d195e8098532c$export$7613e4d4725461b7).useState((s)=>s.toolbar.almostThereIsOpen);
    const onClose = ()=>{
        (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
            s.toolbar.almostThereIsOpen = false;
        });
    };
    // This dialog cannot be closed by clicking the backdrop,
    // because allowing that causes it to close instantly on mobile
    // because the final touch keyboard input is still "active" and insta-closes it.
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $74c5b717dc6d45d0$export$2e2bcd8739ae039), {
        open: isOpen,
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
            className: "revealConfirmationDialogContent",
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                    className: "closeButton",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b4a213a738a62de4$exports))), {})
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                    className: "aboutBody",
                    children: "Almost there! You've filled in the puzzle, but at least one square is wrong. The puzzle will tell you when everything is correct."
                })
            ]
        })
    });
};
var $8187a7daf91c6db9$export$2e2bcd8739ae039 = $8187a7daf91c6db9$var$AlmostThereDialog;


const $656a27434d3639b1$var$DesktopMorphology = ()=>{
    const { clues: clues, author: author, guesses: guesses, solved: solved, focusedClueIndex: focusedClueIndex, completed: completed, dateLabel: dateLabel } = (0, $503d195e8098532c$export$7613e4d4725461b7).useState();
    // Parse clues once when clues change (only happens on initial load)
    const parsedClues = (0, $28UcW.useMemo)(()=>{
        return clues.map((clue)=>(0, $2eaf3926a83a2b13$export$34fa0bd59b56d9c7)(clue.clue));
    }, [
        clues
    ]);
    // handle scrolling things into view when using tab navigation
    (0, $28UcW.useEffect)(()=>{
        const clueRows = document.querySelectorAll('.clueRow');
        const viewportHeight = window.innerHeight;
        const focused = clueRows[focusedClueIndex];
        const focusedRect = focused.getBoundingClientRect();
        const focusedIsBelowView = focusedRect.top > viewportHeight - 30;
        const focusedIsAboveView = focusedRect.bottom < 115;
        if (focusedIsBelowView) {
            focused.scrollIntoView({
                behavior: 'instant',
                block: "nearest"
            });
            return;
        }
        if (focusedIsAboveView) {
            window.scrollTo({
                top: focusedRect.top + window.scrollY - 105,
                behavior: 'instant'
            });
            return;
        }
    }, [
        focusedClueIndex
    ]);
    const useFloatingToolbar = (0, $ba1e3b359abf28ef$export$b87c76f5e9f3d3df)(105);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $b83ee9b416f8fe3a$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $8187a7daf91c6db9$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "puzzleHeader",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "headerFirstLine",
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "puzzleTitle",
                                children: "Morphology"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "puzzleDate",
                                children: dateLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "puzzleAuthor",
                        children: [
                            "By ",
                            author
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "morphologyContainer",
                children: [
                    !useFloatingToolbar && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $efb662539f0209d6$export$2e2bcd8739ae039), {}),
                    clues.map((clue, i)=>/*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                            className: `clueRow ${!solved && focusedClueIndex === i ? 'selected' : ''}`,
                            onClick: (e)=>{
                                // this onClick is for when they click the row but not a specific cell in it
                                (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                                    if (e.__isSelectingIndividualCell) return;
                                    s.focusedClueIndex = i;
                                    (0, $2eaf3926a83a2b13$export$28120faafeefa4c5)(s);
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                    className: "clueContainer",
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "clueIndex",
                                            children: i + 1
                                        }),
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "clueText",
                                            children: parsedClues[i]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                    className: "morph",
                                    children: clue.morph || ''
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                    className: "solutionInputContainer",
                                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $44269a96dd5fae24$export$2e2bcd8739ae039), {
                                        clueIndex: i,
                                        guess: guesses[i]
                                    })
                                })
                            ]
                        }, i))
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $b9f68b54b1083b27$export$2e2bcd8739ae039), {
                store: (0, $503d195e8098532c$export$7613e4d4725461b7),
                useCompleted: true,
                completed: completed
            })
        ]
    });
};
var $656a27434d3639b1$export$2e2bcd8739ae039 = $656a27434d3639b1$var$DesktopMorphology;



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");




var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");







const $bc63087dde2bebf4$var$MobileToolbar = ()=>{
    const { isPaused: isPaused, autocheckOn: autocheckOn, time: time, completed: completed, toolbar: { combinedIsOpen: combinedIsOpen } } = (0, $503d195e8098532c$export$7613e4d4725461b7).useState();
    const ref = (0, $28UcW.useRef)(null);
    const navigate = (0, $6e00b7bb3feca34a$export$9770f232ac06a008)();
    const pauseButtonClass = completed ? 'hidden' : '';
    // If a click is outside the toolbar, it closes all menus.
    // A click within the menu is handled by togglesMenus, which closes all but the clicked one.
    (0, $28UcW.useEffect)(()=>{
        const onClickOutside = (e)=>{
            if (ref.current && !ref.current.contains(e.target)) {
                (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                    s.toolbar.clearIsOpen = false;
                    s.toolbar.revealIsOpen = false;
                    s.toolbar.checkIsOpen = false;
                    s.toolbar.combinedIsOpen = false;
                });
                document.removeEventListener('click', onClickOutside);
            }
        };
        if (combinedIsOpen) document.addEventListener('click', onClickOutside);
        return ()=>{
            document.removeEventListener('click', onClickOutside);
        };
    }, [
        combinedIsOpen
    ]);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        ref: ref,
        className: "morphologyToolbar mobile",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $508758c4c0fa6bdd$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "backButtonContainer",
                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                    disableRipple: true,
                    title: "Back",
                    onClick: ()=>{
                        navigate('/');
                        window.scrollTo(0, 0);
                        (0, $2eaf3926a83a2b13$export$5c96c7fea13888f)();
                    },
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $7959af7cc02c0510$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "timerContainer",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "timer",
                        children: (0, $ba1e3b359abf28ef$export$3203edd9e5edd663)(time)
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        className: pauseButtonClass,
                        title: "Pause",
                        onClick: ()=>{
                            (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                                if (!s.isPaused) (0, $2eaf3926a83a2b13$export$5c96c7fea13888f)();
                                s.isPaused = !s.isPaused;
                            });
                        },
                        children: isPaused ? /*#__PURE__*/ (0, $4XrX4.jsx)((0, $a78c933a9fed8f1c$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $4XrX4.jsx)((0, $067abf68e76eb17f$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "infoAndHelpContainer",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "dropdownButton",
                        onClick: ()=>{
                            (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                                s.instructionsAreOpen = !s.instructionsAreOpen;
                                s.isSoftPaused = s.instructionsAreOpen;
                                s.toolbar.combinedIsOpen = false;
                            });
                        },
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                            className: "buttonLabel",
                            children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                                disableRipple: true,
                                disableTouchRipple: true,
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $1807e3b0b2b8f39f$export$2e2bcd8739ae039), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "dropdownButton",
                        onClick: ()=>{
                            (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                                s.toolbar.aboutIsOpen = true;
                                s.toolbar.combinedIsOpen = false;
                            });
                        },
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                            className: "buttonLabel",
                            children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                                disableRipple: true,
                                disableTouchRipple: true,
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $70d00445c3fb6966$export$2e2bcd8739ae039), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "dropdownButton",
                        onClick: ()=>{
                            (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                                s.toolbar.combinedIsOpen = !s.toolbar.combinedIsOpen;
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "buttonLabel",
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                                    disableRipple: true,
                                    disableTouchRipple: true,
                                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $bd71d3bf9adc9947$export$2e2bcd8739ae039), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                                className: `dropdownMenu revealMenu ${combinedIsOpen ? 'open' : ''}`,
                                children: [
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                        onClick: (0, $2eaf3926a83a2b13$export$4f2368f44db85843),
                                        children: "Clear Word"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                        onClick: ()=>{
                                            if (completed) return;
                                            (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                                                s.toolbar.confirmationDialog.clearAllIsOpen = true;
                                            });
                                        },
                                        children: "Clear Puzzle"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                        className: autocheckOn ? 'autocheckEnabled' : undefined,
                                        onClick: ()=>(0, $2eaf3926a83a2b13$export$9b2690a4578612b0)((0, $2eaf3926a83a2b13$export$105770301816d0f9).Autocheck),
                                        children: "Autocheck"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                        className: autocheckOn ? 'disabled' : undefined,
                                        onClick: ()=>(0, $2eaf3926a83a2b13$export$9b2690a4578612b0)((0, $2eaf3926a83a2b13$export$105770301816d0f9).CheckLetter),
                                        children: "Check Square"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                        className: autocheckOn ? 'disabled' : undefined,
                                        onClick: ()=>(0, $2eaf3926a83a2b13$export$9b2690a4578612b0)((0, $2eaf3926a83a2b13$export$105770301816d0f9).CheckWord),
                                        children: "Check Word"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                        className: autocheckOn ? 'disabled' : undefined,
                                        onClick: ()=>(0, $2eaf3926a83a2b13$export$9b2690a4578612b0)((0, $2eaf3926a83a2b13$export$105770301816d0f9).CheckPuzzle),
                                        children: "Check Puzzle"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                        onClick: ()=>(0, $2eaf3926a83a2b13$export$9b2690a4578612b0)((0, $2eaf3926a83a2b13$export$105770301816d0f9).RevealLetter),
                                        children: "Reveal Square"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                        onClick: ()=>(0, $2eaf3926a83a2b13$export$9b2690a4578612b0)((0, $2eaf3926a83a2b13$export$105770301816d0f9).RevealWord),
                                        children: "Reveal Word"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                        onClick: ()=>(0, $2eaf3926a83a2b13$export$9b2690a4578612b0)((0, $2eaf3926a83a2b13$export$105770301816d0f9).RevealPuzzle),
                                        children: "Reveal Puzzle"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $bc63087dde2bebf4$export$2e2bcd8739ae039 = $bc63087dde2bebf4$var$MobileToolbar;









var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");





const $e69e417f7fc6c41e$var$MobileMorphologyInstructions = ()=>{
    const isOpen = (0, $503d195e8098532c$export$7613e4d4725461b7).useState((s)=>s.instructionsAreOpen);
    const cryptic = (0, $503d195e8098532c$export$7613e4d4725461b7).useState((s)=>s.cryptic);
    const onClose = ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).set(`${(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Morphology}InstructionsDismissed`, 'true', {
            domain: (0, $ba1e3b359abf28ef$export$517466abcb8fcf10),
            expires: 365
        });
        (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
            s.instructionsAreOpen = false;
            s.isSoftPaused = false;
        });
    };
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f13252b13d1e29c0$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: onClose,
        title: "How to Play Morphology",
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                    children: "Fill in the word ladder with single-word solutions matching the clues."
                }),
                /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                    children: [
                        "Each solution differs from the previous clue's solution by just a few letters. The difference is called the ",
                        /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                            className: "italicText",
                            children: "morph"
                        }),
                        " and is given in the format ",
                        /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                            className: "morphText",
                            children: "(+X, -Y, ~Z)"
                        }),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                    className: "sublist",
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                    className: "morphText",
                                    children: "+X"
                                }),
                                " means X characters were added.",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                                " CHAT is ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                    className: "morphText",
                                    children: "+1"
                                }),
                                " from CAT."
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                    className: "morphText",
                                    children: "-Y"
                                }),
                                " means Y characters were removed.",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                                " RAIN is ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                    className: "morphText",
                                    children: "-2"
                                }),
                                " from RACING."
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                    className: "morphText",
                                    children: "~Z"
                                }),
                                " means Z characters were changed.",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                                " GUITAR is ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                    className: "morphText",
                                    children: "~2"
                                }),
                                " from SUITOR."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                    children: "Morphology usually avoids obscure words, as well as proper names that aren't commonplace or inferrable by the morph."
                }),
                cryptic && /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                    className: "crypticCallout",
                    children: /*#__PURE__*/ (0, $4XrX4.jsxs)("b", {
                        children: [
                            "This puzzle is a cryptic, which follows cryptic crossword clueing conventions. Learn more via ",
                            /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                target: "_blank",
                                href: "https://www.youtube.com/watch?v=HrKiYFJxgic",
                                children: "this video"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                target: "_blank",
                                href: "https://www.newyorker.com/puzzles-and-games-dept/cryptic-crossword/reintroducing-the-new-yorkers-cryptic-crossword",
                                children: "this article"
                            }),
                            ", or ",
                            /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                target: "_blank",
                                href: "https://s.wsj.net/blogs/html/wsjcrypticguide.pdf",
                                children: "this concise PDF"
                            }),
                            "."
                        ]
                    })
                })
            ]
        })
    });
};
var $e69e417f7fc6c41e$export$2e2bcd8739ae039 = $e69e417f7fc6c41e$var$MobileMorphologyInstructions;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");




const $0017c5d5d3d37a42$var$MobileMorphologyAbout = ()=>{
    const isOpen = (0, $503d195e8098532c$export$7613e4d4725461b7).useState((s)=>s.toolbar.aboutIsOpen);
    const author = (0, $503d195e8098532c$export$7613e4d4725461b7).useState((s)=>s.author);
    const dateLabel = (0, $503d195e8098532c$export$7613e4d4725461b7).useState((s)=>s.dateLabel);
    const onClose = ()=>{
        (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
            s.toolbar.aboutIsOpen = false;
        });
    };
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $74c5b717dc6d45d0$export$2e2bcd8739ae039), {
        open: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
            className: "revealConfirmationDialogContent",
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                    className: "closeButton",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b4a213a738a62de4$exports))), {})
                }),
                /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                    className: "aboutBody",
                    children: [
                        dateLabel,
                        /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                        "Puzzle by ",
                        author,
                        "."
                    ]
                })
            ]
        })
    });
};
var $0017c5d5d3d37a42$export$2e2bcd8739ae039 = $0017c5d5d3d37a42$var$MobileMorphologyAbout;




let $05473ac6a96a7f06$var$lastScrollTime = 0;
let $05473ac6a96a7f06$var$lastScrollSwitchId = 0;
const $05473ac6a96a7f06$var$keyboardHeight = 192;
const $05473ac6a96a7f06$var$upDownButtonsHeight = 30;
const $05473ac6a96a7f06$var$menuBarHeight = 40;
const $05473ac6a96a7f06$var$MobileMorphology = ()=>{
    const { clues: clues, author: author, guesses: guesses, completed: completed, focusedClueIndex: focusedClueIndex } = (0, $503d195e8098532c$export$7613e4d4725461b7).useState();
    // Parse clues once when clues change (only happens on initial load)
    const parsedClues = (0, $28UcW.useMemo)(()=>{
        return clues.map((clue)=>(0, $2eaf3926a83a2b13$export$34fa0bd59b56d9c7)(clue.clue));
    }, [
        clues
    ]);
    const [initialScroll, setInitialScroll] = (0, $28UcW.useState)(0);
    const totalHeight = (0, $ba1e3b359abf28ef$export$e27d6512d262aec)();
    const remainingHeight = completed ? totalHeight - $05473ac6a96a7f06$var$menuBarHeight : totalHeight - ($05473ac6a96a7f06$var$keyboardHeight + $05473ac6a96a7f06$var$menuBarHeight + $05473ac6a96a7f06$var$upDownButtonsHeight);
    const scrollableContainerHeight = remainingHeight / 2;
    const inputsRef = (0, $28UcW.useRef)(null);
    const cluesRef = (0, $28UcW.useRef)(null);
    // handle scrolling things into view when using up/down button navigation
    (0, $28UcW.useEffect)(()=>{
        // the setTimeout avoids an annoying issue where you tap a row at the top or bottom edge
        // of the scroll container and it immediately jumps and forces you to select one past
        // what you were aiming for
        setTimeout(()=>{
            (0, $2eaf3926a83a2b13$export$2ee2e0ff7ab8887b)(focusedClueIndex);
        }, 10);
    }, [
        focusedClueIndex
    ]);
    // switcher is just a super arbitrary parameter used to tell which
    // container is being scrolled so we can match the scroll on the other one
    const syncScrolls = (e, switcher)=>{
        if (!inputsRef.current || !cluesRef.current) return;
        // When you scroll one container manually, the triggered scroll on the other still invokes
        // the onScroll event and consequently triggers some kind of feedback loop.
        // This logic basically says "ignore any scroll events that are targeting a new
        // container within less than a 50ms interval" because those can be assumed to be
        // the undesirable false triggers.
        if (switcher === $05473ac6a96a7f06$var$lastScrollSwitchId) $05473ac6a96a7f06$var$lastScrollTime = e.timeStamp;
        else if (e.timeStamp - $05473ac6a96a7f06$var$lastScrollTime > 50) {
            $05473ac6a96a7f06$var$lastScrollTime = e.timeStamp;
            $05473ac6a96a7f06$var$lastScrollSwitchId = switcher;
        } else return;
        const inputs = inputsRef.current;
        const clues = cluesRef.current;
        const inputsScrollHeight = inputs.scrollHeight - inputs.clientHeight;
        const cluesScrollHeight = clues.scrollHeight - clues.clientHeight;
        if (switcher === 1) {
            const scrollPercent = inputs.scrollTop / inputsScrollHeight * 100;
            clues.scrollTop = scrollPercent / 100 * cluesScrollHeight;
        } else {
            const scrollPercent = clues.scrollTop / cluesScrollHeight * 100;
            inputs.scrollTop = scrollPercent / 100 * inputsScrollHeight;
        }
    };
    const onNext = ()=>{
        (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
            const isOnLastClue = s.focusedClueIndex === clues.length - 1;
            s.focusedClueIndex = isOnLastClue ? 0 : s.focusedClueIndex + 1;
            (0, $2eaf3926a83a2b13$export$28120faafeefa4c5)(s);
        });
    };
    const onPrevious = ()=>{
        (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
            const isOnFirstClue = s.focusedClueIndex === 0;
            s.focusedClueIndex = isOnFirstClue ? clues.length - 1 : s.focusedClueIndex - 1;
            (0, $2eaf3926a83a2b13$export$28120faafeefa4c5)(s);
        });
    };
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $bc63087dde2bebf4$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $8187a7daf91c6db9$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "morphologyContainer mobile",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "inputsContainer",
                        ref: inputsRef,
                        onScroll: (e)=>syncScrolls(e, 1),
                        style: {
                            height: scrollableContainerHeight
                        },
                        children: clues.map((clue, i)=>/*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: `inputRow ${focusedClueIndex === i ? 'selected' : ''}`,
                                onClick: (e)=>{
                                    if (e.__isSelectingIndividualCell) return;
                                    // (We need both onClick and onScroll because MobileMorphology is also
                                    // used for small window sizes on desktop.)
                                    // this onClick is for when they click the row but not a specific cell in it
                                    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                                        s.focusedClueIndex = i;
                                        (0, $2eaf3926a83a2b13$export$28120faafeefa4c5)(s);
                                    });
                                },
                                onTouchStart: ()=>{
                                    const scrollTop = document.querySelector('.inputsContainer').scrollTop;
                                    setInitialScroll(scrollTop);
                                },
                                onTouchEnd: (e)=>{
                                    if (e.__isSelectingIndividualCell) return;
                                    const scrollTop = document.querySelector('.inputsContainer').scrollTop;
                                    if (scrollTop !== initialScroll) return;
                                    // this onClick is for when they click the row but not a specific cell in it
                                    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                                        s.focusedClueIndex = i;
                                        (0, $2eaf3926a83a2b13$export$28120faafeefa4c5)(s);
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                        className: "clueIndex",
                                        children: i + 1
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                        className: "solutionInputContainer",
                                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $44269a96dd5fae24$export$2e2bcd8739ae039), {
                                            clueIndex: i,
                                            guess: guesses[i]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                        className: "morph",
                                        children: clue.morph || ''
                                    })
                                ]
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "cluesContainer",
                        ref: cluesRef,
                        onScroll: (e)=>syncScrolls(e, 2),
                        style: {
                            height: scrollableContainerHeight
                        },
                        children: clues.map((clue, i)=>/*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: `clueRow ${focusedClueIndex === i ? 'selected' : ''}`,
                                onClick: ()=>{
                                    // (We need both onClick and onScroll because MobileMorphology is also
                                    // used for small window sizes on desktop.)
                                    // this onClick is for when they click the row but not a specific cell in it
                                    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                                        s.focusedClueIndex = i;
                                        (0, $2eaf3926a83a2b13$export$28120faafeefa4c5)(s);
                                    });
                                },
                                onTouchStart: ()=>{
                                    const scrollTop = document.querySelector('.inputsContainer').scrollTop;
                                    setInitialScroll(scrollTop);
                                },
                                onTouchEnd: ()=>{
                                    const scrollTop = document.querySelector('.inputsContainer').scrollTop;
                                    if (scrollTop !== initialScroll) return;
                                    // this onClick is for when they click the row but not a specific cell in it
                                    (0, $503d195e8098532c$export$7613e4d4725461b7).update((s)=>{
                                        s.focusedClueIndex = i;
                                        (0, $2eaf3926a83a2b13$export$28120faafeefa4c5)(s);
                                    });
                                },
                                children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                    className: "clueContainer",
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "clueIndex",
                                            children: i + 1
                                        }),
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                            className: "clueText",
                                            children: parsedClues[i]
                                        })
                                    ]
                                })
                            }, i))
                    }),
                    !completed && /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "navigationContainer",
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                                onClick: onPrevious,
                                disableRipple: true,
                                disableFocusRipple: true,
                                disableTouchRipple: true,
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($67349de2d338c8da$exports))), {})
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                                onClick: onNext,
                                disableRipple: true,
                                disableFocusRipple: true,
                                disableTouchRipple: true,
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9d3a2b240304cbb0$exports))), {})
                            })
                        ]
                    }),
                    !completed && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d6c154c725c93576$export$2e2bcd8739ae039), {
                        handleInput: (0, $2eaf3926a83a2b13$export$412508d679148d5c)
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $b9f68b54b1083b27$export$2e2bcd8739ae039), {
                        store: (0, $503d195e8098532c$export$7613e4d4725461b7),
                        useCompleted: true,
                        completed: completed
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $e69e417f7fc6c41e$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $0017c5d5d3d37a42$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $05473ac6a96a7f06$export$2e2bcd8739ae039 = $05473ac6a96a7f06$var$MobileMorphology;




// Build an MM-DD-YYYY key from URL params like /morphology/2025/10/3.
// Accepts non-padded month/day and zero-pads them. Returns null if the parts
// don't form a structurally valid calendar date.
const $9066f0861aa240ef$var$buildDateKey = (year, month, day)=>{
    if (!year || !month || !day) return null;
    if (!/^\d{1,4}$/.test(year) || !/^\d{1,2}$/.test(month) || !/^\d{1,2}$/.test(day)) return null;
    const y = Number(year);
    const m = Number(month);
    const d = Number(day);
    if (y < 2000 || y > 9999 || m < 1 || m > 12 || d < 1 || d > 31) return null;
    const mm = String(m).padStart(2, '0');
    const dd = String(d).padStart(2, '0');
    const yyyy = String(y);
    // Reject impossible days (e.g. 02-31) by round-tripping through a UTC date.
    const probe = new Date(Date.UTC(y, m - 1, d));
    if (probe.getUTCMonth() !== m - 1 || probe.getUTCDate() !== d) return null;
    return `${mm}-${dd}-${yyyy}`;
};
// Today's date in Eastern time as MM-DD-YYYY, matching the backend's getESTDate().
// en-CA yields YYYY-MM-DD; we reorder to MM-DD-YYYY for comparison.
const $9066f0861aa240ef$var$getEasternTodayKey = ()=>{
    const [yyyy, mm, dd] = new Date().toLocaleDateString('en-CA', {
        timeZone: 'America/New_York'
    }).split('-');
    return `${mm}-${dd}-${yyyy}`;
};
// Inner board: identical to the daily Morphology body, but bound to the archive
// store. Rendered only once data is loaded, so the puzzle hooks below always see
// a populated store.
const $9066f0861aa240ef$var$ArchiveMorphologyBoard = ()=>{
    const { autocheckOn: autocheckOn, guesses: guesses, completed: completed } = (0, $503d195e8098532c$export$7613e4d4725461b7).useState();
    // Mirrors the daily puzzle: morphology only uses `completed`, so we pass it for
    // both the `revealed` and `solved` params of useKeyboardInput.
    (0, $ba1e3b359abf28ef$export$a546a4e9e5b2cdef)((0, $2eaf3926a83a2b13$export$412508d679148d5c), completed, completed);
    (0, $ba1e3b359abf28ef$export$20d77ccceac0f55c)((0, $503d195e8098532c$export$7613e4d4725461b7), (0, $2eaf3926a83a2b13$export$5c96c7fea13888f));
    (0, $ba1e3b359abf28ef$export$e73a86b2063a8f6b)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Morphology, (0, $503d195e8098532c$export$7613e4d4725461b7));
    (0, $28UcW.useEffect)(()=>{
        if (autocheckOn) (0, $2eaf3926a83a2b13$export$ed0314765beb2ba1)();
    }, [
        guesses,
        autocheckOn
    ]);
    const useMobileStyles = (0, $b2cd9ecc66d0956f$exports.isMobile) || (0, $ba1e3b359abf28ef$export$580e0f6db19fa7cc)();
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: `puzzleContainer ${useMobileStyles ? 'mobile' : ''}`,
        children: [
            useMobileStyles && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $05473ac6a96a7f06$export$2e2bcd8739ae039), {}),
            !useMobileStyles && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $656a27434d3639b1$export$2e2bcd8739ae039), {})
        ]
    });
};
const $9066f0861aa240ef$var$ArchiveMorphology = ()=>{
    const { year: year, month: month, day: day } = (0, $6e00b7bb3feca34a$export$99eaa27ddbbb95ef)();
    const navigate = (0, $6e00b7bb3feca34a$export$9770f232ac06a008)();
    const [status, setStatus] = (0, $28UcW.useState)('loading');
    const dateKey = $9066f0861aa240ef$var$buildDateKey(year, month, day);
    const isToday = dateKey !== null && dateKey === $9066f0861aa240ef$var$getEasternTodayKey();
    (0, $28UcW.useEffect)(()=>{
        // Reset to a clean slate before (re)loading, so navigating between archive
        // dates never flashes the previously loaded puzzle.
        setStatus('loading');
        if (!dateKey) {
            setStatus('notfound');
            return;
        }
        // If this is today's puzzle, send the user to the live daily route instead.
        if (isToday) {
            navigate('/morphology', {
                replace: true
            });
            return;
        }
        let cancelled = false;
        (0, $ea74087fd5ac399e$export$2e2bcd8739ae039).get(`/api/puzzles/morphology-archive?date=${dateKey}`).then((response)=>{
            if (cancelled) return;
            (0, $2eaf3926a83a2b13$export$a0020d212ef6ba7a)(response.data);
            setStatus('ready');
        }).catch(()=>{
            if (!cancelled) setStatus('notfound');
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        dateKey,
        isToday,
        navigate
    ]);
    if (isToday) // The effect will redirect; render nothing meaningful in the meantime.
    return null;
    if (status === 'notfound') return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $6e00b7bb3feca34a$export$444b3ab0cb9aec40), {
        to: "/",
        replace: true
    });
    if (status === 'loading') return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "loadingScreen",
        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $309dd07201abfd19$export$2e2bcd8739ae039), {})
    });
    return /*#__PURE__*/ (0, $4XrX4.jsx)($9066f0861aa240ef$var$ArchiveMorphologyBoard, {});
};
var $9066f0861aa240ef$export$2e2bcd8739ae039 = $9066f0861aa240ef$var$ArchiveMorphology;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");






var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");





var $532e0b92c40a7303$exports = {};
$532e0b92c40a7303$exports = import.meta.resolve("oSKvj");


var $1272fe0e511cee73$exports = {};
$1272fe0e511cee73$exports = import.meta.resolve("c9SqR");



const $bf9845d00356f421$var$closeInstructions = ()=>{
    (0, $56703c0bbcb0049a$export$557a6027eb88d4ac).update((s)=>{
        s.instructionsAreOpen = false;
        s.isSoftPaused = false;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).set(`${(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword}InstructionsDismissed`, 'true', {
        domain: (0, $ba1e3b359abf28ef$export$517466abcb8fcf10),
        expires: 365
    });
};
const $bf9845d00356f421$var$Instructions = ()=>{
    const isOpen = (0, $56703c0bbcb0049a$export$557a6027eb88d4ac).useState((s)=>s.instructionsAreOpen);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $a923e83bee9905be$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: $bf9845d00356f421$var$closeInstructions,
        className: "twoColumnInstructions",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("h1", {
                className: "instructionsTitle",
                children: "How to Play the Pathword"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "instructionsBody twoColumnInstructionsBody",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "writtenInstructions",
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                                children: [
                                    "Start at the starred square and ",
                                    (0, $b2cd9ecc66d0956f$exports.isMobile) ? 'tap' : 'click',
                                    " the grid squares to plot a path for the letters through the grid."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                                children: "Each step of the path will use one letter from the cluetext above the grid, in order."
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                                        children: [
                                            "Each horizontal row must spell a 4-letter word. Columns do ",
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                                className: "boldText",
                                                children: "not"
                                            }),
                                            " need to spell words."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                                        children: [
                                            "Consonants can only go in white squares. Vowels can only go in grey squares. ",
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                                            " (Y counts as a vowel.)"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                        children: "Valid moves for the next letter are shown with each new step of the path."
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                        children: "Blue hint letters can only be placed in their assigned spots."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "videoInstructions",
                        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("video", {
                            controls: true,
                            autoPlay: true,
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)("source", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1272fe0e511cee73$exports))),
                                    type: "video/webm"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)("source", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($532e0b92c40a7303$exports))),
                                    type: "video/mp4"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                                    children: "Your browser does not support HTML5 video elements."
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $bf9845d00356f421$export$2e2bcd8739ae039 = $bf9845d00356f421$var$Instructions;



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");

var $2cHFZ = parcelRequire("2cHFZ");




var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");
const $231fc56b57f6ca53$var$GridCell = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($28UcW))).memo(({ store: store, row: row, col: col, isVowel: isVowel, startPath: startPath, continuePath: continuePath })=>{
    const { path: path, cluetext: cluetext, pathHead: pathHead, lines: lines, highlights: highlights, successAnimationGrid: successAnimationGrid, revealed: revealed, solved: solved, solutionPath: solutionPath, solutionLines: solutionLines, hintPositions: hintPositions, enabledHints: enabledHints, hintLetters: hintLetters } = store.useState();
    // Check if this cell has an enabled hint letter
    const posKey = `${row}_${col}`;
    const hintIndex = hintPositions[posKey];
    const hintLetterPosition = hintIndex !== undefined ? hintLetters.indexOf(hintIndex) : -1;
    const isHintEnabled = hintLetterPosition !== -1 && enabledHints.includes(hintLetterPosition);
    const hintLetterForCell = isHintEnabled && !revealed && !solved ? cluetext[hintIndex] : null;
    const hasPath = path[row][col] > 0;
    const showHintPreview = hintLetterForCell && !hasPath;
    // Check if this hint cell is highlighted (next letter matches)
    const highlighted = highlights[row][col] > 0;
    const isHintHighlighted = showHintPreview && highlighted;
    const classes = `matrixCell` + `${isVowel ? ' vowelCell' : ''}` + ` ${solved || revealed ? solutionLines[solutionPath[row][col]] : lines[path[row][col]] || ''}` + `${highlighted && !showHintPreview ? ' highlighted' : ''}` + `${solved || successAnimationGrid[row][col] > 0 ? ' solved' : ''}` + `${showHintPreview ? ' hintPreview' : ''}` + `${isHintHighlighted ? ' hintHighlighted' : ''}`;
    const highlightContent = pathHead ? cluetext[path[pathHead[0]][pathHead[1]]] : '';
    const pathContent = solved || revealed ? cluetext[solutionPath[row][col] - 1] : cluetext[path[row][col] - 1];
    // Check if this cell contains a used hint letter
    const pathIndex = path[row][col] - 1; // Convert to 0-indexed
    const isUsedHintCell = pathIndex >= 0 && isHintEnabled;
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: classes,
        onMouseDown: ()=>startPath(row, col),
        onMouseEnter: ()=>continuePath(row, col),
        onTouchStart: ()=>startPath(row, col),
        onContextMenu: (e)=>{
            e.preventDefault();
        },
        "data-rowindex": row,
        "data-colindex": col,
        children: [
            pathContent && /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: `circledLetter ${isUsedHintCell && !solved ? 'usedHint' : ''}`,
                children: pathContent
            }),
            !pathContent && showHintPreview && /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: `hintPreviewLetter ${isHintHighlighted ? 'unfaded' : ''}`,
                children: hintLetterForCell
            }),
            highlighted && !showHintPreview && /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                children: highlightContent
            })
        ]
    });
});
var $231fc56b57f6ca53$export$2e2bcd8739ae039 = $231fc56b57f6ca53$var$GridCell;





// So for the notation matrix[row][col], row would pick a subarray
// i.e. a word row, and col would pick a letter from that row.
// It equates to [y,x] which is typical in this context.
const $07351e99fd2afdf7$var$startingCorner = [
    0,
    0
];
const $07351e99fd2afdf7$var$SUCCESS_ANIMATION_DELAY = 150;
let $07351e99fd2afdf7$var$continueTimeout = null;
let $07351e99fd2afdf7$var$lastTouchedCell = [
    -1,
    -1
];
const $07351e99fd2afdf7$var$PathwordGrid = ({ store: store, onSolve: onSolve })=>{
    const { vowelMatrix: vowelMatrix, cluetext: cluetext, puzzleSize: puzzleSize, path: path, pathLength: pathLength, pathHead: pathHead, successAnimationGrid: successAnimationGrid, revealed: revealed, solved: solved, solutionPath: solutionPath, hintLetters: hintLetters, enabledHints: enabledHints, hintPositions: hintPositions } = store.useState();
    const reversedClueStringForQueue = [
        ...cluetext
    ].reverse();
    const [isPathing, setIsPathing] = (0, $28UcW.useState)(false);
    // Initialize letterQueue based on current pathLength to handle component remounting
    const [letterQueue, setLetterQueue] = (0, $28UcW.useState)(pathLength > 0 ? reversedClueStringForQueue.slice(0, -pathLength) : reversedClueStringForQueue);
    const nextLetter = letterQueue.at(-1);
    // Check if a cell is an enabled hint cell that requires a specific position in the path
    const violatesHintConstraint = (row, col)=>{
        const posKey = `${row}_${col}`;
        const hintIndex = hintPositions[posKey];
        // Check if the NEXT LETTER we're trying to place is an enabled hint letter
        const nextLetterHintPosition = hintLetters.indexOf(pathLength);
        const nextLetterIsEnabledHint = nextLetterHintPosition !== -1 && enabledHints.includes(nextLetterHintPosition);
        if (nextLetterIsEnabledHint) // Next letter IS an enabled hint - only allow placing it in its designated cell
        return hintIndex !== pathLength;
        // Next letter is NOT a hint - check if we're trying to place it in a hint cell
        if (hintIndex === undefined) return false; // Not a hint cell, allow placement
        const hintLetterPosition = hintLetters.indexOf(hintIndex);
        const isEnabledHint = hintLetterPosition !== -1 && enabledHints.includes(hintLetterPosition);
        if (!isEnabledHint) return false; // Not an enabled hint, allow placement
        // This IS an enabled hint cell - only allow if current path position matches hint index
        return hintIndex !== pathLength;
    };
    const clearPathAfterCell = (row, col)=>{
        const selectedPathValue = path[row][col];
        const modifiedPath = (0, $2cHFZ.cloneDeep)(path);
        for(let i = 0; i < modifiedPath.length; i++){
            for(let j = 0; j < modifiedPath[i].length; j++)if (modifiedPath[i][j] > selectedPathValue) modifiedPath[i][j] = 0;
        }
        store.update((s)=>{
            s.path = modifiedPath;
            s.pathLength = selectedPathValue;
            s.pathHead = [
                row,
                col
            ];
            s.lines = (0, $5672f12342c56f70$export$f649d9377c5250d0)(modifiedPath);
        });
        // so that we can pass it to updateHighlights, since letterQueue is stale here
        const newLetterQueue = reversedClueStringForQueue.slice(0, -selectedPathValue);
        setLetterQueue(newLetterQueue);
        updateHighlights(newLetterQueue.at(-1), row, col, modifiedPath);
    };
    // path is passed as a param because this happens before the state update goes out
    // so using the path variable would have stale data, which messes with backtracking
    const updateHighlights = (nextLetter, row, col, updatedPath)=>{
        // Calculate path length from updatedPath (can't use pathLength from store because it's stale -
        // this function is called AFTER modifying the path but BEFORE the store state updates)
        let updatedPathLength = 0;
        for(let r = 0; r < updatedPath.length; r++){
            for(let c = 0; c < updatedPath[r].length; c++)if (updatedPath[r][c] > 0) updatedPathLength++;
        }
        store.update((s)=>{
            if (updatedPathLength === puzzleSize * puzzleSize) s.highlights = (0, $56703c0bbcb0049a$export$91b909e95a7f5fb0)(puzzleSize);
            else s.highlights = (0, $5672f12342c56f70$export$63d4c81b4cbc0024)(row, col, nextLetter, updatedPath, puzzleSize, vowelMatrix, hintPositions, hintLetters, enabledHints, cluetext, updatedPathLength);
        });
    };
    const addStepToPath = (row, col)=>{
        const modifiedPath = (0, $2cHFZ.cloneDeep)(path);
        modifiedPath[row][col] = pathLength + 1;
        store.update((s)=>{
            s.path = modifiedPath;
            s.pathLength = pathLength + 1;
            s.pathHead = [
                row,
                col
            ];
            s.lines = (0, $5672f12342c56f70$export$f649d9377c5250d0)(modifiedPath);
        });
        const newLetterQueue = letterQueue.slice(0, letterQueue.length - 1);
        setLetterQueue(newLetterQueue);
        updateHighlights(newLetterQueue.at(-1), row, col, modifiedPath);
        return modifiedPath; // for the success verification
    };
    const startPath = (row, col)=>{
        if (revealed || solved) return;
        const mouseUpListener = ()=>{
            setIsPathing(false);
            document.removeEventListener('mouseup', mouseUpListener);
        };
        document.addEventListener('mouseup', mouseUpListener);
        if (pathLength === 0 && !(0, $5672f12342c56f70$export$7f7c305e30d5967e)([
            row,
            col
        ], $07351e99fd2afdf7$var$startingCorner)) // pulse "start here" message in starting square
        return;
        // If the clicked cell is already in path, erase path AFTER this cell
        // so that this cell is now head.
        if (path[row][col]) {
            clearPathAfterCell(row, col);
            setIsPathing(true);
            return;
        }
        // If the clicked cell isn't a valid move from the current pathHead, do nothing
        if (pathHead && !(0, $5672f12342c56f70$export$27c72763f7f1cbe3)([
            row,
            col
        ], pathHead)) return;
        // If the clicked cell isn't a valid move based on consonant/vowel patter, do nothing
        if ((0, $5672f12342c56f70$export$d37972fdbaa5a361)(nextLetter, row, col, vowelMatrix)) return;
        // If the clicked cell is an enabled hint cell that requires a different position, reject
        if (violatesHintConstraint(row, col)) return;
        const modifiedPath = addStepToPath(row, col);
        if (pathLength + 1 === puzzleSize * puzzleSize) {
            if (isValidSolution(modifiedPath)) {
                onSolve();
                setIsPathing(false);
                triggerSuccessAnimation(row, col);
            } else setTimeout(()=>{
                store.update((s)=>{
                    s.almostThereIsOpen = true;
                });
            }, 200);
        } else setIsPathing(true);
    };
    const isValidSolution = (suggestedSolution)=>{
        return (0, $2cHFZ.isEqual)(suggestedSolution, solutionPath);
    };
    const continuePath = (row, col)=>{
        if (!isPathing) return;
        if (revealed || solved) return;
        // This catches an edge-case that mostly seems to trigger during mobile-emulation
        // during development where the currentCell is not part of the grid at all but
        // rather the app or something outside the grid, and so both row and col are NaN.
        // but we can basically just ignore that and skip it. again, only happens during
        // emulation anyway. although it also seems to happen when the AlmostThereDialog comes up.
        if (isNaN(row) || isNaN(col)) return;
        // This has a short delay so we dont trigger it on the wrong square when pathing diagonally
        if ($07351e99fd2afdf7$var$continueTimeout) {
            clearTimeout($07351e99fd2afdf7$var$continueTimeout);
            $07351e99fd2afdf7$var$continueTimeout = null;
        }
        $07351e99fd2afdf7$var$continueTimeout = setTimeout(()=>{
            if (path[row][col]) {
                const [prevRow, prevCol] = pathHead;
                const previousPosition = path[prevRow][prevCol] - 1;
                if (path[row][col] === previousPosition) clearPathAfterCell(row, col);
                return;
            }
            if (!(0, $5672f12342c56f70$export$27c72763f7f1cbe3)([
                row,
                col
            ], pathHead)) return;
            if ((0, $5672f12342c56f70$export$d37972fdbaa5a361)(nextLetter, row, col, vowelMatrix)) return;
            // If the cell is an enabled hint cell that requires a different position, reject
            if (violatesHintConstraint(row, col)) return;
            const modifiedPath = addStepToPath(row, col);
            if (pathLength + 1 === puzzleSize * puzzleSize) {
                if (isValidSolution(modifiedPath)) {
                    onSolve();
                    setIsPathing(false);
                    triggerSuccessAnimation(row, col);
                } else setTimeout(()=>{
                    store.update((s)=>{
                        s.almostThereIsOpen = true;
                    });
                }, 200);
            }
        }, 35);
    };
    const onTouchMove = (event)=>{
        const touch = event.touches[0];
        let currentCell = document.elementFromPoint(touch.clientX, touch.clientY);
        if (!currentCell) return;
        // for when it triggers on the next-letter hint instead of the cell containing it
        if (!currentCell.classList.contains('matrixCell')) currentCell = currentCell.parentElement;
        let row = parseInt(currentCell.getAttribute('data-rowindex'));
        let col = parseInt(currentCell.getAttribute('data-colindex'));
        // This catches an edge-case that mostly seems to trigger during mobile-emulation
        // during development where the currentCell is not part of the grid at all but
        // rather the app or something outside the grid, and so both row and col are NaN.
        // but we can basically just ignore that and skip it. again, only happens during
        // emulation anyway. although it also seems to happen when the AlmostThereDialog comes up.
        if (isNaN(row)) return;
        // Swiped to a new cell.
        if (pathHead && (row !== pathHead[0] || col !== pathHead[1])) {
            // This if statement prevents this from triggering over and over
            // on the same cell, which gets extremely glitchy and stops it from working.
            if ((0, $5672f12342c56f70$export$7f7c305e30d5967e)([
                row,
                col
            ], $07351e99fd2afdf7$var$lastTouchedCell)) return;
            $07351e99fd2afdf7$var$lastTouchedCell = [
                row,
                col
            ];
            continuePath(row, col);
        }
    };
    const triggerSuccessAnimation = (row, col)=>{
        // cuz store state would be stale
        const localCopyOfSuccessGrid = (0, $2cHFZ.cloneDeep)(successAnimationGrid);
        const triggerNextWave = (r, c)=>{
            // Change the cell at row, col to 1
            store.update((s)=>{
                s.successAnimationGrid[r][c] = 1;
            });
            localCopyOfSuccessGrid[r][c] = 1;
            // Check adjacent cells
            const directions = [
                [
                    -1,
                    0
                ],
                [
                    1,
                    0
                ],
                [
                    0,
                    -1
                ],
                [
                    0,
                    1
                ]
            ]; // Up, Down, Left, Right
            for (const [dr, dc] of directions){
                const newRow = r + dr;
                const newCol = c + dc;
                if (newRow >= 0 && newRow < puzzleSize && newCol >= 0 && newCol < puzzleSize && localCopyOfSuccessGrid[newRow][newCol] === 0) setTimeout(()=>triggerNextWave(newRow, newCol), $07351e99fd2afdf7$var$SUCCESS_ANIMATION_DELAY);
            }
        };
        triggerNextWave(row, col);
    };
    const reset = ()=>{
        store.update((s)=>{
            s.path = (0, $56703c0bbcb0049a$export$91b909e95a7f5fb0)(puzzleSize);
            s.lines = {};
            s.pathHead = null;
            s.pathLength = 0;
            s.highlights = (0, $56703c0bbcb0049a$export$91b909e95a7f5fb0)(puzzleSize);
            s.solved = false;
            s.successAnimationGrid = (0, $56703c0bbcb0049a$export$91b909e95a7f5fb0)(puzzleSize);
        });
        setLetterQueue(reversedClueStringForQueue);
    };
    const undo = ()=>{
        alert(`To undo part of your path, simply ${(0, $b2cd9ecc66d0956f$exports.isMobile) ? 'tap' : 'click'} anywhere along the path and everything after that point will be cleared.`);
    };
    const usedLetters = cluetext.slice(0, pathLength);
    const unusedLetters = cluetext.slice(pathLength);
    // Helper to check if an index is an enabled hint
    const isEnabledHint = (index)=>{
        const hintPosition = hintLetters.indexOf(index);
        return hintPosition !== -1 && enabledHints.includes(hintPosition);
    };
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "clueString",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                        className: "usedLetters",
                        children: usedLetters.map((letter, index)=>/*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                className: isEnabledHint(index) ? 'hintLetter' : '',
                                children: letter
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                        className: "unusedLetters",
                        children: unusedLetters.map((letter, index)=>{
                            const absoluteIndex = pathLength + index;
                            return /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                className: isEnabledHint(absoluteIndex) ? 'hintLetter' : '',
                                children: letter
                            }, absoluteIndex);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: `matrixGrid ${solved ? 'solved' : ''}`,
                onTouchMove: (e)=>onTouchMove(e),
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "goldStar",
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($387cc6ad1e5ed9a7$exports))), {})
                    }),
                    vowelMatrix.map((row, rowIndex)=>/*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                            className: "matrixRow",
                            children: row.map((letter, columnIndex)=>/*#__PURE__*/ (0, $4XrX4.jsx)((0, $231fc56b57f6ca53$export$2e2bcd8739ae039), {
                                    store: store,
                                    row: rowIndex,
                                    col: columnIndex,
                                    isVowel: vowelMatrix[rowIndex][columnIndex] === 0,
                                    startPath: startPath,
                                    continuePath: continuePath
                                }, columnIndex))
                        }, rowIndex))
                ]
            }),
            !(solved || revealed) && /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "undoButtons",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                        className: "clearButton",
                        onClick: reset,
                        children: "Clear"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                        className: "undoButton",
                        onClick: undo,
                        children: "Undo"
                    })
                ]
            }),
            revealed && /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "outcomeBanner",
                children: "Solution revealed. Try again tomorrow!"
            })
        ]
    });
};
var $07351e99fd2afdf7$export$2e2bcd8739ae039 = $07351e99fd2afdf7$var$PathwordGrid;





var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");








const $3a74ad574960d25d$var$MobilePathwordInstructions = ()=>{
    const isOpen = (0, $56703c0bbcb0049a$export$557a6027eb88d4ac).useState((s)=>s.instructionsAreOpen);
    const onClose = ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).set(`${(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword}InstructionsDismissed`, 'true', {
            domain: (0, $ba1e3b359abf28ef$export$517466abcb8fcf10),
            expires: 365
        });
        (0, $56703c0bbcb0049a$export$557a6027eb88d4ac).update((s)=>{
            s.instructionsAreOpen = false;
            s.isSoftPaused = false;
        });
    };
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $f13252b13d1e29c0$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: onClose,
        title: "How to Play the Pathword",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                children: [
                    "Start at the starred square and ",
                    (0, $b2cd9ecc66d0956f$exports.isMobile) ? 'tap' : 'click',
                    " the grid squares to plot a path for the letters through the grid."
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "Each step of the path will use one letter from the cluetext above the grid, in order."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                        children: [
                            "Each horizontal row must spell a 4-letter word. Columns do ",
                            /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                className: "boldText",
                                children: "not"
                            }),
                            " need to spell words."
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                        children: "Consonants can only go in white squares. Vowels can only go in grey squares. (Y counts as a vowel.) "
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                        children: "Valid moves for the next letter are shown with each new step of the path."
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                        children: "Blue hint letters can only be placed in their assigned spots."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("video", {
                controls: true,
                autoPlay: true,
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("source", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1272fe0e511cee73$exports))),
                        type: "video/webm"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("source", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($532e0b92c40a7303$exports))),
                        type: "video/mp4"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                        children: "Your browser does not support HTML5 video elements."
                    })
                ]
            })
        ]
    });
};
var $3a74ad574960d25d$export$2e2bcd8739ae039 = $3a74ad574960d25d$var$MobilePathwordInstructions;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");




const $6d5039419ed88ab9$var$AlmostThereDialog = ()=>{
    const isOpen = (0, $56703c0bbcb0049a$export$557a6027eb88d4ac).useState((s)=>s.almostThereIsOpen);
    const onClose = ()=>{
        (0, $56703c0bbcb0049a$export$557a6027eb88d4ac).update((s)=>{
            s.almostThereIsOpen = false;
        });
    };
    // This dialog cannot be closed by clicking the backdrop,
    // because allowing that causes it to close instantly on mobile
    // because the final touch keyboard input is still "active" and insta-closes it.
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $74c5b717dc6d45d0$export$2e2bcd8739ae039), {
        open: isOpen,
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
            className: "revealConfirmationDialogContent",
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                    className: "closeButton",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b4a213a738a62de4$exports))), {})
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                    className: "aboutBody",
                    children: "You've filled in the grid, but at least one horizontal row does not spell a word. Keep trying!"
                })
            ]
        })
    });
};
var $6d5039419ed88ab9$export$2e2bcd8739ae039 = $6d5039419ed88ab9$var$AlmostThereDialog;



const $f307cf6c0adf4390$var$Pathword = ()=>{
    (0, $ba1e3b359abf28ef$export$e73a86b2063a8f6b)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword, (0, $56703c0bbcb0049a$export$557a6027eb88d4ac));
    (0, $ba1e3b359abf28ef$export$20d77ccceac0f55c)((0, $56703c0bbcb0049a$export$557a6027eb88d4ac), (0, $5672f12342c56f70$export$868183fcaa7ce9d2));
    (0, $ba1e3b359abf28ef$export$5b0326dddadcb0de)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword);
    (0, $ba1e3b359abf28ef$export$52dc0a972e5b91c5)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword);
    (0, $80f684051860af43$export$2500c8a6bc3f2f43)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword);
    const useMobileStyles = (0, $b2cd9ecc66d0956f$exports.isMobile) || (0, $ba1e3b359abf28ef$export$580e0f6db19fa7cc)();
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d549bcf7ed920b37$export$2e2bcd8739ae039), {
                puzzleName: (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword,
                store: (0, $56703c0bbcb0049a$export$557a6027eb88d4ac),
                onReveal: (0, $5672f12342c56f70$export$7cf2f68092532300),
                onSave: (0, $5672f12342c56f70$export$868183fcaa7ce9d2),
                InstructionsComponent: useMobileStyles ? (0, $3a74ad574960d25d$export$2e2bcd8739ae039) : (0, $bf9845d00356f421$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $6d5039419ed88ab9$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "puzzleContainer pathwordContainer",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $07351e99fd2afdf7$export$2e2bcd8739ae039), {
                        store: (0, $56703c0bbcb0049a$export$557a6027eb88d4ac),
                        onSolve: (0, $5672f12342c56f70$export$4e3bdb6fc7af2ff8)
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $b9f68b54b1083b27$export$2e2bcd8739ae039), {
                        store: (0, $56703c0bbcb0049a$export$557a6027eb88d4ac)
                    })
                ]
            })
        ]
    });
};
var $f307cf6c0adf4390$export$2e2bcd8739ae039 = $f307cf6c0adf4390$var$Pathword;


var $dc95ef7e08fb73ac$export$2e2bcd8739ae039 = (0, $f307cf6c0adf4390$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");





var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");





const $1687f24858a0bae5$var$closeInstructions = ()=>{
    (0, $86b89eb84cf821a4$export$681392899cda0e6d).update((s)=>{
        s.instructionsAreOpen = false;
        s.isSoftPaused = false;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).set(`${(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword5x5}InstructionsDismissed`, 'true', {
        domain: (0, $ba1e3b359abf28ef$export$517466abcb8fcf10),
        expires: 365
    });
};
const $1687f24858a0bae5$var$Instructions = ()=>{
    const isOpen = (0, $86b89eb84cf821a4$export$681392899cda0e6d).useState((s)=>s.instructionsAreOpen);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $a923e83bee9905be$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: $1687f24858a0bae5$var$closeInstructions,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("h1", {
                className: "instructionsTitle",
                children: "How to Play the Pathword 5x5"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "instructionsBody triwordInstructions",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                        children: "This puzzle is simply a bigger version of the normal Pathword. The rules are the same. Make sure you've solved that one first before attempting this."
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                        children: "The 5x5 is meant for those days when the normal Pathword isn't enough and you're left wanting more."
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                        children: [
                            "But we'll warn you: the 5x5 is ",
                            /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                className: "italicText",
                                children: "much"
                            }),
                            " harder."
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                        children: "As before, start at the star. There is only one solution. Good luck."
                    })
                ]
            })
        ]
    });
};
var $1687f24858a0bae5$export$2e2bcd8739ae039 = $1687f24858a0bae5$var$Instructions;







const $ab7796b1469784b9$var$Pathword5x5 = ()=>{
    (0, $ba1e3b359abf28ef$export$e73a86b2063a8f6b)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword5x5, (0, $86b89eb84cf821a4$export$681392899cda0e6d));
    (0, $ba1e3b359abf28ef$export$20d77ccceac0f55c)((0, $86b89eb84cf821a4$export$681392899cda0e6d), (0, $862bdcea3eeac9b6$export$621a0561ab81bb49));
    (0, $ba1e3b359abf28ef$export$5b0326dddadcb0de)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword5x5);
    (0, $ba1e3b359abf28ef$export$52dc0a972e5b91c5)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword5x5);
    (0, $80f684051860af43$export$2500c8a6bc3f2f43)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword5x5);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d549bcf7ed920b37$export$2e2bcd8739ae039), {
                puzzleName: (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Pathword5x5,
                store: (0, $86b89eb84cf821a4$export$681392899cda0e6d),
                onReveal: (0, $862bdcea3eeac9b6$export$7cf2f68092532300),
                onSave: (0, $862bdcea3eeac9b6$export$621a0561ab81bb49),
                InstructionsComponent: (0, $1687f24858a0bae5$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $6d5039419ed88ab9$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "puzzleContainer pathwordContainer pathword5x5Container",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $07351e99fd2afdf7$export$2e2bcd8739ae039), {
                        store: (0, $86b89eb84cf821a4$export$681392899cda0e6d),
                        onSolve: (0, $862bdcea3eeac9b6$export$4e3bdb6fc7af2ff8)
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $b9f68b54b1083b27$export$2e2bcd8739ae039), {
                        store: (0, $86b89eb84cf821a4$export$681392899cda0e6d)
                    })
                ]
            })
        ]
    });
};
var $ab7796b1469784b9$export$2e2bcd8739ae039 = $ab7796b1469784b9$var$Pathword5x5;


var $cca4f754f104150d$export$2e2bcd8739ae039 = (0, $ab7796b1469784b9$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");


var $2cHFZ = parcelRequire("2cHFZ");



const $b99a42ab34cc1773$export$34a8d0dbc7e71c9e = (rubigramData)=>{
    (0, $e27327853171b943$export$e2e5b62534c2c783).update((s)=>{
        s.puzzleId = rubigramData.puzzleId;
        // Numbered clockwise 0123
        s.subgrids[0].content = (0, $2cHFZ.cloneDeep)(rubigramData.scrambledGrid[0]);
        s.subgrids[1].content = (0, $2cHFZ.cloneDeep)(rubigramData.scrambledGrid[1]);
        s.subgrids[2].content = (0, $2cHFZ.cloneDeep)(rubigramData.scrambledGrid[2]);
        s.subgrids[3].content = (0, $2cHFZ.cloneDeep)(rubigramData.scrambledGrid[3]);
        s.subgrids[0].displayContent = (0, $2cHFZ.cloneDeep)(s.subgrids[0].content);
        s.subgrids[1].displayContent = (0, $2cHFZ.cloneDeep)(s.subgrids[1].content);
        s.subgrids[2].displayContent = (0, $2cHFZ.cloneDeep)(s.subgrids[2].content);
        s.subgrids[3].displayContent = (0, $2cHFZ.cloneDeep)(s.subgrids[3].content);
        s.subgrids[0].solvedContent = (0, $2cHFZ.cloneDeep)(rubigramData.solutionGrid[0]);
        s.subgrids[1].solvedContent = (0, $2cHFZ.cloneDeep)(rubigramData.solutionGrid[1]);
        s.subgrids[2].solvedContent = (0, $2cHFZ.cloneDeep)(rubigramData.solutionGrid[2]);
        s.subgrids[3].solvedContent = (0, $2cHFZ.cloneDeep)(rubigramData.solutionGrid[3]);
        // this is just for resetting for when user logs in or out
        s.subgrids.forEach((subgrid)=>{
            subgrid.flippedHorizontally = false;
            subgrid.flippedVertically = false;
            subgrid.degreesRotated = 0;
        });
        s.degreesRotated = 0;
    // printQuadrantGrid(s);
    });
};
const $b99a42ab34cc1773$export$4e3bdb6fc7af2ff8 = ()=>{
    const { time: time, puzzleId: puzzleId } = (0, $e27327853171b943$export$e2e5b62534c2c783).getRawState();
    setTimeout(()=>{
        (0, $e27327853171b943$export$e2e5b62534c2c783).update((s)=>{
            s.statsDialogIsOpen = true;
        });
    }, (0, $860afe5c90b07ab1$export$87a8383fc3f35723));
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Rubigram, {
        puzzleId: puzzleId,
        revealed: false,
        solved: true,
        time: time
    });
};
const $b99a42ab34cc1773$export$7cf2f68092532300 = ()=>{
    (0, $e27327853171b943$export$e2e5b62534c2c783).update((s)=>{
        s.revealed = true;
        s.isPaused = false;
        (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Rubigram, {
            puzzleId: s.puzzleId,
            revealed: true,
            solved: false,
            time: s.time
        });
    });
};
const $b99a42ab34cc1773$export$b69713a7fb295530 = ()=>{
    const { solved: solved, revealed: revealed, time: time, puzzleId: puzzleId } = (0, $e27327853171b943$export$e2e5b62534c2c783).getRawState();
    if (solved || revealed) return;
    // just updating progress on pause or navigate away
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Rubigram, {
        puzzleId: puzzleId,
        revealed: revealed,
        solved: solved,
        time: time
    });
};
const $b99a42ab34cc1773$var$areGridsIdentical = (subgrid)=>{
    for(let i = 0; i < subgrid.content.length; i++)for(let j = 0; j < subgrid.content[i].length; j++){
        if (subgrid.content[i][j] !== subgrid.solvedContent[i][j]) return false;
    }
    return true;
};
const $b99a42ab34cc1773$var$checkIsSolved = (grid)=>{
    let solved = true;
    for(let i = 0; i < grid.subgrids.length; i++){
        solved = $b99a42ab34cc1773$var$areGridsIdentical(grid.subgrids[i]);
        if (!solved) break;
    }
    if (solved) $b99a42ab34cc1773$export$4e3bdb6fc7af2ff8();
    return solved;
};
const $b99a42ab34cc1773$export$1b0bddff6a99251 = (subgridIdForCss, positionalSubgridIdForData, isAccountingForRotation)=>{
    const puzzleRotation = (0, $e27327853171b943$export$e2e5b62534c2c783).getRawState().degreesRotated;
    const puzzleIsRotated90Degrees = puzzleRotation % 180 !== 0;
    if (puzzleIsRotated90Degrees && !isAccountingForRotation) {
        $b99a42ab34cc1773$export$f4c48aae4f78d06f(subgridIdForCss, positionalSubgridIdForData, true);
        return;
    }
    (0, $e27327853171b943$export$e2e5b62534c2c783).update((s)=>{
        s.activeSubgrid = subgridIdForCss;
        const subgridForCss = s.subgrids[subgridIdForCss];
        const subgridForData = s.subgrids[positionalSubgridIdForData];
        subgridForCss.flippedHorizontally = !subgridForCss.flippedHorizontally;
        subgridForCss.isInFlippingAnimation = true;
        // disable this as soon as animation ends
        setTimeout(()=>{
            (0, $e27327853171b943$export$e2e5b62534c2c783).update((_s)=>{
                _s.subgrids[subgridIdForCss].isInFlippingAnimation = false;
            });
        }, 300);
        if (isAccountingForRotation) subgridForData.content = $b99a42ab34cc1773$var$flipSubgridDataVertically(subgridForData.content);
        else subgridForData.content = $b99a42ab34cc1773$var$flipSubgridDataHorizontally(subgridForData.content);
        s.solved = $b99a42ab34cc1773$var$checkIsSolved(s);
    // printQuadrantGrid(s);
    });
};
const $b99a42ab34cc1773$export$f4c48aae4f78d06f = (subgridIdForCss, positionalSubgridIdForData, isAccountingForRotation)=>{
    const puzzleRotation = (0, $e27327853171b943$export$e2e5b62534c2c783).getRawState().degreesRotated;
    const puzzleIsRotated90Degrees = puzzleRotation % 180 !== 0;
    if (puzzleIsRotated90Degrees && !isAccountingForRotation) {
        $b99a42ab34cc1773$export$1b0bddff6a99251(subgridIdForCss, positionalSubgridIdForData, true);
        return;
    }
    (0, $e27327853171b943$export$e2e5b62534c2c783).update((s)=>{
        s.activeSubgrid = subgridIdForCss;
        const subgridForCss = s.subgrids[subgridIdForCss];
        const subgridForData = s.subgrids[positionalSubgridIdForData];
        subgridForCss.flippedVertically = !subgridForCss.flippedVertically;
        subgridForCss.isInFlippingAnimation = true;
        // disable this as soon as animation ends
        setTimeout(()=>{
            (0, $e27327853171b943$export$e2e5b62534c2c783).update((_s)=>{
                _s.subgrids[subgridIdForCss].isInFlippingAnimation = false;
            });
        }, 300);
        if (isAccountingForRotation) subgridForData.content = $b99a42ab34cc1773$var$flipSubgridDataHorizontally(subgridForData.content);
        else subgridForData.content = $b99a42ab34cc1773$var$flipSubgridDataVertically(subgridForData.content);
        s.solved = $b99a42ab34cc1773$var$checkIsSolved(s);
    // printQuadrantGrid(s);
    });
};
const $b99a42ab34cc1773$export$a5b072a07155f62c = (subgridIdForCss, positionalSubgridIdForData, clockwise)=>{
    (0, $e27327853171b943$export$e2e5b62534c2c783).update((s)=>{
        s.activeSubgrid = subgridIdForCss;
        const subgridForCss = s.subgrids[subgridIdForCss];
        const subgridForData = s.subgrids[positionalSubgridIdForData];
        if (subgridForCss.flippedHorizontally !== subgridForCss.flippedVertically) subgridForCss.degreesRotated = subgridForCss.degreesRotated + (clockwise ? -90 : 90);
        else subgridForCss.degreesRotated = subgridForCss.degreesRotated + (clockwise ? 90 : -90);
        if (clockwise) subgridForData.content = $b99a42ab34cc1773$var$rotateSubgridDataClockwise(subgridForData.content);
        else subgridForData.content = $b99a42ab34cc1773$var$rotateSubgridDataCounterClockwise(subgridForData.content);
        s.solved = $b99a42ab34cc1773$var$checkIsSolved(s);
    // printQuadrantGrid(s);
    });
};
const $b99a42ab34cc1773$export$aefd6fe06446b9a0 = (clockwise)=>{
    (0, $e27327853171b943$export$e2e5b62534c2c783).update((s)=>{
        s.degreesRotated = s.degreesRotated + (clockwise ? 90 : -90);
        if (clockwise) $b99a42ab34cc1773$var$rotatePuzzleDataClockwise(s);
        else $b99a42ab34cc1773$var$rotatePuzzleDataCounterClockwise(s);
        s.solved = $b99a42ab34cc1773$var$checkIsSolved(s);
    // printQuadrantGrid(s);
    });
};
// These fns below do the actual updates to the grid and subgrid data and are used
// by the visual fns above.
// The visual fns make sure the right thing is updating VISUALLY to the user,
// whereas these functions below just make the more low-level simple changes to specified
// parts of the underlying data matrices. remember, the html content never actually changes.
// Example: user wants to horizontally flip the lower right subgrid, but due to transformations
// that actually means vertically flipping the upper left subgrid. so the visual fn figures out
// which subgrid it REALLY is, then one of these fns below would just flip the upper left subgrid.
const $b99a42ab34cc1773$var$flipSubgridDataHorizontally = (subgrid)=>{
    const flippedSubgrid = [];
    for (let row of subgrid)flippedSubgrid.push(row.slice().reverse());
    return flippedSubgrid;
};
const $b99a42ab34cc1773$var$flipSubgridDataVertically = (subgrid)=>{
    const flippedSubgrid = [];
    for(let i = subgrid.length - 1; i >= 0; i--)flippedSubgrid.push(subgrid[i].slice());
    return flippedSubgrid;
};
const $b99a42ab34cc1773$var$rotateSubgridDataClockwise = (subgrid)=>{
    const rotatedSubgrid = [];
    for(let i = 0; i < subgrid.length; i++){
        rotatedSubgrid.push([]);
        for(let j = 0; j < subgrid.length; j++)rotatedSubgrid[i].push(subgrid[subgrid.length - j - 1][i]);
    }
    return rotatedSubgrid;
};
const $b99a42ab34cc1773$var$rotateSubgridDataCounterClockwise = (subgrid)=>{
    const rotatedSubgrid = [];
    for(let i = 0; i < subgrid.length; i++){
        rotatedSubgrid.push([]);
        for(let j = 0; j < subgrid.length; j++)rotatedSubgrid[i].push(subgrid[j][subgrid.length - i - 1]);
    }
    return rotatedSubgrid;
};
const $b99a42ab34cc1773$var$rotatePuzzleDataClockwise = (grid)=>{
    // First rotate the content of the subgrids
    const rotatedTopLeft = $b99a42ab34cc1773$var$rotateSubgridDataClockwise(grid.subgrids[0].content);
    const rotatedTopRight = $b99a42ab34cc1773$var$rotateSubgridDataClockwise(grid.subgrids[1].content);
    const rotatedBottomRight = $b99a42ab34cc1773$var$rotateSubgridDataClockwise(grid.subgrids[2].content);
    const rotatedBottomLeft = $b99a42ab34cc1773$var$rotateSubgridDataClockwise(grid.subgrids[3].content);
    // Then rotate the position of the subgrids
    // Bottom left becomes top left. Top left becomes top right.
    // Top right becomes bottom right. Bottom right becomes bottom left.
    grid.subgrids[0].content = rotatedBottomLeft;
    grid.subgrids[1].content = rotatedTopLeft;
    grid.subgrids[2].content = rotatedTopRight;
    grid.subgrids[3].content = rotatedBottomRight;
};
const $b99a42ab34cc1773$var$rotatePuzzleDataCounterClockwise = (grid)=>{
    // First rotate the content of the subgrids
    const rotatedTopLeft = $b99a42ab34cc1773$var$rotateSubgridDataCounterClockwise(grid.subgrids[0].content);
    const rotatedTopRight = $b99a42ab34cc1773$var$rotateSubgridDataCounterClockwise(grid.subgrids[1].content);
    const rotatedBottomRight = $b99a42ab34cc1773$var$rotateSubgridDataCounterClockwise(grid.subgrids[2].content);
    const rotatedBottomLeft = $b99a42ab34cc1773$var$rotateSubgridDataCounterClockwise(grid.subgrids[3].content);
    // Then rotate the position of the subgrids
    grid.subgrids[0].content = rotatedTopRight;
    grid.subgrids[1].content = rotatedBottomRight;
    grid.subgrids[2].content = rotatedBottomLeft;
    grid.subgrids[3].content = rotatedTopLeft;
};
///////////
function $b99a42ab34cc1773$var$printQuadrantGrid(grid) {
    var subgrid, subgridIndex, row;
    // only enable this for debugging purposes.
    return;
    // Function to merge a subgrid into the parent grid at a specific position
    function mergeSubgrid(subgrid, rowOffset, colOffset) {
        for(let r = 0; r < subgrid.length; r++)for(let c = 0; c < subgrid[r].length; c++)parentGrid[rowOffset + r][colOffset + c] = subgrid[r][c];
    }
}



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");




const $e86b9bb1fa80b7df$var$ControlSubgrid = ({ subgridId: subgridId })=>{
    const solved = (0, $e27327853171b943$export$e2e5b62534c2c783).useState((s)=>s.solved);
    const revealed = (0, $e27327853171b943$export$e2e5b62534c2c783).useState((s)=>s.revealed);
    const subgrid = (0, $e27327853171b943$export$e2e5b62534c2c783).useState((s)=>s.subgrids[subgridId]);
    const activeSubgridId = (0, $e27327853171b943$export$e2e5b62534c2c783).useState((s)=>s.activeSubgrid);
    const isActive = subgridId === activeSubgridId;
    const subgridHFlipped = subgrid.flippedHorizontally;
    const subgridVFlipped = subgrid.flippedVertically;
    const degreesSubgridRotated = subgrid.degreesRotated;
    const degreesPuzzleRotated = (0, $e27327853171b943$export$e2e5b62534c2c783).useState((s)=>s.degreesRotated);
    const isSubgridAt90DegAngle = (degreesSubgridRotated + degreesPuzzleRotated) / 90 % 2 !== 0;
    const flipperStyles = {
        transform: `rotateY(${subgridHFlipped ? 180 : 0}deg)` + ` rotateX(${subgridVFlipped ? 180 : 0}deg)` + ` rotateZ(${degreesSubgridRotated}deg)`
    };
    let degreesToRotateLetters = -1 * (degreesSubgridRotated + degreesPuzzleRotated);
    let flipsToAdd = 0;
    const isGridAt90DegAngle = Math.abs(degreesPuzzleRotated) % 180 !== 0;
    if (isGridAt90DegAngle) {
        if (subgridVFlipped) flipsToAdd += 1;
        if (subgridHFlipped) flipsToAdd += 1;
    }
    degreesToRotateLetters += 180 * (flipsToAdd % 2);
    // This makes sure letters never rotate more than 180deg in any direction for a transform
    const prevDegree = (0, $28UcW.useRef)(degreesToRotateLetters);
    const equivalentDiff = (degreesToRotateLetters - prevDegree.current) % 360;
    if (equivalentDiff === 270) degreesToRotateLetters = prevDegree.current - 90;
    else if (equivalentDiff === -270) degreesToRotateLetters = prevDegree.current + 90;
    else if (equivalentDiff === 0) degreesToRotateLetters = prevDegree.current;
    else degreesToRotateLetters = prevDegree.current + equivalentDiff;
    prevDegree.current = degreesToRotateLetters;
    ///////// end that code ///////
    const letterStyles = {
        transform: `rotate(${degreesToRotateLetters}deg)` + ` rotate3d(1, 0, 0, ${subgridVFlipped ? 180 : 0}deg)` + ` rotate3d(0, 1, 0, ${subgridHFlipped ? 180 : 0}deg)`
    };
    ////////////////
    // This little piece of code is _essential_. It figures out what position
    // this subgrid is in relative to its parent grid. 0=top-left, 1=top-right,
    // 2=bottom-right, 3=bottom left. clockwise order.
    // We need this so the utils can update the right part of the char matrices
    // that are used to check if the puzzle is solved or not.
    // This variable doesn't include degreesSubgridRotated because that doesn't change where
    // the subgrid is, which is the point of this calculation.
    const timesSubgridPositionRotated = degreesPuzzleRotated / 90;
    // This is how far the subgrid has moved around the grid.
    // From upper left to lower right would be 2 or -2, for example.
    const numSubgridPositionShifts = timesSubgridPositionRotated % 4;
    // this line accounts for rotations of the 6x6 grid
    const positionalSubgridId = ((subgridId + numSubgridPositionShifts) % 4 + 4) % 4;
    ////////////////
    const onCellClick = (rowIndex, cellIndex)=>{
        if (solved || revealed) return;
        if (isSubgridAt90DegAngle) {
            if (rowIndex === 1 && [
                0,
                2
            ].includes(cellIndex)) (0, $b99a42ab34cc1773$export$f4c48aae4f78d06f)(subgridId, positionalSubgridId);
            else if ([
                0,
                2
            ].includes(rowIndex) && cellIndex === 1) (0, $b99a42ab34cc1773$export$1b0bddff6a99251)(subgridId, positionalSubgridId);
        } else {
            if (rowIndex === 1 && [
                0,
                2
            ].includes(cellIndex)) (0, $b99a42ab34cc1773$export$1b0bddff6a99251)(subgridId, positionalSubgridId);
            else if ([
                0,
                2
            ].includes(rowIndex) && cellIndex === 1) (0, $b99a42ab34cc1773$export$f4c48aae4f78d06f)(subgridId, positionalSubgridId);
        }
    };
    const isClickableCell = (rowIndex, cellIndex)=>{
        return rowIndex === 1 && [
            0,
            2
        ].includes(cellIndex) || [
            0,
            2
        ].includes(rowIndex) && cellIndex === 1;
    };
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: `controlSubgrid subgrid${subgridId} ${isActive ? 'activeSubgrid' : ''}`,
        children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
            className: "controlSubgridFlipper",
            style: flipperStyles,
            children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: `controlSubgridContents ${subgrid.isInFlippingAnimation ? 'isFlipping' : ''}`,
                children: subgrid.displayContent.map((row, rowIndex)=>/*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "gridRow",
                        children: row.map((cell, cellIndex)=>/*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: `gridCellContainer ${isClickableCell(rowIndex, cellIndex) ? 'clickableCell' : ''}`,
                                onClick: ()=>onCellClick(rowIndex, cellIndex),
                                children: rowIndex === 1 && cellIndex === 1 ? /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                    className: "gridCell",
                                    style: letterStyles,
                                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                                        disableRipple: true,
                                        className: "rotateSubgridClockwiseButton center",
                                        title: "Rotate Clockwise",
                                        onClick: ()=>{
                                            if (solved || revealed) return;
                                            (0, $b99a42ab34cc1773$export$a5b072a07155f62c)(subgridId, positionalSubgridId, true);
                                        },
                                        onContextMenu: (e)=>{
                                            e.preventDefault();
                                            if (solved || revealed) return;
                                            (0, $b99a42ab34cc1773$export$a5b072a07155f62c)(subgridId, positionalSubgridId, false);
                                        },
                                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($27f101808c5d1eaa$exports))), {})
                                    })
                                }) : /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                    className: "gridCell",
                                    style: letterStyles,
                                    onContextMenu: (e)=>{
                                        e.preventDefault();
                                    },
                                    children: cell
                                })
                            }, cellIndex))
                    }, rowIndex))
            })
        })
    });
};
var $e86b9bb1fa80b7df$export$2e2bcd8739ae039 = $e86b9bb1fa80b7df$var$ControlSubgrid;





var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

const $12508ee6e726c2f8$var$SolvedSubgrid = ({ subgridId: subgridId })=>{
    const subgrid = (0, $e27327853171b943$export$e2e5b62534c2c783).useState((s)=>s.subgrids[subgridId]);
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: `controlSubgrid subgrid${subgridId}`,
        children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
            className: "controlSubgridFlipper",
            children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "controlSubgridContents",
                children: subgrid.solvedContent.map((row, rowIndex)=>/*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "gridRow",
                        children: row.map((cell, cellIndex)=>/*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "gridCellContainer",
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                    className: "gridCell",
                                    children: cell
                                })
                            }, cellIndex))
                    }, rowIndex))
            })
        })
    });
};
var $12508ee6e726c2f8$export$2e2bcd8739ae039 = $12508ee6e726c2f8$var$SolvedSubgrid;


const $645f22aaa9fa2583$var$SolvedGrid = ()=>{
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "controlGrid grid",
        children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
            className: "controlGridFlipper",
            children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "controlGridContents solvedGrid",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $12508ee6e726c2f8$export$2e2bcd8739ae039), {
                        subgridId: 0
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $12508ee6e726c2f8$export$2e2bcd8739ae039), {
                        subgridId: 1
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $12508ee6e726c2f8$export$2e2bcd8739ae039), {
                        subgridId: 3
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $12508ee6e726c2f8$export$2e2bcd8739ae039), {
                        subgridId: 2
                    })
                ]
            })
        })
    });
};
var $645f22aaa9fa2583$export$2e2bcd8739ae039 = $645f22aaa9fa2583$var$SolvedGrid;



const $a2efa9c535491a7a$var$ControlGrid = ()=>{
    const { degreesRotated: degreesPuzzleRotated, solved: solved, revealed: revealed } = (0, $e27327853171b943$export$e2e5b62534c2c783).useState();
    const wasSolvedOnLoad = (0, $ba1e3b359abf28ef$export$db3b65d3d3d119f7)(solved);
    const puzzleIsRotated90Deg = degreesPuzzleRotated % 180 !== 0;
    const flipperStyles = {
        transform: `rotateZ(${degreesPuzzleRotated}deg)` + (solved ? puzzleIsRotated90Deg ? ` rotateX(720deg)` : ` rotateY(720deg)` : ''),
        transitionDelay: solved ? '0.4s' : undefined,
        transitionDuration: solved ? '1.0s' : undefined
    };
    const degreesToRotateCenterButton = -1 * (degreesPuzzleRotated + 50);
    const centerButtonStyles = {
        transform: `rotate(${degreesToRotateCenterButton}deg) scaleX(-1)`
    };
    if (revealed || wasSolvedOnLoad) return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $645f22aaa9fa2583$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "controlGrid grid",
        onContextMenu: (e)=>{
            e.preventDefault();
        },
        children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
            className: "controlGridFlipper",
            style: flipperStyles,
            children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "controlGridContents",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $e86b9bb1fa80b7df$export$2e2bcd8739ae039), {
                        subgridId: 0
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $e86b9bb1fa80b7df$export$2e2bcd8739ae039), {
                        subgridId: 1
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $e86b9bb1fa80b7df$export$2e2bcd8739ae039), {
                        subgridId: 3
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $e86b9bb1fa80b7df$export$2e2bcd8739ae039), {
                        subgridId: 2
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f714e0f624d6f306$export$2e2bcd8739ae039), {
                        disableRipple: true,
                        className: "rotateGridClockwiseButton",
                        title: "Rotate Clockwise/Counterclockwise",
                        onClick: ()=>{
                            if (solved || revealed) return;
                            (0, $b99a42ab34cc1773$export$aefd6fe06446b9a0)(true);
                        },
                        onContextMenu: (e)=>{
                            e.preventDefault();
                            if (solved || revealed) return;
                            (0, $b99a42ab34cc1773$export$aefd6fe06446b9a0)(false);
                        },
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($27f101808c5d1eaa$exports))), {
                            style: centerButtonStyles
                        })
                    })
                ]
            })
        })
    });
};
var $a2efa9c535491a7a$export$2e2bcd8739ae039 = $a2efa9c535491a7a$var$ControlGrid;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");


var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");






var $ca47cc5b48de732b$exports = {};
$ca47cc5b48de732b$exports = import.meta.resolve("7edvD");


var $b6501618ed44c427$exports = {};
$b6501618ed44c427$exports = import.meta.resolve("4MCBr");


const $b87cc6bc948f2d57$var$closeInstructions = ()=>{
    (0, $e27327853171b943$export$e2e5b62534c2c783).update((s)=>{
        s.instructionsAreOpen = false;
        s.isSoftPaused = false;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).set(`${(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Rubigram}InstructionsDismissed`, 'true', {
        domain: (0, $ba1e3b359abf28ef$export$517466abcb8fcf10),
        expires: 365
    });
};
const $b87cc6bc948f2d57$var$Instructions = ()=>{
    const isOpen = (0, $e27327853171b943$export$e2e5b62534c2c783).useState((s)=>s.instructionsAreOpen);
    const isTouch = (0, $b2cd9ecc66d0956f$exports.isMobile) || (0, $b2cd9ecc66d0956f$exports.isTablet);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $a923e83bee9905be$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: $b87cc6bc948f2d57$var$closeInstructions,
        className: "twoColumnInstructions",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("h1", {
                className: "instructionsTitle",
                children: "How to Play the Rubigram"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "instructionsBody twoColumnInstructionsBody",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "writtenInstructions",
                        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                    children: "Rotate and flip until every full row and column spells a 6-letter word from left-to-right and top-to-bottom."
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                                    children: [
                                        "Flip the 3x3 subgrids by ",
                                        isTouch ? 'tapping' : 'clicking',
                                        " their non-corner cells."
                                    ]
                                }),
                                !isTouch && /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                    children: "Right-click the rotate buttons to rotate counterclockwise."
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                    children: "No very obscure words or proper names."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "videoInstructions",
                        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("video", {
                            controls: true,
                            autoPlay: true,
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)("source", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b6501618ed44c427$exports))),
                                    type: "video/webm"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)("source", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ca47cc5b48de732b$exports))),
                                    type: "video/mp4"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                                    children: "Your browser does not support HTML5 video elements."
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $b87cc6bc948f2d57$export$2e2bcd8739ae039 = $b87cc6bc948f2d57$var$Instructions;








var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");








const $f8fad377d72147a1$var$MobileRubigramInstructions = ()=>{
    const isOpen = (0, $e27327853171b943$export$e2e5b62534c2c783).useState((s)=>s.instructionsAreOpen);
    const isTouch = (0, $b2cd9ecc66d0956f$exports.isMobile) || (0, $b2cd9ecc66d0956f$exports.isTablet);
    const onClose = ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).set(`${(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Rubigram}InstructionsDismissed`, 'true', {
            domain: (0, $ba1e3b359abf28ef$export$517466abcb8fcf10),
            expires: 365
        });
        (0, $e27327853171b943$export$e2e5b62534c2c783).update((s)=>{
            s.instructionsAreOpen = false;
            s.isSoftPaused = false;
        });
    };
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $f13252b13d1e29c0$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: onClose,
        title: "How to Play the Rubigram",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                        children: "Rotate and flip until every full row and column spells a 6-letter word from left-to-right and top-to-bottom."
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                        children: [
                            "Flip the 3x3 subgrids by ",
                            isTouch ? 'tapping' : 'clicking',
                            " their non-corner cells."
                        ]
                    }),
                    !isTouch && /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                        children: "Right-click the rotate buttons to rotate counterclockwise."
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                        children: "No very obscure words or proper names."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("video", {
                controls: true,
                autoPlay: true,
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("source", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b6501618ed44c427$exports))),
                        type: "video/webm"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("source", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ca47cc5b48de732b$exports))),
                        type: "video/mp4"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                        children: "Your browser does not support HTML5 video elements."
                    })
                ]
            })
        ]
    });
};
var $f8fad377d72147a1$export$2e2bcd8739ae039 = $f8fad377d72147a1$var$MobileRubigramInstructions;


const $9e156e498e1e9c3e$var$RubigramTopBar = ()=>{
    const useMobileStyles = (0, $b2cd9ecc66d0956f$exports.isMobile) || (0, $ba1e3b359abf28ef$export$580e0f6db19fa7cc)();
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d549bcf7ed920b37$export$2e2bcd8739ae039), {
        puzzleName: (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Rubigram,
        store: (0, $e27327853171b943$export$e2e5b62534c2c783),
        onReveal: (0, $b99a42ab34cc1773$export$7cf2f68092532300),
        onSave: (0, $b99a42ab34cc1773$export$b69713a7fb295530),
        InstructionsComponent: useMobileStyles ? (0, $f8fad377d72147a1$export$2e2bcd8739ae039) : (0, $b87cc6bc948f2d57$export$2e2bcd8739ae039)
    });
};
var $9e156e498e1e9c3e$export$2e2bcd8739ae039 = $9e156e498e1e9c3e$var$RubigramTopBar;









const $724cfcd9e6ba28d6$var$Rubigram = ()=>{
    const { revealed: revealed, solved: solved } = (0, $e27327853171b943$export$e2e5b62534c2c783).useState();
    (0, $ba1e3b359abf28ef$export$e73a86b2063a8f6b)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Rubigram, (0, $e27327853171b943$export$e2e5b62534c2c783));
    (0, $ba1e3b359abf28ef$export$20d77ccceac0f55c)((0, $e27327853171b943$export$e2e5b62534c2c783), (0, $b99a42ab34cc1773$export$b69713a7fb295530));
    (0, $ba1e3b359abf28ef$export$5b0326dddadcb0de)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Rubigram);
    (0, $ba1e3b359abf28ef$export$52dc0a972e5b91c5)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Rubigram);
    (0, $80f684051860af43$export$2500c8a6bc3f2f43)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Rubigram);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $9e156e498e1e9c3e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: `puzzleContainer rubigramContainer ${solved ? 'solved' : ''}`,
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $a2efa9c535491a7a$export$2e2bcd8739ae039), {}),
                    revealed && /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "outcomeBanner",
                        children: "Solution revealed. Try again tomorrow!"
                    }),
                    solved && /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "outcomeBanner",
                        children: "Solved! New puzzle tomorrow."
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $b9f68b54b1083b27$export$2e2bcd8739ae039), {
                        store: (0, $e27327853171b943$export$e2e5b62534c2c783)
                    })
                ]
            })
        ]
    });
};
var $724cfcd9e6ba28d6$export$2e2bcd8739ae039 = $724cfcd9e6ba28d6$var$Rubigram;


var $b6c4a115071a81e7$export$2e2bcd8739ae039 = (0, $724cfcd9e6ba28d6$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");


const $b7130a9d5864223c$var$ClueFragments = ()=>{
    const { fragments: fragments, fragmentsWith1PositionRevealed: partiallyRevealed, fullWords: fullWords, solved: solved, revealed: revealed, usedPositionLifeline: usedPositionLifeline } = (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).useState();
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "clueFragmentsContainer",
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
            className: `flipper ${solved || revealed ? 'flipped' : ''}`,
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                    className: "front",
                    children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: `flipper ${usedPositionLifeline ? 'flipped' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: "front innerFront",
                                children: [
                                    fragments[0],
                                    " ",
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                        className: "largeSlash",
                                        children: "/"
                                    }),
                                    " ",
                                    fragments[1],
                                    " ",
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                        className: "largeSlash",
                                        children: "/"
                                    }),
                                    " ",
                                    fragments[2]
                                ]
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: "back innerBack",
                                children: [
                                    partiallyRevealed[0],
                                    " ",
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                        className: "largeSlash",
                                        children: "/"
                                    }),
                                    " ",
                                    partiallyRevealed[1],
                                    " ",
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                        className: "largeSlash",
                                        children: "/"
                                    }),
                                    " ",
                                    partiallyRevealed[2]
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                    className: "back",
                    children: [
                        fullWords[0],
                        " / ",
                        fullWords[1],
                        " / ",
                        fullWords[2]
                    ]
                })
            ]
        })
    });
};
var $b7130a9d5864223c$export$2e2bcd8739ae039 = $b7130a9d5864223c$var$ClueFragments;


var $13da5c1ac3510740$export$2e2bcd8739ae039 = (0, $b7130a9d5864223c$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");
var $b16b9ae728f336fc$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($b16b9ae728f336fc$exports, "__esModule", {
    value: true
});
$b16b9ae728f336fc$exports.default = void 0;

var $b16b9ae728f336fc$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $b16b9ae728f336fc$var$_default = $b16b9ae728f336fc$exports.default = (0, $b16b9ae728f336fc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1z"
}), 'Lock');




const $32c1405891ccfbcf$var$InputSquare = ({ position: position })=>{
    const { guess: guess, revealed: revealed, solved: solved, solution: solution, wrongGuess: wrongGuess, usedLetterLifeline: usedLetterLifeline } = (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).useState();
    const guessLetter = guess[position];
    const previousGuessLetter = (0, $ba1e3b359abf28ef$export$5cae361ad82dce8b)(guessLetter);
    const hasNewLetter = !!guessLetter && !previousGuessLetter;
    const showNewLetterAnimation = (0, $ba1e3b359abf28ef$export$70282ff0fcac9292)(hasNewLetter, 100);
    const classes = `inputSquare` + `${showNewLetterAnimation ? ' newLetter' : ''}` + `${solved ? ' solved' : ''}` + `${wrongGuess ? ' wrongGuess' : ''}`;
    const showLock = !solved && !revealed && usedLetterLifeline && position === solution.length - 1;
    const showSolutionLetter = revealed || solved || usedLetterLifeline && position === solution.length - 1;
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: classes,
        children: [
            showSolutionLetter ? solution[position] : guessLetter || '',
            showLock && /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "revealedLetterLock",
                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b16b9ae728f336fc$exports))), {})
            })
        ]
    });
};
var $32c1405891ccfbcf$export$2e2bcd8739ae039 = $32c1405891ccfbcf$var$InputSquare;



const $5659a5c73a170148$var$SolutionInput = ()=>{
    const { numInputs: numInputs } = (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).useState();
    const inputSquares = Array.from({
        length: numInputs
    }, (_, i)=>/*#__PURE__*/ (0, $4XrX4.jsx)((0, $32c1405891ccfbcf$export$2e2bcd8739ae039), {
            position: i
        }, i));
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $4XrX4.Fragment), {
        children: inputSquares
    });
};
var $5659a5c73a170148$export$2e2bcd8739ae039 = $5659a5c73a170148$var$SolutionInput;


var $f173698067624888$export$2e2bcd8739ae039 = (0, $5659a5c73a170148$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");





const $aa9ffcfe4a885204$var$Key = ({ value: value })=>{
    const { lettersFor5050: lettersFor5050, used5050Lifeline: used5050Lifeline } = (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).useState();
    const hapticFeedbackEnabled = (0, $e2662af8a2ab1f76$export$986181c251d527c3).useState((s)=>s.userData?.settings.hapticFeedbackEnabled) ?? true;
    const handleClick = (event)=>{
        if (hapticFeedbackEnabled) try {
            navigator.vibrate(20);
        } catch (error) {
        // do nothing, just don't vibrate
        }
        (0, $89509cfb9f60b696$export$412508d679148d5c)(value);
        event.currentTarget.blur();
    };
    const isWideKey = value === (0, $ba1e3b359abf28ef$export$cd903283095ece83).Enter || value === (0, $ba1e3b359abf28ef$export$cd903283095ece83).Delete;
    const getSymbol = (value)=>{
        if (value === (0, $ba1e3b359abf28ef$export$cd903283095ece83).Delete) return /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d872a2807693457d$exports))), {});
        else return value;
    };
    const isDisabled = used5050Lifeline && lettersFor5050.includes(value.toLowerCase());
    return /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
        disabled: isDisabled,
        className: `${isWideKey ? 'wideKey' : ''} ${isDisabled ? 'faded' : ''} keyboardKey`,
        onClick: handleClick,
        children: getSymbol(value)
    });
};
var $aa9ffcfe4a885204$export$2e2bcd8739ae039 = $aa9ffcfe4a885204$var$Key;



const $d7e4ff163eaf2ea6$var$Keyboard = ()=>{
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "keyboardContainer",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "keyRow",
                children: [
                    'Q',
                    'W',
                    'E',
                    'R',
                    'T',
                    'Y',
                    'U',
                    'I',
                    'O',
                    'P'
                ].map((key)=>/*#__PURE__*/ (0, $4XrX4.jsx)((0, $aa9ffcfe4a885204$export$2e2bcd8739ae039), {
                        value: key
                    }, key))
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "keyRow",
                children: [
                    'A',
                    'S',
                    'D',
                    'F',
                    'G',
                    'H',
                    'J',
                    'K',
                    'L'
                ].map((key)=>/*#__PURE__*/ (0, $4XrX4.jsx)((0, $aa9ffcfe4a885204$export$2e2bcd8739ae039), {
                        value: key
                    }, key))
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "keyRow",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $aa9ffcfe4a885204$export$2e2bcd8739ae039), {
                        value: (0, $ba1e3b359abf28ef$export$cd903283095ece83).Enter
                    }),
                    [
                        'Z',
                        'X',
                        'C',
                        'V',
                        'B',
                        'N',
                        'M'
                    ].map((key)=>/*#__PURE__*/ (0, $4XrX4.jsx)((0, $aa9ffcfe4a885204$export$2e2bcd8739ae039), {
                            value: key
                        }, key)),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $aa9ffcfe4a885204$export$2e2bcd8739ae039), {
                        value: (0, $ba1e3b359abf28ef$export$cd903283095ece83).Delete
                    })
                ]
            })
        ]
    });
};
var $d7e4ff163eaf2ea6$export$2e2bcd8739ae039 = $d7e4ff163eaf2ea6$var$Keyboard;


var $d86cc2fe4e78a600$export$2e2bcd8739ae039 = (0, $d7e4ff163eaf2ea6$export$2e2bcd8739ae039);







var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");





const $9f2fe431509acae4$var$closeInstructions = ()=>{
    (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).update((s)=>{
        s.instructionsAreOpen = false;
        s.isSoftPaused = false;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).set(`${(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Triword}InstructionsDismissed`, 'true', {
        domain: (0, $ba1e3b359abf28ef$export$517466abcb8fcf10),
        expires: 365
    });
};
const $9f2fe431509acae4$var$Instructions = ()=>{
    const isOpen = (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).useState((s)=>s.instructionsAreOpen);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $a923e83bee9905be$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: $9f2fe431509acae4$var$closeInstructions,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("h1", {
                className: "instructionsTitle",
                children: "How to Play Triword"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "instructionsBody triwordInstructions",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                        children: "Given 3 clue fragments, find a fourth fragment that completes all 3 clues to form full words."
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("h2", {
                        children: "Example:"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                        children: [
                            "TUN / GON / IN + DRA ",
                            /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                            "= TUN",
                            /*#__PURE__*/ (0, $4XrX4.jsx)("em", {
                                children: "DRA"
                            }),
                            " / ",
                            /*#__PURE__*/ (0, $4XrX4.jsx)("em", {
                                children: "DRA"
                            }),
                            "GON / ",
                            /*#__PURE__*/ (0, $4XrX4.jsx)("em", {
                                children: "DRA"
                            }),
                            "IN"
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                        children: "\u2022 Any of the 3 clue fragments may be starting or ending fragments. Their order is random."
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                        children: "\u2022 If you feel stuck, use any of the 3 lifelines available in the top right corner."
                    })
                ]
            })
        ]
    });
};
var $9f2fe431509acae4$export$2e2bcd8739ae039 = $9f2fe431509acae4$var$Instructions;







const $b5ad7c69dca0a2d4$var$Triword = ()=>{
    const { solved: solved, revealed: revealed } = (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).useState();
    const pageHeight = (0, $ba1e3b359abf28ef$export$e27d6512d262aec)();
    const containerHeight = (0, $b2cd9ecc66d0956f$exports.isMobile) ? pageHeight : undefined;
    (0, $ba1e3b359abf28ef$export$20d77ccceac0f55c)((0, $1c52cfe25bc28425$export$cbdad2c51fe016e8), (0, $89509cfb9f60b696$export$e409bdf423f1f13c));
    (0, $ba1e3b359abf28ef$export$e73a86b2063a8f6b)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Triword, (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8));
    (0, $ba1e3b359abf28ef$export$a546a4e9e5b2cdef)((0, $89509cfb9f60b696$export$412508d679148d5c), solved, revealed);
    (0, $ba1e3b359abf28ef$export$5b0326dddadcb0de)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Triword);
    (0, $ba1e3b359abf28ef$export$52dc0a972e5b91c5)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Triword);
    (0, $80f684051860af43$export$2500c8a6bc3f2f43)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Triword);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d549bcf7ed920b37$export$2e2bcd8739ae039), {
                puzzleName: (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Triword,
                store: (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8),
                onReveal: (0, $89509cfb9f60b696$export$7cf2f68092532300),
                onSave: (0, $89509cfb9f60b696$export$e409bdf423f1f13c),
                InstructionsComponent: (0, $9f2fe431509acae4$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: `puzzleContainer triwordContainer ${(0, $b2cd9ecc66d0956f$exports.isMobile) ? 'mobile' : ''}`,
                style: {
                    height: containerHeight
                },
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $13da5c1ac3510740$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "solutionInputContainer",
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f173698067624888$export$2e2bcd8739ae039), {})
                    }),
                    revealed && /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "outcomeBanner",
                        children: "Solution revealed. Try again tomorrow!"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d86cc2fe4e78a600$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $b9f68b54b1083b27$export$2e2bcd8739ae039), {
                        store: (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8)
                    })
                ]
            })
        ]
    });
};
var $b5ad7c69dca0a2d4$export$2e2bcd8739ae039 = $b5ad7c69dca0a2d4$var$Triword;


var $a163f0752441889e$export$2e2bcd8739ae039 = (0, $b5ad7c69dca0a2d4$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");







var $656c0098466b2416$export$9f97c9ab3f6c7b54 = /*#__PURE__*/ function(ShapeEnum) {
    ShapeEnum["Circle"] = "circle";
    ShapeEnum["Square"] = "square";
    ShapeEnum["Triangle"] = "triangle";
    ShapeEnum["Diamond"] = "diamond";
    ShapeEnum["Heart"] = "heart";
    ShapeEnum["Pentagon"] = "pentagon";
    ShapeEnum["Trapezoid"] = "trapezoid";
    ShapeEnum["Star"] = "star";
    return ShapeEnum;
}({});
const $656c0098466b2416$export$8214603e3981bac6 = (color)=>{
    switch(color.toLowerCase()){
        case 'red':
            return "circle";
        case 'blue':
            return "square";
        case 'green':
            return "triangle";
        case 'yellow':
            return "diamond";
        case 'pink':
            return "heart";
        case 'orange':
            return "pentagon";
        case 'purple':
            return "trapezoid";
        case 'cyan':
            return "star";
        default:
            throw new Error(`Unknown color: ${color}`);
    }
};
const $656c0098466b2416$export$8edde018c2520e49 = (puzzleData)=>{
    // Map solution indices to statement colors from the initial statements
    const solutionColors = puzzleData.solution.map((index)=>puzzleData.statements[index].color);
    (0, $abbcacd8f9b8e7dd$export$5aa98d4d531c155f).update((s)=>{
        s.puzzleId = puzzleData.puzzleId;
        s.slots = puzzleData.slots;
        s.statements = puzzleData.statements;
        s.solution = puzzleData.solution;
        s.solutionColors = solutionColors;
    });
};
const $656c0098466b2416$export$7cf2f68092532300 = ()=>{
    (0, $abbcacd8f9b8e7dd$export$5aa98d4d531c155f).update((s)=>{
        clearInterval(s.timerUpdatingFn);
        s.revealed = true;
        s.isPaused = false;
        (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Truthsorting, {
            puzzleId: s.puzzleId,
            revealed: true,
            solved: false,
            time: s.time
        });
    });
    setTimeout(()=>{
        (0, $abbcacd8f9b8e7dd$export$5aa98d4d531c155f).update((s)=>{
            s.statsDialogIsOpen = true;
        });
    }, (0, $860afe5c90b07ab1$export$87a8383fc3f35723));
};
const $656c0098466b2416$export$4e3bdb6fc7af2ff8 = ()=>{
    const { time: time, puzzleId: puzzleId } = (0, $abbcacd8f9b8e7dd$export$5aa98d4d531c155f).getRawState();
    (0, $abbcacd8f9b8e7dd$export$5aa98d4d531c155f).update((s)=>{
        clearInterval(s.timerUpdatingFn);
        s.solved = true;
        s.isPaused = false;
    });
    setTimeout(()=>{
        (0, $abbcacd8f9b8e7dd$export$5aa98d4d531c155f).update((s)=>{
            s.statsDialogIsOpen = true;
        });
    }, (0, $860afe5c90b07ab1$export$87a8383fc3f35723));
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Truthsorting, {
        puzzleId: puzzleId,
        revealed: false,
        solved: true,
        time: time
    });
};
const $656c0098466b2416$export$b9e7221e14f84ef0 = ()=>{
    const { solved: solved, revealed: revealed, time: time, puzzleId: puzzleId } = (0, $abbcacd8f9b8e7dd$export$5aa98d4d531c155f).getRawState();
    if (solved || revealed) return;
    // just updating progress on pause or navigate away
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Truthsorting, {
        puzzleId: puzzleId,
        revealed: revealed,
        solved: solved,
        time: time
    });
};
const $656c0098466b2416$export$6fca47e2663e9ff4 = (slots, statements)=>{
    return statements.map((statement, slotIdx)=>{
        const shouldBeTrue = slots[slotIdx]; // white slot = true, black slot = false
        const isTrue = $656c0098466b2416$var$evaluateStatement(statement, statements, slotIdx, slots);
        // Valid if the statement's truth value matches what the slot requires
        return isTrue === shouldBeTrue;
    });
};
const $656c0098466b2416$var$evaluateStatement = (statement, allStatements, myPos, slots)=>{
    const req = statement.requirement;
    const p = req.params;
    // Helper to find position of a color in the current arrangement
    const findColorPos = (color)=>{
        return allStatements.findIndex((s)=>s.color === color);
    };
    switch(req.type){
        case 'NthStatement':
            return myPos === p.position;
        case 'NegatedNthStatement':
            return myPos !== p.position;
        case 'FollowedByVeracity':
            if (myPos >= allStatements.length - 1) return false;
            // Check if the slot after matches the required veracity
            return slots[myPos + 1] === p.veracity;
        case 'PrecededByVeracity':
            if (myPos <= 0) return false;
            // Check if the slot before matches the required veracity
            return slots[myPos - 1] === p.veracity;
        case 'FollowedByColor':
            {
                const targetPos = findColorPos(p.color);
                return targetPos === myPos + 1;
            }
        case 'NegatedFollowedByColor':
            {
                const targetPos = findColorPos(p.color);
                return targetPos !== myPos + 1;
            }
        case 'PrecededByColor':
            {
                const targetPos = findColorPos(p.color);
                return targetPos === myPos - 1;
            }
        case 'NegatedPrecededByColor':
            {
                const targetPos = findColorPos(p.color);
                return targetPos !== myPos - 1;
            }
        case 'ColorVeracityAssertion':
            {
                const targetPos = findColorPos(p.color);
                const targetSlotIsTrue = slots[targetPos];
                return targetSlotIsTrue === p.veracity;
            }
        case 'PositionalParity':
            {
                // User sees position 1,2,3... we see 0,1,2...
                const userPosition = myPos + 1;
                const isUserEven = userPosition % 2 === 0;
                return isUserEven === p.isEven;
            }
        case 'SurroundedBy':
            if (myPos <= 0 || myPos >= allStatements.length - 1) return false;
            // Check if BOTH adjacent slots match the required veracity
            const leftSlotIsTrue = slots[myPos - 1];
            const rightSlotIsTrue = slots[myPos + 1];
            return leftSlotIsTrue === p.veracity && rightSlotIsTrue === p.veracity;
        case 'NegatedSurroundedBy':
            if (myPos <= 0 || myPos >= allStatements.length - 1) return true;
            // Check if NOT both adjacent slots match the required veracity
            const leftTrue = slots[myPos - 1];
            const rightTrue = slots[myPos + 1];
            return !(leftTrue === p.veracity && rightTrue === p.veracity);
        case 'ColorPosition':
            {
                const targetPos = findColorPos(p.color);
                return targetPos === p.position;
            }
        case 'NegatedColorPosition':
            {
                const targetPos = findColorPos(p.color);
                return targetPos !== p.position;
            }
        case 'DistanceFromColor':
            {
                const targetPos = findColorPos(p.color);
                return Math.abs(targetPos - myPos) - 1 === p.gap;
            }
        case 'ColorOrder':
            {
                const pos1 = findColorPos(p.colorOne);
                const pos2 = findColorPos(p.colorTwo);
                return pos1 < pos2;
            }
        case 'BetweenColors':
            {
                const pos1 = findColorPos(p.colorOne);
                const pos2 = findColorPos(p.colorTwo);
                const minPos = Math.min(pos1, pos2);
                const maxPos = Math.max(pos1, pos2);
                // "Directly between" means the two colors are exactly 2 positions apart
                // and this statement is in the middle position
                return maxPos - minPos === 2 && myPos === minPos + 1;
            }
        case 'BothVeracityAssertion':
            {
                const firstPos = findColorPos(p.firstStatement);
                const secondPos = findColorPos(p.secondStatement);
                const firstSlotIsTrue = slots[firstPos];
                const secondSlotIsTrue = slots[secondPos];
                return firstSlotIsTrue === p.veracity && secondSlotIsTrue === p.veracity;
            }
        case 'XORVeracityAssertion':
            {
                const firstPos = findColorPos(p.firstStatement);
                const secondPos = findColorPos(p.secondStatement);
                const firstSlotIsTrue = slots[firstPos];
                const secondSlotIsTrue = slots[secondPos];
                const firstMatches = firstSlotIsTrue === p.veracity;
                const secondMatches = secondSlotIsTrue === p.veracity;
                // XOR: exactly one must match, not both and not neither
                return firstMatches !== secondMatches;
            }
        case 'SelfIsCloserToColor':
            {
                const pos1 = findColorPos(p.colorOne);
                const pos2 = findColorPos(p.colorTwo);
                const dist1 = Math.abs(myPos - pos1);
                const dist2 = Math.abs(myPos - pos2);
                return dist1 < dist2;
            }
        case 'SelfIsFirstOrLast':
            return myPos === 0 || myPos === allStatements.length - 1;
        case 'NegatedSelfIsFirstOrLast':
            return myPos !== 0 && myPos !== allStatements.length - 1;
        case 'ColorIsFirstOrLast':
            {
                const targetPos = findColorPos(p.colorOne);
                return targetPos === 0 || targetPos === allStatements.length - 1;
            }
        case 'NegatedColorIsFirstOrLast':
            {
                const targetPos = findColorPos(p.colorOne);
                return targetPos !== 0 && targetPos !== allStatements.length - 1;
            }
        case 'SelfAdjacency':
            {
                const targetPos = findColorPos(p.colorOne);
                return Math.abs(targetPos - myPos) === 1;
            }
        case 'NegatedSelfAdjacency':
            {
                const targetPos = findColorPos(p.colorOne);
                return Math.abs(targetPos - myPos) !== 1;
            }
        case 'ColorAdjacency':
            {
                const pos1 = findColorPos(p.colorOne);
                const pos2 = findColorPos(p.colorTwo);
                return Math.abs(pos1 - pos2) === 1;
            }
        case 'XNORVeracityAssertion':
            {
                const pos1 = findColorPos(p.colorOne);
                const pos2 = findColorPos(p.colorTwo);
                const slot1IsTrue = slots[pos1];
                const slot2IsTrue = slots[pos2];
                // XNOR: both are the same (both true or both false)
                return slot1IsTrue === slot2IsTrue;
            }
        default:
            throw new Error(`Unknown requirement type: ${req.type}`);
    }
};




var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");





const $1d53248cd57b50d8$var$closeInstructions = ()=>{
    (0, $abbcacd8f9b8e7dd$export$5aa98d4d531c155f).update((s)=>{
        s.instructionsAreOpen = false;
        s.isSoftPaused = false;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).set(`${(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Truthsorting}InstructionsDismissed`, 'true', {
        domain: (0, $ba1e3b359abf28ef$export$517466abcb8fcf10),
        expires: 365
    });
};
const $1d53248cd57b50d8$var$Instructions = ()=>{
    const isOpen = (0, $abbcacd8f9b8e7dd$export$5aa98d4d531c155f).useState((s)=>s.instructionsAreOpen);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $a923e83bee9905be$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: $1d53248cd57b50d8$var$closeInstructions,
        className: "twoColumnInstructions",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("h1", {
                className: "instructionsTitle",
                children: "How to Play Truthsorting"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "instructionsBody",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                        children: "Truth slots are white. Lie slots are black."
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                        children: "Drag to reorder the statements so that truth slots contain truths and lie slots contain lies."
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                        children: "Whether statements are truths or lies depends entirely on the order they're in."
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                        children: [
                            "A checkmark is shown on any statement whose current truthfulness matches its slot, but that doesn't necessarily mean it's in the right place. The puzzle is solved when ",
                            /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                className: "boldText",
                                children: "all"
                            }),
                            " statements have checkmarks."
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                        children: "There is only one solution. Good luck."
                    })
                ]
            })
        ]
    });
};
var $1d53248cd57b50d8$export$2e2bcd8739ae039 = $1d53248cd57b50d8$var$Instructions;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");






const $7c8b711f7721f678$var$MobileTruthsortingInstructions = ()=>{
    const isOpen = (0, $abbcacd8f9b8e7dd$export$5aa98d4d531c155f).useState((s)=>s.instructionsAreOpen);
    const onClose = ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).set(`${(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Truthsorting}InstructionsDismissed`, 'true', {
            domain: (0, $ba1e3b359abf28ef$export$517466abcb8fcf10),
            expires: 365
        });
        (0, $abbcacd8f9b8e7dd$export$5aa98d4d531c155f).update((s)=>{
            s.instructionsAreOpen = false;
            s.isSoftPaused = false;
        });
    };
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $f13252b13d1e29c0$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: onClose,
        title: "How to Play Truthsorting",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "Truth slots are white. Lie slots are black."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                children: [
                    (0, $b2cd9ecc66d0956f$exports.isMobile) ? 'Drag' : 'Click and drag',
                    " to reorder the statements so that truth slots contain truths and lie slots contain lies."
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "Whether statements are truths or lies depends entirely on the order they're in."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                children: [
                    "A checkmark is shown on any statement whose current truthfulness matches its slot, but that doesn't necessarily mean it's in the right place. The puzzle is solved when ",
                    /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                        className: "boldText",
                        children: "all"
                    }),
                    " statements have checkmarks."
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "There is only one solution. Good luck."
            })
        ]
    });
};
var $7c8b711f7721f678$export$2e2bcd8739ae039 = $7c8b711f7721f678$var$MobileTruthsortingInstructions;



var $93f32e3010cf7396$exports = {};
$93f32e3010cf7396$exports = import.meta.resolve("gOLbs");


var $6e7fa815e0b6548a$exports = {};
$6e7fa815e0b6548a$exports = import.meta.resolve("kQF18");


var $d36dba527bd2f3c5$exports = {};
$d36dba527bd2f3c5$exports = import.meta.resolve("3JVh1");


var $121fb1ecd3758d0b$exports = {};
$121fb1ecd3758d0b$exports = import.meta.resolve("1ms8r");


var $1c41ec5ef0f90303$exports = {};
$1c41ec5ef0f90303$exports = import.meta.resolve("2Ofqz");


var $db4445183c1c1517$exports = {};
$db4445183c1c1517$exports = import.meta.resolve("05rDl");


var $f793e615e6a7a677$exports = {};
$f793e615e6a7a677$exports = import.meta.resolve("dXtZX");


var $d581bd675c923f10$exports = {};
$d581bd675c923f10$exports = import.meta.resolve("fP2YP");





const $992dcec7859ffe00$var$ShapeIcon = ({ shape: shape })=>{
    switch(shape){
        case (0, $656c0098466b2416$export$9f97c9ab3f6c7b54).Circle:
            return /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($93f32e3010cf7396$exports))),
                className: "shapeIcon",
                alt: "circle"
            });
        case (0, $656c0098466b2416$export$9f97c9ab3f6c7b54).Square:
            return /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6e7fa815e0b6548a$exports))),
                className: "shapeIcon",
                alt: "square"
            });
        case (0, $656c0098466b2416$export$9f97c9ab3f6c7b54).Triangle:
            return /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($d36dba527bd2f3c5$exports))),
                className: "shapeIcon",
                alt: "triangle"
            });
        case (0, $656c0098466b2416$export$9f97c9ab3f6c7b54).Diamond:
            return /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($121fb1ecd3758d0b$exports))),
                className: "shapeIcon diamond",
                alt: "diamond"
            });
        case (0, $656c0098466b2416$export$9f97c9ab3f6c7b54).Heart:
            return /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($1c41ec5ef0f90303$exports))),
                className: "shapeIcon",
                alt: "heart"
            });
        case (0, $656c0098466b2416$export$9f97c9ab3f6c7b54).Pentagon:
            return /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($db4445183c1c1517$exports))),
                className: "shapeIcon",
                alt: "pentagon"
            });
        case (0, $656c0098466b2416$export$9f97c9ab3f6c7b54).Trapezoid:
            return /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($f793e615e6a7a677$exports))),
                className: "shapeIcon",
                alt: "trapezoid"
            });
        case (0, $656c0098466b2416$export$9f97c9ab3f6c7b54).Star:
            return /*#__PURE__*/ (0, $4XrX4.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($d581bd675c923f10$exports))),
                className: "shapeIcon star",
                alt: "star"
            });
        default:
            return null;
    }
};
const $992dcec7859ffe00$var$Truthsorting = ()=>{
    const { slots: slots, statements: statements, revealed: revealed, solutionColors: solutionColors, solved: solved } = (0, $abbcacd8f9b8e7dd$export$5aa98d4d531c155f).useState();
    // If revealed or solved, reorder statements to match the solution
    const displayedStatements = (0, (/*@__PURE__*/$parcel$interopDefault($28UcW))).useMemo(()=>{
        return revealed || solved ? solutionColors.map((color)=>statements.find((s)=>s.color === color)) : statements;
    }, [
        revealed,
        solved,
        solutionColors,
        statements
    ]);
    (0, $ba1e3b359abf28ef$export$e73a86b2063a8f6b)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Truthsorting, (0, $abbcacd8f9b8e7dd$export$5aa98d4d531c155f));
    (0, $ba1e3b359abf28ef$export$20d77ccceac0f55c)((0, $abbcacd8f9b8e7dd$export$5aa98d4d531c155f), (0, $656c0098466b2416$export$b9e7221e14f84ef0));
    (0, $ba1e3b359abf28ef$export$5b0326dddadcb0de)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Truthsorting);
    (0, $ba1e3b359abf28ef$export$52dc0a972e5b91c5)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Truthsorting);
    (0, $80f684051860af43$export$2500c8a6bc3f2f43)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Truthsorting);
    const useMobileStyles = (0, $b2cd9ecc66d0956f$exports.isMobile) || (0, $ba1e3b359abf28ef$export$580e0f6db19fa7cc)();
    // Colorblind mode state - load from cookie or default to false
    const [colorblindMode, setColorblindMode] = (0, $28UcW.useState)(()=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).get('truthsortingColorblindMode') === 'true';
    });
    // The statement currently being dragged
    const [draggedStatement, setDraggedStatement] = (0, $28UcW.useState)(null);
    // Vertical distance the dragged statement has moved from its starting position
    const [dragDistance, setDragDistance] = (0, $28UcW.useState)(0);
    // Index of the slot the mouse is currently hovering over during drag
    const [hoveredSlotIndex, setHoveredSlotIndex] = (0, $28UcW.useState)(null);
    // Y position of mouse when drag started
    const initialMousePositionTop = (0, $28UcW.useRef)(0);
    // Array of slot DOM elements for position detection
    const slotElementsRef = (0, $28UcW.useRef)([]);
    // Ref version of hoveredSlotIndex for access in event handlers
    const hoveredSlotIndexRef = (0, $28UcW.useRef)(null);
    // Index of the slot where the drag started
    const dragStartSlotIndexRef = (0, $28UcW.useRef)(null);
    // Array of booleans indicating which statements are validly placed
    const [validities, setValidities] = (0, $28UcW.useState)([]);
    // Calculate validities on initial render and whenever statements change
    (0, $28UcW.useEffect)(()=>{
        setValidities((0, $656c0098466b2416$export$6fca47e2663e9ff4)(slots, displayedStatements));
    }, [
        slots,
        displayedStatements
    ]);
    // Handle colorblind mode toggle
    const handleColorblindModeToggle = ()=>{
        const newValue = !colorblindMode;
        setColorblindMode(newValue);
        (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).set('truthsortingColorblindMode', String(newValue), {
            expires: 365
        });
    };
    const onDragMove = (e)=>{
        const clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
        // Update drag distance by comparing mouse's current position (clientY) to its original position
        setDragDistance(clientY - initialMousePositionTop.current);
        // Detect which slot the mouse is currently over
        let foundIndex = null;
        slotElementsRef.current.forEach((slotEl, index)=>{
            if (slotEl) {
                const rect = slotEl.getBoundingClientRect();
                if (clientY >= rect.top && clientY <= rect.bottom) foundIndex = index;
            }
        });
        // Update hovered slot if changed
        if (foundIndex !== hoveredSlotIndex) {
            setHoveredSlotIndex(foundIndex);
            hoveredSlotIndexRef.current = foundIndex;
        }
    };
    const onDragStart = (e, statement, statementIndex)=>{
        // Don't allow dragging when revealed or solved
        if (revealed || solved) return;
        const clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
        initialMousePositionTop.current = clientY;
        setDraggedStatement(statement);
        dragStartSlotIndexRef.current = statementIndex;
        document.addEventListener('mousemove', onDragMove);
        document.addEventListener('mouseup', onDragEnd);
        document.addEventListener('touchmove', onDragMove);
        document.addEventListener('touchend', onDragEnd);
    };
    const onDragEnd = ()=>{
        const hoveredIndex = hoveredSlotIndexRef.current;
        const startIndex = dragStartSlotIndexRef.current;
        // If we're hovering over a different slot, swap the statements
        if (hoveredIndex !== null && startIndex !== null && hoveredIndex !== startIndex) {
            const newStatements = [
                ...statements
            ];
            // Swap the statements
            [newStatements[startIndex], newStatements[hoveredIndex]] = [
                newStatements[hoveredIndex],
                newStatements[startIndex]
            ];
            (0, $abbcacd8f9b8e7dd$export$5aa98d4d531c155f).update((s)=>{
                s.statements = newStatements;
            });
            // Check if puzzle is solved
            const currentColors = newStatements.map((s)=>s.color);
            const isSolved = currentColors.every((color, index)=>color === solutionColors[index]);
            if (isSolved) (0, $656c0098466b2416$export$4e3bdb6fc7af2ff8)();
        }
        setDraggedStatement(null);
        setDragDistance(0);
        setHoveredSlotIndex(null);
        hoveredSlotIndexRef.current = null;
        dragStartSlotIndexRef.current = null;
        document.removeEventListener('mousemove', onDragMove);
        document.removeEventListener('mouseup', onDragEnd);
        document.removeEventListener('touchmove', onDragMove);
        document.removeEventListener('touchend', onDragEnd);
    };
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d549bcf7ed920b37$export$2e2bcd8739ae039), {
                puzzleName: (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Truthsorting,
                store: (0, $abbcacd8f9b8e7dd$export$5aa98d4d531c155f),
                onReveal: (0, $656c0098466b2416$export$7cf2f68092532300),
                onSave: (0, $656c0098466b2416$export$b9e7221e14f84ef0),
                InstructionsComponent: useMobileStyles ? (0, $7c8b711f7721f678$export$2e2bcd8739ae039) : (0, $1d53248cd57b50d8$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: `puzzleContainer truthsortingContainer ${colorblindMode ? 'colorblindMode' : ''}`,
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $b9f68b54b1083b27$export$2e2bcd8739ae039), {
                        store: (0, $abbcacd8f9b8e7dd$export$5aa98d4d531c155f)
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "positioningContainer",
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "slotsOuterContainer",
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                    className: "slotsInnerContainer",
                                    children: slots.map((slot, i)=>{
                                        const isHovered = hoveredSlotIndex === i && dragStartSlotIndexRef.current !== i;
                                        const isBlackSlot = !slot;
                                        const isWhiteSlot = slot;
                                        const isFirstSlot = i === 0;
                                        const isPrecededByWhiteSlot = i > 0 && slots[i - 1];
                                        const isPrecededByBlackSlot = i > 0 && !slots[i - 1];
                                        const blackSlotShouldHaveBorderTop = isBlackSlot && !isFirstSlot && !isPrecededByWhiteSlot;
                                        const whiteSlotShouldHaveBorderTop = isWhiteSlot && !isFirstSlot && !isPrecededByBlackSlot;
                                        const shouldHaveBorderTop = blackSlotShouldHaveBorderTop || whiteSlotShouldHaveBorderTop;
                                        return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                            ref: (el)=>slotElementsRef.current[i] = el,
                                            className: `slot ${slot ? 'whiteSlot' : 'blackSlot'} ${isHovered ? 'hovered' : ''} ${shouldHaveBorderTop ? 'withBorderTop' : ''}`,
                                            children: [
                                                /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                    className: "slotNumber",
                                                    children: i + 1
                                                }),
                                                /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                                    className: `checkmarkContainer ${solved ? 'solving' : ''}`,
                                                    style: {
                                                        animationDelay: solved ? `${i * 0.15}s` : undefined
                                                    },
                                                    children: validities[i] ? "\u2713" : ''
                                                })
                                            ]
                                        }, i);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "statementsContainer",
                                children: displayedStatements.map((statement, index)=>/*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                        style: {
                                            top: statement.color === draggedStatement?.color ? dragDistance : 0,
                                            zIndex: statement.color === draggedStatement?.color ? 999 : 0,
                                            animationDelay: solved ? `${index * 0.15}s` : undefined
                                        },
                                        onMouseDown: (e)=>onDragStart(e, statement, index),
                                        onTouchStart: (e)=>onDragStart(e, statement, index),
                                        className: `booleanStatement ${statement.color.toLowerCase()} ${colorblindMode ? 'withIcon' : ''} ${revealed || solved ? 'revealed' : ''} ${solved ? 'solving' : ''}`,
                                        children: [
                                            colorblindMode ? statement.colorblindText : statement.text,
                                            colorblindMode && /*#__PURE__*/ (0, $4XrX4.jsx)($992dcec7859ffe00$var$ShapeIcon, {
                                                shape: (0, $656c0098466b2416$export$8214603e3981bac6)(statement.color)
                                            })
                                        ]
                                    }, statement.color))
                            })
                        ]
                    }),
                    revealed && /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "outcomeBanner",
                        children: "Solution revealed. Try again tomorrow!"
                    }),
                    solved && /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "outcomeBanner",
                        children: "Solved! New puzzle tomorrow."
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "colorblindModeToggle",
                        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)("input", {
                                    type: "checkbox",
                                    checked: colorblindMode,
                                    onChange: handleColorblindModeToggle
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                    children: "Colorblind mode"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $992dcec7859ffe00$export$2e2bcd8739ae039 = $992dcec7859ffe00$var$Truthsorting;


var $cd7189524ec7e9f4$export$2e2bcd8739ae039 = (0, $992dcec7859ffe00$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");






const $84fe879902ff3b51$export$2fab4f4634e839b3 = 600;
/** How long letters stay in the pre-flip orientation before snapping, while the piece is edge-on. */ const $84fe879902ff3b51$var$FLIP_HIDE_DURATION = 300;
const $84fe879902ff3b51$export$b04f84b03234f6d0 = (puzzleData)=>{
    (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((s)=>{
        s.puzzleId = puzzleData.puzzleId;
        s.solution = puzzleData.grid.map((row)=>row.split(''));
        s.grids = (0, $48a85ad21da8d504$export$b52c0673261d89c0)();
        (0, $48a85ad21da8d504$export$c4ec174058808011)(s.grids, puzzleData.scrambledGrid.map((row)=>row.split('')));
        s.rot = 0;
        s.isRevealing = false;
        s.isCelebrating = false;
    });
};
const $84fe879902ff3b51$export$4e3bdb6fc7af2ff8 = ()=>{
    const { time: time, puzzleId: puzzleId } = (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).getRawState();
    $84fe879902ff3b51$var$playVictoryAnimation(()=>{
        setTimeout(()=>{
            (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((s)=>{
                s.statsDialogIsOpen = true;
            });
        }, $84fe879902ff3b51$var$STATS_DIALOG_DELAY_AFTER_VICTORY);
    });
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Ultrarubigram, {
        puzzleId: puzzleId,
        revealed: false,
        solved: true,
        time: time,
        // a finished puzzle needs no orientations, and this drops any earlier mid-puzzle save
        partialState: null
    });
};
const $84fe879902ff3b51$export$7cf2f68092532300 = ()=>{
    const { time: time, puzzleId: puzzleId } = (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).getRawState();
    (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((s)=>{
        clearInterval(s.timerUpdatingFn);
        s.revealed = true;
        s.isPaused = false;
        s.isRevealing = true;
    });
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Ultrarubigram, {
        puzzleId: puzzleId,
        revealed: true,
        solved: false,
        time: time,
        partialState: null
    });
    $84fe879902ff3b51$var$playRevealAnimation();
};
const $84fe879902ff3b51$export$3f0ef2d61f406c77 = ()=>{
    const { solved: solved, revealed: revealed, time: time, rot: rot, grids: grids, puzzleId: puzzleId } = (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).getRawState();
    if (solved || revealed) return;
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Ultrarubigram, {
        puzzleId: puzzleId,
        revealed: revealed,
        solved: solved,
        time: time,
        partialState: {
            rot: rot,
            grids: (0, $48a85ad21da8d504$export$b8e17e5947e2dd8a)(grids)
        }
    });
};
// ---------------------------------------------------------------------------
// Moves
// ---------------------------------------------------------------------------
/**
 * Marks a piece as moving for as long as its animation runs: it (and whatever it sits inside)
 * is then raised above its neighbours, so it passes over them (see .moving).
 */ const $84fe879902ff3b51$var$beginMove = (s, path, kind)=>{
    const piece = (0, $48a85ad21da8d504$export$5068540ba132f3a1)(s, path);
    piece.moving = kind;
    const move = ++piece.moves;
    setTimeout(()=>{
        (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((_s)=>{
            const later = (0, $48a85ad21da8d504$export$5068540ba132f3a1)(_s, path);
            if (later.moves === move) later.moving = null;
        });
    }, $84fe879902ff3b51$export$2fab4f4634e839b3);
};
const $84fe879902ff3b51$var$checkSolved = (s)=>{
    if (s.solved || s.revealed) return;
    if ((0, $48a85ad21da8d504$export$9666754a25e0cb16)((0, $48a85ad21da8d504$export$245018fe6e19aee)(s.rot, s.grids), s.solution)) {
        s.solved = true;
        $84fe879902ff3b51$export$4e3bdb6fc7af2ff8();
    }
};
/** Marks a piece as mid-flip for the moment its letters must stay put, then clears it. */ const $84fe879902ff3b51$var$startFlipping = (s, path)=>{
    (0, $48a85ad21da8d504$export$5068540ba132f3a1)(s, path).isFlipping = true;
    $84fe879902ff3b51$var$beginMove(s, path, 'flip');
    setTimeout(()=>{
        (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((_s)=>{
            (0, $48a85ad21da8d504$export$5068540ba132f3a1)(_s, path).isFlipping = false;
        });
    }, $84fe879902ff3b51$var$FLIP_HIDE_DURATION);
};
const $84fe879902ff3b51$var$toggleFlip = (s, path, toggle)=>{
    const piece = (0, $48a85ad21da8d504$export$5068540ba132f3a1)(s, path);
    if (toggle === 'H') piece.flipH = !piece.flipH;
    else piece.flipV = !piece.flipV;
    $84fe879902ff3b51$var$startFlipping(s, path);
};
const $84fe879902ff3b51$var$flipOnScreen = (s, path, horizontal)=>{
    (0, $48a85ad21da8d504$export$bb05e11298275b42)(s, path, horizontal);
    $84fe879902ff3b51$var$startFlipping(s, path);
};
const $84fe879902ff3b51$var$rotateOnScreen = (s, path, clockwise)=>{
    (0, $48a85ad21da8d504$export$4e3be200d92900c1)(s, path, clockwise);
    $84fe879902ff3b51$var$beginMove(s, path, 'turn');
};
const $84fe879902ff3b51$var$interactive = (s)=>!s.solved && !s.revealed && !s.isRevealing;
const $84fe879902ff3b51$export$ac278c6614346f4c = (clockwise)=>{
    (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((s)=>{
        if (!$84fe879902ff3b51$var$interactive(s)) return;
        s.rot += clockwise ? 90 : -90;
        $84fe879902ff3b51$var$checkSolved(s);
    });
};
const $84fe879902ff3b51$export$415532bd5f4f3998 = (grid, toggle)=>{
    (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((s)=>{
        if (!$84fe879902ff3b51$var$interactive(s)) return;
        $84fe879902ff3b51$var$toggleFlip(s, {
            grid: grid
        }, toggle);
        $84fe879902ff3b51$var$checkSolved(s);
    });
};
const $84fe879902ff3b51$export$617e2a9bc33e11cf = (grid, clockwise)=>{
    (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((s)=>{
        if (!$84fe879902ff3b51$var$interactive(s)) return;
        $84fe879902ff3b51$var$rotateOnScreen(s, {
            grid: grid
        }, clockwise);
        $84fe879902ff3b51$var$checkSolved(s);
    });
};
const $84fe879902ff3b51$export$7dab5a7bd4b33727 = (grid, quadrant, edge)=>{
    (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((s)=>{
        if (!$84fe879902ff3b51$var$interactive(s)) return;
        $84fe879902ff3b51$var$flipOnScreen(s, {
            grid: grid,
            quadrant: quadrant
        }, edge === 'left' || edge === 'right');
        $84fe879902ff3b51$var$checkSolved(s);
    });
};
const $84fe879902ff3b51$export$27667ccb1ebed314 = (grid, quadrant, clockwise)=>{
    (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((s)=>{
        if (!$84fe879902ff3b51$var$interactive(s)) return;
        $84fe879902ff3b51$var$rotateOnScreen(s, {
            grid: grid,
            quadrant: quadrant
        }, clockwise);
        $84fe879902ff3b51$var$checkSolved(s);
    });
};
const $84fe879902ff3b51$export$f7ed77eace781e26 = (grid, quadrant, subgrid, row, col)=>{
    (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((s)=>{
        if (!$84fe879902ff3b51$var$interactive(s)) return;
        const path = {
            grid: grid,
            quadrant: quadrant,
            subgrid: subgrid
        };
        const [x] = (0, $48a85ad21da8d504$export$5635d7ef4b8fee1c)((0, $48a85ad21da8d504$export$2b174b2fa5e33c96)(s, path), ...(0, $48a85ad21da8d504$export$1b704bc0cde19094)(row, col));
        $84fe879902ff3b51$var$flipOnScreen(s, path, x !== 0);
        $84fe879902ff3b51$var$checkSolved(s);
    });
};
const $84fe879902ff3b51$export$bbbc098477580154 = (grid, quadrant, subgrid, clockwise)=>{
    (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((s)=>{
        if (!$84fe879902ff3b51$var$interactive(s)) return;
        $84fe879902ff3b51$var$rotateOnScreen(s, {
            grid: grid,
            quadrant: quadrant,
            subgrid: subgrid
        }, clockwise);
        $84fe879902ff3b51$var$checkSolved(s);
    });
};
/** Stagger between pieces moving in the same phase, per level, in ms. */ const $84fe879902ff3b51$var$STAGGER = {
    puzzle: 0,
    grid: 160,
    quadrant: 70,
    subgrid: 22
};
/** Pause after a phase's last move starts before the next phase begins. */ const $84fe879902ff3b51$var$PHASE_GAP = 700;
/** Every piece's required flip and turn, biggest pieces first, working from the solved orientations. */ const $84fe879902ff3b51$var$planReveal = (s)=>{
    const solved = (0, $48a85ad21da8d504$export$d593c3b3b07081f6)(s.grids, s.solution);
    if (!solved) return null;
    const levels = [
        [],
        [],
        []
    ];
    const rootEl = solved.rootEl;
    let rootDelta = ((rootEl * 90 - s.rot) % 360 + 360) % 360;
    if (rootDelta === 270) rootDelta = -90;
    s.grids.forEach((grid, g)=>{
        const gridNode = solved.grids[g];
        levels[0].push({
            path: {
                grid: g
            },
            ...(0, $48a85ad21da8d504$export$a5640c3dbe03d54)(grid, (0, $48a85ad21da8d504$export$f672e0b6f7222cd7)((0, $48a85ad21da8d504$export$70ae2c07e401031b)(rootEl), gridNode.el))
        });
        grid.quadrants.forEach((quadrant, q)=>{
            const quadrantNode = gridNode.children[q];
            levels[1].push({
                path: {
                    grid: g,
                    quadrant: q
                },
                ...(0, $48a85ad21da8d504$export$a5640c3dbe03d54)(quadrant, (0, $48a85ad21da8d504$export$f672e0b6f7222cd7)((0, $48a85ad21da8d504$export$70ae2c07e401031b)(gridNode.el), quadrantNode.el))
            });
            quadrant.subgrids.forEach((subgrid, sub)=>{
                const subgridNode = quadrantNode.children[sub];
                levels[2].push({
                    path: {
                        grid: g,
                        quadrant: q,
                        subgrid: sub
                    },
                    ...(0, $48a85ad21da8d504$export$a5640c3dbe03d54)(subgrid, (0, $48a85ad21da8d504$export$f672e0b6f7222cd7)((0, $48a85ad21da8d504$export$70ae2c07e401031b)(quadrantNode.el), subgridNode.el))
                });
            });
        });
    });
    return {
        rootDelta: rootDelta,
        levels: levels
    };
};
const $84fe879902ff3b51$var$playRevealAnimation = ()=>{
    const plan = $84fe879902ff3b51$var$planReveal((0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).getRawState());
    if (!plan) {
        // Can't happen for a scrambled puzzle, but never leave the player stuck mid-reveal.
        (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((s)=>{
            s.isRevealing = false;
        });
        return;
    }
    const timeline = [];
    let at = 300;
    if (plan.rootDelta !== 0) {
        timeline.push({
            at: at,
            run: ()=>(0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((s)=>{
                    s.rot += plan.rootDelta;
                })
        });
        at += $84fe879902ff3b51$var$PHASE_GAP;
    }
    const staggers = [
        $84fe879902ff3b51$var$STAGGER.grid,
        $84fe879902ff3b51$var$STAGGER.quadrant,
        $84fe879902ff3b51$var$STAGGER.subgrid
    ];
    plan.levels.forEach((moves, level)=>{
        const flips = moves.filter((m)=>m.toggle !== null);
        const turns = moves.filter((m)=>m.deltaRot !== 0);
        for (const phase of [
            flips,
            turns
        ]){
            if (phase.length === 0) continue;
            phase.forEach((move, i)=>{
                timeline.push({
                    at: at + i * staggers[level],
                    run: ()=>(0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((s)=>{
                            if (move.toggle && phase === flips) $84fe879902ff3b51$var$toggleFlip(s, move.path, move.toggle);
                            else {
                                // A reveal turn is applied directly: the planned delta is already in local terms.
                                (0, $48a85ad21da8d504$export$5068540ba132f3a1)(s, move.path).rot += move.deltaRot;
                                $84fe879902ff3b51$var$beginMove(s, move.path, 'turn');
                            }
                        })
                });
            });
            at += (phase.length - 1) * staggers[level] + $84fe879902ff3b51$var$PHASE_GAP;
        }
    });
    timeline.push({
        at: at,
        run: ()=>(0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((s)=>{
                s.isRevealing = false;
            })
    });
    for (const step of timeline)setTimeout(step.run, step.at);
};
// ---------------------------------------------------------------------------
// Victory
// ---------------------------------------------------------------------------
/** After the final move's own animation; the wave starts from the top-left corner then. */ const $84fe879902ff3b51$var$WAVE_START = 500;
/** Milliseconds between a 3x3's spin and the next diagonal's. */ const $84fe879902ff3b51$var$WAVE_STEP = 60;
/** The whole puzzle's spin and the swell that lands it; matches .celebrating in the stylesheet. */ const $84fe879902ff3b51$var$VICTORY_SPIN_DURATION = 1700;
const $84fe879902ff3b51$var$STATS_DIALOG_DELAY_AFTER_VICTORY = 400;
/** Where a 3x3 sits on screen: row and column of 3x3 blocks, 0..7 from the top-left. */ const $84fe879902ff3b51$var$screenBlock = (s, path)=>{
    const root = (0, $48a85ad21da8d504$export$6b3f69c997ae528)(s.rot);
    const grid = s.grids[path.grid];
    const gridEl = (0, $48a85ad21da8d504$export$f672e0b6f7222cd7)(root, (0, $48a85ad21da8d504$export$a630693aae3f96b7)(grid));
    const [gx, gy] = (0, $48a85ad21da8d504$export$5635d7ef4b8fee1c)(root, ...(0, $48a85ad21da8d504$export$3867a73edf336869)(path.grid, (0, $48a85ad21da8d504$export$85915561ea5d0167)));
    const quadrant = grid.quadrants[path.quadrant];
    const quadrantEl = (0, $48a85ad21da8d504$export$f672e0b6f7222cd7)(gridEl, (0, $48a85ad21da8d504$export$a630693aae3f96b7)(quadrant));
    const [qx, qy] = (0, $48a85ad21da8d504$export$5635d7ef4b8fee1c)(gridEl, ...(0, $48a85ad21da8d504$export$3867a73edf336869)(path.quadrant, (0, $48a85ad21da8d504$export$426cb73c3ee7b28e)));
    const [sx, sy] = (0, $48a85ad21da8d504$export$5635d7ef4b8fee1c)(quadrantEl, ...(0, $48a85ad21da8d504$export$3867a73edf336869)(path.subgrid, (0, $48a85ad21da8d504$export$61a688f241a363c6)));
    // the 3x3's centre in half-cells from the puzzle's centre; blocks are 6 half-cells apart
    const x = gx + qx + sx;
    const y = gy + qy + sy;
    return [
        (y + (0, $48a85ad21da8d504$export$e1475ecddab48344) - 3) / 6,
        (x + (0, $48a85ad21da8d504$export$e1475ecddab48344) - 3) / 6
    ];
};
/** A full clockwise turn on screen, whatever the piece's parents have done to it. */ const $84fe879902ff3b51$var$spinOnScreen = (s, path)=>{
    const piece = (0, $48a85ad21da8d504$export$5068540ba132f3a1)(s, path);
    const mirrored = (0, $48a85ad21da8d504$export$43c5e86db8db458)((0, $48a85ad21da8d504$export$222ab8a52715b4f4)(s, path)) !== (piece.flipH !== piece.flipV);
    piece.rot += 360 * (mirrored ? -1 : 1);
    $84fe879902ff3b51$var$beginMove(s, path, 'turn');
};
/**
 * Spins every 3x3 in a wave from the top-left corner to the bottom-right, then spins the whole
 * puzzle once while the board swells and settles. Nothing ends up anywhere new.
 */ const $84fe879902ff3b51$var$playVictoryAnimation = (onDone)=>{
    // planned once the final move has landed, so the wave follows where the 3x3s are on screen
    setTimeout(()=>{
        const s = (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).getRawState();
        const timeline = [];
        let lastSpin = 0;
        s.grids.forEach((grid, g)=>grid.quadrants.forEach((quadrant, q)=>quadrant.subgrids.forEach((_, sub)=>{
                    const path = {
                        grid: g,
                        quadrant: q,
                        subgrid: sub
                    };
                    const [row, col] = $84fe879902ff3b51$var$screenBlock(s, path);
                    const at = (row + col) * $84fe879902ff3b51$var$WAVE_STEP;
                    lastSpin = Math.max(lastSpin, at);
                    timeline.push({
                        at: at,
                        run: ()=>(0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((_s)=>$84fe879902ff3b51$var$spinOnScreen(_s, path))
                    });
                })));
        // the whole puzzle goes as the last 3x3 is finishing
        const spinAt = lastSpin + $84fe879902ff3b51$export$2fab4f4634e839b3 - 150;
        timeline.push({
            at: spinAt,
            run: ()=>(0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((_s)=>{
                    _s.isCelebrating = true;
                    _s.rot += 360;
                })
        });
        timeline.push({
            at: spinAt + $84fe879902ff3b51$var$VICTORY_SPIN_DURATION,
            run: ()=>{
                (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((_s)=>{
                    _s.isCelebrating = false;
                });
                onDone();
            }
        });
        for (const step of timeline)setTimeout(step.run, step.at);
    }, $84fe879902ff3b51$var$WAVE_START);
};
const $84fe879902ff3b51$export$d8e200d5d29cf6f1 = (solution)=>{
    const grids = (0, $48a85ad21da8d504$export$b52c0673261d89c0)();
    (0, $48a85ad21da8d504$export$c4ec174058808011)(grids, solution);
    return grids;
};



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");






var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");


/**
 * A clockwise-turn button. Left click turns clockwise, right click counterclockwise. The
 * arrow is counter-transformed like the letters so it always shows a clockwise arrow no
 * matter how the piece it sits on has been turned or mirrored.
 */ const $270b67ec8f8945d9$var$RotateButton = ({ level: level, upright: upright, onRotate: onRotate })=>{
    const { angle: angle, flip: flip } = (0, $48a85ad21da8d504$export$2ee7a40c7f20e9b7)(upright);
    const previousAngle = (0, $28UcW.useRef)(angle);
    const continued = (0, $48a85ad21da8d504$export$3571c57768c14fd1)(previousAngle.current, angle);
    previousAngle.current = continued;
    // The Replay glyph is a counterclockwise arrow; mirroring it once makes it clockwise.
    const iconStyle = {
        transform: `rotate(${continued}deg) scaleX(${flip ? 1 : -1})`
    };
    return /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
        type: "button",
        className: `ultraRotateButton ${level}`,
        onClick: ()=>onRotate(true),
        onContextMenu: (e)=>{
            e.preventDefault();
            onRotate(false);
        },
        children: /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
            className: "ultraRotateIcon",
            style: iconStyle,
            children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($27f101808c5d1eaa$exports))), {})
        })
    });
};
var $270b67ec8f8945d9$export$2e2bcd8739ae039 = $270b67ec8f8945d9$var$RotateButton;



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");



/**
 * How much thicker than its own 2px border a tile's side must be, given where that side lies
 * on screen (in half-cells from the puzzle center): seams between 6x6s are 4px, seams between
 * 12x12s and the outside are 5px.
 */ const $36e7463c6903892d$var$frameExtra = (position)=>{
    const distance = Math.abs(position);
    if (distance % 12 === 6) return 0; // between two 3x3s of one 6x6
    if (distance === 12) return 2; // between two 6x6s
    return 3; // between two 12x12s (0) or the outside (24)
};
const $36e7463c6903892d$var$CORNERS = [
    {
        name: 'tl',
        x: -1,
        y: -1,
        sides: [
            'top',
            'left'
        ]
    },
    {
        name: 'tr',
        x: 1,
        y: -1,
        sides: [
            'top',
            'right'
        ]
    },
    {
        name: 'bl',
        x: -1,
        y: 1,
        sides: [
            'bottom',
            'left'
        ]
    },
    {
        name: 'br',
        x: 1,
        y: 1,
        sides: [
            'bottom',
            'right'
        ]
    }
];
/** The tab quarter on a corner of a tile, if any. `frame` maps the tab frame to the screen. */ const $36e7463c6903892d$var$quarterAt = (corner, frame, centerX, centerY, quadrantX, quadrantY)=>{
    const [ox, oy] = (0, $48a85ad21da8d504$export$5635d7ef4b8fee1c)(frame, corner.x * (0, $48a85ad21da8d504$export$61a688f241a363c6), corner.y * (0, $48a85ad21da8d504$export$61a688f241a363c6));
    const dx = centerX + ox - quadrantX;
    const dy = centerY + oy - quadrantY;
    if (dx === 0 === (dy === 0)) return null;
    const onSide = dy === 0; // on the left or right edge, rather than the top or bottom
    const edge = onSide ? dx < 0 ? 'left' : 'right' : dy < 0 ? 'top' : 'bottom';
    const across = onSide ? centerX + ox : centerY + oy;
    const seam = Math.abs(across) === (0, $48a85ad21da8d504$export$e1475ecddab48344) ? 'outer' : across === 0 ? 'grid' : 'quad';
    const edgeSide = corner.sides.find((side)=>(0, $48a85ad21da8d504$export$5635d7ef4b8fee1c)(frame, ...(0, $48a85ad21da8d504$export$33c60e0f35e2dfe1)[side])[0] !== 0 === onSide);
    return {
        edge: edge,
        edgeSide: edgeSide,
        seam: seam
    };
};
/**
 * Where a quarter sits relative to its tile's corner, so that the disc is centered on the middle
 * of the seam: 1px in along the side the tile shares with its neighbouring 3x3 (they overlap by
 * 2px), and on a 12x12 seam, where tiles are 1px apart, the right/bottom one reaches 1px out.
 * On the outside the disc's flat side lies on the puzzle's edge, i.e. the outer edge of the
 * band, so that it still looks part of the edge when the tile turns its band away from under
 * it (the disc is bigger by the same amount; see .ultraQuarter.outer). A hidden quarter keeps
 * a position so it never transitions from nowhere.
 */ const $36e7463c6903892d$var$quarterStyle = (corner, quarter)=>{
    const style = {};
    for (const side of corner.sides){
        if (!quarter) style[side] = '0px';
        else if (side !== quarter.edgeSide) style[side] = '1px';
        else if (quarter.seam === 'outer') style[side] = `${-$36e7463c6903892d$var$frameExtra((0, $48a85ad21da8d504$export$e1475ecddab48344))}px`;
        else style[side] = quarter.seam === 'grid' && (quarter.edge === 'right' || quarter.edge === 'bottom') ? '-1px' : '0px';
    }
    return style;
};
/** How far the band along the outside reaches beyond a tile's box; the most any frame does. */ const $36e7463c6903892d$var$BAND_MARGIN = 3;
/**
 * The outline of a tile's band while a piece containing it moves (see .ultraContents::before):
 * a margin around the box wide enough for any frame, minus a bite at each corner that sits on
 * a flip tab, over the neighbouring quarter's split line, so that the band, drawn on top of
 * everything while it moves, never covers that line when at rest. The bite reaches `bite`
 * along the seam from the corner. Twelve vertices, three per corner, clockwise from the
 * top-left, so that every configuration has the same shape of polygon.
 */ const $36e7463c6903892d$var$bandClip = (self, centerX, centerY, quadrantX, quadrantY, bite)=>{
    const out = `-${$36e7463c6903892d$var$BAND_MARGIN}px`;
    const across = `calc(100% + ${$36e7463c6903892d$var$BAND_MARGIN}px)`;
    const near = bite ?? '0px';
    const far = `calc(100% - ${near})`;
    const biteSide = (corner)=>{
        if (!bite) return null;
        const quarter = $36e7463c6903892d$var$quarterAt(corner, self, centerX, centerY, quadrantX, quadrantY);
        return quarter && quarter.seam !== 'outer' ? quarter.edgeSide : null;
    };
    const [tl, tr, bl, br] = $36e7463c6903892d$var$CORNERS.map(biteSide);
    const points = [
        ...tl === 'top' ? [
            `${out} 0px`,
            `${near} 0px`,
            `${near} ${out}`
        ] : tl === 'left' ? [
            `${out} ${near}`,
            `0px ${near}`,
            `0px ${out}`
        ] : Array(3).fill(`${out} ${out}`),
        ...tr === 'top' ? [
            `${far} ${out}`,
            `${far} 0px`,
            `${across} 0px`
        ] : tr === 'right' ? [
            `100% ${out}`,
            `100% ${near}`,
            `${across} ${near}`
        ] : Array(3).fill(`${across} ${out}`),
        ...br === 'right' ? [
            `${across} ${far}`,
            `100% ${far}`,
            `100% ${across}`
        ] : br === 'bottom' ? [
            `${across} 100%`,
            `${far} 100%`,
            `${far} ${across}`
        ] : Array(3).fill(`${across} ${across}`),
        ...bl === 'bottom' ? [
            `${near} ${across}`,
            `${near} 100%`,
            `${out} 100%`
        ] : bl === 'left' ? [
            `0px ${across}`,
            `0px ${far}`,
            `${out} ${far}`
        ] : Array(3).fill(`${out} ${across}`)
    ];
    return `polygon(${points.join(', ')})`;
};
const $36e7463c6903892d$var$Subgrid = /*#__PURE__*/ (0, $28UcW.memo)(({ g: g, q: q, s: s, subgrid: subgrid, parent: parent, parentCenterX: parentCenterX, parentCenterY: parentCenterY, interactive: interactive, layer: layer, ancestorMoving: ancestorMoving })=>{
    const self = (0, $48a85ad21da8d504$export$f672e0b6f7222cd7)(parent, (0, $48a85ad21da8d504$export$a630693aae3f96b7)(subgrid));
    const upright = (0, $48a85ad21da8d504$export$70ae2c07e401031b)(self);
    const [offsetX, offsetY] = (0, $48a85ad21da8d504$export$5635d7ef4b8fee1c)(parent, ...(0, $48a85ad21da8d504$export$3867a73edf336869)(s, (0, $48a85ad21da8d504$export$61a688f241a363c6)));
    const centerX = parentCenterX + offsetX;
    const centerY = parentCenterY + offsetY;
    const flipperStyle = {
        transform: `rotateY(${subgrid.flipH ? 180 : 0}deg)` + ` rotateX(${subgrid.flipV ? 180 : 0}deg)` + ` rotateZ(${subgrid.rot}deg)`
    };
    const pieceClasses = `ultraPiece ultraSubgrid pos${s}${subgrid.moving ? ' moving' : ''}` + (layer === 'bands' ? ' bands' : layer ? ' tabs' : '');
    const contentsClasses = 'ultraContents' + (subgrid.isFlipping ? ' isFlipping' : '') + (subgrid.moving ? ' isMoving' : '');
    const frameStyle = {};
    for (const edge of (0, $48a85ad21da8d504$export$bf3c2d79d8478f0e)){
        const [nx, ny] = (0, $48a85ad21da8d504$export$5635d7ef4b8fee1c)(self, ...(0, $48a85ad21da8d504$export$33c60e0f35e2dfe1)[edge]);
        const position = nx !== 0 ? centerX + nx * (0, $48a85ad21da8d504$export$61a688f241a363c6) : centerY + ny * (0, $48a85ad21da8d504$export$61a688f241a363c6);
        frameStyle[`--frame${edge[0].toUpperCase()}${edge.slice(1)}`] = `${$36e7463c6903892d$var$frameExtra(position)}px`;
    }
    if (layer === 'bands') return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: pieceClasses,
        children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
            className: "ultraFlipper",
            style: flipperStyle,
            children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: contentsClasses,
                style: frameStyle
            })
        })
    });
    if (layer) {
        // The tab frame is the tile's frame without its own turning, so the quarters stay put on
        // screen while the tile turns under them and swing along with it only when it flips.
        const tabFrame = (0, $48a85ad21da8d504$export$f672e0b6f7222cd7)(parent, (0, $48a85ad21da8d504$export$a630693aae3f96b7)({
            rot: 0,
            flipH: subgrid.flipH,
            flipV: subgrid.flipV
        }));
        const tabFrameStyle = {
            transform: `rotateZ(${-subgrid.rot}deg)`
        };
        return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
            className: pieceClasses,
            children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "ultraFlipper",
                style: flipperStyle,
                children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                    className: contentsClasses,
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "ultraQuarterFrame",
                        style: tabFrameStyle,
                        children: $36e7463c6903892d$var$CORNERS.map((corner)=>{
                            const found = $36e7463c6903892d$var$quarterAt(corner, tabFrame, centerX, centerY, parentCenterX, parentCenterY);
                            const quarter = found && found.seam === 'grid' === (layer === 'seamTabs') ? found : null;
                            const classes = `ultraQuarter ${corner.name}` + (quarter ? ` edge-${quarter.edge}${quarter.seam === 'outer' ? ' outer' : ` line-${quarter.edgeSide}`}` : ' hidden');
                            return /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                                type: "button",
                                className: classes,
                                style: $36e7463c6903892d$var$quarterStyle(corner, quarter),
                                onClick: quarter ? ()=>(0, $84fe879902ff3b51$export$7dab5a7bd4b33727)(g, q, quarter.edge) : undefined,
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                    className: "disc"
                                })
                            }, corner.name);
                        })
                    })
                })
            })
        });
    }
    // Only a moving 6x6 or 12x12 is drawn above its neighbours' tabs (see .bigMoving), so only
    // then does the band need bites. While it flips, the bands along the flip axis foreshorten
    // in place over the neighbours' lines, so the bite must reach far along them: half a side.
    const bite = ancestorMoving === 'flip' ? '50%' : ancestorMoving === 'turn' ? 'calc(var(--tab) / 2 + 1px)' : null;
    frameStyle['--bandClip'] = $36e7463c6903892d$var$bandClip(self, centerX, centerY, parentCenterX, parentCenterY, bite);
    const { angle: angle, flip: flip } = (0, $48a85ad21da8d504$export$2ee7a40c7f20e9b7)(upright);
    const previousAngle = (0, $28UcW.useRef)(angle);
    const continued = (0, $48a85ad21da8d504$export$3571c57768c14fd1)(previousAngle.current, angle);
    previousAngle.current = continued;
    const letterStyle = {
        transform: `rotate(${continued}deg) scaleX(${flip ? -1 : 1})`
    };
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: pieceClasses,
        children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
            className: "ultraFlipper",
            style: flipperStyle,
            children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: contentsClasses,
                style: frameStyle,
                children: subgrid.content.map((row, r)=>/*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "ultraRow",
                        children: row.map((cell, c)=>{
                            const isCenter = r === 1 && c === 1;
                            const isSide = r === 1 !== (c === 1);
                            const isBlank = cell === '.';
                            const classes = 'ultraCell' + (isBlank ? ' blank' : '') + (isSide && interactive ? ' side' : '');
                            return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: classes,
                                onClick: isSide && interactive ? ()=>(0, $84fe879902ff3b51$export$f7ed77eace781e26)(g, q, s, r, c) : undefined,
                                children: [
                                    isCenter && interactive && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $270b67ec8f8945d9$export$2e2bcd8739ae039), {
                                        level: "subgrid",
                                        upright: upright,
                                        onRotate: (cw)=>(0, $84fe879902ff3b51$export$bbbc098477580154)(g, q, s, cw)
                                    }),
                                    !isCenter && !isBlank && /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                        className: "ultraLetter",
                                        style: letterStyle,
                                        children: cell
                                    })
                                ]
                            }, c);
                        })
                    }, r))
            })
        })
    });
});
var $36e7463c6903892d$export$2e2bcd8739ae039 = $36e7463c6903892d$var$Subgrid;


const $8a6d020e57a9a318$var$Quadrant = /*#__PURE__*/ (0, $28UcW.memo)(({ g: g, q: q, quadrant: quadrant, parent: parent, parentCenterX: parentCenterX, parentCenterY: parentCenterY, interactive: interactive, layer: layer, ancestorMoving: ancestorMoving })=>{
    const self = (0, $48a85ad21da8d504$export$f672e0b6f7222cd7)(parent, (0, $48a85ad21da8d504$export$a630693aae3f96b7)(quadrant));
    const [offsetX, offsetY] = (0, $48a85ad21da8d504$export$5635d7ef4b8fee1c)(parent, ...(0, $48a85ad21da8d504$export$3867a73edf336869)(q, (0, $48a85ad21da8d504$export$426cb73c3ee7b28e)));
    const centerX = parentCenterX + offsetX;
    const centerY = parentCenterY + offsetY;
    const flipperStyle = {
        transform: `rotateY(${quadrant.flipH ? 180 : 0}deg)` + ` rotateX(${quadrant.flipV ? 180 : 0}deg)` + ` rotateZ(${quadrant.rot}deg)`
    };
    // A tab copy's contents are where a tab's two quarters find each other, to highlight as one.
    const contentsClasses = 'ultraContents' + (layer && layer !== 'bands' ? ' quadrantContents' : '') + (quadrant.isFlipping ? ' isFlipping' : '') + (quadrant.moving ? ' isMoving' : '');
    const moving = quadrant.moving || quadrant.subgrids.some((subgrid)=>subgrid.moving);
    const pieceClasses = `ultraPiece ultraQuadrant pos${q}${moving ? ' moving' : ''}` + (layer === 'bands' ? ' bands' : layer ? ' tabs' : '');
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: pieceClasses,
        children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
            className: "ultraFlipper",
            style: flipperStyle,
            children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: contentsClasses,
                children: [
                    quadrant.subgrids.map((subgrid, s)=>/*#__PURE__*/ (0, $4XrX4.jsx)((0, $36e7463c6903892d$export$2e2bcd8739ae039), {
                            g: g,
                            q: q,
                            s: s,
                            subgrid: subgrid,
                            parent: self,
                            parentCenterX: centerX,
                            parentCenterY: centerY,
                            interactive: interactive,
                            layer: layer,
                            ancestorMoving: quadrant.moving ?? ancestorMoving
                        }, s)),
                    interactive && !layer && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $270b67ec8f8945d9$export$2e2bcd8739ae039), {
                        level: "quadrant",
                        upright: (0, $48a85ad21da8d504$export$70ae2c07e401031b)(self),
                        onRotate: (cw)=>(0, $84fe879902ff3b51$export$27667ccb1ebed314)(g, q, cw)
                    })
                ]
            })
        })
    });
});
var $8a6d020e57a9a318$export$2e2bcd8739ae039 = $8a6d020e57a9a318$var$Quadrant;



const $f3a7d5ed3c03e59f$var$Grid = /*#__PURE__*/ (0, $28UcW.memo)(({ g: g, grid: grid, parent: parent, interactive: interactive, layer: layer })=>{
    const self = (0, $48a85ad21da8d504$export$f672e0b6f7222cd7)(parent, (0, $48a85ad21da8d504$export$a630693aae3f96b7)(grid));
    const [centerX, centerY] = (0, $48a85ad21da8d504$export$5635d7ef4b8fee1c)(parent, ...(0, $48a85ad21da8d504$export$3867a73edf336869)(g, (0, $48a85ad21da8d504$export$85915561ea5d0167)));
    const flipperStyle = {
        transform: `rotateY(${grid.flipH ? 180 : 0}deg)` + ` rotateX(${grid.flipV ? 180 : 0}deg)` + ` rotateZ(${grid.rot}deg)`
    };
    const contentsClasses = 'ultraContents' + (grid.isFlipping ? ' isFlipping' : '') + (grid.moving ? ' isMoving' : '');
    const moving = grid.moving || grid.quadrants.some((quadrant)=>quadrant.moving || quadrant.subgrids.some((subgrid)=>subgrid.moving));
    const pieceClasses = `ultraPiece ultraGrid pos${g}${moving ? ' moving' : ''}` + (layer === 'bands' ? ' bands' : layer ? ' tabs' : '');
    const quadrants = (quadrantLayer)=>grid.quadrants.map((quadrant, q)=>/*#__PURE__*/ (0, $4XrX4.jsx)((0, $8a6d020e57a9a318$export$2e2bcd8739ae039), {
                g: g,
                q: q,
                quadrant: quadrant,
                parent: self,
                parentCenterX: centerX,
                parentCenterY: centerY,
                interactive: interactive,
                layer: quadrantLayer,
                ancestorMoving: grid.moving
            }, `${quadrantLayer ?? 'piece'}${q}`));
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: pieceClasses,
        children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
            className: "ultraFlipper",
            style: flipperStyle,
            children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: contentsClasses,
                children: [
                    quadrants(layer),
                    interactive && !layer && quadrants('innerTabs'),
                    interactive && !layer && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $270b67ec8f8945d9$export$2e2bcd8739ae039), {
                        level: "grid",
                        upright: (0, $48a85ad21da8d504$export$70ae2c07e401031b)(self),
                        onRotate: (cw)=>(0, $84fe879902ff3b51$export$617e2a9bc33e11cf)(g, cw)
                    })
                ]
            })
        })
    });
});
var $f3a7d5ed3c03e59f$export$2e2bcd8739ae039 = $f3a7d5ed3c03e59f$var$Grid;



const $982486b03f857d99$var$Board = /*#__PURE__*/ (0, $28UcW.memo)(()=>{
    // Selected individually so the timer ticking every second doesn't re-render the board.
    const { rot: rot, grids: grids, solution: solution, solved: solved, revealed: revealed, isRevealing: isRevealing, isCelebrating: isCelebrating } = (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).useState((s)=>({
            rot: s.rot,
            grids: s.grids,
            solution: s.solution,
            solved: s.solved,
            revealed: s.revealed,
            isRevealing: s.isRevealing,
            isCelebrating: s.isCelebrating
        }));
    // Once the puzzle is finished, later visits show the solution as a plain grid. The visit in
    // which it was finished keeps the live pieces, so the final move and the victory animation
    // play out on them. "On load" allows for a saved state that arrives just after mounting.
    const wasSolvedOnLoad = $982486b03f857d99$var$useSolvedOnLoad(solved);
    const revealedOnLoad = (0, $28UcW.useRef)(revealed && !isRevealing).current;
    const showStatic = wasSolvedOnLoad || revealedOnLoad;
    const staticGrids = (0, $28UcW.useMemo)(()=>showStatic ? (0, $84fe879902ff3b51$export$d8e200d5d29cf6f1)(solution) : null, [
        showStatic,
        solution
    ]);
    const shownGrids = staticGrids ?? grids;
    const shownRot = staticGrids ? 0 : rot;
    const interactive = !showStatic;
    const root = (0, $48a85ad21da8d504$export$6b3f69c997ae528)(shownRot);
    // While a 6x6 or 12x12 is moving it passes over every tab outside it; a moving 3x3 passes
    // under its 6x6's tabs instead (see .bigMoving).
    const bigMoving = shownGrids.some((grid)=>grid.moving || grid.quadrants.some((quadrant)=>quadrant.moving));
    const rotationStyle = {
        transform: `rotate(${shownRot}deg)`
    };
    const frameClasses = 'ultraBoardFrame' + (bigMoving ? ' bigMoving' : '') + (isCelebrating && !showStatic ? ' celebrating' : '');
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: frameClasses,
        onContextMenu: (e)=>{
            e.preventDefault();
        },
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
            className: "ultraRotation",
            style: rotationStyle,
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                    className: "ultraBandLayer",
                    children: shownGrids.map((grid, g)=>/*#__PURE__*/ (0, $4XrX4.jsx)((0, $f3a7d5ed3c03e59f$export$2e2bcd8739ae039), {
                            g: g,
                            grid: grid,
                            parent: root,
                            interactive: false,
                            layer: "bands"
                        }, g))
                }),
                shownGrids.map((grid, g)=>/*#__PURE__*/ (0, $4XrX4.jsx)((0, $f3a7d5ed3c03e59f$export$2e2bcd8739ae039), {
                        g: g,
                        grid: grid,
                        parent: root,
                        interactive: interactive
                    }, g)),
                interactive && /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
                    children: [
                        shownGrids.map((grid, g)=>/*#__PURE__*/ (0, $4XrX4.jsx)((0, $f3a7d5ed3c03e59f$export$2e2bcd8739ae039), {
                                g: g,
                                grid: grid,
                                parent: root,
                                interactive: true,
                                layer: "seamTabs"
                            }, `seamTabs${g}`)),
                        /*#__PURE__*/ (0, $4XrX4.jsx)((0, $270b67ec8f8945d9$export$2e2bcd8739ae039), {
                            level: "puzzle",
                            upright: (0, $48a85ad21da8d504$export$70ae2c07e401031b)(root),
                            onRotate: (0, $84fe879902ff3b51$export$ac278c6614346f4c)
                        }),
                        [
                            0,
                            1,
                            2,
                            3
                        ].map((g)=>/*#__PURE__*/ (0, $4XrX4.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($28UcW))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                                        type: "button",
                                        className: `ultraOuterFlip vertical g${g}`,
                                        onClick: ()=>(0, $84fe879902ff3b51$export$415532bd5f4f3998)(g, 'V'),
                                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($51ed7e09b9f5ed7e$exports))), {})
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                                        type: "button",
                                        className: `ultraOuterFlip horizontal g${g}`,
                                        onClick: ()=>(0, $84fe879902ff3b51$export$415532bd5f4f3998)(g, 'H'),
                                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($632b5fe9ab18dec8$exports))), {})
                                    })
                                ]
                            }, g))
                    ]
                })
            ]
        })
    });
});
/** Whether the puzzle was already solved when the board appeared (or within its first moments). */ const $982486b03f857d99$var$useSolvedOnLoad = (solved)=>{
    const mountedAt = (0, $28UcW.useRef)(Date.now());
    const solvedOnLoad = (0, $28UcW.useRef)(solved);
    (0, $28UcW.useEffect)(()=>{
        if (solved && Date.now() - mountedAt.current < 300) solvedOnLoad.current = true;
    }, [
        solved
    ]);
    return solvedOnLoad.current;
};
var $982486b03f857d99$export$2e2bcd8739ae039 = $982486b03f857d99$var$Board;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");





const $edb38a4a4086752f$var$closeInstructions = ()=>{
    (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((s)=>{
        s.instructionsAreOpen = false;
        s.isSoftPaused = false;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($a62237d662558d17$exports))).set(`${(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Ultrarubigram}InstructionsDismissed`, 'true', {
        domain: (0, $ba1e3b359abf28ef$export$517466abcb8fcf10),
        expires: 365
    });
};
const $edb38a4a4086752f$var$Instructions = ()=>{
    const isOpen = (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).useState((s)=>s.instructionsAreOpen);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $a923e83bee9905be$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: $edb38a4a4086752f$var$closeInstructions,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("h1", {
                className: "instructionsTitle",
                children: "How to Play the Ultrarubigram"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "instructionsBody",
                children: /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                            children: [
                                "Rotate and flip until every row and column ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                    className: "italicText",
                                    children: "longer than two letters"
                                }),
                                " spells a word from left-to-right and top-to-bottom."
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                            children: "Flip the 3x3 subgrids by clicking their non-corner cells."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                            children: "Flip the 6x6 quadrants with the small tabs on their edges. A tab shared by two quadrants is split: each half flips the quadrant it sits in."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                            children: "Flip the 12x12 grids with the arrows around the outside, and rotate them with the shaded buttons at their centers."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                            children: "The button at the very center rotates the whole puzzle."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                            children: "Right-click any rotate button to rotate counterclockwise."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                            children: "No obscure words and mostly no proper names."
                        })
                    ]
                })
            })
        ]
    });
};
var $edb38a4a4086752f$export$2e2bcd8739ae039 = $edb38a4a4086752f$var$Instructions;








/** Below this the puzzle can't be laid out legibly; it is a desktop puzzle. */ const $6e0123959b2b7179$var$MIN_WINDOW_WIDTH = 900;
const $6e0123959b2b7179$var$MIN_WINDOW_HEIGHT = 560;
/** Vertical space the puzzle can't use: site header + puzzle top bar, outer buttons, margins. */ const $6e0123959b2b7179$var$RESERVED_HEIGHT = 233;
const $6e0123959b2b7179$var$RESERVED_WIDTH = 144;
/** Borders: 24 cells plus the lines between and around them (see Ultrarubigram.less). */ const $6e0123959b2b7179$var$BORDER_WIDTH = 47;
const $6e0123959b2b7179$var$MIN_CELL = 16;
const $6e0123959b2b7179$var$MAX_CELL = 38;
/** One cell's size in whole pixels: as large as the window allows, so the 24x24 fits with room for the controls. */ const $6e0123959b2b7179$var$fitCellSize = ()=>{
    const byHeight = Math.floor((window.innerHeight - $6e0123959b2b7179$var$RESERVED_HEIGHT - $6e0123959b2b7179$var$BORDER_WIDTH) / 24);
    const byWidth = Math.floor((window.innerWidth - $6e0123959b2b7179$var$RESERVED_WIDTH - $6e0123959b2b7179$var$BORDER_WIDTH) / 24);
    return Math.max($6e0123959b2b7179$var$MIN_CELL, Math.min($6e0123959b2b7179$var$MAX_CELL, byHeight, byWidth));
};
const $6e0123959b2b7179$var$useWindowFit = ()=>{
    const measure = ()=>{
        const { innerWidth: width, innerHeight: height } = window;
        return {
            cell: $6e0123959b2b7179$var$fitCellSize(),
            tooSmall: width < $6e0123959b2b7179$var$MIN_WINDOW_WIDTH || height < $6e0123959b2b7179$var$MIN_WINDOW_HEIGHT,
            // A portrait tablet tall enough that, turned on its side, the window would pass.
            suggestLandscape: (0, $b2cd9ecc66d0956f$exports.isTablet) && height > width && height >= $6e0123959b2b7179$var$MIN_WINDOW_WIDTH && width >= $6e0123959b2b7179$var$MIN_WINDOW_HEIGHT
        };
    };
    const [fit, setFit] = (0, $28UcW.useState)(measure);
    (0, $28UcW.useEffect)(()=>{
        const onResize = ()=>setFit(measure());
        window.addEventListener('resize', onResize);
        return ()=>window.removeEventListener('resize', onResize);
    }, []);
    return fit;
};
const $6e0123959b2b7179$var$Ultrarubigram = ()=>{
    const { solved: solved, revealed: revealed, isRevealing: isRevealing } = (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).useState((s)=>({
            solved: s.solved,
            revealed: s.revealed,
            isRevealing: s.isRevealing
        }));
    const { cell: cell, tooSmall: tooSmall, suggestLandscape: suggestLandscape } = $6e0123959b2b7179$var$useWindowFit();
    (0, $ba1e3b359abf28ef$export$e73a86b2063a8f6b)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Ultrarubigram, (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882));
    (0, $ba1e3b359abf28ef$export$20d77ccceac0f55c)((0, $7d75cbd0e5d3963f$export$5f5aeb422b27882), (0, $84fe879902ff3b51$export$3f0ef2d61f406c77));
    (0, $ba1e3b359abf28ef$export$5b0326dddadcb0de)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Ultrarubigram);
    (0, $ba1e3b359abf28ef$export$52dc0a972e5b91c5)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Ultrarubigram);
    (0, $80f684051860af43$export$2500c8a6bc3f2f43)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Ultrarubigram);
    const containerClasses = 'puzzleContainer ultrarubigramContainer' + (solved ? ' solved' : '') + (revealed && !isRevealing ? ' revealed' : '');
    // Whole, even pixel sizes so the two halves of a shared flip tab rasterize identically.
    const containerStyle = {
        '--cell': `${cell}px`,
        '--tab': `${2 * Math.round(cell * 0.36)}px`
    };
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d549bcf7ed920b37$export$2e2bcd8739ae039), {
                puzzleName: (0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Ultrarubigram,
                store: (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882),
                onReveal: (0, $84fe879902ff3b51$export$7cf2f68092532300),
                onSave: (0, $84fe879902ff3b51$export$3f0ef2d61f406c77),
                InstructionsComponent: (0, $edb38a4a4086752f$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: containerClasses,
                style: containerStyle,
                children: [
                    tooSmall ? /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "desktopOnlyNotice",
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                children: [
                                    "The Ultrarubigram needs a window at least ",
                                    $6e0123959b2b7179$var$MIN_WINDOW_WIDTH,
                                    " pixels wide and ",
                                    $6e0123959b2b7179$var$MIN_WINDOW_HEIGHT,
                                    " tall."
                                ]
                            }),
                            suggestLandscape && /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                children: "Try turning your tablet to landscape."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $4XrX4.jsx)((0, $982486b03f857d99$export$2e2bcd8739ae039), {}),
                    revealed && !isRevealing && /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "outcomeBanner",
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                children: "Solution revealed. Try again next time!"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                children: "New Ultrarubigrams on the first of each month."
                            })
                        ]
                    }),
                    solved && /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "outcomeBanner",
                        children: "Solved! New Ultrarubigrams on the first of each month."
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $b9f68b54b1083b27$export$2e2bcd8739ae039), {
                        store: (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882)
                    })
                ]
            })
        ]
    });
};
var $6e0123959b2b7179$export$2e2bcd8739ae039 = $6e0123959b2b7179$var$Ultrarubigram;


var $e21ee5c453a3685c$export$2e2bcd8739ae039 = (0, $6e0123959b2b7179$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");




var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $25D7Q = parcelRequire("25D7Q");

var $1fz9F = parcelRequire("1fz9F");

var $aMDDU = parcelRequire("aMDDU");

var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");


var $1mNk8 = parcelRequire("1mNk8");

var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $0d95ca52356c3b48$export$5a6f9035944c8119(slot) {
    return (0, $dYzHx.default)('MuiButton', slot);
}
const $0d95ca52356c3b48$var$buttonClasses = (0, $d0ZgE.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
var $0d95ca52356c3b48$export$2e2bcd8739ae039 = $0d95ca52356c3b48$var$buttonClasses;



var $28UcW = parcelRequire("28UcW");
/**
 * @ignore - internal component.
 */ const $d76160a5326720b2$var$ButtonGroupContext = /*#__PURE__*/ $28UcW.createContext({});
var $d76160a5326720b2$export$2e2bcd8739ae039 = $d76160a5326720b2$var$ButtonGroupContext;



var $28UcW = parcelRequire("28UcW");
/**
 * @ignore - internal component.
 */ const $4b98a8784c98d75f$var$ButtonGroupButtonContext = /*#__PURE__*/ $28UcW.createContext(undefined);
var $4b98a8784c98d75f$export$2e2bcd8739ae039 = $4b98a8784c98d75f$var$ButtonGroupButtonContext;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $85c133b03e2ea24a$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $85c133b03e2ea24a$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, $1mNk8.default)(color)}`,
            `size${(0, $1mNk8.default)(size)}`,
            `${variant}Size${(0, $1mNk8.default)(size)}`,
            color === 'inherit' && 'colorInherit',
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'startIcon',
            `iconSize${(0, $1mNk8.default)(size)}`
        ],
        endIcon: [
            'endIcon',
            `iconSize${(0, $1mNk8.default)(size)}`
        ]
    };
    const composedClasses = (0, $1fz9F.default)(slots, (0, $0d95ca52356c3b48$export$5a6f9035944c8119), classes);
    return (0, $kLZMq.default)({}, classes, composedClasses);
};
const $85c133b03e2ea24a$var$commonIconStyles = (ownerState)=>(0, $kLZMq.default)({}, ownerState.size === 'small' && {
        '& > *:nth-of-type(1)': {
            fontSize: 18
        }
    }, ownerState.size === 'medium' && {
        '& > *:nth-of-type(1)': {
            fontSize: 20
        }
    }, ownerState.size === 'large' && {
        '& > *:nth-of-type(1)': {
            fontSize: 22
        }
    });
const $85c133b03e2ea24a$var$ButtonRoot = (0, $k5hQd.default)((0, $120c91fa1d9b1234$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $k5hQd.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $1mNk8.default)(ownerState.color)}`],
            styles[`size${(0, $1mNk8.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $1mNk8.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $kLZMq.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': (0, $kLZMq.default)({
            textDecoration: 'none',
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aMDDU.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aMDDU.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aMDDU.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'contained' && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        '&:active': (0, $kLZMq.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $0d95ca52356c3b48$export$2e2bcd8739ae039).focusVisible}`]: (0, $kLZMq.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $0d95ca52356c3b48$export$2e2bcd8739ae039).disabled}`]: (0, $kLZMq.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === 'outlined' && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === 'contained' && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === 'text' && {
        padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
        padding: '5px 15px',
        border: '1px solid currentColor'
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $aMDDU.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === 'contained' && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
        padding: '4px 5px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
        padding: '8px 11px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        padding: '3px 9px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
        padding: '7px 21px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
        padding: '4px 10px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
        padding: '8px 22px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: '100%'
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none'
        },
        [`&.${(0, $0d95ca52356c3b48$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none'
        },
        [`&.${(0, $0d95ca52356c3b48$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: 'none'
        }
    });
const $85c133b03e2ea24a$var$ButtonStartIcon = (0, $k5hQd.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $1mNk8.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kLZMq.default)({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === 'small' && {
        marginLeft: -2
    }, $85c133b03e2ea24a$var$commonIconStyles(ownerState)));
const $85c133b03e2ea24a$var$ButtonEndIcon = (0, $k5hQd.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $1mNk8.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kLZMq.default)({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === 'small' && {
        marginRight: -2
    }, $85c133b03e2ea24a$var$commonIconStyles(ownerState)));
const $85c133b03e2ea24a$var$Button = /*#__PURE__*/ $28UcW.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $28UcW.useContext((0, $d76160a5326720b2$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $28UcW.useContext((0, $4b98a8784c98d75f$export$2e2bcd8739ae039));
    const resolvedProps = (0, $25D7Q.default)(contextProps, inProps);
    const props = (0, $l9mID.default)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $53Ou4.default)(props, $85c133b03e2ea24a$var$_excluded);
    const ownerState = (0, $kLZMq.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $85c133b03e2ea24a$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $4XrX4.jsx)($85c133b03e2ea24a$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $4XrX4.jsx)($85c133b03e2ea24a$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $4XrX4.jsxs)($85c133b03e2ea24a$var$ButtonRoot, (0, $kLZMq.default)({
        ownerState: ownerState,
        className: (0, $dP0oo.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $dP0oo.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $85c133b03e2ea24a$export$2e2bcd8739ae039 = $85c133b03e2ea24a$var$Button;



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");



var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $1fz9F = parcelRequire("1fz9F");



var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");

var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $1fz9F = parcelRequire("1fz9F");

var $8HP8E = parcelRequire("8HP8E");


var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $3H5bK = parcelRequire("3H5bK");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");



var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $28UcW = parcelRequire("28UcW");



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $53219937b3211161$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $53219937b3211161$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $53219937b3211161$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $53219937b3211161$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $53219937b3211161$export$d1710922ecaf577a = /*#__PURE__*/ $28UcW.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $53Ou4.default)(props, $53219937b3211161$var$_excluded);
    const { current: isControlled } = $28UcW.useRef(value != null);
    const inputRef = $28UcW.useRef(null);
    const handleRef = (0, $39cf289415cf806e$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const shadowRef = $28UcW.useRef(null);
    const calculateTextareaStyles = $28UcW.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $c66694b6fb06134f$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || 'x';
        if (inputShallow.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $53219937b3211161$var$getStyleValue(computedStyle.paddingBottom) + $53219937b3211161$var$getStyleValue(computedStyle.paddingTop);
        const border = $53219937b3211161$var$getStyleValue(computedStyle.borderBottomWidth) + $53219937b3211161$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = 'x';
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const syncHeight = $28UcW.useCallback(()=>{
        const textareaStyles = calculateTextareaStyles();
        if ($53219937b3211161$var$isEmpty(textareaStyles)) return;
        const input = inputRef.current;
        input.style.height = `${textareaStyles.outerHeightStyle}px`;
        input.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    (0, $8a0c5c067d762282$export$2e2bcd8739ae039)(()=>{
        const handleResize = ()=>{
            syncHeight();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $3404783e704c4a0b$export$2e2bcd8739ae039)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $c66694b6fb06134f$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener('resize', debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener('resize', debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight
    ]);
    (0, $8a0c5c067d762282$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $4XrX4.jsxs)($28UcW.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("textarea", (0, $kLZMq.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows
            }, other)),
            /*#__PURE__*/ (0, $4XrX4.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $kLZMq.default)({}, $53219937b3211161$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});




var $1fz9F = parcelRequire("1fz9F");
function $f7e6aeeb255be989$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $28UcW = parcelRequire("28UcW");
/**
 * @ignore - internal component.
 */ const $f2b37f5e00362c7e$var$FormControlContext = /*#__PURE__*/ $28UcW.createContext(undefined);
var $f2b37f5e00362c7e$export$2e2bcd8739ae039 = $f2b37f5e00362c7e$var$FormControlContext;



var $28UcW = parcelRequire("28UcW");

'use client';
function $63d2db91a3914164$export$2e2bcd8739ae039() {
    return $28UcW.useContext((0, $f2b37f5e00362c7e$export$2e2bcd8739ae039));
}



var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");

var $1mNk8 = parcelRequire("1mNk8");



var $kLZMq = parcelRequire("kLZMq");
parcelRequire("28UcW");

parcelRequire("28UcW");


var $H0lho = parcelRequire("H0lho");

var $5jh9n = parcelRequire("5jh9n");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
function $caf353245435d2dd$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $5jh9n.default)(defaultTheme);
    const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $H0lho.default), {
        styles: globalStyles
    });
}
var $caf353245435d2dd$export$2e2bcd8739ae039 = $caf353245435d2dd$var$GlobalStyles;



var $dpWha = parcelRequire("dpWha");

var $RjrfP = parcelRequire("RjrfP");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
function $7e397f290e8d4222$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $caf353245435d2dd$export$2e2bcd8739ae039), (0, $kLZMq.default)({}, props, {
        defaultTheme: (0, $dpWha.default),
        themeId: (0, $RjrfP.default)
    }));
}
var $7e397f290e8d4222$export$2e2bcd8739ae039 = $7e397f290e8d4222$var$GlobalStyles;


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $018e7a3c66678698$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $018e7a3c66678698$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($018e7a3c66678698$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $018e7a3c66678698$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $018e7a3c66678698$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $8627db0e4b38589a$export$ef57d5c8ca2278f6(slot) {
    return (0, $dYzHx.default)('MuiInputBase', slot);
}
const $8627db0e4b38589a$var$inputBaseClasses = (0, $d0ZgE.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $8627db0e4b38589a$export$2e2bcd8739ae039 = $8627db0e4b38589a$var$inputBaseClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $fdfdc2e3225ccabb$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $fdfdc2e3225ccabb$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $1mNk8.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $fdfdc2e3225ccabb$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $fdfdc2e3225ccabb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $1mNk8.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $1mNk8.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $8627db0e4b38589a$export$ef57d5c8ca2278f6), classes);
};
const $fdfdc2e3225ccabb$export$298a043133d72a38 = (0, $k5hQd.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $fdfdc2e3225ccabb$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $kLZMq.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $8627db0e4b38589a$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        }
    }, ownerState.multiline && (0, $kLZMq.default)({
        padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: '100%'
    }));
const $fdfdc2e3225ccabb$export$a1ad29c901026019 = (0, $k5hQd.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $fdfdc2e3225ccabb$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, $kLZMq.default)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $kLZMq.default)({
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        // Fix IE11 width issue
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholder,
        // IE11
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $8627db0e4b38589a$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholderHidden,
            // IE11
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus:-ms-input-placeholder': placeholderVisible,
            // IE11
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $8627db0e4b38589a$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        '&:-webkit-autofill': {
            animationDuration: '5000s',
            animationName: 'mui-auto-fill'
        }
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: 'auto',
        resize: 'none',
        padding: 0,
        paddingTop: 0
    }, ownerState.type === 'search' && {
        // Improve type search style.
        MozAppearance: 'textfield'
    });
});
const $fdfdc2e3225ccabb$var$inputGlobalStyles = /*#__PURE__*/ (0, $4XrX4.jsx)((0, $7e397f290e8d4222$export$2e2bcd8739ae039), {
    styles: {
        '@keyframes mui-auto-fill': {
            from: {
                display: 'block'
            }
        },
        '@keyframes mui-auto-fill-cancel': {
            from: {
                display: 'block'
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $fdfdc2e3225ccabb$var$InputBase = /*#__PURE__*/ $28UcW.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp } = props, other = (0, $53Ou4.default)(props, $fdfdc2e3225ccabb$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $28UcW.useRef(value != null);
    const inputRef = $28UcW.useRef();
    const handleInputRefWarning = $28UcW.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $7d57efcdf4f58771$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $28UcW.useState(false);
    const muiFormControl = (0, $63d2db91a3914164$export$2e2bcd8739ae039)();
    const fcs = (0, $f7e6aeeb255be989$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $28UcW.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $28UcW.useCallback((obj)=>{
        if ((0, $018e7a3c66678698$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $1c9ca6404a5190fd$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $3H5bK.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $28UcW.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = (0, $kLZMq.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $kLZMq.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $53219937b3211161$export$d1710922ecaf577a);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $28UcW.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $kLZMq.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $fdfdc2e3225ccabb$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $fdfdc2e3225ccabb$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $fdfdc2e3225ccabb$export$a1ad29c901026019;
    inputProps = (0, $kLZMq.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)($28UcW.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $fdfdc2e3225ccabb$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $4XrX4.jsxs)(Root, (0, $kLZMq.default)({}, rootProps, !(0, $565736d32b3dfb1b$export$e28348cc2430497)(Root) && {
                ownerState: (0, $kLZMq.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $dP0oo.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f2b37f5e00362c7e$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)(Input, (0, $kLZMq.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $565736d32b3dfb1b$export$e28348cc2430497)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $kLZMq.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $dP0oo.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $kLZMq.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $fdfdc2e3225ccabb$export$2e2bcd8739ae039 = $fdfdc2e3225ccabb$var$InputBase;



var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");

var $kLZMq = parcelRequire("kLZMq");

var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");

function $1ae52075288925f1$export$cdb270390122322b(slot) {
    return (0, $dYzHx.default)('MuiInput', slot);
}
const $1ae52075288925f1$var$inputClasses = (0, $kLZMq.default)({}, (0, $8627db0e4b38589a$export$2e2bcd8739ae039), (0, $d0ZgE.default)('MuiInput', [
    'root',
    'underline',
    'input'
]));
var $1ae52075288925f1$export$2e2bcd8739ae039 = $1ae52075288925f1$var$inputClasses;




var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $10a147f6af35f8d7$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $10a147f6af35f8d7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $1fz9F.default)(slots, (0, $1ae52075288925f1$export$cdb270390122322b), classes);
    return (0, $kLZMq.default)({}, classes, composedClasses);
};
const $10a147f6af35f8d7$var$InputRoot = (0, $k5hQd.default)((0, $fdfdc2e3225ccabb$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $k5hQd.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $fdfdc2e3225ccabb$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $kLZMq.default)({
        position: 'relative'
    }, ownerState.formControl && {
        'label + &': {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $1ae52075288925f1$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $1ae52075288925f1$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $1ae52075288925f1$export$2e2bcd8739ae039).disabled}, .${(0, $1ae52075288925f1$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $1ae52075288925f1$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    });
});
const $10a147f6af35f8d7$var$InputInput = (0, $k5hQd.default)((0, $fdfdc2e3225ccabb$export$a1ad29c901026019), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $fdfdc2e3225ccabb$export$cf507b112810e72d)
})({});
const $10a147f6af35f8d7$var$Input = /*#__PURE__*/ $28UcW.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $53Ou4.default)(props, $10a147f6af35f8d7$var$_excluded);
    const classes = $10a147f6af35f8d7$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $8HP8E.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $10a147f6af35f8d7$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $10a147f6af35f8d7$var$InputInput;
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $fdfdc2e3225ccabb$export$2e2bcd8739ae039), (0, $kLZMq.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$10a147f6af35f8d7$var$Input.muiName = 'Input';
var $10a147f6af35f8d7$export$2e2bcd8739ae039 = $10a147f6af35f8d7$var$Input;



var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");

var $8HP8E = parcelRequire("8HP8E");



var $1fz9F = parcelRequire("1fz9F");


var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");

var $kLZMq = parcelRequire("kLZMq");

var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");

function $9c3bce205efbcc44$export$3331e419f1a48437(slot) {
    return (0, $dYzHx.default)('MuiFilledInput', slot);
}
const $9c3bce205efbcc44$var$filledInputClasses = (0, $kLZMq.default)({}, (0, $8627db0e4b38589a$export$2e2bcd8739ae039), (0, $d0ZgE.default)('MuiFilledInput', [
    'root',
    'underline',
    'input'
]));
var $9c3bce205efbcc44$export$2e2bcd8739ae039 = $9c3bce205efbcc44$var$filledInputClasses;




var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $2da6af70f10a5956$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $2da6af70f10a5956$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $1fz9F.default)(slots, (0, $9c3bce205efbcc44$export$3331e419f1a48437), classes);
    return (0, $kLZMq.default)({}, classes, composedClasses);
};
const $2da6af70f10a5956$var$FilledInputRoot = (0, $k5hQd.default)((0, $fdfdc2e3225ccabb$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $k5hQd.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $fdfdc2e3225ccabb$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return (0, $kLZMq.default)({
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $9c3bce205efbcc44$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $9c3bce205efbcc44$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $9c3bce205efbcc44$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $9c3bce205efbcc44$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $9c3bce205efbcc44$export$2e2bcd8739ae039).disabled}, .${(0, $9c3bce205efbcc44$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $9c3bce205efbcc44$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $kLZMq.default)({
        padding: '25px 12px 8px'
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $2da6af70f10a5956$var$FilledInputInput = (0, $k5hQd.default)((0, $fdfdc2e3225ccabb$export$a1ad29c901026019), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $fdfdc2e3225ccabb$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $kLZMq.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $2da6af70f10a5956$var$FilledInput = /*#__PURE__*/ $28UcW.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $53Ou4.default)(props, $2da6af70f10a5956$var$_excluded);
    const ownerState = (0, $kLZMq.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $2da6af70f10a5956$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $8HP8E.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $2da6af70f10a5956$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $2da6af70f10a5956$var$FilledInputInput;
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $fdfdc2e3225ccabb$export$2e2bcd8739ae039), (0, $kLZMq.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$2da6af70f10a5956$var$FilledInput.muiName = 'Input';
var $2da6af70f10a5956$export$2e2bcd8739ae039 = $2da6af70f10a5956$var$FilledInput;



var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");



var $1fz9F = parcelRequire("1fz9F");

var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");
parcelRequire("28UcW");


var $k5hQd = parcelRequire("k5hQd");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
var $6b4487df9b52fff3$var$_span;
const $6b4487df9b52fff3$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $6b4487df9b52fff3$var$NotchedOutlineRoot = (0, $k5hQd.default)('fieldset', {
    shouldForwardProp: (0, $k5hQd.rootShouldForwardProp)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $6b4487df9b52fff3$var$NotchedOutlineLegend = (0, $k5hQd.default)('legend', {
    shouldForwardProp: (0, $k5hQd.rootShouldForwardProp)
})(({ ownerState: ownerState, theme: theme })=>(0, $kLZMq.default)({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden'
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: '11px',
        // sync with `height` in `legend` styles
        transition: theme.transitions.create('width', {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $kLZMq.default)({
        display: 'block',
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: '0.75em',
        visibility: 'hidden',
        maxWidth: 0.01,
        transition: theme.transitions.create('max-width', {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: 'nowrap',
        '& > span': {
            paddingLeft: 5,
            paddingRight: 5,
            display: 'inline-block',
            opacity: 0,
            visibility: 'visible'
        }
    }, ownerState.notched && {
        maxWidth: '100%',
        transition: theme.transitions.create('max-width', {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $6b4487df9b52fff3$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $53Ou4.default)(props, $6b4487df9b52fff3$var$_excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $kLZMq.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $4XrX4.jsx)($6b4487df9b52fff3$var$NotchedOutlineRoot, (0, $kLZMq.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $4XrX4.jsx)($6b4487df9b52fff3$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                children: label
            }) : $6b4487df9b52fff3$var$_span || ($6b4487df9b52fff3$var$_span = /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $k5hQd = parcelRequire("k5hQd");

var $kLZMq = parcelRequire("kLZMq");

var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");

function $a348efedc8b39c84$export$89922944c7227687(slot) {
    return (0, $dYzHx.default)('MuiOutlinedInput', slot);
}
const $a348efedc8b39c84$var$outlinedInputClasses = (0, $kLZMq.default)({}, (0, $8627db0e4b38589a$export$2e2bcd8739ae039), (0, $d0ZgE.default)('MuiOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
var $a348efedc8b39c84$export$2e2bcd8739ae039 = $a348efedc8b39c84$var$outlinedInputClasses;




var $l9mID = parcelRequire("l9mID");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $da732c41ad7dddd4$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $da732c41ad7dddd4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $1fz9F.default)(slots, (0, $a348efedc8b39c84$export$89922944c7227687), classes);
    return (0, $kLZMq.default)({}, classes, composedClasses);
};
const $da732c41ad7dddd4$var$OutlinedInputRoot = (0, $k5hQd.default)((0, $fdfdc2e3225ccabb$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $k5hQd.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $fdfdc2e3225ccabb$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return (0, $kLZMq.default)({
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $a348efedc8b39c84$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $a348efedc8b39c84$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $a348efedc8b39c84$export$2e2bcd8739ae039).focused} .${(0, $a348efedc8b39c84$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $a348efedc8b39c84$export$2e2bcd8739ae039).error} .${(0, $a348efedc8b39c84$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $a348efedc8b39c84$export$2e2bcd8739ae039).disabled} .${(0, $a348efedc8b39c84$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $kLZMq.default)({
        padding: '16.5px 14px'
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }));
});
const $da732c41ad7dddd4$var$NotchedOutlineRoot = (0, $k5hQd.default)((0, $6b4487df9b52fff3$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $da732c41ad7dddd4$var$OutlinedInputInput = (0, $k5hQd.default)((0, $fdfdc2e3225ccabb$export$a1ad29c901026019), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $fdfdc2e3225ccabb$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $kLZMq.default)({
        padding: '16.5px 14px'
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $da732c41ad7dddd4$var$OutlinedInput = /*#__PURE__*/ $28UcW.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = 'text' } = props, other = (0, $53Ou4.default)(props, $da732c41ad7dddd4$var$_excluded);
    const classes = $da732c41ad7dddd4$var$useUtilityClasses(props);
    const muiFormControl = (0, $63d2db91a3914164$export$2e2bcd8739ae039)();
    const fcs = (0, $f7e6aeeb255be989$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = (0, $kLZMq.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $da732c41ad7dddd4$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $da732c41ad7dddd4$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $fdfdc2e3225ccabb$export$2e2bcd8739ae039), (0, $kLZMq.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $4XrX4.jsx)($da732c41ad7dddd4$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $4XrX4.jsxs)($28UcW.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $kLZMq.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$da732c41ad7dddd4$var$OutlinedInput.muiName = 'Input';
var $da732c41ad7dddd4$export$2e2bcd8739ae039 = $da732c41ad7dddd4$var$OutlinedInput;



var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $1fz9F = parcelRequire("1fz9F");

var $dP0oo = parcelRequire("dP0oo");



var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $1fz9F = parcelRequire("1fz9F");



var $1mNk8 = parcelRequire("1mNk8");

var $l9mID = parcelRequire("l9mID");

var $k5hQd = parcelRequire("k5hQd");

var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $ec3ff321fe648d10$export$f7d501e40371cd17(slot) {
    return (0, $dYzHx.default)('MuiFormLabel', slot);
}
const $ec3ff321fe648d10$var$formLabelClasses = (0, $d0ZgE.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $ec3ff321fe648d10$export$2e2bcd8739ae039 = $ec3ff321fe648d10$var$formLabelClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $ed0290a2a1b80546$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $ed0290a2a1b80546$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $1mNk8.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $ec3ff321fe648d10$export$f7d501e40371cd17), classes);
};
const $ed0290a2a1b80546$export$aa5bc7f8a4705b27 = (0, $k5hQd.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $kLZMq.default)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kLZMq.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        [`&.${(0, $ec3ff321fe648d10$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $ec3ff321fe648d10$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $ec3ff321fe648d10$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $ed0290a2a1b80546$var$AsteriskComponent = (0, $k5hQd.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $ec3ff321fe648d10$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $ed0290a2a1b80546$var$FormLabel = /*#__PURE__*/ $28UcW.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, component: component = 'label' } = props, other = (0, $53Ou4.default)(props, $ed0290a2a1b80546$var$_excluded);
    const muiFormControl = (0, $63d2db91a3914164$export$2e2bcd8739ae039)();
    const fcs = (0, $f7e6aeeb255be989$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = (0, $kLZMq.default)({}, props, {
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $ed0290a2a1b80546$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)($ed0290a2a1b80546$export$aa5bc7f8a4705b27, (0, $kLZMq.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $dP0oo.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $4XrX4.jsxs)($ed0290a2a1b80546$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    }));
});
var $ed0290a2a1b80546$export$2e2bcd8739ae039 = $ed0290a2a1b80546$var$FormLabel;



var $l9mID = parcelRequire("l9mID");

var $1mNk8 = parcelRequire("1mNk8");

var $k5hQd = parcelRequire("k5hQd");

var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $3ba5c84a1c354bb5$export$c1c4b4545ad2ea5f(slot) {
    return (0, $dYzHx.default)('MuiInputLabel', slot);
}
const $3ba5c84a1c354bb5$var$inputLabelClasses = (0, $d0ZgE.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $3ba5c84a1c354bb5$export$2e2bcd8739ae039 = $3ba5c84a1c354bb5$var$inputLabelClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $6895abd85aef8ffe$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $6895abd85aef8ffe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $1mNk8.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $1fz9F.default)(slots, (0, $3ba5c84a1c354bb5$export$c1c4b4545ad2ea5f), classes);
    return (0, $kLZMq.default)({}, classes, composedClasses);
};
const $6895abd85aef8ffe$var$InputLabelRoot = (0, $k5hQd.default)((0, $ed0290a2a1b80546$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $k5hQd.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $ec3ff321fe648d10$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kLZMq.default)({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
    }, ownerState.formControl && {
        position: 'absolute',
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: 'translate(0, 20px) scale(1)'
    }, ownerState.size === 'small' && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: 'translate(0, 17px) scale(1)'
    }, ownerState.shrink && {
        transform: 'translate(0, -1.5px) scale(0.75)',
        transformOrigin: 'top left',
        maxWidth: '133%'
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            'color',
            'transform',
            'max-width'
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === 'filled' && (0, $kLZMq.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(12px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 13px) scale(1)'
    }, ownerState.shrink && (0, $kLZMq.default)({
        userSelect: 'none',
        pointerEvents: 'auto',
        transform: 'translate(12px, 7px) scale(0.75)',
        maxWidth: 'calc(133% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 4px) scale(0.75)'
    })), ownerState.variant === 'outlined' && (0, $kLZMq.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(14px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(14px, 9px) scale(1)'
    }, ownerState.shrink && {
        userSelect: 'none',
        pointerEvents: 'auto',
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: 'calc(133% - 32px)',
        transform: 'translate(14px, -9px) scale(0.75)'
    })));
const $6895abd85aef8ffe$var$InputLabel = /*#__PURE__*/ $28UcW.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $l9mID.default)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $53Ou4.default)(props, $6895abd85aef8ffe$var$_excluded);
    const muiFormControl = (0, $63d2db91a3914164$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $f7e6aeeb255be989$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = (0, $kLZMq.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $6895abd85aef8ffe$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4XrX4.jsx)($6895abd85aef8ffe$var$InputLabelRoot, (0, $kLZMq.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $dP0oo.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $6895abd85aef8ffe$export$2e2bcd8739ae039 = $6895abd85aef8ffe$var$InputLabel;



var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $1fz9F = parcelRequire("1fz9F");

var $l9mID = parcelRequire("l9mID");

var $k5hQd = parcelRequire("k5hQd");


var $1mNk8 = parcelRequire("1mNk8");

var $28UcW = parcelRequire("28UcW");
function $2fd35d9935fc324b$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $28UcW.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $499d0c7cb919eee5$export$2e2bcd8739ae039 = (0, $2fd35d9935fc324b$export$2e2bcd8739ae039);




var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $346e346f065ed7f8$export$149c8b8bab2289d1(slot) {
    return (0, $dYzHx.default)('MuiFormControl', slot);
}
const $346e346f065ed7f8$var$formControlClasses = (0, $d0ZgE.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $346e346f065ed7f8$export$2e2bcd8739ae039 = $346e346f065ed7f8$var$formControlClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $5a094b6730918899$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $5a094b6730918899$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $1mNk8.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $346e346f065ed7f8$export$149c8b8bab2289d1), classes);
};
const $5a094b6730918899$var$FormControlRoot = (0, $k5hQd.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $kLZMq.default)({}, styles.root, styles[`margin${(0, $1mNk8.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $kLZMq.default)({
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top'
    }, ownerState.margin === 'normal' && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === 'dense' && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: '100%'
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $5a094b6730918899$var$FormControl = /*#__PURE__*/ $28UcW.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $53Ou4.default)(props, $5a094b6730918899$var$_excluded);
    const ownerState = (0, $kLZMq.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $5a094b6730918899$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $28UcW.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $28UcW.Children.forEach(children, (child)=>{
            if (!(0, $499d0c7cb919eee5$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $499d0c7cb919eee5$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $018e7a3c66678698$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $28UcW.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $28UcW.Children.forEach(children, (child)=>{
            if (!(0, $499d0c7cb919eee5$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $018e7a3c66678698$export$d652b828d7fdeff8)(child.props, true) || (0, $018e7a3c66678698$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $28UcW.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $28UcW.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f2b37f5e00362c7e$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $4XrX4.jsx)($5a094b6730918899$var$FormControlRoot, (0, $kLZMq.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $dP0oo.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $5a094b6730918899$export$2e2bcd8739ae039 = $5a094b6730918899$var$FormControl;



var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $1fz9F = parcelRequire("1fz9F");



var $k5hQd = parcelRequire("k5hQd");

var $1mNk8 = parcelRequire("1mNk8");

var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $fdfcf715b390e01f$export$a394fa61b1d583a9(slot) {
    return (0, $dYzHx.default)('MuiFormHelperText', slot);
}
const $fdfcf715b390e01f$var$formHelperTextClasses = (0, $d0ZgE.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $fdfcf715b390e01f$export$2e2bcd8739ae039 = $fdfcf715b390e01f$var$formHelperTextClasses;



var $l9mID = parcelRequire("l9mID");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
var $c1d51d233b523c7f$var$_span;
const $c1d51d233b523c7f$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $c1d51d233b523c7f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $1mNk8.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $fdfcf715b390e01f$export$a394fa61b1d583a9), classes);
};
const $c1d51d233b523c7f$var$FormHelperTextRoot = (0, $k5hQd.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $1mNk8.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kLZMq.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $fdfcf715b390e01f$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $fdfcf715b390e01f$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === 'small' && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $c1d51d233b523c7f$var$FormHelperText = /*#__PURE__*/ $28UcW.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p' } = props, other = (0, $53Ou4.default)(props, $c1d51d233b523c7f$var$_excluded);
    const muiFormControl = (0, $63d2db91a3914164$export$2e2bcd8739ae039)();
    const fcs = (0, $f7e6aeeb255be989$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = (0, $kLZMq.default)({}, props, {
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $c1d51d233b523c7f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4XrX4.jsx)($c1d51d233b523c7f$var$FormHelperTextRoot, (0, $kLZMq.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $dP0oo.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === ' ' ? $c1d51d233b523c7f$var$_span || ($c1d51d233b523c7f$var$_span = /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $c1d51d233b523c7f$export$2e2bcd8739ae039 = $c1d51d233b523c7f$var$FormHelperText;



var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $8HP8E = parcelRequire("8HP8E");

var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $3H5bK = parcelRequire("3H5bK");

var $28UcW = parcelRequire("28UcW");
parcelRequire("d79ZO");


var $dP0oo = parcelRequire("dP0oo");

var $1fz9F = parcelRequire("1fz9F");




var $1mNk8 = parcelRequire("1mNk8");


var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");


var $1fz9F = parcelRequire("1fz9F");

var $1mNk8 = parcelRequire("1mNk8");

var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $cb4419af79a30f3e$export$1ee13051fd9e2ab5(slot) {
    return (0, $dYzHx.default)('MuiNativeSelect', slot);
}
const $cb4419af79a30f3e$var$nativeSelectClasses = (0, $d0ZgE.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $cb4419af79a30f3e$export$2e2bcd8739ae039 = $cb4419af79a30f3e$var$nativeSelectClasses;



var $k5hQd = parcelRequire("k5hQd");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $d27be2993519aec9$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $d27be2993519aec9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $1mNk8.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $cb4419af79a30f3e$export$1ee13051fd9e2ab5), classes);
};
const $d27be2993519aec9$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $kLZMq.default)({
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        borderRadius: 0,
        // Reset
        cursor: 'pointer',
        '&:focus': (0, $kLZMq.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        '&::-ms-expand': {
            display: 'none'
        },
        [`&.${(0, $cb4419af79a30f3e$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        '&&&': {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === 'filled' && {
        '&&&': {
            paddingRight: 32
        }
    }, ownerState.variant === 'outlined' && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        '&:focus': {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        '&&&': {
            paddingRight: 32
        }
    });
const $d27be2993519aec9$var$NativeSelectSelect = (0, $k5hQd.default)('select', {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $k5hQd.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $cb4419af79a30f3e$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($d27be2993519aec9$export$c1eccd1617458c87);
const $d27be2993519aec9$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $kLZMq.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        top: 'calc(50% - .5em)',
        // Center vertically, height is 1em
        pointerEvents: 'none',
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $cb4419af79a30f3e$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: 'rotate(180deg)'
    }, ownerState.variant === 'filled' && {
        right: 7
    }, ownerState.variant === 'outlined' && {
        right: 7
    });
const $d27be2993519aec9$var$NativeSelectIcon = (0, $k5hQd.default)('svg', {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $1mNk8.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($d27be2993519aec9$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $d27be2993519aec9$var$NativeSelectInput = /*#__PURE__*/ $28UcW.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard' } = props, other = (0, $53Ou4.default)(props, $d27be2993519aec9$var$_excluded);
    const ownerState = (0, $kLZMq.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $d27be2993519aec9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)($28UcW.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)($d27be2993519aec9$var$NativeSelectSelect, (0, $kLZMq.default)({
                ownerState: ownerState,
                className: (0, $dP0oo.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $4XrX4.jsx)($d27be2993519aec9$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $d27be2993519aec9$export$2e2bcd8739ae039 = $d27be2993519aec9$var$NativeSelectInput;




var $k5hQd = parcelRequire("k5hQd");


var $28UcW = parcelRequire("28UcW");
'use client';
function $42df564297299a49$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $28UcW.useRef(controlled !== undefined);
    const [valueState, setValue] = $28UcW.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $28UcW.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
var $5dc34960420057aa$export$2e2bcd8739ae039 = (0, $42df564297299a49$export$2e2bcd8739ae039);



var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $e96757f66d1d5040$export$2c0c1ee5a3392e(slot) {
    return (0, $dYzHx.default)('MuiSelect', slot);
}
const $e96757f66d1d5040$var$selectClasses = (0, $d0ZgE.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $e96757f66d1d5040$export$2e2bcd8739ae039 = $e96757f66d1d5040$var$selectClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
var $6c4128e52851b793$var$_span;
const $6c4128e52851b793$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $6c4128e52851b793$var$SelectSelect = (0, $k5hQd.default)('div', {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $e96757f66d1d5040$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $e96757f66d1d5040$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $e96757f66d1d5040$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $e96757f66d1d5040$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $d27be2993519aec9$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $e96757f66d1d5040$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $6c4128e52851b793$var$SelectIcon = (0, $k5hQd.default)('svg', {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $1mNk8.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $d27be2993519aec9$export$e7a817afd12a40d0));
const $6c4128e52851b793$var$SelectNativeInput = (0, $k5hQd.default)('input', {
    shouldForwardProp: (prop)=>(0, $k5hQd.slotShouldForwardProp)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $6c4128e52851b793$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $6c4128e52851b793$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $6c4128e52851b793$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $1mNk8.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $e96757f66d1d5040$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $6c4128e52851b793$var$SelectInput = /*#__PURE__*/ $28UcW.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = 'standard' } = props, other = (0, $53Ou4.default)(props, $6c4128e52851b793$var$_excluded);
    const [value, setValueState] = (0, $5dc34960420057aa$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $5dc34960420057aa$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $28UcW.useRef(null);
    const displayRef = $28UcW.useRef(null);
    const [displayNode, setDisplayNode] = $28UcW.useState(null);
    const { current: isOpenControlled } = $28UcW.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $28UcW.useState();
    const handleRef = (0, $7d57efcdf4f58771$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $28UcW.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $28UcW.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $28UcW.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $28UcW.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $28UcW.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $365128ae56094f12$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $28UcW.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $018e7a3c66678698$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $28UcW.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $3H5bK.default)(2));
            selected = value.some((v)=>$6c4128e52851b793$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $6c4128e52851b793$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $28UcW.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $kLZMq.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $6c4128e52851b793$var$useUtilityClasses(ownerState);
    const paperProps = (0, $kLZMq.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $930be18af46897d8$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $4XrX4.jsxs)($28UcW.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)($6c4128e52851b793$var$SelectSelect, (0, $kLZMq.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $dP0oo.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $6c4128e52851b793$var$isEmpty(display) ? $6c4128e52851b793$var$_span || ($6c4128e52851b793$var$_span = /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $4XrX4.jsx)($6c4128e52851b793$var$SelectNativeInput, (0, $kLZMq.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $4XrX4.jsx)($6c4128e52851b793$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $253324ab0d2d0f8a$export$2e2bcd8739ae039), (0, $kLZMq.default)({
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            }, MenuProps, {
                MenuListProps: (0, $kLZMq.default)({
                    'aria-labelledby': labelId,
                    role: 'listbox',
                    'aria-multiselectable': multiple ? 'true' : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $kLZMq.default)({}, MenuProps.slotProps, {
                    paper: (0, $kLZMq.default)({}, paperProps, {
                        style: (0, $kLZMq.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $6c4128e52851b793$export$2e2bcd8739ae039 = $6c4128e52851b793$var$SelectInput;




parcelRequire("28UcW");

var $hjLll = parcelRequire("hjLll");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
var $213efc08f1e4be57$export$2e2bcd8739ae039 = (0, $hjLll.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');







var $l9mID = parcelRequire("l9mID");


var $k5hQd = parcelRequire("k5hQd");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $ad474e46ba9e8e25$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $ad474e46ba9e8e25$var$_excluded2 = [
    "root"
];
const $ad474e46ba9e8e25$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $ad474e46ba9e8e25$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $k5hQd.rootShouldForwardProp)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $ad474e46ba9e8e25$var$StyledInput = (0, $k5hQd.default)((0, $10a147f6af35f8d7$export$2e2bcd8739ae039), $ad474e46ba9e8e25$var$styledRootConfig)('');
const $ad474e46ba9e8e25$var$StyledOutlinedInput = (0, $k5hQd.default)((0, $da732c41ad7dddd4$export$2e2bcd8739ae039), $ad474e46ba9e8e25$var$styledRootConfig)('');
const $ad474e46ba9e8e25$var$StyledFilledInput = (0, $k5hQd.default)((0, $2da6af70f10a5956$export$2e2bcd8739ae039), $ad474e46ba9e8e25$var$styledRootConfig)('');
const $ad474e46ba9e8e25$var$Select = /*#__PURE__*/ $28UcW.forwardRef(function Select(inProps, ref) {
    const props = (0, $l9mID.default)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $213efc08f1e4be57$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined' } = props, other = (0, $53Ou4.default)(props, $ad474e46ba9e8e25$var$_excluded);
    const inputComponent = native ? (0, $d27be2993519aec9$export$2e2bcd8739ae039) : (0, $6c4128e52851b793$export$2e2bcd8739ae039);
    const muiFormControl = (0, $63d2db91a3914164$export$2e2bcd8739ae039)();
    const fcs = (0, $f7e6aeeb255be989$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $kLZMq.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $ad474e46ba9e8e25$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $53Ou4.default)(classes, $ad474e46ba9e8e25$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $4XrX4.jsx)($ad474e46ba9e8e25$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $4XrX4.jsx)($ad474e46ba9e8e25$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $4XrX4.jsx)($ad474e46ba9e8e25$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $7d57efcdf4f58771$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $4XrX4.jsx)($28UcW.Fragment, {
        children: /*#__PURE__*/ $28UcW.cloneElement(InputComponent, (0, $kLZMq.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $kLZMq.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $kLZMq.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $8HP8E.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === 'outlined' ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $dP0oo.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$ad474e46ba9e8e25$var$Select.muiName = 'Select';
var $ad474e46ba9e8e25$export$2e2bcd8739ae039 = $ad474e46ba9e8e25$var$Select;



var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $5fd3bc74d99fc398$export$c1bdcbaf0596aeda(slot) {
    return (0, $dYzHx.default)('MuiTextField', slot);
}
const $5fd3bc74d99fc398$var$textFieldClasses = (0, $d0ZgE.default)('MuiTextField', [
    'root'
]);
var $5fd3bc74d99fc398$export$2e2bcd8739ae039 = $5fd3bc74d99fc398$var$textFieldClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $d282dc2bd9d0947e$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $d282dc2bd9d0947e$var$variantComponent = {
    standard: (0, $10a147f6af35f8d7$export$2e2bcd8739ae039),
    filled: (0, $2da6af70f10a5956$export$2e2bcd8739ae039),
    outlined: (0, $da732c41ad7dddd4$export$2e2bcd8739ae039)
};
const $d282dc2bd9d0947e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $5fd3bc74d99fc398$export$c1bdcbaf0596aeda), classes);
};
const $d282dc2bd9d0947e$var$TextFieldRoot = (0, $k5hQd.default)((0, $5a094b6730918899$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $d282dc2bd9d0947e$var$TextField = /*#__PURE__*/ $28UcW.forwardRef(function TextField(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = 'outlined' } = props, other = (0, $53Ou4.default)(props, $d282dc2bd9d0947e$var$_excluded);
    const ownerState = (0, $kLZMq.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $d282dc2bd9d0947e$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    const id = (0, $930be18af46897d8$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $d282dc2bd9d0947e$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $4XrX4.jsx)(InputComponent, (0, $kLZMq.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $4XrX4.jsxs)($d282dc2bd9d0947e$var$TextFieldRoot, (0, $kLZMq.default)({
        className: (0, $dP0oo.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $6895abd85aef8ffe$export$2e2bcd8739ae039), (0, $kLZMq.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $4XrX4.jsx)((0, $ad474e46ba9e8e25$export$2e2bcd8739ae039), (0, $kLZMq.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $c1d51d233b523c7f$export$2e2bcd8739ae039), (0, $kLZMq.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $d282dc2bd9d0947e$export$2e2bcd8739ae039 = $d282dc2bd9d0947e$var$TextField;




var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $1fz9F = parcelRequire("1fz9F");

var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");

var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $6e4ec818ceca41d9$export$61b0ee1f05fb344e(slot) {
    return (0, $dYzHx.default)('MuiDialogContent', slot);
}
const $6e4ec818ceca41d9$var$dialogContentClasses = (0, $d0ZgE.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $6e4ec818ceca41d9$export$2e2bcd8739ae039 = $6e4ec818ceca41d9$var$dialogContentClasses;



var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $b6b0b905438be711$export$f5d2ec7e4c47e088(slot) {
    return (0, $dYzHx.default)('MuiDialogTitle', slot);
}
const $b6b0b905438be711$var$dialogTitleClasses = (0, $d0ZgE.default)('MuiDialogTitle', [
    'root'
]);
var $b6b0b905438be711$export$2e2bcd8739ae039 = $b6b0b905438be711$var$dialogTitleClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $9d07e8f98bc9061e$var$_excluded = [
    "className",
    "dividers"
];
const $9d07e8f98bc9061e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $6e4ec818ceca41d9$export$61b0ee1f05fb344e), classes);
};
const $9d07e8f98bc9061e$var$DialogContentRoot = (0, $k5hQd.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kLZMq.default)({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px'
    }, ownerState.dividers ? {
        padding: '16px 24px',
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $b6b0b905438be711$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $9d07e8f98bc9061e$var$DialogContent = /*#__PURE__*/ $28UcW.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $53Ou4.default)(props, $9d07e8f98bc9061e$var$_excluded);
    const ownerState = (0, $kLZMq.default)({}, props, {
        dividers: dividers
    });
    const classes = $9d07e8f98bc9061e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4XrX4.jsx)($9d07e8f98bc9061e$var$DialogContentRoot, (0, $kLZMq.default)({
        className: (0, $dP0oo.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $9d07e8f98bc9061e$export$2e2bcd8739ae039 = $9d07e8f98bc9061e$var$DialogContent;



var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $1fz9F = parcelRequire("1fz9F");

var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $5hW5y = parcelRequire("5hW5y");

var $1fz9F = parcelRequire("1fz9F");

var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");

var $1mNk8 = parcelRequire("1mNk8");

var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $608b109c4d489909$export$24c1f8f60cbac79e(slot) {
    return (0, $dYzHx.default)('MuiTypography', slot);
}
const $608b109c4d489909$var$typographyClasses = (0, $d0ZgE.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $608b109c4d489909$export$2e2bcd8739ae039 = $608b109c4d489909$var$typographyClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $f5a724df27408118$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $f5a724df27408118$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $1mNk8.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $608b109c4d489909$export$24c1f8f60cbac79e), classes);
};
const $f5a724df27408118$export$140e2f5526d3cad8 = (0, $k5hQd.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $1mNk8.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kLZMq.default)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $f5a724df27408118$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $f5a724df27408118$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $f5a724df27408118$var$transformDeprecatedColors = (color)=>{
    return $f5a724df27408118$var$colorTransformations[color] || color;
};
const $f5a724df27408118$var$Typography = /*#__PURE__*/ $28UcW.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $f5a724df27408118$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $5hW5y.default)((0, $kLZMq.default)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $f5a724df27408118$var$defaultVariantMapping } = props, other = (0, $53Ou4.default)(props, $f5a724df27408118$var$_excluded);
    const ownerState = (0, $kLZMq.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $f5a724df27408118$var$defaultVariantMapping[variant]) || 'span';
    const classes = $f5a724df27408118$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4XrX4.jsx)($f5a724df27408118$export$140e2f5526d3cad8, (0, $kLZMq.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $dP0oo.default)(classes.root, className)
    }, other));
});
var $f5a724df27408118$export$2e2bcd8739ae039 = $f5a724df27408118$var$Typography;



var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $54760b433a986b34$var$_excluded = [
    "className",
    "id"
];
const $54760b433a986b34$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $b6b0b905438be711$export$f5d2ec7e4c47e088), classes);
};
const $54760b433a986b34$var$DialogTitleRoot = (0, $k5hQd.default)((0, $f5a724df27408118$export$2e2bcd8739ae039), {
    name: 'MuiDialogTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $54760b433a986b34$var$DialogTitle = /*#__PURE__*/ $28UcW.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp } = props, other = (0, $53Ou4.default)(props, $54760b433a986b34$var$_excluded);
    const ownerState = props;
    const classes = $54760b433a986b34$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $28UcW.useContext((0, $18aa0493e8a28dcb$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $4XrX4.jsx)($54760b433a986b34$var$DialogTitleRoot, (0, $kLZMq.default)({
        component: "h2",
        className: (0, $dP0oo.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $54760b433a986b34$export$2e2bcd8739ae039 = $54760b433a986b34$var$DialogTitle;








const $84d8865b7a3b1ff1$var$auth = (0, $de660e99e3126d7c$export$ae1af26003f05816)();
const $84d8865b7a3b1ff1$var$SignInDialog = ()=>{
    const navigate = (0, $6e00b7bb3feca34a$export$9770f232ac06a008)();
    const { isOpen: isOpen, redirectPathAfterLogin: redirectPathAfterLogin } = (0, $e2662af8a2ab1f76$export$986181c251d527c3).useState((s)=>s.signInDialog);
    const [creatingAccount, setCreatingAccount] = (0, $28UcW.useState)(true);
    const [resettingPassword, setResettingPassword] = (0, $28UcW.useState)(false);
    const [email, setEmail] = (0, $28UcW.useState)('');
    const [password, setPassword] = (0, $28UcW.useState)('');
    // whitespace for no-error default value so that it still takes up space in doc.
    // just an easy way of accomplishing that
    const [emailError, setEmailError] = (0, $28UcW.useState)(' ');
    const [passwordError, setPasswordError] = (0, $28UcW.useState)(' ');
    const [loading, setLoading] = (0, $28UcW.useState)(false);
    const getMainButtonText = ()=>{
        if (resettingPassword) return 'Reset Password';
        else return creatingAccount ? 'Sign Up' : 'Log In';
    };
    const closeDialog = ()=>{
        if (redirectPathAfterLogin) // delay lets app update so we hit logged-in state so /account doesn't redirect home again after log-in,
        // if that's the page that the user was trying to reach when they were initially directed to login.
        setTimeout(()=>{
            navigate(redirectPathAfterLogin);
        }, 350);
        (0, $e2662af8a2ab1f76$export$986181c251d527c3).update((s)=>{
            s.signInDialog.isOpen = false;
            s.signInDialog.redirectPathAfterLogin = null;
            setLoading(false);
            // delay so it doesnt flicker as it closes
            setTimeout(()=>{
                setEmail('');
                setPassword('');
                setEmailError(' ');
                setPasswordError(' ');
                setResettingPassword(false);
            }, 100);
        });
    };
    const onEmailChange = (event)=>{
        setEmail(event.target.value);
        setEmailError(' ');
    };
    const onPasswordChange = (event)=>{
        setPassword(event.target.value);
        setPasswordError(' ');
    };
    const validateInputs = ()=>{
        let isValid = true;
        if (email.trim() === '') {
            setEmailError('Field cannot be left blank.');
            isValid = false;
        }
        if (email.trim().length > 50) {
            setEmailError('Email cannot be longer than 50 characters.');
            isValid = false;
        }
        if (password.trim() === '') {
            setPasswordError('Field cannot be left blank.');
            isValid = false;
        }
        if (creatingAccount) {
            if (password.trim().length > 0 && password.length < 8) {
                setPasswordError('Password must be at least 8 characters.');
                isValid = false;
            }
        }
        return isValid;
    };
    const handleLogin = async ()=>{
        if (!validateInputs()) return;
        // if we got here from handleSignUp, loading is already true
        if (!loading) setLoading(true);
        try {
            await (0, $de660e99e3126d7c$export$555508cbc6add439)($84d8865b7a3b1ff1$var$auth, email, password);
            closeDialog();
        } catch (error) {
            setLoading(false);
            if (error.code === (0, $860afe5c90b07ab1$export$8a6a76db0c20fb2a).INVALID_PASSWORD) {
                setPasswordError('Invalid password.');
                return;
            }
            if (error.code === (0, $860afe5c90b07ab1$export$8a6a76db0c20fb2a).USER_NOT_FOUND) {
                setEmailError('Email not found.');
                return;
            }
            console.log('login error:');
            console.log(error);
            // generic catch-all
            setEmailError('Something went wrong. Try again.');
            return;
        }
    };
    const handleSignUp = async ()=>{
        if (!validateInputs()) return;
        setLoading(true);
        try {
            const puzzleStates = (0, $741cdd5d8fe36d3f$export$d230f8554682469c)();
            await (0, $ea74087fd5ac399e$export$2e2bcd8739ae039).post('/api/users/create-user', {
                email: email,
                password: password,
                puzzleStates: puzzleStates
            });
        } catch (error) {
            setLoading(false);
            const errorCode = error.response.data.error;
            if (errorCode === (0, $860afe5c90b07ab1$export$8a6a76db0c20fb2a).EMAIL_ALREADY_IN_USE) {
                setEmailError('There is already an account for this email.');
                return;
            }
            if (errorCode === (0, $860afe5c90b07ab1$export$8a6a76db0c20fb2a).INVALID_EMAIL) {
                setEmailError('Invalid email. Check formatting?');
                return;
            }
            if (errorCode === (0, $860afe5c90b07ab1$export$8a6a76db0c20fb2a).WEAK_PASSWORD) {
                setPasswordError('Password must be at least 8 characters.');
                return;
            }
            console.log('signup error:');
            console.log(error);
            // generic catch-all
            setEmailError('Something went wrong.');
            return;
        }
        handleLogin();
    };
    const handlePasswordReset = async ()=>{
        if (email.trim() === '') {
            setEmailError('This field cannot be blank.');
            return;
        }
        setLoading(true);
        try {
            await (0, $de660e99e3126d7c$export$a8550f7dbe79f93a)($84d8865b7a3b1ff1$var$auth, email);
        } catch (error) {
            setLoading(false);
            if (error.code === (0, $860afe5c90b07ab1$export$8a6a76db0c20fb2a).INVALID_EMAIL) {
                setEmailError('Invalid email.');
                return;
            }
            if (error.code === (0, $860afe5c90b07ab1$export$8a6a76db0c20fb2a).USER_NOT_FOUND) {
                setEmailError('Email not found.');
                return;
            }
        }
        setLoading(false);
        closeDialog();
        alert('A password reset email has been sent.');
    };
    const executeMainAction = ()=>{
        if (creatingAccount) handleSignUp();
        else if (resettingPassword) handlePasswordReset();
        else handleLogin();
    };
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $74c5b717dc6d45d0$export$2e2bcd8739ae039), {
        open: isOpen,
        onClose: closeDialog,
        "aria-labelledby": "form-dialog-title",
        PaperProps: {
            className: 'signInDialogContainer'
        },
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $54760b433a986b34$export$2e2bcd8739ae039), {
                className: "signInDialogTitle",
                children: getMainButtonText()
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $9d07e8f98bc9061e$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("form", {
                        className: "signUpForm",
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d282dc2bd9d0947e$export$2e2bcd8739ae039), {
                                error: !!emailError.trim(),
                                helperText: emailError,
                                id: "email",
                                autoComplete: "email",
                                className: "emailField",
                                label: "Email",
                                variant: "outlined",
                                margin: "dense",
                                value: email,
                                onChange: onEmailChange,
                                onFocus: ()=>{
                                    setEmailError(' ');
                                },
                                fullWidth: true
                            }),
                            !resettingPassword && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d282dc2bd9d0947e$export$2e2bcd8739ae039), {
                                error: !!passwordError.trim(),
                                helperText: passwordError,
                                id: "password",
                                className: "passwordField",
                                label: "Password",
                                type: "password",
                                variant: "outlined",
                                autoComplete: "current-password",
                                margin: "dense",
                                value: password,
                                onChange: onPasswordChange,
                                onKeyDown: (event)=>{
                                    if (event.key === 'Enter') {
                                        event.preventDefault();
                                        creatingAccount ? handleSignUp() : handleLogin();
                                    }
                                },
                                onFocus: ()=>{
                                    setPasswordError(' ');
                                },
                                fullWidth: true
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $85c133b03e2ea24a$export$2e2bcd8739ae039), {
                                className: "signUpButton",
                                color: "primary",
                                variant: "contained",
                                onClick: executeMainAction,
                                children: getMainButtonText()
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $85c133b03e2ea24a$export$2e2bcd8739ae039), {
                                color: "primary",
                                className: "forgotPassword",
                                onClick: ()=>{
                                    if (!resettingPassword) setCreatingAccount(false);
                                    setResettingPassword(!resettingPassword);
                                },
                                children: resettingPassword ? 'Go back' : 'Forgot your password?'
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                className: "loginOrSignupSwitchLabel",
                                children: creatingAccount ? 'Already have an account?' : 'New to the Daily Baffle?'
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $85c133b03e2ea24a$export$2e2bcd8739ae039), {
                                color: "primary",
                                className: "loginOrSignUpSwitch",
                                onClick: ()=>{
                                    setEmail('');
                                    setPassword('');
                                    setCreatingAccount(!creatingAccount);
                                    setResettingPassword(false);
                                },
                                children: creatingAccount ? 'Log In' : 'Sign Up'
                            })
                        ]
                    }),
                    loading && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $cb219f8ff05770a2$export$2e2bcd8739ae039), {
                        className: "loadingBackdrop",
                        open: loading,
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $309dd07201abfd19$export$2e2bcd8739ae039), {
                            color: "#36d7b7"
                        })
                    })
                ]
            })
        ]
    });
};
var $84d8865b7a3b1ff1$export$2e2bcd8739ae039 = $84d8865b7a3b1ff1$var$SignInDialog;


var $33e2e95680c2007c$export$2e2bcd8739ae039 = (0, $84d8865b7a3b1ff1$export$2e2bcd8739ae039);


// most of this is copied from MUI docs for BasicMenu and then slightly modified

var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");



var $b6d6353e109e696d$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($b6d6353e109e696d$exports, "__esModule", {
    value: true
});
$b6d6353e109e696d$exports.default = void 0;

var $b6d6353e109e696d$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $b6d6353e109e696d$var$_default = $b6d6353e109e696d$exports.default = (0, $b6d6353e109e696d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6m0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20"
}), 'AccountCircle');



const $f051939c0bfba3e3$var$auth = (0, $de660e99e3126d7c$export$ae1af26003f05816)();
const $f051939c0bfba3e3$var$AccountMenuLink = ()=>{
    const navigate = (0, $6e00b7bb3feca34a$export$9770f232ac06a008)();
    const [anchorEl, setAnchorEl] = $28UcW.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const handleLogout = async ()=>{
        try {
            $f051939c0bfba3e3$var$auth.signOut();
        // window.location = '/' as any; // redirect to home upon logout
        } catch (error) {
            const errorCode = error.code;
            const errorMessage = error.message;
        }
    };
    const userEmail = $f051939c0bfba3e3$var$auth.currentUser?.email || '';
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "accountMenuLink",
                title: "Account Menu",
                onClick: handleClick,
                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b6d6353e109e696d$exports))), {
                    className: "accountIcon"
                })
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $253324ab0d2d0f8a$export$2e2bcd8739ae039), {
                className: "accountMenu",
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                disableScrollLock: true,
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $fbf0bf3f5e6ed773$export$2e2bcd8739ae039), {
                        disableRipple: true,
                        disableTouchRipple: true,
                        style: {
                            cursor: 'default'
                        },
                        className: "accountEmail",
                        children: userEmail
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $fbf0bf3f5e6ed773$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            // go to profile
                            navigate('/account');
                            handleClose();
                        },
                        children: "Account Settings"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $fbf0bf3f5e6ed773$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleLogout();
                            handleClose();
                        },
                        children: "Log Out"
                    })
                ]
            })
        ]
    });
};
var $f051939c0bfba3e3$export$2e2bcd8739ae039 = $f051939c0bfba3e3$var$AccountMenuLink;





var $hjLll = parcelRequire("hjLll");

var $4XrX4 = parcelRequire("4XrX4");
"use client";
var $e169f87cfba9a8b0$export$2e2bcd8739ae039 = (0, $hjLll.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6m0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20"
}), 'AccountCircle');



const $f06d405a9c41b613$var$AccountLinks = ()=>{
    const signedIn = (0, $e2662af8a2ab1f76$export$986181c251d527c3).useState((s)=>s.signedIn);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "accountControls",
        children: [
            signedIn ? /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f051939c0bfba3e3$export$2e2bcd8739ae039), {}) : (0, $b2cd9ecc66d0956f$exports.isMobile) ? /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "accountMenuLink",
                title: "Account Menu",
                onClick: ()=>{
                    (0, $e2662af8a2ab1f76$export$986181c251d527c3).update((s)=>{
                        s.signInDialog.isOpen = true;
                    });
                },
                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $e169f87cfba9a8b0$export$2e2bcd8739ae039), {
                    className: "accountIcon"
                })
            }) : /*#__PURE__*/ (0, $4XrX4.jsx)((0, $85c133b03e2ea24a$export$2e2bcd8739ae039), {
                disableRipple: true,
                color: "primary",
                variant: "contained",
                className: "logInButton",
                onClick: ()=>{
                    (0, $e2662af8a2ab1f76$export$986181c251d527c3).update((s)=>{
                        s.signInDialog.isOpen = true;
                    });
                },
                children: "Log In"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $33e2e95680c2007c$export$2e2bcd8739ae039), {})
        ]
    });
};
var $f06d405a9c41b613$export$2e2bcd8739ae039 = $f06d405a9c41b613$var$AccountLinks;


var $10c0fca1d07bceff$export$2e2bcd8739ae039 = (0, $f06d405a9c41b613$export$2e2bcd8739ae039);




var $2495fce0b83c8581$var$HolidayStyle = /*#__PURE__*/ function(HolidayStyle) {
    HolidayStyle["Halloween"] = "halloween";
    HolidayStyle["Christmas"] = "christmas";
    return HolidayStyle;
}($2495fce0b83c8581$var$HolidayStyle || {});
const $2495fce0b83c8581$var$TopBar = ({ onSave: onSave })=>{
    const navigate = (0, $6e00b7bb3feca34a$export$9770f232ac06a008)();
    const isMobileDimensions = (0, $ba1e3b359abf28ef$export$580e0f6db19fa7cc)();
    // Set to a HolidayStyle enum value to activate holiday colors, or null for normal logo
    const activeHoliday = null;
    const holidayColors = {
        ["halloween"]: [
            'blackLetter',
            'orangeLetter'
        ],
        ["christmas"]: [
            'redLetter',
            'greenLetter'
        ]
    };
    const goTo = (url)=>{
        return ()=>{
            navigate(url);
            window.scrollTo(0, 0);
            onSave();
        };
    };
    const keepTopBarOnMobile = [
        '/',
        '/submissions',
        '/account',
        '/about',
        '/on-ending-morphology'
    ].includes(window.location.pathname);
    // the mobile games include the top bar themselves since they customize it
    if (((0, $b2cd9ecc66d0956f$exports.isMobile) || isMobileDimensions) && !keepTopBarOnMobile) // still need this even if top bar is missing. opens from stats dialog if logged out.
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $33e2e95680c2007c$export$2e2bcd8739ae039), {});
    const logoLetters = 'The Daily Baffle'.split('');
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "topBar",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "logoHeader",
                onClick: goTo('/'),
                children: activeHoliday ? logoLetters.map((letter, index)=>/*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                        className: index % 2 === 0 ? holidayColors[activeHoliday][0] : holidayColors[activeHoliday][1],
                        children: letter
                    }, index)) : 'The Daily Baffle'
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $10c0fca1d07bceff$export$2e2bcd8739ae039), {})
        ]
    });
};
var $2495fce0b83c8581$export$2e2bcd8739ae039 = $2495fce0b83c8581$var$TopBar;


var $d73d4bd4af6a0424$export$2e2bcd8739ae039 = (0, $2495fce0b83c8581$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");




const $c66ee0aaafbc7ad3$var$Footer = ({ keepMobileFooter: keepMobileFooter })=>{
    const navigate = (0, $6e00b7bb3feca34a$export$9770f232ac06a008)();
    const isMobileDimensions = (0, $ba1e3b359abf28ef$export$580e0f6db19fa7cc)();
    if (((0, $b2cd9ecc66d0956f$exports.isMobile) || isMobileDimensions) && !keepMobileFooter) return null;
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("footer", {
        className: "footer",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {}),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "footerItemTitle",
                                children: "About"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "footerItemContent",
                                children: "The Daily Baffle is a digital endeavour aiming to bring entirely new word and logic puzzles to the teeming masses. We hope you enjoy."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "footerItemTitle",
                                children: "Discord"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "footerItemContent",
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                    href: "https://discord.gg/Ar9hENwrUQ",
                                    target: "_blank",
                                    children: "Join us on Discord!"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "footerItemTitle",
                                children: "Contact"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: "footerItemContent",
                                children: [
                                    "Please direct questions, concerns, threats, and feedback to ",
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                        target: "_blank",
                                        href: "mailto:editor@dailybaffle.com",
                                        children: "editor@dailybaffle.com"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "footerItemTitle",
                                children: "Morphology Submissions"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: "footerItemContent",
                                children: [
                                    "Read more ",
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                        target: "_blank",
                                        href: "/submissions",
                                        children: "here"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("ul", {
                            className: "footerItemTitle bottomItems",
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                        target: "_blank",
                                        href: "https://www.termsfeed.com/live/685896b5-d881-40b3-abda-44709050cd37",
                                        children: "Privacy Policy"
                                    })
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                        className: "copyright",
                                        children: "\xa9 2025 The Daily Baffle"
                                    })
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                        onClick: ()=>{
                                            navigate('/about');
                                            window.scrollTo(0, 0);
                                        },
                                        className: "aboutLink",
                                        children: "About+"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $c66ee0aaafbc7ad3$export$2e2bcd8739ae039 = $c66ee0aaafbc7ad3$var$Footer;


var $d3b38ad39fb8613a$export$2e2bcd8739ae039 = (0, $c66ee0aaafbc7ad3$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");


const $85c2880b0ac78b1e$var$LoadingWrapper = ({ children: children })=>{
    const { loadingContent: loadingContent, loadingContentError: loadingContentError, loadingUser: loadingUser } = (0, $e2662af8a2ab1f76$export$986181c251d527c3).useState();
    if (loadingContentError) return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $4XrX4.Fragment), {
        children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
            children: "error loading puzzles"
        })
    });
    if (!loadingContent && !loadingUser) return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $4XrX4.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $4XrX4.Fragment), {
        children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
            className: "loadingScreen",
            children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $309dd07201abfd19$export$2e2bcd8739ae039), {})
        })
    });
};
var $85c2880b0ac78b1e$export$2e2bcd8739ae039 = $85c2880b0ac78b1e$var$LoadingWrapper;



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

const $ba9b0dbab8aa2582$var$SectionHeading = ({ level: level, id: id, children: children })=>{
    const Tag = level;
    return /*#__PURE__*/ (0, $4XrX4.jsxs)(Tag, {
        id: id,
        className: "anchorHeading",
        children: [
            children,
            /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                className: "anchorLink",
                href: `#${id}`,
                "aria-label": "Link to section",
                children: "#"
            })
        ]
    });
};
const $ba9b0dbab8aa2582$var$SubmissionsPage = ()=>{
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "submissionsPage",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)($ba9b0dbab8aa2582$var$SectionHeading, {
                level: "h2",
                id: "morphology-submissions",
                children: "Morphology Submissions"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                children: [
                    "Note: We are no longer taking new submissions for Morphology. Read more ",
                    /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                        href: "/on-ending-morphology",
                        children: "here"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                children: [
                    "Please send any Morphology submissions via email to ",
                    /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                        target: "_blank",
                        href: "mailto:submissions@dailybaffle.com",
                        children: "submissions@dailybaffle.com"
                    }),
                    ". You can use the ",
                    /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                        href: "/formatter",
                        children: "formatter tool"
                    }),
                    ' and choose "Output with Solutions" to format your puzzle nicely for the email. Please include your desired byline and a payment method, such as Venmo, Cashapp, or Paypal. The rate is $100 per puzzle, paid upon acceptance and after any suggested revisions. We will never make any changes to your puzzle without your full approval.'
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "We try to respond to all submissions, but it might take some time. Please do not send in more than two puzzles at a time until you receive a response."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)($ba9b0dbab8aa2582$var$SectionHeading, {
                level: "h2",
                id: "assistive-tools",
                children: "Assistive Tools"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                children: [
                    "Here is a simple wordfinding tool that will find all words within a specified morph distance of a given word:",
                    /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                        target: "_blank",
                        href: "/wordfinder",
                        children: "Wordfinder"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                children: [
                    "And here is a formatter that will help with sharing your puzzle data by neatly laying it out:",
                    /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                        href: "/formatter",
                        children: "Formatter"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)($ba9b0dbab8aa2582$var$SectionHeading, {
                level: "h2",
                id: "construction-guidelines",
                children: "Construction Guidelines"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)($ba9b0dbab8aa2582$var$SectionHeading, {
                level: "h3",
                id: "basics",
                children: "Basics"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                children: [
                    "Aim to keep the puzzle to around 15 clues, give or take, because ",
                    /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                        className: "italicText",
                        children: "The Daily Baffle"
                    }),
                    " leans more towards bite-size puzzles like Wordle or the NYT mini crossword rather than larger commitment puzzles like the NYT daily crossword. But don\u2019t hesitate to make your puzzle a few clues longer if it leads to a better sequence and a better puzzle. Puzzles should not be shorter than 13 entries unless the theme is unbelievably well-executed and adding additional clues would only clutter the perfection."
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "Since it's only around 15 clues and authors don't have to worry about intersecting the words, these generally take much less time to build than a crossword."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "A theme is optional, but the first and last clues of a Morphology puzzle inherently have less information than the clues in the middle since they only have one adjacent word instead of two. So if it\u2019s possible to link them to each other somehow, this can make for a better solving experience. But this isn't mandatory, so don't be afraid to send in puzzles with unrelated starts and finishes."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)($ba9b0dbab8aa2582$var$SectionHeading, {
                level: "h3",
                id: "morph-sequencing",
                children: "Morph Sequencing"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "For each clue, the net morph distance (the sum of X+Y+Z) should be chosen carefully, and the difficulty of a morph should be balanced with the difficulty of its accompanying semantic clue."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "This is very dependent on word length. Consider the following example:"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "example",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("pre", {
                        children: "A vessel for navigating the sea               B O A T"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("pre", {
                        children: "Adjust to new conditions (+1, ~2)             _ _ _ _ _"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "In this context there\u2019s 3 changes happening to a word that\u2019s only 4 letters long, so the morph here is very unhelpful and the solver is almost completely dependent on the semantic clue to arrive at the solution ADAPT."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "Consider this counterexample:"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "example",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("pre", {
                        children: "Add more detail                     E L A B O R A T E"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("pre", {
                        children: "Consider carefully (+1, ~2)         _ _ _ _ _ _ _ _ _ _"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "In this case, that same morph of (+1, ~2) is only 1/3 the length of the much longer ELABORATE, and is thus much more helpful to reach the solution of DELIBERATE."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "With that in mind, three-part morphs like (+1, -1, ~2) are best to be avoided entirely, as it\u2019s nearly impossible to reason around them, although the simple (+1, -1, ~1) can occasionally get by. Likewise, single-part morphs can often work with somewhat higher values, such as (-5), since they\u2019re much easier to reason around. (Although ~5 would be pretty rough.)"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "In general, it\u2019s best to keep the average net morph of your puzzle somewhere around 2 and rarely go above a net morph of 3 for any clue."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)($ba9b0dbab8aa2582$var$SectionHeading, {
                level: "h3",
                id: "island-letters",
                children: "Island Letters"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                children: [
                    "One other thing to look out for is what might be termed ",
                    /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                        className: "italicText",
                        children: "island letters"
                    }),
                    ". Don\u2019t worry about this for the first and last clues, but for the rest, an island letter is any letter in a solution word that doesn\u2019t appear in either of the adjacent solutions above or below. The adjacent words therefore can\u2019t help a solver to deduce that letter\u2019s identity."
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "An example: CLOSE \u2013 CHOSE \u2013 CHORE \u2013 CHOKE \u2013 CHOCK \u2013 CHECK."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "In this example, the R in CHORE is an island letter. It\u2019s the only letter in any of the middle four words which doesn\u2019t appear in the words on either side."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "It may not appear very important in this simple example, but an excess of island letters can make a Morphology puzzle start to feel clunky and arbitrary, because island letters don\u2019t help to move the morph forward. CHOSE could have gone straight to CHOKE without the puzzle losing anything; its absence would make no difference. Whereas if you remove CHOCK, then getting from CHOKE to CHECK requires a larger morph. It\u2019s okay to have an island letter here or there, and sometimes they're necessary for the theme or to make a certain transition, but we should very rarely have multiple words in a row with island letters if it can be avoided."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)($ba9b0dbab8aa2582$var$SectionHeading, {
                level: "h3",
                id: "clueing",
                children: "Word Choice & Clueing"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "Please keep in mind that you are welcome to send in a ladder before clueing it, to check what we think! This can save you considerable time if the word choice was a no-go from the start."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "With that in mind, it's best to avoid 3-letter words unless they are essential to your theme, and even then. The reason for this is that 3-letter words are generally extremely common terms like EAT, FUN, SEE, SKY, or BEE, and while it isn't impossible to find creative clueing angles on such words, the solutions are typically so obvious as to be rather uninteresting. Consider how rarely a 3-letter entry in a crossword really catches your attention and serves any purpose other than fill. A ladder consisting mostly of 4-letter words would also be suspect unless the clueing was incredibly good. It's best to have most words be no shorter than 5 letters, in order to keep the puzzle from becoming too simplistic."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                children: [
                    "Proper nouns are okay to use so long as they\u2019re still broadly known today. In crosswords it\u2019s often somewhat inevitable to have obscure names in the fill, and you can usually get them by the crosses. The nature of a Morphology puzzle is such that it\u2019s almost never ",
                    /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                        className: "italicText",
                        children: "necessary"
                    }),
                    " to have obscure names, and if a puzzle did have one, it would be much harder (if not impossible) to guess since there\u2019s no crosses to rely on."
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "That said, words and names like BABYLON, SPIDERMAN, PARIS, LINCOLN, LENNON, or SHERLOCK would be perfectly fine, while names like SPITZ, BORZOV, WOTTLE (all 1972 Olympic participants) would be strongly advised against. A name like ELIZABETH would be okay if clued as \u201CNoted Queen\u201D but advised against if clued as \u201CEckford of the Little Rock Nine.\u201D"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "Clueing should follow standard crossword conventions with regards to singular/plural agreement and tense agreement, as one would expect."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "Lastly, wordplay and trickery are encouraged. If clueing is overly straightforward \u2013 simply a list of definitions, say \u2013 it can result in a puzzle that's solved in a minute or two and forgotten just as quickly. Constructors should seek to delight with at least some part of their clueing."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)($ba9b0dbab8aa2582$var$SectionHeading, {
                level: "h2",
                id: "themes",
                children: "Themes"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "Morphology tends to lend itself to themes involving movement, change, transformation, directionality, processes, recipes, steps, sequences, or cycles. DAY becomes NIGHT. STAIRS lead to the ATTIC. WATER and FLOUR become BREAD. From EAST to WEST. And so on."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                children: "If you have a theme that needs significantly more space than 15 clues allow, perhaps due to the number of themed clues involved, pitch us on it and we will consider buying a double-length puzzle of around 30 clues at $225. However, double-length puzzles are not being published yet - we're considering running them on weekends down the line - and so right now constructors are encouraged to keep their double-length ideas on the backburner. When we start looking for them actively, we'll put out a visible announcement on the main page."
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                children: [
                    "Lastly, here is a list of the themes that other contributors have come up with, to avoid using the same idea twice:",
                    /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                        target: "_blank",
                        href: "https://github.com/dailybaffle/morphology-themes",
                        children: "Themes"
                    })
                ]
            })
        ]
    });
};
var $ba9b0dbab8aa2582$export$2e2bcd8739ae039 = $ba9b0dbab8aa2582$var$SubmissionsPage;


var $e160abf210f59eba$export$2e2bcd8739ae039 = (0, $ba9b0dbab8aa2582$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");



var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $1fz9F = parcelRequire("1fz9F");

var $3H5bK = parcelRequire("3H5bK");

var $hKGGQ = parcelRequire("hKGGQ");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $2f36425301faf1e3$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $hKGGQ.default)(value, min, max);
}
function $2f36425301faf1e3$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $2f36425301faf1e3$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $2f36425301faf1e3$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $2f36425301faf1e3$export$677b39864803984e($2f36425301faf1e3$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $3H5bK.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $3H5bK.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $2f36425301faf1e3$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $2f36425301faf1e3$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const $2f36425301faf1e3$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $2f36425301faf1e3$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $2f36425301faf1e3$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $2f36425301faf1e3$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $2f36425301faf1e3$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$2f36425301faf1e3$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $2f36425301faf1e3$export$29fb7152bd3f781a(color) {
    color = $2f36425301faf1e3$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $2f36425301faf1e3$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $2f36425301faf1e3$export$c852d90bf7403b62(color) {
    color = $2f36425301faf1e3$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $2f36425301faf1e3$export$677b39864803984e($2f36425301faf1e3$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $2f36425301faf1e3$export$d061e26956a60b0a(foreground, background) {
    const lumA = $2f36425301faf1e3$export$c852d90bf7403b62(foreground);
    const lumB = $2f36425301faf1e3$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $2f36425301faf1e3$export$58f0f39f63f3cf42(color, value) {
    color = $2f36425301faf1e3$export$677b39864803984e(color);
    value = $2f36425301faf1e3$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $2f36425301faf1e3$export$211a73f2b8c10ce4(color);
}
function $2f36425301faf1e3$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $2f36425301faf1e3$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $2f36425301faf1e3$export$4b073707ff63303(color, coefficient) {
    color = $2f36425301faf1e3$export$677b39864803984e(color);
    coefficient = $2f36425301faf1e3$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $2f36425301faf1e3$export$211a73f2b8c10ce4(color);
}
function $2f36425301faf1e3$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $2f36425301faf1e3$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $2f36425301faf1e3$export$c0816ed86df316af(color, coefficient) {
    color = $2f36425301faf1e3$export$677b39864803984e(color);
    coefficient = $2f36425301faf1e3$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $2f36425301faf1e3$export$211a73f2b8c10ce4(color);
}
function $2f36425301faf1e3$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $2f36425301faf1e3$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $2f36425301faf1e3$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $2f36425301faf1e3$export$c852d90bf7403b62(color) > 0.5 ? $2f36425301faf1e3$export$4b073707ff63303(color, coefficient) : $2f36425301faf1e3$export$c0816ed86df316af(color, coefficient);
}
function $2f36425301faf1e3$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $2f36425301faf1e3$export$11bb74ba10c85505(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $2f36425301faf1e3$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $2f36425301faf1e3$export$677b39864803984e(background);
    const overlayColor = $2f36425301faf1e3$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $2f36425301faf1e3$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}



var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");

var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");


'use client';
const $1b3398fa4055645e$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $1b3398fa4055645e$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $1b3398fa4055645e$var$_excluded3 = [
    "component"
];
function $1b3398fa4055645e$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $53Ou4.default)(parameters, $1b3398fa4055645e$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $53Ou4.default)(externalForwardedProps, $1b3398fa4055645e$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $dd7d25a0ccd83122$export$308c24034cde71de)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $b6c6397063b8c1da$export$b01d1e419b049226)((0, $kLZMq.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $53Ou4.default)(_mergeSlotProps.props, $1b3398fa4055645e$var$_excluded3);
    const ref = (0, $39cf289415cf806e$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $kLZMq.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $78ebb5a23c9e54f3$export$b089efb01a7bdf50)(elementType, (0, $kLZMq.default)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}



var $1mNk8 = parcelRequire("1mNk8");


var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $f3775d1f52f789be$export$69aecd24bc2cf7e3(slot) {
    return (0, $dYzHx.default)('MuiAlert', slot);
}
const $f3775d1f52f789be$var$alertClasses = (0, $d0ZgE.default)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $f3775d1f52f789be$export$2e2bcd8739ae039 = $f3775d1f52f789be$var$alertClasses;



parcelRequire("28UcW");

var $hjLll = parcelRequire("hjLll");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
var $09e15c438a7857bd$export$2e2bcd8739ae039 = (0, $hjLll.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');


parcelRequire("28UcW");

var $hjLll = parcelRequire("hjLll");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
var $9702849e64c42925$export$2e2bcd8739ae039 = (0, $hjLll.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');


parcelRequire("28UcW");

var $hjLll = parcelRequire("hjLll");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
var $429894c1f9b8e53d$export$2e2bcd8739ae039 = (0, $hjLll.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');


parcelRequire("28UcW");

var $hjLll = parcelRequire("hjLll");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
var $dd26b396dacc6423$export$2e2bcd8739ae039 = (0, $hjLll.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');


parcelRequire("28UcW");

var $hjLll = parcelRequire("hjLll");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
var $b8a08741895af1bd$export$2e2bcd8739ae039 = (0, $hjLll.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $af6f223451989330$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $af6f223451989330$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${variant}${(0, $1mNk8.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $f3775d1f52f789be$export$69aecd24bc2cf7e3), classes);
};
const $af6f223451989330$var$AlertRoot = (0, $k5hQd.default)((0, $ac02ff9d8c78ed7f$export$2e2bcd8739ae039), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $1mNk8.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const getColor = theme.palette.mode === 'light' ? (0, $2f36425301faf1e3$export$4b073707ff63303) : (0, $2f36425301faf1e3$export$c0816ed86df316af);
    const getBackgroundColor = theme.palette.mode === 'light' ? (0, $2f36425301faf1e3$export$c0816ed86df316af) : (0, $2f36425301faf1e3$export$4b073707ff63303);
    const color = ownerState.color || ownerState.severity;
    return (0, $kLZMq.default)({}, theme.typography.body2, {
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px'
    }, color && ownerState.variant === 'standard' && {
        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
        [`& .${(0, $f3775d1f52f789be$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
            color: theme.vars.palette.Alert[`${color}IconColor`]
        } : {
            color: theme.palette[color].main
        }
    }, color && ownerState.variant === 'outlined' && {
        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
        [`& .${(0, $f3775d1f52f789be$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
            color: theme.vars.palette.Alert[`${color}IconColor`]
        } : {
            color: theme.palette[color].main
        }
    }, color && ownerState.variant === 'filled' && (0, $kLZMq.default)({
        fontWeight: theme.typography.fontWeightMedium
    }, theme.vars ? {
        color: theme.vars.palette.Alert[`${color}FilledColor`],
        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
    } : {
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
        color: theme.palette.getContrastText(theme.palette[color].main)
    }));
});
const $af6f223451989330$var$AlertIcon = (0, $k5hQd.default)('div', {
    name: 'MuiAlert',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $af6f223451989330$var$AlertMessage = (0, $k5hQd.default)('div', {
    name: 'MuiAlert',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $af6f223451989330$var$AlertAction = (0, $k5hQd.default)('div', {
    name: 'MuiAlert',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $af6f223451989330$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $09e15c438a7857bd$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $9702849e64c42925$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $429894c1f9b8e53d$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $dd26b396dacc6423$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $af6f223451989330$var$Alert = /*#__PURE__*/ $28UcW.forwardRef(function Alert(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $af6f223451989330$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard' } = props, other = (0, $53Ou4.default)(props, $af6f223451989330$var$_excluded);
    const ownerState = (0, $kLZMq.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant
    });
    const classes = $af6f223451989330$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: (0, $kLZMq.default)({
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon
        }, slots),
        slotProps: (0, $kLZMq.default)({}, componentsProps, slotProps)
    };
    const [CloseButtonSlot, closeButtonProps] = (0, $1b3398fa4055645e$export$2e2bcd8739ae039)('closeButton', {
        elementType: (0, $f714e0f624d6f306$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $1b3398fa4055645e$export$2e2bcd8739ae039)('closeIcon', {
        elementType: (0, $b8a08741895af1bd$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $4XrX4.jsxs)($af6f223451989330$var$AlertRoot, (0, $kLZMq.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $dP0oo.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $4XrX4.jsx)($af6f223451989330$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $af6f223451989330$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $4XrX4.jsx)($af6f223451989330$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $4XrX4.jsx)($af6f223451989330$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $4XrX4.jsx)($af6f223451989330$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $4XrX4.jsx)(CloseButtonSlot, (0, $kLZMq.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)(CloseIconSlot, (0, $kLZMq.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
var $af6f223451989330$export$2e2bcd8739ae039 = $af6f223451989330$var$Alert;


var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");


var $1fz9F = parcelRequire("1fz9F");



var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $8HP8E = parcelRequire("8HP8E");

var $dYzHx = parcelRequire("dYzHx");

var $1fz9F = parcelRequire("1fz9F");

var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $lXNQ7 = parcelRequire("lXNQ7");

var $8HP8E = parcelRequire("8HP8E");



var $7zKsg = parcelRequire("7zKsg");

var $iJ7JK = parcelRequire("iJ7JK");
const $03a55fe180c56544$var$_excluded = [
    "ownerState"
], $03a55fe180c56544$var$_excluded2 = [
    "variants"
], $03a55fe180c56544$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $03a55fe180c56544$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $03a55fe180c56544$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $03a55fe180c56544$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const $03a55fe180c56544$export$35e57303dbd8a66 = (0, $7zKsg.default)();
const $03a55fe180c56544$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $03a55fe180c56544$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $03a55fe180c56544$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $03a55fe180c56544$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $03a55fe180c56544$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $53Ou4.default)(_ref, $03a55fe180c56544$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $kLZMq.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$03a55fe180c56544$var$processStyleArg(resolvedStyle, (0, $kLZMq.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $53Ou4.default)(resolvedStylesArg, $03a55fe180c56544$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $kLZMq.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === 'function' ? variant.style((0, $kLZMq.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $03a55fe180c56544$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $03a55fe180c56544$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $03a55fe180c56544$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $03a55fe180c56544$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $iJ7JK.default)((0, $kLZMq.default)({}, props, {
            theme: $03a55fe180c56544$var$resolveTheme((0, $kLZMq.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $lXNQ7.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $03a55fe180c56544$var$defaultOverridesResolver($03a55fe180c56544$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $53Ou4.default)(inputOptions, $03a55fe180c56544$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $03a55fe180c56544$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($03a55fe180c56544$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $lXNQ7.default)(tag, (0, $kLZMq.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $8HP8E.isPlainObject)(stylesArg)) return (props)=>$03a55fe180c56544$var$processStyleArg(stylesArg, (0, $kLZMq.default)({}, props, {
                    theme: $03a55fe180c56544$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $03a55fe180c56544$var$resolveTheme((0, $kLZMq.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $03a55fe180c56544$var$processStyleArg(slotStyle, (0, $kLZMq.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $03a55fe180c56544$var$resolveTheme((0, $kLZMq.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $03a55fe180c56544$var$processStyleArg({
                    variants: themeVariants
                }, (0, $kLZMq.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $70214a56a239c980$var$styled = (0, $03a55fe180c56544$export$2e2bcd8739ae039)();
var $70214a56a239c980$export$2e2bcd8739ae039 = $70214a56a239c980$var$styled;



var $9Fmgp = parcelRequire("9Fmgp");

var $5hW5y = parcelRequire("5hW5y");

var $7zKsg = parcelRequire("7zKsg");

var $fFwgb = parcelRequire("fFwgb");

var $fx59a = parcelRequire("fx59a");

var $4XrX4 = parcelRequire("4XrX4");
const $094f419c7a25abf9$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $094f419c7a25abf9$var$defaultTheme = (0, $7zKsg.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $094f419c7a25abf9$var$defaultCreateStyledComponent = (0, $70214a56a239c980$export$2e2bcd8739ae039)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $094f419c7a25abf9$var$useThemePropsDefault(props) {
    return (0, $9Fmgp.default)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $094f419c7a25abf9$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $094f419c7a25abf9$var$joinChildren(children, separator) {
    const childrenArray = $28UcW.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $28UcW.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $094f419c7a25abf9$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $094f419c7a25abf9$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $kLZMq.default)({
        display: 'flex',
        flexDirection: 'column'
    }, (0, $fFwgb.handleBreakpoints)({
        theme: theme
    }, (0, $fFwgb.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $fx59a.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $fFwgb.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $fFwgb.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $fx59a.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$094f419c7a25abf9$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $fx59a.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $8HP8E.default)(styles, (0, $fFwgb.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $fFwgb.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $094f419c7a25abf9$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $094f419c7a25abf9$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $094f419c7a25abf9$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $1fz9F.default)(slots, (slot)=>(0, $dYzHx.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($094f419c7a25abf9$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $28UcW.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $5hW5y.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $53Ou4.default)(props, $094f419c7a25abf9$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $4XrX4.jsx)(StackRoot, (0, $kLZMq.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $dP0oo.default)(classes.root, className)
        }, other, {
            children: divider ? $094f419c7a25abf9$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");
'use client';
const $86a15d936f4dc27a$var$Stack = (0, $094f419c7a25abf9$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $k5hQd.default)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $l9mID.default)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $86a15d936f4dc27a$export$2e2bcd8739ae039 = $86a15d936f4dc27a$var$Stack;




var $1mNk8 = parcelRequire("1mNk8");

var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");

var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $ffd027668f1f8b6b$export$717666c39ec07e12(slot) {
    return (0, $dYzHx.default)('MuiFormControlLabel', slot);
}
const $ffd027668f1f8b6b$var$formControlLabelClasses = (0, $d0ZgE.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $ffd027668f1f8b6b$export$2e2bcd8739ae039 = $ffd027668f1f8b6b$var$formControlLabelClasses;




var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $37789d6043540cf5$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $37789d6043540cf5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $1mNk8.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $ffd027668f1f8b6b$export$717666c39ec07e12), classes);
};
const $37789d6043540cf5$export$1b479270917a5676 = (0, $k5hQd.default)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $ffd027668f1f8b6b$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $1mNk8.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kLZMq.default)({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $ffd027668f1f8b6b$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        }
    }, ownerState.labelPlacement === 'start' && {
        flexDirection: 'row-reverse',
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === 'top' && {
        flexDirection: 'column-reverse',
        marginLeft: 16
    }, ownerState.labelPlacement === 'bottom' && {
        flexDirection: 'column',
        marginLeft: 16
    }, {
        [`& .${(0, $ffd027668f1f8b6b$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $ffd027668f1f8b6b$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $37789d6043540cf5$var$AsteriskComponent = (0, $k5hQd.default)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $ffd027668f1f8b6b$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $37789d6043540cf5$var$FormControlLabel = /*#__PURE__*/ $28UcW.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = 'end', required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $53Ou4.default)(props, $37789d6043540cf5$var$_excluded);
    const muiFormControl = (0, $63d2db91a3914164$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $f7e6aeeb255be989$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $kLZMq.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $37789d6043540cf5$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $f5a724df27408118$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f5a724df27408118$export$2e2bcd8739ae039), (0, $kLZMq.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $dP0oo.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $4XrX4.jsxs)($37789d6043540cf5$export$1b479270917a5676, (0, $kLZMq.default)({
        className: (0, $dP0oo.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $28UcW.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $86a15d936f4dc27a$export$2e2bcd8739ae039), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $4XrX4.jsxs)($37789d6043540cf5$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $37789d6043540cf5$export$2e2bcd8739ae039 = $37789d6043540cf5$var$FormControlLabel;


var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");


var $1fz9F = parcelRequire("1fz9F");

var $aMDDU = parcelRequire("aMDDU");

var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");


var $1fz9F = parcelRequire("1fz9F");

var $1mNk8 = parcelRequire("1mNk8");

var $k5hQd = parcelRequire("k5hQd");




var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $e8c53164f0e099b5$export$baa0faa0c7ad8085(slot) {
    return (0, $dYzHx.default)('PrivateSwitchBase', slot);
}
const $e8c53164f0e099b5$var$switchBaseClasses = (0, $d0ZgE.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $e8c53164f0e099b5$export$2e2bcd8739ae039 = $e8c53164f0e099b5$var$switchBaseClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $ab02db3ae11f40e7$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $ab02db3ae11f40e7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $1mNk8.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $e8c53164f0e099b5$export$baa0faa0c7ad8085), classes);
};
const $ab02db3ae11f40e7$var$SwitchBaseRoot = (0, $k5hQd.default)((0, $120c91fa1d9b1234$export$2e2bcd8739ae039))(({ ownerState: ownerState })=>(0, $kLZMq.default)({
        padding: 9,
        borderRadius: '50%'
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }));
const $ab02db3ae11f40e7$var$SwitchBaseInput = (0, $k5hQd.default)('input', {
    shouldForwardProp: (0, $k5hQd.rootShouldForwardProp)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $ab02db3ae11f40e7$var$SwitchBase = /*#__PURE__*/ $28UcW.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $53Ou4.default)(props, $ab02db3ae11f40e7$var$_excluded);
    const [checked, setCheckedState] = (0, $5dc34960420057aa$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $63d2db91a3914164$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = (0, $kLZMq.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $ab02db3ae11f40e7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)($ab02db3ae11f40e7$var$SwitchBaseRoot, (0, $kLZMq.default)({
        component: "span",
        className: (0, $dP0oo.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)($ab02db3ae11f40e7$var$SwitchBaseInput, (0, $kLZMq.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === 'checkbox' && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $ab02db3ae11f40e7$export$2e2bcd8739ae039 = $ab02db3ae11f40e7$var$SwitchBase;



var $l9mID = parcelRequire("l9mID");

var $kLZMq = parcelRequire("kLZMq");
parcelRequire("28UcW");

parcelRequire("28UcW");

var $hjLll = parcelRequire("hjLll");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
var $3e7d7c19c44cc8f2$export$2e2bcd8739ae039 = (0, $hjLll.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');


parcelRequire("28UcW");

var $hjLll = parcelRequire("hjLll");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
var $744f1748719dec2c$export$2e2bcd8739ae039 = (0, $hjLll.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');



var $k5hQd = parcelRequire("k5hQd");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $4ff593ed71b1a3b6$var$RadioButtonIconRoot = (0, $k5hQd.default)('span', {
    shouldForwardProp: (0, $k5hQd.rootShouldForwardProp)
})({
    position: 'relative',
    display: 'flex'
});
const $4ff593ed71b1a3b6$var$RadioButtonIconBackground = (0, $k5hQd.default)((0, $3e7d7c19c44cc8f2$export$2e2bcd8739ae039))({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
});
const $4ff593ed71b1a3b6$var$RadioButtonIconDot = (0, $k5hQd.default)((0, $744f1748719dec2c$export$2e2bcd8739ae039))(({ theme: theme, ownerState: ownerState })=>(0, $kLZMq.default)({
        left: 0,
        position: 'absolute',
        transform: 'scale(0)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.checked && {
        transform: 'scale(1)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.shortest
        })
    }));
/**
 * @ignore - internal component.
 */ function $4ff593ed71b1a3b6$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = (0, $kLZMq.default)({}, props, {
        checked: checked
    });
    return /*#__PURE__*/ (0, $4XrX4.jsxs)($4ff593ed71b1a3b6$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)($4ff593ed71b1a3b6$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)($4ff593ed71b1a3b6$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $4ff593ed71b1a3b6$export$2e2bcd8739ae039 = $4ff593ed71b1a3b6$var$RadioButtonIcon;



var $1mNk8 = parcelRequire("1mNk8");

var $b56af7727bf3d5bb$export$2e2bcd8739ae039 = (0, $c172664603a592be$export$2e2bcd8739ae039);



var $28UcW = parcelRequire("28UcW");

var $28UcW = parcelRequire("28UcW");
/**
 * @ignore - internal component.
 */ const $7b09ac8716142a6a$var$RadioGroupContext = /*#__PURE__*/ $28UcW.createContext(undefined);
var $7b09ac8716142a6a$export$2e2bcd8739ae039 = $7b09ac8716142a6a$var$RadioGroupContext;


'use client';
function $4768921787bfff81$export$2e2bcd8739ae039() {
    return $28UcW.useContext((0, $7b09ac8716142a6a$export$2e2bcd8739ae039));
}



var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $25a07ddeae6c96a6$export$192f7b2363c77155(slot) {
    return (0, $dYzHx.default)('MuiRadio', slot);
}
const $25a07ddeae6c96a6$var$radioClasses = (0, $d0ZgE.default)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
var $25a07ddeae6c96a6$export$2e2bcd8739ae039 = $25a07ddeae6c96a6$var$radioClasses;



var $k5hQd = parcelRequire("k5hQd");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $fa7b4481dfcfc67c$var$_excluded = [
    "checked",
    "checkedIcon",
    "color",
    "icon",
    "name",
    "onChange",
    "size",
    "className"
];
const $fa7b4481dfcfc67c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $1mNk8.default)(color)}`,
            size !== 'medium' && `size${(0, $1mNk8.default)(size)}`
        ]
    };
    return (0, $kLZMq.default)({}, classes, (0, $1fz9F.default)(slots, (0, $25a07ddeae6c96a6$export$192f7b2363c77155), classes));
};
const $fa7b4481dfcfc67c$var$RadioRoot = (0, $k5hQd.default)((0, $ab02db3ae11f40e7$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $k5hQd.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== 'medium' && styles[`size${(0, $1mNk8.default)(ownerState.size)}`],
            styles[`color${(0, $1mNk8.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kLZMq.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aMDDU.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $25a07ddeae6c96a6$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        }
    }, {
        [`&.${(0, $25a07ddeae6c96a6$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
function $fa7b4481dfcfc67c$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $fa7b4481dfcfc67c$var$defaultCheckedIcon = /*#__PURE__*/ (0, $4XrX4.jsx)((0, $4ff593ed71b1a3b6$export$2e2bcd8739ae039), {
    checked: true
});
const $fa7b4481dfcfc67c$var$defaultIcon = /*#__PURE__*/ (0, $4XrX4.jsx)((0, $4ff593ed71b1a3b6$export$2e2bcd8739ae039), {});
const $fa7b4481dfcfc67c$var$Radio = /*#__PURE__*/ $28UcW.forwardRef(function Radio(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiRadio'
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $fa7b4481dfcfc67c$var$defaultCheckedIcon, color: color = 'primary', icon: icon = $fa7b4481dfcfc67c$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = 'medium', className: className } = props, other = (0, $53Ou4.default)(props, $fa7b4481dfcfc67c$var$_excluded);
    const ownerState = (0, $kLZMq.default)({}, props, {
        color: color,
        size: size
    });
    const classes = $fa7b4481dfcfc67c$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $4768921787bfff81$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $b56af7727bf3d5bb$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = $fa7b4481dfcfc67c$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    return /*#__PURE__*/ (0, $4XrX4.jsx)($fa7b4481dfcfc67c$var$RadioRoot, (0, $kLZMq.default)({
        type: "radio",
        icon: /*#__PURE__*/ $28UcW.cloneElement(icon, {
            fontSize: (_defaultIcon$props$fo = $fa7b4481dfcfc67c$var$defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
        }),
        checkedIcon: /*#__PURE__*/ $28UcW.cloneElement(checkedIcon, {
            fontSize: (_defaultCheckedIcon$p = $fa7b4481dfcfc67c$var$defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
        }),
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref,
        className: (0, $dP0oo.default)(classes.root, className)
    }, other));
});
var $fa7b4481dfcfc67c$export$2e2bcd8739ae039 = $fa7b4481dfcfc67c$var$Radio;


var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $28UcW = parcelRequire("28UcW");


var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $1fz9F = parcelRequire("1fz9F");

var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");

var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $7f512cf429d0a9c5$export$d72d4cbdc30b331f(slot) {
    return (0, $dYzHx.default)('MuiFormGroup', slot);
}
const $7f512cf429d0a9c5$var$formGroupClasses = (0, $d0ZgE.default)('MuiFormGroup', [
    'root',
    'row',
    'error'
]);
var $7f512cf429d0a9c5$export$2e2bcd8739ae039 = $7f512cf429d0a9c5$var$formGroupClasses;





var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $9ae963a7c7fb9763$var$_excluded = [
    "className",
    "row"
];
const $9ae963a7c7fb9763$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $7f512cf429d0a9c5$export$d72d4cbdc30b331f), classes);
};
const $9ae963a7c7fb9763$var$FormGroupRoot = (0, $k5hQd.default)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState: ownerState })=>(0, $kLZMq.default)({
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap'
    }, ownerState.row && {
        flexDirection: 'row'
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $9ae963a7c7fb9763$var$FormGroup = /*#__PURE__*/ $28UcW.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    const { className: className, row: row = false } = props, other = (0, $53Ou4.default)(props, $9ae963a7c7fb9763$var$_excluded);
    const muiFormControl = (0, $63d2db91a3914164$export$2e2bcd8739ae039)();
    const fcs = (0, $f7e6aeeb255be989$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $kLZMq.default)({}, props, {
        row: row,
        error: fcs.error
    });
    const classes = $9ae963a7c7fb9763$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4XrX4.jsx)($9ae963a7c7fb9763$var$FormGroupRoot, (0, $kLZMq.default)({
        className: (0, $dP0oo.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $9ae963a7c7fb9763$export$2e2bcd8739ae039 = $9ae963a7c7fb9763$var$FormGroup;






'use client';
var $36fde02867a5ac3d$export$2e2bcd8739ae039 = (0, $930be18af46897d8$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $e4088b340bd66062$var$_excluded = [
    "actions",
    "children",
    "defaultValue",
    "name",
    "onChange",
    "value"
];
const $e4088b340bd66062$var$RadioGroup = /*#__PURE__*/ $28UcW.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp } = props, other = (0, $53Ou4.default)(props, $e4088b340bd66062$var$_excluded);
    const rootRef = $28UcW.useRef(null);
    const [value, setValueState] = (0, $5dc34960420057aa$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'RadioGroup'
    });
    $28UcW.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector('input:not(:disabled):checked');
                if (!input) input = rootRef.current.querySelector('input:not(:disabled)');
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $7d57efcdf4f58771$export$2e2bcd8739ae039)(ref, rootRef);
    const name = (0, $36fde02867a5ac3d$export$2e2bcd8739ae039)(nameProp);
    const contextValue = $28UcW.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $7b09ac8716142a6a$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $9ae963a7c7fb9763$export$2e2bcd8739ae039), (0, $kLZMq.default)({
            role: "radiogroup",
            ref: handleRef
        }, other, {
            children: children
        }))
    });
});
var $e4088b340bd66062$export$2e2bcd8739ae039 = $e4088b340bd66062$var$RadioGroup;


var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");



var $1fz9F = parcelRequire("1fz9F");

var $28UcW = parcelRequire("28UcW");



var $4XrX4 = parcelRequire("4XrX4");
'use client';
function $033ed16471e2f671$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $033ed16471e2f671$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/base-ui/react-click-away-listener/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/base-ui/react-click-away-listener/components-api/#click-away-listener)
 */ function $033ed16471e2f671$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $28UcW.useRef(false);
    const nodeRef = $28UcW.useRef(null);
    const activatedRef = $28UcW.useRef(false);
    const syntheticEventRef = $28UcW.useRef(false);
    $28UcW.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $39cf289415cf806e$export$2e2bcd8739ae039)(// @ts-expect-error TODO upstream fix
    children.ref, nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $e69ea0a302c22b7c$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $2aa96e427bd09d3b$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $033ed16471e2f671$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $28UcW.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $033ed16471e2f671$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $2aa96e427bd09d3b$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $28UcW.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $033ed16471e2f671$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $2aa96e427bd09d3b$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $4XrX4.jsx)($28UcW.Fragment, {
        children: /*#__PURE__*/ $28UcW.cloneElement(children, childrenProps)
    });
}



var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


'use client';
function $da067b1d2b36e582$export$1c97ac2c9a6e7c09(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = (0, $13f25f9c85a15779$export$2e2bcd8739ae039)();
    $28UcW.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) // IE11, Edge (prior to using Blink?) use 'Esc'
            {
                if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose == null || onClose(nativeEvent, 'escapeKeyDown');
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $e69ea0a302c22b7c$export$2e2bcd8739ae039)((event, reason)=>{
        onClose == null || onClose(event, reason);
    });
    const setAutoHideTimer = (0, $e69ea0a302c22b7c$export$2e2bcd8739ae039)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, 'timeout');
        });
    });
    $28UcW.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose == null || onClose(event, 'clickaway');
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $28UcW.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback == null || onBlurCallback(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback == null || onFocusCallback(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback == null || onMouseEnterCallback(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback == null || onMouseLeaveCallback(event);
            handleResume();
        };
    $28UcW.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return ()=>{
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $kLZMq.default)({}, (0, $772e7eb7442094ca$export$24d5698b57eff81c)(parameters), (0, $772e7eb7442094ca$export$24d5698b57eff81c)(externalProps));
        return (0, $kLZMq.default)({
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: 'presentation'
        }, externalProps, externalEventHandlers, {
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        });
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}



var $k5hQd = parcelRequire("k5hQd");


var $l9mID = parcelRequire("l9mID");

var $1mNk8 = parcelRequire("1mNk8");


var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $1fz9F = parcelRequire("1fz9F");

var $aMDDU = parcelRequire("aMDDU");

var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");


var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $1a3bbd7fb14db74a$export$def81488db1a3216(slot) {
    return (0, $dYzHx.default)('MuiSnackbarContent', slot);
}
const $1a3bbd7fb14db74a$var$snackbarContentClasses = (0, $d0ZgE.default)('MuiSnackbarContent', [
    'root',
    'message',
    'action'
]);
var $1a3bbd7fb14db74a$export$2e2bcd8739ae039 = $1a3bbd7fb14db74a$var$snackbarContentClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $9d82ece261280122$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $9d82ece261280122$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        action: [
            'action'
        ],
        message: [
            'message'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $1a3bbd7fb14db74a$export$def81488db1a3216), classes);
};
const $9d82ece261280122$var$SnackbarContentRoot = (0, $k5hQd.default)((0, $ac02ff9d8c78ed7f$export$2e2bcd8739ae039), {
    name: 'MuiSnackbarContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
    const backgroundColor = (0, $aMDDU.emphasize)(theme.palette.background.default, emphasis);
    return (0, $kLZMq.default)({}, theme.typography.body2, {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
            flexGrow: 'initial',
            minWidth: 288
        }
    });
});
const $9d82ece261280122$var$SnackbarContentMessage = (0, $k5hQd.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0'
});
const $9d82ece261280122$var$SnackbarContentAction = (0, $k5hQd.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8
});
const $9d82ece261280122$var$SnackbarContent = /*#__PURE__*/ $28UcW.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiSnackbarContent'
    });
    const { action: action, className: className, message: message, role: role = 'alert' } = props, other = (0, $53Ou4.default)(props, $9d82ece261280122$var$_excluded);
    const ownerState = props;
    const classes = $9d82ece261280122$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)($9d82ece261280122$var$SnackbarContentRoot, (0, $kLZMq.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $dP0oo.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)($9d82ece261280122$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $4XrX4.jsx)($9d82ece261280122$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
var $9d82ece261280122$export$2e2bcd8739ae039 = $9d82ece261280122$var$SnackbarContent;



var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $4738f7446351a629$export$6cb096457f5926f4(slot) {
    return (0, $dYzHx.default)('MuiSnackbar', slot);
}
const $4738f7446351a629$var$snackbarClasses = (0, $d0ZgE.default)('MuiSnackbar', [
    'root',
    'anchorOriginTopCenter',
    'anchorOriginBottomCenter',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft'
]);
var $4738f7446351a629$export$2e2bcd8739ae039 = $4738f7446351a629$var$snackbarClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $d1491367b4f182a0$var$_excluded = [
    "onEnter",
    "onExited"
], $d1491367b4f182a0$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $d1491367b4f182a0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            'root',
            `anchorOrigin${(0, $1mNk8.default)(anchorOrigin.vertical)}${(0, $1mNk8.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $4738f7446351a629$export$6cb096457f5926f4), classes);
};
const $d1491367b4f182a0$var$SnackbarRoot = (0, $k5hQd.default)('div', {
    name: 'MuiSnackbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $1mNk8.default)(ownerState.anchorOrigin.vertical)}${(0, $1mNk8.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const center = {
        left: '50%',
        right: 'auto',
        transform: 'translateX(-50%)'
    };
    return (0, $kLZMq.default)({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: 'fixed',
        display: 'flex',
        left: 8,
        right: 8,
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.anchorOrigin.vertical === 'top' ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === 'left' && {
        justifyContent: 'flex-start'
    }, ownerState.anchorOrigin.horizontal === 'right' && {
        justifyContent: 'flex-end'
    }, {
        [theme.breakpoints.up('sm')]: (0, $kLZMq.default)({}, ownerState.anchorOrigin.vertical === 'top' ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === 'center' && center, ownerState.anchorOrigin.horizontal === 'left' && {
            left: 24,
            right: 'auto'
        }, ownerState.anchorOrigin.horizontal === 'right' && {
            right: 24,
            left: 'auto'
        })
    });
});
const $d1491367b4f182a0$var$Snackbar = /*#__PURE__*/ $28UcW.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiSnackbar'
    });
    const theme = (0, $93b513bca024249e$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: 'bottom',
        horizontal: 'left'
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerProps, ContentProps: ContentProps, disableWindowBlurListener: disableWindowBlurListener = false, message: message, open: open, TransitionComponent: TransitionComponent = (0, $fd8c790be1396626$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited } = {} } = props, TransitionProps = (0, $53Ou4.default)(props.TransitionProps, $d1491367b4f182a0$var$_excluded), other = (0, $53Ou4.default)(props, $d1491367b4f182a0$var$_excluded2);
    const ownerState = (0, $kLZMq.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDuration
    });
    const classes = $d1491367b4f182a0$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $da067b1d2b36e582$export$1c97ac2c9a6e7c09)((0, $kLZMq.default)({}, ownerState));
    const [exited, setExited] = $28UcW.useState(true);
    const rootProps = (0, $308c9efc97ee800b$export$1e5c9e6e4e15efe3)({
        elementType: $d1491367b4f182a0$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: ref
        },
        className: [
            classes.root,
            className
        ]
    });
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $033ed16471e2f671$export$58385c17fee43f89), (0, $kLZMq.default)({
        onClickAway: onClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $4XrX4.jsx)($d1491367b4f182a0$var$SnackbarRoot, (0, $kLZMq.default)({}, rootProps, {
            children: /*#__PURE__*/ (0, $4XrX4.jsx)(TransitionComponent, (0, $kLZMq.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === 'top' ? 'down' : 'up',
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $4XrX4.jsx)((0, $9d82ece261280122$export$2e2bcd8739ae039), (0, $kLZMq.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
var $d1491367b4f182a0$export$2e2bcd8739ae039 = $d1491367b4f182a0$var$Snackbar;


var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");


var $1fz9F = parcelRequire("1fz9F");

var $aMDDU = parcelRequire("aMDDU");

var $1mNk8 = parcelRequire("1mNk8");


var $l9mID = parcelRequire("l9mID");

var $k5hQd = parcelRequire("k5hQd");

var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $fed12c5133523f6f$export$39f6debbec19b3ba(slot) {
    return (0, $dYzHx.default)('MuiSwitch', slot);
}
const $fed12c5133523f6f$var$switchClasses = (0, $d0ZgE.default)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $fed12c5133523f6f$export$2e2bcd8739ae039 = $fed12c5133523f6f$var$switchClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $282e375ac8975602$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $282e375ac8975602$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $1mNk8.default)(edge)}`,
            `size${(0, $1mNk8.default)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $1mNk8.default)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $1fz9F.default)(slots, (0, $fed12c5133523f6f$export$39f6debbec19b3ba), classes);
    return (0, $kLZMq.default)({}, classes, composedClasses);
};
const $282e375ac8975602$var$SwitchRoot = (0, $k5hQd.default)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $1mNk8.default)(ownerState.edge)}`],
            styles[`size${(0, $1mNk8.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kLZMq.default)({
        display: 'inline-flex',
        width: 58,
        height: 38,
        overflow: 'hidden',
        padding: 12,
        boxSizing: 'border-box',
        position: 'relative',
        flexShrink: 0,
        zIndex: 0,
        // Reset the stacking context.
        verticalAlign: 'middle',
        // For correct alignment with the text.
        '@media print': {
            colorAdjust: 'exact'
        }
    }, ownerState.edge === 'start' && {
        marginLeft: -8
    }, ownerState.edge === 'end' && {
        marginRight: -8
    }, ownerState.size === 'small' && {
        width: 40,
        height: 24,
        padding: 7,
        [`& .${(0, $fed12c5133523f6f$export$2e2bcd8739ae039).thumb}`]: {
            width: 16,
            height: 16
        },
        [`& .${(0, $fed12c5133523f6f$export$2e2bcd8739ae039).switchBase}`]: {
            padding: 4,
            [`&.${(0, $fed12c5133523f6f$export$2e2bcd8739ae039).checked}`]: {
                transform: 'translateX(16px)'
            }
        }
    }));
const $282e375ac8975602$var$SwitchSwitchBase = (0, $k5hQd.default)((0, $ab02db3ae11f40e7$export$2e2bcd8739ae039), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $fed12c5133523f6f$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $1mNk8.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $fed12c5133523f6f$export$2e2bcd8739ae039).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $fed12c5133523f6f$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $fed12c5133523f6f$export$2e2bcd8739ae039).checked} + .${(0, $fed12c5133523f6f$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $fed12c5133523f6f$export$2e2bcd8739ae039).disabled} + .${(0, $fed12c5133523f6f$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $fed12c5133523f6f$export$2e2bcd8739ae039).input}`]: {
            left: '-100%',
            width: '300%'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $kLZMq.default)({
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aMDDU.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $fed12c5133523f6f$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main,
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aMDDU.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            [`&.${(0, $fed12c5133523f6f$export$2e2bcd8739ae039).disabled}`]: {
                color: theme.vars ? theme.vars.palette.Switch[`${ownerState.color}DisabledColor`] : `${theme.palette.mode === 'light' ? (0, $aMDDU.lighten)(theme.palette[ownerState.color].main, 0.62) : (0, $aMDDU.darken)(theme.palette[ownerState.color].main, 0.55)}`
            }
        },
        [`&.${(0, $fed12c5133523f6f$export$2e2bcd8739ae039).checked} + .${(0, $fed12c5133523f6f$export$2e2bcd8739ae039).track}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main
        }
    }));
const $282e375ac8975602$var$SwitchTrack = (0, $k5hQd.default)('span', {
    name: 'MuiSwitch',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    }));
const $282e375ac8975602$var$SwitchThumb = (0, $k5hQd.default)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    }));
const $282e375ac8975602$var$Switch = /*#__PURE__*/ $28UcW.forwardRef(function Switch(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx } = props, other = (0, $53Ou4.default)(props, $282e375ac8975602$var$_excluded);
    const ownerState = (0, $kLZMq.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $282e375ac8975602$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $4XrX4.jsx)($282e375ac8975602$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $4XrX4.jsxs)($282e375ac8975602$var$SwitchRoot, {
        className: (0, $dP0oo.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)($282e375ac8975602$var$SwitchSwitchBase, (0, $kLZMq.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $kLZMq.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $4XrX4.jsx)($282e375ac8975602$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $282e375ac8975602$export$2e2bcd8739ae039 = $282e375ac8975602$var$Switch;








const $424f0e7ae5922bd7$var$AccountPage = ()=>{
    const navigate = (0, $6e00b7bb3feca34a$export$9770f232ac06a008)();
    const initialSettings = (0, $e2662af8a2ab1f76$export$986181c251d527c3).useState((s)=>s.userData?.settings) || {};
    const auth = (0, $de660e99e3126d7c$export$ae1af26003f05816)();
    const signedIn = (0, $e2662af8a2ab1f76$export$986181c251d527c3).useState((s)=>s.signedIn);
    const [hfEnabled, setHfEnabled] = (0, $28UcW.useState)(initialSettings.hapticFeedbackEnabled);
    const [pathwordHints, setPathwordHints] = (0, $28UcW.useState)(initialSettings.pathwordDefaultHints ?? 2);
    const [pathword5x5Hints, setPathword5x5Hints] = (0, $28UcW.useState)(initialSettings.pathword5x5DefaultHints ?? 4);
    const [deleteDialogOpen, setDeleteDialogOpen] = (0, $28UcW.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $28UcW.useState)(false);
    const [toastOpen, setToastOpen] = (0, $28UcW.useState)(false);
    const [toastMessage, setToastMessage] = (0, $28UcW.useState)('');
    const [toastSeverity, setToastSeverity] = (0, $28UcW.useState)('success');
    (0, $28UcW.useEffect)(()=>{
        if (!signedIn) {
            navigate('/');
            (0, $e2662af8a2ab1f76$export$986181c251d527c3).update((s)=>{
                s.signInDialog.isOpen = true;
                s.signInDialog.redirectPathAfterLogin = '/account';
            });
        }
    });
    const saveChanges = async (settings)=>{
        try {
            const authToken = await auth.currentUser?.getIdToken(true);
            await (0, $ea74087fd5ac399e$export$2e2bcd8739ae039).post('/api/users/update-settings', {
                authToken: authToken,
                newSettings: settings
            }, {
                timeout: 5000
            });
            // Only update the store after successful API response
            (0, $e2662af8a2ab1f76$export$986181c251d527c3).update((s)=>{
                if (settings.hapticFeedbackEnabled !== undefined) s.userData.settings.hapticFeedbackEnabled = settings.hapticFeedbackEnabled;
                if (settings.pathwordDefaultHints !== undefined) s.userData.settings.pathwordDefaultHints = settings.pathwordDefaultHints;
                if (settings.pathword5x5DefaultHints !== undefined) s.userData.settings.pathword5x5DefaultHints = settings.pathword5x5DefaultHints;
            });
            // Success - show success toast
            setToastMessage('Changes saved');
            setToastSeverity('success');
            setToastOpen(true);
        } catch (error) {
            console.error('Error saving settings:', error);
            // Revert local state on failure
            if (settings.hapticFeedbackEnabled !== undefined) setHfEnabled(initialSettings.hapticFeedbackEnabled);
            if (settings.pathwordDefaultHints !== undefined) {
                setPathwordHints(initialSettings.pathwordDefaultHints ?? 2);
                (0, $56703c0bbcb0049a$export$557a6027eb88d4ac).update((s)=>{
                    s.enabledHints = (0, $5672f12342c56f70$export$2060161a50430d7e)(initialSettings.pathwordDefaultHints ?? 2);
                    s.initialEnabledHints = initialSettings.pathwordDefaultHints ?? 2;
                });
            }
            if (settings.pathword5x5DefaultHints !== undefined) {
                setPathword5x5Hints(initialSettings.pathword5x5DefaultHints ?? 4);
                (0, $86b89eb84cf821a4$export$681392899cda0e6d).update((s)=>{
                    s.enabledHints = (0, $5672f12342c56f70$export$46f43f842bb402d)(initialSettings.pathword5x5DefaultHints ?? 4);
                    s.initialEnabledHints = initialSettings.pathword5x5DefaultHints ?? 4;
                });
            }
            // Error - show error toast
            setToastMessage('Failed to save changes. Please try again.');
            setToastSeverity('error');
            setToastOpen(true);
        }
    };
    const handleToastClose = ()=>{
        setToastOpen(false);
    };
    const handleDeleteAccount = async ()=>{
        setIsDeleting(true);
        try {
            const authToken = await auth.currentUser?.getIdToken(true);
            await (0, $ea74087fd5ac399e$export$2e2bcd8739ae039).post('/api/users/delete-account', {
                authToken: authToken
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            // Clear local storage
            localStorage.clear();
            // Sign out from Firebase
            await auth.signOut();
            // Redirect to home
            navigate('/');
        } catch (error) {
            console.error('Error deleting account:', error);
            setIsDeleting(false);
            setDeleteDialogOpen(false);
            alert('Failed to delete account. Please try again or contact support.');
        }
    };
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "accountPage",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("h2", {
                children: "Account Settings"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "settingsSection",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                        children: "Enable haptic feedback for mobile keyboard"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $282e375ac8975602$export$2e2bcd8739ae039), {
                        checked: hfEnabled,
                        onChange: ()=>{
                            setHfEnabled(!hfEnabled);
                            saveChanges({
                                hapticFeedbackEnabled: !hfEnabled
                            });
                        },
                        inputProps: {
                            'aria-label': 'controlled'
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "settingsSection",
                children: /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $5a094b6730918899$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsx)((0, $ed0290a2a1b80546$export$2e2bcd8739ae039), {
                            children: "Pathword Default Hints"
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $e4088b340bd66062$export$2e2bcd8739ae039), {
                            row: true,
                            value: pathwordHints,
                            onChange: (e)=>{
                                const value = Number(e.target.value);
                                setPathwordHints(value);
                                // Update the store immediately
                                (0, $56703c0bbcb0049a$export$557a6027eb88d4ac).update((s)=>{
                                    s.enabledHints = (0, $5672f12342c56f70$export$2060161a50430d7e)(value);
                                    s.initialEnabledHints = value;
                                    s.hintsUsed = 0;
                                });
                                saveChanges({
                                    pathwordDefaultHints: value
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $37789d6043540cf5$export$2e2bcd8739ae039), {
                                    value: 0,
                                    control: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $fa7b4481dfcfc67c$export$2e2bcd8739ae039), {}),
                                    label: "0"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $37789d6043540cf5$export$2e2bcd8739ae039), {
                                    value: 1,
                                    control: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $fa7b4481dfcfc67c$export$2e2bcd8739ae039), {}),
                                    label: "1"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $37789d6043540cf5$export$2e2bcd8739ae039), {
                                    value: 2,
                                    control: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $fa7b4481dfcfc67c$export$2e2bcd8739ae039), {}),
                                    label: "2"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "settingsSection",
                children: /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $5a094b6730918899$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsx)((0, $ed0290a2a1b80546$export$2e2bcd8739ae039), {
                            children: "Pathword 5x5 Default Hints"
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $e4088b340bd66062$export$2e2bcd8739ae039), {
                            row: true,
                            value: pathword5x5Hints,
                            onChange: (e)=>{
                                const value = Number(e.target.value);
                                setPathword5x5Hints(value);
                                // Update the store immediately
                                (0, $86b89eb84cf821a4$export$681392899cda0e6d).update((s)=>{
                                    s.enabledHints = (0, $5672f12342c56f70$export$46f43f842bb402d)(value);
                                    s.initialEnabledHints = value;
                                    s.hintsUsed = 0;
                                });
                                saveChanges({
                                    pathword5x5DefaultHints: value
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $37789d6043540cf5$export$2e2bcd8739ae039), {
                                    value: 0,
                                    control: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $fa7b4481dfcfc67c$export$2e2bcd8739ae039), {}),
                                    label: "0"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $37789d6043540cf5$export$2e2bcd8739ae039), {
                                    value: 1,
                                    control: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $fa7b4481dfcfc67c$export$2e2bcd8739ae039), {}),
                                    label: "1"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $37789d6043540cf5$export$2e2bcd8739ae039), {
                                    value: 2,
                                    control: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $fa7b4481dfcfc67c$export$2e2bcd8739ae039), {}),
                                    label: "2"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $37789d6043540cf5$export$2e2bcd8739ae039), {
                                    value: 3,
                                    control: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $fa7b4481dfcfc67c$export$2e2bcd8739ae039), {}),
                                    label: "3"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $37789d6043540cf5$export$2e2bcd8739ae039), {
                                    value: 4,
                                    control: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $fa7b4481dfcfc67c$export$2e2bcd8739ae039), {}),
                                    label: "4"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "settingsSection",
                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $85c133b03e2ea24a$export$2e2bcd8739ae039), {
                    variant: "outlined",
                    color: "error",
                    onClick: ()=>setDeleteDialogOpen(true),
                    children: "Delete My Account"
                })
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $85c133b03e2ea24a$export$2e2bcd8739ae039), {
                className: "returnHomeButton",
                variant: "text",
                onClick: ()=>{
                    navigate('/');
                },
                children: "Return to Main Page"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $74c5b717dc6d45d0$export$2e2bcd8739ae039), {
                open: deleteDialogOpen,
                onClose: ()=>!isDeleting && setDeleteDialogOpen(false),
                children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                    className: "deleteConfirmationDialog",
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsx)("h2", {
                            children: "Delete Account"
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "Are you absolutely sure you want to delete your account? This action cannot be undone."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            className: "warningText",
                            children: "All your progress, stats, and settings will be permanently deleted."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                            className: "dialogButtons",
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $85c133b03e2ea24a$export$2e2bcd8739ae039), {
                                    variant: "outlined",
                                    onClick: ()=>setDeleteDialogOpen(false),
                                    disabled: isDeleting,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $85c133b03e2ea24a$export$2e2bcd8739ae039), {
                                    variant: "contained",
                                    color: "error",
                                    onClick: handleDeleteAccount,
                                    disabled: isDeleting,
                                    children: isDeleting ? 'Deleting...' : 'Yes, Delete My Account'
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d1491367b4f182a0$export$2e2bcd8739ae039), {
                open: toastOpen,
                autoHideDuration: 3000,
                onClose: handleToastClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                sx: {
                    '@media (min-width: 768px)': {
                        bottom: '80px !important',
                        left: 'auto !important',
                        right: '24px !important',
                        transform: 'none !important'
                    }
                },
                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $af6f223451989330$export$2e2bcd8739ae039), {
                    onClose: handleToastClose,
                    severity: toastSeverity,
                    sx: {
                        width: '100%'
                    },
                    children: toastMessage
                })
            })
        ]
    });
};
var $424f0e7ae5922bd7$export$2e2bcd8739ae039 = $424f0e7ae5922bd7$var$AccountPage;


var $f7134883b2941fd5$export$2e2bcd8739ae039 = (0, $424f0e7ae5922bd7$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");



const $dcb5c25fb91189d8$var$AboutPage = ()=>{
    const navigate = (0, $6e00b7bb3feca34a$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "aboutPage",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("h2", {
                children: "About"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "aboutSection",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                        children: [
                            "Although ",
                            /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                className: "italicText",
                                children: "The Daily Baffle"
                            }),
                            ' often employs "the royal we" to maintain the illusion of an editorial staff, it is largely a solo endeavour designed and built by Julian Eden, a developer from the Northeast US.'
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                        children: "All our puzzle formats are original creations designed in a notebook in the spring of 2024."
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                        children: [
                            "Morphology, our clued puzzle published on weekdays, is constructed by a rotating menagerie of talented individuals, many of whom have previously been published in ",
                            /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                className: "italicText",
                                children: "The New York Times"
                            }),
                            ", the ",
                            /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                className: "italicText",
                                children: " Los Angeles Times"
                            }),
                            ", and other mainstream publications."
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                        children: [
                            "We can be reached at ",
                            /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                target: "_blank",
                                href: "mailto:editor@dailybaffle.com",
                                children: "editor@dailybaffle.com"
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $85c133b03e2ea24a$export$2e2bcd8739ae039), {
                className: "returnHomeButton",
                variant: "text",
                onClick: ()=>{
                    navigate('/');
                },
                children: "Return to Main Page"
            })
        ]
    });
};
var $dcb5c25fb91189d8$export$2e2bcd8739ae039 = $dcb5c25fb91189d8$var$AboutPage;


var $785ac5314154ebbf$export$2e2bcd8739ae039 = (0, $dcb5c25fb91189d8$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");



const $dc6e4a407fff7f2d$var$BlogPostPage = ()=>{
    const navigate = (0, $6e00b7bb3feca34a$export$9770f232ac06a008)();
    (0, $28UcW.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, []);
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "blogPostPage",
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("article", {
            className: "blogPost",
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)("header", {
                    className: "blogPostHeader",
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)("h1", {
                        className: "blogPostTitle",
                        children: "On Building Daily Puzzles, On Ending Them, And Other Thoughts"
                    })
                }),
                /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                    className: "blogPostBody",
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                            className: "firstParagraph",
                            children: [
                                "The motivation to build ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("em", {
                                    children: "The Daily Baffle"
                                }),
                                " came largely in reaction to seeing a million-and-one Wordle clones and a million-and-two crosswords, seemingly offered by every web outlet under the sun."
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "While I love crosswords and the original Wordle, I had started to wonder why the mainstream newspapers seemed to struggle in trying to create anything genuinely new in the daily puzzle space. It appeared to me at the time that many puzzle designers were simply copying those two ideas over and over, and many other offerings often boiled down to a mere wordsearch."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "So I wanted to try to build something new. I saw another site succeed at this, although their primary draw was \u2014 you guessed it \u2014 another daily crossword. Two of their other puzzles were essentially wordsearches. I wanted to break that mold, but also to build something challenging."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                            children: [
                                "When I released the Baffle, my personal expectation was that either ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                    onClick: ()=>navigate('/morphology'),
                                    children: "Morphology"
                                }),
                                " or ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                    onClick: ()=>navigate('/pathword'),
                                    children: "Pathword"
                                }),
                                " would be the biggest draw. Morphology, because its hand-written clueing would surely appeal to crossworders looking for a fresh format. Pathword, because it was unlike any other spelling puzzle I\u2019d ever seen, and because I found it fairly addictive myself. Once I\u2019d built it, for a long time I couldn\u2019t stop playing it."
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                            children: [
                                "My hope was that these novel formats would attract an audience sufficiently large that either I could add a paid tier with additional content, or otherwise perhaps attract the attention of a larger publisher, who might want to bring the Baffle\u2019s puzzles aboard one of their newspapers or sites. After all, many others have been acquired \u2014 ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    href: "https://www.puzzmo.com/",
                                    children: "Puzzmo"
                                }),
                                " was bought by Hearst, and ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    href: "https://www.theatlantic.com/games/bracket-city/",
                                    children: "Bracket City"
                                }),
                                " by the Atlantic. ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    href: "https://www.nytimes.com/games/wordle/index.html",
                                    children: "Wordle"
                                }),
                                " was bought by the NYT, of course, but I don\u2019t really count Wordle \u2014 it was the Harry Potter of daily word puzzles, an outlier so extreme in its success that it singlehandedly throws the general statistics."
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "For whatever reason, my hopes were not realized. The Baffle\u2019s daily audience nearly a year after launch hovers around 400 people, and was never much higher. It has attracted little notice from any corner."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                            children: [
                                "By comparison, the recently built ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    href: "https://18words.app/",
                                    children: "18 Words"
                                }),
                                " garnered 132k players on its first day, according to its creator. That left me feeling a bit forlorn. 18 Words challenges the player to unscramble a word, one word at a time, eighteen times. I\u2019m happy for that creator\u2019s success, but I can\u2019t really figure out why the puzzle got the reception it did. There are many such word scrambles; the concept is old as the hills."
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                            children: [
                                "It could be that this is a failure of promotion. That\u2019s quite possible, and it\u2019s what my friends believe. I thought it might grow on its own merits by word-of-mouth, as games like Bracket City, ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    href: "https://tiledwords.com/",
                                    children: "Tiled Words"
                                }),
                                ", and ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    href: "https://wafflegame.net/",
                                    children: "Waffle"
                                }),
                                " seem to have done, but that didn\u2019t happen. I ran various promotional efforts: having the Morphology constructors share their puzzles on their social media, running advertisements in the USA Today, sharing it in every possible discord and subreddit I could think of that might be interested. Those efforts didn\u2019t amount to much, unfortunately."
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "I reached out to reporters who had written articles about similar puzzle sites, and they said the Baffle was \u201CNeat!\u201D but were not interested in writing about it. A prominent crossword blogger said they would be happy to mention it in their blog, but they never did, and when I followed up after an extended delay, they didn\u2019t reply again. Multiple prominent puzzle youtubers didn\u2019t respond to emails. Posts on Hacker News went largely unnoticed. Frankly, I\u2019m not sure what more I could have done."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "The end result is that Morphology is soon going to have to come to an end. The other puzzles can continue to run largely indefinitely, as they have limitless possibilities and cost nothing, but Morphology must be built by hand every day, and at $100 per puzzle it costs roughly $1700/month to run, a price I cannot continue to justify when the site\u2019s future prospects appear dim."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                            children: [
                                "Why do I pay so much for it, you might reasonably ask. After all, Tiled Words pays nothing and has clued puzzles every day for free. Well, you\u2019re not wrong. My thinking was that by offering a competitive rate, the Baffle could attract the talent of the best constructors out there, people whose puzzles are published in ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("em", {
                                    children: "The New York Times"
                                }),
                                ", ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("em", {
                                    children: "The New Yorker"
                                }),
                                ", the ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("em", {
                                    children: "Los Angeles Times"
                                }),
                                ", and many others. I thought this would lead to higher quality and contribute to the site\u2019s success."
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "I was only partially right, it seems. Many extremely talented constructors did submit puzzles, and I have received many submissions of incredible quality. But the rate of submissions has slowed, and many of them come from people who are new to puzzle construction and clue writing. To be clear, I greatly enjoy working with those constructors to help them refine their puzzles and learn the art, and I\u2019m very glad to have their submissions. In fact, many of those submissions have been excellent."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "Nevertheless, I can\u2019t help but notice that the competitive rate we offer hasn\u2019t really garnered the attention of too many veterans. Aside from those I went out of my way to commission early on before launch, only a sliver of new submissions come from experienced constructors."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "Could I lower the rate? I could, but frankly I believe in paying people for their time and I don\u2019t really like the idea of suggesting that people spend their time contributing to my project without fairly compensating them for it. I encourage constructors to write interesting and flavorful clueing, and that takes time and thought. I could pay less, sure. But if $100 per puzzle already didn\u2019t attract much notice, I can only imagine that at $60 per puzzle, many of the existing contributors would feel it no longer worth their time."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "Moreover, it would only drop the cost to around $1000 a month \u2014 which is still far more than I\u2019m willing to continue paying. From a business perspective it just doesn\u2019t make sense for a project that doesn\u2019t appear to be going anywhere. It would make sense for a passion project, but after working on this since early 2024 without too much in the way of results, my passion is somewhat diminished. I want to do something new."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "To that end, I recently got an EMT license and decided to try something completely new rather than take another job in software development."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "To be honest, writing software isn\u2019t really quite what it used to be anymore, anyway. Tools like Claude Code can generate working software from a spec with such speed and competence that it no longer makes sense for us developers to type the code out ourselves. Most of us now just articulate what needs to be done to an AI agent, and then carefully check over its output for mistakes."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "It\u2019s great, in a way. We can build things far faster than ever before. New horizons of possibility are being opened up."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "But for those of us who loved the craft, who loved the marriage of logic and language that was programming, it feels a bit like watching a familiar forest get paved over to make way for an office building. No doubt the office building will contribute to the gross domestic product far more than the forest ever did, but we liked the forest. We liked walking its paths and stepping over the roots of the trees and just being lost in a place of serenity where things followed certain patterns that we felt attuned with. Programming felt at once like both sorcery and artistry, like writing incantations that really worked, where your words had real actual effects and where your skill and your style and your creativity and reasoning all factored into how powerful and how elegant your spells would be."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "I could continue to write code by hand for fun, of course, and I will here and there, but somehow the pleasure is somewhat undercut by the presence of a magical button that can just finish the task in seconds. I guess I have to admit that as much as I love programming, there are other things I would rather do now. 15 years of it was enough for me. There\u2019s so much else to learn and do."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "All that to say, my passion for working on the site has also been a bit corroded by the way the world has shifted in the last few years. If the Baffle had been a big hit and maybe had a chance of becoming a source of income, my passion might have lasted longer. But since I have to look elsewhere for future income, it\u2019s hard to maintain the focus that editing Morphology submissions requires, let alone the motivation to design and build new puzzles and add new content to the site."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "So, in sum, Morphology has now entered a rerun loop, and we won\u2019t be accepting new submissions anymore. The full archives will soon be made available in perpetuity."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "I expect that without Morphology, the site\u2019s audience will dwindle, but nonetheless the other puzzles will continue to run indefinitely. Triword is also made by hand, but I had already made all the valid Triwords before launching the site. It has multiple years\u2019 worth of 3-letter puzzles left before it too will enter a rerun loop due to having run out of valid combinations. The 4-letter solution Triwords will run out after September 5, 2026, and then it will be a 3-letter solution everyday thereafter."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "At some point I will still likely add some new operators to Arithmeglyphs. That is easy enough to do. I also have another version of the Pathword which I call Dueling Pathword, with two symmetrically moving paths, which I might make into a weekly special at some point if I can get it just right. It\u2019s half-built but not quite finished yet. I really like it so I\u2019ll probably finish that at some point in the not-so-distant future."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "To the site\u2019s small crowd of fans, I am very glad if I was able to build something you enjoyed. Anytime a mistake was made and people wrote in immediately to complain, it felt nice that someone cared. Most of the time when a person creates something, nobody else really cares that much, because most things that people create just don\u2019t have much value to anyone other than the creators themselves. Friends and family might be encouraging, but they mainly care about the creator, not the creation. They would be encouraging no matter what the creator made. So to have strangers care about the creation itself is like a little award, in a sense. It\u2019s nice to have built something that was valued by someone other than me."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "It's possible somewhere down the road I might decide to do a limited run of new Morphologies for a month or something like that. If I do, I'll send out an email to all the registered accounts letting them know. So if you would want to be notified about that, just make a free account and that's all it takes."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "Lastly, I feel I should note that a very skilled friend donated their time to build the Baffle\u2019s mobile apps, and I greatly appreciate it. I told them the site couldn\u2019t afford their work, and they said they just wanted to help and didn\u2019t really care about money. They just like building things. That\u2019s pretty rare. I like building things too. I am ready to build something new. I may try writing stories next."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                            children: [
                                "Feel free to write in with any questions; ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                                    target: "_blank",
                                    href: "mailto:editor@dailybaffle.com",
                                    children: "editor@dailybaffle.com"
                                }),
                                " isn\u2019t going anywhere. Thanks for reading, and thanks for solving. Until next time, puzzlers."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                    className: "blogPostFooter",
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $85c133b03e2ea24a$export$2e2bcd8739ae039), {
                        className: "returnHomeButton",
                        variant: "text",
                        onClick: ()=>{
                            navigate('/');
                        },
                        children: "Return to Main Page"
                    })
                })
            ]
        })
    });
};
var $dc6e4a407fff7f2d$export$2e2bcd8739ae039 = $dc6e4a407fff7f2d$var$BlogPostPage;


var $5e6f01baac63d731$export$2e2bcd8739ae039 = (0, $dc6e4a407fff7f2d$export$2e2bcd8739ae039);












var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");

class $5a86e076267d6604$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($28UcW))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }
    render() {
        if (this.state.hasError) return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
            className: "errorBoundaryReplacementUI",
            children: [
                "Something went wrong trying to display this page. Try refreshing.",
                /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                "If the issue persists, please email us at ",
                /*#__PURE__*/ (0, $4XrX4.jsx)("a", {
                    target: "_blank",
                    href: "mailto:editor@dailybaffle.com",
                    children: "editor@dailybaffle.com"
                }),
                " and we'll get on it."
            ]
        });
        return this.props.children;
    }
}
var $5a86e076267d6604$export$2e2bcd8739ae039 = $5a86e076267d6604$var$ErrorBoundary;


var $36480424a441d4c7$export$2e2bcd8739ae039 = (0, $5a86e076267d6604$export$2e2bcd8739ae039);



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");



var $kLZMq = parcelRequire("kLZMq");

var $53Ou4 = parcelRequire("53Ou4");

var $28UcW = parcelRequire("28UcW");

var $dP0oo = parcelRequire("dP0oo");

var $lXNQ7 = parcelRequire("lXNQ7");

var $iJ7JK = parcelRequire("iJ7JK");
var $5hW5y = parcelRequire("5hW5y");

var $5jh9n = parcelRequire("5jh9n");

var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $71990d1b22197c18$var$_excluded = [
    "className",
    "component"
];
function $71990d1b22197c18$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $lXNQ7.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $iJ7JK.default));
    const Box = /*#__PURE__*/ $28UcW.forwardRef(function Box(inProps, ref) {
        const theme = (0, $5jh9n.default)(defaultTheme);
        const _extendSxProp = (0, $5hW5y.default)(inProps), { className: className, component: component = 'div' } = _extendSxProp, other = (0, $53Ou4.default)(_extendSxProp, $71990d1b22197c18$var$_excluded);
        return /*#__PURE__*/ (0, $4XrX4.jsx)(BoxRoot, (0, $kLZMq.default)({
            as: component,
            ref: ref,
            className: (0, $dP0oo.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $gWFI6 = parcelRequire("gWFI6");

var $UbLFR = parcelRequire("UbLFR");

var $RjrfP = parcelRequire("RjrfP");

var $d0ZgE = parcelRequire("d0ZgE");
const $3fc40304524f6958$var$boxClasses = (0, $d0ZgE.default)('MuiBox', [
    'root'
]);
var $3fc40304524f6958$export$2e2bcd8739ae039 = $3fc40304524f6958$var$boxClasses;


'use client';
const $529a92f522bce533$var$defaultTheme = (0, $UbLFR.default)();
const $529a92f522bce533$var$Box = (0, $71990d1b22197c18$export$2e2bcd8739ae039)({
    themeId: (0, $RjrfP.default),
    defaultTheme: $529a92f522bce533$var$defaultTheme,
    defaultClassName: (0, $3fc40304524f6958$export$2e2bcd8739ae039).root,
    generateClassName: (0, $gWFI6.default).generate
});
var $529a92f522bce533$export$2e2bcd8739ae039 = $529a92f522bce533$var$Box;


var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");


var $1fz9F = parcelRequire("1fz9F");

var $3vbO9 = parcelRequire("3vbO9");

var $1mNk8 = parcelRequire("1mNk8");

var $l9mID = parcelRequire("l9mID");

var $k5hQd = parcelRequire("k5hQd");

var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $095ad9bf55814b80$export$29cad1383b3f235d(slot) {
    return (0, $dYzHx.default)('MuiCircularProgress', slot);
}
const $095ad9bf55814b80$var$circularProgressClasses = (0, $d0ZgE.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $095ad9bf55814b80$export$2e2bcd8739ae039 = $095ad9bf55814b80$var$circularProgressClasses;



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $9d16c19426fb8722$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $9d16c19426fb8722$var$_ = (t)=>t, $9d16c19426fb8722$var$_t, $9d16c19426fb8722$var$_t2, $9d16c19426fb8722$var$_t3, $9d16c19426fb8722$var$_t4;
const $9d16c19426fb8722$var$SIZE = 44;
const $9d16c19426fb8722$var$circularRotateKeyframe = (0, $3vbO9.keyframes)($9d16c19426fb8722$var$_t || ($9d16c19426fb8722$var$_t = $9d16c19426fb8722$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $9d16c19426fb8722$var$circularDashKeyframe = (0, $3vbO9.keyframes)($9d16c19426fb8722$var$_t2 || ($9d16c19426fb8722$var$_t2 = $9d16c19426fb8722$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $9d16c19426fb8722$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $1mNk8.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $1mNk8.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $095ad9bf55814b80$export$29cad1383b3f235d), classes);
};
const $9d16c19426fb8722$var$CircularProgressRoot = (0, $k5hQd.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $1mNk8.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $kLZMq.default)({
        display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && (0, $3vbO9.css)($9d16c19426fb8722$var$_t3 || ($9d16c19426fb8722$var$_t3 = $9d16c19426fb8722$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $9d16c19426fb8722$var$circularRotateKeyframe));
const $9d16c19426fb8722$var$CircularProgressSVG = (0, $k5hQd.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $9d16c19426fb8722$var$CircularProgressCircle = (0, $k5hQd.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $1mNk8.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $kLZMq.default)({
        stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, $3vbO9.css)($9d16c19426fb8722$var$_t4 || ($9d16c19426fb8722$var$_t4 = $9d16c19426fb8722$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $9d16c19426fb8722$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $9d16c19426fb8722$var$CircularProgress = /*#__PURE__*/ $28UcW.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate' } = props, other = (0, $53Ou4.default)(props, $9d16c19426fb8722$var$_excluded);
    const ownerState = (0, $kLZMq.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $9d16c19426fb8722$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($9d16c19426fb8722$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $4XrX4.jsx)($9d16c19426fb8722$var$CircularProgressRoot, (0, $kLZMq.default)({
        className: (0, $dP0oo.default)(classes.root, className),
        style: (0, $kLZMq.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $4XrX4.jsx)($9d16c19426fb8722$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$9d16c19426fb8722$var$SIZE / 2} ${$9d16c19426fb8722$var$SIZE / 2} ${$9d16c19426fb8722$var$SIZE} ${$9d16c19426fb8722$var$SIZE}`,
            children: /*#__PURE__*/ (0, $4XrX4.jsx)($9d16c19426fb8722$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $9d16c19426fb8722$var$SIZE,
                cy: $9d16c19426fb8722$var$SIZE,
                r: ($9d16c19426fb8722$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $9d16c19426fb8722$export$2e2bcd8739ae039 = $9d16c19426fb8722$var$CircularProgress;


const $6efaf703600cb10e$export$793970db8e2e1ea1 = [
    {
        name: 'Triword',
        dataKey: 'triword',
        color: '#8884d8'
    },
    {
        name: 'Pathword',
        dataKey: 'pathword',
        color: '#82ca9d'
    },
    {
        name: 'Arithmeglyphs',
        dataKey: 'arithmeglyphs',
        color: '#ffc658'
    },
    {
        name: 'Morphology',
        dataKey: 'morphology',
        color: '#ff7c7c'
    },
    {
        name: 'Rubigram',
        dataKey: 'rubigram',
        color: '#a28bfe'
    },
    {
        name: 'Megarubigram',
        dataKey: 'megarubigram',
        color: '#6dd5ed'
    },
    {
        name: 'Pathword 5x5',
        dataKey: 'pathword5x5',
        color: '#ff6b9d'
    },
    {
        name: 'Truthsorting',
        dataKey: 'truthsorting',
        color: '#ffa07a'
    }
];



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $25D7Q = parcelRequire("25D7Q");

var $1fz9F = parcelRequire("1fz9F");



var $1mNk8 = parcelRequire("1mNk8");

var $l9mID = parcelRequire("l9mID");

var $k5hQd = parcelRequire("k5hQd");

var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $e05218e5cadd6c82$export$21f89b560b65a301(slot) {
    return (0, $dYzHx.default)('MuiToggleButton', slot);
}
const $e05218e5cadd6c82$var$toggleButtonClasses = (0, $d0ZgE.default)('MuiToggleButton', [
    'root',
    'disabled',
    'selected',
    'standard',
    'primary',
    'secondary',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'fullWidth'
]);
var $e05218e5cadd6c82$export$2e2bcd8739ae039 = $e05218e5cadd6c82$var$toggleButtonClasses;



var $28UcW = parcelRequire("28UcW");
/**
 * @ignore - internal component.
 */ const $f002d1314fa53382$var$ToggleButtonGroupContext = /*#__PURE__*/ $28UcW.createContext({});
var $f002d1314fa53382$export$2e2bcd8739ae039 = $f002d1314fa53382$var$ToggleButtonGroupContext;



var $28UcW = parcelRequire("28UcW");
/**
 * @ignore - internal component.
 */ const $87fc61c06977db80$var$ToggleButtonGroupButtonContext = /*#__PURE__*/ $28UcW.createContext(undefined);
var $87fc61c06977db80$export$2e2bcd8739ae039 = $87fc61c06977db80$var$ToggleButtonGroupButtonContext;


// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function $bb1f1e29ee1f897c$export$2e2bcd8739ae039(value, candidate) {
    if (candidate === undefined || value === undefined) return false;
    if (Array.isArray(candidate)) return candidate.indexOf(value) >= 0;
    return value === candidate;
}



var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $31f39f8cd96ddfae$var$_excluded = [
    "value"
], $31f39f8cd96ddfae$var$_excluded2 = [
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "onChange",
    "onClick",
    "selected",
    "size",
    "value"
];
const $31f39f8cd96ddfae$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, fullWidth: fullWidth, selected: selected, disabled: disabled, size: size, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled',
            fullWidth && 'fullWidth',
            `size${(0, $1mNk8.default)(size)}`,
            color
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $e05218e5cadd6c82$export$21f89b560b65a301), classes);
};
const $31f39f8cd96ddfae$var$ToggleButtonRoot = (0, $k5hQd.default)((0, $120c91fa1d9b1234$export$2e2bcd8739ae039), {
    name: 'MuiToggleButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`size${(0, $1mNk8.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    let selectedColor = ownerState.color === 'standard' ? theme.palette.text.primary : theme.palette[ownerState.color].main;
    let selectedColorChannel;
    if (theme.vars) {
        selectedColor = ownerState.color === 'standard' ? theme.vars.palette.text.primary : theme.vars.palette[ownerState.color].main;
        selectedColorChannel = ownerState.color === 'standard' ? theme.vars.palette.text.primaryChannel : theme.vars.palette[ownerState.color].mainChannel;
    }
    return (0, $kLZMq.default)({}, theme.typography.button, {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        padding: 11,
        border: `1px solid ${(theme.vars || theme).palette.divider}`,
        color: (theme.vars || theme).palette.action.active
    }, ownerState.fullWidth && {
        width: '100%'
    }, {
        [`&.${(0, $e05218e5cadd6c82$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        },
        '&:hover': {
            textDecoration: 'none',
            // Reset on mouse devices
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $2f36425301faf1e3$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $e05218e5cadd6c82$export$2e2bcd8739ae039).selected}`]: {
            color: selectedColor,
            backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $2f36425301faf1e3$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $2f36425301faf1e3$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $2f36425301faf1e3$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity)
                }
            }
        }
    }, ownerState.size === 'small' && {
        padding: 7,
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && {
        padding: 15,
        fontSize: theme.typography.pxToRem(15)
    });
});
const $31f39f8cd96ddfae$var$ToggleButton = /*#__PURE__*/ $28UcW.forwardRef(function ToggleButton(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const _React$useContext = $28UcW.useContext((0, $f002d1314fa53382$export$2e2bcd8739ae039)), { value: contextValue } = _React$useContext, contextProps = (0, $53Ou4.default)(_React$useContext, $31f39f8cd96ddfae$var$_excluded);
    const toggleButtonGroupButtonContextPositionClassName = $28UcW.useContext((0, $87fc61c06977db80$export$2e2bcd8739ae039));
    const resolvedProps = (0, $25D7Q.default)((0, $kLZMq.default)({}, contextProps, {
        selected: (0, $bb1f1e29ee1f897c$export$2e2bcd8739ae039)(inProps.value, contextValue)
    }), inProps);
    const props = (0, $l9mID.default)({
        props: resolvedProps,
        name: 'MuiToggleButton'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: fullWidth = false, onChange: onChange, onClick: onClick, selected: selected, size: size = 'medium', value: value } = props, other = (0, $53Ou4.default)(props, $31f39f8cd96ddfae$var$_excluded2);
    const ownerState = (0, $kLZMq.default)({}, props, {
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size
    });
    const classes = $31f39f8cd96ddfae$var$useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onClick) {
            onClick(event, value);
            if (event.defaultPrevented) return;
        }
        if (onChange) onChange(event, value);
    };
    const positionClassName = toggleButtonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $4XrX4.jsx)($31f39f8cd96ddfae$var$ToggleButtonRoot, (0, $kLZMq.default)({
        className: (0, $dP0oo.default)(contextProps.className, classes.root, className, positionClassName),
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        ref: ref,
        onClick: handleChange,
        onChange: onChange,
        value: value,
        ownerState: ownerState,
        "aria-pressed": selected
    }, other, {
        children: children
    }));
});
var $31f39f8cd96ddfae$export$2e2bcd8739ae039 = $31f39f8cd96ddfae$var$ToggleButton;


var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");
parcelRequire("d79ZO");


var $dP0oo = parcelRequire("dP0oo");

var $1fz9F = parcelRequire("1fz9F");

var $28UcW = parcelRequire("28UcW");
function $355cde703b5dfd67$export$2e2bcd8739ae039(children) {
    return $28UcW.Children.toArray(children).filter((child)=>/*#__PURE__*/ $28UcW.isValidElement(child));
}



var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");

var $1mNk8 = parcelRequire("1mNk8");

var $d0ZgE = parcelRequire("d0ZgE");

var $dYzHx = parcelRequire("dYzHx");
function $7b19e3ea14e62850$export$44aa3ae5b353cef1(slot) {
    return (0, $dYzHx.default)('MuiToggleButtonGroup', slot);
}
const $7b19e3ea14e62850$var$toggleButtonGroupClasses = (0, $d0ZgE.default)('MuiToggleButtonGroup', [
    'root',
    'selected',
    'vertical',
    'disabled',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'fullWidth',
    'firstButton',
    'lastButton',
    'middleButton'
]);
var $7b19e3ea14e62850$export$2e2bcd8739ae039 = $7b19e3ea14e62850$var$toggleButtonGroupClasses;






var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $632eb35dc09eae66$var$_excluded = [
    "children",
    "className",
    "color",
    "disabled",
    "exclusive",
    "fullWidth",
    "onChange",
    "orientation",
    "size",
    "value"
];
const $632eb35dc09eae66$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, fullWidth: fullWidth, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation === 'vertical' && 'vertical',
            fullWidth && 'fullWidth'
        ],
        grouped: [
            'grouped',
            `grouped${(0, $1mNk8.default)(orientation)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $7b19e3ea14e62850$export$44aa3ae5b353cef1), classes);
};
const $632eb35dc09eae66$var$ToggleButtonGroupRoot = (0, $k5hQd.default)('div', {
    name: 'MuiToggleButtonGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).grouped}`]: styles.grouped
            },
            {
                [`& .${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $1mNk8.default)(ownerState.orientation)}`]
            },
            {
                [`& .${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
            },
            {
                [`& .${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
            },
            {
                [`& .${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
            },
            styles.root,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $kLZMq.default)({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.orientation === 'vertical' && {
        flexDirection: 'column'
    }, ownerState.fullWidth && {
        width: '100%'
    }, {
        [`& .${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).grouped}`]: (0, $kLZMq.default)({}, ownerState.orientation === 'horizontal' ? {
            [`&.${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).selected} + .${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).grouped}.${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).selected}`]: {
                borderLeft: 0,
                marginLeft: 0
            }
        } : {
            [`&.${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).selected} + .${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).grouped}.${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).selected}`]: {
                borderTop: 0,
                marginTop: 0
            }
        })
    }, ownerState.orientation === 'horizontal' ? {
        [`& .${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).firstButton},& .${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).middleButton}`]: {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        },
        [`& .${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).lastButton},& .${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).middleButton}`]: {
            marginLeft: -1,
            borderLeft: '1px solid transparent',
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
        }
    } : {
        [`& .${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).firstButton},& .${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).middleButton}`]: {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        },
        [`& .${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).lastButton},& .${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).middleButton}`]: {
            marginTop: -1,
            borderTop: '1px solid transparent',
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        }
    }, ownerState.orientation === 'horizontal' ? {
        [`& .${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).lastButton}.${(0, $e05218e5cadd6c82$export$2e2bcd8739ae039).disabled},& .${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).middleButton}.${(0, $e05218e5cadd6c82$export$2e2bcd8739ae039).disabled}`]: {
            borderLeft: '1px solid transparent'
        }
    } : {
        [`& .${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).lastButton}.${(0, $e05218e5cadd6c82$export$2e2bcd8739ae039).disabled},& .${(0, $7b19e3ea14e62850$export$2e2bcd8739ae039).middleButton}.${(0, $e05218e5cadd6c82$export$2e2bcd8739ae039).disabled}`]: {
            borderTop: '1px solid transparent'
        }
    }));
const $632eb35dc09eae66$var$ToggleButtonGroup = /*#__PURE__*/ $28UcW.forwardRef(function ToggleButtonGroup(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiToggleButtonGroup'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, exclusive: exclusive = false, fullWidth: fullWidth = false, onChange: onChange, orientation: orientation = 'horizontal', size: size = 'medium', value: value } = props, other = (0, $53Ou4.default)(props, $632eb35dc09eae66$var$_excluded);
    const ownerState = (0, $kLZMq.default)({}, props, {
        disabled: disabled,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size
    });
    const classes = $632eb35dc09eae66$var$useUtilityClasses(ownerState);
    const handleChange = $28UcW.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        const index = value && value.indexOf(buttonValue);
        let newValue;
        if (value && index >= 0) {
            newValue = value.slice();
            newValue.splice(index, 1);
        } else newValue = value ? value.concat(buttonValue) : [
            buttonValue
        ];
        onChange(event, newValue);
    }, [
        onChange,
        value
    ]);
    const handleExclusiveChange = $28UcW.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        onChange(event, value === buttonValue ? null : buttonValue);
    }, [
        onChange,
        value
    ]);
    const context = $28UcW.useMemo(()=>({
            className: classes.grouped,
            onChange: exclusive ? handleExclusiveChange : handleChange,
            value: value,
            size: size,
            fullWidth: fullWidth,
            color: color,
            disabled: disabled
        }), [
        classes.grouped,
        exclusive,
        handleExclusiveChange,
        handleChange,
        value,
        size,
        fullWidth,
        color,
        disabled
    ]);
    const validChildren = (0, $355cde703b5dfd67$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $4XrX4.jsx)($632eb35dc09eae66$var$ToggleButtonGroupRoot, (0, $kLZMq.default)({
        role: "group",
        className: (0, $dP0oo.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f002d1314fa53382$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $87fc61c06977db80$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    }));
});
var $632eb35dc09eae66$export$2e2bcd8739ae039 = $632eb35dc09eae66$var$ToggleButtonGroup;


// Use the app's themed CSS variables so the buttons stay legible in dark mode
// (MUI's default text color is dark and unreadable on the dark background).
const $55d80683716337ac$var$toggleButtonSx = {
    color: 'var(--textColor)',
    borderColor: 'var(--borderColor)',
    '&.Mui-selected': {
        color: 'var(--textColor)',
        backgroundColor: 'var(--selectedMorphologyRowBackgroundColor)',
        '&:hover': {
            backgroundColor: 'var(--selectedMorphologyRowBackgroundColor)'
        }
    }
};
const $55d80683716337ac$export$337812d3436a1a3d = ({ value: value, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $529a92f522bce533$export$2e2bcd8739ae039), {
        mb: 3,
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $632eb35dc09eae66$export$2e2bcd8739ae039), {
            value: value,
            exclusive: true,
            onChange: onChange,
            "aria-label": "time range",
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $31f39f8cd96ddfae$export$2e2bcd8739ae039), {
                    value: 7,
                    "aria-label": "7 days",
                    sx: $55d80683716337ac$var$toggleButtonSx,
                    children: "7 Days"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $31f39f8cd96ddfae$export$2e2bcd8739ae039), {
                    value: 30,
                    "aria-label": "30 days",
                    sx: $55d80683716337ac$var$toggleButtonSx,
                    children: "30 Days"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $31f39f8cd96ddfae$export$2e2bcd8739ae039), {
                    value: 90,
                    "aria-label": "90 days",
                    sx: $55d80683716337ac$var$toggleButtonSx,
                    children: "90 Days"
                })
            ]
        })
    });
};



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");

const $32a3ebf6780cac2b$var$StatCard = ({ value: value, label: label })=>/*#__PURE__*/ (0, $4XrX4.jsxs)((0, $529a92f522bce533$export$2e2bcd8739ae039), {
        className: "stat-card",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f5a724df27408118$export$2e2bcd8739ae039), {
                variant: "h6",
                children: value
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f5a724df27408118$export$2e2bcd8739ae039), {
                variant: "body2",
                color: "text.secondary",
                children: label
            })
        ]
    });
const $32a3ebf6780cac2b$export$b09a19a67293f946 = ({ visitors: visitors, loggedIn: loggedIn, loggedOut: loggedOut, puzzleOpens: puzzleOpens, puzzleSolves: puzzleSolves })=>{
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $529a92f522bce533$export$2e2bcd8739ae039), {
        className: "stats-summary",
        mb: 3,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)($32a3ebf6780cac2b$var$StatCard, {
                value: visitors,
                label: "Visitors Today"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)($32a3ebf6780cac2b$var$StatCard, {
                value: loggedIn,
                label: "Logged In Today"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)($32a3ebf6780cac2b$var$StatCard, {
                value: loggedOut,
                label: "Logged Out Today"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)($32a3ebf6780cac2b$var$StatCard, {
                value: puzzleOpens,
                label: "Puzzle Opens Today"
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)($32a3ebf6780cac2b$var$StatCard, {
                value: puzzleSolves,
                label: "Puzzle Solves Today"
            })
        ]
    });
};



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");


var $28UcW = parcelRequire("28UcW");
/* eslint no-console: 0 */ var $65baf459c02da39a$var$isDev = true;
var $65baf459c02da39a$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($65baf459c02da39a$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, ()=>args[argIndex++]));
            }
        }
    }
};


var $2c84e5b844764211$exports = {};

$2c84e5b844764211$exports = (parcelRequire("a3kJd")).get;


// if you go lower than 3, wild wild things happen during rendering
var $c127eb7db38963c7$var$defaultRoundPrecision = 4;
function $c127eb7db38963c7$export$2077e0241d6afd3c(num) {
    var roundPrecision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $c127eb7db38963c7$var$defaultRoundPrecision;
    var factor = 10 ** roundPrecision;
    var rounded = Math.round(num * factor) / factor;
    if (Object.is(rounded, -0)) return 0;
    return rounded;
}
function $c127eb7db38963c7$export$f8a24ecc3d6c26c3(strings) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    return strings.reduce((result, string, i)=>{
        var value = values[i - 1];
        if (typeof value === 'string') return result + value + string;
        if (value !== undefined) return result + $c127eb7db38963c7$export$2077e0241d6afd3c(value) + string;
        return result + string;
    }, '');
}


var $9a1343d05dde836c$export$9d334328eb75e624 = (value)=>{
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $9a1343d05dde836c$export$e426a261f3212d7d = (value)=>{
    // eslint-disable-next-line eqeqeq
    return typeof value == 'number' && value != +value;
};
var $9a1343d05dde836c$export$e50269385c77c348 = (value)=>typeof value === 'string' && value.indexOf('%') === value.length - 1;
var $9a1343d05dde836c$export$7e4aa119212bc614 = (value)=>(typeof value === 'number' || value instanceof Number) && !$9a1343d05dde836c$export$e426a261f3212d7d(value);
var $9a1343d05dde836c$export$402a499e1ea44294 = (value)=>$9a1343d05dde836c$export$7e4aa119212bc614(value) || typeof value === 'string';
var $9a1343d05dde836c$var$idCounter = 0;
var $9a1343d05dde836c$export$8b15d37bc3f197d4 = (prefix)=>{
    var id = ++$9a1343d05dde836c$var$idCounter;
    return "".concat(prefix || '').concat(id);
};
var $9a1343d05dde836c$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$9a1343d05dde836c$export$7e4aa119212bc614(percent) && typeof percent !== 'string') return defaultValue;
    var value;
    if ($9a1343d05dde836c$export$e50269385c77c348(percent)) {
        if (totalValue == null) return defaultValue;
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ($9a1343d05dde836c$export$e426a261f3212d7d(value)) value = defaultValue;
    if (validate && totalValue != null && value > totalValue) value = totalValue;
    return value;
};
var $9a1343d05dde836c$export$732baf6a98f122 = (ary)=>{
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[String(ary[i])]) cache[String(ary[i])] = true;
        else return true;
    }
    return false;
};
function $9a1343d05dde836c$export$89e29e4ab65e70a9(start, end, t) {
    if ($9a1343d05dde836c$export$7e4aa119212bc614(start) && $9a1343d05dde836c$export$7e4aa119212bc614(end)) return (0, $c127eb7db38963c7$export$2077e0241d6afd3c)(start + t * (end - start));
    return end;
}
function $9a1343d05dde836c$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return undefined;
    return ary.find((entry)=>entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($2c84e5b844764211$exports)))(entry, specifiedKey)) === specifiedValue);
}
var $9a1343d05dde836c$export$484982720961754e = (data)=>{
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        var _data$i, _data$i2;
        xcurrent = ((_data$i = data[i]) === null || _data$i === void 0 ? void 0 : _data$i.cx) || 0;
        ycurrent = ((_data$i2 = data[i]) === null || _data$i2 === void 0 ? void 0 : _data$i2.cy) || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};
var $9a1343d05dde836c$export$b931b78cbb3caf86 = (value)=>{
    return value === null || typeof value === 'undefined';
};
var $9a1343d05dde836c$export$3061f22cd819074d = (value)=>{
    if ($9a1343d05dde836c$export$b931b78cbb3caf86(value)) return value;
    return "".concat(value.charAt(0).toUpperCase()).concat(value.slice(1));
};
function $9a1343d05dde836c$export$7e515ab5fbd92bef(value) {
    return value != null;
}
function $9a1343d05dde836c$export$8793edee2d425525() {}


var $d179bd389fad45d8$exports = {};

$d179bd389fad45d8$exports = (parcelRequire("3vuQu")).sortBy;



var $c72ad316bc19e104$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$c72ad316bc19e104$exports = (parcelRequire("iWNkM"));



function $02d70e7027eb09d9$export$238176e5211cdc1a(arr, startIndex, endIndex) {
    if (!Array.isArray(arr)) return arr;
    if (arr && startIndex + endIndex !== 0) return arr.slice(startIndex, endIndex + 1);
    return arr;
}


function $11a93f8f3c3518e5$export$f8a8fc612ced9bb0(n) {
    return Number.isFinite(n);
}
function $11a93f8f3c3518e5$export$5374bb854d0e41c8(n) {
    return typeof n === 'number' && n > 0 && Number.isFinite(n);
}


function $912d8cf1d03ea507$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $912d8cf1d03ea507$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $912d8cf1d03ea507$var$ownKeys(Object(t), !0).forEach(function(r) {
            $912d8cf1d03ea507$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $912d8cf1d03ea507$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $912d8cf1d03ea507$var$_defineProperty(e, r, t) {
    return (r = $912d8cf1d03ea507$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $912d8cf1d03ea507$var$_toPropertyKey(t) {
    var i = $912d8cf1d03ea507$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $912d8cf1d03ea507$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $912d8cf1d03ea507$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, $9a1343d05dde836c$export$b931b78cbb3caf86)(obj) || (0, $9a1343d05dde836c$export$b931b78cbb3caf86)(dataKey)) return defaultValue;
    if ((0, $9a1343d05dde836c$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($2c84e5b844764211$exports)))(obj, dataKey, defaultValue);
    if (typeof dataKey === 'function') return dataKey(obj);
    return defaultValue;
}
var $912d8cf1d03ea507$export$3a657a8c9f789617 = (offset, legendSettings, legendSize)=>{
    if (legendSettings && legendSize) {
        var { width: boxWidth, height: boxHeight } = legendSize;
        var { align: align, verticalAlign: verticalAlign, layout: layout } = legendSettings;
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && align !== 'center' && (0, $9a1343d05dde836c$export$7e4aa119212bc614)(offset[align])) return $912d8cf1d03ea507$var$_objectSpread($912d8cf1d03ea507$var$_objectSpread({}, offset), {}, {
            [align]: offset[align] + (boxWidth || 0)
        });
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && verticalAlign !== 'middle' && (0, $9a1343d05dde836c$export$7e4aa119212bc614)(offset[verticalAlign])) return $912d8cf1d03ea507$var$_objectSpread($912d8cf1d03ea507$var$_objectSpread({}, offset), {}, {
            [verticalAlign]: offset[verticalAlign] + (boxHeight || 0)
        });
    }
    return offset;
};
var $912d8cf1d03ea507$export$9fc1baaa6c6368b = (layout, axisType)=>layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
var $912d8cf1d03ea507$export$846dc5ac5fecff74 = (ticks, minValue, maxValue, syncWithTicks)=>{
    if (syncWithTicks) return ticks.map((entry)=>entry.coordinate);
    var hasMin, hasMax;
    var values = ticks.map((entry)=>{
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var $912d8cf1d03ea507$export$c829ee42daf7f66d = (axis, isGrid, isAll)=>{
    if (!axis) return null;
    var { duplicateDomain: duplicateDomain, type: type, range: range, scale: scale, realScaleType: realScaleType, isCategorical: isCategorical, categoricalDomain: categoricalDomain, tickCount: tickCount, ticks: ticks, niceTicks: niceTicks, axisType: axisType } = axis;
    if (!scale) return null;
    var offsetForBand = realScaleType === 'scaleBand' && scale.bandwidth ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axisType === 'angleAxis' && range && range.length >= 2 ? (0, $9a1343d05dde836c$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (ticks || niceTicks)) {
        var result = (ticks || niceTicks || []).map((entry, index)=>{
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset,
                index: index
            };
        });
        return result.filter((row)=>!(0, $9a1343d05dde836c$export$e426a261f3212d7d)(row.coordinate));
    }
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        }));
    if (scale.ticks && !isAll && tickCount != null) return scale.ticks(tickCount).map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset,
            index: index
        }));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        }));
};
var $912d8cf1d03ea507$var$EPS = 1e-4;
var $912d8cf1d03ea507$export$9d80152e23bae434 = (scale)=>{
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - $912d8cf1d03ea507$var$EPS;
    var maxValue = Math.max(range[0], range[1]) + $912d8cf1d03ea507$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $912d8cf1d03ea507$export$c7ec0fa96d0c462e = (value, domain)=>{
    if (!domain || domain.length !== 2 || !(0, $9a1343d05dde836c$export$7e4aa119212bc614)(domain[0]) || !(0, $9a1343d05dde836c$export$7e4aa119212bc614)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $9a1343d05dde836c$export$7e4aa119212bc614)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, $9a1343d05dde836c$export$7e4aa119212bc614)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var $912d8cf1d03ea507$export$3104c513558164c1 = (series)=>{
    var _series$;
    var n = series.length;
    if (n <= 0) return;
    var m = (_series$ = series[0]) === null || _series$ === void 0 ? void 0 : _series$.length;
    if (m == null || m <= 0) return;
    for(var j = 0; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var row = series[i];
            var col = row === null || row === void 0 ? void 0 : row[j];
            if (col == null) continue;
            var series1 = col[1];
            var series0 = col[0];
            var value = (0, $9a1343d05dde836c$export$e426a261f3212d7d)(series1) ? series0 : series1;
            if (value >= 0) {
                col[0] = positive;
                col[1] = positive + value;
                positive = series1;
            } else {
                col[0] = negative;
                col[1] = negative + value;
                negative = series1;
            }
        }
    }
};
var $912d8cf1d03ea507$export$9f2c6ead70935022 = (series)=>{
    var _series$2;
    var n = series.length;
    if (n <= 0) return;
    var m = (_series$2 = series[0]) === null || _series$2 === void 0 ? void 0 : _series$2.length;
    if (m == null || m <= 0) return;
    for(var j = 0; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var row = series[i];
            var col = row === null || row === void 0 ? void 0 : row[j];
            if (col == null) continue;
            var value = (0, $9a1343d05dde836c$export$e426a261f3212d7d)(col[1]) ? col[0] : col[1];
            if (value >= 0) {
                col[0] = positive;
                col[1] = positive + value;
                // eslint-disable-next-line prefer-destructuring
                positive = col[1];
            } else {
                col[0] = 0;
                col[1] = 0;
            }
        }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var $912d8cf1d03ea507$var$STACK_OFFSET_MAP = {
    sign: $912d8cf1d03ea507$export$3104c513558164c1,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, $c72ad316bc19e104$exports.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, $c72ad316bc19e104$exports.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, $c72ad316bc19e104$exports.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, $c72ad316bc19e104$exports.stackOffsetWiggle),
    positive: $912d8cf1d03ea507$export$9f2c6ead70935022
};
var $912d8cf1d03ea507$export$c2170542cfc0177c = (data, dataKeys, offsetType)=>{
    var _STACK_OFFSET_MAP$off;
    var offsetAccessor = (_STACK_OFFSET_MAP$off = $912d8cf1d03ea507$var$STACK_OFFSET_MAP[offsetType]) !== null && _STACK_OFFSET_MAP$off !== void 0 ? _STACK_OFFSET_MAP$off : (0, $c72ad316bc19e104$exports.stackOffsetNone);
    var stack = (0, $c72ad316bc19e104$exports.stack)().keys(dataKeys).value((d, key)=>Number($912d8cf1d03ea507$export$f97fc4a450f29a(d, key, 0))).order((0, $c72ad316bc19e104$exports.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    var result = stack(data);
    // Post-process ranged data: if value is an array of two numbers, use them directly without stacking
    result.forEach((series, seriesIndex)=>{
        series.forEach((point, pointIndex)=>{
            var value = $912d8cf1d03ea507$export$f97fc4a450f29a(data[pointIndex], dataKeys[seriesIndex], 0);
            if (Array.isArray(value) && value.length === 2 && (0, $9a1343d05dde836c$export$7e4aa119212bc614)(value[0]) && (0, $9a1343d05dde836c$export$7e4aa119212bc614)(value[1])) {
                // eslint-disable-next-line prefer-destructuring,no-param-reassign
                point[0] = value[0];
                // eslint-disable-next-line prefer-destructuring,no-param-reassign
                point[1] = value[1];
            }
        });
    });
    return result;
};
function $912d8cf1d03ea507$export$f0871da41ca7fc82(publicStackId) {
    return publicStackId == null ? undefined : String(publicStackId);
}
function $912d8cf1d03ea507$export$6e87f3defb83c3f(_ref) {
    var { axis: axis, ticks: ticks, bandSize: bandSize, entry: entry, index: index, dataKey: dataKey } = _ref;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, $9a1343d05dde836c$export$b931b78cbb3caf86)(entry[axis.dataKey])) {
            // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
            var matchedTick = (0, $9a1343d05dde836c$export$66950d3869f5cc67)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $912d8cf1d03ea507$export$f97fc4a450f29a(entry, !(0, $9a1343d05dde836c$export$b931b78cbb3caf86)(dataKey) ? dataKey : axis.dataKey);
    // @ts-expect-error getValueByDataKey does not validate the output type
    return !(0, $9a1343d05dde836c$export$b931b78cbb3caf86)(value) ? axis.scale(value) : null;
}
var $912d8cf1d03ea507$export$8abb9e87422f3a0c = (_ref2)=>{
    var { axis: axis, ticks: ticks, offset: offset, bandSize: bandSize, entry: entry, index: index } = _ref2;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $912d8cf1d03ea507$export$f97fc4a450f29a(entry, axis.dataKey, axis.scale.domain()[index]);
    return !(0, $9a1343d05dde836c$export$b931b78cbb3caf86)(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $912d8cf1d03ea507$export$54f3200dd4a8a235 = (_ref3)=>{
    var { numericAxis: numericAxis } = _ref3;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        // @ts-expect-error type number means the domain has numbers in it but this relationship is not known to typescript
        var minValue = Math.min(domain[0], domain[1]);
        // @ts-expect-error type number means the domain has numbers in it but this relationship is not known to typescript
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var $912d8cf1d03ea507$var$getDomainOfSingle = (data)=>{
    var flat = data.flat(2).filter((0, $9a1343d05dde836c$export$7e4aa119212bc614));
    return [
        Math.min(...flat),
        Math.max(...flat)
    ];
};
var $912d8cf1d03ea507$var$makeDomainFinite = (domain)=>{
    return [
        domain[0] === Infinity ? 0 : domain[0],
        domain[1] === -Infinity ? 0 : domain[1]
    ];
};
var $912d8cf1d03ea507$export$26522b779eb5497c = (stackGroups, startIndex, endIndex)=>{
    if (stackGroups == null) return undefined;
    return $912d8cf1d03ea507$var$makeDomainFinite(Object.keys(stackGroups).reduce((result, stackId)=>{
        var group = stackGroups[stackId];
        if (!group) return result;
        var { stackedData: stackedData } = group;
        var domain = stackedData.reduce((res, entry)=>{
            var sliced = (0, $02d70e7027eb09d9$export$238176e5211cdc1a)(entry, startIndex, endIndex);
            var s = $912d8cf1d03ea507$var$getDomainOfSingle(sliced);
            if (!(0, $11a93f8f3c3518e5$export$f8a8fc612ced9bb0)(s[0]) || !(0, $11a93f8f3c3518e5$export$f8a8fc612ced9bb0)(s[1])) return res;
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]));
};
var $912d8cf1d03ea507$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $912d8cf1d03ea507$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $912d8cf1d03ea507$export$212ec45c42fe68a7 = (axis, ticks, isBar)=>{
    if (axis && axis.scale && axis.scale.bandwidth) {
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($d179bd389fad45d8$exports)))(ticks, (o)=>o.coordinate);
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min(((cur === null || cur === void 0 ? void 0 : cur.coordinate) || 0) - ((prev === null || prev === void 0 ? void 0 : prev.coordinate) || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
function $912d8cf1d03ea507$export$3c1b390368bb3561(_ref4) {
    var { tooltipEntrySettings: tooltipEntrySettings, dataKey: dataKey, payload: payload, value: value, name: name } = _ref4;
    return $912d8cf1d03ea507$var$_objectSpread($912d8cf1d03ea507$var$_objectSpread({}, tooltipEntrySettings), {}, {
        dataKey: dataKey,
        payload: payload,
        value: value,
        name: name
    });
}
function $912d8cf1d03ea507$export$d3207de44081d2b3(nameFromItem, dataKey) {
    if (nameFromItem) return String(nameFromItem);
    if (typeof dataKey === 'string') return dataKey;
    return undefined;
}
var $912d8cf1d03ea507$export$f29fac779ccd75bc = (coordinate, layout)=>{
    if (layout === 'horizontal') return coordinate.chartX;
    if (layout === 'vertical') return coordinate.chartY;
    return undefined;
};
var $912d8cf1d03ea507$export$fb2b0f76aa25d837 = (rangeObj, layout)=>{
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};



var $c8dcb2cb9e97048b$var$parseIsSsrByDefault = ()=>!(typeof window !== 'undefined' && window.document && Boolean(window.document.createElement) && window.setTimeout);
var $c8dcb2cb9e97048b$export$98f03c5d19621d70 = {
    devToolsEnabled: true,
    isSsr: $c8dcb2cb9e97048b$var$parseIsSsrByDefault()
};


function $24999327541f0a91$var$_defineProperty(e, r, t) {
    return (r = $24999327541f0a91$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $24999327541f0a91$var$_toPropertyKey(t) {
    var i = $24999327541f0a91$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $24999327541f0a91$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $24999327541f0a91$export$182500e6725aad9a {
    constructor(maxSize){
        $24999327541f0a91$var$_defineProperty(this, "cache", new Map());
        this.maxSize = maxSize;
    }
    get(key) {
        var value = this.cache.get(key);
        if (value !== undefined) {
            this.cache.delete(key);
            this.cache.set(key, value);
        }
        return value;
    }
    set(key, value) {
        if (this.cache.has(key)) this.cache.delete(key);
        else if (this.cache.size >= this.maxSize) {
            var firstKey = this.cache.keys().next().value;
            if (firstKey != null) this.cache.delete(firstKey);
        }
        this.cache.set(key, value);
    }
    clear() {
        this.cache.clear();
    }
    size() {
        return this.cache.size;
    }
}


function $677f7abc4dc0215c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $677f7abc4dc0215c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $677f7abc4dc0215c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $677f7abc4dc0215c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $677f7abc4dc0215c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $677f7abc4dc0215c$var$_defineProperty(e, r, t) {
    return (r = $677f7abc4dc0215c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $677f7abc4dc0215c$var$_toPropertyKey(t) {
    var i = $677f7abc4dc0215c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $677f7abc4dc0215c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $677f7abc4dc0215c$var$defaultConfig = {
    cacheSize: 2000,
    enableCache: true
};
var $677f7abc4dc0215c$var$currentConfig = $677f7abc4dc0215c$var$_objectSpread({}, $677f7abc4dc0215c$var$defaultConfig);
var $677f7abc4dc0215c$var$stringCache = new (0, $24999327541f0a91$export$182500e6725aad9a)($677f7abc4dc0215c$var$currentConfig.cacheSize);
var $677f7abc4dc0215c$var$SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var $677f7abc4dc0215c$var$MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function $677f7abc4dc0215c$var$createCacheKey(text, style) {
    // Simple string concatenation for better performance than JSON.stringify
    var fontSize = style.fontSize || '';
    var fontFamily = style.fontFamily || '';
    var fontWeight = style.fontWeight || '';
    var fontStyle = style.fontStyle || '';
    var letterSpacing = style.letterSpacing || '';
    var textTransform = style.textTransform || '';
    return "".concat(text, "|").concat(fontSize, "|").concat(fontFamily, "|").concat(fontWeight, "|").concat(fontStyle, "|").concat(letterSpacing, "|").concat(textTransform);
}
/**
 * Measure text using DOM (accurate but slower)
 * @param text - The text to measure
 * @param style - CSS style properties to apply
 * @returns The size of the text
 */ var $677f7abc4dc0215c$var$measureTextWithDOM = (text, style)=>{
    try {
        var measurementSpan = document.getElementById($677f7abc4dc0215c$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', $677f7abc4dc0215c$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Apply styles directly without unnecessary object creation
        Object.assign(measurementSpan.style, $677f7abc4dc0215c$var$SPAN_STYLE, style);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        return {
            width: rect.width,
            height: rect.height
        };
    } catch (_unused) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $677f7abc4dc0215c$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $c8dcb2cb9e97048b$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    // If caching is disabled, measure directly
    if (!$677f7abc4dc0215c$var$currentConfig.enableCache) return $677f7abc4dc0215c$var$measureTextWithDOM(text, style);
    var cacheKey = $677f7abc4dc0215c$var$createCacheKey(text, style);
    var cachedResult = $677f7abc4dc0215c$var$stringCache.get(cacheKey);
    if (cachedResult) return cachedResult;
    // Measure using DOM
    var result = $677f7abc4dc0215c$var$measureTextWithDOM(text, style);
    // Store in LRU cache
    $677f7abc4dc0215c$var$stringCache.set(cacheKey, result);
    return result;
};
var $677f7abc4dc0215c$export$24830ea431eb8e34 = (config)=>{
    var newConfig = $677f7abc4dc0215c$var$_objectSpread($677f7abc4dc0215c$var$_objectSpread({}, $677f7abc4dc0215c$var$currentConfig), config);
    if (newConfig.cacheSize !== $677f7abc4dc0215c$var$currentConfig.cacheSize) $677f7abc4dc0215c$var$stringCache = new (0, $24999327541f0a91$export$182500e6725aad9a)(newConfig.cacheSize);
    $677f7abc4dc0215c$var$currentConfig = newConfig;
};
var $677f7abc4dc0215c$export$1340d8ffb2cb9b2 = ()=>$677f7abc4dc0215c$var$_objectSpread({}, $677f7abc4dc0215c$var$currentConfig);
var $677f7abc4dc0215c$export$dbfda59986504510 = ()=>{
    $677f7abc4dc0215c$var$stringCache.clear();
};
var $677f7abc4dc0215c$export$5941b2b80425c12f = ()=>({
        size: $677f7abc4dc0215c$var$stringCache.size(),
        maxSize: $677f7abc4dc0215c$var$currentConfig.cacheSize
    });



function $784815f19cc44bcf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $784815f19cc44bcf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $784815f19cc44bcf$var$ownKeys(Object(t), !0).forEach(function(r) {
            $784815f19cc44bcf$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $784815f19cc44bcf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $784815f19cc44bcf$var$_defineProperty(e, r, t) {
    return (r = $784815f19cc44bcf$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $784815f19cc44bcf$var$_toPropertyKey(t) {
    var i = $784815f19cc44bcf$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $784815f19cc44bcf$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $784815f19cc44bcf$export$c7964a5b9439ae62 = (_ref, _ref2)=>{
    var { x: x1, y: y1 } = _ref;
    var { x: x2, y: y2 } = _ref2;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $784815f19cc44bcf$export$6df2062b9e15eec0 = (_ref3)=>{
    var { x1: x1, y1: y1, x2: x2, y2: y2 } = _ref3;
    return $784815f19cc44bcf$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
class $784815f19cc44bcf$export$dae1ac4449a69ee8 {
    static create(obj) {
        return new $784815f19cc44bcf$export$dae1ac4449a69ee8(obj);
    }
    constructor(scale){
        this.scale = scale;
    }
    get domain() {
        return this.scale.domain;
    }
    get range() {
        return this.scale.range;
    }
    get rangeMin() {
        return this.range()[0];
    }
    get rangeMax() {
        return this.range()[1];
    }
    get bandwidth() {
        return this.scale.bandwidth;
    }
    apply(value) {
        var { bandAware: bandAware, position: position } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (value === undefined) return undefined;
        if (position) switch(position){
            case 'start':
                return this.scale(value);
            case 'middle':
                var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                return this.scale(value) + offset;
            case 'end':
                var _offset = this.bandwidth ? this.bandwidth() : 0;
                return this.scale(value) + _offset;
            default:
                return this.scale(value);
        }
        if (bandAware) {
            var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
            return this.scale(value) + _offset2;
        }
        return this.scale(value);
    }
    isInRange(value) {
        var range = this.range();
        var first = range[0];
        var last = range[range.length - 1];
        return first <= last ? value >= first && value <= last : value >= last && value <= first;
    }
}
$784815f19cc44bcf$var$_defineProperty($784815f19cc44bcf$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $784815f19cc44bcf$export$db77ae668c18269f = (options)=>{
    var scales = Object.keys(options).reduce((res, key)=>$784815f19cc44bcf$var$_objectSpread($784815f19cc44bcf$var$_objectSpread({}, res), {}, {
            [key]: $784815f19cc44bcf$export$dae1ac4449a69ee8.create(options[key])
        }), {});
    return $784815f19cc44bcf$var$_objectSpread($784815f19cc44bcf$var$_objectSpread({}, scales), {}, {
        apply (coord) {
            var { bandAware: bandAware, position: position } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return Object.fromEntries(Object.entries(coord).map((_ref4)=>{
                var [label, value] = _ref4;
                return [
                    label,
                    scales[label].apply(value, {
                        bandAware: bandAware,
                        position: position
                    })
                ];
            }));
        },
        isInRange (coord) {
            return Object.keys(coord).every((label)=>scales[label].isInRange(coord[label]));
        }
    });
};
function $784815f19cc44bcf$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $784815f19cc44bcf$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref5) {
    var { width: width, height: height } = _ref5;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $784815f19cc44bcf$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};


/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * For n equal to 1, the input array is returned as is.
 * For n greater than the length of the array, an array containing the first element
 * and every nTh element after that (if any) is returned.
 *
 * @param array An input array.
 * @param n A number specifying which elements to take.
 * @returns The result array of the same type as the input array.
 */ function $ca6a63b5857274bc$export$c0c2f0af9f98bc62(array, n) {
    if (n < 1) return [];
    if (n === 1) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        var item = array[i];
        if (item !== undefined) result.push(item);
    }
    return result;
}


function $8252a911cb8e10ad$export$a1966f4ad955c82b(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $784815f19cc44bcf$export$3ee78d51cffc2b68)(size, angle);
}
function $8252a911cb8e10ad$export$a257eb8806d5033d(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === 'width';
    var { x: x, y: y, width: width, height: height } = viewBox;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function $8252a911cb8e10ad$export$795910f5f15a9633(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function $8252a911cb8e10ad$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $ca6a63b5857274bc$export$c0c2f0af9f98bc62)(ticks, interval + 1);
}




function $08179349cf892f1c$export$77bf2ab5711b7f99(sign, boundaries, getTickSize, ticks, minTickGap) {
    // If the ticks are readonly, then the slice might not be necessary
    var result = (ticks || []).slice();
    var { start: initialStart, end: end } = boundaries;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluated all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, $ca6a63b5857274bc$export$c0c2f0af9f98bc62)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = ()=>{
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, $8252a911cb8e10ad$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}
function $08179349cf892f1c$export$635ece29a4bbdfac(sign, boundaries, getTickSize, ticks, minTickGap) {
    // If the ticks are readonly, then the slice might not be necessary
    // Reworked logic for getEquidistantPreserveEndTicks
    var result = (ticks || []).slice();
    var len = result.length;
    if (len === 0) return [];
    var { start: initialStart, end: end } = boundaries;
    // Start with stepsize = 1 (every tick) up to the maximum possible stepsize (len)
    for(var stepsize = 1; stepsize <= len; stepsize++){
        // 1. Calculate the offset so the last tick (index len - 1) is always included in the sequence.
        var offset = (len - 1) % stepsize;
        var start = initialStart; // `start` tracks the coordinate of the last successfully drawn tick + gap
        var ok = true;
        // 2. Iterate through the end-anchored sequence: offset, offset + stepsize, ..., len - 1
        var _loop2 = function _loop2() {
            var entry = ticks[index];
            var i = index;
            var size;
            // Use a function to get size, as in the original code
            var getSize = ()=>{
                if (size === undefined) size = getTickSize(entry, i);
                return size;
            };
            var tickCoord = entry.coordinate;
            // 3. Apply visibility logic (including the first tick special case)
            // The reviewer says *not* to unconditionally bypass checks for the last tick.
            var isShow = index === offset || (0, $8252a911cb8e10ad$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
            if (!isShow) {
                // If any tick in this end-anchored sequence fails visibility/collision,
                // reject this stepsize and move to the next iteration (larger stepsize).
                ok = false;
                return 1; // break
            }
            // 4. If showable, update the 'start' coordinate for the next collision check
            if (isShow) start = tickCoord + sign * (getSize() / 2 + minTickGap);
        };
        for(var index = offset; index < len; index += stepsize){
            if (_loop2()) break;
        }
        // 5. If the entire sequence for this stepsize passed the visibility check, return the result
        if (ok) {
            // Build the final result array explicitly using the validated stepsize and offset.
            var finalTicks = [];
            for(var _index = offset; _index < len; _index += stepsize)finalTicks.push(ticks[_index]);
            return finalTicks;
        }
    }
    // If no stepsize works (this shouldn't happen unless minTickGap is huge), return an empty array.
    return [];
}


function $5f666a34d09825a1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5f666a34d09825a1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5f666a34d09825a1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5f666a34d09825a1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5f666a34d09825a1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5f666a34d09825a1$var$_defineProperty(e, r, t) {
    return (r = $5f666a34d09825a1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $5f666a34d09825a1$var$_toPropertyKey(t) {
    var i = $5f666a34d09825a1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $5f666a34d09825a1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $5f666a34d09825a1$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var { start: start } = boundaries;
    var { end: end } = boundaries;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = ()=>{
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = $5f666a34d09825a1$var$_objectSpread($5f666a34d09825a1$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $5f666a34d09825a1$var$_objectSpread($5f666a34d09825a1$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        if (entry.tickCoord != null) {
            var isShow = (0, $8252a911cb8e10ad$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
            if (isShow) {
                end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
                result[i] = $5f666a34d09825a1$var$_objectSpread($5f666a34d09825a1$var$_objectSpread({}, entry), {}, {
                    isShow: true
                });
            }
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function $5f666a34d09825a1$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    // This method is mutating the array so clone is indeed necessary here
    var result = (ticks || []).slice();
    var len = result.length;
    var { start: start, end: end } = boundaries;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $5f666a34d09825a1$var$_objectSpread($5f666a34d09825a1$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        if (tail.tickCoord != null) {
            var isTailShow = (0, $8252a911cb8e10ad$export$795910f5f15a9633)(sign, tail.tickCoord, ()=>tailSize, start, end);
            if (isTailShow) {
                end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
                result[len - 1] = $5f666a34d09825a1$var$_objectSpread($5f666a34d09825a1$var$_objectSpread({}, tail), {}, {
                    isShow: true
                });
            }
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = ()=>{
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = $5f666a34d09825a1$var$_objectSpread($5f666a34d09825a1$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $5f666a34d09825a1$var$_objectSpread($5f666a34d09825a1$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        if (entry.tickCoord != null) {
            var isShow = (0, $8252a911cb8e10ad$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
            if (isShow) {
                start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
                result[i] = $5f666a34d09825a1$var$_objectSpread($5f666a34d09825a1$var$_objectSpread({}, entry), {}, {
                    isShow: true
                });
            }
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function $5f666a34d09825a1$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var { tick: tick, ticks: ticks, viewBox: viewBox, minTickGap: minTickGap, orientation: orientation, interval: interval, tickFormatter: tickFormatter, unit: unit, angle: angle } = props;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $9a1343d05dde836c$export$7e4aa119212bc614)(interval) || (0, $c8dcb2cb9e97048b$export$98f03c5d19621d70).isSsr) {
        var _getNumberIntervalTic;
        return (_getNumberIntervalTic = (0, $8252a911cb8e10ad$export$beeebbe3ff1b306b)(ticks, (0, $9a1343d05dde836c$export$7e4aa119212bc614)(interval) ? interval : 0)) !== null && _getNumberIntervalTic !== void 0 ? _getNumberIntervalTic : [];
    }
    var candidates = [];
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var unitSize = unit && sizeKey === 'width' ? (0, $677f7abc4dc0215c$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = (content, index)=>{
        var value = typeof tickFormatter === 'function' ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === 'width' ? (0, $8252a911cb8e10ad$export$a1966f4ad955c82b)((0, $677f7abc4dc0215c$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $677f7abc4dc0215c$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, $9a1343d05dde836c$export$9d334328eb75e624)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, $8252a911cb8e10ad$export$a257eb8806d5033d)(viewBox, sign, sizeKey);
    if (interval === 'equidistantPreserveStart') return (0, $08179349cf892f1c$export$77bf2ab5711b7f99)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'equidistantPreserveEnd') return (0, $08179349cf892f1c$export$635ece29a4bbdfac)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = $5f666a34d09825a1$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === 'preserveStartEnd');
    else candidates = $5f666a34d09825a1$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter((entry)=>entry.isShow);
}



var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $28UcW = parcelRequire("28UcW");

var $dP0oo = parcelRequire("dP0oo");

var $28UcW = parcelRequire("28UcW");
var $18ca78634dfdfe1f$var$EventKeys = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
function $18ca78634dfdfe1f$export$7d045284457d8577(key) {
    if (typeof key !== 'string') return false;
    var allowedEventKeys = $18ca78634dfdfe1f$var$EventKeys;
    return allowedEventKeys.includes(key);
}



var $28UcW = parcelRequire("28UcW");
var $3d820e26962aea02$var$SVGElementPropKeys = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it, and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var $3d820e26962aea02$var$SVGElementPropKeySet = new Set($3d820e26962aea02$var$SVGElementPropKeys);
function $3d820e26962aea02$export$b73d29c2a6d3ff97(key) {
    if (typeof key !== 'string') return false;
    return $3d820e26962aea02$var$SVGElementPropKeySet.has(key);
}
function $3d820e26962aea02$export$904e03d0a8b085df(key) {
    return typeof key === 'string' && key.startsWith('data-');
}
function $3d820e26962aea02$export$8b56257912140094(obj) {
    if (typeof obj !== 'object' || obj === null) return {};
    var result = {};
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if ($3d820e26962aea02$export$b73d29c2a6d3ff97(key) || $3d820e26962aea02$export$904e03d0a8b085df(key)) result[key] = obj[key];
        }
    }
    return result;
}
function $3d820e26962aea02$export$6d5921c09aa671a9(input) {
    if (input == null) return null;
    if (/*#__PURE__*/ (0, $28UcW.isValidElement)(input) && typeof input.props === 'object' && input.props !== null) {
        var p = input.props;
        return $3d820e26962aea02$export$8b56257912140094(p);
    }
    if (typeof input === 'object' && !Array.isArray(input)) return $3d820e26962aea02$export$8b56257912140094(input);
    return null;
}


function $1412060bc6e2b8b4$export$67f8fc03e57e2747(obj) {
    var result = {};
    // for ... in loop is 10x faster than Object.entries + filter + Object.fromEntries in Chrome
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if ((0, $3d820e26962aea02$export$b73d29c2a6d3ff97)(key) || (0, $3d820e26962aea02$export$904e03d0a8b085df)(key) || (0, $18ca78634dfdfe1f$export$7d045284457d8577)(key)) result[key] = obj[key];
        }
    }
    return result;
}
function $1412060bc6e2b8b4$export$87ef3d7bc7cd0706(input) {
    if (input == null) return null;
    if (/*#__PURE__*/ (0, $28UcW.isValidElement)(input)) // @ts-expect-error we can't type this better because input can be any React element
    return $1412060bc6e2b8b4$export$67f8fc03e57e2747(input.props);
    if (typeof input === 'object' && !Array.isArray(input)) return $1412060bc6e2b8b4$export$67f8fc03e57e2747(input);
    return null;
}


var $06287e412aaf2f1c$var$_excluded = [
    "children",
    "className"
];
function $06287e412aaf2f1c$var$_extends() {
    return $06287e412aaf2f1c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $06287e412aaf2f1c$var$_extends.apply(null, arguments);
}
function $06287e412aaf2f1c$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $06287e412aaf2f1c$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $06287e412aaf2f1c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $06287e412aaf2f1c$export$936d0764594b6eb3 = /*#__PURE__*/ $28UcW.forwardRef((props, ref)=>{
    var { children: children, className: className } = props, others = $06287e412aaf2f1c$var$_objectWithoutProperties(props, $06287e412aaf2f1c$var$_excluded);
    var layerClass = (0, $dP0oo.clsx)('recharts-layer', className);
    return /*#__PURE__*/ $28UcW.createElement("g", $06287e412aaf2f1c$var$_extends({
        className: layerClass
    }, (0, $1412060bc6e2b8b4$export$67f8fc03e57e2747)(others), {
        ref: ref
    }), children);
});



var $28UcW = parcelRequire("28UcW");

var $dP0oo = parcelRequire("dP0oo");




var $a81226d821f05921$var$_DecimalCSS;
function $a81226d821f05921$var$_defineProperty(e, r, t) {
    return (r = $a81226d821f05921$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a81226d821f05921$var$_toPropertyKey(t) {
    var i = $a81226d821f05921$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $a81226d821f05921$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $a81226d821f05921$var$MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $a81226d821f05921$var$ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $a81226d821f05921$var$CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var $a81226d821f05921$var$NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var $a81226d821f05921$var$CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    in: 96,
    Q: 96 / 101.6,
    px: 1
};
var $a81226d821f05921$var$FIXED_CSS_LENGTH_UNITS = [
    'cm',
    'mm',
    'pt',
    'pc',
    'in',
    'Q',
    'px'
];
function $a81226d821f05921$var$isSupportedUnit(unit) {
    return $a81226d821f05921$var$FIXED_CSS_LENGTH_UNITS.includes(unit);
}
var $a81226d821f05921$var$STR_NAN = 'NaN';
function $a81226d821f05921$var$convertToPx(value, unit) {
    return value * $a81226d821f05921$var$CONVERSION_RATES[unit];
}
class $a81226d821f05921$var$DecimalCSS {
    static parse(str) {
        var _NUM_SPLIT_REGEX$exec;
        var [, numStr, unit] = (_NUM_SPLIT_REGEX$exec = $a81226d821f05921$var$NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [];
        if (numStr == null) return $a81226d821f05921$var$DecimalCSS.NaN;
        return new $a81226d821f05921$var$DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : '');
    }
    constructor(num, unit){
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if ((0, $9a1343d05dde836c$export$e426a261f3212d7d)(num)) this.unit = '';
        if (unit !== '' && !$a81226d821f05921$var$CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = '';
        }
        if ($a81226d821f05921$var$isSupportedUnit(unit)) {
            this.num = $a81226d821f05921$var$convertToPx(num, unit);
            this.unit = 'px';
        }
    }
    add(other) {
        if (this.unit !== other.unit) return new $a81226d821f05921$var$DecimalCSS(NaN, '');
        return new $a81226d821f05921$var$DecimalCSS(this.num + other.num, this.unit);
    }
    subtract(other) {
        if (this.unit !== other.unit) return new $a81226d821f05921$var$DecimalCSS(NaN, '');
        return new $a81226d821f05921$var$DecimalCSS(this.num - other.num, this.unit);
    }
    multiply(other) {
        if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new $a81226d821f05921$var$DecimalCSS(NaN, '');
        return new $a81226d821f05921$var$DecimalCSS(this.num * other.num, this.unit || other.unit);
    }
    divide(other) {
        if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new $a81226d821f05921$var$DecimalCSS(NaN, '');
        return new $a81226d821f05921$var$DecimalCSS(this.num / other.num, this.unit || other.unit);
    }
    toString() {
        return "".concat(this.num).concat(this.unit);
    }
    isNaN() {
        return (0, $9a1343d05dde836c$export$e426a261f3212d7d)(this.num);
    }
}
$a81226d821f05921$var$_DecimalCSS = $a81226d821f05921$var$DecimalCSS;
$a81226d821f05921$var$_defineProperty($a81226d821f05921$var$DecimalCSS, "NaN", new $a81226d821f05921$var$_DecimalCSS(NaN, ''));
function $a81226d821f05921$var$calculateArithmetic(expr) {
    if (expr == null || expr.includes($a81226d821f05921$var$STR_NAN)) return $a81226d821f05921$var$STR_NAN;
    var newExpr = expr;
    while(newExpr.includes('*') || newExpr.includes('/')){
        var _MULTIPLY_OR_DIVIDE_R;
        var [, leftOperand, operator, rightOperand] = (_MULTIPLY_OR_DIVIDE_R = $a81226d821f05921$var$MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [];
        var lTs = $a81226d821f05921$var$DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : '');
        var rTs = $a81226d821f05921$var$DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : '');
        var result = operator === '*' ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return $a81226d821f05921$var$STR_NAN;
        newExpr = newExpr.replace($a81226d821f05921$var$MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes('+') || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var [, _leftOperand, _operator, _rightOperand] = (_ADD_OR_SUBTRACT_REGE = $a81226d821f05921$var$ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [];
        var _lTs = $a81226d821f05921$var$DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : '');
        var _rTs = $a81226d821f05921$var$DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : '');
        var _result = _operator === '+' ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return $a81226d821f05921$var$STR_NAN;
        newExpr = newExpr.replace($a81226d821f05921$var$ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var $a81226d821f05921$var$PARENTHESES_REGEX = /\(([^()]*)\)/;
function $a81226d821f05921$var$calculateParentheses(expr) {
    var newExpr = expr;
    var match;
    // eslint-disable-next-line no-cond-assign
    while((match = $a81226d821f05921$var$PARENTHESES_REGEX.exec(newExpr)) != null){
        var [, parentheticalExpression] = match;
        newExpr = newExpr.replace($a81226d821f05921$var$PARENTHESES_REGEX, $a81226d821f05921$var$calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function $a81226d821f05921$var$evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, '');
    newExpr = $a81226d821f05921$var$calculateParentheses(newExpr);
    newExpr = $a81226d821f05921$var$calculateArithmetic(newExpr);
    return newExpr;
}
function $a81226d821f05921$export$c891f73c9c6d00c9(expression) {
    try {
        return $a81226d821f05921$var$evaluateExpression(expression);
    } catch (_unused) {
        return $a81226d821f05921$var$STR_NAN;
    }
}
function $a81226d821f05921$export$254eac204f89fd7d(expression) {
    var result = $a81226d821f05921$export$c891f73c9c6d00c9(expression.slice(5, -1));
    if (result === $a81226d821f05921$var$STR_NAN) return '';
    return result;
}



function $2db4b31e06a7a91b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2db4b31e06a7a91b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2db4b31e06a7a91b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2db4b31e06a7a91b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2db4b31e06a7a91b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2db4b31e06a7a91b$var$_defineProperty(e, r, t) {
    return (r = $2db4b31e06a7a91b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2db4b31e06a7a91b$var$_toPropertyKey(t) {
    var i = $2db4b31e06a7a91b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2db4b31e06a7a91b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2db4b31e06a7a91b$export$45004cc70a390ee8(realProps, defaultProps) {
    /*
   * To avoid mutating the original `realProps` object passed to the function, create a shallow copy of it.
   * `resolvedProps` will be modified directly with the defaults.
   */ var resolvedProps = $2db4b31e06a7a91b$var$_objectSpread({}, realProps);
    /*
   * Since the function guarantees `D extends Partial<T>`, this assignment is safe.
   * It allows TypeScript to work with the well-defined `Partial<T>` type inside the loop,
   * making subsequent type inference (especially for `dp[key]`) much more straightforward for the compiler.
   * This is a key step to improve type safety *without* value assertions later.
   */ var dp = defaultProps;
    /*
   * `Object.keys` doesn't preserve strong key types - it always returns Array<string>.
   * However, due to the `D extends Partial<T>` constraint,
   * we know these keys *must* also be valid keys of `T`.
   * This assertion informs TypeScript of this relationship, avoiding type errors when using `key` to index `acc` (type T).
   *
   * Type assertions are not sound but in this case it's necessary
   * as `Object.keys` does not do what we want it to do.
   */ var keys = Object.keys(defaultProps);
    var withDefaults = keys.reduce((acc, key)=>{
        if (acc[key] === undefined && dp[key] !== undefined) acc[key] = dp[key];
        return acc;
    }, resolvedProps);
    /*
   * And again type assertions are not safe but here we have done the runtime work
   * so let's bypass the lack of static type safety and tell the compiler what happened.
   */ return withDefaults;
} /**
 * Helper type to extract the keys of T that are required.
 * It iterates through each key K in T. If Pick<T, K> cannot be assigned an empty object {},
 * it means K is required, so we keep K; otherwise, we discard it (never).
 * [keyof T] at the end creates a union of the kept keys.
 */  /**
 * Helper type to extract the keys of T that are optional.
 * It iterates through each key K in T. If Pick<T, K> can be assigned an empty object {},
 * it means K is optional (or potentially missing), so we keep K; otherwise, we discard it (never).
 * [keyof T] at the end creates a union of the kept keys.
 */  /**
 * Helper type to ensure keys of D exist in T.
 * For each key K in D, if K is also a key of T, keep the type D[K].
 * If K is NOT a key of T, map it to type `never`.
 * An object cannot have a property of type `never`, effectively disallowing extra keys.
 */  /**
 * This type will take a source type `Props` and a default type `Defaults` and will return a new type
 * where all properties that are optional in `Props` but required in `Defaults` are made required in the result.
 * Properties that are required in `Props` and optional in `Defaults` will remain required.
 * Properties that are optional in both `Props` and `Defaults` will remain optional.
 *
 * This is useful for creating a type that represents the resolved props of a component with default props.
 */ 



var $e6266b2db237d3de$var$_excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "fill",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor"
], $e6266b2db237d3de$var$_excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function $e6266b2db237d3de$var$_extends() {
    return $e6266b2db237d3de$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e6266b2db237d3de$var$_extends.apply(null, arguments);
}
function $e6266b2db237d3de$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $e6266b2db237d3de$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $e6266b2db237d3de$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $e6266b2db237d3de$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $e6266b2db237d3de$var$calculateWordWidths = (_ref)=>{
    var { children: children, breakAll: breakAll, style: style } = _ref;
    try {
        var words = [];
        if (!(0, $9a1343d05dde836c$export$b931b78cbb3caf86)(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split($e6266b2db237d3de$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map((word)=>({
                word: word,
                width: (0, $677f7abc4dc0215c$export$e5560531f057ad5d)(word, style).width
            }));
        var spaceWidth = breakAll ? 0 : (0, $677f7abc4dc0215c$export$e5560531f057ad5d)('\u00A0', style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (_unused) {
        return null;
    }
};
function $e6266b2db237d3de$export$ae5e6c08954aa63c(value) {
    return value === 'start' || value === 'middle' || value === 'end' || value === 'inherit';
}
/**
 * @inline
 */ /**
 * @inline
 */ var $e6266b2db237d3de$var$calculate = (words, lineWidth, spaceWidth, scaleToFit)=>words.reduce((result, _ref2)=>{
        var { word: word, width: width } = _ref2;
        var currentLine = result[result.length - 1];
        if (currentLine && width != null && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
            // Word can be added to an existing line
            currentLine.words.push(word);
            currentLine.width += width + spaceWidth;
        } else {
            // Add first word to line or word is too long to scaleToFit on existing line
            var newLine = {
                words: [
                    word
                ],
                width: width
            };
            result.push(newLine);
        }
        return result;
    }, []);
var $e6266b2db237d3de$var$findLongestLine = (words)=>words.reduce((a, b)=>a.width > b.width ? a : b);
var $e6266b2db237d3de$var$suffix = "\u2026";
var $e6266b2db237d3de$var$checkOverflow = (text, index, breakAll, style, maxLines, lineWidth, spaceWidth, scaleToFit)=>{
    var tempText = text.slice(0, index);
    var words = $e6266b2db237d3de$var$calculateWordWidths({
        breakAll: breakAll,
        style: style,
        children: tempText + $e6266b2db237d3de$var$suffix
    });
    if (!words) return [
        false,
        []
    ];
    var result = $e6266b2db237d3de$var$calculate(words.wordsWithComputedWidth, lineWidth, spaceWidth, scaleToFit);
    var doesOverflow = result.length > maxLines || $e6266b2db237d3de$var$findLongestLine(result).width > Number(lineWidth);
    return [
        doesOverflow,
        result
    ];
};
var $e6266b2db237d3de$var$calculateWordsByLines = (_ref3, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit)=>{
    var { maxLines: maxLines, children: children, style: style, breakAll: breakAll } = _ref3;
    var shouldLimitLines = (0, $9a1343d05dde836c$export$7e4aa119212bc614)(maxLines);
    var text = String(children);
    var originalResult = $e6266b2db237d3de$var$calculate(initialWordsWithComputedWith, lineWidth, spaceWidth, scaleToFit);
    if (!shouldLimitLines || scaleToFit) return originalResult;
    var overflows = originalResult.length > maxLines || $e6266b2db237d3de$var$findLongestLine(originalResult).width > Number(lineWidth);
    if (!overflows) return originalResult;
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var [doesPrevOverflow, result] = $e6266b2db237d3de$var$checkOverflow(text, prev, breakAll, style, maxLines, lineWidth, spaceWidth, scaleToFit);
        var [doesMiddleOverflow] = $e6266b2db237d3de$var$checkOverflow(text, middle, breakAll, style, maxLines, lineWidth, spaceWidth, scaleToFit);
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $e6266b2db237d3de$var$getWordsWithoutCalculate = (children)=>{
    var words = !(0, $9a1343d05dde836c$export$b931b78cbb3caf86)(children) ? children.toString().split($e6266b2db237d3de$var$BREAKING_SPACES) : [];
    return [
        {
            words: words,
            width: undefined
        }
    ];
};
var $e6266b2db237d3de$export$86ba3bfd091ebe4f = (_ref4)=>{
    var { width: width, scaleToFit: scaleToFit, children: children, style: style, breakAll: breakAll, maxLines: maxLines } = _ref4;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $c8dcb2cb9e97048b$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $e6266b2db237d3de$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var { wordsWithComputedWidth: wcw, spaceWidth: sw } = wordWidths;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $e6266b2db237d3de$var$getWordsWithoutCalculate(children);
        return $e6266b2db237d3de$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, Boolean(scaleToFit));
    }
    return $e6266b2db237d3de$var$getWordsWithoutCalculate(children);
};
var $e6266b2db237d3de$var$DEFAULT_FILL = '#808080';
var $e6266b2db237d3de$export$beb103ac5cf1498b = {
    angle: 0,
    breakAll: false,
    // Magic number from d3
    capHeight: '0.71em',
    fill: $e6266b2db237d3de$var$DEFAULT_FILL,
    lineHeight: '1em',
    scaleToFit: false,
    textAnchor: 'start',
    // Maintain compat with existing charts / default SVG behavior
    verticalAnchor: 'end',
    x: 0,
    y: 0
};
var $e6266b2db237d3de$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $28UcW.forwardRef)((outsideProps, ref)=>{
    var _resolveDefaultProps = (0, $2db4b31e06a7a91b$export$45004cc70a390ee8)(outsideProps, $e6266b2db237d3de$export$beb103ac5cf1498b), { x: propsX, y: propsY, lineHeight: lineHeight, capHeight: capHeight, fill: fill, scaleToFit: scaleToFit, textAnchor: textAnchor, verticalAnchor: verticalAnchor } = _resolveDefaultProps, props = $e6266b2db237d3de$var$_objectWithoutProperties(_resolveDefaultProps, $e6266b2db237d3de$var$_excluded);
    var wordsByLines = (0, $28UcW.useMemo)(()=>{
        return $e6266b2db237d3de$export$86ba3bfd091ebe4f({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var { dx: dx, dy: dy, angle: angle, className: className, breakAll: breakAll } = props, textProps = $e6266b2db237d3de$var$_objectWithoutProperties(props, $e6266b2db237d3de$var$_excluded2);
    if (!(0, $9a1343d05dde836c$export$402a499e1ea44294)(propsX) || !(0, $9a1343d05dde836c$export$402a499e1ea44294)(propsY) || wordsByLines.length === 0) return null;
    var x = Number(propsX) + ((0, $9a1343d05dde836c$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = Number(propsY) + ((0, $9a1343d05dde836c$export$7e4aa119212bc614)(dy) ? dy : 0);
    if (!(0, $11a93f8f3c3518e5$export$f8a8fc612ced9bb0)(x) || !(0, $11a93f8f3c3518e5$export$f8a8fc612ced9bb0)(y)) return null;
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, $a81226d821f05921$export$254eac204f89fd7d)("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, $a81226d821f05921$export$254eac204f89fd7d)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, $a81226d821f05921$export$254eac204f89fd7d)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var { width: width } = props;
        transforms.push("scale(".concat((0, $9a1343d05dde836c$export$7e4aa119212bc614)(width) && (0, $9a1343d05dde836c$export$7e4aa119212bc614)(lineWidth) ? width / lineWidth : 1, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ $28UcW.createElement("text", $e6266b2db237d3de$var$_extends({}, (0, $1412060bc6e2b8b4$export$67f8fc03e57e2747)(textProps), {
        ref: ref,
        x: x,
        y: y,
        className: (0, $dP0oo.clsx)('recharts-text', className),
        textAnchor: textAnchor,
        fill: fill.includes('url') ? $e6266b2db237d3de$var$DEFAULT_FILL : fill
    }), wordsByLines.map((line, index)=>{
        var words = line.words.join(breakAll ? '' : ' ');
        return(/*#__PURE__*/ // duplicate words will cause duplicate keys which is why we add the array index here
        $28UcW.createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: "".concat(words, "-").concat(index)
        }, words));
    }));
});
$e6266b2db237d3de$export$5f1af8db9871e1d6.displayName = 'Text';



var $28UcW = parcelRequire("28UcW");

var $dP0oo = parcelRequire("dP0oo");



var $28UcW = parcelRequire("28UcW");
function $d16c67d42be24ed1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d16c67d42be24ed1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d16c67d42be24ed1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d16c67d42be24ed1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d16c67d42be24ed1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d16c67d42be24ed1$var$_defineProperty(e, r, t) {
    return (r = $d16c67d42be24ed1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d16c67d42be24ed1$var$_toPropertyKey(t) {
    var i = $d16c67d42be24ed1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d16c67d42be24ed1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $d16c67d42be24ed1$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $d16c67d42be24ed1$export$4f2c4f194778dcbb = (angle)=>angle * Math.PI / 180;
var $d16c67d42be24ed1$export$1c20e104e3e29a0a = (angleInRadian)=>angleInRadian * 180 / Math.PI;
var $d16c67d42be24ed1$export$5c9a959bb3fc7749 = (cx, cy, radius, angle)=>({
        x: cx + Math.cos(-$d16c67d42be24ed1$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$d16c67d42be24ed1$export$d74e8f7e9cc3fed3 * angle) * radius
    });
var $d16c67d42be24ed1$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        brushBottom: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $d16c67d42be24ed1$var$distanceBetweenPoints = (point, anotherPoint)=>{
    var { x: x1, y: y1 } = point;
    var { x: x2, y: y2 } = anotherPoint;
    return Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2);
};
var $d16c67d42be24ed1$var$getAngleOfPoint = (_ref, _ref2)=>{
    var { x: x, y: y } = _ref;
    var { cx: cx, cy: cy } = _ref2;
    var radius = $d16c67d42be24ed1$var$distanceBetweenPoints({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius,
        angle: 0
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $d16c67d42be24ed1$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $d16c67d42be24ed1$var$formatAngleOfSector = (_ref3)=>{
    var { startAngle: startAngle, endAngle: endAngle } = _ref3;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $d16c67d42be24ed1$var$reverseFormatAngleOfSector = (angle, _ref4)=>{
    var { startAngle: startAngle, endAngle: endAngle } = _ref4;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $d16c67d42be24ed1$export$e85a2bf8cd31c504 = (_ref5, viewBox)=>{
    var { chartX: x, chartY: y } = _ref5;
    var { radius: radius, angle: angle } = $d16c67d42be24ed1$var$getAngleOfPoint({
        x: x,
        y: y
    }, viewBox);
    var { innerRadius: innerRadius, outerRadius: outerRadius } = viewBox;
    if (radius < innerRadius || radius > outerRadius) return null;
    if (radius === 0) return null;
    var { startAngle: startAngle, endAngle: endAngle } = $d16c67d42be24ed1$var$formatAngleOfSector(viewBox);
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $d16c67d42be24ed1$var$_objectSpread($d16c67d42be24ed1$var$_objectSpread({}, viewBox), {}, {
        radius: radius,
        angle: $d16c67d42be24ed1$var$reverseFormatAngleOfSector(formatAngle, viewBox)
    });
    return null;
};
var $d16c67d42be24ed1$export$88d525dabc04abcd = (tick)=>!/*#__PURE__*/ (0, $28UcW.isValidElement)(tick) && typeof tick !== 'function' && typeof tick !== 'boolean' && tick != null ? tick.className : '';



var $28UcW = parcelRequire("28UcW");
var $e280435cb76c9b61$exports = {};
'use strict';

$e280435cb76c9b61$exports = (parcelRequire("dRiSd"));



var $28UcW = parcelRequire("28UcW");

var $28UcW = parcelRequire("28UcW");
var $ce316d304b16d2f9$export$876ef70bc88b13cb = /*#__PURE__*/ (0, $28UcW.createContext)(null);


var $bf278eb346227770$var$noopDispatch = (a)=>a;
var $bf278eb346227770$export$f51d452c10d5b956 = ()=>{
    var context = (0, $28UcW.useContext)((0, $ce316d304b16d2f9$export$876ef70bc88b13cb));
    if (context) return context.store.dispatch;
    return $bf278eb346227770$var$noopDispatch;
};
var $bf278eb346227770$var$noop = ()=>{};
var $bf278eb346227770$var$addNestedSubNoop = ()=>$bf278eb346227770$var$noop;
var $bf278eb346227770$var$refEquality = (a, b)=>a === b;
function $bf278eb346227770$export$a7347740d65f620b(selector) {
    var context = (0, $28UcW.useContext)((0, $ce316d304b16d2f9$export$876ef70bc88b13cb));
    return (0, $e280435cb76c9b61$exports.useSyncExternalStoreWithSelector)(context ? context.subscription.addNestedSub : $bf278eb346227770$var$addNestedSubNoop, context ? context.store.getState : $bf278eb346227770$var$noop, context ? context.store.getState : $bf278eb346227770$var$noop, context ? selector : $bf278eb346227770$var$noop, $bf278eb346227770$var$refEquality);
}


// src/utils/formatProdErrorMessage.ts
function $da655fa243288d8a$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $da655fa243288d8a$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $da655fa243288d8a$var$symbol_observable_default = $da655fa243288d8a$var$$$observable;
// src/utils/actionTypes.ts
var $da655fa243288d8a$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $da655fa243288d8a$var$ActionTypes = {
    INIT: `@@redux/INIT${$da655fa243288d8a$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$da655fa243288d8a$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$da655fa243288d8a$var$randomString()}`
};
var $da655fa243288d8a$export$4219e499db7ca678 = $da655fa243288d8a$var$ActionTypes;
// src/utils/isPlainObject.ts
function $da655fa243288d8a$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $da655fa243288d8a$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($da655fa243288d8a$var$isDate(val)) return "date";
    if ($da655fa243288d8a$var$isError(val)) return "error";
    const constructorName = $da655fa243288d8a$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $da655fa243288d8a$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $da655fa243288d8a$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $da655fa243288d8a$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $da655fa243288d8a$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $da655fa243288d8a$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($da655fa243288d8a$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($da655fa243288d8a$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($da655fa243288d8a$var$formatProdErrorMessage(1));
        return enhancer($da655fa243288d8a$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($da655fa243288d8a$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($da655fa243288d8a$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($da655fa243288d8a$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($da655fa243288d8a$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$da655fa243288d8a$export$53b83ca8eaab0383(action)) throw new Error($da655fa243288d8a$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($da655fa243288d8a$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($da655fa243288d8a$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($da655fa243288d8a$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($da655fa243288d8a$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $da655fa243288d8a$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($da655fa243288d8a$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$da655fa243288d8a$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $da655fa243288d8a$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$da655fa243288d8a$var$symbol_observable_default]: observable
    };
    return store;
}
function $da655fa243288d8a$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $da655fa243288d8a$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $da655fa243288d8a$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $da655fa243288d8a$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $da655fa243288d8a$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$da655fa243288d8a$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$da655fa243288d8a$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $da655fa243288d8a$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $da655fa243288d8a$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $da655fa243288d8a$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($da655fa243288d8a$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $da655fa243288d8a$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($da655fa243288d8a$var$formatProdErrorMessage(13));
    });
}
function $da655fa243288d8a$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $da655fa243288d8a$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($da655fa243288d8a$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $da655fa243288d8a$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $da655fa243288d8a$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $da655fa243288d8a$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($da655fa243288d8a$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $da655fa243288d8a$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $da655fa243288d8a$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $da655fa243288d8a$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($da655fa243288d8a$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $da655fa243288d8a$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $da655fa243288d8a$export$b956e38827fca970(action) {
    return $da655fa243288d8a$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $75bf48a0e2bf731d$var$__defProp = Object.defineProperty;
var $75bf48a0e2bf731d$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $75bf48a0e2bf731d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $75bf48a0e2bf731d$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $75bf48a0e2bf731d$var$__defNormalProp = (obj, key, value)=>key in obj ? $75bf48a0e2bf731d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $75bf48a0e2bf731d$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($75bf48a0e2bf731d$var$__hasOwnProp.call(b, prop)) $75bf48a0e2bf731d$var$__defNormalProp(a, prop, b[prop]);
    if ($75bf48a0e2bf731d$var$__getOwnPropSymbols) {
        for (var prop of $75bf48a0e2bf731d$var$__getOwnPropSymbols(b))if ($75bf48a0e2bf731d$var$__propIsEnum.call(b, prop)) $75bf48a0e2bf731d$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $75bf48a0e2bf731d$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $75bf48a0e2bf731d$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $75bf48a0e2bf731d$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $75bf48a0e2bf731d$var$errors = [];
function $75bf48a0e2bf731d$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $75bf48a0e2bf731d$var$O = Object;
var $75bf48a0e2bf731d$var$getPrototypeOf = $75bf48a0e2bf731d$var$O.getPrototypeOf;
var $75bf48a0e2bf731d$var$CONSTRUCTOR = "constructor";
var $75bf48a0e2bf731d$var$PROTOTYPE = "prototype";
var $75bf48a0e2bf731d$var$CONFIGURABLE = "configurable";
var $75bf48a0e2bf731d$var$ENUMERABLE = "enumerable";
var $75bf48a0e2bf731d$var$WRITABLE = "writable";
var $75bf48a0e2bf731d$var$VALUE = "value";
var $75bf48a0e2bf731d$export$541ac630993a4c84 = (value)=>!!value && !!value[$75bf48a0e2bf731d$var$DRAFT_STATE];
function $75bf48a0e2bf731d$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $75bf48a0e2bf731d$var$isPlainObject(value) || $75bf48a0e2bf731d$var$isArray(value) || !!value[$75bf48a0e2bf731d$export$6ee2082928bcb0ee] || !!((_a = value[$75bf48a0e2bf731d$var$CONSTRUCTOR]) == null ? void 0 : _a[$75bf48a0e2bf731d$export$6ee2082928bcb0ee]) || $75bf48a0e2bf731d$var$isMap(value) || $75bf48a0e2bf731d$var$isSet(value);
}
var $75bf48a0e2bf731d$var$objectCtorString = $75bf48a0e2bf731d$var$O[$75bf48a0e2bf731d$var$PROTOTYPE][$75bf48a0e2bf731d$var$CONSTRUCTOR].toString();
var $75bf48a0e2bf731d$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $75bf48a0e2bf731d$var$isPlainObject(value) {
    if (!value || !$75bf48a0e2bf731d$var$isObjectish(value)) return false;
    const proto = $75bf48a0e2bf731d$var$getPrototypeOf(value);
    if (proto === null || proto === $75bf48a0e2bf731d$var$O[$75bf48a0e2bf731d$var$PROTOTYPE]) return true;
    const Ctor = $75bf48a0e2bf731d$var$O.hasOwnProperty.call(proto, $75bf48a0e2bf731d$var$CONSTRUCTOR) && proto[$75bf48a0e2bf731d$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$75bf48a0e2bf731d$var$isFunction(Ctor)) return false;
    let ctorString = $75bf48a0e2bf731d$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $75bf48a0e2bf731d$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $75bf48a0e2bf731d$var$objectCtorString;
}
function $75bf48a0e2bf731d$export$22e8af3f75a010e3(value) {
    if (!$75bf48a0e2bf731d$export$541ac630993a4c84(value)) $75bf48a0e2bf731d$var$die(15, value);
    return value[$75bf48a0e2bf731d$var$DRAFT_STATE].base_;
}
function $75bf48a0e2bf731d$var$each(obj, iter, strict = true) {
    if ($75bf48a0e2bf731d$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $75bf48a0e2bf731d$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $75bf48a0e2bf731d$var$getArchtype(thing) {
    const state = thing[$75bf48a0e2bf731d$var$DRAFT_STATE];
    return state ? state.type_ : $75bf48a0e2bf731d$var$isArray(thing) ? 1 /* Array */  : $75bf48a0e2bf731d$var$isMap(thing) ? 2 /* Map */  : $75bf48a0e2bf731d$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $75bf48a0e2bf731d$var$has = (thing, prop, type = $75bf48a0e2bf731d$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $75bf48a0e2bf731d$var$O[$75bf48a0e2bf731d$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $75bf48a0e2bf731d$var$get = (thing, prop, type = $75bf48a0e2bf731d$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $75bf48a0e2bf731d$var$set = (thing, propOrOldValue, value, type = $75bf48a0e2bf731d$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $75bf48a0e2bf731d$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $75bf48a0e2bf731d$var$isArray = Array.isArray;
var $75bf48a0e2bf731d$var$isMap = (target)=>target instanceof Map;
var $75bf48a0e2bf731d$var$isSet = (target)=>target instanceof Set;
var $75bf48a0e2bf731d$var$isObjectish = (target)=>typeof target === "object";
var $75bf48a0e2bf731d$var$isFunction = (target)=>typeof target === "function";
var $75bf48a0e2bf731d$var$isBoolean = (target)=>typeof target === "boolean";
function $75bf48a0e2bf731d$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $75bf48a0e2bf731d$var$getProxyDraft = (value)=>{
    if (!$75bf48a0e2bf731d$var$isObjectish(value)) return null;
    return value == null ? void 0 : value[$75bf48a0e2bf731d$var$DRAFT_STATE];
};
var $75bf48a0e2bf731d$var$latest = (state)=>state.copy_ || state.base_;
var $75bf48a0e2bf731d$var$getValue = (value)=>{
    var _a;
    const proxyDraft = $75bf48a0e2bf731d$var$getProxyDraft(value);
    return proxyDraft ? (_a = proxyDraft.copy_) != null ? _a : proxyDraft.base_ : value;
};
var $75bf48a0e2bf731d$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $75bf48a0e2bf731d$var$shallowCopy(base, strict) {
    if ($75bf48a0e2bf731d$var$isMap(base)) return new Map(base);
    if ($75bf48a0e2bf731d$var$isSet(base)) return new Set(base);
    if ($75bf48a0e2bf731d$var$isArray(base)) return Array[$75bf48a0e2bf731d$var$PROTOTYPE].slice.call(base);
    const isPlain = $75bf48a0e2bf731d$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $75bf48a0e2bf731d$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$75bf48a0e2bf731d$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$75bf48a0e2bf731d$var$WRITABLE] === false) {
                desc[$75bf48a0e2bf731d$var$WRITABLE] = true;
                desc[$75bf48a0e2bf731d$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$75bf48a0e2bf731d$var$CONFIGURABLE]: true,
                [$75bf48a0e2bf731d$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$75bf48a0e2bf731d$var$ENUMERABLE]: desc[$75bf48a0e2bf731d$var$ENUMERABLE],
                [$75bf48a0e2bf731d$var$VALUE]: base[key]
            };
        }
        return $75bf48a0e2bf731d$var$O.create($75bf48a0e2bf731d$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $75bf48a0e2bf731d$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $75bf48a0e2bf731d$var$__spreadValues({}, base);
        const obj = $75bf48a0e2bf731d$var$O.create(proto);
        return $75bf48a0e2bf731d$var$O.assign(obj, base);
    }
}
function $75bf48a0e2bf731d$export$792f3d81ea979f55(obj, deep = false) {
    if ($75bf48a0e2bf731d$var$isFrozen(obj) || $75bf48a0e2bf731d$export$541ac630993a4c84(obj) || !$75bf48a0e2bf731d$export$16e3aed3edb85946(obj)) return obj;
    if ($75bf48a0e2bf731d$var$getArchtype(obj) > 1) $75bf48a0e2bf731d$var$O.defineProperties(obj, {
        set: $75bf48a0e2bf731d$var$dontMutateMethodOverride,
        add: $75bf48a0e2bf731d$var$dontMutateMethodOverride,
        clear: $75bf48a0e2bf731d$var$dontMutateMethodOverride,
        delete: $75bf48a0e2bf731d$var$dontMutateMethodOverride
    });
    $75bf48a0e2bf731d$var$O.freeze(obj);
    if (deep) $75bf48a0e2bf731d$var$each(obj, (_key, value)=>{
        $75bf48a0e2bf731d$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $75bf48a0e2bf731d$var$dontMutateFrozenCollections() {
    $75bf48a0e2bf731d$var$die(2);
}
var $75bf48a0e2bf731d$var$dontMutateMethodOverride = {
    [$75bf48a0e2bf731d$var$VALUE]: $75bf48a0e2bf731d$var$dontMutateFrozenCollections
};
function $75bf48a0e2bf731d$var$isFrozen(obj) {
    if (obj === null || !$75bf48a0e2bf731d$var$isObjectish(obj)) return true;
    return $75bf48a0e2bf731d$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $75bf48a0e2bf731d$var$PluginMapSet = "MapSet";
var $75bf48a0e2bf731d$var$PluginPatches = "Patches";
var $75bf48a0e2bf731d$var$PluginArrayMethods = "ArrayMethods";
var $75bf48a0e2bf731d$var$plugins = {};
function $75bf48a0e2bf731d$var$getPlugin(pluginKey) {
    const plugin = $75bf48a0e2bf731d$var$plugins[pluginKey];
    if (!plugin) $75bf48a0e2bf731d$var$die(0, pluginKey);
    return plugin;
}
var $75bf48a0e2bf731d$var$isPluginLoaded = (pluginKey)=>!!$75bf48a0e2bf731d$var$plugins[pluginKey];
function $75bf48a0e2bf731d$var$loadPlugin(pluginKey, implementation) {
    if (!$75bf48a0e2bf731d$var$plugins[pluginKey]) $75bf48a0e2bf731d$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $75bf48a0e2bf731d$var$currentScope;
var $75bf48a0e2bf731d$var$getCurrentScope = ()=>$75bf48a0e2bf731d$var$currentScope;
var $75bf48a0e2bf731d$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $75bf48a0e2bf731d$var$isPluginLoaded($75bf48a0e2bf731d$var$PluginMapSet) ? $75bf48a0e2bf731d$var$getPlugin($75bf48a0e2bf731d$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $75bf48a0e2bf731d$var$isPluginLoaded($75bf48a0e2bf731d$var$PluginArrayMethods) ? $75bf48a0e2bf731d$var$getPlugin($75bf48a0e2bf731d$var$PluginArrayMethods) : void 0
    });
function $75bf48a0e2bf731d$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $75bf48a0e2bf731d$var$getPlugin($75bf48a0e2bf731d$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $75bf48a0e2bf731d$var$revokeScope(scope) {
    $75bf48a0e2bf731d$var$leaveScope(scope);
    scope.drafts_.forEach($75bf48a0e2bf731d$var$revokeDraft);
    scope.drafts_ = null;
}
function $75bf48a0e2bf731d$var$leaveScope(scope) {
    if (scope === $75bf48a0e2bf731d$var$currentScope) $75bf48a0e2bf731d$var$currentScope = scope.parent_;
}
var $75bf48a0e2bf731d$var$enterScope = (immer2)=>$75bf48a0e2bf731d$var$currentScope = $75bf48a0e2bf731d$var$createScope($75bf48a0e2bf731d$var$currentScope, immer2);
function $75bf48a0e2bf731d$var$revokeDraft(draft) {
    const state = draft[$75bf48a0e2bf731d$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $75bf48a0e2bf731d$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$75bf48a0e2bf731d$var$DRAFT_STATE].modified_) {
            $75bf48a0e2bf731d$var$revokeScope(scope);
            $75bf48a0e2bf731d$var$die(4);
        }
        if ($75bf48a0e2bf731d$export$16e3aed3edb85946(result)) result = $75bf48a0e2bf731d$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$75bf48a0e2bf731d$var$DRAFT_STATE].base_, result, scope);
    } else result = $75bf48a0e2bf731d$var$finalize(scope, baseDraft);
    $75bf48a0e2bf731d$var$maybeFreeze(scope, result, true);
    $75bf48a0e2bf731d$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $75bf48a0e2bf731d$export$45b790e32b2810ee ? result : void 0;
}
function $75bf48a0e2bf731d$var$finalize(rootScope, value) {
    if ($75bf48a0e2bf731d$var$isFrozen(value)) return value;
    const state = value[$75bf48a0e2bf731d$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $75bf48a0e2bf731d$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$75bf48a0e2bf731d$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $75bf48a0e2bf731d$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $75bf48a0e2bf731d$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $75bf48a0e2bf731d$export$792f3d81ea979f55(value, deep);
}
function $75bf48a0e2bf731d$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $75bf48a0e2bf731d$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $75bf48a0e2bf731d$var$EMPTY_LOCATIONS_RESULT = [];
function $75bf48a0e2bf731d$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    const parentCopy = $75bf48a0e2bf731d$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $75bf48a0e2bf731d$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $75bf48a0e2bf731d$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $75bf48a0e2bf731d$var$each(parentCopy, (key, value)=>{
            if ($75bf48a0e2bf731d$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : $75bf48a0e2bf731d$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$75bf48a0e2bf731d$var$set(parentCopy, location, finalizedValue, parentType);
}
function $75bf48a0e2bf731d$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        const state = child;
        if (!state || !$75bf48a0e2bf731d$var$isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        const finalizedValue = $75bf48a0e2bf731d$var$getFinalValue(state);
        $75bf48a0e2bf731d$var$updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        $75bf48a0e2bf731d$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $75bf48a0e2bf731d$var$generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $75bf48a0e2bf731d$var$markStateFinalized(state);
    }
}
function $75bf48a0e2bf731d$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($75bf48a0e2bf731d$export$541ac630993a4c84(value)) {
        const state = value[$75bf48a0e2bf731d$var$DRAFT_STATE];
        if ($75bf48a0e2bf731d$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $75bf48a0e2bf731d$var$prepareCopy(target);
            const finalizedValue = $75bf48a0e2bf731d$var$getFinalValue(state);
            $75bf48a0e2bf731d$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($75bf48a0e2bf731d$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        const targetCopy = $75bf48a0e2bf731d$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $75bf48a0e2bf731d$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($75bf48a0e2bf731d$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) $75bf48a0e2bf731d$var$handleValue($75bf48a0e2bf731d$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $75bf48a0e2bf731d$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($75bf48a0e2bf731d$export$541ac630993a4c84(target) || handledSet.has(target) || !$75bf48a0e2bf731d$export$16e3aed3edb85946(target) || $75bf48a0e2bf731d$var$isFrozen(target)) return target;
    handledSet.add(target);
    $75bf48a0e2bf731d$var$each(target, (key, value)=>{
        if ($75bf48a0e2bf731d$export$541ac630993a4c84(value)) {
            const state = value[$75bf48a0e2bf731d$var$DRAFT_STATE];
            if ($75bf48a0e2bf731d$var$isSameScope(state, rootScope)) {
                const updatedValue = $75bf48a0e2bf731d$var$getFinalValue(state);
                $75bf48a0e2bf731d$var$set(target, key, updatedValue, target.type_);
                $75bf48a0e2bf731d$var$markStateFinalized(state);
            }
        } else if ($75bf48a0e2bf731d$export$16e3aed3edb85946(value)) $75bf48a0e2bf731d$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $75bf48a0e2bf731d$var$createProxyProxy(base, parent) {
    const baseIsArray = $75bf48a0e2bf731d$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $75bf48a0e2bf731d$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $75bf48a0e2bf731d$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $75bf48a0e2bf731d$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $75bf48a0e2bf731d$var$objectTraps = {
    get (state, prop) {
        if (prop === $75bf48a0e2bf731d$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin == null ? void 0 : arrayPlugin.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $75bf48a0e2bf731d$var$latest(state);
        if (!$75bf48a0e2bf731d$var$has(source, prop, state.type_)) return $75bf48a0e2bf731d$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$75bf48a0e2bf731d$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && (arrayPlugin == null ? void 0 : arrayPlugin.isMutatingArrayMethod(state.operationMethod)) && $75bf48a0e2bf731d$var$isArrayIndex(prop)) return value;
        if (value === $75bf48a0e2bf731d$var$peek(state.base_, prop)) {
            $75bf48a0e2bf731d$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $75bf48a0e2bf731d$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $75bf48a0e2bf731d$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($75bf48a0e2bf731d$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $75bf48a0e2bf731d$var$getDescriptorFromProto($75bf48a0e2bf731d$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $75bf48a0e2bf731d$var$peek($75bf48a0e2bf731d$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$75bf48a0e2bf731d$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($75bf48a0e2bf731d$var$is(value, current2) && (value !== void 0 || $75bf48a0e2bf731d$var$has(state.base_, prop, state.type_))) return true;
            $75bf48a0e2bf731d$var$prepareCopy(state);
            $75bf48a0e2bf731d$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $75bf48a0e2bf731d$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $75bf48a0e2bf731d$var$prepareCopy(state);
        if ($75bf48a0e2bf731d$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $75bf48a0e2bf731d$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $75bf48a0e2bf731d$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$75bf48a0e2bf731d$var$WRITABLE]: true,
            [$75bf48a0e2bf731d$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$75bf48a0e2bf731d$var$ENUMERABLE]: desc[$75bf48a0e2bf731d$var$ENUMERABLE],
            [$75bf48a0e2bf731d$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $75bf48a0e2bf731d$var$die(11);
    },
    getPrototypeOf (state) {
        return $75bf48a0e2bf731d$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $75bf48a0e2bf731d$var$die(12);
    }
};
var $75bf48a0e2bf731d$var$arrayTraps = {};
for(let key in $75bf48a0e2bf731d$var$objectTraps){
    let fn = $75bf48a0e2bf731d$var$objectTraps[key];
    $75bf48a0e2bf731d$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$75bf48a0e2bf731d$var$arrayTraps.deleteProperty = function(state, prop) {
    return $75bf48a0e2bf731d$var$arrayTraps.set.call(this, state, prop, void 0);
};
$75bf48a0e2bf731d$var$arrayTraps.set = function(state, prop, value) {
    return $75bf48a0e2bf731d$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $75bf48a0e2bf731d$var$peek(draft, prop) {
    const state = draft[$75bf48a0e2bf731d$var$DRAFT_STATE];
    const source = state ? $75bf48a0e2bf731d$var$latest(state) : draft;
    return source[prop];
}
function $75bf48a0e2bf731d$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $75bf48a0e2bf731d$var$getDescriptorFromProto(source, prop);
    return desc ? $75bf48a0e2bf731d$var$VALUE in desc ? desc[$75bf48a0e2bf731d$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $75bf48a0e2bf731d$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $75bf48a0e2bf731d$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $75bf48a0e2bf731d$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $75bf48a0e2bf731d$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $75bf48a0e2bf731d$var$markChanged(state.parent_);
    }
}
function $75bf48a0e2bf731d$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $75bf48a0e2bf731d$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $75bf48a0e2bf731d$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($75bf48a0e2bf731d$var$isFunction(base) && !$75bf48a0e2bf731d$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$75bf48a0e2bf731d$var$isFunction(recipe)) $75bf48a0e2bf731d$var$die(6);
            if (patchListener !== void 0 && !$75bf48a0e2bf731d$var$isFunction(patchListener)) $75bf48a0e2bf731d$var$die(7);
            let result;
            if ($75bf48a0e2bf731d$export$16e3aed3edb85946(base)) {
                const scope = $75bf48a0e2bf731d$var$enterScope(this);
                const proxy = $75bf48a0e2bf731d$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $75bf48a0e2bf731d$var$revokeScope(scope);
                    else $75bf48a0e2bf731d$var$leaveScope(scope);
                }
                $75bf48a0e2bf731d$var$usePatchesInScope(scope, patchListener);
                return $75bf48a0e2bf731d$var$processResult(result, scope);
            } else if (!base || !$75bf48a0e2bf731d$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $75bf48a0e2bf731d$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $75bf48a0e2bf731d$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $75bf48a0e2bf731d$var$getPlugin($75bf48a0e2bf731d$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $75bf48a0e2bf731d$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($75bf48a0e2bf731d$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($75bf48a0e2bf731d$var$isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($75bf48a0e2bf731d$var$isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($75bf48a0e2bf731d$var$isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$75bf48a0e2bf731d$export$16e3aed3edb85946(base)) $75bf48a0e2bf731d$var$die(8);
        if ($75bf48a0e2bf731d$export$541ac630993a4c84(base)) base = $75bf48a0e2bf731d$export$97aac956da55dae9(base);
        const scope = $75bf48a0e2bf731d$var$enterScope(this);
        const proxy = $75bf48a0e2bf731d$var$createProxy(scope, base, void 0);
        proxy[$75bf48a0e2bf731d$var$DRAFT_STATE].isManual_ = true;
        $75bf48a0e2bf731d$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$75bf48a0e2bf731d$var$DRAFT_STATE];
        if (!state || !state.isManual_) $75bf48a0e2bf731d$var$die(9);
        const { scope_: scope } = state;
        $75bf48a0e2bf731d$var$usePatchesInScope(scope, patchListener);
        return $75bf48a0e2bf731d$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $75bf48a0e2bf731d$var$getPlugin($75bf48a0e2bf731d$var$PluginPatches).applyPatches_;
        if ($75bf48a0e2bf731d$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $75bf48a0e2bf731d$var$createProxy(rootScope, value, parent, key) {
    var _a, _b;
    const [draft, state] = $75bf48a0e2bf731d$var$isMap(value) ? $75bf48a0e2bf731d$var$getPlugin($75bf48a0e2bf731d$var$PluginMapSet).proxyMap_(value, parent) : $75bf48a0e2bf731d$var$isSet(value) ? $75bf48a0e2bf731d$var$getPlugin($75bf48a0e2bf731d$var$PluginMapSet).proxySet_(value, parent) : $75bf48a0e2bf731d$var$createProxyProxy(value, parent);
    const scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : $75bf48a0e2bf731d$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) $75bf48a0e2bf731d$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $75bf48a0e2bf731d$export$97aac956da55dae9(value) {
    if (!$75bf48a0e2bf731d$export$541ac630993a4c84(value)) $75bf48a0e2bf731d$var$die(10, value);
    return $75bf48a0e2bf731d$var$currentImpl(value);
}
function $75bf48a0e2bf731d$var$currentImpl(value) {
    if (!$75bf48a0e2bf731d$export$16e3aed3edb85946(value) || $75bf48a0e2bf731d$var$isFrozen(value)) return value;
    const state = value[$75bf48a0e2bf731d$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $75bf48a0e2bf731d$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $75bf48a0e2bf731d$var$shallowCopy(value, true);
    $75bf48a0e2bf731d$var$each(copy, (key, childValue)=>{
        $75bf48a0e2bf731d$var$set(copy, key, $75bf48a0e2bf731d$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $75bf48a0e2bf731d$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        var _a;
        if (state.key_ !== void 0) {
            const parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            const proxyDraft = $75bf48a0e2bf731d$var$getProxyDraft($75bf48a0e2bf731d$var$get(parentCopy, state.key_));
            const valueAtKey = $75bf48a0e2bf731d$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $75bf48a0e2bf731d$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $75bf48a0e2bf731d$var$get(current2, key);
            if (!$75bf48a0e2bf731d$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || (assigned_ == null ? void 0 : assigned_.get(i.toString()));
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem == null ? void 0 : copiedItem[$75bf48a0e2bf731d$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $75bf48a0e2bf731d$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $75bf48a0e2bf731d$var$get(base_, key, type_);
            const value = $75bf48a0e2bf731d$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $75bf48a0e2bf731d$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $75bf48a0e2bf731d$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $75bf48a0e2bf731d$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $75bf48a0e2bf731d$var$CONSTRUCTOR)) $75bf48a0e2bf731d$var$die(errorOffset + 3);
                if ($75bf48a0e2bf731d$var$isFunction(base) && p === $75bf48a0e2bf731d$var$PROTOTYPE) $75bf48a0e2bf731d$var$die(errorOffset + 3);
                base = $75bf48a0e2bf731d$var$get(base, p);
                if (!$75bf48a0e2bf731d$var$isObjectish(base)) $75bf48a0e2bf731d$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $75bf48a0e2bf731d$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $75bf48a0e2bf731d$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $75bf48a0e2bf731d$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$75bf48a0e2bf731d$export$16e3aed3edb85946(obj)) return obj;
        if ($75bf48a0e2bf731d$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($75bf48a0e2bf731d$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($75bf48a0e2bf731d$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($75bf48a0e2bf731d$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($75bf48a0e2bf731d$var$has(obj, $75bf48a0e2bf731d$export$6ee2082928bcb0ee)) cloned[$75bf48a0e2bf731d$export$6ee2082928bcb0ee] = obj[$75bf48a0e2bf731d$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($75bf48a0e2bf731d$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $75bf48a0e2bf731d$var$loadPlugin($75bf48a0e2bf731d$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $75bf48a0e2bf731d$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$75bf48a0e2bf731d$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $75bf48a0e2bf731d$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $75bf48a0e2bf731d$var$latest(this[$75bf48a0e2bf731d$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $75bf48a0e2bf731d$var$latest(this[$75bf48a0e2bf731d$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$75bf48a0e2bf731d$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$75bf48a0e2bf731d$var$latest(state).has(key) || $75bf48a0e2bf731d$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $75bf48a0e2bf731d$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $75bf48a0e2bf731d$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$75bf48a0e2bf731d$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $75bf48a0e2bf731d$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$75bf48a0e2bf731d$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($75bf48a0e2bf731d$var$latest(state).size) {
                prepareMapCopy(state);
                $75bf48a0e2bf731d$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $75bf48a0e2bf731d$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$75bf48a0e2bf731d$var$DRAFT_STATE];
            $75bf48a0e2bf731d$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$75bf48a0e2bf731d$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $75bf48a0e2bf731d$var$latest(state).get(key);
            if (state.finalized_ || !$75bf48a0e2bf731d$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $75bf48a0e2bf731d$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $75bf48a0e2bf731d$var$latest(this[$75bf48a0e2bf731d$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($75bf48a0e2bf731d$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$75bf48a0e2bf731d$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$75bf48a0e2bf731d$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $75bf48a0e2bf731d$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $75bf48a0e2bf731d$var$latest(this[$75bf48a0e2bf731d$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$75bf48a0e2bf731d$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$75bf48a0e2bf731d$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $75bf48a0e2bf731d$var$markChanged(state);
                state.copy_.add(value);
                $75bf48a0e2bf731d$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$75bf48a0e2bf731d$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $75bf48a0e2bf731d$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$75bf48a0e2bf731d$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($75bf48a0e2bf731d$var$latest(state).size) {
                prepareSetCopy(state);
                $75bf48a0e2bf731d$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$75bf48a0e2bf731d$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$75bf48a0e2bf731d$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($75bf48a0e2bf731d$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$75bf48a0e2bf731d$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($75bf48a0e2bf731d$export$16e3aed3edb85946(value)) {
                    const draft = $75bf48a0e2bf731d$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $75bf48a0e2bf731d$var$die(3, JSON.stringify($75bf48a0e2bf731d$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($75bf48a0e2bf731d$var$getValue(value));
            });
        }
    }
    $75bf48a0e2bf731d$var$loadPlugin($75bf48a0e2bf731d$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $75bf48a0e2bf731d$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $75bf48a0e2bf731d$var$prepareCopy(state);
        const result = operation();
        $75bf48a0e2bf731d$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        var _a, _b;
        const source = $75bf48a0e2bf731d$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = (_a = args[0]) != null ? _a : 0;
            const rawEnd = (_b = args[1]) != null ? _b : source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $75bf48a0e2bf731d$var$loadPlugin($75bf48a0e2bf731d$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $75bf48a0e2bf731d$var$immer = new $75bf48a0e2bf731d$export$aaadc6ff0f822719();
var $75bf48a0e2bf731d$export$b46cabe22e78bc00 = $75bf48a0e2bf731d$var$immer.produce;
var $75bf48a0e2bf731d$export$4da66d41c9492c78 = /* @__PURE__ */ $75bf48a0e2bf731d$var$immer.produceWithPatches.bind($75bf48a0e2bf731d$var$immer);
var $75bf48a0e2bf731d$export$573f26f60825c493 = /* @__PURE__ */ $75bf48a0e2bf731d$var$immer.setAutoFreeze.bind($75bf48a0e2bf731d$var$immer);
var $75bf48a0e2bf731d$export$333ce65961cbe047 = /* @__PURE__ */ $75bf48a0e2bf731d$var$immer.setUseStrictShallowCopy.bind($75bf48a0e2bf731d$var$immer);
var $75bf48a0e2bf731d$export$1045b3be3904c489 = /* @__PURE__ */ $75bf48a0e2bf731d$var$immer.setUseStrictIteration.bind($75bf48a0e2bf731d$var$immer);
var $75bf48a0e2bf731d$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $75bf48a0e2bf731d$var$immer.applyPatches.bind($75bf48a0e2bf731d$var$immer);
var $75bf48a0e2bf731d$export$3c3214997190395f = /* @__PURE__ */ $75bf48a0e2bf731d$var$immer.createDraft.bind($75bf48a0e2bf731d$var$immer);
var $75bf48a0e2bf731d$export$c60f5e69c521b528 = /* @__PURE__ */ $75bf48a0e2bf731d$var$immer.finishDraft.bind($75bf48a0e2bf731d$var$immer);
var $75bf48a0e2bf731d$export$c05b21e3257751e5 = (value)=>value;
var $75bf48a0e2bf731d$export$20f911b3f8cf0b74 = (value)=>value;


var $c728c8fbce4ac913$var$__defProp = Object.defineProperty;
var $c728c8fbce4ac913$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c728c8fbce4ac913$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c728c8fbce4ac913$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c728c8fbce4ac913$var$__defNormalProp = (obj, key, value)=>key in obj ? $c728c8fbce4ac913$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c728c8fbce4ac913$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c728c8fbce4ac913$var$__hasOwnProp.call(b, prop)) $c728c8fbce4ac913$var$__defNormalProp(a, prop, b[prop]);
    if ($c728c8fbce4ac913$var$__getOwnPropSymbols) {
        for (var prop of $c728c8fbce4ac913$var$__getOwnPropSymbols(b))if ($c728c8fbce4ac913$var$__propIsEnum.call(b, prop)) $c728c8fbce4ac913$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c728c8fbce4ac913$var$__publicField = (obj, key, value)=>{
    $c728c8fbce4ac913$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $c728c8fbce4ac913$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $c728c8fbce4ac913$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $c728c8fbce4ac913$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $c728c8fbce4ac913$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($c728c8fbce4ac913$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $c728c8fbce4ac913$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $c728c8fbce4ac913$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $c728c8fbce4ac913$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $c728c8fbce4ac913$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $c728c8fbce4ac913$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $c728c8fbce4ac913$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $c728c8fbce4ac913$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $c728c8fbce4ac913$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $c728c8fbce4ac913$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $c728c8fbce4ac913$var$__spreadValues($c728c8fbce4ac913$var$__spreadValues({}, $c728c8fbce4ac913$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $c728c8fbce4ac913$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $c728c8fbce4ac913$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $c728c8fbce4ac913$var$$REVISION = 0;
var $c728c8fbce4ac913$var$CURRENT_TRACKER = null;
var $c728c8fbce4ac913$var$Cell = class {
    constructor(initialValue, isEqual = $c728c8fbce4ac913$var$tripleEq){
        $c728c8fbce4ac913$var$__publicField(this, "revision", $c728c8fbce4ac913$var$$REVISION);
        $c728c8fbce4ac913$var$__publicField(this, "_value");
        $c728c8fbce4ac913$var$__publicField(this, "_lastValue");
        $c728c8fbce4ac913$var$__publicField(this, "_isEqual", $c728c8fbce4ac913$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $c728c8fbce4ac913$var$CURRENT_TRACKER == null || $c728c8fbce4ac913$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$c728c8fbce4ac913$var$$REVISION;
    }
};
function $c728c8fbce4ac913$var$tripleEq(a, b) {
    return a === b;
}
var $c728c8fbce4ac913$var$TrackingCache = class {
    constructor(fn){
        $c728c8fbce4ac913$var$__publicField(this, "_cachedValue");
        $c728c8fbce4ac913$var$__publicField(this, "_cachedRevision", -1);
        $c728c8fbce4ac913$var$__publicField(this, "_deps", []);
        $c728c8fbce4ac913$var$__publicField(this, "hits", 0);
        $c728c8fbce4ac913$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $c728c8fbce4ac913$var$CURRENT_TRACKER;
            $c728c8fbce4ac913$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $c728c8fbce4ac913$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $c728c8fbce4ac913$var$CURRENT_TRACKER == null || $c728c8fbce4ac913$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $c728c8fbce4ac913$var$getValue(cell) {
    if (!(cell instanceof $c728c8fbce4ac913$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $c728c8fbce4ac913$var$setValue(storage, value) {
    if (!(storage instanceof $c728c8fbce4ac913$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $c728c8fbce4ac913$var$createCell(initialValue, isEqual = $c728c8fbce4ac913$var$tripleEq) {
    return new $c728c8fbce4ac913$var$Cell(initialValue, isEqual);
}
function $c728c8fbce4ac913$var$createCache(fn) {
    $c728c8fbce4ac913$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $c728c8fbce4ac913$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $c728c8fbce4ac913$var$neverEq = (a, b)=>false;
function $c728c8fbce4ac913$var$createTag() {
    return $c728c8fbce4ac913$var$createCell(null, $c728c8fbce4ac913$var$neverEq);
}
function $c728c8fbce4ac913$var$dirtyTag(tag, value) {
    $c728c8fbce4ac913$var$setValue(tag, value);
}
var $c728c8fbce4ac913$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $c728c8fbce4ac913$var$createTag();
    $c728c8fbce4ac913$var$getValue(tag);
};
var $c728c8fbce4ac913$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $c728c8fbce4ac913$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $c728c8fbce4ac913$var$REDUX_PROXY_LABEL = Symbol();
var $c728c8fbce4ac913$var$nextId = 0;
var $c728c8fbce4ac913$var$proto = Object.getPrototypeOf({});
var $c728c8fbce4ac913$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $c728c8fbce4ac913$var$__publicField(this, "proxy", new Proxy(this, $c728c8fbce4ac913$var$objectProxyHandler));
        $c728c8fbce4ac913$var$__publicField(this, "tag", $c728c8fbce4ac913$var$createTag());
        $c728c8fbce4ac913$var$__publicField(this, "tags", {});
        $c728c8fbce4ac913$var$__publicField(this, "children", {});
        $c728c8fbce4ac913$var$__publicField(this, "collectionTag", null);
        $c728c8fbce4ac913$var$__publicField(this, "id", $c728c8fbce4ac913$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $c728c8fbce4ac913$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $c728c8fbce4ac913$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $c728c8fbce4ac913$var$createNode(childValue);
                if (childNode.tag) $c728c8fbce4ac913$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $c728c8fbce4ac913$var$createTag();
                    tag.value = childValue;
                }
                $c728c8fbce4ac913$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $c728c8fbce4ac913$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $c728c8fbce4ac913$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $c728c8fbce4ac913$var$__publicField(this, "proxy", new Proxy([
            this
        ], $c728c8fbce4ac913$var$arrayProxyHandler));
        $c728c8fbce4ac913$var$__publicField(this, "tag", $c728c8fbce4ac913$var$createTag());
        $c728c8fbce4ac913$var$__publicField(this, "tags", {});
        $c728c8fbce4ac913$var$__publicField(this, "children", {});
        $c728c8fbce4ac913$var$__publicField(this, "collectionTag", null);
        $c728c8fbce4ac913$var$__publicField(this, "id", $c728c8fbce4ac913$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $c728c8fbce4ac913$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $c728c8fbce4ac913$var$consumeCollection(node);
        return $c728c8fbce4ac913$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $c728c8fbce4ac913$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $c728c8fbce4ac913$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $c728c8fbce4ac913$var$objectProxyHandler.has(node, prop);
    }
};
function $c728c8fbce4ac913$var$createNode(value) {
    if (Array.isArray(value)) return new $c728c8fbce4ac913$var$ArrayTreeNode(value);
    return new $c728c8fbce4ac913$var$ObjectTreeNode(value);
}
function $c728c8fbce4ac913$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $c728c8fbce4ac913$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $c728c8fbce4ac913$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $c728c8fbce4ac913$var$dirtyCollection(node);
            $c728c8fbce4ac913$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $c728c8fbce4ac913$var$updateNode(childNode, newChildValue);
        else {
            $c728c8fbce4ac913$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $c728c8fbce4ac913$var$deleteNode(node) {
    if (node.tag) $c728c8fbce4ac913$var$dirtyTag(node.tag, null);
    $c728c8fbce4ac913$var$dirtyCollection(node);
    for(const key in node.tags)$c728c8fbce4ac913$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$c728c8fbce4ac913$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $c728c8fbce4ac913$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $c728c8fbce4ac913$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $c728c8fbce4ac913$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $c728c8fbce4ac913$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $c728c8fbce4ac913$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $c728c8fbce4ac913$export$3f025202a230c6dd = (a, b)=>a === b;
function $c728c8fbce4ac913$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $c728c8fbce4ac913$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $c728c8fbce4ac913$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $c728c8fbce4ac913$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $c728c8fbce4ac913$var$createSingletonCache(comparator) : $c728c8fbce4ac913$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $c728c8fbce4ac913$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $c728c8fbce4ac913$export$c8f9cf88d9fdee55(func) {
    const node = $c728c8fbce4ac913$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $c728c8fbce4ac913$var$createCacheKeyComparator($c728c8fbce4ac913$export$3f025202a230c6dd);
    const cache = $c728c8fbce4ac913$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $c728c8fbce4ac913$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $c728c8fbce4ac913$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $c728c8fbce4ac913$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $c728c8fbce4ac913$var$StrongRef;
var $c728c8fbce4ac913$var$UNTERMINATED = 0;
var $c728c8fbce4ac913$var$TERMINATED = 1;
function $c728c8fbce4ac913$var$createCacheNode() {
    return {
        s: $c728c8fbce4ac913$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $c728c8fbce4ac913$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $c728c8fbce4ac913$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $c728c8fbce4ac913$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $c728c8fbce4ac913$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $c728c8fbce4ac913$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $c728c8fbce4ac913$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $c728c8fbce4ac913$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $c728c8fbce4ac913$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $c728c8fbce4ac913$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $c728c8fbce4ac913$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $c728c8fbce4ac913$var$__spreadValues($c728c8fbce4ac913$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $c728c8fbce4ac913$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $c728c8fbce4ac913$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $c728c8fbce4ac913$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $c728c8fbce4ac913$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $c728c8fbce4ac913$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $c728c8fbce4ac913$export$595d22ed68ca2841 = /* @__PURE__ */ $c728c8fbce4ac913$export$5943f4447f6ef248($c728c8fbce4ac913$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $c728c8fbce4ac913$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $c728c8fbce4ac913$export$595d22ed68ca2841)=>{
    $c728c8fbce4ac913$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$c728c8fbce4ac913$export$75979cfcd91bf38f
});


// src/index.ts
function $1e3ea28decd88f5c$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $1e3ea28decd88f5c$export$dd164f5517779f15 = $1e3ea28decd88f5c$var$createThunkMiddleware();
var $1e3ea28decd88f5c$export$16d06542a1949d9e = $1e3ea28decd88f5c$var$createThunkMiddleware;


var $ec80cf871915f813$var$__defProp = Object.defineProperty;
var $ec80cf871915f813$var$__defProps = Object.defineProperties;
var $ec80cf871915f813$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $ec80cf871915f813$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ec80cf871915f813$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ec80cf871915f813$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ec80cf871915f813$var$__defNormalProp = (obj, key, value)=>key in obj ? $ec80cf871915f813$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ec80cf871915f813$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($ec80cf871915f813$var$__hasOwnProp.call(b, prop)) $ec80cf871915f813$var$__defNormalProp(a, prop, b[prop]);
    if ($ec80cf871915f813$var$__getOwnPropSymbols) {
        for (var prop of $ec80cf871915f813$var$__getOwnPropSymbols(b))if ($ec80cf871915f813$var$__propIsEnum.call(b, prop)) $ec80cf871915f813$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $ec80cf871915f813$var$__spreadProps = (a, b)=>$ec80cf871915f813$var$__defProps(a, $ec80cf871915f813$var$__getOwnPropDescs(b));
var $ec80cf871915f813$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($ec80cf871915f813$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $ec80cf871915f813$var$__getOwnPropSymbols) {
        for (var prop of $ec80cf871915f813$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $ec80cf871915f813$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $ec80cf871915f813$var$__publicField = (obj, key, value)=>$ec80cf871915f813$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/createDraftSafeSelector.ts
var $ec80cf871915f813$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $c728c8fbce4ac913$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $75bf48a0e2bf731d$export$541ac630993a4c84)(value) ? (0, $75bf48a0e2bf731d$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $ec80cf871915f813$export$a5d3c27355e35910 = /* @__PURE__ */ $ec80cf871915f813$export$aab6de9e3dbb1473((0, $c728c8fbce4ac913$export$8402dc26d96f6902));
// src/devtoolsExtension.ts
var $ec80cf871915f813$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $da655fa243288d8a$export$f672e0b6f7222cd7;
    return (0, $da655fa243288d8a$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $ec80cf871915f813$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $ec80cf871915f813$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $ec80cf871915f813$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($ec80cf871915f813$export$378fa86b259c0280(0));
            return $ec80cf871915f813$var$__spreadValues($ec80cf871915f813$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $da655fa243288d8a$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $ec80cf871915f813$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $ec80cf871915f813$var$hasMatchFunction(action);
}
function $ec80cf871915f813$export$ebd532f9034651f3(action) {
    return (0, $da655fa243288d8a$export$b956e38827fca970)(action) && Object.keys(action).every($ec80cf871915f813$var$isValidKey);
}
function $ec80cf871915f813$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $ec80cf871915f813$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $ec80cf871915f813$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/utils.ts
function $ec80cf871915f813$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $ec80cf871915f813$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $ec80cf871915f813$var$freezeDraftable(val) {
    return (0, $75bf48a0e2bf731d$export$16e3aed3edb85946)(val) ? (0, $75bf48a0e2bf731d$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $ec80cf871915f813$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $ec80cf871915f813$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $ec80cf871915f813$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = $ec80cf871915f813$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return $ec80cf871915f813$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $ec80cf871915f813$var$trackProperties(isImmutable, ignoredPaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                const hasMatches = ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) continue;
            }
            tracked.children[key] = $ec80cf871915f813$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
        }
    }
    return tracked;
}
function $ec80cf871915f813$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $ec80cf871915f813$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $ec80cf871915f813$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/serializableStateInvariantMiddleware.ts
function $ec80cf871915f813$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $da655fa243288d8a$export$53b83ca8eaab0383)(val);
}
function $ec80cf871915f813$export$ada5dca0b571bc7(value, path = "", isSerializable = $ec80cf871915f813$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $ec80cf871915f813$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $ec80cf871915f813$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $ec80cf871915f813$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$ec80cf871915f813$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $ec80cf871915f813$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $ec80cf871915f813$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $ec80cf871915f813$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $ec80cf871915f813$export$1908877435b1d5e9();
        if (thunk) {
            if ($ec80cf871915f813$var$isBoolean(thunk)) middlewareArray.push((0, $1e3ea28decd88f5c$export$dd164f5517779f15));
            else middlewareArray.push((0, $1e3ea28decd88f5c$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $ec80cf871915f813$export$8fb31c0f05df007b = "RTK_autoBatch";
var $ec80cf871915f813$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$ec80cf871915f813$export$8fb31c0f05df007b]: true
            }
        });
var $ec80cf871915f813$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $ec80cf871915f813$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $ec80cf871915f813$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $ec80cf871915f813$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$ec80cf871915f813$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $ec80cf871915f813$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $ec80cf871915f813$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($ec80cf871915f813$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $ec80cf871915f813$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $ec80cf871915f813$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $da655fa243288d8a$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $da655fa243288d8a$export$66e4520cdb265d18)(reducer);
    else throw new Error($ec80cf871915f813$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $da655fa243288d8a$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $ec80cf871915f813$var$composeWithDevTools($ec80cf871915f813$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $da655fa243288d8a$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $ec80cf871915f813$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $da655fa243288d8a$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $ec80cf871915f813$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($ec80cf871915f813$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($ec80cf871915f813$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $ec80cf871915f813$var$isStateFunction(x) {
    return typeof x === "function";
}
function $ec80cf871915f813$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $ec80cf871915f813$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($ec80cf871915f813$var$isStateFunction(initialState)) getInitialState = ()=>$ec80cf871915f813$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $ec80cf871915f813$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $75bf48a0e2bf731d$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $75bf48a0e2bf731d$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $75bf48a0e2bf731d$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $ec80cf871915f813$var$matches = (matcher, action)=>{
    if ($ec80cf871915f813$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $ec80cf871915f813$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$ec80cf871915f813$var$matches(matcher, action));
    };
}
function $ec80cf871915f813$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$ec80cf871915f813$var$matches(matcher, action));
    };
}
function $ec80cf871915f813$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $ec80cf871915f813$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $ec80cf871915f813$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$ec80cf871915f813$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$ec80cf871915f813$var$isAsyncThunkArray(asyncThunks)) return $ec80cf871915f813$export$872dec21e9a69476()(asyncThunks[0]);
    return $ec80cf871915f813$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $ec80cf871915f813$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$ec80cf871915f813$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$ec80cf871915f813$var$isAsyncThunkArray(asyncThunks)) return $ec80cf871915f813$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $ec80cf871915f813$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $ec80cf871915f813$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $ec80cf871915f813$export$9dd1fb32974da385($ec80cf871915f813$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$ec80cf871915f813$var$isAsyncThunkArray(asyncThunks)) return $ec80cf871915f813$export$fcc3388fb56de601()(asyncThunks[0]);
    return $ec80cf871915f813$export$9dd1fb32974da385($ec80cf871915f813$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $ec80cf871915f813$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$ec80cf871915f813$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$ec80cf871915f813$var$isAsyncThunkArray(asyncThunks)) return $ec80cf871915f813$export$1da80a6ef1307441()(asyncThunks[0]);
    return $ec80cf871915f813$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $ec80cf871915f813$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$ec80cf871915f813$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$ec80cf871915f813$var$isAsyncThunkArray(asyncThunks)) return $ec80cf871915f813$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $ec80cf871915f813$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $ec80cf871915f813$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $ec80cf871915f813$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $ec80cf871915f813$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $ec80cf871915f813$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $ec80cf871915f813$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $ec80cf871915f813$var$__publicField(this, "_type");
    }
};
var $ec80cf871915f813$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $ec80cf871915f813$var$__publicField(this, "_type");
    }
};
var $ec80cf871915f813$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $ec80cf871915f813$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $ec80cf871915f813$var$externalAbortMessage = "External signal was aborted";
var $ec80cf871915f813$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $ec80cf871915f813$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $ec80cf871915f813$var$__spreadProps($ec80cf871915f813$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $ec80cf871915f813$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $ec80cf871915f813$var$__spreadProps($ec80cf871915f813$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $ec80cf871915f813$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $ec80cf871915f813$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $ec80cf871915f813$var$__spreadProps($ec80cf871915f813$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $ec80cf871915f813$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($ec80cf871915f813$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($ec80cf871915f813$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($ec80cf871915f813$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $ec80cf871915f813$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $ec80cf871915f813$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $ec80cf871915f813$var$RejectWithValue) throw result;
                                if (result instanceof $ec80cf871915f813$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $ec80cf871915f813$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($ec80cf871915f813$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $ec80cf871915f813$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $ec80cf871915f813$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $ec80cf871915f813$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $ec80cf871915f813$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $ec80cf871915f813$export$343355ed40c51c46 = {
    [$ec80cf871915f813$var$asyncThunkSymbol]: $ec80cf871915f813$export$6abd22dc03e5063f
};
var $ec80cf871915f813$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($ec80cf871915f813$export$23a094319a4b586 || {});
function $ec80cf871915f813$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $ec80cf871915f813$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$ec80cf871915f813$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($ec80cf871915f813$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($ec80cf871915f813$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($ec80cf871915f813$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($ec80cf871915f813$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $ec80cf871915f813$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($ec80cf871915f813$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $ec80cf871915f813$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $ec80cf871915f813$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $ec80cf871915f813$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $ec80cf871915f813$var$__spreadValues($ec80cf871915f813$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $ec80cf871915f813$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $ec80cf871915f813$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $ec80cf871915f813$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $ec80cf871915f813$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $ec80cf871915f813$var$wrapSelector(selector, selectState, ()=>$ec80cf871915f813$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $ec80cf871915f813$var$__spreadProps($ec80cf871915f813$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $ec80cf871915f813$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $ec80cf871915f813$var$__spreadValues($ec80cf871915f813$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $ec80cf871915f813$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $ec80cf871915f813$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $ec80cf871915f813$export$affdea4146de9cf5();
function $ec80cf871915f813$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $ec80cf871915f813$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $ec80cf871915f813$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$ec80cf871915f813$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($ec80cf871915f813$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $ec80cf871915f813$export$309c7a02b0b0bc62(type, prepareCallback) : $ec80cf871915f813$export$309c7a02b0b0bc62(type));
}
function $ec80cf871915f813$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $ec80cf871915f813$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $ec80cf871915f813$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($ec80cf871915f813$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $ec80cf871915f813$var$noop,
        pending: pending || $ec80cf871915f813$var$noop,
        rejected: rejected || $ec80cf871915f813$var$noop,
        settled: settled || $ec80cf871915f813$var$noop
    });
}
function $ec80cf871915f813$var$noop() {}
// src/entities/entity_state.ts
function $ec80cf871915f813$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $ec80cf871915f813$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($ec80cf871915f813$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $ec80cf871915f813$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $ec80cf871915f813$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
// src/entities/state_adapter.ts
var $ec80cf871915f813$var$isDraftTyped = (0, $75bf48a0e2bf731d$export$541ac630993a4c84);
function $ec80cf871915f813$var$createSingleArgumentStateOperator(mutator) {
    const operator = $ec80cf871915f813$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $ec80cf871915f813$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $ec80cf871915f813$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($ec80cf871915f813$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $75bf48a0e2bf731d$export$b46cabe22e78bc00)(state, runMutator);
    };
}
// src/entities/utils.ts
function $ec80cf871915f813$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $ec80cf871915f813$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $ec80cf871915f813$var$getCurrent(value) {
    return (0, $75bf48a0e2bf731d$export$541ac630993a4c84)(value) ? (0, $75bf48a0e2bf731d$export$97aac956da55dae9)(value) : value;
}
function $ec80cf871915f813$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $ec80cf871915f813$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $ec80cf871915f813$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $ec80cf871915f813$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $ec80cf871915f813$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $ec80cf871915f813$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $ec80cf871915f813$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $ec80cf871915f813$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $ec80cf871915f813$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $ec80cf871915f813$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $ec80cf871915f813$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $ec80cf871915f813$var$__spreadValues($ec80cf871915f813$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$ec80cf871915f813$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $ec80cf871915f813$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $ec80cf871915f813$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $ec80cf871915f813$var$createStateOperator(addOneMutably),
        addMany: $ec80cf871915f813$var$createStateOperator(addManyMutably),
        setOne: $ec80cf871915f813$var$createStateOperator(setOneMutably),
        setMany: $ec80cf871915f813$var$createStateOperator(setManyMutably),
        setAll: $ec80cf871915f813$var$createStateOperator(setAllMutably),
        updateOne: $ec80cf871915f813$var$createStateOperator(updateOneMutably),
        updateMany: $ec80cf871915f813$var$createStateOperator(updateManyMutably),
        upsertOne: $ec80cf871915f813$var$createStateOperator(upsertOneMutably),
        upsertMany: $ec80cf871915f813$var$createStateOperator(upsertManyMutably),
        removeOne: $ec80cf871915f813$var$createStateOperator(removeOneMutably),
        removeMany: $ec80cf871915f813$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $ec80cf871915f813$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $ec80cf871915f813$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $ec80cf871915f813$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $ec80cf871915f813$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $ec80cf871915f813$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $ec80cf871915f813$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $ec80cf871915f813$var$getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = $ec80cf871915f813$var$selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = $ec80cf871915f813$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = $ec80cf871915f813$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $ec80cf871915f813$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $ec80cf871915f813$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $ec80cf871915f813$var$getCurrent(state.entities);
        const currentIds = $ec80cf871915f813$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $ec80cf871915f813$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $ec80cf871915f813$var$createStateOperator(addOneMutably),
        updateOne: $ec80cf871915f813$var$createStateOperator(updateOneMutably),
        upsertOne: $ec80cf871915f813$var$createStateOperator(upsertOneMutably),
        setOne: $ec80cf871915f813$var$createStateOperator(setOneMutably),
        setMany: $ec80cf871915f813$var$createStateOperator(setManyMutably),
        setAll: $ec80cf871915f813$var$createStateOperator(setAllMutably),
        addMany: $ec80cf871915f813$var$createStateOperator(addManyMutably),
        updateMany: $ec80cf871915f813$var$createStateOperator(updateManyMutably),
        upsertMany: $ec80cf871915f813$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $ec80cf871915f813$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $ec80cf871915f813$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $ec80cf871915f813$var$createSortedStateAdapter(selectId, sortComparer) : $ec80cf871915f813$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $ec80cf871915f813$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $ec80cf871915f813$var$createSelectorsFactory();
    return $ec80cf871915f813$var$__spreadValues($ec80cf871915f813$var$__spreadValues($ec80cf871915f813$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $ec80cf871915f813$var$task = "task";
var $ec80cf871915f813$var$listener = "listener";
var $ec80cf871915f813$var$completed = "completed";
var $ec80cf871915f813$var$cancelled = "cancelled";
var $ec80cf871915f813$var$taskCancelled = `task-${$ec80cf871915f813$var$cancelled}`;
var $ec80cf871915f813$var$taskCompleted = `task-${$ec80cf871915f813$var$completed}`;
var $ec80cf871915f813$var$listenerCancelled = `${$ec80cf871915f813$var$listener}-${$ec80cf871915f813$var$cancelled}`;
var $ec80cf871915f813$var$listenerCompleted = `${$ec80cf871915f813$var$listener}-${$ec80cf871915f813$var$completed}`;
var $ec80cf871915f813$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $ec80cf871915f813$var$__publicField(this, "name", "TaskAbortError");
        $ec80cf871915f813$var$__publicField(this, "message");
        this.message = `${$ec80cf871915f813$var$task} ${$ec80cf871915f813$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $ec80cf871915f813$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($ec80cf871915f813$export$378fa86b259c0280(32));
};
var $ec80cf871915f813$var$noop2 = ()=>{};
var $ec80cf871915f813$var$catchRejection = (promise, onError = $ec80cf871915f813$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $ec80cf871915f813$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
// src/listenerMiddleware/task.ts
var $ec80cf871915f813$var$validateActive = (signal)=>{
    if (signal.aborted) throw new $ec80cf871915f813$export$cb1bdac908fed7f(signal.reason);
};
function $ec80cf871915f813$var$raceWithSignal(signal, promise) {
    let cleanup = $ec80cf871915f813$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $ec80cf871915f813$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $ec80cf871915f813$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $ec80cf871915f813$var$noop2;
    });
}
var $ec80cf871915f813$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $ec80cf871915f813$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $ec80cf871915f813$var$createPause = (signal)=>{
    return (promise)=>{
        return $ec80cf871915f813$var$catchRejection($ec80cf871915f813$var$raceWithSignal(signal, promise).then((output)=>{
            $ec80cf871915f813$var$validateActive(signal);
            return output;
        }));
    };
};
var $ec80cf871915f813$var$createDelay = (signal)=>{
    const pause = $ec80cf871915f813$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $ec80cf871915f813$var$assign } = Object;
var $ec80cf871915f813$var$INTERNAL_NIL_TOKEN = {};
var $ec80cf871915f813$var$alm = "listenerMiddleware";
var $ec80cf871915f813$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$ec80cf871915f813$var$addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $ec80cf871915f813$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $ec80cf871915f813$var$runTask(async ()=>{
            $ec80cf871915f813$var$validateActive(parentAbortSignal);
            $ec80cf871915f813$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $ec80cf871915f813$var$createPause(childAbortController.signal),
                delay: $ec80cf871915f813$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $ec80cf871915f813$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>childAbortController.abort($ec80cf871915f813$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($ec80cf871915f813$var$noop2));
        return {
            result: $ec80cf871915f813$var$createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort($ec80cf871915f813$var$taskCancelled);
            }
        };
    };
};
var $ec80cf871915f813$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $ec80cf871915f813$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $ec80cf871915f813$var$raceWithSignal(signal, Promise.race(promises));
            $ec80cf871915f813$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$ec80cf871915f813$var$catchRejection(take(predicate, timeout));
};
var $ec80cf871915f813$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $ec80cf871915f813$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($ec80cf871915f813$export$378fa86b259c0280(21));
    $ec80cf871915f813$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $ec80cf871915f813$var$createListenerEntry = /* @__PURE__ */ $ec80cf871915f813$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $ec80cf871915f813$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $ec80cf871915f813$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($ec80cf871915f813$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$ec80cf871915f813$var$createListenerEntry
});
var $ec80cf871915f813$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $ec80cf871915f813$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $ec80cf871915f813$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort($ec80cf871915f813$var$listenerCancelled);
    });
};
var $ec80cf871915f813$var$createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener2 of executingListeners.keys())$ec80cf871915f813$var$cancelActiveListeners(listener2);
        listenerMap.clear();
    };
};
var $ec80cf871915f813$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $ec80cf871915f813$export$f03a6b845d3fb58b = /* @__PURE__ */ $ec80cf871915f813$var$assign(/* @__PURE__ */ $ec80cf871915f813$export$309c7a02b0b0bc62(`${$ec80cf871915f813$var$alm}/add`), {
    withTypes: ()=>$ec80cf871915f813$export$f03a6b845d3fb58b
});
var $ec80cf871915f813$export$b1b8022855fb2b71 = /* @__PURE__ */ $ec80cf871915f813$export$309c7a02b0b0bc62(`${$ec80cf871915f813$var$alm}/removeAll`);
var $ec80cf871915f813$export$b03e9483f936dccb = /* @__PURE__ */ $ec80cf871915f813$var$assign(/* @__PURE__ */ $ec80cf871915f813$export$309c7a02b0b0bc62(`${$ec80cf871915f813$var$alm}/remove`), {
    withTypes: ()=>$ec80cf871915f813$export$b03e9483f936dccb
});
var $ec80cf871915f813$var$defaultErrorHandler = (...args)=>{
    console.error(`${$ec80cf871915f813$var$alm}/error`, ...args);
};
var $ec80cf871915f813$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra: extra, onError: onError = $ec80cf871915f813$var$defaultErrorHandler } = middlewareOptions;
    $ec80cf871915f813$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $ec80cf871915f813$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $ec80cf871915f813$var$findListenerEntry(listenerMap, options)) != null ? _a : $ec80cf871915f813$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $ec80cf871915f813$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $ec80cf871915f813$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $ec80cf871915f813$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $ec80cf871915f813$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $ec80cf871915f813$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $ec80cf871915f813$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $ec80cf871915f813$var$createDelay(internalTaskController.signal),
                pause: $ec80cf871915f813$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $ec80cf871915f813$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort($ec80cf871915f813$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort($ec80cf871915f813$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $ec80cf871915f813$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $ec80cf871915f813$export$cb1bdac908fed7f)) $ec80cf871915f813$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort($ec80cf871915f813$var$listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $ec80cf871915f813$var$createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $da655fa243288d8a$export$b956e38827fca970)(action)) return next(action);
                if ($ec80cf871915f813$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($ec80cf871915f813$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($ec80cf871915f813$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $ec80cf871915f813$var$INTERNAL_NIL_TOKEN) throw new Error($ec80cf871915f813$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $ec80cf871915f813$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $ec80cf871915f813$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
// src/dynamicMiddleware/index.ts
var $ec80cf871915f813$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $ec80cf871915f813$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $ec80cf871915f813$export$4bb1606a79445586 = ()=>{
    const instanceId = $ec80cf871915f813$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($ec80cf871915f813$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $ec80cf871915f813$var$getOrInsertComputed(middlewareMap, middleware2, $ec80cf871915f813$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$ec80cf871915f813$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $da655fa243288d8a$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $ec80cf871915f813$export$9dd1fb32974da385(withMiddleware, $ec80cf871915f813$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $ec80cf871915f813$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $ec80cf871915f813$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$ec80cf871915f813$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $ec80cf871915f813$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $ec80cf871915f813$var$isStateProxy = (value)=>!!value && !!value[$ec80cf871915f813$var$ORIGINAL_STATE];
var $ec80cf871915f813$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $ec80cf871915f813$var$createStateProxy = (state, reducerMap, initialStateCache)=>$ec80cf871915f813$var$getOrInsertComputed($ec80cf871915f813$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $ec80cf871915f813$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $ec80cf871915f813$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($ec80cf871915f813$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $ec80cf871915f813$var$original = (state)=>{
    if (!$ec80cf871915f813$var$isStateProxy(state)) throw new Error($ec80cf871915f813$export$378fa86b259c0280(25));
    return state[$ec80cf871915f813$var$ORIGINAL_STATE];
};
var $ec80cf871915f813$var$emptyObject = {};
var $ec80cf871915f813$var$noopReducer = (state = $ec80cf871915f813$var$emptyObject)=>state;
function $ec80cf871915f813$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($ec80cf871915f813$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $da655fa243288d8a$export$66e4520cdb265d18)(reducerMap) : $ec80cf871915f813$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($ec80cf871915f813$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $ec80cf871915f813$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $ec80cf871915f813$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


var $b2c2d9052192be80$var$initialState = {
    layoutType: 'horizontal',
    width: 0,
    height: 0,
    margin: {
        top: 5,
        right: 5,
        bottom: 5,
        left: 5
    },
    scale: 1
};
var $b2c2d9052192be80$var$chartLayoutSlice = (0, $ec80cf871915f813$export$4d8d9bd83c24ae8b)({
    name: 'chartLayout',
    initialState: $b2c2d9052192be80$var$initialState,
    reducers: {
        setLayout (state, action) {
            state.layoutType = action.payload;
        },
        setChartSize (state, action) {
            state.width = action.payload.width;
            state.height = action.payload.height;
        },
        setMargin (state, action) {
            var _action$payload$top, _action$payload$right, _action$payload$botto, _action$payload$left;
            state.margin.top = (_action$payload$top = action.payload.top) !== null && _action$payload$top !== void 0 ? _action$payload$top : 0;
            state.margin.right = (_action$payload$right = action.payload.right) !== null && _action$payload$right !== void 0 ? _action$payload$right : 0;
            state.margin.bottom = (_action$payload$botto = action.payload.bottom) !== null && _action$payload$botto !== void 0 ? _action$payload$botto : 0;
            state.margin.left = (_action$payload$left = action.payload.left) !== null && _action$payload$left !== void 0 ? _action$payload$left : 0;
        },
        setScale (state, action) {
            state.scale = action.payload;
        }
    }
});
var { setMargin: $b2c2d9052192be80$export$3f8f25b83912855f, setLayout: $b2c2d9052192be80$export$e8437af1f2483b8e, setChartSize: $b2c2d9052192be80$export$136b7feefeae481a, setScale: $b2c2d9052192be80$export$4dc523f7f9b3edd6 } = $b2c2d9052192be80$var$chartLayoutSlice.actions;
var $b2c2d9052192be80$export$701395c4acfabc85 = $b2c2d9052192be80$var$chartLayoutSlice.reducer;





var $783738f491029e54$export$1d27a9e667f67593 = (state)=>state.legend.settings;
var $783738f491029e54$export$c9c2b00a34f852e5 = (state)=>state.legend.size;
var $783738f491029e54$var$selectAllLegendPayload2DArray = (state)=>state.legend.payload;
var $783738f491029e54$export$9a6de64b691a7304 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $783738f491029e54$var$selectAllLegendPayload2DArray,
    $783738f491029e54$export$1d27a9e667f67593
], (payloads, _ref)=>{
    var { itemSorter: itemSorter } = _ref;
    var flat = payloads.flat(1);
    return itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($d179bd389fad45d8$exports)))(flat, itemSorter) : flat;
});



var $52905d0b62bb57b1$export$771ef0ac044f724d = (state)=>state.layout.width;
var $52905d0b62bb57b1$export$5856a7d94c109505 = (state)=>state.layout.height;
var $52905d0b62bb57b1$export$317b55dda5fb5617 = (state)=>state.layout.scale;
var $52905d0b62bb57b1$export$aa3aa1fbf76377f0 = (state)=>state.layout.margin;



var $407ef552851b9401$export$bd320344232f30af = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)((state)=>state.cartesianAxis.xAxis, (xAxisMap)=>{
    return Object.values(xAxisMap);
});
var $407ef552851b9401$export$e22adabb0128cf25 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)((state)=>state.cartesianAxis.yAxis, (yAxisMap)=>{
    return Object.values(yAxisMap);
});


var $3114cbf50b21aaf4$export$db34c3e22d611955 = [
    '#1890FF',
    '#66B5FF',
    '#41D9C7',
    '#2FC25B',
    '#6EDB8F',
    '#9AE65C',
    '#FACC14',
    '#E6965C',
    '#57AD71',
    '#223273',
    '#738AE6',
    '#7564CC',
    '#8543E0',
    '#A877ED',
    '#5C8EE6',
    '#13C2C2',
    '#70E0E0',
    '#5CA3E6',
    '#3436C7',
    '#8082FF',
    '#DD81E6',
    '#F04864',
    '#FA7D92',
    '#D598D9'
];
var $3114cbf50b21aaf4$export$c0f3d78d63b3e065 = 'data-recharts-item-index';
var $3114cbf50b21aaf4$export$5c80c48c1d137460 = 'data-recharts-item-id';
var $3114cbf50b21aaf4$export$fb6ee82c8ee2faf8 = 60;


function $4d79bfb805950901$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4d79bfb805950901$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4d79bfb805950901$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4d79bfb805950901$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4d79bfb805950901$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4d79bfb805950901$var$_defineProperty(e, r, t) {
    return (r = $4d79bfb805950901$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4d79bfb805950901$var$_toPropertyKey(t) {
    var i = $4d79bfb805950901$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4d79bfb805950901$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $4d79bfb805950901$export$2d0a7adecb2afc9c = (state)=>state.brush.height;
function $4d79bfb805950901$var$selectLeftAxesOffset(state) {
    var yAxes = (0, $407ef552851b9401$export$e22adabb0128cf25)(state);
    return yAxes.reduce((result, entry)=>{
        if (entry.orientation === 'left' && !entry.mirror && !entry.hide) {
            var width = typeof entry.width === 'number' ? entry.width : (0, $3114cbf50b21aaf4$export$fb6ee82c8ee2faf8);
            return result + width;
        }
        return result;
    }, 0);
}
function $4d79bfb805950901$var$selectRightAxesOffset(state) {
    var yAxes = (0, $407ef552851b9401$export$e22adabb0128cf25)(state);
    return yAxes.reduce((result, entry)=>{
        if (entry.orientation === 'right' && !entry.mirror && !entry.hide) {
            var width = typeof entry.width === 'number' ? entry.width : (0, $3114cbf50b21aaf4$export$fb6ee82c8ee2faf8);
            return result + width;
        }
        return result;
    }, 0);
}
function $4d79bfb805950901$var$selectTopAxesOffset(state) {
    var xAxes = (0, $407ef552851b9401$export$bd320344232f30af)(state);
    return xAxes.reduce((result, entry)=>{
        if (entry.orientation === 'top' && !entry.mirror && !entry.hide) return result + entry.height;
        return result;
    }, 0);
}
function $4d79bfb805950901$var$selectBottomAxesOffset(state) {
    var xAxes = (0, $407ef552851b9401$export$bd320344232f30af)(state);
    return xAxes.reduce((result, entry)=>{
        if (entry.orientation === 'bottom' && !entry.mirror && !entry.hide) return result + entry.height;
        return result;
    }, 0);
}
var $4d79bfb805950901$export$1e34c8efb0bc9b3b = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $52905d0b62bb57b1$export$771ef0ac044f724d),
    (0, $52905d0b62bb57b1$export$5856a7d94c109505),
    (0, $52905d0b62bb57b1$export$aa3aa1fbf76377f0),
    $4d79bfb805950901$export$2d0a7adecb2afc9c,
    $4d79bfb805950901$var$selectLeftAxesOffset,
    $4d79bfb805950901$var$selectRightAxesOffset,
    $4d79bfb805950901$var$selectTopAxesOffset,
    $4d79bfb805950901$var$selectBottomAxesOffset,
    (0, $783738f491029e54$export$1d27a9e667f67593),
    (0, $783738f491029e54$export$c9c2b00a34f852e5)
], (chartWidth, chartHeight, margin, brushHeight, leftAxesOffset, rightAxesOffset, topAxesOffset, bottomAxesOffset, legendSettings, legendSize)=>{
    var offsetH = {
        left: (margin.left || 0) + leftAxesOffset,
        right: (margin.right || 0) + rightAxesOffset
    };
    var offsetV = {
        top: (margin.top || 0) + topAxesOffset,
        bottom: (margin.bottom || 0) + bottomAxesOffset
    };
    var offset = $4d79bfb805950901$var$_objectSpread($4d79bfb805950901$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    offset.bottom += brushHeight;
    offset = (0, $912d8cf1d03ea507$export$3a657a8c9f789617)(offset, legendSettings, legendSize);
    var offsetWidth = chartWidth - offset.left - offset.right;
    var offsetHeight = chartHeight - offset.top - offset.bottom;
    return $4d79bfb805950901$var$_objectSpread($4d79bfb805950901$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
});
var $4d79bfb805950901$export$fb5e3eb7f8167ce7 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)($4d79bfb805950901$export$1e34c8efb0bc9b3b, (offset)=>({
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    }));
var $4d79bfb805950901$export$32c8e778bac69ce4 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)((0, $52905d0b62bb57b1$export$771ef0ac044f724d), (0, $52905d0b62bb57b1$export$5856a7d94c109505), (width, height)=>({
        x: 0,
        y: 0,
        width: width,
        height: height
    }));




var $28UcW = parcelRequire("28UcW");
var $d64615d5c7c4e07c$var$PanoramaContext = /*#__PURE__*/ (0, $28UcW.createContext)(null);
var $d64615d5c7c4e07c$export$4b0c59f8845ba920 = ()=>(0, $28UcW.useContext)($d64615d5c7c4e07c$var$PanoramaContext) != null;
var $d64615d5c7c4e07c$export$415fcedf1e191db0 = (_ref)=>{
    var { children: children } = _ref;
    return /*#__PURE__*/ $28UcW.createElement($d64615d5c7c4e07c$var$PanoramaContext.Provider, {
        value: true
    }, children);
};






var $fec5f39ba81f558d$export$5ba94b496f8dc52e = (state)=>state.brush;
var $fec5f39ba81f558d$export$3b81e97eae001823 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $fec5f39ba81f558d$export$5ba94b496f8dc52e,
    (0, $4d79bfb805950901$export$1e34c8efb0bc9b3b),
    (0, $52905d0b62bb57b1$export$aa3aa1fbf76377f0)
], (brushSettings, offset, margin)=>({
        height: brushSettings.height,
        x: (0, $9a1343d05dde836c$export$7e4aa119212bc614)(brushSettings.x) ? brushSettings.x : offset.left,
        y: (0, $9a1343d05dde836c$export$7e4aa119212bc614)(brushSettings.y) ? brushSettings.y : offset.top + offset.height + offset.brushBottom - ((margin === null || margin === void 0 ? void 0 : margin.bottom) || 0),
        width: (0, $9a1343d05dde836c$export$7e4aa119212bc614)(brushSettings.width) ? brushSettings.width : offset.width
    }));



var $dP0oo = parcelRequire("dP0oo");

var $28UcW = parcelRequire("28UcW");
var $be5898a552f38a82$exports = {};

$be5898a552f38a82$exports = (parcelRequire("f6ZVJ")).throttle;





var $de670c68f2a06f3e$export$83d33ab1950e2a9 = (containerWidth, containerHeight, props)=>{
    var { width: width = '100%', height: height = '100%', aspect: aspect, maxHeight: maxHeight } = props;
    /*
   * The containerWidth and containerHeight are already percentage based because it's set as that percentage in CSS.
   * Means we don't have to calculate percentages here.
   */ var calculatedWidth = (0, $9a1343d05dde836c$export$e50269385c77c348)(width) ? containerWidth : Number(width);
    var calculatedHeight = (0, $9a1343d05dde836c$export$e50269385c77c348)(height) ? containerHeight : Number(height);
    if (aspect && aspect > 0) {
        // Preserve the desired aspect ratio
        if (calculatedWidth) // Will default to using width for aspect ratio
        calculatedHeight = calculatedWidth / aspect;
        else if (calculatedHeight) // But we should also take height into consideration
        calculatedWidth = calculatedHeight * aspect;
        // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
        if (maxHeight && calculatedHeight != null && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
    }
    return {
        calculatedWidth: calculatedWidth,
        calculatedHeight: calculatedHeight
    };
};
var $de670c68f2a06f3e$var$bothOverflow = {
    width: 0,
    height: 0,
    overflow: 'visible'
};
var $de670c68f2a06f3e$var$overflowX = {
    width: 0,
    overflowX: 'visible'
};
var $de670c68f2a06f3e$var$overflowY = {
    height: 0,
    overflowY: 'visible'
};
var $de670c68f2a06f3e$var$noStyle = {};
var $de670c68f2a06f3e$export$d36bc8432d8d3f9d = (props)=>{
    var { width: width, height: height } = props;
    var isWidthPercent = (0, $9a1343d05dde836c$export$e50269385c77c348)(width);
    var isHeightPercent = (0, $9a1343d05dde836c$export$e50269385c77c348)(height);
    if (isWidthPercent && isHeightPercent) return $de670c68f2a06f3e$var$bothOverflow;
    if (isWidthPercent) return $de670c68f2a06f3e$var$overflowX;
    if (isHeightPercent) return $de670c68f2a06f3e$var$overflowY;
    return $de670c68f2a06f3e$var$noStyle;
};
function $de670c68f2a06f3e$export$f717eb32fd8d3af5(_ref) {
    var { width: width, height: height, aspect: aspect } = _ref;
    var calculatedWidth = width;
    var calculatedHeight = height;
    if (calculatedWidth === undefined && calculatedHeight === undefined) {
        calculatedWidth = '100%';
        calculatedHeight = '100%';
    } else if (calculatedWidth === undefined) calculatedWidth = aspect && aspect > 0 ? undefined : '100%';
    else if (calculatedHeight === undefined) calculatedHeight = aspect && aspect > 0 ? undefined : '100%';
    return {
        width: calculatedWidth,
        height: calculatedHeight
    };
}



function $fb5e151ecf96d720$var$_extends() {
    return $fb5e151ecf96d720$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fb5e151ecf96d720$var$_extends.apply(null, arguments);
}
function $fb5e151ecf96d720$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fb5e151ecf96d720$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fb5e151ecf96d720$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fb5e151ecf96d720$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fb5e151ecf96d720$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fb5e151ecf96d720$var$_defineProperty(e, r, t) {
    return (r = $fb5e151ecf96d720$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fb5e151ecf96d720$var$_toPropertyKey(t) {
    var i = $fb5e151ecf96d720$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fb5e151ecf96d720$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $fb5e151ecf96d720$var$ResponsiveContainerContext = /*#__PURE__*/ (0, $28UcW.createContext)({
    width: -1,
    height: -1
});
function $fb5e151ecf96d720$var$isAcceptableSize(size) {
    return (0, $11a93f8f3c3518e5$export$5374bb854d0e41c8)(size.width) && (0, $11a93f8f3c3518e5$export$5374bb854d0e41c8)(size.height);
}
function $fb5e151ecf96d720$var$ResponsiveContainerContextProvider(_ref) {
    var { children: children, width: width, height: height } = _ref;
    var size = (0, $28UcW.useMemo)(()=>({
            width: width,
            height: height
        }), [
        width,
        height
    ]);
    if (!$fb5e151ecf96d720$var$isAcceptableSize(size)) /*
     * Don't render the container if width or height is non-positive because
     * in that case the chart will not be rendered properly anyway.
     * We will instead wait for the next resize event to provide the correct dimensions.
     */ return null;
    return /*#__PURE__*/ $28UcW.createElement($fb5e151ecf96d720$var$ResponsiveContainerContext.Provider, {
        value: size
    }, children);
}
var $fb5e151ecf96d720$export$4ec9972d4f677af6 = ()=>(0, $28UcW.useContext)($fb5e151ecf96d720$var$ResponsiveContainerContext);
var $fb5e151ecf96d720$var$SizeDetectorContainer = /*#__PURE__*/ (0, $28UcW.forwardRef)((_ref2, ref)=>{
    var { aspect: aspect, initialDimension: initialDimension = {
        width: -1,
        height: -1
    }, width: width, height: height, minWidth: /*
     * default min-width to 0 if not specified - 'auto' causes issues with flexbox
     * https://github.com/recharts/recharts/issues/172
     */ minWidth = 0, minHeight: minHeight, maxHeight: maxHeight, children: children, debounce: debounce = 0, id: id, className: className, onResize: onResize, style: style = {} } = _ref2;
    var containerRef = (0, $28UcW.useRef)(null);
    /*
   * We are using a ref to avoid re-creating the ResizeObserver when the onResize function changes.
   * The ref is updated on every render, so the latest onResize function is always available in the effect.
   */ var onResizeRef = (0, $28UcW.useRef)();
    onResizeRef.current = onResize;
    (0, $28UcW.useImperativeHandle)(ref, ()=>containerRef.current);
    var [sizes, setSizes] = (0, $28UcW.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    });
    var setContainerSize = (0, $28UcW.useCallback)((newWidth, newHeight)=>{
        setSizes((prevState)=>{
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, $28UcW.useEffect)(()=>{
        if (containerRef.current == null || typeof ResizeObserver === 'undefined') return 0, $9a1343d05dde836c$export$8793edee2d425525;
        var callback = (entries)=>{
            var _onResizeRef$current;
            var { width: containerWidth, height: containerHeight } = entries[0].contentRect;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, (/*@__PURE__*/$parcel$interopDefault($be5898a552f38a82$exports)))(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var { width: containerWidth, height: containerHeight } = containerRef.current.getBoundingClientRect();
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var { containerWidth: containerWidth, containerHeight: containerHeight } = sizes;
    (0, $65baf459c02da39a$export$c106dd0671a0fc2d)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
    var { calculatedWidth: calculatedWidth, calculatedHeight: calculatedHeight } = (0, $de670c68f2a06f3e$export$83d33ab1950e2a9)(containerWidth, containerHeight, {
        width: width,
        height: height,
        aspect: aspect,
        maxHeight: maxHeight
    });
    (0, $65baf459c02da39a$export$c106dd0671a0fc2d)(calculatedWidth != null && calculatedWidth > 0 || calculatedHeight != null && calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
    return /*#__PURE__*/ $28UcW.createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, $dP0oo.clsx)('recharts-responsive-container', className),
        style: $fb5e151ecf96d720$var$_objectSpread($fb5e151ecf96d720$var$_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, /*#__PURE__*/ $28UcW.createElement("div", {
        style: (0, $de670c68f2a06f3e$export$d36bc8432d8d3f9d)({
            width: width,
            height: height
        })
    }, /*#__PURE__*/ $28UcW.createElement($fb5e151ecf96d720$var$ResponsiveContainerContextProvider, {
        width: calculatedWidth,
        height: calculatedHeight
    }, children)));
});
var $fb5e151ecf96d720$export$e60a4704009a0009 = /*#__PURE__*/ (0, $28UcW.forwardRef)((props, ref)=>{
    var responsiveContainerContext = $fb5e151ecf96d720$export$4ec9972d4f677af6();
    if ((0, $11a93f8f3c3518e5$export$5374bb854d0e41c8)(responsiveContainerContext.width) && (0, $11a93f8f3c3518e5$export$5374bb854d0e41c8)(responsiveContainerContext.height)) /*
     * If we detect that we are already inside another ResponsiveContainer,
     * we do not attempt to add another layer of responsiveness.
     */ return props.children;
    var { width: width, height: height } = (0, $de670c68f2a06f3e$export$f717eb32fd8d3af5)({
        width: props.width,
        height: props.height,
        aspect: props.aspect
    });
    /*
   * Let's try to get the calculated dimensions without having the div container set up.
   * Sometimes this does produce fixed, positive dimensions. If so, we can skip rendering the div and monitoring its size.
   */ var { calculatedWidth: calculatedWidth, calculatedHeight: calculatedHeight } = (0, $de670c68f2a06f3e$export$83d33ab1950e2a9)(undefined, undefined, {
        width: width,
        height: height,
        aspect: props.aspect,
        maxHeight: props.maxHeight
    });
    if ((0, $9a1343d05dde836c$export$7e4aa119212bc614)(calculatedWidth) && (0, $9a1343d05dde836c$export$7e4aa119212bc614)(calculatedHeight)) /*
     * If it just so happens that the combination of width, height, and aspect ratio
     * results in fixed dimensions, then we don't need to monitor the container's size.
     * We can just provide these fixed dimensions to the context.
     *
     * Note that here we are not checking for positive numbers;
     * if the user provides a zero or negative width/height, we will just pass that along
     * as whatever size we detect won't be helping anyway.
     */ return /*#__PURE__*/ $28UcW.createElement($fb5e151ecf96d720$var$ResponsiveContainerContextProvider, {
        width: calculatedWidth,
        height: calculatedHeight
    }, props.children);
    /*
   * Static analysis did not produce fixed dimensions,
   * so we need to render a special div and monitor its size.
   */ return /*#__PURE__*/ $28UcW.createElement($fb5e151ecf96d720$var$SizeDetectorContainer, $fb5e151ecf96d720$var$_extends({}, props, {
        width: width,
        height: height,
        ref: ref
    }));
});



function $6ade474fe9f2b6e0$export$94a03fc5d61f2504(box) {
    if (!box) return undefined;
    return {
        x: box.x,
        y: box.y,
        upperWidth: 'upperWidth' in box ? box.upperWidth : box.width,
        lowerWidth: 'lowerWidth' in box ? box.lowerWidth : box.width,
        width: box.width,
        height: box.height
    };
}
var $6ade474fe9f2b6e0$export$76b29bb074e0c45a = ()=>{
    var _useAppSelector;
    var panorama = (0, $d64615d5c7c4e07c$export$4b0c59f8845ba920)();
    var rootViewBox = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $4d79bfb805950901$export$fb5e3eb7f8167ce7));
    var brushDimensions = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $fec5f39ba81f558d$export$3b81e97eae001823));
    var brushPadding = (_useAppSelector = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $fec5f39ba81f558d$export$5ba94b496f8dc52e))) === null || _useAppSelector === void 0 ? void 0 : _useAppSelector.padding;
    if (!panorama || !brushDimensions || !brushPadding) return rootViewBox;
    return {
        width: brushDimensions.width - brushPadding.left - brushPadding.right,
        height: brushDimensions.height - brushPadding.top - brushPadding.bottom,
        x: brushPadding.left,
        y: brushPadding.top
    };
};
var $6ade474fe9f2b6e0$var$manyComponentsThrowErrorsIfOffsetIsUndefined = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0,
    brushBottom: 0
};
var $6ade474fe9f2b6e0$export$10605f61bef2858a = ()=>{
    var _useAppSelector2;
    return (_useAppSelector2 = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $4d79bfb805950901$export$1e34c8efb0bc9b3b))) !== null && _useAppSelector2 !== void 0 ? _useAppSelector2 : $6ade474fe9f2b6e0$var$manyComponentsThrowErrorsIfOffsetIsUndefined;
};
var $6ade474fe9f2b6e0$export$8854f7ece606854b = ()=>{
    return (0, $bf278eb346227770$export$a7347740d65f620b)((0, $52905d0b62bb57b1$export$771ef0ac044f724d));
};
var $6ade474fe9f2b6e0$export$369ae257969c6f9f = ()=>{
    return (0, $bf278eb346227770$export$a7347740d65f620b)((0, $52905d0b62bb57b1$export$5856a7d94c109505));
};
var $6ade474fe9f2b6e0$export$58ac794108fd8ca = ()=>{
    return (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>state.layout.margin);
};
var $6ade474fe9f2b6e0$export$8426b6d9af801dee = (state)=>state.layout.layoutType;
var $6ade474fe9f2b6e0$export$970c79ecc7081cc = ()=>(0, $bf278eb346227770$export$a7347740d65f620b)($6ade474fe9f2b6e0$export$8426b6d9af801dee);
var $6ade474fe9f2b6e0$export$c9942bdfc7f2781c = ()=>{
    var layout = $6ade474fe9f2b6e0$export$970c79ecc7081cc();
    if (layout === 'horizontal' || layout === 'vertical') return layout;
    return undefined;
};
var $6ade474fe9f2b6e0$export$a3faf3c7b8f19073 = ()=>{
    /*
   * All charts provide a layout type in the chart context.
   * If we have a layout type, we are in a chart context.
   */ var layout = $6ade474fe9f2b6e0$export$970c79ecc7081cc();
    return layout !== undefined;
};
var $6ade474fe9f2b6e0$export$80ea82e77fb424e1 = (props)=>{
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    /*
   * Skip dispatching properties in panorama chart for two reasons:
   * 1. The root chart should be deciding on these properties, and
   * 2. Brush reads these properties from redux store, and so they must remain stable
   *      to avoid circular dependency and infinite re-rendering.
   */ var isPanorama = (0, $d64615d5c7c4e07c$export$4b0c59f8845ba920)();
    var { width: widthFromProps, height: heightFromProps } = props;
    var responsiveContainerCalculations = (0, $fb5e151ecf96d720$export$4ec9972d4f677af6)();
    var width = widthFromProps;
    var height = heightFromProps;
    if (responsiveContainerCalculations) {
        /*
     * In case we receive width and height from ResponsiveContainer,
     * we will always prefer those.
     * Only in case ResponsiveContainer does not provide width or height,
     * we will fall back to the explicitly provided width and height.
     *
     * This to me feels backwards - we should allow override by the more specific props on individual charts, right?
     * But this is 3.x behaviour, so let's keep it for backwards compatibility.
     *
     * We can change this in 4.x if we want to.
     */ width = responsiveContainerCalculations.width > 0 ? responsiveContainerCalculations.width : widthFromProps;
        height = responsiveContainerCalculations.height > 0 ? responsiveContainerCalculations.height : heightFromProps;
    }
    (0, $28UcW.useEffect)(()=>{
        if (!isPanorama && (0, $11a93f8f3c3518e5$export$5374bb854d0e41c8)(width) && (0, $11a93f8f3c3518e5$export$5374bb854d0e41c8)(height)) dispatch((0, $b2c2d9052192be80$export$136b7feefeae481a)({
            width: width,
            height: height
        }));
    }, [
        dispatch,
        isPanorama,
        width,
        height
    ]);
    return null;
};
var $6ade474fe9f2b6e0$export$19a41f515e2a12ff = (_ref)=>{
    var { margin: margin } = _ref;
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    (0, $28UcW.useEffect)(()=>{
        dispatch((0, $b2c2d9052192be80$export$3f8f25b83912855f)(margin));
    }, [
        dispatch,
        margin
    ]);
    return null;
};








/**
 * A collection of all default zIndex values used throughout the library.
 */ var $45e92ad7df96f1e3$export$96df16b28aa32702 = {
    /**
   * CartesianGrid and PolarGrid
   */ grid: -100,
    /**
   * Background of Bar and RadialBar.
   * This is not visible by default but can be enabled by setting background={true} on Bar or RadialBar.
   */ barBackground: -50,
    /*
   * other chart elements or custom elements without specific zIndex
   * render in here, at zIndex 0
   */ /**
   * Area, Pie, Radar, and ReferenceArea
   */ area: 100,
    /**
   * Cursor is embedded inside Tooltip and controlled by it.
   * The Tooltip itself has a separate portal and is not included in the zIndex system;
   * Cursor is the decoration inside the chart area. CursorRectangle is a rectangle box.
   * It renders below bar so that in a stacked bar chart the cursor rectangle does not hide the other bars.
   */ cursorRectangle: 200,
    /**
   * Bar and RadialBar
   */ bar: 300,
    /**
   * Line and ReferenceLine, and ErrorBor
   */ line: 400,
    /**
   * XAxis and YAxis and PolarAngleAxis and PolarRadiusAxis ticks and lines and children
   */ axis: 500,
    /**
   * Scatter and ReferenceDot,
   * and Dots of Line and Area and Radar if they have dot=true
   */ scatter: 600,
    /**
   * Hovering over a Bar or RadialBar renders a highlight rectangle
   */ activeBar: 1000,
    /**
   * Cursor is embedded inside Tooltip and controlled by it.
   * The Tooltip itself has a separate portal and is not included in the zIndex system;
   * Cursor is the decoration inside the chart area, usually a cross or a box.
   * CursorLine is a line cursor rendered in Line, Area, Scatter, Radar charts.
   * It renders above the Line and Scatter so that it is always visible.
   * It renders below active dot so that the dot is always visible and shows the current point.
   * We're also assuming that the active dot is small enough that it does not fully cover the cursor line.
   *
   * This also applies to the radial cursor in RadialBarChart.
   */ cursorLine: 1100,
    /**
   * Hovering over a Point in Line, Area, Scatter, Radar renders a highlight dot
   */ activeDot: 1200,
    /**
   * LabelList and Label, including Axis labels
   */ label: 2000
};


var $a38a2f54d5ca28be$export$969183d9e860c26e = {
    allowDecimals: false,
    allowDuplicatedCategory: true,
    // if I set this to false then Tooltip synchronisation stops working in Radar, wtf
    angleAxisId: 0,
    axisLine: true,
    axisLineType: 'polygon',
    cx: 0,
    cy: 0,
    orientation: 'outer',
    reversed: false,
    scale: 'auto',
    tick: true,
    tickLine: true,
    tickSize: 8,
    type: 'category',
    zIndex: (0, $45e92ad7df96f1e3$export$96df16b28aa32702).axis
};



var $0fc0fea5336b1bd4$export$1a08e61551a7e57d = {
    allowDataOverflow: false,
    allowDecimals: false,
    allowDuplicatedCategory: true,
    angle: 0,
    axisLine: true,
    includeHidden: false,
    hide: false,
    label: false,
    orientation: 'right',
    radiusAxisId: 0,
    reversed: false,
    scale: 'auto',
    stroke: '#ccc',
    tick: true,
    tickCount: 5,
    type: 'number',
    zIndex: (0, $45e92ad7df96f1e3$export$96df16b28aa32702).axis
};


var $aa9bf5f7fc1905d1$export$3f7e30291950e694 = (axisSettings, axisRange)=>{
    if (!axisSettings || !axisRange) return undefined;
    if (axisSettings !== null && axisSettings !== void 0 && axisSettings.reversed) return [
        axisRange[1],
        axisRange[0]
    ];
    return axisRange;
};



var $fe99398211301319$export$7489bacc62c76b42 = {
    allowDataOverflow: false,
    allowDecimals: false,
    allowDuplicatedCategory: false,
    // defaultPolarAngleAxisProps.allowDuplicatedCategory has it set to true but the actual axis rendering ignores the prop because reasons,
    dataKey: undefined,
    domain: undefined,
    id: (0, $a38a2f54d5ca28be$export$969183d9e860c26e).angleAxisId,
    includeHidden: false,
    name: undefined,
    reversed: (0, $a38a2f54d5ca28be$export$969183d9e860c26e).reversed,
    scale: (0, $a38a2f54d5ca28be$export$969183d9e860c26e).scale,
    tick: (0, $a38a2f54d5ca28be$export$969183d9e860c26e).tick,
    tickCount: undefined,
    ticks: undefined,
    type: (0, $a38a2f54d5ca28be$export$969183d9e860c26e).type,
    unit: undefined
};
var $fe99398211301319$export$31037ebc9a4d24a3 = {
    allowDataOverflow: (0, $0fc0fea5336b1bd4$export$1a08e61551a7e57d).allowDataOverflow,
    allowDecimals: false,
    allowDuplicatedCategory: (0, $0fc0fea5336b1bd4$export$1a08e61551a7e57d).allowDuplicatedCategory,
    dataKey: undefined,
    domain: undefined,
    id: (0, $0fc0fea5336b1bd4$export$1a08e61551a7e57d).radiusAxisId,
    includeHidden: false,
    name: undefined,
    reversed: false,
    scale: (0, $0fc0fea5336b1bd4$export$1a08e61551a7e57d).scale,
    tick: (0, $0fc0fea5336b1bd4$export$1a08e61551a7e57d).tick,
    tickCount: (0, $0fc0fea5336b1bd4$export$1a08e61551a7e57d).tickCount,
    ticks: undefined,
    type: (0, $0fc0fea5336b1bd4$export$1a08e61551a7e57d).type,
    unit: undefined
};
var $fe99398211301319$export$12cefc54c06c7ceb = {
    allowDataOverflow: false,
    allowDecimals: false,
    allowDuplicatedCategory: (0, $a38a2f54d5ca28be$export$969183d9e860c26e).allowDuplicatedCategory,
    dataKey: undefined,
    domain: undefined,
    id: (0, $a38a2f54d5ca28be$export$969183d9e860c26e).angleAxisId,
    includeHidden: false,
    name: undefined,
    reversed: false,
    scale: (0, $a38a2f54d5ca28be$export$969183d9e860c26e).scale,
    tick: (0, $a38a2f54d5ca28be$export$969183d9e860c26e).tick,
    tickCount: undefined,
    ticks: undefined,
    type: 'number',
    unit: undefined
};
var $fe99398211301319$export$829f399331f9ec1b = {
    allowDataOverflow: (0, $0fc0fea5336b1bd4$export$1a08e61551a7e57d).allowDataOverflow,
    allowDecimals: false,
    allowDuplicatedCategory: (0, $0fc0fea5336b1bd4$export$1a08e61551a7e57d).allowDuplicatedCategory,
    dataKey: undefined,
    domain: undefined,
    id: (0, $0fc0fea5336b1bd4$export$1a08e61551a7e57d).radiusAxisId,
    includeHidden: false,
    name: undefined,
    reversed: false,
    scale: (0, $0fc0fea5336b1bd4$export$1a08e61551a7e57d).scale,
    tick: (0, $0fc0fea5336b1bd4$export$1a08e61551a7e57d).tick,
    tickCount: (0, $0fc0fea5336b1bd4$export$1a08e61551a7e57d).tickCount,
    ticks: undefined,
    type: 'category',
    unit: undefined
};
var $fe99398211301319$export$2d9ff7eb66def0da = (state, angleAxisId)=>{
    if (state.polarAxis.angleAxis[angleAxisId] != null) return state.polarAxis.angleAxis[angleAxisId];
    if (state.layout.layoutType === 'radial') return $fe99398211301319$export$12cefc54c06c7ceb;
    return $fe99398211301319$export$7489bacc62c76b42;
};
var $fe99398211301319$export$74b0499accddabe1 = (state, radiusAxisId)=>{
    if (state.polarAxis.radiusAxis[radiusAxisId] != null) return state.polarAxis.radiusAxis[radiusAxisId];
    if (state.layout.layoutType === 'radial') return $fe99398211301319$export$829f399331f9ec1b;
    return $fe99398211301319$export$31037ebc9a4d24a3;
};
var $fe99398211301319$export$a743f010244424e8 = (state)=>state.polarOptions;
var $fe99398211301319$export$53b653c1c5d6829b = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $52905d0b62bb57b1$export$771ef0ac044f724d),
    (0, $52905d0b62bb57b1$export$5856a7d94c109505),
    (0, $4d79bfb805950901$export$1e34c8efb0bc9b3b)
], (0, $d16c67d42be24ed1$export$ad5c48602371adfa));
var $fe99398211301319$var$selectInnerRadius = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $fe99398211301319$export$a743f010244424e8,
    $fe99398211301319$export$53b653c1c5d6829b
], (polarChartOptions, maxRadius)=>{
    if (polarChartOptions == null) return undefined;
    return (0, $9a1343d05dde836c$export$476354dbf49bdff6)(polarChartOptions.innerRadius, maxRadius, 0);
});
var $fe99398211301319$export$32a1ec2f6eaad494 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $fe99398211301319$export$a743f010244424e8,
    $fe99398211301319$export$53b653c1c5d6829b
], (polarChartOptions, maxRadius)=>{
    if (polarChartOptions == null) return undefined;
    return (0, $9a1343d05dde836c$export$476354dbf49bdff6)(polarChartOptions.outerRadius, maxRadius, maxRadius * 0.8);
});
var $fe99398211301319$var$combineAngleAxisRange = (polarOptions)=>{
    if (polarOptions == null) return [
        0,
        0
    ];
    var { startAngle: startAngle, endAngle: endAngle } = polarOptions;
    return [
        startAngle,
        endAngle
    ];
};
var $fe99398211301319$export$d00c8e94622c940 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $fe99398211301319$export$a743f010244424e8
], $fe99398211301319$var$combineAngleAxisRange);
var $fe99398211301319$export$15ccd32b0dd865d2 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $fe99398211301319$export$2d9ff7eb66def0da,
    $fe99398211301319$export$d00c8e94622c940
], (0, $aa9bf5f7fc1905d1$export$3f7e30291950e694));
var $fe99398211301319$export$e13d847e4d4f833f = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $fe99398211301319$export$53b653c1c5d6829b,
    $fe99398211301319$var$selectInnerRadius,
    $fe99398211301319$export$32a1ec2f6eaad494
], (maxRadius, innerRadius, outerRadius)=>{
    if (maxRadius == null || innerRadius == null || outerRadius == null) return undefined;
    return [
        innerRadius,
        outerRadius
    ];
});
var $fe99398211301319$export$2b324c38f06972bb = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $fe99398211301319$export$74b0499accddabe1,
    $fe99398211301319$export$e13d847e4d4f833f
], (0, $aa9bf5f7fc1905d1$export$3f7e30291950e694));
var $fe99398211301319$export$57f4101c1e20bd95 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    $fe99398211301319$export$a743f010244424e8,
    $fe99398211301319$var$selectInnerRadius,
    $fe99398211301319$export$32a1ec2f6eaad494,
    (0, $52905d0b62bb57b1$export$771ef0ac044f724d),
    (0, $52905d0b62bb57b1$export$5856a7d94c109505)
], (layout, polarOptions, innerRadius, outerRadius, width, height)=>{
    if (layout !== 'centric' && layout !== 'radial' || polarOptions == null || innerRadius == null || outerRadius == null) return undefined;
    var { cx: cx, cy: cy, startAngle: startAngle, endAngle: endAngle } = polarOptions;
    return {
        cx: (0, $9a1343d05dde836c$export$476354dbf49bdff6)(cx, width, width / 2),
        cy: (0, $9a1343d05dde836c$export$476354dbf49bdff6)(cy, height, height / 2),
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle,
        clockWise: false // this property look useful, why not use it?
    };
});





var $28UcW = parcelRequire("28UcW");




/**
 * Checks if two arrays are equal, treating empty arrays as equal regardless of reference.
 * If both arrays are non-empty, it checks for reference equality.
 * @param a
 * @param b
 */ function $20e12f99ca944083$export$dcc34c4213e7f4c(a, b) {
    if (Array.isArray(a) && Array.isArray(b) && a.length === 0 && b.length === 0) // empty arrays are always equal, regardless of reference
    return true;
    return a === b;
}
function $20e12f99ca944083$export$4f42c64323a69d96(a, b) {
    if (a.length === b.length) {
        for(var i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return false;
}



var $b8d26b5f9fa0ad58$export$30b3c9504f8bc181 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)((state)=>state.zIndex.zIndexMap, (_, zIndex)=>zIndex, (_, _zIndex, isPanorama)=>isPanorama, (zIndexMap, zIndex, isPanorama)=>{
    if (zIndex == null) return undefined;
    var entry = zIndexMap[zIndex];
    if (entry == null) return undefined;
    if (isPanorama) return entry.panoramaElement;
    return entry.element;
});
var $b8d26b5f9fa0ad58$export$7967bffce127e19c = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)((state)=>state.zIndex.zIndexMap, (zIndexMap)=>{
    var allNumbers = Object.keys(zIndexMap).map((zIndexStr)=>parseInt(zIndexStr, 10)).concat(Object.values((0, $45e92ad7df96f1e3$export$96df16b28aa32702)));
    var uniqueNumbers = Array.from(new Set(allNumbers));
    return uniqueNumbers.sort((a, b)=>a - b);
}, {
    memoizeOptions: {
        resultEqualityCheck: (0, $20e12f99ca944083$export$4f42c64323a69d96)
    }
});



var $46230e101f7bd5ae$var$__defProp = Object.defineProperty;
var $46230e101f7bd5ae$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $46230e101f7bd5ae$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $46230e101f7bd5ae$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $46230e101f7bd5ae$var$__defNormalProp = (obj, key, value)=>key in obj ? $46230e101f7bd5ae$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $46230e101f7bd5ae$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($46230e101f7bd5ae$var$__hasOwnProp.call(b, prop)) $46230e101f7bd5ae$var$__defNormalProp(a, prop, b[prop]);
    if ($46230e101f7bd5ae$var$__getOwnPropSymbols) {
        for (var prop of $46230e101f7bd5ae$var$__getOwnPropSymbols(b))if ($46230e101f7bd5ae$var$__propIsEnum.call(b, prop)) $46230e101f7bd5ae$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $46230e101f7bd5ae$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $46230e101f7bd5ae$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $46230e101f7bd5ae$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $46230e101f7bd5ae$var$errors = [];
function $46230e101f7bd5ae$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $46230e101f7bd5ae$var$getPrototypeOf = Object.getPrototypeOf;
function $46230e101f7bd5ae$export$541ac630993a4c84(value) {
    return !!value && !!value[$46230e101f7bd5ae$var$DRAFT_STATE];
}
function $46230e101f7bd5ae$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $46230e101f7bd5ae$var$isPlainObject(value) || Array.isArray(value) || !!value[$46230e101f7bd5ae$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$46230e101f7bd5ae$export$6ee2082928bcb0ee]) || $46230e101f7bd5ae$var$isMap(value) || $46230e101f7bd5ae$var$isSet(value);
}
var $46230e101f7bd5ae$var$objectCtorString = Object.prototype.constructor.toString();
var $46230e101f7bd5ae$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $46230e101f7bd5ae$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = Object.getPrototypeOf(value);
    if (proto === null || proto === Object.prototype) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    if (typeof Ctor !== "function") return false;
    let ctorString = $46230e101f7bd5ae$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $46230e101f7bd5ae$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $46230e101f7bd5ae$var$objectCtorString;
}
function $46230e101f7bd5ae$export$22e8af3f75a010e3(value) {
    if (!$46230e101f7bd5ae$export$541ac630993a4c84(value)) $46230e101f7bd5ae$var$die(15, value);
    return value[$46230e101f7bd5ae$var$DRAFT_STATE].base_;
}
function $46230e101f7bd5ae$var$each(obj, iter, strict = true) {
    if ($46230e101f7bd5ae$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : Object.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $46230e101f7bd5ae$var$getArchtype(thing) {
    const state = thing[$46230e101f7bd5ae$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $46230e101f7bd5ae$var$isMap(thing) ? 2 /* Map */  : $46230e101f7bd5ae$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $46230e101f7bd5ae$var$has(thing, prop) {
    return $46230e101f7bd5ae$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $46230e101f7bd5ae$var$get(thing, prop) {
    return $46230e101f7bd5ae$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $46230e101f7bd5ae$var$set(thing, propOrOldValue, value) {
    const t = $46230e101f7bd5ae$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $46230e101f7bd5ae$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $46230e101f7bd5ae$var$isMap(target) {
    return target instanceof Map;
}
function $46230e101f7bd5ae$var$isSet(target) {
    return target instanceof Set;
}
function $46230e101f7bd5ae$var$latest(state) {
    return state.copy_ || state.base_;
}
function $46230e101f7bd5ae$var$shallowCopy(base, strict) {
    if ($46230e101f7bd5ae$var$isMap(base)) return new Map(base);
    if ($46230e101f7bd5ae$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $46230e101f7bd5ae$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$46230e101f7bd5ae$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($46230e101f7bd5ae$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $46230e101f7bd5ae$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $46230e101f7bd5ae$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $46230e101f7bd5ae$export$792f3d81ea979f55(obj, deep = false) {
    if ($46230e101f7bd5ae$var$isFrozen(obj) || $46230e101f7bd5ae$export$541ac630993a4c84(obj) || !$46230e101f7bd5ae$export$16e3aed3edb85946(obj)) return obj;
    if ($46230e101f7bd5ae$var$getArchtype(obj) > 1) Object.defineProperties(obj, {
        set: $46230e101f7bd5ae$var$dontMutateMethodOverride,
        add: $46230e101f7bd5ae$var$dontMutateMethodOverride,
        clear: $46230e101f7bd5ae$var$dontMutateMethodOverride,
        delete: $46230e101f7bd5ae$var$dontMutateMethodOverride
    });
    Object.freeze(obj);
    if (deep) Object.values(obj).forEach((value)=>$46230e101f7bd5ae$export$792f3d81ea979f55(value, true));
    return obj;
}
function $46230e101f7bd5ae$var$dontMutateFrozenCollections() {
    $46230e101f7bd5ae$var$die(2);
}
var $46230e101f7bd5ae$var$dontMutateMethodOverride = {
    value: $46230e101f7bd5ae$var$dontMutateFrozenCollections
};
function $46230e101f7bd5ae$var$isFrozen(obj) {
    if (obj === null || typeof obj !== "object") return true;
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $46230e101f7bd5ae$var$plugins = {};
function $46230e101f7bd5ae$var$getPlugin(pluginKey) {
    const plugin = $46230e101f7bd5ae$var$plugins[pluginKey];
    if (!plugin) $46230e101f7bd5ae$var$die(0, pluginKey);
    return plugin;
}
function $46230e101f7bd5ae$var$loadPlugin(pluginKey, implementation) {
    if (!$46230e101f7bd5ae$var$plugins[pluginKey]) $46230e101f7bd5ae$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $46230e101f7bd5ae$var$currentScope;
function $46230e101f7bd5ae$var$getCurrentScope() {
    return $46230e101f7bd5ae$var$currentScope;
}
function $46230e101f7bd5ae$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $46230e101f7bd5ae$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $46230e101f7bd5ae$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $46230e101f7bd5ae$var$revokeScope(scope) {
    $46230e101f7bd5ae$var$leaveScope(scope);
    scope.drafts_.forEach($46230e101f7bd5ae$var$revokeDraft);
    scope.drafts_ = null;
}
function $46230e101f7bd5ae$var$leaveScope(scope) {
    if (scope === $46230e101f7bd5ae$var$currentScope) $46230e101f7bd5ae$var$currentScope = scope.parent_;
}
function $46230e101f7bd5ae$var$enterScope(immer2) {
    return $46230e101f7bd5ae$var$currentScope = $46230e101f7bd5ae$var$createScope($46230e101f7bd5ae$var$currentScope, immer2);
}
function $46230e101f7bd5ae$var$revokeDraft(draft) {
    const state = draft[$46230e101f7bd5ae$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $46230e101f7bd5ae$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$46230e101f7bd5ae$var$DRAFT_STATE].modified_) {
            $46230e101f7bd5ae$var$revokeScope(scope);
            $46230e101f7bd5ae$var$die(4);
        }
        if ($46230e101f7bd5ae$export$16e3aed3edb85946(result)) {
            result = $46230e101f7bd5ae$var$finalize(scope, result);
            if (!scope.parent_) $46230e101f7bd5ae$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $46230e101f7bd5ae$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$46230e101f7bd5ae$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $46230e101f7bd5ae$var$finalize(scope, baseDraft, []);
    $46230e101f7bd5ae$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $46230e101f7bd5ae$export$45b790e32b2810ee ? result : void 0;
}
function $46230e101f7bd5ae$var$finalize(rootScope, value, path) {
    if ($46230e101f7bd5ae$var$isFrozen(value)) return value;
    const useStrictIteration = rootScope.immer_.shouldUseStrictIteration();
    const state = value[$46230e101f7bd5ae$var$DRAFT_STATE];
    if (!state) {
        $46230e101f7bd5ae$var$each(value, (key, childValue)=>$46230e101f7bd5ae$var$finalizeProperty(rootScope, state, value, key, childValue, path), useStrictIteration);
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $46230e101f7bd5ae$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $46230e101f7bd5ae$var$each(resultEach, (key, childValue)=>$46230e101f7bd5ae$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2), useStrictIteration);
        $46230e101f7bd5ae$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $46230e101f7bd5ae$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $46230e101f7bd5ae$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (childValue == null) return;
    if (typeof childValue !== "object" && !targetIsSet) return;
    const childIsFrozen = $46230e101f7bd5ae$var$isFrozen(childValue);
    if (childIsFrozen && !targetIsSet) return;
    if ($46230e101f7bd5ae$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$46230e101f7bd5ae$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $46230e101f7bd5ae$var$finalize(rootScope, childValue, path);
        $46230e101f7bd5ae$var$set(targetObject, prop, res);
        if ($46230e101f7bd5ae$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($46230e101f7bd5ae$export$16e3aed3edb85946(childValue) && !childIsFrozen) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        if (parentState && parentState.base_ && parentState.base_[prop] === childValue && childIsFrozen) return;
        $46230e101f7bd5ae$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && ($46230e101f7bd5ae$var$isMap(targetObject) ? targetObject.has(prop) : Object.prototype.propertyIsEnumerable.call(targetObject, prop))) $46230e101f7bd5ae$var$maybeFreeze(rootScope, childValue);
    }
}
function $46230e101f7bd5ae$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $46230e101f7bd5ae$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $46230e101f7bd5ae$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $46230e101f7bd5ae$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $46230e101f7bd5ae$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $46230e101f7bd5ae$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $46230e101f7bd5ae$var$objectTraps = {
    get (state, prop) {
        if (prop === $46230e101f7bd5ae$var$DRAFT_STATE) return state;
        const source = $46230e101f7bd5ae$var$latest(state);
        if (!$46230e101f7bd5ae$var$has(source, prop)) return $46230e101f7bd5ae$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$46230e101f7bd5ae$export$16e3aed3edb85946(value)) return value;
        if (value === $46230e101f7bd5ae$var$peek(state.base_, prop)) {
            $46230e101f7bd5ae$var$prepareCopy(state);
            return state.copy_[prop] = $46230e101f7bd5ae$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $46230e101f7bd5ae$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($46230e101f7bd5ae$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $46230e101f7bd5ae$var$getDescriptorFromProto($46230e101f7bd5ae$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $46230e101f7bd5ae$var$peek($46230e101f7bd5ae$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$46230e101f7bd5ae$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($46230e101f7bd5ae$var$is(value, current2) && (value !== void 0 || $46230e101f7bd5ae$var$has(state.base_, prop))) return true;
            $46230e101f7bd5ae$var$prepareCopy(state);
            $46230e101f7bd5ae$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($46230e101f7bd5ae$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $46230e101f7bd5ae$var$prepareCopy(state);
            $46230e101f7bd5ae$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $46230e101f7bd5ae$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $46230e101f7bd5ae$var$die(11);
    },
    getPrototypeOf (state) {
        return $46230e101f7bd5ae$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $46230e101f7bd5ae$var$die(12);
    }
};
var $46230e101f7bd5ae$var$arrayTraps = {};
$46230e101f7bd5ae$var$each($46230e101f7bd5ae$var$objectTraps, (key, fn)=>{
    $46230e101f7bd5ae$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$46230e101f7bd5ae$var$arrayTraps.deleteProperty = function(state, prop) {
    return $46230e101f7bd5ae$var$arrayTraps.set.call(this, state, prop, void 0);
};
$46230e101f7bd5ae$var$arrayTraps.set = function(state, prop, value) {
    return $46230e101f7bd5ae$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $46230e101f7bd5ae$var$peek(draft, prop) {
    const state = draft[$46230e101f7bd5ae$var$DRAFT_STATE];
    const source = state ? $46230e101f7bd5ae$var$latest(state) : draft;
    return source[prop];
}
function $46230e101f7bd5ae$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $46230e101f7bd5ae$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $46230e101f7bd5ae$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $46230e101f7bd5ae$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $46230e101f7bd5ae$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $46230e101f7bd5ae$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $46230e101f7bd5ae$var$markChanged(state.parent_);
    }
}
function $46230e101f7bd5ae$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $46230e101f7bd5ae$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $46230e101f7bd5ae$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = true;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $46230e101f7bd5ae$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $46230e101f7bd5ae$var$die(7);
            let result;
            if ($46230e101f7bd5ae$export$16e3aed3edb85946(base)) {
                const scope = $46230e101f7bd5ae$var$enterScope(this);
                const proxy = $46230e101f7bd5ae$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $46230e101f7bd5ae$var$revokeScope(scope);
                    else $46230e101f7bd5ae$var$leaveScope(scope);
                }
                $46230e101f7bd5ae$var$usePatchesInScope(scope, patchListener);
                return $46230e101f7bd5ae$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $46230e101f7bd5ae$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $46230e101f7bd5ae$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $46230e101f7bd5ae$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $46230e101f7bd5ae$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if (typeof (config == null ? void 0 : config.useStrictIteration) === "boolean") this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$46230e101f7bd5ae$export$16e3aed3edb85946(base)) $46230e101f7bd5ae$var$die(8);
        if ($46230e101f7bd5ae$export$541ac630993a4c84(base)) base = $46230e101f7bd5ae$export$97aac956da55dae9(base);
        const scope = $46230e101f7bd5ae$var$enterScope(this);
        const proxy = $46230e101f7bd5ae$var$createProxy(base, void 0);
        proxy[$46230e101f7bd5ae$var$DRAFT_STATE].isManual_ = true;
        $46230e101f7bd5ae$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$46230e101f7bd5ae$var$DRAFT_STATE];
        if (!state || !state.isManual_) $46230e101f7bd5ae$var$die(9);
        const { scope_: scope } = state;
        $46230e101f7bd5ae$var$usePatchesInScope(scope, patchListener);
        return $46230e101f7bd5ae$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $46230e101f7bd5ae$var$getPlugin("Patches").applyPatches_;
        if ($46230e101f7bd5ae$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $46230e101f7bd5ae$var$createProxy(value, parent) {
    const draft = $46230e101f7bd5ae$var$isMap(value) ? $46230e101f7bd5ae$var$getPlugin("MapSet").proxyMap_(value, parent) : $46230e101f7bd5ae$var$isSet(value) ? $46230e101f7bd5ae$var$getPlugin("MapSet").proxySet_(value, parent) : $46230e101f7bd5ae$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $46230e101f7bd5ae$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $46230e101f7bd5ae$export$97aac956da55dae9(value) {
    if (!$46230e101f7bd5ae$export$541ac630993a4c84(value)) $46230e101f7bd5ae$var$die(10, value);
    return $46230e101f7bd5ae$var$currentImpl(value);
}
function $46230e101f7bd5ae$var$currentImpl(value) {
    if (!$46230e101f7bd5ae$export$16e3aed3edb85946(value) || $46230e101f7bd5ae$var$isFrozen(value)) return value;
    const state = value[$46230e101f7bd5ae$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $46230e101f7bd5ae$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $46230e101f7bd5ae$var$shallowCopy(value, true);
    $46230e101f7bd5ae$var$each(copy, (key, childValue)=>{
        $46230e101f7bd5ae$var$set(copy, key, $46230e101f7bd5ae$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $46230e101f7bd5ae$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $46230e101f7bd5ae$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $46230e101f7bd5ae$var$get(base_, key);
            const value = $46230e101f7bd5ae$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $46230e101f7bd5ae$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $46230e101f7bd5ae$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $46230e101f7bd5ae$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $46230e101f7bd5ae$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $46230e101f7bd5ae$var$die(errorOffset + 3);
                base = $46230e101f7bd5ae$var$get(base, p);
                if (typeof base !== "object") $46230e101f7bd5ae$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $46230e101f7bd5ae$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $46230e101f7bd5ae$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $46230e101f7bd5ae$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$46230e101f7bd5ae$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($46230e101f7bd5ae$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($46230e101f7bd5ae$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($46230e101f7bd5ae$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($46230e101f7bd5ae$var$has(obj, $46230e101f7bd5ae$export$6ee2082928bcb0ee)) cloned[$46230e101f7bd5ae$export$6ee2082928bcb0ee] = obj[$46230e101f7bd5ae$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($46230e101f7bd5ae$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $46230e101f7bd5ae$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $46230e101f7bd5ae$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$46230e101f7bd5ae$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $46230e101f7bd5ae$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $46230e101f7bd5ae$var$latest(this[$46230e101f7bd5ae$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $46230e101f7bd5ae$var$latest(this[$46230e101f7bd5ae$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$46230e101f7bd5ae$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$46230e101f7bd5ae$var$latest(state).has(key) || $46230e101f7bd5ae$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $46230e101f7bd5ae$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$46230e101f7bd5ae$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $46230e101f7bd5ae$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$46230e101f7bd5ae$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($46230e101f7bd5ae$var$latest(state).size) {
                prepareMapCopy(state);
                $46230e101f7bd5ae$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $46230e101f7bd5ae$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$46230e101f7bd5ae$var$DRAFT_STATE];
            $46230e101f7bd5ae$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$46230e101f7bd5ae$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $46230e101f7bd5ae$var$latest(state).get(key);
            if (state.finalized_ || !$46230e101f7bd5ae$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $46230e101f7bd5ae$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $46230e101f7bd5ae$var$latest(this[$46230e101f7bd5ae$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($46230e101f7bd5ae$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$46230e101f7bd5ae$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $46230e101f7bd5ae$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $46230e101f7bd5ae$var$latest(this[$46230e101f7bd5ae$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$46230e101f7bd5ae$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$46230e101f7bd5ae$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $46230e101f7bd5ae$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$46230e101f7bd5ae$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $46230e101f7bd5ae$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$46230e101f7bd5ae$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($46230e101f7bd5ae$var$latest(state).size) {
                prepareSetCopy(state);
                $46230e101f7bd5ae$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$46230e101f7bd5ae$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$46230e101f7bd5ae$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($46230e101f7bd5ae$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($46230e101f7bd5ae$export$16e3aed3edb85946(value)) {
                    const draft = $46230e101f7bd5ae$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $46230e101f7bd5ae$var$die(3, JSON.stringify($46230e101f7bd5ae$var$latest(state)));
    }
    $46230e101f7bd5ae$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $46230e101f7bd5ae$var$immer = new $46230e101f7bd5ae$export$aaadc6ff0f822719();
var $46230e101f7bd5ae$export$b46cabe22e78bc00 = $46230e101f7bd5ae$var$immer.produce;
var $46230e101f7bd5ae$export$4da66d41c9492c78 = /* @__PURE__ */ $46230e101f7bd5ae$var$immer.produceWithPatches.bind($46230e101f7bd5ae$var$immer);
var $46230e101f7bd5ae$export$573f26f60825c493 = /* @__PURE__ */ $46230e101f7bd5ae$var$immer.setAutoFreeze.bind($46230e101f7bd5ae$var$immer);
var $46230e101f7bd5ae$export$333ce65961cbe047 = /* @__PURE__ */ $46230e101f7bd5ae$var$immer.setUseStrictShallowCopy.bind($46230e101f7bd5ae$var$immer);
var $46230e101f7bd5ae$export$1045b3be3904c489 = /* @__PURE__ */ $46230e101f7bd5ae$var$immer.setUseStrictIteration.bind($46230e101f7bd5ae$var$immer);
var $46230e101f7bd5ae$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $46230e101f7bd5ae$var$immer.applyPatches.bind($46230e101f7bd5ae$var$immer);
var $46230e101f7bd5ae$export$3c3214997190395f = /* @__PURE__ */ $46230e101f7bd5ae$var$immer.createDraft.bind($46230e101f7bd5ae$var$immer);
var $46230e101f7bd5ae$export$c60f5e69c521b528 = /* @__PURE__ */ $46230e101f7bd5ae$var$immer.finishDraft.bind($46230e101f7bd5ae$var$immer);
function $46230e101f7bd5ae$export$c05b21e3257751e5(value) {
    return value;
}
function $46230e101f7bd5ae$export$20f911b3f8cf0b74(value) {
    return value;
}



function $f0a32278ca24a846$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f0a32278ca24a846$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f0a32278ca24a846$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f0a32278ca24a846$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f0a32278ca24a846$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f0a32278ca24a846$var$_defineProperty(e, r, t) {
    return (r = $f0a32278ca24a846$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f0a32278ca24a846$var$_toPropertyKey(t) {
    var i = $f0a32278ca24a846$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f0a32278ca24a846$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f0a32278ca24a846$var$seed = {};
var $f0a32278ca24a846$var$initialState = {
    zIndexMap: Object.values((0, $45e92ad7df96f1e3$export$96df16b28aa32702)).reduce((acc, current)=>$f0a32278ca24a846$var$_objectSpread($f0a32278ca24a846$var$_objectSpread({}, acc), {}, {
            [current]: {
                element: undefined,
                panoramaElement: undefined,
                consumers: 0
            }
        }), $f0a32278ca24a846$var$seed)
};
var $f0a32278ca24a846$var$defaultZIndexSet = new Set(Object.values((0, $45e92ad7df96f1e3$export$96df16b28aa32702)));
function $f0a32278ca24a846$var$isDefaultZIndex(zIndex) {
    return $f0a32278ca24a846$var$defaultZIndexSet.has(zIndex);
}
var $f0a32278ca24a846$var$zIndexSlice = (0, $ec80cf871915f813$export$4d8d9bd83c24ae8b)({
    name: 'zIndex',
    initialState: $f0a32278ca24a846$var$initialState,
    reducers: {
        registerZIndexPortal: {
            reducer: (state, action)=>{
                var { zIndex: zIndex } = action.payload;
                if (state.zIndexMap[zIndex]) state.zIndexMap[zIndex].consumers += 1;
                else state.zIndexMap[zIndex] = {
                    consumers: 1,
                    element: undefined,
                    panoramaElement: undefined
                };
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        unregisterZIndexPortal: {
            reducer: (state, action)=>{
                var { zIndex: zIndex } = action.payload;
                if (state.zIndexMap[zIndex]) {
                    state.zIndexMap[zIndex].consumers -= 1;
                    /*
           * Garbage collect unused z-index entries, except for default z-indexes.
           * Default z-indexes are always rendered, regardless of whether there are consumers or not.
           * And because of that, even if we delete this entry, the ZIndexPortal provider will still be rendered
           * and React is not going to re-create it, and it won't re-register the element ID.
           * So let's not delete default z-index entries.
           */ if (state.zIndexMap[zIndex].consumers <= 0 && !$f0a32278ca24a846$var$isDefaultZIndex(zIndex)) delete state.zIndexMap[zIndex];
                }
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        registerZIndexPortalElement: {
            reducer: (state, action)=>{
                var { zIndex: zIndex, element: element, isPanorama: isPanorama } = action.payload;
                if (state.zIndexMap[zIndex]) {
                    if (isPanorama) state.zIndexMap[zIndex].panoramaElement = (0, $46230e101f7bd5ae$export$c05b21e3257751e5)(element);
                    else state.zIndexMap[zIndex].element = (0, $46230e101f7bd5ae$export$c05b21e3257751e5)(element);
                } else state.zIndexMap[zIndex] = {
                    consumers: 0,
                    element: isPanorama ? undefined : (0, $46230e101f7bd5ae$export$c05b21e3257751e5)(element),
                    panoramaElement: isPanorama ? (0, $46230e101f7bd5ae$export$c05b21e3257751e5)(element) : undefined
                };
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        unregisterZIndexPortalElement: {
            reducer: (state, action)=>{
                var { zIndex: zIndex } = action.payload;
                if (state.zIndexMap[zIndex]) {
                    if (action.payload.isPanorama) state.zIndexMap[zIndex].panoramaElement = undefined;
                    else state.zIndexMap[zIndex].element = undefined;
                }
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        }
    }
});
var { registerZIndexPortal: $f0a32278ca24a846$export$8fe155db96cddace, unregisterZIndexPortal: $f0a32278ca24a846$export$230718bd38635ccb, registerZIndexPortalElement: $f0a32278ca24a846$export$2e6026208075bd4f, unregisterZIndexPortalElement: $f0a32278ca24a846$export$b735943939e8125 } = $f0a32278ca24a846$var$zIndexSlice.actions;
var $f0a32278ca24a846$export$a34096cdea3a022a = $f0a32278ca24a846$var$zIndexSlice.reducer;




function $3603bfc8e6eb9e37$export$b37befaf92aba9f1(_ref) {
    var { zIndex: zIndex, children: children } = _ref;
    /*
   * If we are outside of chart, then we can't rely on the zIndex portal state,
   * so we just render normally.
   */ var isInChartContext = (0, $6ade474fe9f2b6e0$export$a3faf3c7b8f19073)();
    /*
   * If zIndex is undefined then we render normally without portals.
   * Also, if zIndex is 0, we render normally without portals,
   * because 0 is the default layer that does not need a portal.
   */ var shouldRenderInPortal = isInChartContext && zIndex !== undefined && zIndex !== 0;
    var isPanorama = (0, $d64615d5c7c4e07c$export$4b0c59f8845ba920)();
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    (0, $28UcW.useLayoutEffect)(()=>{
        if (!shouldRenderInPortal) // Nothing to do. We have to call the hook because of the rules of hooks.
        return 0, $9a1343d05dde836c$export$8793edee2d425525;
        /*
     * Because zIndexes are dynamic (meaning, we're not working with a predefined set of layers,
     * but we allow users to define any zIndex at any time), we need to register
     * the requested zIndex in the global store. This way, the ZIndexPortals component
     * can render the corresponding portals and only the requested ones.
     */ dispatch((0, $f0a32278ca24a846$export$8fe155db96cddace)({
            zIndex: zIndex
        }));
        return ()=>{
            dispatch((0, $f0a32278ca24a846$export$230718bd38635ccb)({
                zIndex: zIndex
            }));
        };
    }, [
        dispatch,
        zIndex,
        shouldRenderInPortal
    ]);
    var portalElement = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $b8d26b5f9fa0ad58$export$30b3c9504f8bc181)(state, zIndex, isPanorama));
    if (!shouldRenderInPortal) // If no zIndex is provided or zIndex is 0, render normally without portals
    return children;
    if (!portalElement) /*
     * If we don't have a portal element yet, this means that the registration
     * has not been processed yet by the ZIndexPortals component.
     * So here we render null and wait for the next render cycle.
     */ return null;
    return /*#__PURE__*/ (0, $ac717a3ef8959bc0$exports.createPortal)(children, portalElement);
}



var $9290b2e14d5ce35d$var$_excluded = [
    "labelRef"
], $9290b2e14d5ce35d$var$_excluded2 = [
    "content"
];
function $9290b2e14d5ce35d$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $9290b2e14d5ce35d$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $9290b2e14d5ce35d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $9290b2e14d5ce35d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9290b2e14d5ce35d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9290b2e14d5ce35d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9290b2e14d5ce35d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9290b2e14d5ce35d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9290b2e14d5ce35d$var$_defineProperty(e, r, t) {
    return (r = $9290b2e14d5ce35d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9290b2e14d5ce35d$var$_toPropertyKey(t) {
    var i = $9290b2e14d5ce35d$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $9290b2e14d5ce35d$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9290b2e14d5ce35d$var$_extends() {
    return $9290b2e14d5ce35d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9290b2e14d5ce35d$var$_extends.apply(null, arguments);
}
/**
 * @inline
 */ /**
 * @inline
 */ /**
 * @inline
 */ var $9290b2e14d5ce35d$var$CartesianLabelContext = /*#__PURE__*/ (0, $28UcW.createContext)(null);
var $9290b2e14d5ce35d$export$3b4df77eaec10b03 = (_ref)=>{
    var { x: x, y: y, upperWidth: upperWidth, lowerWidth: lowerWidth, width: width, height: height, children: children } = _ref;
    var viewBox = (0, $28UcW.useMemo)(()=>({
            x: x,
            y: y,
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            width: width,
            height: height
        }), [
        x,
        y,
        upperWidth,
        lowerWidth,
        width,
        height
    ]);
    return /*#__PURE__*/ $28UcW.createElement($9290b2e14d5ce35d$var$CartesianLabelContext.Provider, {
        value: viewBox
    }, children);
};
var $9290b2e14d5ce35d$var$useCartesianLabelContext = ()=>{
    var labelChildContext = (0, $28UcW.useContext)($9290b2e14d5ce35d$var$CartesianLabelContext);
    var chartContext = (0, $6ade474fe9f2b6e0$export$76b29bb074e0c45a)();
    return labelChildContext || (0, $6ade474fe9f2b6e0$export$94a03fc5d61f2504)(chartContext);
};
var $9290b2e14d5ce35d$var$PolarLabelContext = /*#__PURE__*/ (0, $28UcW.createContext)(null);
var $9290b2e14d5ce35d$export$cd0d7ffccbd95e6d = (_ref2)=>{
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle, clockWise: clockWise, children: children } = _ref2;
    var viewBox = (0, $28UcW.useMemo)(()=>({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle,
            clockWise: clockWise
        }), [
        cx,
        cy,
        innerRadius,
        outerRadius,
        startAngle,
        endAngle,
        clockWise
    ]);
    return /*#__PURE__*/ $28UcW.createElement($9290b2e14d5ce35d$var$PolarLabelContext.Provider, {
        value: viewBox
    }, children);
};
var $9290b2e14d5ce35d$export$6f334acae8be4776 = ()=>{
    var labelChildContext = (0, $28UcW.useContext)($9290b2e14d5ce35d$var$PolarLabelContext);
    var chartContext = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $fe99398211301319$export$57f4101c1e20bd95));
    return labelChildContext || chartContext;
};
var $9290b2e14d5ce35d$var$getLabel = (props)=>{
    var { value: value, formatter: formatter } = props;
    var label = (0, $9a1343d05dde836c$export$b931b78cbb3caf86)(props.children) ? value : props.children;
    if (typeof formatter === 'function') return formatter(label);
    return label;
};
var $9290b2e14d5ce35d$export$96a48941c06f377f = (content)=>{
    return content != null && typeof content === 'function';
};
var $9290b2e14d5ce35d$var$getDeltaAngle = (startAngle, endAngle)=>{
    var sign = (0, $9a1343d05dde836c$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $9290b2e14d5ce35d$var$renderRadialLabel = (labelProps, position, label, attrs, viewBox)=>{
    var { offset: offset, className: className } = labelProps;
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle, clockWise: clockWise } = viewBox;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $9290b2e14d5ce35d$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    switch(position){
        case 'insideStart':
            labelAngle = startAngle + sign * offset;
            direction = clockWise;
            break;
        case 'insideEnd':
            labelAngle = endAngle - sign * offset;
            direction = !clockWise;
            break;
        case 'end':
            labelAngle = endAngle + sign * offset;
            direction = clockWise;
            break;
        default:
            throw new Error("Unsupported position ".concat(position));
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $d16c67d42be24ed1$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $d16c67d42be24ed1$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, $9a1343d05dde836c$export$b931b78cbb3caf86)(labelProps.id) ? (0, $9a1343d05dde836c$export$8b15d37bc3f197d4)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ $28UcW.createElement("text", $9290b2e14d5ce35d$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, $dP0oo.clsx)('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ $28UcW.createElement("defs", null, /*#__PURE__*/ $28UcW.createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ $28UcW.createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $9290b2e14d5ce35d$var$getAttrsOfPolarLabel = (viewBox, offset, position)=>{
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle } = viewBox;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var { x: _x, y: _y } = (0, $d16c67d42be24ed1$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle);
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var { x: x, y: y } = (0, $d16c67d42be24ed1$export$5c9a959bb3fc7749)(cx, cy, r, midAngle);
    return {
        x: x,
        y: y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var $9290b2e14d5ce35d$var$isPolar = (viewBox)=>'cx' in viewBox && (0, $9a1343d05dde836c$export$7e4aa119212bc614)(viewBox.cx);
var $9290b2e14d5ce35d$export$41428aa60b2f4ad6 = (props, viewBox)=>{
    var { parentViewBox: parentViewBoxFromProps, offset: offset, position: position } = props;
    var parentViewBox;
    if (parentViewBoxFromProps != null && !$9290b2e14d5ce35d$var$isPolar(parentViewBoxFromProps)) // Check that nobody is trying to pass a polar viewBox to a cartesian label
    parentViewBox = parentViewBoxFromProps;
    var { x: x, y: y, upperWidth: upperWidth, lowerWidth: lowerWidth, height: height } = viewBox;
    // Funnel.tsx provides a viewBox where `x` is the top-left of the trapezoid shape.
    var upperX = x;
    // The trapezoid is centered, so we can calculate the other corners from the top-left.
    var lowerX = x + (upperWidth - lowerWidth) / 2;
    // middleX is the x-coordinate of the left edge at the vertical midpoint of the trapezoid.
    var middleX = (upperX + lowerX) / 2;
    // The width of the trapezoid at its vertical midpoint.
    var midHeightWidth = (upperWidth + lowerWidth) / 2;
    // The center x-coordinate is constant for the entire height of the trapezoid.
    var centerX = upperX + upperWidth / 2;
    // Define vertical offsets and position inverts based on the value being positive or negative.
    // This allows labels to be positioned correctly for bars with negative height.
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative.
    // This allows labels to be positioned correctly for bars with negative width.
    var horizontalSign = upperWidth >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    if (position === 'top') {
        var attrs = {
            x: upperX + upperWidth / 2,
            y: y - verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        return $9290b2e14d5ce35d$var$_objectSpread($9290b2e14d5ce35d$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: upperWidth
        } : {});
    }
    if (position === 'bottom') {
        var _attrs = {
            x: lowerX + lowerWidth / 2,
            y: y + height + verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        return $9290b2e14d5ce35d$var$_objectSpread($9290b2e14d5ce35d$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: lowerWidth
        } : {});
    }
    if (position === 'left') {
        var _attrs2 = {
            x: middleX - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        return $9290b2e14d5ce35d$var$_objectSpread($9290b2e14d5ce35d$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === 'right') {
        var _attrs3 = {
            x: middleX + midHeightWidth + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        return $9290b2e14d5ce35d$var$_objectSpread($9290b2e14d5ce35d$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: midHeightWidth,
        height: height
    } : {};
    if (position === 'insideLeft') return $9290b2e14d5ce35d$var$_objectSpread({
        x: middleX + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return $9290b2e14d5ce35d$var$_objectSpread({
        x: middleX + midHeightWidth - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return $9290b2e14d5ce35d$var$_objectSpread({
        x: upperX + upperWidth / 2,
        y: y + verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return $9290b2e14d5ce35d$var$_objectSpread({
        x: lowerX + lowerWidth / 2,
        y: y + height - verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return $9290b2e14d5ce35d$var$_objectSpread({
        x: upperX + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return $9290b2e14d5ce35d$var$_objectSpread({
        x: upperX + upperWidth - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return $9290b2e14d5ce35d$var$_objectSpread({
        x: lowerX + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return $9290b2e14d5ce35d$var$_objectSpread({
        x: lowerX + lowerWidth - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (!!position && typeof position === 'object' && ((0, $9a1343d05dde836c$export$7e4aa119212bc614)(position.x) || (0, $9a1343d05dde836c$export$e50269385c77c348)(position.x)) && ((0, $9a1343d05dde836c$export$7e4aa119212bc614)(position.y) || (0, $9a1343d05dde836c$export$e50269385c77c348)(position.y))) // TODO: This is not quite right. The width of the trapezoid changes with y.
    // A percentage-based x should be relative to the width at that y.
    // For now, we use the mid-height width as a reasonable approximation.
    return $9290b2e14d5ce35d$var$_objectSpread({
        x: x + (0, $9a1343d05dde836c$export$476354dbf49bdff6)(position.x, midHeightWidth),
        y: y + (0, $9a1343d05dde836c$export$476354dbf49bdff6)(position.y, height),
        textAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return $9290b2e14d5ce35d$var$_objectSpread({
        x: centerX,
        y: y + height / 2,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};
var $9290b2e14d5ce35d$export$b1c389a57ef19225 = {
    angle: 0,
    offset: 5,
    zIndex: (0, $45e92ad7df96f1e3$export$96df16b28aa32702).label,
    position: 'middle',
    textBreakAll: false
};
function $9290b2e14d5ce35d$export$b04be29aa201d4f5(outerProps) {
    var props = (0, $2db4b31e06a7a91b$export$45004cc70a390ee8)(outerProps, $9290b2e14d5ce35d$export$b1c389a57ef19225);
    var { viewBox: viewBoxFromProps, position: position, value: value, children: children, content: content, className: className = '', textBreakAll: textBreakAll, labelRef: labelRef } = props;
    var polarViewBox = $9290b2e14d5ce35d$export$6f334acae8be4776();
    var cartesianViewBox = $9290b2e14d5ce35d$var$useCartesianLabelContext();
    /*
   * I am not proud about this solution, but it's a quick fix for https://github.com/recharts/recharts/issues/6030#issuecomment-3155352460.
   * What we should really do is split Label into two components: CartesianLabel and PolarLabel and then handle their respective viewBoxes separately.
   * Also other components should set its own viewBox in a context so that we can fix https://github.com/recharts/recharts/issues/6156
   */ var resolvedViewBox = position === 'center' ? cartesianViewBox : polarViewBox !== null && polarViewBox !== void 0 ? polarViewBox : cartesianViewBox;
    var viewBox, label, positionAttrs;
    if (viewBoxFromProps == null) viewBox = resolvedViewBox;
    else if ($9290b2e14d5ce35d$var$isPolar(viewBoxFromProps)) viewBox = viewBoxFromProps;
    else viewBox = (0, $6ade474fe9f2b6e0$export$94a03fc5d61f2504)(viewBoxFromProps);
    if (!viewBox || (0, $9a1343d05dde836c$export$b931b78cbb3caf86)(value) && (0, $9a1343d05dde836c$export$b931b78cbb3caf86)(children) && !/*#__PURE__*/ (0, $28UcW.isValidElement)(content) && typeof content !== 'function') return null;
    var propsWithViewBox = $9290b2e14d5ce35d$var$_objectSpread($9290b2e14d5ce35d$var$_objectSpread({}, props), {}, {
        viewBox: viewBox
    });
    if (/*#__PURE__*/ (0, $28UcW.isValidElement)(content)) {
        var { labelRef: _ } = propsWithViewBox, propsWithoutLabelRef = $9290b2e14d5ce35d$var$_objectWithoutProperties(propsWithViewBox, $9290b2e14d5ce35d$var$_excluded);
        return /*#__PURE__*/ (0, $28UcW.cloneElement)(content, propsWithoutLabelRef);
    }
    if (typeof content === 'function') {
        var { content: _2 } = propsWithViewBox, propsForContent = $9290b2e14d5ce35d$var$_objectWithoutProperties(propsWithViewBox, $9290b2e14d5ce35d$var$_excluded2);
        // @ts-expect-error we're not checking if the content component returns something that Text is able to render
        label = /*#__PURE__*/ (0, $28UcW.createElement)(content, propsForContent);
        if (/*#__PURE__*/ (0, $28UcW.isValidElement)(label)) return label;
    } else label = $9290b2e14d5ce35d$var$getLabel(props);
    var attrs = (0, $1412060bc6e2b8b4$export$67f8fc03e57e2747)(props);
    if ($9290b2e14d5ce35d$var$isPolar(viewBox)) {
        if (position === 'insideStart' || position === 'insideEnd' || position === 'end') return $9290b2e14d5ce35d$var$renderRadialLabel(props, position, label, attrs, viewBox);
        positionAttrs = $9290b2e14d5ce35d$var$getAttrsOfPolarLabel(viewBox, props.offset, props.position);
    } else positionAttrs = $9290b2e14d5ce35d$export$41428aa60b2f4ad6(props, viewBox);
    return /*#__PURE__*/ $28UcW.createElement((0, $3603bfc8e6eb9e37$export$b37befaf92aba9f1), {
        zIndex: props.zIndex
    }, /*#__PURE__*/ $28UcW.createElement((0, $e6266b2db237d3de$export$5f1af8db9871e1d6), $9290b2e14d5ce35d$var$_extends({
        ref: labelRef,
        className: (0, $dP0oo.clsx)('recharts-label', className)
    }, attrs, positionAttrs, {
        /*
     * textAnchor is decided by default based on the `position`
     * but we allow overriding via props for precise control.
     */ textAnchor: (0, $e6266b2db237d3de$export$ae5e6c08954aa63c)(attrs.textAnchor) ? attrs.textAnchor : positionAttrs.textAnchor,
        breakAll: textBreakAll
    }), label));
}
$9290b2e14d5ce35d$export$b04be29aa201d4f5.displayName = 'Label';
var $9290b2e14d5ce35d$var$parseLabel = (label, viewBox, labelRef)=>{
    if (!label) return null;
    var commonProps = {
        viewBox: viewBox,
        labelRef: labelRef
    };
    if (label === true) return /*#__PURE__*/ $28UcW.createElement($9290b2e14d5ce35d$export$b04be29aa201d4f5, $9290b2e14d5ce35d$var$_extends({
        key: "label-implicit"
    }, commonProps));
    if ((0, $9a1343d05dde836c$export$402a499e1ea44294)(label)) return /*#__PURE__*/ $28UcW.createElement($9290b2e14d5ce35d$export$b04be29aa201d4f5, $9290b2e14d5ce35d$var$_extends({
        key: "label-implicit",
        value: label
    }, commonProps));
    if (/*#__PURE__*/ (0, $28UcW.isValidElement)(label)) {
        if (label.type === $9290b2e14d5ce35d$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $28UcW.cloneElement)(label, $9290b2e14d5ce35d$var$_objectSpread({
            key: 'label-implicit'
        }, commonProps));
        return /*#__PURE__*/ $28UcW.createElement($9290b2e14d5ce35d$export$b04be29aa201d4f5, $9290b2e14d5ce35d$var$_extends({
            key: "label-implicit",
            content: label
        }, commonProps));
    }
    if ($9290b2e14d5ce35d$export$96a48941c06f377f(label)) return /*#__PURE__*/ $28UcW.createElement($9290b2e14d5ce35d$export$b04be29aa201d4f5, $9290b2e14d5ce35d$var$_extends({
        key: "label-implicit",
        content: label
    }, commonProps));
    if (label && typeof label === 'object') return /*#__PURE__*/ $28UcW.createElement($9290b2e14d5ce35d$export$b04be29aa201d4f5, $9290b2e14d5ce35d$var$_extends({}, label, {
        key: "label-implicit"
    }, commonProps));
    return null;
};
function $9290b2e14d5ce35d$export$3c82c3a3704539d8(_ref3) {
    var { label: label, labelRef: labelRef } = _ref3;
    var viewBox = $9290b2e14d5ce35d$var$useCartesianLabelContext();
    return $9290b2e14d5ce35d$var$parseLabel(label, viewBox, labelRef) || null;
}
function $9290b2e14d5ce35d$export$24b42d9a68417c83(_ref4) {
    var { label: label } = _ref4;
    var viewBox = $9290b2e14d5ce35d$export$6f334acae8be4776();
    return $9290b2e14d5ce35d$var$parseLabel(label, viewBox) || null;
}




var $28UcW = parcelRequire("28UcW");

var $4009b9153cff02e8$export$b8cdb4ab1d25db49 = (c)=>{
    return 'radius' in c && 'startAngle' in c && 'endAngle' in c;
};
var $4009b9153cff02e8$export$7c4c290a4a9c1b1e = (props, newHandler)=>{
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $28UcW.isValidElement)(props)) inputProps = props.props;
    if (typeof inputProps !== 'object' && typeof inputProps !== 'function') return null;
    var out = {};
    Object.keys(inputProps).forEach((key)=>{
        if ((0, $18ca78634dfdfe1f$export$7d045284457d8577)(key)) out[key] = newHandler || ((e)=>inputProps[key](inputProps, e));
    });
    return out;
};
var $4009b9153cff02e8$var$getEventHandlerOfChild = (originalHandler, data, index)=>(e)=>{
        originalHandler(data, index, e);
        return null;
    };
var $4009b9153cff02e8$export$ca62be0d67a3158c = (props, data, index)=>{
    if (props === null || typeof props !== 'object' && typeof props !== 'function') return null;
    var out = null;
    Object.keys(props).forEach((key)=>{
        var item = props[key];
        if ((0, $18ca78634dfdfe1f$export$7d045284457d8577)(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = $4009b9153cff02e8$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};
var $4009b9153cff02e8$export$d307f5934e447d0e = (arr)=>{
    return Array.isArray(arr) && arr.length > 0;
};




/**
 * Calculates the width of the Y-axis based on the tick labels and the axis label.
 * @param params - The parameters object.
 * @param [params.ticks] - An array-like object of tick elements, each with a `getBoundingClientRect` method.
 * @param [params.label] - The axis label element, with a `getBoundingClientRect` method.
 * @param [params.labelGapWithTick=5] - The gap between the label and the tick.
 * @param [params.tickSize=0] - The length of the tick line.
 * @param [params.tickMargin=0] - The margin between the tick line and the tick text.
 * @returns The calculated width of the Y-axis.
 */ var $33210867991f4a62$export$b70f70a4fdbed242 = (_ref)=>{
    var { ticks: ticks, label: label, labelGapWithTick: labelGapWithTick = 5, tickSize: // Default gap between label and tick
    tickSize = 0, tickMargin: tickMargin = 0 } = _ref;
    // find the max width of the tick labels
    var maxTickWidth = 0;
    if (ticks) {
        Array.from(ticks).forEach((tickNode)=>{
            if (tickNode) {
                var bbox = tickNode.getBoundingClientRect();
                if (bbox.width > maxTickWidth) maxTickWidth = bbox.width;
            }
        });
        // calculate width of the axis label
        var labelWidth = label ? label.getBoundingClientRect().width : 0;
        var tickWidth = tickSize + tickMargin;
        // calculate the updated width of the y-axis
        var updatedYAxisWidth = maxTickWidth + tickWidth + labelWidth + (label ? labelGapWithTick : 0);
        return Math.round(updatedYAxisWidth);
    }
    return 0;
};





var $c8f4efe43d81a1a3$var$_excluded = [
    "axisLine",
    "width",
    "height",
    "className",
    "hide",
    "ticks",
    "axisType"
];
function $c8f4efe43d81a1a3$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c8f4efe43d81a1a3$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $c8f4efe43d81a1a3$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $c8f4efe43d81a1a3$var$_extends() {
    return $c8f4efe43d81a1a3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c8f4efe43d81a1a3$var$_extends.apply(null, arguments);
}
function $c8f4efe43d81a1a3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c8f4efe43d81a1a3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c8f4efe43d81a1a3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c8f4efe43d81a1a3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c8f4efe43d81a1a3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c8f4efe43d81a1a3$var$_defineProperty(e, r, t) {
    return (r = $c8f4efe43d81a1a3$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c8f4efe43d81a1a3$var$_toPropertyKey(t) {
    var i = $c8f4efe43d81a1a3$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c8f4efe43d81a1a3$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $c8f4efe43d81a1a3$export$179c35154a9748c0 = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd',
    zIndex: (0, $45e92ad7df96f1e3$export$96df16b28aa32702).axis
};
/*
 * `viewBox` and `scale` are SVG attributes.
 * Recharts however - unfortunately - has its own attributes named `viewBox` and `scale`
 * that are completely different data shape and different purpose.
 */ function $c8f4efe43d81a1a3$var$AxisLine(axisLineProps) {
    var { x: x, y: y, width: width, height: height, orientation: orientation, mirror: mirror, axisLine: axisLine, otherSvgProps: otherSvgProps } = axisLineProps;
    if (!axisLine) return null;
    var props = $c8f4efe43d81a1a3$var$_objectSpread($c8f4efe43d81a1a3$var$_objectSpread($c8f4efe43d81a1a3$var$_objectSpread({}, otherSvgProps), (0, $3d820e26962aea02$export$8b56257912140094)(axisLine)), {}, {
        fill: 'none'
    });
    if (orientation === 'top' || orientation === 'bottom') {
        var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
        props = $c8f4efe43d81a1a3$var$_objectSpread($c8f4efe43d81a1a3$var$_objectSpread({}, props), {}, {
            x1: x,
            y1: y + needHeight * height,
            x2: x + width,
            y2: y + needHeight * height
        });
    } else {
        var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
        props = $c8f4efe43d81a1a3$var$_objectSpread($c8f4efe43d81a1a3$var$_objectSpread({}, props), {}, {
            x1: x + needWidth * width,
            y1: y,
            x2: x + needWidth * width,
            y2: y + height
        });
    }
    return /*#__PURE__*/ $28UcW.createElement("line", $c8f4efe43d81a1a3$var$_extends({}, props, {
        className: (0, $dP0oo.clsx)('recharts-cartesian-axis-line', (0, (/*@__PURE__*/$parcel$interopDefault($2c84e5b844764211$exports)))(axisLine, 'className'))
    }));
}
/**
 * Calculate the coordinates of endpoints in ticks.
 * @param data The data of a simple tick.
 * @param x The x-coordinate of the axis.
 * @param y The y-coordinate of the axis.
 * @param width The width of the axis.
 * @param height The height of the axis.
 * @param orientation The orientation of the axis.
 * @param tickSize The length of the tick line.
 * @param mirror If true, the ticks are mirrored.
 * @param tickMargin The margin between the tick line and the tick text.
 * @returns An object with `line` and `tick` coordinates.
 * `line` is the coordinates for the tick line, and `tick` is the coordinate for the tick text.
 */ function $c8f4efe43d81a1a3$var$getTickLineCoord(data, x, y, width, height, orientation, tickSize, mirror, tickMargin) {
    var x1, x2, y1, y2, tx, ty;
    var sign = mirror ? -1 : 1;
    var finalTickSize = data.tickSize || tickSize;
    var tickCoord = (0, $9a1343d05dde836c$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
    switch(orientation){
        case 'top':
            x1 = x2 = data.coordinate;
            y2 = y + +!mirror * height;
            y1 = y2 - sign * finalTickSize;
            ty = y1 - sign * tickMargin;
            tx = tickCoord;
            break;
        case 'left':
            y1 = y2 = data.coordinate;
            x2 = x + +!mirror * width;
            x1 = x2 - sign * finalTickSize;
            tx = x1 - sign * tickMargin;
            ty = tickCoord;
            break;
        case 'right':
            y1 = y2 = data.coordinate;
            x2 = x + +mirror * width;
            x1 = x2 + sign * finalTickSize;
            tx = x1 + sign * tickMargin;
            ty = tickCoord;
            break;
        default:
            x1 = x2 = data.coordinate;
            y2 = y + +mirror * height;
            y1 = y2 + sign * finalTickSize;
            ty = y1 + sign * tickMargin;
            tx = tickCoord;
            break;
    }
    return {
        line: {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
        },
        tick: {
            x: tx,
            y: ty
        }
    };
}
/**
 * @param orientation The orientation of the axis.
 * @param mirror If true, the ticks are mirrored.
 * @returns The text anchor of the tick.
 */ function $c8f4efe43d81a1a3$var$getTickTextAnchor(orientation, mirror) {
    switch(orientation){
        case 'left':
            return mirror ? 'start' : 'end';
        case 'right':
            return mirror ? 'end' : 'start';
        default:
            return 'middle';
    }
}
/**
 * @param orientation The orientation of the axis.
 * @param mirror If true, the ticks are mirrored.
 * @returns The vertical text anchor of the tick.
 */ function $c8f4efe43d81a1a3$var$getTickVerticalAnchor(orientation, mirror) {
    switch(orientation){
        case 'left':
        case 'right':
            return 'middle';
        case 'top':
            return mirror ? 'start' : 'end';
        default:
            return mirror ? 'end' : 'start';
    }
}
function $c8f4efe43d81a1a3$var$TickItem(props) {
    var { option: option, tickProps: tickProps, value: value } = props;
    var tickItem;
    var combinedClassName = (0, $dP0oo.clsx)(tickProps.className, 'recharts-cartesian-axis-tick-value');
    if (/*#__PURE__*/ $28UcW.isValidElement(option)) // @ts-expect-error element cloning is not typed
    tickItem = /*#__PURE__*/ $28UcW.cloneElement(option, $c8f4efe43d81a1a3$var$_objectSpread($c8f4efe43d81a1a3$var$_objectSpread({}, tickProps), {}, {
        className: combinedClassName
    }));
    else if (typeof option === 'function') tickItem = option($c8f4efe43d81a1a3$var$_objectSpread($c8f4efe43d81a1a3$var$_objectSpread({}, tickProps), {}, {
        className: combinedClassName
    }));
    else {
        var className = 'recharts-cartesian-axis-tick-value';
        if (typeof option !== 'boolean') className = (0, $dP0oo.clsx)(className, option === null || option === void 0 ? void 0 : option.className);
        tickItem = /*#__PURE__*/ $28UcW.createElement((0, $e6266b2db237d3de$export$5f1af8db9871e1d6), $c8f4efe43d81a1a3$var$_extends({}, tickProps, {
            className: className
        }), value);
    }
    return tickItem;
}
var $c8f4efe43d81a1a3$var$Ticks = /*#__PURE__*/ (0, $28UcW.forwardRef)((props, ref)=>{
    var { ticks: ticks = [], tick: tick, tickLine: tickLine, stroke: stroke, tickFormatter: tickFormatter, unit: unit, padding: padding, tickTextProps: tickTextProps, orientation: orientation, mirror: mirror, x: x, y: y, width: width, height: height, tickSize: tickSize, tickMargin: tickMargin, fontSize: fontSize, letterSpacing: letterSpacing, getTicksConfig: getTicksConfig, events: events, axisType: axisType } = props;
    // @ts-expect-error some properties are optional in props but required in getTicks
    var finalTicks = (0, $5f666a34d09825a1$export$3d27d42b1034de5c)($c8f4efe43d81a1a3$var$_objectSpread($c8f4efe43d81a1a3$var$_objectSpread({}, getTicksConfig), {}, {
        ticks: ticks
    }), fontSize, letterSpacing);
    var textAnchor = $c8f4efe43d81a1a3$var$getTickTextAnchor(orientation, mirror);
    var verticalAnchor = $c8f4efe43d81a1a3$var$getTickVerticalAnchor(orientation, mirror);
    var axisProps = (0, $3d820e26962aea02$export$8b56257912140094)(getTicksConfig);
    var customTickProps = (0, $3d820e26962aea02$export$6d5921c09aa671a9)(tick);
    var tickLinePropsObject = {};
    if (typeof tickLine === 'object') tickLinePropsObject = tickLine;
    var tickLineProps = $c8f4efe43d81a1a3$var$_objectSpread($c8f4efe43d81a1a3$var$_objectSpread({}, axisProps), {}, {
        fill: 'none'
    }, tickLinePropsObject);
    var tickLineCoords = finalTicks.map((entry)=>$c8f4efe43d81a1a3$var$_objectSpread({
            entry: entry
        }, $c8f4efe43d81a1a3$var$getTickLineCoord(entry, x, y, width, height, orientation, tickSize, mirror, tickMargin)));
    var tickLines = tickLineCoords.map((_ref)=>{
        var { entry: entry, line: lineCoord } = _ref;
        return /*#__PURE__*/ $28UcW.createElement((0, $06287e412aaf2f1c$export$936d0764594b6eb3), {
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
        }, tickLine && /*#__PURE__*/ $28UcW.createElement("line", $c8f4efe43d81a1a3$var$_extends({}, tickLineProps, lineCoord, {
            className: (0, $dP0oo.clsx)('recharts-cartesian-axis-tick-line', (0, (/*@__PURE__*/$parcel$interopDefault($2c84e5b844764211$exports)))(tickLine, 'className'))
        })));
    });
    var tickLabels = tickLineCoords.map((_ref2, i)=>{
        var { entry: entry, tick: tickCoord } = _ref2;
        var tickProps = $c8f4efe43d81a1a3$var$_objectSpread($c8f4efe43d81a1a3$var$_objectSpread($c8f4efe43d81a1a3$var$_objectSpread($c8f4efe43d81a1a3$var$_objectSpread({
            textAnchor: // @ts-expect-error textAnchor from axisProps is typed as `string` but Text wants type `TextAnchor`
            textAnchor,
            verticalAnchor: verticalAnchor
        }, axisProps), {}, {
            // @ts-expect-error customTickProps is contributing unknown props
            stroke: 'none',
            // @ts-expect-error customTickProps is contributing unknown props
            fill: stroke
        }, customTickProps), tickCoord), {}, {
            index: i,
            payload: entry,
            visibleTicksCount: finalTicks.length,
            tickFormatter: tickFormatter,
            padding: padding
        }, tickTextProps);
        return /*#__PURE__*/ $28UcW.createElement((0, $06287e412aaf2f1c$export$936d0764594b6eb3), $c8f4efe43d81a1a3$var$_extends({
            className: "recharts-cartesian-axis-tick-label",
            key: "tick-label-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
        }, (0, $4009b9153cff02e8$export$ca62be0d67a3158c)(events, entry, i)), tick && /*#__PURE__*/ $28UcW.createElement($c8f4efe43d81a1a3$var$TickItem, {
            option: tick,
            tickProps: tickProps,
            value: "".concat(typeof tickFormatter === 'function' ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')
        }));
    });
    return /*#__PURE__*/ $28UcW.createElement("g", {
        className: "recharts-cartesian-axis-ticks recharts-".concat(axisType, "-ticks")
    }, tickLabels.length > 0 && /*#__PURE__*/ $28UcW.createElement((0, $3603bfc8e6eb9e37$export$b37befaf92aba9f1), {
        zIndex: (0, $45e92ad7df96f1e3$export$96df16b28aa32702).label
    }, /*#__PURE__*/ $28UcW.createElement("g", {
        className: "recharts-cartesian-axis-tick-labels recharts-".concat(axisType, "-tick-labels"),
        ref: ref
    }, tickLabels)), tickLines.length > 0 && /*#__PURE__*/ $28UcW.createElement("g", {
        className: "recharts-cartesian-axis-tick-lines recharts-".concat(axisType, "-tick-lines")
    }, tickLines));
});
var $c8f4efe43d81a1a3$var$CartesianAxisComponent = /*#__PURE__*/ (0, $28UcW.forwardRef)((props, ref)=>{
    var { axisLine: axisLine, width: width, height: height, className: className, hide: hide, ticks: ticks, axisType: axisType } = props, rest = $c8f4efe43d81a1a3$var$_objectWithoutProperties(props, $c8f4efe43d81a1a3$var$_excluded);
    var [fontSize, setFontSize] = (0, $28UcW.useState)('');
    var [letterSpacing, setLetterSpacing] = (0, $28UcW.useState)('');
    var tickRefs = (0, $28UcW.useRef)(null);
    (0, $28UcW.useImperativeHandle)(ref, ()=>({
            getCalculatedWidth: ()=>{
                var _props$labelRef;
                return (0, $33210867991f4a62$export$b70f70a4fdbed242)({
                    ticks: tickRefs.current,
                    label: (_props$labelRef = props.labelRef) === null || _props$labelRef === void 0 ? void 0 : _props$labelRef.current,
                    labelGapWithTick: 5,
                    tickSize: props.tickSize,
                    tickMargin: props.tickMargin
                });
            }
        }));
    var layerRef = (0, $28UcW.useCallback)((el)=>{
        if (el) {
            var tickNodes = el.getElementsByClassName('recharts-cartesian-axis-tick-value');
            tickRefs.current = tickNodes;
            var tick = tickNodes[0];
            if (tick) {
                var computedStyle = window.getComputedStyle(tick);
                var calculatedFontSize = computedStyle.fontSize;
                var calculatedLetterSpacing = computedStyle.letterSpacing;
                if (calculatedFontSize !== fontSize || calculatedLetterSpacing !== letterSpacing) {
                    setFontSize(calculatedFontSize);
                    setLetterSpacing(calculatedLetterSpacing);
                }
            }
        }
    }, [
        fontSize,
        letterSpacing
    ]);
    if (hide) return null;
    /*
   * This is different condition from what validateWidthHeight is doing;
   * the CartesianAxis does allow width or height to be undefined.
   */ if (width != null && width <= 0 || height != null && height <= 0) return null;
    return /*#__PURE__*/ $28UcW.createElement((0, $3603bfc8e6eb9e37$export$b37befaf92aba9f1), {
        zIndex: props.zIndex
    }, /*#__PURE__*/ $28UcW.createElement((0, $06287e412aaf2f1c$export$936d0764594b6eb3), {
        className: (0, $dP0oo.clsx)('recharts-cartesian-axis', className)
    }, /*#__PURE__*/ $28UcW.createElement($c8f4efe43d81a1a3$var$AxisLine, {
        x: props.x,
        y: props.y,
        width: width,
        height: height,
        orientation: props.orientation,
        mirror: props.mirror,
        axisLine: axisLine,
        otherSvgProps: (0, $3d820e26962aea02$export$8b56257912140094)(props)
    }), /*#__PURE__*/ $28UcW.createElement($c8f4efe43d81a1a3$var$Ticks, {
        ref: layerRef,
        axisType: axisType,
        events: rest,
        fontSize: fontSize,
        getTicksConfig: props,
        height: props.height,
        letterSpacing: letterSpacing,
        mirror: props.mirror,
        orientation: props.orientation,
        padding: props.padding,
        stroke: props.stroke,
        tick: props.tick,
        tickFormatter: props.tickFormatter,
        tickLine: props.tickLine,
        tickMargin: props.tickMargin,
        tickSize: props.tickSize,
        tickTextProps: props.tickTextProps,
        ticks: ticks,
        unit: props.unit,
        width: props.width,
        x: props.x,
        y: props.y
    }), /*#__PURE__*/ $28UcW.createElement((0, $9290b2e14d5ce35d$export$3b4df77eaec10b03), {
        x: props.x,
        y: props.y,
        width: props.width,
        height: props.height,
        lowerWidth: props.width,
        upperWidth: props.width
    }, /*#__PURE__*/ $28UcW.createElement((0, $9290b2e14d5ce35d$export$3c82c3a3704539d8), {
        label: props.label,
        labelRef: props.labelRef
    }), props.children)));
});
var $c8f4efe43d81a1a3$export$bdd99f2cdf352bae = /*#__PURE__*/ $28UcW.forwardRef((outsideProps, ref)=>{
    var props = (0, $2db4b31e06a7a91b$export$45004cc70a390ee8)(outsideProps, $c8f4efe43d81a1a3$export$179c35154a9748c0);
    return /*#__PURE__*/ $28UcW.createElement($c8f4efe43d81a1a3$var$CartesianAxisComponent, $c8f4efe43d81a1a3$var$_extends({}, props, {
        ref: ref
    }));
});
$c8f4efe43d81a1a3$export$bdd99f2cdf352bae.displayName = 'CartesianAxis';




var $45c9781546233b1d$exports = {};

$45c9781546233b1d$exports = (parcelRequire("aY1aK")).range;


var $1cd2e188ffea0020$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$1cd2e188ffea0020$exports = (parcelRequire("55SMh"));





var $d6cc9cc11e425d5b$export$519edd692222520 = (state)=>state.chartData;
var $d6cc9cc11e425d5b$export$3b10e41b7db2c36 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $d6cc9cc11e425d5b$export$519edd692222520
], (dataState)=>{
    var dataEndIndex = dataState.chartData != null ? dataState.chartData.length - 1 : 0;
    return {
        chartData: dataState.chartData,
        computedData: dataState.computedData,
        dataEndIndex: dataEndIndex,
        dataStartIndex: 0
    };
});
var $d6cc9cc11e425d5b$export$fe05134c2701d897 = (state, _unused1, _unused2, isPanorama)=>{
    if (isPanorama) return $d6cc9cc11e425d5b$export$3b10e41b7db2c36(state);
    return $d6cc9cc11e425d5b$export$519edd692222520(state);
};
var $d6cc9cc11e425d5b$export$46bf9459876c0e0c = (state, _unused1, isPanorama)=>{
    if (isPanorama) return $d6cc9cc11e425d5b$export$3b10e41b7db2c36(state);
    return $d6cc9cc11e425d5b$export$519edd692222520(state);
};





function $10a31e6d89f791d6$export$ba29b24e2a92eb58(v) {
    if (Array.isArray(v) && v.length === 2) {
        var [min, max] = v;
        if ((0, $11a93f8f3c3518e5$export$f8a8fc612ced9bb0)(min) && (0, $11a93f8f3c3518e5$export$f8a8fc612ced9bb0)(max)) return true;
    }
    return false;
}
function $10a31e6d89f791d6$export$15a9d37c57dafeb9(providedDomain, boundaryDomain, allowDataOverflow) {
    if (allowDataOverflow) // If the data are allowed to overflow - we're fine with whatever user provided
    return providedDomain;
    /*
   * If the data are not allowed to overflow - we need to extend the domain.
   * Means that effectively the user is allowed to make the domain larger
   * but not smaller.
   */ return [
        Math.min(providedDomain[0], boundaryDomain[0]),
        Math.max(providedDomain[1], boundaryDomain[1])
    ];
}
function $10a31e6d89f791d6$export$fcbf88d4627b24df(userDomain, allowDataOverflow) {
    if (!allowDataOverflow) // Cannot compute data overflow if the data is not provided
    return undefined;
    if (typeof userDomain === 'function') // The user function expects the data to be provided as an argument
    return undefined;
    if (Array.isArray(userDomain) && userDomain.length === 2) {
        var [providedMin, providedMax] = userDomain;
        var finalMin, finalMax;
        if ((0, $11a93f8f3c3518e5$export$f8a8fc612ced9bb0)(providedMin)) finalMin = providedMin;
        else if (typeof providedMin === 'function') // The user function expects the data to be provided as an argument
        return undefined;
        if ((0, $11a93f8f3c3518e5$export$f8a8fc612ced9bb0)(providedMax)) finalMax = providedMax;
        else if (typeof providedMax === 'function') // The user function expects the data to be provided as an argument
        return undefined;
        var candidate = [
            finalMin,
            finalMax
        ];
        if ($10a31e6d89f791d6$export$ba29b24e2a92eb58(candidate)) return candidate;
    }
    return undefined;
}
function $10a31e6d89f791d6$export$3f87aa7a53437a70(userDomain, dataDomain, allowDataOverflow) {
    if (!allowDataOverflow && dataDomain == null) // Cannot compute data overflow if the data is not provided
    return undefined;
    if (typeof userDomain === 'function' && dataDomain != null) try {
        var result = userDomain(dataDomain, allowDataOverflow);
        if ($10a31e6d89f791d6$export$ba29b24e2a92eb58(result)) return $10a31e6d89f791d6$export$15a9d37c57dafeb9(result, dataDomain, allowDataOverflow);
    } catch (_unused) {
    /* ignore the exception and compute domain from data later */ }
    if (Array.isArray(userDomain) && userDomain.length === 2) {
        var [providedMin, providedMax] = userDomain;
        var finalMin, finalMax;
        if (providedMin === 'auto') {
            if (dataDomain != null) finalMin = Math.min(...dataDomain);
        } else if ((0, $9a1343d05dde836c$export$7e4aa119212bc614)(providedMin)) finalMin = providedMin;
        else if (typeof providedMin === 'function') try {
            if (dataDomain != null) finalMin = providedMin(dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[0]);
        } catch (_unused2) {
        /* ignore the exception and compute domain from data later */ }
        else if (typeof providedMin === 'string' && (0, $912d8cf1d03ea507$export$75a7b23ff266dfa1).test(providedMin)) {
            var match = (0, $912d8cf1d03ea507$export$75a7b23ff266dfa1).exec(providedMin);
            if (match == null || match[1] == null || dataDomain == null) finalMin = undefined;
            else {
                var value = +match[1];
                finalMin = dataDomain[0] - value;
            }
        } else finalMin = dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[0];
        if (providedMax === 'auto') {
            if (dataDomain != null) finalMax = Math.max(...dataDomain);
        } else if ((0, $9a1343d05dde836c$export$7e4aa119212bc614)(providedMax)) finalMax = providedMax;
        else if (typeof providedMax === 'function') try {
            if (dataDomain != null) finalMax = providedMax(dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[1]);
        } catch (_unused3) {
        /* ignore the exception and compute domain from data later */ }
        else if (typeof providedMax === 'string' && (0, $912d8cf1d03ea507$export$19c111ec8ad6c644).test(providedMax)) {
            var _match = (0, $912d8cf1d03ea507$export$19c111ec8ad6c644).exec(providedMax);
            if (_match == null || _match[1] == null || dataDomain == null) finalMax = undefined;
            else {
                var _value = +_match[1];
                finalMax = dataDomain[1] + _value;
            }
        } else finalMax = dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[1];
        var candidate = [
            finalMin,
            finalMax
        ];
        if ($10a31e6d89f791d6$export$ba29b24e2a92eb58(candidate)) {
            if (dataDomain == null) return candidate;
            return $10a31e6d89f791d6$export$15a9d37c57dafeb9(candidate, dataDomain, allowDataOverflow);
        }
    }
    return undefined;
}




/**
 * @fileOverview calculate tick values of scale
 * @author xile611, arcthur
 * @date 2015-09-17
 */ var $d4aaa5a9e7b150c0$exports = {};
/*! decimal.js-light v2.5.1 https://github.com/MikeMcl/decimal.js-light/LICENCE */ (function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if ($d4aaa5a9e7b150c0$exports) $d4aaa5a9e7b150c0$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})($d4aaa5a9e7b150c0$exports);


var $882cabba5fd04602$var$identity = (i)=>i;
var $882cabba5fd04602$export$ca73b6d700d0505 = {
    '@@functional/placeholder': true
};
var $882cabba5fd04602$var$isPlaceHolder = (val)=>val === $882cabba5fd04602$export$ca73b6d700d0505;
var $882cabba5fd04602$var$curry0 = (fn)=>function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $882cabba5fd04602$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn(...arguments);
    };
var $882cabba5fd04602$var$curryN = (n, fn)=>{
    if (n === 1) return fn;
    return $882cabba5fd04602$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter((arg)=>arg !== $882cabba5fd04602$export$ca73b6d700d0505).length;
        if (argsLength >= n) return fn(...args);
        return $882cabba5fd04602$var$curryN(n - argsLength, $882cabba5fd04602$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map((arg)=>$882cabba5fd04602$var$isPlaceHolder(arg) ? restArgs.shift() : arg);
            return fn(...newArgs, ...restArgs);
        }));
    });
};
var $882cabba5fd04602$export$c3095a23b368d1f2 = (fn)=>$882cabba5fd04602$var$curryN(fn.length, fn);
var $882cabba5fd04602$export$d02631cccf789723 = (begin, end)=>{
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $882cabba5fd04602$export$871de8747c9eaa88 = $882cabba5fd04602$export$c3095a23b368d1f2((fn, arr)=>{
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map((key)=>arr[key]).map(fn);
});
var $882cabba5fd04602$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $882cabba5fd04602$var$identity;
    var fns = args.reverse();
    // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce((res, fn)=>fn(res), firstFn(...arguments));
    };
};


/**
 * @fileOverview Some common arithmetic methods
 * @author xile611
 * @date 2015-09-17
 */ 
/**
 * Get the digit count of a number.
 * If the absolute value is in the interval [0.1, 1), the result is 0.
 * If the absolute value is in the interval [0.01, 0.1), the digit count is -1.
 * If the absolute value is in the interval [0.001, 0.01), the digit count is -2.
 *
 * @param  {Number} value The number
 * @return {Integer}      Digit count
 */ function $b291568ee55e506e$export$c21fa0a8c666ce01(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * Get the data in the interval [start, end) with a fixed step.
 * Also handles JS calculation precision issues.
 *
 * @param  {Decimal} start Start point
 * @param  {Decimal} end   End point, not included
 * @param  {Decimal} step  Step size
 * @return {Array}         Array of numbers
 */ function $b291568ee55e506e$export$85207d4610782ccb(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(start);
    var i = 0;
    var result = [];
    // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}


var $5095dcff3396f81a$export$9fcf9e98b0fc6c13 = (_ref)=>{
    var [min, max] = _ref;
    var [validMin, validMax] = [
        min,
        max
    ];
    // exchange
    if (min > max) [validMin, validMax] = [
        max,
        min
    ];
    return [
        validMin,
        validMax
    ];
};
var $5095dcff3396f81a$export$bda2c289544cdcde = (roughStep, allowDecimals, correctionFactor)=>{
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(0);
    var digitCount = (0, $b291568ee55e506e$export$c21fa0a8c666ce01)(roughStep.toNumber());
    // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue);
    // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(formatStep.toNumber()) : new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(Math.ceil(formatStep.toNumber()));
};
var $5095dcff3396f81a$export$8913aec4ff751b4d = (value, tickCount, allowDecimals)=>{
    var step = new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(1);
    // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(10).pow((0, $b291568ee55e506e$export$c21fa0a8c666ce01)(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $882cabba5fd04602$export$f672e0b6f7222cd7)((0, $882cabba5fd04602$export$871de8747c9eaa88)((n)=>middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(n - middleIndex).mul(step)).toNumber()), (0, $882cabba5fd04602$export$d02631cccf789723));
    return fn(0, tickCount);
};
/**
 * Calculate the step
 *
 * @param  min              The minimum value of an interval
 * @param  max              The maximum value of an interval
 * @param  tickCount        The count of ticks
 * @param  allowDecimals    Allow the ticks to be decimals or not
 * @param  correctionFactor A correction factor
 * @return The step, minimum value of ticks, maximum value of ticks
 */ var $5095dcff3396f81a$export$ca78fcd978995194 = function calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(0)
    };
    // The step which is easy to understand between two ticks
    var step = $5095dcff3396f81a$export$bda2c289544cdcde(new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor);
    // A medial value of ticks
    var middle;
    // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(min).add(max).div(2);
        // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $5095dcff3396f81a$export$ca78fcd978995194(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(upCount).mul(step))
    };
};
var $5095dcff3396f81a$export$b84e75ccbfe6a612 = function getNiceTickValues(_ref2) {
    var [min, max] = _ref2;
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var [cormin, cormax] = $5095dcff3396f81a$export$9fcf9e98b0fc6c13([
        min,
        max
    ]);
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin,
            ...(0, $882cabba5fd04602$export$d02631cccf789723)(0, tickCount - 1).map(()=>Infinity)
        ] : [
            ...(0, $882cabba5fd04602$export$d02631cccf789723)(0, tickCount - 1).map(()=>-Infinity),
            cormax
        ];
        return min > max ? _values.reverse() : _values;
    }
    if (cormin === cormax) return $5095dcff3396f81a$export$8913aec4ff751b4d(cormin, tickCount, allowDecimals);
    // Get the step between two ticks
    var { step: step, tickMin: tickMin, tickMax: tickMax } = $5095dcff3396f81a$export$ca78fcd978995194(cormin, cormax, count, allowDecimals, 0);
    var values = (0, $b291568ee55e506e$export$85207d4610782ccb)(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(0.1).mul(step)), step);
    return min > max ? values.reverse() : values;
};
var $5095dcff3396f81a$export$e9d28da780436e98 = function getTickValuesFixedDomain(_ref3, tickCount) {
    var [min, max] = _ref3;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var [cormin, cormax] = $5095dcff3396f81a$export$9fcf9e98b0fc6c13([
        min,
        max
    ]);
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $5095dcff3396f81a$export$bda2c289544cdcde(new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [
        ...(0, $b291568ee55e506e$export$85207d4610782ccb)(new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($d4aaa5a9e7b150c0$exports)))(cormax), step),
        cormax
    ];
    if (allowDecimals === false) /*
     * allowDecimals is false means that we want to have integer ticks.
     * The step is guaranteed to be an integer in the code above which is great start
     * but when the first step is not an integer, it will start stepping from a decimal value anyway.
     * So we need to round all the values to integers after the fact.
     */ values = values.map((value)=>Math.round(value));
    return min > max ? values.reverse() : values;
};






var $d319e2ad1ad322d2$export$db43f3089e0ec1e9 = (state)=>state.rootProps.maxBarSize;
var $d319e2ad1ad322d2$export$9b8e3d53e72fb7a8 = (state)=>state.rootProps.barGap;
var $d319e2ad1ad322d2$export$a73f9d39b015942a = (state)=>state.rootProps.barCategoryGap;
var $d319e2ad1ad322d2$export$be00206a4a82272f = (state)=>state.rootProps.barSize;
var $d319e2ad1ad322d2$export$73aff39176364def = (state)=>state.rootProps.stackOffset;
var $d319e2ad1ad322d2$export$ec830dc49707c6da = (state)=>state.rootProps.reverseStackOrder;
var $d319e2ad1ad322d2$export$3247769c9dbde559 = (state)=>state.options.chartName;
var $d319e2ad1ad322d2$export$d3b88e5c88540018 = (state)=>state.rootProps.syncId;
var $d319e2ad1ad322d2$export$f3cbf53653105e96 = (state)=>state.rootProps.syncMethod;
var $d319e2ad1ad322d2$export$b89defd58e84e980 = (state)=>state.options.eventEmitter;
var $d319e2ad1ad322d2$export$a1ad1f48be8d5def = (state)=>state.rootProps.baseValue;



var $2166cd81382e43aa$export$8a7d579879340d98 = (_state, axisType)=>axisType;


var $7919f41c64f031eb$export$6a2efa106dc9c8f6 = (_state, _axisType, axisId)=>axisId;




/**
 * Returns identifier for stack series which is one individual graphical item in the stack.
 * @param graphicalItem - The graphical item representing the series in the stack.
 * @return The identifier for the series in the stack
 */ function $e87b7d47ab6fc507$export$58b095b87bc46727(graphicalItem) {
    return graphicalItem === null || graphicalItem === void 0 ? void 0 : graphicalItem.id;
}




function $0c25d0c543be64c4$export$ae6c77e7720cddf9(stackedGraphicalItems, _ref, tooltipAxisSettings) {
    var { chartData: chartData = [] } = _ref;
    var { allowDuplicatedCategory: allowDuplicatedCategory, dataKey: tooltipDataKey } = tooltipAxisSettings;
    // A map of tooltip data keys to the stacked data points
    var knownItemsByDataKey = new Map();
    stackedGraphicalItems.forEach((item)=>{
        var _item$data;
        // If there is no data on the individual item then we use the root chart data
        var resolvedData = (_item$data = item.data) !== null && _item$data !== void 0 ? _item$data : chartData;
        if (resolvedData == null || resolvedData.length === 0) // if that doesn't work then we skip this item
        return;
        var stackIdentifier = (0, $e87b7d47ab6fc507$export$58b095b87bc46727)(item);
        resolvedData.forEach((entry, index)=>{
            var tooltipValue = tooltipDataKey == null || allowDuplicatedCategory ? index : String((0, $912d8cf1d03ea507$export$f97fc4a450f29a)(entry, tooltipDataKey, null));
            var numericValue = (0, $912d8cf1d03ea507$export$f97fc4a450f29a)(entry, item.dataKey, 0);
            var curr;
            if (knownItemsByDataKey.has(tooltipValue)) curr = knownItemsByDataKey.get(tooltipValue);
            else curr = {};
            Object.assign(curr, {
                [stackIdentifier]: numericValue
            });
            knownItemsByDataKey.set(tooltipValue, curr);
        });
    });
    return Array.from(knownItemsByDataKey.values());
}


/**
 * Some graphical items allow data stacking. The stacks are optional,
 * so all props here are optional too.
 */ /**
 * Some graphical items allow data stacking.
 * This interface is used to represent the items that are stacked
 * because the user has provided the stackId and dataKey properties.
 */ function $2e709b3ca282ae8f$export$2335dd91cc88053e(graphicalItem) {
    return 'stackId' in graphicalItem && graphicalItem.stackId != null && graphicalItem.dataKey != null;
}


var $112aba0500e31420$export$45c01007b107f1a6 = (a, b)=>{
    if (a === b) return true;
    if (a == null || b == null) return false;
    return a[0] === b[0] && a[1] === b[1];
};




var $411fa86e80c20dfb$export$898d3dfd98fb482 = (state)=>{
    var layout = (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee)(state);
    if (layout === 'horizontal') return 'xAxis';
    if (layout === 'vertical') return 'yAxis';
    if (layout === 'centric') return 'angleAxis';
    return 'radiusAxis';
};


var $9a8bc2d38fad28d3$export$eeffdb10daff095d = (state)=>state.tooltip.settings.axisId;


function $8f21bd235d951197$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8f21bd235d951197$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8f21bd235d951197$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8f21bd235d951197$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8f21bd235d951197$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8f21bd235d951197$var$_defineProperty(e, r, t) {
    return (r = $8f21bd235d951197$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8f21bd235d951197$var$_toPropertyKey(t) {
    var i = $8f21bd235d951197$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8f21bd235d951197$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $8f21bd235d951197$export$a012a4dce80491c2 = [
    0,
    'auto'
];
var $8f21bd235d951197$export$21aec091b6ac8422 = {
    allowDataOverflow: false,
    allowDecimals: true,
    allowDuplicatedCategory: true,
    angle: 0,
    dataKey: undefined,
    domain: undefined,
    height: 30,
    hide: true,
    id: 0,
    includeHidden: false,
    interval: 'preserveEnd',
    minTickGap: 5,
    mirror: false,
    name: undefined,
    orientation: 'bottom',
    padding: {
        left: 0,
        right: 0
    },
    reversed: false,
    scale: 'auto',
    tick: true,
    tickCount: 5,
    tickFormatter: undefined,
    ticks: undefined,
    type: 'category',
    unit: undefined
};
var $8f21bd235d951197$export$8079b33b4a6a2ac5 = (state, axisId)=>{
    return state.cartesianAxis.xAxis[axisId];
};
var $8f21bd235d951197$export$d6895d8ddb4cee5 = (state, axisId)=>{
    var axis = $8f21bd235d951197$export$8079b33b4a6a2ac5(state, axisId);
    if (axis == null) return $8f21bd235d951197$export$21aec091b6ac8422;
    return axis;
};
var $8f21bd235d951197$export$397148de2ecdec3c = {
    allowDataOverflow: false,
    allowDecimals: true,
    allowDuplicatedCategory: true,
    angle: 0,
    dataKey: undefined,
    domain: $8f21bd235d951197$export$a012a4dce80491c2,
    hide: true,
    id: 0,
    includeHidden: false,
    interval: 'preserveEnd',
    minTickGap: 5,
    mirror: false,
    name: undefined,
    orientation: 'left',
    padding: {
        top: 0,
        bottom: 0
    },
    reversed: false,
    scale: 'auto',
    tick: true,
    tickCount: 5,
    tickFormatter: undefined,
    ticks: undefined,
    type: 'number',
    unit: undefined,
    width: (0, $3114cbf50b21aaf4$export$fb6ee82c8ee2faf8)
};
var $8f21bd235d951197$export$d0970661da76c14c = (state, axisId)=>{
    return state.cartesianAxis.yAxis[axisId];
};
var $8f21bd235d951197$export$1f472705a332f1c9 = (state, axisId)=>{
    var axis = $8f21bd235d951197$export$d0970661da76c14c(state, axisId);
    if (axis == null) return $8f21bd235d951197$export$397148de2ecdec3c;
    return axis;
};
var $8f21bd235d951197$export$73a439a535d82503 = {
    domain: [
        0,
        'auto'
    ],
    includeHidden: false,
    reversed: false,
    allowDataOverflow: false,
    allowDuplicatedCategory: false,
    dataKey: undefined,
    id: 0,
    name: '',
    range: [
        64,
        64
    ],
    scale: 'auto',
    type: 'number',
    unit: ''
};
var $8f21bd235d951197$export$26eadf639b453d0f = (state, axisId)=>{
    var axis = state.cartesianAxis.zAxis[axisId];
    if (axis == null) return $8f21bd235d951197$export$73a439a535d82503;
    return axis;
};
var $8f21bd235d951197$export$fc14c3706e09c50c = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return $8f21bd235d951197$export$d6895d8ddb4cee5(state, axisId);
        case 'yAxis':
            return $8f21bd235d951197$export$1f472705a332f1c9(state, axisId);
        case 'zAxis':
            return $8f21bd235d951197$export$26eadf639b453d0f(state, axisId);
        case 'angleAxis':
            return (0, $fe99398211301319$export$2d9ff7eb66def0da)(state, axisId);
        case 'radiusAxis':
            return (0, $fe99398211301319$export$74b0499accddabe1)(state, axisId);
        default:
            throw new Error("Unexpected axis type: ".concat(axisType));
    }
};
var $8f21bd235d951197$var$selectCartesianAxisSettings = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return $8f21bd235d951197$export$d6895d8ddb4cee5(state, axisId);
        case 'yAxis':
            return $8f21bd235d951197$export$1f472705a332f1c9(state, axisId);
        default:
            throw new Error("Unexpected axis type: ".concat(axisType));
    }
};
var $8f21bd235d951197$export$3635e5ebe47f85a9 = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return $8f21bd235d951197$export$d6895d8ddb4cee5(state, axisId);
        case 'yAxis':
            return $8f21bd235d951197$export$1f472705a332f1c9(state, axisId);
        case 'angleAxis':
            return (0, $fe99398211301319$export$2d9ff7eb66def0da)(state, axisId);
        case 'radiusAxis':
            return (0, $fe99398211301319$export$74b0499accddabe1)(state, axisId);
        default:
            throw new Error("Unexpected axis type: ".concat(axisType));
    }
};
var $8f21bd235d951197$export$1c7798b82c8010cd = (state)=>state.graphicalItems.cartesianItems.some((item)=>item.type === 'bar') || state.graphicalItems.polarItems.some((item)=>item.type === 'radialBar');
function $8f21bd235d951197$export$a3923f321c6572c3(axisType, axisId) {
    return (item)=>{
        switch(axisType){
            case 'xAxis':
                // This is sensitive to the data type, as 0 !== '0'. I wonder if we should be more flexible. How does 2.x branch behave? TODO write test for that
                return 'xAxisId' in item && item.xAxisId === axisId;
            case 'yAxis':
                return 'yAxisId' in item && item.yAxisId === axisId;
            case 'zAxis':
                return 'zAxisId' in item && item.zAxisId === axisId;
            case 'angleAxis':
                return 'angleAxisId' in item && item.angleAxisId === axisId;
            case 'radiusAxis':
                return 'radiusAxisId' in item && item.radiusAxisId === axisId;
            default:
                return false;
        }
    };
}
var $8f21bd235d951197$export$f67c737adf41a3af = (state)=>state.graphicalItems.cartesianItems;
var $8f21bd235d951197$var$selectAxisPredicate = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $2166cd81382e43aa$export$8a7d579879340d98),
    (0, $7919f41c64f031eb$export$6a2efa106dc9c8f6)
], $8f21bd235d951197$export$a3923f321c6572c3);
var $8f21bd235d951197$export$ad35679ce4582010 = (graphicalItems, axisSettings, axisPredicate)=>graphicalItems.filter(axisPredicate).filter((item)=>{
        if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.includeHidden) === true) return true;
        return !item.hide;
    });
var $8f21bd235d951197$export$533d13f911334c9d = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$f67c737adf41a3af,
    $8f21bd235d951197$export$fc14c3706e09c50c,
    $8f21bd235d951197$var$selectAxisPredicate
], $8f21bd235d951197$export$ad35679ce4582010, {
    memoizeOptions: {
        resultEqualityCheck: (0, $20e12f99ca944083$export$dcc34c4213e7f4c)
    }
});
var $8f21bd235d951197$export$58ad06f71246a0da = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$533d13f911334c9d
], (cartesianItems)=>{
    return cartesianItems.filter((item)=>item.type === 'area' || item.type === 'bar').filter((0, $2e709b3ca282ae8f$export$2335dd91cc88053e));
});
var $8f21bd235d951197$export$a61da86823382adc = (cartesianItems)=>cartesianItems.filter((item)=>!('stackId' in item) || item.stackId === undefined);
var $8f21bd235d951197$var$selectCartesianItemsSettingsExceptStacked = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$533d13f911334c9d
], $8f21bd235d951197$export$a61da86823382adc);
var $8f21bd235d951197$export$d945cee965d266f0 = (cartesianItems)=>cartesianItems.map((item)=>item.data).filter(Boolean).flat(1);
var $8f21bd235d951197$export$f2151bebfd9ae457 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$533d13f911334c9d
], $8f21bd235d951197$export$d945cee965d266f0, {
    memoizeOptions: {
        resultEqualityCheck: (0, $20e12f99ca944083$export$dcc34c4213e7f4c)
    }
});
var $8f21bd235d951197$export$c2c6d012cffe2c75 = (graphicalItemsData, _ref)=>{
    var { chartData: chartData = [], dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = _ref;
    if (graphicalItemsData.length > 0) /*
     * There is no slicing when data is defined on graphical items. Why?
     * Because Brush ignores data defined on graphical items,
     * and does not render.
     * So Brush will never show up in a Scatter chart for example.
     * This is something we will need to fix.
     *
     * Now, when the root chart data is not defined, the dataEndIndex is 0,
     * which means the itemsData will be sliced to an empty array anyway.
     * But that's an implementation detail, and we can fix that too.
     *
     * Also, in absence of Axis dataKey, we use the dataKey from each item, respectively.
     * This is the usual pattern for numerical axis, that is the one where bars go up:
     * users don't specify any dataKey by default and expect the axis to "just match the data".
     */ return graphicalItemsData;
    return chartData.slice(dataStartIndex, dataEndIndex + 1);
};
var $8f21bd235d951197$export$6099ba314905f0c4 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$f2151bebfd9ae457,
    (0, $d6cc9cc11e425d5b$export$fe05134c2701d897)
], $8f21bd235d951197$export$c2c6d012cffe2c75);
var $8f21bd235d951197$export$3051da2013ba9cfe = (data, axisSettings, items)=>{
    if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.dataKey) != null) return data.map((item)=>({
            value: (0, $912d8cf1d03ea507$export$f97fc4a450f29a)(item, axisSettings.dataKey)
        }));
    if (items.length > 0) return items.map((item)=>item.dataKey).flatMap((dataKey)=>data.map((entry)=>({
                value: (0, $912d8cf1d03ea507$export$f97fc4a450f29a)(entry, dataKey)
            })));
    return data.map((entry)=>({
            value: entry
        }));
};
var $8f21bd235d951197$export$9cea618b690f07b7 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$6099ba314905f0c4,
    $8f21bd235d951197$export$fc14c3706e09c50c,
    $8f21bd235d951197$export$533d13f911334c9d
], $8f21bd235d951197$export$3051da2013ba9cfe);
function $8f21bd235d951197$export$8b0eb5a8c39b724f(axisType, errorBar) {
    switch(axisType){
        case 'xAxis':
            return errorBar.direction === 'x';
        case 'yAxis':
            return errorBar.direction === 'y';
        default:
            return false;
    }
}
/**
 * This is type of "error" in chart. It is set by using ErrorBar, and it can represent confidence interval,
 * or gap in the data, or standard deviation, or quartiles in boxplot, or whiskers or whatever.
 *
 * We will internally represent it as a tuple of two numbers, where the first number is the lower bound and the second number is the upper bound.
 *
 * It is also true that the first number should be lower than or equal to the associated "main value",
 * and the second number should be higher than or equal to the associated "main value".
 */ function $8f21bd235d951197$var$makeNumber(val) {
    if ((0, $9a1343d05dde836c$export$402a499e1ea44294)(val) || val instanceof Date) {
        var n = Number(val);
        if ((0, $11a93f8f3c3518e5$export$f8a8fc612ced9bb0)(n)) return n;
    }
    return undefined;
}
function $8f21bd235d951197$var$makeDomain(val) {
    if (Array.isArray(val)) {
        var attempt = [
            $8f21bd235d951197$var$makeNumber(val[0]),
            $8f21bd235d951197$var$makeNumber(val[1])
        ];
        if ((0, $10a31e6d89f791d6$export$ba29b24e2a92eb58)(attempt)) return attempt;
        return undefined;
    }
    var n = $8f21bd235d951197$var$makeNumber(val);
    if (n == null) return undefined;
    return [
        n,
        n
    ];
}
function $8f21bd235d951197$var$onlyAllowNumbers(data) {
    return data.map($8f21bd235d951197$var$makeNumber).filter((0, $9a1343d05dde836c$export$7e515ab5fbd92bef));
}
function $8f21bd235d951197$export$25971beae035f58a(entry, appliedValue, relevantErrorBars) {
    if (!relevantErrorBars || typeof appliedValue !== 'number' || (0, $9a1343d05dde836c$export$e426a261f3212d7d)(appliedValue)) return [];
    if (!relevantErrorBars.length) return [];
    return $8f21bd235d951197$var$onlyAllowNumbers(relevantErrorBars.flatMap((eb)=>{
        var errorValue = (0, $912d8cf1d03ea507$export$f97fc4a450f29a)(entry, eb.dataKey);
        var lowBound, highBound;
        if (Array.isArray(errorValue)) [lowBound, highBound] = errorValue;
        else lowBound = highBound = errorValue;
        if (!(0, $11a93f8f3c3518e5$export$f8a8fc612ced9bb0)(lowBound) || !(0, $11a93f8f3c3518e5$export$f8a8fc612ced9bb0)(highBound)) return undefined;
        return [
            appliedValue - lowBound,
            appliedValue + highBound
        ];
    }));
}
var $8f21bd235d951197$export$27d9004292294cd7 = (state)=>{
    var axisType = (0, $411fa86e80c20dfb$export$898d3dfd98fb482)(state);
    var axisId = (0, $9a8bc2d38fad28d3$export$eeffdb10daff095d)(state);
    return $8f21bd235d951197$export$3635e5ebe47f85a9(state, axisType, axisId);
};
var $8f21bd235d951197$export$bf8397fefbaa3617 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$27d9004292294cd7
], (axis)=>axis === null || axis === void 0 ? void 0 : axis.dataKey);
var $8f21bd235d951197$export$b329ef9482661e60 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$58ad06f71246a0da,
    (0, $d6cc9cc11e425d5b$export$fe05134c2701d897),
    $8f21bd235d951197$export$27d9004292294cd7
], (0, $0c25d0c543be64c4$export$ae6c77e7720cddf9));
var $8f21bd235d951197$export$9312914d13496409 = (displayedData, items, stackOffsetType, reverseStackOrder)=>{
    var initialItemsGroups = {};
    var itemsGroup = items.reduce((acc, item)=>{
        if (item.stackId == null) return acc;
        var stack = acc[item.stackId];
        if (stack == null) stack = [];
        stack.push(item);
        acc[item.stackId] = stack;
        return acc;
    }, initialItemsGroups);
    return Object.fromEntries(Object.entries(itemsGroup).map((_ref2)=>{
        var [stackId, graphicalItems] = _ref2;
        var orderedGraphicalItems = reverseStackOrder ? [
            ...graphicalItems
        ].reverse() : graphicalItems;
        var dataKeys = orderedGraphicalItems.map((0, $e87b7d47ab6fc507$export$58b095b87bc46727));
        return [
            stackId,
            {
                // @ts-expect-error getStackedData requires that the input is array of objects, Recharts does not test for that
                stackedData: (0, $912d8cf1d03ea507$export$c2170542cfc0177c)(displayedData, dataKeys, stackOffsetType),
                graphicalItems: orderedGraphicalItems
            }
        ];
    }));
};
var $8f21bd235d951197$export$af2278e5e47fc440 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$b329ef9482661e60,
    $8f21bd235d951197$export$58ad06f71246a0da,
    (0, $d319e2ad1ad322d2$export$73aff39176364def),
    (0, $d319e2ad1ad322d2$export$ec830dc49707c6da)
], $8f21bd235d951197$export$9312914d13496409);
var $8f21bd235d951197$export$3286b8ea6ff06720 = (stackGroups, _ref3, axisType, domainFromUserPreference)=>{
    var { dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = _ref3;
    if (domainFromUserPreference != null) // User has specified a domain, so we respect that and we can skip computing anything else
    return undefined;
    if (axisType === 'zAxis') // ZAxis ignores stacks
    return undefined;
    var domainOfStackGroups = (0, $912d8cf1d03ea507$export$26522b779eb5497c)(stackGroups, dataStartIndex, dataEndIndex);
    if (domainOfStackGroups != null && domainOfStackGroups[0] === 0 && domainOfStackGroups[1] === 0) return undefined;
    return domainOfStackGroups;
};
var $8f21bd235d951197$var$selectAllowsDataOverflow = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$fc14c3706e09c50c
], (axisSettings)=>axisSettings.allowDataOverflow);
var $8f21bd235d951197$export$2e6262b6c952ab02 = (axisSettings)=>{
    var _axisSettings$domain;
    if (axisSettings == null || !('domain' in axisSettings)) return $8f21bd235d951197$export$a012a4dce80491c2;
    if (axisSettings.domain != null) return axisSettings.domain;
    if ('ticks' in axisSettings && axisSettings.ticks != null) {
        if (axisSettings.type === 'number') {
            var allValues = $8f21bd235d951197$var$onlyAllowNumbers(axisSettings.ticks);
            return [
                Math.min(...allValues),
                Math.max(...allValues)
            ];
        }
        if (axisSettings.type === 'category') return axisSettings.ticks.map(String);
    }
    return (_axisSettings$domain = axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.domain) !== null && _axisSettings$domain !== void 0 ? _axisSettings$domain : $8f21bd235d951197$export$a012a4dce80491c2;
};
var $8f21bd235d951197$export$5d46410c3f089eb2 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$fc14c3706e09c50c
], $8f21bd235d951197$export$2e6262b6c952ab02);
var $8f21bd235d951197$export$c21dc69ecce61f8a = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$5d46410c3f089eb2,
    $8f21bd235d951197$var$selectAllowsDataOverflow
], (0, $10a31e6d89f791d6$export$fcbf88d4627b24df));
var $8f21bd235d951197$export$969bc8d84122c036 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$af2278e5e47fc440,
    (0, $d6cc9cc11e425d5b$export$519edd692222520),
    (0, $2166cd81382e43aa$export$8a7d579879340d98),
    $8f21bd235d951197$export$c21dc69ecce61f8a
], $8f21bd235d951197$export$3286b8ea6ff06720, {
    memoizeOptions: {
        resultEqualityCheck: (0, $112aba0500e31420$export$45c01007b107f1a6)
    }
});
var $8f21bd235d951197$export$9429ab4550237b6d = (state)=>state.errorBars;
var $8f21bd235d951197$var$combineRelevantErrorBarSettings = (cartesianItemsSettings, allErrorBarSettings, axisType)=>{
    return cartesianItemsSettings.flatMap((item)=>{
        return allErrorBarSettings[item.id];
    }).filter(Boolean).filter((e)=>{
        return $8f21bd235d951197$export$8b0eb5a8c39b724f(axisType, e);
    });
};
var $8f21bd235d951197$export$9c8185c6eda0fb0d = function mergeDomains() {
    for(var _len = arguments.length, domains = new Array(_len), _key = 0; _key < _len; _key++)domains[_key] = arguments[_key];
    var allDomains = domains.filter(Boolean);
    if (allDomains.length === 0) return undefined;
    var allValues = allDomains.flat();
    var min = Math.min(...allValues);
    var max = Math.max(...allValues);
    return [
        min,
        max
    ];
};
var $8f21bd235d951197$export$df56c8e9a3e45e65 = (data, axisSettings, items, errorBars, axisType)=>{
    var lowerEnd, upperEnd;
    if (items.length > 0) data.forEach((entry)=>{
        items.forEach((item)=>{
            var _errorBars$item$id, _axisSettings$dataKey;
            var relevantErrorBars = (_errorBars$item$id = errorBars[item.id]) === null || _errorBars$item$id === void 0 ? void 0 : _errorBars$item$id.filter((errorBar)=>$8f21bd235d951197$export$8b0eb5a8c39b724f(axisType, errorBar));
            var valueByDataKey = (0, $912d8cf1d03ea507$export$f97fc4a450f29a)(entry, (_axisSettings$dataKey = axisSettings.dataKey) !== null && _axisSettings$dataKey !== void 0 ? _axisSettings$dataKey : item.dataKey);
            var errorDomain = $8f21bd235d951197$export$25971beae035f58a(entry, valueByDataKey, relevantErrorBars);
            if (errorDomain.length >= 2) {
                var localLower = Math.min(...errorDomain);
                var localUpper = Math.max(...errorDomain);
                if (lowerEnd == null || localLower < lowerEnd) lowerEnd = localLower;
                if (upperEnd == null || localUpper > upperEnd) upperEnd = localUpper;
            }
            var dataValueDomain = $8f21bd235d951197$var$makeDomain(valueByDataKey);
            if (dataValueDomain != null) {
                lowerEnd = lowerEnd == null ? dataValueDomain[0] : Math.min(lowerEnd, dataValueDomain[0]);
                upperEnd = upperEnd == null ? dataValueDomain[1] : Math.max(upperEnd, dataValueDomain[1]);
            }
        });
    });
    if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.dataKey) != null) data.forEach((item)=>{
        var dataValueDomain = $8f21bd235d951197$var$makeDomain((0, $912d8cf1d03ea507$export$f97fc4a450f29a)(item, axisSettings.dataKey));
        if (dataValueDomain != null) {
            lowerEnd = lowerEnd == null ? dataValueDomain[0] : Math.min(lowerEnd, dataValueDomain[0]);
            upperEnd = upperEnd == null ? dataValueDomain[1] : Math.max(upperEnd, dataValueDomain[1]);
        }
    });
    if ((0, $11a93f8f3c3518e5$export$f8a8fc612ced9bb0)(lowerEnd) && (0, $11a93f8f3c3518e5$export$f8a8fc612ced9bb0)(upperEnd)) return [
        lowerEnd,
        upperEnd
    ];
    return undefined;
};
var $8f21bd235d951197$var$selectDomainOfAllAppliedNumericalValuesIncludingErrorValues = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$6099ba314905f0c4,
    $8f21bd235d951197$export$fc14c3706e09c50c,
    $8f21bd235d951197$var$selectCartesianItemsSettingsExceptStacked,
    $8f21bd235d951197$export$9429ab4550237b6d,
    (0, $2166cd81382e43aa$export$8a7d579879340d98)
], $8f21bd235d951197$export$df56c8e9a3e45e65, {
    memoizeOptions: {
        resultEqualityCheck: (0, $112aba0500e31420$export$45c01007b107f1a6)
    }
});
function $8f21bd235d951197$var$onlyAllowNumbersAndStringsAndDates(item) {
    var { value: value } = item;
    if ((0, $9a1343d05dde836c$export$402a499e1ea44294)(value) || value instanceof Date) return value;
    return undefined;
}
var $8f21bd235d951197$var$computeDomainOfTypeCategory = (allDataSquished, axisSettings, isCategorical)=>{
    var categoricalDomain = allDataSquished.map($8f21bd235d951197$var$onlyAllowNumbersAndStringsAndDates).filter((v)=>v != null);
    if (isCategorical && (axisSettings.dataKey == null || axisSettings.allowDuplicatedCategory && (0, $9a1343d05dde836c$export$732baf6a98f122)(categoricalDomain))) /*
     * 1. In an absence of dataKey, Recharts will use array indexes as its categorical domain
     * 2. When category axis has duplicated text, serial numbers are used to generate scale
     */ return (0, (/*@__PURE__*/$parcel$interopDefault($45c9781546233b1d$exports)))(0, allDataSquished.length);
    if (axisSettings.allowDuplicatedCategory) return categoricalDomain;
    return Array.from(new Set(categoricalDomain));
};
var $8f21bd235d951197$export$71580de5ed38161a = (state)=>state.referenceElements.dots;
var $8f21bd235d951197$export$2829d12117d2002f = (elements, axisType, axisId)=>{
    return elements.filter((el)=>el.ifOverflow === 'extendDomain').filter((el)=>{
        if (axisType === 'xAxis') return el.xAxisId === axisId;
        return el.yAxisId === axisId;
    });
};
var $8f21bd235d951197$export$dc267b7b9026caca = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$71580de5ed38161a,
    (0, $2166cd81382e43aa$export$8a7d579879340d98),
    (0, $7919f41c64f031eb$export$6a2efa106dc9c8f6)
], $8f21bd235d951197$export$2829d12117d2002f);
var $8f21bd235d951197$export$c7e152cb7f10c1a6 = (state)=>state.referenceElements.areas;
var $8f21bd235d951197$export$699de899b7bc81a9 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$c7e152cb7f10c1a6,
    (0, $2166cd81382e43aa$export$8a7d579879340d98),
    (0, $7919f41c64f031eb$export$6a2efa106dc9c8f6)
], $8f21bd235d951197$export$2829d12117d2002f);
var $8f21bd235d951197$export$8fe2a49ce63c5348 = (state)=>state.referenceElements.lines;
var $8f21bd235d951197$export$29b80feb73eec2b3 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$8fe2a49ce63c5348,
    (0, $2166cd81382e43aa$export$8a7d579879340d98),
    (0, $7919f41c64f031eb$export$6a2efa106dc9c8f6)
], $8f21bd235d951197$export$2829d12117d2002f);
var $8f21bd235d951197$export$5da0b79fd816ec4b = (dots, axisType)=>{
    if (dots == null) return undefined;
    var allCoords = $8f21bd235d951197$var$onlyAllowNumbers(dots.map((dot)=>axisType === 'xAxis' ? dot.x : dot.y));
    if (allCoords.length === 0) return undefined;
    return [
        Math.min(...allCoords),
        Math.max(...allCoords)
    ];
};
var $8f21bd235d951197$var$selectReferenceDotsDomain = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)($8f21bd235d951197$export$dc267b7b9026caca, (0, $2166cd81382e43aa$export$8a7d579879340d98), $8f21bd235d951197$export$5da0b79fd816ec4b);
var $8f21bd235d951197$export$7b27918cf5e1fc19 = (areas, axisType)=>{
    if (areas == null) return undefined;
    var allCoords = $8f21bd235d951197$var$onlyAllowNumbers(areas.flatMap((area)=>[
            axisType === 'xAxis' ? area.x1 : area.y1,
            axisType === 'xAxis' ? area.x2 : area.y2
        ]));
    if (allCoords.length === 0) return undefined;
    return [
        Math.min(...allCoords),
        Math.max(...allCoords)
    ];
};
var $8f21bd235d951197$var$selectReferenceAreasDomain = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$699de899b7bc81a9,
    (0, $2166cd81382e43aa$export$8a7d579879340d98)
], $8f21bd235d951197$export$7b27918cf5e1fc19);
function $8f21bd235d951197$var$extractXCoordinates(line) {
    var _line$segment;
    if (line.x != null) return $8f21bd235d951197$var$onlyAllowNumbers([
        line.x
    ]);
    var segmentCoordinates = (_line$segment = line.segment) === null || _line$segment === void 0 ? void 0 : _line$segment.map((s)=>s.x);
    if (segmentCoordinates == null || segmentCoordinates.length === 0) return [];
    return $8f21bd235d951197$var$onlyAllowNumbers(segmentCoordinates);
}
function $8f21bd235d951197$var$extractYCoordinates(line) {
    var _line$segment2;
    if (line.y != null) return $8f21bd235d951197$var$onlyAllowNumbers([
        line.y
    ]);
    var segmentCoordinates = (_line$segment2 = line.segment) === null || _line$segment2 === void 0 ? void 0 : _line$segment2.map((s)=>s.y);
    if (segmentCoordinates == null || segmentCoordinates.length === 0) return [];
    return $8f21bd235d951197$var$onlyAllowNumbers(segmentCoordinates);
}
var $8f21bd235d951197$export$f1d17aebd11953eb = (lines, axisType)=>{
    if (lines == null) return undefined;
    var allCoords = lines.flatMap((line)=>axisType === 'xAxis' ? $8f21bd235d951197$var$extractXCoordinates(line) : $8f21bd235d951197$var$extractYCoordinates(line));
    if (allCoords.length === 0) return undefined;
    return [
        Math.min(...allCoords),
        Math.max(...allCoords)
    ];
};
var $8f21bd235d951197$var$selectReferenceLinesDomain = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$29b80feb73eec2b3,
    (0, $2166cd81382e43aa$export$8a7d579879340d98)
], $8f21bd235d951197$export$f1d17aebd11953eb);
var $8f21bd235d951197$var$selectReferenceElementsDomain = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)($8f21bd235d951197$var$selectReferenceDotsDomain, $8f21bd235d951197$var$selectReferenceLinesDomain, $8f21bd235d951197$var$selectReferenceAreasDomain, (dotsDomain, linesDomain, areasDomain)=>{
    return $8f21bd235d951197$export$9c8185c6eda0fb0d(dotsDomain, areasDomain, linesDomain);
});
var $8f21bd235d951197$export$b9eca0fd568f66a4 = (axisSettings, domainDefinition, domainFromUserPreference, domainOfStackGroups, dataAndErrorBarsDomain, referenceElementsDomain, layout, axisType)=>{
    if (domainFromUserPreference != null) // We're done! No need to compute anything else.
    return domainFromUserPreference;
    var shouldIncludeDomainOfStackGroups = layout === 'vertical' && axisType === 'xAxis' || layout === 'horizontal' && axisType === 'yAxis';
    var mergedDomains = shouldIncludeDomainOfStackGroups ? $8f21bd235d951197$export$9c8185c6eda0fb0d(domainOfStackGroups, referenceElementsDomain, dataAndErrorBarsDomain) : $8f21bd235d951197$export$9c8185c6eda0fb0d(referenceElementsDomain, dataAndErrorBarsDomain);
    return (0, $10a31e6d89f791d6$export$3f87aa7a53437a70)(domainDefinition, mergedDomains, axisSettings.allowDataOverflow);
};
var $8f21bd235d951197$export$2a64502fccb4dfa6 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$fc14c3706e09c50c,
    $8f21bd235d951197$export$5d46410c3f089eb2,
    $8f21bd235d951197$export$c21dc69ecce61f8a,
    $8f21bd235d951197$export$969bc8d84122c036,
    $8f21bd235d951197$var$selectDomainOfAllAppliedNumericalValuesIncludingErrorValues,
    $8f21bd235d951197$var$selectReferenceElementsDomain,
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    (0, $2166cd81382e43aa$export$8a7d579879340d98)
], $8f21bd235d951197$export$b9eca0fd568f66a4, {
    memoizeOptions: {
        resultEqualityCheck: (0, $112aba0500e31420$export$45c01007b107f1a6)
    }
});
/**
 * Expand by design maps everything between 0 and 1,
 * there is nothing to compute.
 * See https://d3js.org/d3-shape/stack#stack-offsets
 */ var $8f21bd235d951197$var$expandDomain = [
    0,
    1
];
var $8f21bd235d951197$export$70e6ef68424edf74 = (axisSettings, layout, displayedData, allAppliedValues, stackOffsetType, axisType, numericalDomain)=>{
    if ((axisSettings == null || displayedData == null || displayedData.length === 0) && numericalDomain === undefined) return undefined;
    var { dataKey: dataKey, type: type } = axisSettings;
    var isCategorical = (0, $912d8cf1d03ea507$export$9fc1baaa6c6368b)(layout, axisType);
    if (isCategorical && dataKey == null) {
        var _displayedData$length;
        return (0, (/*@__PURE__*/$parcel$interopDefault($45c9781546233b1d$exports)))(0, (_displayedData$length = displayedData === null || displayedData === void 0 ? void 0 : displayedData.length) !== null && _displayedData$length !== void 0 ? _displayedData$length : 0);
    }
    if (type === 'category') return $8f21bd235d951197$var$computeDomainOfTypeCategory(allAppliedValues, axisSettings, isCategorical);
    if (stackOffsetType === 'expand') return $8f21bd235d951197$var$expandDomain;
    return numericalDomain;
};
var $8f21bd235d951197$export$4fc5ecb5227dd744 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$fc14c3706e09c50c,
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    $8f21bd235d951197$export$6099ba314905f0c4,
    $8f21bd235d951197$export$9cea618b690f07b7,
    (0, $d319e2ad1ad322d2$export$73aff39176364def),
    (0, $2166cd81382e43aa$export$8a7d579879340d98),
    $8f21bd235d951197$export$2a64502fccb4dfa6
], $8f21bd235d951197$export$70e6ef68424edf74);
var $8f21bd235d951197$export$bebec32544750591 = (axisConfig, layout, hasBar, chartType, axisType)=>{
    if (axisConfig == null) return undefined;
    var { scale: scale, type: type } = axisConfig;
    if (scale === 'auto') {
        if (layout === 'radial' && axisType === 'radiusAxis') return 'band';
        if (layout === 'radial' && axisType === 'angleAxis') return 'linear';
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return 'point';
        if (type === 'category') return 'band';
        return 'linear';
    }
    if (typeof scale === 'string') {
        var name = "scale".concat((0, $9a1343d05dde836c$export$3061f22cd819074d)(scale));
        return name in $1cd2e188ffea0020$exports ? name : 'point';
    }
    return undefined;
};
var $8f21bd235d951197$export$a1a58ca78bb13ce7 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$fc14c3706e09c50c,
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    $8f21bd235d951197$export$1c7798b82c8010cd,
    (0, $d319e2ad1ad322d2$export$3247769c9dbde559),
    (0, $2166cd81382e43aa$export$8a7d579879340d98)
], $8f21bd235d951197$export$bebec32544750591);
function $8f21bd235d951197$var$getD3ScaleFromType(realScaleType) {
    if (realScaleType == null) return undefined;
    if (realScaleType in $1cd2e188ffea0020$exports) // @ts-expect-error we should do better type verification here
    return $1cd2e188ffea0020$exports[realScaleType]();
    var name = "scale".concat((0, $9a1343d05dde836c$export$3061f22cd819074d)(realScaleType));
    if (name in $1cd2e188ffea0020$exports) // @ts-expect-error we should do better type verification here
    return $1cd2e188ffea0020$exports[name]();
    return undefined;
}
function $8f21bd235d951197$export$e2fe61793fcf6495(axis, realScaleType, axisDomain, axisRange) {
    if (axisDomain == null || axisRange == null) return undefined;
    if (typeof axis.scale === 'function') // @ts-expect-error we're going to assume here that if axis.scale is a function then it is a d3Scale function
    return axis.scale.copy().domain(axisDomain).range(axisRange);
    var d3ScaleFunction = $8f21bd235d951197$var$getD3ScaleFromType(realScaleType);
    if (d3ScaleFunction == null) return undefined;
    var scale = d3ScaleFunction.domain(axisDomain).range(axisRange);
    // I don't like this function because it mutates the scale. We should come up with a way to compute the domain up front.
    (0, $912d8cf1d03ea507$export$9d80152e23bae434)(scale);
    return scale;
}
var $8f21bd235d951197$export$aa1ef6c8f610e48c = (axisDomain, axisSettings, realScaleType)=>{
    var domainDefinition = $8f21bd235d951197$export$2e6262b6c952ab02(axisSettings);
    if (realScaleType !== 'auto' && realScaleType !== 'linear') return undefined;
    if (axisSettings != null && axisSettings.tickCount && Array.isArray(domainDefinition) && (domainDefinition[0] === 'auto' || domainDefinition[1] === 'auto') && (0, $10a31e6d89f791d6$export$ba29b24e2a92eb58)(axisDomain)) return (0, $5095dcff3396f81a$export$b84e75ccbfe6a612)(axisDomain, axisSettings.tickCount, axisSettings.allowDecimals);
    if (axisSettings != null && axisSettings.tickCount && axisSettings.type === 'number' && (0, $10a31e6d89f791d6$export$ba29b24e2a92eb58)(axisDomain)) return (0, $5095dcff3396f81a$export$e9d28da780436e98)(axisDomain, axisSettings.tickCount, axisSettings.allowDecimals);
    return undefined;
};
var $8f21bd235d951197$export$2efb9b5d95659d33 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$4fc5ecb5227dd744,
    $8f21bd235d951197$export$3635e5ebe47f85a9,
    $8f21bd235d951197$export$a1a58ca78bb13ce7
], $8f21bd235d951197$export$aa1ef6c8f610e48c);
var $8f21bd235d951197$export$3a4530026b1860ff = (axisSettings, domain, niceTicks, axisType)=>{
    if (/*
   * Angle axis for some reason uses nice ticks when rendering axis tick labels,
   * but doesn't use nice ticks for extending domain like all the other axes do.
   * Not really sure why? Is there a good reason,
   * or is it just because someone added support for nice ticks to the other axes and forgot this one?
   */ axisType !== 'angleAxis' && (axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.type) === 'number' && (0, $10a31e6d89f791d6$export$ba29b24e2a92eb58)(domain) && Array.isArray(niceTicks) && niceTicks.length > 0) {
        var minFromDomain = domain[0];
        var minFromTicks = niceTicks[0];
        var maxFromDomain = domain[1];
        var maxFromTicks = niceTicks[niceTicks.length - 1];
        return [
            Math.min(minFromDomain, minFromTicks),
            Math.max(maxFromDomain, maxFromTicks)
        ];
    }
    return domain;
};
var $8f21bd235d951197$export$af7761c6ea30fae4 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$fc14c3706e09c50c,
    $8f21bd235d951197$export$4fc5ecb5227dd744,
    $8f21bd235d951197$export$2efb9b5d95659d33,
    (0, $2166cd81382e43aa$export$8a7d579879340d98)
], $8f21bd235d951197$export$3a4530026b1860ff);
var $8f21bd235d951197$export$a1013ea99dfe6af9 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)($8f21bd235d951197$export$9cea618b690f07b7, $8f21bd235d951197$export$fc14c3706e09c50c, (allDataSquished, axisSettings)=>{
    if (!axisSettings || axisSettings.type !== 'number') return undefined;
    var smallestDistanceBetweenValues = Infinity;
    var sortedValues = Array.from($8f21bd235d951197$var$onlyAllowNumbers(allDataSquished.map((d)=>d.value))).sort((a, b)=>a - b);
    var first = sortedValues[0];
    var last = sortedValues[sortedValues.length - 1];
    if (first == null || last == null) return Infinity;
    var diff = last - first;
    if (diff === 0) return Infinity;
    // Only do n - 1 distance calculations because there's only n - 1 distances between n values.
    for(var i = 0; i < sortedValues.length - 1; i++){
        var curr = sortedValues[i];
        var next = sortedValues[i + 1];
        if (curr == null || next == null) continue;
        var distance = next - curr;
        smallestDistanceBetweenValues = Math.min(smallestDistanceBetweenValues, distance);
    }
    return smallestDistanceBetweenValues / diff;
});
var $8f21bd235d951197$var$selectCalculatedPadding = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)($8f21bd235d951197$export$a1013ea99dfe6af9, (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee), (0, $d319e2ad1ad322d2$export$a73f9d39b015942a), (0, $4d79bfb805950901$export$1e34c8efb0bc9b3b), (_1, _2, _3, _4, padding)=>padding, (smallestDistanceInPercent, layout, barCategoryGap, offset, padding)=>{
    if (!(0, $11a93f8f3c3518e5$export$f8a8fc612ced9bb0)(smallestDistanceInPercent)) return 0;
    var rangeWidth = layout === 'vertical' ? offset.height : offset.width;
    if (padding === 'gap') return smallestDistanceInPercent * rangeWidth / 2;
    if (padding === 'no-gap') {
        var gap = (0, $9a1343d05dde836c$export$476354dbf49bdff6)(barCategoryGap, smallestDistanceInPercent * rangeWidth);
        var halfBand = smallestDistanceInPercent * rangeWidth / 2;
        return halfBand - gap - (halfBand - gap) / rangeWidth * gap;
    }
    return 0;
});
var $8f21bd235d951197$export$29cb35c3432eef0e = (state, axisId, isPanorama)=>{
    var xAxisSettings = $8f21bd235d951197$export$d6895d8ddb4cee5(state, axisId);
    if (xAxisSettings == null || typeof xAxisSettings.padding !== 'string') return 0;
    return $8f21bd235d951197$var$selectCalculatedPadding(state, 'xAxis', axisId, isPanorama, xAxisSettings.padding);
};
var $8f21bd235d951197$export$689bf02345b2d857 = (state, axisId, isPanorama)=>{
    var yAxisSettings = $8f21bd235d951197$export$1f472705a332f1c9(state, axisId);
    if (yAxisSettings == null || typeof yAxisSettings.padding !== 'string') return 0;
    return $8f21bd235d951197$var$selectCalculatedPadding(state, 'yAxis', axisId, isPanorama, yAxisSettings.padding);
};
var $8f21bd235d951197$var$selectXAxisPadding = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)($8f21bd235d951197$export$d6895d8ddb4cee5, $8f21bd235d951197$export$29cb35c3432eef0e, (xAxisSettings, calculated)=>{
    var _padding$left, _padding$right;
    if (xAxisSettings == null) return {
        left: 0,
        right: 0
    };
    var { padding: padding } = xAxisSettings;
    if (typeof padding === 'string') return {
        left: calculated,
        right: calculated
    };
    return {
        left: ((_padding$left = padding.left) !== null && _padding$left !== void 0 ? _padding$left : 0) + calculated,
        right: ((_padding$right = padding.right) !== null && _padding$right !== void 0 ? _padding$right : 0) + calculated
    };
});
var $8f21bd235d951197$var$selectYAxisPadding = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)($8f21bd235d951197$export$1f472705a332f1c9, $8f21bd235d951197$export$689bf02345b2d857, (yAxisSettings, calculated)=>{
    var _padding$top, _padding$bottom;
    if (yAxisSettings == null) return {
        top: 0,
        bottom: 0
    };
    var { padding: padding } = yAxisSettings;
    if (typeof padding === 'string') return {
        top: calculated,
        bottom: calculated
    };
    return {
        top: ((_padding$top = padding.top) !== null && _padding$top !== void 0 ? _padding$top : 0) + calculated,
        bottom: ((_padding$bottom = padding.bottom) !== null && _padding$bottom !== void 0 ? _padding$bottom : 0) + calculated
    };
});
var $8f21bd235d951197$export$f90f75eaf1068eb1 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $4d79bfb805950901$export$1e34c8efb0bc9b3b),
    $8f21bd235d951197$var$selectXAxisPadding,
    (0, $fec5f39ba81f558d$export$3b81e97eae001823),
    (0, $fec5f39ba81f558d$export$5ba94b496f8dc52e),
    (_state, _axisId, isPanorama)=>isPanorama
], (offset, padding, brushDimensions, _ref4, isPanorama)=>{
    var { padding: brushPadding } = _ref4;
    if (isPanorama) return [
        brushPadding.left,
        brushDimensions.width - brushPadding.right
    ];
    return [
        offset.left + padding.left,
        offset.left + offset.width - padding.right
    ];
});
var $8f21bd235d951197$export$90c620fc44f45640 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $4d79bfb805950901$export$1e34c8efb0bc9b3b),
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    $8f21bd235d951197$var$selectYAxisPadding,
    (0, $fec5f39ba81f558d$export$3b81e97eae001823),
    (0, $fec5f39ba81f558d$export$5ba94b496f8dc52e),
    (_state, _axisId, isPanorama)=>isPanorama
], (offset, layout, padding, brushDimensions, _ref5, isPanorama)=>{
    var { padding: brushPadding } = _ref5;
    if (isPanorama) return [
        brushDimensions.height - brushPadding.bottom,
        brushPadding.top
    ];
    if (layout === 'horizontal') return [
        offset.top + offset.height - padding.bottom,
        offset.top + padding.top
    ];
    return [
        offset.top + padding.top,
        offset.top + offset.height - padding.bottom
    ];
});
var $8f21bd235d951197$export$3506ed461810cc8f = (state, axisType, axisId, isPanorama)=>{
    var _selectZAxisSettings;
    switch(axisType){
        case 'xAxis':
            return $8f21bd235d951197$export$f90f75eaf1068eb1(state, axisId, isPanorama);
        case 'yAxis':
            return $8f21bd235d951197$export$90c620fc44f45640(state, axisId, isPanorama);
        case 'zAxis':
            return (_selectZAxisSettings = $8f21bd235d951197$export$26eadf639b453d0f(state, axisId)) === null || _selectZAxisSettings === void 0 ? void 0 : _selectZAxisSettings.range;
        case 'angleAxis':
            return (0, $fe99398211301319$export$d00c8e94622c940)(state);
        case 'radiusAxis':
            return (0, $fe99398211301319$export$e13d847e4d4f833f)(state, axisId);
        default:
            return undefined;
    }
};
var $8f21bd235d951197$export$d6d5faff23feedea = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$fc14c3706e09c50c,
    $8f21bd235d951197$export$3506ed461810cc8f
], (0, $aa9bf5f7fc1905d1$export$3f7e30291950e694));
var $8f21bd235d951197$export$22e8e5f8924724ea = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$fc14c3706e09c50c,
    $8f21bd235d951197$export$a1a58ca78bb13ce7,
    $8f21bd235d951197$export$af7761c6ea30fae4,
    $8f21bd235d951197$export$d6d5faff23feedea
], $8f21bd235d951197$export$e2fe61793fcf6495);
var $8f21bd235d951197$export$565b9812b1d7c04f = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$533d13f911334c9d,
    $8f21bd235d951197$export$9429ab4550237b6d,
    (0, $2166cd81382e43aa$export$8a7d579879340d98)
], $8f21bd235d951197$var$combineRelevantErrorBarSettings);
function $8f21bd235d951197$var$compareIds(a, b) {
    if (a.id < b.id) return -1;
    if (a.id > b.id) return 1;
    return 0;
}
var $8f21bd235d951197$var$pickAxisOrientation = (_state, orientation)=>orientation;
var $8f21bd235d951197$var$pickMirror = (_state, _orientation, mirror)=>mirror;
var $8f21bd235d951197$var$selectAllXAxesWithOffsetType = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)((0, $407ef552851b9401$export$bd320344232f30af), $8f21bd235d951197$var$pickAxisOrientation, $8f21bd235d951197$var$pickMirror, (allAxes, orientation, mirror)=>allAxes.filter((axis)=>axis.orientation === orientation).filter((axis)=>axis.mirror === mirror).sort($8f21bd235d951197$var$compareIds));
var $8f21bd235d951197$var$selectAllYAxesWithOffsetType = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)((0, $407ef552851b9401$export$e22adabb0128cf25), $8f21bd235d951197$var$pickAxisOrientation, $8f21bd235d951197$var$pickMirror, (allAxes, orientation, mirror)=>allAxes.filter((axis)=>axis.orientation === orientation).filter((axis)=>axis.mirror === mirror).sort($8f21bd235d951197$var$compareIds));
var $8f21bd235d951197$var$getXAxisSize = (offset, axisSettings)=>{
    return {
        width: offset.width,
        height: axisSettings.height
    };
};
var $8f21bd235d951197$var$getYAxisSize = (offset, axisSettings)=>{
    var width = typeof axisSettings.width === 'number' ? axisSettings.width : (0, $3114cbf50b21aaf4$export$fb6ee82c8ee2faf8);
    return {
        width: width,
        height: offset.height
    };
};
var $8f21bd235d951197$export$50d4085c87c19b12 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)((0, $4d79bfb805950901$export$1e34c8efb0bc9b3b), $8f21bd235d951197$export$d6895d8ddb4cee5, $8f21bd235d951197$var$getXAxisSize);
var $8f21bd235d951197$var$combineXAxisPositionStartingPoint = (offset, orientation, chartHeight)=>{
    switch(orientation){
        case 'top':
            return offset.top;
        case 'bottom':
            return chartHeight - offset.bottom;
        default:
            return 0;
    }
};
var $8f21bd235d951197$var$combineYAxisPositionStartingPoint = (offset, orientation, chartWidth)=>{
    switch(orientation){
        case 'left':
            return offset.left;
        case 'right':
            return chartWidth - offset.right;
        default:
            return 0;
    }
};
var $8f21bd235d951197$export$6cb04966ad155e81 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)((0, $52905d0b62bb57b1$export$5856a7d94c109505), (0, $4d79bfb805950901$export$1e34c8efb0bc9b3b), $8f21bd235d951197$var$selectAllXAxesWithOffsetType, $8f21bd235d951197$var$pickAxisOrientation, $8f21bd235d951197$var$pickMirror, (chartHeight, offset, allAxesWithSameOffsetType, orientation, mirror)=>{
    var steps = {};
    var position;
    allAxesWithSameOffsetType.forEach((axis)=>{
        var axisSize = $8f21bd235d951197$var$getXAxisSize(offset, axis);
        if (position == null) position = $8f21bd235d951197$var$combineXAxisPositionStartingPoint(offset, orientation, chartHeight);
        var needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
        steps[axis.id] = position - Number(needSpace) * axisSize.height;
        position += (needSpace ? -1 : 1) * axisSize.height;
    });
    return steps;
});
var $8f21bd235d951197$export$edba808018e1c207 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)((0, $52905d0b62bb57b1$export$771ef0ac044f724d), (0, $4d79bfb805950901$export$1e34c8efb0bc9b3b), $8f21bd235d951197$var$selectAllYAxesWithOffsetType, $8f21bd235d951197$var$pickAxisOrientation, $8f21bd235d951197$var$pickMirror, (chartWidth, offset, allAxesWithSameOffsetType, orientation, mirror)=>{
    var steps = {};
    var position;
    allAxesWithSameOffsetType.forEach((axis)=>{
        var axisSize = $8f21bd235d951197$var$getYAxisSize(offset, axis);
        if (position == null) position = $8f21bd235d951197$var$combineYAxisPositionStartingPoint(offset, orientation, chartWidth);
        var needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
        steps[axis.id] = position - Number(needSpace) * axisSize.width;
        position += (needSpace ? -1 : 1) * axisSize.width;
    });
    return steps;
});
var $8f21bd235d951197$var$selectXAxisOffsetSteps = (state, axisId)=>{
    var axisSettings = $8f21bd235d951197$export$d6895d8ddb4cee5(state, axisId);
    if (axisSettings == null) return undefined;
    return $8f21bd235d951197$export$6cb04966ad155e81(state, axisSettings.orientation, axisSettings.mirror);
};
var $8f21bd235d951197$export$92fdc590d2371053 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $4d79bfb805950901$export$1e34c8efb0bc9b3b),
    $8f21bd235d951197$export$d6895d8ddb4cee5,
    $8f21bd235d951197$var$selectXAxisOffsetSteps,
    (_, axisId)=>axisId
], (offset, axisSettings, allSteps, axisId)=>{
    if (axisSettings == null) return undefined;
    var stepOfThisAxis = allSteps === null || allSteps === void 0 ? void 0 : allSteps[axisId];
    if (stepOfThisAxis == null) return {
        x: offset.left,
        y: 0
    };
    return {
        x: offset.left,
        y: stepOfThisAxis
    };
});
var $8f21bd235d951197$var$selectYAxisOffsetSteps = (state, axisId)=>{
    var axisSettings = $8f21bd235d951197$export$1f472705a332f1c9(state, axisId);
    if (axisSettings == null) return undefined;
    return $8f21bd235d951197$export$edba808018e1c207(state, axisSettings.orientation, axisSettings.mirror);
};
var $8f21bd235d951197$export$e67a320452ebcaef = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $4d79bfb805950901$export$1e34c8efb0bc9b3b),
    $8f21bd235d951197$export$1f472705a332f1c9,
    $8f21bd235d951197$var$selectYAxisOffsetSteps,
    (_, axisId)=>axisId
], (offset, axisSettings, allSteps, axisId)=>{
    if (axisSettings == null) return undefined;
    var stepOfThisAxis = allSteps === null || allSteps === void 0 ? void 0 : allSteps[axisId];
    if (stepOfThisAxis == null) return {
        x: 0,
        y: offset.top
    };
    return {
        x: stepOfThisAxis,
        y: offset.top
    };
});
var $8f21bd235d951197$export$249bec756af8ac39 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)((0, $4d79bfb805950901$export$1e34c8efb0bc9b3b), $8f21bd235d951197$export$1f472705a332f1c9, (offset, axisSettings)=>{
    var width = typeof axisSettings.width === 'number' ? axisSettings.width : (0, $3114cbf50b21aaf4$export$fb6ee82c8ee2faf8);
    return {
        width: width,
        height: offset.height
    };
});
var $8f21bd235d951197$export$6d6e642aa7a0ae10 = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return $8f21bd235d951197$export$50d4085c87c19b12(state, axisId).width;
        case 'yAxis':
            return $8f21bd235d951197$export$249bec756af8ac39(state, axisId).height;
        default:
            return undefined;
    }
};
var $8f21bd235d951197$export$bb1ebf56a37bd899 = (chartLayout, appliedValues, axis, axisType)=>{
    if (axis == null) return undefined;
    var { allowDuplicatedCategory: allowDuplicatedCategory, type: type, dataKey: dataKey } = axis;
    var isCategorical = (0, $912d8cf1d03ea507$export$9fc1baaa6c6368b)(chartLayout, axisType);
    var allData = appliedValues.map((av)=>av.value);
    if (dataKey && isCategorical && type === 'category' && allowDuplicatedCategory && (0, $9a1343d05dde836c$export$732baf6a98f122)(allData)) return allData;
    return undefined;
};
var $8f21bd235d951197$export$4fc6aadcd9e9157c = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    $8f21bd235d951197$export$9cea618b690f07b7,
    $8f21bd235d951197$export$fc14c3706e09c50c,
    (0, $2166cd81382e43aa$export$8a7d579879340d98)
], $8f21bd235d951197$export$bb1ebf56a37bd899);
var $8f21bd235d951197$export$911ef47868c9ab07 = (layout, appliedValues, axis, axisType)=>{
    if (axis == null || axis.dataKey == null) return undefined;
    var { type: type, scale: scale } = axis;
    var isCategorical = (0, $912d8cf1d03ea507$export$9fc1baaa6c6368b)(layout, axisType);
    if (isCategorical && (type === 'number' || scale !== 'auto')) return appliedValues.map((d)=>d.value);
    return undefined;
};
var $8f21bd235d951197$export$a6a79e7a5412631c = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    $8f21bd235d951197$export$9cea618b690f07b7,
    $8f21bd235d951197$export$3635e5ebe47f85a9,
    (0, $2166cd81382e43aa$export$8a7d579879340d98)
], $8f21bd235d951197$export$911ef47868c9ab07);
var $8f21bd235d951197$export$45cd57660792dd31 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    $8f21bd235d951197$var$selectCartesianAxisSettings,
    $8f21bd235d951197$export$a1a58ca78bb13ce7,
    $8f21bd235d951197$export$22e8e5f8924724ea,
    $8f21bd235d951197$export$4fc6aadcd9e9157c,
    $8f21bd235d951197$export$a6a79e7a5412631c,
    $8f21bd235d951197$export$3506ed461810cc8f,
    $8f21bd235d951197$export$2efb9b5d95659d33,
    (0, $2166cd81382e43aa$export$8a7d579879340d98)
], (layout, axis, realScaleType, scale, duplicateDomain, categoricalDomain, axisRange, niceTicks, axisType)=>{
    if (axis == null) return undefined;
    var isCategorical = (0, $912d8cf1d03ea507$export$9fc1baaa6c6368b)(layout, axisType);
    return {
        angle: axis.angle,
        interval: axis.interval,
        minTickGap: axis.minTickGap,
        orientation: axis.orientation,
        tick: axis.tick,
        tickCount: axis.tickCount,
        tickFormatter: axis.tickFormatter,
        ticks: axis.ticks,
        type: axis.type,
        unit: axis.unit,
        axisType: axisType,
        categoricalDomain: categoricalDomain,
        duplicateDomain: duplicateDomain,
        isCategorical: isCategorical,
        niceTicks: niceTicks,
        range: axisRange,
        realScaleType: realScaleType,
        scale: scale
    };
});
var $8f21bd235d951197$export$d033262fd214bffb = (layout, axis, realScaleType, scale, niceTicks, axisRange, duplicateDomain, categoricalDomain, axisType)=>{
    if (axis == null || scale == null) return undefined;
    var isCategorical = (0, $912d8cf1d03ea507$export$9fc1baaa6c6368b)(layout, axisType);
    var { type: type, ticks: ticks, tickCount: tickCount } = axis;
    // This is testing for `scaleBand` but for band axis the type is reported as `band` so this looks like a dead code with a workaround elsewhere?
    var offsetForBand = realScaleType === 'scaleBand' && typeof scale.bandwidth === 'function' ? scale.bandwidth() / 2 : 2;
    var offset = type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axisType === 'angleAxis' && axisRange != null && axisRange.length >= 2 ? (0, $9a1343d05dde836c$export$9d334328eb75e624)(axisRange[0] - axisRange[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    var ticksOrNiceTicks = ticks || niceTicks;
    if (ticksOrNiceTicks) {
        var result = ticksOrNiceTicks.map((entry, index)=>{
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                index: index,
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter((row)=>(0, $11a93f8f3c3518e5$export$f8a8fc612ced9bb0)(row.coordinate));
    }
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        })).filter((row)=>(0, $11a93f8f3c3518e5$export$f8a8fc612ced9bb0)(row.coordinate));
    if (scale.ticks) return scale.ticks(tickCount)// @ts-expect-error why does the offset go here? The type does not require it
    .map((entry)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        }));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        }));
};
var $8f21bd235d951197$export$f0d85e8287c47657 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    $8f21bd235d951197$export$3635e5ebe47f85a9,
    $8f21bd235d951197$export$a1a58ca78bb13ce7,
    $8f21bd235d951197$export$22e8e5f8924724ea,
    $8f21bd235d951197$export$2efb9b5d95659d33,
    $8f21bd235d951197$export$3506ed461810cc8f,
    $8f21bd235d951197$export$4fc6aadcd9e9157c,
    $8f21bd235d951197$export$a6a79e7a5412631c,
    (0, $2166cd81382e43aa$export$8a7d579879340d98)
], $8f21bd235d951197$export$d033262fd214bffb);
var $8f21bd235d951197$export$453d0e9212f0369b = (layout, axis, scale, axisRange, duplicateDomain, categoricalDomain, axisType)=>{
    if (axis == null || scale == null || axisRange == null || axisRange[0] === axisRange[1]) return undefined;
    var isCategorical = (0, $912d8cf1d03ea507$export$9fc1baaa6c6368b)(layout, axisType);
    var { tickCount: tickCount } = axis;
    var offset = 0;
    offset = axisType === 'angleAxis' && (axisRange === null || axisRange === void 0 ? void 0 : axisRange.length) >= 2 ? (0, $9a1343d05dde836c$export$9d334328eb75e624)(axisRange[0] - axisRange[1]) * 2 * offset : offset;
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        }));
    if (scale.ticks) return scale.ticks(tickCount)// @ts-expect-error why does the offset go here? The type does not require it
    .map((entry)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        }));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        }));
};
var $8f21bd235d951197$export$b894cb5d8586b43d = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    $8f21bd235d951197$export$3635e5ebe47f85a9,
    $8f21bd235d951197$export$22e8e5f8924724ea,
    $8f21bd235d951197$export$3506ed461810cc8f,
    $8f21bd235d951197$export$4fc6aadcd9e9157c,
    $8f21bd235d951197$export$a6a79e7a5412631c,
    (0, $2166cd81382e43aa$export$8a7d579879340d98)
], $8f21bd235d951197$export$453d0e9212f0369b);
var $8f21bd235d951197$export$db36c2f3bfe5c9d7 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)($8f21bd235d951197$export$fc14c3706e09c50c, $8f21bd235d951197$export$22e8e5f8924724ea, (axis, scale)=>{
    if (axis == null || scale == null) return undefined;
    return $8f21bd235d951197$var$_objectSpread($8f21bd235d951197$var$_objectSpread({}, axis), {}, {
        scale: scale
    });
});
var $8f21bd235d951197$var$selectZAxisScale = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $8f21bd235d951197$export$fc14c3706e09c50c,
    $8f21bd235d951197$export$a1a58ca78bb13ce7,
    $8f21bd235d951197$export$4fc5ecb5227dd744,
    $8f21bd235d951197$export$d6d5faff23feedea
], $8f21bd235d951197$export$e2fe61793fcf6495);
var $8f21bd235d951197$export$4dab5213d1420bb3 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)((state, _axisType, axisId)=>$8f21bd235d951197$export$26eadf639b453d0f(state, axisId), $8f21bd235d951197$var$selectZAxisScale, (axis, scale)=>{
    if (axis == null || scale == null) return undefined;
    return $8f21bd235d951197$var$_objectSpread($8f21bd235d951197$var$_objectSpread({}, axis), {}, {
        scale: scale
    });
});
var $8f21bd235d951197$export$430d623a94added7 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    (0, $407ef552851b9401$export$bd320344232f30af),
    (0, $407ef552851b9401$export$e22adabb0128cf25)
], (layout, allXAxes, allYAxes)=>{
    switch(layout){
        case 'horizontal':
            return allXAxes.some((axis)=>axis.reversed) ? 'right-to-left' : 'left-to-right';
        case 'vertical':
            return allYAxes.some((axis)=>axis.reversed) ? 'bottom-to-top' : 'top-to-bottom';
        // TODO: make this better. For now, right arrow triggers "forward", left arrow "back"
        // however, the tooltip moves an unintuitive direction because of how the indices are rendered
        case 'centric':
        case 'radial':
            return 'left-to-right';
        default:
            return undefined;
    }
});









var $14fd122f24c9c808$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], $14fd122f24c9c808$var$_excluded2 = [
    "offset"
], $14fd122f24c9c808$var$_excluded3 = [
    "xAxisId",
    "yAxisId"
], $14fd122f24c9c808$var$_excluded4 = [
    "xAxisId",
    "yAxisId"
];
function $14fd122f24c9c808$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $14fd122f24c9c808$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $14fd122f24c9c808$var$ownKeys(Object(t), !0).forEach(function(r) {
            $14fd122f24c9c808$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $14fd122f24c9c808$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $14fd122f24c9c808$var$_defineProperty(e, r, t) {
    return (r = $14fd122f24c9c808$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $14fd122f24c9c808$var$_toPropertyKey(t) {
    var i = $14fd122f24c9c808$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $14fd122f24c9c808$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $14fd122f24c9c808$var$_extends() {
    return $14fd122f24c9c808$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $14fd122f24c9c808$var$_extends.apply(null, arguments);
}
function $14fd122f24c9c808$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $14fd122f24c9c808$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $14fd122f24c9c808$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * The <CartesianGrid horizontal
 */ var $14fd122f24c9c808$var$Background = (props)=>{
    var { fill: fill } = props;
    if (!fill || fill === 'none') return null;
    var { fillOpacity: fillOpacity, x: x, y: y, width: width, height: height, ry: ry } = props;
    return /*#__PURE__*/ $28UcW.createElement("rect", {
        x: x,
        y: y,
        ry: ry,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function $14fd122f24c9c808$var$LineItem(_ref) {
    var { option: option, lineItemProps: lineItemProps } = _ref;
    var lineItem;
    if (/*#__PURE__*/ $28UcW.isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ $28UcW.cloneElement(option, lineItemProps);
    else if (typeof option === 'function') lineItem = option(lineItemProps);
    else {
        var _svgPropertiesNoEvent;
        var { x1: x1, y1: y1, x2: x2, y2: y2, key: key } = lineItemProps, others = $14fd122f24c9c808$var$_objectWithoutProperties(lineItemProps, $14fd122f24c9c808$var$_excluded);
        var _ref2 = (_svgPropertiesNoEvent = (0, $3d820e26962aea02$export$8b56257912140094)(others)) !== null && _svgPropertiesNoEvent !== void 0 ? _svgPropertiesNoEvent : {}, { offset: __ } = _ref2, restOfFilteredProps = $14fd122f24c9c808$var$_objectWithoutProperties(_ref2, $14fd122f24c9c808$var$_excluded2);
        lineItem = /*#__PURE__*/ $28UcW.createElement("line", $14fd122f24c9c808$var$_extends({}, restOfFilteredProps, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function $14fd122f24c9c808$var$HorizontalGridLines(props) {
    var { x: x, width: width, horizontal: horizontal = true, horizontalPoints: horizontalPoints } = props;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var { xAxisId: xAxisId, yAxisId: yAxisId } = props, otherLineItemProps = $14fd122f24c9c808$var$_objectWithoutProperties(props, $14fd122f24c9c808$var$_excluded3);
    var items = horizontalPoints.map((entry, i)=>{
        var lineItemProps = $14fd122f24c9c808$var$_objectSpread($14fd122f24c9c808$var$_objectSpread({}, otherLineItemProps), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return /*#__PURE__*/ $28UcW.createElement($14fd122f24c9c808$var$LineItem, {
            key: "line-".concat(i),
            option: horizontal,
            lineItemProps: lineItemProps
        });
    });
    return /*#__PURE__*/ $28UcW.createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function $14fd122f24c9c808$var$VerticalGridLines(props) {
    var { y: y, height: height, vertical: vertical = true, verticalPoints: verticalPoints } = props;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var { xAxisId: xAxisId, yAxisId: yAxisId } = props, otherLineItemProps = $14fd122f24c9c808$var$_objectWithoutProperties(props, $14fd122f24c9c808$var$_excluded4);
    var items = verticalPoints.map((entry, i)=>{
        var lineItemProps = $14fd122f24c9c808$var$_objectSpread($14fd122f24c9c808$var$_objectSpread({}, otherLineItemProps), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return /*#__PURE__*/ $28UcW.createElement($14fd122f24c9c808$var$LineItem, {
            option: vertical,
            lineItemProps: lineItemProps,
            key: "line-".concat(i)
        });
    });
    return /*#__PURE__*/ $28UcW.createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function $14fd122f24c9c808$var$HorizontalStripes(props) {
    var { horizontalFill: horizontalFill, fillOpacity: fillOpacity, x: x, y: y, width: width, height: height, horizontalPoints: horizontalPoints, horizontal: horizontal = true } = props;
    if (!horizontal || !horizontalFill || !horizontalFill.length || horizontalPoints == null) return null;
    var roundedSortedHorizontalPoints = horizontalPoints.map((e)=>Math.round(e + y - y)).sort((a, b)=>a - b);
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map((entry, i)=>{
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var lastStripe = !roundedSortedHorizontalPoints[i + 1];
        var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ $28UcW.createElement("rect", {
            key: "react-".concat(i),
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ $28UcW.createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function $14fd122f24c9c808$var$VerticalStripes(props) {
    var { vertical: vertical = true, verticalFill: verticalFill, fillOpacity: fillOpacity, x: x, y: y, width: width, height: height, verticalPoints: verticalPoints } = props;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map((e)=>Math.round(e + x - x)).sort((a, b)=>a - b);
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map((entry, i)=>{
        var lastStripe = !roundedSortedVerticalPoints[i + 1];
        var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ $28UcW.createElement("rect", {
            key: "react-".concat(i),
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ $28UcW.createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var $14fd122f24c9c808$var$defaultVerticalCoordinatesGenerator = (_ref3, syncWithTicks)=>{
    var { xAxis: xAxis, width: width, height: height, offset: offset } = _ref3;
    return (0, $912d8cf1d03ea507$export$846dc5ac5fecff74)((0, $5f666a34d09825a1$export$3d27d42b1034de5c)($14fd122f24c9c808$var$_objectSpread($14fd122f24c9c808$var$_objectSpread($14fd122f24c9c808$var$_objectSpread({}, (0, $c8f4efe43d81a1a3$export$179c35154a9748c0)), xAxis), {}, {
        ticks: (0, $912d8cf1d03ea507$export$c829ee42daf7f66d)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var $14fd122f24c9c808$var$defaultHorizontalCoordinatesGenerator = (_ref4, syncWithTicks)=>{
    var { yAxis: yAxis, width: width, height: height, offset: offset } = _ref4;
    return (0, $912d8cf1d03ea507$export$846dc5ac5fecff74)((0, $5f666a34d09825a1$export$3d27d42b1034de5c)($14fd122f24c9c808$var$_objectSpread($14fd122f24c9c808$var$_objectSpread($14fd122f24c9c808$var$_objectSpread({}, (0, $c8f4efe43d81a1a3$export$179c35154a9748c0)), yAxis), {}, {
        ticks: (0, $912d8cf1d03ea507$export$c829ee42daf7f66d)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var $14fd122f24c9c808$export$58f1dfa394f98e54 = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: '#ccc',
    fill: 'none',
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: [],
    xAxisId: 0,
    yAxisId: 0,
    syncWithTicks: false,
    zIndex: (0, $45e92ad7df96f1e3$export$96df16b28aa32702).grid
};
function $14fd122f24c9c808$export$6440e27b9f186856(props) {
    var chartWidth = (0, $6ade474fe9f2b6e0$export$8854f7ece606854b)();
    var chartHeight = (0, $6ade474fe9f2b6e0$export$369ae257969c6f9f)();
    var offset = (0, $6ade474fe9f2b6e0$export$10605f61bef2858a)();
    var propsIncludingDefaults = $14fd122f24c9c808$var$_objectSpread($14fd122f24c9c808$var$_objectSpread({}, (0, $2db4b31e06a7a91b$export$45004cc70a390ee8)(props, $14fd122f24c9c808$export$58f1dfa394f98e54)), {}, {
        x: (0, $9a1343d05dde836c$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
        y: (0, $9a1343d05dde836c$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
        width: (0, $9a1343d05dde836c$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
        height: (0, $9a1343d05dde836c$export$7e4aa119212bc614)(props.height) ? props.height : offset.height
    });
    var { xAxisId: xAxisId, yAxisId: yAxisId, x: x, y: y, width: width, height: height, syncWithTicks: syncWithTicks, horizontalValues: horizontalValues, verticalValues: verticalValues } = propsIncludingDefaults;
    var isPanorama = (0, $d64615d5c7c4e07c$export$4b0c59f8845ba920)();
    var xAxis = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $8f21bd235d951197$export$45cd57660792dd31)(state, 'xAxis', xAxisId, isPanorama));
    var yAxis = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $8f21bd235d951197$export$45cd57660792dd31)(state, 'yAxis', yAxisId, isPanorama));
    if (!(0, $11a93f8f3c3518e5$export$5374bb854d0e41c8)(width) || !(0, $11a93f8f3c3518e5$export$5374bb854d0e41c8)(height) || !(0, $9a1343d05dde836c$export$7e4aa119212bc614)(x) || !(0, $9a1343d05dde836c$export$7e4aa119212bc614)(y)) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || $14fd122f24c9c808$var$defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || $14fd122f24c9c808$var$defaultHorizontalCoordinatesGenerator;
    var { horizontalPoints: horizontalPoints, verticalPoints: verticalPoints } = propsIncludingDefaults;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && typeof horizontalCoordinatesGenerator === 'function') {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? $14fd122f24c9c808$var$_objectSpread($14fd122f24c9c808$var$_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth !== null && chartWidth !== void 0 ? chartWidth : width,
            height: chartHeight !== null && chartHeight !== void 0 ? chartHeight : height,
            offset: offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, $65baf459c02da39a$export$c106dd0671a0fc2d)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(typeof generatorResult, "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && typeof verticalCoordinatesGenerator === 'function') {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? $14fd122f24c9c808$var$_objectSpread($14fd122f24c9c808$var$_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth !== null && chartWidth !== void 0 ? chartWidth : width,
            height: chartHeight !== null && chartHeight !== void 0 ? chartHeight : height,
            offset: offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, $65baf459c02da39a$export$c106dd0671a0fc2d)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(typeof _generatorResult, "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ $28UcW.createElement((0, $3603bfc8e6eb9e37$export$b37befaf92aba9f1), {
        zIndex: propsIncludingDefaults.zIndex
    }, /*#__PURE__*/ $28UcW.createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ $28UcW.createElement($14fd122f24c9c808$var$Background, {
        fill: propsIncludingDefaults.fill,
        fillOpacity: propsIncludingDefaults.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height,
        ry: propsIncludingDefaults.ry
    }), /*#__PURE__*/ $28UcW.createElement($14fd122f24c9c808$var$HorizontalStripes, $14fd122f24c9c808$var$_extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ $28UcW.createElement($14fd122f24c9c808$var$VerticalStripes, $14fd122f24c9c808$var$_extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })), /*#__PURE__*/ $28UcW.createElement($14fd122f24c9c808$var$HorizontalGridLines, $14fd122f24c9c808$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        horizontalPoints: horizontalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ $28UcW.createElement($14fd122f24c9c808$var$VerticalGridLines, $14fd122f24c9c808$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        verticalPoints: verticalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    }))));
}
$14fd122f24c9c808$export$6440e27b9f186856.displayName = 'CartesianGrid';


var $28UcW = parcelRequire("28UcW");


var $28UcW = parcelRequire("28UcW");
var $75139349d654247f$export$63a23315bebc1b2 = /*#__PURE__*/ (0, $28UcW.createContext)(null);
var $75139349d654247f$export$36ebc0838785d4af = ()=>(0, $28UcW.useContext)($75139349d654247f$export$63a23315bebc1b2);



var $28UcW = parcelRequire("28UcW");

var $dP0oo = parcelRequire("dP0oo");

var $28UcW = parcelRequire("28UcW");

var $dP0oo = parcelRequire("dP0oo");

var $ff8d9169ee46fca6$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function $ff8d9169ee46fca6$var$_extends() {
    return $ff8d9169ee46fca6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ff8d9169ee46fca6$var$_extends.apply(null, arguments);
}
function $ff8d9169ee46fca6$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $ff8d9169ee46fca6$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $ff8d9169ee46fca6$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ff8d9169ee46fca6$export$7b92b459e668cb21 = /*#__PURE__*/ (0, $28UcW.forwardRef)((props, ref)=>{
    var { children: children, width: width, height: height, viewBox: viewBox, className: className, style: style, title: title, desc: desc } = props, others = $ff8d9169ee46fca6$var$_objectWithoutProperties(props, $ff8d9169ee46fca6$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, $dP0oo.clsx)('recharts-surface', className);
    return /*#__PURE__*/ $28UcW.createElement("svg", $ff8d9169ee46fca6$var$_extends({}, (0, $1412060bc6e2b8b4$export$67f8fc03e57e2747)(others), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height),
        ref: ref
    }), /*#__PURE__*/ $28UcW.createElement("title", null, title), /*#__PURE__*/ $28UcW.createElement("desc", null, desc), children);
});



var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");


var $be2abe7587430551$var$_excluded = [
    "type",
    "size",
    "sizeType"
];
function $be2abe7587430551$var$_extends() {
    return $be2abe7587430551$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $be2abe7587430551$var$_extends.apply(null, arguments);
}
function $be2abe7587430551$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $be2abe7587430551$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $be2abe7587430551$var$ownKeys(Object(t), !0).forEach(function(r) {
            $be2abe7587430551$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $be2abe7587430551$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $be2abe7587430551$var$_defineProperty(e, r, t) {
    return (r = $be2abe7587430551$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $be2abe7587430551$var$_toPropertyKey(t) {
    var i = $be2abe7587430551$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $be2abe7587430551$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $be2abe7587430551$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $be2abe7587430551$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $be2abe7587430551$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $be2abe7587430551$var$symbolFactories = {
    symbolCircle: $c72ad316bc19e104$exports.symbolCircle,
    symbolCross: $c72ad316bc19e104$exports.symbolCross,
    symbolDiamond: $c72ad316bc19e104$exports.symbolDiamond,
    symbolSquare: $c72ad316bc19e104$exports.symbolSquare,
    symbolStar: $c72ad316bc19e104$exports.symbolStar,
    symbolTriangle: $c72ad316bc19e104$exports.symbolTriangle,
    symbolWye: $c72ad316bc19e104$exports.symbolWye
};
var $be2abe7587430551$var$RADIAN = Math.PI / 180;
var $be2abe7587430551$var$getSymbolFactory = (type)=>{
    var name = "symbol".concat((0, $9a1343d05dde836c$export$3061f22cd819074d)(type));
    return $be2abe7587430551$var$symbolFactories[name] || (0, $c72ad316bc19e104$exports.symbolCircle);
};
var $be2abe7587430551$var$calculateAreaSize = (size, sizeType, type)=>{
    if (sizeType === 'area') return size;
    switch(type){
        case 'cross':
            return 5 * size * size / 9;
        case 'diamond':
            return 0.5 * size * size / Math.sqrt(3);
        case 'square':
            return size * size;
        case 'star':
            var angle = 18 * $be2abe7587430551$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.tan(angle) ** 2);
        case 'triangle':
            return Math.sqrt(3) * size * size / 4;
        case 'wye':
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $be2abe7587430551$var$registerSymbol = (key, factory)=>{
    $be2abe7587430551$var$symbolFactories["symbol".concat((0, $9a1343d05dde836c$export$3061f22cd819074d)(key))] = factory;
};
var $be2abe7587430551$export$fa456266707bf4e4 = (_ref)=>{
    var { type: type = 'circle', size: size = 64, sizeType: sizeType = 'area' } = _ref, rest = $be2abe7587430551$var$_objectWithoutProperties(_ref, $be2abe7587430551$var$_excluded);
    var props = $be2abe7587430551$var$_objectSpread($be2abe7587430551$var$_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    var realType = 'circle';
    if (typeof type === 'string') /*
     * Our type guard is not as strong as it could be (i.e. non-existent),
     * and so despite the typescript type saying that `type` is a `SymbolType`,
     * we can get numbers or really anything, so let's have a runtime check here to fix the exception.
     *
     * https://github.com/recharts/recharts/issues/6197
     */ realType = type;
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = ()=>{
        var symbolFactory = $be2abe7587430551$var$getSymbolFactory(realType);
        var symbol = (0, $c72ad316bc19e104$exports.symbol)().type(symbolFactory).size($be2abe7587430551$var$calculateAreaSize(size, sizeType, realType));
        var s = symbol();
        if (s === null) return undefined;
        return s;
    };
    var { className: className, cx: cx, cy: cy } = props;
    var filteredProps = (0, $1412060bc6e2b8b4$export$67f8fc03e57e2747)(props);
    if ((0, $9a1343d05dde836c$export$7e4aa119212bc614)(cx) && (0, $9a1343d05dde836c$export$7e4aa119212bc614)(cy) && (0, $9a1343d05dde836c$export$7e4aa119212bc614)(size)) return /*#__PURE__*/ $28UcW.createElement("path", $be2abe7587430551$var$_extends({}, filteredProps, {
        className: (0, $dP0oo.clsx)('recharts-symbols', className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$be2abe7587430551$export$fa456266707bf4e4.registerSymbol = $be2abe7587430551$var$registerSymbol;




function $4eab2852d099c55d$var$_extends() {
    return $4eab2852d099c55d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4eab2852d099c55d$var$_extends.apply(null, arguments);
}
function $4eab2852d099c55d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4eab2852d099c55d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4eab2852d099c55d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4eab2852d099c55d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4eab2852d099c55d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4eab2852d099c55d$var$_defineProperty(e, r, t) {
    return (r = $4eab2852d099c55d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4eab2852d099c55d$var$_toPropertyKey(t) {
    var i = $4eab2852d099c55d$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4eab2852d099c55d$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $4eab2852d099c55d$var$SIZE = 32;
var $4eab2852d099c55d$var$defaultLegendContentDefaultProps = {
    align: 'center',
    iconSize: 14,
    inactiveColor: '#ccc',
    layout: 'horizontal',
    verticalAlign: 'middle'
};
function $4eab2852d099c55d$var$Icon(_ref) {
    var { data: data, iconType: iconType, inactiveColor: inactiveColor } = _ref;
    var halfSize = $4eab2852d099c55d$var$SIZE / 2;
    var sixthSize = $4eab2852d099c55d$var$SIZE / 6;
    var thirdSize = $4eab2852d099c55d$var$SIZE / 3;
    var color = data.inactive ? inactiveColor : data.color;
    var preferredIcon = iconType !== null && iconType !== void 0 ? iconType : data.type;
    if (preferredIcon === 'none') return null;
    if (preferredIcon === 'plainline') {
        var _data$payload;
        return /*#__PURE__*/ $28UcW.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: color,
            strokeDasharray: (_data$payload = data.payload) === null || _data$payload === void 0 ? void 0 : _data$payload.strokeDasharray,
            x1: 0,
            y1: halfSize,
            x2: $4eab2852d099c55d$var$SIZE,
            y2: halfSize,
            className: "recharts-legend-icon"
        });
    }
    if (preferredIcon === 'line') return /*#__PURE__*/ $28UcW.createElement("path", {
        strokeWidth: 4,
        fill: "none",
        stroke: color,
        d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($4eab2852d099c55d$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
        className: "recharts-legend-icon"
    });
    if (preferredIcon === 'rect') return /*#__PURE__*/ $28UcW.createElement("path", {
        stroke: "none",
        fill: color,
        d: "M0,".concat($4eab2852d099c55d$var$SIZE / 8, "h").concat($4eab2852d099c55d$var$SIZE, "v").concat($4eab2852d099c55d$var$SIZE * 3 / 4, "h").concat(-$4eab2852d099c55d$var$SIZE, "z"),
        className: "recharts-legend-icon"
    });
    if (/*#__PURE__*/ $28UcW.isValidElement(data.legendIcon)) {
        var iconProps = $4eab2852d099c55d$var$_objectSpread({}, data);
        delete iconProps.legendIcon;
        return /*#__PURE__*/ $28UcW.cloneElement(data.legendIcon, iconProps);
    }
    return /*#__PURE__*/ $28UcW.createElement((0, $be2abe7587430551$export$fa456266707bf4e4), {
        fill: color,
        cx: halfSize,
        cy: halfSize,
        size: $4eab2852d099c55d$var$SIZE,
        sizeType: "diameter",
        type: preferredIcon
    });
}
function $4eab2852d099c55d$var$Items(props) {
    var { payload: payload, iconSize: iconSize, layout: layout, formatter: formatter, inactiveColor: inactiveColor, iconType: iconType } = props;
    var viewBox = {
        x: 0,
        y: 0,
        width: $4eab2852d099c55d$var$SIZE,
        height: $4eab2852d099c55d$var$SIZE
    };
    var itemStyle = {
        display: layout === 'horizontal' ? 'inline-block' : 'block',
        marginRight: 10
    };
    var svgStyle = {
        display: 'inline-block',
        verticalAlign: 'middle',
        marginRight: 4
    };
    return payload.map((entry, i)=>{
        var finalFormatter = entry.formatter || formatter;
        var className = (0, $dP0oo.clsx)({
            'recharts-legend-item': true,
            ["legend-item-".concat(i)]: true,
            inactive: entry.inactive
        });
        if (entry.type === 'none') return null;
        var color = entry.inactive ? inactiveColor : entry.color;
        var finalValue = finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value;
        return /*#__PURE__*/ $28UcW.createElement("li", $4eab2852d099c55d$var$_extends({
            className: className,
            style: itemStyle,
            key: "legend-item-".concat(i)
        }, (0, $4009b9153cff02e8$export$ca62be0d67a3158c)(props, entry, i)), /*#__PURE__*/ $28UcW.createElement((0, $ff8d9169ee46fca6$export$7b92b459e668cb21), {
            width: iconSize,
            height: iconSize,
            viewBox: viewBox,
            style: svgStyle,
            "aria-label": "".concat(finalValue, " legend icon")
        }, /*#__PURE__*/ $28UcW.createElement($4eab2852d099c55d$var$Icon, {
            data: entry,
            iconType: iconType,
            inactiveColor: inactiveColor
        })), /*#__PURE__*/ $28UcW.createElement("span", {
            className: "recharts-legend-item-text",
            style: {
                color: color
            }
        }, finalValue));
    });
}
var $4eab2852d099c55d$export$99f8d96ed0cededa = (outsideProps)=>{
    var props = (0, $2db4b31e06a7a91b$export$45004cc70a390ee8)(outsideProps, $4eab2852d099c55d$var$defaultLegendContentDefaultProps);
    var { payload: payload, layout: layout, align: align } = props;
    if (!payload || !payload.length) return null;
    var finalStyle = {
        padding: 0,
        margin: 0,
        textAlign: layout === 'horizontal' ? align : 'left'
    };
    return /*#__PURE__*/ $28UcW.createElement("ul", {
        className: "recharts-default-legend",
        style: finalStyle
    }, /*#__PURE__*/ $28UcW.createElement($4eab2852d099c55d$var$Items, $4eab2852d099c55d$var$_extends({}, props, {
        payload: payload
    })));
};



var $8371b61845348058$exports = {};

$8371b61845348058$exports = (parcelRequire("3KrT2")).uniqBy;


function $1e5ef0021e80e27b$export$b67e33c2fb1535fa(payload, option, defaultUniqBy) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($8371b61845348058$exports)))(payload, defaultUniqBy);
    if (typeof option === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($8371b61845348058$exports)))(payload, option);
    return payload;
}




function $588fc76e382c2f9e$export$5e7711dbef7c() {
    return (0, $bf278eb346227770$export$a7347740d65f620b)((0, $783738f491029e54$export$9a6de64b691a7304));
}



var $28UcW = parcelRequire("28UcW");
var $e74793f8d349d213$var$EPS = 1;
function $e74793f8d349d213$export$35f58fcda6094144() {
    var extraDependencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var [lastBoundingBox, setLastBoundingBox] = (0, $28UcW.useState)({
        height: 0,
        left: 0,
        top: 0,
        width: 0
    });
    var updateBoundingBox = (0, $28UcW.useCallback)((node)=>{
        if (node != null) {
            var rect = node.getBoundingClientRect();
            var box = {
                height: rect.height,
                left: rect.left,
                top: rect.top,
                width: rect.width
            };
            if (Math.abs(box.height - lastBoundingBox.height) > $e74793f8d349d213$var$EPS || Math.abs(box.left - lastBoundingBox.left) > $e74793f8d349d213$var$EPS || Math.abs(box.top - lastBoundingBox.top) > $e74793f8d349d213$var$EPS || Math.abs(box.width - lastBoundingBox.width) > $e74793f8d349d213$var$EPS) setLastBoundingBox({
                height: box.height,
                left: box.left,
                top: box.top,
                width: box.width
            });
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        lastBoundingBox.width,
        lastBoundingBox.height,
        lastBoundingBox.top,
        lastBoundingBox.left,
        ...extraDependencies
    ]);
    return [
        lastBoundingBox,
        updateBoundingBox
    ];
}





/**
 * The properties inside this state update independently of each other and quite often.
 * When selecting, never select the whole state because you are going to get
 * unnecessary re-renders. Select only the properties you need.
 *
 * This is why this state type is not exported - don't use it directly.
 */ var $64fc3eecfa5a3e7d$var$initialState = {
    settings: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'middle',
        itemSorter: 'value'
    },
    size: {
        width: 0,
        height: 0
    },
    payload: []
};
var $64fc3eecfa5a3e7d$var$legendSlice = (0, $ec80cf871915f813$export$4d8d9bd83c24ae8b)({
    name: 'legend',
    initialState: $64fc3eecfa5a3e7d$var$initialState,
    reducers: {
        setLegendSize (state, action) {
            state.size.width = action.payload.width;
            state.size.height = action.payload.height;
        },
        setLegendSettings (state, action) {
            state.settings.align = action.payload.align;
            state.settings.layout = action.payload.layout;
            state.settings.verticalAlign = action.payload.verticalAlign;
            state.settings.itemSorter = action.payload.itemSorter;
        },
        addLegendPayload: {
            reducer (state, action) {
                state.payload.push((0, $46230e101f7bd5ae$export$c05b21e3257751e5)(action.payload));
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        replaceLegendPayload: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                var index = (0, $75bf48a0e2bf731d$export$97aac956da55dae9)(state).payload.indexOf((0, $46230e101f7bd5ae$export$c05b21e3257751e5)(prev));
                if (index > -1) state.payload[index] = (0, $46230e101f7bd5ae$export$c05b21e3257751e5)(next);
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        removeLegendPayload: {
            reducer (state, action) {
                var index = (0, $75bf48a0e2bf731d$export$97aac956da55dae9)(state).payload.indexOf((0, $46230e101f7bd5ae$export$c05b21e3257751e5)(action.payload));
                if (index > -1) state.payload.splice(index, 1);
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        }
    }
});
var { setLegendSize: $64fc3eecfa5a3e7d$export$f9ba9ab9b90c340e, setLegendSettings: $64fc3eecfa5a3e7d$export$a1a647a9c0dcc839, addLegendPayload: $64fc3eecfa5a3e7d$export$236fd33b6ffe3f4b, replaceLegendPayload: $64fc3eecfa5a3e7d$export$379d42d798953c3d, removeLegendPayload: $64fc3eecfa5a3e7d$export$337e5f2bb3b9e128 } = $64fc3eecfa5a3e7d$var$legendSlice.actions;
var $64fc3eecfa5a3e7d$export$8d8dfb8d5acf8179 = $64fc3eecfa5a3e7d$var$legendSlice.reducer;




var $1a4da5e443fb808c$var$_excluded = [
    "contextPayload"
];
function $1a4da5e443fb808c$var$_extends() {
    return $1a4da5e443fb808c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1a4da5e443fb808c$var$_extends.apply(null, arguments);
}
function $1a4da5e443fb808c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1a4da5e443fb808c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1a4da5e443fb808c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1a4da5e443fb808c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1a4da5e443fb808c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1a4da5e443fb808c$var$_defineProperty(e, r, t) {
    return (r = $1a4da5e443fb808c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1a4da5e443fb808c$var$_toPropertyKey(t) {
    var i = $1a4da5e443fb808c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1a4da5e443fb808c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1a4da5e443fb808c$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $1a4da5e443fb808c$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $1a4da5e443fb808c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $1a4da5e443fb808c$var$defaultUniqBy(entry) {
    return entry.value;
}
function $1a4da5e443fb808c$var$LegendContent(props) {
    var { contextPayload: contextPayload } = props, otherProps = $1a4da5e443fb808c$var$_objectWithoutProperties(props, $1a4da5e443fb808c$var$_excluded);
    var finalPayload = (0, $1e5ef0021e80e27b$export$b67e33c2fb1535fa)(contextPayload, props.payloadUniqBy, $1a4da5e443fb808c$var$defaultUniqBy);
    var contentProps = $1a4da5e443fb808c$var$_objectSpread($1a4da5e443fb808c$var$_objectSpread({}, otherProps), {}, {
        payload: finalPayload
    });
    if (/*#__PURE__*/ $28UcW.isValidElement(props.content)) return /*#__PURE__*/ $28UcW.cloneElement(props.content, contentProps);
    if (typeof props.content === 'function') return /*#__PURE__*/ $28UcW.createElement(props.content, contentProps);
    return /*#__PURE__*/ $28UcW.createElement((0, $4eab2852d099c55d$export$99f8d96ed0cededa), contentProps);
}
function $1a4da5e443fb808c$var$getDefaultPosition(style, props, margin, chartWidth, chartHeight, box) {
    var { layout: layout, align: align, verticalAlign: verticalAlign } = props;
    var hPos, vPos;
    if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
        if (align === 'center' && layout === 'vertical') hPos = {
            left: ((chartWidth || 0) - box.width) / 2
        };
        else hPos = align === 'right' ? {
            right: margin && margin.right || 0
        } : {
            left: margin && margin.left || 0
        };
    }
    if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
        if (verticalAlign === 'middle') vPos = {
            top: ((chartHeight || 0) - box.height) / 2
        };
        else vPos = verticalAlign === 'bottom' ? {
            bottom: margin && margin.bottom || 0
        } : {
            top: margin && margin.top || 0
        };
    }
    return $1a4da5e443fb808c$var$_objectSpread($1a4da5e443fb808c$var$_objectSpread({}, hPos), vPos);
}
function $1a4da5e443fb808c$var$LegendSettingsDispatcher(props) {
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    (0, $28UcW.useEffect)(()=>{
        dispatch((0, $64fc3eecfa5a3e7d$export$a1a647a9c0dcc839)(props));
    }, [
        dispatch,
        props
    ]);
    return null;
}
function $1a4da5e443fb808c$var$LegendSizeDispatcher(props) {
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    (0, $28UcW.useEffect)(()=>{
        dispatch((0, $64fc3eecfa5a3e7d$export$f9ba9ab9b90c340e)(props));
        return ()=>{
            dispatch((0, $64fc3eecfa5a3e7d$export$f9ba9ab9b90c340e)({
                width: 0,
                height: 0
            }));
        };
    }, [
        dispatch,
        props
    ]);
    return null;
}
function $1a4da5e443fb808c$var$getWidthOrHeight(layout, height, width, maxWidth) {
    if (layout === 'vertical' && (0, $9a1343d05dde836c$export$7e4aa119212bc614)(height)) return {
        height: height
    };
    if (layout === 'horizontal') return {
        width: width || maxWidth
    };
    return null;
}
var $1a4da5e443fb808c$export$af43120f4eb40347 = {
    align: 'center',
    iconSize: 14,
    itemSorter: 'value',
    layout: 'horizontal',
    verticalAlign: 'bottom'
};
function $1a4da5e443fb808c$export$ed247974535929c7(outsideProps) {
    var props = (0, $2db4b31e06a7a91b$export$45004cc70a390ee8)(outsideProps, $1a4da5e443fb808c$export$af43120f4eb40347);
    var contextPayload = (0, $588fc76e382c2f9e$export$5e7711dbef7c)();
    var legendPortalFromContext = (0, $75139349d654247f$export$36ebc0838785d4af)();
    var margin = (0, $6ade474fe9f2b6e0$export$58ac794108fd8ca)();
    var { width: widthFromProps, height: heightFromProps, wrapperStyle: wrapperStyle, portal: portalFromProps } = props;
    // The contextPayload is not used directly inside the hook, but we need the onBBoxUpdate call
    // when the payload changes, therefore it's here as a dependency.
    var [lastBoundingBox, updateBoundingBox] = (0, $e74793f8d349d213$export$35f58fcda6094144)([
        contextPayload
    ]);
    var chartWidth = (0, $6ade474fe9f2b6e0$export$8854f7ece606854b)();
    var chartHeight = (0, $6ade474fe9f2b6e0$export$369ae257969c6f9f)();
    if (chartWidth == null || chartHeight == null) return null;
    var maxWidth = chartWidth - ((margin === null || margin === void 0 ? void 0 : margin.left) || 0) - ((margin === null || margin === void 0 ? void 0 : margin.right) || 0);
    var widthOrHeight = $1a4da5e443fb808c$var$getWidthOrHeight(props.layout, heightFromProps, widthFromProps, maxWidth);
    // if the user supplies their own portal, only use their defined wrapper styles
    var outerStyle = portalFromProps ? wrapperStyle : $1a4da5e443fb808c$var$_objectSpread($1a4da5e443fb808c$var$_objectSpread({
        position: 'absolute',
        width: (widthOrHeight === null || widthOrHeight === void 0 ? void 0 : widthOrHeight.width) || widthFromProps || 'auto',
        height: (widthOrHeight === null || widthOrHeight === void 0 ? void 0 : widthOrHeight.height) || heightFromProps || 'auto'
    }, $1a4da5e443fb808c$var$getDefaultPosition(wrapperStyle, props, margin, chartWidth, chartHeight, lastBoundingBox)), wrapperStyle);
    var legendPortal = portalFromProps !== null && portalFromProps !== void 0 ? portalFromProps : legendPortalFromContext;
    if (legendPortal == null || contextPayload == null) return null;
    var legendElement = /*#__PURE__*/ $28UcW.createElement("div", {
        className: "recharts-legend-wrapper",
        style: outerStyle,
        ref: updateBoundingBox
    }, /*#__PURE__*/ $28UcW.createElement($1a4da5e443fb808c$var$LegendSettingsDispatcher, {
        layout: props.layout,
        align: props.align,
        verticalAlign: props.verticalAlign,
        itemSorter: props.itemSorter
    }), !portalFromProps && /*#__PURE__*/ $28UcW.createElement($1a4da5e443fb808c$var$LegendSizeDispatcher, {
        width: lastBoundingBox.width,
        height: lastBoundingBox.height
    }), /*#__PURE__*/ $28UcW.createElement($1a4da5e443fb808c$var$LegendContent, $1a4da5e443fb808c$var$_extends({}, props, widthOrHeight, {
        margin: margin,
        chartWidth: chartWidth,
        chartHeight: chartHeight,
        contextPayload: contextPayload
    })));
    return /*#__PURE__*/ (0, $ac717a3ef8959bc0$exports.createPortal)(legendElement, legendPortal);
}
$1a4da5e443fb808c$export$ed247974535929c7.displayName = 'Legend';


var $28UcW = parcelRequire("28UcW");

var $dP0oo = parcelRequire("dP0oo");


var $28UcW = parcelRequire("28UcW");
var $d2fe18be1a2061ff$exports = {};

$d2fe18be1a2061ff$exports = (parcelRequire("9bufC")).last;









var $e58439db30c77114$var$_excluded = [
    "valueAccessor"
], $e58439db30c77114$var$_excluded2 = [
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll",
    "zIndex"
];
function $e58439db30c77114$var$_extends() {
    return $e58439db30c77114$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e58439db30c77114$var$_extends.apply(null, arguments);
}
function $e58439db30c77114$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $e58439db30c77114$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $e58439db30c77114$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * This is public API because we expose it as the valueAccessor parameter.
 *
 * The properties of "viewBox" are repeated as the root props of the entry object.
 * So it doesn't matter if you read entry.x or entry.viewBox.x, they are the same.
 *
 * It's not necessary to pass redundant data, but we keep it for backward compatibility.
 */ /**
 * LabelList props do not allow refs because the same props are reused in multiple elements so we don't have a good single place to ref to.
 */ /**
 * This is the type accepted for the `label` prop on various graphical items.
 * It accepts:
 *
 * boolean:
 *    true = labels show,
 *    false = labels don't show
 * React element:
 *    will be cloned with extra props
 * function:
 *    is used as <Label content={function} />, so this will be called once for each individual label (so typically once for each data point)
 * object:
 *    the props to be passed to a LabelList component
 *
 * @inline
 */ var $e58439db30c77114$var$defaultAccessor = (entry)=>Array.isArray(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($d2fe18be1a2061ff$exports)))(entry.value) : entry.value;
var $e58439db30c77114$var$CartesianLabelListContext = /*#__PURE__*/ (0, $28UcW.createContext)(undefined);
var $e58439db30c77114$export$64e384eac5db53f7 = $e58439db30c77114$var$CartesianLabelListContext.Provider;
var $e58439db30c77114$var$PolarLabelListContext = /*#__PURE__*/ (0, $28UcW.createContext)(undefined);
var $e58439db30c77114$export$38a852d7976af0fe = $e58439db30c77114$var$PolarLabelListContext.Provider;
function $e58439db30c77114$var$useCartesianLabelListContext() {
    return (0, $28UcW.useContext)($e58439db30c77114$var$CartesianLabelListContext);
}
function $e58439db30c77114$var$usePolarLabelListContext() {
    return (0, $28UcW.useContext)($e58439db30c77114$var$PolarLabelListContext);
}
function $e58439db30c77114$export$835fcf23ab7bf88(_ref) {
    var { valueAccessor: valueAccessor = $e58439db30c77114$var$defaultAccessor } = _ref, restProps = $e58439db30c77114$var$_objectWithoutProperties(_ref, $e58439db30c77114$var$_excluded);
    var { dataKey: dataKey, clockWise: clockWise, id: id, textBreakAll: textBreakAll, zIndex: zIndex } = restProps, others = $e58439db30c77114$var$_objectWithoutProperties(restProps, $e58439db30c77114$var$_excluded2);
    var cartesianData = $e58439db30c77114$var$useCartesianLabelListContext();
    var polarData = $e58439db30c77114$var$usePolarLabelListContext();
    var data = cartesianData || polarData;
    if (!data || !data.length) return null;
    return /*#__PURE__*/ $28UcW.createElement((0, $3603bfc8e6eb9e37$export$b37befaf92aba9f1), {
        zIndex: zIndex !== null && zIndex !== void 0 ? zIndex : (0, $45e92ad7df96f1e3$export$96df16b28aa32702).label
    }, /*#__PURE__*/ $28UcW.createElement((0, $06287e412aaf2f1c$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map((entry, index)=>{
        var _restProps$fill;
        var value = (0, $9a1343d05dde836c$export$b931b78cbb3caf86)(dataKey) ? valueAccessor(entry, index) : (0, $912d8cf1d03ea507$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, $9a1343d05dde836c$export$b931b78cbb3caf86)(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ $28UcW.createElement((0, $9290b2e14d5ce35d$export$b04be29aa201d4f5), $e58439db30c77114$var$_extends({
            key: "label-".concat(index)
        }, (0, $1412060bc6e2b8b4$export$67f8fc03e57e2747)(entry), others, idProps, {
            /*
       * Prefer to use the explicit fill from LabelList props.
       * Only in an absence of that, fall back to the fill of the entry.
       * The entry fill can be quite difficult to see especially in Bar, Pie, RadialBar in inside positions.
       * On the other hand it's quite convenient in Scatter, Line, or when the position is outside the Bar, Pie filled shapes.
       */ fill: (_restProps$fill = restProps.fill) !== null && _restProps$fill !== void 0 ? _restProps$fill : entry.fill,
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: entry.viewBox,
            index: index,
            zIndex: 0
        }));
    })));
}
$e58439db30c77114$export$835fcf23ab7bf88.displayName = 'LabelList';
function $e58439db30c77114$export$9a402bc8de2b410e(_ref2) {
    var { label: label } = _ref2;
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ $28UcW.createElement($e58439db30c77114$export$835fcf23ab7bf88, {
        key: "labelList-implicit"
    });
    if (/*#__PURE__*/ $28UcW.isValidElement(label) || (0, $9290b2e14d5ce35d$export$96a48941c06f377f)(label)) return /*#__PURE__*/ $28UcW.createElement($e58439db30c77114$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        content: label
    });
    if (typeof label === 'object') return /*#__PURE__*/ $28UcW.createElement($e58439db30c77114$export$835fcf23ab7bf88, $e58439db30c77114$var$_extends({
        key: "labelList-implicit"
    }, label, {
        type: String(label.type)
    }));
    return null;
}



var $28UcW = parcelRequire("28UcW");

var $dP0oo = parcelRequire("dP0oo");

var $28UcW = parcelRequire("28UcW");

var $dP0oo = parcelRequire("dP0oo");



function $1c02e9deaea11a2b$var$_extends() {
    return $1c02e9deaea11a2b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1c02e9deaea11a2b$var$_extends.apply(null, arguments);
}
var $1c02e9deaea11a2b$export$d046b3c4a416f60d = (props)=>{
    var { cx: cx, cy: cy, r: r, className: className } = props;
    var layerClass = (0, $dP0oo.clsx)('recharts-dot', className);
    if ((0, $9a1343d05dde836c$export$7e4aa119212bc614)(cx) && (0, $9a1343d05dde836c$export$7e4aa119212bc614)(cy) && (0, $9a1343d05dde836c$export$7e4aa119212bc614)(r)) return /*#__PURE__*/ $28UcW.createElement("circle", $1c02e9deaea11a2b$var$_extends({}, (0, $3d820e26962aea02$export$8b56257912140094)(props), (0, $4009b9153cff02e8$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};





var $28UcW = parcelRequire("28UcW");

var $d79ZO = parcelRequire("d79ZO");

var $5d3adb881548ed4e$export$e65e0ff8d3882b46 = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var $5d3adb881548ed4e$export$be63e0664592e141 = (Comp)=>{
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $5d3adb881548ed4e$var$lastChildren = null;
var $5d3adb881548ed4e$var$lastResult = null;
var $5d3adb881548ed4e$export$45b10814cc054894 = (children)=>{
    if (children === $5d3adb881548ed4e$var$lastChildren && Array.isArray($5d3adb881548ed4e$var$lastResult)) return $5d3adb881548ed4e$var$lastResult;
    var result = [];
    (0, $28UcW.Children).forEach(children, (child)=>{
        if ((0, $9a1343d05dde836c$export$b931b78cbb3caf86)(child)) return;
        if ((0, $d79ZO.isFragment)(child)) result = result.concat($5d3adb881548ed4e$export$45b10814cc054894(child.props.children));
        else // @ts-expect-error this could still be Iterable<ReactNode> and TS does not like that
        result.push(child);
    });
    $5d3adb881548ed4e$var$lastResult = result;
    $5d3adb881548ed4e$var$lastChildren = children;
    return result;
};
function $5d3adb881548ed4e$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map((t)=>$5d3adb881548ed4e$export$be63e0664592e141(t));
    else types = [
        $5d3adb881548ed4e$export$be63e0664592e141(type)
    ];
    $5d3adb881548ed4e$export$45b10814cc054894(children).forEach((child)=>{
        // @ts-expect-error toArray and lodash.get are not compatible. Let's get rid of the whole findAllByType function
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($2c84e5b844764211$exports)))(child, 'type.displayName') || (0, (/*@__PURE__*/$parcel$interopDefault($2c84e5b844764211$exports)))(child, 'type.name');
        if (childType && types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
var $5d3adb881548ed4e$export$28c0c718114c1a2e = (dot)=>{
    if (dot && typeof dot === 'object' && 'clipDot' in dot) return Boolean(dot.clipDot);
    return true;
};





var $425486537aadb3b9$var$_excluded = [
    "points"
];
function $425486537aadb3b9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $425486537aadb3b9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $425486537aadb3b9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $425486537aadb3b9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $425486537aadb3b9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $425486537aadb3b9$var$_defineProperty(e, r, t) {
    return (r = $425486537aadb3b9$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $425486537aadb3b9$var$_toPropertyKey(t) {
    var i = $425486537aadb3b9$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $425486537aadb3b9$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $425486537aadb3b9$var$_extends() {
    return $425486537aadb3b9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $425486537aadb3b9$var$_extends.apply(null, arguments);
}
function $425486537aadb3b9$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $425486537aadb3b9$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $425486537aadb3b9$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $425486537aadb3b9$var$DotItem(_ref) {
    var { option: option, dotProps: dotProps, className: className } = _ref;
    if (/*#__PURE__*/ (0, $28UcW.isValidElement)(option)) // @ts-expect-error we can't type check element cloning properly
    return /*#__PURE__*/ (0, $28UcW.cloneElement)(option, dotProps);
    if (typeof option === 'function') return option(dotProps);
    var finalClassName = (0, $dP0oo.clsx)(className, typeof option !== 'boolean' ? option.className : '');
    var _ref2 = dotProps !== null && dotProps !== void 0 ? dotProps : {}, { points: points } = _ref2, props = $425486537aadb3b9$var$_objectWithoutProperties(_ref2, $425486537aadb3b9$var$_excluded);
    return /*#__PURE__*/ $28UcW.createElement((0, $1c02e9deaea11a2b$export$d046b3c4a416f60d), $425486537aadb3b9$var$_extends({}, props, {
        className: finalClassName
    }));
}
function $425486537aadb3b9$var$shouldRenderDots(points, dot) {
    if (points == null) return false;
    if (dot) return true;
    return points.length === 1;
}
function $425486537aadb3b9$export$8da50d3722682be0(_ref3) {
    var { points: points, dot: dot, className: className, dotClassName: dotClassName, dataKey: dataKey, baseProps: baseProps, needClip: needClip, clipPathId: clipPathId, zIndex: zIndex = (0, $45e92ad7df96f1e3$export$96df16b28aa32702).scatter } = _ref3;
    if (!$425486537aadb3b9$var$shouldRenderDots(points, dot)) return null;
    var clipDot = (0, $5d3adb881548ed4e$export$28c0c718114c1a2e)(dot);
    var customDotProps = (0, $1412060bc6e2b8b4$export$87ef3d7bc7cd0706)(dot);
    var dots = points.map((entry, i)=>{
        var _entry$x, _entry$y;
        var dotProps = $425486537aadb3b9$var$_objectSpread($425486537aadb3b9$var$_objectSpread($425486537aadb3b9$var$_objectSpread({
            r: 3
        }, baseProps), customDotProps), {}, {
            index: i,
            cx: (_entry$x = entry.x) !== null && _entry$x !== void 0 ? _entry$x : undefined,
            cy: (_entry$y = entry.y) !== null && _entry$y !== void 0 ? _entry$y : undefined,
            dataKey: dataKey,
            value: entry.value,
            payload: entry.payload,
            points: points
        });
        return /*#__PURE__*/ $28UcW.createElement($425486537aadb3b9$var$DotItem, {
            key: "dot-".concat(i),
            option: dot,
            dotProps: dotProps,
            className: dotClassName
        });
    });
    var layerProps = {};
    if (needClip && clipPathId != null) layerProps.clipPath = "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")");
    return /*#__PURE__*/ $28UcW.createElement((0, $3603bfc8e6eb9e37$export$b37befaf92aba9f1), {
        zIndex: zIndex
    }, /*#__PURE__*/ $28UcW.createElement((0, $06287e412aaf2f1c$export$936d0764594b6eb3), $425486537aadb3b9$var$_extends({
        className: className
    }, layerProps), dots));
}






var $28UcW = parcelRequire("28UcW");













var $aab1adcf9dbc37ce$export$877d2dd8db5f51fd = (state)=>state.options.defaultTooltipEventType;
var $aab1adcf9dbc37ce$export$7f95a7e594fa7911 = (state)=>state.options.validateTooltipEventTypes;
function $aab1adcf9dbc37ce$export$d419a1f58b445a8f(shared, defaultTooltipEventType, validateTooltipEventTypes) {
    if (shared == null) return defaultTooltipEventType;
    var eventType = shared ? 'axis' : 'item';
    if (validateTooltipEventTypes == null) return defaultTooltipEventType;
    return validateTooltipEventTypes.includes(eventType) ? eventType : defaultTooltipEventType;
}
function $aab1adcf9dbc37ce$export$53af65c2db668fac(state, shared) {
    var defaultTooltipEventType = $aab1adcf9dbc37ce$export$877d2dd8db5f51fd(state);
    var validateTooltipEventTypes = $aab1adcf9dbc37ce$export$7f95a7e594fa7911(state);
    return $aab1adcf9dbc37ce$export$d419a1f58b445a8f(shared, defaultTooltipEventType, validateTooltipEventTypes);
}
function $aab1adcf9dbc37ce$export$7ac1fe18a92be318(shared) {
    return (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>$aab1adcf9dbc37ce$export$53af65c2db668fac(state, shared));
}



var $59977616e6d01c73$export$3213c4688ceb4c80 = (tooltipTicks, activeIndex)=>{
    var _tooltipTicks$n;
    var n = Number(activeIndex);
    if ((0, $9a1343d05dde836c$export$e426a261f3212d7d)(n) || activeIndex == null) return undefined;
    return n >= 0 ? tooltipTicks === null || tooltipTicks === void 0 || (_tooltipTicks$n = tooltipTicks[n]) === null || _tooltipTicks$n === void 0 ? void 0 : _tooltipTicks$n.value : undefined;
};


var $596f687a7ed806f3$export$26d1e95fb7dea02 = (state)=>state.tooltip.settings;




var $038eefd840ad861c$export$66f2ad380b6acece = {
    active: false,
    index: null,
    dataKey: undefined,
    graphicalItemId: undefined,
    coordinate: undefined
};
var $038eefd840ad861c$export$d4c72bab9d6cc13a = {
    itemInteraction: {
        click: $038eefd840ad861c$export$66f2ad380b6acece,
        hover: $038eefd840ad861c$export$66f2ad380b6acece
    },
    axisInteraction: {
        click: $038eefd840ad861c$export$66f2ad380b6acece,
        hover: $038eefd840ad861c$export$66f2ad380b6acece
    },
    keyboardInteraction: $038eefd840ad861c$export$66f2ad380b6acece,
    syncInteraction: {
        active: false,
        index: null,
        dataKey: undefined,
        label: undefined,
        coordinate: undefined,
        sourceViewBox: undefined,
        graphicalItemId: undefined
    },
    tooltipItemPayloads: [],
    settings: {
        shared: undefined,
        trigger: 'hover',
        axisId: 0,
        active: false,
        defaultIndex: undefined
    }
};
/**
 * This is the event we get when user is interacting with a specific graphical item.
 */ /**
 * Keyboard interaction payload has no graphical item ID,
 * and no dataKey, because keyboard interaction is always
 * with the whole chart, not with a specific graphical item.
 */ var $038eefd840ad861c$var$tooltipSlice = (0, $ec80cf871915f813$export$4d8d9bd83c24ae8b)({
    name: 'tooltip',
    initialState: $038eefd840ad861c$export$d4c72bab9d6cc13a,
    reducers: {
        addTooltipEntrySettings: {
            reducer (state, action) {
                state.tooltipItemPayloads.push((0, $46230e101f7bd5ae$export$c05b21e3257751e5)(action.payload));
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        replaceTooltipEntrySettings: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                var index = (0, $75bf48a0e2bf731d$export$97aac956da55dae9)(state).tooltipItemPayloads.indexOf((0, $46230e101f7bd5ae$export$c05b21e3257751e5)(prev));
                if (index > -1) state.tooltipItemPayloads[index] = (0, $46230e101f7bd5ae$export$c05b21e3257751e5)(next);
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        removeTooltipEntrySettings: {
            reducer (state, action) {
                var index = (0, $75bf48a0e2bf731d$export$97aac956da55dae9)(state).tooltipItemPayloads.indexOf((0, $46230e101f7bd5ae$export$c05b21e3257751e5)(action.payload));
                if (index > -1) state.tooltipItemPayloads.splice(index, 1);
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        setTooltipSettingsState (state, action) {
            state.settings = action.payload;
        },
        setActiveMouseOverItemIndex (state, action) {
            state.syncInteraction.active = false;
            state.keyboardInteraction.active = false;
            state.itemInteraction.hover.active = true;
            state.itemInteraction.hover.index = action.payload.activeIndex;
            state.itemInteraction.hover.dataKey = action.payload.activeDataKey;
            state.itemInteraction.hover.graphicalItemId = action.payload.activeGraphicalItemId;
            state.itemInteraction.hover.coordinate = action.payload.activeCoordinate;
        },
        mouseLeaveChart (state) {
            /*
       * Clear only the active flags. Why?
       * 1. Keep Coordinate to preserve animation - next time the Tooltip appears, we want to render it from
       * the last place where it was when it disappeared.
       * 2. We want to keep all the properties anyway just in case the tooltip has `active=true` prop
       * and continues being visible even after the mouse has left the chart.
       */ state.itemInteraction.hover.active = false;
            state.axisInteraction.hover.active = false;
        },
        mouseLeaveItem (state) {
            state.itemInteraction.hover.active = false;
        },
        setActiveClickItemIndex (state, action) {
            state.syncInteraction.active = false;
            state.itemInteraction.click.active = true;
            state.keyboardInteraction.active = false;
            state.itemInteraction.click.index = action.payload.activeIndex;
            state.itemInteraction.click.dataKey = action.payload.activeDataKey;
            state.itemInteraction.click.graphicalItemId = action.payload.activeGraphicalItemId;
            state.itemInteraction.click.coordinate = action.payload.activeCoordinate;
        },
        setMouseOverAxisIndex (state, action) {
            state.syncInteraction.active = false;
            state.axisInteraction.hover.active = true;
            state.keyboardInteraction.active = false;
            state.axisInteraction.hover.index = action.payload.activeIndex;
            state.axisInteraction.hover.dataKey = action.payload.activeDataKey;
            state.axisInteraction.hover.coordinate = action.payload.activeCoordinate;
        },
        setMouseClickAxisIndex (state, action) {
            state.syncInteraction.active = false;
            state.keyboardInteraction.active = false;
            state.axisInteraction.click.active = true;
            state.axisInteraction.click.index = action.payload.activeIndex;
            state.axisInteraction.click.dataKey = action.payload.activeDataKey;
            state.axisInteraction.click.coordinate = action.payload.activeCoordinate;
        },
        setSyncInteraction (state, action) {
            state.syncInteraction = action.payload;
        },
        setKeyboardInteraction (state, action) {
            state.keyboardInteraction.active = action.payload.active;
            state.keyboardInteraction.index = action.payload.activeIndex;
            state.keyboardInteraction.coordinate = action.payload.activeCoordinate;
        }
    }
});
var { addTooltipEntrySettings: $038eefd840ad861c$export$2eaa1babb4725485, replaceTooltipEntrySettings: $038eefd840ad861c$export$7333cdb61d5073d3, removeTooltipEntrySettings: $038eefd840ad861c$export$29793cde90169929, setTooltipSettingsState: $038eefd840ad861c$export$8d517a53c4528750, setActiveMouseOverItemIndex: $038eefd840ad861c$export$c78abbb2450f6b44, mouseLeaveItem: $038eefd840ad861c$export$68742311289b8f85, mouseLeaveChart: $038eefd840ad861c$export$73879bed3f2eef71, setActiveClickItemIndex: $038eefd840ad861c$export$99be2464250d8cae, setMouseOverAxisIndex: $038eefd840ad861c$export$a7277636863fc703, setMouseClickAxisIndex: $038eefd840ad861c$export$d2b1af5c3a560528, setSyncInteraction: $038eefd840ad861c$export$f2efc99b98e50938, setKeyboardInteraction: $038eefd840ad861c$export$820c94985c9eba3f } = $038eefd840ad861c$var$tooltipSlice.actions;
var $038eefd840ad861c$export$cadd4678b967dba6 = $038eefd840ad861c$var$tooltipSlice.reducer;


function $065b0b03628c3100$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $065b0b03628c3100$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $065b0b03628c3100$var$ownKeys(Object(t), !0).forEach(function(r) {
            $065b0b03628c3100$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $065b0b03628c3100$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $065b0b03628c3100$var$_defineProperty(e, r, t) {
    return (r = $065b0b03628c3100$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $065b0b03628c3100$var$_toPropertyKey(t) {
    var i = $065b0b03628c3100$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $065b0b03628c3100$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $065b0b03628c3100$var$chooseAppropriateMouseInteraction(tooltipState, tooltipEventType, trigger) {
    if (tooltipEventType === 'axis') {
        if (trigger === 'click') return tooltipState.axisInteraction.click;
        return tooltipState.axisInteraction.hover;
    }
    if (trigger === 'click') return tooltipState.itemInteraction.click;
    return tooltipState.itemInteraction.hover;
}
function $065b0b03628c3100$var$hasBeenActivePreviously(tooltipInteractionState) {
    return tooltipInteractionState.index != null;
}
var $065b0b03628c3100$export$d759c39cacfacf6a = (tooltipState, tooltipEventType, trigger, defaultIndex)=>{
    if (tooltipEventType == null) return 0, $038eefd840ad861c$export$66f2ad380b6acece;
    var appropriateMouseInteraction = $065b0b03628c3100$var$chooseAppropriateMouseInteraction(tooltipState, tooltipEventType, trigger);
    if (appropriateMouseInteraction == null) return 0, $038eefd840ad861c$export$66f2ad380b6acece;
    if (appropriateMouseInteraction.active) return appropriateMouseInteraction;
    if (tooltipState.keyboardInteraction.active) return tooltipState.keyboardInteraction;
    if (tooltipState.syncInteraction.active && tooltipState.syncInteraction.index != null) return tooltipState.syncInteraction;
    var activeFromProps = tooltipState.settings.active === true;
    if ($065b0b03628c3100$var$hasBeenActivePreviously(appropriateMouseInteraction)) {
        if (activeFromProps) return $065b0b03628c3100$var$_objectSpread($065b0b03628c3100$var$_objectSpread({}, appropriateMouseInteraction), {}, {
            active: true
        });
    } else if (defaultIndex != null) return {
        active: true,
        coordinate: undefined,
        dataKey: undefined,
        index: defaultIndex,
        graphicalItemId: undefined
    };
    return $065b0b03628c3100$var$_objectSpread($065b0b03628c3100$var$_objectSpread({}, (0, $038eefd840ad861c$export$66f2ad380b6acece)), {}, {
        coordinate: appropriateMouseInteraction.coordinate
    });
};





function $38fc54c0e5fe33b8$var$toFiniteNumber(value) {
    if (typeof value === 'number') return Number.isFinite(value) ? value : undefined;
    if (value instanceof Date) {
        var numericValue = value.valueOf();
        return Number.isFinite(numericValue) ? numericValue : undefined;
    }
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
}
function $38fc54c0e5fe33b8$var$isValueWithinNumberDomain(value, domain) {
    var numericValue = $38fc54c0e5fe33b8$var$toFiniteNumber(value);
    var lowerBound = domain[0];
    var upperBound = domain[1];
    if (numericValue === undefined) return false;
    var min = Math.min(lowerBound, upperBound);
    var max = Math.max(lowerBound, upperBound);
    return numericValue >= min && numericValue <= max;
}
function $38fc54c0e5fe33b8$var$isValueWithinDomain(entry, axisDataKey, domain) {
    if (domain == null || axisDataKey == null) return true;
    var value = (0, $912d8cf1d03ea507$export$f97fc4a450f29a)(entry, axisDataKey);
    if (value == null) return true;
    if (!(0, $10a31e6d89f791d6$export$ba29b24e2a92eb58)(domain)) return true;
    return $38fc54c0e5fe33b8$var$isValueWithinNumberDomain(value, domain);
}
var $38fc54c0e5fe33b8$export$32df4b03a0962e46 = (tooltipInteraction, chartData, axisDataKey, domain)=>{
    var desiredIndex = tooltipInteraction === null || tooltipInteraction === void 0 ? void 0 : tooltipInteraction.index;
    if (desiredIndex == null) return null;
    var indexAsNumber = Number(desiredIndex);
    if (!(0, $11a93f8f3c3518e5$export$f8a8fc612ced9bb0)(indexAsNumber)) // this is for charts like Sankey and Treemap that do not support numerical indexes. We need a proper solution for this before we can start supporting keyboard events on these charts.
    return desiredIndex;
    /*
   * Zero is a trivial limit for single-dimensional charts like Line and Area,
   * but this also needs a support for multidimensional charts like Sankey and Treemap! TODO
   */ var lowerLimit = 0;
    var upperLimit = Infinity;
    if (chartData.length > 0) upperLimit = chartData.length - 1;
    // now let's clamp the desiredIndex between the limits
    var clampedIndex = Math.max(lowerLimit, Math.min(indexAsNumber, upperLimit));
    var entry = chartData[clampedIndex];
    if (entry == null) return String(clampedIndex);
    if (!$38fc54c0e5fe33b8$var$isValueWithinDomain(entry, axisDataKey, domain)) return null;
    return String(clampedIndex);
};


var $df1e162003e24b73$export$c2cbc37a7546bbd0 = (width, height, layout, offset, tooltipTicks, defaultIndex, tooltipConfigurations, tooltipPayloadSearcher)=>{
    if (defaultIndex == null || tooltipPayloadSearcher == null) return undefined;
    // With defaultIndex alone, we don't have enough information to decide _which_ of the multiple tooltips to display. So we choose the first one.
    var firstConfiguration = tooltipConfigurations[0];
    // @ts-expect-error we need to rethink the tooltipPayloadSearcher type
    var maybePosition = firstConfiguration == null ? undefined : tooltipPayloadSearcher(firstConfiguration.positions, defaultIndex);
    if (maybePosition != null) return maybePosition;
    var tick = tooltipTicks === null || tooltipTicks === void 0 ? void 0 : tooltipTicks[Number(defaultIndex)];
    if (!tick) return undefined;
    switch(layout){
        case 'horizontal':
            return {
                x: tick.coordinate,
                y: (offset.top + height) / 2
            };
        default:
            // This logic is not super sound - it conflates vertical, radial, centric layouts into just one. TODO improve!
            return {
                x: (offset.left + width) / 2,
                y: tick.coordinate
            };
    }
};




var $3bb3b59f1f1868dc$export$45044aaa79c0cddb = (tooltipState, tooltipEventType, trigger, defaultIndex)=>{
    // if tooltip reacts to axis interaction, then we display all items at the same time.
    if (tooltipEventType === 'axis') return tooltipState.tooltipItemPayloads;
    /*
   * By now we already know that tooltipEventType is 'item', so we can only search in itemInteractions.
   * item means that only the hovered or clicked item will be present in the tooltip.
   */ if (tooltipState.tooltipItemPayloads.length === 0) // No point filtering if the payload is empty
    return [];
    var filterByGraphicalItemId;
    if (trigger === 'hover') filterByGraphicalItemId = tooltipState.itemInteraction.hover.graphicalItemId;
    else filterByGraphicalItemId = tooltipState.itemInteraction.click.graphicalItemId;
    if (filterByGraphicalItemId == null && defaultIndex != null) {
        /*
     * So when we use `defaultIndex` - we don't have a dataKey to filter by because user did not hover over anything yet.
     * In that case let's display the first item in the tooltip; after all, this is `item` interaction case,
     * so we should display only one item at a time instead of all.
     */ var firstItemPayload = tooltipState.tooltipItemPayloads[0];
        if (firstItemPayload != null) return [
            firstItemPayload
        ];
        return [];
    }
    return tooltipState.tooltipItemPayloads.filter((tpc)=>{
        var _tpc$settings;
        return ((_tpc$settings = tpc.settings) === null || _tpc$settings === void 0 ? void 0 : _tpc$settings.graphicalItemId) === filterByGraphicalItemId;
    });
};


var $add332f30cb660ad$export$6ae1ee94e6fa88a7 = (state)=>state.options.tooltipPayloadSearcher;


var $de1984c48ab3d63c$export$703b585bc92b5bae = (state)=>state.tooltip;





function $ecdb5daf6954abfe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ecdb5daf6954abfe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ecdb5daf6954abfe$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ecdb5daf6954abfe$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ecdb5daf6954abfe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ecdb5daf6954abfe$var$_defineProperty(e, r, t) {
    return (r = $ecdb5daf6954abfe$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ecdb5daf6954abfe$var$_toPropertyKey(t) {
    var i = $ecdb5daf6954abfe$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ecdb5daf6954abfe$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ecdb5daf6954abfe$var$selectFinalData(dataDefinedOnItem, dataDefinedOnChart) {
    /*
   * If a payload has data specified directly from the graphical item, prefer that.
   * Otherwise, fill in data from the chart level, using the same index.
   */ if (dataDefinedOnItem != null) return dataDefinedOnItem;
    return dataDefinedOnChart;
}
var $ecdb5daf6954abfe$export$e50d50655fe0e7ab = (tooltipPayloadConfigurations, activeIndex, chartDataState, tooltipAxisDataKey, activeLabel, tooltipPayloadSearcher, tooltipEventType)=>{
    if (activeIndex == null || tooltipPayloadSearcher == null) return undefined;
    var { chartData: chartData, computedData: computedData, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = chartDataState;
    var init = [];
    return tooltipPayloadConfigurations.reduce((agg, _ref)=>{
        var _settings$dataKey;
        var { dataDefinedOnItem: dataDefinedOnItem, settings: settings } = _ref;
        var finalData = $ecdb5daf6954abfe$var$selectFinalData(dataDefinedOnItem, chartData);
        var sliced = Array.isArray(finalData) ? (0, $02d70e7027eb09d9$export$238176e5211cdc1a)(finalData, dataStartIndex, dataEndIndex) : finalData;
        var finalDataKey = (_settings$dataKey = settings === null || settings === void 0 ? void 0 : settings.dataKey) !== null && _settings$dataKey !== void 0 ? _settings$dataKey : tooltipAxisDataKey;
        // BaseAxisProps does not support nameKey but it could!
        var finalNameKey = settings === null || settings === void 0 ? void 0 : settings.nameKey; // ?? tooltipAxis?.nameKey;
        var tooltipPayload;
        if (tooltipAxisDataKey && Array.isArray(sliced) && /*
     * findEntryInArray won't work for Scatter because Scatter provides an array of arrays
     * as tooltip payloads and findEntryInArray is not prepared to handle that.
     * Sad but also ScatterChart only allows 'item' tooltipEventType
     * and also this is only a problem if there are multiple Scatters and each has its own data array
     * so let's fix that some other time.
     */ !Array.isArray(sliced[0]) && /*
     * If the tooltipEventType is 'axis', we should search for the dataKey in the sliced data
     * because thanks to allowDuplicatedCategory=false, the order of elements in the array
     * no longer matches the order of elements in the original data
     * and so we need to search by the active dataKey + label rather than by index.
     *
     * The same happens if multiple graphical items are present in the chart
     * and each of them has its own data array. Those arrays get concatenated
     * and again the tooltip index no longer matches the original data.
     *
     * On the other hand the tooltipEventType 'item' should always search by index
     * because we get the index from interacting over the individual elements
     * which is always accurate, irrespective of the allowDuplicatedCategory setting.
     */ tooltipEventType === 'axis') tooltipPayload = (0, $9a1343d05dde836c$export$66950d3869f5cc67)(sliced, tooltipAxisDataKey, activeLabel);
        else /*
       * This is a problem because it assumes that the index is pointing to the displayed data
       * which it isn't because the index is pointing to the tooltip ticks array.
       * The above approach (with findEntryInArray) is the correct one, but it only works
       * if the axis dataKey is defined explicitly, and if the data is an array of objects.
       */ tooltipPayload = tooltipPayloadSearcher(sliced, activeIndex, computedData, finalNameKey);
        if (Array.isArray(tooltipPayload)) tooltipPayload.forEach((item)=>{
            var newSettings = $ecdb5daf6954abfe$var$_objectSpread($ecdb5daf6954abfe$var$_objectSpread({}, settings), {}, {
                // @ts-expect-error we're assuming that item has name and unit properties
                name: item.name,
                // @ts-expect-error we're assuming that item has name and unit properties
                unit: item.unit,
                // color and fill are erased to keep 100% the identical behaviour to recharts 2.x - but there's nothing stopping us from returning them here. It's technically a breaking change.
                color: undefined,
                // color and fill are erased to keep 100% the identical behaviour to recharts 2.x - but there's nothing stopping us from returning them here. It's technically a breaking change.
                fill: undefined
            });
            agg.push((0, $912d8cf1d03ea507$export$3c1b390368bb3561)({
                tooltipEntrySettings: newSettings,
                // @ts-expect-error we're assuming that item has name and unit properties
                dataKey: item.dataKey,
                // @ts-expect-error we're assuming that item has name and unit properties
                payload: item.payload,
                // @ts-expect-error getValueByDataKey does not validate the output type
                value: (0, $912d8cf1d03ea507$export$f97fc4a450f29a)(item.payload, item.dataKey),
                // @ts-expect-error we're assuming that item has name and unit properties
                name: item.name
            }));
        });
        else {
            var _getValueByDataKey;
            // I am not quite sure why these two branches (Array vs Array of Arrays) have to behave differently - I imagine we should unify these. 3.x breaking change?
            agg.push((0, $912d8cf1d03ea507$export$3c1b390368bb3561)({
                tooltipEntrySettings: settings,
                dataKey: finalDataKey,
                payload: tooltipPayload,
                // @ts-expect-error getValueByDataKey does not validate the output type
                value: (0, $912d8cf1d03ea507$export$f97fc4a450f29a)(tooltipPayload, finalDataKey),
                // @ts-expect-error getValueByDataKey does not validate the output type
                name: (_getValueByDataKey = (0, $912d8cf1d03ea507$export$f97fc4a450f29a)(tooltipPayload, finalNameKey)) !== null && _getValueByDataKey !== void 0 ? _getValueByDataKey : settings === null || settings === void 0 ? void 0 : settings.name
            }));
        }
        return agg;
    }, init);
};









var $36d5b5b4d0834cee$export$221021c57c593b2 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $8f21bd235d951197$export$27d9004292294cd7),
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    (0, $8f21bd235d951197$export$1c7798b82c8010cd),
    (0, $d319e2ad1ad322d2$export$3247769c9dbde559),
    (0, $411fa86e80c20dfb$export$898d3dfd98fb482)
], (0, $8f21bd235d951197$export$bebec32544750591));
var $36d5b5b4d0834cee$export$4751149f4d54cbbf = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (state)=>state.graphicalItems.cartesianItems,
    (state)=>state.graphicalItems.polarItems
], (cartesianItems, polarItems)=>[
        ...cartesianItems,
        ...polarItems
    ]);
var $36d5b5b4d0834cee$var$selectTooltipAxisPredicate = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $411fa86e80c20dfb$export$898d3dfd98fb482),
    (0, $9a8bc2d38fad28d3$export$eeffdb10daff095d)
], (0, $8f21bd235d951197$export$a3923f321c6572c3));
var $36d5b5b4d0834cee$export$645965005f643e6f = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$export$4751149f4d54cbbf,
    (0, $8f21bd235d951197$export$27d9004292294cd7),
    $36d5b5b4d0834cee$var$selectTooltipAxisPredicate
], (0, $8f21bd235d951197$export$ad35679ce4582010), {
    memoizeOptions: {
        resultEqualityCheck: (0, $20e12f99ca944083$export$dcc34c4213e7f4c)
    }
});
var $36d5b5b4d0834cee$var$selectAllStackedGraphicalItemsSettings = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$export$645965005f643e6f
], (graphicalItems)=>graphicalItems.filter((0, $2e709b3ca282ae8f$export$2335dd91cc88053e)));
var $36d5b5b4d0834cee$export$b3f948fbed0299f1 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$export$645965005f643e6f
], (0, $8f21bd235d951197$export$d945cee965d266f0), {
    memoizeOptions: {
        resultEqualityCheck: (0, $20e12f99ca944083$export$dcc34c4213e7f4c)
    }
});
var $36d5b5b4d0834cee$export$5a8beccc8250d20e = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$export$b3f948fbed0299f1,
    (0, $d6cc9cc11e425d5b$export$519edd692222520)
], (0, $8f21bd235d951197$export$c2c6d012cffe2c75));
var $36d5b5b4d0834cee$var$selectTooltipStackedData = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$var$selectAllStackedGraphicalItemsSettings,
    (0, $d6cc9cc11e425d5b$export$519edd692222520),
    (0, $8f21bd235d951197$export$27d9004292294cd7)
], (0, $0c25d0c543be64c4$export$ae6c77e7720cddf9));
var $36d5b5b4d0834cee$var$selectAllTooltipAppliedValues = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$export$5a8beccc8250d20e,
    (0, $8f21bd235d951197$export$27d9004292294cd7),
    $36d5b5b4d0834cee$export$645965005f643e6f
], (0, $8f21bd235d951197$export$3051da2013ba9cfe));
var $36d5b5b4d0834cee$var$selectTooltipAxisDomainDefinition = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $8f21bd235d951197$export$27d9004292294cd7)
], (0, $8f21bd235d951197$export$2e6262b6c952ab02));
var $36d5b5b4d0834cee$var$selectTooltipDataOverflow = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $8f21bd235d951197$export$27d9004292294cd7)
], (axisSettings)=>axisSettings.allowDataOverflow);
var $36d5b5b4d0834cee$var$selectTooltipDomainFromUserPreferences = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$var$selectTooltipAxisDomainDefinition,
    $36d5b5b4d0834cee$var$selectTooltipDataOverflow
], (0, $10a31e6d89f791d6$export$fcbf88d4627b24df));
var $36d5b5b4d0834cee$var$selectAllStackedGraphicalItems = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$export$645965005f643e6f
], (graphicalItems)=>graphicalItems.filter((0, $2e709b3ca282ae8f$export$2335dd91cc88053e)));
var $36d5b5b4d0834cee$var$selectTooltipStackGroups = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$var$selectTooltipStackedData,
    $36d5b5b4d0834cee$var$selectAllStackedGraphicalItems,
    (0, $d319e2ad1ad322d2$export$73aff39176364def),
    (0, $d319e2ad1ad322d2$export$ec830dc49707c6da)
], (0, $8f21bd235d951197$export$9312914d13496409));
var $36d5b5b4d0834cee$var$selectTooltipDomainOfStackGroups = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$var$selectTooltipStackGroups,
    (0, $d6cc9cc11e425d5b$export$519edd692222520),
    (0, $411fa86e80c20dfb$export$898d3dfd98fb482),
    $36d5b5b4d0834cee$var$selectTooltipDomainFromUserPreferences
], (0, $8f21bd235d951197$export$3286b8ea6ff06720));
var $36d5b5b4d0834cee$var$selectTooltipItemsSettingsExceptStacked = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$export$645965005f643e6f
], (0, $8f21bd235d951197$export$a61da86823382adc));
var $36d5b5b4d0834cee$var$selectDomainOfAllAppliedNumericalValuesIncludingErrorValues = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$export$5a8beccc8250d20e,
    (0, $8f21bd235d951197$export$27d9004292294cd7),
    $36d5b5b4d0834cee$var$selectTooltipItemsSettingsExceptStacked,
    (0, $8f21bd235d951197$export$9429ab4550237b6d),
    (0, $411fa86e80c20dfb$export$898d3dfd98fb482)
], (0, $8f21bd235d951197$export$df56c8e9a3e45e65), {
    memoizeOptions: {
        resultEqualityCheck: (0, $112aba0500e31420$export$45c01007b107f1a6)
    }
});
var $36d5b5b4d0834cee$var$selectReferenceDotsByTooltipAxis = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $8f21bd235d951197$export$71580de5ed38161a),
    (0, $411fa86e80c20dfb$export$898d3dfd98fb482),
    (0, $9a8bc2d38fad28d3$export$eeffdb10daff095d)
], (0, $8f21bd235d951197$export$2829d12117d2002f));
var $36d5b5b4d0834cee$var$selectTooltipReferenceDotsDomain = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$var$selectReferenceDotsByTooltipAxis,
    (0, $411fa86e80c20dfb$export$898d3dfd98fb482)
], (0, $8f21bd235d951197$export$5da0b79fd816ec4b));
var $36d5b5b4d0834cee$var$selectReferenceAreasByTooltipAxis = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $8f21bd235d951197$export$c7e152cb7f10c1a6),
    (0, $411fa86e80c20dfb$export$898d3dfd98fb482),
    (0, $9a8bc2d38fad28d3$export$eeffdb10daff095d)
], (0, $8f21bd235d951197$export$2829d12117d2002f));
var $36d5b5b4d0834cee$var$selectTooltipReferenceAreasDomain = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$var$selectReferenceAreasByTooltipAxis,
    (0, $411fa86e80c20dfb$export$898d3dfd98fb482)
], (0, $8f21bd235d951197$export$7b27918cf5e1fc19));
var $36d5b5b4d0834cee$var$selectReferenceLinesByTooltipAxis = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $8f21bd235d951197$export$8fe2a49ce63c5348),
    (0, $411fa86e80c20dfb$export$898d3dfd98fb482),
    (0, $9a8bc2d38fad28d3$export$eeffdb10daff095d)
], (0, $8f21bd235d951197$export$2829d12117d2002f));
var $36d5b5b4d0834cee$var$selectTooltipReferenceLinesDomain = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$var$selectReferenceLinesByTooltipAxis,
    (0, $411fa86e80c20dfb$export$898d3dfd98fb482)
], (0, $8f21bd235d951197$export$f1d17aebd11953eb));
var $36d5b5b4d0834cee$var$selectTooltipReferenceElementsDomain = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$var$selectTooltipReferenceDotsDomain,
    $36d5b5b4d0834cee$var$selectTooltipReferenceLinesDomain,
    $36d5b5b4d0834cee$var$selectTooltipReferenceAreasDomain
], (0, $8f21bd235d951197$export$9c8185c6eda0fb0d));
var $36d5b5b4d0834cee$var$selectTooltipNumericalDomain = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $8f21bd235d951197$export$27d9004292294cd7),
    $36d5b5b4d0834cee$var$selectTooltipAxisDomainDefinition,
    $36d5b5b4d0834cee$var$selectTooltipDomainFromUserPreferences,
    $36d5b5b4d0834cee$var$selectTooltipDomainOfStackGroups,
    $36d5b5b4d0834cee$var$selectDomainOfAllAppliedNumericalValuesIncludingErrorValues,
    $36d5b5b4d0834cee$var$selectTooltipReferenceElementsDomain,
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    (0, $411fa86e80c20dfb$export$898d3dfd98fb482)
], (0, $8f21bd235d951197$export$b9eca0fd568f66a4));
var $36d5b5b4d0834cee$export$76f7a1975f60ccf1 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $8f21bd235d951197$export$27d9004292294cd7),
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    $36d5b5b4d0834cee$export$5a8beccc8250d20e,
    $36d5b5b4d0834cee$var$selectAllTooltipAppliedValues,
    (0, $d319e2ad1ad322d2$export$73aff39176364def),
    (0, $411fa86e80c20dfb$export$898d3dfd98fb482),
    $36d5b5b4d0834cee$var$selectTooltipNumericalDomain
], (0, $8f21bd235d951197$export$70e6ef68424edf74));
var $36d5b5b4d0834cee$var$selectTooltipNiceTicks = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$export$76f7a1975f60ccf1,
    (0, $8f21bd235d951197$export$27d9004292294cd7),
    $36d5b5b4d0834cee$export$221021c57c593b2
], (0, $8f21bd235d951197$export$aa1ef6c8f610e48c));
var $36d5b5b4d0834cee$export$90be38154e4228b2 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $8f21bd235d951197$export$27d9004292294cd7),
    $36d5b5b4d0834cee$export$76f7a1975f60ccf1,
    $36d5b5b4d0834cee$var$selectTooltipNiceTicks,
    (0, $411fa86e80c20dfb$export$898d3dfd98fb482)
], (0, $8f21bd235d951197$export$3a4530026b1860ff));
var $36d5b5b4d0834cee$var$selectTooltipAxisRange = (state)=>{
    var axisType = (0, $411fa86e80c20dfb$export$898d3dfd98fb482)(state);
    var axisId = (0, $9a8bc2d38fad28d3$export$eeffdb10daff095d)(state);
    var isPanorama = false; // Tooltip never displays in panorama so this is safe to assume
    return (0, $8f21bd235d951197$export$3506ed461810cc8f)(state, axisType, axisId, isPanorama);
};
var $36d5b5b4d0834cee$export$cf4d6dfce3a76af3 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $8f21bd235d951197$export$27d9004292294cd7),
    $36d5b5b4d0834cee$var$selectTooltipAxisRange
], (0, $aa9bf5f7fc1905d1$export$3f7e30291950e694));
var $36d5b5b4d0834cee$export$cdeccbbdd343ae59 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $8f21bd235d951197$export$27d9004292294cd7),
    $36d5b5b4d0834cee$export$221021c57c593b2,
    $36d5b5b4d0834cee$export$90be38154e4228b2,
    $36d5b5b4d0834cee$export$cf4d6dfce3a76af3
], (0, $8f21bd235d951197$export$e2fe61793fcf6495));
var $36d5b5b4d0834cee$var$selectTooltipDuplicateDomain = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    $36d5b5b4d0834cee$var$selectAllTooltipAppliedValues,
    (0, $8f21bd235d951197$export$27d9004292294cd7),
    (0, $411fa86e80c20dfb$export$898d3dfd98fb482)
], (0, $8f21bd235d951197$export$bb1ebf56a37bd899));
var $36d5b5b4d0834cee$export$f7665d13a99c934c = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    $36d5b5b4d0834cee$var$selectAllTooltipAppliedValues,
    (0, $8f21bd235d951197$export$27d9004292294cd7),
    (0, $411fa86e80c20dfb$export$898d3dfd98fb482)
], (0, $8f21bd235d951197$export$911ef47868c9ab07));
var $36d5b5b4d0834cee$var$combineTicksOfTooltipAxis = (layout, axis, realScaleType, scale, range, duplicateDomain, categoricalDomain, axisType)=>{
    if (!axis) return undefined;
    var { type: type } = axis;
    var isCategorical = (0, $912d8cf1d03ea507$export$9fc1baaa6c6368b)(layout, axisType);
    if (!scale) return undefined;
    var offsetForBand = realScaleType === 'scaleBand' && scale.bandwidth ? scale.bandwidth() / 2 : 2;
    var offset = type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axisType === 'angleAxis' && range != null && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $9a1343d05dde836c$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        }));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        }));
};
var $36d5b5b4d0834cee$export$ffe0e60f8c88c05a = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    (0, $8f21bd235d951197$export$27d9004292294cd7),
    $36d5b5b4d0834cee$export$221021c57c593b2,
    $36d5b5b4d0834cee$export$cdeccbbdd343ae59,
    $36d5b5b4d0834cee$var$selectTooltipAxisRange,
    $36d5b5b4d0834cee$var$selectTooltipDuplicateDomain,
    $36d5b5b4d0834cee$export$f7665d13a99c934c,
    (0, $411fa86e80c20dfb$export$898d3dfd98fb482)
], $36d5b5b4d0834cee$var$combineTicksOfTooltipAxis);
var $36d5b5b4d0834cee$var$selectTooltipEventType = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $aab1adcf9dbc37ce$export$877d2dd8db5f51fd),
    (0, $aab1adcf9dbc37ce$export$7f95a7e594fa7911),
    (0, $596f687a7ed806f3$export$26d1e95fb7dea02)
], (defaultTooltipEventType, validateTooltipEventType, settings)=>(0, $aab1adcf9dbc37ce$export$d419a1f58b445a8f)(settings.shared, defaultTooltipEventType, validateTooltipEventType));
var $36d5b5b4d0834cee$var$selectTooltipTrigger = (state)=>state.tooltip.settings.trigger;
var $36d5b5b4d0834cee$var$selectDefaultIndex = (state)=>state.tooltip.settings.defaultIndex;
var $36d5b5b4d0834cee$var$selectTooltipInteractionState = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $de1984c48ab3d63c$export$703b585bc92b5bae),
    $36d5b5b4d0834cee$var$selectTooltipEventType,
    $36d5b5b4d0834cee$var$selectTooltipTrigger,
    $36d5b5b4d0834cee$var$selectDefaultIndex
], (0, $065b0b03628c3100$export$d759c39cacfacf6a));
var $36d5b5b4d0834cee$export$8b2762260f5891c9 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$var$selectTooltipInteractionState,
    $36d5b5b4d0834cee$export$5a8beccc8250d20e,
    (0, $8f21bd235d951197$export$bf8397fefbaa3617),
    $36d5b5b4d0834cee$export$76f7a1975f60ccf1
], (0, $38fc54c0e5fe33b8$export$32df4b03a0962e46));
var $36d5b5b4d0834cee$export$400c35cc3b9a0487 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$export$ffe0e60f8c88c05a,
    $36d5b5b4d0834cee$export$8b2762260f5891c9
], (0, $59977616e6d01c73$export$3213c4688ceb4c80));
var $36d5b5b4d0834cee$export$999f7a7ced063fab = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$var$selectTooltipInteractionState
], (tooltipInteraction)=>{
    if (!tooltipInteraction) return undefined;
    return tooltipInteraction.dataKey;
});
var $36d5b5b4d0834cee$export$3bddf33d79812741 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$var$selectTooltipInteractionState
], (tooltipInteraction)=>{
    if (!tooltipInteraction) return undefined;
    return tooltipInteraction.graphicalItemId;
});
var $36d5b5b4d0834cee$var$selectTooltipPayloadConfigurations = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $de1984c48ab3d63c$export$703b585bc92b5bae),
    $36d5b5b4d0834cee$var$selectTooltipEventType,
    $36d5b5b4d0834cee$var$selectTooltipTrigger,
    $36d5b5b4d0834cee$var$selectDefaultIndex
], (0, $3bb3b59f1f1868dc$export$45044aaa79c0cddb));
var $36d5b5b4d0834cee$var$selectTooltipCoordinateForDefaultIndex = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $52905d0b62bb57b1$export$771ef0ac044f724d),
    (0, $52905d0b62bb57b1$export$5856a7d94c109505),
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    (0, $4d79bfb805950901$export$1e34c8efb0bc9b3b),
    $36d5b5b4d0834cee$export$ffe0e60f8c88c05a,
    $36d5b5b4d0834cee$var$selectDefaultIndex,
    $36d5b5b4d0834cee$var$selectTooltipPayloadConfigurations,
    (0, $add332f30cb660ad$export$6ae1ee94e6fa88a7)
], (0, $df1e162003e24b73$export$c2cbc37a7546bbd0));
var $36d5b5b4d0834cee$export$90c565a5b196e427 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$var$selectTooltipInteractionState,
    $36d5b5b4d0834cee$var$selectTooltipCoordinateForDefaultIndex
], (tooltipInteractionState, defaultIndexCoordinate)=>{
    if (tooltipInteractionState !== null && tooltipInteractionState !== void 0 && tooltipInteractionState.coordinate) return tooltipInteractionState.coordinate;
    return defaultIndexCoordinate;
});
var $36d5b5b4d0834cee$export$c8884ed37796034a = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$var$selectTooltipInteractionState
], (tooltipInteractionState)=>{
    var _tooltipInteractionSt;
    return (_tooltipInteractionSt = tooltipInteractionState === null || tooltipInteractionState === void 0 ? void 0 : tooltipInteractionState.active) !== null && _tooltipInteractionSt !== void 0 ? _tooltipInteractionSt : false;
});
var $36d5b5b4d0834cee$export$a2bb5be6e87cbb86 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$var$selectTooltipPayloadConfigurations,
    $36d5b5b4d0834cee$export$8b2762260f5891c9,
    (0, $d6cc9cc11e425d5b$export$519edd692222520),
    (0, $8f21bd235d951197$export$bf8397fefbaa3617),
    $36d5b5b4d0834cee$export$400c35cc3b9a0487,
    (0, $add332f30cb660ad$export$6ae1ee94e6fa88a7),
    $36d5b5b4d0834cee$var$selectTooltipEventType
], (0, $ecdb5daf6954abfe$export$e50d50655fe0e7ab));
var $36d5b5b4d0834cee$export$1a5b9bd341ad5f0e = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $36d5b5b4d0834cee$export$a2bb5be6e87cbb86
], (payload)=>{
    if (payload == null) return undefined;
    var dataPoints = payload.map((p)=>p.payload).filter((p)=>p != null);
    return Array.from(new Set(dataPoints));
});




function $1426ac70c5e0f1c4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1426ac70c5e0f1c4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1426ac70c5e0f1c4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1426ac70c5e0f1c4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1426ac70c5e0f1c4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1426ac70c5e0f1c4$var$_defineProperty(e, r, t) {
    return (r = $1426ac70c5e0f1c4$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1426ac70c5e0f1c4$var$_toPropertyKey(t) {
    var i = $1426ac70c5e0f1c4$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1426ac70c5e0f1c4$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $1426ac70c5e0f1c4$export$e43f7367e579f53d = 0;
/**
 * Properties shared in X, Y, and Z axes
 */ /**
 * These are the external props, visible for users as they set them using our public API.
 * There is all sorts of internal computed things based on these, but they will come through selectors.
 *
 * Properties shared between X and Y axes
 */ /**
 * Z axis is special because it's never displayed. It controls the size of Scatter dots,
 * but it never displays ticks anywhere.
 */ var $1426ac70c5e0f1c4$var$initialState = {
    xAxis: {},
    yAxis: {},
    zAxis: {}
};
/**
 * This is the slice where each individual Axis element pushes its own configuration.
 * Prefer to use this one instead of axisSlice.
 */ var $1426ac70c5e0f1c4$var$cartesianAxisSlice = (0, $ec80cf871915f813$export$4d8d9bd83c24ae8b)({
    name: 'cartesianAxis',
    initialState: $1426ac70c5e0f1c4$var$initialState,
    reducers: {
        addXAxis: {
            reducer (state, action) {
                state.xAxis[action.payload.id] = (0, $46230e101f7bd5ae$export$c05b21e3257751e5)(action.payload);
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        replaceXAxis: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                if (state.xAxis[prev.id] !== undefined) {
                    if (prev.id !== next.id) delete state.xAxis[prev.id];
                    state.xAxis[next.id] = (0, $46230e101f7bd5ae$export$c05b21e3257751e5)(next);
                }
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        removeXAxis: {
            reducer (state, action) {
                delete state.xAxis[action.payload.id];
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        addYAxis: {
            reducer (state, action) {
                state.yAxis[action.payload.id] = (0, $46230e101f7bd5ae$export$c05b21e3257751e5)(action.payload);
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        replaceYAxis: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                if (state.yAxis[prev.id] !== undefined) {
                    if (prev.id !== next.id) delete state.yAxis[prev.id];
                    state.yAxis[next.id] = (0, $46230e101f7bd5ae$export$c05b21e3257751e5)(next);
                }
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        removeYAxis: {
            reducer (state, action) {
                delete state.yAxis[action.payload.id];
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        addZAxis: {
            reducer (state, action) {
                state.zAxis[action.payload.id] = (0, $46230e101f7bd5ae$export$c05b21e3257751e5)(action.payload);
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        replaceZAxis: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                if (state.zAxis[prev.id] !== undefined) {
                    if (prev.id !== next.id) delete state.zAxis[prev.id];
                    state.zAxis[next.id] = (0, $46230e101f7bd5ae$export$c05b21e3257751e5)(next);
                }
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        removeZAxis: {
            reducer (state, action) {
                delete state.zAxis[action.payload.id];
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        updateYAxisWidth (state, action) {
            var { id: id, width: width } = action.payload;
            var axis = state.yAxis[id];
            if (axis) {
                var history = axis.widthHistory || [];
                // An oscillation is detected when the new width is the same as the width before the last one.
                // This is a simple A -> B -> A pattern. If the next width is B, and the difference is less than 1 pixel, we ignore it.
                if (history.length === 3 && history[0] === history[2] && width === history[1] && width !== axis.width && Math.abs(width - history[0]) <= 1) return;
                var newHistory = [
                    ...history,
                    width
                ].slice(-3);
                state.yAxis[id] = $1426ac70c5e0f1c4$var$_objectSpread($1426ac70c5e0f1c4$var$_objectSpread({}, state.yAxis[id]), {}, {
                    width: width,
                    widthHistory: newHistory
                });
            }
        }
    }
});
var { addXAxis: $1426ac70c5e0f1c4$export$add6226ad7812fc8, replaceXAxis: $1426ac70c5e0f1c4$export$40aac341c282a543, removeXAxis: $1426ac70c5e0f1c4$export$f408189458c6a79b, addYAxis: $1426ac70c5e0f1c4$export$4ed10a19d7febea1, replaceYAxis: $1426ac70c5e0f1c4$export$58b7fa4a7d4572f6, removeYAxis: $1426ac70c5e0f1c4$export$79db5e9bd25f14c4, addZAxis: $1426ac70c5e0f1c4$export$1c8a1319a1571880, replaceZAxis: $1426ac70c5e0f1c4$export$ad147e7505520476, removeZAxis: $1426ac70c5e0f1c4$export$d823f07ec1da7041, updateYAxisWidth: $1426ac70c5e0f1c4$export$6e42dbbf4e5a5faa } = $1426ac70c5e0f1c4$var$cartesianAxisSlice.actions;
var $1426ac70c5e0f1c4$export$c8ae79f5f6ae07c6 = $1426ac70c5e0f1c4$var$cartesianAxisSlice.reducer;








var $4de8777fd13eeec7$export$623d7e312118b313 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $4d79bfb805950901$export$1e34c8efb0bc9b3b)
], (offsetInternal)=>{
    return {
        top: offsetInternal.top,
        bottom: offsetInternal.bottom,
        left: offsetInternal.left,
        right: offsetInternal.right
    };
});





var $615d64fd44f73522$export$8a921ed356911d9a = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $4de8777fd13eeec7$export$623d7e312118b313),
    (0, $52905d0b62bb57b1$export$771ef0ac044f724d),
    (0, $52905d0b62bb57b1$export$5856a7d94c109505)
], (offset, chartWidth, chartHeight)=>{
    if (!offset || chartWidth == null || chartHeight == null) return undefined;
    return {
        x: offset.left,
        y: offset.top,
        width: Math.max(0, chartWidth - offset.left - offset.right),
        height: Math.max(0, chartHeight - offset.top - offset.bottom)
    };
});


var $cf472f754cd2bf9d$export$5acf30f46eb8262f = (xAxisId)=>{
    var isPanorama = (0, $d64615d5c7c4e07c$export$4b0c59f8845ba920)();
    return (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $8f21bd235d951197$export$db36c2f3bfe5c9d7)(state, 'xAxis', xAxisId, isPanorama));
};
var $cf472f754cd2bf9d$export$db526816f6980005 = (yAxisId)=>{
    var isPanorama = (0, $d64615d5c7c4e07c$export$4b0c59f8845ba920)();
    return (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $8f21bd235d951197$export$db36c2f3bfe5c9d7)(state, 'yAxis', yAxisId, isPanorama));
};
var $cf472f754cd2bf9d$export$44023ffa3b5a8134 = ()=>{
    return (0, $bf278eb346227770$export$a7347740d65f620b)((0, $36d5b5b4d0834cee$export$400c35cc3b9a0487));
};
var $cf472f754cd2bf9d$export$99e5207fa7e69f17 = ()=>{
    return (0, $bf278eb346227770$export$a7347740d65f620b)((0, $4de8777fd13eeec7$export$623d7e312118b313));
};
var $cf472f754cd2bf9d$export$f1ef8efc9ef6fe0c = ()=>{
    return (0, $bf278eb346227770$export$a7347740d65f620b)((0, $615d64fd44f73522$export$8a921ed356911d9a));
};
var $cf472f754cd2bf9d$export$a5935a9f8709ac28 = ()=>{
    return (0, $bf278eb346227770$export$a7347740d65f620b)((0, $36d5b5b4d0834cee$export$1a5b9bd341ad5f0e));
};
var $cf472f754cd2bf9d$export$fef606eda509da71 = function useXAxisDomain() {
    var xAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $1426ac70c5e0f1c4$export$e43f7367e579f53d);
    var isPanorama = (0, $d64615d5c7c4e07c$export$4b0c59f8845ba920)();
    return (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $8f21bd235d951197$export$4fc5ecb5227dd744)(state, 'xAxis', xAxisId, isPanorama));
};
var $cf472f754cd2bf9d$export$530156bda5a6e0b8 = function useYAxisDomain() {
    var yAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $1426ac70c5e0f1c4$export$e43f7367e579f53d);
    var isPanorama = (0, $d64615d5c7c4e07c$export$4b0c59f8845ba920)();
    return (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $8f21bd235d951197$export$4fc5ecb5227dd744)(state, 'yAxis', yAxisId, isPanorama));
};






function $bd092d308d8485c0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bd092d308d8485c0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bd092d308d8485c0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $bd092d308d8485c0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bd092d308d8485c0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bd092d308d8485c0$var$_defineProperty(e, r, t) {
    return (r = $bd092d308d8485c0$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $bd092d308d8485c0$var$_toPropertyKey(t) {
    var i = $bd092d308d8485c0$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $bd092d308d8485c0$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $bd092d308d8485c0$var$ActivePoint = (_ref)=>{
    var { point: point, childIndex: childIndex, mainColor: mainColor, activeDot: activeDot, dataKey: dataKey, clipPath: clipPath } = _ref;
    if (activeDot === false || point.x == null || point.y == null) return null;
    var dotPropsTyped = {
        index: childIndex,
        dataKey: dataKey,
        cx: point.x,
        cy: point.y,
        r: 4,
        fill: mainColor !== null && mainColor !== void 0 ? mainColor : 'none',
        strokeWidth: 2,
        stroke: '#fff',
        payload: point.payload,
        value: point.value
    };
    // @ts-expect-error svgPropertiesNoEventsFromUnknown(activeDot) is contributing unknown props
    var dotProps = $bd092d308d8485c0$var$_objectSpread($bd092d308d8485c0$var$_objectSpread($bd092d308d8485c0$var$_objectSpread({}, dotPropsTyped), (0, $3d820e26962aea02$export$6d5921c09aa671a9)(activeDot)), (0, $4009b9153cff02e8$export$7c4c290a4a9c1b1e)(activeDot));
    var dot;
    if (/*#__PURE__*/ (0, $28UcW.isValidElement)(activeDot)) // @ts-expect-error we're improperly typing events
    dot = /*#__PURE__*/ (0, $28UcW.cloneElement)(activeDot, dotProps);
    else if (typeof activeDot === 'function') dot = activeDot(dotProps);
    else dot = /*#__PURE__*/ $28UcW.createElement((0, $1c02e9deaea11a2b$export$d046b3c4a416f60d), dotProps);
    return /*#__PURE__*/ $28UcW.createElement((0, $06287e412aaf2f1c$export$936d0764594b6eb3), {
        className: "recharts-active-dot",
        clipPath: clipPath
    }, dot);
};
function $bd092d308d8485c0$export$dd2d3dc8acd956aa(_ref2) {
    var { points: points, mainColor: mainColor, activeDot: activeDot, itemDataKey: itemDataKey, clipPath: clipPath, zIndex: zIndex = (0, $45e92ad7df96f1e3$export$96df16b28aa32702).activeDot } = _ref2;
    var activeTooltipIndex = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $36d5b5b4d0834cee$export$8b2762260f5891c9));
    var activeDataPoints = (0, $cf472f754cd2bf9d$export$a5935a9f8709ac28)();
    if (points == null || activeDataPoints == null) return null;
    var activePoint = points.find((p)=>activeDataPoints.includes(p.payload));
    if ((0, $9a1343d05dde836c$export$b931b78cbb3caf86)(activePoint)) return null;
    return /*#__PURE__*/ $28UcW.createElement((0, $3603bfc8e6eb9e37$export$b37befaf92aba9f1), {
        zIndex: zIndex
    }, /*#__PURE__*/ $28UcW.createElement($bd092d308d8485c0$var$ActivePoint, {
        point: activePoint,
        childIndex: Number(activeTooltipIndex),
        mainColor: mainColor,
        dataKey: itemDataKey,
        activeDot: activeDot,
        clipPath: clipPath
    }));
}



var $28UcW = parcelRequire("28UcW");



function $8e4c9ddf806a5a3a$export$7fa09c17ce18f3e8(_ref) {
    var { tooltipEntrySettings: tooltipEntrySettings } = _ref;
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    var isPanorama = (0, $d64615d5c7c4e07c$export$4b0c59f8845ba920)();
    var prevSettingsRef = (0, $28UcW.useRef)(null);
    (0, $28UcW.useLayoutEffect)(()=>{
        if (isPanorama) // Panorama graphical items should never contribute to Tooltip payload.
        return;
        if (prevSettingsRef.current === null) dispatch((0, $038eefd840ad861c$export$2eaa1babb4725485)(tooltipEntrySettings));
        else if (prevSettingsRef.current !== tooltipEntrySettings) dispatch((0, $038eefd840ad861c$export$7333cdb61d5073d3)({
            prev: prevSettingsRef.current,
            next: tooltipEntrySettings
        }));
        prevSettingsRef.current = tooltipEntrySettings;
    }, [
        tooltipEntrySettings,
        dispatch,
        isPanorama
    ]);
    (0, $28UcW.useLayoutEffect)(()=>{
        return ()=>{
            if (prevSettingsRef.current) {
                dispatch((0, $038eefd840ad861c$export$29793cde90169929)(prevSettingsRef.current));
                prevSettingsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}



var $28UcW = parcelRequire("28UcW");

/**
 * ErrorBars have lot more settings but all the others are scoped to the component itself.
 * Only some of them required to be reported to the global store because XAxis and YAxis need to know
 * if the error bar is contributing to extending the axis domain.
 */ var $ae7e4deeef0773e1$var$initialState = {};
var $ae7e4deeef0773e1$var$errorBarSlice = (0, $ec80cf871915f813$export$4d8d9bd83c24ae8b)({
    name: 'errorBars',
    initialState: $ae7e4deeef0773e1$var$initialState,
    reducers: {
        addErrorBar: (state, action)=>{
            var { itemId: itemId, errorBar: errorBar } = action.payload;
            if (!state[itemId]) state[itemId] = [];
            state[itemId].push(errorBar);
        },
        replaceErrorBar: (state, action)=>{
            var { itemId: itemId, prev: prev, next: next } = action.payload;
            if (state[itemId]) state[itemId] = state[itemId].map((e)=>e.dataKey === prev.dataKey && e.direction === prev.direction ? next : e);
        },
        removeErrorBar: (state, action)=>{
            var { itemId: itemId, errorBar: errorBar } = action.payload;
            if (state[itemId]) state[itemId] = state[itemId].filter((e)=>e.dataKey !== errorBar.dataKey || e.direction !== errorBar.direction);
        }
    }
});
var { addErrorBar: $ae7e4deeef0773e1$export$155912f95c88abac, replaceErrorBar: $ae7e4deeef0773e1$export$f1ebd3b9f70a9f5f, removeErrorBar: $ae7e4deeef0773e1$export$b0d2fb6a7d9d3b45 } = $ae7e4deeef0773e1$var$errorBarSlice.actions;
var $ae7e4deeef0773e1$export$6dda85fa3c67ca19 = $ae7e4deeef0773e1$var$errorBarSlice.reducer;




var $28UcW = parcelRequire("28UcW");

var $28UcW = parcelRequire("28UcW");

var $f32ceb22e057b406$var$_ref;
var $f32ceb22e057b406$export$bf86633db292cdb4 = ()=>{
    var [id] = $28UcW.useState(()=>(0, $9a1343d05dde836c$export$8b15d37bc3f197d4)('uid-'));
    return id;
};
var $f32ceb22e057b406$export$f680877a34711e37 = ($f32ceb22e057b406$var$_ref = $28UcW['useId'.toString()]) !== null && $f32ceb22e057b406$var$_ref !== void 0 ? $f32ceb22e057b406$var$_ref : $f32ceb22e057b406$export$bf86633db292cdb4;


function $efa273d1e578ea37$export$c485849f2e393253(prefix, customId) {
    /*
   * We have to call this hook here even if we don't use the result because
   * rules of hooks demand that hooks are never called conditionally.
   */ var generatedId = (0, $f32ceb22e057b406$export$f680877a34711e37)();
    // If a custom ID is provided, it always takes precedence.
    if (customId) return customId;
    // Apply the prefix if one was provided.
    return prefix ? "".concat(prefix, "-").concat(generatedId) : generatedId;
} /**
 * The useUniqueId hook returns a unique ID that is either reused from external props or generated internally.
 * Either way the ID is now guaranteed to be present so no more nulls or undefined.
 */ 


var $a1b930a3052976a6$var$GraphicalItemIdContext = /*#__PURE__*/ (0, $28UcW.createContext)(undefined);
var $a1b930a3052976a6$export$8c2f307ff93f02ba = (_ref)=>{
    var { id: id, type: type, children: children } = _ref;
    var resolvedId = (0, $efa273d1e578ea37$export$c485849f2e393253)("recharts-".concat(type), id);
    return /*#__PURE__*/ $28UcW.createElement($a1b930a3052976a6$var$GraphicalItemIdContext.Provider, {
        value: resolvedId
    }, children(resolvedId));
};
function $a1b930a3052976a6$export$e24f341c4ff41691() {
    return (0, $28UcW.useContext)($a1b930a3052976a6$var$GraphicalItemIdContext);
}


var $eec382277d540037$var$_excluded = [
    "children"
];
function $eec382277d540037$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $eec382277d540037$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $eec382277d540037$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $eec382277d540037$var$initialContextState = {
    data: [],
    xAxisId: 'xAxis-0',
    yAxisId: 'yAxis-0',
    dataPointFormatter: ()=>({
            x: 0,
            y: 0,
            value: 0
        }),
    errorBarOffset: 0
};
var $eec382277d540037$var$ErrorBarContext = /*#__PURE__*/ (0, $28UcW.createContext)($eec382277d540037$var$initialContextState);
function $eec382277d540037$export$fcd6ba6fb4bc66e7(props) {
    var { children: children } = props, rest = $eec382277d540037$var$_objectWithoutProperties(props, $eec382277d540037$var$_excluded);
    return /*#__PURE__*/ $28UcW.createElement($eec382277d540037$var$ErrorBarContext.Provider, {
        value: rest
    }, children);
}
var $eec382277d540037$export$ce29452bff119c97 = ()=>(0, $28UcW.useContext)($eec382277d540037$var$ErrorBarContext);
function $eec382277d540037$export$18dc5be7c8cb3008(props) {
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    var graphicalItemId = (0, $a1b930a3052976a6$export$e24f341c4ff41691)();
    var prevPropsRef = (0, $28UcW.useRef)(null);
    (0, $28UcW.useEffect)(()=>{
        if (graphicalItemId == null) // ErrorBar outside a graphical item context does not do anything.
        return;
        if (prevPropsRef.current === null) dispatch((0, $ae7e4deeef0773e1$export$155912f95c88abac)({
            itemId: graphicalItemId,
            errorBar: props
        }));
        else if (prevPropsRef.current !== props) dispatch((0, $ae7e4deeef0773e1$export$f1ebd3b9f70a9f5f)({
            itemId: graphicalItemId,
            prev: prevPropsRef.current,
            next: props
        }));
        prevPropsRef.current = props;
    }, [
        dispatch,
        graphicalItemId,
        props
    ]);
    (0, $28UcW.useEffect)(()=>{
        return ()=>{
            if (prevPropsRef.current != null && graphicalItemId != null) {
                dispatch((0, $ae7e4deeef0773e1$export$b0d2fb6a7d9d3b45)({
                    itemId: graphicalItemId,
                    errorBar: prevPropsRef.current
                }));
                prevPropsRef.current = null;
            }
        };
    }, [
        dispatch,
        graphicalItemId
    ]);
    return null;
}



var $28UcW = parcelRequire("28UcW");



function $dcc21075cc3e5cd7$export$79e142f66441c204(xAxisId, yAxisId) {
    var _xAxis$allowDataOverf, _yAxis$allowDataOverf;
    var xAxis = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $8f21bd235d951197$export$d6895d8ddb4cee5)(state, xAxisId));
    var yAxis = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $8f21bd235d951197$export$1f472705a332f1c9)(state, yAxisId));
    var needClipX = (_xAxis$allowDataOverf = xAxis === null || xAxis === void 0 ? void 0 : xAxis.allowDataOverflow) !== null && _xAxis$allowDataOverf !== void 0 ? _xAxis$allowDataOverf : (0, $8f21bd235d951197$export$21aec091b6ac8422).allowDataOverflow;
    var needClipY = (_yAxis$allowDataOverf = yAxis === null || yAxis === void 0 ? void 0 : yAxis.allowDataOverflow) !== null && _yAxis$allowDataOverf !== void 0 ? _yAxis$allowDataOverf : (0, $8f21bd235d951197$export$397148de2ecdec3c).allowDataOverflow;
    var needClip = needClipX || needClipY;
    return {
        needClip: needClip,
        needClipX: needClipX,
        needClipY: needClipY
    };
}
function $dcc21075cc3e5cd7$export$d65f7a7dd82fbb63(_ref) {
    var { xAxisId: xAxisId, yAxisId: yAxisId, clipPathId: clipPathId } = _ref;
    var plotArea = (0, $cf472f754cd2bf9d$export$f1ef8efc9ef6fe0c)();
    var { needClipX: needClipX, needClipY: needClipY, needClip: needClip } = $dcc21075cc3e5cd7$export$79e142f66441c204(xAxisId, yAxisId);
    if (!needClip || !plotArea) return null;
    var { x: x, y: y, width: width, height: height } = plotArea;
    return /*#__PURE__*/ $28UcW.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
    }, /*#__PURE__*/ $28UcW.createElement("rect", {
        x: needClipX ? x : x - width / 2,
        y: needClipY ? y : y - height / 2,
        width: needClipX ? width : width * 2,
        height: needClipY ? height : height * 2
    }));
}










var $88297809403819de$var$selectXAxisWithScale = (state, xAxisId, _yAxisId, isPanorama)=>(0, $8f21bd235d951197$export$db36c2f3bfe5c9d7)(state, 'xAxis', xAxisId, isPanorama);
var $88297809403819de$var$selectXAxisTicks = (state, xAxisId, _yAxisId, isPanorama)=>(0, $8f21bd235d951197$export$b894cb5d8586b43d)(state, 'xAxis', xAxisId, isPanorama);
var $88297809403819de$var$selectYAxisWithScale = (state, _xAxisId, yAxisId, isPanorama)=>(0, $8f21bd235d951197$export$db36c2f3bfe5c9d7)(state, 'yAxis', yAxisId, isPanorama);
var $88297809403819de$var$selectYAxisTicks = (state, _xAxisId, yAxisId, isPanorama)=>(0, $8f21bd235d951197$export$b894cb5d8586b43d)(state, 'yAxis', yAxisId, isPanorama);
var $88297809403819de$var$selectBandSize = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    $88297809403819de$var$selectXAxisWithScale,
    $88297809403819de$var$selectYAxisWithScale,
    $88297809403819de$var$selectXAxisTicks,
    $88297809403819de$var$selectYAxisTicks
], (layout, xAxis, yAxis, xAxisTicks, yAxisTicks)=>{
    if ((0, $912d8cf1d03ea507$export$9fc1baaa6c6368b)(layout, 'xAxis')) return (0, $912d8cf1d03ea507$export$212ec45c42fe68a7)(xAxis, xAxisTicks, false);
    return (0, $912d8cf1d03ea507$export$212ec45c42fe68a7)(yAxis, yAxisTicks, false);
});
var $88297809403819de$var$pickLineId = (_state, _xAxisId, _yAxisId, _isPanorama, id)=>id;
function $88297809403819de$var$isLineSettings(item) {
    return item.type === 'line';
}
/*
 * There is a race condition problem because we read some data from props and some from the state.
 * The state is updated through a dispatch and is one render behind,
 * and so we have this weird one tick render where the displayedData in one selector have the old dataKey
 * but the new dataKey in another selector.
 *
 * So here instead of reading the dataKey from the props, we always read it from the state.
 */ var $88297809403819de$var$selectSynchronisedLineSettings = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $8f21bd235d951197$export$f67c737adf41a3af),
    $88297809403819de$var$pickLineId
], (graphicalItems, id)=>graphicalItems.filter($88297809403819de$var$isLineSettings).find((x)=>x.id === id));
var $88297809403819de$export$3eaebea0f6c183c0 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    $88297809403819de$var$selectXAxisWithScale,
    $88297809403819de$var$selectYAxisWithScale,
    $88297809403819de$var$selectXAxisTicks,
    $88297809403819de$var$selectYAxisTicks,
    $88297809403819de$var$selectSynchronisedLineSettings,
    $88297809403819de$var$selectBandSize,
    (0, $d6cc9cc11e425d5b$export$fe05134c2701d897)
], (layout, xAxis, yAxis, xAxisTicks, yAxisTicks, lineSettings, bandSize, _ref)=>{
    var { chartData: chartData, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = _ref;
    if (lineSettings == null || xAxis == null || yAxis == null || xAxisTicks == null || yAxisTicks == null || xAxisTicks.length === 0 || yAxisTicks.length === 0 || bandSize == null || layout !== 'horizontal' && layout !== 'vertical') return undefined;
    var { dataKey: dataKey, data: data } = lineSettings;
    var displayedData;
    if (data != null && data.length > 0) displayedData = data;
    else displayedData = chartData === null || chartData === void 0 ? void 0 : chartData.slice(dataStartIndex, dataEndIndex + 1);
    if (displayedData == null) return undefined;
    return (0, $0af3c38f38567981$export$bfbd9a993cf94d79)({
        layout: layout,
        xAxis: xAxis,
        yAxis: yAxis,
        xAxisTicks: xAxisTicks,
        yAxisTicks: yAxisTicks,
        dataKey: dataKey,
        bandSize: bandSize,
        displayedData: displayedData
    });
});




var $28UcW = parcelRequire("28UcW");




function $50f39ee352ba7e28$export$34b61b169492c008(_ref) {
    var { legendPayload: legendPayload } = _ref;
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    var isPanorama = (0, $d64615d5c7c4e07c$export$4b0c59f8845ba920)();
    var prevPayloadRef = (0, $28UcW.useRef)(null);
    (0, $28UcW.useLayoutEffect)(()=>{
        if (isPanorama) return;
        if (prevPayloadRef.current === null) dispatch((0, $64fc3eecfa5a3e7d$export$236fd33b6ffe3f4b)(legendPayload));
        else if (prevPayloadRef.current !== legendPayload) dispatch((0, $64fc3eecfa5a3e7d$export$379d42d798953c3d)({
            prev: prevPayloadRef.current,
            next: legendPayload
        }));
        prevPayloadRef.current = legendPayload;
    }, [
        dispatch,
        isPanorama,
        legendPayload
    ]);
    (0, $28UcW.useLayoutEffect)(()=>{
        return ()=>{
            if (prevPayloadRef.current) {
                dispatch((0, $64fc3eecfa5a3e7d$export$337e5f2bb3b9e128)(prevPayloadRef.current));
                prevPayloadRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}
function $50f39ee352ba7e28$export$eb937fedea4aab3a(_ref2) {
    var { legendPayload: legendPayload } = _ref2;
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    var layout = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $6ade474fe9f2b6e0$export$8426b6d9af801dee));
    var prevPayloadRef = (0, $28UcW.useRef)(null);
    (0, $28UcW.useLayoutEffect)(()=>{
        if (layout !== 'centric' && layout !== 'radial') return;
        if (prevPayloadRef.current === null) dispatch((0, $64fc3eecfa5a3e7d$export$236fd33b6ffe3f4b)(legendPayload));
        else if (prevPayloadRef.current !== legendPayload) dispatch((0, $64fc3eecfa5a3e7d$export$379d42d798953c3d)({
            prev: prevPayloadRef.current,
            next: legendPayload
        }));
        prevPayloadRef.current = legendPayload;
    }, [
        dispatch,
        layout,
        legendPayload
    ]);
    (0, $28UcW.useLayoutEffect)(()=>{
        return ()=>{
            if (prevPayloadRef.current) {
                dispatch((0, $64fc3eecfa5a3e7d$export$337e5f2bb3b9e128)(prevPayloadRef.current));
                prevPayloadRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}



var $28UcW = parcelRequire("28UcW");

function $49cf52428a039363$export$e1042b2944b80b7f(input) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'animation-';
    var animationId = (0, $28UcW.useRef)((0, $9a1343d05dde836c$export$8b15d37bc3f197d4)(prefix));
    var prevProps = (0, $28UcW.useRef)(input);
    if (prevProps.current !== input) {
        animationId.current = (0, $9a1343d05dde836c$export$8b15d37bc3f197d4)(prefix);
        prevProps.current = input;
    }
    return animationId.current;
}






var $28UcW = parcelRequire("28UcW");



/**
 * Unique ID of the graphical item.
 * This is used to identify the graphical item in the state and in the React tree.
 * This is required for every graphical item - it's either provided by the user or generated automatically.
 */ var $9f25864d38d26021$var$initialState = {
    cartesianItems: [],
    polarItems: []
};
var $9f25864d38d26021$var$graphicalItemsSlice = (0, $ec80cf871915f813$export$4d8d9bd83c24ae8b)({
    name: 'graphicalItems',
    initialState: $9f25864d38d26021$var$initialState,
    reducers: {
        addCartesianGraphicalItem: {
            reducer (state, action) {
                state.cartesianItems.push((0, $46230e101f7bd5ae$export$c05b21e3257751e5)(action.payload));
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        replaceCartesianGraphicalItem: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                var index = (0, $75bf48a0e2bf731d$export$97aac956da55dae9)(state).cartesianItems.indexOf((0, $46230e101f7bd5ae$export$c05b21e3257751e5)(prev));
                if (index > -1) state.cartesianItems[index] = (0, $46230e101f7bd5ae$export$c05b21e3257751e5)(next);
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        removeCartesianGraphicalItem: {
            reducer (state, action) {
                var index = (0, $75bf48a0e2bf731d$export$97aac956da55dae9)(state).cartesianItems.indexOf((0, $46230e101f7bd5ae$export$c05b21e3257751e5)(action.payload));
                if (index > -1) state.cartesianItems.splice(index, 1);
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        addPolarGraphicalItem: {
            reducer (state, action) {
                state.polarItems.push((0, $46230e101f7bd5ae$export$c05b21e3257751e5)(action.payload));
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        },
        removePolarGraphicalItem: {
            reducer (state, action) {
                var index = (0, $75bf48a0e2bf731d$export$97aac956da55dae9)(state).polarItems.indexOf((0, $46230e101f7bd5ae$export$c05b21e3257751e5)(action.payload));
                if (index > -1) state.polarItems.splice(index, 1);
            },
            prepare: (0, $ec80cf871915f813$export$39fcd5145ec5e4e2)()
        }
    }
});
var { addCartesianGraphicalItem: $9f25864d38d26021$export$3f947cc833f5129c, replaceCartesianGraphicalItem: $9f25864d38d26021$export$5e4d82f2e2775795, removeCartesianGraphicalItem: $9f25864d38d26021$export$cc47a48755a91e1a, addPolarGraphicalItem: $9f25864d38d26021$export$468d47d44d0e088f, removePolarGraphicalItem: $9f25864d38d26021$export$77442a5b47e92750 } = $9f25864d38d26021$var$graphicalItemsSlice.actions;
var $9f25864d38d26021$export$183eecd5cb7dbb38 = $9f25864d38d26021$var$graphicalItemsSlice.reducer;


var $cc018e6668d1f6a1$var$SetCartesianGraphicalItemImpl = (props)=>{
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    var prevPropsRef = (0, $28UcW.useRef)(null);
    (0, $28UcW.useLayoutEffect)(()=>{
        if (prevPropsRef.current === null) dispatch((0, $9f25864d38d26021$export$3f947cc833f5129c)(props));
        else if (prevPropsRef.current !== props) dispatch((0, $9f25864d38d26021$export$5e4d82f2e2775795)({
            prev: prevPropsRef.current,
            next: props
        }));
        prevPropsRef.current = props;
    }, [
        dispatch,
        props
    ]);
    (0, $28UcW.useLayoutEffect)(()=>{
        return ()=>{
            if (prevPropsRef.current) {
                dispatch((0, $9f25864d38d26021$export$cc47a48755a91e1a)(prevPropsRef.current));
                /*
         * Here we have to reset the ref to null because in StrictMode, the effect will run twice,
         * but it will keep the same ref value from the first render.
         *
         * In browser, React will clear the ref after the first effect cleanup,
         * so that wouldn't be an issue.
         *
         * In StrictMode, however, the ref is kept,
         * and in the hook above the code checks for `prevPropsRef.current === null`
         * which would be false so it would not dispatch the `addCartesianGraphicalItem` action again.
         *
         * https://github.com/recharts/recharts/issues/6022
         */ prevPropsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
};
var $cc018e6668d1f6a1$export$b600bf9c1966a9c2 = /*#__PURE__*/ (0, $28UcW.memo)($cc018e6668d1f6a1$var$SetCartesianGraphicalItemImpl);
function $cc018e6668d1f6a1$export$8d7124402ca6b71c(props) {
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    (0, $28UcW.useLayoutEffect)(()=>{
        dispatch((0, $9f25864d38d26021$export$468d47d44d0e088f)(props));
        return ()=>{
            dispatch((0, $9f25864d38d26021$export$77442a5b47e92750)(props));
        };
    }, [
        dispatch,
        props
    ]);
    return null;
}




var $28UcW = parcelRequire("28UcW");


function $75b4928fd5f9633d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $75b4928fd5f9633d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $75b4928fd5f9633d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $75b4928fd5f9633d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $75b4928fd5f9633d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $75b4928fd5f9633d$var$_defineProperty(e, r, t) {
    return (r = $75b4928fd5f9633d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $75b4928fd5f9633d$var$_toPropertyKey(t) {
    var i = $75b4928fd5f9633d$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $75b4928fd5f9633d$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $75b4928fd5f9633d$export$51610fddbf64bc9d = (name)=>name.replace(/([A-Z])/g, (v)=>"-".concat(v.toLowerCase()));
var $75b4928fd5f9633d$export$1594c78389ee3429 = (props, duration, easing)=>props.map((prop)=>"".concat($75b4928fd5f9633d$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing)).join(',');
var $75b4928fd5f9633d$export$59e29973723da0b3 = (preObj, nextObj)=>[
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce((a, b)=>a.filter((c)=>b.includes(c)));
var $75b4928fd5f9633d$export$d6051a0f7a227332 = (fn, obj)=>Object.keys(obj).reduce((res, key)=>$75b4928fd5f9633d$var$_objectSpread($75b4928fd5f9633d$var$_objectSpread({}, res), {}, {
            [key]: fn(key, obj[key])
        }), {});


function $7564ccb65042ad09$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7564ccb65042ad09$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7564ccb65042ad09$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7564ccb65042ad09$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7564ccb65042ad09$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7564ccb65042ad09$var$_defineProperty(e, r, t) {
    return (r = $7564ccb65042ad09$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7564ccb65042ad09$var$_toPropertyKey(t) {
    var i = $7564ccb65042ad09$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7564ccb65042ad09$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $7564ccb65042ad09$export$58f0f39f63f3cf42 = (begin, end, k)=>begin + (end - begin) * k;
var $7564ccb65042ad09$var$needContinue = (_ref)=>{
    var { from: from, to: to } = _ref;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $7564ccb65042ad09$var$calStepperVals = (easing, preVals, steps)=>{
    var nextStepVals = (0, $75b4928fd5f9633d$export$d6051a0f7a227332)((key, val)=>{
        if ($7564ccb65042ad09$var$needContinue(val)) {
            var [newX, newV] = easing(val.from, val.to, val.velocity);
            return $7564ccb65042ad09$var$_objectSpread($7564ccb65042ad09$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $75b4928fd5f9633d$export$d6051a0f7a227332)((key, val)=>{
        if ($7564ccb65042ad09$var$needContinue(val) && nextStepVals[key] != null) return $7564ccb65042ad09$var$_objectSpread($7564ccb65042ad09$var$_objectSpread({}, val), {}, {
            velocity: $7564ccb65042ad09$export$58f0f39f63f3cf42(val.velocity, nextStepVals[key].velocity, steps),
            from: $7564ccb65042ad09$export$58f0f39f63f3cf42(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return $7564ccb65042ad09$var$calStepperVals(easing, nextStepVals, steps - 1);
};
function $7564ccb65042ad09$var$createStepperUpdate(from, to, easing, interKeys, render, timeoutController) {
    var preTime;
    var stepperStyle = interKeys.reduce((res, key)=>$7564ccb65042ad09$var$_objectSpread($7564ccb65042ad09$var$_objectSpread({}, res), {}, {
            [key]: {
                from: from[key],
                velocity: 0,
                to: to[key]
            }
        }), {});
    var getCurrStyle = ()=>(0, $75b4928fd5f9633d$export$d6051a0f7a227332)((key, val)=>val.from, stepperStyle);
    var shouldStopAnimation = ()=>!Object.values(stepperStyle).filter($7564ccb65042ad09$var$needContinue).length;
    var stopAnimation = null;
    var stepperUpdate = (now)=>{
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $7564ccb65042ad09$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($7564ccb65042ad09$var$_objectSpread($7564ccb65042ad09$var$_objectSpread($7564ccb65042ad09$var$_objectSpread({}, from), to), getCurrStyle()));
        preTime = now;
        if (!shouldStopAnimation()) stopAnimation = timeoutController.setTimeout(stepperUpdate);
    };
    // return start animation method
    return ()=>{
        stopAnimation = timeoutController.setTimeout(stepperUpdate);
        // return stop animation method
        return ()=>{
            var _stopAnimation;
            (_stopAnimation = stopAnimation) === null || _stopAnimation === void 0 || _stopAnimation();
        };
    };
}
function $7564ccb65042ad09$var$createTimingUpdate(from, to, easing, duration, interKeys, render, timeoutController) {
    var stopAnimation = null;
    var timingStyle = interKeys.reduce((res, key)=>{
        var fromElement = from[key];
        var toElement = to[key];
        if (fromElement == null || toElement == null) return res;
        return $7564ccb65042ad09$var$_objectSpread($7564ccb65042ad09$var$_objectSpread({}, res), {}, {
            [key]: [
                fromElement,
                toElement
            ]
        });
    }, {});
    var beginTime;
    var timingUpdate = (now)=>{
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $75b4928fd5f9633d$export$d6051a0f7a227332)((key, val)=>$7564ccb65042ad09$export$58f0f39f63f3cf42(...val, easing(t)), timingStyle);
        // get union set and add compatible prefix
        render($7564ccb65042ad09$var$_objectSpread($7564ccb65042ad09$var$_objectSpread($7564ccb65042ad09$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) stopAnimation = timeoutController.setTimeout(timingUpdate);
        else {
            var finalStyle = (0, $75b4928fd5f9633d$export$d6051a0f7a227332)((key, val)=>$7564ccb65042ad09$export$58f0f39f63f3cf42(...val, easing(1)), timingStyle);
            render($7564ccb65042ad09$var$_objectSpread($7564ccb65042ad09$var$_objectSpread($7564ccb65042ad09$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    // return start animation method
    return ()=>{
        stopAnimation = timeoutController.setTimeout(timingUpdate);
        // return stop animation method
        return ()=>{
            var _stopAnimation2;
            (_stopAnimation2 = stopAnimation) === null || _stopAnimation2 === void 0 || _stopAnimation2();
        };
    };
}
var // configure update function
// eslint-disable-next-line import/no-default-export
$7564ccb65042ad09$export$2e2bcd8739ae039 = (from, to, easing, duration, render, timeoutController)=>{
    var interKeys = (0, $75b4928fd5f9633d$export$59e29973723da0b3)(from, to);
    if (easing == null) // no animation, just set to final state
    return ()=>{
        render($7564ccb65042ad09$var$_objectSpread($7564ccb65042ad09$var$_objectSpread({}, from), to));
        return ()=>{};
    };
    return easing.isStepper === true ? $7564ccb65042ad09$var$createStepperUpdate(from, to, easing, interKeys, render, timeoutController) : $7564ccb65042ad09$var$createTimingUpdate(from, to, easing, duration, interKeys, render, timeoutController);
};


var $f90550a0c0fc23e7$export$73dea3ad38069b0e = 1e-4;
var $f90550a0c0fc23e7$var$cubicBezierFactor = (c1, c2)=>[
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
var $f90550a0c0fc23e7$var$evaluatePolynomial = (params, t)=>params.map((param, i)=>param * t ** i).reduce((pre, curr)=>pre + curr);
var $f90550a0c0fc23e7$var$cubicBezier = (c1, c2)=>(t)=>{
        var params = $f90550a0c0fc23e7$var$cubicBezierFactor(c1, c2);
        return $f90550a0c0fc23e7$var$evaluatePolynomial(params, t);
    };
var $f90550a0c0fc23e7$var$derivativeCubicBezier = (c1, c2)=>(t)=>{
        var params = $f90550a0c0fc23e7$var$cubicBezierFactor(c1, c2);
        var newParams = [
            ...params.map((param, i)=>param * i).slice(1),
            0
        ];
        return $f90550a0c0fc23e7$var$evaluatePolynomial(newParams, t);
    };
var $f90550a0c0fc23e7$var$parseCubicBezier = (easing)=>{
    var _easingParts$;
    var easingParts = easing.split('(');
    if (easingParts.length !== 2 || easingParts[0] !== 'cubic-bezier') return null;
    var numbers = (_easingParts$ = easingParts[1]) === null || _easingParts$ === void 0 || (_easingParts$ = _easingParts$.split(')')[0]) === null || _easingParts$ === void 0 ? void 0 : _easingParts$.split(',');
    if (numbers == null || numbers.length !== 4) return null;
    var coords = numbers.map((x)=>parseFloat(x));
    return [
        coords[0],
        coords[1],
        coords[2],
        coords[3]
    ];
};
var $f90550a0c0fc23e7$var$getBezierCoordinates = function getBezierCoordinates() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            return [
                0.0,
                0.0,
                1.0,
                1.0
            ];
        case 'ease':
            return [
                0.25,
                0.1,
                0.25,
                1.0
            ];
        case 'ease-in':
            return [
                0.42,
                0.0,
                1.0,
                1.0
            ];
        case 'ease-out':
            return [
                0.42,
                0.0,
                0.58,
                1.0
            ];
        case 'ease-in-out':
            return [
                0.0,
                0.0,
                0.58,
                1.0
            ];
        default:
            var easing = $f90550a0c0fc23e7$var$parseCubicBezier(args[0]);
            if (easing) return easing;
    }
    if (args.length === 4) return args;
    // Fallback for invalid inputs. The previous implementation was buggy and would lead to NaN.
    // Returning linear easing is a safe default.
    return [
        0.0,
        0.0,
        1.0,
        1.0
    ];
};
var $f90550a0c0fc23e7$var$createBezierEasing = (x1, y1, x2, y2)=>{
    var curveX = $f90550a0c0fc23e7$var$cubicBezier(x1, x2);
    var curveY = $f90550a0c0fc23e7$var$cubicBezier(y1, y2);
    var derCurveX = $f90550a0c0fc23e7$var$derivativeCubicBezier(x1, x2);
    var rangeValue = (value)=>{
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = (_t)=>{
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $f90550a0c0fc23e7$export$73dea3ad38069b0e || derVal < $f90550a0c0fc23e7$export$73dea3ad38069b0e) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $f90550a0c0fc23e7$export$56c51296f72f0592 = function configBezier() {
    return $f90550a0c0fc23e7$var$createBezierEasing(...$f90550a0c0fc23e7$var$getBezierCoordinates(...arguments));
};
var $f90550a0c0fc23e7$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var { stiff: stiff = 100, damping: damping = 8, dt: dt = 17 } = config;
    var stepper = (currX, destX, currV)=>{
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $f90550a0c0fc23e7$export$73dea3ad38069b0e && Math.abs(newV) < $f90550a0c0fc23e7$export$73dea3ad38069b0e) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $f90550a0c0fc23e7$export$e3e04925801e5434 = (easing)=>{
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return $f90550a0c0fc23e7$export$56c51296f72f0592(easing);
        case 'spring':
            return $f90550a0c0fc23e7$export$12fc25daf62b865a();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return $f90550a0c0fc23e7$export$56c51296f72f0592(easing);
    }
    if (typeof easing === 'function') return easing;
    return null;
};



var $28UcW = parcelRequire("28UcW");
/**
 * Represents a single item in the ReactSmoothQueue.
 * The item can be:
 * - A number representing a delay in milliseconds.
 * - An object representing a style change
 * - A StartAnimationFunction that starts eased transition and calls different render
 *      because of course in Recharts we have to have three ways to do everything
 * - An arbitrary function to be executed
 */ function $b7d536ac64561f5b$export$26646f0bb02941d1(timeoutController) {
    var currStyle;
    var handleChange = ()=>null;
    var shouldStop = false;
    var cancelTimeout = null;
    var setStyle = (_style)=>{
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var [curr, ...restStyles] = styles;
            if (typeof curr === 'number') {
                cancelTimeout = timeoutController.setTimeout(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            cancelTimeout = timeoutController.setTimeout(setStyle.bind(null, restStyles));
            return;
        }
        if (typeof _style === 'string') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'object') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'function') _style();
    };
    return {
        stop: ()=>{
            shouldStop = true;
        },
        start: (style)=>{
            shouldStop = false;
            if (cancelTimeout) {
                cancelTimeout();
                cancelTimeout = null;
            }
            setStyle(style);
        },
        subscribe: (_handleChange)=>{
            handleChange = _handleChange;
            return ()=>{
                handleChange = ()=>null;
            };
        },
        getTimeoutController: ()=>timeoutController
    };
}


/**
 * Callback type for the timeout function.
 * Receives current time in milliseconds as an argument.
 */ /**
 * A function that, when called, cancels the timeout.
 */ class $6b018c3a09723d81$export$fa255b8f41b568c2 {
    setTimeout(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var startTime = performance.now();
        var requestId = null;
        var executeCallback = (now)=>{
            if (now - startTime >= delay) callback(now);
            else if (typeof requestAnimationFrame === 'function') requestId = requestAnimationFrame(executeCallback);
        };
        requestId = requestAnimationFrame(executeCallback);
        return ()=>{
            if (requestId != null) cancelAnimationFrame(requestId);
        };
    }
}


function $4454ad1879109c80$export$a649b7dd21ebb400() {
    return (0, $b7d536ac64561f5b$export$26646f0bb02941d1)(new (0, $6b018c3a09723d81$export$fa255b8f41b568c2)());
}


var $8533d9a550c55152$export$ec4cae1386f040b6 = /*#__PURE__*/ (0, $28UcW.createContext)((0, $4454ad1879109c80$export$a649b7dd21ebb400));
function $8533d9a550c55152$export$996cb06187bf3507(animationId, animationManagerFromProps) {
    var contextAnimationManager = (0, $28UcW.useContext)($8533d9a550c55152$export$ec4cae1386f040b6);
    return (0, $28UcW.useMemo)(()=>animationManagerFromProps !== null && animationManagerFromProps !== void 0 ? animationManagerFromProps : contextAnimationManager(animationId), [
        animationId,
        animationManagerFromProps,
        contextAnimationManager
    ]);
}



var $2cfa712dd658b01e$var$defaultJavascriptAnimateProps = {
    begin: 0,
    duration: 1000,
    easing: 'ease',
    isActive: true,
    canBegin: true,
    onAnimationEnd: ()=>{},
    onAnimationStart: ()=>{}
};
var $2cfa712dd658b01e$var$from = {
    t: 0
};
var $2cfa712dd658b01e$var$to = {
    t: 1
};
function $2cfa712dd658b01e$export$5d41821894c47c52(outsideProps) {
    var props = (0, $2db4b31e06a7a91b$export$45004cc70a390ee8)(outsideProps, $2cfa712dd658b01e$var$defaultJavascriptAnimateProps);
    var { isActive: isActiveProp, canBegin: canBegin, duration: duration, easing: easing, begin: begin, onAnimationEnd: onAnimationEnd, onAnimationStart: onAnimationStart, children: children } = props;
    var isActive = isActiveProp === 'auto' ? !(0, $c8dcb2cb9e97048b$export$98f03c5d19621d70).isSsr : isActiveProp;
    var animationManager = (0, $8533d9a550c55152$export$996cb06187bf3507)(props.animationId, props.animationManager);
    var [style, setStyle] = (0, $28UcW.useState)(isActive ? $2cfa712dd658b01e$var$from : $2cfa712dd658b01e$var$to);
    var stopJSAnimation = (0, $28UcW.useRef)(null);
    (0, $28UcW.useEffect)(()=>{
        if (!isActive) setStyle($2cfa712dd658b01e$var$to);
    }, [
        isActive
    ]);
    (0, $28UcW.useEffect)(()=>{
        if (!isActive || !canBegin) return 0, $9a1343d05dde836c$export$8793edee2d425525;
        var startAnimation = (0, $7564ccb65042ad09$export$2e2bcd8739ae039)($2cfa712dd658b01e$var$from, $2cfa712dd658b01e$var$to, (0, $f90550a0c0fc23e7$export$e3e04925801e5434)(easing), duration, setStyle, animationManager.getTimeoutController());
        var onAnimationActive = ()=>{
            stopJSAnimation.current = startAnimation();
        };
        animationManager.start([
            onAnimationStart,
            begin,
            onAnimationActive,
            duration,
            onAnimationEnd
        ]);
        return ()=>{
            animationManager.stop();
            if (stopJSAnimation.current) stopJSAnimation.current();
            onAnimationEnd();
        };
    }, [
        isActive,
        canBegin,
        duration,
        easing,
        begin,
        onAnimationStart,
        onAnimationEnd,
        animationManager
    ]);
    return children(style.t);
}




function $1428e64421e343f5$export$af45be059e20a9dd(dot) {
    var props = (0, $3d820e26962aea02$export$6d5921c09aa671a9)(dot);
    var defaultR = 3;
    var defaultStrokeWidth = 2;
    if (props != null) {
        var { r: r, strokeWidth: strokeWidth } = props;
        var realR = Number(r);
        var realStrokeWidth = Number(strokeWidth);
        if (Number.isNaN(realR) || realR < 0) realR = defaultR;
        if (Number.isNaN(realStrokeWidth) || realStrokeWidth < 0) realStrokeWidth = defaultStrokeWidth;
        return {
            r: realR,
            strokeWidth: realStrokeWidth
        };
    }
    return {
        r: defaultR,
        strokeWidth: defaultStrokeWidth
    };
}



var $28UcW = parcelRequire("28UcW");
var $2c9d695f30ac56aa$exports = {};

$2c9d695f30ac56aa$exports = (parcelRequire("8gzRo")).isPlainObject;



var $28UcW = parcelRequire("28UcW");

var $dP0oo = parcelRequire("dP0oo");







var $0237cf75d6781a88$var$_excluded = [
    "radius"
], $0237cf75d6781a88$var$_excluded2 = [
    "radius"
];
var $0237cf75d6781a88$var$_templateObject, $0237cf75d6781a88$var$_templateObject2, $0237cf75d6781a88$var$_templateObject3, $0237cf75d6781a88$var$_templateObject4, $0237cf75d6781a88$var$_templateObject5, $0237cf75d6781a88$var$_templateObject6, $0237cf75d6781a88$var$_templateObject7, $0237cf75d6781a88$var$_templateObject8, $0237cf75d6781a88$var$_templateObject9, $0237cf75d6781a88$var$_templateObject0;
function $0237cf75d6781a88$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0237cf75d6781a88$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0237cf75d6781a88$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0237cf75d6781a88$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0237cf75d6781a88$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0237cf75d6781a88$var$_defineProperty(e, r, t) {
    return (r = $0237cf75d6781a88$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0237cf75d6781a88$var$_toPropertyKey(t) {
    var i = $0237cf75d6781a88$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0237cf75d6781a88$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0237cf75d6781a88$var$_extends() {
    return $0237cf75d6781a88$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0237cf75d6781a88$var$_extends.apply(null, arguments);
}
function $0237cf75d6781a88$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $0237cf75d6781a88$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $0237cf75d6781a88$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $0237cf75d6781a88$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
/**
 * @inline
 */ var $0237cf75d6781a88$var$getRectanglePath = (x, y, width, height, radius)=>{
    var roundedWidth = (0, $c127eb7db38963c7$export$2077e0241d6afd3c)(width);
    var roundedHeight = (0, $c127eb7db38963c7$export$2077e0241d6afd3c)(height);
    var maxRadius = Math.min(Math.abs(roundedWidth) / 2, Math.abs(roundedHeight) / 2);
    var ySign = roundedHeight >= 0 ? 1 : -1;
    var xSign = roundedWidth >= 0 ? 1 : -1;
    var clockWise = roundedHeight >= 0 && roundedWidth >= 0 || roundedHeight < 0 && roundedWidth < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($0237cf75d6781a88$var$_templateObject || ($0237cf75d6781a88$var$_templateObject = $0237cf75d6781a88$var$_taggedTemplateLiteral([
            "M",
            ",",
            ""
        ])), x, y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($0237cf75d6781a88$var$_templateObject2 || ($0237cf75d6781a88$var$_templateObject2 = $0237cf75d6781a88$var$_taggedTemplateLiteral([
            "A ",
            ",",
            ",0,0,",
            ",",
            ",",
            ""
        ])), newRadius[0], newRadius[0], clockWise, x + xSign * newRadius[0], y);
        path += (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($0237cf75d6781a88$var$_templateObject3 || ($0237cf75d6781a88$var$_templateObject3 = $0237cf75d6781a88$var$_taggedTemplateLiteral([
            "L ",
            ",",
            ""
        ])), x + width - xSign * newRadius[1], y);
        if (newRadius[1] > 0) path += (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($0237cf75d6781a88$var$_templateObject4 || ($0237cf75d6781a88$var$_templateObject4 = $0237cf75d6781a88$var$_taggedTemplateLiteral([
            "A ",
            ",",
            ",0,0,",
            ",\n        ",
            ",",
            ""
        ])), newRadius[1], newRadius[1], clockWise, x + width, y + ySign * newRadius[1]);
        path += (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($0237cf75d6781a88$var$_templateObject5 || ($0237cf75d6781a88$var$_templateObject5 = $0237cf75d6781a88$var$_taggedTemplateLiteral([
            "L ",
            ",",
            ""
        ])), x + width, y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($0237cf75d6781a88$var$_templateObject6 || ($0237cf75d6781a88$var$_templateObject6 = $0237cf75d6781a88$var$_taggedTemplateLiteral([
            "A ",
            ",",
            ",0,0,",
            ",\n        ",
            ",",
            ""
        ])), newRadius[2], newRadius[2], clockWise, x + width - xSign * newRadius[2], y + height);
        path += (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($0237cf75d6781a88$var$_templateObject7 || ($0237cf75d6781a88$var$_templateObject7 = $0237cf75d6781a88$var$_taggedTemplateLiteral([
            "L ",
            ",",
            ""
        ])), x + xSign * newRadius[3], y + height);
        if (newRadius[3] > 0) path += (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($0237cf75d6781a88$var$_templateObject8 || ($0237cf75d6781a88$var$_templateObject8 = $0237cf75d6781a88$var$_taggedTemplateLiteral([
            "A ",
            ",",
            ",0,0,",
            ",\n        ",
            ",",
            ""
        ])), newRadius[3], newRadius[3], clockWise, x, y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($0237cf75d6781a88$var$_templateObject9 || ($0237cf75d6781a88$var$_templateObject9 = $0237cf75d6781a88$var$_taggedTemplateLiteral([
            "M ",
            ",",
            "\n            A ",
            ",",
            ",0,0,",
            ",",
            ",",
            "\n            L ",
            ",",
            "\n            A ",
            ",",
            ",0,0,",
            ",",
            ",",
            "\n            L ",
            ",",
            "\n            A ",
            ",",
            ",0,0,",
            ",",
            ",",
            "\n            L ",
            ",",
            "\n            A ",
            ",",
            ",0,0,",
            ",",
            ",",
            " Z"
        ])), x, y + ySign * _newRadius, _newRadius, _newRadius, clockWise, x + xSign * _newRadius, y, x + width - xSign * _newRadius, y, _newRadius, _newRadius, clockWise, x + width, y + ySign * _newRadius, x + width, y + height - ySign * _newRadius, _newRadius, _newRadius, clockWise, x + width - xSign * _newRadius, y + height, x + xSign * _newRadius, y + height, _newRadius, _newRadius, clockWise, x, y + height - ySign * _newRadius);
    } else path = (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($0237cf75d6781a88$var$_templateObject0 || ($0237cf75d6781a88$var$_templateObject0 = $0237cf75d6781a88$var$_taggedTemplateLiteral([
        "M ",
        ",",
        " h ",
        " v ",
        " h ",
        " Z"
    ])), x, y, width, height, -width);
    return path;
};
var $0237cf75d6781a88$export$90e429de6eb3e62f = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $0237cf75d6781a88$export$4617fb02663045ef = (rectangleProps)=>{
    var props = (0, $2db4b31e06a7a91b$export$45004cc70a390ee8)(rectangleProps, $0237cf75d6781a88$export$90e429de6eb3e62f);
    var pathRef = (0, $28UcW.useRef)(null);
    var [totalLength, setTotalLength] = (0, $28UcW.useState)(-1);
    (0, $28UcW.useEffect)(()=>{
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (_unused) {
        // calculate total length error
        }
    }, []);
    var { x: x, y: y, width: width, height: height, radius: radius, className: className } = props;
    var { animationEasing: animationEasing, animationDuration: animationDuration, animationBegin: animationBegin, isAnimationActive: isAnimationActive, isUpdateAnimationActive: isUpdateAnimationActive } = props;
    var prevWidthRef = (0, $28UcW.useRef)(width);
    var prevHeightRef = (0, $28UcW.useRef)(height);
    var prevXRef = (0, $28UcW.useRef)(x);
    var prevYRef = (0, $28UcW.useRef)(y);
    var animationIdInput = (0, $28UcW.useMemo)(()=>({
            x: x,
            y: y,
            width: width,
            height: height,
            radius: radius
        }), [
        x,
        y,
        width,
        height,
        radius
    ]);
    var animationId = (0, $49cf52428a039363$export$e1042b2944b80b7f)(animationIdInput, 'rectangle-');
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, $dP0oo.clsx)('recharts-rectangle', className);
    if (!isUpdateAnimationActive) {
        var _svgPropertiesAndEven = (0, $1412060bc6e2b8b4$export$67f8fc03e57e2747)(props), { radius: _ } = _svgPropertiesAndEven, otherPathProps = $0237cf75d6781a88$var$_objectWithoutProperties(_svgPropertiesAndEven, $0237cf75d6781a88$var$_excluded);
        return /*#__PURE__*/ $28UcW.createElement("path", $0237cf75d6781a88$var$_extends({}, otherPathProps, {
            x: (0, $c127eb7db38963c7$export$2077e0241d6afd3c)(x),
            y: (0, $c127eb7db38963c7$export$2077e0241d6afd3c)(y),
            width: (0, $c127eb7db38963c7$export$2077e0241d6afd3c)(width),
            height: (0, $c127eb7db38963c7$export$2077e0241d6afd3c)(height),
            radius: typeof radius === 'number' ? radius : undefined,
            className: layerClass,
            d: $0237cf75d6781a88$var$getRectanglePath(x, y, width, height, radius)
        }));
    }
    var prevWidth = prevWidthRef.current;
    var prevHeight = prevHeightRef.current;
    var prevX = prevXRef.current;
    var prevY = prevYRef.current;
    var from = "0px ".concat(totalLength === -1 ? 1 : totalLength, "px");
    var to = "".concat(totalLength, "px 0px");
    var transition = (0, $75b4928fd5f9633d$export$1594c78389ee3429)([
        'strokeDasharray'
    ], animationDuration, typeof animationEasing === 'string' ? animationEasing : $0237cf75d6781a88$export$90e429de6eb3e62f.animationEasing);
    return /*#__PURE__*/ $28UcW.createElement((0, $2cfa712dd658b01e$export$5d41821894c47c52), {
        animationId: animationId,
        key: animationId,
        canBegin: totalLength > 0,
        duration: animationDuration,
        easing: animationEasing,
        isActive: isUpdateAnimationActive,
        begin: animationBegin
    }, (t)=>{
        var currWidth = (0, $9a1343d05dde836c$export$89e29e4ab65e70a9)(prevWidth, width, t);
        var currHeight = (0, $9a1343d05dde836c$export$89e29e4ab65e70a9)(prevHeight, height, t);
        var currX = (0, $9a1343d05dde836c$export$89e29e4ab65e70a9)(prevX, x, t);
        var currY = (0, $9a1343d05dde836c$export$89e29e4ab65e70a9)(prevY, y, t);
        if (pathRef.current) {
            prevWidthRef.current = currWidth;
            prevHeightRef.current = currHeight;
            prevXRef.current = currX;
            prevYRef.current = currY;
        }
        var animationStyle;
        if (!isAnimationActive) animationStyle = {
            strokeDasharray: to
        };
        else if (t > 0) animationStyle = {
            transition: transition,
            strokeDasharray: to
        };
        else animationStyle = {
            strokeDasharray: from
        };
        var _svgPropertiesAndEven2 = (0, $1412060bc6e2b8b4$export$67f8fc03e57e2747)(props), { radius: _ } = _svgPropertiesAndEven2, otherPathProps = $0237cf75d6781a88$var$_objectWithoutProperties(_svgPropertiesAndEven2, $0237cf75d6781a88$var$_excluded2);
        return /*#__PURE__*/ $28UcW.createElement("path", $0237cf75d6781a88$var$_extends({}, otherPathProps, {
            radius: typeof radius === 'number' ? radius : undefined,
            className: layerClass,
            d: $0237cf75d6781a88$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef,
            style: $0237cf75d6781a88$var$_objectSpread($0237cf75d6781a88$var$_objectSpread({}, animationStyle), props.style)
        }));
    });
};



var $28UcW = parcelRequire("28UcW");

var $dP0oo = parcelRequire("dP0oo");







var $cb11189e3b1417f3$var$_templateObject, $cb11189e3b1417f3$var$_templateObject2, $cb11189e3b1417f3$var$_templateObject3, $cb11189e3b1417f3$var$_templateObject4, $cb11189e3b1417f3$var$_templateObject5;
function $cb11189e3b1417f3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cb11189e3b1417f3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cb11189e3b1417f3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cb11189e3b1417f3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cb11189e3b1417f3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cb11189e3b1417f3$var$_defineProperty(e, r, t) {
    return (r = $cb11189e3b1417f3$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $cb11189e3b1417f3$var$_toPropertyKey(t) {
    var i = $cb11189e3b1417f3$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $cb11189e3b1417f3$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cb11189e3b1417f3$var$_extends() {
    return $cb11189e3b1417f3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cb11189e3b1417f3$var$_extends.apply(null, arguments);
}
function $cb11189e3b1417f3$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $cb11189e3b1417f3$var$getTrapezoidPath = (x, y, upperWidth, lowerWidth, height)=>{
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($cb11189e3b1417f3$var$_templateObject || ($cb11189e3b1417f3$var$_templateObject = $cb11189e3b1417f3$var$_taggedTemplateLiteral([
        "M ",
        ",",
        ""
    ])), x, y);
    path += (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($cb11189e3b1417f3$var$_templateObject2 || ($cb11189e3b1417f3$var$_templateObject2 = $cb11189e3b1417f3$var$_taggedTemplateLiteral([
        "L ",
        ",",
        ""
    ])), x + upperWidth, y);
    path += (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($cb11189e3b1417f3$var$_templateObject3 || ($cb11189e3b1417f3$var$_templateObject3 = $cb11189e3b1417f3$var$_taggedTemplateLiteral([
        "L ",
        ",",
        ""
    ])), x + upperWidth - widthGap / 2, y + height);
    path += (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($cb11189e3b1417f3$var$_templateObject4 || ($cb11189e3b1417f3$var$_templateObject4 = $cb11189e3b1417f3$var$_taggedTemplateLiteral([
        "L ",
        ",",
        ""
    ])), x + upperWidth - widthGap / 2 - lowerWidth, y + height);
    path += (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($cb11189e3b1417f3$var$_templateObject5 || ($cb11189e3b1417f3$var$_templateObject5 = $cb11189e3b1417f3$var$_taggedTemplateLiteral([
        "L ",
        ",",
        " Z"
    ])), x, y);
    return path;
};
var $cb11189e3b1417f3$export$d414f170eb9e3706 = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $cb11189e3b1417f3$export$d1ed33dc592f5337 = (outsideProps)=>{
    var trapezoidProps = (0, $2db4b31e06a7a91b$export$45004cc70a390ee8)(outsideProps, $cb11189e3b1417f3$export$d414f170eb9e3706);
    var { x: x, y: y, upperWidth: upperWidth, lowerWidth: lowerWidth, height: height, className: className } = trapezoidProps;
    var { animationEasing: animationEasing, animationDuration: animationDuration, animationBegin: animationBegin, isUpdateAnimationActive: isUpdateAnimationActive } = trapezoidProps;
    var pathRef = (0, $28UcW.useRef)(null);
    var [totalLength, setTotalLength] = (0, $28UcW.useState)(-1);
    var prevUpperWidthRef = (0, $28UcW.useRef)(upperWidth);
    var prevLowerWidthRef = (0, $28UcW.useRef)(lowerWidth);
    var prevHeightRef = (0, $28UcW.useRef)(height);
    var prevXRef = (0, $28UcW.useRef)(x);
    var prevYRef = (0, $28UcW.useRef)(y);
    var animationId = (0, $49cf52428a039363$export$e1042b2944b80b7f)(outsideProps, 'trapezoid-');
    (0, $28UcW.useEffect)(()=>{
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (_unused) {
        // calculate total length error
        }
    }, []);
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, $dP0oo.clsx)('recharts-trapezoid', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ $28UcW.createElement("g", null, /*#__PURE__*/ $28UcW.createElement("path", $cb11189e3b1417f3$var$_extends({}, (0, $1412060bc6e2b8b4$export$67f8fc03e57e2747)(trapezoidProps), {
        className: layerClass,
        d: $cb11189e3b1417f3$var$getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    var prevUpperWidth = prevUpperWidthRef.current;
    var prevLowerWidth = prevLowerWidthRef.current;
    var prevHeight = prevHeightRef.current;
    var prevX = prevXRef.current;
    var prevY = prevYRef.current;
    var from = "0px ".concat(totalLength === -1 ? 1 : totalLength, "px");
    var to = "".concat(totalLength, "px 0px");
    var transition = (0, $75b4928fd5f9633d$export$1594c78389ee3429)([
        'strokeDasharray'
    ], animationDuration, animationEasing);
    return /*#__PURE__*/ $28UcW.createElement((0, $2cfa712dd658b01e$export$5d41821894c47c52), {
        animationId: animationId,
        key: animationId,
        canBegin: totalLength > 0,
        duration: animationDuration,
        easing: animationEasing,
        isActive: isUpdateAnimationActive,
        begin: animationBegin
    }, (t)=>{
        var currUpperWidth = (0, $9a1343d05dde836c$export$89e29e4ab65e70a9)(prevUpperWidth, upperWidth, t);
        var currLowerWidth = (0, $9a1343d05dde836c$export$89e29e4ab65e70a9)(prevLowerWidth, lowerWidth, t);
        var currHeight = (0, $9a1343d05dde836c$export$89e29e4ab65e70a9)(prevHeight, height, t);
        var currX = (0, $9a1343d05dde836c$export$89e29e4ab65e70a9)(prevX, x, t);
        var currY = (0, $9a1343d05dde836c$export$89e29e4ab65e70a9)(prevY, y, t);
        if (pathRef.current) {
            prevUpperWidthRef.current = currUpperWidth;
            prevLowerWidthRef.current = currLowerWidth;
            prevHeightRef.current = currHeight;
            prevXRef.current = currX;
            prevYRef.current = currY;
        }
        var animationStyle = t > 0 ? {
            transition: transition,
            strokeDasharray: to
        } : {
            strokeDasharray: from
        };
        return /*#__PURE__*/ $28UcW.createElement("path", $cb11189e3b1417f3$var$_extends({}, (0, $1412060bc6e2b8b4$export$67f8fc03e57e2747)(trapezoidProps), {
            className: layerClass,
            d: $cb11189e3b1417f3$var$getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef,
            style: $cb11189e3b1417f3$var$_objectSpread($cb11189e3b1417f3$var$_objectSpread({}, animationStyle), trapezoidProps.style)
        }));
    });
};



var $28UcW = parcelRequire("28UcW");

var $dP0oo = parcelRequire("dP0oo");





var $95f0b2df306fffbd$var$_templateObject, $95f0b2df306fffbd$var$_templateObject2, $95f0b2df306fffbd$var$_templateObject3, $95f0b2df306fffbd$var$_templateObject4, $95f0b2df306fffbd$var$_templateObject5, $95f0b2df306fffbd$var$_templateObject6, $95f0b2df306fffbd$var$_templateObject7;
function $95f0b2df306fffbd$var$_extends() {
    return $95f0b2df306fffbd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $95f0b2df306fffbd$var$_extends.apply(null, arguments);
}
function $95f0b2df306fffbd$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $95f0b2df306fffbd$var$getDeltaAngle = (startAngle, endAngle)=>{
    var sign = (0, $9a1343d05dde836c$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $95f0b2df306fffbd$var$getTangentCircle = (_ref)=>{
    var { cx: cx, cy: cy, radius: radius, angle: angle, sign: sign, isExternal: isExternal, cornerRadius: cornerRadius, cornerIsExternal: cornerIsExternal } = _ref;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $d16c67d42be24ed1$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $d16c67d42be24ed1$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $d16c67d42be24ed1$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $d16c67d42be24ed1$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $d16c67d42be24ed1$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $95f0b2df306fffbd$var$getSectorPath = (_ref2)=>{
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle } = _ref2;
    var angle = $95f0b2df306fffbd$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $d16c67d42be24ed1$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $d16c67d42be24ed1$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($95f0b2df306fffbd$var$_templateObject || ($95f0b2df306fffbd$var$_templateObject = $95f0b2df306fffbd$var$_taggedTemplateLiteral([
        "M ",
        ",",
        "\n    A ",
        ",",
        ",0,\n    ",
        ",",
        ",\n    ",
        ",",
        "\n  "
    ])), outerStartPoint.x, outerStartPoint.y, outerRadius, outerRadius, +(Math.abs(angle) > 180), +(startAngle > tempEndAngle), outerEndPoint.x, outerEndPoint.y);
    if (innerRadius > 0) {
        var innerStartPoint = (0, $d16c67d42be24ed1$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $d16c67d42be24ed1$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($95f0b2df306fffbd$var$_templateObject2 || ($95f0b2df306fffbd$var$_templateObject2 = $95f0b2df306fffbd$var$_taggedTemplateLiteral([
            "L ",
            ",",
            "\n            A ",
            ",",
            ",0,\n            ",
            ",",
            ",\n            ",
            ",",
            " Z"
        ])), innerEndPoint.x, innerEndPoint.y, innerRadius, innerRadius, +(Math.abs(angle) > 180), +(startAngle <= tempEndAngle), innerStartPoint.x, innerStartPoint.y);
    } else path += (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($95f0b2df306fffbd$var$_templateObject3 || ($95f0b2df306fffbd$var$_templateObject3 = $95f0b2df306fffbd$var$_taggedTemplateLiteral([
        "L ",
        ",",
        " Z"
    ])), cx, cy);
    return path;
};
var $95f0b2df306fffbd$var$getSectorWithCorner = (_ref3)=>{
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, cornerRadius: cornerRadius, forceCornerRadius: forceCornerRadius, cornerIsExternal: cornerIsExternal, startAngle: startAngle, endAngle: endAngle } = _ref3;
    var sign = (0, $9a1343d05dde836c$export$9d334328eb75e624)(endAngle - startAngle);
    var { circleTangency: soct, lineTangency: solt, theta: sot } = $95f0b2df306fffbd$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    });
    var { circleTangency: eoct, lineTangency: eolt, theta: eot } = $95f0b2df306fffbd$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    });
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($95f0b2df306fffbd$var$_templateObject4 || ($95f0b2df306fffbd$var$_templateObject4 = $95f0b2df306fffbd$var$_taggedTemplateLiteral([
            "M ",
            ",",
            "\n        a",
            ",",
            ",0,0,1,",
            ",0\n        a",
            ",",
            ",0,0,1,",
            ",0\n      "
        ])), solt.x, solt.y, cornerRadius, cornerRadius, cornerRadius * 2, cornerRadius, cornerRadius, -cornerRadius * 2);
        return $95f0b2df306fffbd$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($95f0b2df306fffbd$var$_templateObject5 || ($95f0b2df306fffbd$var$_templateObject5 = $95f0b2df306fffbd$var$_taggedTemplateLiteral([
        "M ",
        ",",
        "\n    A",
        ",",
        ",0,0,",
        ",",
        ",",
        "\n    A",
        ",",
        ",0,",
        ",",
        ",",
        ",",
        "\n    A",
        ",",
        ",0,0,",
        ",",
        ",",
        "\n  "
    ])), solt.x, solt.y, cornerRadius, cornerRadius, +(sign < 0), soct.x, soct.y, outerRadius, outerRadius, +(outerArcAngle > 180), +(sign < 0), eoct.x, eoct.y, cornerRadius, cornerRadius, +(sign < 0), eolt.x, eolt.y);
    if (innerRadius > 0) {
        var { circleTangency: sict, lineTangency: silt, theta: sit } = $95f0b2df306fffbd$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        });
        var { circleTangency: eict, lineTangency: eilt, theta: eit } = $95f0b2df306fffbd$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        });
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($95f0b2df306fffbd$var$_templateObject6 || ($95f0b2df306fffbd$var$_templateObject6 = $95f0b2df306fffbd$var$_taggedTemplateLiteral([
            "L",
            ",",
            "\n      A",
            ",",
            ",0,0,",
            ",",
            ",",
            "\n      A",
            ",",
            ",0,",
            ",",
            ",",
            ",",
            "\n      A",
            ",",
            ",0,0,",
            ",",
            ",",
            "Z"
        ])), eilt.x, eilt.y, cornerRadius, cornerRadius, +(sign < 0), eict.x, eict.y, innerRadius, innerRadius, +(innerArcAngle > 180), +(sign > 0), sict.x, sict.y, cornerRadius, cornerRadius, +(sign < 0), silt.x, silt.y);
    } else path += (0, $c127eb7db38963c7$export$f8a24ecc3d6c26c3)($95f0b2df306fffbd$var$_templateObject7 || ($95f0b2df306fffbd$var$_templateObject7 = $95f0b2df306fffbd$var$_taggedTemplateLiteral([
        "L",
        ",",
        "Z"
    ])), cx, cy);
    return path;
};
var $95f0b2df306fffbd$export$1d63e9c2e020b2a7 = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var $95f0b2df306fffbd$export$e98c2c7eb2b14f45 = (sectorProps)=>{
    var props = (0, $2db4b31e06a7a91b$export$45004cc70a390ee8)(sectorProps, $95f0b2df306fffbd$export$1d63e9c2e020b2a7);
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, cornerRadius: cornerRadius, forceCornerRadius: forceCornerRadius, cornerIsExternal: cornerIsExternal, startAngle: startAngle, endAngle: endAngle, className: className } = props;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, $dP0oo.clsx)('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $9a1343d05dde836c$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $95f0b2df306fffbd$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $95f0b2df306fffbd$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ $28UcW.createElement("path", $95f0b2df306fffbd$var$_extends({}, (0, $1412060bc6e2b8b4$export$67f8fc03e57e2747)(props), {
        className: layerClass,
        d: path
    }));
};





var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");





function $5c6e6021af31f172$var$_extends() {
    return $5c6e6021af31f172$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5c6e6021af31f172$var$_extends.apply(null, arguments);
}
function $5c6e6021af31f172$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5c6e6021af31f172$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5c6e6021af31f172$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5c6e6021af31f172$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5c6e6021af31f172$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5c6e6021af31f172$var$_defineProperty(e, r, t) {
    return (r = $5c6e6021af31f172$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $5c6e6021af31f172$var$_toPropertyKey(t) {
    var i = $5c6e6021af31f172$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $5c6e6021af31f172$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $5c6e6021af31f172$var$CURVE_FACTORIES = {
    curveBasisClosed: $c72ad316bc19e104$exports.curveBasisClosed,
    curveBasisOpen: $c72ad316bc19e104$exports.curveBasisOpen,
    curveBasis: $c72ad316bc19e104$exports.curveBasis,
    curveBumpX: $c72ad316bc19e104$exports.curveBumpX,
    curveBumpY: $c72ad316bc19e104$exports.curveBumpY,
    curveLinearClosed: $c72ad316bc19e104$exports.curveLinearClosed,
    curveLinear: $c72ad316bc19e104$exports.curveLinear,
    curveMonotoneX: $c72ad316bc19e104$exports.curveMonotoneX,
    curveMonotoneY: $c72ad316bc19e104$exports.curveMonotoneY,
    curveNatural: $c72ad316bc19e104$exports.curveNatural,
    curveStep: $c72ad316bc19e104$exports.curveStep,
    curveStepAfter: $c72ad316bc19e104$exports.curveStepAfter,
    curveStepBefore: $c72ad316bc19e104$exports.curveStepBefore
};
/**
 * @inline
 */ var $5c6e6021af31f172$var$defined = (p)=>(0, $11a93f8f3c3518e5$export$f8a8fc612ced9bb0)(p.x) && (0, $11a93f8f3c3518e5$export$f8a8fc612ced9bb0)(p.y);
var $5c6e6021af31f172$var$areaDefined = (d)=>d.base != null && $5c6e6021af31f172$var$defined(d.base) && $5c6e6021af31f172$var$defined(d);
var $5c6e6021af31f172$var$getX = (p)=>p.x;
var $5c6e6021af31f172$var$getY = (p)=>p.y;
var $5c6e6021af31f172$var$getCurveFactory = (type, layout)=>{
    if (typeof type === 'function') return type;
    var name = "curve".concat((0, $9a1343d05dde836c$export$3061f22cd819074d)(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) return $5c6e6021af31f172$var$CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
    return $5c6e6021af31f172$var$CURVE_FACTORIES[name] || (0, $c72ad316bc19e104$exports.curveLinear);
};
var $5c6e6021af31f172$export$2aa3fd96c49a84a8 = (_ref)=>{
    var { type: type = 'linear', points: points = [], baseLine: baseLine, layout: layout, connectNulls: connectNulls = false } = _ref;
    var curveFactory = $5c6e6021af31f172$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter($5c6e6021af31f172$var$defined) : points;
    var lineFunction;
    // When dealing with an area chart (where `baseLine` is an array),
    // we need to pair points with their corresponding `baseLine` points first.
    // This is to ensure that we filter points and their baseline counterparts together,
    // preventing errors from mismatched array lengths and ensuring `defined` checks both.
    if (Array.isArray(baseLine)) {
        var areaPoints = points.map((entry, index)=>$5c6e6021af31f172$var$_objectSpread($5c6e6021af31f172$var$_objectSpread({}, entry), {}, {
                base: baseLine[index]
            }));
        if (layout === 'vertical') lineFunction = (0, $c72ad316bc19e104$exports.area)().y($5c6e6021af31f172$var$getY).x1($5c6e6021af31f172$var$getX).x0((d)=>d.base.x);
        else lineFunction = (0, $c72ad316bc19e104$exports.area)().x($5c6e6021af31f172$var$getX).y1($5c6e6021af31f172$var$getY).y0((d)=>d.base.y);
        /*
     * What happens here is that the `.defined()` call will make it so that this function can accept
     * nullable points, and internally it will filter them out and skip when generating the path.
     * So on the input it accepts NullableCoordinate, but it never calls getX/getY on null points because of the defined() filter.
     *
     * The d3 type definition has only one generic so it doesn't allow to describe this properly.
     * However. d3 types are mutable, but we can pretend that they are not, and we can pretend
     * that calling defined() returns a new function with a different generic type.
     */ var _nullableLineFunction = lineFunction.defined($5c6e6021af31f172$var$areaDefined).curve(curveFactory);
        var finalPoints = connectNulls ? areaPoints.filter($5c6e6021af31f172$var$areaDefined) : areaPoints;
        return _nullableLineFunction(finalPoints);
    }
    if (layout === 'vertical' && (0, $9a1343d05dde836c$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $c72ad316bc19e104$exports.area)().y($5c6e6021af31f172$var$getY).x1($5c6e6021af31f172$var$getX).x0(baseLine);
    else if ((0, $9a1343d05dde836c$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $c72ad316bc19e104$exports.area)().x($5c6e6021af31f172$var$getX).y1($5c6e6021af31f172$var$getY).y0(baseLine);
    else lineFunction = (0, $c72ad316bc19e104$exports.line)().x($5c6e6021af31f172$var$getX).y($5c6e6021af31f172$var$getY);
    var nullableLineFunction = lineFunction.defined($5c6e6021af31f172$var$defined).curve(curveFactory);
    return nullableLineFunction(formatPoints);
};
var $5c6e6021af31f172$export$b0e83c3ef8d2db1 = (props)=>{
    var { className: className, points: points, path: path, pathRef: pathRef } = props;
    var layout = (0, $6ade474fe9f2b6e0$export$970c79ecc7081cc)();
    if ((!points || !points.length) && !path) return null;
    var getPathInput = {
        type: props.type,
        points: props.points,
        baseLine: props.baseLine,
        layout: props.layout || layout,
        connectNulls: props.connectNulls
    };
    var realPath = points && points.length ? $5c6e6021af31f172$export$2aa3fd96c49a84a8(getPathInput) : path;
    return /*#__PURE__*/ $28UcW.createElement("path", $5c6e6021af31f172$var$_extends({}, (0, $3d820e26962aea02$export$8b56257912140094)(props), (0, $4009b9153cff02e8$export$7c4c290a4a9c1b1e)(props), {
        className: (0, $dP0oo.clsx)('recharts-curve', className),
        d: realPath === null ? undefined : realPath,
        ref: pathRef
    }));
};


var $1ee4f71f8120f773$var$_excluded = [
    "option",
    "shapeType",
    "activeClassName"
];
function $1ee4f71f8120f773$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $1ee4f71f8120f773$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $1ee4f71f8120f773$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $1ee4f71f8120f773$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1ee4f71f8120f773$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1ee4f71f8120f773$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1ee4f71f8120f773$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1ee4f71f8120f773$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1ee4f71f8120f773$var$_defineProperty(e, r, t) {
    return (r = $1ee4f71f8120f773$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1ee4f71f8120f773$var$_toPropertyKey(t) {
    var i = $1ee4f71f8120f773$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1ee4f71f8120f773$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a React element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function $1ee4f71f8120f773$var$defaultPropTransformer(option, props) {
    return $1ee4f71f8120f773$var$_objectSpread($1ee4f71f8120f773$var$_objectSpread({}, props), option);
}
function $1ee4f71f8120f773$var$isSymbolsProps(shapeType, _elementProps) {
    return shapeType === 'symbols';
}
function $1ee4f71f8120f773$var$ShapeSelector(_ref) {
    var { shapeType: shapeType, elementProps: elementProps } = _ref;
    switch(shapeType){
        case 'rectangle':
            return /*#__PURE__*/ $28UcW.createElement((0, $0237cf75d6781a88$export$4617fb02663045ef), elementProps);
        case 'trapezoid':
            return /*#__PURE__*/ $28UcW.createElement((0, $cb11189e3b1417f3$export$d1ed33dc592f5337), elementProps);
        case 'sector':
            return /*#__PURE__*/ $28UcW.createElement((0, $95f0b2df306fffbd$export$e98c2c7eb2b14f45), elementProps);
        case 'symbols':
            if ($1ee4f71f8120f773$var$isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ $28UcW.createElement((0, $be2abe7587430551$export$fa456266707bf4e4), elementProps);
            break;
        case 'curve':
            return /*#__PURE__*/ $28UcW.createElement((0, $5c6e6021af31f172$export$b0e83c3ef8d2db1), elementProps);
        default:
            return null;
    }
}
function $1ee4f71f8120f773$export$33c4f706a443da24(option) {
    if (/*#__PURE__*/ (0, $28UcW.isValidElement)(option)) return option.props;
    return option;
}
function $1ee4f71f8120f773$export$6428a7f2611ef1fa(_ref2) {
    var { option: option, shapeType: shapeType, activeClassName: activeClassName = 'recharts-active-shape' } = _ref2, props = $1ee4f71f8120f773$var$_objectWithoutProperties(_ref2, $1ee4f71f8120f773$var$_excluded);
    var shape;
    if (/*#__PURE__*/ (0, $28UcW.isValidElement)(option)) // @ts-expect-error we can't know the type of cloned element props
    shape = /*#__PURE__*/ (0, $28UcW.cloneElement)(option, $1ee4f71f8120f773$var$_objectSpread($1ee4f71f8120f773$var$_objectSpread({}, props), $1ee4f71f8120f773$export$33c4f706a443da24(option)));
    else if (typeof option === 'function') shape = option(props, props.index);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($2c9d695f30ac56aa$exports)))(option) && typeof option !== 'boolean') {
        var nextProps = $1ee4f71f8120f773$var$defaultPropTransformer(option, props);
        shape = /*#__PURE__*/ $28UcW.createElement($1ee4f71f8120f773$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ $28UcW.createElement($1ee4f71f8120f773$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (props.isActive) return /*#__PURE__*/ $28UcW.createElement((0, $06287e412aaf2f1c$export$936d0764594b6eb3), {
        className: activeClassName
    }, shape);
    return shape;
}





var $28UcW = parcelRequire("28UcW");
var $db057e8ae635efa3$exports = {};
'use strict';

$db057e8ae635efa3$exports = (parcelRequire("84KgJ"));


var $fd3445816ed466ed$var$__defProp = Object.defineProperty;
var $fd3445816ed466ed$var$__defProps = Object.defineProperties;
var $fd3445816ed466ed$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $fd3445816ed466ed$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $fd3445816ed466ed$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $fd3445816ed466ed$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $fd3445816ed466ed$var$__defNormalProp = (obj, key, value)=>key in obj ? $fd3445816ed466ed$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $fd3445816ed466ed$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($fd3445816ed466ed$var$__hasOwnProp.call(b, prop)) $fd3445816ed466ed$var$__defNormalProp(a, prop, b[prop]);
    if ($fd3445816ed466ed$var$__getOwnPropSymbols) {
        for (var prop of $fd3445816ed466ed$var$__getOwnPropSymbols(b))if ($fd3445816ed466ed$var$__propIsEnum.call(b, prop)) $fd3445816ed466ed$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $fd3445816ed466ed$var$__spreadProps = (a, b)=>$fd3445816ed466ed$var$__defProps(a, $fd3445816ed466ed$var$__getOwnPropDescs(b));
var $fd3445816ed466ed$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($fd3445816ed466ed$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $fd3445816ed466ed$var$__getOwnPropSymbols) {
        for (var prop of $fd3445816ed466ed$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $fd3445816ed466ed$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $fd3445816ed466ed$var$IS_REACT_19 = /* @__PURE__ */ $28UcW.version.startsWith("19");
var $fd3445816ed466ed$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($fd3445816ed466ed$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $fd3445816ed466ed$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $fd3445816ed466ed$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $fd3445816ed466ed$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $fd3445816ed466ed$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $fd3445816ed466ed$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $fd3445816ed466ed$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $fd3445816ed466ed$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $fd3445816ed466ed$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $fd3445816ed466ed$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $fd3445816ed466ed$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $fd3445816ed466ed$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $fd3445816ed466ed$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $fd3445816ed466ed$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $fd3445816ed466ed$var$ForwardRef = $fd3445816ed466ed$var$REACT_FORWARD_REF_TYPE;
var $fd3445816ed466ed$var$Memo = $fd3445816ed466ed$var$REACT_MEMO_TYPE;
function $fd3445816ed466ed$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $fd3445816ed466ed$var$REACT_FRAGMENT_TYPE || type === $fd3445816ed466ed$var$REACT_PROFILER_TYPE || type === $fd3445816ed466ed$var$REACT_STRICT_MODE_TYPE || type === $fd3445816ed466ed$var$REACT_SUSPENSE_TYPE || type === $fd3445816ed466ed$var$REACT_SUSPENSE_LIST_TYPE || type === $fd3445816ed466ed$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $fd3445816ed466ed$var$REACT_LAZY_TYPE || type.$$typeof === $fd3445816ed466ed$var$REACT_MEMO_TYPE || type.$$typeof === $fd3445816ed466ed$var$REACT_CONTEXT_TYPE || type.$$typeof === $fd3445816ed466ed$var$REACT_CONSUMER_TYPE || type.$$typeof === $fd3445816ed466ed$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $fd3445816ed466ed$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $fd3445816ed466ed$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $fd3445816ed466ed$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $fd3445816ed466ed$var$REACT_FRAGMENT_TYPE:
                    case $fd3445816ed466ed$var$REACT_PROFILER_TYPE:
                    case $fd3445816ed466ed$var$REACT_STRICT_MODE_TYPE:
                    case $fd3445816ed466ed$var$REACT_SUSPENSE_TYPE:
                    case $fd3445816ed466ed$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $fd3445816ed466ed$var$REACT_CONTEXT_TYPE:
                            case $fd3445816ed466ed$var$REACT_FORWARD_REF_TYPE:
                            case $fd3445816ed466ed$var$REACT_LAZY_TYPE:
                            case $fd3445816ed466ed$var$REACT_MEMO_TYPE:
                                return object;
                            case $fd3445816ed466ed$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $fd3445816ed466ed$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $fd3445816ed466ed$var$isContextConsumer(object) {
    return $fd3445816ed466ed$var$IS_REACT_19 ? $fd3445816ed466ed$var$typeOf(object) === $fd3445816ed466ed$var$REACT_CONSUMER_TYPE : $fd3445816ed466ed$var$typeOf(object) === $fd3445816ed466ed$var$REACT_CONTEXT_TYPE;
}
function $fd3445816ed466ed$var$isMemo(object) {
    return $fd3445816ed466ed$var$typeOf(object) === $fd3445816ed466ed$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $fd3445816ed466ed$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $fd3445816ed466ed$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $fd3445816ed466ed$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $fd3445816ed466ed$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $fd3445816ed466ed$var$verify(mapStateToProps, "mapStateToProps");
    $fd3445816ed466ed$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $fd3445816ed466ed$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $fd3445816ed466ed$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $fd3445816ed466ed$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $fd3445816ed466ed$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $fd3445816ed466ed$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $fd3445816ed466ed$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $fd3445816ed466ed$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $fd3445816ed466ed$var$verifyPlainObject(value, displayName, methodName) {
    if (!$fd3445816ed466ed$var$isPlainObject(value)) $fd3445816ed466ed$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $fd3445816ed466ed$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $fd3445816ed466ed$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $fd3445816ed466ed$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $fd3445816ed466ed$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $fd3445816ed466ed$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $fd3445816ed466ed$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $fd3445816ed466ed$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $fd3445816ed466ed$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $fd3445816ed466ed$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $fd3445816ed466ed$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $fd3445816ed466ed$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $fd3445816ed466ed$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $fd3445816ed466ed$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $fd3445816ed466ed$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $fd3445816ed466ed$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $fd3445816ed466ed$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $fd3445816ed466ed$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $fd3445816ed466ed$var$__spreadValues($fd3445816ed466ed$var$__spreadValues($fd3445816ed466ed$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $fd3445816ed466ed$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $fd3445816ed466ed$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$fd3445816ed466ed$var$defaultMergeProps : typeof mergeProps === "function" ? $fd3445816ed466ed$var$wrapMergePropsFunc(mergeProps) : $fd3445816ed466ed$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $fd3445816ed466ed$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $fd3445816ed466ed$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $fd3445816ed466ed$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $fd3445816ed466ed$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $fd3445816ed466ed$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $fd3445816ed466ed$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $fd3445816ed466ed$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $fd3445816ed466ed$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $fd3445816ed466ed$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $fd3445816ed466ed$var$isDOM = /* @__PURE__ */ $fd3445816ed466ed$var$canUseDOM();
var $fd3445816ed466ed$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $fd3445816ed466ed$var$isReactNative = /* @__PURE__ */ $fd3445816ed466ed$var$isRunningInReactNative();
var $fd3445816ed466ed$var$getUseIsomorphicLayoutEffect = ()=>$fd3445816ed466ed$var$isDOM || $fd3445816ed466ed$var$isReactNative ? $28UcW.useLayoutEffect : $28UcW.useEffect;
var $fd3445816ed466ed$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $fd3445816ed466ed$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $fd3445816ed466ed$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $fd3445816ed466ed$export$d36bdfa510afb180(objA, objB) {
    if ($fd3445816ed466ed$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$fd3445816ed466ed$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $fd3445816ed466ed$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $fd3445816ed466ed$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $fd3445816ed466ed$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $fd3445816ed466ed$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $fd3445816ed466ed$var$TYPE_STATICS = {
    [$fd3445816ed466ed$var$ForwardRef]: $fd3445816ed466ed$var$FORWARD_REF_STATICS,
    [$fd3445816ed466ed$var$Memo]: $fd3445816ed466ed$var$MEMO_STATICS
};
function $fd3445816ed466ed$var$getStatics(component) {
    if ($fd3445816ed466ed$var$isMemo(component)) return $fd3445816ed466ed$var$MEMO_STATICS;
    return $fd3445816ed466ed$var$TYPE_STATICS[component["$$typeof"]] || $fd3445816ed466ed$var$REACT_STATICS;
}
var $fd3445816ed466ed$var$defineProperty = Object.defineProperty;
var $fd3445816ed466ed$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $fd3445816ed466ed$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $fd3445816ed466ed$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $fd3445816ed466ed$var$getPrototypeOf = Object.getPrototypeOf;
var $fd3445816ed466ed$var$objectPrototype = Object.prototype;
function $fd3445816ed466ed$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($fd3445816ed466ed$var$objectPrototype) {
            const inheritedComponent = $fd3445816ed466ed$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $fd3445816ed466ed$var$objectPrototype) $fd3445816ed466ed$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $fd3445816ed466ed$var$getOwnPropertyNames(sourceComponent);
        if ($fd3445816ed466ed$var$getOwnPropertySymbols) keys = keys.concat($fd3445816ed466ed$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $fd3445816ed466ed$var$getStatics(targetComponent);
        const sourceStatics = $fd3445816ed466ed$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$fd3445816ed466ed$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $fd3445816ed466ed$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $fd3445816ed466ed$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $fd3445816ed466ed$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $fd3445816ed466ed$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $fd3445816ed466ed$var$getContext() {
    var _a;
    if (!$28UcW.createContext) return {};
    const contextMap = (_a = $fd3445816ed466ed$var$gT[$fd3445816ed466ed$var$ContextKey]) != null ? _a : $fd3445816ed466ed$var$gT[$fd3445816ed466ed$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($28UcW.createContext);
    if (!realContext) {
        realContext = $28UcW.createContext(null);
        contextMap.set($28UcW.createContext, realContext);
    }
    return realContext;
}
var $fd3445816ed466ed$export$cc80c08dc91f1c00 = /* @__PURE__ */ $fd3445816ed466ed$var$getContext();
// src/components/connect.tsx
var $fd3445816ed466ed$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $fd3445816ed466ed$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $fd3445816ed466ed$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $fd3445816ed466ed$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $fd3445816ed466ed$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $fd3445816ed466ed$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $fd3445816ed466ed$var$strictEqual(a, b) {
    return a === b;
}
var $fd3445816ed466ed$var$hasWarnedAboutDeprecatedPureOption = false;
function $fd3445816ed466ed$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $fd3445816ed466ed$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $fd3445816ed466ed$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $fd3445816ed466ed$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $fd3445816ed466ed$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $fd3445816ed466ed$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $fd3445816ed466ed$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $fd3445816ed466ed$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $fd3445816ed466ed$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $28UcW.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $fd3445816ed466ed$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $28UcW.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $28UcW.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $28UcW.useMemo(()=>{
                return $fd3445816ed466ed$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $28UcW.useMemo(()=>{
                if (!shouldHandleStateChanges) return $fd3445816ed466ed$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $fd3445816ed466ed$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $28UcW.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $fd3445816ed466ed$var$__spreadProps($fd3445816ed466ed$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $28UcW.useRef(void 0);
            const lastWrapperProps = $28UcW.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $28UcW.useRef(void 0);
            const renderIsScheduled = $28UcW.useRef(false);
            const isMounted = $28UcW.useRef(false);
            const latestSubscriptionCallbackError = $28UcW.useRef(void 0);
            $fd3445816ed466ed$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $28UcW.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $28UcW.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $fd3445816ed466ed$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $fd3445816ed466ed$var$useIsomorphicLayoutEffectWithArgs($fd3445816ed466ed$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $28UcW.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $fd3445816ed466ed$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $28UcW.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $28UcW.createElement(WrappedComponent, $fd3445816ed466ed$var$__spreadProps($fd3445816ed466ed$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $28UcW.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $28UcW.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $28UcW.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $28UcW.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $28UcW.createElement(Connect, $fd3445816ed466ed$var$__spreadProps($fd3445816ed466ed$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $fd3445816ed466ed$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $fd3445816ed466ed$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $fd3445816ed466ed$export$64605811ab45167f = $fd3445816ed466ed$var$connect;
// src/components/Provider.tsx
function $fd3445816ed466ed$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $28UcW.useMemo(()=>{
        const subscription = $fd3445816ed466ed$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $28UcW.useMemo(()=>store.getState(), [
        store
    ]);
    $fd3445816ed466ed$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $fd3445816ed466ed$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $28UcW.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $fd3445816ed466ed$export$2881499e37b75b9a = $fd3445816ed466ed$var$Provider;
// src/hooks/useReduxContext.ts
function $fd3445816ed466ed$var$createReduxContextHook(context = $fd3445816ed466ed$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $28UcW.useContext(context);
        return contextValue;
    };
}
var $fd3445816ed466ed$var$useReduxContext = /* @__PURE__ */ $fd3445816ed466ed$var$createReduxContextHook();
// src/hooks/useStore.ts
function $fd3445816ed466ed$export$671dba69185d0304(context = $fd3445816ed466ed$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $fd3445816ed466ed$export$cc80c08dc91f1c00 ? $fd3445816ed466ed$var$useReduxContext : // @ts-ignore
    $fd3445816ed466ed$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $fd3445816ed466ed$export$6ccbb43953eebf8 = /* @__PURE__ */ $fd3445816ed466ed$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $fd3445816ed466ed$export$bc9b55530897c558(context = $fd3445816ed466ed$export$cc80c08dc91f1c00) {
    const useStore2 = context === $fd3445816ed466ed$export$cc80c08dc91f1c00 ? $fd3445816ed466ed$export$6ccbb43953eebf8 : $fd3445816ed466ed$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $fd3445816ed466ed$export$8ad76b76a4c905f8 = /* @__PURE__ */ $fd3445816ed466ed$export$bc9b55530897c558();
var $fd3445816ed466ed$var$refEquality = (a, b)=>a === b;
function $fd3445816ed466ed$export$2b53f90d2bd1cbfb(context = $fd3445816ed466ed$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $fd3445816ed466ed$export$cc80c08dc91f1c00 ? $fd3445816ed466ed$var$useReduxContext : $fd3445816ed466ed$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $fd3445816ed466ed$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $28UcW.useRef(true);
        const wrappedSelector = $28UcW.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $db057e8ae635efa3$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $28UcW.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $fd3445816ed466ed$export$2105062e25df4afe = /* @__PURE__ */ $fd3445816ed466ed$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $fd3445816ed466ed$export$712ea50be43a7858 = $fd3445816ed466ed$var$defaultNoopBatch;


var $b5b53d7d8a4bed40$var$propsToShallowCompare = new Set([
    'axisLine',
    'tickLine',
    'activeBar',
    'activeDot',
    'activeLabel',
    'activeShape',
    'allowEscapeViewBox',
    'background',
    'cursor',
    'dot',
    'label',
    'line',
    'margin',
    'padding',
    'position',
    'shape',
    'style',
    'tick',
    'wrapperStyle',
    // radius can be an array of 4 numbers, easy to compare shallowly
    'radius'
]);
/**
 * When comparing two values, returns true if they are the same value or
 * are both NaN.
 *
 * If we used just a simple triple equals, we would get false negatives for two NaNs
 * which could cause extra re-renders so let's have this instead.
 *
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Equality_comparisons_and_sameness#same-value-zero_equality
 *
 * @param x first value to compare
 * @param y second value to compare
 * return true if the same, false if different
 */ function $b5b53d7d8a4bed40$var$sameValueZero(x, y) {
    if (x == null && y == null) /*
     * treat null and undefined as equal. Internally in Recharts we make no difference between these two
     * so there is no need to re-render.
     */ return true;
    if (typeof x === 'number' && typeof y === 'number') // x and y are equal (this is true for -0 and 0) or they are both NaN
    // eslint-disable-next-line no-self-compare
    return x === y || x !== x && y !== y;
    return x === y;
}
function $b5b53d7d8a4bed40$export$b8f09df787c278d9(prevProps, nextProps) {
    var allKeys = new Set([
        ...Object.keys(prevProps),
        ...Object.keys(nextProps)
    ]);
    for (var key of allKeys){
        /*
     * If a key is on a special allowlist, go one level deeper
     * and do a shallow comparison of the values.
     */ if ($b5b53d7d8a4bed40$var$propsToShallowCompare.has(key)) {
            if (prevProps[key] == null && nextProps[key] == null) continue;
            if (!(0, $fd3445816ed466ed$export$d36bdfa510afb180)(prevProps[key], nextProps[key])) return false;
        /*
       * Otherwise do a simple same-value comparison (with NaN support).
       */ } else if (!$b5b53d7d8a4bed40$var$sameValueZero(prevProps[key], nextProps[key])) return false;
    }
    return true;
}


var $0af3c38f38567981$var$_excluded = [
    "id"
], $0af3c38f38567981$var$_excluded2 = [
    "type",
    "layout",
    "connectNulls",
    "needClip",
    "shape"
], $0af3c38f38567981$var$_excluded3 = [
    "activeDot",
    "animateNewValues",
    "animationBegin",
    "animationDuration",
    "animationEasing",
    "connectNulls",
    "dot",
    "hide",
    "isAnimationActive",
    "label",
    "legendType",
    "xAxisId",
    "yAxisId",
    "id"
];
function $0af3c38f38567981$var$_extends() {
    return $0af3c38f38567981$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0af3c38f38567981$var$_extends.apply(null, arguments);
}
function $0af3c38f38567981$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0af3c38f38567981$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0af3c38f38567981$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0af3c38f38567981$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0af3c38f38567981$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0af3c38f38567981$var$_defineProperty(e, r, t) {
    return (r = $0af3c38f38567981$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0af3c38f38567981$var$_toPropertyKey(t) {
    var i = $0af3c38f38567981$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0af3c38f38567981$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0af3c38f38567981$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $0af3c38f38567981$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $0af3c38f38567981$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * Internal props, combination of external props + defaultProps + private Recharts state
 */ /**
 * External props, intended for end users to fill in
 */ /**
 * Because of naming conflict, we are forced to ignore certain (valid) SVG attributes.
 */ var $0af3c38f38567981$var$computeLegendPayloadFromAreaData = (props)=>{
    var { dataKey: dataKey, name: name, stroke: stroke, legendType: legendType, hide: hide } = props;
    return [
        {
            inactive: hide,
            dataKey: dataKey,
            type: legendType,
            color: stroke,
            value: (0, $912d8cf1d03ea507$export$d3207de44081d2b3)(name, dataKey),
            payload: props
        }
    ];
};
var $0af3c38f38567981$var$SetLineTooltipEntrySettings = /*#__PURE__*/ $28UcW.memo((_ref)=>{
    var { dataKey: dataKey, data: data, stroke: stroke, strokeWidth: strokeWidth, fill: fill, name: name, hide: hide, unit: unit, tooltipType: tooltipType, id: id } = _ref;
    var tooltipEntrySettings = {
        dataDefinedOnItem: data,
        positions: undefined,
        settings: {
            stroke: stroke,
            strokeWidth: strokeWidth,
            fill: fill,
            dataKey: dataKey,
            nameKey: undefined,
            name: (0, $912d8cf1d03ea507$export$d3207de44081d2b3)(name, dataKey),
            hide: hide,
            type: tooltipType,
            color: stroke,
            unit: unit,
            graphicalItemId: id
        }
    };
    return /*#__PURE__*/ $28UcW.createElement((0, $8e4c9ddf806a5a3a$export$7fa09c17ce18f3e8), {
        tooltipEntrySettings: tooltipEntrySettings
    });
});
var $0af3c38f38567981$var$generateSimpleStrokeDasharray = (totalLength, length)=>{
    return "".concat(length, "px ").concat(totalLength - length, "px");
};
function $0af3c38f38567981$var$repeat(lines, count) {
    var linesUnit = lines.length % 2 !== 0 ? [
        ...lines,
        0
    ] : lines;
    var result = [];
    for(var i = 0; i < count; ++i)result = [
        ...result,
        ...linesUnit
    ];
    return result;
}
var $0af3c38f38567981$var$getStrokeDasharray = (length, totalLength, lines)=>{
    var lineLength = lines.reduce((pre, next)=>pre + next);
    // if lineLength is 0 return the default when no strokeDasharray is provided
    if (!lineLength) return $0af3c38f38567981$var$generateSimpleStrokeDasharray(totalLength, length);
    var count = Math.floor(length / lineLength);
    var remainLength = length % lineLength;
    var restLength = totalLength - length;
    var remainLines = [];
    for(var i = 0, sum = 0; i < lines.length; sum += lines[i], ++i)if (sum + lines[i] > remainLength) {
        remainLines = [
            ...lines.slice(0, i),
            remainLength - sum
        ];
        break;
    }
    var emptyLines = remainLines.length % 2 === 0 ? [
        0,
        restLength
    ] : [
        restLength
    ];
    return [
        ...$0af3c38f38567981$var$repeat(lines, count),
        ...remainLines,
        ...emptyLines
    ].map((line)=>"".concat(line, "px")).join(', ');
};
function $0af3c38f38567981$var$LineDotsWrapper(_ref2) {
    var { clipPathId: clipPathId, points: points, props: props } = _ref2;
    var { dot: dot, dataKey: dataKey, needClip: needClip } = props;
    /*
   * Exclude ID from the props passed to the Dots component
   * because then the ID would be applied to multiple dots, and it would no longer be unique.
   */ var { id: id } = props, propsWithoutId = $0af3c38f38567981$var$_objectWithoutProperties(props, $0af3c38f38567981$var$_excluded);
    var lineProps = (0, $3d820e26962aea02$export$8b56257912140094)(propsWithoutId);
    return /*#__PURE__*/ $28UcW.createElement((0, $425486537aadb3b9$export$8da50d3722682be0), {
        points: points,
        dot: dot,
        className: "recharts-line-dots",
        dotClassName: "recharts-line-dot",
        dataKey: dataKey,
        baseProps: lineProps,
        needClip: needClip,
        clipPathId: clipPathId
    });
}
function $0af3c38f38567981$var$LineLabelListProvider(_ref3) {
    var { showLabels: showLabels, children: children, points: points } = _ref3;
    var labelListEntries = (0, $28UcW.useMemo)(()=>{
        return points === null || points === void 0 ? void 0 : points.map((point)=>{
            var _point$x, _point$y;
            var viewBox = {
                x: (_point$x = point.x) !== null && _point$x !== void 0 ? _point$x : 0,
                y: (_point$y = point.y) !== null && _point$y !== void 0 ? _point$y : 0,
                width: 0,
                lowerWidth: 0,
                upperWidth: 0,
                height: 0
            };
            return $0af3c38f38567981$var$_objectSpread($0af3c38f38567981$var$_objectSpread({}, viewBox), {}, {
                value: point.value,
                payload: point.payload,
                viewBox: viewBox,
                /*
         * Line is not passing parentViewBox to the LabelList so the labels can escape - looks like a bug, should we pass parentViewBox?
         * Or should this just be the root chart viewBox?
         */ parentViewBox: undefined,
                fill: undefined
            });
        });
    }, [
        points
    ]);
    return /*#__PURE__*/ $28UcW.createElement((0, $e58439db30c77114$export$64e384eac5db53f7), {
        value: showLabels ? labelListEntries : undefined
    }, children);
}
function $0af3c38f38567981$var$StaticCurve(_ref4) {
    var { clipPathId: clipPathId, pathRef: pathRef, points: points, strokeDasharray: strokeDasharray, props: props } = _ref4;
    var { type: type, layout: layout, connectNulls: connectNulls, needClip: needClip, shape: shape } = props, others = $0af3c38f38567981$var$_objectWithoutProperties(props, $0af3c38f38567981$var$_excluded2);
    var curveProps = $0af3c38f38567981$var$_objectSpread($0af3c38f38567981$var$_objectSpread({}, (0, $1412060bc6e2b8b4$export$67f8fc03e57e2747)(others)), {}, {
        fill: 'none',
        className: 'recharts-line-curve',
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : undefined,
        points: points,
        type: type,
        layout: layout,
        connectNulls: connectNulls,
        strokeDasharray: strokeDasharray !== null && strokeDasharray !== void 0 ? strokeDasharray : props.strokeDasharray
    });
    return /*#__PURE__*/ $28UcW.createElement($28UcW.Fragment, null, (points === null || points === void 0 ? void 0 : points.length) > 1 && /*#__PURE__*/ $28UcW.createElement((0, $1ee4f71f8120f773$export$6428a7f2611ef1fa), $0af3c38f38567981$var$_extends({
        shapeType: "curve",
        option: shape
    }, curveProps, {
        pathRef: pathRef
    })), /*#__PURE__*/ $28UcW.createElement($0af3c38f38567981$var$LineDotsWrapper, {
        points: points,
        clipPathId: clipPathId,
        props: props
    }));
}
function $0af3c38f38567981$var$getTotalLength(mainCurve) {
    try {
        return mainCurve && mainCurve.getTotalLength && mainCurve.getTotalLength() || 0;
    } catch (_unused) {
        return 0;
    }
}
function $0af3c38f38567981$var$CurveWithAnimation(_ref5) {
    var { clipPathId: clipPathId, props: props, pathRef: pathRef, previousPointsRef: previousPointsRef, longestAnimatedLengthRef: longestAnimatedLengthRef } = _ref5;
    var { points: points, strokeDasharray: strokeDasharray, isAnimationActive: isAnimationActive, animationBegin: animationBegin, animationDuration: animationDuration, animationEasing: animationEasing, animateNewValues: animateNewValues, width: width, height: height, onAnimationEnd: onAnimationEnd, onAnimationStart: onAnimationStart } = props;
    var prevPoints = previousPointsRef.current;
    var animationId = (0, $49cf52428a039363$export$e1042b2944b80b7f)(points, 'recharts-line-');
    var animationIdRef = (0, $28UcW.useRef)(animationId);
    var [isAnimating, setIsAnimating] = (0, $28UcW.useState)(false);
    var showLabels = !isAnimating;
    var handleAnimationEnd = (0, $28UcW.useCallback)(()=>{
        if (typeof onAnimationEnd === 'function') onAnimationEnd();
        setIsAnimating(false);
    }, [
        onAnimationEnd
    ]);
    var handleAnimationStart = (0, $28UcW.useCallback)(()=>{
        if (typeof onAnimationStart === 'function') onAnimationStart();
        setIsAnimating(true);
    }, [
        onAnimationStart
    ]);
    var totalLength = $0af3c38f38567981$var$getTotalLength(pathRef.current);
    /*
   * Here we want to detect if the length animation has been interrupted.
   * For that we keep a reference to the furthest length that has been animated.
   *
   * And then, to keep things smooth, we add to it the current length that is being animated right now.
   *
   * If we did Math.max then it makes the length animation "pause" but we want to keep it smooth
   * so in case we have some "leftover" length from the previous animation we add it to the current length.
   *
   * This is not perfect because the animation changes speed due to easing. The default easing is 'ease' which is not linear
   * and makes it stand out. But it's good enough I suppose.
   * If we want to fix it then we need to keep track of multiple animations and their easing and timings.
   *
   * If you want to see this in action, try to change the dataKey of the line chart while the initial animation is running.
   * The Line begins with zero length and slowly grows to the full length. While this growth is in progress,
   * change the dataKey and the Line will continue growing from where it has grown so far.
   *
   * This is for the case when new animation triggers. When that happens we get new points, everything re-renders,
   * and we get fresh new state in this component and use the ref stored above.
   *
   * In case when we get render without new animation - for example when opacity changes, or color changes,
   * then the animationId remains the same, and we do not update the starting point.
   * See https://github.com/recharts/recharts/issues/6044
   */ var startingPointRef = (0, $28UcW.useRef)(0);
    if (animationIdRef.current !== animationId) {
        startingPointRef.current = longestAnimatedLengthRef.current;
        animationIdRef.current = animationId;
    }
    var startingPoint = startingPointRef.current;
    return /*#__PURE__*/ $28UcW.createElement($0af3c38f38567981$var$LineLabelListProvider, {
        points: points,
        showLabels: showLabels
    }, props.children, /*#__PURE__*/ $28UcW.createElement((0, $2cfa712dd658b01e$export$5d41821894c47c52), {
        animationId: animationId,
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        onAnimationEnd: handleAnimationEnd,
        onAnimationStart: handleAnimationStart,
        key: animationId
    }, (t)=>{
        var lengthInterpolated = (0, $9a1343d05dde836c$export$89e29e4ab65e70a9)(startingPoint, totalLength + startingPoint, t);
        var curLength = Math.min(lengthInterpolated, totalLength);
        var currentStrokeDasharray;
        if (isAnimationActive) {
            if (strokeDasharray) {
                var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map((num)=>parseFloat(num));
                currentStrokeDasharray = $0af3c38f38567981$var$getStrokeDasharray(curLength, totalLength, lines);
            } else currentStrokeDasharray = $0af3c38f38567981$var$generateSimpleStrokeDasharray(totalLength, curLength);
        } else currentStrokeDasharray = strokeDasharray == null ? undefined : String(strokeDasharray);
        /*
     * Here it is important to wait a little bit with updating the previousPointsRef
     * before the animation has a time to initialize.
     * If we set the previous pointsRef immediately, we set it before the Legend height it calculated
     * and before pathRef is set.
     * If that happens, the Line will re-render again after Legend had reported its height
     * which will start a new animation with the previous points as the starting point
     * which gives the effect of the Line animating slightly upwards (where the animation distance equals the Legend height).
     * Waiting for t > 0 is indirect but good enough to ensure that the Legend height is calculated and animation works properly.
     *
     * Total length similarly is calculated from the pathRef. We should not update the previousPointsRef
     * before the pathRef is set, otherwise we will have a wrong total length.
     */ if (t > 0 && totalLength > 0) {
            // eslint-disable-next-line no-param-reassign
            previousPointsRef.current = points;
            /*
       * totalLength is set from a ref and is not updated in the first tick of the animation.
       * It defaults to zero which is exactly what we want here because we want to grow from zero,
       * however the same happens when the data change.
       *
       * In that case we want to remember the previous length and continue from there, and only animate the shape.
       *
       * Therefore the totalLength > 0 check.
       *
       * The Animate is about to fire handleAnimationStart which will update the state
       * and cause a re-render and read a new proper totalLength which will be used in the next tick
       * and update the longestAnimatedLengthRef.
       *
       * Why Math.max? Sometimes the curve goes through a smaller length than previously recorded.
       * If we just set it to curLength, then the next animation would start from a smaller length
       * which looks weird. So we keep the longest length ever reached and then animate from there.
       */ // eslint-disable-next-line no-param-reassign
            longestAnimatedLengthRef.current = Math.max(longestAnimatedLengthRef.current, curLength);
        }
        if (prevPoints) {
            var prevPointsDiffFactor = prevPoints.length / points.length;
            var stepData = t === 1 ? points : points.map((entry, index)=>{
                var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                if (prevPoints[prevPointIndex]) {
                    var prev = prevPoints[prevPointIndex];
                    return $0af3c38f38567981$var$_objectSpread($0af3c38f38567981$var$_objectSpread({}, entry), {}, {
                        x: (0, $9a1343d05dde836c$export$89e29e4ab65e70a9)(prev.x, entry.x, t),
                        y: (0, $9a1343d05dde836c$export$89e29e4ab65e70a9)(prev.y, entry.y, t)
                    });
                }
                // magic number of faking previous x and y location
                if (animateNewValues) return $0af3c38f38567981$var$_objectSpread($0af3c38f38567981$var$_objectSpread({}, entry), {}, {
                    x: (0, $9a1343d05dde836c$export$89e29e4ab65e70a9)(width * 2, entry.x, t),
                    y: (0, $9a1343d05dde836c$export$89e29e4ab65e70a9)(height / 2, entry.y, t)
                });
                return $0af3c38f38567981$var$_objectSpread($0af3c38f38567981$var$_objectSpread({}, entry), {}, {
                    x: entry.x,
                    y: entry.y
                });
            });
            // eslint-disable-next-line no-param-reassign
            previousPointsRef.current = stepData;
            return /*#__PURE__*/ $28UcW.createElement($0af3c38f38567981$var$StaticCurve, {
                props: props,
                points: stepData,
                clipPathId: clipPathId,
                pathRef: pathRef,
                strokeDasharray: currentStrokeDasharray
            });
        }
        return /*#__PURE__*/ $28UcW.createElement($0af3c38f38567981$var$StaticCurve, {
            props: props,
            points: points,
            clipPathId: clipPathId,
            pathRef: pathRef,
            strokeDasharray: currentStrokeDasharray
        });
    }), /*#__PURE__*/ $28UcW.createElement((0, $e58439db30c77114$export$9a402bc8de2b410e), {
        label: props.label
    }));
}
function $0af3c38f38567981$var$RenderCurve(_ref6) {
    var { clipPathId: clipPathId, props: props } = _ref6;
    var previousPointsRef = (0, $28UcW.useRef)(null);
    var longestAnimatedLengthRef = (0, $28UcW.useRef)(0);
    var pathRef = (0, $28UcW.useRef)(null);
    return /*#__PURE__*/ $28UcW.createElement($0af3c38f38567981$var$CurveWithAnimation, {
        props: props,
        clipPathId: clipPathId,
        previousPointsRef: previousPointsRef,
        longestAnimatedLengthRef: longestAnimatedLengthRef,
        pathRef: pathRef
    });
}
var $0af3c38f38567981$var$errorBarDataPointFormatter = (dataPoint, dataKey)=>{
    var _dataPoint$x, _dataPoint$y;
    return {
        x: (_dataPoint$x = dataPoint.x) !== null && _dataPoint$x !== void 0 ? _dataPoint$x : undefined,
        y: (_dataPoint$y = dataPoint.y) !== null && _dataPoint$y !== void 0 ? _dataPoint$y : undefined,
        value: dataPoint.value,
        // @ts-expect-error getValueByDataKey does not validate the output type
        errorVal: (0, $912d8cf1d03ea507$export$f97fc4a450f29a)(dataPoint.payload, dataKey)
    };
};
// eslint-disable-next-line react/prefer-stateless-function
class $0af3c38f38567981$var$LineWithState extends (0, $28UcW.Component) {
    render() {
        var { hide: hide, dot: dot, points: points, className: className, xAxisId: xAxisId, yAxisId: yAxisId, top: top, left: left, width: width, height: height, id: id, needClip: needClip, zIndex: zIndex } = this.props;
        if (hide) return null;
        var layerClass = (0, $dP0oo.clsx)('recharts-line', className);
        var clipPathId = id;
        var { r: r, strokeWidth: strokeWidth } = (0, $1428e64421e343f5$export$af45be059e20a9dd)(dot);
        var clipDot = (0, $5d3adb881548ed4e$export$28c0c718114c1a2e)(dot);
        var dotSize = r * 2 + strokeWidth;
        var activePointsClipPath = needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : undefined;
        return /*#__PURE__*/ $28UcW.createElement((0, $3603bfc8e6eb9e37$export$b37befaf92aba9f1), {
            zIndex: zIndex
        }, /*#__PURE__*/ $28UcW.createElement((0, $06287e412aaf2f1c$export$936d0764594b6eb3), {
            className: layerClass
        }, needClip && /*#__PURE__*/ $28UcW.createElement("defs", null, /*#__PURE__*/ $28UcW.createElement((0, $dcc21075cc3e5cd7$export$d65f7a7dd82fbb63), {
            clipPathId: clipPathId,
            xAxisId: xAxisId,
            yAxisId: yAxisId
        }), !clipDot && /*#__PURE__*/ $28UcW.createElement("clipPath", {
            id: "clipPath-dots-".concat(clipPathId)
        }, /*#__PURE__*/ $28UcW.createElement("rect", {
            x: left - dotSize / 2,
            y: top - dotSize / 2,
            width: width + dotSize,
            height: height + dotSize
        }))), /*#__PURE__*/ $28UcW.createElement((0, $eec382277d540037$export$fcd6ba6fb4bc66e7), {
            xAxisId: xAxisId,
            yAxisId: yAxisId,
            data: points,
            dataPointFormatter: $0af3c38f38567981$var$errorBarDataPointFormatter,
            errorBarOffset: 0
        }, /*#__PURE__*/ $28UcW.createElement($0af3c38f38567981$var$RenderCurve, {
            props: this.props,
            clipPathId: clipPathId
        }))), /*#__PURE__*/ $28UcW.createElement((0, $bd092d308d8485c0$export$dd2d3dc8acd956aa), {
            activeDot: this.props.activeDot,
            points: points,
            mainColor: this.props.stroke,
            itemDataKey: this.props.dataKey,
            clipPath: activePointsClipPath
        }));
    }
}
var $0af3c38f38567981$export$ab40e5efc5c9973f = {
    activeDot: true,
    animateNewValues: true,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease',
    connectNulls: false,
    dot: true,
    fill: '#fff',
    hide: false,
    isAnimationActive: 'auto',
    label: false,
    legendType: 'line',
    stroke: '#3182bd',
    strokeWidth: 1,
    xAxisId: 0,
    yAxisId: 0,
    zIndex: (0, $45e92ad7df96f1e3$export$96df16b28aa32702).line,
    type: 'linear'
};
function $0af3c38f38567981$var$LineImpl(props) {
    var _resolveDefaultProps = (0, $2db4b31e06a7a91b$export$45004cc70a390ee8)(props, $0af3c38f38567981$export$ab40e5efc5c9973f), { activeDot: activeDot, animateNewValues: animateNewValues, animationBegin: animationBegin, animationDuration: animationDuration, animationEasing: animationEasing, connectNulls: connectNulls, dot: dot, hide: hide, isAnimationActive: isAnimationActive, label: label, legendType: legendType, xAxisId: xAxisId, yAxisId: yAxisId, id: id } = _resolveDefaultProps, everythingElse = $0af3c38f38567981$var$_objectWithoutProperties(_resolveDefaultProps, $0af3c38f38567981$var$_excluded3);
    var { needClip: needClip } = (0, $dcc21075cc3e5cd7$export$79e142f66441c204)(xAxisId, yAxisId);
    var plotArea = (0, $cf472f754cd2bf9d$export$f1ef8efc9ef6fe0c)();
    var layout = (0, $6ade474fe9f2b6e0$export$970c79ecc7081cc)();
    var isPanorama = (0, $d64615d5c7c4e07c$export$4b0c59f8845ba920)();
    var points = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $88297809403819de$export$3eaebea0f6c183c0)(state, xAxisId, yAxisId, isPanorama, id));
    if (layout !== 'horizontal' && layout !== 'vertical' || points == null || plotArea == null) // Cannot render Line in an unsupported layout
    return null;
    var { height: height, width: width, x: left, y: top } = plotArea;
    return /*#__PURE__*/ $28UcW.createElement($0af3c38f38567981$var$LineWithState, $0af3c38f38567981$var$_extends({}, everythingElse, {
        id: id,
        connectNulls: connectNulls,
        dot: dot,
        activeDot: activeDot,
        animateNewValues: animateNewValues,
        animationBegin: animationBegin,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        isAnimationActive: isAnimationActive,
        hide: hide,
        label: label,
        legendType: legendType,
        xAxisId: xAxisId,
        yAxisId: yAxisId,
        points: points,
        layout: layout,
        height: height,
        width: width,
        left: left,
        top: top,
        needClip: needClip
    }));
}
function $0af3c38f38567981$export$bfbd9a993cf94d79(_ref7) {
    var { layout: layout, xAxis: xAxis, yAxis: yAxis, xAxisTicks: xAxisTicks, yAxisTicks: yAxisTicks, dataKey: dataKey, bandSize: bandSize, displayedData: displayedData } = _ref7;
    return displayedData.map((entry, index)=>{
        // @ts-expect-error getValueByDataKey does not validate the output type
        var value = (0, $912d8cf1d03ea507$export$f97fc4a450f29a)(entry, dataKey);
        if (layout === 'horizontal') {
            var _x = (0, $912d8cf1d03ea507$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            });
            var _y = (0, $9a1343d05dde836c$export$b931b78cbb3caf86)(value) ? null : yAxis.scale(value);
            return {
                x: _x,
                y: _y,
                value: value,
                payload: entry
            };
        }
        var x = (0, $9a1343d05dde836c$export$b931b78cbb3caf86)(value) ? null : xAxis.scale(value);
        var y = (0, $912d8cf1d03ea507$export$6e87f3defb83c3f)({
            axis: yAxis,
            ticks: yAxisTicks,
            bandSize: bandSize,
            entry: entry,
            index: index
        });
        if (x == null || y == null) return null;
        return {
            x: x,
            y: y,
            value: value,
            payload: entry
        };
    }).filter(Boolean);
}
function $0af3c38f38567981$var$LineFn(outsideProps) {
    var props = (0, $2db4b31e06a7a91b$export$45004cc70a390ee8)(outsideProps, $0af3c38f38567981$export$ab40e5efc5c9973f);
    var isPanorama = (0, $d64615d5c7c4e07c$export$4b0c59f8845ba920)();
    return /*#__PURE__*/ $28UcW.createElement((0, $a1b930a3052976a6$export$8c2f307ff93f02ba), {
        id: props.id,
        type: "line"
    }, (id)=>/*#__PURE__*/ $28UcW.createElement($28UcW.Fragment, null, /*#__PURE__*/ $28UcW.createElement((0, $50f39ee352ba7e28$export$34b61b169492c008), {
            legendPayload: $0af3c38f38567981$var$computeLegendPayloadFromAreaData(props)
        }), /*#__PURE__*/ $28UcW.createElement($0af3c38f38567981$var$SetLineTooltipEntrySettings, {
            dataKey: props.dataKey,
            data: props.data,
            stroke: props.stroke,
            strokeWidth: props.strokeWidth,
            fill: props.fill,
            name: props.name,
            hide: props.hide,
            unit: props.unit,
            tooltipType: props.tooltipType,
            id: id
        }), /*#__PURE__*/ $28UcW.createElement((0, $cc018e6668d1f6a1$export$b600bf9c1966a9c2), {
            type: "line",
            id: id,
            data: props.data,
            xAxisId: props.xAxisId,
            yAxisId: props.yAxisId,
            zAxisId: 0,
            dataKey: props.dataKey,
            hide: props.hide,
            isPanorama: isPanorama
        }), /*#__PURE__*/ $28UcW.createElement($0af3c38f38567981$var$LineImpl, $0af3c38f38567981$var$_extends({}, props, {
            id: id
        }))));
}
var $0af3c38f38567981$export$17d680238e50603e = /*#__PURE__*/ $28UcW.memo($0af3c38f38567981$var$LineFn, (0, $b5b53d7d8a4bed40$export$b8f09df787c278d9));
$0af3c38f38567981$export$17d680238e50603e.displayName = 'Line';


var $28UcW = parcelRequire("28UcW");


function $95a694333b7fd46c$export$3d996ff386c7802d(data, strIndex) {
    if (!strIndex) return undefined;
    var numIndex = Number.parseInt(strIndex, 10);
    if ((0, $9a1343d05dde836c$export$e426a261f3212d7d)(numIndex)) return undefined;
    return data === null || data === void 0 ? void 0 : data[numIndex];
}
var $95a694333b7fd46c$var$initialState = {
    chartName: '',
    tooltipPayloadSearcher: undefined,
    eventEmitter: undefined,
    defaultTooltipEventType: 'axis'
};
var $95a694333b7fd46c$var$optionsSlice = (0, $ec80cf871915f813$export$4d8d9bd83c24ae8b)({
    name: 'options',
    initialState: $95a694333b7fd46c$var$initialState,
    reducers: {
        createEventEmitter: (state)=>{
            if (state.eventEmitter == null) state.eventEmitter = Symbol('rechartsEventEmitter');
        }
    }
});
var $95a694333b7fd46c$export$81a3ba457dd82bec = $95a694333b7fd46c$var$optionsSlice.reducer;
var { createEventEmitter: $95a694333b7fd46c$export$abfecd6a8e6070c1 } = $95a694333b7fd46c$var$optionsSlice.actions;



var $28UcW = parcelRequire("28UcW");

var $28UcW = parcelRequire("28UcW");





var $0b06aae827f336cc$export$7285b50bc333b067 = {
    chartData: undefined,
    computedData: undefined,
    dataStartIndex: 0,
    dataEndIndex: 0
};
var $0b06aae827f336cc$var$chartDataSlice = (0, $ec80cf871915f813$export$4d8d9bd83c24ae8b)({
    name: 'chartData',
    initialState: $0b06aae827f336cc$export$7285b50bc333b067,
    reducers: {
        setChartData (state, action) {
            state.chartData = action.payload;
            if (action.payload == null) {
                state.dataStartIndex = 0;
                state.dataEndIndex = 0;
                return;
            }
            if (action.payload.length > 0 && state.dataEndIndex !== action.payload.length - 1) state.dataEndIndex = action.payload.length - 1;
        },
        setComputedData (state, action) {
            state.computedData = action.payload;
        },
        setDataStartEndIndexes (state, action) {
            var { startIndex: startIndex, endIndex: endIndex } = action.payload;
            if (startIndex != null) state.dataStartIndex = startIndex;
            if (endIndex != null) state.dataEndIndex = endIndex;
        }
    }
});
var { setChartData: $0b06aae827f336cc$export$624c47d88733f253, setDataStartEndIndexes: $0b06aae827f336cc$export$427d605cc4e3bbdd, setComputedData: $0b06aae827f336cc$export$9b2e7f4962514250 } = $0b06aae827f336cc$var$chartDataSlice.actions;
var $0b06aae827f336cc$export$52973ca5fce0a5d5 = $0b06aae827f336cc$var$chartDataSlice.reducer;






























function $03913e9dbecf7541$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $03913e9dbecf7541$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $03913e9dbecf7541$var$ownKeys(Object(t), !0).forEach(function(r) {
            $03913e9dbecf7541$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $03913e9dbecf7541$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $03913e9dbecf7541$var$_defineProperty(e, r, t) {
    return (r = $03913e9dbecf7541$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $03913e9dbecf7541$var$_toPropertyKey(t) {
    var i = $03913e9dbecf7541$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $03913e9dbecf7541$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $03913e9dbecf7541$export$cfad5721ad1fe55 = (layout, tooltipTicks, activeIndex, pointer)=>{
    var entry = tooltipTicks.find((tick)=>tick && tick.index === activeIndex);
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: pointer.chartY
        };
        if (layout === 'vertical') return {
            x: pointer.chartX,
            y: entry.coordinate
        };
    }
    return {
        x: 0,
        y: 0
    };
};
var $03913e9dbecf7541$export$6bc723868198544 = (layout, tooltipTicks, activeIndex, rangeObj)=>{
    var entry = tooltipTicks.find((tick)=>tick && tick.index === activeIndex);
    if (entry) {
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var { radius: _radius } = rangeObj;
            return $03913e9dbecf7541$var$_objectSpread($03913e9dbecf7541$var$_objectSpread($03913e9dbecf7541$var$_objectSpread({}, rangeObj), (0, $d16c67d42be24ed1$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var { angle: angle } = rangeObj;
        return $03913e9dbecf7541$var$_objectSpread($03913e9dbecf7541$var$_objectSpread($03913e9dbecf7541$var$_objectSpread({}, rangeObj), (0, $d16c67d42be24ed1$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return {
        angle: 0,
        clockWise: false,
        cx: 0,
        cy: 0,
        endAngle: 0,
        innerRadius: 0,
        outerRadius: 0,
        radius: 0,
        startAngle: 0,
        x: 0,
        y: 0
    };
};
function $03913e9dbecf7541$export$215f974420919247(pointer, offset) {
    var { chartX: x, chartY: y } = pointer;
    return x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
}
var $03913e9dbecf7541$export$3071d39cc844078e = (coordinate, ticks, unsortedTicks, axisType, range)=>{
    var _ticks$length;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or fewer ticks or if there is no coordinate then the active tick is at index 0
    if (len <= 1 || coordinate == null) return 0;
    if (axisType === 'angleAxis' && range != null && Math.abs(Math.abs(range[1] - range[0]) - 360) <= 1e-6) // ticks are distributed in a circle
    for(var i = 0; i < len; i++){
        var _unsortedTicks, _unsortedTicks2, _unsortedTicks$i, _unsortedTicks$, _unsortedTicks3;
        var before = i > 0 ? (_unsortedTicks = unsortedTicks[i - 1]) === null || _unsortedTicks === void 0 ? void 0 : _unsortedTicks.coordinate : (_unsortedTicks2 = unsortedTicks[len - 1]) === null || _unsortedTicks2 === void 0 ? void 0 : _unsortedTicks2.coordinate;
        var cur = (_unsortedTicks$i = unsortedTicks[i]) === null || _unsortedTicks$i === void 0 ? void 0 : _unsortedTicks$i.coordinate;
        var after = i >= len - 1 ? (_unsortedTicks$ = unsortedTicks[0]) === null || _unsortedTicks$ === void 0 ? void 0 : _unsortedTicks$.coordinate : (_unsortedTicks3 = unsortedTicks[i + 1]) === null || _unsortedTicks3 === void 0 ? void 0 : _unsortedTicks3.coordinate;
        var sameDirectionCoord = void 0;
        if (before == null || cur == null || after == null) continue;
        if ((0, $9a1343d05dde836c$export$9d334328eb75e624)(cur - before) !== (0, $9a1343d05dde836c$export$9d334328eb75e624)(after - cur)) {
            var diffInterval = [];
            if ((0, $9a1343d05dde836c$export$9d334328eb75e624)(after - cur) === (0, $9a1343d05dde836c$export$9d334328eb75e624)(range[1] - range[0])) {
                sameDirectionCoord = after;
                var curInRange = cur + range[1] - range[0];
                diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
            } else {
                sameDirectionCoord = before;
                var afterInRange = after + range[1] - range[0];
                diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
            }
            var sameInterval = [
                Math.min(cur, (sameDirectionCoord + cur) / 2),
                Math.max(cur, (sameDirectionCoord + cur) / 2)
            ];
            if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                var _unsortedTicks$i2;
                return (_unsortedTicks$i2 = unsortedTicks[i]) === null || _unsortedTicks$i2 === void 0 ? void 0 : _unsortedTicks$i2.index;
            }
        } else {
            var minValue = Math.min(before, after);
            var maxValue = Math.max(before, after);
            if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                var _unsortedTicks$i3;
                return (_unsortedTicks$i3 = unsortedTicks[i]) === null || _unsortedTicks$i3 === void 0 ? void 0 : _unsortedTicks$i3.index;
            }
        }
    }
    else if (ticks) // ticks are distributed in a single direction
    for(var _i = 0; _i < len; _i++){
        var curr = ticks[_i];
        if (curr == null) continue;
        var next = ticks[_i + 1];
        var prev = ticks[_i - 1];
        if (_i === 0 && next != null && coordinate <= (curr.coordinate + next.coordinate) / 2) return curr.index;
        if (_i === len - 1 && prev != null && coordinate > (curr.coordinate + prev.coordinate) / 2) return curr.index;
        if (_i > 0 && _i < len - 1 && prev != null && next != null && coordinate > (curr.coordinate + prev.coordinate) / 2 && coordinate <= (curr.coordinate + next.coordinate) / 2) return curr.index;
    }
    return -1;
};



var $5ff82c06c780fa4c$export$ed30b3372172c46c = ()=>{
    return (0, $bf278eb346227770$export$a7347740d65f620b)((0, $d319e2ad1ad322d2$export$3247769c9dbde559));
};
var $5ff82c06c780fa4c$var$pickTooltipEventType = (_state, tooltipEventType)=>tooltipEventType;
var $5ff82c06c780fa4c$var$pickTrigger = (_state, _tooltipEventType, trigger)=>trigger;
var $5ff82c06c780fa4c$var$pickDefaultIndex = (_state, _tooltipEventType, _trigger, defaultIndex)=>defaultIndex;
var $5ff82c06c780fa4c$export$e133bec3c93a9247 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)((0, $36d5b5b4d0834cee$export$ffe0e60f8c88c05a), (ticks)=>(0, (/*@__PURE__*/$parcel$interopDefault($d179bd389fad45d8$exports)))(ticks, (o)=>o.coordinate));
var $5ff82c06c780fa4c$export$1288ff5c64c4ac42 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $de1984c48ab3d63c$export$703b585bc92b5bae),
    $5ff82c06c780fa4c$var$pickTooltipEventType,
    $5ff82c06c780fa4c$var$pickTrigger,
    $5ff82c06c780fa4c$var$pickDefaultIndex
], (0, $065b0b03628c3100$export$d759c39cacfacf6a));
var $5ff82c06c780fa4c$export$95fb15d7bb7a8a94 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $5ff82c06c780fa4c$export$1288ff5c64c4ac42,
    (0, $36d5b5b4d0834cee$export$5a8beccc8250d20e),
    (0, $8f21bd235d951197$export$bf8397fefbaa3617),
    (0, $36d5b5b4d0834cee$export$76f7a1975f60ccf1)
], (0, $38fc54c0e5fe33b8$export$32df4b03a0962e46));
var $5ff82c06c780fa4c$export$faa2b8b92235e5bd = (state, tooltipEventType, trigger)=>{
    if (tooltipEventType == null) return undefined;
    var tooltipState = (0, $de1984c48ab3d63c$export$703b585bc92b5bae)(state);
    if (tooltipEventType === 'axis') {
        if (trigger === 'hover') return tooltipState.axisInteraction.hover.dataKey;
        return tooltipState.axisInteraction.click.dataKey;
    }
    if (trigger === 'hover') return tooltipState.itemInteraction.hover.dataKey;
    return tooltipState.itemInteraction.click.dataKey;
};
var $5ff82c06c780fa4c$export$8ff07a725463bd5 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $de1984c48ab3d63c$export$703b585bc92b5bae),
    $5ff82c06c780fa4c$var$pickTooltipEventType,
    $5ff82c06c780fa4c$var$pickTrigger,
    $5ff82c06c780fa4c$var$pickDefaultIndex
], (0, $3bb3b59f1f1868dc$export$45044aaa79c0cddb));
var $5ff82c06c780fa4c$export$7dbe424d18defe7d = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $52905d0b62bb57b1$export$771ef0ac044f724d),
    (0, $52905d0b62bb57b1$export$5856a7d94c109505),
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    (0, $4d79bfb805950901$export$1e34c8efb0bc9b3b),
    (0, $36d5b5b4d0834cee$export$ffe0e60f8c88c05a),
    $5ff82c06c780fa4c$var$pickDefaultIndex,
    $5ff82c06c780fa4c$export$8ff07a725463bd5,
    (0, $add332f30cb660ad$export$6ae1ee94e6fa88a7)
], (0, $df1e162003e24b73$export$c2cbc37a7546bbd0));
var $5ff82c06c780fa4c$export$392a0083df9bfd7c = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $5ff82c06c780fa4c$export$1288ff5c64c4ac42,
    $5ff82c06c780fa4c$export$7dbe424d18defe7d
], (tooltipInteractionState, defaultIndexCoordinate)=>{
    var _tooltipInteractionSt;
    return (_tooltipInteractionSt = tooltipInteractionState.coordinate) !== null && _tooltipInteractionSt !== void 0 ? _tooltipInteractionSt : defaultIndexCoordinate;
});
var $5ff82c06c780fa4c$export$400c35cc3b9a0487 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $36d5b5b4d0834cee$export$ffe0e60f8c88c05a),
    $5ff82c06c780fa4c$export$95fb15d7bb7a8a94
], (0, $59977616e6d01c73$export$3213c4688ceb4c80));
var $5ff82c06c780fa4c$export$529676bfdba08611 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $5ff82c06c780fa4c$export$8ff07a725463bd5,
    $5ff82c06c780fa4c$export$95fb15d7bb7a8a94,
    (0, $d6cc9cc11e425d5b$export$519edd692222520),
    (0, $8f21bd235d951197$export$bf8397fefbaa3617),
    $5ff82c06c780fa4c$export$400c35cc3b9a0487,
    (0, $add332f30cb660ad$export$6ae1ee94e6fa88a7),
    $5ff82c06c780fa4c$var$pickTooltipEventType
], (0, $ecdb5daf6954abfe$export$e50d50655fe0e7ab));
var $5ff82c06c780fa4c$export$c8884ed37796034a = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $5ff82c06c780fa4c$export$1288ff5c64c4ac42,
    $5ff82c06c780fa4c$export$95fb15d7bb7a8a94
], (tooltipInteractionState, activeIndex)=>{
    return {
        isActive: tooltipInteractionState.active && activeIndex != null,
        activeIndex: activeIndex
    };
});
var $5ff82c06c780fa4c$var$combineActiveCartesianProps = (chartEvent, layout, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks, offset)=>{
    if (!chartEvent || !tooltipAxisType || !tooltipAxisRange || !tooltipTicks) return undefined;
    if (!(0, $03913e9dbecf7541$export$215f974420919247)(chartEvent, offset)) return undefined;
    var pos = (0, $912d8cf1d03ea507$export$f29fac779ccd75bc)(chartEvent, layout);
    var activeIndex = (0, $03913e9dbecf7541$export$3071d39cc844078e)(pos, orderedTooltipTicks, tooltipTicks, tooltipAxisType, tooltipAxisRange);
    var activeCoordinate = (0, $03913e9dbecf7541$export$cfad5721ad1fe55)(layout, tooltipTicks, activeIndex, chartEvent);
    return {
        activeIndex: String(activeIndex),
        activeCoordinate: activeCoordinate
    };
};
var $5ff82c06c780fa4c$var$combineActivePolarProps = (chartEvent, layout, polarViewBox, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks)=>{
    if (!chartEvent || !tooltipAxisType || !tooltipAxisRange || !tooltipTicks || !polarViewBox) return undefined;
    var rangeObj = (0, $d16c67d42be24ed1$export$e85a2bf8cd31c504)(chartEvent, polarViewBox);
    if (!rangeObj) return undefined;
    var pos = (0, $912d8cf1d03ea507$export$fb2b0f76aa25d837)(rangeObj, layout);
    var activeIndex = (0, $03913e9dbecf7541$export$3071d39cc844078e)(pos, orderedTooltipTicks, tooltipTicks, tooltipAxisType, tooltipAxisRange);
    var activeCoordinate = (0, $03913e9dbecf7541$export$6bc723868198544)(layout, tooltipTicks, activeIndex, rangeObj);
    return {
        activeIndex: String(activeIndex),
        activeCoordinate: activeCoordinate
    };
};
var $5ff82c06c780fa4c$export$e1c9f959fffb37b4 = (chartEvent, layout, polarViewBox, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks, offset)=>{
    if (!chartEvent || !layout || !tooltipAxisType || !tooltipAxisRange || !tooltipTicks) return undefined;
    if (layout === 'horizontal' || layout === 'vertical') return $5ff82c06c780fa4c$var$combineActiveCartesianProps(chartEvent, layout, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks, offset);
    return $5ff82c06c780fa4c$var$combineActivePolarProps(chartEvent, layout, polarViewBox, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks);
};




var $4a0344bb264a5784$var$pickChartPointer = (_state, chartPointer)=>chartPointer;
var $4a0344bb264a5784$export$2cfb761a54690867 = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $4a0344bb264a5784$var$pickChartPointer,
    (0, $6ade474fe9f2b6e0$export$8426b6d9af801dee),
    (0, $fe99398211301319$export$57f4101c1e20bd95),
    (0, $411fa86e80c20dfb$export$898d3dfd98fb482),
    (0, $36d5b5b4d0834cee$export$cf4d6dfce3a76af3),
    (0, $36d5b5b4d0834cee$export$ffe0e60f8c88c05a),
    (0, $5ff82c06c780fa4c$export$e133bec3c93a9247),
    (0, $4d79bfb805950901$export$1e34c8efb0bc9b3b)
], (0, $5ff82c06c780fa4c$export$e1c9f959fffb37b4));



/**
 * Computes the chart coordinates from the mouse event.
 *
 * The coordinates are relative to the top-left corner of the chart,
 * where the top-left corner of the chart is (0, 0).
 * Moving right, the x-coordinate increases, and moving down, the y-coordinate increases.
 *
 * The coordinates are rounded to the nearest integer and are including a CSS transform scale.
 * So a chart that's scaled will return the same coordinates as a chart that's not scaled.
 *
 * @param event The mouse event from React event handlers
 * @return chartPointer The chart coordinates relative to the top-left corner of the chart
 */ var $22977cc0c145c796$export$96f447b11b1279d1 = (event)=>{
    var rect = event.currentTarget.getBoundingClientRect();
    var scaleX = rect.width / event.currentTarget.offsetWidth;
    var scaleY = rect.height / event.currentTarget.offsetHeight;
    return {
        /*
     * Here it's important to use:
     * - event.clientX and event.clientY to get the mouse position relative to the viewport, including scroll.
     * - pageX and pageY are not used because they are relative to the whole document, and ignore scroll.
     * - rect.left and rect.top are used to get the position of the chart relative to the viewport.
     * - offsetX and offsetY are not used because they are relative to the offset parent
     *  which may or may not be the same as the clientX and clientY, depending on the position of the chart in the DOM
     *  and surrounding element styles. CSS position: relative, absolute, fixed, will change the offset parent.
     * - scaleX and scaleY are necessary for when the chart element is scaled using CSS `transform: scale(N)`.
     */ chartX: Math.round((event.clientX - rect.left) / scaleX),
        chartY: Math.round((event.clientY - rect.top) / scaleY)
    };
};


var $235ad3f30eff74ff$export$f06e14b484aecafc = (0, $ec80cf871915f813$export$309c7a02b0b0bc62)('mouseClick');
var $235ad3f30eff74ff$export$fb3df626ae9864a = (0, $ec80cf871915f813$export$1228acebbbcb485b)();
// TODO: there's a bug here when you click the chart the activeIndex resets to zero
$235ad3f30eff74ff$export$fb3df626ae9864a.startListening({
    actionCreator: $235ad3f30eff74ff$export$f06e14b484aecafc,
    effect: (action, listenerApi)=>{
        var mousePointer = action.payload;
        var activeProps = (0, $4a0344bb264a5784$export$2cfb761a54690867)(listenerApi.getState(), (0, $22977cc0c145c796$export$96f447b11b1279d1)(mousePointer));
        if ((activeProps === null || activeProps === void 0 ? void 0 : activeProps.activeIndex) != null) listenerApi.dispatch((0, $038eefd840ad861c$export$d2b1af5c3a560528)({
            activeIndex: activeProps.activeIndex,
            activeDataKey: undefined,
            activeCoordinate: activeProps.activeCoordinate
        }));
    }
});
var $235ad3f30eff74ff$export$f9de213dbfb2e32c = (0, $ec80cf871915f813$export$309c7a02b0b0bc62)('mouseMove');
var $235ad3f30eff74ff$export$b7e1b38eb227944a = (0, $ec80cf871915f813$export$1228acebbbcb485b)();
/*
 * This single rafId is safe because:
 * 1. Each chart has its own Redux store instance with its own middleware
 * 2. mouseMoveAction only fires from one DOM element (the chart wrapper)
 * 3. Rapid mousemove events from the same element SHOULD debounce - we only care about the latest position
 * This is different from externalEventsMiddleware which handles multiple event types
 * (click, mouseenter, mouseleave, etc.) that should NOT cancel each other.
 */ var $235ad3f30eff74ff$var$rafId = null;
$235ad3f30eff74ff$export$b7e1b38eb227944a.startListening({
    actionCreator: $235ad3f30eff74ff$export$f9de213dbfb2e32c,
    effect: (action, listenerApi)=>{
        var mousePointer = action.payload;
        // Cancel any pending animation frame
        if ($235ad3f30eff74ff$var$rafId !== null) cancelAnimationFrame($235ad3f30eff74ff$var$rafId);
        var chartPointer = (0, $22977cc0c145c796$export$96f447b11b1279d1)(mousePointer);
        // Schedule the dispatch for the next animation frame
        $235ad3f30eff74ff$var$rafId = requestAnimationFrame(()=>{
            var state = listenerApi.getState();
            var tooltipEventType = (0, $aab1adcf9dbc37ce$export$53af65c2db668fac)(state, state.tooltip.settings.shared);
            // this functionality only applies to charts that have axes
            if (tooltipEventType === 'axis') {
                var activeProps = (0, $4a0344bb264a5784$export$2cfb761a54690867)(state, chartPointer);
                if ((activeProps === null || activeProps === void 0 ? void 0 : activeProps.activeIndex) != null) listenerApi.dispatch((0, $038eefd840ad861c$export$a7277636863fc703)({
                    activeIndex: activeProps.activeIndex,
                    activeDataKey: undefined,
                    activeCoordinate: activeProps.activeCoordinate
                }));
                else // this is needed to clear tooltip state when the mouse moves out of the inRange (svg - offset) function, but not yet out of the svg
                listenerApi.dispatch((0, $038eefd840ad861c$export$73879bed3f2eef71)());
            }
            $235ad3f30eff74ff$var$rafId = null;
        });
    }
});


function $eb846b4b124cfc3e$export$b5f053baf756345f(key, value) {
    if (value instanceof HTMLElement) return "HTMLElement <".concat(value.tagName, " class=\"").concat(value.className, "\">");
    if (value === window) return 'global.window';
    if (key === 'children' && typeof value === 'object' && value !== null) return '<<CHILDREN>>';
    return value;
}






var $3ceb8fe6b324345d$var$initialState = {
    dots: [],
    areas: [],
    lines: []
};
var $3ceb8fe6b324345d$export$cbde679baaad2c79 = (0, $ec80cf871915f813$export$4d8d9bd83c24ae8b)({
    name: 'referenceElements',
    initialState: $3ceb8fe6b324345d$var$initialState,
    reducers: {
        addDot: (state, action)=>{
            state.dots.push(action.payload);
        },
        removeDot: (state, action)=>{
            var index = (0, $75bf48a0e2bf731d$export$97aac956da55dae9)(state).dots.findIndex((dot)=>dot === action.payload);
            if (index !== -1) state.dots.splice(index, 1);
        },
        addArea: (state, action)=>{
            state.areas.push(action.payload);
        },
        removeArea: (state, action)=>{
            var index = (0, $75bf48a0e2bf731d$export$97aac956da55dae9)(state).areas.findIndex((area)=>area === action.payload);
            if (index !== -1) state.areas.splice(index, 1);
        },
        addLine: (state, action)=>{
            state.lines.push((0, $46230e101f7bd5ae$export$c05b21e3257751e5)(action.payload));
        },
        removeLine: (state, action)=>{
            var index = (0, $75bf48a0e2bf731d$export$97aac956da55dae9)(state).lines.findIndex((line)=>line === action.payload);
            if (index !== -1) state.lines.splice(index, 1);
        }
    }
});
var { addDot: $3ceb8fe6b324345d$export$9be8ef3add1f8c1e, removeDot: $3ceb8fe6b324345d$export$57ff7495ce685163, addArea: $3ceb8fe6b324345d$export$d604a18565cfc1b3, removeArea: $3ceb8fe6b324345d$export$a8da2ad4123475fe, addLine: $3ceb8fe6b324345d$export$a9ce8e8146745e3e, removeLine: $3ceb8fe6b324345d$export$fd7919a5491769ec } = $3ceb8fe6b324345d$export$cbde679baaad2c79.actions;
var $3ceb8fe6b324345d$export$f30a87c263d1acf8 = $3ceb8fe6b324345d$export$cbde679baaad2c79.reducer;



/**
 * From all Brush properties, only height has a default value and will always be defined.
 * Other properties are nullable and will be computed from offsets and margins if they are not set.
 */ var $d234b24ec8309ed6$var$initialState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
};
var $d234b24ec8309ed6$export$d64e835ef4b0c23a = (0, $ec80cf871915f813$export$4d8d9bd83c24ae8b)({
    name: 'brush',
    initialState: $d234b24ec8309ed6$var$initialState,
    reducers: {
        setBrushSettings (_state, action) {
            if (action.payload == null) return $d234b24ec8309ed6$var$initialState;
            return action.payload;
        }
    }
});
var { setBrushSettings: $d234b24ec8309ed6$export$1860ec7d971c6a5b } = $d234b24ec8309ed6$export$d64e835ef4b0c23a.actions;
var $d234b24ec8309ed6$export$b8c9ca32ee9dbf92 = $d234b24ec8309ed6$export$d64e835ef4b0c23a.reducer;




var $d8bc15fccc044751$export$d4c72bab9d6cc13a = {
    accessibilityLayer: true,
    barCategoryGap: '10%',
    barGap: 4,
    barSize: undefined,
    className: undefined,
    maxBarSize: undefined,
    stackOffset: 'none',
    syncId: undefined,
    syncMethod: 'index',
    baseValue: undefined,
    reverseStackOrder: false
};
var $d8bc15fccc044751$var$rootPropsSlice = (0, $ec80cf871915f813$export$4d8d9bd83c24ae8b)({
    name: 'rootProps',
    initialState: $d8bc15fccc044751$export$d4c72bab9d6cc13a,
    reducers: {
        updateOptions: (state, action)=>{
            var _action$payload$barGa;
            state.accessibilityLayer = action.payload.accessibilityLayer;
            state.barCategoryGap = action.payload.barCategoryGap;
            state.barGap = (_action$payload$barGa = action.payload.barGap) !== null && _action$payload$barGa !== void 0 ? _action$payload$barGa : $d8bc15fccc044751$export$d4c72bab9d6cc13a.barGap;
            state.barSize = action.payload.barSize;
            state.maxBarSize = action.payload.maxBarSize;
            state.stackOffset = action.payload.stackOffset;
            state.syncId = action.payload.syncId;
            state.syncMethod = action.payload.syncMethod;
            state.className = action.payload.className;
            state.baseValue = action.payload.baseValue;
            state.reverseStackOrder = action.payload.reverseStackOrder;
        }
    }
});
var $d8bc15fccc044751$export$291d6468e221147e = $d8bc15fccc044751$var$rootPropsSlice.reducer;
var { updateOptions: $d8bc15fccc044751$export$c6fe4049d20353ac } = $d8bc15fccc044751$var$rootPropsSlice.actions;




var $f70dfe64af993df0$var$initialState = {
    radiusAxis: {},
    angleAxis: {}
};
var $f70dfe64af993df0$var$polarAxisSlice = (0, $ec80cf871915f813$export$4d8d9bd83c24ae8b)({
    name: 'polarAxis',
    initialState: $f70dfe64af993df0$var$initialState,
    reducers: {
        addRadiusAxis (state, action) {
            state.radiusAxis[action.payload.id] = (0, $46230e101f7bd5ae$export$c05b21e3257751e5)(action.payload);
        },
        removeRadiusAxis (state, action) {
            delete state.radiusAxis[action.payload.id];
        },
        addAngleAxis (state, action) {
            state.angleAxis[action.payload.id] = (0, $46230e101f7bd5ae$export$c05b21e3257751e5)(action.payload);
        },
        removeAngleAxis (state, action) {
            delete state.angleAxis[action.payload.id];
        }
    }
});
var { addRadiusAxis: $f70dfe64af993df0$export$3555d359361c9fe3, removeRadiusAxis: $f70dfe64af993df0$export$104b2ce9f0baf86f, addAngleAxis: $f70dfe64af993df0$export$bf871b0db8674238, removeAngleAxis: $f70dfe64af993df0$export$d540ed209cfbb147 } = $f70dfe64af993df0$var$polarAxisSlice.actions;
var $f70dfe64af993df0$export$97e65520f1278b5 = $f70dfe64af993df0$var$polarAxisSlice.reducer;



var $050e98b6e25106d6$var$polarOptionsSlice = (0, $ec80cf871915f813$export$4d8d9bd83c24ae8b)({
    name: 'polarOptions',
    initialState: null,
    reducers: {
        updatePolarOptions: (_state, action)=>{
            return action.payload;
        }
    }
});
var { updatePolarOptions: $050e98b6e25106d6$export$5dfe4dcb848af93f } = $050e98b6e25106d6$var$polarOptionsSlice.actions;
var $050e98b6e25106d6$export$8d4054f1936f7f4d = $050e98b6e25106d6$var$polarOptionsSlice.reducer;








var $ace6e797b6848f5b$export$4839538efb7414c = (0, $ec80cf871915f813$export$309c7a02b0b0bc62)('keyDown');
var $ace6e797b6848f5b$export$d95192eee5865567 = (0, $ec80cf871915f813$export$309c7a02b0b0bc62)('focus');
var $ace6e797b6848f5b$export$b4d762ee62ea3f99 = (0, $ec80cf871915f813$export$1228acebbbcb485b)();
$ace6e797b6848f5b$export$b4d762ee62ea3f99.startListening({
    actionCreator: $ace6e797b6848f5b$export$4839538efb7414c,
    effect: (action, listenerApi)=>{
        var state = listenerApi.getState();
        var accessibilityLayerIsActive = state.rootProps.accessibilityLayer !== false;
        if (!accessibilityLayerIsActive) return;
        var { keyboardInteraction: keyboardInteraction } = state.tooltip;
        var key = action.payload;
        if (key !== 'ArrowRight' && key !== 'ArrowLeft' && key !== 'Enter') return;
        // TODO this is lacking index for charts that do not support numeric indexes
        var resolvedIndex = (0, $38fc54c0e5fe33b8$export$32df4b03a0962e46)(keyboardInteraction, (0, $36d5b5b4d0834cee$export$5a8beccc8250d20e)(state), (0, $8f21bd235d951197$export$bf8397fefbaa3617)(state), (0, $36d5b5b4d0834cee$export$76f7a1975f60ccf1)(state));
        var currentIndex = resolvedIndex == null ? -1 : Number(resolvedIndex);
        if (!Number.isFinite(currentIndex) || currentIndex < 0) return;
        var tooltipTicks = (0, $36d5b5b4d0834cee$export$ffe0e60f8c88c05a)(state);
        if (key === 'Enter') {
            var _coordinate = (0, $5ff82c06c780fa4c$export$7dbe424d18defe7d)(state, 'axis', 'hover', String(keyboardInteraction.index));
            listenerApi.dispatch((0, $038eefd840ad861c$export$820c94985c9eba3f)({
                active: !keyboardInteraction.active,
                activeIndex: keyboardInteraction.index,
                activeCoordinate: _coordinate
            }));
            return;
        }
        var direction = (0, $8f21bd235d951197$export$430d623a94added7)(state);
        var directionMultiplier = direction === 'left-to-right' ? 1 : -1;
        var movement = key === 'ArrowRight' ? 1 : -1;
        var nextIndex = currentIndex + movement * directionMultiplier;
        if (tooltipTicks == null || nextIndex >= tooltipTicks.length || nextIndex < 0) return;
        var coordinate = (0, $5ff82c06c780fa4c$export$7dbe424d18defe7d)(state, 'axis', 'hover', String(nextIndex));
        listenerApi.dispatch((0, $038eefd840ad861c$export$820c94985c9eba3f)({
            active: true,
            activeIndex: nextIndex.toString(),
            activeCoordinate: coordinate
        }));
    }
});
$ace6e797b6848f5b$export$b4d762ee62ea3f99.startListening({
    actionCreator: $ace6e797b6848f5b$export$d95192eee5865567,
    effect: (_action, listenerApi)=>{
        var state = listenerApi.getState();
        var accessibilityLayerIsActive = state.rootProps.accessibilityLayer !== false;
        if (!accessibilityLayerIsActive) return;
        var { keyboardInteraction: keyboardInteraction } = state.tooltip;
        if (keyboardInteraction.active) return;
        if (keyboardInteraction.index == null) {
            var nextIndex = '0';
            var coordinate = (0, $5ff82c06c780fa4c$export$7dbe424d18defe7d)(state, 'axis', 'hover', String(nextIndex));
            listenerApi.dispatch((0, $038eefd840ad861c$export$820c94985c9eba3f)({
                active: true,
                activeIndex: nextIndex,
                activeCoordinate: coordinate
            }));
        }
    }
});




var $ad93c74adacdabbb$export$1d0268b9f89859f0 = (0, $ec80cf871915f813$export$309c7a02b0b0bc62)('externalEvent');
var $ad93c74adacdabbb$export$3c5d447f046d0ec3 = (0, $ec80cf871915f813$export$1228acebbbcb485b)();
/*
 * We need a Map keyed by event type because this middleware handles MULTIPLE different event types
 * (click, mouseenter, mouseleave, mousedown, mouseup, contextmenu, dblclick, touchstart, touchmove, touchend)
 * from the same DOM element. Different event types should NOT cancel each other's animation frames.
 * For example, a click event and a mousemove event can happen in quick succession and both should be processed.
 * This is different from mouseMoveMiddleware which only handles one event type and uses a single rafId.
 */ var $ad93c74adacdabbb$var$rafIdMap = new Map();
$ad93c74adacdabbb$export$3c5d447f046d0ec3.startListening({
    actionCreator: $ad93c74adacdabbb$export$1d0268b9f89859f0,
    effect: (action, listenerApi)=>{
        var { handler: handler, reactEvent: reactEvent } = action.payload;
        if (handler == null) return;
        reactEvent.persist();
        var eventType = reactEvent.type;
        // Cancel any pending animation frame for this event type
        var existingRafId = $ad93c74adacdabbb$var$rafIdMap.get(eventType);
        if (existingRafId !== undefined) cancelAnimationFrame(existingRafId);
        var rafId = requestAnimationFrame(()=>{
            try {
                /*
         * Here it is important that we get the latest state inside the animation frame callback,
         * not from the outer scope, because there may have been other actions dispatched
         * between the time the event was fired and the animation frame callback is executed.
         * One of those actions is the one that actually sets the active tooltip state!
         */ var state = listenerApi.getState();
                var nextState = {
                    activeCoordinate: (0, $36d5b5b4d0834cee$export$90c565a5b196e427)(state),
                    activeDataKey: (0, $36d5b5b4d0834cee$export$999f7a7ced063fab)(state),
                    activeIndex: (0, $36d5b5b4d0834cee$export$8b2762260f5891c9)(state),
                    activeLabel: (0, $36d5b5b4d0834cee$export$400c35cc3b9a0487)(state),
                    activeTooltipIndex: (0, $36d5b5b4d0834cee$export$8b2762260f5891c9)(state),
                    isTooltipActive: (0, $36d5b5b4d0834cee$export$c8884ed37796034a)(state)
                };
                handler(nextState, reactEvent);
            } finally{
                $ad93c74adacdabbb$var$rafIdMap.delete(eventType);
            }
        });
        $ad93c74adacdabbb$var$rafIdMap.set(eventType, rafId);
    }
});











var $154e4d42c8b585f4$var$selectAllTooltipPayloadConfiguration = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    (0, $de1984c48ab3d63c$export$703b585bc92b5bae)
], (tooltipState)=>tooltipState.tooltipItemPayloads);
var $154e4d42c8b585f4$export$4e32c9da1f3ea7ce = (0, $c728c8fbce4ac913$export$595d22ed68ca2841)([
    $154e4d42c8b585f4$var$selectAllTooltipPayloadConfiguration,
    (0, $add332f30cb660ad$export$6ae1ee94e6fa88a7),
    (_state, tooltipIndex)=>tooltipIndex,
    (_state, _tooltipIndex, graphicalItemId)=>graphicalItemId
], (allTooltipConfigurations, tooltipPayloadSearcher, tooltipIndex, graphicalItemId)=>{
    var mostRelevantTooltipConfiguration = allTooltipConfigurations.find((tooltipConfiguration)=>{
        return tooltipConfiguration.settings.graphicalItemId === graphicalItemId;
    });
    if (mostRelevantTooltipConfiguration == null) return undefined;
    var { positions: positions } = mostRelevantTooltipConfiguration;
    if (positions == null) return undefined;
    // @ts-expect-error tooltipPayloadSearcher is not typed well
    var maybePosition = tooltipPayloadSearcher(positions, tooltipIndex);
    return maybePosition;
});



var $929ff66c9946de2e$export$ba46b5fda0e2985f = (0, $ec80cf871915f813$export$309c7a02b0b0bc62)('touchMove');
var $929ff66c9946de2e$export$923ceddc5a79736a = (0, $ec80cf871915f813$export$1228acebbbcb485b)();
$929ff66c9946de2e$export$923ceddc5a79736a.startListening({
    actionCreator: $929ff66c9946de2e$export$ba46b5fda0e2985f,
    effect: (action, listenerApi)=>{
        var touchEvent = action.payload;
        if (touchEvent.touches == null || touchEvent.touches.length === 0) return;
        var state = listenerApi.getState();
        var tooltipEventType = (0, $aab1adcf9dbc37ce$export$53af65c2db668fac)(state, state.tooltip.settings.shared);
        if (tooltipEventType === 'axis') {
            var touch = touchEvent.touches[0];
            if (touch == null) return;
            var activeProps = (0, $4a0344bb264a5784$export$2cfb761a54690867)(state, (0, $22977cc0c145c796$export$96f447b11b1279d1)({
                clientX: touch.clientX,
                clientY: touch.clientY,
                currentTarget: touchEvent.currentTarget
            }));
            if ((activeProps === null || activeProps === void 0 ? void 0 : activeProps.activeIndex) != null) listenerApi.dispatch((0, $038eefd840ad861c$export$a7277636863fc703)({
                activeIndex: activeProps.activeIndex,
                activeDataKey: undefined,
                activeCoordinate: activeProps.activeCoordinate
            }));
        } else if (tooltipEventType === 'item') {
            var _target$getAttribute;
            var _touch = touchEvent.touches[0];
            if (document.elementFromPoint == null || _touch == null) return;
            var target = document.elementFromPoint(_touch.clientX, _touch.clientY);
            if (!target || !target.getAttribute) return;
            var itemIndex = target.getAttribute((0, $3114cbf50b21aaf4$export$c0f3d78d63b3e065));
            var graphicalItemId = (_target$getAttribute = target.getAttribute((0, $3114cbf50b21aaf4$export$5c80c48c1d137460))) !== null && _target$getAttribute !== void 0 ? _target$getAttribute : undefined;
            var settings = (0, $36d5b5b4d0834cee$export$645965005f643e6f)(state).find((item)=>item.id === graphicalItemId);
            if (itemIndex == null || settings == null || graphicalItemId == null) return;
            var { dataKey: dataKey } = settings;
            var coordinate = (0, $154e4d42c8b585f4$export$4e32c9da1f3ea7ce)(state, itemIndex, graphicalItemId);
            listenerApi.dispatch((0, $038eefd840ad861c$export$c78abbb2450f6b44)({
                activeDataKey: dataKey,
                activeIndex: itemIndex,
                activeCoordinate: coordinate,
                activeGraphicalItemId: graphicalItemId
            }));
        }
    }
});





var $10055dc62a492d65$var$rootReducer = (0, $da655fa243288d8a$export$66e4520cdb265d18)({
    brush: (0, $d234b24ec8309ed6$export$b8c9ca32ee9dbf92),
    cartesianAxis: (0, $1426ac70c5e0f1c4$export$c8ae79f5f6ae07c6),
    chartData: (0, $0b06aae827f336cc$export$52973ca5fce0a5d5),
    errorBars: (0, $ae7e4deeef0773e1$export$6dda85fa3c67ca19),
    graphicalItems: (0, $9f25864d38d26021$export$183eecd5cb7dbb38),
    layout: (0, $b2c2d9052192be80$export$701395c4acfabc85),
    legend: (0, $64fc3eecfa5a3e7d$export$8d8dfb8d5acf8179),
    options: (0, $95a694333b7fd46c$export$81a3ba457dd82bec),
    polarAxis: (0, $f70dfe64af993df0$export$97e65520f1278b5),
    polarOptions: (0, $050e98b6e25106d6$export$8d4054f1936f7f4d),
    referenceElements: (0, $3ceb8fe6b324345d$export$f30a87c263d1acf8),
    rootProps: (0, $d8bc15fccc044751$export$291d6468e221147e),
    tooltip: (0, $038eefd840ad861c$export$cadd4678b967dba6),
    zIndex: (0, $f0a32278ca24a846$export$a34096cdea3a022a)
});
var $10055dc62a492d65$export$a4383593d58e8efa = function createRechartsStore(preloadedState) {
    var chartName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Chart';
    return (0, $ec80cf871915f813$export$7d8a5b498da695ac)({
        reducer: $10055dc62a492d65$var$rootReducer,
        // redux-toolkit v1 types are unhappy with the preloadedState type. Remove the `as any` when bumping to v2
        preloadedState: preloadedState,
        // @ts-expect-error redux-toolkit v1 types are unhappy with the middleware array. Remove this comment when bumping to v2
        middleware: (getDefaultMiddleware)=>{
            var _process$env$NODE_ENV;
            return getDefaultMiddleware({
                serializableCheck: false,
                immutableCheck: ![
                    'commonjs',
                    'es6',
                    'production'
                ].includes((_process$env$NODE_ENV = "es6", _process$env$NODE_ENV !== void 0) ? _process$env$NODE_ENV : '')
            }).concat([
                (0, $235ad3f30eff74ff$export$fb3df626ae9864a).middleware,
                (0, $235ad3f30eff74ff$export$b7e1b38eb227944a).middleware,
                (0, $ace6e797b6848f5b$export$b4d762ee62ea3f99).middleware,
                (0, $ad93c74adacdabbb$export$3c5d447f046d0ec3).middleware,
                (0, $929ff66c9946de2e$export$923ceddc5a79736a).middleware
            ]);
        },
        /*
     * I can't find out how to satisfy typescript here.
     * We return `EnhancerArray<[StoreEnhancer<{}, {}>, StoreEnhancer]>` from this function,
     * but the types say we should return `EnhancerArray<StoreEnhancer<{}, {}>`.
     * Looks like it's badly inferred generics, but it won't allow me to provide the correct type manually either.
     * So let's just ignore the error for now.
     */ // @ts-expect-error mismatched generics
        enhancers: (getDefaultEnhancers)=>{
            var enhancers = getDefaultEnhancers;
            if (typeof getDefaultEnhancers === 'function') /*
         * In RTK v2 this is always a function, but in v1 it is an array.
         * Because we have @types/redux-toolkit v1 as a dependency, typescript is going to flag this as an error.
         * We support both RTK v1 and v2, so we need to do this check.
         * https://redux-toolkit.js.org/usage/migrating-rtk-2#configurestoreenhancers-must-be-a-callback
         */ // @ts-expect-error RTK v2 behaviour on RTK v1 types
            enhancers = getDefaultEnhancers();
            return enhancers.concat((0, $ec80cf871915f813$export$676277d7dca0f396)({
                type: 'raf'
            }));
        },
        devTools: (0, $c8dcb2cb9e97048b$export$98f03c5d19621d70).devToolsEnabled && {
            serialize: {
                replacer: (0, $eb846b4b124cfc3e$export$b5f053baf756345f)
            },
            name: "recharts-".concat(chartName)
        }
    });
};




function $cc45ff7da2ab8dc7$export$debe87639f2707f9(_ref) {
    var { preloadedState: preloadedState, children: children, reduxStoreName: reduxStoreName } = _ref;
    var isPanorama = (0, $d64615d5c7c4e07c$export$4b0c59f8845ba920)();
    /*
   * Why the ref? Redux official documentation recommends to use store as a singleton,
   * and reuse that everywhere: https://redux-toolkit.js.org/api/configureStore#basic-example
   *
   * Which is correct! Except that is considering deploying Redux in an app.
   * Recharts as a library supports multiple charts on the same page.
   * And each of these charts needs its own store independent of others!
   *
   * The alternative is to have everything in the store keyed by the chart id.
   * Which would make working with everything a little bit more painful because we need the chart id everywhere.
   */ var storeRef = (0, $28UcW.useRef)(null);
    /*
   * Panorama means that this chart is not its own chart, it's only a "preview"
   * being rendered as a child of Brush.
   * In such case, it should not have a store on its own - it should implicitly inherit
   * whatever data is in the "parent" or "root" chart.
   * Which here is represented by not having a Provider at all. All selectors will use the root store by default.
   */ if (isPanorama) return children;
    if (storeRef.current == null) storeRef.current = (0, $10055dc62a492d65$export$a4383593d58e8efa)(preloadedState, reduxStoreName);
    // @ts-expect-error React-Redux types demand that the context internal value is not null, but we have that as default.
    var nonNullContext = (0, $ce316d304b16d2f9$export$876ef70bc88b13cb);
    return /*#__PURE__*/ $28UcW.createElement((0, $fd3445816ed466ed$export$2881499e37b75b9a), {
        context: nonNullContext,
        store: storeRef.current
    }, children);
}



var $28UcW = parcelRequire("28UcW");



var $9cc15f91b24b888a$export$2100a1dedbca0238 = (props)=>{
    var { chartData: chartData } = props;
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    var isPanorama = (0, $d64615d5c7c4e07c$export$4b0c59f8845ba920)();
    (0, $28UcW.useEffect)(()=>{
        if (isPanorama) // Panorama mode reuses data from the main chart, so we must not overwrite it here.
        return ()=>{
        // there is nothing to clean up
        };
        dispatch((0, $0b06aae827f336cc$export$624c47d88733f253)(chartData));
        return ()=>{
            dispatch((0, $0b06aae827f336cc$export$624c47d88733f253)(undefined));
        };
    }, [
        chartData,
        dispatch,
        isPanorama
    ]);
    return null;
};
var $9cc15f91b24b888a$export$91a155b0e28498ba = (props)=>{
    var { computedData: computedData } = props;
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    (0, $28UcW.useEffect)(()=>{
        dispatch((0, $0b06aae827f336cc$export$9b2e7f4962514250)(computedData));
        return ()=>{
            dispatch((0, $0b06aae827f336cc$export$624c47d88733f253)(undefined));
        };
    }, [
        computedData,
        dispatch
    ]);
    return null;
};
var $9cc15f91b24b888a$var$selectChartData = (state)=>state.chartData.chartData;
var $9cc15f91b24b888a$export$551a2a6f7431b8ad = ()=>(0, $bf278eb346227770$export$a7347740d65f620b)($9cc15f91b24b888a$var$selectChartData);
var $9cc15f91b24b888a$var$selectDataIndex = (state)=>{
    var { dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = state.chartData;
    return {
        startIndex: dataStartIndex,
        endIndex: dataEndIndex
    };
};
var $9cc15f91b24b888a$export$824568c74ea1faec = ()=>{
    return (0, $bf278eb346227770$export$a7347740d65f620b)($9cc15f91b24b888a$var$selectDataIndex);
};



var $28UcW = parcelRequire("28UcW");




/**
 * "Main" props are props that are only accepted on the main chart,
 * as opposed to the small panorama chart inside a Brush.
 */ function $b8b3a215b6586190$var$ReportMainChartPropsImpl(_ref) {
    var { layout: layout, margin: margin } = _ref;
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    /*
   * Skip dispatching properties in panorama chart for two reasons:
   * 1. The root chart should be deciding on these properties, and
   * 2. Brush reads these properties from redux store, and so they must remain stable
   *      to avoid circular dependency and infinite re-rendering.
   */ var isPanorama = (0, $d64615d5c7c4e07c$export$4b0c59f8845ba920)();
    /*
   * useEffect here is required to avoid the "Cannot update a component while rendering a different component" error.
   * https://github.com/facebook/react/issues/18178
   *
   * Reported in https://github.com/recharts/recharts/issues/5514
   */ (0, $28UcW.useEffect)(()=>{
        if (!isPanorama) {
            dispatch((0, $b2c2d9052192be80$export$e8437af1f2483b8e)(layout));
            dispatch((0, $b2c2d9052192be80$export$3f8f25b83912855f)(margin));
        }
    }, [
        dispatch,
        isPanorama,
        layout,
        margin
    ]);
    return null;
}
var $b8b3a215b6586190$export$6faeaad6e02c2e9d = /*#__PURE__*/ (0, $28UcW.memo)($b8b3a215b6586190$var$ReportMainChartPropsImpl, (0, $b5b53d7d8a4bed40$export$b8f09df787c278d9));



var $28UcW = parcelRequire("28UcW");


function $71abb7370041d836$export$6fabfb9ba230d12b(props) {
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    (0, $28UcW.useEffect)(()=>{
        dispatch((0, $d8bc15fccc044751$export$c6fe4049d20353ac)(props));
    }, [
        dispatch,
        props
    ]);
    return null;
}



var $28UcW = parcelRequire("28UcW");

var $28UcW = parcelRequire("28UcW");


var $7753843e36efc467$export$276788f18f24cad3 = ()=>{
    var _useAppSelector;
    return (_useAppSelector = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>state.rootProps.accessibilityLayer)) !== null && _useAppSelector !== void 0 ? _useAppSelector : true;
};








var $28UcW = parcelRequire("28UcW");



function $2f18311028c18b72$var$ZIndexSvgPortal(_ref) {
    var { zIndex: zIndex, isPanorama: isPanorama } = _ref;
    var ref = (0, $28UcW.useRef)(null);
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    (0, $28UcW.useLayoutEffect)(()=>{
        if (ref.current) dispatch((0, $f0a32278ca24a846$export$2e6026208075bd4f)({
            zIndex: zIndex,
            element: ref.current,
            isPanorama: isPanorama
        }));
        return ()=>{
            dispatch((0, $f0a32278ca24a846$export$b735943939e8125)({
                zIndex: zIndex,
                isPanorama: isPanorama
            }));
        };
    }, [
        dispatch,
        zIndex,
        isPanorama
    ]);
    // these g elements should not be tabbable
    return /*#__PURE__*/ $28UcW.createElement("g", {
        tabIndex: -1,
        ref: ref
    });
}
function $2f18311028c18b72$export$7a76624f8e4da531(_ref2) {
    var { children: children, isPanorama: isPanorama } = _ref2;
    var allRegisteredZIndexes = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $b8d26b5f9fa0ad58$export$7967bffce127e19c));
    if (!allRegisteredZIndexes || allRegisteredZIndexes.length === 0) return children;
    var allNegativeZIndexes = allRegisteredZIndexes.filter((zIndex)=>zIndex < 0);
    // We exclude zero on purpose - that is the default layer, and it doesn't need a portal.
    var allPositiveZIndexes = allRegisteredZIndexes.filter((zIndex)=>zIndex > 0);
    return /*#__PURE__*/ $28UcW.createElement($28UcW.Fragment, null, allNegativeZIndexes.map((zIndex)=>/*#__PURE__*/ $28UcW.createElement($2f18311028c18b72$var$ZIndexSvgPortal, {
            key: zIndex,
            zIndex: zIndex,
            isPanorama: isPanorama
        })), children, allPositiveZIndexes.map((zIndex)=>/*#__PURE__*/ $28UcW.createElement($2f18311028c18b72$var$ZIndexSvgPortal, {
            key: zIndex,
            zIndex: zIndex,
            isPanorama: isPanorama
        })));
}


var $a3e32d9dcc41a426$var$_excluded = [
    "children"
];
function $a3e32d9dcc41a426$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $a3e32d9dcc41a426$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $a3e32d9dcc41a426$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $a3e32d9dcc41a426$var$_extends() {
    return $a3e32d9dcc41a426$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a3e32d9dcc41a426$var$_extends.apply(null, arguments);
}
var $a3e32d9dcc41a426$var$FULL_WIDTH_AND_HEIGHT = {
    width: '100%',
    height: '100%',
    /*
   * display: block is necessary here because the default for an SVG is display: inline,
   * which in some browsers (Chrome) adds a little bit of extra space above and below the SVG
   * to make space for the descender of letters like "g" and "y". This throws off the height calculation
   * and causes the container to grow indefinitely on each render with responsive=true.
   * Display: block removes that extra space.
   *
   * Interestingly, Firefox does not have this problem, but it doesn't hurt to add the style anyway.
   */ display: 'block'
};
var $a3e32d9dcc41a426$var$MainChartSurface = /*#__PURE__*/ (0, $28UcW.forwardRef)((props, ref)=>{
    var width = (0, $6ade474fe9f2b6e0$export$8854f7ece606854b)();
    var height = (0, $6ade474fe9f2b6e0$export$369ae257969c6f9f)();
    var hasAccessibilityLayer = (0, $7753843e36efc467$export$276788f18f24cad3)();
    if (!(0, $11a93f8f3c3518e5$export$5374bb854d0e41c8)(width) || !(0, $11a93f8f3c3518e5$export$5374bb854d0e41c8)(height)) return null;
    var { children: children, otherAttributes: otherAttributes, title: title, desc: desc } = props;
    var tabIndex, role;
    if (otherAttributes != null) {
        if (typeof otherAttributes.tabIndex === 'number') tabIndex = otherAttributes.tabIndex;
        else tabIndex = hasAccessibilityLayer ? 0 : undefined;
        if (typeof otherAttributes.role === 'string') role = otherAttributes.role;
        else role = hasAccessibilityLayer ? 'application' : undefined;
    }
    return /*#__PURE__*/ $28UcW.createElement((0, $ff8d9169ee46fca6$export$7b92b459e668cb21), $a3e32d9dcc41a426$var$_extends({}, otherAttributes, {
        title: title,
        desc: desc,
        role: role,
        tabIndex: tabIndex,
        width: width,
        height: height,
        style: $a3e32d9dcc41a426$var$FULL_WIDTH_AND_HEIGHT,
        ref: ref
    }), children);
});
var $a3e32d9dcc41a426$var$BrushPanoramaSurface = (_ref)=>{
    var { children: children } = _ref;
    var brushDimensions = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $fec5f39ba81f558d$export$3b81e97eae001823));
    if (!brushDimensions) return null;
    var { width: width, height: height, y: y, x: x } = brushDimensions;
    return /*#__PURE__*/ $28UcW.createElement((0, $ff8d9169ee46fca6$export$7b92b459e668cb21), {
        width: width,
        height: height,
        x: x,
        y: y
    }, children);
};
var $a3e32d9dcc41a426$export$b6c051d2e0bcd3e9 = /*#__PURE__*/ (0, $28UcW.forwardRef)((_ref2, ref)=>{
    var { children: children } = _ref2, rest = $a3e32d9dcc41a426$var$_objectWithoutProperties(_ref2, $a3e32d9dcc41a426$var$_excluded);
    var isPanorama = (0, $d64615d5c7c4e07c$export$4b0c59f8845ba920)();
    if (isPanorama) return /*#__PURE__*/ $28UcW.createElement($a3e32d9dcc41a426$var$BrushPanoramaSurface, null, /*#__PURE__*/ $28UcW.createElement((0, $2f18311028c18b72$export$7a76624f8e4da531), {
        isPanorama: true
    }, children));
    return /*#__PURE__*/ $28UcW.createElement($a3e32d9dcc41a426$var$MainChartSurface, $a3e32d9dcc41a426$var$_extends({
        ref: ref
    }, rest), /*#__PURE__*/ $28UcW.createElement((0, $2f18311028c18b72$export$7a76624f8e4da531), {
        isPanorama: false
    }, children));
});



var $28UcW = parcelRequire("28UcW");

var $dP0oo = parcelRequire("dP0oo");




var $28UcW = parcelRequire("28UcW");


var $6885764c1a717e32$exports = {};
'use strict';
var $6885764c1a717e32$var$has = Object.prototype.hasOwnProperty, $6885764c1a717e32$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $6885764c1a717e32$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $6885764c1a717e32$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $6885764c1a717e32$var$Events().__proto__) $6885764c1a717e32$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $6885764c1a717e32$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $6885764c1a717e32$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $6885764c1a717e32$var$EE(fn, context || emitter, once), evt = $6885764c1a717e32$var$prefix ? $6885764c1a717e32$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $6885764c1a717e32$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $6885764c1a717e32$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $6885764c1a717e32$var$EventEmitter() {
    this._events = new $6885764c1a717e32$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $6885764c1a717e32$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($6885764c1a717e32$var$has.call(events, name)) names.push($6885764c1a717e32$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $6885764c1a717e32$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $6885764c1a717e32$var$prefix ? $6885764c1a717e32$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $6885764c1a717e32$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $6885764c1a717e32$var$prefix ? $6885764c1a717e32$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $6885764c1a717e32$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $6885764c1a717e32$var$prefix ? $6885764c1a717e32$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $6885764c1a717e32$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $6885764c1a717e32$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $6885764c1a717e32$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $6885764c1a717e32$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $6885764c1a717e32$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $6885764c1a717e32$var$prefix ? $6885764c1a717e32$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $6885764c1a717e32$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $6885764c1a717e32$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $6885764c1a717e32$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $6885764c1a717e32$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $6885764c1a717e32$var$prefix ? $6885764c1a717e32$var$prefix + event : event;
        if (this._events[evt]) $6885764c1a717e32$var$clearEvent(this, evt);
    } else {
        this._events = new $6885764c1a717e32$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$6885764c1a717e32$var$EventEmitter.prototype.off = $6885764c1a717e32$var$EventEmitter.prototype.removeListener;
$6885764c1a717e32$var$EventEmitter.prototype.addListener = $6885764c1a717e32$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$6885764c1a717e32$var$EventEmitter.prefixed = $6885764c1a717e32$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$6885764c1a717e32$var$EventEmitter.EventEmitter = $6885764c1a717e32$var$EventEmitter;
$6885764c1a717e32$exports = $6885764c1a717e32$var$EventEmitter;


var $7bcffe13aade50c8$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($6885764c1a717e32$exports)))();
var $7bcffe13aade50c8$export$e2631176295fd79b = 'recharts.syncEvent.tooltip';
var $7bcffe13aade50c8$export$5069141294af4ee8 = 'recharts.syncEvent.brush';






function $fcd5f3f1c01e00b4$export$54e3aed0d8d4a717(state) {
    return state.tooltip.syncInteraction;
}





var $1d357b3b480ea4d1$var$_excluded = [
    "x",
    "y"
];
function $1d357b3b480ea4d1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1d357b3b480ea4d1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1d357b3b480ea4d1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1d357b3b480ea4d1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1d357b3b480ea4d1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1d357b3b480ea4d1$var$_defineProperty(e, r, t) {
    return (r = $1d357b3b480ea4d1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1d357b3b480ea4d1$var$_toPropertyKey(t) {
    var i = $1d357b3b480ea4d1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1d357b3b480ea4d1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1d357b3b480ea4d1$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $1d357b3b480ea4d1$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $1d357b3b480ea4d1$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $1d357b3b480ea4d1$var$useTooltipSyncEventsListener() {
    var mySyncId = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $d319e2ad1ad322d2$export$d3b88e5c88540018));
    var myEventEmitter = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $d319e2ad1ad322d2$export$b89defd58e84e980));
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    var syncMethod = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $d319e2ad1ad322d2$export$f3cbf53653105e96));
    var tooltipTicks = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $36d5b5b4d0834cee$export$ffe0e60f8c88c05a));
    var layout = (0, $6ade474fe9f2b6e0$export$970c79ecc7081cc)();
    var viewBox = (0, $6ade474fe9f2b6e0$export$76b29bb074e0c45a)();
    var className = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>state.rootProps.className);
    (0, $28UcW.useEffect)(()=>{
        if (mySyncId == null) // This chart is not synchronised with any other chart so we don't need to listen for any events.
        return 0, $9a1343d05dde836c$export$8793edee2d425525;
        var listener = (incomingSyncId, action, emitter)=>{
            if (myEventEmitter === emitter) // We don't want to dispatch actions that we sent ourselves.
            return;
            if (mySyncId !== incomingSyncId) // This event is not for this chart
            return;
            if (syncMethod === 'index') {
                var _action$payload;
                if (viewBox && action !== null && action !== void 0 && (_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.coordinate && action.payload.sourceViewBox) {
                    var _action$payload$coord = action.payload.coordinate, { x: _x, y: _y } = _action$payload$coord, otherCoordinateProps = $1d357b3b480ea4d1$var$_objectWithoutProperties(_action$payload$coord, $1d357b3b480ea4d1$var$_excluded);
                    var { x: sourceX, y: sourceY, width: sourceWidth, height: sourceHeight } = action.payload.sourceViewBox;
                    var scaledCoordinate = $1d357b3b480ea4d1$var$_objectSpread($1d357b3b480ea4d1$var$_objectSpread({}, otherCoordinateProps), {}, {
                        x: viewBox.x + (sourceWidth ? (_x - sourceX) / sourceWidth : 0) * viewBox.width,
                        y: viewBox.y + (sourceHeight ? (_y - sourceY) / sourceHeight : 0) * viewBox.height
                    });
                    dispatch($1d357b3b480ea4d1$var$_objectSpread($1d357b3b480ea4d1$var$_objectSpread({}, action), {}, {
                        payload: $1d357b3b480ea4d1$var$_objectSpread($1d357b3b480ea4d1$var$_objectSpread({}, action.payload), {}, {
                            coordinate: scaledCoordinate
                        })
                    }));
                } else dispatch(action);
                return;
            }
            if (tooltipTicks == null) // for the other two sync methods, we need the ticks to be available
            return;
            var activeTick;
            if (typeof syncMethod === 'function') {
                /*
         * This is what the data shape in 2.x CategoricalChartState used to look like.
         * In 3.x we store things differently but let's try to keep the old shape for compatibility.
         */ var syncMethodParam = {
                    activeTooltipIndex: action.payload.index == null ? undefined : Number(action.payload.index),
                    isTooltipActive: action.payload.active,
                    activeIndex: action.payload.index == null ? undefined : Number(action.payload.index),
                    activeLabel: action.payload.label,
                    activeDataKey: action.payload.dataKey,
                    activeCoordinate: action.payload.coordinate
                };
                // Call a callback function. If there is an application specific algorithm
                var activeTooltipIndex = syncMethod(tooltipTicks, syncMethodParam);
                activeTick = tooltipTicks[activeTooltipIndex];
            } else if (syncMethod === 'value') // labels are always strings, tick.value might be a string or a number, depending on axis type
            activeTick = tooltipTicks.find((tick)=>String(tick.value) === action.payload.label);
            var { coordinate: coordinate } = action.payload;
            if (activeTick == null || action.payload.active === false || coordinate == null || viewBox == null) {
                dispatch((0, $038eefd840ad861c$export$f2efc99b98e50938)({
                    active: false,
                    coordinate: undefined,
                    dataKey: undefined,
                    index: null,
                    label: undefined,
                    sourceViewBox: undefined,
                    graphicalItemId: undefined
                }));
                return;
            }
            var { x: x, y: y } = coordinate;
            var validateChartX = Math.min(x, viewBox.x + viewBox.width);
            var validateChartY = Math.min(y, viewBox.y + viewBox.height);
            var activeCoordinate = {
                x: layout === 'horizontal' ? activeTick.coordinate : validateChartX,
                y: layout === 'horizontal' ? validateChartY : activeTick.coordinate
            };
            var syncAction = (0, $038eefd840ad861c$export$f2efc99b98e50938)({
                active: action.payload.active,
                coordinate: activeCoordinate,
                dataKey: action.payload.dataKey,
                index: String(activeTick.index),
                label: action.payload.label,
                sourceViewBox: action.payload.sourceViewBox,
                graphicalItemId: action.payload.graphicalItemId
            });
            dispatch(syncAction);
        };
        (0, $7bcffe13aade50c8$export$9bcdfe5f29bb33).on((0, $7bcffe13aade50c8$export$e2631176295fd79b), listener);
        return ()=>{
            (0, $7bcffe13aade50c8$export$9bcdfe5f29bb33).off((0, $7bcffe13aade50c8$export$e2631176295fd79b), listener);
        };
    }, [
        className,
        dispatch,
        myEventEmitter,
        mySyncId,
        syncMethod,
        tooltipTicks,
        layout,
        viewBox
    ]);
}
function $1d357b3b480ea4d1$var$useBrushSyncEventsListener() {
    var mySyncId = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $d319e2ad1ad322d2$export$d3b88e5c88540018));
    var myEventEmitter = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $d319e2ad1ad322d2$export$b89defd58e84e980));
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    (0, $28UcW.useEffect)(()=>{
        if (mySyncId == null) // This chart is not synchronised with any other chart so we don't need to listen for any events.
        return 0, $9a1343d05dde836c$export$8793edee2d425525;
        var listener = (incomingSyncId, action, emitter)=>{
            if (myEventEmitter === emitter) // We don't want to dispatch actions that we sent ourselves.
            return;
            if (mySyncId === incomingSyncId) dispatch((0, $0b06aae827f336cc$export$427d605cc4e3bbdd)(action));
        };
        (0, $7bcffe13aade50c8$export$9bcdfe5f29bb33).on((0, $7bcffe13aade50c8$export$5069141294af4ee8), listener);
        return ()=>{
            (0, $7bcffe13aade50c8$export$9bcdfe5f29bb33).off((0, $7bcffe13aade50c8$export$5069141294af4ee8), listener);
        };
    }, [
        dispatch,
        myEventEmitter,
        mySyncId
    ]);
}
function $1d357b3b480ea4d1$export$3a6efefeed76accf() {
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    (0, $28UcW.useEffect)(()=>{
        dispatch((0, $95a694333b7fd46c$export$abfecd6a8e6070c1)());
    }, [
        dispatch
    ]);
    $1d357b3b480ea4d1$var$useTooltipSyncEventsListener();
    $1d357b3b480ea4d1$var$useBrushSyncEventsListener();
}
function $1d357b3b480ea4d1$export$21f8394fb189b529(tooltipEventType, trigger, activeCoordinate, activeLabel, activeIndex, isTooltipActive) {
    var activeDataKey = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $5ff82c06c780fa4c$export$faa2b8b92235e5bd)(state, tooltipEventType, trigger));
    var eventEmitterSymbol = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $d319e2ad1ad322d2$export$b89defd58e84e980));
    var syncId = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $d319e2ad1ad322d2$export$d3b88e5c88540018));
    var syncMethod = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $d319e2ad1ad322d2$export$f3cbf53653105e96));
    var tooltipState = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $fcd5f3f1c01e00b4$export$54e3aed0d8d4a717));
    var isReceivingSynchronisation = tooltipState === null || tooltipState === void 0 ? void 0 : tooltipState.active;
    var viewBox = (0, $6ade474fe9f2b6e0$export$76b29bb074e0c45a)();
    (0, $28UcW.useEffect)(()=>{
        if (isReceivingSynchronisation) /*
       * This chart currently has active tooltip, synchronised from another chart.
       * Let's not send any outgoing synchronisation events while that's happening
       * to avoid infinite loops.
       */ return;
        if (syncId == null) /*
       * syncId is not set, means that this chart is not synchronised with any other chart,
       * means we don't need to send synchronisation events
       */ return;
        if (eventEmitterSymbol == null) /*
       * When using Recharts internal hooks and selectors outside charts context,
       * these properties will be undefined. Let's return silently instead of throwing an error.
       */ return;
        var syncAction = (0, $038eefd840ad861c$export$f2efc99b98e50938)({
            active: isTooltipActive,
            coordinate: activeCoordinate,
            dataKey: activeDataKey,
            index: activeIndex,
            label: typeof activeLabel === 'number' ? String(activeLabel) : activeLabel,
            sourceViewBox: viewBox,
            graphicalItemId: undefined
        });
        (0, $7bcffe13aade50c8$export$9bcdfe5f29bb33).emit((0, $7bcffe13aade50c8$export$e2631176295fd79b), syncId, syncAction, eventEmitterSymbol);
    }, [
        isReceivingSynchronisation,
        activeCoordinate,
        activeDataKey,
        activeIndex,
        activeLabel,
        eventEmitterSymbol,
        syncId,
        syncMethod,
        isTooltipActive,
        viewBox
    ]);
}
function $1d357b3b480ea4d1$export$d3c93a99675de51f() {
    var syncId = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $d319e2ad1ad322d2$export$d3b88e5c88540018));
    var eventEmitterSymbol = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $d319e2ad1ad322d2$export$b89defd58e84e980));
    var brushStartIndex = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>state.chartData.dataStartIndex);
    var brushEndIndex = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>state.chartData.dataEndIndex);
    (0, $28UcW.useEffect)(()=>{
        if (syncId == null || brushStartIndex == null || brushEndIndex == null || eventEmitterSymbol == null) return;
        var syncAction = {
            startIndex: brushStartIndex,
            endIndex: brushEndIndex
        };
        (0, $7bcffe13aade50c8$export$9bcdfe5f29bb33).emit((0, $7bcffe13aade50c8$export$5069141294af4ee8), syncId, syncAction, eventEmitterSymbol);
    }, [
        brushEndIndex,
        brushStartIndex,
        eventEmitterSymbol,
        syncId
    ]);
}




var $28UcW = parcelRequire("28UcW");




function $8e5d152c31beab67$export$20f53c2c914d2da0() {
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    var [ref, setRef] = (0, $28UcW.useState)(null);
    var scale = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $52905d0b62bb57b1$export$317b55dda5fb5617));
    (0, $28UcW.useEffect)(()=>{
        if (ref == null) return;
        var rect = ref.getBoundingClientRect();
        var newScale = rect.width / ref.offsetWidth;
        if ((0, $11a93f8f3c3518e5$export$f8a8fc612ced9bb0)(newScale) && newScale !== scale) dispatch((0, $b2c2d9052192be80$export$4dc523f7f9b3edd6)(newScale));
    }, [
        ref,
        dispatch,
        scale
    ]);
    return setRef;
}





var $28UcW = parcelRequire("28UcW");
var $b4821fa4aeb9e847$export$cf22c67346dd99a4 = /*#__PURE__*/ (0, $28UcW.createContext)(null);
var $b4821fa4aeb9e847$export$2842d70d9d62127a = ()=>(0, $28UcW.useContext)($b4821fa4aeb9e847$export$cf22c67346dd99a4);






function $1060c70a25036b5e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1060c70a25036b5e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1060c70a25036b5e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1060c70a25036b5e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1060c70a25036b5e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1060c70a25036b5e$var$_defineProperty(e, r, t) {
    return (r = $1060c70a25036b5e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1060c70a25036b5e$var$_toPropertyKey(t) {
    var i = $1060c70a25036b5e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1060c70a25036b5e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1060c70a25036b5e$var$_extends() {
    return $1060c70a25036b5e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1060c70a25036b5e$var$_extends.apply(null, arguments);
}
var $1060c70a25036b5e$var$EventSynchronizer = ()=>{
    (0, $1d357b3b480ea4d1$export$3a6efefeed76accf)();
    return null;
};
function $1060c70a25036b5e$var$getNumberOrZero(value) {
    if (typeof value === 'number') return value;
    if (typeof value === 'string') {
        var parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) return parsed;
    }
    return 0;
}
var $1060c70a25036b5e$var$ResponsiveDiv = /*#__PURE__*/ (0, $28UcW.forwardRef)((props, ref)=>{
    var _props$style, _props$style2;
    var observerRef = (0, $28UcW.useRef)(null);
    var [sizes, setSizes] = (0, $28UcW.useState)({
        containerWidth: $1060c70a25036b5e$var$getNumberOrZero((_props$style = props.style) === null || _props$style === void 0 ? void 0 : _props$style.width),
        containerHeight: $1060c70a25036b5e$var$getNumberOrZero((_props$style2 = props.style) === null || _props$style2 === void 0 ? void 0 : _props$style2.height)
    });
    var setContainerSize = (0, $28UcW.useCallback)((newWidth, newHeight)=>{
        setSizes((prevState)=>{
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    var innerRef = (0, $28UcW.useCallback)((node)=>{
        if (typeof ref === 'function') ref(node);
        if (node != null && typeof ResizeObserver !== 'undefined') {
            var { width: containerWidth, height: containerHeight } = node.getBoundingClientRect();
            setContainerSize(containerWidth, containerHeight);
            var callback = (entries)=>{
                var { width: width, height: height } = entries[0].contentRect;
                setContainerSize(width, height);
            };
            var observer = new ResizeObserver(callback);
            observer.observe(node);
            observerRef.current = observer;
        }
    }, [
        ref,
        setContainerSize
    ]);
    (0, $28UcW.useEffect)(()=>{
        return ()=>{
            var observer = observerRef.current;
            if (observer != null) observer.disconnect();
        };
    }, [
        setContainerSize
    ]);
    return /*#__PURE__*/ $28UcW.createElement($28UcW.Fragment, null, /*#__PURE__*/ $28UcW.createElement((0, $6ade474fe9f2b6e0$export$80ea82e77fb424e1), {
        width: sizes.containerWidth,
        height: sizes.containerHeight
    }), /*#__PURE__*/ $28UcW.createElement("div", $1060c70a25036b5e$var$_extends({
        ref: innerRef
    }, props)));
});
var $1060c70a25036b5e$var$ReadSizeOnceDiv = /*#__PURE__*/ (0, $28UcW.forwardRef)((props, ref)=>{
    var { width: width, height: height } = props;
    var [sizes, setSizes] = (0, $28UcW.useState)({
        containerWidth: $1060c70a25036b5e$var$getNumberOrZero(width),
        containerHeight: $1060c70a25036b5e$var$getNumberOrZero(height)
    });
    var setContainerSize = (0, $28UcW.useCallback)((newWidth, newHeight)=>{
        setSizes((prevState)=>{
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    var innerRef = (0, $28UcW.useCallback)((node)=>{
        if (typeof ref === 'function') ref(node);
        if (node != null) {
            var { width: containerWidth, height: containerHeight } = node.getBoundingClientRect();
            setContainerSize(containerWidth, containerHeight);
        }
    }, [
        ref,
        setContainerSize
    ]);
    return /*#__PURE__*/ $28UcW.createElement($28UcW.Fragment, null, /*#__PURE__*/ $28UcW.createElement((0, $6ade474fe9f2b6e0$export$80ea82e77fb424e1), {
        width: sizes.containerWidth,
        height: sizes.containerHeight
    }), /*#__PURE__*/ $28UcW.createElement("div", $1060c70a25036b5e$var$_extends({
        ref: innerRef
    }, props)));
});
var $1060c70a25036b5e$var$StaticDiv = /*#__PURE__*/ (0, $28UcW.forwardRef)((props, ref)=>{
    var { width: width, height: height } = props;
    return /*#__PURE__*/ $28UcW.createElement($28UcW.Fragment, null, /*#__PURE__*/ $28UcW.createElement((0, $6ade474fe9f2b6e0$export$80ea82e77fb424e1), {
        width: width,
        height: height
    }), /*#__PURE__*/ $28UcW.createElement("div", $1060c70a25036b5e$var$_extends({
        ref: ref
    }, props)));
});
var $1060c70a25036b5e$var$NonResponsiveDiv = /*#__PURE__*/ (0, $28UcW.forwardRef)((props, ref)=>{
    var { width: width, height: height } = props;
    if ((0, $9a1343d05dde836c$export$e50269385c77c348)(width) || (0, $9a1343d05dde836c$export$e50269385c77c348)(height)) return /*#__PURE__*/ $28UcW.createElement($1060c70a25036b5e$var$ReadSizeOnceDiv, $1060c70a25036b5e$var$_extends({}, props, {
        ref: ref
    }));
    return /*#__PURE__*/ $28UcW.createElement($1060c70a25036b5e$var$StaticDiv, $1060c70a25036b5e$var$_extends({}, props, {
        ref: ref
    }));
});
function $1060c70a25036b5e$var$getWrapperDivComponent(responsive) {
    return responsive === true ? $1060c70a25036b5e$var$ResponsiveDiv : $1060c70a25036b5e$var$NonResponsiveDiv;
}
var $1060c70a25036b5e$export$81bb7974a33f88b = /*#__PURE__*/ (0, $28UcW.forwardRef)((props, ref)=>{
    var { children: children, className: className, height: heightFromProps, onClick: onClick, onContextMenu: onContextMenu, onDoubleClick: onDoubleClick, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, style: style, width: widthFromProps, responsive: responsive, dispatchTouchEvents: dispatchTouchEvents = true } = props;
    var containerRef = (0, $28UcW.useRef)(null);
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    var [tooltipPortal, setTooltipPortal] = (0, $28UcW.useState)(null);
    var [legendPortal, setLegendPortal] = (0, $28UcW.useState)(null);
    var setScaleRef = (0, $8e5d152c31beab67$export$20f53c2c914d2da0)();
    var responsiveContainerCalculations = (0, $fb5e151ecf96d720$export$4ec9972d4f677af6)();
    var width = (responsiveContainerCalculations === null || responsiveContainerCalculations === void 0 ? void 0 : responsiveContainerCalculations.width) > 0 ? responsiveContainerCalculations.width : widthFromProps;
    var height = (responsiveContainerCalculations === null || responsiveContainerCalculations === void 0 ? void 0 : responsiveContainerCalculations.height) > 0 ? responsiveContainerCalculations.height : heightFromProps;
    var innerRef = (0, $28UcW.useCallback)((node)=>{
        setScaleRef(node);
        if (typeof ref === 'function') ref(node);
        setTooltipPortal(node);
        setLegendPortal(node);
        if (node != null) containerRef.current = node;
    }, [
        setScaleRef,
        ref,
        setTooltipPortal,
        setLegendPortal
    ]);
    var myOnClick = (0, $28UcW.useCallback)((e)=>{
        dispatch((0, $235ad3f30eff74ff$export$f06e14b484aecafc)(e));
        dispatch((0, $ad93c74adacdabbb$export$1d0268b9f89859f0)({
            handler: onClick,
            reactEvent: e
        }));
    }, [
        dispatch,
        onClick
    ]);
    var myOnMouseEnter = (0, $28UcW.useCallback)((e)=>{
        dispatch((0, $235ad3f30eff74ff$export$f9de213dbfb2e32c)(e));
        dispatch((0, $ad93c74adacdabbb$export$1d0268b9f89859f0)({
            handler: onMouseEnter,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseEnter
    ]);
    var myOnMouseLeave = (0, $28UcW.useCallback)((e)=>{
        dispatch((0, $038eefd840ad861c$export$73879bed3f2eef71)());
        dispatch((0, $ad93c74adacdabbb$export$1d0268b9f89859f0)({
            handler: onMouseLeave,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseLeave
    ]);
    var myOnMouseMove = (0, $28UcW.useCallback)((e)=>{
        dispatch((0, $235ad3f30eff74ff$export$f9de213dbfb2e32c)(e));
        dispatch((0, $ad93c74adacdabbb$export$1d0268b9f89859f0)({
            handler: onMouseMove,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseMove
    ]);
    var onFocus = (0, $28UcW.useCallback)(()=>{
        dispatch((0, $ace6e797b6848f5b$export$d95192eee5865567)());
    }, [
        dispatch
    ]);
    var onKeyDown = (0, $28UcW.useCallback)((e)=>{
        dispatch((0, $ace6e797b6848f5b$export$4839538efb7414c)(e.key));
    }, [
        dispatch
    ]);
    var myOnContextMenu = (0, $28UcW.useCallback)((e)=>{
        dispatch((0, $ad93c74adacdabbb$export$1d0268b9f89859f0)({
            handler: onContextMenu,
            reactEvent: e
        }));
    }, [
        dispatch,
        onContextMenu
    ]);
    var myOnDoubleClick = (0, $28UcW.useCallback)((e)=>{
        dispatch((0, $ad93c74adacdabbb$export$1d0268b9f89859f0)({
            handler: onDoubleClick,
            reactEvent: e
        }));
    }, [
        dispatch,
        onDoubleClick
    ]);
    var myOnMouseDown = (0, $28UcW.useCallback)((e)=>{
        dispatch((0, $ad93c74adacdabbb$export$1d0268b9f89859f0)({
            handler: onMouseDown,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseDown
    ]);
    var myOnMouseUp = (0, $28UcW.useCallback)((e)=>{
        dispatch((0, $ad93c74adacdabbb$export$1d0268b9f89859f0)({
            handler: onMouseUp,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseUp
    ]);
    var myOnTouchStart = (0, $28UcW.useCallback)((e)=>{
        dispatch((0, $ad93c74adacdabbb$export$1d0268b9f89859f0)({
            handler: onTouchStart,
            reactEvent: e
        }));
    }, [
        dispatch,
        onTouchStart
    ]);
    /*
   * onTouchMove is special because it behaves different from mouse events.
   * Mouse events have 'enter' + 'leave' combo that notify us when the mouse is over
   * a certain element. Touch events don't have that; touch only gives us
   * start (finger down), end (finger up) and move (finger moving).
   * So we need to figure out which element the user is touching
   * ourselves. Fortunately, there's a convenient method for that:
   * https://developer.mozilla.org/en-US/docs/Web/API/Document/elementFromPoint
   */ var myOnTouchMove = (0, $28UcW.useCallback)((e)=>{
        if (dispatchTouchEvents) dispatch((0, $929ff66c9946de2e$export$ba46b5fda0e2985f)(e));
        dispatch((0, $ad93c74adacdabbb$export$1d0268b9f89859f0)({
            handler: onTouchMove,
            reactEvent: e
        }));
    }, [
        dispatch,
        dispatchTouchEvents,
        onTouchMove
    ]);
    var myOnTouchEnd = (0, $28UcW.useCallback)((e)=>{
        dispatch((0, $ad93c74adacdabbb$export$1d0268b9f89859f0)({
            handler: onTouchEnd,
            reactEvent: e
        }));
    }, [
        dispatch,
        onTouchEnd
    ]);
    var WrapperDiv = $1060c70a25036b5e$var$getWrapperDivComponent(responsive);
    return /*#__PURE__*/ $28UcW.createElement((0, $b4821fa4aeb9e847$export$cf22c67346dd99a4).Provider, {
        value: tooltipPortal
    }, /*#__PURE__*/ $28UcW.createElement((0, $75139349d654247f$export$63a23315bebc1b2).Provider, {
        value: legendPortal
    }, /*#__PURE__*/ $28UcW.createElement(WrapperDiv, {
        width: width !== null && width !== void 0 ? width : style === null || style === void 0 ? void 0 : style.width,
        height: height !== null && height !== void 0 ? height : style === null || style === void 0 ? void 0 : style.height,
        className: (0, $dP0oo.clsx)('recharts-wrapper', className),
        style: $1060c70a25036b5e$var$_objectSpread({
            position: 'relative',
            cursor: 'default',
            width: width,
            height: height
        }, style),
        onClick: myOnClick,
        onContextMenu: myOnContextMenu,
        onDoubleClick: myOnDoubleClick,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseDown: myOnMouseDown,
        onMouseEnter: myOnMouseEnter,
        onMouseLeave: myOnMouseLeave,
        onMouseMove: myOnMouseMove,
        onMouseUp: myOnMouseUp,
        onTouchEnd: myOnTouchEnd,
        onTouchMove: myOnTouchMove,
        onTouchStart: myOnTouchStart,
        ref: innerRef
    }, /*#__PURE__*/ $28UcW.createElement($1060c70a25036b5e$var$EventSynchronizer, null), children)));
});



var $28UcW = parcelRequire("28UcW");


var $521db4d71dba3f0d$var$ClipPathIdContext = /*#__PURE__*/ (0, $28UcW.createContext)(undefined);
var $521db4d71dba3f0d$export$8b42b9b49a38ca72 = (_ref)=>{
    var { children: children } = _ref;
    var [clipPathId] = (0, $28UcW.useState)("".concat((0, $9a1343d05dde836c$export$8b15d37bc3f197d4)('recharts'), "-clip"));
    var plotArea = (0, $cf472f754cd2bf9d$export$f1ef8efc9ef6fe0c)();
    if (plotArea == null) return null;
    var { x: x, y: y, width: width, height: height } = plotArea;
    return /*#__PURE__*/ $28UcW.createElement($521db4d71dba3f0d$var$ClipPathIdContext.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ $28UcW.createElement("defs", null, /*#__PURE__*/ $28UcW.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $28UcW.createElement("rect", {
        x: x,
        y: y,
        height: height,
        width: width
    }))), children);
};
var $521db4d71dba3f0d$export$71e825c43eae6ca6 = ()=>{
    return (0, $28UcW.useContext)($521db4d71dba3f0d$var$ClipPathIdContext);
};




var $f2e7fa7651d04326$var$_excluded = [
    "width",
    "height",
    "responsive",
    "children",
    "className",
    "style",
    "compact",
    "title",
    "desc"
];
function $f2e7fa7651d04326$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $f2e7fa7651d04326$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $f2e7fa7651d04326$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $f2e7fa7651d04326$export$d49e03133b3316a9 = /*#__PURE__*/ (0, $28UcW.forwardRef)((props, ref)=>{
    var { width: width, height: height, responsive: responsive, children: children, className: className, style: style, compact: compact, title: title, desc: desc } = props, others = $f2e7fa7651d04326$var$_objectWithoutProperties(props, $f2e7fa7651d04326$var$_excluded);
    var attrs = (0, $3d820e26962aea02$export$8b56257912140094)(others);
    /*
   * The "compact" mode is used as the panorama within Brush.
   * However because `compact` is a public prop, let's assume that it can render outside of Brush too.
   */ if (compact) return /*#__PURE__*/ $28UcW.createElement($28UcW.Fragment, null, /*#__PURE__*/ $28UcW.createElement((0, $6ade474fe9f2b6e0$export$80ea82e77fb424e1), {
        width: width,
        height: height
    }), /*#__PURE__*/ $28UcW.createElement((0, $a3e32d9dcc41a426$export$b6c051d2e0bcd3e9), {
        otherAttributes: attrs,
        title: title,
        desc: desc
    }, children));
    return /*#__PURE__*/ $28UcW.createElement((0, $1060c70a25036b5e$export$81bb7974a33f88b), {
        className: className,
        style: style,
        width: width,
        height: height,
        responsive: responsive !== null && responsive !== void 0 ? responsive : false,
        onClick: props.onClick,
        onMouseLeave: props.onMouseLeave,
        onMouseEnter: props.onMouseEnter,
        onMouseMove: props.onMouseMove,
        onMouseDown: props.onMouseDown,
        onMouseUp: props.onMouseUp,
        onContextMenu: props.onContextMenu,
        onDoubleClick: props.onDoubleClick,
        onTouchStart: props.onTouchStart,
        onTouchMove: props.onTouchMove,
        onTouchEnd: props.onTouchEnd
    }, /*#__PURE__*/ $28UcW.createElement((0, $a3e32d9dcc41a426$export$b6c051d2e0bcd3e9), {
        otherAttributes: attrs,
        title: title,
        desc: desc,
        ref: ref
    }, /*#__PURE__*/ $28UcW.createElement((0, $521db4d71dba3f0d$export$8b42b9b49a38ca72), null, children)));
});



function $1f2e5949a70c5fc2$var$_extends() {
    return $1f2e5949a70c5fc2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1f2e5949a70c5fc2$var$_extends.apply(null, arguments);
}
var $1f2e5949a70c5fc2$var$defaultMargin = {
    top: 5,
    right: 5,
    bottom: 5,
    left: 5
};
var $1f2e5949a70c5fc2$export$2663cf0965a16cf2 = {
    accessibilityLayer: true,
    barCategoryGap: '10%',
    barGap: 4,
    layout: 'horizontal',
    margin: $1f2e5949a70c5fc2$var$defaultMargin,
    responsive: false,
    reverseStackOrder: false,
    stackOffset: 'none',
    syncMethod: 'index'
};
var $1f2e5949a70c5fc2$export$855bb85b2910abc9 = /*#__PURE__*/ (0, $28UcW.forwardRef)(function CartesianChart(props, ref) {
    var _categoricalChartProp;
    var rootChartProps = (0, $2db4b31e06a7a91b$export$45004cc70a390ee8)(props.categoricalChartProps, $1f2e5949a70c5fc2$export$2663cf0965a16cf2);
    var { chartName: chartName, defaultTooltipEventType: defaultTooltipEventType, validateTooltipEventTypes: validateTooltipEventTypes, tooltipPayloadSearcher: tooltipPayloadSearcher, categoricalChartProps: categoricalChartProps } = props;
    var options = {
        chartName: chartName,
        defaultTooltipEventType: defaultTooltipEventType,
        validateTooltipEventTypes: validateTooltipEventTypes,
        tooltipPayloadSearcher: tooltipPayloadSearcher,
        eventEmitter: undefined
    };
    return /*#__PURE__*/ $28UcW.createElement((0, $cc45ff7da2ab8dc7$export$debe87639f2707f9), {
        preloadedState: {
            options: options
        },
        reduxStoreName: (_categoricalChartProp = categoricalChartProps.id) !== null && _categoricalChartProp !== void 0 ? _categoricalChartProp : chartName
    }, /*#__PURE__*/ $28UcW.createElement((0, $9cc15f91b24b888a$export$2100a1dedbca0238), {
        chartData: categoricalChartProps.data
    }), /*#__PURE__*/ $28UcW.createElement((0, $b8b3a215b6586190$export$6faeaad6e02c2e9d), {
        layout: rootChartProps.layout,
        margin: rootChartProps.margin
    }), /*#__PURE__*/ $28UcW.createElement((0, $71abb7370041d836$export$6fabfb9ba230d12b), {
        baseValue: rootChartProps.baseValue,
        accessibilityLayer: rootChartProps.accessibilityLayer,
        barCategoryGap: rootChartProps.barCategoryGap,
        maxBarSize: rootChartProps.maxBarSize,
        stackOffset: rootChartProps.stackOffset,
        barGap: rootChartProps.barGap,
        barSize: rootChartProps.barSize,
        syncId: rootChartProps.syncId,
        syncMethod: rootChartProps.syncMethod,
        className: rootChartProps.className,
        reverseStackOrder: rootChartProps.reverseStackOrder
    }), /*#__PURE__*/ $28UcW.createElement((0, $f2e7fa7651d04326$export$d49e03133b3316a9), $1f2e5949a70c5fc2$var$_extends({}, rootChartProps, {
        ref: ref
    })));
});


var $d8f2cb6cabd4e2ef$var$allowedTooltipTypes = [
    'axis'
];
var $d8f2cb6cabd4e2ef$export$54d0e8420ac838ac = /*#__PURE__*/ (0, $28UcW.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ $28UcW.createElement((0, $1f2e5949a70c5fc2$export$855bb85b2910abc9), {
        chartName: "LineChart",
        defaultTooltipEventType: "axis",
        validateTooltipEventTypes: $d8f2cb6cabd4e2ef$var$allowedTooltipTypes,
        tooltipPayloadSearcher: (0, $95a694333b7fd46c$export$3d996ff386c7802d),
        categoricalChartProps: props,
        ref: ref
    });
});


var $28UcW = parcelRequire("28UcW");


var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

function $8402e5e8b67ff3f6$var$_extends() {
    return $8402e5e8b67ff3f6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8402e5e8b67ff3f6$var$_extends.apply(null, arguments);
}
function $8402e5e8b67ff3f6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8402e5e8b67ff3f6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8402e5e8b67ff3f6$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8402e5e8b67ff3f6$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8402e5e8b67ff3f6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8402e5e8b67ff3f6$var$_defineProperty(e, r, t) {
    return (r = $8402e5e8b67ff3f6$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8402e5e8b67ff3f6$var$_toPropertyKey(t) {
    var i = $8402e5e8b67ff3f6$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8402e5e8b67ff3f6$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8402e5e8b67ff3f6$var$defaultFormatter(value) {
    return Array.isArray(value) && (0, $9a1343d05dde836c$export$402a499e1ea44294)(value[0]) && (0, $9a1343d05dde836c$export$402a499e1ea44294)(value[1]) ? value.join(' ~ ') : value;
}
var $8402e5e8b67ff3f6$export$6fe33945eebf9ac8 = (props)=>{
    var { separator: separator = ' : ', contentStyle: contentStyle = {}, itemStyle: itemStyle = {}, labelStyle: labelStyle = {}, payload: payload, formatter: formatter, itemSorter: itemSorter, wrapperClassName: wrapperClassName, labelClassName: labelClassName, label: label, labelFormatter: labelFormatter, accessibilityLayer: accessibilityLayer = false } = props;
    var renderContent = ()=>{
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($d179bd389fad45d8$exports)))(payload, itemSorter) : payload).map((entry, i)=>{
                if (entry.type === 'none') return null;
                var finalFormatter = entry.formatter || formatter || $8402e5e8b67ff3f6$var$defaultFormatter;
                var { value: value, name: name } = entry;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) [finalValue, finalName] = formatted;
                    else if (formatted != null) finalValue = formatted;
                    else return null;
                }
                var finalItemStyle = $8402e5e8b67ff3f6$var$_objectSpread({
                    display: 'block',
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || '#000'
                }, itemStyle);
                return /*#__PURE__*/ $28UcW.createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $9a1343d05dde836c$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ $28UcW.createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $9a1343d05dde836c$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ $28UcW.createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ $28UcW.createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ $28UcW.createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || ''));
            });
            return /*#__PURE__*/ $28UcW.createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $8402e5e8b67ff3f6$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    }, contentStyle);
    var finalLabelStyle = $8402e5e8b67ff3f6$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, $9a1343d05dde836c$export$b931b78cbb3caf86)(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, $dP0oo.clsx)('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, $dP0oo.clsx)('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    var accessibilityAttributes = accessibilityLayer ? {
        role: 'status',
        'aria-live': 'assertive'
    } : {};
    return /*#__PURE__*/ $28UcW.createElement("div", $8402e5e8b67ff3f6$var$_extends({
        className: wrapperCN,
        style: finalStyle
    }, accessibilityAttributes), /*#__PURE__*/ $28UcW.createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ $28UcW.isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};



var $28UcW = parcelRequire("28UcW");

var $dP0oo = parcelRequire("dP0oo");

var $4d21471f661a0974$var$CSS_CLASS_PREFIX = 'recharts-tooltip-wrapper';
var $4d21471f661a0974$var$TOOLTIP_HIDDEN = {
    visibility: 'hidden'
};
function $4d21471f661a0974$export$46aee7ef09f78756(_ref) {
    var { coordinate: coordinate, translateX: translateX, translateY: translateY } = _ref;
    return (0, $dP0oo.clsx)($4d21471f661a0974$var$CSS_CLASS_PREFIX, {
        ["".concat($4d21471f661a0974$var$CSS_CLASS_PREFIX, "-right")]: (0, $9a1343d05dde836c$export$7e4aa119212bc614)(translateX) && coordinate && (0, $9a1343d05dde836c$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x,
        ["".concat($4d21471f661a0974$var$CSS_CLASS_PREFIX, "-left")]: (0, $9a1343d05dde836c$export$7e4aa119212bc614)(translateX) && coordinate && (0, $9a1343d05dde836c$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x,
        ["".concat($4d21471f661a0974$var$CSS_CLASS_PREFIX, "-bottom")]: (0, $9a1343d05dde836c$export$7e4aa119212bc614)(translateY) && coordinate && (0, $9a1343d05dde836c$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y,
        ["".concat($4d21471f661a0974$var$CSS_CLASS_PREFIX, "-top")]: (0, $9a1343d05dde836c$export$7e4aa119212bc614)(translateY) && coordinate && (0, $9a1343d05dde836c$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y
    });
}
function $4d21471f661a0974$export$4cccba03fe0eccc6(_ref2) {
    var { allowEscapeViewBox: allowEscapeViewBox, coordinate: coordinate, key: key, offsetTopLeft: offsetTopLeft, position: position, reverseDirection: reverseDirection, tooltipDimension: tooltipDimension, viewBox: viewBox, viewBoxDimension: viewBoxDimension } = _ref2;
    if (position && (0, $9a1343d05dde836c$export$7e4aa119212bc614)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - (offsetTopLeft > 0 ? offsetTopLeft : 0);
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    var viewBoxKey = viewBox[key];
    if (viewBoxKey == null) return 0;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBoxKey;
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBoxKey);
        return Math.max(negative, viewBoxKey);
    }
    if (viewBoxDimension == null) return 0;
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBoxKey + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBoxKey);
    return Math.max(positive, viewBoxKey);
}
function $4d21471f661a0974$export$4fe0982879780f9b(_ref3) {
    var { translateX: translateX, translateY: translateY, useTranslate3d: useTranslate3d } = _ref3;
    return {
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    };
}
function $4d21471f661a0974$export$25e3b0ae21503056(_ref4) {
    var { allowEscapeViewBox: allowEscapeViewBox, coordinate: coordinate, offsetTopLeft: offsetTopLeft, position: position, reverseDirection: reverseDirection, tooltipBox: tooltipBox, useTranslate3d: useTranslate3d, viewBox: viewBox } = _ref4;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = $4d21471f661a0974$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'x',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = $4d21471f661a0974$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'y',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = $4d21471f661a0974$export$4fe0982879780f9b({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = $4d21471f661a0974$var$TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: $4d21471f661a0974$export$46aee7ef09f78756({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}


function $50b47089332b3e48$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $50b47089332b3e48$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $50b47089332b3e48$var$ownKeys(Object(t), !0).forEach(function(r) {
            $50b47089332b3e48$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $50b47089332b3e48$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $50b47089332b3e48$var$_defineProperty(e, r, t) {
    return (r = $50b47089332b3e48$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $50b47089332b3e48$var$_toPropertyKey(t) {
    var i = $50b47089332b3e48$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $50b47089332b3e48$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $50b47089332b3e48$export$9e6cee7b86551b9c extends (0, $28UcW.PureComponent) {
    constructor(){
        super(...arguments);
        $50b47089332b3e48$var$_defineProperty(this, "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            }
        });
        $50b47089332b3e48$var$_defineProperty(this, "handleKeyDown", (event)=>{
            if (event.key === 'Escape') {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
    }
    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown);
    }
    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }
    componentDidUpdate() {
        var _this$props$coordinat5, _this$props$coordinat6;
        if (!this.state.dismissed) return;
        if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
    }
    render() {
        var { active: active, allowEscapeViewBox: allowEscapeViewBox, animationDuration: animationDuration, animationEasing: animationEasing, children: children, coordinate: coordinate, hasPayload: hasPayload, isAnimationActive: isAnimationActive, offset: offset, position: position, reverseDirection: reverseDirection, useTranslate3d: useTranslate3d, viewBox: viewBox, wrapperStyle: wrapperStyle, lastBoundingBox: lastBoundingBox, innerRef: innerRef, hasPortalFromProps: hasPortalFromProps } = this.props;
        var { cssClasses: cssClasses, cssProperties: cssProperties } = (0, $4d21471f661a0974$export$25e3b0ae21503056)({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            offsetTopLeft: offset,
            position: position,
            reverseDirection: reverseDirection,
            tooltipBox: {
                height: lastBoundingBox.height,
                width: lastBoundingBox.width
            },
            useTranslate3d: useTranslate3d,
            viewBox: viewBox
        });
        // do not use absolute styles if the user has passed a custom portal prop
        var positionStyles = hasPortalFromProps ? {} : $50b47089332b3e48$var$_objectSpread($50b47089332b3e48$var$_objectSpread({
            transition: isAnimationActive && active ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : undefined
        }, cssProperties), {}, {
            pointerEvents: 'none',
            visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden',
            position: 'absolute',
            top: 0,
            left: 0
        });
        var outerStyle = $50b47089332b3e48$var$_objectSpread($50b47089332b3e48$var$_objectSpread({}, positionStyles), {}, {
            visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden'
        }, wrapperStyle);
        return(/*#__PURE__*/ // This element allow listening to the `Escape` key. See https://github.com/recharts/recharts/pull/2925
        $28UcW.createElement("div", {
            // @ts-expect-error typescript library does not recognize xmlns attribute, but it's required for an HTML chunk inside SVG.
            xmlns: "http://www.w3.org/1999/xhtml",
            tabIndex: -1,
            className: cssClasses,
            style: outerStyle,
            ref: innerRef
        }, children));
    }
}







var $28UcW = parcelRequire("28UcW");

var $dP0oo = parcelRequire("dP0oo");



var $28UcW = parcelRequire("28UcW");

var $dP0oo = parcelRequire("dP0oo");


var $57b15cee458fffc0$var$_excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function $57b15cee458fffc0$var$_extends() {
    return $57b15cee458fffc0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $57b15cee458fffc0$var$_extends.apply(null, arguments);
}
function $57b15cee458fffc0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $57b15cee458fffc0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $57b15cee458fffc0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $57b15cee458fffc0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $57b15cee458fffc0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $57b15cee458fffc0$var$_defineProperty(e, r, t) {
    return (r = $57b15cee458fffc0$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $57b15cee458fffc0$var$_toPropertyKey(t) {
    var i = $57b15cee458fffc0$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $57b15cee458fffc0$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $57b15cee458fffc0$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $57b15cee458fffc0$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $57b15cee458fffc0$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $57b15cee458fffc0$var$getPath = (x, y, width, height, top, left)=>{
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $57b15cee458fffc0$export$3c877bb842c36952 = (_ref)=>{
    var { x: x = 0, y: y = 0, top: top = 0, left: left = 0, width: width = 0, height: height = 0, className: className } = _ref, rest = $57b15cee458fffc0$var$_objectWithoutProperties(_ref, $57b15cee458fffc0$var$_excluded);
    var props = $57b15cee458fffc0$var$_objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, $9a1343d05dde836c$export$7e4aa119212bc614)(x) || !(0, $9a1343d05dde836c$export$7e4aa119212bc614)(y) || !(0, $9a1343d05dde836c$export$7e4aa119212bc614)(width) || !(0, $9a1343d05dde836c$export$7e4aa119212bc614)(height) || !(0, $9a1343d05dde836c$export$7e4aa119212bc614)(top) || !(0, $9a1343d05dde836c$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ $28UcW.createElement("path", $57b15cee458fffc0$var$_extends({}, (0, $1412060bc6e2b8b4$export$67f8fc03e57e2747)(props), {
        className: (0, $dP0oo.clsx)('recharts-cross', className),
        d: $57b15cee458fffc0$var$getPath(x, y, width, height, top, left)
    }));
};


function $1d36c01cd7b0a196$export$f84ec1ecc69a13c9(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: 'none',
        fill: '#ccc',
        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
    };
}




function $f8f3543ea7b06a66$export$ad661ef85a042a4f(activeCoordinate) {
    var { cx: cx, cy: cy, radius: radius, startAngle: startAngle, endAngle: endAngle } = activeCoordinate;
    var startPoint = (0, $d16c67d42be24ed1$export$5c9a959bb3fc7749)(cx, cy, radius, startAngle);
    var endPoint = (0, $d16c67d42be24ed1$export$5c9a959bb3fc7749)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}






function $6042b9e84cfd04b2$export$56e1305620ce5745(layout, activeCoordinate, offset) {
    if (layout === 'horizontal') return [
        {
            x: activeCoordinate.x,
            y: offset.top
        },
        {
            x: activeCoordinate.x,
            y: offset.top + offset.height
        }
    ];
    if (layout === 'vertical') return [
        {
            x: offset.left,
            y: activeCoordinate.y
        },
        {
            x: offset.left + offset.width,
            y: activeCoordinate.y
        }
    ];
    if ((0, $4009b9153cff02e8$export$b8cdb4ab1d25db49)(activeCoordinate)) {
        if (layout === 'centric') {
            var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, angle: angle } = activeCoordinate;
            var innerPoint = (0, $d16c67d42be24ed1$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
            var outerPoint = (0, $d16c67d42be24ed1$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
            return [
                {
                    x: innerPoint.x,
                    y: innerPoint.y
                },
                {
                    x: outerPoint.x,
                    y: outerPoint.y
                }
            ];
        }
        return (0, $f8f3543ea7b06a66$export$ad661ef85a042a4f)(activeCoordinate);
    }
    return undefined;
}







function $4f265d8aa75f86ee$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4f265d8aa75f86ee$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4f265d8aa75f86ee$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4f265d8aa75f86ee$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4f265d8aa75f86ee$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4f265d8aa75f86ee$var$_defineProperty(e, r, t) {
    return (r = $4f265d8aa75f86ee$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4f265d8aa75f86ee$var$_toPropertyKey(t) {
    var i = $4f265d8aa75f86ee$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4f265d8aa75f86ee$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $4f265d8aa75f86ee$export$952de9be87065336 = ()=>(0, $bf278eb346227770$export$a7347740d65f620b)((0, $8f21bd235d951197$export$27d9004292294cd7));
var $4f265d8aa75f86ee$export$fd17f57c33e9d17e = ()=>{
    var tooltipAxis = $4f265d8aa75f86ee$export$952de9be87065336();
    var tooltipTicks = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $36d5b5b4d0834cee$export$ffe0e60f8c88c05a));
    var tooltipAxisScale = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $36d5b5b4d0834cee$export$cdeccbbdd343ae59));
    if (!tooltipAxis || !tooltipAxisScale) return (0, $912d8cf1d03ea507$export$212ec45c42fe68a7)(undefined, tooltipTicks);
    return (0, $912d8cf1d03ea507$export$212ec45c42fe68a7)($4f265d8aa75f86ee$var$_objectSpread($4f265d8aa75f86ee$var$_objectSpread({}, tooltipAxis), {}, {
        scale: tooltipAxisScale
    }), tooltipTicks);
};






function $94c469f4b8f0b968$var$_extends() {
    return $94c469f4b8f0b968$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $94c469f4b8f0b968$var$_extends.apply(null, arguments);
}
function $94c469f4b8f0b968$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $94c469f4b8f0b968$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $94c469f4b8f0b968$var$ownKeys(Object(t), !0).forEach(function(r) {
            $94c469f4b8f0b968$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $94c469f4b8f0b968$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $94c469f4b8f0b968$var$_defineProperty(e, r, t) {
    return (r = $94c469f4b8f0b968$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $94c469f4b8f0b968$var$_toPropertyKey(t) {
    var i = $94c469f4b8f0b968$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $94c469f4b8f0b968$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * If set false, no cursor will be drawn when tooltip is active.
 * If set an object, the option is the configuration of cursor.
 * If set a React element, the option is the custom react element of drawing cursor
 */ function $94c469f4b8f0b968$var$RenderCursor(_ref) {
    var { cursor: cursor, cursorComp: cursorComp, cursorProps: cursorProps } = _ref;
    if (/*#__PURE__*/ (0, $28UcW.isValidElement)(cursor)) return /*#__PURE__*/ (0, $28UcW.cloneElement)(cursor, cursorProps);
    return /*#__PURE__*/ (0, $28UcW.createElement)(cursorComp, cursorProps);
}
function $94c469f4b8f0b968$export$3ea3a57cbaeb6b4e(props) {
    var _props$zIndex;
    var { coordinate: coordinate, payload: payload, index: index, offset: offset, tooltipAxisBandSize: tooltipAxisBandSize, layout: layout, cursor: cursor, tooltipEventType: tooltipEventType, chartName: chartName } = props;
    // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
    var activeCoordinate = coordinate;
    var activePayload = payload;
    var activeTooltipIndex = index;
    if (!cursor || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
    var restProps, cursorComp, preferredZIndex;
    if (chartName === 'ScatterChart') {
        restProps = activeCoordinate;
        cursorComp = (0, $57b15cee458fffc0$export$3c877bb842c36952);
        preferredZIndex = (0, $45e92ad7df96f1e3$export$96df16b28aa32702).cursorLine;
    } else if (chartName === 'BarChart') {
        restProps = (0, $1d36c01cd7b0a196$export$f84ec1ecc69a13c9)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, $0237cf75d6781a88$export$4617fb02663045ef);
        preferredZIndex = (0, $45e92ad7df96f1e3$export$96df16b28aa32702).cursorRectangle;
    } else if (layout === 'radial' && (0, $4009b9153cff02e8$export$b8cdb4ab1d25db49)(activeCoordinate)) {
        var { cx: cx, cy: cy, radius: radius, startAngle: startAngle, endAngle: endAngle } = (0, $f8f3543ea7b06a66$export$ad661ef85a042a4f)(activeCoordinate);
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, $95f0b2df306fffbd$export$e98c2c7eb2b14f45);
        preferredZIndex = (0, $45e92ad7df96f1e3$export$96df16b28aa32702).cursorLine;
    } else {
        restProps = {
            points: (0, $6042b9e84cfd04b2$export$56e1305620ce5745)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, $5c6e6021af31f172$export$b0e83c3ef8d2db1);
        preferredZIndex = (0, $45e92ad7df96f1e3$export$96df16b28aa32702).cursorLine;
    }
    var extraClassName = typeof cursor === 'object' && 'className' in cursor ? cursor.className : undefined;
    var cursorProps = $94c469f4b8f0b968$var$_objectSpread($94c469f4b8f0b968$var$_objectSpread($94c469f4b8f0b968$var$_objectSpread($94c469f4b8f0b968$var$_objectSpread({
        stroke: '#ccc',
        pointerEvents: 'none'
    }, offset), restProps), (0, $3d820e26962aea02$export$6d5921c09aa671a9)(cursor)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: (0, $dP0oo.clsx)('recharts-tooltip-cursor', extraClassName)
    });
    return /*#__PURE__*/ $28UcW.createElement((0, $3603bfc8e6eb9e37$export$b37befaf92aba9f1), {
        zIndex: (_props$zIndex = props.zIndex) !== null && _props$zIndex !== void 0 ? _props$zIndex : preferredZIndex
    }, /*#__PURE__*/ $28UcW.createElement($94c469f4b8f0b968$var$RenderCursor, {
        cursor: cursor,
        cursorComp: cursorComp,
        cursorProps: cursorProps
    }));
}
function $94c469f4b8f0b968$export$b6a79797ad180576(props) {
    var tooltipAxisBandSize = (0, $4f265d8aa75f86ee$export$fd17f57c33e9d17e)();
    var offset = (0, $6ade474fe9f2b6e0$export$10605f61bef2858a)();
    var layout = (0, $6ade474fe9f2b6e0$export$970c79ecc7081cc)();
    var chartName = (0, $5ff82c06c780fa4c$export$ed30b3372172c46c)();
    if (tooltipAxisBandSize == null || offset == null || layout == null || chartName == null) return null;
    return /*#__PURE__*/ $28UcW.createElement($94c469f4b8f0b968$export$3ea3a57cbaeb6b4e, $94c469f4b8f0b968$var$_extends({}, props, {
        offset: offset,
        layout: layout,
        tooltipAxisBandSize: tooltipAxisBandSize,
        chartName: chartName
    }));
}









function $f713f1a518f2f838$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f713f1a518f2f838$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f713f1a518f2f838$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f713f1a518f2f838$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f713f1a518f2f838$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f713f1a518f2f838$var$_defineProperty(e, r, t) {
    return (r = $f713f1a518f2f838$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f713f1a518f2f838$var$_toPropertyKey(t) {
    var i = $f713f1a518f2f838$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f713f1a518f2f838$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f713f1a518f2f838$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $f713f1a518f2f838$var$renderContent(content, props) {
    if (/*#__PURE__*/ $28UcW.isValidElement(content)) return /*#__PURE__*/ $28UcW.cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ $28UcW.createElement(content, props);
    return /*#__PURE__*/ $28UcW.createElement((0, $8402e5e8b67ff3f6$export$6fe33945eebf9ac8), props);
}
var $f713f1a518f2f838$var$emptyPayload = [];
var $f713f1a518f2f838$export$3e858c907a5012de = {
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: 'ease',
    axisId: 0,
    contentStyle: {},
    cursor: true,
    filterNull: true,
    includeHidden: false,
    isAnimationActive: 'auto',
    itemSorter: 'name',
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: ' : ',
    trigger: 'hover',
    useTranslate3d: false,
    wrapperStyle: {}
};
function $f713f1a518f2f838$export$28c660c63b792dea(outsideProps) {
    var _useAppSelector, _ref;
    var props = (0, $2db4b31e06a7a91b$export$45004cc70a390ee8)(outsideProps, $f713f1a518f2f838$export$3e858c907a5012de);
    var { active: activeFromProps, allowEscapeViewBox: allowEscapeViewBox, animationDuration: animationDuration, animationEasing: animationEasing, content: content, filterNull: filterNull, isAnimationActive: isAnimationActive, offset: offset, payloadUniqBy: payloadUniqBy, position: position, reverseDirection: reverseDirection, useTranslate3d: useTranslate3d, wrapperStyle: wrapperStyle, cursor: cursor, shared: shared, trigger: trigger, defaultIndex: defaultIndex, portal: portalFromProps, axisId: axisId } = props;
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    var defaultIndexAsString = typeof defaultIndex === 'number' ? String(defaultIndex) : defaultIndex;
    (0, $28UcW.useEffect)(()=>{
        dispatch((0, $038eefd840ad861c$export$8d517a53c4528750)({
            shared: shared,
            trigger: trigger,
            axisId: axisId,
            active: activeFromProps,
            defaultIndex: defaultIndexAsString
        }));
    }, [
        dispatch,
        shared,
        trigger,
        axisId,
        activeFromProps,
        defaultIndexAsString
    ]);
    var viewBox = (0, $6ade474fe9f2b6e0$export$76b29bb074e0c45a)();
    var accessibilityLayer = (0, $7753843e36efc467$export$276788f18f24cad3)();
    var tooltipEventType = (0, $aab1adcf9dbc37ce$export$7ac1fe18a92be318)(shared);
    var { activeIndex: activeIndex, isActive: isActive } = (_useAppSelector = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $5ff82c06c780fa4c$export$c8884ed37796034a)(state, tooltipEventType, trigger, defaultIndexAsString))) !== null && _useAppSelector !== void 0 ? _useAppSelector : {};
    var payloadFromRedux = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $5ff82c06c780fa4c$export$529676bfdba08611)(state, tooltipEventType, trigger, defaultIndexAsString));
    var labelFromRedux = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $5ff82c06c780fa4c$export$400c35cc3b9a0487)(state, tooltipEventType, trigger, defaultIndexAsString));
    var coordinate = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $5ff82c06c780fa4c$export$392a0083df9bfd7c)(state, tooltipEventType, trigger, defaultIndexAsString));
    var payload = payloadFromRedux;
    var tooltipPortalFromContext = (0, $b4821fa4aeb9e847$export$2842d70d9d62127a)();
    /*
   * The user can set `active=true` on the Tooltip in which case the Tooltip will stay always active,
   * or `active=false` in which case the Tooltip never shows.
   *
   * If the `active` prop is not defined then it will show and hide based on mouse or keyboard activity.
   */ var finalIsActive = (_ref = activeFromProps !== null && activeFromProps !== void 0 ? activeFromProps : isActive) !== null && _ref !== void 0 ? _ref : false;
    var [lastBoundingBox, updateBoundingBox] = (0, $e74793f8d349d213$export$35f58fcda6094144)([
        payload,
        finalIsActive
    ]);
    var finalLabel = tooltipEventType === 'axis' ? labelFromRedux : undefined;
    (0, $1d357b3b480ea4d1$export$21f8394fb189b529)(tooltipEventType, trigger, coordinate, finalLabel, activeIndex, finalIsActive);
    var tooltipPortal = portalFromProps !== null && portalFromProps !== void 0 ? portalFromProps : tooltipPortalFromContext;
    if (tooltipPortal == null || viewBox == null || tooltipEventType == null) return null;
    var finalPayload = payload !== null && payload !== void 0 ? payload : $f713f1a518f2f838$var$emptyPayload;
    if (!finalIsActive) finalPayload = $f713f1a518f2f838$var$emptyPayload;
    if (filterNull && finalPayload.length) finalPayload = (0, $1e5ef0021e80e27b$export$b67e33c2fb1535fa)(finalPayload.filter((entry)=>entry.value != null && (entry.hide !== true || props.includeHidden)), payloadUniqBy, $f713f1a518f2f838$var$defaultUniqBy);
    var hasPayload = finalPayload.length > 0;
    var tooltipElement = /*#__PURE__*/ $28UcW.createElement((0, $50b47089332b3e48$export$9e6cee7b86551b9c), {
        allowEscapeViewBox: allowEscapeViewBox,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        isAnimationActive: isAnimationActive,
        active: finalIsActive,
        coordinate: coordinate,
        hasPayload: hasPayload,
        offset: offset,
        position: position,
        reverseDirection: reverseDirection,
        useTranslate3d: useTranslate3d,
        viewBox: viewBox,
        wrapperStyle: wrapperStyle,
        lastBoundingBox: lastBoundingBox,
        innerRef: updateBoundingBox,
        hasPortalFromProps: Boolean(portalFromProps)
    }, $f713f1a518f2f838$var$renderContent(content, $f713f1a518f2f838$var$_objectSpread($f713f1a518f2f838$var$_objectSpread({}, props), {}, {
        payload: finalPayload,
        label: finalLabel,
        active: finalIsActive,
        activeIndex: activeIndex,
        coordinate: coordinate,
        accessibilityLayer: accessibilityLayer
    })));
    return /*#__PURE__*/ $28UcW.createElement($28UcW.Fragment, null, /*#__PURE__*/ (0, $ac717a3ef8959bc0$exports.createPortal)(tooltipElement, tooltipPortal), finalIsActive && /*#__PURE__*/ $28UcW.createElement((0, $94c469f4b8f0b968$export$b6a79797ad180576), {
        cursor: cursor,
        tooltipEventType: tooltipEventType,
        coordinate: coordinate,
        payload: finalPayload,
        index: activeIndex
    }));
}


var $28UcW = parcelRequire("28UcW");

var $dP0oo = parcelRequire("dP0oo");








var $7f2b40120f0f91c9$var$_excluded = [
    "domain",
    "range"
], $7f2b40120f0f91c9$var$_excluded2 = [
    "domain",
    "range"
];
function $7f2b40120f0f91c9$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $7f2b40120f0f91c9$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $7f2b40120f0f91c9$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $7f2b40120f0f91c9$var$shortArraysAreEqual(arr1, arr2) {
    if (arr1 === arr2) return true;
    if (Array.isArray(arr1) && arr1.length === 2 && Array.isArray(arr2) && arr2.length === 2) return arr1[0] === arr2[0] && arr1[1] === arr2[1];
    return false;
}
function $7f2b40120f0f91c9$export$a803260e379f3736(prevProps, nextProps) {
    if (prevProps === nextProps) return true;
    var { domain: prevDomain, range: prevRange } = prevProps, prevRest = $7f2b40120f0f91c9$var$_objectWithoutProperties(prevProps, $7f2b40120f0f91c9$var$_excluded);
    var { domain: nextDomain, range: nextRange } = nextProps, nextRest = $7f2b40120f0f91c9$var$_objectWithoutProperties(nextProps, $7f2b40120f0f91c9$var$_excluded2);
    if (!$7f2b40120f0f91c9$var$shortArraysAreEqual(prevDomain, nextDomain)) return false;
    if (!$7f2b40120f0f91c9$var$shortArraysAreEqual(prevRange, nextRange)) return false;
    return (0, $b5b53d7d8a4bed40$export$b8f09df787c278d9)(prevRest, nextRest);
}


var $ca52201d00fbab86$var$_excluded = [
    "dangerouslySetInnerHTML",
    "ticks",
    "scale"
], $ca52201d00fbab86$var$_excluded2 = [
    "id",
    "scale"
];
function $ca52201d00fbab86$var$_extends() {
    return $ca52201d00fbab86$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ca52201d00fbab86$var$_extends.apply(null, arguments);
}
function $ca52201d00fbab86$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $ca52201d00fbab86$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $ca52201d00fbab86$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $ca52201d00fbab86$var$SetXAxisSettings(settings) {
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    var prevSettingsRef = (0, $28UcW.useRef)(null);
    (0, $28UcW.useLayoutEffect)(()=>{
        if (prevSettingsRef.current === null) dispatch((0, $1426ac70c5e0f1c4$export$add6226ad7812fc8)(settings));
        else if (prevSettingsRef.current !== settings) dispatch((0, $1426ac70c5e0f1c4$export$40aac341c282a543)({
            prev: prevSettingsRef.current,
            next: settings
        }));
        prevSettingsRef.current = settings;
    }, [
        settings,
        dispatch
    ]);
    (0, $28UcW.useLayoutEffect)(()=>{
        return ()=>{
            if (prevSettingsRef.current) {
                dispatch((0, $1426ac70c5e0f1c4$export$f408189458c6a79b)(prevSettingsRef.current));
                prevSettingsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}
var $ca52201d00fbab86$var$XAxisImpl = (props)=>{
    var { xAxisId: xAxisId, className: className } = props;
    var viewBox = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $4d79bfb805950901$export$32c8e778bac69ce4));
    var isPanorama = (0, $d64615d5c7c4e07c$export$4b0c59f8845ba920)();
    var axisType = 'xAxis';
    var cartesianTickItems = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $8f21bd235d951197$export$f0d85e8287c47657)(state, axisType, xAxisId, isPanorama));
    var axisSize = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $8f21bd235d951197$export$50d4085c87c19b12)(state, xAxisId));
    var position = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $8f21bd235d951197$export$92fdc590d2371053)(state, xAxisId));
    /*
   * Here we select settings from the store and prefer to use them instead of the actual props
   * so that the chart is consistent. If we used the props directly, some components will use axis settings
   * from state and some from props and because there is a render step between these two, they might be showing different things.
   * https://github.com/recharts/recharts/issues/6257
   */ var synchronizedSettings = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $8f21bd235d951197$export$8079b33b4a6a2ac5)(state, xAxisId));
    if (axisSize == null || position == null || synchronizedSettings == null) return null;
    var { dangerouslySetInnerHTML: dangerouslySetInnerHTML, ticks: ticks, scale: del } = props, allOtherProps = $ca52201d00fbab86$var$_objectWithoutProperties(props, $ca52201d00fbab86$var$_excluded);
    var { id: id, scale: del2 } = synchronizedSettings, restSynchronizedSettings = $ca52201d00fbab86$var$_objectWithoutProperties(synchronizedSettings, $ca52201d00fbab86$var$_excluded2);
    return /*#__PURE__*/ $28UcW.createElement((0, $c8f4efe43d81a1a3$export$bdd99f2cdf352bae), $ca52201d00fbab86$var$_extends({}, allOtherProps, restSynchronizedSettings, {
        x: position.x,
        y: position.y,
        width: axisSize.width,
        height: axisSize.height,
        className: (0, $dP0oo.clsx)("recharts-".concat(axisType, " ").concat(axisType), className),
        viewBox: viewBox,
        ticks: cartesianTickItems,
        axisType: axisType
    }));
};
var $ca52201d00fbab86$export$bf921d6fd02045a0 = {
    allowDataOverflow: (0, $8f21bd235d951197$export$21aec091b6ac8422).allowDataOverflow,
    allowDecimals: (0, $8f21bd235d951197$export$21aec091b6ac8422).allowDecimals,
    allowDuplicatedCategory: (0, $8f21bd235d951197$export$21aec091b6ac8422).allowDuplicatedCategory,
    angle: (0, $8f21bd235d951197$export$21aec091b6ac8422).angle,
    axisLine: (0, $c8f4efe43d81a1a3$export$179c35154a9748c0).axisLine,
    height: (0, $8f21bd235d951197$export$21aec091b6ac8422).height,
    hide: false,
    includeHidden: (0, $8f21bd235d951197$export$21aec091b6ac8422).includeHidden,
    interval: (0, $8f21bd235d951197$export$21aec091b6ac8422).interval,
    minTickGap: (0, $8f21bd235d951197$export$21aec091b6ac8422).minTickGap,
    mirror: (0, $8f21bd235d951197$export$21aec091b6ac8422).mirror,
    orientation: (0, $8f21bd235d951197$export$21aec091b6ac8422).orientation,
    padding: (0, $8f21bd235d951197$export$21aec091b6ac8422).padding,
    reversed: (0, $8f21bd235d951197$export$21aec091b6ac8422).reversed,
    scale: (0, $8f21bd235d951197$export$21aec091b6ac8422).scale,
    tick: (0, $8f21bd235d951197$export$21aec091b6ac8422).tick,
    tickCount: (0, $8f21bd235d951197$export$21aec091b6ac8422).tickCount,
    tickLine: (0, $c8f4efe43d81a1a3$export$179c35154a9748c0).tickLine,
    tickSize: (0, $c8f4efe43d81a1a3$export$179c35154a9748c0).tickSize,
    type: (0, $8f21bd235d951197$export$21aec091b6ac8422).type,
    xAxisId: 0
};
var $ca52201d00fbab86$var$XAxisSettingsDispatcher = (outsideProps)=>{
    var props = (0, $2db4b31e06a7a91b$export$45004cc70a390ee8)(outsideProps, $ca52201d00fbab86$export$bf921d6fd02045a0);
    return /*#__PURE__*/ $28UcW.createElement($28UcW.Fragment, null, /*#__PURE__*/ $28UcW.createElement($ca52201d00fbab86$var$SetXAxisSettings, {
        allowDataOverflow: props.allowDataOverflow,
        allowDecimals: props.allowDecimals,
        allowDuplicatedCategory: props.allowDuplicatedCategory,
        angle: props.angle,
        dataKey: props.dataKey,
        domain: props.domain,
        height: props.height,
        hide: props.hide,
        id: props.xAxisId,
        includeHidden: props.includeHidden,
        interval: props.interval,
        minTickGap: props.minTickGap,
        mirror: props.mirror,
        name: props.name,
        orientation: props.orientation,
        padding: props.padding,
        reversed: props.reversed,
        scale: props.scale,
        tick: props.tick,
        tickCount: props.tickCount,
        tickFormatter: props.tickFormatter,
        ticks: props.ticks,
        type: props.type,
        unit: props.unit
    }), /*#__PURE__*/ $28UcW.createElement($ca52201d00fbab86$var$XAxisImpl, props));
};
var $ca52201d00fbab86$export$ea77231de273b52d = /*#__PURE__*/ $28UcW.memo($ca52201d00fbab86$var$XAxisSettingsDispatcher, (0, $7f2b40120f0f91c9$export$a803260e379f3736));
$ca52201d00fbab86$export$ea77231de273b52d.displayName = 'XAxis';


var $28UcW = parcelRequire("28UcW");

var $dP0oo = parcelRequire("dP0oo");









var $2a03ff2aca785380$var$_excluded = [
    "dangerouslySetInnerHTML",
    "ticks",
    "scale"
], $2a03ff2aca785380$var$_excluded2 = [
    "id",
    "scale"
];
function $2a03ff2aca785380$var$_extends() {
    return $2a03ff2aca785380$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2a03ff2aca785380$var$_extends.apply(null, arguments);
}
function $2a03ff2aca785380$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $2a03ff2aca785380$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $2a03ff2aca785380$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $2a03ff2aca785380$var$SetYAxisSettings(settings) {
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    var prevSettingsRef = (0, $28UcW.useRef)(null);
    (0, $28UcW.useLayoutEffect)(()=>{
        if (prevSettingsRef.current === null) dispatch((0, $1426ac70c5e0f1c4$export$4ed10a19d7febea1)(settings));
        else if (prevSettingsRef.current !== settings) dispatch((0, $1426ac70c5e0f1c4$export$58b7fa4a7d4572f6)({
            prev: prevSettingsRef.current,
            next: settings
        }));
        prevSettingsRef.current = settings;
    }, [
        settings,
        dispatch
    ]);
    (0, $28UcW.useLayoutEffect)(()=>{
        return ()=>{
            if (prevSettingsRef.current) {
                dispatch((0, $1426ac70c5e0f1c4$export$79db5e9bd25f14c4)(prevSettingsRef.current));
                prevSettingsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}
var $2a03ff2aca785380$var$YAxisImpl = (props)=>{
    var { yAxisId: yAxisId, className: className, width: width, label: label } = props;
    var cartesianAxisRef = (0, $28UcW.useRef)(null);
    var labelRef = (0, $28UcW.useRef)(null);
    var viewBox = (0, $bf278eb346227770$export$a7347740d65f620b)((0, $4d79bfb805950901$export$32c8e778bac69ce4));
    var isPanorama = (0, $d64615d5c7c4e07c$export$4b0c59f8845ba920)();
    var dispatch = (0, $bf278eb346227770$export$f51d452c10d5b956)();
    var axisType = 'yAxis';
    var axisSize = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $8f21bd235d951197$export$249bec756af8ac39)(state, yAxisId));
    var position = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $8f21bd235d951197$export$e67a320452ebcaef)(state, yAxisId));
    var cartesianTickItems = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $8f21bd235d951197$export$f0d85e8287c47657)(state, axisType, yAxisId, isPanorama));
    /*
   * Here we select settings from the store and prefer to use them instead of the actual props
   * so that the chart is consistent. If we used the props directly, some components will use axis settings
   * from state and some from props and because there is a render step between these two, they might be showing different things.
   * https://github.com/recharts/recharts/issues/6257
   */ var synchronizedSettings = (0, $bf278eb346227770$export$a7347740d65f620b)((state)=>(0, $8f21bd235d951197$export$d0970661da76c14c)(state, yAxisId));
    (0, $28UcW.useLayoutEffect)(()=>{
        // No dynamic width calculation is done when width !== 'auto'
        // or when a function/react element is used for label
        if (width !== 'auto' || !axisSize || (0, $9290b2e14d5ce35d$export$96a48941c06f377f)(label) || /*#__PURE__*/ (0, $28UcW.isValidElement)(label) || synchronizedSettings == null) return;
        var axisComponent = cartesianAxisRef.current;
        if (!axisComponent) return;
        var updatedYAxisWidth = axisComponent.getCalculatedWidth();
        // if the width has changed, dispatch an action to update the width
        if (Math.round(axisSize.width) !== Math.round(updatedYAxisWidth)) dispatch((0, $1426ac70c5e0f1c4$export$6e42dbbf4e5a5faa)({
            id: yAxisId,
            width: updatedYAxisWidth
        }));
    }, [
        // The dependency on cartesianAxisRef.current is not needed because useLayoutEffect will run after every render.
        // The ref will be populated by then.
        // To re-run this effect when ticks change, we can depend on the ticks array from the store.
        cartesianTickItems,
        axisSize,
        dispatch,
        label,
        yAxisId,
        width,
        synchronizedSettings
    ]);
    if (axisSize == null || position == null || synchronizedSettings == null) return null;
    var { dangerouslySetInnerHTML: dangerouslySetInnerHTML, ticks: ticks, scale: del } = props, allOtherProps = $2a03ff2aca785380$var$_objectWithoutProperties(props, $2a03ff2aca785380$var$_excluded);
    var { id: id, scale: del2 } = synchronizedSettings, restSynchronizedSettings = $2a03ff2aca785380$var$_objectWithoutProperties(synchronizedSettings, $2a03ff2aca785380$var$_excluded2);
    return /*#__PURE__*/ $28UcW.createElement((0, $c8f4efe43d81a1a3$export$bdd99f2cdf352bae), $2a03ff2aca785380$var$_extends({}, allOtherProps, restSynchronizedSettings, {
        ref: cartesianAxisRef,
        labelRef: labelRef,
        x: position.x,
        y: position.y,
        tickTextProps: width === 'auto' ? {
            width: undefined
        } : {
            width: width
        },
        width: axisSize.width,
        height: axisSize.height,
        className: (0, $dP0oo.clsx)("recharts-".concat(axisType, " ").concat(axisType), className),
        viewBox: viewBox,
        ticks: cartesianTickItems,
        axisType: axisType
    }));
};
var $2a03ff2aca785380$export$299ffbfed5267dce = {
    allowDataOverflow: (0, $8f21bd235d951197$export$397148de2ecdec3c).allowDataOverflow,
    allowDecimals: (0, $8f21bd235d951197$export$397148de2ecdec3c).allowDecimals,
    allowDuplicatedCategory: (0, $8f21bd235d951197$export$397148de2ecdec3c).allowDuplicatedCategory,
    angle: (0, $8f21bd235d951197$export$397148de2ecdec3c).angle,
    axisLine: (0, $c8f4efe43d81a1a3$export$179c35154a9748c0).axisLine,
    hide: false,
    includeHidden: (0, $8f21bd235d951197$export$397148de2ecdec3c).includeHidden,
    interval: (0, $8f21bd235d951197$export$397148de2ecdec3c).interval,
    minTickGap: (0, $8f21bd235d951197$export$397148de2ecdec3c).minTickGap,
    mirror: (0, $8f21bd235d951197$export$397148de2ecdec3c).mirror,
    orientation: (0, $8f21bd235d951197$export$397148de2ecdec3c).orientation,
    padding: (0, $8f21bd235d951197$export$397148de2ecdec3c).padding,
    reversed: (0, $8f21bd235d951197$export$397148de2ecdec3c).reversed,
    scale: (0, $8f21bd235d951197$export$397148de2ecdec3c).scale,
    tick: (0, $8f21bd235d951197$export$397148de2ecdec3c).tick,
    tickCount: (0, $8f21bd235d951197$export$397148de2ecdec3c).tickCount,
    tickLine: (0, $c8f4efe43d81a1a3$export$179c35154a9748c0).tickLine,
    tickSize: (0, $c8f4efe43d81a1a3$export$179c35154a9748c0).tickSize,
    type: (0, $8f21bd235d951197$export$397148de2ecdec3c).type,
    width: (0, $8f21bd235d951197$export$397148de2ecdec3c).width,
    yAxisId: 0
};
var $2a03ff2aca785380$var$YAxisSettingsDispatcher = (outsideProps)=>{
    var props = (0, $2db4b31e06a7a91b$export$45004cc70a390ee8)(outsideProps, $2a03ff2aca785380$export$299ffbfed5267dce);
    return /*#__PURE__*/ $28UcW.createElement($28UcW.Fragment, null, /*#__PURE__*/ $28UcW.createElement($2a03ff2aca785380$var$SetYAxisSettings, {
        interval: props.interval,
        id: props.yAxisId,
        scale: props.scale,
        type: props.type,
        domain: props.domain,
        allowDataOverflow: props.allowDataOverflow,
        dataKey: props.dataKey,
        allowDuplicatedCategory: props.allowDuplicatedCategory,
        allowDecimals: props.allowDecimals,
        tickCount: props.tickCount,
        padding: props.padding,
        includeHidden: props.includeHidden,
        reversed: props.reversed,
        ticks: props.ticks,
        width: props.width,
        orientation: props.orientation,
        mirror: props.mirror,
        hide: props.hide,
        unit: props.unit,
        name: props.name,
        angle: props.angle,
        minTickGap: props.minTickGap,
        tick: props.tick,
        tickFormatter: props.tickFormatter
    }), /*#__PURE__*/ $28UcW.createElement($2a03ff2aca785380$var$YAxisImpl, props));
};
var $2a03ff2aca785380$export$f96c4024c52de8f4 = /*#__PURE__*/ $28UcW.memo($2a03ff2aca785380$var$YAxisSettingsDispatcher, (0, $7f2b40120f0f91c9$export$a803260e379f3736));
$2a03ff2aca785380$export$f96c4024c52de8f4.displayName = 'YAxis';


const $6fba7d71e245ae9d$export$7ff37a512047be2e = ({ data: data, formatDate: formatDate })=>{
    const chartData = data.map((d)=>({
            ...d,
            displayDate: formatDate(d.date)
        }));
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $529a92f522bce533$export$2e2bcd8739ae039), {
        className: "chart-container",
        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $fb5e151ecf96d720$export$e60a4704009a0009), {
            width: "100%",
            height: 400,
            children: /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $d8f2cb6cabd4e2ef$export$54d0e8420ac838ac), {
                data: chartData,
                margin: {
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5
                },
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $14fd122f24c9c808$export$6440e27b9f186856), {
                        strokeDasharray: "3 3"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $ca52201d00fbab86$export$ea77231de273b52d), {
                        dataKey: "displayDate",
                        tick: {
                            fontSize: 12
                        },
                        interval: Math.floor(data.length / 10)
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2a03ff2aca785380$export$f96c4024c52de8f4), {}),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f713f1a518f2f838$export$28c660c63b792dea), {
                        animationDuration: 0,
                        formatter: (value, name)=>{
                            const labels = {
                                totalCount: 'Total',
                                loggedInCount: 'Logged In',
                                loggedOutCount: 'Logged Out'
                            };
                            return [
                                value,
                                labels[name || ''] || name || ''
                            ];
                        },
                        labelFormatter: (label)=>{
                            const point = chartData.find((d)=>d.displayDate === label);
                            return point ? point.date : label;
                        },
                        itemSorter: (item)=>-item.value
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $1a4da5e443fb808c$export$ed247974535929c7), {
                        formatter: (value)=>{
                            const labels = {
                                totalCount: 'Total Visitors',
                                loggedInCount: 'Logged In Users',
                                loggedOutCount: 'Logged Out Users'
                            };
                            return labels[value] || value;
                        }
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $0af3c38f38567981$export$17d680238e50603e), {
                        type: "monotone",
                        dataKey: "totalCount",
                        stroke: "#8884d8",
                        strokeWidth: 2,
                        name: "totalCount"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $0af3c38f38567981$export$17d680238e50603e), {
                        type: "monotone",
                        dataKey: "loggedInCount",
                        stroke: "#82ca9d",
                        strokeWidth: 2,
                        name: "loggedInCount"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $0af3c38f38567981$export$17d680238e50603e), {
                        type: "monotone",
                        dataKey: "loggedOutCount",
                        stroke: "#ffc658",
                        strokeWidth: 2,
                        name: "loggedOutCount"
                    })
                ]
            })
        })
    });
};



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");



var $4XrX4 = parcelRequire("4XrX4");
parcelRequire("28UcW");
const $19563dc08e225e0c$export$18ec36e5748d6a7f = ({ puzzles: puzzles, onHover: onHover, onLeave: onLeave })=>{
    return /*#__PURE__*/ (0, $4XrX4.jsx)("ul", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            listStyle: 'none',
            padding: '10px 0',
            margin: 0,
            position: 'relative',
            zIndex: 20
        },
        children: puzzles.map((puzzle, index)=>/*#__PURE__*/ (0, $4XrX4.jsxs)("li", {
                style: {
                    marginRight: 20,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center'
                },
                onMouseEnter: ()=>onHover(puzzle.dataKey),
                onMouseLeave: onLeave,
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("svg", {
                        width: "14",
                        height: "14",
                        style: {
                            marginRight: 5
                        },
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)("rect", {
                            width: "14",
                            height: "14",
                            fill: puzzle.color
                        })
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                        style: {
                            fontSize: 14
                        },
                        children: puzzle.name
                    })
                ]
            }, `item-${index}`))
    });
};


const $2e81c08246c84a84$export$a03b90d0feb534fe = ({ title: title, data: data, puzzleConfigs: puzzleConfigs, formatDate: formatDate, hoveredPuzzle: hoveredPuzzle, onHover: onHover, onLeave: onLeave })=>{
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $529a92f522bce533$export$2e2bcd8739ae039), {
        mt: 6,
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f5a724df27408118$export$2e2bcd8739ae039), {
                variant: "h5",
                gutterBottom: true,
                children: title
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $529a92f522bce533$export$2e2bcd8739ae039), {
                className: "chart-container",
                position: "relative",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $fb5e151ecf96d720$export$e60a4704009a0009), {
                        width: "100%",
                        height: 400,
                        children: /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $d8f2cb6cabd4e2ef$export$54d0e8420ac838ac), {
                            data: data.map((d)=>({
                                    ...d,
                                    displayDate: formatDate(d.date)
                                })),
                            margin: {
                                top: 5,
                                right: 30,
                                left: 20,
                                bottom: 40
                            },
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $14fd122f24c9c808$export$6440e27b9f186856), {
                                    strokeDasharray: "3 3"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $ca52201d00fbab86$export$ea77231de273b52d), {
                                    dataKey: "displayDate",
                                    tick: {
                                        fontSize: 12
                                    },
                                    interval: Math.floor(data.length / 10)
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2a03ff2aca785380$export$f96c4024c52de8f4), {}),
                                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f713f1a518f2f838$export$28c660c63b792dea), {
                                    animationDuration: 0,
                                    labelFormatter: (label)=>{
                                        const point = data.find((d)=>formatDate(d.date) === label);
                                        return point ? point.date : label;
                                    },
                                    itemSorter: (item)=>-item.value
                                }),
                                puzzleConfigs.map((config)=>/*#__PURE__*/ (0, $4XrX4.jsx)((0, $0af3c38f38567981$export$17d680238e50603e), {
                                        type: "monotone",
                                        dataKey: config.dataKey,
                                        stroke: config.color,
                                        strokeWidth: 2,
                                        name: config.name,
                                        strokeOpacity: !hoveredPuzzle || hoveredPuzzle === config.dataKey ? 1 : 0.2
                                    }, config.dataKey))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $529a92f522bce533$export$2e2bcd8739ae039), {
                        position: "absolute",
                        bottom: "10px",
                        left: 0,
                        right: 0,
                        display: "flex",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $19563dc08e225e0c$export$18ec36e5748d6a7f), {
                            puzzles: puzzleConfigs,
                            onHover: onHover,
                            onLeave: onLeave
                        })
                    })
                ]
            })
        ]
    });
};



const $761676a2b4b59fb8$var$AdminAnalytics = ()=>{
    const [data, setData] = (0, $28UcW.useState)([]);
    const [puzzleOpens, setPuzzleOpens] = (0, $28UcW.useState)([]);
    const [puzzleSolves, setPuzzleSolves] = (0, $28UcW.useState)([]);
    const [loading, setLoading] = (0, $28UcW.useState)(true);
    const [error, setError] = (0, $28UcW.useState)(null);
    const [days, setDays] = (0, $28UcW.useState)(30);
    const [hoveredOpens, setHoveredOpens] = (0, $28UcW.useState)(null);
    const [hoveredSolves, setHoveredSolves] = (0, $28UcW.useState)(null);
    (0, $28UcW.useEffect)(()=>{
        fetchAnalytics();
    }, [
        days
    ]);
    const fetchAnalytics = async ()=>{
        try {
            setLoading(true);
            setError(null);
            const auth = (0, $de660e99e3126d7c$export$ae1af26003f05816)();
            const user = auth.currentUser;
            if (!user) {
                setError('You must be logged in to view analytics');
                setLoading(false);
                return;
            }
            const token = await user.getIdToken();
            const response = await (0, $ea74087fd5ac399e$export$2e2bcd8739ae039).get(`/api/analytics?days=${days}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setData(response.data.data);
            setPuzzleOpens(response.data.puzzleOpens);
            setPuzzleSolves(response.data.puzzleSolves);
            setLoading(false);
        } catch (err) {
            console.error('Error fetching analytics:', err);
            if (err.response?.status === 403) setError('Unauthorized - You do not have admin access');
            else setError('Failed to load analytics data');
            setLoading(false);
        }
    };
    const handleDaysChange = (event, newDays)=>{
        if (newDays !== null) setDays(newDays);
    };
    // Format date for display (MM/DD)
    const formatDate = (dateString)=>{
        const date = new Date(dateString);
        return `${date.getMonth() + 1}/${date.getDate()}`;
    };
    // Calculate summary stats for today (most recent date in the data)
    const today = data.length > 0 ? data[data.length - 1] : null;
    const todayVisitors = today?.totalCount || 0;
    const todayLoggedIn = today?.loggedInCount || 0;
    const todayLoggedOut = today?.loggedOutCount || 0;
    // Calculate total puzzle opens and solves for today
    const todayPuzzleOpensData = puzzleOpens.length > 0 ? puzzleOpens[puzzleOpens.length - 1] : null;
    const todayPuzzleSolvesData = puzzleSolves.length > 0 ? puzzleSolves[puzzleSolves.length - 1] : null;
    const todayOpens = todayPuzzleOpensData ? Object.keys(todayPuzzleOpensData).filter((k)=>k !== 'date').reduce((sum, key)=>sum + (Number(todayPuzzleOpensData[key]) || 0), 0) : 0;
    const todaySolves = todayPuzzleSolvesData ? Object.keys(todayPuzzleSolvesData).filter((k)=>k !== 'date').reduce((sum, key)=>sum + (Number(todayPuzzleSolvesData[key]) || 0), 0) : 0;
    return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $529a92f522bce533$export$2e2bcd8739ae039), {
        className: "admin-analytics-container",
        children: [
            loading && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $529a92f522bce533$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "calc(100vh - 200px)",
                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $9d16c19426fb8722$export$2e2bcd8739ae039), {})
            }),
            error && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $529a92f522bce533$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "calc(100vh - 200px)",
                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $af6f223451989330$export$2e2bcd8739ae039), {
                    severity: "error",
                    sx: {
                        maxWidth: 500
                    },
                    children: error
                })
            }),
            !loading && !error && data.length === 0 && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $529a92f522bce533$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "calc(100vh - 200px)",
                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $af6f223451989330$export$2e2bcd8739ae039), {
                    severity: "info",
                    children: "No analytics data available yet"
                })
            }),
            !loading && !error && data.length > 0 && /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $529a92f522bce533$export$2e2bcd8739ae039), {
                pt: 4,
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $55d80683716337ac$export$337812d3436a1a3d), {
                        value: days,
                        onChange: handleDaysChange
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $32a3ebf6780cac2b$export$b09a19a67293f946), {
                        visitors: todayVisitors,
                        loggedIn: todayLoggedIn,
                        loggedOut: todayLoggedOut,
                        puzzleOpens: todayOpens,
                        puzzleSolves: todaySolves
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $6fba7d71e245ae9d$export$7ff37a512047be2e), {
                        data: data,
                        formatDate: formatDate
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2e81c08246c84a84$export$a03b90d0feb534fe), {
                        title: "Puzzle Opens",
                        data: puzzleOpens,
                        puzzleConfigs: (0, $6efaf703600cb10e$export$793970db8e2e1ea1),
                        formatDate: formatDate,
                        hoveredPuzzle: hoveredOpens,
                        onHover: setHoveredOpens,
                        onLeave: ()=>setHoveredOpens(null)
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)((0, $2e81c08246c84a84$export$a03b90d0feb534fe), {
                        title: "Puzzle Solves",
                        data: puzzleSolves,
                        puzzleConfigs: (0, $6efaf703600cb10e$export$793970db8e2e1ea1),
                        formatDate: formatDate,
                        hoveredPuzzle: hoveredSolves,
                        onHover: setHoveredSolves,
                        onLeave: ()=>setHoveredSolves(null)
                    })
                ]
            })
        ]
    });
};
var $761676a2b4b59fb8$export$2e2bcd8739ae039 = $761676a2b4b59fb8$var$AdminAnalytics;



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");



var $53Ou4 = parcelRequire("53Ou4");

var $kLZMq = parcelRequire("kLZMq");

var $28UcW = parcelRequire("28UcW");


var $dP0oo = parcelRequire("dP0oo");

var $1fz9F = parcelRequire("1fz9F");

var $aMDDU = parcelRequire("aMDDU");

var $k5hQd = parcelRequire("k5hQd");

var $l9mID = parcelRequire("l9mID");


var $4XrX4 = parcelRequire("4XrX4");
'use client';
const $f72b7a47f8a31e91$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $f72b7a47f8a31e91$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $1fz9F.default)(slots, (0, $bdc8384d03faeed4$export$46f01d01378ec5a2), classes);
};
const $f72b7a47f8a31e91$var$DividerRoot = (0, $k5hQd.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kLZMq.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin'
    }, ownerState.absolute && {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%'
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $aMDDU.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === 'inset' && {
        marginLeft: 72
    }, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === 'vertical' && {
        height: '100%',
        borderBottomWidth: 0,
        borderRightWidth: 'thin'
    }, ownerState.flexItem && {
        alignSelf: 'stretch',
        height: 'auto'
    }), ({ ownerState: ownerState })=>(0, $kLZMq.default)({}, ownerState.children && {
        display: 'flex',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        border: 0,
        '&::before, &::after': {
            content: '""',
            alignSelf: 'center'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $kLZMq.default)({}, ownerState.children && ownerState.orientation !== 'vertical' && {
        '&::before, &::after': {
            width: '100%',
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $kLZMq.default)({}, ownerState.children && ownerState.orientation === 'vertical' && {
        flexDirection: 'column',
        '&::before, &::after': {
            height: '100%',
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ ownerState: ownerState })=>(0, $kLZMq.default)({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '90%'
        },
        '&::after': {
            width: '10%'
        }
    }, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '10%'
        },
        '&::after': {
            width: '90%'
        }
    }));
const $f72b7a47f8a31e91$var$DividerWrapper = (0, $k5hQd.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kLZMq.default)({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === 'vertical' && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $f72b7a47f8a31e91$var$Divider = /*#__PURE__*/ $28UcW.forwardRef(function Divider(inProps, ref) {
    const props = (0, $l9mID.default)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, orientation: orientation = 'horizontal', role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth' } = props, other = (0, $53Ou4.default)(props, $f72b7a47f8a31e91$var$_excluded);
    const ownerState = (0, $kLZMq.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $f72b7a47f8a31e91$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4XrX4.jsx)($f72b7a47f8a31e91$var$DividerRoot, (0, $kLZMq.default)({
        as: component,
        className: (0, $dP0oo.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $4XrX4.jsx)($f72b7a47f8a31e91$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $f72b7a47f8a31e91$var$Divider.muiSkipListHighlight = true;
var $f72b7a47f8a31e91$export$2e2bcd8739ae039 = $f72b7a47f8a31e91$var$Divider;


var $0fc40b88987a025e$exports = {};
"use strict";
"use client";

var $9C5EU = parcelRequire("9C5EU");
Object.defineProperty($0fc40b88987a025e$exports, "__esModule", {
    value: true
});
$0fc40b88987a025e$exports.default = void 0;

var $0fc40b88987a025e$var$_createSvgIcon = $9C5EU((parcelRequire("cfmhQ")));

var $4XrX4 = parcelRequire("4XrX4");
var $0fc40b88987a025e$var$_default = $0fc40b88987a025e$exports.default = (0, $0fc40b88987a025e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4XrX4.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96M14 13v4h-4v-4H7l5-5 5 5z"
}), 'CloudUpload');



const $9c810dcad9e38f9c$var$MorphologyProcessor = ()=>{
    const [file, setFile] = (0, $28UcW.useState)(null);
    const [startDate, setStartDate] = (0, $28UcW.useState)('');
    const [startingId, setStartingId] = (0, $28UcW.useState)('');
    const [loading, setLoading] = (0, $28UcW.useState)(false);
    const [error, setError] = (0, $28UcW.useState)(null);
    const [success, setSuccess] = (0, $28UcW.useState)(false);
    const [stats, setStats] = (0, $28UcW.useState)(null);
    const [processedData, setProcessedData] = (0, $28UcW.useState)(null);
    const [isDragging, setIsDragging] = (0, $28UcW.useState)(false);
    const handleFileChange = (event)=>{
        const selectedFile = event.target.files?.[0];
        if (selectedFile) {
            setFile(selectedFile);
            setError(null);
            setSuccess(false);
        }
    };
    const handleDragOver = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        setIsDragging(true);
    };
    const handleDragLeave = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        setIsDragging(false);
    };
    const handleDrop = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        setIsDragging(false);
        const droppedFile = event.dataTransfer.files?.[0];
        if (droppedFile && droppedFile.name.endsWith('.txt')) {
            setFile(droppedFile);
            setError(null);
            setSuccess(false);
        } else setError('Please drop a .txt file');
    };
    const handleSubmit = async (event)=>{
        event.preventDefault();
        if (!file) {
            setError('Please select a file to upload');
            return;
        }
        if (!startDate) {
            setError('Please enter a start date');
            return;
        }
        if (!startingId || parseInt(startingId) < 1) {
            setError('Please enter a valid starting ID (positive number)');
            return;
        }
        try {
            setLoading(true);
            setError(null);
            setSuccess(false);
            setStats(null);
            const auth = (0, $de660e99e3126d7c$export$ae1af26003f05816)();
            const user = auth.currentUser;
            if (!user) {
                setError('You must be logged in to use this tool');
                setLoading(false);
                return;
            }
            const token = await user.getIdToken();
            // Read file content
            const fileContent = await file.text();
            // Send to backend
            const response = await (0, $ea74087fd5ac399e$export$2e2bcd8739ae039).post('/api/admin/process-morphology', {
                fileContent: fileContent,
                startDate: startDate,
                startingId: parseInt(startingId)
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            if (response.data.success) {
                setSuccess(true);
                setStats(response.data.stats);
                setProcessedData(response.data.data);
            } else setError(response.data.error || 'Processing failed');
            setLoading(false);
        } catch (err) {
            console.error('Error processing morphology data:', err);
            if (err.response?.status === 403) setError('Unauthorized - You do not have admin access');
            else if (err.response?.data?.error) {
                const errorMsg = err.response.data.error;
                const lineNum = err.response.data.lineNumber;
                setError(lineNum ? `Line ${lineNum}: ${errorMsg}` : errorMsg);
            } else setError('Failed to process morphology data');
            setLoading(false);
        }
    };
    const handleDownload = ()=>{
        if (!processedData) return;
        const dataStr = JSON.stringify(processedData, null, 2);
        const blob = new Blob([
            dataStr
        ], {
            type: 'application/json'
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'morphology-processed.json';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $529a92f522bce533$export$2e2bcd8739ae039), {
        className: "morphology-processor-container",
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $529a92f522bce533$export$2e2bcd8739ae039), {
            className: "content-wrapper",
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f5a724df27408118$export$2e2bcd8739ae039), {
                    variant: "h4",
                    gutterBottom: true,
                    children: "Morphology Puzzle Processor"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f5a724df27408118$export$2e2bcd8739ae039), {
                    variant: "body2",
                    color: "textSecondary",
                    gutterBottom: true,
                    children: "Upload a morphology puzzle text file to process it into the final JSON format"
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f72b7a47f8a31e91$export$2e2bcd8739ae039), {
                    sx: {
                        my: 3
                    }
                }),
                /*#__PURE__*/ (0, $4XrX4.jsxs)("form", {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $ac02ff9d8c78ed7f$export$2e2bcd8739ae039), {
                            elevation: 2,
                            sx: {
                                p: 3,
                                mb: 3
                            },
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f5a724df27408118$export$2e2bcd8739ae039), {
                                    variant: "h6",
                                    gutterBottom: true,
                                    children: "Upload File"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $529a92f522bce533$export$2e2bcd8739ae039), {
                                    onDragOver: handleDragOver,
                                    onDragLeave: handleDragLeave,
                                    onDrop: handleDrop,
                                    sx: {
                                        border: '2px dashed',
                                        borderColor: isDragging ? 'primary.main' : 'grey.400',
                                        borderRadius: 2,
                                        p: 4,
                                        textAlign: 'center',
                                        backgroundColor: isDragging ? 'action.hover' : 'background.paper',
                                        transition: 'all 0.2s',
                                        cursor: 'pointer',
                                        mb: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0fc40b88987a025e$exports))), {
                                            sx: {
                                                fontSize: 48,
                                                color: 'action.active',
                                                mb: 1
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f5a724df27408118$export$2e2bcd8739ae039), {
                                            variant: "body1",
                                            gutterBottom: true,
                                            children: isDragging ? 'Drop file here' : 'Drag and drop a .txt file here'
                                        }),
                                        /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f5a724df27408118$export$2e2bcd8739ae039), {
                                            variant: "body2",
                                            color: "textSecondary",
                                            gutterBottom: true,
                                            children: "or"
                                        }),
                                        /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $85c133b03e2ea24a$export$2e2bcd8739ae039), {
                                            variant: "outlined",
                                            component: "label",
                                            startIcon: /*#__PURE__*/ (0, $4XrX4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0fc40b88987a025e$exports))), {}),
                                            children: [
                                                "Choose File",
                                                /*#__PURE__*/ (0, $4XrX4.jsx)("input", {
                                                    type: "file",
                                                    accept: ".txt",
                                                    hidden: true,
                                                    onChange: handleFileChange
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                file && /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $af6f223451989330$export$2e2bcd8739ae039), {
                                    severity: "info",
                                    sx: {
                                        mt: 2
                                    },
                                    children: [
                                        "Selected: ",
                                        file.name
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $ac02ff9d8c78ed7f$export$2e2bcd8739ae039), {
                            elevation: 2,
                            sx: {
                                p: 3,
                                mb: 3
                            },
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f5a724df27408118$export$2e2bcd8739ae039), {
                                    variant: "h6",
                                    gutterBottom: true,
                                    children: "Configuration"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d282dc2bd9d0947e$export$2e2bcd8739ae039), {
                                    label: "Start Date",
                                    type: "date",
                                    value: startDate,
                                    onChange: (e)=>setStartDate(e.target.value),
                                    fullWidth: true,
                                    sx: {
                                        mb: 2
                                    },
                                    InputLabelProps: {
                                        shrink: true
                                    },
                                    helperText: "First puzzle date (YYYY-MM-DD format)"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d282dc2bd9d0947e$export$2e2bcd8739ae039), {
                                    label: "Starting ID",
                                    type: "number",
                                    value: startingId,
                                    onChange: (e)=>setStartingId(e.target.value),
                                    fullWidth: true,
                                    helperText: "ID for the first puzzle",
                                    inputProps: {
                                        min: 1
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)((0, $529a92f522bce533$export$2e2bcd8739ae039), {
                            display: "flex",
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $85c133b03e2ea24a$export$2e2bcd8739ae039), {
                                type: "submit",
                                variant: "contained",
                                color: "primary",
                                size: "large",
                                disabled: loading || !file || !startDate || !startingId,
                                sx: {
                                    minWidth: 200
                                },
                                children: loading ? /*#__PURE__*/ (0, $4XrX4.jsx)((0, $9d16c19426fb8722$export$2e2bcd8739ae039), {
                                    size: 24
                                }) : 'Process Puzzles'
                            })
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $af6f223451989330$export$2e2bcd8739ae039), {
                    severity: "error",
                    sx: {
                        mt: 3
                    },
                    children: error
                }),
                success && stats && /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $529a92f522bce533$export$2e2bcd8739ae039), {
                    mt: 3,
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsx)((0, $af6f223451989330$export$2e2bcd8739ae039), {
                            severity: "success",
                            sx: {
                                mb: 2
                            },
                            children: "Processing completed successfully!"
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $ac02ff9d8c78ed7f$export$2e2bcd8739ae039), {
                            elevation: 2,
                            sx: {
                                p: 3
                            },
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $f5a724df27408118$export$2e2bcd8739ae039), {
                                    variant: "h6",
                                    gutterBottom: true,
                                    children: "Processing Stats"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $f5a724df27408118$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    children: [
                                        "Original puzzles: ",
                                        stats.originalPuzzleCount
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $f5a724df27408118$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    children: [
                                        "Total entries (with Katie placeholders): ",
                                        stats.totalEntries
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $f5a724df27408118$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    children: [
                                        "Katie placeholders added: ",
                                        stats.katiePlaceholders
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $f5a724df27408118$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    children: [
                                        "Date range: ",
                                        stats.dateRange.start,
                                        " to ",
                                        stats.dateRange.end
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $f5a724df27408118$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    children: [
                                        "ID range: ",
                                        stats.idRange.start,
                                        " to ",
                                        stats.idRange.end
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)((0, $85c133b03e2ea24a$export$2e2bcd8739ae039), {
                                    variant: "contained",
                                    color: "secondary",
                                    onClick: handleDownload,
                                    sx: {
                                        mt: 2
                                    },
                                    children: "Download JSON"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $9c810dcad9e38f9c$export$2e2bcd8739ae039 = $9c810dcad9e38f9c$var$MorphologyProcessor;



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");

var $2c10585caa95ace7$exports = {};
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/ (function(f) {
    var g;
    $2c10585caa95ace7$exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    'use strict';
                    var Mutation = global1.MutationObserver || global1.WebKitMutationObserver;
                    var scheduleDrain;
                    if (Mutation) {
                        var called = 0;
                        var observer = new Mutation(nextTick);
                        var element = global1.document.createTextNode('');
                        observer.observe(element, {
                            characterData: true
                        });
                        scheduleDrain = function() {
                            element.data = called = ++called % 2;
                        };
                    } else if (!global1.setImmediate && typeof global1.MessageChannel !== 'undefined') {
                        var channel = new global1.MessageChannel();
                        channel.port1.onmessage = nextTick;
                        scheduleDrain = function() {
                            channel.port2.postMessage(0);
                        };
                    } else if ('document' in global1 && 'onreadystatechange' in global1.document.createElement('script')) scheduleDrain = function() {
                        // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
                        // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
                        var scriptEl = global1.document.createElement('script');
                        scriptEl.onreadystatechange = function() {
                            nextTick();
                            scriptEl.onreadystatechange = null;
                            scriptEl.parentNode.removeChild(scriptEl);
                            scriptEl = null;
                        };
                        global1.document.documentElement.appendChild(scriptEl);
                    };
                    else scheduleDrain = function() {
                        setTimeout(nextTick, 0);
                    };
                    var draining;
                    var queue = [];
                    //named nextTick for less confusing stack traces
                    function nextTick() {
                        draining = true;
                        var i, oldQueue;
                        var len = queue.length;
                        while(len){
                            oldQueue = queue;
                            queue = [];
                            i = -1;
                            while(++i < len)oldQueue[i]();
                            len = queue.length;
                        }
                        draining = false;
                    }
                    module1.exports = immediate;
                    function immediate(task) {
                        if (queue.push(task) === 1 && !draining) scheduleDrain();
                    }
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ],
        2: [
            function(_dereq_, module1, exports) {
                'use strict';
                var immediate = _dereq_(1);
                /* istanbul ignore next */ function INTERNAL() {}
                var handlers = {};
                var REJECTED = [
                    'REJECTED'
                ];
                var FULFILLED = [
                    'FULFILLED'
                ];
                var PENDING = [
                    'PENDING'
                ];
                module1.exports = Promise1;
                function Promise1(resolver) {
                    if (typeof resolver !== 'function') throw new TypeError('resolver must be a function');
                    this.state = PENDING;
                    this.queue = [];
                    this.outcome = void 0;
                    if (resolver !== INTERNAL) safelyResolveThenable(this, resolver);
                }
                Promise1.prototype["catch"] = function(onRejected) {
                    return this.then(null, onRejected);
                };
                Promise1.prototype.then = function(onFulfilled, onRejected) {
                    if (typeof onFulfilled !== 'function' && this.state === FULFILLED || typeof onRejected !== 'function' && this.state === REJECTED) return this;
                    var promise = new this.constructor(INTERNAL);
                    if (this.state !== PENDING) {
                        var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
                        unwrap(promise, resolver, this.outcome);
                    } else this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
                    return promise;
                };
                function QueueItem(promise, onFulfilled, onRejected) {
                    this.promise = promise;
                    if (typeof onFulfilled === 'function') {
                        this.onFulfilled = onFulfilled;
                        this.callFulfilled = this.otherCallFulfilled;
                    }
                    if (typeof onRejected === 'function') {
                        this.onRejected = onRejected;
                        this.callRejected = this.otherCallRejected;
                    }
                }
                QueueItem.prototype.callFulfilled = function(value) {
                    handlers.resolve(this.promise, value);
                };
                QueueItem.prototype.otherCallFulfilled = function(value) {
                    unwrap(this.promise, this.onFulfilled, value);
                };
                QueueItem.prototype.callRejected = function(value) {
                    handlers.reject(this.promise, value);
                };
                QueueItem.prototype.otherCallRejected = function(value) {
                    unwrap(this.promise, this.onRejected, value);
                };
                function unwrap(promise, func, value) {
                    immediate(function() {
                        var returnValue;
                        try {
                            returnValue = func(value);
                        } catch (e) {
                            return handlers.reject(promise, e);
                        }
                        if (returnValue === promise) handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
                        else handlers.resolve(promise, returnValue);
                    });
                }
                handlers.resolve = function(self1, value) {
                    var result = tryCatch(getThen, value);
                    if (result.status === 'error') return handlers.reject(self1, result.value);
                    var thenable = result.value;
                    if (thenable) safelyResolveThenable(self1, thenable);
                    else {
                        self1.state = FULFILLED;
                        self1.outcome = value;
                        var i = -1;
                        var len = self1.queue.length;
                        while(++i < len)self1.queue[i].callFulfilled(value);
                    }
                    return self1;
                };
                handlers.reject = function(self1, error) {
                    self1.state = REJECTED;
                    self1.outcome = error;
                    var i = -1;
                    var len = self1.queue.length;
                    while(++i < len)self1.queue[i].callRejected(error);
                    return self1;
                };
                function getThen(obj) {
                    // Make sure we only access the accessor once as required by the spec
                    var then = obj && obj.then;
                    if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') return function appyThen() {
                        then.apply(obj, arguments);
                    };
                }
                function safelyResolveThenable(self1, thenable) {
                    // Either fulfill, reject or reject with error
                    var called = false;
                    function onError(value) {
                        if (called) return;
                        called = true;
                        handlers.reject(self1, value);
                    }
                    function onSuccess(value) {
                        if (called) return;
                        called = true;
                        handlers.resolve(self1, value);
                    }
                    function tryToUnwrap() {
                        thenable(onSuccess, onError);
                    }
                    var result = tryCatch(tryToUnwrap);
                    if (result.status === 'error') onError(result.value);
                }
                function tryCatch(func, value) {
                    var out = {};
                    try {
                        out.value = func(value);
                        out.status = 'success';
                    } catch (e) {
                        out.status = 'error';
                        out.value = e;
                    }
                    return out;
                }
                Promise1.resolve = resolve;
                function resolve(value) {
                    if (value instanceof this) return value;
                    return handlers.resolve(new this(INTERNAL), value);
                }
                Promise1.reject = reject;
                function reject(reason) {
                    var promise = new this(INTERNAL);
                    return handlers.reject(promise, reason);
                }
                Promise1.all = all;
                function all(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== '[object Array]') return this.reject(new TypeError('must be an array'));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var values = new Array(len);
                    var resolved = 0;
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)allResolver(iterable[i], i);
                    return promise;
                    function allResolver(value, i) {
                        self1.resolve(value).then(resolveFromAll, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                        function resolveFromAll(outValue) {
                            values[i] = outValue;
                            if (++resolved === len && !called) {
                                called = true;
                                handlers.resolve(promise, values);
                            }
                        }
                    }
                }
                Promise1.race = race;
                function race(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== '[object Array]') return this.reject(new TypeError('must be an array'));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)resolver(iterable[i]);
                    return promise;
                    function resolver(value) {
                        self1.resolve(value).then(function(response) {
                            if (!called) {
                                called = true;
                                handlers.resolve(promise, response);
                            }
                        }, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                    }
                }
            },
            {
                "1": 1
            }
        ],
        3: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    'use strict';
                    if (typeof global1.Promise !== 'function') global1.Promise = _dereq_(2);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "2": 2
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                'use strict';
                var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function getIDB() {
                    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */ try {
                        if (typeof indexedDB !== 'undefined') return indexedDB;
                        if (typeof webkitIndexedDB !== 'undefined') return webkitIndexedDB;
                        if (typeof mozIndexedDB !== 'undefined') return mozIndexedDB;
                        if (typeof OIndexedDB !== 'undefined') return OIndexedDB;
                        if (typeof msIndexedDB !== 'undefined') return msIndexedDB;
                    } catch (e) {
                        return;
                    }
                }
                var idb = getIDB();
                function isIndexedDBValid() {
                    try {
                        // Initialize IndexedDB; fall back to vendor-prefixed versions
                        // if needed.
                        if (!idb || !idb.open) return false;
                        // We mimic PouchDB here;
                        //
                        // We test for openDatabase because IE Mobile identifies itself
                        // as Safari. Oh the lulz...
                        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
                        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;
                        // Safari <10.1 does not meet our requirements for IDB support
                        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
                        // Safari 10.1 shipped with fetch, we can use that to detect it.
                        // Note: this creates issues with `window.fetch` polyfills and
                        // overrides; see:
                        // https://github.com/localForage/localForage/issues/856
                        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' && // some outdated implementations of IDB that appear on Samsung
                        // and HTC Android devices <4.4 are missing IDBKeyRange
                        // See: https://github.com/mozilla/localForage/issues/128
                        // See: https://github.com/mozilla/localForage/issues/272
                        typeof IDBKeyRange !== 'undefined';
                    } catch (e) {
                        return false;
                    }
                }
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                function createBlob(parts, properties) {
                    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */ parts = parts || [];
                    properties = properties || {};
                    try {
                        return new Blob(parts, properties);
                    } catch (e) {
                        if (e.name !== 'TypeError') throw e;
                        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
                        var builder = new Builder();
                        for(var i = 0; i < parts.length; i += 1)builder.append(parts[i]);
                        return builder.getBlob(properties.type);
                    }
                }
                // This is CommonJS because lie is an external dependency, so Rollup
                // can just ignore it.
                if (typeof Promise === 'undefined') // In the "nopromises" build this will just throw if you don't have
                // a global promise object, but it would throw anyway later.
                _dereq_(3);
                var Promise$1 = Promise;
                function executeCallback(promise, callback) {
                    if (callback) promise.then(function(result) {
                        callback(null, result);
                    }, function(error) {
                        callback(error);
                    });
                }
                function executeTwoCallbacks(promise, callback, errorCallback) {
                    if (typeof callback === 'function') promise.then(callback);
                    if (typeof errorCallback === 'function') promise["catch"](errorCallback);
                }
                function normalizeKey(key) {
                    // Cast the key to a string, as that's all we can set as a key.
                    if (typeof key !== 'string') {
                        console.warn(key + ' used as a key, but it is not a string.');
                        key = String(key);
                    }
                    return key;
                }
                function getCallback() {
                    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') return arguments[arguments.length - 1];
                }
                // Some code originally from async_storage.js in
                // [Gaia](https://github.com/mozilla-b2g/gaia).
                var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
                var supportsBlobs = void 0;
                var dbContexts = {};
                var toString = Object.prototype.toString;
                // Transaction Modes
                var READ_ONLY = 'readonly';
                var READ_WRITE = 'readwrite';
                // Transform a binary string to an array buffer, because otherwise
                // weird stuff happens when you try to work with the binary string directly.
                // It is known.
                // From http://stackoverflow.com/questions/14967647/ (continues on next line)
                // encode-decode-image-with-base64-breaks-image (2013-04-21)
                function _binStringToArrayBuffer(bin) {
                    var length = bin.length;
                    var buf = new ArrayBuffer(length);
                    var arr = new Uint8Array(buf);
                    for(var i = 0; i < length; i++)arr[i] = bin.charCodeAt(i);
                    return buf;
                }
                //
                // Blobs are not supported in all versions of IndexedDB, notably
                // Chrome <37 and Android <5. In those versions, storing a blob will throw.
                //
                // Various other blob bugs exist in Chrome v37-42 (inclusive).
                // Detecting them is expensive and confusing to users, and Chrome 37-42
                // is at very low usage worldwide, so we do a hacky userAgent check instead.
                //
                // content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
                // 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
                // FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
                //
                // Code borrowed from PouchDB. See:
                // https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
                //
                function _checkBlobSupportWithoutCaching(idb) {
                    return new Promise$1(function(resolve) {
                        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
                        var blob = createBlob([
                            ''
                        ]);
                        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');
                        txn.onabort = function(e) {
                            // If the transaction aborts now its due to not being able to
                            // write to the database, likely due to the disk being full
                            e.preventDefault();
                            e.stopPropagation();
                            resolve(false);
                        };
                        txn.oncomplete = function() {
                            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
                            var matchedEdge = navigator.userAgent.match(/Edge\//);
                            // MS Edge pretends to be Chrome 42:
                            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
                            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
                        };
                    })["catch"](function() {
                        return false; // error, so assume unsupported
                    });
                }
                function _checkBlobSupport(idb) {
                    if (typeof supportsBlobs === 'boolean') return Promise$1.resolve(supportsBlobs);
                    return _checkBlobSupportWithoutCaching(idb).then(function(value) {
                        supportsBlobs = value;
                        return supportsBlobs;
                    });
                }
                function _deferReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Create a deferred object representing the current database operation.
                    var deferredOperation = {};
                    deferredOperation.promise = new Promise$1(function(resolve, reject) {
                        deferredOperation.resolve = resolve;
                        deferredOperation.reject = reject;
                    });
                    // Enqueue the deferred operation.
                    dbContext.deferredOperations.push(deferredOperation);
                    // Chain its promise to the database readiness.
                    if (!dbContext.dbReady) dbContext.dbReady = deferredOperation.promise;
                    else dbContext.dbReady = dbContext.dbReady.then(function() {
                        return deferredOperation.promise;
                    });
                }
                function _advanceReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Resolve its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.resolve();
                        return deferredOperation.promise;
                    }
                }
                function _rejectReadiness(dbInfo, err) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Reject its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.reject(err);
                        return deferredOperation.promise;
                    }
                }
                function _getConnection(dbInfo, upgradeNeeded) {
                    return new Promise$1(function(resolve, reject) {
                        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
                        if (dbInfo.db) {
                            if (upgradeNeeded) {
                                _deferReadiness(dbInfo);
                                dbInfo.db.close();
                            } else return resolve(dbInfo.db);
                        }
                        var dbArgs = [
                            dbInfo.name
                        ];
                        if (upgradeNeeded) dbArgs.push(dbInfo.version);
                        var openreq = idb.open.apply(idb, dbArgs);
                        if (upgradeNeeded) openreq.onupgradeneeded = function(e) {
                            var db = openreq.result;
                            try {
                                db.createObjectStore(dbInfo.storeName);
                                if (e.oldVersion <= 1) // Added when support for blob shims was added
                                db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                            } catch (ex) {
                                if (ex.name === 'ConstraintError') console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                                else throw ex;
                            }
                        };
                        openreq.onerror = function(e) {
                            e.preventDefault();
                            reject(openreq.error);
                        };
                        openreq.onsuccess = function() {
                            var db = openreq.result;
                            db.onversionchange = function(e) {
                                // Triggered when the database is modified (e.g. adding an objectStore) or
                                // deleted (even when initiated by other sessions in different tabs).
                                // Closing the connection here prevents those operations from being blocked.
                                // If the database is accessed again later by this instance, the connection
                                // will be reopened or the database recreated as needed.
                                e.target.close();
                            };
                            resolve(db);
                            _advanceReadiness(dbInfo);
                        };
                    });
                }
                function _getOriginalConnection(dbInfo) {
                    return _getConnection(dbInfo, false);
                }
                function _getUpgradedConnection(dbInfo) {
                    return _getConnection(dbInfo, true);
                }
                function _isUpgradeNeeded(dbInfo, defaultVersion) {
                    if (!dbInfo.db) return true;
                    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
                    var isDowngrade = dbInfo.version < dbInfo.db.version;
                    var isUpgrade = dbInfo.version > dbInfo.db.version;
                    if (isDowngrade) {
                        // If the version is not the default one
                        // then warn for impossible downgrade.
                        if (dbInfo.version !== defaultVersion) console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
                        // Align the versions to prevent errors.
                        dbInfo.version = dbInfo.db.version;
                    }
                    if (isUpgrade || isNewStore) {
                        // If the store is new then increment the version (if needed).
                        // This will trigger an "upgradeneeded" event which is required
                        // for creating a store.
                        if (isNewStore) {
                            var incVersion = dbInfo.db.version + 1;
                            if (incVersion > dbInfo.version) dbInfo.version = incVersion;
                        }
                        return true;
                    }
                    return false;
                }
                // encode a blob for indexeddb engines that don't support blobs
                function _encodeBlob(blob) {
                    return new Promise$1(function(resolve, reject) {
                        var reader = new FileReader();
                        reader.onerror = reject;
                        reader.onloadend = function(e) {
                            var base64 = btoa(e.target.result || '');
                            resolve({
                                __local_forage_encoded_blob: true,
                                data: base64,
                                type: blob.type
                            });
                        };
                        reader.readAsBinaryString(blob);
                    });
                }
                // decode an encoded blob
                function _decodeBlob(encodedBlob) {
                    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
                    return createBlob([
                        arrayBuff
                    ], {
                        type: encodedBlob.type
                    });
                }
                // is this one of our fancy encoded blobs?
                function _isEncodedBlob(value) {
                    return value && value.__local_forage_encoded_blob;
                }
                // Specialize the default `ready()` function by making it dependent
                // on the current database operations. Thus, the driver will be actually
                // ready when it's been initialized (default) *and* there are no pending
                // operations on the database (initiated by some other instances).
                function _fullyReady(callback) {
                    var self1 = this;
                    var promise = self1._initReady().then(function() {
                        var dbContext = dbContexts[self1._dbInfo.name];
                        if (dbContext && dbContext.dbReady) return dbContext.dbReady;
                    });
                    executeTwoCallbacks(promise, callback, callback);
                    return promise;
                }
                // Try to establish a new db connection to replace the
                // current one which is broken (i.e. experiencing
                // InvalidStateError while creating a transaction).
                function _tryReconnect(dbInfo) {
                    _deferReadiness(dbInfo);
                    var dbContext = dbContexts[dbInfo.name];
                    var forages = dbContext.forages;
                    for(var i = 0; i < forages.length; i++){
                        var forage = forages[i];
                        if (forage._dbInfo.db) {
                            forage._dbInfo.db.close();
                            forage._dbInfo.db = null;
                        }
                    }
                    dbInfo.db = null;
                    return _getOriginalConnection(dbInfo).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        // store the latest db reference
                        // in case the db was upgraded
                        dbInfo.db = dbContext.db = db;
                        for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                    })["catch"](function(err) {
                        _rejectReadiness(dbInfo, err);
                        throw err;
                    });
                }
                // FF doesn't like Promises (micro-tasks) and IDDB store operations,
                // so we have to do it with callbacks
                function createTransaction(dbInfo, mode, callback, retries) {
                    if (retries === undefined) retries = 1;
                    try {
                        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
                        callback(null, tx);
                    } catch (err) {
                        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) return Promise$1.resolve().then(function() {
                            if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                                // increase the db version, to create the new ObjectStore
                                if (dbInfo.db) dbInfo.version = dbInfo.db.version + 1;
                                // Reopen the database for upgrading.
                                return _getUpgradedConnection(dbInfo);
                            }
                        }).then(function() {
                            return _tryReconnect(dbInfo).then(function() {
                                createTransaction(dbInfo, mode, callback, retries - 1);
                            });
                        })["catch"](callback);
                        callback(err);
                    }
                }
                function createDbContext() {
                    return {
                        // Running localForages sharing a database.
                        forages: [],
                        // Shared database.
                        db: null,
                        // Database readiness (promise).
                        dbReady: null,
                        // Deferred operations on the database.
                        deferredOperations: []
                    };
                }
                // Open the IndexedDB database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    // Get the current context of the database;
                    var dbContext = dbContexts[dbInfo.name];
                    // ...or create a new context.
                    if (!dbContext) {
                        dbContext = createDbContext();
                        // Register the new context in the global container.
                        dbContexts[dbInfo.name] = dbContext;
                    }
                    // Register itself as a running localForage in the current context.
                    dbContext.forages.push(self1);
                    // Replace the default `ready()` function with the specialized one.
                    if (!self1._initReady) {
                        self1._initReady = self1.ready;
                        self1.ready = _fullyReady;
                    }
                    // Create an array of initialization states of the related localForages.
                    var initPromises = [];
                    function ignoreErrors() {
                        // Don't handle errors here,
                        // just makes sure related localForages aren't pending.
                        return Promise$1.resolve();
                    }
                    for(var j = 0; j < dbContext.forages.length; j++){
                        var forage = dbContext.forages[j];
                        if (forage !== self1) // Don't wait for itself...
                        initPromises.push(forage._initReady()["catch"](ignoreErrors));
                    }
                    // Take a snapshot of the related localForages.
                    var forages = dbContext.forages.slice(0);
                    // Initialize the connection process only when
                    // all the related localForages aren't pending.
                    return Promise$1.all(initPromises).then(function() {
                        dbInfo.db = dbContext.db;
                        // Get the connection or open a new one without upgrade.
                        return _getOriginalConnection(dbInfo);
                    }).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo, self1._defaultConfig.version)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        dbInfo.db = dbContext.db = db;
                        self1._dbInfo = dbInfo;
                        // Share the final connection amongst related localForages.
                        for(var k = 0; k < forages.length; k++){
                            var forage = forages[k];
                            if (forage !== self1) {
                                // Self is already up-to-date.
                                forage._dbInfo.db = dbInfo.db;
                                forage._dbInfo.version = dbInfo.version;
                            }
                        }
                    });
                }
                function getItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.get(key);
                                    req.onsuccess = function() {
                                        var value = req.result;
                                        if (value === undefined) value = null;
                                        if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                        resolve(value);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items stored in database.
                function iterate(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openCursor();
                                    var iterationNumber = 1;
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (cursor) {
                                            var value = cursor.value;
                                            if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                            var result = iterator(value, cursor.key, iterationNumber++);
                                            // when the iterator callback returns any
                                            // (non-`undefined`) value, then we stop
                                            // the iteration immediately
                                            if (result !== void 0) resolve(result);
                                            else cursor["continue"]();
                                        } else resolve();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        var dbInfo;
                        self1.ready().then(function() {
                            dbInfo = self1._dbInfo;
                            if (toString.call(value) === '[object Blob]') return _checkBlobSupport(dbInfo.db).then(function(blobSupport) {
                                if (blobSupport) return value;
                                return _encodeBlob(value);
                            });
                            return value;
                        }).then(function(value) {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // The reason we don't _save_ null is because IE 10 does
                                    // not support saving the `null` type in IndexedDB. How
                                    // ironic, given the bug below!
                                    // See: https://github.com/mozilla/localForage/issues/161
                                    if (value === null) value = undefined;
                                    var req = store.put(value, key);
                                    transaction.oncomplete = function() {
                                        // Cast to undefined so the value passed to
                                        // callback/promise is the same as what one would get out
                                        // of `getItem()` later. This leads to some weirdness
                                        // (setItem('foo', undefined) will return `null`), but
                                        // it's not my fault localStorage is our baseline and that
                                        // it's weird.
                                        if (value === undefined) value = null;
                                        resolve(value);
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function removeItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // We use a Grunt task to make this safe for IE and some
                                    // versions of Android (including those used by Cordova).
                                    // Normally IE won't like `.delete()` and will insist on
                                    // using `['delete']()`, but we have a build step that
                                    // fixes this for us now.
                                    var req = store["delete"](key);
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onerror = function() {
                                        reject(req.error);
                                    };
                                    // The request will be also be aborted if we've exceeded our storage
                                    // space.
                                    transaction.onabort = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function clear(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.clear();
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function length(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.count();
                                    req.onsuccess = function() {
                                        resolve(req.result);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function key(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        if (n < 0) {
                            resolve(null);
                            return;
                        }
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var advanced = false;
                                    var req = store.openKeyCursor();
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            // this means there weren't enough keys
                                            resolve(null);
                                            return;
                                        }
                                        if (n === 0) // We have the first key, return it if that's what they
                                        // wanted.
                                        resolve(cursor.key);
                                        else if (!advanced) {
                                            // Otherwise, ask the cursor to skip ahead n
                                            // records.
                                            advanced = true;
                                            cursor.advance(n);
                                        } else // When we get here, we've got the nth key.
                                        resolve(cursor.key);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openKeyCursor();
                                    var keys = [];
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            resolve(keys);
                                            return;
                                        }
                                        keys.push(cursor.key);
                                        cursor["continue"]();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else {
                        var isCurrentDb = options.name === currentConfig.name && self1._dbInfo.db;
                        var dbPromise = isCurrentDb ? Promise$1.resolve(self1._dbInfo.db) : _getOriginalConnection(options).then(function(db) {
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            dbContext.db = db;
                            for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                            return db;
                        });
                        if (!options.storeName) promise = dbPromise.then(function(db) {
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                            }
                            var dropDBPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.deleteDatabase(options.name);
                                req.onerror = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    reject(req.error);
                                };
                                req.onblocked = function() {
                                    // Closing all open connections in onversionchange handler should prevent this situation, but if
                                    // we do get here, it just means the request remains pending - eventually it will succeed or error
                                    console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    resolve(db);
                                };
                            });
                            return dropDBPromise.then(function(db) {
                                dbContext.db = db;
                                for(var i = 0; i < forages.length; i++){
                                    var _forage = forages[i];
                                    _advanceReadiness(_forage._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                        else promise = dbPromise.then(function(db) {
                            if (!db.objectStoreNames.contains(options.storeName)) return;
                            var newVersion = db.version + 1;
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                                forage._dbInfo.version = newVersion;
                            }
                            var dropObjectPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.open(options.name, newVersion);
                                req.onerror = function(err) {
                                    var db = req.result;
                                    db.close();
                                    reject(err);
                                };
                                req.onupgradeneeded = function() {
                                    var db = req.result;
                                    db.deleteObjectStore(options.storeName);
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    db.close();
                                    resolve(db);
                                };
                            });
                            return dropObjectPromise.then(function(db) {
                                dbContext.db = db;
                                for(var j = 0; j < forages.length; j++){
                                    var _forage2 = forages[j];
                                    _forage2._dbInfo.db = db;
                                    _advanceReadiness(_forage2._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                    }
                    executeCallback(promise, callback);
                    return promise;
                }
                var asyncStorage = {
                    _driver: 'asyncStorage',
                    _initStorage: _initStorage,
                    _support: isIndexedDBValid(),
                    iterate: iterate,
                    getItem: getItem,
                    setItem: setItem,
                    removeItem: removeItem,
                    clear: clear,
                    length: length,
                    key: key,
                    keys: keys,
                    dropInstance: dropInstance
                };
                function isWebSQLValid() {
                    return typeof openDatabase === 'function';
                }
                // Sadly, the best way to save binary data in WebSQL/localStorage is serializing
                // it to Base64, so this is how we store it to prevent very strange errors with less
                // verbose ways of binary <-> string data storage.
                var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
                var BLOB_TYPE_PREFIX = '~~local_forage_type~';
                var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
                var SERIALIZED_MARKER = '__lfsc__:';
                var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
                // OMG the serializations!
                var TYPE_ARRAYBUFFER = 'arbf';
                var TYPE_BLOB = 'blob';
                var TYPE_INT8ARRAY = 'si08';
                var TYPE_UINT8ARRAY = 'ui08';
                var TYPE_UINT8CLAMPEDARRAY = 'uic8';
                var TYPE_INT16ARRAY = 'si16';
                var TYPE_INT32ARRAY = 'si32';
                var TYPE_UINT16ARRAY = 'ur16';
                var TYPE_UINT32ARRAY = 'ui32';
                var TYPE_FLOAT32ARRAY = 'fl32';
                var TYPE_FLOAT64ARRAY = 'fl64';
                var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
                var toString$1 = Object.prototype.toString;
                function stringToBuffer(serializedString) {
                    // Fill the string into a ArrayBuffer.
                    var bufferLength = serializedString.length * 0.75;
                    var len = serializedString.length;
                    var i;
                    var p = 0;
                    var encoded1, encoded2, encoded3, encoded4;
                    if (serializedString[serializedString.length - 1] === '=') {
                        bufferLength--;
                        if (serializedString[serializedString.length - 2] === '=') bufferLength--;
                    }
                    var buffer = new ArrayBuffer(bufferLength);
                    var bytes = new Uint8Array(buffer);
                    for(i = 0; i < len; i += 4){
                        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
                        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
                        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
                        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
                        /*jslint bitwise: true */ bytes[p++] = encoded1 << 2 | encoded2 >> 4;
                        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
                        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
                    }
                    return buffer;
                }
                // Converts a buffer to a string to store, serialized, in the backend
                // storage library.
                function bufferToString(buffer) {
                    // base64-arraybuffer
                    var bytes = new Uint8Array(buffer);
                    var base64String = '';
                    var i;
                    for(i = 0; i < bytes.length; i += 3){
                        /*jslint bitwise: true */ base64String += BASE_CHARS[bytes[i] >> 2];
                        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                        base64String += BASE_CHARS[bytes[i + 2] & 63];
                    }
                    if (bytes.length % 3 === 2) base64String = base64String.substring(0, base64String.length - 1) + '=';
                    else if (bytes.length % 3 === 1) base64String = base64String.substring(0, base64String.length - 2) + '==';
                    return base64String;
                }
                // Serialize a value, afterwards executing a callback (which usually
                // instructs the `setItem()` callback/promise to be executed). This is how
                // we store binary data with localStorage.
                function serialize(value, callback) {
                    var valueType = '';
                    if (value) valueType = toString$1.call(value);
                    // Cannot use `value instanceof ArrayBuffer` or such here, as these
                    // checks fail when running the tests using casper.js...
                    //
                    // TODO: See why those tests fail and use a better solution.
                    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
                        // Convert binary arrays to a string and prefix the string with
                        // a special marker.
                        var buffer;
                        var marker = SERIALIZED_MARKER;
                        if (value instanceof ArrayBuffer) {
                            buffer = value;
                            marker += TYPE_ARRAYBUFFER;
                        } else {
                            buffer = value.buffer;
                            if (valueType === '[object Int8Array]') marker += TYPE_INT8ARRAY;
                            else if (valueType === '[object Uint8Array]') marker += TYPE_UINT8ARRAY;
                            else if (valueType === '[object Uint8ClampedArray]') marker += TYPE_UINT8CLAMPEDARRAY;
                            else if (valueType === '[object Int16Array]') marker += TYPE_INT16ARRAY;
                            else if (valueType === '[object Uint16Array]') marker += TYPE_UINT16ARRAY;
                            else if (valueType === '[object Int32Array]') marker += TYPE_INT32ARRAY;
                            else if (valueType === '[object Uint32Array]') marker += TYPE_UINT32ARRAY;
                            else if (valueType === '[object Float32Array]') marker += TYPE_FLOAT32ARRAY;
                            else if (valueType === '[object Float64Array]') marker += TYPE_FLOAT64ARRAY;
                            else callback(new Error('Failed to get type for BinaryArray'));
                        }
                        callback(marker + bufferToString(buffer));
                    } else if (valueType === '[object Blob]') {
                        // Conver the blob to a binaryArray and then to a string.
                        var fileReader = new FileReader();
                        fileReader.onload = function() {
                            // Backwards-compatible prefix for the blob type.
                            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);
                            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
                        };
                        fileReader.readAsArrayBuffer(value);
                    } else try {
                        callback(JSON.stringify(value));
                    } catch (e) {
                        console.error("Couldn't convert value into a JSON string: ", value);
                        callback(null, e);
                    }
                }
                // Deserialize data we've inserted into a value column/field. We place
                // special markers into our strings to mark them as encoded; this isn't
                // as nice as a meta field, but it's the only sane thing we can do whilst
                // keeping localStorage support intact.
                //
                // Oftentimes this will just deserialize JSON content, but if we have a
                // special marker (SERIALIZED_MARKER, defined above), we will extract
                // some kind of arraybuffer/binary data/typed array out of the string.
                function deserialize(value) {
                    // If we haven't marked this string as being specially serialized (i.e.
                    // something other than serialized JSON), we can just return it and be
                    // done with it.
                    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) return JSON.parse(value);
                    // The following code deals with deserializing some kind of Blob or
                    // TypedArray. First we separate out the type of data we're dealing
                    // with from the data itself.
                    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
                    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
                    var blobType;
                    // Backwards-compatible blob type serialization strategy.
                    // DBs created with older versions of localForage will simply not have the blob type.
                    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
                        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
                        blobType = matcher[1];
                        serializedString = serializedString.substring(matcher[0].length);
                    }
                    var buffer = stringToBuffer(serializedString);
                    // Return the right type based on the code/type set during
                    // serialization.
                    switch(type){
                        case TYPE_ARRAYBUFFER:
                            return buffer;
                        case TYPE_BLOB:
                            return createBlob([
                                buffer
                            ], {
                                type: blobType
                            });
                        case TYPE_INT8ARRAY:
                            return new Int8Array(buffer);
                        case TYPE_UINT8ARRAY:
                            return new Uint8Array(buffer);
                        case TYPE_UINT8CLAMPEDARRAY:
                            return new Uint8ClampedArray(buffer);
                        case TYPE_INT16ARRAY:
                            return new Int16Array(buffer);
                        case TYPE_UINT16ARRAY:
                            return new Uint16Array(buffer);
                        case TYPE_INT32ARRAY:
                            return new Int32Array(buffer);
                        case TYPE_UINT32ARRAY:
                            return new Uint32Array(buffer);
                        case TYPE_FLOAT32ARRAY:
                            return new Float32Array(buffer);
                        case TYPE_FLOAT64ARRAY:
                            return new Float64Array(buffer);
                        default:
                            throw new Error('Unkown type: ' + type);
                    }
                }
                var localforageSerializer = {
                    serialize: serialize,
                    deserialize: deserialize,
                    stringToBuffer: stringToBuffer,
                    bufferToString: bufferToString
                };
                /*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */ function createDbTable(t, dbInfo, callback, errorCallback) {
                    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
                }
                // Open the WebSQL database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage$1(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
                    var dbInfoPromise = new Promise$1(function(resolve, reject) {
                        // Open the database; the openDatabase API will automatically
                        // create it for us if it doesn't exist.
                        try {
                            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
                        } catch (e) {
                            return reject(e);
                        }
                        // Create our key/value table if it doesn't exist.
                        dbInfo.db.transaction(function(t) {
                            createDbTable(t, dbInfo, function() {
                                self1._dbInfo = dbInfo;
                                resolve();
                            }, function(t, error) {
                                reject(error);
                            });
                        }, reject);
                    });
                    dbInfo.serializer = localforageSerializer;
                    return dbInfoPromise;
                }
                function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
                    t.executeSql(sqlStatement, args, callback, function(t, error) {
                        if (error.code === error.SYNTAX_ERR) t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [
                            dbInfo.storeName
                        ], function(t, results) {
                            if (!results.rows.length) // if the table is missing (was deleted)
                            // re-create it table and retry
                            createDbTable(t, dbInfo, function() {
                                t.executeSql(sqlStatement, args, callback, errorCallback);
                            }, errorCallback);
                            else errorCallback(t, error);
                        }, errorCallback);
                        else errorCallback(t, error);
                    }, errorCallback);
                }
                function getItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [
                                    key
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).value : null;
                                    // Check to see if this is serialized content we need to
                                    // unpack.
                                    if (result) result = dbInfo.serializer.deserialize(result);
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function iterate$1(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var rows = results.rows;
                                    var length = rows.length;
                                    for(var i = 0; i < length; i++){
                                        var item = rows.item(i);
                                        var result = item.value;
                                        // Check to see if this is serialized content
                                        // we need to unpack.
                                        if (result) result = dbInfo.serializer.deserialize(result);
                                        result = iterator(result, item.key, i + 1);
                                        // void(0) prevents problems with redefinition
                                        // of `undefined`.
                                        if (result !== void 0) {
                                            resolve(result);
                                            return;
                                        }
                                    }
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function _setItem(key, value, callback, retriesLeft) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            // The localStorage API doesn't return undefined values in an
                            // "expected" way, so undefined is always cast to null in all
                            // drivers. See: https://github.com/mozilla/localForage/pull/42
                            if (value === undefined) value = null;
                            // Save the original value to pass to the callback.
                            var originalValue = value;
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else dbInfo.db.transaction(function(t) {
                                    tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [
                                        key,
                                        value
                                    ], function() {
                                        resolve(originalValue);
                                    }, function(t, error) {
                                        reject(error);
                                    });
                                }, function(sqlError) {
                                    // The transaction failed; check
                                    // to see if it's a quota error.
                                    if (sqlError.code === sqlError.QUOTA_ERR) {
                                        // We reject the callback outright for now, but
                                        // it's worth trying to re-run the transaction.
                                        // Even if the user accepts the prompt to use
                                        // more storage on Safari, this error will
                                        // be called.
                                        //
                                        // Try to re-run the transaction.
                                        if (retriesLeft > 0) {
                                            resolve(_setItem.apply(self1, [
                                                key,
                                                originalValue,
                                                callback,
                                                retriesLeft - 1
                                            ]));
                                            return;
                                        }
                                        reject(sqlError);
                                    }
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem$1(key, value, callback) {
                    return _setItem.apply(this, [
                        key,
                        value,
                        callback,
                        1
                    ]);
                }
                function removeItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [
                                    key
                                ], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Deletes every item in the table.
                // TODO: Find out if this resets the AUTO_INCREMENT number.
                function clear$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Does a simple `COUNT(key)` to get the number of items stored in
                // localForage.
                function length$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                // Ahhh, SQL makes this one soooooo easy.
                                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var result = results.rows.item(0).c;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Return the key located at key index X; essentially gets the key from a
                // `WHERE id = ?`. This is the most efficient way I can think to implement
                // this rarely-used (in my experience) part of the API, but it can seem
                // inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
                // the ID of each key will change every time it's updated. Perhaps a stored
                // procedure for the `setItem()` SQL would solve this problem?
                // TODO: Don't change ID on `setItem()`.
                function key$1(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [
                                    n + 1
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).key : null;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var keys = [];
                                    for(var i = 0; i < results.rows.length; i++)keys.push(results.rows.item(i).key);
                                    resolve(keys);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // https://www.w3.org/TR/webdatabase/#databases
                // > There is no way to enumerate or delete the databases available for an origin from this API.
                function getAllStoreNames(db) {
                    return new Promise$1(function(resolve, reject) {
                        db.transaction(function(t) {
                            t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(t, results) {
                                var storeNames = [];
                                for(var i = 0; i < results.rows.length; i++)storeNames.push(results.rows.item(i).name);
                                resolve({
                                    db: db,
                                    storeNames: storeNames
                                });
                            }, function(t, error) {
                                reject(error);
                            });
                        }, function(sqlError) {
                            reject(sqlError);
                        });
                    });
                }
                function dropInstance$1(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else promise = new Promise$1(function(resolve) {
                        var db;
                        if (options.name === currentConfig.name) // use the db reference of the current instance
                        db = self1._dbInfo.db;
                        else db = openDatabase(options.name, '', '', 0);
                        if (!options.storeName) // drop all database tables
                        resolve(getAllStoreNames(db));
                        else resolve({
                            db: db,
                            storeNames: [
                                options.storeName
                            ]
                        });
                    }).then(function(operationInfo) {
                        return new Promise$1(function(resolve, reject) {
                            operationInfo.db.transaction(function(t) {
                                function dropTable(storeName) {
                                    return new Promise$1(function(resolve, reject) {
                                        t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function() {
                                            resolve();
                                        }, function(t, error) {
                                            reject(error);
                                        });
                                    });
                                }
                                var operations = [];
                                for(var i = 0, len = operationInfo.storeNames.length; i < len; i++)operations.push(dropTable(operationInfo.storeNames[i]));
                                Promise$1.all(operations).then(function() {
                                    resolve();
                                })["catch"](function(e) {
                                    reject(e);
                                });
                            }, function(sqlError) {
                                reject(sqlError);
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var webSQLStorage = {
                    _driver: 'webSQLStorage',
                    _initStorage: _initStorage$1,
                    _support: isWebSQLValid(),
                    iterate: iterate$1,
                    getItem: getItem$1,
                    setItem: setItem$1,
                    removeItem: removeItem$1,
                    clear: clear$1,
                    length: length$1,
                    key: key$1,
                    keys: keys$1,
                    dropInstance: dropInstance$1
                };
                function isLocalStorageValid() {
                    try {
                        return typeof localStorage !== 'undefined' && 'setItem' in localStorage && // in IE8 typeof localStorage.setItem === 'object'
                        !!localStorage.setItem;
                    } catch (e) {
                        return false;
                    }
                }
                function _getKeyPrefix(options, defaultConfig) {
                    var keyPrefix = options.name + '/';
                    if (options.storeName !== defaultConfig.storeName) keyPrefix += options.storeName + '/';
                    return keyPrefix;
                }
                // Check if localStorage throws when saving an item
                function checkIfLocalStorageThrows() {
                    var localStorageTestKey = '_localforage_support_test';
                    try {
                        localStorage.setItem(localStorageTestKey, true);
                        localStorage.removeItem(localStorageTestKey);
                        return false;
                    } catch (e) {
                        return true;
                    }
                }
                // Check if localStorage is usable and allows to save an item
                // This method checks if localStorage is usable in Safari Private Browsing
                // mode, or in any other case where the available quota for localStorage
                // is 0 and there wasn't any saved items yet.
                function _isLocalStorageUsable() {
                    return !checkIfLocalStorageThrows() || localStorage.length > 0;
                }
                // Config the localStorage backend, using options set in the config.
                function _initStorage$2(options) {
                    var self1 = this;
                    var dbInfo = {};
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    dbInfo.keyPrefix = _getKeyPrefix(options, self1._defaultConfig);
                    if (!_isLocalStorageUsable()) return Promise$1.reject();
                    self1._dbInfo = dbInfo;
                    dbInfo.serializer = localforageSerializer;
                    return Promise$1.resolve();
                }
                // Remove all keys from the datastore, effectively destroying all data in
                // the app's key/value store!
                function clear$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var keyPrefix = self1._dbInfo.keyPrefix;
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Retrieve an item from the store. Unlike the original async_storage
                // library in Gaia, we don't modify return values at all. If a key's value
                // is `undefined`, we pass that value to the callback function.
                function getItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result = localStorage.getItem(dbInfo.keyPrefix + key);
                        // If a result was found, parse it from the serialized
                        // string into a JS object. If result isn't truthy, the key
                        // is likely undefined and we'll pass it straight to the
                        // callback.
                        if (result) result = dbInfo.serializer.deserialize(result);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items in the store.
                function iterate$2(iterator, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var keyPrefix = dbInfo.keyPrefix;
                        var keyPrefixLength = keyPrefix.length;
                        var length = localStorage.length;
                        // We use a dedicated iterator instead of the `i` variable below
                        // so other keys we fetch in localStorage aren't counted in
                        // the `iterationNumber` argument passed to the `iterate()`
                        // callback.
                        //
                        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
                        var iterationNumber = 1;
                        for(var i = 0; i < length; i++){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) !== 0) continue;
                            var value = localStorage.getItem(key);
                            // If a result was found, parse it from the serialized
                            // string into a JS object. If result isn't truthy, the
                            // key is likely undefined and we'll pass it straight
                            // to the iterator.
                            if (value) value = dbInfo.serializer.deserialize(value);
                            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);
                            if (value !== void 0) return value;
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Same as localStorage's key() method, except takes a callback.
                function key$2(n, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result;
                        try {
                            result = localStorage.key(n);
                        } catch (error) {
                            result = null;
                        }
                        // Remove the prefix from the key, if a key is found.
                        if (result) result = result.substring(dbInfo.keyPrefix.length);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var length = localStorage.length;
                        var keys = [];
                        for(var i = 0; i < length; i++){
                            var itemKey = localStorage.key(i);
                            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) keys.push(itemKey.substring(dbInfo.keyPrefix.length));
                        }
                        return keys;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Supply the number of keys in the datastore to the callback function.
                function length$2(callback) {
                    var self1 = this;
                    var promise = self1.keys().then(function(keys) {
                        return keys.length;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Remove an item from the store, nice and simple.
                function removeItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        localStorage.removeItem(dbInfo.keyPrefix + key);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Set a key's value and run an optional callback once the value is set.
                // Unlike Gaia's implementation, the callback function is passed the value,
                // in case you want to operate on that value only after you're sure it
                // saved, or something like that.
                function setItem$2(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        // Convert undefined values to null.
                        // https://github.com/mozilla/localForage/pull/42
                        if (value === undefined) value = null;
                        // Save the original value to pass to the callback.
                        var originalValue = value;
                        return new Promise$1(function(resolve, reject) {
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else try {
                                    localStorage.setItem(dbInfo.keyPrefix + key, value);
                                    resolve(originalValue);
                                } catch (e) {
                                    // localStorage capacity exceeded.
                                    // TODO: Make this a specific error/event.
                                    if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') reject(e);
                                    reject(e);
                                }
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance$2(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        var currentConfig = this.config();
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else promise = new Promise$1(function(resolve) {
                        if (!options.storeName) resolve(options.name + '/');
                        else resolve(_getKeyPrefix(options, self1._defaultConfig));
                    }).then(function(keyPrefix) {
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var localStorageWrapper = {
                    _driver: 'localStorageWrapper',
                    _initStorage: _initStorage$2,
                    _support: isLocalStorageValid(),
                    iterate: iterate$2,
                    getItem: getItem$2,
                    setItem: setItem$2,
                    removeItem: removeItem$2,
                    clear: clear$2,
                    length: length$2,
                    key: key$2,
                    keys: keys$2,
                    dropInstance: dropInstance$2
                };
                var sameValue = function sameValue(x, y) {
                    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
                };
                var includes = function includes(array, searchElement) {
                    var len = array.length;
                    var i = 0;
                    while(i < len){
                        if (sameValue(array[i], searchElement)) return true;
                        i++;
                    }
                    return false;
                };
                var isArray = Array.isArray || function(arg) {
                    return Object.prototype.toString.call(arg) === '[object Array]';
                };
                // Drivers are stored here when `defineDriver()` is called.
                // They are shared across all instances of localForage.
                var DefinedDrivers = {};
                var DriverSupport = {};
                var DefaultDrivers = {
                    INDEXEDDB: asyncStorage,
                    WEBSQL: webSQLStorage,
                    LOCALSTORAGE: localStorageWrapper
                };
                var DefaultDriverOrder = [
                    DefaultDrivers.INDEXEDDB._driver,
                    DefaultDrivers.WEBSQL._driver,
                    DefaultDrivers.LOCALSTORAGE._driver
                ];
                var OptionalDriverMethods = [
                    'dropInstance'
                ];
                var LibraryMethods = [
                    'clear',
                    'getItem',
                    'iterate',
                    'key',
                    'keys',
                    'length',
                    'removeItem',
                    'setItem'
                ].concat(OptionalDriverMethods);
                var DefaultConfig = {
                    description: '',
                    driver: DefaultDriverOrder.slice(),
                    name: 'localforage',
                    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
                    // we can use without a prompt.
                    size: 4980736,
                    storeName: 'keyvaluepairs',
                    version: 1.0
                };
                function callWhenReady(localForageInstance, libraryMethod) {
                    localForageInstance[libraryMethod] = function() {
                        var _args = arguments;
                        return localForageInstance.ready().then(function() {
                            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
                        });
                    };
                }
                function extend() {
                    for(var i = 1; i < arguments.length; i++){
                        var arg = arguments[i];
                        if (arg) {
                            for(var _key in arg)if (arg.hasOwnProperty(_key)) {
                                if (isArray(arg[_key])) arguments[0][_key] = arg[_key].slice();
                                else arguments[0][_key] = arg[_key];
                            }
                        }
                    }
                    return arguments[0];
                }
                var LocalForage = function() {
                    function LocalForage(options) {
                        _classCallCheck(this, LocalForage);
                        for(var driverTypeKey in DefaultDrivers)if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                            var driver = DefaultDrivers[driverTypeKey];
                            var driverName = driver._driver;
                            this[driverTypeKey] = driverName;
                            if (!DefinedDrivers[driverName]) // we don't need to wait for the promise,
                            // since the default drivers can be defined
                            // in a blocking manner
                            this.defineDriver(driver);
                        }
                        this._defaultConfig = extend({}, DefaultConfig);
                        this._config = extend({}, this._defaultConfig, options);
                        this._driverSet = null;
                        this._initDriver = null;
                        this._ready = false;
                        this._dbInfo = null;
                        this._wrapLibraryMethodsWithReady();
                        this.setDriver(this._config.driver)["catch"](function() {});
                    }
                    // Set any config values for localForage; can be called anytime before
                    // the first API call (e.g. `getItem`, `setItem`).
                    // We loop through options so we don't overwrite existing config
                    // values.
                    LocalForage.prototype.config = function config(options) {
                        // If the options argument is an object, we use it to set values.
                        // Otherwise, we return either a specified config value or all
                        // config values.
                        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
                            // If localforage is ready and fully initialized, we can't set
                            // any new configuration values. Instead, we return an error.
                            if (this._ready) return new Error("Can't call config() after localforage has been used.");
                            for(var i in options){
                                if (i === 'storeName') options[i] = options[i].replace(/\W/g, '_');
                                if (i === 'version' && typeof options[i] !== 'number') return new Error('Database version must be a number.');
                                this._config[i] = options[i];
                            }
                            // after all config options are set and
                            // the driver option is used, try setting it
                            if ('driver' in options && options.driver) return this.setDriver(this._config.driver);
                            return true;
                        } else if (typeof options === 'string') return this._config[options];
                        else return this._config;
                    };
                    // Used to define a custom driver, shared across all instances of
                    // localForage.
                    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
                        var promise = new Promise$1(function(resolve, reject) {
                            try {
                                var driverName = driverObject._driver;
                                var complianceError = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                                // A driver name should be defined and not overlap with the
                                // library-defined, default drivers.
                                if (!driverObject._driver) {
                                    reject(complianceError);
                                    return;
                                }
                                var driverMethods = LibraryMethods.concat('_initStorage');
                                for(var i = 0, len = driverMethods.length; i < len; i++){
                                    var driverMethodName = driverMethods[i];
                                    // when the property is there,
                                    // it should be a method even when optional
                                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
                                        reject(complianceError);
                                        return;
                                    }
                                }
                                var configureMissingMethods = function configureMissingMethods() {
                                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                                        return function() {
                                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
                                            var promise = Promise$1.reject(error);
                                            executeCallback(promise, arguments[arguments.length - 1]);
                                            return promise;
                                        };
                                    };
                                    for(var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++){
                                        var optionalDriverMethod = OptionalDriverMethods[_i];
                                        if (!driverObject[optionalDriverMethod]) driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                                    }
                                };
                                configureMissingMethods();
                                var setDriverSupport = function setDriverSupport(support) {
                                    if (DefinedDrivers[driverName]) console.info('Redefining LocalForage driver: ' + driverName);
                                    DefinedDrivers[driverName] = driverObject;
                                    DriverSupport[driverName] = support;
                                    // don't use a then, so that we can define
                                    // drivers that have simple _support methods
                                    // in a blocking manner
                                    resolve();
                                };
                                if ('_support' in driverObject) {
                                    if (driverObject._support && typeof driverObject._support === 'function') driverObject._support().then(setDriverSupport, reject);
                                    else setDriverSupport(!!driverObject._support);
                                } else setDriverSupport(true);
                            } catch (e) {
                                reject(e);
                            }
                        });
                        executeTwoCallbacks(promise, callback, errorCallback);
                        return promise;
                    };
                    LocalForage.prototype.driver = function driver() {
                        return this._driver || null;
                    };
                    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
                        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));
                        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
                        return getDriverPromise;
                    };
                    LocalForage.prototype.getSerializer = function getSerializer(callback) {
                        var serializerPromise = Promise$1.resolve(localforageSerializer);
                        executeTwoCallbacks(serializerPromise, callback);
                        return serializerPromise;
                    };
                    LocalForage.prototype.ready = function ready(callback) {
                        var self1 = this;
                        var promise = self1._driverSet.then(function() {
                            if (self1._ready === null) self1._ready = self1._initDriver();
                            return self1._ready;
                        });
                        executeTwoCallbacks(promise, callback, callback);
                        return promise;
                    };
                    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
                        var self1 = this;
                        if (!isArray(drivers)) drivers = [
                            drivers
                        ];
                        var supportedDrivers = this._getSupportedDrivers(drivers);
                        function setDriverToConfig() {
                            self1._config.driver = self1.driver();
                        }
                        function extendSelfWithDriver(driver) {
                            self1._extend(driver);
                            setDriverToConfig();
                            self1._ready = self1._initStorage(self1._config);
                            return self1._ready;
                        }
                        function initDriver(supportedDrivers) {
                            return function() {
                                var currentDriverIndex = 0;
                                function driverPromiseLoop() {
                                    while(currentDriverIndex < supportedDrivers.length){
                                        var driverName = supportedDrivers[currentDriverIndex];
                                        currentDriverIndex++;
                                        self1._dbInfo = null;
                                        self1._ready = null;
                                        return self1.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                                    }
                                    setDriverToConfig();
                                    var error = new Error('No available storage method found.');
                                    self1._driverSet = Promise$1.reject(error);
                                    return self1._driverSet;
                                }
                                return driverPromiseLoop();
                            };
                        }
                        // There might be a driver initialization in progress
                        // so wait for it to finish in order to avoid a possible
                        // race condition to set _dbInfo
                        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function() {
                            return Promise$1.resolve();
                        }) : Promise$1.resolve();
                        this._driverSet = oldDriverSetDone.then(function() {
                            var driverName = supportedDrivers[0];
                            self1._dbInfo = null;
                            self1._ready = null;
                            return self1.getDriver(driverName).then(function(driver) {
                                self1._driver = driver._driver;
                                setDriverToConfig();
                                self1._wrapLibraryMethodsWithReady();
                                self1._initDriver = initDriver(supportedDrivers);
                            });
                        })["catch"](function() {
                            setDriverToConfig();
                            var error = new Error('No available storage method found.');
                            self1._driverSet = Promise$1.reject(error);
                            return self1._driverSet;
                        });
                        executeTwoCallbacks(this._driverSet, callback, errorCallback);
                        return this._driverSet;
                    };
                    LocalForage.prototype.supports = function supports(driverName) {
                        return !!DriverSupport[driverName];
                    };
                    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
                        extend(this, libraryMethodsAndProperties);
                    };
                    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
                        var supportedDrivers = [];
                        for(var i = 0, len = drivers.length; i < len; i++){
                            var driverName = drivers[i];
                            if (this.supports(driverName)) supportedDrivers.push(driverName);
                        }
                        return supportedDrivers;
                    };
                    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
                        // Add a stub for each driver API method that delays the call to the
                        // corresponding driver method until localForage is ready. These stubs
                        // will be replaced by the driver methods as soon as the driver is
                        // loaded, so there is no performance impact.
                        for(var i = 0, len = LibraryMethods.length; i < len; i++)callWhenReady(this, LibraryMethods[i]);
                    };
                    LocalForage.prototype.createInstance = function createInstance(options) {
                        return new LocalForage(options);
                    };
                    return LocalForage;
                }();
                // The actual localForage object that we expose as a module or via a
                // global. It's extended by pulling in one of our other libraries.
                var localforage_js = new LocalForage();
                module1.exports = localforage_js;
            },
            {
                "3": 3
            }
        ]
    }, {}, [
        4
    ])(4);
});


const $30fc287789802bd3$var$CUSTOM_WORDLIST_KEY = 'wordfinder_custom_wordlist';
const $30fc287789802bd3$export$135985a8b7f58ff1 = (word1, word2)=>{
    const len1 = word1.length;
    const len2 = word2.length;
    const dp = Array.from({
        length: len1 + 1
    }, ()=>Array(len2 + 1).fill(0));
    for(let i = 0; i <= len1; i++)dp[i][0] = i;
    for(let j = 0; j <= len2; j++)dp[0][j] = j;
    for(let i = 1; i <= len1; i++){
        for(let j = 1; j <= len2; j++)if (word1[i - 1] === word2[j - 1]) dp[i][j] = dp[i - 1][j - 1];
        else {
            const insert = dp[i][j - 1] + 1;
            const remove = dp[i - 1][j] + 1;
            const replace = dp[i - 1][j - 1] + 1;
            dp[i][j] = Math.min(insert, remove, replace);
        }
    }
    return dp[len1][len2];
};
const $30fc287789802bd3$export$fa0c4ff8171c3e48 = (str1, str2)=>{
    const m = str1.length;
    const n = str2.length;
    const dp = [];
    for(let i = 0; i <= m; i++){
        dp[i] = [];
        for(let j = 0; j <= n; j++){
            if (i === 0) dp[i][j] = j;
            else if (j === 0) dp[i][j] = i;
            else if (str1[i - 1] === str2[j - 1]) dp[i][j] = dp[i - 1][j - 1];
            else dp[i][j] = 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
        }
    }
    let added = 0;
    let removed = 0;
    let replaced = 0;
    let i = m, j = n;
    while(i > 0 || j > 0){
        if (i > 0 && dp[i][j] === dp[i - 1][j] + 1) {
            removed++;
            i--;
        } else if (j > 0 && dp[i][j] === dp[i][j - 1] + 1) {
            added++;
            j--;
        } else {
            if (i > 0 && j > 0 && dp[i][j] === dp[i - 1][j - 1] + 1) replaced++;
            i--;
            j--;
        }
    }
    const results = [];
    if (replaced > 0) results.push(`~${replaced}`);
    if (added > 0) results.push(`+${added}`);
    if (removed > 0) results.push(`-${removed}`);
    return `(${results.join(', ')})`;
};
const $30fc287789802bd3$export$e032af4a6a20ad39 = (word, wordList, minLength, maxLength, minDistance, maxDistance)=>{
    const results = [];
    wordList.forEach((candidate)=>{
        if (candidate.length < minLength || candidate.length > maxLength || word === candidate) return;
        const distance = $30fc287789802bd3$export$135985a8b7f58ff1(word, candidate);
        if (distance >= minDistance && distance <= maxDistance) results.push({
            word: candidate,
            distance: $30fc287789802bd3$export$fa0c4ff8171c3e48(word, candidate)
        });
    });
    return results;
};
/**
 * Calculate the net morph size from a distance string
 * Example: "(~2, +1)" -> 3, "(+1, -1, ~1)" -> 3
 */ const $30fc287789802bd3$var$calculateNetMorphSize = (distance)=>{
    let netSize = 0;
    // Extract numbers preceded by ~, +, or -
    const tildeMatch = distance.match(/~(\d+)/);
    const plusMatch = distance.match(/\+(\d+)/);
    const minusMatch = distance.match(/-(\d+)/);
    if (tildeMatch) netSize += parseInt(tildeMatch[1]);
    if (plusMatch) netSize += parseInt(plusMatch[1]);
    if (minusMatch) netSize += parseInt(minusMatch[1]);
    return netSize;
};
const $30fc287789802bd3$export$1b001418845b471c = (results, filter)=>{
    let filteredResults;
    if (filter === 'plusMinus') filteredResults = results.filter((candidate)=>!candidate.distance.includes('~'));
    else if (filter === 'tilde') filteredResults = results.filter((candidate)=>!/[+-]/.test(candidate.distance));
    else filteredResults = results;
    // Sort by net morph size first, then alphabetically
    return filteredResults.sort((a, b)=>{
        const netSizeA = $30fc287789802bd3$var$calculateNetMorphSize(a.distance);
        const netSizeB = $30fc287789802bd3$var$calculateNetMorphSize(b.distance);
        if (netSizeA !== netSizeB) return netSizeA - netSizeB;
        // If net sizes are equal, sort alphabetically
        return a.word.localeCompare(b.word);
    });
};
const $30fc287789802bd3$export$2b802892000cae02 = async (url)=>{
    const response = await fetch(url);
    const text = await response.text();
    return text.split('\n').map((x)=>x.trim().toLowerCase());
};
const $30fc287789802bd3$export$7941756437382940 = async (url)=>{
    const response = await fetch(url);
    const text = await response.text();
    return text.split('\n').map((x)=>x.trim());
};
const $30fc287789802bd3$export$aa5f9a38ef7a1502 = (content, filename, onProgress)=>{
    const lines = content.split('\n').filter((line)=>line.trim().length > 0);
    if (lines.length > 1000000) throw new Error('Wordlist exceeds maximum size of 1 million lines');
    const words = [];
    const qualitySet = new Set();
    let hasQualityRatings = false;
    lines.forEach((line, index)=>{
        const trimmedLine = line.trim();
        if (!trimmedLine) return;
        // Check for "word;quality" format
        const parts = trimmedLine.split(';');
        const word = parts[0].trim().toLowerCase();
        if (word.length === 0) return;
        let quality;
        if (parts.length > 1) {
            const qualityStr = parts[1].trim();
            const qualityNum = parseInt(qualityStr, 10);
            if (!isNaN(qualityNum)) {
                quality = qualityNum;
                qualitySet.add(qualityNum);
                hasQualityRatings = true;
            }
        }
        words.push({
            word: word,
            quality: quality
        });
        // Report progress every 10,000 words
        if (onProgress && index % 10000 === 0) onProgress(Math.floor(index / lines.length * 100));
    });
    if (onProgress) onProgress(100);
    const qualityLevels = Array.from(qualitySet).sort((a, b)=>a - b);
    return {
        name: filename,
        words: words,
        qualityLevels: qualityLevels,
        hasQualityRatings: hasQualityRatings,
        uploadedAt: Date.now(),
        wordCount: words.length
    };
};
const $30fc287789802bd3$export$ba041e932716dc84 = (customData, minQuality)=>{
    if (!customData.hasQualityRatings || minQuality === undefined) return customData.words.map((w)=>w.word);
    // Find max quality for treating unrated words
    const maxQuality = Math.max(...customData.qualityLevels);
    return customData.words.filter((w)=>{
        const quality = w.quality ?? maxQuality;
        return quality >= minQuality;
    }).map((w)=>w.word);
};
const $30fc287789802bd3$export$f146cacfc73207e3 = async (data)=>{
    await (0, (/*@__PURE__*/$parcel$interopDefault($2c10585caa95ace7$exports))).setItem($30fc287789802bd3$var$CUSTOM_WORDLIST_KEY, data);
};
const $30fc287789802bd3$export$b563230e20c473d7 = async ()=>{
    const data = await (0, (/*@__PURE__*/$parcel$interopDefault($2c10585caa95ace7$exports))).getItem($30fc287789802bd3$var$CUSTOM_WORDLIST_KEY);
    return data;
};
const $30fc287789802bd3$export$dba0cc7baa017b53 = async ()=>{
    await (0, (/*@__PURE__*/$parcel$interopDefault($2c10585caa95ace7$exports))).removeItem($30fc287789802bd3$var$CUSTOM_WORDLIST_KEY);
};



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");

const $3e822100038b564a$var$CustomWordlistDialog = ({ existingWordlist: existingWordlist, onClose: onClose, onWordlistUploaded: onWordlistUploaded, onWordlistCleared: onWordlistCleared })=>{
    const [uploadProgress, setUploadProgress] = (0, $28UcW.useState)(0);
    const [uploading, setUploading] = (0, $28UcW.useState)(false);
    const fileInputRef = (0, $28UcW.useRef)(null);
    const handleFileUpload = async (event)=>{
        const file = event.target.files?.[0];
        if (!file) return;
        if (!file.name.endsWith('.txt')) {
            alert('Please select a .txt file');
            return;
        }
        setUploading(true);
        setUploadProgress(0);
        try {
            const reader = new FileReader();
            reader.onload = async (e)=>{
                const content = e.target?.result;
                try {
                    const customData = (0, $30fc287789802bd3$export$aa5f9a38ef7a1502)(content, file.name, (progress)=>setUploadProgress(progress));
                    await (0, $30fc287789802bd3$export$f146cacfc73207e3)(customData);
                    onWordlistUploaded(customData);
                    // Clear file input
                    if (fileInputRef.current) fileInputRef.current.value = '';
                } catch (error) {
                    console.error('Error parsing wordlist:', error);
                    alert(error instanceof Error ? error.message : 'Error parsing wordlist');
                    setUploading(false);
                    setUploadProgress(0);
                }
            };
            reader.onerror = ()=>{
                alert('Error reading file');
                setUploading(false);
                setUploadProgress(0);
            };
            reader.readAsText(file);
        } catch (error) {
            console.error('Error uploading file:', error);
            alert('Error uploading file');
            setUploading(false);
            setUploadProgress(0);
        }
    };
    const handleClearWordlist = async ()=>{
        if (!existingWordlist) return;
        const confirmed = window.confirm(`Are you sure you want to clear the custom wordlist "${existingWordlist.name}"? This cannot be undone.`);
        if (!confirmed) return;
        try {
            await (0, $30fc287789802bd3$export$dba0cc7baa017b53)();
            onWordlistCleared();
        } catch (error) {
            console.error('Error clearing wordlist:', error);
            alert('Error clearing wordlist');
        }
    };
    return /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
        className: "wordfinderDialogOverlay",
        onClick: ()=>!uploading && onClose(),
        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
            className: "wordfinderDialog",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $4XrX4.jsx)("h2", {
                    className: "wordfinderDialogTitle",
                    children: existingWordlist ? 'Replace Custom Wordlist' : 'Upload Custom Wordlist'
                }),
                /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                    className: "wordfinderDialogInstructions",
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                            children: "Select a .txt file from your computer with one word per line."
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)("strong", {
                                    children: "Optional:"
                                }),
                                " Include quality ratings in the format ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("code", {
                                    children: "word;rating"
                                }),
                                ' ',
                                "(e.g., ",
                                /*#__PURE__*/ (0, $4XrX4.jsx)("code", {
                                    children: "apple;85"
                                }),
                                ")"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                    className: "wordfinderDialogInfo",
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsx)("strong", {
                            children: "Privacy Notice:"
                        }),
                        " Your wordlist is stored locally in your browser only. It is never uploaded to any server nor shared in any way."
                    ]
                }),
                existingWordlist && /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                    className: "wordfinderDialogWarning",
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsx)("strong", {
                            children: "Note:"
                        }),
                        " This will replace your current wordlist",
                        ' ',
                        /*#__PURE__*/ (0, $4XrX4.jsx)("em", {
                            children: existingWordlist.name
                        }),
                        " (",
                        existingWordlist.wordCount.toLocaleString(),
                        " words)."
                    ]
                }),
                /*#__PURE__*/ (0, $4XrX4.jsx)("input", {
                    ref: fileInputRef,
                    type: "file",
                    accept: ".txt",
                    onChange: handleFileUpload,
                    disabled: uploading,
                    style: {
                        marginTop: '16px'
                    }
                }),
                uploading && /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                    className: "wordfinderDialogProgress",
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                            className: "wordfinderProgressBar",
                            children: /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "wordfinderProgressFill",
                                style: {
                                    width: `${uploadProgress}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                            children: [
                                "Processing... ",
                                uploadProgress,
                                "%"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                    className: "wordfinderDialogButtons",
                    children: [
                        existingWordlist && /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                            type: "button",
                            onClick: handleClearWordlist,
                            disabled: uploading,
                            className: "wordfinderClearButton",
                            children: "Clear Wordlist"
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                            type: "button",
                            onClick: onClose,
                            disabled: uploading,
                            children: "Cancel"
                        })
                    ]
                })
            ]
        })
    });
};
var $3e822100038b564a$export$2e2bcd8739ae039 = $3e822100038b564a$var$CustomWordlistDialog;



const $7aa830066e27386b$var$Wordfinder = ()=>{
    const [searchParams, setSearchParams] = (0, $ca600093aacddd58$export$f1a78c17382fe22a)();
    const [words41k, setWords41k] = (0, $28UcW.useState)(null);
    const [words172k, setWords172k] = (0, $28UcW.useState)(null);
    const [words380k, setWords380k] = (0, $28UcW.useState)(null);
    const [broda, setBroda] = (0, $28UcW.useState)(null);
    const [currentWordList, setCurrentWordList] = (0, $28UcW.useState)([]);
    const [wordlistSize, setWordlistSize] = (0, $28UcW.useState)('41k');
    const [inputWord, setInputWord] = (0, $28UcW.useState)('');
    const [minLength, setMinLength] = (0, $28UcW.useState)('');
    const [maxLength, setMaxLength] = (0, $28UcW.useState)('');
    const [minDistance, setMinDistance] = (0, $28UcW.useState)('');
    const [maxDistance, setMaxDistance] = (0, $28UcW.useState)('');
    const [filter, setFilter] = (0, $28UcW.useState)('all');
    const [results, setResults] = (0, $28UcW.useState)([]);
    const [loading, setLoading] = (0, $28UcW.useState)(false);
    // Custom wordlist state
    const [customWordlist, setCustomWordlist] = (0, $28UcW.useState)(null);
    const [minQuality, setMinQuality] = (0, $28UcW.useState)(undefined);
    const [showCustomDialog, setShowCustomDialog] = (0, $28UcW.useState)(false);
    // Fetch word lists on component mount
    (0, $28UcW.useEffect)(()=>{
        (0, $30fc287789802bd3$export$2b802892000cae02)('https://raw.githubusercontent.com/julianeden/english-words/refs/heads/master/40k.txt').then((words)=>{
            setWords41k(words);
            setCurrentWordList(words);
        }).catch((error)=>console.error('Error fetching 41k word list:', error));
        (0, $30fc287789802bd3$export$2b802892000cae02)('https://raw.githubusercontent.com/julianeden/english-words/master/172k.txt').then((words)=>setWords172k(words)).catch((error)=>console.error('Error fetching 172k word list:', error));
        (0, $30fc287789802bd3$export$7941756437382940)('https://raw.githubusercontent.com/julianeden/english-words/master/words_alpha.txt').then((words)=>setWords380k(words)).catch((error)=>console.error('Error fetching 380k word list:', error));
        (0, $30fc287789802bd3$export$2b802892000cae02)('https://raw.githubusercontent.com/julianeden/english-words/master/Broda-trimmed.txt').then((words)=>setBroda(words)).catch((error)=>console.error('Error fetching Broda word list:', error));
        // Load custom wordlist from storage if it exists
        (0, $30fc287789802bd3$export$b563230e20c473d7)().then((data)=>{
            if (data) {
                setCustomWordlist(data);
                setWordlistSize('custom');
            }
        }).catch((error)=>console.error('Error loading custom wordlist:', error));
    }, []);
    // Update current word list when selection changes
    (0, $28UcW.useEffect)(()=>{
        switch(wordlistSize){
            case '41k':
                if (words41k) setCurrentWordList(words41k);
                break;
            case '172k':
                if (words172k) setCurrentWordList(words172k);
                break;
            case '380k':
                if (words380k) setCurrentWordList(words380k);
                break;
            case 'broda':
                if (broda) setCurrentWordList(broda);
                break;
            case 'custom':
                if (customWordlist) setCurrentWordList((0, $30fc287789802bd3$export$ba041e932716dc84)(customWordlist, minQuality));
                break;
        }
    }, [
        wordlistSize,
        words41k,
        words172k,
        words380k,
        broda,
        customWordlist,
        minQuality
    ]);
    const handleWordlistUploaded = (wordlist)=>{
        setCustomWordlist(wordlist);
        setWordlistSize('custom');
        setMinQuality(undefined);
        setShowCustomDialog(false);
    };
    const handleWordlistCleared = ()=>{
        setCustomWordlist(null);
        setWordlistSize('41k');
        setMinQuality(undefined);
        setShowCustomDialog(false);
    };
    const performSearch = (word)=>{
        if (!word) return;
        setLoading(true);
        setInputWord(word);
        // Update URL with search parameters
        const params = {
            word: word
        };
        if (minLength) params.minLength = minLength;
        if (maxLength) params.maxLength = maxLength;
        if (minDistance) params.minDistance = minDistance;
        if (maxDistance) params.maxDistance = maxDistance;
        if (wordlistSize !== '41k') params.wordlistSize = wordlistSize;
        if (filter !== 'all') params.filter = filter;
        setSearchParams(params);
        // Use setTimeout to allow UI to update before heavy computation
        setTimeout(()=>{
            const minLen = minLength ? parseInt(minLength) : 1;
            const maxLen = maxLength ? parseInt(maxLength) : 9000;
            const minDist = minDistance ? parseInt(minDistance) : 1;
            const maxDist = maxDistance ? parseInt(maxDistance) : 2;
            let searchResults = (0, $30fc287789802bd3$export$e032af4a6a20ad39)(word, currentWordList, minLen, maxLen, minDist, maxDist);
            searchResults = (0, $30fc287789802bd3$export$1b001418845b471c)(searchResults, filter);
            setResults(searchResults);
            setLoading(false);
        }, 0);
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        performSearch(inputWord.toLowerCase());
    };
    const handleResultClick = (word)=>{
        window.scrollTo(0, 0);
        performSearch(word);
    };
    const handlePreviousSearch = ()=>{
        window.history.back();
    };
    // Load search params from URL on mount and when URL changes (browser back/forward)
    (0, $28UcW.useEffect)(()=>{
        const word = searchParams.get('word');
        if (!word) return;
        setInputWord(word);
        setMinLength(searchParams.get('minLength') || '');
        setMaxLength(searchParams.get('maxLength') || '');
        setMinDistance(searchParams.get('minDistance') || '');
        setMaxDistance(searchParams.get('maxDistance') || '');
        setWordlistSize(searchParams.get('wordlistSize') || '41k');
        setFilter(searchParams.get('filter') || 'all');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchParams
    ]);
    // Perform search when URL params change and wordlist is ready
    (0, $28UcW.useEffect)(()=>{
        const word = searchParams.get('word');
        if (!word || currentWordList.length === 0) return;
        const minLen = searchParams.get('minLength') ? parseInt(searchParams.get('minLength')) : 1;
        const maxLen = searchParams.get('maxLength') ? parseInt(searchParams.get('maxLength')) : 9000;
        const minDist = searchParams.get('minDistance') ? parseInt(searchParams.get('minDistance')) : 1;
        const maxDist = searchParams.get('maxDistance') ? parseInt(searchParams.get('maxDistance')) : 2;
        const filterParam = searchParams.get('filter') || 'all';
        setLoading(true);
        setTimeout(()=>{
            let searchResults = (0, $30fc287789802bd3$export$e032af4a6a20ad39)(word, currentWordList, minLen, maxLen, minDist, maxDist);
            searchResults = (0, $30fc287789802bd3$export$1b001418845b471c)(searchResults, filterParam);
            setResults(searchResults);
            setLoading(false);
        }, 0);
    }, [
        searchParams,
        currentWordList
    ]);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "wordfinderContainer",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "wordfinderFormContainer",
                children: /*#__PURE__*/ (0, $4XrX4.jsxs)("form", {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                            className: "wordfinderFormGroup",
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)("label", {
                                    htmlFor: "inputWord",
                                    children: "Input Word:"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)("input", {
                                    type: "text",
                                    id: "inputWord",
                                    value: inputWord,
                                    onChange: (e)=>setInputWord(e.target.value),
                                    autoComplete: "off",
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                            className: "wordfinderFormGroup",
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)("label", {
                                    htmlFor: "minLength",
                                    children: "Min Length:"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)("input", {
                                    type: "number",
                                    id: "minLength",
                                    value: minLength,
                                    onChange: (e)=>setMinLength(e.target.value),
                                    placeholder: "1"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                            className: "wordfinderFormGroup",
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)("label", {
                                    htmlFor: "maxLength",
                                    children: "Max Length:"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)("input", {
                                    type: "number",
                                    id: "maxLength",
                                    value: maxLength,
                                    onChange: (e)=>setMaxLength(e.target.value),
                                    placeholder: "No max"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                            className: "wordfinderFormGroup",
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)("label", {
                                    htmlFor: "minDistance",
                                    children: "Min Distance:"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)("input", {
                                    type: "number",
                                    id: "minDistance",
                                    value: minDistance,
                                    onChange: (e)=>setMinDistance(e.target.value),
                                    placeholder: "1"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                            className: "wordfinderFormGroup",
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)("label", {
                                    htmlFor: "maxDistance",
                                    children: "Max Distance:"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsx)("input", {
                                    type: "number",
                                    id: "maxDistance",
                                    value: maxDistance,
                                    onChange: (e)=>setMaxDistance(e.target.value),
                                    placeholder: "2"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                            className: "wordfinderFormGroup",
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)("label", {
                                    htmlFor: "wordlistSize",
                                    children: "Use wordlist with size:"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("select", {
                                    id: "wordlistSize",
                                    value: wordlistSize,
                                    onChange: (e)=>setWordlistSize(e.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("option", {
                                            value: "41k",
                                            children: "41k"
                                        }),
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("option", {
                                            value: "172k",
                                            children: "172k"
                                        }),
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("option", {
                                            value: "380k",
                                            children: "380k"
                                        }),
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("option", {
                                            value: "broda",
                                            children: "Broda (280k, includes phrases + names)"
                                        }),
                                        customWordlist && /*#__PURE__*/ (0, $4XrX4.jsxs)("option", {
                                            value: "custom",
                                            children: [
                                                "Custom (",
                                                customWordlist.wordCount.toLocaleString(),
                                                " words)"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                            className: "wordfinderFormGroup",
                            children: /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                                type: "button",
                                className: "wordfinderCustomButton",
                                onClick: ()=>setShowCustomDialog(true),
                                children: customWordlist ? 'Change custom wordlist' : 'Use custom wordlist'
                            })
                        }),
                        customWordlist?.hasQualityRatings && wordlistSize === 'custom' && /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                            className: "wordfinderFormGroup",
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)("label", {
                                    htmlFor: "minQuality",
                                    children: "Minimum word quality:"
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("select", {
                                    id: "minQuality",
                                    value: minQuality ?? '',
                                    onChange: (e)=>setMinQuality(e.target.value ? parseInt(e.target.value) : undefined),
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("option", {
                                            value: "",
                                            children: "All qualities"
                                        }),
                                        customWordlist.qualityLevels.map((level)=>/*#__PURE__*/ (0, $4XrX4.jsxs)("option", {
                                                value: level,
                                                children: [
                                                    level,
                                                    "+"
                                                ]
                                            }, level))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                            className: "wordfinderFilterOptions",
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("input", {
                                            type: "radio",
                                            id: "includeAll",
                                            name: "filter",
                                            value: "all",
                                            checked: filter === 'all',
                                            onChange: (e)=>setFilter(e.target.value)
                                        }),
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("label", {
                                            htmlFor: "includeAll",
                                            children: "Include all results"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("input", {
                                            type: "radio",
                                            id: "onlyPlusMinus",
                                            name: "filter",
                                            value: "plusMinus",
                                            checked: filter === 'plusMinus',
                                            onChange: (e)=>setFilter(e.target.value)
                                        }),
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("label", {
                                            htmlFor: "onlyPlusMinus",
                                            children: "Only +/-, no ~"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("input", {
                                            type: "radio",
                                            id: "onlyTilde",
                                            name: "filter",
                                            value: "tilde",
                                            checked: filter === 'tilde',
                                            onChange: (e)=>setFilter(e.target.value)
                                        }),
                                        /*#__PURE__*/ (0, $4XrX4.jsx)("label", {
                                            htmlFor: "onlyTilde",
                                            children: "Only ~, no +/-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                            className: "wordfinderSubmitButton",
                            type: "submit",
                            children: "Find Words"
                        }),
                        /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                            className: "wordfinderPreviousButton",
                            type: "button",
                            onClick: handlePreviousSearch,
                            children: "Previous search"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                className: "wordfinderResultsContainer",
                children: loading ? /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                    children: "Searching..."
                }) : results.length > 0 ? /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                            children: [
                                results.length,
                                " matches found"
                            ]
                        }),
                        results.map((result, index)=>{
                            // Calculate net morph size for current and previous result
                            const calculateNetMorphSize = (distance)=>{
                                let netSize = 0;
                                const tildeMatch = distance.match(/~(\d+)/);
                                const plusMatch = distance.match(/\+(\d+)/);
                                const minusMatch = distance.match(/-(\d+)/);
                                if (tildeMatch) netSize += parseInt(tildeMatch[1]);
                                if (plusMatch) netSize += parseInt(plusMatch[1]);
                                if (minusMatch) netSize += parseInt(minusMatch[1]);
                                return netSize;
                            };
                            const currentNetSize = calculateNetMorphSize(result.distance);
                            const prevNetSize = index > 0 ? calculateNetMorphSize(results[index - 1].distance) : -1;
                            const showDivider = index > 0 && currentNetSize !== prevNetSize;
                            return /*#__PURE__*/ (0, $4XrX4.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($28UcW))).Fragment, {
                                children: [
                                    showDivider && /*#__PURE__*/ (0, $4XrX4.jsx)("hr", {
                                        className: "morphSizeDivider"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                                        className: "wordfinderSearchResult",
                                        children: [
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                                className: "matchText",
                                                onClick: ()=>handleResultClick(result.word),
                                                children: result.word
                                            }),
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                                className: "matchDistance",
                                                children: result.distance
                                            })
                                        ]
                                    })
                                ]
                            }, index);
                        })
                    ]
                }) : inputWord && !loading ? /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                    children: "No matches found"
                }) : /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                    children: 'Enter a word and click "Find Words" to search'
                })
            }),
            showCustomDialog && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $3e822100038b564a$export$2e2bcd8739ae039), {
                existingWordlist: customWordlist,
                onClose: ()=>setShowCustomDialog(false),
                onWordlistUploaded: handleWordlistUploaded,
                onWordlistCleared: handleWordlistCleared
            })
        ]
    });
};
var $7aa830066e27386b$export$2e2bcd8739ae039 = $7aa830066e27386b$var$Wordfinder;



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");




/**
 * Find neighbors of a word (words within maxMorph distance)
 * This is computed on-demand, not precomputed
 * Excludes words in the excludedWords set and words shorter than minWordLength
 */ const $3a01fbb239245b1e$var$findNeighbors = (word, wordList, maxMorph, excludedWords, minWordLength)=>{
    const neighbors = [];
    for (const candidate of wordList){
        if (candidate === word || excludedWords.has(candidate) || candidate.length < minWordLength) continue;
        const dist = (0, $30fc287789802bd3$export$135985a8b7f58ff1)(word, candidate);
        if (dist > 0 && dist <= maxMorph) neighbors.push(candidate);
    }
    return neighbors;
};
const $3a01fbb239245b1e$export$cf87c56433cc03 = (startWord, endWord, wordList, maxPathLength, maxMorph, maxResults = 50, onPathFound, onProgress, excludedWords = new Set(), minWordLength = 1)=>{
    if (startWord === endWord) return {
        paths: [],
        hasMore: false
    };
    let searchesPerformed = 0;
    const results = [];
    let stoppedEarly = false;
    // Start: Find neighbors of start word
    const startNeighbors = $3a01fbb239245b1e$var$findNeighbors(startWord, wordList, maxMorph, excludedWords, minWordLength);
    searchesPerformed++;
    if (onProgress) onProgress({
        searchesPerformed: searchesPerformed,
        pathsFound: results.length
    });
    // End: Find neighbors of end word
    const endNeighbors = $3a01fbb239245b1e$var$findNeighbors(endWord, wordList, maxMorph, excludedWords, minWordLength);
    searchesPerformed++;
    if (onProgress) onProgress({
        searchesPerformed: searchesPerformed,
        pathsFound: results.length
    });
    // Check for direct connection (2-step path)
    if (startNeighbors.includes(endWord)) {
        results.push({
            path: [
                startWord,
                endWord
            ],
            length: 2
        });
        if (onPathFound) onPathFound(results[results.length - 1]);
        if (results.length >= maxResults) {
            stoppedEarly = true;
            return {
                paths: results,
                hasMore: true
            };
        }
    }
    // Check for 3-step paths (overlap in neighbors)
    for (const neighbor of startNeighbors)if (endNeighbors.includes(neighbor)) {
        results.push({
            path: [
                startWord,
                neighbor,
                endWord
            ],
            length: 3
        });
        if (onPathFound) onPathFound(results[results.length - 1]);
        if (results.length >= maxResults) {
            stoppedEarly = true;
            return {
                paths: results,
                hasMore: true
            };
        }
    }
    // Bidirectional BFS: track paths from both ends
    const fromStart = new Map(); // word -> path from start
    const fromEnd = new Map(); // word -> path to end
    for (const neighbor of startNeighbors)fromStart.set(neighbor, [
        startWord,
        neighbor
    ]);
    for (const neighbor of endNeighbors)fromEnd.set(neighbor, [
        neighbor,
        endWord
    ]);
    let currentLength = 2;
    while(currentLength < maxPathLength && results.length < maxResults){
        if (fromStart.size === 0 && fromEnd.size === 0) break;
        // Expand the smaller frontier
        const expandStart = fromStart.size <= fromEnd.size && fromStart.size > 0;
        if (expandStart) {
            const newFrontier = new Map();
            for (const [word, pathFromStart] of fromStart){
                const neighbors = $3a01fbb239245b1e$var$findNeighbors(word, wordList, maxMorph, excludedWords, minWordLength);
                searchesPerformed++;
                if (onProgress && searchesPerformed % 5 === 0) onProgress({
                    searchesPerformed: searchesPerformed,
                    pathsFound: results.length
                });
                for (const neighbor of neighbors){
                    // Avoid cycles in this path
                    if (pathFromStart.includes(neighbor)) continue;
                    const newPath = [
                        ...pathFromStart,
                        neighbor
                    ];
                    // Check if we reached the end
                    if (neighbor === endWord) {
                        results.push({
                            path: newPath,
                            length: newPath.length
                        });
                        if (onPathFound) onPathFound(results[results.length - 1]);
                        if (results.length >= maxResults) {
                            stoppedEarly = true;
                            return {
                                paths: results,
                                hasMore: true
                            };
                        }
                    }
                    // Check if we connected to the end frontier
                    if (fromEnd.has(neighbor)) {
                        const pathToEnd = fromEnd.get(neighbor);
                        const fullPath = [
                            ...newPath,
                            ...pathToEnd.slice(1)
                        ];
                        results.push({
                            path: fullPath,
                            length: fullPath.length
                        });
                        if (onPathFound) onPathFound(results[results.length - 1]);
                        if (results.length >= maxResults) {
                            stoppedEarly = true;
                            return {
                                paths: results,
                                hasMore: true
                            };
                        }
                    }
                    // Add to new frontier if not already explored from this end
                    if (!fromStart.has(neighbor) && !newFrontier.has(neighbor)) newFrontier.set(neighbor, newPath);
                }
            }
            fromStart.clear();
            for (const [word, path] of newFrontier)fromStart.set(word, path);
        } else if (fromEnd.size > 0) {
            const newFrontier = new Map();
            for (const [word, pathToEnd] of fromEnd){
                const neighbors = $3a01fbb239245b1e$var$findNeighbors(word, wordList, maxMorph, excludedWords, minWordLength);
                searchesPerformed++;
                if (onProgress && searchesPerformed % 5 === 0) onProgress({
                    searchesPerformed: searchesPerformed,
                    pathsFound: results.length
                });
                for (const neighbor of neighbors){
                    // Avoid cycles
                    if (pathToEnd.includes(neighbor)) continue;
                    const newPath = [
                        neighbor,
                        ...pathToEnd
                    ];
                    // Check if we reached the start
                    if (neighbor === startWord) {
                        results.push({
                            path: newPath,
                            length: newPath.length
                        });
                        if (onPathFound) onPathFound(results[results.length - 1]);
                        if (results.length >= maxResults) {
                            stoppedEarly = true;
                            return {
                                paths: results,
                                hasMore: true
                            };
                        }
                    }
                    // Check if we connected to the start frontier
                    if (fromStart.has(neighbor)) {
                        const pathFromStart = fromStart.get(neighbor);
                        const fullPath = [
                            ...pathFromStart,
                            ...newPath.slice(1)
                        ];
                        results.push({
                            path: fullPath,
                            length: fullPath.length
                        });
                        if (onPathFound) onPathFound(results[results.length - 1]);
                        if (results.length >= maxResults) {
                            stoppedEarly = true;
                            return {
                                paths: results,
                                hasMore: true
                            };
                        }
                    }
                    // Add to new frontier
                    if (!fromEnd.has(neighbor) && !newFrontier.has(neighbor)) newFrontier.set(neighbor, newPath);
                }
            }
            fromEnd.clear();
            for (const [word, path] of newFrontier)fromEnd.set(word, path);
        }
        currentLength++;
    }
    return {
        paths: results,
        hasMore: false
    };
};



const $e82957840eedb671$var$Pathfinder = ()=>{
    const [searchParams, setSearchParams] = (0, $ca600093aacddd58$export$f1a78c17382fe22a)();
    const [words41k, setWords41k] = (0, $28UcW.useState)(null);
    const [words172k, setWords172k] = (0, $28UcW.useState)(null);
    const [words380k, setWords380k] = (0, $28UcW.useState)(null);
    const [broda, setBroda] = (0, $28UcW.useState)(null);
    const [currentWordList, setCurrentWordList] = (0, $28UcW.useState)([]);
    const [wordlistSize, setWordlistSize] = (0, $28UcW.useState)('41k');
    const [startWord, setStartWord] = (0, $28UcW.useState)('');
    const [endWord, setEndWord] = (0, $28UcW.useState)('');
    const [maxPathLength, setMaxPathLength] = (0, $28UcW.useState)('5');
    const [maxMorph, setMaxMorph] = (0, $28UcW.useState)('2');
    const [minWordLength, setMinWordLength] = (0, $28UcW.useState)('4');
    const [results, setResults] = (0, $28UcW.useState)([]);
    const [loading, setLoading] = (0, $28UcW.useState)(false);
    const [excludedWords, setExcludedWords] = (0, $28UcW.useState)(new Set());
    const [hasMoreResults, setHasMoreResults] = (0, $28UcW.useState)(false);
    const [currentMaxResults, setCurrentMaxResults] = (0, $28UcW.useState)(50);
    const [currentPage, setCurrentPage] = (0, $28UcW.useState)(1);
    const resultsPerPage = 50;
    // Custom wordlist state
    const [customWordlist, setCustomWordlist] = (0, $28UcW.useState)(null);
    const [minQuality, setMinQuality] = (0, $28UcW.useState)(undefined);
    const [showCustomDialog, setShowCustomDialog] = (0, $28UcW.useState)(false);
    // Fetch word lists on component mount
    (0, $28UcW.useEffect)(()=>{
        (0, $30fc287789802bd3$export$2b802892000cae02)('https://raw.githubusercontent.com/julianeden/english-words/refs/heads/master/40k.txt').then((words)=>{
            setWords41k(words);
            setCurrentWordList(words);
        }).catch((error)=>console.error('Error fetching 41k word list:', error));
        (0, $30fc287789802bd3$export$2b802892000cae02)('https://raw.githubusercontent.com/julianeden/english-words/master/172k.txt').then((words)=>setWords172k(words)).catch((error)=>console.error('Error fetching 172k word list:', error));
        (0, $30fc287789802bd3$export$7941756437382940)('https://raw.githubusercontent.com/julianeden/english-words/master/words_alpha.txt').then((words)=>setWords380k(words)).catch((error)=>console.error('Error fetching 380k word list:', error));
        (0, $30fc287789802bd3$export$2b802892000cae02)('https://raw.githubusercontent.com/julianeden/english-words/master/Broda-trimmed.txt').then((words)=>setBroda(words)).catch((error)=>console.error('Error fetching Broda word list:', error));
        // Load custom wordlist from storage if it exists
        (0, $30fc287789802bd3$export$b563230e20c473d7)().then((data)=>{
            if (data) setCustomWordlist(data);
        }).catch((error)=>console.error('Error loading custom wordlist:', error));
    }, []);
    // Update current word list when selection changes
    (0, $28UcW.useEffect)(()=>{
        switch(wordlistSize){
            case '41k':
                if (words41k) setCurrentWordList(words41k);
                break;
            case '172k':
                if (words172k) setCurrentWordList(words172k);
                break;
            case '380k':
                if (words380k) setCurrentWordList(words380k);
                break;
            case 'broda':
                if (broda) setCurrentWordList(broda);
                break;
            case 'custom':
                if (customWordlist) setCurrentWordList((0, $30fc287789802bd3$export$ba041e932716dc84)(customWordlist, minQuality));
                break;
        }
    }, [
        wordlistSize,
        words41k,
        words172k,
        words380k,
        broda,
        customWordlist,
        minQuality
    ]);
    const handleWordlistUploaded = (wordlist)=>{
        setCustomWordlist(wordlist);
        setWordlistSize('custom');
        setMinQuality(undefined);
        setShowCustomDialog(false);
    };
    const handleWordlistCleared = ()=>{
        setCustomWordlist(null);
        setWordlistSize('41k'); // Reset to default wordlist
        setMinQuality(undefined);
        setShowCustomDialog(false);
    };
    const handleExcludeWord = (word)=>{
        // Don't exclude start or end words
        if (word === startWord.toLowerCase() || word === endWord.toLowerCase()) return;
        const newExcluded = new Set(excludedWords);
        newExcluded.add(word);
        setExcludedWords(newExcluded);
        // Automatically rerun the search
        performSearchWithExcluded(newExcluded);
    };
    const handleRemoveExcluded = (word)=>{
        const newExcluded = new Set(excludedWords);
        newExcluded.delete(word);
        setExcludedWords(newExcluded);
        // Automatically rerun the search
        performSearchWithExcluded(newExcluded);
    };
    const performSearchWithExcluded = (excluded, maxResults = currentMaxResults, resetPage = true)=>{
        if (!startWord || !endWord) return;
        setLoading(true);
        // Parse string inputs to numbers
        const maxLen = parseInt(maxPathLength) || 5;
        const maxM = parseInt(maxMorph) || 2;
        const minLen = parseInt(minWordLength) || 4;
        if (resetPage) {
            // Fresh search - clear results and reset page
            setResults([]);
            setCurrentPage(1);
        }
        // If not resetting page, keep existing results visible
        // Use setTimeout to allow UI to update before heavy computation
        setTimeout(()=>{
            const searchResult = (0, $3a01fbb239245b1e$export$cf87c56433cc03)(startWord.toLowerCase(), endWord.toLowerCase(), currentWordList, maxLen, maxM, maxResults, resetPage ? (path)=>{
                // Stream results as they're found (only for fresh searches)
                setResults((prev)=>[
                        ...prev,
                        path
                    ]);
            } : undefined, undefined, excluded, minLen);
            // Update results with complete set when loading more
            if (!resetPage) setResults(searchResult.paths);
            setHasMoreResults(searchResult.hasMore);
            setLoading(false);
        }, 0);
    };
    const performSearch = ()=>{
        if (!startWord || !endWord) return;
        // Clear excluded words when starting a new search
        setExcludedWords(new Set());
        // Reset max results to default
        setCurrentMaxResults(50);
        setCurrentPage(1);
        setLoading(true);
        // Parse string inputs to numbers
        const maxLen = parseInt(maxPathLength) || 5;
        const maxM = parseInt(maxMorph) || 2;
        const minLen = parseInt(minWordLength) || 4;
        // Update URL with search parameters
        const params = {
            start: startWord,
            end: endWord
        };
        if (maxLen !== 5) params.maxPathLength = maxLen.toString();
        if (maxM !== 2) params.maxMorph = maxM.toString();
        if (minLen !== 4) params.minWordLength = minLen.toString();
        if (wordlistSize !== '41k') params.wordlistSize = wordlistSize;
        setSearchParams(params);
        // Clear previous results
        setResults([]);
        // Use setTimeout to allow UI to update before heavy computation
        setTimeout(()=>{
            const searchResult = (0, $3a01fbb239245b1e$export$cf87c56433cc03)(startWord.toLowerCase(), endWord.toLowerCase(), currentWordList, maxLen, maxM, 50, (path)=>{
                // Stream results as they're found
                setResults((prev)=>[
                        ...prev,
                        path
                    ]);
            }, undefined, new Set(), minLen);
            setHasMoreResults(searchResult.hasMore);
            setLoading(false);
        }, 0);
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        performSearch();
    };
    const handlePreviousSearch = ()=>{
        window.history.back();
    };
    const handleLoadMore = ()=>{
        const newMaxResults = currentMaxResults + 50;
        setCurrentMaxResults(newMaxResults);
        setCurrentPage(currentPage + 1);
        performSearchWithExcluded(excludedWords, newMaxResults, false);
    };
    const handleNextPage = ()=>{
        setCurrentPage((prev)=>prev + 1);
    };
    const handlePrevPage = ()=>{
        setCurrentPage((prev)=>Math.max(1, prev - 1));
    };
    // Load search params from URL on mount and when URL changes
    (0, $28UcW.useEffect)(()=>{
        const start = searchParams.get('start');
        const end = searchParams.get('end');
        if (!start || !end) return;
        setStartWord(start);
        setEndWord(end);
        setMaxPathLength(searchParams.get('maxPathLength') || '5');
        setMaxMorph(searchParams.get('maxMorph') || '2');
        setMinWordLength(searchParams.get('minWordLength') || '4');
        setWordlistSize(searchParams.get('wordlistSize') || '41k');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchParams
    ]);
    // Perform search when URL params change and wordlist is ready
    (0, $28UcW.useEffect)(()=>{
        const start = searchParams.get('start');
        const end = searchParams.get('end');
        if (!start || !end || currentWordList.length === 0) return;
        const maxLen = searchParams.get('maxPathLength') ? parseInt(searchParams.get('maxPathLength')) : 5;
        const maxM = searchParams.get('maxMorph') ? parseInt(searchParams.get('maxMorph')) : 2;
        const minLen = searchParams.get('minWordLength') ? parseInt(searchParams.get('minWordLength')) : 4;
        setLoading(true);
        setResults([]);
        setExcludedWords(new Set());
        setCurrentMaxResults(50);
        setCurrentPage(1);
        setTimeout(()=>{
            const searchResult = (0, $3a01fbb239245b1e$export$cf87c56433cc03)(start, end, currentWordList, maxLen, maxM, 50, (path)=>{
                // Stream results as they're found
                setResults((prev)=>[
                        ...prev,
                        path
                    ]);
            }, undefined, new Set(), minLen);
            setHasMoreResults(searchResult.hasMore);
            setLoading(false);
        }, 0);
    }, [
        searchParams,
        currentWordList
    ]);
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "pathfinderContainer",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "pathfinderFormContainer",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("form", {
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: "pathfinderFormGroup",
                                children: [
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("label", {
                                        htmlFor: "startWord",
                                        children: "Start Word:"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("input", {
                                        type: "text",
                                        id: "startWord",
                                        value: startWord,
                                        onChange: (e)=>setStartWord(e.target.value),
                                        autoComplete: "off",
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: "pathfinderFormGroup",
                                children: [
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("label", {
                                        htmlFor: "endWord",
                                        children: "End Word:"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("input", {
                                        type: "text",
                                        id: "endWord",
                                        value: endWord,
                                        onChange: (e)=>setEndWord(e.target.value),
                                        autoComplete: "off",
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: "pathfinderFormGroup",
                                children: [
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("label", {
                                        htmlFor: "maxPathLength",
                                        children: "Max Path Length:"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("input", {
                                        type: "number",
                                        id: "maxPathLength",
                                        value: maxPathLength,
                                        onChange: (e)=>setMaxPathLength(e.target.value),
                                        placeholder: "5",
                                        min: "2",
                                        max: "10"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: "pathfinderFormGroup",
                                children: [
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("label", {
                                        htmlFor: "maxMorph",
                                        children: "Max Morph:"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("input", {
                                        type: "number",
                                        id: "maxMorph",
                                        value: maxMorph,
                                        onChange: (e)=>setMaxMorph(e.target.value),
                                        placeholder: "2",
                                        min: "1",
                                        max: "5"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: "pathfinderFormGroup",
                                children: [
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("label", {
                                        htmlFor: "minWordLength",
                                        children: "Min Word Length:"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("input", {
                                        type: "number",
                                        id: "minWordLength",
                                        value: minWordLength,
                                        onChange: (e)=>setMinWordLength(e.target.value),
                                        placeholder: "4",
                                        min: "1",
                                        max: "20"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: "pathfinderFormGroup",
                                children: [
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("label", {
                                        htmlFor: "wordlistSize",
                                        children: "Use wordlist with size:"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsxs)("select", {
                                        id: "wordlistSize",
                                        value: wordlistSize,
                                        onChange: (e)=>setWordlistSize(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("option", {
                                                value: "41k",
                                                children: "41k"
                                            }),
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("option", {
                                                value: "172k",
                                                children: "172k"
                                            }),
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("option", {
                                                value: "380k",
                                                children: "380k"
                                            }),
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("option", {
                                                value: "broda",
                                                children: "Broda (280k, includes phrases + names)"
                                            }),
                                            customWordlist && /*#__PURE__*/ (0, $4XrX4.jsxs)("option", {
                                                value: "custom",
                                                children: [
                                                    "Custom (",
                                                    customWordlist.wordCount.toLocaleString(),
                                                    " words)"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "pathfinderFormGroup",
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                                    type: "button",
                                    className: "pathfinderCustomButton",
                                    onClick: ()=>setShowCustomDialog(true),
                                    children: customWordlist ? 'Change custom wordlist' : 'Use custom wordlist'
                                })
                            }),
                            customWordlist?.hasQualityRatings && wordlistSize === 'custom' && /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: "pathfinderFormGroup",
                                children: [
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("label", {
                                        htmlFor: "minQuality",
                                        children: "Minimum word quality:"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsxs)("select", {
                                        id: "minQuality",
                                        value: minQuality ?? '',
                                        onChange: (e)=>setMinQuality(e.target.value ? parseInt(e.target.value) : undefined),
                                        children: [
                                            /*#__PURE__*/ (0, $4XrX4.jsx)("option", {
                                                value: "",
                                                children: "All qualities"
                                            }),
                                            customWordlist.qualityLevels.map((level)=>/*#__PURE__*/ (0, $4XrX4.jsxs)("option", {
                                                    value: level,
                                                    children: [
                                                        level,
                                                        "+"
                                                    ]
                                                }, level))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("br", {}),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                                className: "pathfinderSubmitButton",
                                type: "submit",
                                children: "Find Paths"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                                className: "pathfinderPreviousButton",
                                type: "button",
                                onClick: handlePreviousSearch,
                                children: "Previous search"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "pathfinderInfoBox",
                        children: /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $4XrX4.jsx)("strong", {
                                    children: "Tip:"
                                }),
                                " Click any word in a result path to exclude it and rerun the search."
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "pathfinderResultsContainer",
                children: [
                    excludedWords.size > 0 && /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "pathfinderExcludedWords",
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                                children: /*#__PURE__*/ (0, $4XrX4.jsx)("strong", {
                                    children: "Excluded words:"
                                })
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "pathfinderExcludedList",
                                children: Array.from(excludedWords).map((word)=>/*#__PURE__*/ (0, $4XrX4.jsxs)("span", {
                                        className: "pathfinderExcludedWord",
                                        onClick: ()=>handleRemoveExcluded(word),
                                        children: [
                                            word,
                                            " \u2715"
                                        ]
                                    }, word))
                            })
                        ]
                    }),
                    loading ? /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("p", {
                                children: [
                                    'Searching for paths from "',
                                    startWord,
                                    '" to "',
                                    endWord,
                                    '" with max morph ',
                                    parseInt(maxMorph) || 2,
                                    "..."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                className: "pathfinderLoadingSpinner"
                            })
                        ]
                    }) : results.length > 0 ? /*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: "pathfinderResultsCount",
                                children: [
                                    /*#__PURE__*/ (0, $4XrX4.jsxs)("span", {
                                        children: [
                                            hasMoreResults ? 'At least ' : '',
                                            results.length,
                                            " path",
                                            results.length !== 1 ? 's' : '',
                                            " found"
                                        ]
                                    }),
                                    hasMoreResults && /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                                        className: "pathfinderLoadMoreButton",
                                        onClick: handleLoadMore,
                                        children: "Find 50 more paths"
                                    })
                                ]
                            }),
                            results.length > resultsPerPage && /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                                className: "pathfinderPagination",
                                children: [
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                                        className: "pathfinderPaginationButton",
                                        onClick: handlePrevPage,
                                        disabled: currentPage === 1,
                                        children: "\u2190 Previous"
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsxs)("span", {
                                        className: "pathfinderPaginationInfo",
                                        children: [
                                            "Page ",
                                            currentPage,
                                            " of ",
                                            Math.ceil(results.length / resultsPerPage)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                                        className: "pathfinderPaginationButton",
                                        onClick: handleNextPage,
                                        disabled: currentPage >= Math.ceil(results.length / resultsPerPage),
                                        children: "Next \u2192"
                                    })
                                ]
                            }),
                            results.slice((currentPage - 1) * resultsPerPage, currentPage * resultsPerPage).map((result, index)=>/*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                                    className: "pathfinderSearchResult",
                                    children: result.path.map((word, wordIndex)=>/*#__PURE__*/ (0, $4XrX4.jsxs)("span", {
                                            children: [
                                                wordIndex > 0 && /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                                    className: "pathfinderArrow",
                                                    children: " \u2192 "
                                                }),
                                                /*#__PURE__*/ (0, $4XrX4.jsx)("span", {
                                                    className: `pathfinderPathWord ${word === startWord.toLowerCase() || word === endWord.toLowerCase() ? 'pathfinderEndpoint' : 'pathfinderClickable'}`,
                                                    onClick: ()=>handleExcludeWord(word),
                                                    children: word
                                                })
                                            ]
                                        }, wordIndex))
                                }, index))
                        ]
                    }) : startWord && endWord && !loading ? /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                        children: "No paths found"
                    }) : /*#__PURE__*/ (0, $4XrX4.jsx)("p", {
                        children: "Enter start and end words to find morph paths"
                    })
                ]
            }),
            showCustomDialog && /*#__PURE__*/ (0, $4XrX4.jsx)((0, $3e822100038b564a$export$2e2bcd8739ae039), {
                existingWordlist: customWordlist,
                onClose: ()=>setShowCustomDialog(false),
                onWordlistUploaded: handleWordlistUploaded,
                onWordlistCleared: handleWordlistCleared
            })
        ]
    });
};
var $e82957840eedb671$export$2e2bcd8739ae039 = $e82957840eedb671$var$Pathfinder;



var $4XrX4 = parcelRequire("4XrX4");

var $28UcW = parcelRequire("28UcW");

const $87b28790dc28ae2e$var$Formatter = ()=>{
    const [puzzleData, setPuzzleData] = (0, $28UcW.useState)('');
    const [outputData, setOutputData] = (0, $28UcW.useState)('');
    const handleOutputWithBlanks = ()=>{
        const input = puzzleData.split('\n');
        const maxLength = Math.max(...input.map((line)=>line.split(' ')[0].length));
        const output = input.map((line)=>{
            const match = line.match(/^(\S*)(\s*)(.*)$/);
            if (!match) return '';
            const [_, firstWord, , rest] = match;
            const blanks = '_ '.repeat(firstWord.length).trim();
            return blanks.padEnd(maxLength * 2 - 1 + 5) + ' ' + rest;
        }).join('\n');
        setOutputData(output);
    };
    const handleOutputWithSolutions = ()=>{
        const input = puzzleData.split('\n');
        const maxLength = Math.max(...input.map((line)=>line.split(' ')[0].length));
        const output = input.map((line)=>{
            const match = line.match(/^(\S*)(\s*)(.*)$/);
            if (!match) return '';
            const [_, firstWord, , rest] = match;
            return firstWord.toUpperCase().padEnd(maxLength + 5) + ' ' + rest;
        }).join('\n');
        setOutputData(output);
    };
    const handleOutputAsJson = ()=>{
        const input = puzzleData.split('\n');
        const clues = input.map((line)=>{
            const match = line.match(/^(\S*)(\s*)(.*)$/);
            if (!match) return {
                solution: '',
                clue: '',
                morph: ''
            };
            const [_, solution, , clue] = match;
            const clueMatch = clue.trim().match(/^(.*?)(\s*\([^)]*\))?$/);
            const [clueText, morph] = clueMatch ? clueMatch.slice(1, 3) : [
                '',
                ''
            ];
            return {
                solution: solution,
                clue: clueText,
                morph: (morph || '()').trim().replace(/^\(|\)$/g, '')
            };
        });
        const outputObject = {
            clues: clues
        };
        setOutputData(JSON.stringify(outputObject, null, 2));
    };
    const handleCopyOutput = ()=>{
        navigator.clipboard.writeText(outputData).then(()=>{
            console.log('Output copied to clipboard');
        }).catch((err)=>{
            console.error('Failed to copy text: ', err);
        });
    };
    return /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
        className: "formatterContainer",
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "formatterInputContainer",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("label", {
                        htmlFor: "puzzleData",
                        children: "Puzzle Data"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("textarea", {
                        id: "puzzleData",
                        value: puzzleData,
                        onChange: (e)=>setPuzzleData(e.target.value),
                        placeholder: `Put your puzzle data here, one clue per line, like so:

LEFT Not right
CLEFT Divided (+1)
CHEF One who prepares food (-1, ~1)`
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                        className: "formatterButtonContainer",
                        children: [
                            /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                                onClick: handleOutputWithBlanks,
                                children: "Output with Blanks"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                                onClick: handleOutputWithSolutions,
                                children: "Output with Solutions"
                            }),
                            /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                                onClick: handleOutputAsJson,
                                children: "Output as JSON"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4XrX4.jsxs)("div", {
                className: "formatterOutputContainer",
                children: [
                    /*#__PURE__*/ (0, $4XrX4.jsx)("label", {
                        htmlFor: "outputData",
                        children: "Output"
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("pre", {
                        id: "outputData",
                        children: outputData
                    }),
                    /*#__PURE__*/ (0, $4XrX4.jsx)("div", {
                        className: "formatterButtonContainer",
                        children: /*#__PURE__*/ (0, $4XrX4.jsx)("button", {
                            onClick: handleCopyOutput,
                            children: "Copy to clipboard"
                        })
                    })
                ]
            })
        ]
    });
};
var $87b28790dc28ae2e$export$2e2bcd8739ae039 = $87b28790dc28ae2e$var$Formatter;



// Did this because I wanted the topbar to be a subcomponent of the router so that
// clicking links there would be fast and not require full reload.
// If the router only returned the component, then the router itself is BETWEEN the topbar
// and the footer, and then the links in the footer and topbar would need to do a full reload.
const $e5b76596fd4a5619$var$layout = (Component, onSave, keepMobileFooter)=>/*#__PURE__*/ (0, $4XrX4.jsxs)((0, $4XrX4.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d73d4bd4af6a0424$export$2e2bcd8739ae039), {
                onSave: onSave
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $85c2880b0ac78b1e$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $36480424a441d4c7$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $4XrX4.jsx)(Component, {})
                })
            }),
            /*#__PURE__*/ (0, $4XrX4.jsx)((0, $d3b38ad39fb8613a$export$2e2bcd8739ae039), {
                keepMobileFooter: keepMobileFooter
            })
        ]
    });
const $e5b76596fd4a5619$var$router = (0, $ca600093aacddd58$export$1f3f55432a00e06d)([
    {
        path: '/',
        element: $e5b76596fd4a5619$var$layout((0, $2ca58842a47d438a$export$2e2bcd8739ae039), ()=>{}, true)
    },
    {
        path: '/arithmeglyphs',
        element: $e5b76596fd4a5619$var$layout((0, $54ed509a2813e983$export$2e2bcd8739ae039), (0, $8a5badd6ef6136ba$export$a020a0ba86fc9904))
    },
    {
        path: '/megarubigram',
        element: $e5b76596fd4a5619$var$layout((0, $11fb873f9cbbf0ee$export$2e2bcd8739ae039), (0, $71d26f524812ace6$export$9c46c33257c0e40e))
    },
    {
        path: '/morphology',
        element: $e5b76596fd4a5619$var$layout((0, $136a2f89319ea25d$export$2e2bcd8739ae039), (0, $796711f10012c239$export$5c96c7fea13888f))
    },
    {
        // Permalink to a past Morphology puzzle, e.g. /morphology/2025/10/3.
        // ArchiveMorphology handles its own saving internally, so no onSave is needed.
        path: '/morphology/:year/:month/:day',
        element: $e5b76596fd4a5619$var$layout((0, $9066f0861aa240ef$export$2e2bcd8739ae039), ()=>{})
    },
    {
        path: '/pathword',
        element: $e5b76596fd4a5619$var$layout((0, $dc95ef7e08fb73ac$export$2e2bcd8739ae039), (0, $5672f12342c56f70$export$868183fcaa7ce9d2))
    },
    {
        path: '/pathword5x5',
        element: $e5b76596fd4a5619$var$layout((0, $cca4f754f104150d$export$2e2bcd8739ae039), (0, $862bdcea3eeac9b6$export$621a0561ab81bb49))
    },
    {
        path: '/rubigram',
        element: $e5b76596fd4a5619$var$layout((0, $b6c4a115071a81e7$export$2e2bcd8739ae039), (0, $b99a42ab34cc1773$export$b69713a7fb295530))
    },
    {
        path: '/triword',
        element: $e5b76596fd4a5619$var$layout((0, $a163f0752441889e$export$2e2bcd8739ae039), (0, $89509cfb9f60b696$export$e409bdf423f1f13c))
    },
    {
        path: '/truthsorting',
        element: $e5b76596fd4a5619$var$layout((0, $cd7189524ec7e9f4$export$2e2bcd8739ae039), (0, $656c0098466b2416$export$b9e7221e14f84ef0))
    },
    {
        path: '/ultrarubigram',
        element: $e5b76596fd4a5619$var$layout((0, $e21ee5c453a3685c$export$2e2bcd8739ae039), (0, $84fe879902ff3b51$export$3f0ef2d61f406c77))
    },
    {
        path: '/submissions',
        element: $e5b76596fd4a5619$var$layout((0, $e160abf210f59eba$export$2e2bcd8739ae039), ()=>{})
    },
    {
        path: '/account',
        element: $e5b76596fd4a5619$var$layout((0, $f7134883b2941fd5$export$2e2bcd8739ae039), ()=>{})
    },
    {
        path: '/about',
        element: $e5b76596fd4a5619$var$layout((0, $785ac5314154ebbf$export$2e2bcd8739ae039), ()=>{})
    },
    {
        path: '/on-ending-morphology',
        element: $e5b76596fd4a5619$var$layout((0, $5e6f01baac63d731$export$2e2bcd8739ae039), ()=>{})
    },
    {
        path: '/wordfinder',
        element: $e5b76596fd4a5619$var$layout((0, $7aa830066e27386b$export$2e2bcd8739ae039), ()=>{})
    },
    {
        path: '/pathfinder',
        element: $e5b76596fd4a5619$var$layout((0, $e82957840eedb671$export$2e2bcd8739ae039), ()=>{})
    },
    {
        path: '/formatter',
        element: $e5b76596fd4a5619$var$layout((0, $87b28790dc28ae2e$export$2e2bcd8739ae039), ()=>{})
    },
    {
        path: '/admin/analytics',
        element: $e5b76596fd4a5619$var$layout((0, $761676a2b4b59fb8$export$2e2bcd8739ae039), ()=>{})
    },
    {
        path: '/admin/morphology-processor',
        element: $e5b76596fd4a5619$var$layout((0, $9c810dcad9e38f9c$export$2e2bcd8739ae039), ()=>{})
    },
    {
        path: '*',
        element: /*#__PURE__*/ (0, $4XrX4.jsx)((0, $6e00b7bb3feca34a$export$444b3ab0cb9aec40), {
            to: "/",
            replace: true
        })
    }
]);
const $e5b76596fd4a5619$var$ContentSwitcher = ()=>{
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $ca600093aacddd58$export$323e4fc2fa4753fb), {
        router: $e5b76596fd4a5619$var$router
    });
};
var $e5b76596fd4a5619$export$2e2bcd8739ae039 = $e5b76596fd4a5619$var$ContentSwitcher;


var $b26d24ba6793933c$export$2e2bcd8739ae039 = (0, $e5b76596fd4a5619$export$2e2bcd8739ae039);












var $2cHFZ = parcelRequire("2cHFZ");




const $37409761e25a12bf$export$4e3bdb6fc7af2ff8 = ()=>{
    const { time: time, puzzleId: puzzleId } = (0, $6a94dce2910e1181$export$f4312d14943ef1a6).getRawState();
    setTimeout(()=>{
        (0, $6a94dce2910e1181$export$f4312d14943ef1a6).update((s)=>{
            s.statsDialogIsOpen = true;
        });
    }, 1000);
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).VaryClove, {
        puzzleId: puzzleId,
        revealed: false,
        solved: true,
        time: time
    });
};
const $37409761e25a12bf$export$7cf2f68092532300 = ()=>{
    (0, $6a94dce2910e1181$export$f4312d14943ef1a6).update((s)=>{
        clearInterval(s.timerUpdatingFn);
        s.revealed = true;
        s.isPaused = false;
        (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).VaryClove, {
            puzzleId: s.puzzleId,
            revealed: true,
            solved: false,
            time: s.time
        });
    });
};
const $37409761e25a12bf$export$41690f6550a5a71b = ()=>{
    const { solved: solved, revealed: revealed, time: time, puzzleId: puzzleId } = (0, $6a94dce2910e1181$export$f4312d14943ef1a6).getRawState();
    if (solved || revealed) return;
    // just updating progress on pause or navigate away
    (0, $741cdd5d8fe36d3f$export$435569523fbdf788)((0, $860afe5c90b07ab1$export$3e1d53562ebc9131).VaryClove, {
        puzzleId: puzzleId,
        revealed: revealed,
        solved: solved,
        time: time
    });
};
const $37409761e25a12bf$export$a2d04682ca2072ee = (puzzleData)=>{
    (0, $6a94dce2910e1181$export$f4312d14943ef1a6).update((s)=>{
        s.puzzleId = puzzleData.puzzleId;
        s.cluePhrase = puzzleData.cluePhrase;
        s.prompt = puzzleData.prompt;
        s.numAlteredLetters = puzzleData.numAlteredLetters;
        s.solution = puzzleData.solution.toLowerCase();
        s.guessWords = [];
        s.solution.split(' ').forEach((word)=>{
            // e.g. 'fast as hell' => [['', '', '', '',], ['', '',], ['', '', '', '',]]
            const emptyStringArray = Array(word.length).fill('');
            s.guessWords.push(emptyStringArray);
            const wordCharArray = word.toLowerCase().split('');
            s.solutionAsCharArrays.push(wordCharArray);
        });
    });
};
// This puzzle's code has a little bit of fuckery because of the challenge of having
// space-separated input sequences where you can type across them continuously.
const $37409761e25a12bf$var$moveCursorForward = (arr, cursorLocation)=>{
    const [wordIndex, letterIndex] = cursorLocation;
    if (letterIndex < arr[wordIndex].length - 1) return [
        wordIndex,
        letterIndex + 1
    ];
    else if (wordIndex < arr.length - 1) return [
        wordIndex + 1,
        0
    ];
    else return cursorLocation;
};
const $37409761e25a12bf$var$moveCursorBackward = (arr, cursorLocation)=>{
    const [wordIndex, letterIndex] = cursorLocation;
    if (letterIndex > 0) return [
        wordIndex,
        letterIndex - 1
    ];
    else if (wordIndex > 0) return [
        wordIndex - 1,
        arr[wordIndex - 1].length - 1
    ];
    else return cursorLocation;
};
const $37409761e25a12bf$var$updateGuess = (inputLetter)=>{
    (0, $6a94dce2910e1181$export$f4312d14943ef1a6).update((s)=>{
        if (s.solved || s.revealed) return;
        const newGuessWords = (0, $2cHFZ.cloneDeep)(s.guessWords);
        // the letter that WAS in the active InputSquare before keystroke
        const previousLetterAtThisSquare = newGuessWords[s.cursorLocation[0]][s.cursorLocation[1]];
        // If we backspace on an already blank square, move cursor back a step first
        // so that we're clearing the square to the left instead.
        // Otherwise, put letter in current square and move cursor forward.
        if (inputLetter === '' && previousLetterAtThisSquare === '') {
            s.cursorLocation = $37409761e25a12bf$var$moveCursorBackward(newGuessWords, s.cursorLocation);
            newGuessWords[s.cursorLocation[0]][s.cursorLocation[1]] = inputLetter;
        } else {
            newGuessWords[s.cursorLocation[0]][s.cursorLocation[1]] = inputLetter;
            s.cursorLocation = $37409761e25a12bf$var$moveCursorForward(newGuessWords, s.cursorLocation);
        }
        s.guessWords = newGuessWords;
        const guessWordsCombined = newGuessWords.map((word)=>word.join('')).join(' ');
        if (guessWordsCombined === s.solution) {
            s.solved = true;
            $37409761e25a12bf$export$4e3bdb6fc7af2ff8();
        }
    });
};
const $37409761e25a12bf$export$412508d679148d5c = (key)=>{
    const { solved: solved } = (0, $6a94dce2910e1181$export$f4312d14943ef1a6).getRawState();
    if (solved) return;
    if (/^[a-zA-Z]$/.test(key)) {
        key = key.toLowerCase();
        $37409761e25a12bf$var$updateGuess(key);
    } else if (key === (0, $ba1e3b359abf28ef$export$cd903283095ece83).Delete) $37409761e25a12bf$var$updateGuess('');
};














const $77b33712010dcacd$export$389d240d9dcd906e = (puzzleData, featureData)=>{
    // The original puzzle states are preserved here to be used to reset puzzles on logout
    // (Mainly just the rubigram and megarubigram need that.)
    // But wait... doesn't the authstatechanged handler in app.tsx reload everything anyway?
    // Yes but whatever just leave it idc, not important at all
    (0, $e2662af8a2ab1f76$export$986181c251d527c3).update((s)=>{
        s.loadingContent = false;
        s.loadingContentError = false;
        s.puzzleData = puzzleData;
        s.featureData = featureData;
    });
    // Get user settings for pathword hints, or use defaults
    const signedIn = (0, $e2662af8a2ab1f76$export$986181c251d527c3).getRawState().signedIn;
    const userSettings = (0, $e2662af8a2ab1f76$export$986181c251d527c3).getRawState().userData?.settings;
    const pathwordHints = signedIn && userSettings?.pathwordDefaultHints !== undefined ? userSettings.pathwordDefaultHints : 2;
    const pathword5x5Hints = signedIn && userSettings?.pathword5x5DefaultHints !== undefined ? userSettings.pathword5x5DefaultHints : 4;
    (0, $8a5badd6ef6136ba$export$9afb3e602442910f)(puzzleData.arithmeglyphs);
    (0, $71d26f524812ace6$export$456ce1e409e7e64)(puzzleData.megarubigram);
    (0, $796711f10012c239$export$2b897112635d6470)(puzzleData.morphology);
    (0, $5672f12342c56f70$export$39f6b94519bfc80)(puzzleData.pathword, pathwordHints);
    (0, $862bdcea3eeac9b6$export$47aaa92647edceb7)(puzzleData.pathword5x5, pathword5x5Hints);
    (0, $b99a42ab34cc1773$export$34a8d0dbc7e71c9e)(puzzleData.rubigram);
    (0, $89509cfb9f60b696$export$a4e69d7037101c3f)(puzzleData.triword);
    (0, $656c0098466b2416$export$8edde018c2520e49)(puzzleData.truthsortingV2);
    (0, $84fe879902ff3b51$export$b04f84b03234f6d0)(puzzleData.ultrarubigram);
    (0, $37409761e25a12bf$export$a2d04682ca2072ee)(puzzleData.varyClove);
};
const $77b33712010dcacd$export$d4367cd1ab530cae = (userPuzzlesProgress)=>{
    (0, $f159c0fbed3d8ee5$export$f0f19936383bf48f).update((s)=>{
        if (userPuzzlesProgress.arithmeglyphs) {
            const a = userPuzzlesProgress.arithmeglyphs;
            s.solved = a.solved;
            s.revealed = a.revealed;
            s.time = a.time;
            s.completed = a.completed;
            s.dataByLine.forEach((line, i)=>{
                line.guesses = a.partialState?.dataByLine?.[i]?.guesses || Array(line.numSeq.length).fill(null);
                line.revealedCells = a.partialState?.dataByLine?.[i]?.revealedCells || Array(line.numSeq.length).fill(false);
            });
        } else {
            s.solved = false;
            s.revealed = false;
            s.time = 0;
            s.completed = false;
            s.dataByLine.forEach((line)=>{
                line.guesses = Array(line.numSeq.length).fill(null);
                line.revealedCells = Array(line.numSeq.length).fill(false);
            });
        }
    });
    (0, $7d75cbd0e5d3963f$export$5f5aeb422b27882).update((s)=>{
        const u = userPuzzlesProgress.ultrarubigram;
        s.revealed = u?.revealed ?? false;
        s.solved = u?.solved ?? false;
        s.time = u?.time ?? 0;
        s.rot = 0;
        s.isRevealing = false;
        // a finished puzzle is saved with a null partialState; anything done while logged out is cleared
        (0, $48a85ad21da8d504$export$39ef76c8a466c6a7)(s.grids);
        if (u?.partialState && (0, $48a85ad21da8d504$export$50709009735b417)(s.grids, u.partialState.grids)) s.rot = u.partialState.rot;
    });
    (0, $f731e2f2b99acd98$export$67e62d6ceebdf4ee).update((s)=>{
        if (userPuzzlesProgress.megarubigram) {
            const m = userPuzzlesProgress.megarubigram;
            s.revealed = m.revealed;
            s.solved = m.solved;
            s.time = m.time;
            // if it was solved/revealed, partialState will have been saved as null
            s.grids = m.partialState?.grids || s.grids;
            s.degreesRotated = m.partialState?.degreesRotated || s.degreesRotated;
        } else {
            // clear away anything done while logged-out
            s.revealed = false;
            s.solved = false;
            s.time = 0;
        }
    });
    (0, $01d05596dd530619$export$9e774c7f63a1a494).update((s)=>{
        if (userPuzzlesProgress.morphology) {
            const m = userPuzzlesProgress.morphology;
            s.guesses = m.partialState?.guesses || s.clues.map((clue)=>Array(clue.solution.length).fill(null));
            s.revealedCells = m.partialState?.revealedCells || s.clues.map((clue)=>Array(clue.solution.length).fill(false));
            s.mistakes = s.clues.map((clue)=>Array(clue.solution.length).fill(false));
            s.solved = m.solved;
            s.revealed = m.revealed;
            s.completed = m.completed || false;
            s.time = m.time;
        } else {
            s.guesses = s.clues.map((clue)=>Array(clue.solution.length).fill(null));
            s.revealedCells = s.clues.map((clue)=>Array(clue.solution.length).fill(false));
            s.mistakes = s.clues.map((clue)=>Array(clue.solution.length).fill(false));
            s.solved = false;
            s.revealed = false;
            s.completed = false;
            s.time = 0;
        }
    });
    (0, $56703c0bbcb0049a$export$557a6027eb88d4ac).update((s)=>{
        if (userPuzzlesProgress.pathword) {
            const p = userPuzzlesProgress.pathword;
            s.revealed = p.revealed;
            s.solved = p.solved;
            s.time = p.time;
        } else {
            // clear away anything done while logged-out
            s.revealed = false;
            s.solved = false;
            s.time = 0;
            (0, $5672f12342c56f70$export$99823ce229395b16)(s);
        }
    });
    (0, $86b89eb84cf821a4$export$681392899cda0e6d).update((s)=>{
        if (userPuzzlesProgress.pathword5x5) {
            const p = userPuzzlesProgress.pathword5x5;
            s.revealed = p.revealed;
            s.solved = p.solved;
            s.time = p.time;
        } else {
            // clear away anything done while logged-out
            s.revealed = false;
            s.solved = false;
            s.time = 0;
            (0, $862bdcea3eeac9b6$export$3abe0514b238bb90)(s);
        }
    });
    (0, $e27327853171b943$export$e2e5b62534c2c783).update((s)=>{
        if (userPuzzlesProgress.rubigram) {
            const r = userPuzzlesProgress.rubigram;
            s.revealed = r.revealed;
            s.solved = r.solved;
            s.time = r.time;
        } else {
            // clear away anything done while logged-out
            s.revealed = false;
            s.solved = false;
            s.time = 0;
        }
    });
    (0, $1c52cfe25bc28425$export$cbdad2c51fe016e8).update((s)=>{
        if (userPuzzlesProgress.triword) {
            const t = userPuzzlesProgress.triword;
            s.revealed = t.revealed;
            s.solved = t.solved;
            s.time = t.time;
            s.used5050Lifeline = t.partialState?.used5050Lifeline || false;
            s.usedLetterLifeline = t.partialState?.usedLetterLifeline || false;
            s.usedPositionLifeline = t.partialState?.usedPositionLifeline || false;
            if (s.usedLetterLifeline) (0, $89509cfb9f60b696$export$1df4bb14ce74baa0)();
        } else {
            s.revealed = false;
            s.solved = false;
            s.time = 0;
            s.used5050Lifeline = false;
            s.usedLetterLifeline = false;
            s.usedPositionLifeline = false;
        }
    });
    (0, $abbcacd8f9b8e7dd$export$5aa98d4d531c155f).update((s)=>{
        if (userPuzzlesProgress.truthsorting) {
            const t = userPuzzlesProgress.truthsorting;
            s.revealed = t.revealed;
            s.solved = t.solved;
            s.time = t.time;
        // more needed here to restore user's partial state
        } else {
            s.revealed = false;
            s.solved = false;
            s.time = 0;
        // more needed here to clear any partial state
        }
    });
    (0, $6a94dce2910e1181$export$f4312d14943ef1a6).update((s)=>{
        if (userPuzzlesProgress.varyClove) {
            const v = userPuzzlesProgress.varyClove;
            s.revealed = v.revealed;
            s.solved = v.solved;
            s.time = v.time;
        } else {
            s.revealed = false;
            s.solved = false;
            s.time = 0;
        }
    });
};








try {
    $0d3747952a05ae22$export$2cd8252107eb640b('75831f161966b62fc4fa9f037b28f323', {
        defaultTracking: true,
        // equivalent to LogLevel.None in their enum that isnt available in frontend sdk.
        // without this, it spews errors and warnings when its requests are blocked by ublock/vpn.
        // the errors then trigger the react dev error overlay constantly, which is infuriating.
        // it happens even if you catch the error. disabling the logging is the only way to stop it,
        // because the overlay is monitoring logging i guess.
        logLevel: 0
    });
} catch (error) {}
const $cd93687958c8007e$var$App = ()=>{
    (0, $28UcW.useEffect)(()=>{
        const auth = (0, $de660e99e3126d7c$export$ae1af26003f05816)();
        // we wait for firebase to establish login state before loading our own data
        (0, $de660e99e3126d7c$export$4a5767248b18ef41)(auth, async (user)=>{
            // load puzzles
            let puzzlesLoaded = false;
            const puzzleIds = {};
            try {
                // Include auth token if user is logged in (for analytics)
                const headers = user ? {
                    Authorization: `Bearer ${await user.getIdToken()}`
                } : {};
                const response = await (0, $ea74087fd5ac399e$export$2e2bcd8739ae039).get(`/api/puzzles`, {
                    headers: headers
                });
                const { featureData: featureData, puzzleData: puzzleData } = response.data;
                (0, $77b33712010dcacd$export$389d240d9dcd906e)(puzzleData, featureData);
                puzzlesLoaded = true;
                Object.keys(puzzleData).forEach((key)=>{
                    puzzleIds[key] = puzzleData[key].puzzleId;
                });
                // temporary while truthsortingV1 is being deprecated; full removal pending
                puzzleIds[(0, $860afe5c90b07ab1$export$3e1d53562ebc9131).Truthsorting] = puzzleData['truthsortingV2'].puzzleId;
                window.scrollTo({
                    top: 0
                });
            } catch (error) {
                console.error('Error fetching puzzle data:', error);
                (0, $e2662af8a2ab1f76$export$986181c251d527c3).update((s)=>{
                    s.loadingContentError = true;
                    s.loadingContent = false;
                });
            }
            // don't even try loading user if we couldn't load puzzles.
            if (!puzzlesLoaded) {
                (0, $e2662af8a2ab1f76$export$986181c251d527c3).update((s)=>{
                    s.loadingUser = false;
                    s.loadingUserError = false;
                    s.signedIn = false;
                    s.userData = null;
                });
                return;
            }
            // load user
            if (user) {
                const authToken = await user.getIdToken(true);
                try {
                    const response = await (0, $ea74087fd5ac399e$export$2e2bcd8739ae039).post('/api/users/load-user', {
                        authToken: authToken,
                        puzzleIds: puzzleIds
                    });
                    (0, $e2662af8a2ab1f76$export$986181c251d527c3).update((s)=>{
                        s.loadingUser = false;
                        s.loadingUserError = false;
                        s.signedIn = true;
                        s.userData = {
                            stats: response.data.stats,
                            settings: response.data.settings
                        };
                    });
                    (0, $77b33712010dcacd$export$d4367cd1ab530cae)(response.data.puzzlesProgress);
                    // Update pathword puzzles with user's hint settings
                    (0, $56703c0bbcb0049a$export$557a6027eb88d4ac).update((s)=>{
                        s.enabledHints = (0, $5672f12342c56f70$export$2060161a50430d7e)(response.data.settings.pathwordDefaultHints);
                        s.initialEnabledHints = response.data.settings.pathwordDefaultHints;
                    });
                    (0, $86b89eb84cf821a4$export$681392899cda0e6d).update((s)=>{
                        s.enabledHints = (0, $5672f12342c56f70$export$46f43f842bb402d)(response.data.settings.pathword5x5DefaultHints);
                        s.initialEnabledHints = response.data.settings.pathword5x5DefaultHints;
                    });
                } catch (error) {
                    (0, $e2662af8a2ab1f76$export$986181c251d527c3).update((s)=>{
                        s.loadingUser = false;
                        s.loadingUserError = true;
                        s.signedIn = false;
                        s.userData = null;
                    });
                    (0, $741cdd5d8fe36d3f$export$9a3c3183a7548a58)(puzzleIds);
                    auth.signOut();
                    alert('Something went wrong while loading account. Try refreshing and logging in again.');
                }
            } else {
                (0, $741cdd5d8fe36d3f$export$9a3c3183a7548a58)(puzzleIds);
                (0, $e2662af8a2ab1f76$export$986181c251d527c3).update((s)=>{
                    s.loadingUser = false;
                    s.loadingUserError = false;
                    s.signedIn = false;
                    s.userData = null;
                });
            }
        });
    }, []);
    return /*#__PURE__*/ (0, $4XrX4.jsx)((0, $b26d24ba6793933c$export$2e2bcd8739ae039), {});
};
var $cd93687958c8007e$export$2e2bcd8739ae039 = $cd93687958c8007e$var$App;



const $70fc9a727fa662ae$var$container = document.getElementById('app');
const $70fc9a727fa662ae$var$root = (0, $f7655ee7f8b44636$export$882461b6382ed46c)($70fc9a727fa662ae$var$container);
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $4XrX4.jsx)((0, $cd93687958c8007e$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=frontend.78cb87de.js.map
